/* eslint-disable */
import * as React from 'react'

export type IconProps = Omit<React.ComponentProps<'svg'>, 'width' | 'height'>

export function Icon10k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="10k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 9V15V19H5V10.5H6V15H7.5V9H5V5H19V9Z"
            fill="currentColor"
          />
          <path
            d="M15.5 11.25V9H14V15H15.5V12.75L17.25 15H19L16.75 12L19 9H17.25L15.5 11.25Z"
            fill="currentColor"
          />
          <path
            d="M9.5 15H12C12.55 15 13 14.55 13 14V10C13 9.45 12.55 9 12 9H9.5C8.95 9 8.5 9.45 8.5 10V14C8.5 14.55 8.95 15 9.5 15ZM10 10.5H11.5V13.5H10V10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon10mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="10mp">
        <g id="Vector">
          <path
            d="M13 11.5H15.5C16.05 11.5 16.5 11.05 16.5 10.5V6.5C16.5 5.95 16.05 5.5 15.5 5.5H13C12.45 5.5 12 5.95 12 6.5V10.5C12 11.05 12.45 11.5 13 11.5ZM13.5 7H15V10H13.5V7Z"
            fill="currentColor"
          />
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon11mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="11mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M9.5 11.5H11V5.5H8V7H9.5V11.5Z" fill="currentColor" />
          <path d="M14.5 11.5H16V5.5H13V7H14.5V11.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function Icon123(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="123">
        <path
          id="Vector"
          d="M7.25 15H5.75V10.5H4.25V9H7.25V15ZM13.75 13.5H10.75V12.5H12.75C13.3 12.5 13.75 12.05 13.75 11.5V10C13.75 9.45 13.3 9 12.75 9H9.25V10.5H12.25V11.5H10.25C9.7 11.5 9.25 11.95 9.25 12.5V15H13.75V13.5ZM19.75 14V10C19.75 9.45 19.3 9 18.75 9H15.25V10.5H18.25V11.5H16.25V12.5H18.25V13.5H15.25V15H18.75C19.3 15 19.75 14.55 19.75 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon12mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="12mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M16.5 10H13.5V9H15.5C16.05 9 16.5 8.55 16.5 8V6.5C16.5 5.95 16.05 5.5 15.5 5.5H12V7H15V8H13C12.45 8 12 8.45 12 9V11.5H16.5V10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon13mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="13mp">
        <g id="Vector">
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M16.5 10.5V6.5C16.5 5.95 16.05 5.5 15.5 5.5H12V7H15V8H13V9H15V10H12V11.5H15.5C16.05 11.5 16.5 11.05 16.5 10.5Z"
            fill="currentColor"
          />
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon14mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="14mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 12.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5ZM16.5 15.5H15V14H16.5V15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M15 11.5H16.5V10H17.5V8.5H16.5V5.5H15V8.5H13.5V5.5H12V10H15V11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon15mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="15mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M16.5 10.5V9C16.5 8.45 16.05 8 15.5 8H13.5V7H16.5V5.5H12V9H15V10H12V11.5H15.5C16.05 11.5 16.5 11.05 16.5 10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon16mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="16mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M13 11.5H15.5C16.05 11.5 16.5 11.05 16.5 10.5V9C16.5 8.45 16.05 8 15.5 8H13.5V7H16.5V5.5H13C12.45 5.5 12 5.95 12 6.5V10.5C12 11.05 12.45 11.5 13 11.5ZM13.5 9H15V10.5H13.5V9Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function Icon17mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="17mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M13.25 11.5H15L16.46 6.79C16.65 6.15 16.17 5.5 15.5 5.5H12V7H14.62L13.25 11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon18UpRating(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="18_up_rating">
        <g id="Vector">
          <path d="M8.5 15H10V9H7V10.5H8.5V15Z" fill="currentColor" />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M12.5 15H15C15.55 15 16 14.55 16 14V10C16 9.45 15.55 9 15 9H12.5C11.95 9 11.5 9.45 11.5 10V14C11.5 14.55 11.95 15 12.5 15ZM13 10H14.5V11.5H13V10ZM13 12.5H14.5V14H13V12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon18mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="18mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M13 11.5H15.5C16.05 11.5 16.5 11.05 16.5 10.5V6.5C16.5 5.95 16.05 5.5 15.5 5.5H13C12.45 5.5 12 5.95 12 6.5V10.5C12 11.05 12.45 11.5 13 11.5ZM13.5 6.5H15V8H13.5V6.5ZM13.5 9H15V10.5H13.5V9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon19mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="19mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 11.5H10V5.5H7V7H8.5V11.5Z" fill="currentColor" />
          <path
            d="M16.5 10.5V6.5C16.5 5.95 16.05 5.5 15.5 5.5H13C12.45 5.5 12 5.95 12 6.5V8C12 8.55 12.45 9 13 9H15V10H12V11.5H15.5C16.05 11.5 16.5 11.05 16.5 10.5ZM15 8H13.5V6.5H15V8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon1k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="1k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M8.5 15H10V9H7V10.5H8.5V15Z" fill="currentColor" />
          <path
            d="M13.5 12.75L15.25 15H17L14.75 12L17 9H15.25L13.5 11.25V9H12V15H13.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon1kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="1k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path d="M7.5 15H9V9H6V10.5H7.5V15Z" fill="currentColor" />
          <path
            d="M12 12.75L13.75 15H15.5L13.25 12L15.5 9H13.75L12 11.25V9H10.5V15H12V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon1xMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="1x_mobiledata">
        <path
          id="Vector"
          d="M4.5 7H8.5V17H6.5V9H4.5V7ZM16.33 11.72L19.16 7H16.83L15.17 9.77L13.5 7H11.17L14 11.72L10.83 17H13.16L15.16 13.66L17.16 17H19.5L16.33 11.72Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon20mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="20mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 12.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5ZM16.5 15.5H15V14H16.5V15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14 11.5H16.5C17.05 11.5 17.5 11.05 17.5 10.5V6.5C17.5 5.95 17.05 5.5 16.5 5.5H14C13.45 5.5 13 5.95 13 6.5V10.5C13 11.05 13.45 11.5 14 11.5ZM14.5 7H16V10H14.5V7Z"
            fill="currentColor"
          />
          <path
            d="M11 10H8V9H10C10.55 9 11 8.55 11 8V6.5C11 5.95 10.55 5.5 10 5.5H6.5V7H9.5V8H7.5C6.95 8 6.5 8.45 6.5 9V11.5H11V10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon21mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="21mp">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M14.5 11.5H16V5.5H13V7H14.5V11.5Z" fill="currentColor" />
          <path
            d="M12 10H9V9H11C11.55 9 12 8.55 12 8V6.5C12 5.95 11.55 5.5 11 5.5H7.5V7H10.5V8H8.5C7.95 8 7.5 8.45 7.5 9V11.5H12V10Z"
            fill="currentColor"
          />
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M15 17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5H15V17ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon22mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="22mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 12.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5ZM16.5 15.5H15V14H16.5V15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 10H8V9H10C10.55 9 11 8.55 11 8V6.5C11 5.95 10.55 5.5 10 5.5H6.5V7H9.5V8H7.5C6.95 8 6.5 8.45 6.5 9V11.5H11V10Z"
            fill="currentColor"
          />
          <path
            d="M17.5 10H14.5V9H16.5C17.05 9 17.5 8.55 17.5 8V6.5C17.5 5.95 17.05 5.5 16.5 5.5H13V7H16V8H14C13.45 8 13 8.45 13 9V11.5H17.5V10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon23mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="23mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 12.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5ZM16.5 15.5H15V14H16.5V15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 10H8V9H10C10.55 9 11 8.55 11 8V6.5C11 5.95 10.55 5.5 10 5.5H6.5V7H9.5V8H7.5C6.95 8 6.5 8.45 6.5 9V11.5H11V10Z"
            fill="currentColor"
          />
          <path
            d="M17.5 10.5V6.5C17.5 5.95 17.05 5.5 16.5 5.5H13V7H16V8H14V9H16V10H13V11.5H16.5C17.05 11.5 17.5 11.05 17.5 10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon24mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="24mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M17 12.5H13.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5ZM16.5 15.5H15V14H16.5V15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 10H8V9H10C10.55 9 11 8.55 11 8V6.5C11 5.95 10.55 5.5 10 5.5H6.5V7H9.5V8H7.5C6.95 8 6.5 8.45 6.5 9V11.5H11V10Z"
            fill="currentColor"
          />
          <path
            d="M16 11.5H17.5V10H18.5V8.5H17.5V5.5H16V8.5H14.5V5.5H13V10H16V11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon2k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="2k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 13.5H8V12.5H10C10.55 12.5 11 12.05 11 11.5V10C11 9.45 10.55 9 10 9H6.5V10.5H9.5V11.5H7.5C6.95 11.5 6.5 11.95 6.5 12.5V15H11V13.5Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon2kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="2k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M10 13.5H7.5V12.5H9C9.55 12.5 10 12.05 10 11.5V10C10 9.45 9.55 9 9 9H6V10.5H8.5V11.5H7C6.45 11.5 6 11.95 6 12.5V15H10V13.5Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon2mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="2mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 10H11.5V9H13.5C14.05 9 14.5 8.55 14.5 8V6.5C14.5 5.95 14.05 5.5 13.5 5.5H10V7H13V8H11C10.45 8 10 8.45 10 9V11.5H14.5V10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon30fps(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="30fps">
        <path
          id="Vector"
          d="M2 5V8H8V10.5H3V13.5H8V16H2V19H8C9.66 19 11 17.66 11 16V14.1C11 12.94 10.06 12 8.9 12C10.06 12 11 11.06 11 9.9V8C11 6.34 9.66 5 8 5H2ZM19 8V16H15V8H19ZM19 5H15C13.34 5 12 6.34 12 8V16C12 17.66 13.34 19 15 19H19C20.66 19 22 17.66 22 16V8C22 6.34 20.66 5 19 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon30fpsSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="30fps_select">
        <path
          id="Vector"
          d="M4 3V5H9V7H5V9H9V11H4V13H9C10.1 13 11 12.1 11 11V9.5C11 8.67 10.83 8 10 8C10.83 8 11 7.33 11 6.5V5C11 3.9 10.1 3 9 3H4ZM18 3C19.1 3 20 3.9 20 5V11C20 12.1 19.1 13 18 13H15C13.9 13 13 12.1 13 11V5C13 3.9 13.9 3 15 3H18ZM18 5H15V11H18V5ZM5 21H3V16H5V21ZM9 21H7V16H9V21ZM13 21H11V16H13V21ZM21 21H15V16H21V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon360(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="360">
        <path
          id="Vector"
          d="M12 5.5C6.48 5.5 2 7.74 2 10.5C2 12.74 4.94 14.63 9 15.27V18.5L13 14.5L9 10.5V13.23C5.85 12.67 4 11.33 4 10.5C4 9.44 7.04 7.5 12 7.5C16.96 7.5 20 9.44 20 10.5C20 11.23 18.54 12.39 16 13.03V15.08C19.53 14.31 22 12.55 22 10.5C22 7.74 17.52 5.5 12 5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon3dRotation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="3d_rotation" clipPath="url(#clip0_395_3612)">
        <path
          id="Vector"
          d="M7.52505 21.48C4.25505 19.94 1.91505 16.76 1.55505 13H0.0550537C0.565054 19.16 5.71505 24 12.0051 24L12.6651 23.97L8.85505 20.16L7.52505 21.48ZM8.41505 14.96C8.22505 14.96 8.04505 14.93 7.89505 14.88C7.73505 14.82 7.60505 14.75 7.49505 14.64C7.38505 14.54 7.29505 14.42 7.23505 14.27C7.17505 14.13 7.14505 13.97 7.14505 13.8H5.84505C5.84505 14.16 5.91505 14.48 6.05505 14.75C6.19505 15.02 6.38505 15.25 6.61505 15.44C6.85505 15.62 7.12505 15.76 7.43505 15.85C7.73505 15.95 8.05505 16 8.39505 16C8.76505 16 9.11505 15.95 9.42505 15.85C9.74505 15.75 10.0251 15.6 10.2551 15.41C10.4851 15.22 10.6751 14.98 10.8051 14.69C10.9351 14.4 11.0051 14.08 11.0051 13.72C11.0051 13.53 10.9851 13.34 10.9351 13.16C10.8851 12.98 10.8151 12.81 10.7051 12.65C10.6051 12.49 10.4651 12.35 10.3051 12.22C10.1351 12.09 9.93505 11.99 9.69505 11.91C9.89505 11.82 10.0651 11.71 10.2151 11.58C10.3651 11.45 10.4851 11.31 10.5851 11.16C10.6851 11.01 10.7551 10.86 10.8051 10.7C10.8551 10.54 10.8751 10.38 10.8751 10.22C10.8751 9.86 10.8151 9.54 10.6951 9.26C10.5751 8.98 10.4051 8.75 10.1851 8.57C9.98505 8.38 9.71505 8.24 9.41505 8.14C9.10505 8.05 8.76505 8 8.39505 8C8.03505 8 7.70505 8.05 7.39505 8.16C7.09505 8.27 6.82505 8.42 6.60505 8.61C6.39505 8.8 6.22505 9.02 6.09505 9.28C5.97505 9.54 5.91505 9.82 5.91505 10.13H7.21505C7.21505 9.96 7.24505 9.81 7.30505 9.68C7.36505 9.55 7.44505 9.43 7.55505 9.34C7.66505 9.25 7.78505 9.17 7.93505 9.12C8.08505 9.07 8.23505 9.04 8.41505 9.04C8.81505 9.04 9.11505 9.14 9.30505 9.35C9.49505 9.55 9.59505 9.84 9.59505 10.21C9.59505 10.39 9.56505 10.55 9.51505 10.7C9.46505 10.85 9.37505 10.97 9.26505 11.07C9.15505 11.17 9.01505 11.25 8.85505 11.31C8.69505 11.37 8.49505 11.4 8.27505 11.4H7.50505V12.43H8.27505C8.49505 12.43 8.69505 12.45 8.87505 12.5C9.05505 12.55 9.20505 12.63 9.32505 12.73C9.44505 12.84 9.54505 12.97 9.61505 13.13C9.68505 13.29 9.71505 13.48 9.71505 13.7C9.71505 14.11 9.59505 14.42 9.36505 14.63C9.13505 14.86 8.81505 14.96 8.41505 14.96ZM16.9651 9.04C16.6451 8.71 16.2651 8.45 15.8251 8.27C15.3851 8.09 14.8951 8 14.3551 8H11.9951V16H14.2951C14.8451 16 15.3551 15.91 15.8051 15.73C16.2551 15.55 16.6451 15.3 16.9651 14.97C17.2851 14.64 17.5351 14.24 17.7051 13.78C17.8751 13.31 17.9651 12.79 17.9651 12.21V11.81C17.9651 11.23 17.8751 10.71 17.7051 10.24C17.5351 9.77 17.2851 9.37 16.9651 9.04ZM16.5751 12.2C16.5751 12.62 16.5251 12.99 16.4351 13.33C16.3351 13.66 16.1951 13.95 16.0051 14.18C15.8151 14.41 15.5751 14.59 15.2951 14.71C15.0051 14.83 14.6751 14.89 14.3051 14.89H13.3951V9.12H14.3651C15.0851 9.12 15.6351 9.35 16.0051 9.81C16.3851 10.27 16.5751 10.93 16.5751 11.8V12.2ZM12.0051 0L11.3451 0.03L15.1551 3.84L16.4851 2.51C19.7551 4.06 22.0951 7.23 22.4451 10.99H23.9451C23.4451 4.84 18.2951 0 12.0051 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_3612">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Icon3gMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="3g_mobiledata">
        <path
          id="Vector"
          d="M3 7V9H8V11H4V13H8V15H3V17H8C9.1 17 10 16.1 10 15V13.5C10 12.67 9.33 12 8.5 12C9.33 12 10 11.33 10 10.5V9C10 7.9 9.1 7 8 7H3ZM21 11V15C21 16.1 20.1 17 19 17H14C12.9 17 12 16.1 12 15V9C12 7.9 12.9 7 14 7H19C20.1 7 21 7.9 21 9H14V15H19V13H16.5V11H21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon3k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="3k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 14V10C11 9.45 10.55 9 10 9H6.5V10.5H9.5V11.5H7.5V12.5H9.5V13.5H6.5V15H10C10.55 15 11 14.55 11 14Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon3kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="3k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M10 14V10C10 9.45 9.55 9 9 9H5.5V10.5H8.5V11.5H6.5V12.5H8.5V13.5H5.5V15H9C9.55 15 10 14.55 10 14Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon3mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="3mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 12.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5ZM16.5 15.5H15V14H16.5V15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 10.5V6.5C14.5 5.95 14.05 5.5 13.5 5.5H10V7H13V8H11V9H13V10H10V11.5H13.5C14.05 11.5 14.5 11.05 14.5 10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon3p(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="3p">
        <path
          id="Vector"
          d="M20 2H4.01C2.91 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM12 10C13.1 10 14 9.1 14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10ZM16 13.43C16 12.62 15.52 11.9 14.78 11.58C13.93 11.21 12.99 11 12 11C11.01 11 10.07 11.21 9.22 11.58C8.48 11.9 8 12.62 8 13.43V14H16V13.43Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon4gMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="4g_mobiledata">
        <path
          id="Vector"
          d="M9 7H7V12H5V7H3V14H7V17H9V14H11V12H9V7ZM17 11V13H19V15H14V9H21C21 7.9 20.1 7 19 7H14C12.9 7 12 7.9 12 9V15C12 16.1 12.9 17 14 17H19C20.1 17 21 16.1 21 15V11H17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon4gPlusMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="4g_plus_mobiledata">
        <path
          id="Vector"
          d="M12.5 11V13H14.5V15H10.5V9H16.5C16.5 7.9 15.6 7 14.5 7H10.5C9.4 7 8.5 7.9 8.5 9V15C8.5 16.1 9.4 17 10.5 17H14.5C15.6 17 16.5 16.1 16.5 15V11H12.5ZM23.5 11H21.5V9H19.5V11H17.5V13H19.5V15H21.5V13H23.5V11ZM6.5 7H4.5V12H2.5V7H0.5V14H4.5V17H6.5V14H7.5V12H6.5V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon4k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="4k">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V5H19V19ZM9.5 15H11V13.51H12V12H11V9H9.5V12H8V9H6.5V13.5H9.5V15ZM18.2 15L16.2 12L18.2 9H16.5L14.5 12L16.5 15H18.2ZM14.5 12V9H13V15H14.5V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon4kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="4k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path d="M8.5 15H10V13.5H11V12H10V9H8.5V12H7V9H5.5V13.5H8.5V15Z" fill="currentColor" />
          <path
            d="M13 12.75L14.75 15H16.5L14.25 12L16.5 9H14.75L13 11.25V9H11.5V15H13V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon4mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="4mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M12.5 11.5H14V10H15V8.5H14V5.5H12.5V8.5H11V5.5H9.5V10H12.5V11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon5g(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="5g">
        <g id="Vector">
          <path
            d="M16.5 13H19V15H14V9H21C21 7.9 20.1 7 19 7H14C12.9 7 12 7.9 12 9V15C12 16.1 12.9 17 14 17H19C20.1 17 21 16.1 21 15V11H16.5V13Z"
            fill="currentColor"
          />
          <path
            d="M3 13H8V15H3V17H8C9.1 17 10 16.1 10 15V13C10 11.9 9.1 11 8 11H5V9H10V7H3V13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon5k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="5k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 14V12.5C11 11.95 10.55 11.5 10 11.5H8V10.5H11V9H6.5V12.5H9.5V13.5H6.5V15H10C10.55 15 11 14.55 11 14Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon5kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="5k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M10 14V12.5C10 11.95 9.55 11.5 9 11.5H7.5V10.5H10V9H6V12.5H8.5V13.5H6V15H9C9.55 15 10 14.55 10 14Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon5mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="5mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 10.5V9C14.5 8.45 14.05 8 13.5 8H11.5V7H14.5V5.5H10V9H13V10H10V11.5H13.5C14.05 11.5 14.5 11.05 14.5 10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon60fps(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="60fps">
        <path
          id="Vector"
          d="M19 8V16H15V8H19ZM19 5H15C13.34 5 12 6.34 12 8V16C12 17.66 13.34 19 15 19H19C20.66 19 22 17.66 22 16V8C22 6.34 20.66 5 19 5ZM10 8V5H5C3.34 5 2 6.34 2 8V16C2 17.66 3.34 19 5 19H8C9.66 19 11 17.66 11 16V13C11 11.34 9.66 10 8 10H5V8H10ZM8 13V16H5V13H8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon60fpsSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="60fps_select">
        <path
          id="Vector"
          d="M18 5V11H15V5H18ZM18 3H15C13.9 3 13 3.9 13 5V11C13 12.1 13.9 13 15 13H18C19.1 13 20 12.1 20 11V5C20 3.9 19.1 3 18 3ZM11 5V3H6C4.9 3 4 3.9 4 5V11C4 12.1 4.9 13 6 13H9C10.1 13 11 12.1 11 11V9C11 7.9 10.1 7 9 7H6V5H11ZM9 9V11H6V9H9ZM5 21H3V16H5V21ZM9 21H7V16H9V21ZM13 21H11V16H13V21ZM21 21H15V16H21V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon6FtApart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="6_ft_apart">
        <path
          id="Vector"
          d="M6 6C7.1 6 8 5.1 8 4C8 2.9 7.1 2 6 2C4.9 2 4 2.9 4 4C4 5.1 4.9 6 6 6ZM10 9.43C10 8.62 9.52 7.9 8.78 7.58C7.93 7.21 6.99 7 6 7C5.01 7 4.07 7.21 3.22 7.58C2.48 7.9 2 8.62 2 9.43V10H10V9.43ZM18 6C19.1 6 20 5.1 20 4C20 2.9 19.1 2 18 2C16.9 2 16 2.9 16 4C16 5.1 16.9 6 18 6ZM22 9.43C22 8.62 21.52 7.9 20.78 7.58C19.93 7.21 18.99 7 18 7C17.01 7 16.07 7.21 15.22 7.58C14.48 7.9 14 8.62 14 9.43V10H22V9.43ZM19 17V14.99L5 15V17L2 14L5 11V13.01L19 13V11L22 14L19 17ZM10 19V18H7.5C7.22 18 7 18.22 7 18.5V21.5C7 21.78 7.22 22 7.5 22H9.5C9.78 22 10 21.78 10 21.5V20C10 19.72 9.78 19.5 9.5 19.5H8V19H10ZM9 20.5V21H8V20.5H9ZM17.5 19H16.5V22H15.5V19H14.5V18H17.5V19ZM12.5 19V19.5H13.5V20.5H12.5V22H11.5V18H14V19H12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Icon6k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="6k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
          <path
            d="M7.5 15H10C10.55 15 11 14.55 11 14V12.5C11 11.95 10.55 11.5 10 11.5H8V10.5H11V9H7.5C6.95 9 6.5 9.45 6.5 10V14C6.5 14.55 6.95 15 7.5 15ZM8 12.5H9.5V14H8V12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon6kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="6k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
          <path
            d="M7 15H9C9.55 15 10 14.55 10 14V12.5C10 11.95 9.55 11.5 9 11.5H7.5V10.5H10V9H7C6.45 9 6 9.45 6 10V14C6 14.55 6.45 15 7 15ZM7.5 12.5H8.5V14H7.5V12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon6mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="6mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 11.5H13.5C14.05 11.5 14.5 11.05 14.5 10.5V9C14.5 8.45 14.05 8 13.5 8H11.5V7H14.5V5.5H11C10.45 5.5 10 5.95 10 6.5V10.5C10 11.05 10.45 11.5 11 11.5ZM11.5 9H13V10.5H11.5V9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon7k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="7k">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M7.75 15H9.5L10.96 10.29C11.15 9.65 10.67 9 10 9H6.5V10.5H9.13L7.75 15Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon7kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="7k_plus">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M6.75 15H8.5L9.96 10.29C10.15 9.65 9.67 9 9 9H5.5V10.5H8.13L6.75 15Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon7mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="7mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11.25 11.5H13L14.46 6.79C14.65 6.15 14.17 5.5 13.5 5.5H10V7H12.62L11.25 11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon8k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="8k">
        <g id="Vector">
          <path
            d="M7.5 15H10C10.55 15 11 14.55 11 14V10C11 9.45 10.55 9 10 9H7.5C6.95 9 6.5 9.45 6.5 10V14C6.5 14.55 6.95 15 7.5 15ZM8 10H9.5V11.5H8V10ZM8 12.5H9.5V14H8V12.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon8kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="8k_plus">
        <g id="Vector">
          <path
            d="M7 15H9C9.55 15 10 14.55 10 14V10C10 9.45 9.55 9 9 9H7C6.45 9 6 9.45 6 10V14C6 14.55 6.45 15 7 15ZM7.5 10H8.5V11.5H7.5V10ZM7.5 12.5H8.5V14H7.5V12.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon8mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="8mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M11 11.5H13.5C14.05 11.5 14.5 11.05 14.5 10.5V6.5C14.5 5.95 14.05 5.5 13.5 5.5H11C10.45 5.5 10 5.95 10 6.5V10.5C10 11.05 10.45 11.5 11 11.5ZM11.5 6.5H13V8H11.5V6.5ZM11.5 9H13V10.5H11.5V9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon9k(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="9k">
        <g id="Vector">
          <path
            d="M11 14V10C11 9.45 10.55 9 10 9H7.5C6.95 9 6.5 9.45 6.5 10V11.5C6.5 12.05 6.95 12.5 7.5 12.5H9.5V13.5H6.5V15H10C10.55 15 11 14.55 11 14ZM9.5 11.5H8V10H9.5V11.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 12.75L16.25 15H18L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon9kPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="9k_plus">
        <g id="Vector">
          <path
            d="M10 14V10C10 9.45 9.55 9 9 9H7C6.45 9 6 9.45 6 10V11.5C6 12.05 6.45 12.5 7 12.5H8.5V13.5H6V15H9C9.55 15 10 14.55 10 14ZM8.5 11.5H7.5V10H8.5V11.5Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11.5H17.5V10H16.5V11.5H15V12.5H16.5V14H17.5V12.5H19V19H5V5H19V11.5Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12.75L14.25 15H16L13.75 12L16 9H14.25L12.5 11.25V9H11V15H12.5V12.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function Icon9mp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="9mp">
        <g id="Vector">
          <path
            d="M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z"
            fill="currentColor"
          />
          <path
            d="M13.5 18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5V18.5ZM15 14H16.5V15.5H15V14Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M14.5 10.5V6.5C14.5 5.95 14.05 5.5 13.5 5.5H11C10.45 5.5 10 5.95 10 6.5V8C10 8.55 10.45 9 11 9H13V10H10V11.5H13.5C14.05 11.5 14.5 11.05 14.5 10.5ZM13 8H11.5V6.5H13V8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAbc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="abc">
        <path
          id="Vector"
          d="M21 11H19.5V10.5H17.5V13.5H19.5V13H21V14C21 14.55 20.55 15 20 15H17C16.45 15 16 14.55 16 14V10C16 9.45 16.45 9 17 9H20C20.55 9 21 9.45 21 10V11ZM8 10V15H6.5V13.5H4.5V15H3V10C3 9.45 3.45 9 4 9H7C7.55 9 8 9.45 8 10ZM6.5 10.5H4.5V12H6.5V10.5ZM13.5 12C14.05 12 14.5 12.45 14.5 13V14C14.5 14.55 14.05 15 13.5 15H9.5V9H13.5C14.05 9 14.5 9.45 14.5 10V11C14.5 11.55 14.05 12 13.5 12ZM11 10.5V11.25H13V10.5H11ZM13 12.75H11V13.5H13V12.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAcUnit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ac_unit">
        <path
          id="Vector"
          d="M22 11H17.83L21.07 7.76L19.66 6.34L15 11H13V9L17.66 4.34L16.24 2.93L13 6.17V2H11V6.17L7.76 2.93L6.34 4.34L11 9V11H9L4.34 6.34L2.93 7.76L6.17 11H2V13H6.17L2.93 16.24L4.34 17.66L9 13H11V15L6.34 19.66L7.76 21.07L11 17.83V22H13V17.83L16.24 21.07L17.66 19.66L13 15V13H15L19.66 17.66L21.07 16.24L17.83 13H22V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccessAlarm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="access_alarm">
        <path
          id="Vector"
          d="M22 5.78999L17.4 1.92999L16.11 3.45999L20.71 7.31999L22 5.78999ZM7.88 3.45999L6.6 1.92999L2 5.77999L3.29 7.30999L7.88 3.45999ZM12.5 8.06999H11V14.07L15.75 16.92L16.5 15.69L12.5 13.32V8.06999ZM12 4.06999C7.03 4.06999 3 8.09999 3 13.07C3 18.04 7.02 22.07 12 22.07C16.97 22.07 21 18.04 21 13.07C21 8.09999 16.97 4.06999 12 4.06999ZM12 20.07C8.13 20.07 5 16.94 5 13.07C5 9.19999 8.13 6.06999 12 6.06999C15.87 6.06999 19 9.19999 19 13.07C19 16.94 15.87 20.07 12 20.07Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccessTime(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="access_time">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccessTimeFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="access_time_filled">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM15.29 16.71L11 12.41V7H13V11.59L16.71 15.3L15.29 16.71Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccessibility(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="accessibility">
        <path
          id="Vector"
          d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9H15V22H13V16H11V22H9V9H3V7H21V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccessibilityNew(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="accessibility_new">
        <path
          id="Vector"
          d="M20.5 6C17.89 6.7 14.83 7 12 7C9.17 7 6.11 6.7 3.5 6L3 8C4.86 8.5 7 8.83 9 9V22H11V16H13V22H15V9C17 8.83 19.14 8.5 21 8L20.5 6ZM12 6C13.1 6 14 5.1 14 4C14 2.9 13.1 2 12 2C10.9 2 10 2.9 10 4C10 5.1 10.9 6 12 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccessible(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="accessible">
        <g id="Vector">
          <path
            d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
            fill="currentColor"
          />
          <path
            d="M19 13V11C17.46 11.02 15.91 10.25 14.93 9.17L13.64 7.74C13.47 7.55 13.26 7.4 13.03 7.29C13.02 7.29 13.02 7.28 13.01 7.28H13C12.65 7.08 12.25 6.98 11.81 7.02C10.76 7.11 10 8.04 10 9.09V15C10 16.1 10.9 17 12 17H17V22H19V16.5C19 15.4 18.1 14.5 17 14.5H14V11.05C15.29 12.12 17.25 12.99 19 13ZM10 20C8.34 20 7 18.66 7 17C7 15.69 7.84 14.59 9 14.17V12.1C6.72 12.56 5 14.58 5 17C5 19.76 7.24 22 10 22C12.42 22 14.44 20.28 14.9 18H12.83C12.42 19.16 11.31 20 10 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAccessibleForward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="accessible_forward">
        <g id="Vector">
          <path
            d="M17.5 6.27C18.6046 6.27 19.5 5.37457 19.5 4.27C19.5 3.16543 18.6046 2.27 17.5 2.27C16.3954 2.27 15.5 3.16543 15.5 4.27C15.5 5.37457 16.3954 6.27 17.5 6.27Z"
            fill="currentColor"
          />
          <path
            d="M14.5 16.73H12.5C12.5 18.38 11.15 19.73 9.5 19.73C7.85 19.73 6.5 18.38 6.5 16.73C6.5 15.08 7.85 13.73 9.5 13.73V11.73C6.74 11.73 4.5 13.97 4.5 16.73C4.5 19.49 6.74 21.73 9.5 21.73C12.26 21.73 14.5 19.49 14.5 16.73ZM17.5 13.23H15.64L17.31 9.56C17.92 8.23 16.94 6.73 15.46 6.73H10.26C9.45 6.73 8.72 7.2 8.39 7.93L7.72 9.73L9.64 10.26L10.29 8.73H12.5L10.67 12.83C10.07 14.16 11.06 15.73 12.52 15.73H17.5V20.73H19.5V15.23C19.5 14.13 18.6 13.23 17.5 13.23Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAccountBalance(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="account_balance">
        <path
          id="Vector"
          d="M7 11H5V18H7V11ZM13 11H11V18H13V11ZM21.5 20H2.5V22H21.5V20ZM19 11H17V18H19V11ZM12 4.26L17.21 7H6.79L12 4.26ZM12 2L2.5 7V9H21.5V7L12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccountBalanceWallet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="account_balance_wallet">
        <g id="Vector">
          <path
            d="M20.5 7.28V5C20.5 3.9 19.6 3 18.5 3H4.5C3.39 3 2.5 3.9 2.5 5V19C2.5 20.1 3.39 21 4.5 21H18.5C19.6 21 20.5 20.1 20.5 19V16.72C21.09 16.37 21.5 15.74 21.5 15V9C21.5 8.26 21.09 7.63 20.5 7.28ZM19.5 9V15H12.5V9H19.5ZM4.5 19V5H18.5V7H12.5C11.4 7 10.5 7.9 10.5 9V15C10.5 16.1 11.4 17 12.5 17H18.5V19H4.5Z"
            fill="currentColor"
          />
          <path
            d="M15.5 13.5C16.3284 13.5 17 12.8284 17 12C17 11.1716 16.3284 10.5 15.5 10.5C14.6716 10.5 14 11.1716 14 12C14 12.8284 14.6716 13.5 15.5 13.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAccountBox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="account_box">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17 19H7V18.76C8.42 17.62 10.16 17 12 17C13.84 17 15.58 17.62 17 18.76V19ZM19 17.86C17.2 16.09 14.73 15 12 15C9.27 15 6.8 16.09 5 17.86V5H19V17.86ZM12 13C13.93 13 15.5 11.43 15.5 9.5C15.5 7.57 13.93 6 12 6C10.07 6 8.5 7.57 8.5 9.5C8.5 11.43 10.07 13 12 13ZM12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAccountCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="account_circle">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.35 18.5C8.66 17.56 10.26 17 12 17C13.74 17 15.34 17.56 16.65 18.5C15.34 19.44 13.74 20 12 20C10.26 20 8.66 19.44 7.35 18.5ZM18.14 17.12C16.45 15.8 14.32 15 12 15C9.68 15 7.55 15.8 5.86 17.12C4.7 15.73 4 13.95 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 13.95 19.3 15.73 18.14 17.12Z"
            fill="currentColor"
          />
          <path
            d="M12 6C10.07 6 8.5 7.57 8.5 9.5C8.5 11.43 10.07 13 12 13C13.93 13 15.5 11.43 15.5 9.5C15.5 7.57 13.93 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAccountTree(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="account_tree">
        <path
          id="Vector"
          d="M22 11V3H15V6H9V3H2V11H9V8H11V18H15V21H22V13H15V16H13V8H15V11H22ZM7 9H4V5H7V9ZM17 15H20V19H17V15ZM17 5H20V9H17V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAdUnits(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ad_units">
        <g id="Vector">
          <path
            d="M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM7 4V3H17V4H7ZM7 18V6H17V18H7ZM7 21V20H17V21H7Z"
            fill="currentColor"
          />
          <path d="M16 7H8V9H16V7Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAdb(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="adb">
        <path
          id="Vector"
          d="M5 15.78C5 19.65 8.13 22.78 12 22.78C15.87 22.78 19 19.65 19 15.78V11.78H5V15.78ZM16.12 4.14997L18.22 2.04997L17.4 1.21997L15.1 3.52997C14.16 3.05997 13.12 2.77997 12 2.77997C10.88 2.77997 9.84 3.05997 8.91 3.52997L6.6 1.21997L5.78 2.04997L7.88 4.14997C6.14 5.41997 5 7.45997 5 9.77997V10.78H19V9.77997C19 7.45997 17.86 5.41997 16.12 4.14997ZM9 8.77997C8.45 8.77997 8 8.32997 8 7.77997C8 7.22997 8.45 6.77997 9 6.77997C9.55 6.77997 10 7.22997 10 7.77997C10 8.32997 9.55 8.77997 9 8.77997ZM15 8.77997C14.45 8.77997 14 8.32997 14 7.77997C14 7.22997 14.45 6.77997 15 6.77997C15.55 6.77997 16 7.22997 16 7.77997C16 8.32997 15.55 8.77997 15 8.77997Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add">
        <path id="Vector" d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconAddAPhoto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_a_photo">
        <path
          id="Vector"
          d="M21.5 6.5H18.33L16.5 4.5H10.5V6.5H15.62L17.45 8.5H21.5V20.5H5.5V11.5H3.5V20.5C3.5 21.6 4.4 22.5 5.5 22.5H21.5C22.6 22.5 23.5 21.6 23.5 20.5V8.5C23.5 7.4 22.6 6.5 21.5 6.5ZM8.5 14.5C8.5 17.26 10.74 19.5 13.5 19.5C16.26 19.5 18.5 17.26 18.5 14.5C18.5 11.74 16.26 9.5 13.5 9.5C10.74 9.5 8.5 11.74 8.5 14.5ZM13.5 11.5C15.15 11.5 16.5 12.85 16.5 14.5C16.5 16.15 15.15 17.5 13.5 17.5C11.85 17.5 10.5 16.15 10.5 14.5C10.5 12.85 11.85 11.5 13.5 11.5ZM5.5 6.5H8.5V4.5H5.5V1.5H3.5V4.5H0.5V6.5H3.5V9.5H5.5V6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddAlarm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_alarm">
        <path
          id="Vector"
          d="M7.88 3.45999L6.6 1.92999L2 5.77999L3.29 7.30999L7.88 3.45999ZM22 5.78999L17.4 1.92999L16.11 3.45999L20.71 7.31999L22 5.78999ZM12 4.06999C7.03 4.06999 3 8.09999 3 13.07C3 18.04 7.02 22.07 12 22.07C16.97 22.07 21 18.04 21 13.07C21 8.09999 16.97 4.06999 12 4.06999ZM12 20.07C8.13 20.07 5 16.94 5 13.07C5 9.19999 8.13 6.06999 12 6.06999C15.87 6.06999 19 9.19999 19 13.07C19 16.94 15.87 20.07 12 20.07ZM13 9.06999H11V12.07H8V14.07H11V17.07H13V14.07H16V12.07H13V9.06999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_alert">
        <path
          id="Vector"
          d="M10.01 20.76C10.01 21.86 10.9 22.75 12 22.75C13.1 22.75 13.99 21.86 13.99 20.76H10.01ZM12 5.75C14.76 5.75 17 7.99 17 10.75V17.75H7V10.75C7 7.99 9.24 5.75 12 5.75ZM12 1.25C11.17 1.25 10.5 1.92 10.5 2.75V3.92C7.36 4.6 5 7.4 5 10.75V16.75L3 18.75V19.75H21V18.75L19 16.75V10.75C19 7.4 16.64 4.6 13.5 3.92V2.75C13.5 1.92 12.83 1.25 12 1.25ZM13 7.75H11V10.75H8V12.75H11V15.75H13V12.75H16V10.75H13V7.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddBox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_box">
        <path
          id="Vector"
          d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM11 17H13V13H17V11H13V7H11V11H7V13H11V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddBusiness(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_business">
        <g id="Vector">
          <path d="M17 2.5H2V4.5H17V2.5Z" fill="currentColor" />
          <path
            d="M15 15.5H17V12.5H18V10.5L17 5.5H2L1 10.5V12.5H2V18.5H11V12.5H15V15.5ZM9 16.5H4V12.5H9V16.5ZM3.04 10.5L3.64 7.5H15.36L15.96 10.5H3.04Z"
            fill="currentColor"
          />
          <path d="M23 16.5H20V13.5H18V16.5H15V18.5H18V21.5H20V18.5H23V16.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAddCard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_card">
        <path
          id="Vector"
          d="M19 3H3C1.89 3 1.01 3.89 1.01 5L1 17C1 18.11 1.89 19 3 19H13V17H3V11H21V5C21 3.89 20.11 3 19 3ZM19 7H3V5H19V7ZM23 16V18H20V21H18V18H15V16H18V13H20V16H23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_chart">
        <g id="Vector">
          <path
            d="M19 19H5V5H14V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V10H19V19Z"
            fill="currentColor"
          />
          <path d="M17 13H15V17H17V13Z" fill="currentColor" />
          <path d="M9 10H7V17H9V10Z" fill="currentColor" />
          <path d="M13 7H11V17H13V7Z" fill="currentColor" />
          <path d="M19 5V3H17V5H15V7H17V9H19V7H21V5H19Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAddCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddCircleOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_circle_outline">
        <path
          id="Vector"
          d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddComment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_comment">
        <path
          id="Vector"
          d="M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4ZM20 17.17L18.83 16H4V4H20V17.17ZM13 5H11V9H7V11H11V15H13V11H17V9H13V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddHome(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_home">
        <g id="Vector">
          <path
            d="M10.5 4.5L16.5 9V10C17.2 10 17.87 10.1 18.5 10.29V8L10.5 2L2.5 8V20H10.18C9.88 19.38 9.68 18.71 9.58 18H4.5V9L10.5 4.5Z"
            fill="currentColor"
          />
          <path
            d="M16.5 12C13.74 12 11.5 14.24 11.5 17C11.5 19.76 13.74 22 16.5 22C19.26 22 21.5 19.76 21.5 17C21.5 14.24 19.26 12 16.5 12ZM19.5 17.5H17V20H16V17.5H13.5V16.5H16V14H17V16.5H19.5V17.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAddHomeWork(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_home_work">
        <g id="Vector">
          <path
            d="M11 13H5V18H3V11.03L8 7.46L13 11.03V12.11C13.57 11.52 14.25 11.04 15 10.69V10L8 5L1 10V20H7V15H9V20H11.68C11.25 19.09 11 18.08 11 17V13Z"
            fill="currentColor"
          />
          <path d="M19 6H17V8H19V6Z" fill="currentColor" />
          <path
            d="M23 12.11V2H10V3.97L12 5.4V4H21V10.68C21.75 11.04 22.43 11.52 23 12.11Z"
            fill="currentColor"
          />
          <path
            d="M23 17C23 14.24 20.76 12 18 12C15.24 12 13 14.24 13 17C13 19.76 15.24 22 18 22C20.76 22 23 19.76 23 17ZM17.5 20V17.5H15V16.5H17.5V14H18.5V16.5H21V17.5H18.5V20H17.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAddIcCall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_ic_call">
        <path
          id="Vector"
          d="M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM18 6V3H16V6H13V8H16V11H18V8H21V6H18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddLink(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_link">
        <path
          id="Vector"
          d="M8 9.5H16V11.5H8V9.5ZM20.1 10.5H22C22 7.74 19.76 5.5 17 5.5H13V7.4H17C18.71 7.4 20.1 8.79 20.1 10.5ZM3.9 10.5C3.9 8.79 5.29 7.4 7 7.4H11V5.5H7C4.24 5.5 2 7.74 2 10.5C2 13.26 4.24 15.5 7 15.5H11V13.6H7C5.29 13.6 3.9 12.21 3.9 10.5ZM19 10.5H17V13.5H14V15.5H17V18.5H19V15.5H22V13.5H19V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddLocation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_location">
        <path
          id="Vector"
          d="M13 6V9H16V11H13V14H11V11H8V9H11V6H13ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddLocationAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_location_alt">
        <path
          id="Vector"
          d="M18.5 1V4H21.5V6H18.5V9H16.5V6H13.5V4H16.5V1H18.5ZM10.5 13C9.4 13 8.5 12.1 8.5 11C8.5 9.9 9.4 9 10.5 9C11.6 9 12.5 9.9 12.5 11C12.5 12.1 11.6 13 10.5 13ZM11.5 3.06V5.08C11.1692 5.02773 10.8349 5.00098 10.5 5C7.15 5 4.5 7.57 4.5 11.2C4.5 13.54 6.45 16.64 10.5 20.34C14.55 16.64 16.5 13.55 16.5 11.2V11H18.5V11.2C18.5 14.52 15.83 18.45 10.5 23C5.17 18.45 2.5 14.52 2.5 11.2C2.5 6.22 6.3 3 10.5 3C10.84 3 11.17 3.02 11.5 3.06Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddModerator(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_moderator">
        <g id="Vector">
          <path
            d="M5 11.09V6.39L11 4.14L17 6.39V10.08C17.71 10.18 18.38 10.39 19 10.68V5L11 2L3 5V11.09C3 16.14 6.41 20.85 11 22C11.03 21.99 11.05 21.98 11.08 21.98C10.29 21.2 9.68 20.22 9.33 19.14C6.76 17.53 5 14.42 5 11.09Z"
            fill="currentColor"
          />
          <path
            d="M16 12C13.24 12 11 14.24 11 17C11 19.76 13.24 22 16 22C18.76 22 21 19.76 21 17C21 14.24 18.76 12 16 12ZM19 17.5H16.5V20H15.5V17.5H13V16.5H15.5V14H16.5V16.5H19V17.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAddPhotoAlternate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_photo_alternate">
        <path
          id="Vector"
          d="M17.5 20.5H3.5V6.5H12.5V4.5H3.5C2.4 4.5 1.5 5.4 1.5 6.5V20.5C1.5 21.6 2.4 22.5 3.5 22.5H17.5C18.6 22.5 19.5 21.6 19.5 20.5V11.5H17.5V20.5ZM9.71 17.33L7.75 14.97L5 18.5H16L12.46 13.79L9.71 17.33ZM19.5 4.5V1.5H17.5V4.5H14.5C14.51 4.51 14.5 6.5 14.5 6.5H17.5V9.49C17.51 9.5 19.5 9.49 19.5 9.49V6.5H22.5V4.5H19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddReaction(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_reaction">
        <path
          id="Vector"
          d="M6 10C6 9.17 6.67 8.5 7.5 8.5C8.33 8.5 9 9.17 9 10C9 10.83 8.33 11.5 7.5 11.5C6.67 11.5 6 10.83 6 10ZM11 18C13.33 18 15.31 16.54 16.11 14.5H5.89C6.69 16.54 8.67 18 11 18ZM14.5 11.5C15.33 11.5 16 10.83 16 10C16 9.17 15.33 8.5 14.5 8.5C13.67 8.5 13 9.17 13 10C13 10.83 13.67 11.5 14.5 11.5ZM21 1.5H19V3.5H17V5.5H19V7.5H21V5.5H23V3.5H21V1.5ZM19 12.5C19 16.92 15.42 20.5 11 20.5C6.58 20.5 3 16.92 3 12.5C3 8.08 6.58 4.5 11 4.5C12.46 4.5 13.82 4.9 15 5.58V3.34C13.77 2.8 12.42 2.5 10.99 2.5C5.47 2.5 1 6.98 1 12.5C1 18.02 5.47 22.5 10.99 22.5C16.52 22.5 21 18.02 21 12.5C21 11.45 20.83 10.45 20.53 9.5H18.4C18.78 10.43 19 11.44 19 12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddRoad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_road">
        <g id="Vector">
          <path
            d="M18.5 16.5V13.5H16.5V16.5H13.5V18.5H16.5V21.5H18.5V18.5H21.5V16.5H18.5Z"
            fill="currentColor"
          />
          <path d="M18.5 2.5H16.5V11.5H18.5V2.5Z" fill="currentColor" />
          <path d="M4.5 2.5H2.5V18.5H4.5V2.5Z" fill="currentColor" />
          <path d="M11.5 2.5H9.5V6.5H11.5V2.5Z" fill="currentColor" />
          <path d="M11.5 8.5H9.5V12.5H11.5V8.5Z" fill="currentColor" />
          <path d="M11.5 14.5H9.5V18.5H11.5V14.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAddShoppingCart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_shopping_cart">
        <path
          id="Vector"
          d="M11.92 9.5H13.92V6.5H16.92V4.5H13.92V1.5H11.92V4.5H8.92004V6.5H11.92V9.5ZM7.92004 18.5C6.82004 18.5 5.93004 19.4 5.93004 20.5C5.93004 21.6 6.82004 22.5 7.92004 22.5C9.02004 22.5 9.92004 21.6 9.92004 20.5C9.92004 19.4 9.02004 18.5 7.92004 18.5ZM17.92 18.5C16.82 18.5 15.93 19.4 15.93 20.5C15.93 21.6 16.82 22.5 17.92 22.5C19.02 22.5 19.92 21.6 19.92 20.5C19.92 19.4 19.02 18.5 17.92 18.5ZM9.02004 13.5H16.47C17.22 13.5 17.88 13.09 18.22 12.47L22.08 5.46L20.34 4.5L16.47 11.5H9.45004L5.19004 2.5H1.92004V4.5H3.92004L7.52004 12.09L6.17004 14.53C5.44004 15.87 6.40004 17.5 7.92004 17.5H19.92V15.5H7.92004L9.02004 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddTask(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_task">
        <path
          id="Vector"
          d="M21 5.18L9.59 16.6L5.35 12.36L6.76 10.95L9.59 13.78L19.59 3.78L21 5.18ZM11 20C6.59 20 3 16.41 3 12C3 7.59 6.59 4 11 4C12.57 4 14.04 4.46 15.28 5.25L16.73 3.8C15.1 2.67 13.13 2 11 2C5.48 2 1 6.48 1 12C1 17.52 5.48 22 11 22C12.73 22 14.36 21.56 15.78 20.78L14.28 19.28C13.28 19.74 12.17 20 11 20ZM18 15H15V17H18V20H20V17H23V15H20V12H18V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddToDrive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_to_drive">
        <g id="Vector">
          <path
            d="M18.5 11C18.67 11 18.83 11.01 18.99 11.02L14.5 3H8.5L14.18 12.84C15.27 11.71 16.8 11 18.5 11Z"
            fill="currentColor"
          />
          <path d="M7.65 4.52L1.5 15.5L4.5 21L10.83 10.03L7.65 4.52Z" fill="currentColor" />
          <path
            d="M12.7 15.5H9.4L6.23 21H14.04C13.08 19.94 12.5 18.54 12.5 17C12.5 16.48 12.57 15.98 12.7 15.5Z"
            fill="currentColor"
          />
          <path d="M19.5 16V13H17.5V16H14.5V18H17.5V21H19.5V18H22.5V16H19.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAddToHomeScreen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_to_home_screen">
        <path
          id="Vector"
          d="M18.5 1.01L8.5 1C7.4 1 6.5 1.9 6.5 3V6H8.5V5H18.5V19H8.5V18H6.5V21C6.5 22.1 7.4 23 8.5 23H18.5C19.6 23 20.5 22.1 20.5 21V3C20.5 1.9 19.6 1.01 18.5 1.01ZM10.5 15H12.5V8H5.5V10H9.09L3.5 15.59L4.91 17L10.5 11.41V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddToPhotos(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_to_photos">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 15H15V11H19V9H15V5H13V9H9V11H13V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddToQueue(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add_to_queue">
        <path
          id="Vector"
          d="M11 15H13V12H16V10H13V7H11V10H8V12H11V15ZM21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAddchart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="addchart">
        <path
          id="Vector"
          d="M21.5 5.5V7.5H18.5V10.5H16.5V7.5H13.5V5.5H16.5V2.5H18.5V5.5H21.5ZM18.5 19.5H4.5V5.5H10.5V3.5H4.5C3.4 3.5 2.5 4.4 2.5 5.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H18.5C19.6 21.5 20.5 20.6 20.5 19.5V13.5H18.5V19.5ZM14.5 13.5V17.5H16.5V13.5H14.5ZM10.5 17.5H12.5V9.5H10.5V17.5ZM8.5 17.5V11.5H6.5V17.5H8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAdfScanner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="adf_scanner">
        <g id="Vector">
          <path
            d="M19 12H18V4H6V12H5C3.34 12 2 13.34 2 15V20H22V15C22 13.34 20.66 12 19 12ZM8 6H16V12H8V6ZM20 18H4V15C4 14.45 4.45 14 5 14H19C19.55 14 20 14.45 20 15V18Z"
            fill="currentColor"
          />
          <path
            d="M18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAdjust(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="adjust">
        <path
          id="Vector"
          d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAdminPanelSettings(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="admin_panel_settings">
        <g id="Vector">
          <path
            d="M16 15.62C16.6186 15.62 17.12 15.1186 17.12 14.5C17.12 13.8814 16.6186 13.38 16 13.38C15.3814 13.38 14.88 13.8814 14.88 14.5C14.88 15.1186 15.3814 15.62 16 15.62Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 16.5C15.27 16.5 13.81 16.86 13.76 17.58C14.26 18.29 15.08 18.75 16 18.75C16.92 18.75 17.74 18.29 18.24 17.58C18.19 16.86 16.73 16.5 16 16.5Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 10.09V5.27L9.5 2L2 5.27V10.18C2 14.72 5.2 18.97 9.5 20C10.05 19.87 10.58 19.68 11.1 19.45C12.18 20.99 13.97 22 16 22C19.31 22 22 19.31 22 16C22 13.03 19.84 10.57 17 10.09ZM10 16C10 16.56 10.08 17.11 10.23 17.62C9.99 17.73 9.75 17.84 9.5 17.92C6.33 16.92 4 13.68 4 10.18V6.58L9.5 4.18L15 6.58V10.09C12.16 10.57 10 13.03 10 16ZM16 20C13.79 20 12 18.21 12 16C12 13.79 13.79 12 16 12C18.21 12 20 13.79 20 16C20 18.21 18.21 20 16 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAdsClick(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ads_click">
        <path
          id="Vector"
          d="M11.4551 17.74C8.27512 17.59 5.74512 14.97 5.74512 11.75C5.74512 8.44 8.43512 5.75 11.7451 5.75C14.9651 5.75 17.5851 8.28 17.7351 11.46L15.6351 10.83C15.2251 9.06 13.6351 7.75 11.7451 7.75C9.53512 7.75 7.74512 9.54 7.74512 11.75C7.74512 13.64 9.05512 15.23 10.8251 15.64L11.4551 17.74ZM21.7451 11.75C21.7451 12.05 21.7351 12.35 21.7051 12.65L19.7351 12.06C19.7451 11.96 19.7451 11.85 19.7451 11.75C19.7451 7.33 16.1651 3.75 11.7451 3.75C7.32512 3.75 3.74512 7.33 3.74512 11.75C3.74512 16.17 7.32512 19.75 11.7451 19.75C11.8451 19.75 11.9551 19.75 12.0551 19.74L12.6451 21.71C12.3451 21.74 12.0451 21.75 11.7451 21.75C6.22512 21.75 1.74512 17.27 1.74512 11.75C1.74512 6.23 6.22512 1.75 11.7451 1.75C17.2651 1.75 21.7451 6.23 21.7451 11.75ZM17.9751 16.01L21.7451 14.75L11.7451 11.75L14.7451 21.75L16.0051 17.98L20.2751 22.25L22.2551 20.27L17.9751 16.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAgriculture(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="agriculture">
        <g id="Vector">
          <path
            d="M4 9.59H9C9 8.49 8.1 7.59 7 7.59H4C3.45 7.59 3 8.04 3 8.59C3 9.14 3.45 9.59 4 9.59Z"
            fill="currentColor"
          />
          <path
            d="M22 14.65V8.59C22 7.49 21.1 6.59 20 6.59H13.71L12.65 5.53L14.06 4.12L13.35 3.41L9.82 6.94L10.53 7.65L11.94 6.24L13 7.3V9.59C13 10.69 12.1 11.59 11 11.59H8.96C8.74 11.43 8.51 11.29 8.27 11.16L7.87 12.05L7.41 11.84L7.81 10.94C7.26 10.72 6.64 10.59 6 10.59C5.47 10.59 4.96 10.7 4.48 10.85L4.82 11.76L4.35 11.94L4 11.01C2.94 11.47 2.09 12.29 1.57 13.32L2.46 13.72L2.25 14.18L1.35 13.78C1.13 14.33 1 14.95 1 15.59C1 16.12 1.11 16.63 1.26 17.11L2.17 16.77L2.35 17.24L1.42 17.59C1.88 18.65 2.7 19.5 3.73 20.02L4.13 19.13L4.59 19.34L4.19 20.24C4.74 20.46 5.36 20.59 6 20.59C6.53 20.59 7.04 20.48 7.52 20.33L7.18 19.42L7.65 19.24L8 20.17C9.06 19.71 9.91 18.89 10.43 17.86L9.54 17.46L9.75 17L10.65 17.4C10.75 17.14 10.83 16.86 10.89 16.58H16.05C16.03 16.75 16 16.92 16 17.09C16 19.02 17.57 20.59 19.5 20.59C21.43 20.59 23 19.02 23 17.09C23 16.14 22.62 15.28 22 14.65ZM6 18.59C4.34 18.59 3 17.25 3 15.59C3 13.93 4.34 12.59 6 12.59C7.66 12.59 9 13.93 9 15.59C9 17.25 7.66 18.59 6 18.59ZM10.87 14.59C10.83 14.41 10.79 14.24 10.74 14.07L9.83 14.41L9.65 13.94L10.58 13.59H11C13.21 13.59 15 11.8 15 9.59V8.59H20V13.64C19.84 13.62 19.67 13.59 19.5 13.59C18.55 13.59 17.69 13.97 17.06 14.59H10.87ZM19.5 18.59C18.67 18.59 18 17.92 18 17.09C18 16.26 18.67 15.59 19.5 15.59C20.33 15.59 21 16.26 21 17.09C21 17.92 20.33 18.59 19.5 18.59Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAir(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="air">
        <path
          id="Vector"
          d="M14.5 17.5C14.5 19.15 13.15 20.5 11.5 20.5C9.85 20.5 8.5 19.15 8.5 17.5H10.5C10.5 18.05 10.95 18.5 11.5 18.5C12.05 18.5 12.5 18.05 12.5 17.5C12.5 16.95 12.05 16.5 11.5 16.5H2V14.5H11.5C13.15 14.5 14.5 15.85 14.5 17.5ZM19 7C19 5.07 17.43 3.5 15.5 3.5C13.57 3.5 12 5.07 12 7H14C14 6.17 14.67 5.5 15.5 5.5C16.33 5.5 17 6.17 17 7C17 7.83 16.33 8.5 15.5 8.5H2V10.5H15.5C17.43 10.5 19 8.93 19 7ZM18.5 11.5H2V13.5H18.5C19.33 13.5 20 14.17 20 15C20 15.83 19.33 16.5 18.5 16.5V18.5C20.43 18.5 22 16.93 22 15C22 13.07 20.43 11.5 18.5 11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatFlat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_flat">
        <path
          id="Vector"
          d="M5 12.5C5.78 12.5 6.55 12.2 7.14 11.6C8.3 10.41 8.28 8.52 7.1 7.36C6.51 6.79 5.75 6.5 5 6.5C4.22 6.5 3.45 6.8 2.86 7.4C1.7 8.59 1.72 10.48 2.9 11.64C3.49 12.21 4.25 12.5 5 12.5ZM4.29 8.8C4.48 8.61 4.73 8.5 5 8.5C5.26 8.5 5.51 8.6 5.7 8.78C6.1 9.17 6.1 9.79 5.72 10.19C5.52 10.39 5.27 10.5 5 10.5C4.74 10.5 4.49 10.4 4.3 10.22C3.9 9.82 3.9 9.2 4.29 8.8ZM18 6.5H9V12.5H22V10.5C22 8.29 20.21 6.5 18 6.5ZM11 10.5V8.5H18C19.1 8.5 20 9.4 20 10.5H11ZM2 15.5H8V17.5H16V15.5H22V13.5H2V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatFlatAngled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_flat_angled">
        <path
          id="Vector"
          d="M6.00073 6.75C6.31073 6.75 6.70073 6.9 6.90073 7.31C7.14073 7.81 6.92073 8.41 6.43073 8.65C6.29073 8.71 6.15073 8.75 6.00073 8.75C5.70073 8.75 5.30073 8.6 5.11073 8.19C4.94073 7.85 5.01073 7.56 5.06073 7.41C5.11073 7.27 5.24073 7.01 5.57073 6.85C5.71073 6.79 5.85073 6.75 6.00073 6.75ZM12.4707 8.86L19.1607 11.27C19.6807 11.46 20.0907 11.83 20.3107 12.32C20.5307 12.8 20.5607 13.35 20.3707 13.85L20.3607 13.87L11.7707 10.76L12.4707 8.86ZM10.0007 15.44L14.0007 16.88V17.25H10.0007V15.44ZM6.00073 4.75C5.56073 4.75 5.12073 4.85 4.70073 5.05C3.21073 5.76 2.58073 7.55 3.30073 9.05C3.81073 10.12 4.88073 10.75 6.00073 10.75C6.44073 10.75 6.88073 10.65 7.30073 10.45C8.79073 9.73 9.42073 7.94 8.71073 6.45C8.19073 5.38 7.12073 4.75 6.00073 4.75ZM11.2807 6.3L9.20073 11.96L21.5607 16.43L22.2507 14.54C23.0207 12.45 21.9407 10.15 19.8407 9.39L11.2807 6.3ZM2.19073 10.5L1.50073 12.39L8.00073 14.73V19.25H16.0007V17.62L20.5207 19.25L21.2107 17.36L2.19073 10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatIndividualSuite(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_individual_suite">
        <path
          id="Vector"
          d="M7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11C4 12.66 5.34 14 7 14ZM7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10ZM19 7H11V15H3V7H1V17H23V11C23 8.79 21.21 7 19 7ZM21 15H13V9H19C20.1 9 21 9.9 21 11V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatLegroomExtra(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_legroom_extra">
        <path
          id="Vector"
          d="M3.49951 12V3H1.49951V12C1.49951 14.76 3.73951 17 6.49951 17H12.4995V15H6.49951C4.83951 15 3.49951 13.66 3.49951 12ZM22.3295 17.24C21.9495 16.52 21.0395 16.27 20.2995 16.61L19.2095 17.11L15.7995 10.13C15.4595 9.45 14.7695 9 14.0095 9H10.4995V3H4.49951V11C4.49951 12.66 5.83951 14 7.49951 14H14.4995L17.9095 21L21.6295 19.3C22.3995 18.94 22.7295 18 22.3295 17.24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatLegroomNormal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_legroom_normal">
        <path
          id="Vector"
          d="M4.5 12V3H2.5V12C2.5 14.76 4.74 17 7.5 17H13.5V15H7.5C5.84 15 4.5 13.66 4.5 12ZM20 18H18.5V11C18.5 9.9 17.6 9 16.5 9H11.5V3H5.5V11C5.5 12.65 6.85 14 8.5 14H15.5V21H20C20.83 21 21.5 20.33 21.5 19.5C21.5 18.67 20.83 18 20 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatLegroomReduced(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_legroom_reduced">
        <path
          id="Vector"
          d="M20.4715 19.2C20.6515 20.16 19.9215 21 19.0015 21H14.5015V18L15.5015 14H9.50146C7.85146 14 6.50146 12.65 6.50146 11V3H12.5015V9H17.5015C18.6015 9 19.5015 9.9 19.5015 11L17.5015 18H18.9415C19.6715 18 20.3315 18.49 20.4715 19.2ZM5.50146 12V3H3.50146V12C3.50146 14.76 5.74146 17 8.50146 17H12.5015V15H8.50146C6.84146 15 5.50146 13.66 5.50146 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatReclineExtra(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_recline_extra">
        <path
          id="Vector"
          d="M5.35 6.13974C4.45 5.49974 4.23 4.25974 4.86 3.34974C5.49 2.44974 6.74 2.22974 7.65 2.85974C8.55 3.49974 8.77 4.73974 8.14 5.64974C7.5 6.54974 6.26 6.76974 5.35 6.13974ZM16 19.4997H8.93C7.45 19.4997 6.19 18.4197 5.97 16.9597L4 7.49974H2L3.99 17.2597C4.37 19.6997 6.47 21.4997 8.94 21.4997H16V19.4997ZM16.23 15.4997H11.35L10.32 11.3997C11.9 12.2897 13.6 12.9397 15.47 12.6197V10.4897C13.84 10.7997 12.03 10.2197 10.78 9.23974L9.14 7.96974C8.91 7.78974 8.65 7.66974 8.38 7.58974C8.06 7.49974 7.72 7.46974 7.39 7.52974H7.37C6.14 7.74974 5.32 8.91974 5.53 10.1397L6.88 16.0597C7.16 17.4797 8.39 18.4997 9.83 18.4997H16.68L20.5 21.4997L22 19.9997L16.23 15.4997Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineSeatReclineNormal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_seat_recline_normal">
        <path
          id="Vector"
          d="M7.59 5.66256C6.81 4.88256 6.81 3.61256 7.59 2.83256C8.37 2.05256 9.64 2.05256 10.42 2.83256C11.2 3.61256 11.2 4.88256 10.42 5.66256C9.63 6.45256 8.37 6.45256 7.59 5.66256ZM6 16.2526V7.25256H4V16.2526C4 19.0126 6.24 21.2526 9 21.2526H15V19.2526H9C7.34 19.2526 6 17.9126 6 16.2526ZM20 20.3226L14.93 15.2526H11.5V11.5726C12.9 12.7226 15.1 13.7326 17 13.7326V11.5726C15.34 11.5926 13.39 10.7026 12.33 9.53256L10.93 7.98256C10.74 7.77256 10.5 7.60256 10.24 7.48256C9.95 7.34256 9.62 7.25256 9.28 7.25256H9.25C8.01 7.25256 7 8.26256 7 9.50256V15.2526C7 16.9126 8.34 18.2526 10 18.2526H15.07L18.57 21.7526L20 20.3226Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlineStops(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airline_stops">
        <path
          id="Vector"
          d="M19.5 8.7C17.04 10.2 14 12.87 13.5 17H15.5V19H9.5V17H11.5C11 12.5 7.13 9 2.5 9V7C6.89 7 10.72 9.55 12.5 13.3C13.88 10.33 16.36 8.27 18.46 6.99L14.5 7V5H21.5V12H19.5V8.7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirlines(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airlines">
        <path
          id="Vector"
          d="M17.34 18H5.8L14.05 6H19.59L17.34 18ZM13 4L2 20H19L22 4H13ZM14.5 9C13.12 9 12 10.12 12 11.5C12 12.88 13.12 14 14.5 14C15.88 14 17 12.88 17 11.5C17 10.12 15.88 9 14.5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirplaneTicket(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airplane_ticket">
        <path
          id="Vector"
          d="M20.19 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.19 4 20.19 4ZM20 18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V18ZM8.87 15.66L7.21 12.78L8.14 12.53L9.4 13.52L11.79 12.88L9.39 8.72L10.79 8.34L14.8 12.08L17.24 11.43C17.75 11.29 18.28 11.6 18.42 12.11C18.55 12.62 18.25 13.15 17.73 13.3L8.87 15.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirplanemodeActive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airplanemode_active">
        <path
          id="Vector"
          d="M22 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2 14V16L10.5 13.5V19L8 20.5V22L12 21L16 22V20.5L13.5 19V13.5L22 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirplanemodeInactive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airplanemode_inactive">
        <path
          id="Vector"
          d="M10.8051 7.36501V3.19501C10.8051 2.36501 11.4751 1.69501 12.3051 1.69501C13.1351 1.69501 13.8051 2.36501 13.8051 3.19501V8.69501L22.3051 13.695V15.695L17.8151 14.375L10.8051 7.36501ZM20.0851 22.305L21.4951 20.895L3.11507 2.50501L1.69507 3.91501L8.07507 10.295L2.30507 13.695V15.695L10.8051 13.195V18.695L8.30507 20.195V21.695L12.3051 20.695L16.3051 21.695V20.195L13.8051 18.695V16.025L20.0851 22.305Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAirplay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airplay">
        <g id="Vector">
          <path d="M6 21.5H18L12 15.5L6 21.5Z" fill="currentColor" />
          <path
            d="M21 2.5H3C1.9 2.5 1 3.4 1 4.5V16.5C1 17.6 1.9 18.5 3 18.5H7V16.5H3V4.5H21V16.5H17V18.5H21C22.1 18.5 23 17.6 23 16.5V4.5C23 3.4 22.1 2.5 21 2.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAirportShuttle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="airport_shuttle">
        <path
          id="Vector"
          d="M17 5H3C1.9 5 1 5.89 1 7V16H3C3 17.66 4.34 19 6 19C7.66 19 9 17.66 9 16H15C15 17.66 16.34 19 18 19C19.66 19 21 17.66 21 16H23V11L17 5ZM15 7H16L19 10H15V7ZM9 7H13V10H9V7ZM3 7H7V10H3V7ZM6 17.25C5.31 17.25 4.75 16.69 4.75 16C4.75 15.31 5.31 14.75 6 14.75C6.69 14.75 7.25 15.31 7.25 16C7.25 16.69 6.69 17.25 6 17.25ZM18 17.25C17.31 17.25 16.75 16.69 16.75 16C16.75 15.31 17.31 14.75 18 14.75C18.69 14.75 19.25 15.31 19.25 16C19.25 16.69 18.69 17.25 18 17.25ZM21 14H20.22C19.67 13.39 18.88 13 18 13C17.12 13 16.33 13.39 15.78 14H8.22C7.67 13.39 6.89 13 6 13C5.11 13 4.33 13.39 3.78 14H3V12H21V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlarm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="alarm">
        <path
          id="Vector"
          d="M12.4994 8.095H10.9994V14.095L15.7494 16.945L16.4994 15.715L12.4994 13.345V8.095ZM17.3364 1.905L21.9434 5.75L20.6634 7.285L16.0534 3.442L17.3364 1.905ZM6.6624 1.905L7.9444 3.441L3.3364 7.285L2.0564 5.749L6.6624 1.905ZM11.9994 4.095C7.0294 4.095 2.9994 8.125 2.9994 13.095C2.9994 18.065 7.0294 22.095 11.9994 22.095C16.9694 22.095 20.9994 18.065 20.9994 13.095C20.9994 8.125 16.9694 4.095 11.9994 4.095ZM11.9994 20.095C8.1394 20.095 4.9994 16.955 4.9994 13.095C4.9994 9.235 8.1394 6.095 11.9994 6.095C15.8594 6.095 18.9994 9.235 18.9994 13.095C18.9994 16.955 15.8594 20.095 11.9994 20.095Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlarmAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="alarm_add">
        <path
          id="Vector"
          d="M17.3365 1.905L21.9435 5.75L20.6635 7.285L16.0535 3.442L17.3365 1.905ZM6.66252 1.905L7.94452 3.441L3.33652 7.285L2.05652 5.749L6.66252 1.905ZM11.9995 4.095C7.02952 4.095 2.99952 8.125 2.99952 13.095C2.99952 18.065 7.02952 22.095 11.9995 22.095C16.9695 22.095 20.9995 18.065 20.9995 13.095C20.9995 8.125 16.9695 4.095 11.9995 4.095ZM11.9995 20.095C8.13952 20.095 4.99952 16.955 4.99952 13.095C4.99952 9.235 8.13952 6.095 11.9995 6.095C15.8595 6.095 18.9995 9.235 18.9995 13.095C18.9995 16.955 15.8595 20.095 11.9995 20.095ZM12.9995 9.095H10.9995V12.095H7.99952V14.095H10.9995V17.095H12.9995V14.095H15.9995V12.095H12.9995V9.095Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlarmOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="alarm_off">
        <path
          id="Vector"
          d="M10.263 6.385C10.883 6.205 11.543 6.095 12.223 6.095C16.083 6.095 19.223 9.235 19.223 13.095C19.223 13.775 19.113 14.435 18.933 15.055L20.493 16.615C20.963 15.535 21.223 14.345 21.223 13.095C21.223 8.125 17.193 4.095 12.223 4.095C10.973 4.095 9.78301 4.355 8.69301 4.815L10.263 6.385ZM17.56 1.905L22.167 5.75L20.887 7.285L16.277 3.442L17.56 1.905ZM3.24301 2.195L1.83301 3.605L3.20301 4.975L2.28301 5.745L3.56301 7.285L4.62301 6.405L5.42301 7.205C4.05301 8.785 3.22301 10.845 3.22301 13.095C3.22301 18.065 7.25301 22.095 12.223 22.095C14.473 22.095 16.533 21.265 18.113 19.895L20.213 21.995L21.623 20.585L3.24301 2.195ZM12.223 20.095C8.36301 20.095 5.22301 16.955 5.22301 13.095C5.22301 11.395 5.83301 9.835 6.84301 8.625L16.693 18.475C15.483 19.485 13.923 20.095 12.223 20.095ZM7.70301 3.825L8.16301 3.445L6.88301 1.905L6.28301 2.405L7.70301 3.825Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlarmOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="alarm_on">
        <path
          id="Vector"
          d="M10.5395 14.625L8.40952 12.495L7.34952 13.555L10.5295 16.735L16.5295 10.735L15.4695 9.675L10.5395 14.625ZM17.3365 1.905L21.9435 5.75L20.6635 7.285L16.0535 3.442L17.3365 1.905ZM6.66252 1.905L7.94452 3.441L3.33652 7.285L2.05652 5.749L6.66252 1.905ZM11.9995 4.095C7.02952 4.095 2.99952 8.125 2.99952 13.095C2.99952 18.065 7.02952 22.095 11.9995 22.095C16.9695 22.095 20.9995 18.065 20.9995 13.095C20.9995 8.125 16.9695 4.095 11.9995 4.095ZM11.9995 20.095C8.13952 20.095 4.99952 16.955 4.99952 13.095C4.99952 9.235 8.13952 6.095 11.9995 6.095C15.8595 6.095 18.9995 9.235 18.9995 13.095C18.9995 16.955 15.8595 20.095 11.9995 20.095Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlbum(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="album">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 7.5C9.51 7.5 7.5 9.51 7.5 12C7.5 14.49 9.51 16.5 12 16.5C14.49 16.5 16.5 14.49 16.5 12C16.5 9.51 14.49 7.5 12 7.5ZM12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlignHorizontalCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="align_horizontal_center">
        <path
          id="Vector"
          d="M11 2H13V7H21V10H13V14H18V17H13V22H11V17H6V14H11V10H3V7H11V2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlignHorizontalLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="align_horizontal_left">
        <path
          id="Vector"
          d="M4 22H2V2H4V22ZM22 7H6V10H22V7ZM16 14H6V17H16V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlignHorizontalRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="align_horizontal_right">
        <path
          id="Vector"
          d="M20 2H22V22H20V2ZM2 10H18V7H2V10ZM8 17H18V14H8V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlignVerticalBottom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="align_vertical_bottom">
        <path
          id="Vector"
          d="M22 22H2V20H22V22ZM10 2H7V18H10V2ZM17 8H14V18H17V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlignVerticalCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="align_vertical_center">
        <path
          id="Vector"
          d="M22.0799 11H17.0799V6H14.0799V11H10.0799V3H7.07992V11H1.91992V13H7.07992V21H10.0799V13H14.0799V18H17.0799V13H22.0799V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlignVerticalTop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="align_vertical_top">
        <path
          id="Vector"
          d="M22 2V4H2V2H22ZM7 22H10V6H7V22ZM14 16H17V6H14V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAllInbox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="all_inbox">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V12C3 13.1 3.9 14 5 14H19C20.1 14 21 13.1 21 12V5C21 3.9 20.1 3 19 3ZM5 10H8.13C8.34 10.78 8.8 11.47 9.4 12H5V10ZM19 12H14.6C15.2 11.47 15.66 10.78 15.87 10H19V12ZM19 8H14V9C14 10.07 13.07 11 12 11C10.93 11 10 10.07 10 9V8H5V5H19V8ZM14 15V16C14 16.47 13.81 16.9 13.52 17.25C13.15 17.7 12.6 18 12 18C11.4 18 10.85 17.7 10.48 17.25C10.19 16.9 10 16.47 10 16V15H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15H14ZM5 17H8.13C8.15 17.09 8.19 17.17 8.22 17.25C8.46 17.93 8.87 18.53 9.4 19H5V17ZM19 19H14.6C15.14 18.53 15.55 17.93 15.78 17.25C15.81 17.17 15.85 17.09 15.87 17H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAllInclusive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="all_inclusive">
        <path
          id="Vector"
          d="M18.6 6.62C17.16 6.62 15.8 7.17999 14.83 8.14999L7.8 14.39C7.16 15.03 6.31 15.38 5.4 15.38C3.53 15.38 2.01 13.87 2.01 12C2.01 10.13 3.53 8.62 5.4 8.62C6.31 8.62 7.16 8.96999 7.84 9.64999L8.97 10.65L10.48 9.31L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62C2.42 6.62 0 9.04 0 12C0 14.96 2.42 17.38 5.4 17.38C6.84 17.38 8.2 16.82 9.17 15.85L16.2 9.60999C16.84 8.97 17.69 8.62 18.6 8.62C20.47 8.62 21.99 10.13 21.99 12C21.99 13.87 20.47 15.38 18.6 15.38C17.7 15.38 16.84 15.03 16.16 14.35L15.02 13.34L13.51 14.68L14.78 15.8C15.8 16.81 17.15 17.37 18.6 17.37C21.58 17.37 24 14.96 24 11.99C24 9.01999 21.58 6.62 18.6 6.62Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAllOut(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="all_out">
        <path
          id="Vector"
          d="M4 4V8L8 4H4ZM16 4L20 8V4H16ZM20 20V16L16 20H20ZM4 20H8L4 16V20ZM19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAltRoute(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="alt_route">
        <path
          id="Vector"
          d="M9.78 11.16L8.36 12.58C7.68 11.89 7.02 11 6.57 9.64L8.51 9.15C8.83 10.04 9.28 10.65 9.78 11.16ZM11 6L7 2L3 6H6.02C6.04 6.81 6.1 7.54 6.21 8.17L8.15 7.68C8.08 7.2 8.03 6.63 8.02 6H11ZM21 6L17 2L13 6H15.99C15.89 9.68 14.71 10.75 13.45 11.88C12.95 12.32 12.44 12.8 12 13.43C11.66 12.94 11.27 12.55 10.87 12.19L9.46 13.6C10.39 14.45 11 15.14 11 17V22H13V17C13 14.98 13.71 14.34 14.79 13.37C16.17 12.13 17.87 10.59 17.99 6H21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAlternateEmail(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="alternate_email">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22H17V20H12C7.66 20 4 16.34 4 12C4 7.66 7.66 4 12 4C16.34 4 20 7.66 20 12V13.43C20 14.22 19.29 15 18.5 15C17.71 15 17 14.22 17 13.43V12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.38 17 14.64 16.44 15.54 15.53C16.19 16.42 17.31 17 18.5 17C20.47 17 22 15.4 22 13.43V12C22 6.48 17.52 2 12 2ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAnalytics(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="analytics">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M9 12H7V17H9V12Z" fill="currentColor" />
          <path d="M17 7H15V17H17V7Z" fill="currentColor" />
          <path d="M13 14H11V17H13V14Z" fill="currentColor" />
          <path d="M13 10H11V12H13V10Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAnchor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="anchor">
        <path
          id="Vector"
          d="M17 15L18.55 16.55C17.59 18.24 15.22 19.59 13 19.92V11H16V9H13V7.82C14.16 7.4 15 6.3 15 5C15 3.35 13.65 2 12 2C10.35 2 9 3.35 9 5C9 6.3 9.84 7.4 11 7.82V9H8V11H11V19.92C8.78 19.59 6.41 18.24 5.45 16.55L7 15L3 12V15C3 18.88 7.92 22 12 22C16.08 22 21 18.88 21 15V12L17 15ZM12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAndroid(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="android">
        <path
          id="Vector"
          d="M17.6 9.79138L19.44 6.61138C19.6 6.30138 19.48 5.92138 19.18 5.76138C18.89 5.61138 18.53 5.70138 18.35 5.98138L16.47 9.22138C13.61 8.01138 10.39 8.01138 7.53 9.22138L5.65 5.98138C5.46 5.69138 5.07 5.60138 4.78 5.78138C4.5 5.96138 4.41 6.32138 4.56 6.61138L6.4 9.79138C3.3 11.5614 1.28 14.7514 1 18.3114H23C22.72 14.7514 20.7 11.5614 17.6 9.79138ZM7 15.5614C6.31 15.5614 5.75 15.0014 5.75 14.3114C5.75 13.6214 6.31 13.0614 7 13.0614C7.69 13.0614 8.25 13.6214 8.25 14.3114C8.25 15.0014 7.69 15.5614 7 15.5614ZM17 15.5614C16.31 15.5614 15.75 15.0014 15.75 14.3114C15.75 13.6214 16.31 13.0614 17 13.0614C17.69 13.0614 18.25 13.6214 18.25 14.3114C18.25 15.0014 17.69 15.5614 17 15.5614Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAnimation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="animation">
        <path
          id="Vector"
          d="M15 2C12.29 2 9.95 3.54 8.78 5.78C7.5 6.45 6.44 7.5 5.78 8.78C3.54 9.95 2 12.29 2 15C2 18.87 5.13 22 9 22C11.71 22 14.05 20.46 15.22 18.22C16.5 17.55 17.56 16.5 18.22 15.22C20.46 14.05 22 11.71 22 9C22 5.13 18.87 2 15 2ZM9 20C6.24 20 4 17.76 4 15C4 13.88 4.37 12.84 5 12C5 15.87 8.13 19 12 19C11.16 19.63 10.12 20 9 20ZM12 17C9.24 17 7 14.76 7 12C7 10.88 7.37 9.84 8 9C8 12.86 11.13 15.99 15 16C14.16 16.63 13.12 17 12 17ZM16.7 13.7C16.17 13.89 15.6 14 15 14C12.24 14 10 11.76 10 9C10 8.4 10.11 7.83 10.3 7.3C10.83 7.11 11.4 7 12 7C14.76 7 17 9.24 17 12C17 12.6 16.89 13.17 16.7 13.7ZM19 12C19 8.14 15.87 5.01 12 5C12.84 4.37 13.87 4 15 4C17.76 4 20 6.24 20 9C20 10.12 19.63 11.16 19 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAnnouncement(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="announcement">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM11 5H13V11H11V5ZM11 13H13V15H11V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAod(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="aod">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM17 4H7V3H17V4ZM8 10H16V11.5H8V10ZM9 13H15V14.5H9V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconApartment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="apartment">
        <path
          id="Vector"
          d="M17 11V3H7V7H3V21H11V17H13V21H21V11H17ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM15 15H13V13H15V15ZM15 11H13V9H15V11ZM15 7H13V5H15V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconApi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="api">
        <path
          id="Vector"
          d="M14 12L12 14L10 12L12 10L14 12ZM12 6L14.12 8.12L16.62 5.62L12 1L7.38 5.62L9.88 8.12L12 6ZM6 12L8.12 9.88L5.62 7.38L1 12L5.62 16.62L8.12 14.12L6 12ZM18 12L15.88 14.12L18.38 16.62L23 12L18.38 7.38L15.88 9.88L18 12ZM12 18L9.88 15.88L7.38 18.38L12 23L16.62 18.38L14.12 15.88L12 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAppBlocking(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="app_blocking">
        <g id="Vector">
          <path
            d="M16.5 8C14.29 8 12.5 9.79 12.5 12C12.5 14.21 14.29 16 16.5 16C18.71 16 20.5 14.21 20.5 12C20.5 9.79 18.71 8 16.5 8ZM14 12C14 10.62 15.12 9.5 16.5 9.5C16.92 9.5 17.3 9.61 17.65 9.79L14.29 13.15C14.11 12.8 14 12.42 14 12ZM16.5 14.5C16.08 14.5 15.7 14.39 15.35 14.21L18.71 10.85C18.89 11.2 19 11.58 19 12C19 13.38 17.88 14.5 16.5 14.5Z"
            fill="currentColor"
          />
          <path
            d="M15.5 18H5.5V6H15.5V7H17.5V3C17.5 1.9 16.6 1 15.5 1H5.5C4.4 1 3.5 1.9 3.5 3V21C3.5 22.1 4.4 23 5.5 23H15.5C16.6 23 17.5 22.1 17.5 21V17H15.5V18ZM5.5 3H15.5V4H5.5V3ZM15.5 21H5.5V20H15.5V21Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAppRegistration(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="app_registration">
        <g id="Vector">
          <path d="M13.5 4H9.5V8H13.5V4Z" fill="currentColor" />
          <path d="M7.5 16H3.5V20H7.5V16Z" fill="currentColor" />
          <path d="M7.5 10H3.5V14H7.5V10Z" fill="currentColor" />
          <path d="M7.5 4H3.5V8H7.5V4Z" fill="currentColor" />
          <path d="M19.5 4H15.5V8H19.5V4Z" fill="currentColor" />
          <path d="M10.5 17.86V20H12.6L18.58 14.03L16.46 11.91L10.5 17.86Z" fill="currentColor" />
          <path d="M13.5 12.03V10H9.5V14H11.53L13.5 12.03Z" fill="currentColor" />
          <path
            d="M20.35 11.56L18.94 10.15C18.74 9.95 18.43 9.95 18.23 10.15L17.17 11.21L19.29 13.33L20.35 12.27C20.55 12.07 20.55 11.76 20.35 11.56Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAppSettingsAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="app_settings_alt">
        <path
          id="Vector"
          d="M20.3278 12.74L19.5078 12.11C19.5078 12.02 19.5078 11.98 19.5078 11.89L20.3078 11.26C20.4678 11.14 20.5078 10.92 20.4078 10.75L19.5578 9.27C19.4878 9.14 19.3478 9.07 19.2078 9.07C19.1578 9.07 19.1078 9.08 19.0578 9.1L18.1078 9.48C18.0278 9.43 17.9978 9.41 17.9178 9.37L17.7678 8.36C17.7378 8.15 17.5678 8 17.3678 8H15.6578C15.4578 8 15.2878 8.15 15.2578 8.34L15.1178 9.35C15.0878 9.37 15.0478 9.38 15.0178 9.4C14.9878 9.42 14.9578 9.44 14.9278 9.46L13.9778 9.08C13.9278 9.06 13.8778 9.05 13.8278 9.05C13.6878 9.05 13.5578 9.12 13.4778 9.25L12.6278 10.73C12.5278 10.9 12.5678 11.12 12.7278 11.24L13.5278 11.87C13.5278 11.96 13.5278 12 13.5278 12.1L12.7278 12.73C12.5678 12.85 12.5278 13.07 12.6278 13.24L13.4778 14.72C13.5478 14.85 13.6878 14.92 13.8278 14.92C13.8778 14.92 13.9278 14.91 13.9778 14.89L14.9278 14.52C15.0078 14.57 15.0478 14.59 15.1278 14.63L15.2778 15.64C15.3078 15.84 15.4778 15.98 15.6778 15.98H17.3878C17.5878 15.98 17.7578 15.83 17.7878 15.64L17.9378 14.63C17.9678 14.61 18.0078 14.6 18.0378 14.58C18.0678 14.56 18.0978 14.54 18.1278 14.52L19.0778 14.9C19.1278 14.92 19.1778 14.93 19.2278 14.93C19.3678 14.93 19.4978 14.86 19.5778 14.73L20.4278 13.25C20.5278 13.08 20.4878 12.86 20.3278 12.74ZM16.5178 13.5C15.6878 13.5 15.0178 12.83 15.0178 12C15.0178 11.17 15.6878 10.5 16.5178 10.5C17.3478 10.5 18.0178 11.17 18.0178 12C18.0178 12.83 17.3478 13.5 16.5178 13.5ZM15.5178 18H5.51782V6H15.5178V7H17.5178V3C17.5178 1.9 16.6178 1 15.5178 1H5.51782C4.41782 1 3.51782 1.9 3.51782 3V21C3.51782 22.1 4.41782 23 5.51782 23H15.5178C16.6178 23 17.5178 22.1 17.5178 21V17H15.5178V18ZM5.51782 3H15.5178V4H5.51782V3ZM15.5178 21H5.51782V20H15.5178V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAppShortcut(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="app_shortcut">
        <g id="Vector">
          <path
            d="M15 18H5V6H15V7H17V3C17 1.9 16.1 1 15 1H5C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H15C16.1 23 17 22.1 17 21V17H15V18ZM5 3H15V4H5V3ZM15 21H5V20H15V21Z"
            fill="currentColor"
          />
          <path
            d="M18.38 9.62L19 11L19.62 9.62L21 9L19.62 8.38L19 7L18.38 8.38L17 9L18.38 9.62Z"
            fill="currentColor"
          />
          <path
            d="M14 8L12.75 10.75L10 12L12.75 13.25L14 16L15.25 13.25L18 12L15.25 10.75L14 8Z"
            fill="currentColor"
          />
          <path
            d="M19 13L18.38 14.38L17 15L18.38 15.62L19 17L19.62 15.62L21 15L19.62 14.38L19 13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconApproval(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="approval">
        <path
          id="Vector"
          d="M4 16V22H20V16C20 14.9 19.1 14 18 14H6C4.9 14 4 14.9 4 16ZM18 18H6V16H18V18ZM12 2C9.24 2 7 4.24 7 7L12 14L17 7C17 4.24 14.76 2 12 2ZM12 11L9 7C9 5.34 10.34 4 12 4C13.66 4 15 5.34 15 7L12 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconApps(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="apps">
        <path
          id="Vector"
          d="M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAppsOutage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="apps_outage">
        <path
          id="Vector"
          d="M2 10H6V6H2V10ZM8 22H12V18H8V22ZM2 22H6V18H2V22ZM2 16H6V12H2V16ZM8 16H12V12H8V16ZM14 22H18V18H14V22ZM17 2C14.24 2 12 4.24 12 7C12 9.76 14.24 12 17 12C19.76 12 22 9.76 22 7C22 4.24 19.76 2 17 2ZM17.5 10H16.5V9H17.5V10ZM17.5 8H16.5V4H17.5V8ZM14 16H18V13.93C17.67 13.98 17.34 14 17 14C15.93 14 14.91 13.76 14 13.32V16ZM8 6V10H10.68C10.24 9.09 10 8.07 10 7C10 6.66 10.02 6.33 10.07 6H8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArchitecture(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="architecture">
        <g id="Vector">
          <path
            d="M6.35498 18.78L6.60498 21L8.22498 19.46L10.995 11.86C10.315 11.69 9.71498 11.35 9.22498 10.88L6.35498 18.78Z"
            fill="currentColor"
          />
          <path
            d="M14.765 10.88C14.275 11.35 13.665 11.69 12.995 11.86L15.765 19.46L17.385 21L17.645 18.78L14.765 10.88Z"
            fill="currentColor"
          />
          <path
            d="M14.995 8C14.995 6.7 14.155 5.6 12.995 5.18V3H10.995V5.18C9.83498 5.6 8.99498 6.7 8.99498 8C8.99498 9.66 10.335 11 11.995 11C13.655 11 14.995 9.66 14.995 8ZM11.995 9C11.445 9 10.995 8.55 10.995 8C10.995 7.45 11.445 7 11.995 7C12.545 7 12.995 7.45 12.995 8C12.995 8.55 12.545 9 11.995 9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconArchive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="archive">
        <path
          id="Vector"
          d="M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.57 5.97H5.44L6.24 5ZM5 19V8H19V19H5ZM13.45 10H10.55V13H8L12 17L16 13H13.45V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAreaChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="area_chart">
        <path
          id="Vector"
          d="M17 7.5L12 3.5L7 10.5L3 7.5V20.5H21V7.5H17ZM19 17.45L12 12L8 17.5L5 15.1V11.5L7.44 13.33L12.4 6.38L16.3 9.5H19V17.45Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowBack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_back">
        <path
          id="Vector"
          d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowBackIos(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_back_ios">
        <path
          id="Vector"
          d="M17.835 3.86998L16.055 2.09998L6.16504 12L16.065 21.9L17.835 20.13L9.70504 12L17.835 3.86998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowBackIosNew(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_back_ios_new">
        <path
          id="Vector"
          d="M17.885 3.77L16.115 2L6.11499 12L16.115 22L17.885 20.23L9.65499 12L17.885 3.77Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowCircleDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_circle_down">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 12V8H11V12H8L12 16L16 12H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowCircleLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_circle_left">
        <path
          id="Vector"
          d="M2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12ZM20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12ZM8 12L12 8L13.41 9.41L11.83 11H16V13H11.83L13.42 14.59L12 16L8 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowCircleRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_circle_right">
        <path
          id="Vector"
          d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12ZM4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12ZM16 12L12 16L10.59 14.59L12.17 13H8V11H12.17L10.58 9.41L12 8L16 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowCircleUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_circle_up">
        <path
          id="Vector"
          d="M12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM11 12V16H13V12H16L12 8L8 12H11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowDownward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_downward">
        <path
          id="Vector"
          d="M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowDropDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_drop_down">
        <path id="Vector" d="M7 9.5L12 14.5L17 9.5H7Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconArrowDropDownCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_drop_down_circle">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 15L8 11H16L12 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowDropUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_drop_up">
        <path id="Vector" d="M7 14.5L12 9.5L17 14.5H7Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconArrowForward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_forward">
        <path
          id="Vector"
          d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowForwardIos(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_forward_ios">
        <path
          id="Vector"
          d="M6.11499 20.23L7.88499 22L17.885 12L7.88499 2L6.11499 3.77L14.345 12L6.11499 20.23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_left">
        <path id="Vector" d="M14.5 7L9.5 12L14.5 17V7Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconArrowOutward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_outward">
        <path
          id="Vector"
          d="M6.5 5.5V7.5H15.09L5.5 17.09L6.91 18.5L16.5 8.91V17.5H18.5V5.5H6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArrowRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_right">
        <path id="Vector" d="M9.5 17L14.5 12L9.5 7V17Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconArrowRightAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_right_alt">
        <path id="Vector" d="M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconArrowUpward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_upward">
        <path
          id="Vector"
          d="M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArtTrack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="art_track">
        <path
          id="Vector"
          d="M22 13H14V11H22V13ZM22 7H14V9H22V7ZM14 17H22V15H14V17ZM12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9ZM10.5 15L8.25 12L6.5 14.26L5.25 12.75L3.5 15H10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconArticle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="article">
        <g id="Vector">
          <path
            d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
            fill="currentColor"
          />
          <path d="M14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAspectRatio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="aspect_ratio">
        <path
          id="Vector"
          d="M19 12H17V15H14V17H19V12ZM7 9H10V7H5V12H7V9ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssessment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assessment">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssignment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assignment">
        <path
          id="Vector"
          d="M7 16H14V18H7V16ZM7 12H17V14H7V12ZM7 8H17V10H7V8ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssignmentInd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assignment_ind">
        <path
          id="Vector"
          d="M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.22 3.75 12.41 3.85 12.55 4C12.67 4.13 12.75 4.31 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.31 11.33 4.13 11.45 4C11.59 3.85 11.78 3.75 12 3.75ZM19 20H5V6H19V20ZM12 7C10.35 7 9 8.35 9 10C9 11.65 10.35 13 12 13C13.65 13 15 11.65 15 10C15 8.35 13.65 7 12 7ZM12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11ZM6 17.47V19H18V17.47C18 14.97 14.03 13.89 12 13.89C9.97 13.89 6 14.96 6 17.47ZM8.31 17C9 16.44 10.69 15.88 12 15.88C13.31 15.88 15.01 16.44 15.69 17H8.31Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssignmentLate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assignment_late">
        <path
          id="Vector"
          d="M11 16H13V18H11V16ZM11 8H13V14H11V8ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssignmentReturn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assignment_return">
        <path
          id="Vector"
          d="M12 15H16V11H12V8L7 13L12 18V15ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssignmentReturned(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assignment_returned">
        <path
          id="Vector"
          d="M17 13H14V9H10V13H7L12 18L17 13ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssignmentTurnedIn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assignment_turned_in">
        <path
          id="Vector"
          d="M18 10L16.59 8.58L10 15.17L7.41 12.59L6 14L10 18L18 10ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssistWalker(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assist_walker">
        <g id="Vector">
          <path
            d="M13.1752 7C14.2798 7 15.1752 6.10457 15.1752 5C15.1752 3.89543 14.2798 3 13.1752 3C12.0706 3 11.1752 3.89543 11.1752 5C11.1752 6.10457 12.0706 7 13.1752 7Z"
            fill="currentColor"
          />
          <path
            d="M20.4452 18.22L19.8052 11.85C19.7352 11.08 19.0852 10.5 18.3152 10.5H16.6752C15.1752 10.48 13.8152 9.96 12.9152 9.06L10.9152 7.08C10.7552 6.92 10.2952 6.5 9.5052 6.5C8.9952 6.5 8.4852 6.7 8.0952 7.09L4.7552 10.41C4.2252 11.09 4.2452 11.98 4.5452 12.54L5.9752 15.34L2.8252 19.39L4.3952 20.63L8.0752 15.9L7.9052 14.54L8.6752 15.25V20.5H10.6752V14.38L8.5552 12.26L10.9152 9.9C11.8552 10.84 12.6352 11.72 14.5052 12.22L13.6752 20.5H15.1752L15.5852 17H18.7652L18.9052 18.22C18.4652 18.48 18.1752 18.96 18.1752 19.5C18.1752 20.33 18.8452 21 19.6752 21C20.5052 21 21.1752 20.33 21.1752 19.5C21.1752 18.96 20.8852 18.48 20.4452 18.22ZM15.7652 15.5L16.1752 12H18.1752L18.5852 15.5H15.7652Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAssistant(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assistant">
        <path
          id="Vector"
          d="M19 1.5H5C3.9 1.5 3 2.4 3 3.5V17.5C3 18.6 3.9 19.5 5 19.5H9L12 22.5L15 19.5H19C20.1 19.5 21 18.6 21 17.5V3.5C21 2.4 20.1 1.5 19 1.5ZM19 17.5H14.17L12 19.67L9.83 17.5H5V3.5H19V17.5ZM12 16.5L13.88 12.38L18 10.5L13.88 8.62L12 4.5L10.12 8.62L6 10.5L10.12 12.38L12 16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssistantDirection(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assistant_direction">
        <g id="Vector">
          <path
            d="M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM12 21C7.01 21 3 16.99 3 12C3 7.01 7.01 3 12 3C16.99 3 21 7.01 21 12C21 16.99 16.99 21 12 21Z"
            fill="currentColor"
          />
          <path
            d="M19.73 11.42L12.54 4.2C12.18 3.93 11.74 3.93 11.39 4.2L4.2 11.42C3.93 11.78 3.93 12.22 4.2 12.58L11.39 19.8C11.75 20.07 12.19 20.07 12.54 19.8L19.73 12.58C20.09 12.22 20.09 11.69 19.73 11.42ZM13.5 14.5L12.09 13.09L13.17 12H10V15H8V11C8 10.4 8.4 10 9 10H13.17L12.08 8.91L13.5 7.5L17 11L13.5 14.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAssistantPhoto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assistant_photo">
        <path
          id="Vector"
          d="M11.86 5.5L11.94 5.89L12.26 7.5H17.5V13.5H14.14L14.06 13.11L13.74 11.5H6.5V5.5H11.86ZM13.5 3.5H4.5V20.5H6.5V13.5H12.1L12.5 15.5H19.5V5.5H13.9L13.5 3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAssuredWorkload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="assured_workload">
        <g id="Vector">
          <path d="M6 9.5H4V16.5H6V9.5Z" fill="currentColor" />
          <path d="M12 9.5H10V16.5H12V9.5Z" fill="currentColor" />
          <path
            d="M21 5.5L11 0.5L1 5.5V7.5H21V5.5ZM5.47 5.5L11 2.74L16.53 5.5H5.47Z"
            fill="currentColor"
          />
          <path d="M1 18.5V20.5H13.4C13.19 19.86 13.08 19.19 13.04 18.5H1Z" fill="currentColor" />
          <path d="M18 11.76V9.5H16V12.76L18 11.76Z" fill="currentColor" />
          <path
            d="M19 13.5L15 15.5V18.05C15 20.57 16.71 22.93 19 23.5C21.29 22.93 23 20.57 23 18.05V15.5L19 13.5ZM18.28 20.5L16.25 18.47L17.31 17.41L18.28 18.38L20.69 16L21.75 17.06L18.28 20.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAtm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="atm">
        <path
          id="Vector"
          d="M8 9V10.5H10.25V15H11.75V10.5H14V9H8ZM6 9H3C2.45 9 2 9.45 2 10V15H3.5V13.5H5.5V15H7V10C7 9.45 6.55 9 6 9ZM5.5 12H3.5V10.5H5.5V12ZM21 9H16.5C15.95 9 15.5 9.45 15.5 10V15H17V10.5H18V14H19.5V10.49H20.5V15H22V10C22 9.45 21.55 9 21 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAttachEmail(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="attach_email">
        <g id="Vector">
          <path
            d="M3 6L11 11L19 6V9H21V4C21 2.9 20.1 2 19 2H3C1.9 2 1.01 2.9 1.01 4L1 16C1 17.1 1.9 18 3 18H13V16H3V6ZM19 4L11 9L3 4H19Z"
            fill="currentColor"
          />
          <path
            d="M21 14V18C21 19.1 20.1 20 19 20C17.9 20 17 19.1 17 18V13.5C17 13.22 17.22 13 17.5 13C17.78 13 18 13.22 18 13.5V18H20V13.5C20 12.12 18.88 11 17.5 11C16.12 11 15 12.12 15 13.5V18C15 20.21 16.79 22 19 22C21.21 22 23 20.21 23 18V14H21Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAttachFile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="attach_file">
        <path
          id="Vector"
          d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5V5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5V5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5V17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAttachMoney(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="attach_money">
        <path
          id="Vector"
          d="M12.3899 10.9C10.1199 10.31 9.38991 9.7 9.38991 8.75C9.38991 7.66 10.3999 6.9 12.0899 6.9C13.8699 6.9 14.5299 7.75 14.5899 9H16.7999C16.7299 7.28 15.6799 5.7 13.5899 5.19V3H10.5899V5.16C8.64991 5.58 7.08991 6.84 7.08991 8.77C7.08991 11.08 8.99991 12.23 11.7899 12.9C14.2899 13.5 14.7899 14.38 14.7899 15.31C14.7899 16 14.2999 17.1 12.0899 17.1C10.0299 17.1 9.21991 16.18 9.10991 15H6.90991C7.02991 17.19 8.66991 18.42 10.5899 18.83V21H13.5899V18.85C15.5399 18.48 17.0899 17.35 17.0899 15.3C17.0899 12.46 14.6599 11.49 12.3899 10.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAttachment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="attachment">
        <path
          id="Vector"
          d="M18 16H6.5C4.29 16 2.5 14.21 2.5 12C2.5 9.79 4.29 8 6.5 8H19C20.38 8 21.5 9.12 21.5 10.5C21.5 11.88 20.38 13 19 13H8.5C7.95 13 7.5 12.55 7.5 12C7.5 11.45 7.95 11 8.5 11H18V9.5H8.5C7.12 9.5 6 10.62 6 12C6 13.38 7.12 14.5 8.5 14.5H19C21.21 14.5 23 12.71 23 10.5C23 8.29 21.21 6.5 19 6.5H6.5C3.46 6.5 1 8.96 1 12C1 15.04 3.46 17.5 6.5 17.5H18V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAttractions(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="attractions">
        <path
          id="Vector"
          d="M20.1486 14.42C20.3786 13.65 20.4986 12.84 20.4986 12C20.4986 11.16 20.3786 10.35 20.1486 9.58C20.9286 8.98 21.1686 7.88 20.6586 7C20.1486 6.12 19.0786 5.77 18.1686 6.15C17.0586 4.98 15.6086 4.12 13.9886 3.73C13.8486 2.75 13.0086 2 11.9986 2C10.9886 2 10.1486 2.75 10.0186 3.73C8.38859 4.12 6.94859 4.98 5.82859 6.15C4.91859 5.77 3.84859 6.12 3.33859 7C2.82859 7.88 3.06859 8.98 3.84859 9.58C3.61859 10.35 3.49859 11.16 3.49859 12C3.49859 12.84 3.61859 13.65 3.84859 14.42C3.06859 15.02 2.82859 16.12 3.33859 17C3.84859 17.88 4.91859 18.23 5.82859 17.85C6.22859 18.27 6.65859 18.64 7.12859 18.97L5.77859 22H7.65859L8.63859 19.81C9.07859 20 9.53859 20.15 10.0186 20.27C10.1486 21.25 10.9886 22 11.9986 22C13.0086 22 13.8486 21.25 13.9786 20.27C14.4386 20.16 14.8886 20.01 15.3186 19.83L16.2986 22H18.1786L16.8386 19C17.3186 18.66 17.7686 18.28 18.1786 17.85C19.0886 18.23 20.1686 17.88 20.6686 17C21.1686 16.12 20.9286 15.02 20.1486 14.42ZM13.5586 18.75C13.1886 18.29 12.6286 18 11.9986 18C11.3686 18 10.7986 18.29 10.4286 18.75C10.0286 18.66 9.63859 18.54 9.26859 18.38L10.6986 15.19C11.0986 15.35 11.5386 15.44 11.9986 15.44C12.4386 15.44 12.8686 15.36 13.2586 15.21L14.6786 18.39C14.3186 18.54 13.9486 18.66 13.5586 18.75ZM10.4786 12.02C10.4786 11.19 11.1486 10.52 11.9786 10.52C12.8086 10.52 13.4786 11.19 13.4786 12.02C13.4786 12.85 12.8086 13.52 11.9786 13.52C11.1486 13.52 10.4786 12.85 10.4786 12.02ZM18.7086 14.01C18.0986 14.08 17.5286 14.42 17.1886 15C16.8686 15.56 16.8486 16.2 17.0686 16.75C16.7886 17.04 16.4886 17.3 16.1686 17.54L14.6686 14.19C15.1586 13.6 15.4486 12.85 15.4486 12.03C15.4486 10.14 13.8986 8.62 11.9886 8.62C10.0786 8.62 8.52859 10.15 8.52859 12.03C8.52859 12.83 8.80859 13.57 9.27859 14.16L7.75859 17.55C7.44859 17.32 7.15859 17.07 6.88859 16.79C7.14859 16.23 7.12859 15.57 6.79859 15C6.45859 14.41 5.86859 14.06 5.23859 14.01C5.01859 13.33 4.90859 12.61 4.90859 11.86C4.90859 11.22 4.99859 10.6 5.15859 10.01C5.81859 9.98 6.45859 9.63 6.80859 9.01C7.17859 8.38 7.15859 7.63 6.81859 7.03C7.73859 6.05 8.92859 5.34 10.2686 5C10.6086 5.59 11.2586 6 11.9986 6C12.7386 6 13.3886 5.6 13.7286 5C15.0686 5.34 16.2586 6.07 17.1686 7.05C16.8486 7.64 16.8386 8.38 17.1986 9C17.5486 9.6 18.1586 9.95 18.7986 10C18.9586 10.59 19.0486 11.21 19.0486 11.86C19.0486 12.61 18.9286 13.33 18.7086 14.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAttribution(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="attribution">
        <g id="Vector">
          <path
            d="M12 8.5C11.09 8.5 9.25 8.96 9.25 9.88V14.5H10.75V19H13.25V14.5H14.75V9.88C14.75 8.97 12.91 8.5 12 8.5ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAudioFile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="audio_file">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6ZM16 11H12V14.88C11.64 14.64 11.21 14.5 10.75 14.5C9.51 14.5 8.5 15.51 8.5 16.75C8.5 17.99 9.51 19 10.75 19C11.99 19 13 17.99 13 16.75V13H16V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAudiotrack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="audiotrack">
        <path
          id="Vector"
          d="M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10 21C12.21 21 14 19.21 14 17V7H18V3H12ZM10 19C8.9 19 8 18.1 8 17C8 15.9 8.9 15 10 15C11.1 15 12 15.9 12 17C12 18.1 11.1 19 10 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAutoAwesome(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_awesome">
        <g id="Vector">
          <path
            d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9Z"
            fill="currentColor"
          />
          <path
            d="M19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z"
            fill="currentColor"
          />
          <path
            d="M11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM9.99 12.99L9 15.17L8.01 12.99L5.83 12L8.01 11.01L9 8.83L9.99 11.01L12.17 12L9.99 12.99Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoAwesomeMosaic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_awesome_mosaic">
        <g id="Vector">
          <path
            d="M3 5V19C3 20.1 3.89 21 5 21H11V3H5C3.89 3 3 3.9 3 5ZM9 19H5V5H9V19Z"
            fill="currentColor"
          />
          <path d="M19 3H13V11H21V5C21 3.9 20.1 3 19 3ZM19 9H15V5H19V9Z" fill="currentColor" />
          <path
            d="M13 21H19C20.1 21 21 20.1 21 19V13H13V21ZM15 15H19V19H15V15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoAwesomeMotion(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_awesome_motion">
        <path
          id="Vector"
          d="M14 2H4C2.9 2 2 2.9 2 4V14H4V4H14V2ZM18 6H8C6.9 6 6 6.9 6 8V18H8V8H18V6ZM20 10H12C10.9 10 10 10.9 10 12V20C10 21.1 10.9 22 12 22H20C21.1 22 22 21.1 22 20V12C22 10.9 21.1 10 20 10ZM20 20H12V12H20V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAutoDelete(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_delete">
        <g id="Vector">
          <path d="M15 2H11.5L10.5 1H5.5L4.5 2H1V4H15V2Z" fill="currentColor" />
          <path
            d="M16 9C15.3 9 14.63 9.1 14 9.29V5H2V17C2 18.1 2.9 19 4 19H9.68C10.8 21.36 13.21 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9ZM9 16C9 16.34 9.03 16.67 9.08 17H4V7H12V10.26C10.19 11.53 9 13.62 9 16ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21Z"
            fill="currentColor"
          />
          <path d="M16.5 12H15V17L18.6 19.1L19.4 17.9L16.5 16.2V12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoFixHigh(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_fix_high">
        <g id="Vector">
          <path
            d="M19.5013 7.5L20.4413 5.44L22.5013 4.5L20.4413 3.56L19.5013 1.5L18.5613 3.56L16.5013 4.5L18.5613 5.44L19.5013 7.5Z"
            fill="currentColor"
          />
          <path
            d="M8.00128 7.5L8.94128 5.44L11.0013 4.5L8.94128 3.56L8.00128 1.5L7.06128 3.56L5.00128 4.5L7.06128 5.44L8.00128 7.5Z"
            fill="currentColor"
          />
          <path
            d="M19.5013 13L18.5613 15.06L16.5013 16L18.5613 16.94L19.5013 19L20.4413 16.94L22.5013 16L20.4413 15.06L19.5013 13Z"
            fill="currentColor"
          />
          <path
            d="M17.2113 9.62L14.3813 6.79C14.1813 6.6 13.9313 6.5 13.6713 6.5C13.4113 6.5 13.1613 6.6 12.9613 6.79L1.79128 17.96C1.40128 18.35 1.40128 18.98 1.79128 19.37L4.62128 22.2C4.82128 22.4 5.07128 22.5 5.33128 22.5C5.59128 22.5 5.84128 22.4 6.04128 22.21L17.2113 11.04C17.6013 10.65 17.6013 10.01 17.2113 9.62ZM13.6713 8.92L15.0813 10.33L13.9113 11.5L12.5013 10.09L13.6713 8.92ZM5.33128 20.09L3.92128 18.68L11.0913 11.5L12.5013 12.91L5.33128 20.09Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoFixNormal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_fix_normal">
        <g id="Vector">
          <path
            d="M19.5013 7.5L20.4413 5.44L22.5013 4.5L20.4413 3.56L19.5013 1.5L18.5613 3.56L16.5013 4.5L18.5613 5.44L19.5013 7.5Z"
            fill="currentColor"
          />
          <path
            d="M17.2113 9.62L14.3813 6.79C14.1813 6.6 13.9313 6.5 13.6713 6.5C13.4113 6.5 13.1613 6.6 12.9613 6.79L1.79128 17.96C1.40128 18.35 1.40128 18.98 1.79128 19.37L4.62128 22.2C4.82128 22.4 5.07128 22.5 5.33128 22.5C5.59128 22.5 5.84128 22.4 6.04128 22.21L17.2113 11.04C17.6013 10.65 17.6013 10.01 17.2113 9.62ZM13.6713 8.92L15.0813 10.33L13.9113 11.5L12.5013 10.09L13.6713 8.92ZM5.33128 20.09L3.92128 18.68L11.0913 11.5L12.5013 12.91L5.33128 20.09Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoFixOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_fix_off">
        <g id="Vector">
          <path
            d="M19.8051 7.19495L20.7451 5.13495L22.8051 4.19495L20.7451 3.25495L19.8051 1.19495L18.8651 3.25495L16.8051 4.19495L18.8651 5.13495L19.8051 7.19495Z"
            fill="currentColor"
          />
          <path
            d="M13.9751 8.61495L15.3851 10.0249L13.9251 11.4849L15.3351 12.8949L17.5051 10.7249C17.8951 10.3349 17.8951 9.70495 17.5051 9.31495L14.6751 6.48495C14.4851 6.29495 14.2351 6.19495 13.9751 6.19495C13.7151 6.19495 13.4651 6.29495 13.2651 6.48495L11.0951 8.65495L12.5051 10.0649L13.9751 8.61495Z"
            fill="currentColor"
          />
          <path
            d="M1.19507 4.41495L8.26507 11.4849L2.09507 17.6549C1.70507 18.0449 1.70507 18.6749 2.09507 19.0649L4.92507 21.8949C5.12507 22.0949 5.37507 22.1949 5.63507 22.1949C5.89507 22.1949 6.14507 22.0949 6.34507 21.9049L12.5151 15.7349L19.5851 22.8049L20.9951 21.3949L2.61507 3.00495L1.19507 4.41495ZM11.0951 14.3149L5.63507 19.7749L4.22507 18.3649L9.68507 12.9049L11.0951 14.3149Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoGraph(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_graph">
        <path
          id="Vector"
          d="M14.06 10.69L12 9.75L14.06 8.81L15 6.75L15.94 8.81L18 9.75L15.94 10.69L15 12.75L14.06 10.69ZM4 14.75L4.94 12.69L7 11.75L4.94 10.81L4 8.75L3.06 10.81L1 11.75L3.06 12.69L4 14.75ZM8.5 9.75L9.59 7.34L12 6.25L9.59 5.16L8.5 2.75L7.41 5.16L5 6.25L7.41 7.34L8.5 9.75ZM4.5 21.25L10.5 15.24L14.5 19.24L23 9.68L21.59 8.27L14.5 16.24L10.5 12.24L3 19.75L4.5 21.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAutoMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_mode">
        <g id="Vector">
          <path
            d="M19.0549 3.53502C17.3849 2.14502 15.3149 1.23502 13.0249 1.02502V3.03502C14.7549 3.22502 16.3349 3.91502 17.6349 4.95502L19.0549 3.53502Z"
            fill="currentColor"
          />
          <path
            d="M11.0249 3.03502V1.02502C8.7349 1.22502 6.6649 2.14502 4.9949 3.53502L6.4149 4.95502C7.7149 3.91502 9.2949 3.22502 11.0249 3.03502Z"
            fill="currentColor"
          />
          <path
            d="M5.0049 6.36502L3.5849 4.94502C2.1949 6.61502 1.2849 8.68502 1.0749 10.975H3.0849C3.2749 9.24502 3.9649 7.66502 5.0049 6.36502Z"
            fill="currentColor"
          />
          <path
            d="M20.9649 10.975H22.9749C22.7649 8.68502 21.8549 6.61502 20.4649 4.94502L19.0449 6.36502C20.0849 7.66502 20.7749 9.24502 20.9649 10.975Z"
            fill="currentColor"
          />
          <path
            d="M7.0249 11.975L10.4649 13.535L12.0249 16.975L13.5849 13.535L17.0249 11.975L13.5849 10.415L12.0249 6.97502L10.4649 10.415L7.0249 11.975Z"
            fill="currentColor"
          />
          <path
            d="M12.0249 20.975C8.9149 20.975 6.1749 19.385 4.5649 16.975H7.0249V14.975H1.0249V20.975H3.0249V18.275C5.0149 21.115 8.2949 22.975 12.0249 22.975C16.8949 22.975 21.0249 19.805 22.4649 15.415L20.5049 14.965C19.2749 18.455 15.9449 20.975 12.0249 20.975Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAutoStories(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="auto_stories">
        <path
          id="Vector"
          d="M22.47 6.95C22 6.71 21.51 6.51 21 6.34V18.37C19.86 17.96 18.69 17.75 17.5 17.75C15.6 17.75 13.72 18.29 12 19.33V7.23C10.38 6.3 8.51 5.75 6.5 5.75C4.71 5.75 3.02 6.19 1.53 6.95C1.2 7.11 1 7.46 1 7.83V19.91C1 20.49 1.47 20.9 2 20.9C2.16 20.9 2.32 20.86 2.48 20.78C3.69 20.15 5.05 19.75 6.5 19.75C8.57 19.75 10.48 20.57 12 21.75C13.52 20.57 15.43 19.75 17.5 19.75C18.95 19.75 20.31 20.15 21.52 20.79C21.68 20.87 21.84 20.91 22 20.91C22.52 20.91 23 20.5 23 19.92V7.83C23 7.46 22.8 7.11 22.47 6.95ZM10 18.37C8.86 17.96 7.69 17.75 6.5 17.75C5.31 17.75 4.14 17.96 3 18.37V8.46C4.11 7.99 5.28 7.75 6.5 7.75C7.7 7.75 8.89 8 10 8.47V18.37ZM19 2.25L14 7.25V16.75L19 12.25V2.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAutofpsSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="autofps_select">
        <g id="Vector">
          <path d="M12.03 5.8H11.97L10.95 8.69H13.05L12.03 5.8Z" fill="currentColor" />
          <path d="M5 16.5H3V21.5H5V16.5Z" fill="currentColor" />
          <path
            d="M12 14.5C15.31 14.5 18 11.81 18 8.5C18 5.19 15.31 2.5 12 2.5C8.69 2.5 6 5.19 6 8.5C6 11.81 8.69 14.5 12 14.5ZM11.37 4.5H12.62L15.25 11.5H14.04L13.41 9.71H10.58L9.96 11.5H8.74L11.37 4.5Z"
            fill="currentColor"
          />
          <path d="M9 16.5H7V21.5H9V16.5Z" fill="currentColor" />
          <path d="M13 16.5H11V21.5H13V16.5Z" fill="currentColor" />
          <path d="M21 16.5H15V21.5H21V16.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconAutorenew(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="autorenew">
        <path
          id="Vector"
          d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAvTimer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="av_timer">
        <path
          id="Vector"
          d="M11 17C11 17.55 11.45 18 12 18C12.55 18 13 17.55 13 17C13 16.45 12.55 16 12 16C11.45 16 11 16.45 11 17ZM11 3V7H13V5.08C16.39 5.57 19 8.47 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 10.32 5.59 8.78 6.58 7.58L12 13L13.41 11.59L6.61 4.79V4.81C4.42 6.45 3 9.05 3 12C3 16.97 7.02 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3H11ZM18 12C18 11.45 17.55 11 17 11C16.45 11 16 11.45 16 12C16 12.55 16.45 13 17 13C17.55 13 18 12.55 18 12ZM6 12C6 12.55 6.45 13 7 13C7.55 13 8 12.55 8 12C8 11.45 7.55 11 7 11C6.45 11 6 11.45 6 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBabyChangingStation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="baby_changing_station">
        <path
          id="Vector"
          d="M14 8.5V10.5H11L8.31 9.32L7 13.25V22.5H3V12.5L4.58 7.87C4.96 6.75 6.22 6.19 7.3 6.68L11.45 8.51L14 8.5ZM8 1.5C6.9 1.5 6 2.4 6 3.5C6 4.6 6.9 5.5 8 5.5C9.1 5.5 10 4.6 10 3.5C10 2.4 9.1 1.5 8 1.5ZM9 19.5H21V17.5H9V19.5ZM19.5 16.5C20.33 16.5 21 15.83 21 15C21 14.17 20.33 13.5 19.5 13.5C18.67 13.5 18 14.17 18 15C18 15.83 18.67 16.5 19.5 16.5ZM13 12.5C13 11.95 12.55 11.5 12 11.5H9V13.5H11V14.5C11 15.6 11.9 16.5 13 16.5H15C16.1 16.5 17 15.6 17 14.5V11.5H15V13.5H13V12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBackHand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="back_hand">
        <path
          id="Vector"
          d="M21.248 7C21.248 5.62 20.128 4.5 18.748 4.5C18.578 4.5 18.408 4.52 18.248 4.55V4C18.248 2.62 17.128 1.5 15.748 1.5C15.518 1.5 15.288 1.53 15.078 1.59C14.708 0.66 13.808 0 12.748 0C11.518 0 10.498 0.89 10.288 2.06C10.118 2.02 9.93802 2 9.74802 2C8.36802 2 7.24802 3.12 7.24802 4.5V10.39C6.90802 10.08 6.48802 9.85 6.02802 9.73L5.25802 9.52C4.42802 9.29 3.55802 9.61 3.06802 10.35C2.68802 10.92 2.66802 11.66 2.91802 12.3L5.47802 18.73C6.73802 21.91 9.81802 24 13.248 24C17.668 24 21.248 20.42 21.248 16V7ZM19.248 16C19.248 19.31 16.558 22 13.248 22C10.638 22 8.29802 20.41 7.33802 17.99L4.73802 11.45L5.26802 11.59C5.72802 11.71 6.09802 12.05 6.26802 12.49L7.24802 15H9.24802V4.5C9.24802 4.22 9.46802 4 9.74802 4C10.028 4 10.248 4.22 10.248 4.5V12H12.248V2.5C12.248 2.22 12.468 2 12.748 2C13.028 2 13.248 2.22 13.248 2.5V12H15.248V4C15.248 3.72 15.468 3.5 15.748 3.5C16.028 3.5 16.248 3.72 16.248 4V12H18.248V7C18.248 6.72 18.468 6.5 18.748 6.5C19.028 6.5 19.248 6.72 19.248 7V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBackpack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="backpack">
        <path
          id="Vector"
          d="M17 4.14V2H14V4H10V2H7V4.14C5.28 4.59 4 6.14 4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8C20 6.14 18.72 4.59 17 4.14ZM18 20H6V8C6 6.9 6.9 6 8 6H16C17.1 6 18 6.9 18 8V20ZM16.5 12V16H14.5V14H7.5V12H16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBackspace(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="backspace">
        <path
          id="Vector"
          d="M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.31 21 7 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM22 19H7.07L2.4 12L7.06 5H22V19ZM10.41 17L14 13.41L17.59 17L19 15.59L15.41 12L19 8.41L17.59 7L14 10.59L10.41 7L9 8.41L12.59 12L9 15.59L10.41 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBackup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="backup">
        <path
          id="Vector"
          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18ZM8 13H10.55V16H13.45V13H16L12 9L8 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBackupTable(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="backup_table">
        <g id="Vector">
          <path d="M20 6V20H6V22H20C21.1 22 22 21.1 22 20V6H20Z" fill="currentColor" />
          <path
            d="M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM9 16H4V11H9V16ZM16 16H11V11H16V16ZM16 9H4V4H16V9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBadge(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="badge">
        <g id="Vector">
          <path d="M18 12H14V13.5H18V12Z" fill="currentColor" />
          <path d="M18 15H14V16.5H18V15Z" fill="currentColor" />
          <path
            d="M20 7H15V4C15 2.9 14.1 2 13 2H11C9.9 2 9 2.9 9 4V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM11 4H13V9H11V4ZM20 20H4V9H9C9 10.1 9.9 11 11 11H13C14.1 11 15 10.1 15 9H20V20Z"
            fill="currentColor"
          />
          <path
            d="M9 15C9.82843 15 10.5 14.3284 10.5 13.5C10.5 12.6716 9.82843 12 9 12C8.17157 12 7.5 12.6716 7.5 13.5C7.5 14.3284 8.17157 15 9 15Z"
            fill="currentColor"
          />
          <path
            d="M11.08 16.18C10.44 15.9 9.74 15.75 9 15.75C8.26 15.75 7.56 15.9 6.92 16.18C6.36 16.42 6 16.96 6 17.57V18H12V17.57C12 16.96 11.64 16.42 11.08 16.18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBakeryDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bakery_dining">
        <path
          id="Vector"
          d="M20.4951 10.94C20.6251 10.62 20.5951 10.71 20.6451 10.55C20.9451 9.34 20.3051 8.08 19.1451 7.62L17.1351 6.82C16.6751 6.64 16.1851 6.61 15.7251 6.7C15.6151 6.37 15.4351 6.07 15.2051 5.81C14.7251 5.29 14.0551 5 13.3551 5H10.6451C9.93512 5 9.26512 5.29 8.79512 5.81C8.55512 6.07 8.37512 6.37 8.26512 6.69C7.80512 6.6 7.31512 6.63 6.85512 6.81L4.84512 7.61C3.68512 8.07 3.04512 9.33 3.34512 10.54L3.49512 10.92C1.09512 15.55 0.995117 15.55 0.995117 16.38C0.995117 17.29 1.45512 18.12 2.23512 18.6C3.65512 19.48 4.72512 18.74 6.23512 17.99H17.7651C19.2851 18.75 19.6251 19 20.3951 19C21.3951 19 23.0051 18.23 23.0051 16.39C22.9951 15.54 22.8751 15.51 20.4951 10.94ZM20.1151 16.93L18.4351 16.09L19.5151 13.39L20.9251 16.1C21.2051 16.63 20.6351 17.19 20.1151 16.93ZM15.0851 15.99L15.7051 9.09C15.7351 8.76 16.0751 8.55 16.3851 8.67L18.3951 9.47C18.6151 9.56 18.7351 9.78 18.7051 10.01L16.3051 15.99H15.0851ZM7.67512 15.99L5.27512 10.01C5.24512 9.78 5.36512 9.56 5.58512 9.47L7.59512 8.67C7.90512 8.55 8.24512 8.75 8.27512 9.09L8.89512 15.99H7.67512ZM3.06512 16.1L4.47512 13.38L5.55512 16.09L3.87512 16.93C3.35512 17.19 2.78512 16.63 3.06512 16.1ZM10.1451 7.54C10.1151 7.23 10.3751 7 10.6451 7H13.3551C13.6251 7 13.8851 7.23 13.8551 7.54L13.0851 15.99H10.9151L10.1451 7.54Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBalance(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="balance">
        <path
          id="Vector"
          d="M13 8.33C13.85 8.03 14.53 7.35 14.83 6.5H18L15 13.5C15 15.16 16.57 16.5 18.5 16.5C20.43 16.5 22 15.16 22 13.5L19 6.5H21V4.5H14.83C14.42 3.33 13.31 2.5 12 2.5C10.69 2.5 9.58 3.33 9.17 4.5H3V6.5H5L2 13.5C2 15.16 3.57 16.5 5.5 16.5C7.43 16.5 9 15.16 9 13.5L6 6.5H9.17C9.47 7.35 10.15 8.03 11 8.33V19.5H2V21.5H22V19.5H13V8.33ZM20.37 13.5H16.63L18.5 9.14L20.37 13.5ZM7.37 13.5H3.63L5.5 9.14L7.37 13.5ZM12 6.5C11.45 6.5 11 6.05 11 5.5C11 4.95 11.45 4.5 12 4.5C12.55 4.5 13 4.95 13 5.5C13 6.05 12.55 6.5 12 6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBalcony(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="balcony">
        <path
          id="Vector"
          d="M10 10V12H8V10H10ZM16 12V10H14V12H16ZM21 14V22H3V14H4V10C4 5.58 7.58 2 12 2C16.42 2 20 5.58 20 10V14H21ZM7 16H5V20H7V16ZM11 16H9V20H11V16ZM11 4.08C8.16 4.56 6 7.03 6 10V14H11V4.08ZM13 14H18V10C18 7.03 15.84 4.56 13 4.08V14ZM15 16H13V20H15V16ZM19 16H17V20H19V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBallot(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ballot">
        <path
          id="Vector"
          d="M13 7.5H18V9.5H13V7.5ZM13 14.5H18V16.5H13V14.5ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM11 6H6V11H11V6ZM10 10H7V7H10V10ZM11 13H6V18H11V13ZM10 17H7V14H10V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBarChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bar_chart">
        <g id="Vector">
          <path d="M8 9H4V20H8V9Z" fill="currentColor" />
          <path d="M20 13H16V20H20V13Z" fill="currentColor" />
          <path d="M14 4H10V20H14V4Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconBatchPrediction(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="batch_prediction">
        <path
          id="Vector"
          d="M17 8H7C5.9 8 5 8.9 5 10V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V10C19 8.9 18.1 8 17 8ZM13 20.5H11V19H13V20.5ZM13 18H11C11 16.5 8.5 15 8.5 13C8.5 11.07 10.07 9.5 12 9.5C13.93 9.5 15.5 11.07 15.5 13C15.5 15 13 16.5 13 18ZM18 6.5H6C6 5.67 6.67 5 7.5 5H16.5C17.33 5 18 5.67 18 6.5ZM17 3.5H7C7 2.67 7.67 2 8.5 2H15.5C16.33 2 17 2.67 17 3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBathroom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bathroom">
        <path
          id="Vector"
          d="M8 14C8 13.45 8.45 13 9 13C9.55 13 10 13.45 10 14C10 14.55 9.55 15 9 15C8.45 15 8 14.55 8 14ZM12 15C12.55 15 13 14.55 13 14C13 13.45 12.55 13 12 13C11.45 13 11 13.45 11 14C11 14.55 11.45 15 12 15ZM15 15C15.55 15 16 14.55 16 14C16 13.45 15.55 13 15 13C14.45 13 14 13.45 14 14C14 14.55 14.45 15 15 15ZM12 7.5C10.24 7.5 8.78 8.81 8.54 10.5H15.47C15.22 8.81 13.76 7.5 12 7.5ZM12 6C14.76 6 17 8.24 17 11V12H7V11C7 8.24 9.24 6 12 6ZM9 18C9.55 18 10 17.55 10 17C10 16.45 9.55 16 9 16C8.45 16 8 16.45 8 17C8 17.55 8.45 18 9 18ZM12 18C12.55 18 13 17.55 13 17C13 16.45 12.55 16 12 16C11.45 16 11 16.45 11 17C11 17.55 11.45 18 12 18ZM15 18C15.55 18 16 17.55 16 17C16 16.45 15.55 16 15 16C14.45 16 14 16.45 14 17C14 17.55 14.45 18 15 18ZM20 4H4V20H20V4ZM20 2C21.1 2 22 2.9 22 4V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBathtub(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bathtub">
        <g id="Vector">
          <path
            d="M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"
            fill="currentColor"
          />
          <path
            d="M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13.01 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.49L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.52 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10.01 5 11.01 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20ZM20 19H4V15H20V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBattery0Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_0_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V20H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBattery1Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_1_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V18H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBattery2Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_2_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V16H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBattery3Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_3_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V14H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBattery4Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_4_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V12H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBattery5Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_5_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V10H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBattery6Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_6_bar">
        <path
          id="Vector"
          d="M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V8H15V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBatteryAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_alert">
        <path
          id="Vector"
          d="M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM13 18H11V16H13V18ZM13 14H11V9H13V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBatteryChargingFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_charging_full">
        <path
          id="Vector"
          d="M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM11 20V14.5H9L13 7V12.5H15L11 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBatteryFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_full">
        <path
          id="Vector"
          d="M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBatterySaver(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_saver">
        <path
          id="Vector"
          d="M16 4H14V2H10V4H8C7.45 4 7 4.45 7 5V21C7 21.55 7.45 22 8 22H16C16.55 22 17 21.55 17 21V5C17 4.45 16.55 4 16 4ZM15 14H13V16H11V14H9V12H11V10H13V12H15V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBatteryUnknown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="battery_unknown">
        <path
          id="Vector"
          d="M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM13 18H11V16H13V18ZM14.3 12.69C14.3 12.69 13.92 13.11 13.63 13.4C13.15 13.88 12.8 14.55 12.8 15H11.2C11.2 14.17 11.66 13.48 12.13 13L13.06 12.06C13.33 11.79 13.5 11.41 13.5 11C13.5 10.17 12.83 9.5 12 9.5C11.17 9.5 10.5 10.17 10.5 11H9C9 9.34 10.34 8 12 8C13.66 8 15 9.34 15 11C15 11.66 14.73 12.26 14.3 12.69Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBeachAccess(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="beach_access">
        <path
          id="Vector"
          d="M20.9964 19.571L19.5694 20.999L13.1274 14.557L14.5574 13.129L20.9964 19.571ZM13.1164 3.00101C10.5364 3.00101 7.95641 3.98101 5.97641 5.95101L5.96641 5.96101C2.01641 9.91101 2.01641 16.321 5.96641 20.271L20.2664 5.96101C18.2964 3.99101 15.7064 3.00101 13.1164 3.00101ZM6.13641 17.271C5.39641 16.031 4.99641 14.611 4.99641 13.121C4.99641 12.191 5.15641 11.301 5.45641 10.451C5.64641 12.361 6.34641 14.241 7.52641 15.891L6.13641 17.271ZM8.97641 14.431C7.62641 12.381 7.11641 9.93101 7.59641 7.60101C8.17641 7.48101 8.75641 7.42101 9.34641 7.42101C11.1464 7.42101 12.8964 7.97101 14.4264 8.98101L8.97641 14.431ZM10.4464 5.46101C11.2964 5.16101 12.1864 5.00101 13.1164 5.00101C14.6064 5.00101 16.0264 5.40101 17.2664 6.14101L15.8764 7.53101C14.2264 6.35101 12.3564 5.65101 10.4464 5.46101Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bed">
        <path
          id="Vector"
          d="M21 10.78V8C21 6.35 19.65 5 18 5H14C13.23 5 12.53 5.3 12 5.78C11.47 5.3 10.77 5 10 5H6C4.35 5 3 6.35 3 8V10.78C2.39 11.33 2 12.12 2 13V19H4V17H20V19H22V13C22 12.12 21.61 11.33 21 10.78ZM14 7H18C18.55 7 19 7.45 19 8V10H13V8C13 7.45 13.45 7 14 7ZM5 8C5 7.45 5.45 7 6 7H10C10.55 7 11 7.45 11 8V10H5V8ZM4 15V13C4 12.45 4.45 12 5 12H19C19.55 12 20 12.45 20 13V15H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBedroomBaby(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bedroom_baby">
        <path
          id="Vector"
          d="M17.94 14.04C17.6 14.38 17.23 14.68 16.84 14.96L16 13.5V11H17V10H11.38L9.65 7H6L7 7.76L5.5 9.5L6.45 10.5L8 9.51V13.5L7.16 14.96C6.77 14.69 6.4 14.38 6.06 14.04L5 15.1C6.87 16.97 9.36 18 12 18C14.64 18 17.13 16.97 19 15.1L17.94 14.04ZM8.45 15.71L8.48 15.65L9.29 14.24C11.03 14.89 12.95 14.89 14.69 14.24L15.5 15.65L15.53 15.71C14.43 16.22 13.23 16.5 11.98 16.5C10.73 16.5 9.55 16.23 8.45 15.71ZM20 4V20H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBedroomChild(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bedroom_child">
        <path
          id="Vector"
          d="M20 4V20H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM16.5 10.67V9C16.5 7.9 15.6 7 14.5 7H9.5C8.4 7 7.5 7.9 7.5 9V10.67C6.62 11.02 6 11.87 6 12.87V17H7.5V15.5H16.5V17H18V12.87C18 11.87 17.38 11.02 16.5 10.67ZM15 8.5V10.5H9V8.5H15ZM7.5 12.87C7.5 12.39 7.89 12 8.37 12H15.64C16.12 12 16.51 12.39 16.51 12.87V14H7.51V12.87H7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBedroomParent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bedroom_parent">
        <path
          id="Vector"
          d="M18.35 11.45V9C18.35 7.9 17.45 7 16.35 7H13C12.63 7 12.28 7.12 12 7.32C11.72 7.12 11.37 7 11 7H7.65C6.55 7 5.65 7.9 5.65 9V11.45C5.25 11.91 5 12.51 5 13.17V17H6.5V15.5H17.5V17H19V13.17C19 12.51 18.75 11.91 18.35 11.45ZM16.75 10.5H12.75V8.5H16.75V10.5ZM7.25 8.5H11.25V10.5H7.25V8.5ZM17.5 14H6.5V13C6.5 12.45 6.95 12 7.5 12H16.5C17.05 12 17.5 12.45 17.5 13V14ZM20 4V20H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBedtime(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bedtime">
        <path
          id="Vector"
          d="M9.93992 4.485C8.30992 12.025 13.6899 16.895 17.5999 18.285C16.2099 19.375 14.4799 19.995 12.6699 19.995C8.25992 19.995 4.66992 16.405 4.66992 11.995C4.66992 8.545 6.86992 5.595 9.93992 4.485ZM12.6599 2.005C7.06992 2.005 2.66992 6.535 2.66992 11.995C2.66992 17.515 7.14992 21.995 12.6699 21.995C16.3799 21.995 19.5999 19.975 21.3299 16.975C13.8199 16.725 9.23992 8.545 13.0099 2.005H12.6599Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBedtimeOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bedtime_off">
        <path
          id="Vector"
          d="M9.9801 4.17995C9.8501 4.76995 9.7801 5.32995 9.7401 5.88995L11.7901 7.93995C11.5201 5.88995 11.8901 3.71995 13.0501 1.70995C12.9301 1.70995 12.8201 1.69995 12.7001 1.69995C10.6501 1.69995 8.7701 2.30995 7.2001 3.34995L8.6601 4.80995C9.0801 4.56995 9.5201 4.34995 9.9801 4.17995ZM2.1001 3.90995L4.3701 6.17995C3.3201 7.75995 2.7101 9.65995 2.7101 11.69C2.7101 17.21 7.1901 21.69 12.7101 21.69C14.7501 21.69 16.6301 21.06 18.2101 20.02L20.4901 22.3L21.9001 20.89L3.5201 2.49995L2.1001 3.90995ZM5.8401 7.64995L16.7601 18.57C15.5501 19.2899 14.1601 19.69 12.7101 19.69C8.3001 19.69 4.7101 16.1 4.7101 11.69C4.7101 10.21 5.1301 8.83995 5.8401 7.64995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBeenhere(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="beenhere">
        <path
          id="Vector"
          d="M19 1H5C3.9 1 3.01 1.9 3.01 3L3 15.93C3 16.62 3.35 17.23 3.88 17.59L12 23L20.11 17.59C20.64 17.23 20.99 16.62 20.99 15.93L21 3C21 1.9 20.1 1 19 1ZM12 20.6L5 15.94V3H19V15.93L12 20.6ZM9.99 13.18L7.41 10.59L6 12L10 16L18 8L16.58 6.58L9.99 13.18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBento(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bento">
        <path
          id="Vector"
          d="M20 5H4C2.9 5 2 5.9 2 7V17C2 18.1 2.9 19 4 19H20C21.1 19 22 18.1 22 17V7C22 5.9 21.1 5 20 5ZM20 11H14V7H20V11ZM4 7H12V17H4V7ZM14 17V13H20V17H14ZM9.5 12C9.5 12.83 8.83 13.5 8 13.5C7.17 13.5 6.5 12.83 6.5 12C6.5 11.17 7.17 10.5 8 10.5C8.83 10.5 9.5 11.17 9.5 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBikeScooter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bike_scooter">
        <g id="Vector">
          <path
            d="M10 14H10.74L8.82 5.56C8.61 4.65 7.8 4 6.87 4H3V6H6.87L8.29 12.25H8.28C6.12 12.9 4.47 14.73 4.09 17H0V19H6V18C6 15.79 7.79 14 10 14Z"
            fill="currentColor"
          />
          <path
            d="M19 8H18.18L16.83 4.31C16.55 3.52 15.8 3 14.96 3H11V5H14.96L16.06 8H10.4L10.86 10H15C14.57 10.58 14.25 11.25 14.1 12H11.31L11.77 14H14.1C14.54 16.23 16.41 17.88 18.75 17.99C21.55 18.12 24 15.8 24 12.99C24 10.2 21.8 8 19 8ZM19 16C17.32 16 16 14.68 16 13C16 12.07 16.41 11.27 17.05 10.72L18.01 13.36L19.89 12.68L18.92 10.01C18.95 10.01 18.98 10 19.01 10C20.69 10 22.01 11.32 22.01 13C22.01 14.68 20.68 16 19 16Z"
            fill="currentColor"
          />
          <path
            d="M10 15C8.34 15 7 16.34 7 18C7 19.66 8.34 21 10 21C11.66 21 13 19.66 13 18C13 16.34 11.66 15 10 15ZM10 19C9.45 19 9 18.55 9 18C9 17.45 9.45 17 10 17C10.55 17 11 17.45 11 18C11 18.55 10.55 19 10 19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBiotech(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="biotech">
        <path
          id="Vector"
          d="M7 19.5C5.9 19.5 5 20.4 5 21.5H19C19 20.4 18.1 19.5 17 19.5H13V17.5H16C17.1 17.5 18 16.6 18 15.5H10C8.34 15.5 7 14.16 7 12.5C7 11.41 7.59 10.46 8.47 9.93C8.88 10.52 9.53 10.93 10.3 10.99C11 11.05 11.66 10.8 12.15 10.37L12.74 11.98L13.68 11.64L14.02 12.58L15.9 11.9L15.56 10.96L16.5 10.62L13.76 3.1L12.82 3.44L12.48 2.5L10.6 3.18L10.94 4.12L10 4.47L10.56 6.02C9.39 5.98 8.37 6.77 8.08 7.88C6.27 8.64 5 10.42 5 12.5C5 15.26 7.24 17.5 10 17.5V19.5H7ZM12.86 5.02L14.57 9.72L13.63 10.06L11.92 5.36L12.86 5.02ZM10.5 7.5C11.05 7.5 11.5 7.95 11.5 8.5C11.5 9.05 11.05 9.5 10.5 9.5C9.95 9.5 9.5 9.05 9.5 8.5C9.5 7.95 9.95 7.5 10.5 7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBlender(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blender">
        <g id="Vector">
          <path
            d="M17.63 15.13L19.5 3H15.5V2H11.5V3H6.5C5.4 3 4.5 3.9 4.5 5V9C4.5 10.1 5.4 11 6.5 11H8.73L9.37 15.13C8.24 16.05 7.5 17.43 7.5 19V20C7.5 21.1 8.4 22 9.5 22H17.5C18.6 22 19.5 21.1 19.5 20V19C19.5 17.43 18.76 16.05 17.63 15.13ZM6.5 9V5H7.81L8.43 9H6.5ZM17.17 5L15.79 14H11.22L9.83 5H17.17ZM17.5 20H9.5V19C9.5 17.35 10.85 16 12.5 16H14.5C16.15 16 17.5 17.35 17.5 19V20Z"
            fill="currentColor"
          />
          <path
            d="M13.5 19C14.0523 19 14.5 18.5523 14.5 18C14.5 17.4477 14.0523 17 13.5 17C12.9477 17 12.5 17.4477 12.5 18C12.5 18.5523 12.9477 19 13.5 19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBlind(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blind">
        <g id="Vector">
          <path
            d="M10.75 5.25C11.8546 5.25 12.75 4.35457 12.75 3.25C12.75 2.14543 11.8546 1.25 10.75 1.25C9.64543 1.25 8.75 2.14543 8.75 3.25C8.75 4.35457 9.64543 5.25 10.75 5.25Z"
            fill="currentColor"
          />
          <path
            d="M11.38 6.87C11.21 6.52 10.94 6.22 10.58 6.02C9.97 5.66 9.24 5.68 8.65 5.99V5.98L3.25 9.05V13.75H5.25V10.21L6.75 9.36C6.43 10.46 6.25 11.6 6.25 12.75V18.08L3.65 21.55L5.25 22.75L8.25 18.75L8.47 15.21L10.25 17.75V22.75H12.25V16.25L10.28 13.44C10.24 12.92 10.14 11.68 10.73 10.04C11.48 11.18 12.61 12.02 13.93 12.45L19.88 22.75L20.75 22.25L15.27 12.75H16.25V10.75C15.76 10.75 13.37 10.92 12.17 8.54"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBlinds(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blinds">
        <path
          id="Vector"
          d="M20 19V3H4V19H2V21H22V19H20ZM16 9H18V11H16V9ZM14 11H6V9H14V11ZM18 7H16V5H18V7ZM14 5V7H6V5H14ZM6 19V13H14V14.82C13.55 15.14 13.25 15.66 13.25 16.25C13.25 17.22 14.03 18 15 18C15.97 18 16.75 17.22 16.75 16.25C16.75 15.66 16.45 15.13 16 14.82V13H18V19H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBlindsClosed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blinds_closed">
        <path
          id="Vector"
          d="M20 18.125V2.125H4V18.125H2V20.125H13.25C13.25 21.095 14.03 21.875 15 21.875C15.97 21.875 16.75 21.095 16.75 20.125H22V18.125H20ZM18 10.125H16V8.125H18V10.125ZM14 10.125H6V8.125H14V10.125ZM14 12.125V14.125H6V12.125H14ZM16 12.125H18V14.125H16V12.125ZM18 6.125H16V4.125H18V6.125ZM14 4.125V6.125H6V4.125H14ZM6 18.125V16.125H14V18.125H6ZM16 18.125V16.125H18V18.125H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBlock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="block">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.63 15.55 4 13.85 4 12ZM12 20C10.15 20 8.45 19.37 7.1 18.31L18.31 7.1C19.37 8.45 20 10.15 20 12C20 16.42 16.42 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBloodtype(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bloodtype">
        <g id="Vector">
          <path d="M15 16H9V18H15V16Z" fill="currentColor" />
          <path d="M13 9H11V11H9V13H11V15H13V13H15V11H13V9Z" fill="currentColor" />
          <path
            d="M12 2C6.67 6.55 4 10.48 4 13.8C4 18.78 7.8 22 12 22C16.2 22 20 18.78 20 13.8C20 10.48 17.33 6.55 12 2ZM12 20C8.65 20 6 17.43 6 13.8C6 11.46 7.95 8.36 12 4.66C16.05 8.36 18 11.45 18 13.8C18 17.43 15.35 20 12 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBluetooth(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bluetooth">
        <path
          id="Vector"
          d="M18.355 7.71L12.645 2H11.645V9.59L7.05502 5L5.64502 6.41L11.235 12L5.64502 17.59L7.05502 19L11.645 14.41V22H12.645L18.355 16.29L14.055 12L18.355 7.71ZM13.645 5.83L15.525 7.71L13.645 9.59V5.83ZM15.525 16.29L13.645 18.17V14.41L15.525 16.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBluetoothAudio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bluetooth_audio">
        <path
          id="Vector"
          d="M14.2351 12.01L16.5551 14.33C16.8351 13.61 16.9951 12.82 16.9951 12C16.9951 11.18 16.8351 10.41 16.5651 9.69L14.2351 12.01ZM19.5251 6.71L18.2651 7.97C18.8951 9.18 19.2451 10.54 19.2451 11.99C19.2451 13.44 18.8851 14.81 18.2651 16.01L19.4651 17.21C20.4351 15.67 21.0051 13.85 21.0051 11.9C20.9951 10.01 20.4551 8.23 19.5251 6.71ZM15.7051 7.71L9.99512 2H8.99512V9.59L4.40512 5L2.99512 6.41L8.58512 12L2.99512 17.59L4.40512 19L8.99512 14.41V22H9.99512L15.7051 16.29L11.4051 12L15.7051 7.71ZM10.9951 5.83L12.8751 7.71L10.9951 9.59V5.83ZM12.8751 16.29L10.9951 18.17V14.41L12.8751 16.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBluetoothConnected(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bluetooth_connected">
        <path
          id="Vector"
          d="M7 12L5 10L3 12L5 14L7 12ZM17.71 7.71L12 2H11V9.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L17.71 16.29L13.41 12L17.71 7.71ZM13 5.83L14.88 7.71L13 9.59V5.83ZM14.88 16.29L13 18.17V14.41L14.88 16.29ZM19 10L17 12L19 14L21 12L19 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBluetoothDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bluetooth_disabled">
        <path
          id="Vector"
          d="M13 5.83L14.88 7.71L13.28 9.31L14.69 10.72L17.71 7.7L12 2H11V7.03L13 9.03V5.83ZM5.41 4L4 5.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L16.29 17.71L18.59 20L20 18.59L5.41 4ZM13 18.17V14.41L14.88 16.29L13 18.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBluetoothDrive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bluetooth_drive">
        <g id="Vector">
          <path
            d="M6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17Z"
            fill="currentColor"
          />
          <path
            d="M15.5 17C16.3284 17 17 16.3284 17 15.5C17 14.6716 16.3284 14 15.5 14C14.6716 14 14 14.6716 14 15.5C14 16.3284 14.6716 17 15.5 17Z"
            fill="currentColor"
          />
          <path
            d="M18 18H4V13H15V11H4.81L5.85 8H15V6H5.5C4.84 6 4.29 6.42 4.08 7.01L2 13V21C2 21.55 2.45 22 3 22H4C4.55 22 5 21.55 5 21V20H17V21C17 21.55 17.45 22 18 22H19C19.55 22 20 21.55 20 21V13H18V18Z"
            fill="currentColor"
          />
          <path
            d="M22 4.85L19.15 2H18.65V5.79L16.35 3.5L15.65 4.2L18.44 7L15.65 9.79L16.35 10.5L18.65 8.2V12H19.15L22 9.14L19.85 7L22 4.85ZM19.65 3.91L20.59 4.85L19.65 5.79V3.91ZM20.59 9.14L19.65 10.08V8.2L20.59 9.14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBluetoothSearching(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bluetooth_searching">
        <path
          id="Vector"
          d="M14.2351 12.01L16.5551 14.33C16.8351 13.61 16.9951 12.82 16.9951 12C16.9951 11.18 16.8351 10.41 16.5651 9.69L14.2351 12.01ZM19.5251 6.71L18.2651 7.97C18.8951 9.18 19.2451 10.54 19.2451 11.99C19.2451 13.44 18.8851 14.81 18.2651 16.01L19.4651 17.21C20.4351 15.67 21.0051 13.85 21.0051 11.9C20.9951 10.01 20.4551 8.23 19.5251 6.71ZM15.7051 7.71L9.99512 2H8.99512V9.59L4.40512 5L2.99512 6.41L8.58512 12L2.99512 17.59L4.40512 19L8.99512 14.41V22H9.99512L15.7051 16.29L11.4051 12L15.7051 7.71ZM10.9951 5.83L12.8751 7.71L10.9951 9.59V5.83ZM12.8751 16.29L10.9951 18.17V14.41L12.8751 16.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBlurCircular(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blur_circular">
        <path
          id="Vector"
          d="M10 9C9.45 9 9 9.45 9 10C9 10.55 9.45 11 10 11C10.55 11 11 10.55 11 10C11 9.45 10.55 9 10 9ZM10 13C9.45 13 9 13.45 9 14C9 14.55 9.45 15 10 15C10.55 15 11 14.55 11 14C11 13.45 10.55 13 10 13ZM7 9.5C6.72 9.5 6.5 9.72 6.5 10C6.5 10.28 6.72 10.5 7 10.5C7.28 10.5 7.5 10.28 7.5 10C7.5 9.72 7.28 9.5 7 9.5ZM10 16.5C9.72 16.5 9.5 16.72 9.5 17C9.5 17.28 9.72 17.5 10 17.5C10.28 17.5 10.5 17.28 10.5 17C10.5 16.72 10.28 16.5 10 16.5ZM7 13.5C6.72 13.5 6.5 13.72 6.5 14C6.5 14.28 6.72 14.5 7 14.5C7.28 14.5 7.5 14.28 7.5 14C7.5 13.72 7.28 13.5 7 13.5ZM10 7.5C10.28 7.5 10.5 7.28 10.5 7C10.5 6.72 10.28 6.5 10 6.5C9.72 6.5 9.5 6.72 9.5 7C9.5 7.28 9.72 7.5 10 7.5ZM14 9C13.45 9 13 9.45 13 10C13 10.55 13.45 11 14 11C14.55 11 15 10.55 15 10C15 9.45 14.55 9 14 9ZM14 7.5C14.28 7.5 14.5 7.28 14.5 7C14.5 6.72 14.28 6.5 14 6.5C13.72 6.5 13.5 6.72 13.5 7C13.5 7.28 13.72 7.5 14 7.5ZM17 13.5C16.72 13.5 16.5 13.72 16.5 14C16.5 14.28 16.72 14.5 17 14.5C17.28 14.5 17.5 14.28 17.5 14C17.5 13.72 17.28 13.5 17 13.5ZM17 9.5C16.72 9.5 16.5 9.72 16.5 10C16.5 10.28 16.72 10.5 17 10.5C17.28 10.5 17.5 10.28 17.5 10C17.5 9.72 17.28 9.5 17 9.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM14 16.5C13.72 16.5 13.5 16.72 13.5 17C13.5 17.28 13.72 17.5 14 17.5C14.28 17.5 14.5 17.28 14.5 17C14.5 16.72 14.28 16.5 14 16.5ZM14 13C13.45 13 13 13.45 13 14C13 14.55 13.45 15 14 15C14.55 15 15 14.55 15 14C15 13.45 14.55 13 14 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBlurLinear(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blur_linear">
        <path
          id="Vector"
          d="M5 17.5C5.83 17.5 6.5 16.83 6.5 16C6.5 15.17 5.83 14.5 5 14.5C4.17 14.5 3.5 15.17 3.5 16C3.5 16.83 4.17 17.5 5 17.5ZM9 13C9.55 13 10 12.55 10 12C10 11.45 9.55 11 9 11C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13ZM9 9C9.55 9 10 8.55 10 8C10 7.45 9.55 7 9 7C8.45 7 8 7.45 8 8C8 8.55 8.45 9 9 9ZM3 21H21V19H3V21ZM5 9.5C5.83 9.5 6.5 8.83 6.5 8C6.5 7.17 5.83 6.5 5 6.5C4.17 6.5 3.5 7.17 3.5 8C3.5 8.83 4.17 9.5 5 9.5ZM5 13.5C5.83 13.5 6.5 12.83 6.5 12C6.5 11.17 5.83 10.5 5 10.5C4.17 10.5 3.5 11.17 3.5 12C3.5 12.83 4.17 13.5 5 13.5ZM9 17C9.55 17 10 16.55 10 16C10 15.45 9.55 15 9 15C8.45 15 8 15.45 8 16C8 16.55 8.45 17 9 17ZM17 16.5C17.28 16.5 17.5 16.28 17.5 16C17.5 15.72 17.28 15.5 17 15.5C16.72 15.5 16.5 15.72 16.5 16C16.5 16.28 16.72 16.5 17 16.5ZM3 3V5H21V3H3ZM17 8.5C17.28 8.5 17.5 8.28 17.5 8C17.5 7.72 17.28 7.5 17 7.5C16.72 7.5 16.5 7.72 16.5 8C16.5 8.28 16.72 8.5 17 8.5ZM17 12.5C17.28 12.5 17.5 12.28 17.5 12C17.5 11.72 17.28 11.5 17 11.5C16.72 11.5 16.5 11.72 16.5 12C16.5 12.28 16.72 12.5 17 12.5ZM13 9C13.55 9 14 8.55 14 8C14 7.45 13.55 7 13 7C12.45 7 12 7.45 12 8C12 8.55 12.45 9 13 9ZM13 13C13.55 13 14 12.55 14 12C14 11.45 13.55 11 13 11C12.45 11 12 11.45 12 12C12 12.55 12.45 13 13 13ZM13 17C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15C12.45 15 12 15.45 12 16C12 16.55 12.45 17 13 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBlurOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blur_off">
        <g id="Vector">
          <path
            d="M14 7C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7Z"
            fill="currentColor"
          />
          <path
            d="M13.8 11.48L14 11.5C14.83 11.5 15.5 10.83 15.5 10C15.5 9.17 14.83 8.5 14 8.5C13.17 8.5 12.5 9.17 12.5 10L12.52 10.2C12.61 10.87 13.13 11.39 13.8 11.48ZM14 3.5C14.28 3.5 14.5 3.28 14.5 3C14.5 2.72 14.28 2.5 14 2.5C13.72 2.5 13.5 2.72 13.5 3C13.5 3.28 13.72 3.5 14 3.5ZM10 3.5C10.28 3.5 10.5 3.28 10.5 3C10.5 2.72 10.28 2.5 10 2.5C9.72 2.5 9.5 2.72 9.5 3C9.5 3.28 9.72 3.5 10 3.5Z"
            fill="currentColor"
          />
          <path
            d="M18 11C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9C17.4477 9 17 9.44772 17 10C17 10.5523 17.4477 11 18 11Z"
            fill="currentColor"
          />
          <path
            d="M18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7Z"
            fill="currentColor"
          />
          <path
            d="M21 10.5C21.28 10.5 21.5 10.28 21.5 10C21.5 9.72 21.28 9.5 21 9.5C20.72 9.5 20.5 9.72 20.5 10C20.5 10.28 20.72 10.5 21 10.5Z"
            fill="currentColor"
          />
          <path
            d="M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z"
            fill="currentColor"
          />
          <path
            d="M18 15C18.5523 15 19 14.5523 19 14C19 13.4477 18.5523 13 18 13C17.4477 13 17 13.4477 17 14C17 14.5523 17.4477 15 18 15Z"
            fill="currentColor"
          />
          <path
            d="M6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z"
            fill="currentColor"
          />
          <path
            d="M14 20.5C13.72 20.5 13.5 20.72 13.5 21C13.5 21.28 13.72 21.5 14 21.5C14.28 21.5 14.5 21.28 14.5 21C14.5 20.72 14.28 20.5 14 20.5ZM21 13.5C20.72 13.5 20.5 13.72 20.5 14C20.5 14.28 20.72 14.5 21 14.5C21.28 14.5 21.5 14.28 21.5 14C21.5 13.72 21.28 13.5 21 13.5ZM3 13.5C2.72 13.5 2.5 13.72 2.5 14C2.5 14.28 2.72 14.5 3 14.5C3.28 14.5 3.5 14.28 3.5 14C3.5 13.72 3.28 13.5 3 13.5Z"
            fill="currentColor"
          />
          <path
            d="M10 19C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17C9.44772 17 9 17.4477 9 18C9 18.5523 9.44772 19 10 19Z"
            fill="currentColor"
          />
          <path
            d="M3 9.5C2.72 9.5 2.5 9.72 2.5 10C2.5 10.28 2.72 10.5 3 10.5C3.28 10.5 3.5 10.28 3.5 10C3.5 9.72 3.28 9.5 3 9.5ZM10 20.5C9.72 20.5 9.5 20.72 9.5 21C9.5 21.28 9.72 21.5 10 21.5C10.28 21.5 10.5 21.28 10.5 21C10.5 20.72 10.28 20.5 10 20.5Z"
            fill="currentColor"
          />
          <path
            d="M6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z"
            fill="currentColor"
          />
          <path
            d="M2.5 5.27L6.28 9.05L6 9C5.45 9 5 9.45 5 10C5 10.55 5.45 11 6 11C6.55 11 7 10.55 7 10C7 9.9 6.97 9.81 6.94 9.72L9.75 12.53C9.04 12.64 8.5 13.26 8.5 14C8.5 14.83 9.17 15.5 10 15.5C10.74 15.5 11.36 14.96 11.47 14.25L14.28 17.06C14.19 17.03 14.1 17 14 17C13.45 17 13 17.45 13 18C13 18.55 13.45 19 14 19C14.55 19 15 18.55 15 18C15 17.9 14.97 17.81 14.94 17.72L18.72 21.5H18.73L20.14 20.09L3.91 3.86L2.5 5.27Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBlurOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="blur_on">
        <path
          id="Vector"
          d="M6 13C5.45 13 5 13.45 5 14C5 14.55 5.45 15 6 15C6.55 15 7 14.55 7 14C7 13.45 6.55 13 6 13ZM6 17C5.45 17 5 17.45 5 18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18C7 17.45 6.55 17 6 17ZM6 9C5.45 9 5 9.45 5 10C5 10.55 5.45 11 6 11C6.55 11 7 10.55 7 10C7 9.45 6.55 9 6 9ZM3 9.5C2.72 9.5 2.5 9.72 2.5 10C2.5 10.28 2.72 10.5 3 10.5C3.28 10.5 3.5 10.28 3.5 10C3.5 9.72 3.28 9.5 3 9.5ZM6 5C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5ZM21 10.5C21.28 10.5 21.5 10.28 21.5 10C21.5 9.72 21.28 9.5 21 9.5C20.72 9.5 20.5 9.72 20.5 10C20.5 10.28 20.72 10.5 21 10.5ZM14 7C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5C13.45 5 13 5.45 13 6C13 6.55 13.45 7 14 7ZM14 3.5C14.28 3.5 14.5 3.28 14.5 3C14.5 2.72 14.28 2.5 14 2.5C13.72 2.5 13.5 2.72 13.5 3C13.5 3.28 13.72 3.5 14 3.5ZM3 13.5C2.72 13.5 2.5 13.72 2.5 14C2.5 14.28 2.72 14.5 3 14.5C3.28 14.5 3.5 14.28 3.5 14C3.5 13.72 3.28 13.5 3 13.5ZM10 20.5C9.72 20.5 9.5 20.72 9.5 21C9.5 21.28 9.72 21.5 10 21.5C10.28 21.5 10.5 21.28 10.5 21C10.5 20.72 10.28 20.5 10 20.5ZM10 3.5C10.28 3.5 10.5 3.28 10.5 3C10.5 2.72 10.28 2.5 10 2.5C9.72 2.5 9.5 2.72 9.5 3C9.5 3.28 9.72 3.5 10 3.5ZM10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6C9 6.55 9.45 7 10 7ZM10 12.5C9.17 12.5 8.5 13.17 8.5 14C8.5 14.83 9.17 15.5 10 15.5C10.83 15.5 11.5 14.83 11.5 14C11.5 13.17 10.83 12.5 10 12.5ZM18 13C17.45 13 17 13.45 17 14C17 14.55 17.45 15 18 15C18.55 15 19 14.55 19 14C19 13.45 18.55 13 18 13ZM18 17C17.45 17 17 17.45 17 18C17 18.55 17.45 19 18 19C18.55 19 19 18.55 19 18C19 17.45 18.55 17 18 17ZM18 9C17.45 9 17 9.45 17 10C17 10.55 17.45 11 18 11C18.55 11 19 10.55 19 10C19 9.45 18.55 9 18 9ZM18 5C17.45 5 17 5.45 17 6C17 6.55 17.45 7 18 7C18.55 7 19 6.55 19 6C19 5.45 18.55 5 18 5ZM21 13.5C20.72 13.5 20.5 13.72 20.5 14C20.5 14.28 20.72 14.5 21 14.5C21.28 14.5 21.5 14.28 21.5 14C21.5 13.72 21.28 13.5 21 13.5ZM14 17C13.45 17 13 17.45 13 18C13 18.55 13.45 19 14 19C14.55 19 15 18.55 15 18C15 17.45 14.55 17 14 17ZM14 20.5C13.72 20.5 13.5 20.72 13.5 21C13.5 21.28 13.72 21.5 14 21.5C14.28 21.5 14.5 21.28 14.5 21C14.5 20.72 14.28 20.5 14 20.5ZM10 8.5C9.17 8.5 8.5 9.17 8.5 10C8.5 10.83 9.17 11.5 10 11.5C10.83 11.5 11.5 10.83 11.5 10C11.5 9.17 10.83 8.5 10 8.5ZM10 17C9.45 17 9 17.45 9 18C9 18.55 9.45 19 10 19C10.55 19 11 18.55 11 18C11 17.45 10.55 17 10 17ZM14 12.5C13.17 12.5 12.5 13.17 12.5 14C12.5 14.83 13.17 15.5 14 15.5C14.83 15.5 15.5 14.83 15.5 14C15.5 13.17 14.83 12.5 14 12.5ZM14 8.5C13.17 8.5 12.5 9.17 12.5 10C12.5 10.83 13.17 11.5 14 11.5C14.83 11.5 15.5 10.83 15.5 10C15.5 9.17 14.83 8.5 14 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBolt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bolt">
        <path
          id="Vector"
          d="M10.9956 21H9.99558L10.9956 14H7.49558C6.61558 14 7.16558 13.25 7.18558 13.22C8.47558 10.94 10.4156 7.54 13.0056 3H14.0056L13.0056 10H16.5156C16.9156 10 17.1356 10.19 16.9156 10.66C12.9656 17.55 10.9956 21 10.9956 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBook(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="book">
        <path
          id="Vector"
          d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 4H11V9L10 8.25L9 9V4ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookOnline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="book_online">
        <path
          id="Vector"
          d="M17 4H7V3H17V4ZM17 21H7V20H17V21ZM17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM7 6H17V18H7V6ZM16 11V9.14C16 8.51 15.55 8 15 8H9C8.45 8 8 8.51 8 9.14V11.1C8.55 11.1 9 11.55 9 12.1C9 12.65 8.55 13.1 8 13.1V14.86C8 15.49 8.45 16 9 16H15C15.55 16 16 15.49 16 14.86V13C15.45 13 15 12.55 15 12C15 11.45 15.45 11 16 11ZM12.5 14.5H11.5V13.5H12.5V14.5ZM12.5 12.5H11.5V11.5H12.5V12.5ZM12.5 10.5H11.5V9.5H12.5V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmark(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmark">
        <path
          id="Vector"
          d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmarkAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmark_add">
        <path
          id="Vector"
          d="M16 11V17.97L11 15.83L6 17.97V5H12V3H6C4.9 3 4 3.9 4 5V21L11 18L18 21V11H16ZM20 7H18V9H16V7H14V5H16V3H18V5H20V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmarkAdded(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmark_added">
        <path
          id="Vector"
          d="M15.115 11.185V18.155L10.115 16.015L5.11499 18.155V5.185H11.115V3.185H5.11499C4.01499 3.185 3.11499 4.085 3.11499 5.185V21.185L10.115 18.185L17.115 21.185V11.185H15.115ZM15.945 9.185L13.115 6.355L14.525 4.945L15.935 6.355L19.475 2.815L20.885 4.225L15.945 9.185Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmarkBorder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmark_border">
        <path
          id="Vector"
          d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmarkRemove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmark_remove">
        <path
          id="Vector"
          d="M16 11V17.97L11 15.83L6 17.97V5H12V3H6C4.9 3 4 3.9 4 5V21L11 18L18 21V11H16ZM20 7H14V5H20V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmarks(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmarks">
        <path
          id="Vector"
          d="M15 7V19.97L10 17.82L5 19.97V7H15ZM19 1H8.99C7.89 1 7 1.9 7 3H17C18.1 3 19 3.9 19 5V18L21 19V3C21 1.9 20.1 1 19 1ZM15 5H5C3.9 5 3 5.9 3 7V23L10 20L17 23V7C17 5.9 16.1 5 15 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBookmarksFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bookmarks_filled">
        <path
          id="Vector"
          d="M19 18L21 19V3C21 1.9 20.1 1 19 1H8.99C7.89 1 7 1.9 7 3H17C18.1 3 19 3.9 19 5V18ZM15 5H5C3.9 5 3 5.9 3 7V23L10 20L17 23V7C17 5.9 16.1 5 15 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_all">
        <path
          id="Vector"
          d="M3 3V21H21V3H3ZM11 19H5V13H11V19ZM11 11H5V5H11V11ZM19 19H13V13H19V19ZM19 11H13V5H19V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderBottom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_bottom">
        <path
          id="Vector"
          d="M9 11H7V13H9V11ZM13 15H11V17H13V15ZM9 3H7V5H9V3ZM13 11H11V13H13V11ZM5 3H3V5H5V3ZM13 7H11V9H13V7ZM17 11H15V13H17V11ZM13 3H11V5H13V3ZM17 3H15V5H17V3ZM19 13H21V11H19V13ZM19 17H21V15H19V17ZM5 7H3V9H5V7ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM5 11H3V13H5V11ZM3 21H21V19H3V21ZM5 15H3V17H5V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderClear(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_clear">
        <path
          id="Vector"
          d="M7 5H9V3H7V5ZM7 13H9V11H7V13ZM7 21H9V19H7V21ZM11 17H13V15H11V17ZM11 21H13V19H11V21ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM11 13H13V11H11V13ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM19 9H21V7H19V9ZM11 9H13V7H11V9ZM19 3V5H21V3H19ZM11 5H13V3H11V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderColor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_color">
        <g id="Vector">
          <path
            d="M16.81 7.94L13.06 4.19L4 13.25V17H7.75L16.81 7.94ZM6 15V14.08L13.06 7.02L13.98 7.94L6.92 15H6Z"
            fill="currentColor"
          />
          <path
            d="M19.71 5.04C20.1 4.65 20.1 4.02 19.71 3.63L17.37 1.29C17.17 1.09 16.92 1 16.66 1C16.41 1 16.15 1.1 15.96 1.29L14.13 3.12L17.88 6.87L19.71 5.04Z"
            fill="currentColor"
          />
          <path d="M22 19H2V23H22V19Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconBorderHorizontal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_horizontal">
        <path
          id="Vector"
          d="M3 21H5V19H3V21ZM5 7H3V9H5V7ZM3 17H5V15H3V17ZM7 21H9V19H7V21ZM5 3H3V5H5V3ZM9 3H7V5H9V3ZM17 3H15V5H17V3ZM13 7H11V9H13V7ZM13 3H11V5H13V3ZM19 17H21V15H19V17ZM11 21H13V19H11V21ZM3 13H21V11H3V13ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM11 17H13V15H11V17ZM15 21H17V19H15V21ZM19 21H21V19H19V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderInner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_inner">
        <path
          id="Vector"
          d="M3 21H5V19H3V21ZM7 21H9V19H7V21ZM5 7H3V9H5V7ZM3 17H5V15H3V17ZM9 3H7V5H9V3ZM5 3H3V5H5V3ZM17 3H15V5H17V3ZM19 9H21V7H19V9ZM19 3V5H21V3H19ZM15 21H17V19H15V21ZM13 3H11V11H3V13H11V21H13V13H21V11H13V3ZM19 21H21V19H19V21ZM19 17H21V15H19V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_left">
        <path
          id="Vector"
          d="M11 21H13V19H11V21ZM11 17H13V15H11V17ZM11 5H13V3H11V5ZM11 9H13V7H11V9ZM11 13H13V11H11V13ZM7 21H9V19H7V21ZM7 5H9V3H7V5ZM7 13H9V11H7V13ZM3 21H5V3H3V21ZM19 9H21V7H19V9ZM15 21H17V19H15V21ZM19 17H21V15H19V17ZM19 3V5H21V3H19ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderOuter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_outer">
        <path
          id="Vector"
          d="M13 7H11V9H13V7ZM13 11H11V13H13V11ZM17 11H15V13H17V11ZM3 3V21H21V3H3ZM19 19H5V5H19V19ZM13 15H11V17H13V15ZM9 11H7V13H9V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_right">
        <path
          id="Vector"
          d="M7 21H9V19H7V21ZM3 5H5V3H3V5ZM7 5H9V3H7V5ZM7 13H9V11H7V13ZM3 21H5V19H3V21ZM11 21H13V19H11V21ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM11 17H13V15H11V17ZM15 13H17V11H15V13ZM19 3V21H21V3H19ZM15 21H17V19H15V21ZM15 5H17V3H15V5ZM11 13H13V11H11V13ZM11 5H13V3H11V5ZM11 9H13V7H11V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderStyle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_style">
        <path
          id="Vector"
          d="M15 21H17V19H15V21ZM19 21H21V19H19V21ZM7 21H9V19H7V21ZM11 21H13V19H11V21ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM3 3V21H5V5H21V3H3ZM19 9H21V7H19V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderTop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_top">
        <path
          id="Vector"
          d="M7 21H9V19H7V21ZM7 13H9V11H7V13ZM11 13H13V11H11V13ZM11 21H13V19H11V21ZM3 17H5V15H3V17ZM3 21H5V19H3V21ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM11 17H13V15H11V17ZM19 9H21V7H19V9ZM19 13H21V11H19V13ZM3 3V5H21V3H3ZM19 17H21V15H19V17ZM15 21H17V19H15V21ZM11 9H13V7H11V9ZM19 21H21V19H19V21ZM15 13H17V11H15V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBorderVertical(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="border_vertical">
        <path
          id="Vector"
          d="M3 9H5V7H3V9ZM3 5H5V3H3V5ZM7 21H9V19H7V21ZM7 13H9V11H7V13ZM3 13H5V11H3V13ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM7 5H9V3H7V5ZM19 17H21V15H19V17ZM11 21H13V3H11V21ZM19 21H21V19H19V21ZM19 13H21V11H19V13ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM15 5H17V3H15V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBoy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="boy">
        <path
          id="Vector"
          d="M12 7.5C12.97 7.5 13.75 6.72 13.75 5.75C13.75 4.78 12.97 4 12 4C11.03 4 10.25 4.78 10.25 5.75C10.25 6.72 11.03 7.5 12 7.5ZM14 20V15H15V10.5C15 9.4 14.1 8.5 13 8.5H11C9.9 8.5 9 9.4 9 10.5V15H10V20H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBrandingWatermark(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="branding_watermark">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM11 12H20V18H11V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBreakfastDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="breakfast_dining">
        <g id="Vector">
          <path
            d="M18 3H6C3.79 3 2 4.79 2 7C2 8.48 2.81 9.75 4 10.45V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V10.45C21.19 9.76 22 8.48 22 7C22 4.79 20.21 3 18 3ZM19 8.72L18 9.3V19H6V9.31L5.01 8.73C4.38 8.35 4 7.71 4 7C4 5.9 4.9 5 6 5H18C19.1 5 20 5.9 20 7C20 7.71 19.62 8.36 19 8.72Z"
            fill="currentColor"
          />
          <path
            d="M12.71 9.29C12.51 9.1 12.26 9 12 9C11.74 9 11.49 9.1 11.29 9.29L8.29 12.29C7.9 12.68 7.9 13.31 8.29 13.7L11.29 16.7C11.49 16.9 11.74 17 12 17C12.26 17 12.51 16.9 12.71 16.71L15.71 13.71C16.1 13.32 16.1 12.69 15.71 12.3L12.71 9.29ZM12 14.58L10.41 13L12 11.41L13.59 13L12 14.58Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBrightness2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_2">
        <path
          id="Vector"
          d="M9.5 4C13.91 4 17.5 7.59 17.5 12C17.5 16.41 13.91 20 9.5 20C9.16 20 8.82 19.98 8.49 19.93C10.4 17.77 11.5 14.95 11.5 12C11.5 9.05 10.4 6.23 8.49 4.07C8.82 4.02 9.16 4 9.5 4ZM9.5 2C7.68 2 5.97 2.5 4.5 3.35C7.49 5.08 9.5 8.3 9.5 12C9.5 15.7 7.49 18.92 4.5 20.65C5.97 21.5 7.68 22 9.5 22C15.02 22 19.5 17.52 19.5 12C19.5 6.48 15.02 2 9.5 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBrightness3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_3">
        <path
          id="Vector"
          d="M12.2 4.91C14.75 6.24 16.5 8.92 16.5 12C16.5 15.08 14.75 17.76 12.2 19.09C13.66 17.09 14.5 14.63 14.5 12C14.5 9.37 13.66 6.91 12.2 4.91ZM8.5 2C7.45 2 6.45 2.16 5.5 2.46C9.56 3.73 12.5 7.52 12.5 12C12.5 16.48 9.56 20.27 5.5 21.54C6.45 21.84 7.45 22 8.5 22C14.02 22 18.5 17.52 18.5 12C18.5 6.48 14.02 2 8.5 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBrightness4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_4" clipPath="url(#clip0_395_1646)">
        <path
          id="Vector"
          d="M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM12.2899 6.99994C11.5499 6.99994 10.8399 7.16994 10.2099 7.45994C11.9299 8.24994 13.1299 9.98994 13.1299 11.9999C13.1299 14.0099 11.9299 15.7499 10.2099 16.5399C10.8399 16.8299 11.5499 16.9999 12.2899 16.9999C15.0499 16.9999 17.2899 14.7599 17.2899 11.9999C17.2899 9.23994 15.0499 6.99994 12.2899 6.99994Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_1646">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightness5(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_5" clipPath="url(#clip0_395_1648)">
        <path
          id="Vector"
          d="M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 6.49994C8.96994 6.49994 6.49994 8.96994 6.49994 11.9999C6.49994 15.0299 8.96994 17.4999 11.9999 17.4999C15.0299 17.4999 17.4999 15.0299 17.4999 11.9999C17.4999 8.96994 15.0299 6.49994 11.9999 6.49994ZM11.9999 15.4999C10.0699 15.4999 8.49994 13.9299 8.49994 11.9999C8.49994 10.0699 10.0699 8.49994 11.9999 8.49994C13.9299 8.49994 15.4999 10.0699 15.4999 11.9999C15.4999 13.9299 13.9299 15.4999 11.9999 15.4999Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_1648">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightness6(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_6" clipPath="url(#clip0_395_1650)">
        <path
          id="Vector"
          d="M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 6.49994V17.4999C15.0299 17.4999 17.4999 15.0299 17.4999 11.9999C17.4999 8.96994 15.0299 6.49994 11.9999 6.49994Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_1650">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightness7(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_7" clipPath="url(#clip0_395_1652)">
        <g id="Vector">
          <path
            d="M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 6.49994C8.96994 6.49994 6.49994 8.96994 6.49994 11.9999C6.49994 15.0299 8.96994 17.4999 11.9999 17.4999C15.0299 17.4999 17.4999 15.0299 17.4999 11.9999C17.4999 8.96994 15.0299 6.49994 11.9999 6.49994ZM11.9999 15.4999C10.0699 15.4999 8.49994 13.9299 8.49994 11.9999C8.49994 10.0699 10.0699 8.49994 11.9999 8.49994C13.9299 8.49994 15.4999 10.0699 15.4999 11.9999C15.4999 13.9299 13.9299 15.4999 11.9999 15.4999Z"
            fill="currentColor"
          />
          <path
            d="M11.9999 13.9999C13.1045 13.9999 13.9999 13.1045 13.9999 11.9999C13.9999 10.8954 13.1045 9.99994 11.9999 9.99994C10.8954 9.99994 9.99994 10.8954 9.99994 11.9999C9.99994 13.1045 10.8954 13.9999 11.9999 13.9999Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_1652">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightnessAuto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_auto" clipPath="url(#clip0_395_2664)">
        <path
          id="Vector"
          d="M10.9999 7L7.79994 16H9.69994L10.3999 14H13.5999L14.2999 16H16.1999L12.9999 7H10.9999ZM10.8499 12.65L11.9999 9L13.1499 12.65H10.8499ZM19.9999 8.69V4H15.3099L11.9999 0.690002L8.68994 4H3.99994V8.69L0.689941 12L3.99994 15.31V20H8.68994L11.9999 23.31L15.3099 20H19.9999V15.31L23.3099 12L19.9999 8.69ZM17.9999 14.48V18H14.4799L11.9999 20.48L9.51994 18H5.99994V14.48L3.51994 12L5.99994 9.52V6H9.51994L11.9999 3.52L14.4799 6H17.9999V9.52L20.4799 12L17.9999 14.48Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_2664">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightnessHigh(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_high" clipPath="url(#clip0_395_2666)">
        <g id="Vector">
          <path
            d="M19.9999 8.69V4H15.3099L11.9999 0.690002L8.68994 4H3.99994V8.69L0.689941 12L3.99994 15.31V20H8.68994L11.9999 23.31L15.3099 20H19.9999V15.31L23.3099 12L19.9999 8.69ZM17.9999 14.48V18H14.4799L11.9999 20.48L9.51994 18H5.99994V14.48L3.51994 12L5.99994 9.52V6H9.51994L11.9999 3.52L14.4799 6H17.9999V9.52L20.4799 12L17.9999 14.48ZM11.9999 6C8.68994 6 5.99994 8.69 5.99994 12C5.99994 15.31 8.68994 18 11.9999 18C15.3099 18 17.9999 15.31 17.9999 12C17.9999 8.69 15.3099 6 11.9999 6ZM11.9999 16C9.78994 16 7.99994 14.21 7.99994 12C7.99994 9.79 9.78994 8 11.9999 8C14.2099 8 15.9999 9.79 15.9999 12C15.9999 14.21 14.2099 16 11.9999 16Z"
            fill="currentColor"
          />
          <path
            d="M11.9999 14.5C13.3807 14.5 14.4999 13.3807 14.4999 12C14.4999 10.6193 13.3807 9.5 11.9999 9.5C10.6192 9.5 9.49994 10.6193 9.49994 12C9.49994 13.3807 10.6192 14.5 11.9999 14.5Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_2666">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightnessLow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_low" clipPath="url(#clip0_395_2668)">
        <path
          id="Vector"
          d="M19.9999 8.69V4H15.3099L11.9999 0.690002L8.68994 4H3.99994V8.69L0.689941 12L3.99994 15.31V20H8.68994L11.9999 23.31L15.3099 20H19.9999V15.31L23.3099 12L19.9999 8.69ZM17.9999 14.48V18H14.4799L11.9999 20.48L9.51994 18H5.99994V14.48L3.51994 12L5.99994 9.52V6H9.51994L11.9999 3.52L14.4799 6H17.9999V9.52L20.4799 12L17.9999 14.48ZM11.9999 6C8.68994 6 5.99994 8.69 5.99994 12C5.99994 15.31 8.68994 18 11.9999 18C15.3099 18 17.9999 15.31 17.9999 12C17.9999 8.69 15.3099 6 11.9999 6ZM11.9999 16C9.78994 16 7.99994 14.21 7.99994 12C7.99994 9.79 9.78994 8 11.9999 8C14.2099 8 15.9999 9.79 15.9999 12C15.9999 14.21 14.2099 16 11.9999 16Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_2668">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBrightnessMedium(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brightness_medium" clipPath="url(#clip0_395_2670)">
        <path
          id="Vector"
          d="M19.9999 8.69V4H15.3099L11.9999 0.690002L8.68994 4H3.99994V8.69L0.689941 12L3.99994 15.31V20H8.68994L11.9999 23.31L15.3099 20H19.9999V15.31L23.3099 12L19.9999 8.69ZM17.9999 14.48V18H14.4799L11.9999 20.48L9.51994 18H5.99994V14.48L3.51994 12L5.99994 9.52V6H9.51994L11.9999 3.52L14.4799 6H17.9999V9.52L20.4799 12L17.9999 14.48ZM11.9999 6V18C15.3099 18 17.9999 15.31 17.9999 12C17.9999 8.69 15.3099 6 11.9999 6Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_2670">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBroadcastOnHome(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="broadcast_on_home">
        <g id="Vector">
          <path
            d="M21.25 5C21.25 3.9 20.35 3 19.25 3H3.25V5H19.25V7.59C19.98 7.88 20.65 8.28 21.25 8.76V5Z"
            fill="currentColor"
          />
          <path
            d="M7.25 8H2.25C1.75 8 1.25 8.5 1.25 9V18C1.25 18.5 1.75 19 2.25 19H7.25C7.75 19 8.25 18.5 8.25 18V9C8.25 8.5 7.75 8 7.25 8ZM6.25 17H3.25V10H6.25V17Z"
            fill="currentColor"
          />
          <path
            d="M17 15.97C17.3 15.74 17.5 15.4 17.5 15C17.5 14.31 16.94 13.75 16.25 13.75C15.56 13.75 15 14.31 15 15C15 15.4 15.2 15.75 15.5 15.97V21H17V15.97Z"
            fill="currentColor"
          />
          <path
            d="M16.25 12.5C17.63 12.5 18.75 13.62 18.75 15C18.75 15.69 18.47 16.31 18.02 16.76L19.08 17.82C19.8 17.1 20.25 16.1 20.25 15C20.25 12.79 18.46 11 16.25 11C14.04 11 12.25 12.79 12.25 15C12.25 16.1 12.7 17.1 13.42 17.83L14.48 16.77C14.03 16.32 13.75 15.69 13.75 15C13.75 13.62 14.87 12.5 16.25 12.5Z"
            fill="currentColor"
          />
          <path
            d="M16.25 8.5C12.66 8.5 9.75 11.41 9.75 15C9.75 16.79 10.48 18.42 11.65 19.6L12.71 18.54C11.81 17.63 11.25 16.38 11.25 15C11.25 12.24 13.49 10 16.25 10C19.01 10 21.25 12.24 21.25 15C21.25 16.37 20.69 17.62 19.79 18.52L20.86 19.58C22.03 18.4 22.75 16.78 22.75 15C22.75 11.41 19.84 8.5 16.25 8.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBroadcastOnPersonal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="broadcast_on_personal">
        <g id="Vector">
          <path
            d="M3.25 18.5V9.5L9.25 5L13.33 8.06C14.14 7.74 15.02 7.55 15.94 7.52L9.25 2.5L1.25 8.5V20.5H10.01C9.53 19.9 9.13 19.23 8.84 18.5H3.25Z"
            fill="currentColor"
          />
          <path
            d="M16.25 14.25C15.56 14.25 15 14.81 15 15.5C15 15.9 15.2 16.25 15.5 16.47V21.5H17V16.47C17.3 16.24 17.5 15.9 17.5 15.5C17.5 14.81 16.94 14.25 16.25 14.25Z"
            fill="currentColor"
          />
          <path
            d="M16.25 11.5C14.04 11.5 12.25 13.29 12.25 15.5C12.25 16.6 12.7 17.6 13.42 18.33L14.48 17.27C14.03 16.82 13.75 16.19 13.75 15.5C13.75 14.12 14.87 13 16.25 13C17.63 13 18.75 14.12 18.75 15.5C18.75 16.19 18.47 16.81 18.02 17.26L19.08 18.32C19.8 17.6 20.25 16.6 20.25 15.5C20.25 13.29 18.46 11.5 16.25 11.5Z"
            fill="currentColor"
          />
          <path
            d="M16.25 9C12.66 9 9.75 11.91 9.75 15.5C9.75 17.29 10.48 18.92 11.65 20.1L12.71 19.04C11.81 18.13 11.25 16.88 11.25 15.5C11.25 12.74 13.49 10.5 16.25 10.5C19.01 10.5 21.25 12.74 21.25 15.5C21.25 16.87 20.69 18.12 19.79 19.02L20.86 20.08C22.03 18.9 22.75 17.28 22.75 15.5C22.75 11.91 19.84 9 16.25 9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBrokenImage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="broken_image">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V14.42L5.99 15.41L9.99 11.41L13.99 15.41L17.99 11.42L19 12.43V19ZM19 9.59L17.99 8.58L13.99 12.59L9.99 8.59L5.99 12.59L5 11.59V5H19V9.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBrowseGallery(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="browse_gallery">
        <g id="Vector">
          <path
            d="M9 3C4.03 3 0 7.03 0 12C0 16.97 4.03 21 9 21C13.97 21 18 16.97 18 12C18 7.03 13.97 3 9 3ZM9 19C5.14 19 2 15.86 2 12C2 8.14 5.14 5 9 5C12.86 5 16 8.14 16 12C16 15.86 12.86 19 9 19Z"
            fill="currentColor"
          />
          <path d="M10 7H8V12.41L11.79 16.21L13.21 14.79L10 11.59V7Z" fill="currentColor" />
          <path
            d="M17.99 3.52V5.68C20.36 6.8 22 9.21 22 12C22 14.79 20.36 17.2 17.99 18.32V20.48C21.48 19.24 24 15.91 24 12C24 8.09 21.48 4.76 17.99 3.52Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBrowserNotSupported(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="browser_not_supported">
        <g id="Vector">
          <path
            d="M19.5251 5.31V15.81L21.4751 17.76C21.5051 17.61 21.5251 17.46 21.5251 17.31V5.31C21.5251 4.21 20.6251 3.31 19.5251 3.31H7.0251L9.0251 5.31H19.5251Z"
            fill="currentColor"
          />
          <path
            d="M3.7451 2.63L2.4751 3.90001L3.5251 4.95V17.31C3.5251 18.41 4.4251 19.31 5.5251 19.31H17.8851L19.9451 21.37L21.2151 20.1L3.7451 2.63ZM5.5251 17.31V6.95L15.8851 17.31H5.5251Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBrowserUpdated(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="browser_updated">
        <path
          id="Vector"
          d="M22 13V16C22 17.1 21.1 18 20 18H17L18 19V21H6V19L7 18H4C2.9 18 2 17.1 2 16V5C2 3.9 2.9 3 4 3H12V5H4V16H20V13H22ZM15 15L10 10L11.41 8.59L14 11.17V3H16V11.17L18.59 8.59L20 10L15 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBrunchDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brunch_dining">
        <g id="Vector">
          <path
            d="M2 21.5C2 21.78 2.22 22 2.49 22H15.51C15.78 22 16 21.78 16 21.5V20H2V21.5Z"
            fill="currentColor"
          />
          <path
            d="M15.5 16H11V14H7V16H2.5C2.22 16 2 16.22 2 16.5V18H16V16.5C16 16.22 15.78 16 15.5 16Z"
            fill="currentColor"
          />
          <path
            d="M20.47 15.45C21.46 14.38 22 12.97 22 11.51V2H16V11.47C16 12.95 16.58 14.39 17.6 15.47L18 15.89V22H22V20H20V15.97L20.47 15.45ZM18 4H20V8H18V4ZM19.03 14.07C18.38 13.36 18 12.42 18 11.47V10H20V11.51C20 12.46 19.66 13.36 19.03 14.07Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBrush(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="brush">
        <path
          id="Vector"
          d="M7.49878 16C8.04878 16 8.49878 16.45 8.49878 17C8.49878 18.1 7.59878 19 6.49878 19C6.32878 19 6.16878 18.98 5.99878 18.95C6.30878 18.4 6.49878 17.74 6.49878 17C6.49878 16.45 6.94878 16 7.49878 16ZM19.1688 3C18.9088 3 18.6588 3.1 18.4588 3.29L9.49878 12.25L12.2488 15L21.2088 6.04C21.5988 5.65 21.5988 5.02 21.2088 4.63L19.8688 3.29C19.6688 3.09 19.4188 3 19.1688 3ZM7.49878 14C5.83878 14 4.49878 15.34 4.49878 17C4.49878 18.31 3.33878 19 2.49878 19C3.41878 20.22 4.98878 21 6.49878 21C8.70878 21 10.4988 19.21 10.4988 17C10.4988 15.34 9.15878 14 7.49878 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBubbleChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bubble_chart">
        <path
          id="Vector"
          d="M6.5 10C4.29 10 2.5 11.79 2.5 14C2.5 16.21 4.29 18 6.5 18C8.71 18 10.5 16.21 10.5 14C10.5 11.79 8.71 10 6.5 10ZM6.5 16C5.4 16 4.5 15.1 4.5 14C4.5 12.9 5.4 12 6.5 12C7.6 12 8.5 12.9 8.5 14C8.5 15.1 7.6 16 6.5 16ZM14.51 15C12.86 15 11.51 16.35 11.51 18C11.51 19.65 12.86 21 14.51 21C16.16 21 17.51 19.65 17.51 18C17.51 16.35 16.16 15 14.51 15ZM14.51 19C13.96 19 13.51 18.55 13.51 18C13.51 17.45 13.96 17 14.51 17C15.06 17 15.51 17.45 15.51 18C15.51 18.55 15.06 19 14.51 19ZM16 3C12.97 3 10.5 5.47 10.5 8.5C10.5 11.53 12.97 14 16 14C19.03 14 21.5 11.53 21.5 8.5C21.5 5.47 19.03 3 16 3ZM16 12C14.07 12 12.5 10.43 12.5 8.5C12.5 6.57 14.07 5 16 5C17.93 5 19.5 6.57 19.5 8.5C19.5 10.43 17.93 12 16 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBugReport(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bug_report">
        <path
          id="Vector"
          d="M20 8H17.19C16.74 7.22 16.12 6.55 15.37 6.04L17 4.41L15.59 3L13.42 5.17C12.96 5.06 12.49 5 12 5C11.51 5 11.04 5.06 10.59 5.17L8.41 3L7 4.41L8.62 6.04C7.88 6.55 7.26 7.22 6.81 8H4V10H6.09C6.04 10.33 6 10.66 6 11V12H4V14H6V15C6 15.34 6.04 15.67 6.09 16H4V18H6.81C7.85 19.79 9.78 21 12 21C14.22 21 16.15 19.79 17.19 18H20V16H17.91C17.96 15.67 18 15.34 18 15V14H20V12H18V11C18 10.66 17.96 10.33 17.91 10H20V8ZM16 15C16 15.22 15.97 15.47 15.93 15.7L15.83 16.35L15.46 17C14.74 18.24 13.42 19 12 19C10.58 19 9.26 18.23 8.54 17L8.17 16.36L8.07 15.71C8.03 15.48 8 15.23 8 15V11C8 10.77 8.03 10.52 8.07 10.3L8.17 9.65L8.54 9C8.84 8.48 9.26 8.03 9.75 7.69L10.32 7.3L11.06 7.12C11.37 7.04 11.69 7 12 7C12.32 7 12.63 7.04 12.95 7.12L13.63 7.28L14.24 7.7C14.74 8.04 15.15 8.48 15.45 9.01L15.83 9.66L15.93 10.31C15.97 10.53 16 10.78 16 11V15ZM10 14H14V16H10V14ZM10 10H14V12H10V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBuild(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="build">
        <path
          id="Vector"
          d="M22.6559 18.9896L13.5759 9.90957C14.5059 7.56957 14.0259 4.80957 12.1359 2.90957C9.83586 0.609575 6.25586 0.399574 3.70586 2.25957L7.54586 6.10957L6.12586 7.51957L2.29586 3.68957C0.43586 6.22957 0.64586 9.81957 2.94586 12.1096C4.80586 13.9696 7.51586 14.4596 9.83586 13.5896L18.9459 22.6996C19.3359 23.0896 19.9659 23.0896 20.3559 22.6996L22.6559 20.3996C23.0559 20.0196 23.0559 19.3896 22.6559 18.9896ZM19.6559 20.5896L10.1959 11.1296C9.58586 11.5796 8.90586 11.8496 8.19586 11.9496C6.83586 12.1496 5.40586 11.7396 4.36586 10.6996C3.41586 9.75957 2.97586 8.49957 3.04586 7.25957L6.13586 10.3496L10.3759 6.10957L7.28586 3.01957C8.52586 2.94957 9.77586 3.38957 10.7259 4.32957C11.8059 5.40957 12.2159 6.89957 11.9659 8.28957C11.8459 8.99957 11.5459 9.65957 11.0859 10.2496L20.5359 19.6996L19.6559 20.5896Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBuildCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="build_circle">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.49 11.38C13.92 10.16 13.66 8.74 12.68 7.76C11.57 6.65 9.89 6.46 8.58 7.17L10.93 9.52L9.52 10.93L7.17 8.58C6.46 9.9 6.65 11.57 7.76 12.68C8.74 13.66 10.16 13.92 11.38 13.49L14.79 16.9C14.99 17.1 15.3 17.1 15.5 16.9L16.9 15.5C17.1 15.3 17.1 14.99 16.9 14.79L13.49 11.38Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBungalow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bungalow">
        <path
          id="Vector"
          d="M13.0002 14H11.0002V12H13.0002V14ZM18.1002 16.56L17.0002 14.79V21H7.0002V14.8L5.9002 16.56L4.2002 15.5L12.0002 3L19.8002 15.5L18.1002 16.56ZM15.0002 11.59L12.0002 6.79L9.0002 11.59V19H11.0002V16H13.0002V19H15.0002V11.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBurstMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="burst_mode">
        <path
          id="Vector"
          d="M1 5H3V19H1V5ZM5 5H7V19H5V5ZM22 5H10C9.45 5 9 5.45 9 6V18C9 18.55 9.45 19 10 19H22C22.55 19 23 18.55 23 18V6C23 5.45 22.55 5 22 5ZM21 17H11V7H21V17ZM17.43 12.62L15.43 15.19L14 13.47L12 15.99H20L17.43 12.62Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBusAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="bus_alert">
        <g id="Vector">
          <path
            d="M6 17.5C6.82843 17.5 7.5 16.8284 7.5 16C7.5 15.1716 6.82843 14.5 6 14.5C5.17157 14.5 4.5 15.1716 4.5 16C4.5 16.8284 5.17157 17.5 6 17.5Z"
            fill="currentColor"
          />
          <path
            d="M13 17.5C13.8284 17.5 14.5 16.8284 14.5 16C14.5 15.1716 13.8284 14.5 13 14.5C12.1716 14.5 11.5 15.1716 11.5 16C11.5 16.8284 12.1716 17.5 13 17.5Z"
            fill="currentColor"
          />
          <path
            d="M3.5 11.5V8.5H10.79C10.6 7.87 10.5 7.2 10.5 6.5H3.93C4.76 5.79 6.91 5.41 10.58 5.52C10.68 4.82 10.88 4.15 11.17 3.53C2.47 3.17 1.5 5.52 1.5 7.5V17C1.5 17.95 1.88 18.81 2.5 19.44V21.5C2.5 22.05 2.95 22.5 3.5 22.5H4.5C5.05 22.5 5.5 22.05 5.5 21.5V20.5H13.5V21.5C13.5 22.05 13.95 22.5 14.5 22.5H15.5C16.05 22.5 16.5 22.05 16.5 21.5V19.44C17.12 18.81 17.5 17.95 17.5 17V13.5C15.59 13.5 13.87 12.74 12.61 11.5H3.5ZM15.5 16.5C15.5 17.6 14.6 18.5 13.5 18.5H5.5C4.4 18.5 3.5 17.6 3.5 16.5V13.5H15.5V16.5Z"
            fill="currentColor"
          />
          <path
            d="M17.5 1.5C14.74 1.5 12.5 3.74 12.5 6.5C12.5 9.26 14.74 11.5 17.5 11.5C20.26 11.5 22.5 9.26 22.5 6.5C22.5 3.74 20.26 1.5 17.5 1.5ZM18 9.5H17V8.5H18V9.5ZM18 7.5H17V3.5H18V7.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBusiness(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="business">
        <path
          id="Vector"
          d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconBusinessCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="business_center">
        <path
          id="Vector"
          d="M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V14C2 14.75 2.4 15.38 3 15.73V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15.72C21.59 15.37 22 14.73 22 14V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5ZM4 9H20V14H15V11H9V14H4V9ZM13 15H11V13H13V15ZM19 19H5V16H9V17H15V16H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCabin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cabin">
        <path
          id="Vector"
          d="M10 2C10 3.66 8.66 5 7 5C6.45 5 6 5.45 6 6H4C4 4.34 5.34 3 7 3C7.55 3 8 2.55 8 2H10ZM12 4L6 8.58V7H4V10.11L1 12.4L2.21 13.99L4 12.62V22H20V12.62L21.79 13.98L23 12.4L12 4ZM13.94 8H10.05L12 6.52L13.94 8ZM7.44 10H16.56L18 11.1V12H6V11.1L7.44 10ZM18 14V16H6V14H18ZM6 20V18H18V20H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCable(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cable">
        <path
          id="Vector"
          d="M20 5V4C20 3.45 19.55 3 19 3H17C16.45 3 16 3.45 16 4V5H15V9C15 9.55 15.45 10 16 10H17V17C17 18.1 16.1 19 15 19C13.9 19 13 18.1 13 17V7C13 4.79 11.21 3 9 3C6.79 3 5 4.79 5 7V14H4C3.45 14 3 14.45 3 15V19H4V20C4 20.55 4.45 21 5 21H7C7.55 21 8 20.55 8 20V19H9V15C9 14.45 8.55 14 8 14H7V7C7 5.9 7.9 5 9 5C10.1 5 11 5.9 11 7V17C11 19.21 12.79 21 15 21C17.21 21 19 19.21 19 17V10H20C20.55 10 21 9.55 21 9V5H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCached(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cached">
        <path
          id="Vector"
          d="M19 8L15 12H18C18 15.31 15.31 18 12 18C10.99 18 10.03 17.75 9.2 17.3L7.74 18.76C8.97 19.54 10.43 20 12 20C16.42 20 20 16.42 20 12H23L19 8ZM6 12C6 8.69 8.69 6 12 6C13.01 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C7.58 4 4 7.58 4 12H1L5 16L9 12H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCake(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cake">
        <path
          id="Vector"
          d="M12 7C13.11 7 14 6.1 14 5C14 4.62 13.9 4.27 13.71 3.97L12 1L10.29 3.97C10.1 4.27 10 4.62 10 5C10 6.1 10.9 7 12 7ZM18 10H13V8H11V10H6C4.34 10 3 11.34 3 13V22C3 22.55 3.45 23 4 23H20C20.55 23 21 22.55 21 22V13C21 11.34 19.66 10 18 10ZM19 21H5V18C5.9 17.99 6.76 17.63 7.4 16.99L8.49 15.92L9.56 16.99C10.87 18.3 13.15 18.29 14.45 16.99L15.53 15.92L16.6 16.99C17.24 17.63 18.1 17.99 19 18V21ZM19 16.5C18.49 16.49 18.01 16.3 17.65 15.93L15.52 13.8L13.38 15.93C12.64 16.67 11.35 16.67 10.61 15.93L8.48 13.8L6.34 15.93C5.99 16.29 5.51 16.49 5 16.5V13C5 12.45 5.45 12 6 12H18C18.55 12 19 12.45 19 13V16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCalculate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calculate">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M11.25 7.72H6.25V9.22H11.25V7.72Z" fill="currentColor" />
          <path d="M18 15.75H13V17.25H18V15.75Z" fill="currentColor" />
          <path d="M18 13.25H13V14.75H18V13.25Z" fill="currentColor" />
          <path d="M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18Z" fill="currentColor" />
          <path
            d="M14.09 10.95L15.5 9.54L16.91 10.95L17.97 9.89L16.56 8.47L17.97 7.06L16.91 6L15.5 7.41L14.09 6L13.03 7.06L14.44 8.47L13.03 9.89L14.09 10.95Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCalendarMonth(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar_month">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCalendarToday(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar_today">
        <path
          id="Vector"
          d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM20 8H4V5H20V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCalendarViewDay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar_view_day">
        <path
          id="Vector"
          d="M3 16.5H21V18.5H3V16.5ZM19 11.5V12.5H5V11.5H19ZM21 9.5H3V14.5H21V9.5ZM3 5.5H21V7.5H3V5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCalendarViewMonth(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar_view_month">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM8 11H4V6H8V11ZM14 11H10V6H14V11ZM20 11H16V6H20V11ZM8 18H4V13H8V18ZM14 18H10V13H14V18ZM20 18H16V13H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCalendarViewWeek(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="calendar_view_week">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM13 6H15.5V18H13V6ZM11 18H8.5V6H11V18ZM4 6H6.5V18H4V6ZM20 18H17.5V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call">
        <path
          id="Vector"
          d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallEnd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_end">
        <path
          id="Vector"
          d="M18.59 11.0899C19.64 11.5999 20.63 12.2399 21.55 12.9999L20.48 14.0699C19.9 13.5999 19.27 13.1799 18.6 12.7999V11.0899M5.4 11.0899V12.7899C4.75 13.1599 4.12 13.5799 3.53 14.0599L2.46 12.9899C3.37 12.2399 4.36 11.6099 5.4 11.0899ZM12 7.56995C7.46 7.56995 3.34 9.34995 0.29 12.2399C0.11 12.4199 0 12.6699 0 12.9499C0 13.2299 0.11 13.4799 0.29 13.6499L2.77 16.1299C2.95 16.3099 3.2 16.4199 3.48 16.4199C3.75 16.4199 4 16.3199 4.18 16.1399C4.97 15.4099 5.86 14.7799 6.84 14.2899C7.17 14.1299 7.4 13.7799 7.4 13.3899V10.2899C8.85 9.81995 10.4 9.56995 12 9.56995C13.6 9.56995 15.15 9.81995 16.59 10.2999V13.3999C16.59 13.7999 16.82 14.1399 17.15 14.2999C18.13 14.7899 19.03 15.4099 19.82 16.1499C20 16.3199 20.25 16.4299 20.52 16.4299C20.8 16.4299 21.05 16.3199 21.23 16.1399L23.71 13.6599C23.89 13.4799 24 13.2299 24 12.9499C24 12.6699 23.89 12.4199 23.71 12.2399C20.66 9.34995 16.54 7.56995 12 7.56995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallMade(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_made">
        <path
          id="Vector"
          d="M9.5 4.5V6.5H16.09L4.5 18.09L5.91 19.5L17.5 7.91V14.5H19.5V4.5H9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallMerge(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_merge">
        <path
          id="Vector"
          d="M17.0001 20.455L18.4101 19.045L15.0001 15.635L13.5901 17.045L17.0001 20.455ZM7.50009 8.04504H11.0001V13.635L5.59009 19.045L7.00009 20.455L13.0001 14.455V8.04504H16.5001L12.0001 3.54504L7.50009 8.04504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallMissed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_missed">
        <path
          id="Vector"
          d="M19.59 6.79504L12 14.385L6.41 8.79504H11V6.79504H3V14.795H5V10.205L12 17.205L21 8.20504L19.59 6.79504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallMissedOutgoing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_missed_outgoing">
        <path
          id="Vector"
          d="M3 8.20504L12 17.205L19 10.205V14.795H21V6.79504H13V8.79504H17.59L12 14.385L4.41 6.79504L3 8.20504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallReceived(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_received">
        <path
          id="Vector"
          d="M19.5 5.91L18.09 4.5L6.5 16.09V9.5H4.5V19.5H14.5V17.5H7.91L19.5 5.91Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallSplit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_split">
        <path
          id="Vector"
          d="M14 4L16.29 6.29L13.41 9.17L14.83 10.59L17.71 7.71L20 10V4H14ZM10 4H4V10L6.29 7.71L11 12.41V20H13V11.59L7.71 6.29L10 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCallToAction(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="call_to_action">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM5 15H19V18H5V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCamera(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera">
        <path
          id="Vector"
          d="M14.25 2.26L14.17 2.22L14.16 2.24C13.46 2.09 12.74 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 7.25 18.69 3.28 14.25 2.26ZM19.41 9H11.42L14.13 4.3C16.53 4.96 18.48 6.72 19.41 9ZM13.1 4.08L9.12 11L6.4 6.3C7.84 4.88 9.82 4 12 4C12.37 4 12.74 4.03 13.1 4.08ZM5.7 7.09L8.54 12L9.69 14H4.26C4.1 13.36 4 12.69 4 12C4 10.15 4.64 8.45 5.7 7.09ZM4.59 15H12.57L9.86 19.7C7.46 19.03 5.52 17.28 4.59 15ZM10.9 19.91L14.89 13L17.61 17.7C16.16 19.12 14.18 20 12 20C11.62 20 11.26 19.96 10.9 19.91ZM18.3 16.91L14.3 10H19.73C19.9 10.64 20 11.31 20 12C20 13.85 19.36 15.55 18.3 16.91Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_alt">
        <path
          id="Vector"
          d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L9.88 5H14.12L15.95 7H20V19ZM12 8C9.24 8 7 10.24 7 13C7 15.76 9.24 18 12 18C14.76 18 17 15.76 17 13C17 10.24 14.76 8 12 8ZM12 16C10.35 16 9 14.65 9 13C9 11.35 10.35 10 12 10C13.65 10 15 11.35 15 13C15 14.65 13.65 16 12 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraEnhance(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_enhance">
        <path
          id="Vector"
          d="M12 10L11.06 12.06L9 13L11.06 13.94L12 16L12.94 13.94L15 13L12.94 12.06L12 10ZM20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L8.64 6.35L9.88 5H14.12L15.36 6.35L15.95 7H20V19ZM12 8C9.24 8 7 10.24 7 13C7 15.76 9.24 18 12 18C14.76 18 17 15.76 17 13C17 10.24 14.76 8 12 8ZM12 16C10.35 16 9 14.65 9 13C9 11.35 10.35 10 12 10C13.65 10 15 11.35 15 13C15 14.65 13.65 16 12 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraFront(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_front">
        <path
          id="Vector"
          d="M5 20V22H10V24L13 21L10 18V20H5ZM14 20H19V22H14V20ZM11.99 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 11.99 4C10.88 4 10 4.9 10 6C10 7.1 10.89 8 11.99 8ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM17 16H7V14H17V16ZM17 12.5C17 10.83 13.67 10 12 10C10.33 10 7 10.83 7 12.5V2H17V12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraIndoor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_indoor">
        <path
          id="Vector"
          d="M14 13V12C14 11.45 13.55 11 13 11H9C8.45 11 8 11.45 8 12V16C8 16.55 8.45 17 9 17H13C13.55 17 14 16.55 14 16V15L16 16.06V11.94L14 13ZM12 5.5L18 10V19H6V10L12 5.5ZM12 3L4 9V21H20V9L12 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraOutdoor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_outdoor">
        <path
          id="Vector"
          d="M18 13C18 12.45 17.55 12 17 12H13C12.45 12 12 12.45 12 13V17C12 17.55 12.45 18 13 18H17C17.55 18 18 17.55 18 17V16L20 17.06V12.94L18 14V13ZM12 3L4 9V21H20V19H6V10L12 5.5L18 10V11H20V9L12 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraRear(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_rear">
        <path
          id="Vector"
          d="M5 20V22H10V24L13 21L10 18V20H5ZM14 20H19V22H14V20ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM17 16H7V2H17V16ZM12 7C13.1 7 14 6.1 13.99 5C13.99 3.9 13.09 3 11.99 3C10.89 3 10 3.9 10 5C10 6.1 10.89 7 12 7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraRoll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="camera_roll">
        <path
          id="Vector"
          d="M14 5.5C14 4.4 13.1 3.5 12 3.5H11V2.5C11 1.95 10.55 1.5 10 1.5H6C5.45 1.5 5 1.95 5 2.5V3.5H4C2.9 3.5 2 4.4 2 5.5V20.5C2 21.6 2.9 22.5 4 22.5H12C13.1 22.5 14 21.6 14 20.5H22V5.5H14ZM20 18.5H12V20.5H4V5.5H7V3.5H9V5.5H12V7.5H20V18.5ZM9 15.5H11V17.5H9V15.5ZM9 8.5H11V10.5H9V8.5ZM13 15.5H15V17.5H13V15.5ZM13 8.5H15V10.5H13V8.5ZM17 15.5H19V17.5H17V15.5ZM17 8.5H19V10.5H17V8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCameraswitch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cameraswitch" clipPath="url(#clip0_395_2674)">
        <g id="Vector">
          <path
            d="M16 6.99999H15L14 5.99999H10L9 6.99999H8C6.9 6.99999 6 7.89999 6 8.99999V15C6 16.1 6.9 17 8 17H16C17.1 17 18 16.1 18 15V8.99999C18 7.89999 17.1 6.99999 16 6.99999ZM16 15H8V8.99999H9.83L10.83 7.99999H13.17L14.17 8.99999H16V15Z"
            fill="currentColor"
          />
          <path
            d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 9.99999 12 9.99999C10.8954 9.99999 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
            fill="currentColor"
          />
          <path
            d="M8.57 0.519993L13.05 4.99999L14.46 3.58999L12.92 2.04999C17.7 2.45999 21.53 6.23999 22 11H24C23.36 3.29999 15.79 -1.67001 8.57 0.519993Z"
            fill="currentColor"
          />
          <path
            d="M9.54 20.41L11.08 21.95C6.3 21.54 2.47 17.76 2 13H0C0.64 20.7 8.21 25.67 15.43 23.48L10.95 19L9.54 20.41Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_2674">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconCampaign(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="campaign">
        <g id="Vector">
          <path
            d="M18 11C18 11.67 18 12.33 18 13C19.2 13 20.76 13 22 13C22 12.33 22 11.67 22 11C20.76 11 19.2 11 18 11Z"
            fill="currentColor"
          />
          <path
            d="M16 17.61C16.96 18.32 18.21 19.26 19.2 20C19.6 19.47 20 18.93 20.4 18.4C19.41 17.66 18.16 16.72 17.2 16C16.8 16.54 16.4 17.08 16 17.61Z"
            fill="currentColor"
          />
          <path
            d="M20.4 5.6C20 5.07 19.6 4.53 19.2 4C18.21 4.74 16.96 5.68 16 6.4C16.4 6.93 16.8 7.47 17.2 8C18.16 7.28 19.41 6.35 20.4 5.6Z"
            fill="currentColor"
          />
          <path
            d="M4 9C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V19H7V15H8L13 18V6L8 9H4ZM9.03 10.71L11 9.53V14.47L9.03 13.29L8.55 13H4V11H8.55L9.03 10.71Z"
            fill="currentColor"
          />
          <path
            d="M15.5 12C15.5 10.67 14.92 9.47 14 8.65V15.34C14.92 14.53 15.5 13.33 15.5 12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCancelFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cancel-filled">
        <path
          id="Vector"
          d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCancel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cancel">
        <path
          id="Vector"
          d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCancelPresentation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cancel_presentation">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM9.41 15.95L12 13.36L14.59 15.95L16 14.54L13.41 11.95L16 9.36L14.59 7.95L12 10.54L9.41 7.95L8 9.36L10.59 11.95L8 14.54L9.41 15.95Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCancelScheduleSend(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cancel_schedule_send">
        <g id="Vector">
          <path
            d="M16 7.5C15.58 7.5 15.17 7.54 14.76 7.61L0.51 1.5L0.5 8.5L10.56 9.84C10.14 10.28 9.78 10.77 9.47 11.3L0.5 12.5L0.51 19.5L8.58 16.04C9.09 19.69 12.21 22.5 16 22.5C20.14 22.5 23.5 19.14 23.5 15C23.5 10.86 20.14 7.5 16 7.5ZM2.5 6.75L2.51 4.53L10.02 7.75L2.5 6.75ZM8.6 13.86L2.5 16.47V14.25L8.67 13.43C8.64 13.57 8.62 13.71 8.6 13.86ZM16 20.5C12.97 20.5 10.5 18.03 10.5 15C10.5 11.97 12.97 9.5 16 9.5C19.03 9.5 21.5 11.97 21.5 15C21.5 18.03 19.03 20.5 16 20.5Z"
            fill="currentColor"
          />
          <path
            d="M17.77 12.53L16 14.29L14.23 12.53L13.53 13.23L15.29 15L13.53 16.77L14.23 17.47L16 15.71L17.77 17.47L18.47 16.77L16.71 15L18.47 13.23L17.77 12.53Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCandlestickChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="candlestick_chart">
        <g id="Vector">
          <path d="M9 4H7V6H5V18H7V20H9V18H11V6H9V4ZM9 16H7V8H9V16Z" fill="currentColor" />
          <path
            d="M19 8H17V4H15V8H13V15H15V20H17V15H19V8ZM17 13H15V10H17V13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCarCrash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="car_crash">
        <path
          id="Vector"
          d="M17 2.5C14.24 2.5 12 4.74 12 7.5C12 10.26 14.24 12.5 17 12.5C19.76 12.5 22 10.26 22 7.5C22 4.74 19.76 2.5 17 2.5ZM17.5 8.5H16.5V4.5H17.5V8.5ZM17.5 9.5V10.5H16.5V9.5H17.5ZM5 15C5 14.17 5.67 13.5 6.5 13.5C7.33 13.5 8 14.17 8 15C8 15.83 7.33 16.5 6.5 16.5C5.67 16.5 5 15.83 5 15ZM18 14.43C18.65 14.34 19.34 14.15 20 13.83V20.5C20 21.05 19.55 21.5 19 21.5H18C17.45 21.5 17 21.05 17 20.5V19.5H5V20.5C5 21.05 4.55 21.5 4 21.5H3C2.45 21.5 2 21.05 2 20.5V12.5L4.08 6.51C4.29 5.92 4.84 5.5 5.5 5.5H10.29C10.1 6.13 10 6.81 10 7.5H5.85L4.81 10.5H10.67C11.03 11.25 11.51 11.93 12.1 12.5H4V17.5H18V14.43ZM16.91 14.5C16.02 14.49 15.17 14.31 14.38 13.99C14.15 14.26 14 14.61 14 15C14 15.83 14.67 16.5 15.5 16.5C16.33 16.5 17 15.83 17 15C17 14.82 16.97 14.66 16.91 14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCarRental(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="car_rental">
        <g id="Vector">
          <path
            d="M9 18C9.55228 18 10 17.5523 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18Z"
            fill="currentColor"
          />
          <path
            d="M15 18C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18Z"
            fill="currentColor"
          />
          <path
            d="M17.25 10.1C17.23 10.08 17.22 10.06 17.2 10.03C16.82 9.51 16.28 9.5 16.28 9.5H7.72C7.72 9.5 7.18 9.51 6.8 10.04C6.78 10.06 6.77 10.08 6.75 10.1C6.68 10.21 6.61 10.34 6.56 10.5C6.34 11.16 5.82 12.72 5 15.19V21.69C5 22.14 5.35 22.5 5.78 22.5H6.22C6.65 22.5 7 22.14 7 21.69V20.5H17V21.69C17 22.14 17.34 22.5 17.78 22.5H18.22C18.65 22.5 19 22.14 19 21.69V15.19C18.18 12.73 17.66 11.16 17.44 10.5C17.39 10.34 17.32 10.21 17.25 10.1ZM8.33 11.5H15.67L15.9 12.19L16.33 13.5H7.67L8.33 11.5ZM17 18.5H7V15.5H17V18.5Z"
            fill="currentColor"
          />
          <path
            d="M10.83 3.5C10.41 2.33 9.3 1.5 8 1.5C6.34 1.5 5 2.84 5 4.5C5 6.15 6.34 7.5 8 7.5C9.3 7.5 10.41 6.66 10.83 5.5H16V7.5H18V5.5H19V3.5H10.83ZM8 5.5C7.45 5.5 7 5.05 7 4.5C7 3.95 7.45 3.5 8 3.5C8.55 3.5 9 3.95 9 4.5C9 5.05 8.55 5.5 8 5.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCarRepair(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="car_repair">
        <g id="Vector">
          <path
            d="M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z"
            fill="currentColor"
          />
          <path
            d="M15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11Z"
            fill="currentColor"
          />
          <path
            d="M5.78 15.5H6.22C6.65 15.5 7 15.14 7 14.69V13.5H17V14.69C17 15.14 17.34 15.5 17.78 15.5H18.22C18.65 15.5 19 15.14 19 14.69V8.19C19 8.19 17.66 4.16 17.44 3.5C17.39 3.34 17.32 3.21 17.25 3.1C17.23 3.08 17.22 3.06 17.2 3.03C16.82 2.51 16.28 2.5 16.28 2.5H7.72C7.72 2.5 7.18 2.51 6.8 3.04C6.78 3.06 6.77 3.08 6.75 3.1C6.68 3.21 6.61 3.34 6.56 3.5C6.34 4.16 5 8.19 5 8.19V14.69C5 15.14 5.35 15.5 5.78 15.5ZM8.33 4.5H15.67L15.9 5.19L16.33 6.5H7.67L8.33 4.5ZM7 8.5H17V11.5H7V8.5Z"
            fill="currentColor"
          />
          <path d="M4 16.51V18.5H11V21.5H13V18.5H20V16.51H4Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconCardGiftcard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="card_giftcard">
        <path
          id="Vector"
          d="M20 6.5H17.82C17.93 6.19 18 5.85 18 5.5C18 3.84 16.66 2.5 15 2.5C13.95 2.5 13.04 3.04 12.5 3.85L12 4.52L11.5 3.84C10.96 3.04 10.05 2.5 9 2.5C7.34 2.5 6 3.84 6 5.5C6 5.85 6.07 6.19 6.18 6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM15 4.5C15.55 4.5 16 4.95 16 5.5C16 6.05 15.55 6.5 15 6.5C14.45 6.5 14 6.05 14 5.5C14 4.95 14.45 4.5 15 4.5ZM9 4.5C9.55 4.5 10 4.95 10 5.5C10 6.05 9.55 6.5 9 6.5C8.45 6.5 8 6.05 8 5.5C8 4.95 8.45 4.5 9 4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H9.08L7 11.33L8.62 12.5L12 7.9L15.38 12.5L17 11.33L14.92 8.5H20V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCardMembership(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="card_membership">
        <path
          id="Vector"
          d="M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCardTravel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="card_travel">
        <path
          id="Vector"
          d="M20 6.5H17V4.5C17 3.39 16.11 2.5 15 2.5H9C7.89 2.5 7 3.39 7 4.5V6.5H4C2.89 6.5 2 7.39 2 8.5V19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM9 4.5H15V6.5H9V4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H7V10.5H9V8.5H15V10.5H17V8.5H20V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCarpenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="carpenter">
        <path
          id="Vector"
          d="M20.0179 14.5375L7.28795 1.8075L3.39795 5.69749L11.5279 17.3675C10.7479 18.1475 10.7479 19.4175 11.5279 20.1975L12.9379 21.6075C13.7179 22.3875 14.9879 22.3875 15.7679 21.6075L20.0079 17.3675C20.7979 16.5875 20.7979 15.3175 20.0179 14.5375ZM5.99795 5.9275L7.28795 4.6375L15.7779 13.1275L12.9679 15.9375L5.99795 5.9275ZM14.3579 20.1875L12.9479 18.7775L17.1879 14.5375L18.5979 15.9475L14.3579 20.1875Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCases(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cases">
        <g id="Vector">
          <path d="M3 9.5H1V20.5C1 21.61 1.89 22.5 3 22.5H20V20.5H3V9.5Z" fill="currentColor" />
          <path
            d="M18 5.5V3.5C18 2.4 17.1 1.5 16 1.5H12C10.9 1.5 10 2.4 10 3.5V5.5H5V16.5C5 17.6 5.9 18.5 7 18.5H21C22.1 18.5 23 17.6 23 16.5V5.5H18ZM12 3.5H16V5.5H12V3.5ZM21 16.5H7V7.5H21V16.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCasino(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="casino">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18Z"
            fill="currentColor"
          />
          <path
            d="M7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z"
            fill="currentColor"
          />
          <path
            d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
            fill="currentColor"
          />
          <path
            d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
            fill="currentColor"
          />
          <path
            d="M16.5 9C17.3284 9 18 8.32843 18 7.5C18 6.67157 17.3284 6 16.5 6C15.6716 6 15 6.67157 15 7.5C15 8.32843 15.6716 9 16.5 9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCast(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cast">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCastConnected(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cast_connected">
        <path
          id="Vector"
          d="M1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM5 7V9H17V15H14V17H19V7H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCastForEducation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cast_for_education">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM11 11.09V13.09L14.5 15L18 13.09V11.09L14.5 13L11 11.09ZM14.5 6L9 9L14.5 12L20 9L14.5 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCastle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="castle">
        <g id="Vector">
          <path
            d="M21 9V11H19V3H17V5H15V3H13V5H11V3H9V5H7V3H5V11H3V9H1V21H10V18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18V21H23V9H21ZM21 19H16V18C16 15.79 14.21 14 12 14C9.79 14 8 15.79 8 18V19H3V13H7V7H17V13H21V19Z"
            fill="currentColor"
          />
          <path d="M11 9H9V12H11V9Z" fill="currentColor" />
          <path d="M15 9H13V12H15V9Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconCatchingPokemon(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="catching_pokemon">
        <path
          id="Vector"
          d="M14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM20 12H16C16 9.79 14.21 8 12 8C9.79 8 8 9.79 8 12H4C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCategory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="category">
        <path
          id="Vector"
          d="M11.5 2L6 11H17L11.5 2ZM11.5 5.84L13.43 9H9.56L11.5 5.84ZM17 13C14.51 13 12.5 15.01 12.5 17.5C12.5 19.99 14.51 22 17 22C19.49 22 21.5 19.99 21.5 17.5C21.5 15.01 19.49 13 17 13ZM17 20C15.62 20 14.5 18.88 14.5 17.5C14.5 16.12 15.62 15 17 15C18.38 15 19.5 16.12 19.5 17.5C19.5 18.88 18.38 20 17 20ZM2.5 21.5H10.5V13.5H2.5V21.5ZM4.5 15.5H8.5V19.5H4.5V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCelebration(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="celebration">
        <g id="Vector">
          <path
            d="M1.22998 22.27L15.23 17.27L6.22998 8.27001L1.22998 22.27ZM11.58 16.45L4.52998 18.97L7.04998 11.92L11.58 16.45Z"
            fill="currentColor"
          />
          <path
            d="M13.76 12.8L19.35 7.21001C19.84 6.72001 20.63 6.72001 21.12 7.21001L21.71 7.80001L22.77 6.74001L22.18 6.15001C21.11 5.08001 19.36 5.08001 18.29 6.15001L12.7 11.74L13.76 12.8Z"
            fill="currentColor"
          />
          <path
            d="M9.28998 7.15001L8.69998 7.74001L9.75998 8.80001L10.35 8.21001C11.42 7.14001 11.42 5.39001 10.35 4.32001L9.75998 3.73001L8.69998 4.80001L9.28998 5.39001C9.76998 5.87001 9.76998 6.67001 9.28998 7.15001Z"
            fill="currentColor"
          />
          <path
            d="M16.29 12.15L14.7 13.74L15.76 14.8L17.35 13.21C17.84 12.72 18.63 12.72 19.12 13.21L20.73 14.82L21.79 13.76L20.18 12.15C19.1 11.08 17.36 11.08 16.29 12.15Z"
            fill="currentColor"
          />
          <path
            d="M14.29 6.15001L10.7 9.74001L11.76 10.8L15.35 7.21001C16.42 6.14001 16.42 4.39001 15.35 3.32001L13.76 1.73001L12.7 2.79001L14.29 4.38001C14.77 4.87001 14.77 5.67001 14.29 6.15001Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCellTower(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cell_tower">
        <g id="Vector">
          <path
            d="M7.3 14.25L8.5 13.05C7.5 12.05 7 10.75 7 9.54995C7 8.24995 7.5 6.94995 8.5 6.04995L7.3 4.84995C6 6.14995 5.3 7.84995 5.3 9.54995C5.3 11.25 6 12.95 7.3 14.25Z"
            fill="currentColor"
          />
          <path
            d="M19.1 2.44995L17.9 3.64995C19.5 5.24995 20.3 7.44995 20.3 9.54995C20.3 11.65 19.5 13.85 17.9 15.45L19.1 16.65C21.1 14.65 22 12.15 22 9.54995C22 6.94995 21 4.44995 19.1 2.44995Z"
            fill="currentColor"
          />
          <path
            d="M6.1 3.64995L4.9 2.44995C3 4.44995 2 6.94995 2 9.54995C2 12.15 3 14.65 4.9 16.65L6.1 15.45C4.5 13.85 3.7 11.65 3.7 9.54995C3.7 7.44995 4.5 5.24995 6.1 3.64995Z"
            fill="currentColor"
          />
          <path
            d="M16.7 14.25C18 12.95 18.7 11.25 18.7 9.54995C18.6 7.84995 18 6.14995 16.7 4.84995L15.5 6.04995C16.5 7.04995 17 8.34995 17 9.54995C17 10.85 16.5 12.15 15.5 13.05L16.7 14.25Z"
            fill="currentColor"
          />
          <path
            d="M14.5 9.54995C14.5 8.16995 13.38 7.04995 12 7.04995C10.62 7.04995 9.5 8.16995 9.5 9.54995C9.5 10.31 9.84 10.97 10.37 11.43L7 21.55H9L9.67 19.55H14.34L15 21.55H17L13.63 11.43C14.16 10.97 14.5 10.31 14.5 9.54995ZM10.33 17.55L12 12.55L13.67 17.55H10.33Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCellWifi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cell_wifi">
        <path
          id="Vector"
          d="M5.03509 21.5013H21.0351V5.47128L5.03509 21.5013ZM19.0351 19.5013H17.0351V12.2813L19.0351 10.2813V19.5013ZM4.25509 6.72128L2.96509 5.43128C6.86509 1.52128 13.2051 1.52128 17.1151 5.43128L15.8251 6.72128C12.6351 3.53128 7.44509 3.53128 4.25509 6.72128ZM11.9651 10.5713L10.0351 12.5013L8.10509 10.5713C9.17509 9.51128 10.8951 9.51128 11.9651 10.5713ZM13.2551 9.29128C11.4751 7.52128 8.59509 7.52128 6.82509 9.29128L5.53509 8.00128C8.01509 5.52128 12.0551 5.52128 14.5351 8.00128L13.2551 9.29128Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCenterFocusStrong(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="center_focus_strong">
        <path
          id="Vector"
          d="M17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15ZM5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCenterFocusWeak(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="center_focus_weak">
        <path
          id="Vector"
          d="M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChair(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chair">
        <path
          id="Vector"
          d="M20 8V6C20 4.35 18.65 3 17 3H7C5.35 3 4 4.35 4 6V8C2.35 8 1 9.35 1 11V16C1 17.65 2.35 19 4 19V20C4 20.55 4.45 21 5 21C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V19C21.65 19 23 17.65 23 16V11C23 9.35 21.65 8 20 8ZM6 6C6 5.45 6.45 5 7 5H17C17.55 5 18 5.45 18 6V8.78C17.39 9.33 17 10.12 17 11V13H7V11C7 10.12 6.61 9.33 6 8.78V6ZM21 16C21 16.55 20.55 17 20 17H4C3.45 17 3 16.55 3 16V11C3 10.45 3.45 10 4 10C4.55 10 5 10.45 5 11V15H19V11C19 10.45 19.45 10 20 10C20.55 10 21 10.45 21 11V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChairAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chair_alt">
        <path
          id="Vector"
          d="M17 10C18.1 10 19 9.1 19 8V5C19 3.9 18.1 3 17 3H7C5.9 3 5 3.9 5 5V8C5 9.1 5.9 10 7 10H8V12H7C5.9 12 5 12.9 5 14V21H7V18H17V21H19V14C19 12.9 18.1 12 17 12H16V10H17ZM7 8V5H17V8H7ZM17 16H7V14H17V16ZM14 12H10V10H14V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChalet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chalet">
        <path
          id="Vector"
          d="M17.25 15.5L9.75 8L2.25 15.5L3.66 16.91L4.75 15.83V20.5H14.75V15.83L15.84 16.92L17.25 15.5ZM12.75 18.5H10.75V15.5H8.75V18.5H6.75V13.83L9.75 10.83L12.75 13.83V18.5ZM21.75 8H20.56L21.31 8.75L20.6 9.46L19.14 8H18.25V8.89L19.7 10.34L18.99 11.05L18.25 10.31V11.5H17.25V10.31L16.5 11.06L15.79 10.35L17.24 8.9V8H16.35L14.9 9.45L14.19 8.74L14.94 7.99H13.75V6.99H14.94L14.19 6.24L14.9 5.53L16.35 6.98H17.24V6.11L15.79 4.66L16.5 3.95L17.25 4.7V3.5H18.25V4.69L19 3.94L19.71 4.65L18.25 6.11V7H19.14L20.59 5.55L21.3 6.26L20.56 7H21.75V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChangeCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="change_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.17 14.76L15.07 13.66C15.78 12.33 15.6 10.65 14.48 9.53C13.79 8.84 12.9 8.5 12 8.5C11.97 8.5 11.94 8.51 11.91 8.51L13 9.6L11.94 10.66L9.11 7.83L11.94 5L13 6.06L12.04 7.02C13.31 7.03 14.57 7.5 15.54 8.46C17.24 10.17 17.45 12.82 16.17 14.76ZM14.89 16.17L12.06 19L11 17.94L11.95 16.99C10.69 16.98 9.43 16.49 8.47 15.53C6.76 13.82 6.55 11.18 7.83 9.24L8.93 10.34C8.22 11.67 8.4 13.35 9.52 14.47C10.22 15.17 11.15 15.51 12.08 15.48L11 14.4L12.06 13.34L14.89 16.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChangeHistory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="change_history">
        <path
          id="Vector"
          d="M12 7.77L18.39 18H5.61L12 7.77ZM12 4L2 20H22L12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChargingStation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="charging_station">
        <path
          id="Vector"
          d="M14.5 11L11.5 17V13H9.5L12.5 7V11H14.5ZM17 3H7V4H17V3ZM17 20H7V21H17V20ZM17 1C18.1 1 19 1.9 19 3V21C19 22.1 18.1 23 17 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1H17ZM7 18H17V6H7V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chat">
        <path
          id="Vector"
          d="M4 4H20V16H5.17L4 17.17V4ZM4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM6 12H14V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChatBubble(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chat_bubble">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChatBubbleOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chat_bubble_outline">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check">
        <path
          id="Vector"
          d="M8.79508 15.875L4.62508 11.705L3.20508 13.115L8.79508 18.705L20.7951 6.70504L19.3851 5.29504L8.79508 15.875Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCheckBox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check_box">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17.99 9L16.58 7.58L9.99 14.17L7.41 11.6L5.99 13.01L9.99 17L17.99 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCheckBoxOutlineBlank(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check_box_outline_blank">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCheckCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCheckCircleBorder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check_circle_border">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChecklist(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="checklist">
        <path
          id="Vector"
          d="M22 7.53497H13V9.53497H22V7.53497ZM22 15.535H13V17.535H22V15.535ZM5.54 11.535L2 7.99497L3.41 6.58497L5.53 8.70497L9.77 4.46497L11.18 5.87497L5.54 11.535ZM5.54 19.535L2 15.995L3.41 14.585L5.53 16.705L9.77 12.465L11.18 13.875L5.54 19.535Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChecklistRtl(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="checklist_rtl">
        <path
          id="Vector"
          d="M11 7.53497H2V9.53497H11V7.53497ZM11 15.535H2V17.535H11V15.535ZM16.34 11.535L12.8 7.99497L14.21 6.58497L16.33 8.70497L20.57 4.46497L22 5.87497L16.34 11.535ZM16.34 19.535L12.8 15.995L14.21 14.585L16.33 16.705L20.57 12.465L22 13.875L16.34 19.535Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCheckroom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="checkroom">
        <path
          id="Vector"
          d="M21.5998 18.2015L12.9998 11.7515V10.8415C14.6498 10.3515 15.7998 8.67155 15.4298 6.79155C15.1698 5.48155 14.1298 4.39155 12.8198 4.09155C10.5398 3.57155 8.49977 5.30155 8.49977 7.50155H10.4998C10.4998 6.67155 11.1698 6.00155 11.9998 6.00155C12.8298 6.00155 13.4998 6.67155 13.4998 7.50155C13.4998 8.34155 12.8098 9.02155 11.9698 9.00155C11.4298 8.99155 10.9998 9.45155 10.9998 9.99155V11.7515L2.39977 18.2015C1.62977 18.7815 2.03977 20.0015 2.99977 20.0015H20.9998C21.9598 20.0015 22.3698 18.7815 21.5998 18.2015ZM5.99977 18.0015L11.9998 13.5015L17.9998 18.0015H5.99977Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChevronLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chevron_left">
        <path
          id="Vector"
          d="M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChevronRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chevron_right">
        <path
          id="Vector"
          d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChildCare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="child_care">
        <g id="Vector">
          <path
            d="M14.5 11.75C15.1904 11.75 15.75 11.1904 15.75 10.5C15.75 9.80964 15.1904 9.25 14.5 9.25C13.8096 9.25 13.25 9.80964 13.25 10.5C13.25 11.1904 13.8096 11.75 14.5 11.75Z"
            fill="currentColor"
          />
          <path
            d="M9.5 11.75C10.1904 11.75 10.75 11.1904 10.75 10.5C10.75 9.80964 10.1904 9.25 9.5 9.25C8.80964 9.25 8.25 9.80964 8.25 10.5C8.25 11.1904 8.80964 11.75 9.5 11.75Z"
            fill="currentColor"
          />
          <path
            d="M22.94 11.34C22.69 9.83 21.58 8.6 20.13 8.17C19.6 7.05 18.85 6.07 17.94 5.26C16.36 3.85 14.28 3 12 3C9.72 3 7.64 3.85 6.06 5.26C5.14 6.07 4.39 7.06 3.87 8.17C2.42 8.6 1.31 9.82 1.06 11.34C1.02 11.55 1 11.77 1 12C1 12.23 1.02 12.45 1.06 12.66C1.31 14.17 2.42 15.4 3.87 15.83C4.39 16.94 5.14 17.92 6.04 18.72C7.62 20.14 9.71 21 12 21C14.29 21 16.38 20.14 17.97 18.72C18.87 17.92 19.62 16.93 20.14 15.83C21.58 15.4 22.69 14.18 22.94 12.66C22.98 12.45 23 12.23 23 12C23 11.77 22.98 11.55 22.94 11.34ZM19 14C18.9 14 18.81 13.98 18.71 13.97C18.51 14.64 18.22 15.26 17.85 15.83C16.6 17.74 14.45 19 12 19C9.55 19 7.4 17.74 6.15 15.83C5.78 15.26 5.49 14.64 5.29 13.97C5.19 13.98 5.1 14 5 14C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10C5.1 10 5.19 10.02 5.29 10.03C5.49 9.36 5.78 8.74 6.15 8.17C7.4 6.26 9.55 5 12 5C14.45 5 16.6 6.26 17.85 8.17C18.22 8.74 18.51 9.36 18.71 10.03C18.81 10.02 18.9 10 19 10C20.1 10 21 10.9 21 12C21 13.1 20.1 14 19 14ZM12 17C14.01 17 15.74 15.77 16.5 14H7.5C8.26 15.77 9.99 17 12 17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconChildFriendly(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="child_friendly">
        <path
          id="Vector"
          d="M13.5 2V10H21.5C21.5 5.58 17.92 2 13.5 2ZM15.5 8V4.34C17.2 4.94 18.55 6.29 19.16 8H15.5ZM6.94 11L5.99 9H2.5V11H4.72C4.72 11 6.61 15.07 6.84 15.42C5.74 16.01 5 17.17 5 18.5C5 20.43 6.57 22 8.5 22C10.26 22 11.72 20.7 11.96 19H14.04C14.28 20.7 15.74 22 17.5 22C19.43 22 21 20.43 21 18.5C21 17.46 20.54 16.53 19.82 15.89C20.87 14.54 21.5 12.84 21.5 11H6.94ZM8.5 20C7.67 20 7 19.33 7 18.5C7 17.67 7.67 17 8.5 17C9.33 17 10 17.67 10 18.5C10 19.33 9.33 20 8.5 20ZM17.5 20C16.67 20 16 19.33 16 18.5C16 17.67 16.67 17 17.5 17C18.33 17 19 17.67 19 18.5C19 19.33 18.33 20 17.5 20ZM18.24 14.66L17.95 15.03C17.81 15.01 17.65 15 17.5 15C16.11 15 14.9 15.82 14.34 17H11.66C11.16 15.96 10.16 15.2 8.98 15.03L8.54 14.36C8.44 14.19 8.2 13.67 7.87 13H19.16C18.95 13.59 18.64 14.15 18.24 14.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChromeReaderMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chrome_reader_mode">
        <path
          id="Vector"
          d="M21 3.5H3C1.9 3.5 1 4.4 1 5.5V18.5C1 19.6 1.9 20.5 3 20.5H21C22.1 20.5 23 19.6 23 18.5V5.5C23 4.4 22.1 3.5 21 3.5ZM3 18.5V5.5H11V18.5H3ZM21 18.5H13V5.5H21V18.5ZM14 9H20V10.5H14V9ZM14 11.5H20V13H14V11.5ZM14 14H20V15.5H14V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconChurch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="church">
        <g id="Vector">
          <path
            d="M18 12.72V9.5L13 7V5.5H15V3.5H13V1.5H11V3.5H9V5.5H11V7L6 9.5V12.72L2 14.5V22.5H11V18.5C11 17.95 11.45 17.5 12 17.5C12.55 17.5 13 17.95 13 18.5V22.5H22V14.5L18 12.72ZM20 20.5H15V18.46C15 16.77 13.65 15.4 12 15.4C10.35 15.4 9 16.77 9 18.46V20.5H4V15.71L8 13.9V10.55L12 8.5L16 10.54V13.89L20 15.7V20.5Z"
            fill="currentColor"
          />
          <path
            d="M12 14C12.8284 14 13.5 13.3284 13.5 12.5C13.5 11.6716 12.8284 11 12 11C11.1716 11 10.5 11.6716 10.5 12.5C10.5 13.3284 11.1716 14 12 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="circle">
        <path
          id="Vector"
          d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCircleNotifications(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="circle_notifications">
        <path
          id="Vector"
          d="M12 18.5C12.83 18.5 13.5 17.83 13.5 17H10.5C10.5 17.83 11.17 18.5 12 18.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16 11.39C16 9.28 14.97 7.47 13 7V6.5C13 5.93 12.57 5.5 12 5.5C11.43 5.5 11 5.93 11 6.5V7C9.03 7.47 8 9.27 8 11.39V14H7V16H17V14H16V11.39ZM14 14H10V11C10 9.9 10.9 9 12 9C13.1 9 14 9.9 14 11V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClass(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="class">
        <path
          id="Vector"
          d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 4H11V9L10 8.25L9 9V4ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCleanHands(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="clean_hands">
        <path
          id="Vector"
          d="M17.49 4.75L18.12 6.12L19.49 6.75L18.12 7.38L17.49 8.75L16.86 7.38L15.49 6.75L16.86 6.12L17.49 4.75ZM20.5 13.75C21.6 13.75 22.5 12.85 22.5 11.75C22.5 10.65 20.5 7.75 20.5 7.75C20.5 7.75 18.5 10.65 18.5 11.75C18.5 12.85 19.4 13.75 20.5 13.75ZM11.5 5.85V3.75H13.5C14.07 3.75 14.6 3.92 15.05 4.2L16.48 2.77C15.65 2.14 14.63 1.75 13.5 1.75C12.03 1.75 8.06 1.75 8 1.75V3.75H9.5V5.86C7.72 6.23 6.3 7.54 5.75 9.25H7.91C8.44 8.36 9.39 7.75 10.5 7.75C12.12 7.75 13.44 9.04 13.49 10.65L15.5 11.4V10.75C15.5 8.33 13.78 6.31 11.5 5.85ZM22.5 18.75V19.75L14.5 22.25L7.5 20.31V21.75H1.5V10.75H9.47L15.63 13.05C16.75 13.47 17.5 14.55 17.5 15.75H19.5C21.16 15.75 22.5 17.09 22.5 18.75ZM5.5 19.75V12.75H3.5V19.75H5.5ZM20.4 18.32C20.24 17.99 19.89 17.76 19.5 17.76H14.15C13.61 17.76 13.08 17.67 12.57 17.5L10.19 16.71L10.82 14.81L13.2 15.6C13.51 15.7 15.5 15.75 15.5 15.75C15.5 15.38 15.27 15.05 14.93 14.92L9.11 12.75H7.5V18.23L14.47 20.16L20.4 18.32Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCleaningServices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cleaning_services">
        <path
          id="Vector"
          d="M16 11H15V3C15 1.9 14.1 1 13 1H11C9.9 1 9 1.9 9 3V11H8C5.24 11 3 13.24 3 16V23H21V16C21 13.24 18.76 11 16 11ZM11 3H13V11H11V3ZM19 21H17V18C17 17.45 16.55 17 16 17C15.45 17 15 17.45 15 18V21H13V18C13 17.45 12.55 17 12 17C11.45 17 11 17.45 11 18V21H9V18C9 17.45 8.55 17 8 17C7.45 17 7 17.45 7 18V21H5V16C5 14.35 6.35 13 8 13H16C17.65 13 19 14.35 19 16V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClearAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="clear_all">
        <path
          id="Vector"
          d="M5 13H19V11H5V13ZM3 17H17V15H3V17ZM7 7V9H21V7H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClose(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="close">
        <path
          id="Vector"
          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloseFullscreen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="close_fullscreen">
        <path
          id="Vector"
          d="M22 3.41L16.71 8.7L20 12H12V4L15.29 7.29L20.59 2L22 3.41ZM3.41 22L8.7 16.71L12 20V12H4L7.29 15.29L2 20.59L3.41 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClosedCaption(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="closed_caption">
        <path
          id="Vector"
          d="M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18ZM7 15H10C10.55 15 11 14.55 11 14V13H9.5V13.5H7.5V10.5H9.5V11H11V10C11 9.45 10.55 9 10 9H7C6.45 9 6 9.45 6 10V14C6 14.55 6.45 15 7 15ZM14 15H17C17.55 15 18 14.55 18 14V13H16.5V13.5H14.5V10.5H16.5V11H18V10C18 9.45 17.55 9 17 9H14C13.45 9 13 9.45 13 10V14C13 14.55 13.45 15 14 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClosedCaptionDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="closed_caption_disabled">
        <path
          id="Vector"
          d="M13.715 9.29001C13.715 8.74001 14.165 8.29001 14.715 8.29001H17.715C18.265 8.29001 18.715 8.74001 18.715 9.29001V10.29H17.215V9.79001H15.215V10.79L13.715 9.29001ZM17.215 12.79L18.425 14C18.605 13.81 18.715 13.56 18.715 13.29V12.29H17.215V12.79ZM9.54498 5.29001H19.715V15.46L21.695 17.44C21.695 17.39 21.715 17.34 21.715 17.28V5.29001C21.715 4.19001 20.815 3.29001 19.715 3.29001H7.54498L9.54498 5.29001ZM20.495 21.9L17.885 19.29H5.71498C4.60498 19.29 3.71498 18.39 3.71498 17.29V5.29001C3.71498 5.24001 3.73498 5.19001 3.73498 5.14001L2.10498 3.51001L3.51498 2.10001L21.895 20.48L20.495 21.9ZM8.21498 12.79H10.215V12.29H10.885L8.38498 9.79001H8.21498V12.79ZM15.885 17.29L11.715 13.12V13.29C11.715 13.84 11.265 14.29 10.715 14.29H7.71498C7.16498 14.29 6.71498 13.84 6.71498 13.29V9.29001C6.71498 8.97001 6.87498 8.70001 7.11498 8.51001L5.71498 7.12001V17.29H15.885Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClosedCaptionOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="closed_caption_off">
        <g id="Vector">
          <path
            d="M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18Z"
            fill="currentColor"
          />
          <path
            d="M7 15H10C10.55 15 11 14.55 11 14V13H9.5V13.5H7.5V10.5H9.5V11H11V10C11 9.45 10.55 9 10 9H7C6.45 9 6 9.45 6 10V14C6 14.55 6.45 15 7 15Z"
            fill="currentColor"
          />
          <path
            d="M14 15H17C17.55 15 18 14.55 18 14V13H16.5V13.5H14.5V10.5H16.5V11H18V10C18 9.45 17.55 9 17 9H14C13.45 9 13 9.45 13 10V14C13 14.55 13.45 15 14 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCloud(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud">
        <path
          id="Vector"
          d="M12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6ZM12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04C18.67 6.59 15.64 4 12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloudCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.29 10.19C15.89 8.18 14.13 6.67 12 6.67C10.31 6.67 8.85 7.63 8.12 9.03C6.36 9.21 5 10.7 5 12.5C5 14.43 6.57 16 8.5 16H16.08C17.69 16 19 14.69 19 13.08C19 11.54 17.8 10.29 16.29 10.19ZM16 14H8.5C7.67 14 7 13.33 7 12.5C7 11.67 7.67 11 8.5 11H9.4L9.89 9.95C10.3 9.16 11.11 8.67 12 8.67C13.13 8.67 14.11 9.47 14.33 10.58L14.61 12H16C16.55 12 17 12.45 17 13C17 13.55 16.55 14 16 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloudDone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud_done">
        <path
          id="Vector"
          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18ZM10 14.18L7.91 12.09L6.5 13.5L10 17L16.01 10.99L14.6 9.58L10 14.18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloudDownload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud_download">
        <path
          id="Vector"
          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18ZM13.45 10H10.55V13H8L12 17L16 13H13.45V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloudOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud_off">
        <path
          id="Vector"
          d="M24 14.0701C24 11.4301 21.95 9.29005 19.35 9.11005C18.67 5.66005 15.64 3.07005 12 3.07005C10.67 3.07005 9.43 3.43005 8.35 4.04005L9.84 5.53005C10.51 5.24005 11.23 5.07005 12 5.07005C15.04 5.07005 17.5 7.53005 17.5 10.5701V11.0701H19C20.66 11.0701 22 12.4101 22 14.0701C22 15.0601 21.52 15.9201 20.79 16.4701L22.2 17.8801C23.29 16.9601 24 15.6101 24 14.0701ZM4.41 2.93005L3 4.34005L5.77 7.11005H5.35C2.34 7.43005 0 9.98005 0 13.0701C0 16.3801 2.69 19.0701 6 19.0701H17.73L19.73 21.0701L21.14 19.6601L4.41 2.93005ZM6 17.0701C3.79 17.0701 2 15.2801 2 13.0701C2 10.8601 3.79 9.07005 6 9.07005H7.73L15.73 17.0701H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloudSync(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud_sync">
        <path
          id="Vector"
          d="M19.5 14.98C19.48 14.98 19.47 14.98 19.45 14.99C19.2 13.3 17.76 12 16 12C14.6 12 13.4 12.83 12.84 14.02C11.26 14.1 10 15.4 10 17C10 18.66 11.34 20 13 20L19.5 19.98C20.88 19.98 22 18.86 22 17.48C22 16.1 20.88 14.98 19.5 14.98ZM19.51 18H13C12.45 18 12 17.55 12 17C12 16.45 12.45 16 13 16H14.25V15.75C14.25 14.78 15.03 14 16 14C16.97 14 17.75 14.78 17.75 15.75V17C17.75 17 19.5 17 19.51 17C19.79 17 20.01 17.22 20.01 17.5C20 17.77 19.78 18 19.51 18ZM8 4.26V6.35C5.67 7.18 4 9.39 4 12C4 13.77 4.78 15.34 6 16.44V14H8V20H2V18H4.73C3.06 16.54 2 14.4 2 12C2 8.27 4.55 5.15 8 4.26ZM18 6H15.27C16.7 7.26 17.68 9.01 17.93 11H15.91C15.68 9.64 14.98 8.45 14 7.56V10H12V4H18V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCloudUpload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cloud_upload">
        <path
          id="Vector"
          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18ZM8 13H10.55V16H13.45V13H16L12 9L8 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClubhouseMenu(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="clubhouse_menu">
        <path
          id="Union"
          d="M6.375 3.75C6.5726 3.75 6.73691 3.78778 6.85449 3.82129C7.12101 3.89728 7.32858 4.04285 7.44238 4.12598C7.56448 4.21517 7.70656 4.33163 7.85156 4.4502L7.87109 4.46582C8.41621 4.91149 8.99569 5.21274 9.77832 5.38477L9.80957 5.3916C10.2195 5.48169 10.5728 5.5594 10.8496 5.63672C11.115 5.71084 11.4532 5.82051 11.7422 6.03613C11.9087 6.16036 12.0765 6.30782 12.2275 6.50391C12.3777 6.69904 12.478 6.89951 12.5566 7.09082C12.6804 7.39197 12.718 7.6951 12.7344 7.95898C12.7501 8.21342 12.75 8.5229 12.75 8.86816V11.5352C12.75 13.6339 11.6701 15.3643 10.541 16.6074C9.40346 17.8598 8.10735 18.7397 7.42383 19.1611C7.41533 19.1664 7.4056 19.1724 7.39551 19.1787C7.27813 19.2521 7.05493 19.3925 6.76172 19.459C6.51846 19.5141 6.23154 19.5141 5.98828 19.459C5.69508 19.3925 5.47187 19.2521 5.35449 19.1787C5.34441 19.1724 5.33467 19.1664 5.32617 19.1611C4.64265 18.7397 3.34653 17.8598 2.20898 16.6074C1.07989 15.3643 0 13.6339 0 11.5352V8.86816C-1.44837e-05 8.52289 -0.000134056 8.21343 0.015625 7.95898C0.0319837 7.6951 0.069619 7.39197 0.193359 7.09082C0.271975 6.89951 0.372273 6.69904 0.522461 6.50391C0.673473 6.30782 0.841337 6.16036 1.00781 6.03613C1.2968 5.8205 1.63503 5.71084 1.90039 5.63672C2.17721 5.5594 2.53051 5.48169 2.94043 5.3916L2.97168 5.38477C3.75431 5.21274 4.33379 4.91149 4.87891 4.46582C4.88537 4.46054 4.89199 4.45547 4.89844 4.4502C5.04344 4.33163 5.18552 4.21517 5.30762 4.12598C5.42142 4.04285 5.62899 3.89728 5.89551 3.82129C6.01309 3.78778 6.1774 3.75 6.375 3.75ZM24 18.3203H11.4727C11.5988 18.1974 11.7248 18.0719 11.8486 17.9424C12.3128 17.4565 12.7685 16.9091 13.1729 16.3066H24V18.3203ZM6.30371 6.20801C5.49713 6.86744 4.59765 7.33086 3.45508 7.58203C3.00518 7.68092 2.71436 7.74548 2.50586 7.80371C2.40076 7.83307 2.34601 7.85377 2.32422 7.8623C2.31531 7.8695 2.30843 7.87454 2.30469 7.87793C2.29998 7.88669 2.29174 7.90413 2.2793 7.93359C2.27654 7.94706 2.26816 7.99464 2.26172 8.09863C2.25082 8.27486 2.25 8.51303 2.25 8.89941V11.5352C2.25 12.8407 2.92675 14.0518 3.87402 15.0947C4.74664 16.0555 5.75902 16.7722 6.375 17.1631C6.99098 16.7722 8.00336 16.0555 8.87598 15.0947C9.82325 14.0518 10.5 12.8407 10.5 11.5352V8.89941C10.5 8.51303 10.4992 8.27486 10.4883 8.09863C10.4818 7.99463 10.4735 7.94705 10.4707 7.93359C10.4583 7.90412 10.45 7.88668 10.4453 7.87793C10.4416 7.87454 10.4347 7.8695 10.4258 7.8623C10.404 7.85377 10.3492 7.83306 10.2441 7.80371C10.0356 7.74548 9.74481 7.68092 9.29492 7.58203C8.15235 7.33086 7.25286 6.86744 6.44629 6.20801C6.42104 6.18736 6.39741 6.16771 6.375 6.14941C6.35259 6.16771 6.32897 6.18736 6.30371 6.20801ZM24.002 13.2871H14.4834C14.5748 12.8387 14.6269 12.3734 14.627 11.8916V11.2734H24.002V13.2871ZM24.002 8.25391H14.626C14.6247 7.98456 14.6211 7.74218 14.6074 7.53223C14.5868 7.2166 14.5409 6.87156 14.3955 6.53516C14.3528 6.43642 14.3043 6.33831 14.25 6.24023H24.002V8.25391Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconClubhouseMenuFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="clubhouse_menu_filled">
        <path
          id="Union"
          d="M6.375 3.75C6.5726 3.75 6.73691 3.78778 6.85449 3.82129C7.12101 3.89728 7.32858 4.04285 7.44238 4.12598C7.56448 4.21517 7.70656 4.33163 7.85156 4.4502L7.87109 4.46582C8.41621 4.91149 8.99569 5.21274 9.77832 5.38477L9.80957 5.3916C10.2195 5.48169 10.5728 5.5594 10.8496 5.63672C11.115 5.71084 11.4532 5.82051 11.7422 6.03613C11.9087 6.16036 12.0765 6.30782 12.2275 6.50391C12.3777 6.69904 12.478 6.89951 12.5566 7.09082C12.6804 7.39197 12.718 7.6951 12.7344 7.95898C12.7501 8.21342 12.75 8.5229 12.75 8.86816V11.5352C12.75 13.6339 11.6701 15.3643 10.541 16.6074C9.40346 17.8598 8.10735 18.7397 7.42383 19.1611C7.41533 19.1664 7.4056 19.1724 7.39551 19.1787C7.27813 19.2521 7.05493 19.3925 6.76172 19.459C6.51846 19.5141 6.23154 19.5141 5.98828 19.459C5.69508 19.3925 5.47187 19.2521 5.35449 19.1787C5.34441 19.1724 5.33467 19.1664 5.32617 19.1611C4.64265 18.7397 3.34653 17.8598 2.20898 16.6074C1.07989 15.3643 0 13.6339 0 11.5352V8.86816C-1.44837e-05 8.52289 -0.000134056 8.21343 0.015625 7.95898C0.0319837 7.6951 0.069619 7.39197 0.193359 7.09082C0.271975 6.89951 0.372273 6.69904 0.522461 6.50391C0.673473 6.30782 0.841337 6.16036 1.00781 6.03613C1.2968 5.8205 1.63503 5.71084 1.90039 5.63672C2.17721 5.5594 2.53051 5.48169 2.94043 5.3916L2.97168 5.38477C3.75431 5.21274 4.33379 4.91149 4.87891 4.46582C4.88537 4.46054 4.89199 4.45547 4.89844 4.4502C5.04344 4.33163 5.18552 4.21517 5.30762 4.12598C5.42142 4.04285 5.62899 3.89728 5.89551 3.82129C6.01309 3.78778 6.1774 3.75 6.375 3.75ZM24 18.3203H11.4727C11.5988 18.1974 11.7248 18.0719 11.8486 17.9424C12.3128 17.4565 12.7685 16.9091 13.1729 16.3066H24V18.3203ZM24.002 13.2871H14.4834C14.5748 12.8387 14.6269 12.3734 14.627 11.8916V11.2734H24.002V13.2871ZM24.002 8.25391H14.626C14.6247 7.98456 14.6211 7.74218 14.6074 7.53223C14.5868 7.2166 14.5409 6.87156 14.3955 6.53516C14.3528 6.43642 14.3043 6.33831 14.25 6.24023H24.002V8.25391Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCo2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="co2">
        <path
          id="Vector"
          d="M13.75 7.5H10.75C10.2 7.5 9.75 7.95 9.75 8.5V12.5C9.75 13.05 10.2 13.5 10.75 13.5H13.75C14.3 13.5 14.75 13.05 14.75 12.5V8.5C14.75 7.95 14.3 7.5 13.75 7.5ZM13.25 12H11.25V9H13.25V12ZM7.75 11.5V12.5C7.75 13.05 7.3 13.5 6.75 13.5H3.75C3.2 13.5 2.75 13.05 2.75 12.5V8.5C2.75 7.95 3.2 7.5 3.75 7.5H6.75C7.3 7.5 7.75 7.95 7.75 8.5V9.5H6.25V9H4.25V12H6.25V11.5H7.75ZM20.25 14H18.25V15H21.25V16.5H16.75V14C16.75 13.45 17.2 13 17.75 13H19.75V12H16.75V10.5H20.25C20.8 10.5 21.25 10.95 21.25 11.5V13C21.25 13.55 20.8 14 20.25 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCoPresent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="co_present">
        <g id="Vector">
          <path
            d="M21 2.5H3C1.9 2.5 1 3.4 1 4.5V12.5H3V4.5H21V20.5C22.1 20.5 23 19.6 23 18.5V4.5C23 3.4 22.1 2.5 21 2.5Z"
            fill="currentColor"
          />
          <path
            d="M13 9.5C13 7.29 11.21 5.5 9 5.5C6.79 5.5 5 7.29 5 9.5C5 11.71 6.79 13.5 9 13.5C11.21 13.5 13 11.71 13 9.5ZM7 9.5C7 8.4 7.9 7.5 9 7.5C10.1 7.5 11 8.4 11 9.5C11 10.6 10.1 11.5 9 11.5C7.9 11.5 7 10.6 7 9.5Z"
            fill="currentColor"
          />
          <path
            d="M15.39 16.06C13.71 15.2 11.53 14.5 9 14.5C6.47 14.5 4.29 15.2 2.61 16.06C1.61 16.57 1 17.6 1 18.72V21.5H17V18.72C17 17.6 16.39 16.57 15.39 16.06ZM15 19.5H3C3 18.78 2.9 18.16 3.52 17.84C4.71 17.23 6.63 16.5 9 16.5C11.37 16.5 13.29 17.23 14.48 17.84C15.11 18.16 15 18.79 15 19.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="code">
        <path
          id="Vector"
          d="M9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6ZM14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCodeOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="code_off">
        <path
          id="Vector"
          d="M19.4749 11.29L14.8949 6.69998L16.3049 5.28998L22.3049 11.29L18.7149 14.88L17.3049 13.46L19.4749 11.29ZM1.69495 3.50998L5.88495 7.69998L2.30495 11.29L8.30495 17.29L9.71495 15.88L5.13495 11.29L7.30495 9.11998L20.0849 21.9L21.4949 20.49L3.11495 2.09998L1.69495 3.50998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCoffee(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="coffee">
        <path
          id="Vector"
          d="M17.5 3H5C3.9 3 3 3.9 3 5V10.71C3 14.54 5.95 17.89 9.78 18C13.74 18.12 17 14.94 17 11V10H17.5C19.43 10 21 8.43 21 6.5C21 4.57 19.43 3 17.5 3ZM15 5V8H5V5H15ZM15 10V11C15 13.76 12.76 16 10 16C7.24 16 5 13.76 5 11V10M17.5 8H17V5H17.5C18.33 5 19 5.67 19 6.5C19 7.33 18.33 8 17.5 8ZM3 19H19V21H3V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCoffeeMaker(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="coffee_maker">
        <g id="Vector">
          <path
            d="M18 6V4H20V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H20V20H15.97C17.2 19.09 18 17.64 18 16V11H8V16C8 17.64 8.81 19.09 10.03 20H6V4H8V6C8 6.55 8.45 7 9 7H17C17.55 7 18 6.55 18 6ZM10 16V13H16V16C16 17.65 14.65 19 13 19C11.35 19 10 17.65 10 16Z"
            fill="currentColor"
          />
          <path
            d="M13 10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCollapseContent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="collapse_content">
        <path id="Vector" d="M11 13V19H9V15H5V13H11ZM15 5V9H19V11H13V5H15Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconCollections(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="collections">
        <path
          id="Vector"
          d="M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCollectionsBookmark(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="collections_bookmark">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM17 4V9L16 8.25L15 9V4H17ZM20 16H8V4H13V13L16 10.75L19 13V4H20V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconColorLens(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="color_lens">
        <g id="Vector">
          <path
            d="M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.04 22 11C22 14.31 19.31 17 16 17H14.23C13.95 17 13.73 17.22 13.73 17.5C13.73 17.62 13.78 17.73 13.86 17.83C14.27 18.3 14.5 18.89 14.5 19.5C14.5 20.88 13.38 22 12 22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C12.28 20 12.5 19.78 12.5 19.5C12.5 19.34 12.42 19.22 12.36 19.15C11.95 18.69 11.73 18.1 11.73 17.5C11.73 16.12 12.85 15 14.23 15H16C18.21 15 20 13.21 20 11C20 7.14 16.41 4 12 4Z"
            fill="currentColor"
          />
          <path
            d="M6.5 13C7.32843 13 8 12.3284 8 11.5C8 10.6716 7.32843 10 6.5 10C5.67157 10 5 10.6716 5 11.5C5 12.3284 5.67157 13 6.5 13Z"
            fill="currentColor"
          />
          <path
            d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z"
            fill="currentColor"
          />
          <path
            d="M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z"
            fill="currentColor"
          />
          <path
            d="M17.5 13C18.3284 13 19 12.3284 19 11.5C19 10.6716 18.3284 10 17.5 10C16.6716 10 16 10.6716 16 11.5C16 12.3284 16.6716 13 17.5 13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconColorize(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="colorize">
        <path
          id="Vector"
          d="M17.6593 5.41L18.5793 6.33L15.8893 9.02L14.9693 8.1L17.6593 5.41ZM17.6693 3C17.4093 3 17.1593 3.1 16.9593 3.29L13.8393 6.41L11.9093 4.5L10.4993 5.91L11.9193 7.33L2.99927 16.25V21H7.74927L16.6693 12.08L18.0893 13.5L19.4993 12.09L17.5793 10.17L20.6993 7.05C21.0993 6.65 21.0993 6.02 20.7093 5.63L18.3693 3.29C18.1693 3.1 17.9193 3 17.6693 3ZM6.91927 19L4.99927 17.08L13.0593 9.02L14.9793 10.94L6.91927 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconComment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="comment">
        <path
          id="Vector"
          d="M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4ZM20 4V17.17L18.83 16H4V4H20ZM6 12H18V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCommentBank(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="comment_bank">
        <g id="Vector">
          <path d="M18 14V6H13V14L15.5 12.5L18 14Z" fill="currentColor" />
          <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCommentsDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="comments_disabled">
        <path
          id="Vector"
          d="M19.485 15.345H20.655V3.34497H7.48497L5.48497 1.34497H20.655C21.755 1.34497 22.655 2.24497 22.655 3.34497V18.515L19.485 15.345ZM18.655 5.34497H9.48497L11.485 7.34497H18.655V5.34497ZM18.655 8.34497H12.485L14.485 10.345H18.655V8.34497ZM18.655 13.345V11.345H15.485L17.485 13.345H18.655ZM22.555 21.245L21.145 22.655L15.825 17.345H4.65497C3.55497 17.345 2.65497 16.445 2.65497 15.345V4.17497L1.34497 2.85497L2.75497 1.44497L22.555 21.245ZM13.825 15.345L11.825 13.345H6.65497V11.345H9.82497L8.82497 10.345H6.65497V8.34497H6.82497L4.65497 6.17497V15.345H13.825Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCommit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="commit">
        <path
          id="Vector"
          d="M16.9 11C16.44 8.72 14.42 7 12 7C9.58 7 7.56 8.72 7.1 11H2V13H7.1C7.56 15.28 9.58 17 12 17C14.42 17 16.44 15.28 16.9 13H22V11H16.9ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCommute(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="commute">
        <path
          id="Vector"
          d="M12 4H5C3.34 4 2 5.34 2 7V15C2 16.66 3.34 18 5 18L4 19V20H5L7 18H9V13H4V6H13V8H15V7C15 5.34 13.66 4 12 4ZM5 14C5.55 14 6 14.45 6 15C6 15.55 5.55 16 5 16C4.45 16 4 15.55 4 15C4 14.45 4.45 14 5 14ZM20.57 9.66C20.43 9.26 20.05 9 19.6 9H12.41C11.95 9 11.58 9.26 11.43 9.66L10.01 13.77V19.28C10.01 19.66 10.32 20 10.7 20H11.32C11.7 20 12 19.62 12 19.24V18H20V19.24C20 19.62 20.31 20 20.69 20H21.3C21.68 20 21.99 19.66 21.99 19.28L22 17.91V13.77L20.57 9.66ZM12.41 10H19.6L20.63 13H11.38L12.41 10ZM12 16C11.45 16 11 15.55 11 15C11 14.45 11.45 14 12 14C12.55 14 13 14.45 13 15C13 15.55 12.55 16 12 16ZM20 16C19.45 16 19 15.55 19 15C19 14.45 19.45 14 20 14C20.55 14 21 14.45 21 15C21 15.55 20.55 16 20 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCompare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="compare">
        <path
          id="Vector"
          d="M10 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H10V23H12V1H10V3ZM10 18H5L10 12V18ZM19 3H14V5H19V18L14 12V21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCompareArrows(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="compare_arrows">
        <path
          id="Vector"
          d="M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCompassCalibration(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="compass_calibration">
        <path
          id="Vector"
          d="M12 11.5C9.24 11.5 7 13.74 7 16.5C7 19.26 9.24 21.5 12 21.5C14.76 21.5 17 19.26 17 16.5C17 13.74 14.76 11.5 12 11.5ZM12 19.5C10.35 19.5 9 18.15 9 16.5C9 14.85 10.35 13.5 12 13.5C13.65 13.5 15 14.85 15 16.5C15 18.15 13.65 19.5 12 19.5ZM12 2.5C8.1 2.5 4.56 4.09 2 6.65L7 11.65C8.28 10.37 10.05 9.57 12 9.57C13.95 9.57 15.72 10.36 17 11.64L22 6.64C19.44 4.09 15.9 2.5 12 2.5ZM16.84 8.97C15.4 8.06 13.74 7.57 12 7.57C10.26 7.57 8.59 8.06 7.15 8.98L4.94 6.76C6.99 5.29 9.44 4.5 12 4.5C14.56 4.5 17 5.29 19.05 6.76L16.84 8.97Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCompost(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="compost">
        <path
          id="Vector"
          d="M12.87 13.06C12.64 12.68 12.5 12.23 12.5 11.75C12.5 10.37 13.62 9.25 15 9.25H16C17.51 9.25 18 8.25 18 8.25C18 8.25 18.55 14.25 15 14.25C14.51 14.25 14.06 14.11 13.68 13.87C13.44 14.51 13.09 15.63 12.92 16.83C14.18 17.05 15.2 17.72 15.69 18.6C17.38 17.43 18.5 15.47 18.5 13.25H21.5C21.5 18.49 17.24 22.75 12 22.75C6.76 22.75 2.5 18.49 2.5 13.25C2.5 8.01 6.76 3.75 12 3.75V1.25L16 5.25L12 9.25V6.75C8.42 6.75 5.5 9.67 5.5 13.25C5.5 15.46 6.61 17.42 8.31 18.6C8.82 17.68 9.94 16.98 11.29 16.8C11.2 16.11 11.03 15.38 10.8 14.77C10.45 15.07 10 15.25 9.5 15.25C8.4 15.25 7.5 14.35 7.5 13.25V12.26C7.5 11.7 7.31 11.17 7 10.75C7 10.75 11.45 10.52 11.5 13.25C11.5 13.54 11.44 13.81 11.33 14.05C10.91 13.73 10.47 13.45 10 13.25C10.58 13.68 11.37 14.62 12 15.85C12.67 14.23 13.68 12.58 15 11.25C14.24 11.77 13.53 12.37 12.87 13.06Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCompress(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="compress">
        <path
          id="Vector"
          d="M4 9.5V11.5H20V9.5H4ZM16 4.5L14.59 3.09L13 4.67V1.5H11V4.69L9.39 3.11L8 4.5L12 8.5L16 4.5ZM4 14.5H20V12.5H4V14.5ZM8 19.5L9.39 20.89L11 19.31V22.5H13V19.33L14.59 20.92L16 19.5L12 15.5L8 19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconComputer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="computer">
        <path
          id="Vector"
          d="M20 18C21.1 18 21.99 17.1 21.99 16L22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconConfirmationNumber(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="confirmation_number">
        <path
          id="Vector"
          d="M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2.01 4.89 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM11 15H13V17H11V15ZM11 11H13V13H11V11ZM11 7H13V9H11V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconConnectWithoutContact(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="connect_without_contact">
        <path
          id="Vector"
          d="M11 14H9C9 9.03 13.03 5 18 5V7C14.13 7 11 10.13 11 14ZM18 11V9C15.24 9 13 11.24 13 14H15C15 12.34 16.34 11 18 11ZM7 4C7 2.89 6.11 2 5 2C3.89 2 3 2.89 3 4C3 5.11 3.89 6 5 6C6.11 6 7 5.11 7 4ZM11.45 4.5H9.45C9.21 5.92 7.99 7 6.5 7H3.5C2.67 7 2 7.67 2 8.5V11H8V8.74C9.86 8.15 11.25 6.51 11.45 4.5ZM19 17C20.11 17 21 16.11 21 15C21 13.89 20.11 13 19 13C17.89 13 17 13.89 17 15C17 16.11 17.89 17 19 17ZM20.5 18H17.5C16.01 18 14.79 16.92 14.55 15.5H12.55C12.75 17.51 14.14 19.15 16 19.74V22H22V19.5C22 18.67 21.33 18 20.5 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconConnectedTv(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="connected_tv">
        <path
          id="Vector"
          d="M20 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H8V21H16V19H20C21.1 19 21.99 18.1 21.99 17L22 5C22 3.9 21.1 3 20 3ZM20 17H4V5H20V17ZM5 14V16H7C7 14.89 6.11 14 5 14ZM5 11V12.43C6.97 12.43 8.57 14.03 8.57 16H10C10 13.24 7.76 11 5 11ZM5 8V9.45C8.61 9.45 11.55 12.38 11.55 16H13C13 11.58 9.41 8 5 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconConnectingAirports(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="connecting_airports">
        <path
          id="Vector"
          d="M15.4 17L16.7 21.4H15.6L13 17H10C9.45 17 9 16.55 9 16C9 15.45 9.45 15 10 15H13L15.6 10.6H16.7L15.4 15H18.25L19 14H20L19.4 16L20 18H19L18.25 17H15.4ZM5.75 7.00001L5 6.00001H4L4.6 8.00001L4 10H5L5.75 9.00001H8.6L7.3 13.4H8.4L11 9.00001H14C14.55 9.00001 15 8.55001 15 8.00001C15 7.45001 14.55 7.00001 14 7.00001H11L8.4 2.60001H7.3L8.6 7.00001H5.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconConstruction(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="construction">
        <g id="Vector">
          <path
            d="M15.9041 13.1602L13.7828 15.2815L19.779 21.2777L21.9003 19.1564L15.9041 13.1602Z"
            fill="currentColor"
          />
          <path
            d="M17.5001 10.1097C19.4301 10.1097 21.0001 8.53967 21.0001 6.60967C21.0001 6.02967 20.8401 5.48967 20.5901 5.00967L17.8901 7.70967L16.4001 6.21967L19.1001 3.51967C18.6201 3.26967 18.0801 3.10967 17.5001 3.10967C15.5701 3.10967 14.0001 4.67967 14.0001 6.60967C14.0001 7.01967 14.0801 7.40967 14.2101 7.76967L12.3601 9.61967L10.5801 7.83967L11.2901 7.12967L9.8801 5.71967L12.0001 3.59967C10.8301 2.42967 8.9301 2.42967 7.7601 3.59967L4.2201 7.13967L5.6301 8.54967H2.8101L2.1001 9.25967L5.6401 12.7997L6.3501 12.0897V9.25967L7.7601 10.6697L8.4701 9.95967L10.2501 11.7397L2.8401 19.1497L4.9601 21.2697L16.3401 9.89967C16.7001 10.0297 17.0901 10.1097 17.5001 10.1097Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconContactEmergency(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contact_emergency">
        <g id="Vector">
          <path
            d="M9 14C10.65 14 12 12.65 12 11C12 9.35 10.65 8 9 8C7.35 8 6 9.35 6 11C6 12.65 7.35 14 9 14ZM9 10C9.54 10 10 10.46 10 11C10 11.54 9.54 12 9 12C8.46 12 8 11.54 8 11C8 10.46 8.46 10 9 10Z"
            fill="currentColor"
          />
          <path
            d="M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM4.54 19C5.64 17.78 7.23 17 9 17C10.77 17 12.36 17.78 13.46 19H4.54ZM22 19H15.92C14.54 16.61 11.96 15 9 15C6.04 15 3.46 16.61 2.08 19H2V5H22V19Z"
            fill="currentColor"
          />
          <path
            d="M15.78 11.15L17.25 10.3V12H18.75V10.3L20.22 11.15L20.97 9.85L19.5 9L20.97 8.15L20.22 6.85L18.75 7.7V6H17.25V7.7L15.78 6.85L15.03 8.15L16.5 9L15.03 9.85L15.78 11.15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconContactMail(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contact_mail">
        <path
          id="Vector"
          d="M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM22 19H2V5H22V19ZM21 6H14V11H21V6ZM20 8L17.5 9.75L15 8V7L17.5 8.75L20 7V8ZM9 12C10.65 12 12 10.65 12 9C12 7.35 10.65 6 9 6C7.35 6 6 7.35 6 9C6 10.65 7.35 12 9 12ZM9 8C9.55 8 10 8.45 10 9C10 9.55 9.55 10 9 10C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8ZM15 16.59C15 14.09 11.03 13.01 9 13.01C6.97 13.01 3 14.09 3 16.59V18H15V16.59ZM5.48 16C6.22 15.5 7.7 15 9 15C10.3 15 11.77 15.49 12.52 16H5.48Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContactPage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contact_page">
        <path
          id="Vector"
          d="M13.17 4L18 8.83V20H6V4H13.17ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14ZM16 17.43C16 16.62 15.52 15.9 14.78 15.58C13.93 15.21 12.99 15 12 15C11.01 15 10.07 15.21 9.22 15.58C8.48 15.9 8 16.62 8 17.43V18H16V17.43Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContactPhone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contact_phone">
        <path
          id="Vector"
          d="M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM22 19H2V5H22V19ZM19.01 17.99L21 16L19.49 14H17.85C17.63 13.37 17.5 12.7 17.5 12C17.5 11.3 17.63 10.63 17.85 10H19.49L21 8L19.01 6.01C17.7 6.99 16.73 8.38 16.28 10C16.1 10.64 16 11.31 16 12C16 12.69 16.1 13.36 16.28 14C16.73 15.61 17.7 17.01 19.01 17.99ZM9 12C10.65 12 12 10.65 12 9C12 7.35 10.65 6 9 6C7.35 6 6 7.35 6 9C6 10.65 7.35 12 9 12ZM9 8C9.55 8 10 8.45 10 9C10 9.55 9.55 10 9 10C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8ZM15 16.59C15 14.09 11.03 13.01 9 13.01C6.97 13.01 3 14.09 3 16.59V18H15V16.59ZM5.48 16C6.22 15.5 7.7 15 9 15C10.3 15 11.77 15.49 12.52 16H5.48Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContactSupport(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contact_support">
        <path
          id="Vector"
          d="M11.5 23.295V19.695C6.49 19.435 2.5 15.275 2.5 10.205C2.5 4.96502 6.76 0.705017 12 0.705017C17.24 0.705017 21.5 4.96502 21.5 10.205C21.5 15.155 18.06 20.135 12.93 22.605L11.5 23.295ZM12 2.70502C7.86 2.70502 4.5 6.06502 4.5 10.205C4.5 14.345 7.86 17.705 12 17.705H13.5V20.005C17.14 17.705 19.5 13.925 19.5 10.205C19.5 6.06502 16.14 2.70502 12 2.70502ZM11 14.205H13V16.205H11V14.205ZM13 12.705H11C11 9.45502 14 9.70502 14 7.70502C14 6.60502 13.1 5.70502 12 5.70502C10.9 5.70502 10 6.60502 10 7.70502H8C8 5.49502 9.79 3.70502 12 3.70502C14.21 3.70502 16 5.49502 16 7.70502C16 10.205 13 10.455 13 12.705Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContactless(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contactless">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M7.1 10.18C7.36 10.74 7.49 11.34 7.5 11.98C7.51 12.61 7.37 13.23 7.1 13.84L8.47 14.46C8.84 13.65 9.02 12.81 9.01 11.96C9 11.12 8.82 10.31 8.47 9.56L7.1 10.18Z"
            fill="currentColor"
          />
          <path
            d="M13.33 7.33C14.11 8.9 14.51 10.47 14.51 11.97C14.51 13.48 14.11 15.06 13.33 16.66L14.68 17.32C15.56 15.51 16.01 13.71 16.01 11.97C16.01 10.23 15.56 8.44 14.68 6.66L13.33 7.33Z"
            fill="currentColor"
          />
          <path
            d="M10.2 8.72C10.73 9.79 11 10.93 11 12.12C11 13.29 10.74 14.35 10.22 15.27L11.52 16.01C12.17 14.86 12.5 13.56 12.5 12.12C12.5 10.7 12.18 9.33 11.54 8.05L10.2 8.72Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconContacts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contacts">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18ZM4 0H20V2H4V0ZM4 22H20V24H4V22ZM12 12C13.38 12 14.5 10.88 14.5 9.5C14.5 8.12 13.38 7 12 7C10.62 7 9.5 8.12 9.5 9.5C9.5 10.88 10.62 12 12 12ZM12 8.5C12.55 8.5 13 8.95 13 9.5C13 10.05 12.55 10.5 12 10.5C11.45 10.5 11 10.05 11 9.5C11 8.95 11.45 8.5 12 8.5ZM17 15.99C17 13.9 13.69 13 12 13C10.31 13 7 13.9 7 15.99V17H17V15.99ZM8.81 15.5C9.42 14.98 10.84 14.5 12 14.5C13.17 14.5 14.59 14.98 15.2 15.5H8.81Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContentCopy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="content_copy">
        <path
          id="Vector"
          d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContentCut(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="content_cut">
        <path
          id="Vector"
          d="M9.64 7.64C9.87 7.14 10 6.59 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6C2 8.21 3.79 10 6 10C6.59 10 7.14 9.87 7.64 9.64L10 12L7.64 14.36C7.14 14.13 6.59 14 6 14C3.79 14 2 15.79 2 18C2 20.21 3.79 22 6 22C8.21 22 10 20.21 10 18C10 17.41 9.87 16.86 9.64 16.36L12 14L19 21H22V20L9.64 7.64ZM6 8C4.9 8 4 7.11 4 6C4 4.89 4.9 4 6 4C7.1 4 8 4.89 8 6C8 7.11 7.1 8 6 8ZM6 20C4.9 20 4 19.11 4 18C4 16.89 4.9 16 6 16C7.1 16 8 16.89 8 18C8 19.11 7.1 20 6 20ZM12 12.5C11.72 12.5 11.5 12.28 11.5 12C11.5 11.72 11.72 11.5 12 11.5C12.28 11.5 12.5 11.72 12.5 12C12.5 12.28 12.28 12.5 12 12.5ZM19 3L13 9L15 11L22 4V3H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContentPaste(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="content_paste">
        <path
          id="Vector"
          d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM19 21H5V5H7V8H17V5H19V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContentPasteGo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="content_paste_go">
        <g id="Vector">
          <path
            d="M4.5 6H6.5V9H16.5V6H18.5V12H20.5V6C20.5 4.9 19.6 4 18.5 4H14.32C13.9 2.84 12.8 2 11.5 2C10.2 2 9.1 2.84 8.68 4H4.5C3.4 4 2.5 4.9 2.5 6V20C2.5 21.1 3.4 22 4.5 22H9.5V20H4.5V6ZM11.5 4C12.05 4 12.5 4.45 12.5 5C12.5 5.55 12.05 6 11.5 6C10.95 6 10.5 5.55 10.5 5C10.5 4.45 10.95 4 11.5 4Z"
            fill="currentColor"
          />
          <path
            d="M17.51 14L16.09 15.41L17.67 16.99H11.5V18.99H17.67L16.09 20.58L17.51 21.99L21.5 17.99L17.51 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconContentPasteOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="content_paste_off">
        <path
          id="Vector"
          d="M21.9001 21.3849L3.5201 3.00495L2.1001 4.41495L3.7101 6.02495V19.1949C3.7101 20.2949 4.6101 21.1949 5.7101 21.1949H18.8801L20.4901 22.8049L21.9001 21.3849ZM5.7101 19.1949V8.02495L16.8801 19.1949H5.7101ZM17.7101 8.19495V5.19495H19.7101V16.3649L21.7101 18.3649V5.19495C21.7101 4.09495 20.8101 3.19495 19.7101 3.19495H15.5301C15.1101 2.03495 14.0101 1.19495 12.7101 1.19495C11.4101 1.19495 10.3101 2.03495 9.8901 3.19495H6.5401L11.5401 8.19495H17.7101ZM12.7101 3.19495C13.2601 3.19495 13.7101 3.64495 13.7101 4.19495C13.7101 4.74495 13.2601 5.19495 12.7101 5.19495C12.1601 5.19495 11.7101 4.74495 11.7101 4.19495C11.7101 3.64495 12.1601 3.19495 12.7101 3.19495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconContentPasteSearch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="content_paste_search">
        <g id="Vector">
          <path
            d="M4 5H6V8H16V5H18V10H20V5C20 3.9 19.1 3 18 3H13.82C13.4 1.84 12.3 1 11 1C9.7 1 8.6 1.84 8.18 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H9V19H4V5ZM11 3C11.55 3 12 3.45 12 4C12 4.55 11.55 5 11 5C10.45 5 10 4.55 10 4C10 3.45 10.45 3 11 3Z"
            fill="currentColor"
          />
          <path
            d="M19.3 18.9C19.7 18.2 20 17.4 20 16.5C20 14 18 12 15.5 12C13 12 11 14 11 16.5C11 19 13 21 15.5 21C16.4 21 17.2 20.7 17.9 20.3L20.6 23L22 21.6L19.3 18.9ZM15.5 19C14.1 19 13 17.9 13 16.5C13 15.1 14.1 14 15.5 14C16.9 14 18 15.1 18 16.5C18 17.9 16.9 19 15.5 19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconContrast(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="contrast">
        <path
          id="Vector"
          d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM13 4.07C16.94 4.56 20 7.92 20 12C20 16.08 16.95 19.44 13 19.93V4.07Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconControlCamera(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="control_camera">
        <g id="Vector">
          <path
            d="M5.54 8.46L2 12L5.54 15.54L7.3 13.77L5.54 12L7.3 10.23L5.54 8.46ZM12 18.46L10.23 16.7L8.46 18.46L12 22L15.54 18.46L13.77 16.7L12 18.46ZM18.46 8.46L16.7 10.23L18.46 12L16.7 13.77L18.46 15.54L22 12L18.46 8.46ZM8.46 5.54L10.23 7.3L12 5.54L13.77 7.3L15.54 5.54L12 2L8.46 5.54Z"
            fill="currentColor"
          />
          <path
            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconControlPoint(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="control_point">
        <path
          id="Vector"
          d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconControlPointDuplicate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="control_point_duplicate">
        <path
          id="Vector"
          d="M16 8H14V11H11V13H14V16H16V13H19V11H16V8ZM2 12C2 9.21 3.64 6.8 6.01 5.68V3.52C2.52 4.76 0 8.09 0 12C0 15.91 2.52 19.24 6.01 20.48V18.32C3.64 17.2 2 14.79 2 12ZM15 3C10.04 3 6 7.04 6 12C6 16.96 10.04 21 15 21C19.96 21 24 16.96 24 12C24 7.04 19.96 3 15 3ZM15 19C11.14 19 8 15.86 8 12C8 8.14 11.14 5 15 5C18.86 5 22 8.14 22 12C22 15.86 18.86 19 15 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCookie(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cookie">
        <g id="Vector">
          <path
            d="M10.4995 10.0127C11.3279 10.0127 11.9995 9.34116 11.9995 8.51273C11.9995 7.6843 11.3279 7.01273 10.4995 7.01273C9.67108 7.01273 8.99951 7.6843 8.99951 8.51273C8.99951 9.34116 9.67108 10.0127 10.4995 10.0127Z"
            fill="currentColor"
          />
          <path
            d="M8.49951 15.0127C9.32794 15.0127 9.99951 14.3412 9.99951 13.5127C9.99951 12.6843 9.32794 12.0127 8.49951 12.0127C7.67108 12.0127 6.99951 12.6843 6.99951 13.5127C6.99951 14.3412 7.67108 15.0127 8.49951 15.0127Z"
            fill="currentColor"
          />
          <path
            d="M14.9995 16.0127C15.5518 16.0127 15.9995 15.565 15.9995 15.0127C15.9995 14.4604 15.5518 14.0127 14.9995 14.0127C14.4472 14.0127 13.9995 14.4604 13.9995 15.0127C13.9995 15.565 14.4472 16.0127 14.9995 16.0127Z"
            fill="currentColor"
          />
          <path
            d="M21.9495 11.0027C20.1595 10.9727 18.2495 9.05273 19.2695 6.78273C16.2995 7.78273 13.4895 5.19273 14.0795 2.22273C7.10951 0.752732 1.99951 6.42273 1.99951 12.0127C1.99951 17.5327 6.47951 22.0127 11.9995 22.0127C17.8895 22.0127 22.5395 16.9327 21.9495 11.0027ZM11.9995 20.0127C7.58951 20.0127 3.99951 16.4227 3.99951 12.0127C3.99951 8.70273 6.72951 3.83273 12.0795 3.99273C12.4995 6.53273 14.5195 8.55273 17.0695 8.93273C17.1395 9.29273 17.5895 11.4827 19.9895 12.5627C19.6995 16.8727 16.0595 20.0127 11.9995 20.0127Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCopyAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="copy_all">
        <path
          id="Vector"
          d="M18.5 2H9.5C8.4 2 7.5 2.9 7.5 4V16C7.5 17.1 8.4 18 9.5 18H18.5C19.6 18 20.5 17.1 20.5 16V4C20.5 2.9 19.6 2 18.5 2ZM18.5 16H9.5V4H18.5V16ZM3.5 15V13H5.5V15H3.5ZM3.5 9.5H5.5V11.5H3.5V9.5ZM10.5 20H12.5V22H10.5V20ZM3.5 18.5V16.5H5.5V18.5H3.5ZM5.5 22C4.4 22 3.5 21.1 3.5 20H5.5V22ZM9 22H7V20H9V22ZM14 22V20H16C16 21.1 15.1 22 14 22ZM5.5 6V8H3.5C3.5 6.9 4.4 6 5.5 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCopyright(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="copyright">
        <path
          id="Vector"
          d="M10.08 10.86C10.13 10.53 10.24 10.24 10.38 9.99C10.52 9.74 10.72 9.53 10.97 9.37C11.21 9.22 11.51 9.15 11.88 9.14C12.11 9.15 12.32 9.19 12.51 9.27C12.71 9.36 12.89 9.48 13.03 9.63C13.17 9.78 13.28 9.96 13.37 10.16C13.46 10.36 13.5 10.58 13.51 10.8H15.3C15.28 10.33 15.19 9.9 15.02 9.51C14.85 9.12 14.62 8.78 14.32 8.5C14.02 8.22 13.66 8 13.24 7.84C12.82 7.68 12.36 7.61 11.85 7.61C11.2 7.61 10.63 7.72 10.15 7.95C9.67 8.18 9.27 8.48 8.95 8.87C8.63 9.26 8.39 9.71 8.24 10.23C8.09 10.75 8 11.29 8 11.87V12.14C8 12.72 8.08 13.26 8.23 13.78C8.38 14.3 8.62 14.75 8.94 15.13C9.26 15.51 9.66 15.82 10.14 16.04C10.62 16.26 11.19 16.38 11.84 16.38C12.31 16.38 12.75 16.3 13.16 16.15C13.57 16 13.93 15.79 14.24 15.52C14.55 15.25 14.8 14.94 14.98 14.58C15.16 14.22 15.27 13.84 15.28 13.43H13.49C13.48 13.64 13.43 13.83 13.34 14.01C13.25 14.19 13.13 14.34 12.98 14.47C12.83 14.6 12.66 14.7 12.46 14.77C12.27 14.84 12.07 14.86 11.86 14.87C11.5 14.86 11.2 14.79 10.97 14.64C10.72 14.48 10.52 14.27 10.38 14.02C10.24 13.77 10.13 13.47 10.08 13.14C10.03 12.81 10 12.47 10 12.14V11.87C10 11.52 10.03 11.19 10.08 10.86ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCoronavirus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="coronavirus">
        <path
          id="Vector"
          d="M9.5 11.995C9.5 12.545 9.05 12.995 8.5 12.995C7.95 12.995 7.5 12.545 7.5 11.995C7.5 11.445 7.95 10.995 8.5 10.995C9.05 10.995 9.5 11.445 9.5 11.995ZM13.75 9.995C14.3 9.995 14.75 9.545 14.75 8.995C14.75 8.44499 14.3 7.995 13.75 7.995C13.2 7.995 12.75 8.44499 12.75 8.995C12.75 9.545 13.2 9.995 13.75 9.995ZM10.25 9.995C10.8 9.995 11.25 9.545 11.25 8.995C11.25 8.44499 10.8 7.995 10.25 7.995C9.7 7.995 9.25 8.44499 9.25 8.995C9.25 9.545 9.7 9.995 10.25 9.995ZM10.25 13.995C9.7 13.995 9.25 14.445 9.25 14.995C9.25 15.545 9.7 15.995 10.25 15.995C10.8 15.995 11.25 15.545 11.25 14.995C11.25 14.445 10.8 13.995 10.25 13.995ZM22 11.245V12.745C22 13.155 21.66 13.495 21.25 13.495C20.84 13.495 20.5 13.155 20.5 12.745H18.96C18.81 14.115 18.27 15.375 17.44 16.395L18.53 17.485L18.54 17.475C18.83 17.185 19.31 17.185 19.6 17.475C19.89 17.765 19.89 18.245 19.6 18.535L18.54 19.595C18.25 19.885 17.77 19.885 17.48 19.595C17.19 19.305 17.19 18.835 17.47 18.545L16.38 17.455C15.36 18.275 14.11 18.815 12.74 18.965V20.505H12.75C13.16 20.505 13.5 20.845 13.5 21.255C13.5 21.665 13.16 22.005 12.75 22.005H11.25C10.84 22.005 10.5 21.665 10.5 21.255C10.5 20.845 10.83 20.515 11.24 20.505V18.955C9.87 18.805 8.62 18.265 7.61 17.445L6.52 18.535L6.53 18.545C6.82 18.835 6.82 19.315 6.53 19.605C6.24 19.895 5.76 19.895 5.47 19.605L4.4 18.535C4.11 18.245 4.11 17.765 4.4 17.475C4.69 17.185 5.16 17.185 5.45 17.465L6.54 16.375C5.72 15.355 5.18 14.115 5.04 12.745H3.5C3.5 13.155 3.16 13.495 2.75 13.495C2.34 13.495 2 13.155 2 12.745V11.245C2 10.835 2.34 10.495 2.75 10.495C3.16 10.495 3.5 10.835 3.5 11.245H5.04C5.19 9.875 5.73 8.63499 6.54 7.615L5.45 6.525C5.16 6.805 4.69 6.805 4.4 6.515C4.11 6.225 4.11 5.745 4.4 5.455L5.46 4.395C5.75 4.105 6.23 4.105 6.52 4.395C6.81 4.685 6.81 5.165 6.52 5.455L6.51 5.46499L7.6 6.555C8.62 5.735 9.86 5.195 11.23 5.045V3.495C10.82 3.485 10.49 3.155 10.49 2.745C10.5 2.335 10.84 1.995 11.25 1.995H12.75C13.16 1.995 13.5 2.335 13.5 2.745C13.5 3.155 13.16 3.495 12.75 3.495H12.74V5.035C14.11 5.175 15.36 5.725 16.38 6.545L17.47 5.455C17.18 5.165 17.19 4.69499 17.48 4.40499C17.77 4.115 18.25 4.115 18.54 4.40499L19.6 5.46499C19.89 5.75499 19.89 6.235 19.6 6.525C19.31 6.815 18.83 6.815 18.54 6.525L18.53 6.515L17.44 7.595C18.26 8.615 18.81 9.865 18.96 11.245H20.5C20.5 10.835 20.84 10.495 21.25 10.495C21.66 10.495 22 10.835 22 11.245ZM17 11.995C17 9.23499 14.76 6.995 12 6.995C9.24 6.995 7 9.23499 7 11.995C7 14.755 9.24 16.995 12 16.995C14.76 16.995 17 14.755 17 11.995ZM12 10.995C11.45 10.995 11 11.445 11 11.995C11 12.545 11.45 12.995 12 12.995C12.55 12.995 13 12.545 13 11.995C13 11.445 12.55 10.995 12 10.995ZM15.5 10.995C14.95 10.995 14.5 11.445 14.5 11.995C14.5 12.545 14.95 12.995 15.5 12.995C16.05 12.995 16.5 12.545 16.5 11.995C16.5 11.445 16.05 10.995 15.5 10.995ZM13.75 13.995C13.2 13.995 12.75 14.445 12.75 14.995C12.75 15.545 13.2 15.995 13.75 15.995C14.3 15.995 14.75 15.545 14.75 14.995C14.75 14.445 14.3 13.995 13.75 13.995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCorporateFare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="corporate_fare">
        <path
          id="Vector"
          d="M12 7V3H2V21H22V7H12ZM10 19H4V17H10V19ZM10 15H4V13H10V15ZM10 11H4V9H10V11ZM10 7H4V5H10V7ZM20 19H12V9H20V19ZM18 11H14V13H18V11ZM18 15H14V17H18V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCottage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cottage">
        <path
          id="Vector"
          d="M12 4L6 8.58V7H4V10.11L1 12.4L2.21 13.99L4 12.62V22H20V12.62L21.79 13.98L23 12.4L12 4ZM18 20H13V16H11V20H6V11.1L12 6.52L18 11.1V20ZM10 2C10 3.66 8.66 5 7 5C6.45 5 6 5.45 6 6H4C4 4.34 5.34 3 7 3C7.55 3 8 2.55 8 2H10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCountertops(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="countertops">
        <path
          id="Vector"
          d="M22 10H18V7C18 5.34 16.66 4 15 4C13.34 4 12 5.34 12 7H14C14 6.45 14.45 6 15 6C15.55 6 16 6.45 16 7V10H8C9.1 10 10 9.1 10 8V4H4V8C4 9.1 4.9 10 6 10H2V12H4V20H20V12H22V10ZM6 6H8V8H6V6ZM6 18V12H11V18H6ZM18 18H13V12H18V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCreate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="create">
        <path
          id="Vector"
          d="M2.99878 17.25V21H6.74878L17.8088 9.94L14.0588 6.19L2.99878 17.25ZM5.91878 19H4.99878V18.08L14.0588 9.02L14.9788 9.94L5.91878 19ZM20.7088 5.63L18.3688 3.29C18.1688 3.09 17.9188 3 17.6588 3C17.3988 3 17.1488 3.1 16.9588 3.29L15.1288 5.12L18.8788 8.87L20.7088 7.04C21.0988 6.65 21.0988 6.02 20.7088 5.63Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCreateNewFolder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="create_new_folder">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM12 14H14V16H16V14H18V12H16V10H14V12H12V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCreditCard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="credit_card">
        <path
          id="Vector"
          d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCreditCardOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="credit_card_off">
        <path
          id="Vector"
          d="M7.48497 3.29502H20.655C21.765 3.29502 22.655 4.18502 22.655 5.29502V17.295C22.655 17.635 22.575 17.955 22.425 18.235L20.655 16.465V11.295H15.485L11.485 7.29502H20.655V5.29502H9.48497L7.48497 3.29502ZM21.145 22.605L17.825 19.295H4.65497C3.54497 19.295 2.65497 18.405 2.65497 17.295L2.66497 5.29502C2.66497 4.95502 2.74497 4.63502 2.89497 4.36502L1.34497 2.80502L2.75497 1.39502L22.555 21.195L21.145 22.605ZM4.65497 6.12502V7.29502H5.82497L4.65497 6.12502ZM15.825 17.295L9.82497 11.295H4.65497V17.295H15.825Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCreditScore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="credit_score">
        <path
          id="Vector"
          d="M20 3H4C2.89 3 2.01 3.89 2.01 5L2 17C2 18.11 2.89 19 4 19H9V17H4V11H22V5C22 3.89 21.11 3 20 3ZM20 7H4V5H20V7ZM14.93 18.17L12.1 15.34L10.69 16.75L14.93 21L22 13.93L20.59 12.52L14.93 18.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrib(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crib">
        <path
          id="Vector"
          d="M18 8H12V3H8C5.79 3 4 4.79 4 7V13C4 14.1 4.9 15 6 15H8V17.93C7.39 17.58 6.84 17.15 6.35 16.66L4.93 18.08C6.74 19.88 9.24 21 12 21C14.76 21 17.26 19.88 19.07 18.07L17.65 16.65C17.16 17.14 16.6 17.57 16 17.92V15H18C19.1 15 20 14.1 20 13V10C20 8.9 19.1 8 18 8ZM14 18.75C13.36 18.91 12.69 19 12 19C11.31 19 10.64 18.91 10 18.75V15H14V18.75ZM18 13H6V7C6 5.9 6.9 5 8 5H10V10H18V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrisisAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crisis_alert">
        <path
          id="Vector"
          d="M14.5 3.5C14.5 5 13 9.5 13 9.5H11C11 9.5 9.5 5 9.5 3.5C9.5 2.12 10.62 1 12 1C13.38 1 14.5 2.12 14.5 3.5ZM12 11C10.9 11 10 11.9 10 13C10 14.1 10.9 15 12 15C13.1 15 14 14.1 14 13C14 11.9 13.1 11 12 11ZM16.08 6.11C16.26 5.36 16.41 4.64 16.47 4.05C19.75 5.69 22 9.08 22 13C22 18.52 17.52 23 12 23C6.48 23 2 18.52 2 13C2 9.08 4.25 5.69 7.53 4.05C7.6 4.64 7.74 5.37 7.92 6.11C5.58 7.51 4 10.07 4 13C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 10.07 18.42 7.51 16.08 6.11ZM18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13C6 11 6.98 9.23 8.48 8.14C8.71 8.95 9.13 10.21 9.13 10.21C8.43 10.93 8 11.92 8 13C8 15.21 9.79 17 12 17C14.21 17 16 15.21 16 13C16 11.92 15.57 10.93 14.87 10.21C14.87 10.21 15.28 8.99 15.52 8.14C17.02 9.23 18 11 18 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop">
        <path
          id="Vector"
          d="M17 15H19V7C19 5.9 18.1 5 17 5H9V7H17V15ZM7 17V1H5V5H1V7H5V17C5 18.1 5.9 19 7 19H17V23H19V19H23V17H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrop169(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_16_9">
        <path
          id="Vector"
          d="M19 7H5C3.9 7 3 7.9 3 9V15C3 16.1 3.9 17 5 17H19C20.1 17 21 16.1 21 15V9C21 7.9 20.1 7 19 7ZM19 15H5V9H19V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrop32(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_3_2">
        <path
          id="Vector"
          d="M19 6H5C3.9 6 3 6.9 3 8V16C3 17.1 3.9 18 5 18H19C20.1 18 21 17.1 21 16V8C21 6.9 20.1 6 19 6ZM19 16H5V8H19V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrop54(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_5_4">
        <path
          id="Vector"
          d="M19 4H5C3.9 4 3 4.9 3 6V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrop75(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_7_5">
        <path
          id="Vector"
          d="M19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5ZM19 17H5V7H19V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCropDin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_din">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCropFree(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_free">
        <path
          id="Vector"
          d="M3 5V9H5V5H9V3H5C3.9 3 3 3.9 3 5ZM5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCropLandscape(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_landscape">
        <path
          id="Vector"
          d="M19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5ZM19 17H5V7H19V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCropOriginal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_original">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H17.5L13.96 12.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCropPortrait(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_portrait">
        <path
          id="Vector"
          d="M17 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V5C19 3.9 18.1 3 17 3ZM17 19H7V5H17V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCropRotate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_rotate" clipPath="url(#clip0_395_1714)">
        <path
          id="Vector"
          d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0C0.51 19.16 5.66 24 11.95 24C12.18 24 12.39 23.98 12.61 23.97L8.8 20.15L7.47 21.49ZM12.05 0C11.82 0 11.61 0.02 11.39 0.04L15.2 3.85L16.53 2.52C19.8 4.07 22.14 7.24 22.5 11H24C23.49 4.84 18.34 0 12.05 0ZM16 14H18V8C18 6.89 17.1 6 16 6H10V8H16V14ZM8 16V4H6V6H4V8H6V16C6 17.1 6.89 18 8 18H16V20H18V18H20V16H8Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_1714">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconCropSquare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="crop_square">
        <path
          id="Vector"
          d="M18 4H6C4.9 4 4 4.9 4 6V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4ZM18 18H6V6H18V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCrueltyFree(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cruelty_free">
        <path
          id="Vector"
          d="M17 14C16.76 13.76 16.56 13.51 16.35 13.25C17.51 11.5 19 8.56 19 5C19 3.05 18.26 2 17 2C15.46 2 13.04 4.06 12 7.97C10.96 4.06 8.54 2 7 2C5.74 2 5 3.05 5 5C5 8.56 6.49 11.5 7.65 13.25C7.44 13.51 7.24 13.76 7 14C6.75 14.25 5 15.39 5 17.5C5 19.98 7.02 22 9.5 22C11 22 12 21.5 12 21.5C12 21.5 13 22 14.5 22C16.98 22 19 19.98 19 17.5C19 15.39 17.25 14.25 17 14ZM16.88 4.03C16.94 4.2 17 4.51 17 5C17 7.84 15.89 10.24 14.93 11.78C14.55 11.52 14.1 11.3 13.53 11.16C13.77 6.64 15.97 4.33 16.88 4.03ZM7 5C7 4.51 7.06 4.2 7.12 4.03C8.03 4.33 10.23 6.64 10.48 11.16C9.9 11.3 9.45 11.51 9.08 11.78C8.11 10.24 7 7.84 7 5ZM14.5 20C13.5 20 12.7 19.67 12.28 19.44C12.7 19.26 13 18.73 13 18.5C13 18.22 12.55 18 12 18C11.45 18 11 18.22 11 18.5C11 18.73 11.3 19.26 11.72 19.44C11.3 19.67 10.5 20 9.5 20C8.12 20 7 18.88 7 17.5C7 16.8 7.43 16.26 8 15.77C8.44 15.41 8.61 15.25 9.3 14.4C10.06 13.45 10.39 13 12 13C13.61 13 13.94 13.45 14.7 14.4C15.39 15.25 15.56 15.41 16 15.77C16.57 16.26 17 16.8 17 17.5C17 18.88 15.88 20 14.5 20ZM14 16C14 16.41 13.78 16.75 13.5 16.75C13.22 16.75 13 16.41 13 16C13 15.59 13.22 15.25 13.5 15.25C13.78 15.25 14 15.59 14 16ZM11 16C11 16.41 10.78 16.75 10.5 16.75C10.22 16.75 10 16.41 10 16C10 15.59 10.22 15.25 10.5 15.25C10.78 15.25 11 15.59 11 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCss(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="css">
        <path
          id="Vector"
          d="M9.5 14V13H11V13.5H13V12.5H10.5C9.95 12.5 9.5 12.05 9.5 11.5V10C9.5 9.45 9.95 9 10.5 9H13.5C14.05 9 14.5 9.45 14.5 10V11H13V10.5H11V11.5H13.5C14.05 11.5 14.5 11.95 14.5 12.5V14C14.5 14.55 14.05 15 13.5 15H10.5C9.95 15 9.5 14.55 9.5 14ZM17 15H20C20.55 15 21 14.55 21 14V12.5C21 11.95 20.55 11.5 20 11.5H17.5V10.5H19.5V11H21V10C21 9.45 20.55 9 20 9H17C16.45 9 16 9.45 16 10V11.5C16 12.05 16.45 12.5 17 12.5H19.5V13.5H17.5V13H16V14C16 14.55 16.45 15 17 15ZM8 10C8 9.45 7.55 9 7 9H4C3.45 9 3 9.45 3 10V14C3 14.55 3.45 15 4 15H7C7.55 15 8 14.55 8 14V13H6.5V13.5H4.5V10.5H6.5V11H8V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyBitcoin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_bitcoin">
        <path
          id="Vector"
          d="M16.56 11.57C17.15 10.88 17.5 9.98 17.5 9C17.5 7.14 16.23 5.57 14.5 5.13V3H12.5V5H10.5V3H8.5V5H5.5V7H7.5V17H5.5V19H8.5V21H10.5V19H12.5V21H14.5V19C16.71 19 18.5 17.21 18.5 15C18.5 13.55 17.72 12.27 16.56 11.57ZM9.5 7H13.5C14.6 7 15.5 7.9 15.5 9C15.5 10.1 14.6 11 13.5 11H9.5V7ZM14.5 17H9.5V13H14.5C15.6 13 16.5 13.9 16.5 15C16.5 16.1 15.6 17 14.5 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyExchange(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_exchange">
        <path
          id="Vector"
          d="M12.89 11.1C11.11 10.51 10.25 10.14 10.25 9.2C10.25 8.18 11.36 7.81 12.06 7.81C13.37 7.81 13.85 8.8 13.96 9.15L15.54 8.48C15.39 8.03 14.72 6.56 13 6.24V5H11V6.26C8.52 6.82 8.51 9.12 8.51 9.22C8.51 11.49 10.76 12.13 11.86 12.53C13.44 13.09 14.14 13.6 14.14 14.56C14.14 15.69 13.09 16.17 12.16 16.17C10.34 16.17 9.82 14.3 9.76 14.08L8.1 14.75C8.73 16.94 10.38 17.53 11 17.71V19H13V17.76C13.4 17.67 15.9 17.17 15.9 14.54C15.9 13.15 15.29 11.93 12.89 11.1ZM3 21H1V15H7V17H4.52C6.13 19.41 8.88 21 12 21C16.97 21 21 16.97 21 12H23C23 18.08 18.08 23 12 23C8.28 23 4.99 21.15 3 18.33V21ZM1 12C1 5.92 5.92 1 12 1C15.72 1 19.01 2.85 21 5.67V3H23V9H17V7H19.48C17.87 4.59 15.12 3 12 3C7.03 3 3 7.03 3 12H1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyFranc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_franc">
        <path
          id="Vector"
          d="M18.5 5V3H7.5V16H5.5V18H7.5V21H9.5V18H13.5V16H9.5V13H17.5V11H9.5V5H18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyLira(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_lira">
        <path
          id="Vector"
          d="M9 8.76V3H11V7.51L15 5V7.36L11 9.87L11.01 12.22L15 9.72V12.08L11 14.59V19C13.76 19 16 16.76 16 14H18C18 17.87 14.87 21 11 21H9V15.84L6 17.72V15.36L9 13.48V11.12L6 13V10.64L9 8.76Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyPound(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_pound">
        <path
          id="Vector"
          d="M14 21.25C15.93 21.25 17.62 20.08 18 18.25L16.25 17.37C16 18.46 15.33 19.25 14 19.25H9.1C9.93 18.25 10.6 16.91 10.6 15.25C10.6 14.9 10.57 14.56 10.52 14.25H14V12.25H9.82C9 10.67 8 9.85 8 8.25C8 6.32 9.57 4.75 11.5 4.75C13 4.75 14.29 5.7 14.78 7.03L16.63 6.25C15.83 4.2 13.84 2.75 11.5 2.75C8.46 2.75 6 5.21 6 8.25C6 10.03 6.79 11.15 7.49 12.25H6V14.25H8.47C8.55 14.56 8.6 14.89 8.6 15.25C8.6 17.95 6 19.25 6 19.25V21.25H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyRuble(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_ruble">
        <path
          id="Vector"
          d="M13.5 3H7V12H5V14H7V16H5V18H7V21H9V18H13V16H9V14H13.5C16.54 14 19 11.54 19 8.5C19 5.46 16.54 3 13.5 3ZM13.5 12H9V5H13.5C15.43 5 17 6.57 17 8.5C17 10.43 15.43 12 13.5 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyRupee(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_rupee">
        <path
          id="Vector"
          d="M13.66 7C13.1 5.82 11.9 5 10.5 5H6V3H18V5H14.74C15.22 5.58 15.58 6.26 15.79 7H18V9H15.98C15.73 11.8 13.37 14 10.5 14H9.77L16.5 21H13.73L7 14V12H10.5C12.26 12 13.72 10.7 13.96 9H6V7H13.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyYen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_yen">
        <path
          id="Vector"
          d="M13.92 11H18V13H13V15H18V17H13V21H11V17H6V15H11V13H6V11H10.08L5 3H7.37L12 10.29L16.63 3H19L13.92 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurrencyYuan(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="currency_yuan">
        <path
          id="Vector"
          d="M13.28 12H18V14H13V21H11V14H6V12H10.72L5 3H7.37L12 10.29L16.63 3H19L13.28 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurtains(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="curtains">
        <path
          id="Vector"
          d="M20 19V3H4V19H2V21H22V19H20ZM18 10.86C15.95 10.28 14.36 7.93 14.06 5H18V10.86ZM15.81 12C13.77 13.35 12.31 15.94 12.05 19H11.96C11.7 15.94 10.24 13.35 8.2 12C10.24 10.65 11.7 8.06 11.96 5H12.05C12.31 8.06 13.77 10.65 15.81 12ZM9.94 5C9.64 7.93 8.05 10.27 6 10.86V5H9.94ZM6 13.14C8.05 13.72 9.64 16.07 9.94 19H6V13.14ZM14.06 19C14.36 16.07 15.95 13.73 18 13.14V19H14.06Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCurtainsClosed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="curtains_closed">
        <path
          id="Vector"
          d="M20 19V3H4V19H2V21H22V19H20ZM13 5V19H11V5H13ZM6 5H9V19H6V5ZM15 19V5H18V19H15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconCyclone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cyclone">
        <g id="Vector">
          <path
            d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z"
            fill="currentColor"
          />
          <path
            d="M22 7.47V5.35C20.05 4.77 16.56 4 12 4C9.85 4 7.89 4.86 6.46 6.24C6.59 5.39 6.86 3.84 7.47 2H5.35C4.77 3.95 4 7.44 4 12C4 14.15 4.86 16.11 6.24 17.54C5.39 17.4 3.84 17.14 2 16.53V18.65C3.95 19.23 7.44 20 12 20C14.15 20 16.11 19.14 17.54 17.76C17.4 18.61 17.14 20.16 16.53 22H18.65C19.23 20.05 20 16.56 20 12C20 9.85 19.14 7.89 17.76 6.46C18.61 6.59 20.16 6.86 22 7.47ZM12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDangerous(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dangerous">
        <path
          id="Vector"
          d="M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9ZM14.83 7.76L12 10.59L9.17 7.76L7.76 9.17L10.59 12L7.76 14.83L9.17 16.24L12 13.41L14.83 16.24L16.24 14.83L13.41 12L16.24 9.17L14.83 7.76Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDarkMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dark_mode">
        <path
          id="Vector"
          d="M9.37 5.51C9.19 6.15 9.1 6.82 9.1 7.5C9.1 11.58 12.42 14.9 16.5 14.9C17.18 14.9 17.85 14.81 18.49 14.63C17.45 17.19 14.93 19 12 19C8.14 19 5 15.86 5 12C5 9.07 6.81 6.55 9.37 5.51ZM12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 11.54 20.96 11.08 20.9 10.64C19.92 12.01 18.32 12.9 16.5 12.9C13.52 12.9 11.1 10.48 11.1 7.5C11.1 5.69 11.99 4.08 13.36 3.1C12.92 3.04 12.46 3 12 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDashboard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dashboard">
        <path
          id="Vector"
          d="M19 5V7H15V5H19ZM9 5V11H5V5H9ZM19 13V19H15V13H19ZM9 17V19H5V17H9ZM21 3H13V9H21V3ZM11 3H3V13H11V3ZM21 11H13V21H21V11ZM11 15H3V21H11V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDashboardCustomize(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dashboard_customize">
        <g id="Vector">
          <path d="M3 11H11V3H3V11ZM5 5H9V9H5V5Z" fill="currentColor" />
          <path d="M13 3V11H21V3H13ZM19 9H15V5H19V9Z" fill="currentColor" />
          <path d="M3 21H11V13H3V21ZM5 15H9V19H5V15Z" fill="currentColor" />
          <path d="M18 13H16V16H13V18H16V21H18V18H21V16H18V13Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDataArray(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_array">
        <g id="Vector">
          <path d="M15 4V6H18V18H15V20H20V4H15Z" fill="currentColor" />
          <path d="M4 20H9V18H6V6H9V4H4V20Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDataExploration(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_exploration">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22H20C21.1 22 22 21.1 22 20V12C22 6.48 17.52 2 12 2ZM12 20C9.11 20 6.57 18.46 5.17 16.16L8.12 13.21L11.41 16L16 11.42V13H18V8H13V10H14.58L11.3 13.28L8 10.5L4.31 14.2C4.11 13.5 4 12.76 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM19.5 20.5C18.95 20.5 18.5 20.05 18.5 19.5C18.5 18.95 18.95 18.5 19.5 18.5C20.05 18.5 20.5 18.95 20.5 19.5C20.5 20.05 20.05 20.5 19.5 20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDataObject(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_object">
        <g id="Vector">
          <path
            d="M4 7V9C4 9.55 3.55 10 3 10H2V14H3C3.55 14 4 14.45 4 15V17C4 18.65 5.35 20 7 20H10V18H7C6.45 18 6 17.55 6 17V15C6 13.7 5.16 12.58 4 12.17V11.83C5.16 11.42 6 10.3 6 9V7C6 6.45 6.45 6 7 6H10V4H7C5.35 4 4 5.35 4 7Z"
            fill="currentColor"
          />
          <path
            d="M21 10C20.45 10 20 9.55 20 9V7C20 5.35 18.65 4 17 4H14V6H17C17.55 6 18 6.45 18 7V9C18 10.3 18.84 11.42 20 11.83V12.17C18.84 12.58 18 13.69 18 15V17C18 17.55 17.55 18 17 18H14V20H17C18.65 20 20 18.65 20 17V15C20 14.45 20.45 14 21 14H22V10H21Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDataSaverOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_saver_off">
        <path
          id="Vector"
          d="M13 2.02499V5.05499C16.39 5.54499 19 8.44499 19 11.975C19 12.875 18.82 13.725 18.52 14.515L21.12 16.045C21.68 14.805 22 13.425 22 11.975C22 6.79499 18.05 2.52499 13 2.02499ZM12 18.975C8.13 18.975 5 15.845 5 11.975C5 8.44499 7.61 5.54499 11 5.05499V2.02499C5.94 2.52499 2 6.78499 2 11.975C2 17.495 6.47 21.975 11.99 21.975C15.3 21.975 18.23 20.365 20.05 17.885L17.45 16.355C16.17 17.955 14.21 18.975 12 18.975Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDataSaverOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_saver_on">
        <path
          id="Vector"
          d="M11 7.97499V10.975H8V12.975H11V15.975H13V12.975H16V10.975H13V7.97499H11ZM13 2.02499V5.05499C16.39 5.54499 19 8.44499 19 11.975C19 12.875 18.82 13.725 18.52 14.515L21.12 16.045C21.68 14.805 22 13.425 22 11.975C22 6.79499 18.05 2.52499 13 2.02499ZM12 18.975C8.13 18.975 5 15.845 5 11.975C5 8.44499 7.61 5.54499 11 5.05499V2.02499C5.94 2.52499 2 6.78499 2 11.975C2 17.495 6.47 21.975 11.99 21.975C15.3 21.975 18.23 20.365 20.05 17.885L17.45 16.355C16.17 17.955 14.21 18.975 12 18.975Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDataThresholding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_thresholding">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H17.27L19 17.27V19ZM19 16H18.15L15.15 19H13.53L16.53 16H14.41L11.41 19H9.8L12.8 16H10.68L7.68 19H5.84L8.84 16H6.72L5 17.72V5H19V16Z"
            fill="currentColor"
          />
          <path
            d="M10.67 11L12.67 13L17.75 7.91L16.34 6.5L12.67 10.17L10.67 8.17L6.25 12.59L7.66 14L10.67 11Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDataUsage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="data_usage">
        <path
          id="Vector"
          d="M13 2.02499V5.05499C16.39 5.54499 19 8.44499 19 11.975C19 12.875 18.82 13.725 18.52 14.515L21.12 16.045C21.68 14.805 22 13.425 22 11.975C22 6.79499 18.05 2.52499 13 2.02499ZM12 18.975C8.13 18.975 5 15.845 5 11.975C5 8.44499 7.61 5.54499 11 5.05499V2.02499C5.94 2.52499 2 6.78499 2 11.975C2 17.495 6.47 21.975 11.99 21.975C15.3 21.975 18.23 20.365 20.05 17.885L17.45 16.355C16.17 17.955 14.21 18.975 12 18.975Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDataset(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dataset">
        <g id="Vector">
          <path d="M11 13H7V17H11V13Z" fill="currentColor" />
          <path d="M17 13H13V17H17V13Z" fill="currentColor" />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path d="M11 7H7V11H11V7Z" fill="currentColor" />
          <path d="M17 7H13V11H17V7Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDatasetLinked(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dataset_linked">
        <g id="Vector">
          <path d="M5.5 16.5H6.59C6.87 14.83 7.83 13.4 9.19 12.5H5.5V16.5Z" fill="currentColor" />
          <path
            d="M3.5 18.5V4.5H17.5V11.5H18.5C18.84 11.5 19.17 11.54 19.5 11.59V4.5C19.5 3.4 18.6 2.5 17.5 2.5H3.5C2.4 2.5 1.5 3.4 1.5 4.5V18.5C1.5 19.6 2.4 20.5 3.5 20.5H7.31C6.96 19.89 6.71 19.22 6.59 18.5H3.5Z"
            fill="currentColor"
          />
          <path d="M9.5 6.5H5.5V10.5H9.5V6.5Z" fill="currentColor" />
          <path d="M15.5 6.5H11.5V10.5H15.5V6.5Z" fill="currentColor" />
          <path
            d="M14.5 19.5H12.5C11.4 19.5 10.5 18.6 10.5 17.5C10.5 16.4 11.4 15.5 12.5 15.5H14.5V13.5H12.5C10.29 13.5 8.5 15.29 8.5 17.5C8.5 19.71 10.29 21.5 12.5 21.5H14.5V19.5Z"
            fill="currentColor"
          />
          <path
            d="M18.5 13.5H16.5V15.5H18.5C19.6 15.5 20.5 16.4 20.5 17.5C20.5 18.6 19.6 19.5 18.5 19.5H16.5V21.5H18.5C20.71 21.5 22.5 19.71 22.5 17.5C22.5 15.29 20.71 13.5 18.5 13.5Z"
            fill="currentColor"
          />
          <path d="M18.5 18.5V16.5H12.5V18.5H18.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDateRange(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="date_range">
        <path
          id="Vector"
          d="M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeblur(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="deblur">
        <g id="Vector">
          <path
            d="M6.25 15C6.80228 15 7.25 14.5523 7.25 14C7.25 13.4477 6.80228 13 6.25 13C5.69772 13 5.25 13.4477 5.25 14C5.25 14.5523 5.69772 15 6.25 15Z"
            fill="currentColor"
          />
          <path
            d="M6.25 19C6.80228 19 7.25 18.5523 7.25 18C7.25 17.4477 6.80228 17 6.25 17C5.69772 17 5.25 17.4477 5.25 18C5.25 18.5523 5.69772 19 6.25 19Z"
            fill="currentColor"
          />
          <path
            d="M6.25 11C6.80228 11 7.25 10.5523 7.25 10C7.25 9.44772 6.80228 9 6.25 9C5.69772 9 5.25 9.44772 5.25 10C5.25 10.5523 5.69772 11 6.25 11Z"
            fill="currentColor"
          />
          <path
            d="M3.25 10.5C3.52614 10.5 3.75 10.2761 3.75 10C3.75 9.72386 3.52614 9.5 3.25 9.5C2.97386 9.5 2.75 9.72386 2.75 10C2.75 10.2761 2.97386 10.5 3.25 10.5Z"
            fill="currentColor"
          />
          <path
            d="M6.25 7C6.80228 7 7.25 6.55228 7.25 6C7.25 5.44772 6.80228 5 6.25 5C5.69772 5 5.25 5.44772 5.25 6C5.25 6.55228 5.69772 7 6.25 7Z"
            fill="currentColor"
          />
          <path
            d="M3.25 14.5C3.52614 14.5 3.75 14.2761 3.75 14C3.75 13.7239 3.52614 13.5 3.25 13.5C2.97386 13.5 2.75 13.7239 2.75 14C2.75 14.2761 2.97386 14.5 3.25 14.5Z"
            fill="currentColor"
          />
          <path
            d="M10.25 21.5C10.5261 21.5 10.75 21.2761 10.75 21C10.75 20.7239 10.5261 20.5 10.25 20.5C9.97386 20.5 9.75 20.7239 9.75 21C9.75 21.2761 9.97386 21.5 10.25 21.5Z"
            fill="currentColor"
          />
          <path
            d="M10.25 3.5C10.5261 3.5 10.75 3.27614 10.75 3C10.75 2.72386 10.5261 2.5 10.25 2.5C9.97386 2.5 9.75 2.72386 9.75 3C9.75 3.27614 9.97386 3.5 10.25 3.5Z"
            fill="currentColor"
          />
          <path
            d="M10.25 7C10.8023 7 11.25 6.55228 11.25 6C11.25 5.44772 10.8023 5 10.25 5C9.69772 5 9.25 5.44772 9.25 6C9.25 6.55228 9.69772 7 10.25 7Z"
            fill="currentColor"
          />
          <path
            d="M10.25 15.5C11.0784 15.5 11.75 14.8284 11.75 14C11.75 13.1716 11.0784 12.5 10.25 12.5C9.42157 12.5 8.75 13.1716 8.75 14C8.75 14.8284 9.42157 15.5 10.25 15.5Z"
            fill="currentColor"
          />
          <path
            d="M10.25 11.5C11.0784 11.5 11.75 10.8284 11.75 10C11.75 9.17157 11.0784 8.5 10.25 8.5C9.42157 8.5 8.75 9.17157 8.75 10C8.75 10.8284 9.42157 11.5 10.25 11.5Z"
            fill="currentColor"
          />
          <path
            d="M10.25 19C10.8023 19 11.25 18.5523 11.25 18C11.25 17.4477 10.8023 17 10.25 17C9.69772 17 9.25 17.4477 9.25 18C9.25 18.5523 9.69772 19 10.25 19Z"
            fill="currentColor"
          />
          <path
            d="M12.25 3V5C16.11 5 19.25 8.14 19.25 12C19.25 15.86 16.11 19 12.25 19V21C17.21 21 21.25 16.96 21.25 12C21.25 7.04 17.21 3 12.25 3Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDeck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="deck">
        <g id="Vector">
          <path
            d="M22 9L12 2L2 9H11V22H13V9H22ZM12 4.44L15.66 7H8.34L12 4.44Z"
            fill="currentColor"
          />
          <path
            d="M4.14 12L2.18 12.37L3 16.74V22H5L5.02 18H7V22H9V16H4.9L4.14 12Z"
            fill="currentColor"
          />
          <path
            d="M19.1 16H15V22H17V18H18.98L19 22H21V16.74L21.82 12.37L19.86 12L19.1 16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDehaze(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dehaze">
        <path
          id="Vector"
          d="M2 16V18H22V16H2ZM2 11V13H22V11H2ZM2 6V8H22V6H2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDelete(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="delete">
        <path
          id="Vector"
          d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeleteForever(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="delete_forever">
        <path
          id="Vector"
          d="M14.12 10.47L12 12.59L9.87 10.47L8.46 11.88L10.59 14L8.47 16.12L9.88 17.53L12 15.41L14.12 17.53L15.53 16.12L13.41 14L15.53 11.88L14.12 10.47ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeleteSweep(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="delete_sweep">
        <path
          id="Vector"
          d="M15 16H19V18H15V16ZM15 8H22V10H15V8ZM15 12H21V14H15V12ZM3 18C3 19.1 3.9 20 5 20H11C12.1 20 13 19.1 13 18V8H3V18ZM5 10H11V18H5V10ZM10 4H6L5 5H2V7H14V5H11L10 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeliveryDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="delivery_dining">
        <g id="Vector">
          <path
            d="M19 7C19 5.9 18.1 5 17 5H14V7H17V9.65L13.52 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19C8.66 19 10 17.66 10 16H14.48L19 10.35V7ZM4 14V13C4 11.9 4.9 11 6 11H8V14H4ZM7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z"
            fill="currentColor"
          />
          <path d="M10 6H5V8H10V6Z" fill="currentColor" />
          <path
            d="M19 13C17.34 13 16 14.34 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 14.34 20.66 13 19 13ZM19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDensityLarge(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="density_large">
        <g id="Vector">
          <path d="M21 3H3V5H21V3Z" fill="currentColor" />
          <path d="M21 19H3V21H21V19Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDensityMedium(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="density_medium">
        <g id="Vector">
          <path d="M21 3H3V5H21V3Z" fill="currentColor" />
          <path d="M21 19H3V21H21V19Z" fill="currentColor" />
          <path d="M21 11H3V13H21V11Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDensitySmall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="density_small">
        <g id="Vector">
          <path d="M21 2H3V4H21V2Z" fill="currentColor" />
          <path d="M21 20H3V22H21V20Z" fill="currentColor" />
          <path d="M21 14H3V16H21V14Z" fill="currentColor" />
          <path d="M21 8H3V10H21V8Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDepartureBoard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="departure_board">
        <g id="Vector">
          <path
            d="M5.5 18C6.32843 18 7 17.3284 7 16.5C7 15.6716 6.32843 15 5.5 15C4.67157 15 4 15.6716 4 16.5C4 17.3284 4.67157 18 5.5 18Z"
            fill="currentColor"
          />
          <path
            d="M12.5 18C13.3284 18 14 17.3284 14 16.5C14 15.6716 13.3284 15 12.5 15C11.6716 15 11 15.6716 11 16.5C11 17.3284 11.6716 18 12.5 18Z"
            fill="currentColor"
          />
          <path
            d="M16 1C13.61 1 11.51 2.2 10.25 4.02C9.84 4.01 9.43 4 9 4C4.58 4 1 4.5 1 8V18C1 18.88 1.39 19.67 2 20.22V22C2 22.55 2.45 23 3 23H4C4.55 23 5 22.55 5 22V21H13V22C13 22.55 13.45 23 14 23H15C15.55 23 16 22.55 16 22V20.22C16.61 19.67 17 18.88 17 18V14.92C20.39 14.43 23 11.53 23 8C23 4.13 19.87 1 16 1ZM9 6H9.29C9.2 6.32 9.13 6.66 9.08 6.99H3.34C3.89 6.46 5.31 6 9 6ZM3 8.99H9.08C9.24 10.1 9.65 11.12 10.26 12H3V8.99ZM15 18C15 18.37 14.79 18.62 14.66 18.73L14.37 19H3.63L3.34 18.73C3.21 18.62 3 18.37 3 18V14H12.41C13.19 14.47 14.06 14.79 15 14.92V18ZM16 13C13.24 13 11 10.76 11 8C11 5.24 13.24 3 16 3C18.76 3 21 5.24 21 8C21 10.76 18.76 13 16 13ZM16.5 4H15V9L18.62 11.16L19.37 9.93L16.5 8.25V4Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDescription(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="description">
        <path
          id="Vector"
          d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeselect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="deselect">
        <path
          id="Vector"
          d="M3.7101 12.29H5.7101V10.29H3.7101V12.29ZM7.7101 20.29H9.7101V18.29H7.7101V20.29ZM13.7101 2.28998H11.7101V4.28998H13.7101V2.28998ZM19.7101 2.28998V4.28998H21.7101C21.7101 3.18998 20.8101 2.28998 19.7101 2.28998ZM5.7101 20.29V18.29H3.7101C3.7101 19.39 4.6101 20.29 5.7101 20.29ZM3.7101 16.29H5.7101V14.29H3.7101V16.29ZM11.7101 20.29H13.7101V18.29H11.7101V20.29ZM19.7101 12.29H21.7101V10.29H19.7101V12.29ZM19.7101 8.28998H21.7101V6.28998H19.7101V8.28998ZM15.7101 4.28998H17.7101V2.28998H15.7101V4.28998ZM8.5401 4.28998L7.7101 3.45998V2.28998H9.7101V4.28998H8.5401ZM20.5401 16.29L19.7101 15.46V14.29H21.7101V16.29H20.5401ZM21.9001 20.48L3.5201 2.09998L2.1001 3.50998L4.8801 6.28998H3.7101V8.28998H5.7101V7.11998L7.7101 9.11998V16.29H14.8801L16.8801 18.29H15.7101V20.29H17.7101V19.12L20.4901 21.9L21.9001 20.48ZM9.7101 14.29V11.12L12.8801 14.29H9.7101ZM15.7101 11.46V8.28998H12.5401L10.5401 6.28998H17.7101V13.46L15.7101 11.46Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDesignServices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="design_services">
        <path
          id="Vector"
          d="M20.8387 7.40124C21.2287 7.01124 21.2287 6.38124 20.8387 5.99124L18.0087 3.16124C17.6187 2.77124 16.9887 2.77124 16.5987 3.16124L12.1087 7.65124L8.21865 3.76124C7.43865 2.98124 6.16865 2.98124 5.38865 3.76124L3.48865 5.66124C2.70865 6.44124 2.70865 7.71124 3.48865 8.49124L7.37865 12.3812L2.86865 16.8912V21.1312H7.10865L11.6287 16.6112L15.5187 20.5012C16.4687 21.4512 17.7487 21.1012 18.3487 20.5012L20.2487 18.6012C21.0287 17.8212 21.0287 16.5512 20.2487 15.7712L16.3587 11.8812L20.8387 7.40124ZM4.90865 7.07124L6.79865 5.17124L8.06865 6.44124L6.88865 7.63124L8.29865 9.04124L9.48865 7.85124L10.6887 9.05124L8.78865 10.9512L4.90865 7.07124ZM16.1387 14.5112L14.9487 15.7012L16.3587 17.1112L17.5487 15.9212L18.8187 17.1912L16.9187 19.0912L13.0287 15.2012L14.9287 13.3012L16.1387 14.5112ZM6.27865 19.1312H4.86865V17.7212L14.4787 8.11124L15.8887 9.52124L6.27865 19.1312ZM15.8887 6.69124L17.2987 5.28124L18.7087 6.69124L17.2987 8.10124L15.8887 6.69124Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDesk(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="desk">
        <path
          id="Vector"
          d="M2 6V18H4V8H14V18H16V16H20V18H22V6H2ZM20 8V10H16V8H20ZM16 14V12H20V14H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDesktopAccessDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="desktop_access_disabled" clipPath="url(#clip0_395_3196)">
        <path
          id="Vector"
          d="M1.91488 0.844971L0.504883 2.25497L1.50488 3.24497V15.155C1.50488 16.255 2.39488 17.155 3.49488 17.155H10.5049V19.155H8.50488V21.155H16.5049V19.155H14.5049V17.155H15.4049L21.4049 23.155L22.8149 21.745L1.91488 0.844971ZM3.49488 15.155V5.24497L13.4049 15.155H3.49488ZM5.05488 1.15497L7.05488 3.15497H21.5049V15.155H19.0549L21.0549 17.155H21.4949C22.5949 17.155 23.4949 16.255 23.4949 15.155V3.15497C23.4949 2.05497 22.5949 1.15497 21.4949 1.15497H5.05488Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_3196">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconDesktopMac(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="desktop_mac">
        <path
          id="Vector"
          d="M21 2H3C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H10L8 21V22H16V21L14 18H21C22.1 18 23 17.1 23 16V4C23 2.9 22.1 2 21 2ZM21 14H3V4H21V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDesktopWindows(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="desktop_windows">
        <path
          id="Vector"
          d="M21 2H3C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H10V20H8V22H16V20H14V18H21C22.1 18 23 17.1 23 16V4C23 2.9 22.1 2 21 2ZM21 16H3V4H21V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDetails(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="details">
        <path
          id="Vector"
          d="M12 3L2 21H22L12 3ZM13 8.92L18.6 19H13V8.92ZM11 8.92V19H5.4L11 8.92Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeveloperBoard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="developer_board">
        <path
          id="Vector"
          d="M22 9V7H20V5C20 3.9 19.1 3 18 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H18C19.1 21 20 20.1 20 19V17H22V15H20V13H22V11H20V9H22ZM18 19H4V5H18V19ZM6 13H11V17H6V13ZM12 7H16V10H12V7ZM6 7H11V12H6V7ZM12 11H16V17H12V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeveloperBoardOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="developer_board_off">
        <path
          id="Vector"
          d="M8.48497 4.295H18.655V14.465L20.485 16.295H22.655V14.295H20.655V12.295H22.655V10.295H20.655V8.295H22.655V6.295H20.655V4.295C20.655 3.195 19.755 2.295 18.655 2.295H6.48497L8.48497 4.295ZM12.655 8.465V6.295H16.655V9.295H13.485L12.655 8.465ZM10.485 6.295H11.655V7.465L10.485 6.295ZM14.485 10.295H16.655V12.465L14.485 10.295ZM18.655 20.295C18.715 20.295 18.765 20.295 18.815 20.285L21.135 22.605L22.545 21.195L2.75497 1.395L1.34497 2.805L2.66497 4.125C2.65497 4.185 2.65497 4.235 2.65497 4.295V18.295C2.65497 19.395 3.55497 20.295 4.65497 20.295H18.655ZM4.65497 18.295V6.125L6.65497 8.125V11.295H9.82497L10.825 12.295H6.65497V16.295H11.655V13.125L12.655 14.125V16.295H14.825L16.825 18.295H4.65497Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeveloperMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="developer_mode">
        <path
          id="Vector"
          d="M7 5H17V7H19V3C19 1.9 18.1 1.01 17 1.01L7 1C5.9 1 5 1.9 5 3V7H7V5ZM15.41 16.59L20 12L15.41 7.41L14 8.83L17.17 12L14 15.17L15.41 16.59ZM10 15.17L6.83 12L10 8.83L8.59 7.41L4 12L8.59 16.59L10 15.17ZM17 19H7V17H5V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V17H17V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeviceHub(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="device_hub">
        <path
          id="Vector"
          d="M17 16L13 12V8.82C14.16 8.4 15 7.3 15 6C15 4.34 13.66 3 12 3C10.34 3 9 4.34 9 6C9 7.3 9.84 8.4 11 8.82V12L7 16H3V21H8V17.95L12 13.75L16 17.95V21H21V16H17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeviceThermostat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="device_thermostat">
        <path
          id="Vector"
          d="M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 11V5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V6H12V7H13V9H12V10H13V11H11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDeviceUnknown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="device_unknown">
        <path
          id="Vector"
          d="M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19ZM12 6.72C10.04 6.72 8.5 8.24 8.5 10.19H10.25C10.25 9.26 11.07 8.44 12 8.44C12.93 8.44 13.75 9.26 13.75 10.19C13.75 11.94 11.12 11.76 11.12 14.64H12.88C12.88 12.68 15.5 12.45 15.5 10.19C15.5 8.23 13.96 6.72 12 6.72ZM11 16H13V18H11V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDevices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="devices">
        <path
          id="Vector"
          d="M4 6H22V4H4C2.9 4 2 4.9 2 6V17H0V20H14V17H4V6ZM23 8H17C16.45 8 16 8.45 16 9V19C16 19.55 16.45 20 17 20H23C23.55 20 24 19.55 24 19V9C24 8.45 23.55 8 23 8ZM22 17H18V10H22V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDevicesFold(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="devices_fold">
        <g id="Vector">
          <path
            d="M20 4.00097H17C17 2.56097 15.53 1.60097 14.21 2.16097L11.21 3.45097C10.48 3.76097 10 4.49097 10 5.29097V20.001C10 21.101 10.9 22.001 12 22.001H20C21.1 22.001 22 21.101 22 20.001V6.00097C22 4.90097 21.1 4.00097 20 4.00097ZM15 17.681L12 18.971V5.29097L15 4.00097V17.681ZM20 20.001H14.67L15.79 19.521C16.52 19.201 17 18.481 17 17.681V6.00097H20V20.001Z"
            fill="currentColor"
          />
          <path d="M4 4.00097H2V6.00097H4V4.00097Z" fill="currentColor" />
          <path d="M4 20.001H2V22.001H4V20.001Z" fill="currentColor" />
          <path d="M4 16.001H2V18.001H4V16.001Z" fill="currentColor" />
          <path d="M4 12.001H2V14.001H4V12.001Z" fill="currentColor" />
          <path d="M4 8.00097H2V10.001H4V8.00097Z" fill="currentColor" />
          <path d="M8 4.00097H6V6.00097H8V4.00097Z" fill="currentColor" />
          <path d="M8 20.001H6V22.001H8V20.001Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDevicesOther(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="devices_other">
        <path
          id="Vector"
          d="M3 6H21V4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H7V18H3V6ZM13 12H9V13.78C8.39 14.33 8 15.11 8 16C8 16.89 8.39 17.67 9 18.22V20H13V18.22C13.61 17.67 14 16.88 14 16C14 15.12 13.61 14.33 13 13.78V12ZM11 17.5C10.17 17.5 9.5 16.83 9.5 16C9.5 15.17 10.17 14.5 11 14.5C11.83 14.5 12.5 15.17 12.5 16C12.5 16.83 11.83 17.5 11 17.5ZM22 8H16C15.5 8 15 8.5 15 9V19C15 19.5 15.5 20 16 20H22C22.5 20 23 19.5 23 19V9C23 8.5 22.5 8 22 8ZM21 18H17V10H21V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDialerSip(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dialer_sip">
        <path
          id="Vector"
          d="M16 3H17V8H16V3ZM15 5H13V4H15V3H12V6H14V7H12V8H15V5ZM18 3V8H19V6H21V3H18ZM20 5H19V4H20V5ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.42 15.17L13.22 17.37C10.39 15.93 8.07 13.62 6.63 10.78L8.83 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.99 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5ZM19 18.97C17.68 18.88 16.41 18.62 15.2 18.22L16.4 17.02C17.25 17.26 18.11 17.41 18.99 17.47V18.97H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDialpad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dialpad">
        <path
          id="Vector"
          d="M12 19C10.9 19 10 19.9 10 21C10 22.1 10.9 23 12 23C13.1 23 14 22.1 14 21C14 19.9 13.1 19 12 19ZM6 1C4.9 1 4 1.9 4 3C4 4.1 4.9 5 6 5C7.1 5 8 4.1 8 3C8 1.9 7.1 1 6 1ZM6 7C4.9 7 4 7.9 4 9C4 10.1 4.9 11 6 11C7.1 11 8 10.1 8 9C8 7.9 7.1 7 6 7ZM6 13C4.9 13 4 13.9 4 15C4 16.1 4.9 17 6 17C7.1 17 8 16.1 8 15C8 13.9 7.1 13 6 13ZM18 5C19.1 5 20 4.1 20 3C20 1.9 19.1 1 18 1C16.9 1 16 1.9 16 3C16 4.1 16.9 5 18 5ZM12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13ZM18 13C16.9 13 16 13.9 16 15C16 16.1 16.9 17 18 17C19.1 17 20 16.1 20 15C20 13.9 19.1 13 18 13ZM18 7C16.9 7 16 7.9 16 9C16 10.1 16.9 11 18 11C19.1 11 20 10.1 20 9C20 7.9 19.1 7 18 7ZM12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C13.1 11 14 10.1 14 9C14 7.9 13.1 7 12 7ZM12 1C10.9 1 10 1.9 10 3C10 4.1 10.9 5 12 5C13.1 5 14 4.1 14 3C14 1.9 13.1 1 12 1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDiamond(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="diamond">
        <path
          id="Vector"
          d="M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDifference(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="difference">
        <path
          id="Vector"
          d="M18.5 23H4.5C3.4 23 2.5 22.1 2.5 21V7H4.5V21H18.5V23ZM15 7V5H13V7H11V9H13V11H15V9H17V7H15ZM17 13H11V15H17V13ZM15.5 1H8.5C7.4 1 6.51 1.9 6.51 3L6.5 17C6.5 18.1 7.39 19 8.49 19H19.5C20.6 19 21.5 18.1 21.5 17V7L15.5 1ZM19.5 17H8.5V3H14.67L19.5 7.83V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dining">
        <path
          id="Vector"
          d="M14.75 6C13.38 6 12.25 7.52 12.25 9.4C12.25 10.88 12.95 12.11 13.92 12.58L14 12.62V19H15.5V12.62L15.58 12.59C16.55 12.12 17.25 10.89 17.25 9.41C17.25 7.53 16.13 6 14.75 6ZM10.5 6C10.23 6 10 6.22 10 6.5V9H9.25V6.5C9.25 6.22 9.03 6 8.75 6C8.47 6 8.25 6.22 8.25 6.5V9H7.5V6.5C7.5 6.22 7.28 6 7 6C6.72 6 6.5 6.22 6.5 6.5V10.3C6.5 11.23 7.14 12.01 8 12.23V19H9.5V12.23C10.36 12.01 11 11.23 11 10.3V6.5C11 6.22 10.78 6 10.5 6ZM20 4H4V20H20V4ZM20 2C21.1 2 22 2.9 22 4V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDinnerDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dinner_dining">
        <g id="Vector">
          <path d="M2 19L4 21H20L22 19H2Z" fill="currentColor" />
          <path
            d="M3 18H19.97C20.26 14.74 17.69 12 14.49 12C12.14 12 10.14 13.48 9.35 15.55C8.94 15.32 8.48 15.17 8 15.08V9H9.75C10.99 9 12 7.99 12 6.75H21V5.25H12C12 4.01 10.99 3 9.75 3H3V4.5H4V5.25H3V6.75H4V7.5H3V9H4V16.39C3.56 16.85 3.22 17.39 3 18ZM14.5 14C15.49 14 16.41 14.4 17.08 15.14C17.32 15.4 17.52 15.69 17.66 16H11.34C11.92 14.79 13.15 14 14.5 14ZM8 4.5H10V5.25H8V4.5ZM8 6.75H10V7.5H8V6.75ZM5.5 4.5H6.5V5.25H5.5V4.5ZM5.5 6.75H6.5V7.5H5.5V6.75ZM5.5 9H6.5V15.06C6.15 15.12 5.82 15.23 5.5 15.36V9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDirections(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions">
        <path
          id="Vector"
          d="M22.4274 10.5931L13.4174 1.58313C12.6674 0.833132 11.3474 0.823132 10.5874 1.58313L1.58744 10.5831C0.807441 11.3631 0.807441 12.6231 1.58744 13.4031L10.5874 22.4031C10.9774 22.7931 11.4874 22.9831 11.9974 22.9831C12.5074 22.9831 13.0174 22.7931 13.4074 22.4031L22.3974 13.4131C23.1874 12.6531 23.1974 11.3931 22.4274 10.5931ZM12.0074 20.9931L3.00744 11.9931L12.0074 2.99313L21.0074 11.9931L12.0074 20.9931ZM7.99744 11.0031V15.0031H9.99744V12.0031H13.9974V14.5031L17.4974 11.0031L13.9974 7.50313V10.0031H8.99744C8.44744 10.0031 7.99744 10.4531 7.99744 11.0031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDirectionsBike(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_bike">
        <path
          id="Vector"
          d="M15.5 5.75C16.6 5.75 17.5 4.85 17.5 3.75C17.5 2.65 16.6 1.75 15.5 1.75C14.4 1.75 13.5 2.65 13.5 3.75C13.5 4.85 14.4 5.75 15.5 5.75ZM5 12.25C2.2 12.25 0 14.45 0 17.25C0 20.05 2.2 22.25 5 22.25C7.8 22.25 10 20.05 10 17.25C10 14.45 7.8 12.25 5 12.25ZM5 20.75C3.1 20.75 1.5 19.15 1.5 17.25C1.5 15.35 3.1 13.75 5 13.75C6.9 13.75 8.5 15.35 8.5 17.25C8.5 19.15 6.9 20.75 5 20.75ZM10.8 10.75L13.2 8.35L14 9.15C15.3 10.45 17 11.25 19.1 11.25V9.25C17.6 9.25 16.4 8.65 15.5 7.75L13.6 5.85C13.1 5.45 12.6 5.25 12 5.25C11.4 5.25 10.9 5.45 10.6 5.85L7.8 8.65C7.4 9.05 7.2 9.55 7.2 10.05C7.2 10.65 7.4 11.15 7.8 11.45L11 14.25V19.25H13V13.05L10.8 10.75ZM19 12.25C16.2 12.25 14 14.45 14 17.25C14 20.05 16.2 22.25 19 22.25C21.8 22.25 24 20.05 24 17.25C24 14.45 21.8 12.25 19 12.25ZM19 20.75C17.1 20.75 15.5 19.15 15.5 17.25C15.5 15.35 17.1 13.75 19 13.75C20.9 13.75 22.5 15.35 22.5 17.25C22.5 19.15 20.9 20.75 19 20.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDirectionsBoat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_boat">
        <path
          id="Vector"
          d="M13.0011 3V4H11.0011V3H13.0011ZM12.0011 10.11L17.3811 11.88L19.7711 12.66L18.6511 16.63C18.1111 16.33 17.7111 15.92 17.5111 15.69L16.0011 13.96L14.4911 15.68C14.1511 16.08 13.2111 17 12.0011 17C10.7911 17 9.85111 16.08 9.51111 15.68L8.00111 13.96L6.49111 15.68C6.29111 15.91 5.89111 16.31 5.35111 16.61L4.22111 12.65L6.62111 11.86L12.0011 10.11ZM15.0011 1H9.00111V4H6.00111C4.90111 4 4.00111 4.9 4.00111 6V10.62L2.71111 11.04C2.45111 11.12 2.23111 11.3 2.11111 11.54C1.99111 11.78 1.96111 12.06 2.05111 12.32L3.95111 19H4.00111C5.60111 19 7.02111 18.12 8.00111 17C8.98111 18.12 10.4011 19 12.0011 19C13.6011 19 15.0211 18.12 16.0011 17C16.9811 18.12 18.4011 19 20.0011 19H20.0511L21.9411 12.32C22.0211 12.06 22.0011 11.78 21.8811 11.54C21.7611 11.3 21.5411 11.12 21.2811 11.04L20.0011 10.62V6C20.0011 4.9 19.1011 4 18.0011 4H15.0011V1ZM6.00111 9.97V6H18.0011V9.97L12.0011 8L6.00111 9.97ZM16.0011 19.68C14.7811 20.53 13.3911 20.96 12.0011 20.96C10.6111 20.96 9.22111 20.53 8.00111 19.68C6.78111 20.53 5.39111 21 4.00111 21H2.00111V23H4.00111C5.38111 23 6.74111 22.65 8.00111 22.01C9.26111 22.65 10.6311 22.98 12.0011 22.98C13.3711 22.98 14.7411 22.66 16.0011 22.01C17.2611 22.66 18.6211 23 20.0011 23H22.0011V21H20.0011C18.6111 21 17.2211 20.53 16.0011 19.68Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDirectionsBus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_bus">
        <g id="Vector">
          <path
            d="M12 2.5C7.58 2.5 4 3 4 6.5V16.5C4 17.38 4.39 18.17 5 18.72V20.5C5 21.05 5.45 21.5 6 21.5H7C7.55 21.5 8 21.05 8 20.5V19.5H16V20.5C16 21.05 16.45 21.5 17 21.5H18C18.55 21.5 19 21.05 19 20.5V18.72C19.61 18.17 20 17.38 20 16.5V6.5C20 3 16.42 2.5 12 2.5ZM17.66 5.49H6.34C6.89 4.96 8.31 4.5 12 4.5C15.69 4.5 17.11 4.96 17.66 5.49ZM18 7.49V10.5H6V7.49H18ZM17.66 17.23L17.37 17.5H6.63L6.34 17.23C6.21 17.12 6 16.87 6 16.5V12.5H18V16.5C18 16.87 17.79 17.12 17.66 17.23Z"
            fill="currentColor"
          />
          <path
            d="M8.5 16.5C9.32843 16.5 10 15.8284 10 15C10 14.1716 9.32843 13.5 8.5 13.5C7.67157 13.5 7 14.1716 7 15C7 15.8284 7.67157 16.5 8.5 16.5Z"
            fill="currentColor"
          />
          <path
            d="M15.5 16.5C16.3284 16.5 17 15.8284 17 15C17 14.1716 16.3284 13.5 15.5 13.5C14.6716 13.5 14 14.1716 14 15C14 15.8284 14.6716 16.5 15.5 16.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDirectionsCar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_car">
        <g id="Vector">
          <path
            d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.85 6H17.14L18.22 9.11H5.77L6.85 6ZM19 16H5V11H19V16Z"
            fill="currentColor"
          />
          <path
            d="M7.5 15C8.32843 15 9 14.3284 9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15Z"
            fill="currentColor"
          />
          <path
            d="M16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDirectionsOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_off">
        <g id="Vector">
          <path
            d="M22.0143 10.9862L13.0143 1.98617C12.9218 1.89347 12.8119 1.81992 12.691 1.76974C12.57 1.71956 12.4403 1.69373 12.3093 1.69373C12.1784 1.69373 12.0487 1.71956 11.9277 1.76974C11.8067 1.81992 11.6968 1.89347 11.6043 1.98617L8.51434 5.07617L9.92434 6.48617L12.3043 4.11617L19.8843 11.6962L17.5043 14.0762L18.9143 15.4862L22.0043 12.3962C22.4043 12.0262 22.4043 11.3962 22.0143 10.9862Z"
            fill="currentColor"
          />
          <path
            d="M13.3043 7.19617V9.86617L15.4743 12.0362L16.8043 10.6962L13.3043 7.19617Z"
            fill="currentColor"
          />
          <path
            d="M1.69434 3.91617L5.68434 7.90617L2.59434 10.9962C2.50163 11.0887 2.42808 11.1986 2.3779 11.3195C2.32772 11.4405 2.30189 11.5702 2.30189 11.7012C2.30189 11.8321 2.32772 11.9618 2.3779 12.0828C2.42808 12.2038 2.50163 12.3137 2.59434 12.4062L11.5943 21.4062C11.9843 21.7962 12.6143 21.7962 13.0043 21.4062L16.0943 18.3162L20.0843 22.3062L21.4943 20.8962L3.11434 2.50617L1.69434 3.91617ZM8.33434 10.5462C8.32434 10.5962 8.29434 10.6462 8.29434 10.6962V14.6962H10.2943V12.5162L14.6743 16.8962L12.3043 19.2762L4.72434 11.6962L7.10434 9.31617L8.33434 10.5462Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDirectionsRailway(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_railway">
        <path
          id="Vector"
          d="M12 2C7.58 2 4 2.5 4 6V16.5C4 18.43 5.57 20 7.5 20L6 21.5V22H18V21.5L16.5 20C18.43 20 20 18.43 20 16.5V6C20 2.5 16.42 2 12 2ZM12 4C18 4 18 5.2 18 6H6C6 5.2 6 4 12 4ZM18 8V11H6V8H18ZM16.5 18H7.5C6.67 18 6 17.33 6 16.5V13H18V16.5C18 17.33 17.33 18 16.5 18ZM12 13.5C10.9 13.5 10 14.4 10 15.5C10 16.6 10.9 17.5 12 17.5C13.1 17.5 14 16.6 14 15.5C14 14.4 13.1 13.5 12 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDirectionsRun(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_run">
        <path
          id="Vector"
          d="M14.55 5.25C15.65 5.25 16.55 4.35 16.55 3.25C16.55 2.15 15.65 1.25 14.55 1.25C13.45 1.25 12.55 2.15 12.55 3.25C12.55 4.35 13.45 5.25 14.55 5.25ZM10.95 19.15L11.95 14.75L14.05 16.75V22.75H16.05V15.25L13.95 13.25L14.55 10.25C15.85 11.75 17.85 12.75 20.05 12.75V10.75C18.15 10.75 16.55 9.75 15.75 8.35L14.75 6.75C14.35 6.15 13.75 5.75 13.05 5.75C12.75 5.75 12.55 5.85 12.25 5.85L7.04995 8.05V12.75H9.04995V9.35L10.85 8.65L9.24995 16.75L4.34995 15.75L3.94995 17.75L10.95 19.15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDirectionsSubway(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_subway">
        <g id="Vector">
          <path
            d="M12 2.5C8 2.5 4 3 4 6.5V16C4 17.93 5.57 19.5 7.5 19.5L6 21V21.5H18V21L16.5 19.5C18.43 19.5 20 17.93 20 16V6.5C20 3 16.42 2.5 12 2.5ZM17.66 5.5H6.43C7.04 4.98 8.49 4.5 12 4.5C15.71 4.5 17.12 4.96 17.66 5.5ZM11 7.5V10.5H6V7.5H11ZM13 7.5H18V10.5H13V7.5ZM16.5 17.5H7.5C6.67 17.5 6 16.83 6 16V12.5H18V16C18 16.83 17.33 17.5 16.5 17.5Z"
            fill="currentColor"
          />
          <path
            d="M8.5 16.5C9.32843 16.5 10 15.8284 10 15C10 14.1716 9.32843 13.5 8.5 13.5C7.67157 13.5 7 14.1716 7 15C7 15.8284 7.67157 16.5 8.5 16.5Z"
            fill="currentColor"
          />
          <path
            d="M15.5 16.5C16.3284 16.5 17 15.8284 17 15C17 14.1716 16.3284 13.5 15.5 13.5C14.6716 13.5 14 14.1716 14 15C14 15.8284 14.6716 16.5 15.5 16.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDirectionsWalk(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="directions_walk">
        <path
          id="Vector"
          d="M13 5.25C14.1 5.25 15 4.35 15 3.25C15 2.15 14.1 1.25 13 1.25C11.9 1.25 11 2.15 11 3.25C11 4.35 11.9 5.25 13 5.25ZM9.3 8.65L6.5 22.75H8.6L10.4 14.75L12.5 16.75V22.75H14.5V15.25L12.4 13.25L13 10.25C14.3 11.75 16.3 12.75 18.5 12.75V10.75C16.6 10.75 15 9.75 14.2 8.35L13.2 6.75C12.64 5.86 11.52 5.5 10.55 5.91L5.5 8.05V12.75H7.5V9.35L9.3 8.65Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDirtyLens(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dirty_lens">
        <g id="Vector">
          <path
            d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H12.98C12.76 18.16 12.46 17.24 12.85 16.67C13.66 15.55 15.52 18.44 16.66 16.58C17.43 15.01 15.08 15.29 15.02 14.46C14.97 13.62 18.7 14.63 18.06 12.8C17.45 11.07 15.64 13.28 15.3 12.27C14.72 10.53 20 10.59 18.15 8.26C16.39 6.04 15.68 11.11 13.74 10.59C12.4 10.23 12.73 7.71 11.09 8.15C9.21 8.66 12.12 10.35 11.09 11.01C10.13 11.64 9.37 10.09 8.58 9.82C8.38 9.75 7.89 9.77 7.67 10.01C6.89 10.87 7.95 11.17 7.92 11.92C7.9 12.67 6.33 12.41 6.41 13.41C6.53 15.01 8.59 13.86 8.81 14.65C9.36 16.63 6.92 16.8 8.31 17.92C9.84 18.63 10.22 15.98 11.11 16.57C11.69 16.95 11.41 18.02 11.27 19H4V7H8.05L9.88 5H14.12L15.95 7H20V19Z"
            fill="currentColor"
          />
          <path
            d="M17.28 17.15C17.28 17.63 17.67 18.01 18.14 18.01C18.62 18.01 19 17.63 19 17.15C19 16.67 18.61 16.29 18.14 16.29C17.66 16.29 17.28 16.67 17.28 17.15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDisabledByDefault(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="disabled_by_default">
        <path
          id="Vector"
          d="M19 19H5V5H19V19ZM3 3V21H21V3H3ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDisabledVisible(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="disabled_visible">
        <path
          id="Vector"
          d="M16 15C17.95 15 19.76 15.98 20.75 17.5C19.76 19.02 17.95 20 16 20C14.05 20 12.24 19.02 11.25 17.5C12.24 15.98 14.05 15 16 15ZM16 13C12.82 13 10.1 14.87 9 17.5C10.1 20.13 12.82 22 16 22C19.18 22 21.9 20.13 23 17.5C21.9 14.87 19.18 13 16 13ZM16 19C15.17 19 14.5 18.33 14.5 17.5C14.5 16.67 15.17 16 16 16C16.83 16 17.5 16.67 17.5 17.5C17.5 18.33 16.83 19 16 19ZM20.99 12.34C21 12.23 21 12.11 21 12C21 6.48 16.52 2 11 2C5.48 2 1 6.48 1 12C1 17.17 4.93 21.43 9.96 21.95C9.03 21.22 8.24 20.31 7.64 19.27C4.9 18 3 15.22 3 12C3 10.15 3.63 8.45 4.69 7.1L10.35 12.76C10.91 12.36 11.52 12.03 12.17 11.76L6.1 5.69C7.45 4.63 9.15 4 11 4C15.24 4 18.7 7.29 18.98 11.45C19.69 11.67 20.37 11.97 20.99 12.34Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDiscFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="disc_full">
        <path
          id="Vector"
          d="M20 7H22V12H20V7ZM10 4C5.58 4 2 7.58 2 12C2 16.42 5.58 20 10 20C14.42 20 18 16.42 18 12C18 7.58 14.42 4 10 4ZM10 18C6.69 18 4 15.31 4 12C4 8.69 6.69 6 10 6C13.31 6 16 8.69 16 12C16 15.31 13.31 18 10 18ZM20 14H22V16H20V14ZM10 10C8.9 10 8 10.9 8 12C8 13.1 8.9 14 10 14C11.1 14 12 13.1 12 12C12 10.9 11.1 10 10 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDiscount(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="discount">
        <g id="Vector">
          <path
            d="M12.7876 21.5025L2.99756 11.7125V13.7125C2.99756 14.2425 3.20756 14.7525 3.58756 15.1225L11.3776 22.9125C12.1576 23.6925 13.4276 23.6925 14.2076 22.9125L20.4176 16.7025C21.1976 15.9225 21.1976 14.6525 20.4176 13.8725L12.7876 21.5025Z"
            fill="currentColor"
          />
          <path
            d="M11.3776 17.9125C11.7676 18.3025 12.2776 18.5025 12.7876 18.5025C13.2976 18.5025 13.8076 18.3025 14.1976 17.9125L20.4076 11.7025C21.1876 10.9225 21.1876 9.6525 20.4076 8.8725L12.6176 1.0825C12.2476 0.712502 11.7376 0.502502 11.2076 0.502502H4.99756C3.89756 0.502502 2.99756 1.4025 2.99756 2.5025V8.7125C2.99756 9.2425 3.20756 9.7525 3.58756 10.1225L11.3776 17.9125ZM4.99756 2.5025H11.2076L18.9976 10.2925L12.7876 16.5025L4.99756 8.7125V2.5025Z"
            fill="currentColor"
          />
          <path
            d="M7.24756 6.0025C7.93791 6.0025 8.49756 5.44286 8.49756 4.7525C8.49756 4.06215 7.93791 3.5025 7.24756 3.5025C6.5572 3.5025 5.99756 4.06215 5.99756 4.7525C5.99756 5.44286 6.5572 6.0025 7.24756 6.0025Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDisplaySettings(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="display_settings">
        <g id="Vector">
          <path
            d="M20 3H4C2.89 3 2 3.89 2 5V17C2 18.1 2.89 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V5C22 3.89 21.1 3 20 3ZM20 17H4V5H20V17Z"
            fill="currentColor"
          />
          <path d="M14 8.25H6V9.75H14V8.25Z" fill="currentColor" />
          <path d="M16.5 9.75H18V8.25H16.5V7H15V11H16.5V9.75Z" fill="currentColor" />
          <path d="M18 12.25H10V13.75H18V12.25Z" fill="currentColor" />
          <path d="M7.5 15H9V11H7.5V12.25H6V13.75H7.5V15Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDiversity1(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="diversity_1">
        <g id="Vector">
          <path
            d="M4 16.5C5.10457 16.5 6 15.6046 6 14.5C6 13.3954 5.10457 12.5 4 12.5C2.89543 12.5 2 13.3954 2 14.5C2 15.6046 2.89543 16.5 4 16.5Z"
            fill="currentColor"
          />
          <path
            d="M1.22 18.08C0.48 18.4 0 19.12 0 19.93V21.5H4.5V19.89C4.5 19.06 4.73 18.28 5.13 17.6C4.76 17.54 4.39 17.5 4 17.5C3.01 17.5 2.07 17.71 1.22 18.08Z"
            fill="currentColor"
          />
          <path
            d="M20 16.5C21.1046 16.5 22 15.6046 22 14.5C22 13.3954 21.1046 12.5 20 12.5C18.8954 12.5 18 13.3954 18 14.5C18 15.6046 18.8954 16.5 20 16.5Z"
            fill="currentColor"
          />
          <path
            d="M22.78 18.08C21.93 17.71 20.99 17.5 20 17.5C19.61 17.5 19.24 17.54 18.87 17.6C19.27 18.28 19.5 19.06 19.5 19.89V21.5H24V19.93C24 19.12 23.52 18.4 22.78 18.08Z"
            fill="currentColor"
          />
          <path
            d="M16.24 17.15C15.07 16.63 13.63 16.25 12 16.25C10.37 16.25 8.93 16.64 7.76 17.15C6.68 17.63 6 18.71 6 19.89V21.5H18V19.89C18 18.71 17.32 17.63 16.24 17.15ZM8.07 19.5C8.16 19.27 8.34 19.08 8.56 18.98C9.66 18.49 10.82 18.25 11.99 18.25C13.17 18.25 14.32 18.5 15.42 18.98C15.65 19.08 15.82 19.27 15.91 19.5H8.07Z"
            fill="currentColor"
          />
          <path
            d="M9 12.5C9 14.16 10.34 15.5 12 15.5C13.66 15.5 15 14.16 15 12.5C15 10.84 13.66 9.5 12 9.5C10.34 9.5 9 10.84 9 12.5ZM13 12.5C13 13.05 12.55 13.5 12 13.5C11.45 13.5 11 13.05 11 12.5C11 11.95 11.45 11.5 12 11.5C12.55 11.5 13 11.95 13 12.5Z"
            fill="currentColor"
          />
          <path
            d="M2.48 11.36C2.17 10.6 2 9.86 2 9.1C2 6.52 4.02 4.5 6.6 4.5C9.28 4.5 10.42 6.24 12 8.09C13.57 6.26 14.7 4.5 17.4 4.5C19.98 4.5 22 6.52 22 9.1C22 9.86 21.83 10.6 21.52 11.36C22.17 11.67 22.7 12.18 23.05 12.8C23.65 11.6 24 10.38 24 9.1C24 5.4 21.1 2.5 17.4 2.5C15.31 2.5 13.31 3.47 12 5.01C10.69 3.47 8.69 2.5 6.6 2.5C2.9 2.5 0 5.4 0 9.1C0 10.38 0.35 11.6 0.96 12.8C1.31 12.18 1.84 11.67 2.48 11.36Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDiversity2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="diversity_2" clipPath="url(#clip0_395_310)">
        <g id="Vector">
          <path
            d="M10.0962 15.89L11.5162 14.47C8.78621 12.04 6.9962 10.4 6.9962 8.83999C6.9962 7.78999 7.7962 6.98999 8.8462 6.98999C9.9562 6.98999 10.3862 7.63999 11.5262 8.98999H12.4562C13.5762 7.67999 13.9862 6.98999 15.1362 6.98999C16.0062 6.98999 16.6862 7.52999 16.9062 8.30999C17.2562 8.26999 17.5862 8.24999 17.9062 8.24999C18.2662 8.24999 18.6062 8.27999 18.9362 8.32999C18.6962 6.41999 17.1262 4.98999 15.1462 4.98999C15.0262 4.98999 14.9162 5.01999 14.7962 5.02999C14.9162 4.69999 14.9962 4.35999 14.9962 3.98999C14.9962 2.32999 13.6562 0.98999 11.9962 0.98999C10.3362 0.98999 8.9962 2.32999 8.9962 3.98999C8.9962 4.35999 9.0762 4.69999 9.1962 5.02999C9.0762 5.01999 8.9662 4.98999 8.8462 4.98999C6.6862 4.98999 4.9962 6.67999 4.9962 8.83999C4.9962 11.26 7.0362 13.15 10.0962 15.89Z"
            fill="currentColor"
          />
          <path
            d="M22.4962 16.23C22.1762 16.05 21.8362 15.94 21.4962 15.88C21.5662 15.78 21.6462 15.7 21.7062 15.6C22.7862 13.73 22.1662 11.42 20.2962 10.34C18.2062 9.12999 15.5362 9.94999 11.6462 11.24L12.1662 13.18C15.6362 12.04 17.9562 11.3 19.3062 12.08C20.2162 12.61 20.5062 13.69 19.9862 14.61C19.4262 15.57 18.6562 15.61 16.9162 15.93L16.4462 16.74C17.0262 18.36 17.4162 19.07 16.8362 20.06C16.3062 20.97 15.2262 21.26 14.3062 20.74C14.2462 20.71 14.1962 20.65 14.1362 20.61C13.8362 21.28 13.4962 21.85 13.1062 22.34C13.1762 22.38 13.2362 22.43 13.3062 22.48C15.1762 23.56 17.4862 22.94 18.5662 21.07C18.6262 20.97 18.6562 20.86 18.7062 20.75C18.9262 21.02 19.1862 21.26 19.5062 21.44C20.9362 22.27 22.7762 21.78 23.6062 20.34C24.4362 18.9 23.9262 17.05 22.4962 16.23Z"
            fill="currentColor"
          />
          <path
            d="M12.3162 14C11.5762 17.58 11.0462 19.95 9.6962 20.73C8.7862 21.26 7.6962 20.97 7.1662 20.05C6.6062 19.09 6.9662 18.39 7.5562 16.73L7.0962 15.92C5.3962 15.61 4.5962 15.59 4.0262 14.6C3.4962 13.69 3.7862 12.6 4.7062 12.07C4.7962 12.02 4.8962 11.99 4.9962 11.96C4.6462 11.4 4.3562 10.79 4.1762 10.11C4.0162 10.18 3.8562 10.25 3.6962 10.34C1.8262 11.42 1.2062 13.73 2.2862 15.6C2.3462 15.7 2.4262 15.78 2.4962 15.88C2.1562 15.94 1.8162 16.05 1.4962 16.23C0.066204 17.06 -0.433796 18.89 0.396204 20.33C1.2262 21.77 3.0562 22.26 4.4962 21.43C4.8162 21.25 5.0762 21.01 5.2962 20.74C5.3462 20.85 5.3762 20.96 5.4362 21.06C6.5162 22.93 8.8262 23.55 10.6962 22.47C12.7862 21.26 13.4062 18.54 14.2462 14.53L12.3162 14Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_310">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconDiversity3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="diversity_3">
        <g id="Vector">
          <path
            d="M6.32 13.01C7.28 13.03 8.17 13.51 8.77 14.35C9.5 15.38 10.71 16 12 16C13.29 16 14.5 15.38 15.23 14.34C15.83 13.5 16.72 13.02 17.68 13C16.96 11.78 14.08 11 12 11C9.93 11 7.04 11.78 6.32 13.01Z"
            fill="currentColor"
          />
          <path
            d="M4 13C5.66 13 7 11.66 7 10C7 8.34 5.66 7 4 7C2.34 7 1 8.34 1 10C1 11.66 2.34 13 4 13Z"
            fill="currentColor"
          />
          <path
            d="M20 13C21.66 13 23 11.66 23 10C23 8.34 21.66 7 20 7C18.34 7 17 8.34 17 10C17 11.66 18.34 13 20 13Z"
            fill="currentColor"
          />
          <path
            d="M12 10C13.66 10 15 8.66 15 7C15 5.34 13.66 4 12 4C10.34 4 9 5.34 9 7C9 8.66 10.34 10 12 10Z"
            fill="currentColor"
          />
          <path
            d="M21 14H17.73C16.96 14 16.38 14.45 16.05 14.92C16.01 14.98 14.69 17 12 17C10.57 17 8.97 16.36 7.95 14.92C7.56 14.37 6.95 14 6.27 14H3C1.9 14 1 14.9 1 16V20H8V17.74C9.15 18.54 10.54 19 12 19C13.46 19 14.85 18.54 16 17.74V20H23V16C23 14.9 22.1 14 21 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDns(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dns">
        <path
          id="Vector"
          d="M19 15V19H5V15H19ZM20 13H4C3.45 13 3 13.45 3 14V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V14C21 13.45 20.55 13 20 13ZM7 18.5C6.18 18.5 5.5 17.83 5.5 17C5.5 16.17 6.18 15.5 7 15.5C7.82 15.5 8.5 16.17 8.5 17C8.5 17.83 7.83 18.5 7 18.5ZM19 5V9H5V5H19ZM20 3H4C3.45 3 3 3.45 3 4V10C3 10.55 3.45 11 4 11H20C20.55 11 21 10.55 21 10V4C21 3.45 20.55 3 20 3ZM7 8.5C6.18 8.5 5.5 7.83 5.5 7C5.5 6.17 6.18 5.5 7 5.5C7.82 5.5 8.5 6.18 8.5 7C8.5 7.82 7.83 8.5 7 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoDisturb(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_disturb">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoDisturbAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_disturb_alt">
        <path
          id="Vector"
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM4 12C4 7.6 7.6 4 12 4C13.8 4 15.5 4.6 16.9 5.7L5.7 16.9C4.6 15.5 4 13.8 4 12ZM12 20C10.2 20 8.5 19.4 7.1 18.3L18.3 7.1C19.4 8.5 20 10.2 20 12C20 16.4 16.4 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoDisturbOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_disturb_off">
        <path
          id="Vector"
          d="M12.5 3.5C16.91 3.5 20.5 7.09 20.5 11.5C20.5 12.91 20.13 14.23 19.49 15.38L20.95 16.84C21.93 15.29 22.5 13.46 22.5 11.5C22.5 5.98 18.02 1.5 12.5 1.5C10.54 1.5 8.71 2.07 7.17 3.05L8.63 4.51C9.77 3.87 11.09 3.5 12.5 3.5ZM17.5 10.5H14.62L16.62 12.5H17.5V10.5ZM2.91 1.63L1.5 3.04L4.28 5.82C3.16 7.43 2.5 9.39 2.5 11.5C2.5 17.02 6.98 21.5 12.5 21.5C14.61 21.5 16.57 20.84 18.18 19.72L20.96 22.5L22.37 21.09L2.91 1.63ZM12.5 19.5C8.09 19.5 4.5 15.91 4.5 11.5C4.5 9.94 4.95 8.5 5.73 7.27L8.96 10.5H7.5V12.5H10.96L16.73 18.27C15.5 19.05 14.06 19.5 12.5 19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoDisturbOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_disturb_on">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM7 11H17V13H7V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoNotDisturb(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_disturb">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoNotDisturbAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_disturb_alt">
        <path
          id="Vector"
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM4 12C4 7.6 7.6 4 12 4C13.8 4 15.5 4.6 16.9 5.7L5.7 16.9C4.6 15.5 4 13.8 4 12ZM12 20C10.2 20 8.5 19.4 7.1 18.3L18.3 7.1C19.4 8.5 20 10.2 20 12C20 16.4 16.4 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoNotDisturbOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_disturb_off">
        <g id="Vector">
          <path
            d="M8.24507 4.81495C9.44507 4.10495 10.8251 3.69495 12.3051 3.69495C16.7151 3.69495 20.3051 7.28495 20.3051 11.6949C20.3051 13.1749 19.8951 14.5549 19.1851 15.7549L20.6451 17.2149C21.6951 15.6249 22.3051 13.7349 22.3051 11.6949C22.3051 6.17495 17.8251 1.69495 12.3051 1.69495C10.2651 1.69495 8.37507 2.30495 6.79507 3.35495L8.24507 4.81495Z"
            fill="currentColor"
          />
          <path
            d="M3.11507 2.50495L1.69507 3.91495L3.96507 6.18495C2.91507 7.76495 2.30507 9.65495 2.30507 11.6949C2.30507 17.2149 6.78507 21.6949 12.3051 21.6949C14.3451 21.6949 16.2351 21.0849 17.8151 20.0349L20.0851 22.3049L21.4951 20.8949L3.11507 2.50495ZM12.3051 19.6949C7.89507 19.6949 4.30507 16.1049 4.30507 11.6949C4.30507 10.2149 4.71507 8.83495 5.42507 7.63495L8.47507 10.6949H7.30507V12.6949H10.4751L16.3551 18.5749C15.1651 19.2849 13.7851 19.6949 12.3051 19.6949Z"
            fill="currentColor"
          />
          <path d="M14.1351 10.6949L16.1351 12.6949H17.3051V10.6949H14.1351Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDoNotDisturbOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_disturb_on">
        <path
          id="Vector"
          d="M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoNotDisturbOnTotalSilence(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_disturb_on_total_silence">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C8.7 6 6 8.7 6 12C6 15.3 8.7 18 12 18C15.3 18 18 15.3 18 12C18 8.7 15.4 6 12 6ZM15 13H9V11H15V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoNotStep(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_step">
        <path
          id="Vector"
          d="M18.51 15.375L17.1 13.965L21.58 9.48501L23 10.895L18.51 15.375ZM14.98 11.845L18.05 8.77501L13.8 4.51501L10.72 7.58501L9.3 6.16501L13.8 1.69501L20.88 8.77501L16.4 13.255L14.98 11.845ZM21.18 20.895L19.77 22.305L13.83 16.365L10.5 19.695H1V17.065C1 16.225 1.52 15.495 2.3 15.185C2.88 14.955 3.58 14.625 4.27 14.165L5.65 15.545C5.74 15.645 5.87 15.695 6 15.695C6.13 15.695 6.26 15.645 6.36 15.545C6.56 15.345 6.56 15.035 6.36 14.835L5.08 13.555C5.35 13.315 5.61 13.045 5.85 12.755L7.12 14.025C7.21 14.125 7.35 14.175 7.47 14.175C7.59 14.175 7.72 14.125 7.82 14.025C8.02 13.825 8.02 13.515 7.82 13.315L6.42 11.915C6.61 11.575 6.76 11.195 6.87 10.795L8.58 12.515C8.67 12.615 8.81 12.665 8.93 12.665C9.05 12.665 9.18 12.615 9.28 12.515C9.47 12.315 9.47 12.015 9.29 11.815L1.39 3.91501L2.81 2.50501L21.18 20.895ZM12.42 14.955L10.75 13.275L7.42 16.595C6.64 17.375 5.37 17.375 4.59 16.585L4.4 16.415L3.93 16.655C3.64 16.795 3.34 16.925 3.04 17.045L3.03 17.695H9.67L12.42 14.955Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoNotTouch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="do_not_touch">
        <path
          id="Vector"
          d="M3.5201 3.01001L2.1001 4.42001L7.7101 10.03V14.33L5.1101 12.85C4.9401 12.76 4.7701 12.71 4.5701 12.71C4.3101 12.71 4.0701 12.8 3.8701 12.97L2.7101 14.08L9.5101 21.26C10.0801 21.86 10.8601 22.2 11.6901 22.2H17.7101C18.3301 22.2 18.8901 22.01 19.3701 21.68L20.4901 22.8L21.9001 21.39L3.5201 3.01001ZM17.7101 20.2H11.7101C11.3201 20.2 11.0701 19.97 10.9601 19.84L7.5801 16.2H9.7101V12.03L17.8501 20.17C17.8001 20.18 17.7601 20.2 17.7101 20.2ZM14.5401 11.2H14.7101V3.45001C14.7101 2.76001 15.2701 2.20001 15.9601 2.20001C16.6501 2.20001 17.2101 2.76001 17.2101 3.45001V11.2H18.2101V5.45001C18.2101 4.76001 18.7701 4.20001 19.4601 4.20001C20.1501 4.20001 20.7101 4.76001 20.7101 5.45001V17.37L18.7101 15.37V13.2H16.5401L14.5401 11.2ZM13.7101 10.37V2.45001C13.7101 1.76001 13.1501 1.20001 12.4601 1.20001C11.7701 1.20001 11.2101 1.76001 11.2101 2.45001V7.87001L13.7101 10.37ZM10.2101 6.87001V4.45001C10.2101 3.76001 9.6501 3.20001 8.9601 3.20001C8.2901 3.20001 7.7601 3.73001 7.7201 4.38001L10.2101 6.87001Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dock">
        <path
          id="Vector"
          d="M8 23H16V21H8V23ZM16 1.01L8 1C6.9 1 6 1.9 6 3V17C6 18.1 6.9 19 8 19H16C17.1 19 18 18.1 18 17V3C18 1.9 17.1 1.01 16 1.01ZM16 15H8V5H16V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDocumentScanner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="document_scanner">
        <path
          id="Vector"
          d="M7 3H4V6H2V1H7V3ZM22 6V1H17V3H20V6H22ZM7 21H4V18H2V23H7V21ZM20 18V21H17V23H22V18H20ZM17 6H7V18H17V6ZM19 18C19 19.1 18.1 20 17 20H7C5.9 20 5 19.1 5 18V6C5 4.9 5.9 4 7 4H17C18.1 4 19 4.9 19 6V18ZM15 8H9V10H15V8ZM15 11H9V13H15V11ZM15 14H9V16H15V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDomain(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="domain">
        <path
          id="Vector"
          d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDomainAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="domain_add">
        <path
          id="Vector"
          d="M11 6V2H1V20H15V18H11V16H13V14H11V12H13V10H11V8H19V14H21V6H11ZM5 18H3V16H5V18ZM5 14H3V12H5V14ZM5 10H3V8H5V10ZM5 6H3V4H5V6ZM9 18H7V16H9V18ZM9 14H7V12H9V14ZM9 10H7V8H9V10ZM9 6H7V4H9V6ZM23 18V20H21V22H19V20H17V18H19V16H21V18H23ZM17 10H15V12H17V10ZM17 14H15V16H17V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDomainDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="domain_disabled" clipPath="url(#clip0_395_3204)">
        <path
          id="Vector"
          d="M2.25497 0.844971L0.844971 2.25497L2.84497 4.25497V20.155H18.745L21.745 23.155L23.155 21.745L2.25497 0.844971ZM6.84497 18.155H4.84497V16.155H6.84497V18.155ZM6.84497 14.155H4.84497V12.155H6.84497V14.155ZM4.84497 10.155V8.15497H6.84497V10.155H4.84497ZM10.845 18.155H8.84497V16.155H10.845V18.155ZM8.84497 14.155V12.155H10.845V14.155H8.84497ZM12.845 18.155V16.155H14.745L16.745 18.155H12.845ZM8.84497 4.15497H10.845V6.15497H10.395L12.845 8.60497V8.15497H20.845V16.605L22.845 18.605V6.15497H12.845V2.15497H6.39497L8.84497 4.60497V4.15497ZM16.845 10.155H18.845V12.155H16.845V10.155Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_3204">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconDomainVerification(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="domain_verification">
        <g id="Vector">
          <path
            d="M16.6 10.88L15.18 9.46L10.94 13.71L8.82 11.58L7.4 13L10.94 16.54L16.6 10.88Z"
            fill="currentColor"
          />
          <path
            d="M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="done">
        <path
          id="Vector"
          d="M8.79995 15.9L4.59995 11.7L3.19995 13.1L8.79995 18.7L20.8 6.69999L19.4 5.29999L8.79995 15.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoneAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="done_all">
        <path
          id="Vector"
          d="M17.965 6.70498L16.555 5.29498L10.215 11.635L11.625 13.045L17.965 6.70498ZM22.205 5.29498L11.625 15.875L7.445 11.705L6.035 13.115L11.625 18.705L23.625 6.70498L22.205 5.29498ZM0.375 13.115L5.965 18.705L7.375 17.295L1.795 11.705L0.375 13.115Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoneOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="done_outline">
        <path
          id="Vector"
          d="M19.77 4.92998L21.17 6.32998L8.43 19.07L2.83 13.47L4.23 12.07L8.43 16.27L19.77 4.92998ZM19.77 2.09998L8.43 13.44L4.23 9.23998L0 13.47L8.43 21.9L24 6.32998L19.77 2.09998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDonutLarge(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="donut_large">
        <path
          id="Vector"
          d="M13.0249 5.07999C16.0849 5.51999 18.5049 7.93999 18.9449 11H21.9749C21.5049 6.27999 17.7449 2.51999 13.0249 2.04999V5.07999ZM18.9449 13C18.5049 16.06 16.0849 18.48 13.0249 18.92V21.95C17.7449 21.48 21.5049 17.72 21.9749 13H18.9449ZM11.0249 18.92C7.6349 18.43 5.0249 15.52 5.0249 12C5.0249 8.47999 7.6349 5.56999 11.0249 5.07999V2.04999C5.9749 2.54999 2.0249 6.80999 2.0249 12C2.0249 17.19 5.9749 21.45 11.0249 21.95V18.92Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDonutSmall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="donut_small">
        <path
          id="Vector"
          d="M14.8449 11H21.9749C21.5049 6.27999 17.7449 2.51999 13.0249 2.04999V9.17999C13.8749 9.48999 14.5349 10.15 14.8449 11ZM15.0249 4.57999C17.0249 5.39999 18.6249 6.99999 19.4449 8.99999H16.0149C15.7349 8.62999 15.3949 8.28999 15.0249 8.00999V4.57999ZM2.0249 12C2.0249 17.19 5.9749 21.45 11.0249 21.95V14.82C9.8649 14.4 9.0249 13.3 9.0249 12C9.0249 10.7 9.8649 9.59999 11.0249 9.17999V2.04999C5.9749 2.54999 2.0249 6.80999 2.0249 12ZM9.0249 4.57999V8.01999C7.7949 8.93999 7.0249 10.41 7.0249 12C7.0249 13.59 7.7949 15.06 9.0249 15.99V19.43C6.0649 18.24 4.0249 15.35 4.0249 12C4.0249 8.64999 6.0649 5.75999 9.0249 4.57999ZM13.0249 14.82V21.95C17.7449 21.48 21.5049 17.72 21.9749 13H14.8449C14.5349 13.85 13.8749 14.51 13.0249 14.82ZM15.0249 15.99C15.3949 15.71 15.7349 15.38 16.0149 15H19.4449C18.6249 17 17.0249 18.6 15.0249 19.42V15.99Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoorBack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="door_back">
        <g id="Vector">
          <path
            d="M19 19V5C19 3.9 18.1 3 17 3H7C5.9 3 5 3.9 5 5V19H3V21H21V19H19ZM17 19H7V5H17V19Z"
            fill="currentColor"
          />
          <path d="M11 11H9V13H11V11Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDoorFront(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="door_front">
        <path
          id="Vector"
          d="M19 19V5C19 3.9 18.1 3 17 3H7C5.9 3 5 3.9 5 5V19H3V21H21V19H19ZM17 19H7V5H17V19ZM13 11H15V13H13V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoorSliding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="door_sliding">
        <path
          id="Vector"
          d="M10 13H8V11H10V13ZM16 11H14V13H16V11ZM21 19V21H3V19H4V5C4 3.9 4.9 3 6 3H18C19.1 3 20 3.9 20 5V19H21ZM11 5H6V19H11V5ZM18 5H13V19H18V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoorbell(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="doorbell">
        <path
          id="Vector"
          d="M11 16.5H13C13 17.05 12.55 17.5 12 17.5C11.45 17.5 11 17.05 11 16.5ZM15 15V12.66C15 11.12 14.19 9.84 12.75 9.5V9.25C12.75 8.84 12.41 8.5 12 8.5C11.59 8.5 11.25 8.84 11.25 9.25V9.5C9.82 9.84 9 11.12 9 12.66V15H8V16H16V15H15ZM12 5.5L6 10V19H18V10L12 5.5ZM12 3L20 9V21H4V9L12 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDoubleArrow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="double_arrow">
        <g id="Vector">
          <path d="M15.25 5H10.75L15.75 12L10.75 19H15.25L20.25 12L15.25 5Z" fill="currentColor" />
          <path d="M8.25 5H3.75L8.75 12L3.75 19H8.25L13.25 12L8.25 5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDownhillSkiing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="downhill_skiing">
        <path
          id="Vector"
          d="M18.5 3.75C18.5 4.85 17.6 5.75 16.5 5.75C15.4 5.75 14.5 4.85 14.5 3.75C14.5 2.65 15.4 1.75 16.5 1.75C17.6 1.75 18.5 2.65 18.5 3.75ZM15.78 20.15L16.54 20.42C17.16 20.63 17.81 20.75 18.5 20.75C19.34 20.75 20.15 20.57 20.88 20.25L22 21.38C20.95 21.93 19.76 22.25 18.5 22.25C17.64 22.25 16.82 22.11 16.05 21.84L2 16.72L2.5 15.31L9.4 17.82L11.12 13.38L7.55 9.65C6.66 8.71 6.88 7.18 8 6.53L11.48 4.52C12.58 3.88 14 4.42 14.39 5.63L14.72 6.71C15.16 8.13 16.2 9.28 17.55 9.85L18.07 8.25L19.5 8.71L18.38 12.16C15.93 11.76 13.9 10.09 13 7.84L10.47 9.29L13.5 12.75L11.28 18.51L14.37 19.63L16.47 13.19C16.93 13.37 17.41 13.5 17.91 13.6L15.78 20.15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDownload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="download">
        <path
          id="Vector"
          d="M19 9.5H15V3.5H9V9.5H5L12 16.5L19 9.5ZM11 11.5V5.5H13V11.5H14.17L12 13.67L9.83 11.5H11ZM5 18.5H19V20.5H5V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDownloadDone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="download_done">
        <path
          id="Vector"
          d="M5 18H19V20H5V18ZM9.6 15.3L5 10.7L7 8.8L9.6 11.4L17 4L19 6L9.6 15.3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDownloadForOffline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="download_for_offline">
        <path
          id="Vector"
          d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM14.59 8.59L16 10L12 14L8 10L9.41 8.59L11 10.17V6H13V10.17L14.59 8.59ZM17 17H7V15H17V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDownloading(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="downloading">
        <path
          id="Vector"
          d="M18.3449 4.26005C16.8649 3.05005 15.0349 2.25005 13.0249 2.05005V4.07005C14.4849 4.25005 15.8149 4.83005 16.9249 5.69005L18.3449 4.26005ZM19.9549 11H21.9749C21.7749 8.99005 20.9749 7.16005 19.7649 5.68005L18.3349 7.10005C19.1949 8.21005 19.7749 9.54005 19.9549 11ZM18.3349 16.9L19.7649 18.33C20.9749 16.85 21.7749 15.01 21.9749 13.01H19.9549C19.7749 14.46 19.1949 15.79 18.3349 16.9ZM13.0249 19.93V21.9501C15.0349 21.75 16.8649 20.9501 18.3449 19.74L16.9149 18.31C15.8149 19.17 14.4849 19.75 13.0249 19.93ZM15.6149 10.59L13.0249 13.17V7.00005H11.0249V13.17L8.4349 10.58L7.0249 12L12.0249 17L17.0249 12L15.6149 10.59ZM11.0249 19.93V21.9501C5.9749 21.4501 2.0249 17.19 2.0249 12C2.0249 6.81005 5.9749 2.55005 11.0249 2.05005V4.07005C7.0749 4.56005 4.0249 7.92005 4.0249 12C4.0249 16.08 7.0749 19.4401 11.0249 19.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDrafts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drafts">
        <path
          id="Vector"
          d="M21.99 9.5C21.99 8.78 21.62 8.15 21.05 7.8L12 2.5L2.95 7.8C2.38 8.15 2 8.78 2 9.5V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5L21.99 9.5ZM19.99 9.5V9.51L12 14.5L4 9.5L12 4.82L19.99 9.5ZM4 19.5V11.84L12 16.86L19.99 11.87L20 19.5H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDragHandle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drag_handle">
        <path id="Vector" d="M20 9H4V11H20V9ZM4 15H20V13H4V15Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconDragIndicator(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drag_indicator">
        <path
          id="Vector"
          d="M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDraw(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="draw">
        <path
          id="Vector"
          d="M19.1024 10.39L20.1624 9.33C20.9424 8.55 20.9424 7.28 20.1624 6.5L18.7524 5.09C17.9724 4.31 16.7024 4.31 15.9224 5.09L14.8624 6.15L19.1024 10.39ZM14.8624 11.81L7.66244 19H6.25244V17.59L13.4424 10.4L14.8624 11.81ZM13.4424 7.56L4.25244 16.76V21H8.49244L17.6824 11.81L13.4424 7.56ZM19.2524 17.5C19.2524 19.69 16.7124 21 14.2524 21C13.7024 21 13.2524 20.55 13.2524 20C13.2524 19.45 13.7024 19 14.2524 19C15.7924 19 17.2524 18.27 17.2524 17.5C17.2524 17.03 16.7724 16.63 16.0224 16.3L17.5024 14.82C18.5724 15.45 19.2524 16.29 19.2524 17.5ZM4.83244 13.35C3.86244 12.79 3.25244 12.06 3.25244 11C3.25244 9.2 5.14244 8.37 6.81244 7.64C7.84244 7.18 9.25244 6.56 9.25244 6C9.25244 5.59 8.47244 5 7.25244 5C5.99244 5 5.45244 5.61 5.42244 5.64C5.07244 6.05 4.44244 6.1 4.02244 5.76C3.61244 5.42 3.53244 4.81 3.87244 4.38C3.98244 4.24 5.01244 3 7.25244 3C9.49244 3 11.2524 4.32 11.2524 6C11.2524 7.87 9.32244 8.72 7.61244 9.47C6.67244 9.88 5.25244 10.5 5.25244 11C5.25244 11.31 5.68244 11.6 6.32244 11.86L4.83244 13.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDriveEta(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drive_eta">
        <g id="Vector">
          <path
            d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.85 6H17.14L18.18 9H5.81L6.85 6ZM19 16H5V11.34L5.12 11H18.89L19 11.34V16Z"
            fill="currentColor"
          />
          <path
            d="M7.5 15C8.32843 15 9 14.3284 9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15Z"
            fill="currentColor"
          />
          <path
            d="M16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDriveFileMove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drive_file_move">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM12.16 12H8V14H12.16L10.57 15.59L11.99 17L16 13.01L11.99 9L10.58 10.41L12.16 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDriveFileMoveRtl(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drive_file_move_rtl">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM13.41 15.59L12 17L8 13L12 9L13.41 10.41L11.83 12H16V14H11.83L13.41 15.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDriveFileRenameOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drive_file_rename_outline">
        <g id="Vector">
          <path d="M15 16L11 20H21V16H15Z" fill="currentColor" />
          <path
            d="M12.06 7.19L3 16.25V20H6.75L15.81 10.94L12.06 7.19ZM5.92 18H5V17.08L12.06 10.02L12.98 10.94L5.92 18Z"
            fill="currentColor"
          />
          <path
            d="M18.71 8.04C19.1 7.65 19.1 7.02 18.71 6.63L16.37 4.29C16.17 4.09 15.92 4 15.66 4C15.41 4 15.15 4.1 14.96 4.29L13.13 6.12L16.88 9.87L18.71 8.04Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDriveFolderUpload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="drive_folder_upload">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM9.41 14.42L11 12.84V17H13V12.84L14.59 14.43L16 13.01L12.01 9L8 13.01L9.41 14.42Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDry(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dry">
        <path
          id="Vector"
          d="M21.25 15.5C21.94 15.5 22.5 14.94 22.5 14.25C22.5 13.56 21.94 13 21.25 13H12.5V12H19.25C19.94 12 20.5 11.44 20.5 10.75C20.5 10.08 19.97 9.55 19.32 9.51L9.37 9.5L10.85 6.9C10.94 6.73 10.99 6.56 10.99 6.36C10.99 6.1 10.9 5.86 10.73 5.66L9.62 4.5L2.44 11.3C1.84 11.86 1.5 12.65 1.5 13.47V19.5C1.5 21.16 2.84 22.5 4.5 22.5H18.25C18.94 22.5 19.5 21.94 19.5 21.25C19.5 20.56 18.94 20 18.25 20H12.5V19H20.25C20.94 19 21.5 18.44 21.5 17.75C21.5 17.06 20.94 16.5 20.25 16.5H12.5V15.5H21.25ZM10.5 20.5H4.5C3.95 20.5 3.5 20.05 3.5 19.5V13.5C3.5 13.11 3.73 12.86 3.86 12.75L7.5 9.37V11.5H10.5V20.5ZM16.15 4.36L16.08 4.29C15.51 3.67 15.26 2.88 15.41 2.09L15.5 1.5H13.61L13.55 1.93C13.35 3.29 13.82 4.64 14.85 5.65L14.92 5.71C15.49 6.33 15.74 7.12 15.59 7.91L15.48 8.5H17.39L17.45 8.07C17.66 6.71 17.18 5.36 16.15 4.36ZM20.15 4.36L20.08 4.29C19.51 3.67 19.26 2.88 19.41 2.09L19.5 1.5H17.61L17.55 1.93C17.35 3.29 17.82 4.64 18.85 5.65L18.92 5.71C19.49 6.33 19.74 7.12 19.59 7.91L19.48 8.5H21.39L21.45 8.07C21.66 6.71 21.18 5.36 20.15 4.36Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDryCleaning(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dry_cleaning">
        <path
          id="Vector"
          d="M19.56 11.3611L13 8.44106V7.00106C13 6.45106 12.55 6.00106 12 6.00106C11.45 6.00106 11 5.55106 11 5.00106C11 4.45106 11.45 4.00106 12 4.00106C12.55 4.00106 13 4.45106 13 5.00106H15C15 3.16106 13.34 1.70106 11.44 2.05106C10.26 2.27106 9.29 3.22106 9.06 4.40106C8.76 5.96106 9.66 7.34106 11 7.82106V8.45106L4.44 11.3711C3.56 11.7511 3 12.6211 3 13.5711V13.5811C3 14.9211 4.08 16.0011 5.42 16.0011H7V22.0011H17V16.0011H18.58C19.92 16.0011 21 14.9211 21 13.5811V13.5711C21 12.6211 20.44 11.7511 19.56 11.3611ZM15 20.0011H9V15.0011H15V20.0011ZM18.58 14.0011H17V13.0011H7V14.0011H5.42C4.96 14.0011 4.84 13.3511 5.25 13.1911L12 10.1911L18.75 13.1911C19.17 13.3811 19.03 14.0011 18.58 14.0011Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDuo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="duo">
        <path
          id="Vector"
          d="M20 2H12C6.38 2 2 6.66 2 12.28C2 17.5 6.49 22 11.72 22C17.39 22 22 17.62 22 12V4C22 2.9 21.1 2 20 2ZM17 15L14 13V15H7V9H14V11L17 9V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDvr(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dvr">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17ZM19 8H8V10H19V8ZM19 12H8V14H19V12ZM7 8H5V10H7V8ZM7 12H5V14H7V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDynamicFeed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dynamic_feed">
        <g id="Vector">
          <path d="M8 8H6V15C6 16.1 6.9 17 8 17H17V15H8V8Z" fill="currentColor" />
          <path
            d="M20 3H12C10.9 3 10 3.9 10 5V11C10 12.1 10.9 13 12 13H20C21.1 13 22 12.1 22 11V5C22 3.9 21.1 3 20 3ZM20 11H12V7H20V11Z"
            fill="currentColor"
          />
          <path d="M4 12H2V19C2 20.1 2.9 21 4 21H13V19H4V12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconDynamicForm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="dynamic_form">
        <path
          id="Vector"
          d="M13 11H4C2.9 11 2 10.1 2 9V6C2 4.9 2.9 4 4 4H13V11ZM4 9H11V6H4V9ZM15 20H4C2.9 20 2 19.1 2 18V15C2 13.9 2.9 13 4 13H15V20ZM4 18H13V15H4V18ZM22 9H20L22 4H15V11H17V20L22 9ZM4.75 17.25H6.25V15.75H4.75V17.25ZM4.75 8.25H6.25V6.75H4.75V8.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="e_mobiledata">
        <path id="Vector" d="M16 9V7H8V17H16V15H10V13H16V11H10V9H16Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconEarbuds(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="earbuds">
        <path
          id="Vector"
          d="M16 2.9995C13.24 2.9995 11 5.2395 11 7.9995V15.9995C11 17.6595 9.66 18.9995 8 18.9995C6.34 18.9995 5 17.6595 5 15.9995V8.9995H5.83C7.44 8.9995 8.89 7.8195 9 6.2095C9.12 4.5195 7.84 3.1095 6.2 2.9995C4.44 2.8895 3 4.4195 3 6.1895V15.9995C3 18.7595 5.24 20.9995 8 20.9995C10.76 20.9995 13 18.7595 13 15.9995V7.9995C13 6.3395 14.34 4.9995 16 4.9995C17.66 4.9995 19 6.3395 19 7.9995V14.9995H18.17C16.56 14.9995 15.11 16.1795 15 17.7895C14.88 19.4795 16.16 20.8895 17.8 20.9995C19.56 21.1195 21 19.5795 21 17.8195V7.9995C21 5.2395 18.76 2.9995 16 2.9995ZM5 5.9995C5 5.4495 5.45 4.9995 6 4.9995C6.55 4.9995 7 5.4495 7 5.9995C7 6.5495 6.55 6.9995 6 6.9995H5V5.9995ZM19 17.9995C19 18.5495 18.55 18.9995 18 18.9995C17.45 18.9995 17 18.5495 17 17.9995C17 17.4495 17.45 16.9995 18 16.9995H19V17.9995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEarbudsBattery(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="earbuds_battery">
        <path
          id="Vector"
          d="M21 7H20V6H18V7H17C16.45 7 16 7.45 16 8V17C16 17.55 16.45 18 17 18H21C21.55 18 22 17.55 22 17V8C22 7.45 21.55 7 21 7ZM20 16H18V9H20V16ZM14 9.38C14 7.51 12.49 6 10.62 6C8.75 6 7.25 7.51 7.25 9.38V14.63C7.25 15.67 6.41 16.51 5.37 16.51C4.33 16.51 3.5 15.66 3.5 14.62V9.92C3.66 9.97 3.83 10 4 10C5.1 10 6 9.1 6 8C6 6.9 5.1 6 4 6C2.9 6 2 6.9 2 8C2 8.04 2 14.62 2 14.62C2 16.49 3.51 18 5.38 18C7.25 18 8.76 16.49 8.76 14.62V9.38C8.76 8.34 9.6 7.5 10.64 7.5C11.68 7.5 12.52 8.34 12.52 9.38V14.08C12.34 14.03 12.17 14 12 14C10.9 14 10 14.9 10 16C10 17.1 10.9 18 12 18C13.1 18 14 17.1 14 16C14 15.96 14 9.38 14 9.38Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEast(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="east">
        <path
          id="Vector"
          d="M15 5L13.59 6.41L18.17 11H2V13H18.17L13.58 17.59L15 19L22 12L15 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEdgesensorHigh(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edgesensor_high">
        <path
          id="Vector"
          d="M3 7H5V14H3V7ZM0 10H2V17H0V10ZM22 7H24V14H22V7ZM19 10H21V17H19V10ZM16 2.01L8 2C6.9 2 6 2.9 6 4V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2.01 16 2.01ZM16 20H8V19H16V20ZM16 17H8V7H16V17ZM8 5V4H16V5H8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEdgesensorLow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edgesensor_low">
        <path
          id="Vector"
          d="M2 7H4V14H2V7ZM20 10H22V17H20V10ZM16 2.01L8 2C6.9 2 6 2.9 6 4V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2.01 16 2.01ZM16 20H8V19H16V20ZM16 17H8V7H16V17ZM8 5V4H16V5H8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEdit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit">
        <path
          id="Vector"
          d="M14.0588 9.02L14.9788 9.94L5.91878 19H4.99878V18.08L14.0588 9.02ZM17.6588 3C17.4088 3 17.1488 3.1 16.9588 3.29L15.1288 5.12L18.8788 8.87L20.7088 7.04C21.0988 6.65 21.0988 6.02 20.7088 5.63L18.3688 3.29C18.1688 3.09 17.9188 3 17.6588 3ZM14.0588 6.19L2.99878 17.25V21H6.74878L17.8088 9.94L14.0588 6.19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditAttributes(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_attributes">
        <path
          id="Vector"
          d="M17.63 7H6.37C3.96 7 2 9.24 2 12C2 14.76 3.96 17 6.37 17H17.63C20.04 17 22 14.76 22 12C22 9.24 20.04 7 17.63 7ZM17.63 15H6.37C5.09 15 4 13.63 4 12C4 10.37 5.09 9 6.37 9H17.63C18.91 9 20 10.37 20 12C20 13.63 18.91 15 17.63 15ZM7.24 13.06L5.37 11.19L4.67 11.89L7.24 14.46L11.46 10.24L10.76 9.54L7.24 13.06Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditCalendar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_calendar">
        <path
          id="Vector"
          d="M3.93372 9.5H17.9337V11.5H19.9337V5.5C19.9337 4.4 19.0337 3.5 17.9337 3.5H16.9337V1.5H14.9337V3.5H6.93372V1.5H4.93372V3.5H3.93372C2.82372 3.5 1.94372 4.4 1.94372 5.5L1.93372 19.5C1.93372 20.6 2.82372 21.5 3.93372 21.5H10.9337V19.5H3.93372V9.5ZM3.93372 5.5H17.9337V7.5H3.93372V5.5ZM21.7737 15.78L21.0637 16.49L18.9437 14.37L19.6537 13.66C20.0437 13.27 20.6737 13.27 21.0637 13.66L21.7737 14.37C22.1637 14.76 22.1637 15.39 21.7737 15.78ZM18.2337 15.08L20.3537 17.2L15.0537 22.5H12.9337V20.38L18.2337 15.08Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditLocation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_location">
        <path
          id="Vector"
          d="M17.6688 5.40143L16.5988 4.33143L11.0488 9.88143V10.9614H12.1288L17.6688 5.40143ZM16.7888 1.94143C16.9274 1.80114 17.0924 1.68975 17.2744 1.61373C17.4563 1.53771 17.6516 1.49857 17.8488 1.49857C18.046 1.49857 18.2412 1.53771 18.4232 1.61373C18.6051 1.68975 18.7702 1.80114 18.9088 1.94143L20.0588 3.09143C20.6488 3.68143 20.6488 4.63143 20.0588 5.21143L12.7788 12.4914H9.49878V9.23143L16.7888 1.94143ZM13.2188 2.68143L11.3988 4.50143C8.09878 4.55143 5.49878 7.10143 5.49878 10.7014C5.49878 13.0414 7.44878 16.1414 11.4988 19.8414C15.5488 16.1414 17.4988 13.0514 17.4988 10.7014V10.6014L19.2988 8.80143C19.4288 9.40143 19.4988 10.0414 19.4988 10.7014C19.4988 14.0214 16.8288 17.9514 11.4988 22.5014C6.16878 17.9514 3.49878 14.0214 3.49878 10.7014C3.49878 5.72143 7.29878 2.50143 11.4988 2.50143C12.0788 2.50143 12.6588 2.56143 13.2188 2.68143Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditLocationAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_location_alt">
        <path
          id="Vector"
          d="M10.4988 11.5012H12.6188L18.7788 5.34125L16.6588 3.22125L10.4988 9.38125V11.5012ZM20.2088 2.50125L19.4988 1.79125C19.1088 1.40125 18.4788 1.40125 18.0888 1.79125L17.3688 2.51125L19.4888 4.63125L20.2088 3.91125C20.5988 3.52125 20.5988 2.89125 20.2088 2.50125ZM17.3988 9.55125C17.4588 9.91125 17.4988 10.2912 17.4988 10.7012C17.4988 12.4112 16.4188 15.3412 11.4988 19.8412C6.57878 15.3512 5.49878 12.4112 5.49878 10.7012C5.49878 6.67125 8.58878 4.50125 11.4988 4.50125C11.8188 4.50125 12.1488 4.53125 12.4688 4.58125L14.1188 2.93125C13.2788 2.66125 12.3988 2.50125 11.4988 2.50125C7.29878 2.50125 3.49878 5.72125 3.49878 10.7012C3.49878 14.0212 6.16878 17.9512 11.4988 22.5012C16.8288 17.9512 19.4988 14.0212 19.4988 10.7012C19.4988 9.69125 19.3388 8.76125 19.0488 7.90125L17.3988 9.55125Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditNote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_note">
        <path
          id="Vector"
          d="M2.93384 8.5H13.9338V10.5H2.93384V8.5ZM2.93384 6.5H13.9338V4.5H2.93384V6.5ZM2.93384 14.5H9.93384V12.5H2.93384V14.5ZM17.9438 11.37L18.6538 10.66C19.0438 10.27 19.6738 10.27 20.0638 10.66L20.7738 11.37C21.1638 11.76 21.1638 12.39 20.7738 12.78L20.0638 13.49L17.9438 11.37ZM17.2338 12.08L11.9338 17.38V19.5H14.0538L19.3538 14.2L17.2338 12.08Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditNotifications(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_notifications">
        <path
          id="Vector"
          d="M17.08 6.25L18.85 8.02L13.87 13H12.1V11.23L17.08 6.25ZM20.35 5.81L19.29 4.75C19.09 4.55 18.78 4.55 18.58 4.75L17.73 5.6L19.5 7.37L20.35 6.52C20.55 6.32 20.55 6 20.35 5.81ZM17.5 12.2V17H19.5V19H3.5V17H5.5V10C5.5 7.21 7.41 4.86 10 4.2V3.5C10 2.67 10.67 2 11.5 2C12.33 2 13 2.67 13 3.5V4.2C13.82 4.41 14.57 4.79 15.21 5.29L13.78 6.72C13.14 6.26 12.35 6 11.5 6C9.29 6 7.5 7.79 7.5 10V17H15.5V14.2L17.5 12.2ZM9.5 20H13.5C13.5 21.1 12.6 22 11.5 22C10.4 22 9.5 21.1 9.5 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_off">
        <path
          id="Vector"
          d="M14.77 8.30998L15.69 9.22998L14.58 10.34L15.99 11.75L18.51 9.22998L14.76 5.47998L12.24 7.99998L13.65 9.40998L14.77 8.30998ZM21.42 6.32998C21.81 5.93998 21.81 5.30998 21.42 4.91998L19.08 2.57998C18.88 2.37998 18.63 2.28998 18.37 2.28998C18.11 2.28998 17.86 2.38998 17.67 2.57998L15.84 4.40998L19.59 8.15998L21.42 6.32998ZM3.51998 2.09998L2.09998 3.50998L9.41998 10.83L3.70998 16.54V20.29H7.45998L13.17 14.58L20.49 21.9L21.9 20.49L3.51998 2.09998ZM6.62998 18.29H5.70998V17.37L10.84 12.24L11.76 13.16L6.62998 18.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEditRoad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="edit_road">
        <g id="Vector">
          <path d="M16.4988 4H14.4988V11.9L16.4988 9.9V4Z" fill="currentColor" />
          <path d="M4.49878 4H2.49878V20H4.49878V4Z" fill="currentColor" />
          <path d="M10.4988 4H8.49878V8H10.4988V4Z" fill="currentColor" />
          <path d="M10.4988 10H8.49878V14H10.4988V10Z" fill="currentColor" />
          <path d="M10.4988 16H8.49878V20H10.4988V16Z" fill="currentColor" />
          <path
            d="M21.0588 12.59L19.9088 11.44C19.3188 10.85 18.3688 10.85 17.7888 11.44L12.4988 16.73V20H15.7688L21.0588 14.71C21.6488 14.12 21.6488 13.17 21.0588 12.59ZM15.0788 18.45H14.0488V17.42L17.4988 13.97L18.5288 15L15.0788 18.45Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEgg(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="egg">
        <g id="Vector">
          <path
            d="M12 3C8.5 3 5 9.33 5 14C5 17.87 8.13 21 12 21C15.87 21 19 17.87 19 14C19 9.33 15.5 3 12 3ZM12 19C9.24 19 7 16.76 7 14C7 9.91 10.07 5 12 5C13.93 5 17 9.91 17 14C17 16.76 14.76 19 12 19Z"
            fill="currentColor"
          />
          <path
            d="M13 16C12.42 16 10 15.92 10 13C10 12.45 9.55 12 9 12C8.45 12 8 12.45 8 13C8 16 9.99 18 13 18C13.55 18 14 17.55 14 17C14 16.45 13.55 16 13 16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEggAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="egg_alt">
        <g id="Vector">
          <path
            d="M19.0004 9C17.0004 7 15.9904 2 9.97039 2C4.95039 2 1.94039 6 2.00039 11.52C2.06039 17.04 6.96039 19 9.97039 19C11.9804 19 11.9804 22 15.9904 22C19.0004 22 22.0004 19 22.0004 15.02C22.0004 12 21.0104 11 19.0004 9ZM15.9904 20C14.5004 20 14.0304 19.5 13.3104 18.74C12.6604 18.05 11.6604 17 9.97039 17C8.33039 17 4.05039 16.01 4.00039 11.5C3.97039 8.99 4.68039 6.88 5.99039 5.55C7.01039 4.52 8.35039 4 9.97039 4C13.3104 4 14.4804 5.86 15.8304 8.02C16.3804 8.9 16.9004 9.73 17.5904 10.41C19.4904 12.3 20.0004 12.81 20.0004 15.02C20.0004 17.87 17.8804 20 15.9904 20Z"
            fill="currentColor"
          />
          <path
            d="M12.0004 15.5C13.9334 15.5 15.5004 13.933 15.5004 12C15.5004 10.067 13.9334 8.5 12.0004 8.5C10.0674 8.5 8.50039 10.067 8.50039 12C8.50039 13.933 10.0674 15.5 12.0004 15.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEject(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="eject">
        <path
          id="Vector"
          d="M5 17H19V19H5V17ZM12 5L5.33 15H18.67L12 5ZM12 8.6L14.93 13H9.07L12 8.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconElderly(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="elderly">
        <path
          id="Vector"
          d="M12.5 5.25C13.6 5.25 14.5 4.35 14.5 3.25C14.5 2.15 13.6 1.25 12.5 1.25C11.4 1.25 10.5 2.15 10.5 3.25C10.5 4.35 11.4 5.25 12.5 5.25ZM19 12.25V22.75H18V12.25C18 11.97 17.78 11.75 17.5 11.75C17.22 11.75 17 11.97 17 12.25V13.25H16V12.56C14.54 12.18 13.3 11.27 12.49 10.04C12.18 10.91 12 11.82 12 12.75C12 12.98 12.02 13.21 12.03 13.44L14 16.25V22.75H12V17.75L10.22 15.21L10 18.75L7 22.75L5.4 21.55L8 18.08V12.75C8 11.6 8.18 10.46 8.5 9.36L7 10.21V13.75H5V9.05L10.4 5.98V5.99C10.99 5.68 11.72 5.66 12.34 6.02C12.7 6.23 12.97 6.53 13.14 6.87L13.93 8.54C14.58 9.85 15.94 10.75 17.5 10.75C18.33 10.75 19 11.42 19 12.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconElderlyWoman(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="elderly_woman">
        <g id="Vector">
          <path
            d="M17.5 11C15.94 11 14.58 10.1 13.92 8.79L13.13 7.12C13.12 7.1 12.63 6 11.34 6C7.72 6 5 16.69 5 19H7.5L5.4 21.8L7 23L10 19H12V23H14V18.97L12 13L12.49 10.29C13.3 11.52 14.54 12.43 16 12.81V13.5H17V12.5C17 12.22 17.22 12 17.5 12C17.78 12 18 12.22 18 12.5V23H19V12.5C19 11.67 18.33 11 17.5 11Z"
            fill="currentColor"
          />
          <path
            d="M10.6 2.91C10.54 3.1 10.5 3.29 10.5 3.5C10.5 4.6 11.4 5.5 12.5 5.5C13.6 5.5 14.5 4.6 14.5 3.5C14.5 2.4 13.6 1.5 12.5 1.5C12.29 1.5 12.1 1.54 11.91 1.6C11.76 1.25 11.41 1 11 1C10.45 1 10 1.45 10 2C10 2.41 10.25 2.76 10.6 2.91Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricBike(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_bike">
        <g id="Vector">
          <path
            d="M19 7H18.18L16.48 2.32C16.19 1.53 15.44 1 14.6 1H12V3H14.6L16.06 7H11.25L10.89 6H12V4H7V6H8.75L10.57 11H9.9C9.46 8.77 7.59 7.12 5.25 7.01C2.45 6.87 0 9.2 0 12C0 14.8 2.2 17 5 17C7.46 17 9.45 15.31 9.9 13H14.1C14.54 15.23 16.41 16.88 18.75 16.99C21.55 17.12 24 14.8 24 11.99C24 9.2 21.8 7 19 7ZM7.82 13C7.42 14.17 6.33 15 5 15C3.32 15 2 13.68 2 12C2 10.32 3.32 9 5 9C6.33 9 7.42 9.83 7.82 11H5V13H7.82ZM14.1 11H12.7L11.97 9H15C14.56 9.58 14.24 10.25 14.1 11ZM19 15C17.32 15 16 13.68 16 12C16 11.07 16.41 10.27 17.05 9.72L18.01 12.36L19.89 11.68L18.92 9.01C18.94 9.01 18.97 9 19 9C20.68 9 22 10.32 22 12C22 13.68 20.68 15 19 15Z"
            fill="currentColor"
          />
          <path d="M11 20H7L13 23V21H17L11 18V20Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricBolt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_bolt">
        <path
          id="Vector"
          d="M14.6901 2.20999L4.33009 11.49C3.69009 12.07 4.05009 13.14 4.91009 13.22L13.0001 14L8.15009 20.76C7.93009 21.07 7.96009 21.5 8.23009 21.77C8.53009 22.07 9.00009 22.08 9.31009 21.79L19.6701 12.51C20.3101 11.93 19.9501 10.86 19.0901 10.78L11.0001 9.99999L15.8501 3.23999C16.0701 2.92999 16.0401 2.49999 15.7701 2.22999C15.4701 1.92999 15.0001 1.91999 14.6901 2.20999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconElectricCar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_car">
        <g id="Vector">
          <path
            d="M18.92 2.01C18.72 1.42 18.16 1 17.5 1H6.5C5.84 1 5.29 1.42 5.08 2.01L3 8V16C3 16.55 3.45 17 4 17H5C5.55 17 6 16.55 6 16V15H18V16C18 16.55 18.45 17 19 17H20C20.55 17 21 16.55 21 16V8L18.92 2.01ZM6.85 3H17.14L18.22 6.11H5.77L6.85 3ZM19 13H5V8H19V13Z"
            fill="currentColor"
          />
          <path
            d="M7.5 12C8.32843 12 9 11.3284 9 10.5C9 9.67157 8.32843 9 7.5 9C6.67157 9 6 9.67157 6 10.5C6 11.3284 6.67157 12 7.5 12Z"
            fill="currentColor"
          />
          <path
            d="M16.5 12C17.3284 12 18 11.3284 18 10.5C18 9.67157 17.3284 9 16.5 9C15.6716 9 15 9.67157 15 10.5C15 11.3284 15.6716 12 16.5 12Z"
            fill="currentColor"
          />
          <path d="M7 20H11V18L17 21H13V23L7 20Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricMeter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_meter">
        <g id="Vector">
          <path
            d="M21 11C21 6.03 16.97 2 12 2C7.03 2 3 6.03 3 11C3 14.92 5.51 18.24 9 19.48V22H11V19.94C11.33 19.98 11.66 20 12 20C12.34 20 12.67 19.98 13 19.94V22H15V19.48C18.49 18.24 21 14.92 21 11ZM12 18C8.14 18 5 14.86 5 11C5 7.14 8.14 4 12 4C15.86 4 19 7.14 19 11C19 14.86 15.86 18 12 18Z"
            fill="currentColor"
          />
          <path d="M16 7H8V9H16V7Z" fill="currentColor" />
          <path
            d="M12.75 10L9.75 13L11 14.25L9.75 15.5L11.25 17L14.25 14L13 12.75L14.25 11.5L12.75 10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricMoped(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_moped">
        <g id="Vector">
          <path
            d="M19 4C19 2.9 18.1 2 17 2H14V4H17V6.65L13.52 11H10V6H6C3.79 6 2 7.79 2 10V13H4C4 14.66 5.34 16 7 16C8.66 16 10 14.66 10 13H14.48L19 7.35V4ZM4 11V10C4 8.9 4.9 8 6 8H8V11H4ZM7 14C6.45 14 6 13.55 6 13H8C8 13.55 7.55 14 7 14Z"
            fill="currentColor"
          />
          <path d="M10 3H5V5H10V3Z" fill="currentColor" />
          <path
            d="M19 10C17.34 10 16 11.34 16 13C16 14.66 17.34 16 19 16C20.66 16 22 14.66 22 13C22 11.34 20.66 10 19 10ZM19 14C18.45 14 18 13.55 18 13C18 12.45 18.45 12 19 12C19.55 12 20 12.45 20 13C20 13.55 19.55 14 19 14Z"
            fill="currentColor"
          />
          <path d="M7 19H11V17L17 20H13V22L7 19Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricRickshaw(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_rickshaw">
        <g id="Vector">
          <path
            d="M20.9951 10.18V8.72C20.9951 8.25 20.8351 7.8 20.5351 7.44L16.5951 2.72C16.2151 2.26 15.6551 2 15.0551 2H2.99512C1.89512 2 0.995117 2.9 0.995117 4V12C0.995117 13.1 1.89512 14 2.99512 14H3.17512C3.59512 15.16 4.69512 16 5.99512 16C7.29512 16 8.39512 15.16 8.81512 14H17.1851C17.5951 15.16 18.6951 16 20.0051 16C21.6651 16 23.0051 14.66 23.0051 13C22.9951 11.7 22.1551 10.6 20.9951 10.18ZM5.99512 14C5.44512 14 4.99512 13.55 4.99512 13C4.99512 12.45 5.44512 12 5.99512 12C6.54512 12 6.99512 12.45 6.99512 13C6.99512 13.55 6.54512 14 5.99512 14ZM6.99512 10.17C6.68512 10.06 6.34512 10 5.99512 10C4.69512 10 3.57512 10.84 3.16512 12H2.99512V9H6.99512V10.17ZM6.99512 7H2.99512V4H6.99512V7ZM13.9951 12H8.99512V9H11.9951V7H8.99512V4H13.9951V12ZM15.9951 5.12L18.3951 8H15.9951V5.12ZM17.1651 12H15.9951V10H18.9951V10.17C18.1451 10.47 17.4651 11.15 17.1651 12ZM19.9951 14C19.4451 14 18.9951 13.55 18.9951 13C18.9951 12.45 19.4451 12 19.9951 12C20.5451 12 20.9951 12.45 20.9951 13C20.9951 13.55 20.5451 14 19.9951 14Z"
            fill="currentColor"
          />
          <path d="M6.99512 19H10.9951V17L16.9951 20H12.9951V22L6.99512 19Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricScooter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electric_scooter">
        <g id="Vector">
          <path
            d="M7.82116 16H15.0012V15C15.0012 12.79 16.7912 11 19.0012 11H19.7412L17.8412 2.56C17.6312 1.65 16.8212 1 15.8912 1H12.0012V3H15.8912L17.2912 9.25H17.2812C15.1212 9.9 13.4712 11.73 13.0912 14H7.82116C7.34116 12.66 5.96116 11.76 4.40116 12.06C3.22116 12.29 2.27116 13.26 2.05116 14.44C1.70116 16.34 3.16116 18 5.00116 18C6.30116 18 7.40116 17.16 7.82116 16ZM5.00116 16C4.45116 16 4.00116 15.55 4.00116 15C4.00116 14.45 4.45116 14 5.00116 14C5.55116 14 6.00116 14.45 6.00116 15C6.00116 15.55 5.55116 16 5.00116 16Z"
            fill="currentColor"
          />
          <path
            d="M19.0012 12C17.3412 12 16.0012 13.34 16.0012 15C16.0012 16.66 17.3412 18 19.0012 18C20.6612 18 22.0012 16.66 22.0012 15C22.0012 13.34 20.6612 12 19.0012 12ZM19.0012 16C18.4512 16 18.0012 15.55 18.0012 15C18.0012 14.45 18.4512 14 19.0012 14C19.5512 14 20.0012 14.45 20.0012 15C20.0012 15.55 19.5512 16 19.0012 16Z"
            fill="currentColor"
          />
          <path d="M11.0012 20H7.00116L13.0012 23V21H17.0012L11.0012 18V20Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconElectricalServices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="electrical_services">
        <g id="Vector">
          <path
            d="M21 14C21 13.45 20.55 13 20 13H18V15H20C20.55 15 21 14.55 21 14Z"
            fill="currentColor"
          />
          <path
            d="M20 17H18V19H20C20.55 19 21 18.55 21 18C21 17.45 20.55 17 20 17Z"
            fill="currentColor"
          />
          <path
            d="M12 14H10V18H12C12 19.1 12.9 20 14 20H17V12H14C12.9 12 12 12.9 12 14Z"
            fill="currentColor"
          />
          <path
            d="M5 13C5 11.9 5.9 11 7 11H8.5C10.43 11 12 9.43 12 7.5C12 5.57 10.43 4 8.5 4H5C4.45 4 4 4.45 4 5C4 5.55 4.45 6 5 6H8.5C9.33 6 10 6.67 10 7.5C10 8.33 9.33 9 8.5 9H7C4.79 9 3 10.79 3 13C3 15.21 4.79 17 7 17H9V15H7C5.9 15 5 14.1 5 13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconElevator(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="elevator">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10 18V14H11V11.5C11 10.4 10.1 9.5 9 9.5H8C6.9 9.5 6 10.4 6 11.5V14H7V18H10ZM8.5 8.5C9.19 8.5 9.75 7.94 9.75 7.25C9.75 6.56 9.19 6 8.5 6C7.81 6 7.25 6.56 7.25 7.25C7.25 7.94 7.81 8.5 8.5 8.5ZM18 11L15.5 7L13 11H18ZM13 13L15.5 17L18 13H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEmail(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="email">
        <path
          id="Vector"
          d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEmergency(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emergency">
        <path
          id="Vector"
          d="M21.2901 13.9L18.0001 12L21.2901 10.1C21.7701 9.82 21.9301 9.21 21.6601 8.73L19.6601 5.27C19.3801 4.79 18.7701 4.63 18.2901 4.9L15.0001 6.8V3C15.0001 2.45 14.5501 2 14.0001 2H10.0001C9.45006 2 9.00006 2.45 9.00006 3V6.8L5.71006 4.9C5.23006 4.63 4.62006 4.79 4.34006 5.27L2.34006 8.73C2.06006 9.21 2.23006 9.82 2.71006 10.1L6.00006 12L2.71006 13.9C2.23006 14.18 2.07006 14.79 2.34006 15.27L4.34006 18.73C4.62006 19.21 5.23006 19.37 5.71006 19.1L9.00006 17.2V21C9.00006 21.55 9.45006 22 10.0001 22H14.0001C14.5501 22 15.0001 21.55 15.0001 21V17.2L18.2901 19.1C18.7701 19.38 19.3801 19.21 19.6601 18.73L21.6601 15.27C21.9401 14.79 21.7701 14.18 21.2901 13.9ZM18.4301 16.87L13.7501 14.17C13.4201 13.97 13.0001 14.21 13.0001 14.6V20H11.0001V14.6C11.0001 14.22 10.5801 13.97 10.2501 14.17L5.57006 16.87L4.57006 15.14L9.25006 12.44C9.58006 12.25 9.58006 11.77 9.25006 11.57L4.57006 8.87L5.57006 7.14L10.2501 9.84C10.5801 10.03 11.0001 9.79 11.0001 9.4V4H13.0001V9.4C13.0001 9.78 13.4201 10.03 13.7501 9.83L18.4301 7.13L19.4301 8.86L14.7501 11.56C14.4201 11.75 14.4201 12.23 14.7501 12.43L19.4301 15.13L18.4301 16.87Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEmergencyRecording(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emergency_recording">
        <path
          id="Vector"
          d="M18 10.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V13.52L22 17.5V6.5L18 10.48ZM16 18H4V6H16V18ZM12 12L15 13.73L14 15.46L11 13.73V17H9V13.73L6 15.46L5 13.73L8 12L5 10.27L6 8.54L9 10.27V7H11V10.27L14 8.54L15 10.27L12 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEmergencyShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emergency_share">
        <path
          id="Vector"
          d="M12 4C13.93 4 15.68 4.78 16.95 6.05L15.54 7.46C14.63 6.56 13.38 6 12 6C10.62 6 9.36997 6.56 8.45997 7.46L7.04997 6.05C8.31997 4.78 10.07 4 12 4ZM19.78 3.23L18.37 4.64C16.74 3.01 14.49 2 12.01 2C9.52997 2 7.26997 3.01 5.63997 4.63L4.21997 3.22C6.21997 1.23 8.96997 0 12.01 0C15.05 0 17.79 1.23 19.78 3.23ZM12 11C13.94 11 16 12.45 16 15.15C16 16.09 15.45 18.08 12 21.32C8.54997 18.08 7.99997 16.09 7.99997 15.15C7.99997 12.45 10.06 11 12 11ZM12 9C8.84997 9 5.99997 11.41 5.99997 15.15C5.99997 17.64 7.99997 20.59 12 24C16 20.59 18 17.64 18 15.15C18 11.41 15.15 9 12 9ZM13.5 15C13.5 14.17 12.83 13.5 12 13.5C11.17 13.5 10.5 14.17 10.5 15C10.5 15.83 11.17 16.5 12 16.5C12.83 16.5 13.5 15.83 13.5 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEmojiEmotions(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_emotions">
        <g id="Vector">
          <path
            d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z"
            fill="currentColor"
          />
          <path
            d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z"
            fill="currentColor"
          />
          <path
            d="M12 18C14.28 18 16.22 16.34 17 14H7C7.78 16.34 9.72 18 12 18Z"
            fill="currentColor"
          />
          <path
            d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEmojiEvents(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_events">
        <path
          id="Vector"
          d="M19 5H17V3H7V5H5C3.9 5 3 5.9 3 7V8C3 10.55 4.92 12.63 7.39 12.94C8.02 14.44 9.37 15.57 11 15.9V19H7V21H17V19H13V15.9C14.63 15.57 15.98 14.44 16.61 12.94C19.08 12.63 21 10.55 21 8V7C21 5.9 20.1 5 19 5ZM5 8V7H7V10.82C5.84 10.4 5 9.3 5 8ZM12 14C10.35 14 9 12.65 9 11V5H15V11C15 12.65 13.65 14 12 14ZM19 8C19 9.3 18.16 10.4 17 10.82V7H19V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEmojiFoodBeverage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_food_beverage">
        <g id="Vector">
          <path d="M20 19H2V21H20V19Z" fill="currentColor" />
          <path
            d="M20 3H4V13C4 15.21 5.79 17 8 17H14C16.21 17 18 15.21 18 13V10H20C21.11 10 22 9.11 22 8V5C22 3.89 21.11 3 20 3ZM16 13C16 14.1 15.1 15 14 15H8C6.9 15 6 14.1 6 13V5H9V6.4L7.19 7.85C7.07 7.94 7 8.09 7 8.24V12.5C7 12.78 7.22 13 7.5 13H11.5C11.78 13 12 12.78 12 12.5V8.24C12 8.09 11.93 7.94 11.81 7.85L10 6.4V5H16V13ZM9.5 7.28L11 8.48V12H8V8.48L9.5 7.28ZM20 8H18V5H20V8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEmojiNature(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_nature">
        <g id="Vector">
          <path
            d="M21.943 4.88C21.763 4.35 21.253 4 20.683 4C20.653 4 20.623 4 20.593 4H19.603L19.293 3.03C19.153 2.43 18.613 2 18.003 2C17.393 2 16.853 2.43 16.713 3.04L16.403 4H15.423C15.393 4 15.363 4 15.333 4C14.763 4 14.253 4.35 14.073 4.88C13.883 5.44 14.113 6.05 14.633 6.36L15.503 6.88L15.103 8.12C14.873 8.7 15.063 9.37 15.553 9.74C15.783 9.91 16.063 10 16.333 10C16.643 10 16.943 9.89 17.193 9.68L18.003 8.98L18.813 9.68C19.063 9.89 19.363 10 19.673 10C19.943 10 20.223 9.91 20.453 9.74C20.953 9.37 21.133 8.7 20.903 8.12L20.513 6.88L21.383 6.36C21.893 6.05 22.123 5.44 21.943 4.88ZM18.003 7C17.453 7 17.003 6.55 17.003 6C17.003 5.45 17.453 5 18.003 5C18.553 5 19.003 5.45 19.003 6C19.003 6.55 18.553 7 18.003 7Z"
            fill="currentColor"
          />
          <path
            d="M13.493 10.51C13.063 10.08 12.553 9.78 12.003 9.58V8H11.003V9.38C10.893 9.37 10.773 9.35 10.663 9.35C9.64295 9.35 8.61295 9.74 7.83295 10.52C7.71295 10.64 7.53295 10.82 7.33295 11.02L6.00295 10.52C4.44295 9.97 2.72295 10.79 2.17295 12.34C1.90295 13.09 1.94295 13.91 2.29295 14.63C2.52295 15.11 2.87295 15.5 3.29295 15.79C2.91295 17.14 3.23295 18.64 4.29295 19.7C5.07295 20.48 6.09295 20.87 7.12295 20.87C7.49295 20.87 7.85295 20.8 8.21295 20.7C8.50295 21.12 8.89295 21.47 9.37295 21.7C9.78295 21.9 10.213 22 10.653 22C10.993 22 11.333 21.94 11.663 21.83C13.223 21.28 14.043 19.56 13.483 17.98L12.993 16.68C13.193 16.48 13.373 16.3 13.493 16.18C14.363 15.31 14.733 14.14 14.633 13.01H16.003V12.01H14.413C14.223 11.46 13.923 10.95 13.493 10.51ZM7.58295 18.82C7.43295 18.86 7.28295 18.88 7.12295 18.88C6.59295 18.88 6.08295 18.67 5.71295 18.29C5.33295 17.91 5.12295 17.41 5.12295 16.88C5.12295 16.72 5.15295 16.56 5.18295 16.41C5.32295 16.42 5.46295 16.44 5.60295 16.44C6.45295 16.44 7.28295 16.24 8.04295 15.96C7.72295 16.85 7.50295 17.83 7.58295 18.82ZM4.67295 14.29C4.42295 14.2 4.22295 14.02 4.10295 13.78C3.98295 13.54 3.97295 13.27 4.06295 13.02C4.25295 12.5 4.82295 12.23 5.32295 12.41L8.48295 13.6C7.33295 14.2 5.85295 14.71 4.67295 14.29ZM10.993 19.94C10.743 20.03 10.473 20.02 10.233 19.9C9.99295 19.79 9.81295 19.58 9.72295 19.33C9.30295 18.15 9.81295 16.68 10.423 15.53L11.603 18.66C11.783 19.18 11.513 19.76 10.993 19.94ZM12.203 14.6L11.593 12.99C11.593 12.98 11.583 12.97 11.573 12.96C11.553 12.92 11.533 12.88 11.513 12.84C11.493 12.8 11.473 12.77 11.443 12.73C11.413 12.7 11.383 12.67 11.353 12.64C11.323 12.61 11.293 12.58 11.263 12.55C11.233 12.52 11.193 12.5 11.153 12.48C11.113 12.46 11.083 12.43 11.033 12.42C11.023 12.42 11.013 12.41 11.003 12.4L9.40295 11.8C9.76295 11.51 10.193 11.34 10.663 11.34C11.193 11.34 11.703 11.55 12.073 11.93C12.803 12.66 12.843 13.81 12.203 14.6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEmojiObjects(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_objects">
        <g id="Vector">
          <path
            d="M12.0018 2.5C11.5418 2.5 11.0718 2.54 10.6018 2.64C7.84178 3.17 5.64178 5.4 5.12178 8.16C4.64178 10.77 5.60178 13.17 7.34178 14.72C7.77178 15.1 8.00178 15.63 8.00178 16.19V18.5C8.00178 19.6 8.90178 20.5 10.0018 20.5H10.2818C10.6318 21.1 11.2618 21.5 12.0018 21.5C12.7418 21.5 13.3818 21.1 13.7218 20.5H14.0018C15.1018 20.5 16.0018 19.6 16.0018 18.5V16.19C16.0018 15.64 16.2218 15.1 16.6418 14.73C18.0918 13.45 19.0018 11.58 19.0018 9.5C19.0018 5.63 15.8718 2.5 12.0018 2.5ZM14.0018 16.5H10.0018V15.5H14.0018V16.5ZM10.0018 18.5V17.5H14.0018V18.5H10.0018ZM15.3118 13.24C15.2218 13.32 15.1518 13.42 15.0718 13.5H8.92178C8.84178 13.41 8.77178 13.31 8.68178 13.23C7.36178 12.05 6.77178 10.29 7.09178 8.53C7.45178 6.59 9.05178 4.98 10.9818 4.6C11.3218 4.53 11.6618 4.5 12.0018 4.5C14.7618 4.5 17.0018 6.74 17.0018 9.5C17.0018 10.93 16.3918 12.29 15.3118 13.24Z"
            fill="currentColor"
          />
          <path d="M12.5018 10.5H11.5018V13.5H12.5018V10.5Z" fill="currentColor" />
          <path
            d="M10.3813 8.37372L9.67418 9.08082L11.7955 11.2021L12.5026 10.495L10.3813 8.37372Z"
            fill="currentColor"
          />
          <path
            d="M11.5028 10.5052L12.2099 11.2123L14.3312 9.09098L13.6241 8.38388L11.5028 10.5052Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEmojiPeople(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_people">
        <g id="Vector">
          <path
            d="M11.8198 6C12.9244 6 13.8198 5.10457 13.8198 4C13.8198 2.89543 12.9244 2 11.8198 2C10.7153 2 9.81982 2.89543 9.81982 4C9.81982 5.10457 10.7153 6 11.8198 6Z"
            fill="currentColor"
          />
          <path
            d="M15.7098 8.11C15.3198 7.72 14.6498 7 13.3498 7C13.1398 7 11.9298 7 10.8098 7C8.05982 6.99 5.81982 4.75 5.81982 2H3.81982C3.81982 5.16 5.92982 7.84 8.81982 8.71V22H10.8198V16H12.8198V22H14.8198V10.05L18.7698 14L20.1798 12.59L15.7098 8.11Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEmojiSymbols(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_symbols">
        <g id="Vector">
          <path d="M10.7093 2H2.70934V4H10.7093V2Z" fill="currentColor" />
          <path d="M5.70934 11H7.70934V7H10.7093V5H2.70934V7H5.70934V11Z" fill="currentColor" />
          <path
            d="M19.8911 12.4038L12.113 20.1819L13.5272 21.5961L21.3053 13.818L19.8911 12.4038Z"
            fill="currentColor"
          />
          <path
            d="M14.2093 16C15.0378 16 15.7093 15.3284 15.7093 14.5C15.7093 13.6716 15.0378 13 14.2093 13C13.3809 13 12.7093 13.6716 12.7093 14.5C12.7093 15.3284 13.3809 16 14.2093 16Z"
            fill="currentColor"
          />
          <path
            d="M19.2093 21C20.0378 21 20.7093 20.3284 20.7093 19.5C20.7093 18.6716 20.0378 18 19.2093 18C18.3809 18 17.7093 18.6716 17.7093 19.5C17.7093 20.3284 18.3809 21 19.2093 21Z"
            fill="currentColor"
          />
          <path
            d="M15.2093 11C16.5893 11 17.7093 9.88 17.7093 8.5V4H20.7093V2H16.7093V6.51C16.2893 6.19 15.7793 6 15.2093 6C13.8293 6 12.7093 7.12 12.7093 8.5C12.7093 9.88 13.8293 11 15.2093 11Z"
            fill="currentColor"
          />
          <path
            d="M9.44934 15.96L8.03934 17.37L7.32934 16.66L7.67934 16.31C8.65934 15.33 8.65934 13.75 7.67934 12.77C7.18934 12.28 6.54934 12.04 5.90934 12.04C5.26934 12.04 4.62934 12.28 4.13934 12.77C3.15934 13.75 3.15934 15.33 4.13934 16.31L4.48934 16.66L3.42934 17.72C2.44934 18.7 2.44934 20.28 3.42934 21.26C3.92934 21.76 4.56934 22 5.20934 22C5.84934 22 6.48934 21.76 6.97934 21.27L8.03934 20.21L9.44934 21.62L10.8593 20.21L9.44934 18.8L10.8593 17.39L9.44934 15.96ZM5.55934 14.2C5.67934 14.08 5.81934 14.05 5.90934 14.05C5.99934 14.05 6.13934 14.08 6.25934 14.2C6.44934 14.4 6.44934 14.71 6.25934 14.91L5.90934 15.26L5.55934 14.9C5.36934 14.71 5.36934 14.39 5.55934 14.2ZM5.55934 19.85C5.43934 19.97 5.29934 20 5.20934 20C5.11934 20 4.97934 19.97 4.85934 19.85C4.66934 19.66 4.66934 19.34 4.85934 19.14L5.91934 18.08L6.62934 18.79L5.55934 19.85Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEmojiTransportation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="emoji_transportation">
        <g id="Vector">
          <path
            d="M20.57 10.66C20.43 10.26 20.05 10 19.6 10H12.41C11.95 10 11.58 10.26 11.43 10.66L10 14.77L10.01 20.28C10.01 20.66 10.32 21 10.7 21H11.32C11.7 21 12 20.62 12 20.24V19H20V20.24C20 20.62 20.31 21 20.69 21H21.3C21.68 21 21.99 20.66 21.99 20.28L22 18.91V14.77L20.57 10.66ZM12.41 11H19.6L20.63 14H11.38L12.41 11ZM12 17C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15C12.55 15 13 15.45 13 16C13 16.55 12.55 17 12 17ZM20 17C19.45 17 19 16.55 19 16C19 15.45 19.45 15 20 15C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17Z"
            fill="currentColor"
          />
          <path d="M14 9H15V3H7V8H2V21H3V9H8V4H14V9Z" fill="currentColor" />
          <path d="M7 11H5V13H7V11Z" fill="currentColor" />
          <path d="M12 5H10V7H12V5Z" fill="currentColor" />
          <path d="M7 15H5V17H7V15Z" fill="currentColor" />
          <path d="M7 19H5V21H7V19Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconEnergySavingsLeaf(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="energy_savings_leaf">
        <g id="Vector">
          <path
            d="M12 3C7.2 3 3 6.86 3 12C3 14.12 3.74 16.07 4.97 17.61L3 19.59L4.41 21L6.38 19.03C7.93 20.26 9.88 21 12 21C14.3 21 16.61 20.12 18.36 18.36C20.12 16.61 21 14.3 21 12V3H12ZM19 12C19 13.87 18.27 15.63 16.95 16.95C15.63 18.27 13.87 19 12 19C8.14 19 5 15.86 5 12C5 10.1 5.74 8.32 7.1 7.01C8.42 5.71 10.16 5 12 5H19V12Z"
            fill="currentColor"
          />
          <path
            d="M8.46 12.63L12.51 13.03L10.07 16.36C9.96 16.52 9.97 16.74 10.11 16.88C10.26 17.03 10.51 17.04 10.67 16.89L15.83 12.26C16.16 11.96 15.98 11.41 15.53 11.37L11.48 10.97L13.92 7.64C14.03 7.48 14.02 7.26 13.88 7.12C13.73 6.97 13.48 6.96 13.32 7.11L8.16 11.74C7.84 12.04 8.02 12.59 8.46 12.63Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEngineering(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="engineering">
        <g id="Vector">
          <path
            d="M9.04492 15C6.37492 15 1.04492 16.34 1.04492 19V21H17.0449V19C17.0449 16.34 11.7149 15 9.04492 15ZM3.04492 19C3.26492 18.28 6.35492 17 9.04492 17C11.7449 17 14.8449 18.29 15.0449 19H3.04492Z"
            fill="currentColor"
          />
          <path
            d="M4.78492 9H5.04492C5.04492 11.21 6.83492 13 9.04492 13C11.2549 13 13.0449 11.21 13.0449 9H13.3049C13.5749 9 13.7949 8.78 13.7949 8.51V8.49C13.7949 8.22 13.5749 8 13.3049 8H13.0449C13.0449 6.52 12.2349 5.25 11.0449 4.55V5.5C11.0449 5.78 10.8249 6 10.5449 6C10.2649 6 10.0449 5.78 10.0449 5.5V4.14C9.72492 4.06 9.39492 4 9.04492 4C8.69492 4 8.36492 4.06 8.04492 4.14V5.5C8.04492 5.78 7.82492 6 7.54492 6C7.26492 6 7.04492 5.78 7.04492 5.5V4.55C5.85492 5.25 5.04492 6.52 5.04492 8H4.78492C4.51492 8 4.29492 8.22 4.29492 8.49V8.52C4.29492 8.78 4.51492 9 4.78492 9ZM11.0449 9C11.0449 10.1 10.1449 11 9.04492 11C7.94492 11 7.04492 10.1 7.04492 9H11.0449Z"
            fill="currentColor"
          />
          <path
            d="M22.0249 6.23L22.9549 5.4L22.2049 4.1L21.0149 4.49C20.8749 4.38 20.7149 4.29 20.5449 4.22L20.2949 3H18.7949L18.5449 4.22C18.3749 4.29 18.2149 4.38 18.0649 4.49L16.8849 4.1L16.1349 5.4L17.0649 6.23C17.0449 6.4 17.0449 6.58 17.0649 6.75L16.1349 7.6L16.8849 8.9L18.0849 8.52C18.2149 8.62 18.3649 8.7 18.5149 8.77L18.7949 10H20.2949L20.5649 8.78C20.7249 8.71 20.8649 8.63 21.0049 8.53L22.1949 8.91L22.9449 7.61L22.0149 6.76C22.0449 6.57 22.0349 6.4 22.0249 6.23ZM19.5449 7.75C18.8549 7.75 18.2949 7.19 18.2949 6.5C18.2949 5.81 18.8549 5.25 19.5449 5.25C20.2349 5.25 20.7949 5.81 20.7949 6.5C20.7949 7.19 20.2349 7.75 19.5449 7.75Z"
            fill="currentColor"
          />
          <path
            d="M19.4449 10.79L18.5949 11.07C18.4949 10.99 18.3849 10.93 18.2649 10.88L18.0849 10H17.0149L16.8349 10.87C16.7149 10.92 16.5949 10.99 16.4949 11.06L15.6549 10.78L15.1149 11.71L15.7749 12.3C15.7649 12.43 15.7649 12.55 15.7749 12.67L15.1149 13.28L15.6549 14.21L16.5149 13.94C16.6149 14.01 16.7149 14.07 16.8249 14.12L17.0049 15H18.0749L18.2649 14.13C18.3749 14.08 18.4849 14.02 18.5849 13.95L19.4349 14.22L19.9749 13.29L19.3149 12.68C19.3249 12.55 19.3249 12.43 19.3149 12.31L19.9749 11.72L19.4449 10.79ZM17.5449 13.39C17.0549 13.39 16.6549 12.99 16.6549 12.5C16.6549 12.01 17.0549 11.61 17.5449 11.61C18.0349 11.61 18.4349 12.01 18.4349 12.5C18.4349 12.99 18.0349 13.39 17.5449 13.39Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEnhancedEncryption(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="enhanced_encryption">
        <path
          id="Vector"
          d="M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM8.9 6.5C8.9 4.79 10.29 3.4 12 3.4C13.71 3.4 15.1 4.79 15.1 6.5V8.5H8.9V6.5ZM18 20.5H6V10.5H18V20.5ZM13 11.5H11V14.5H8V16.5H11V19.5H13V16.5H16V14.5H13V11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEqualizer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="equalizer">
        <path
          id="Vector"
          d="M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconError(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="error">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconErrorOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="error_outline">
        <path
          id="Vector"
          d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEscalator(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="escalator">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17 6H13.7L8.7 15H7C6.17 15 5.5 15.67 5.5 16.5C5.5 17.33 6.17 18 7 18H10.3L15.3 9H17C17.83 9 18.5 8.33 18.5 7.5C18.5 6.67 17.83 6 17 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEscalatorWarning(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="escalator_warning">
        <path
          id="Vector"
          d="M7 2C8.1 2 9 2.9 9 4C9 5.1 8.1 6 7 6C5.9 6 5 5.1 5 4C5 2.9 5.9 2 7 2ZM16 9.5C16 10.33 16.67 11 17.5 11C18.33 11 19 10.33 19 9.5C19 8.67 18.33 8 17.5 8C16.67 8 16 8.67 16 9.5ZM19 12H16.16C15.58 12.01 15.02 12.32 14.71 12.86L13.79 14.18L10.22 8C9.85 7.37 9.19 7.01 8.51 7H5.5C4.4 7 3.5 7.9 3.5 9V15H5V22H10V11.61L12.53 16H14.73L15.5 14.9V22H19.5V17H20.5V13.5C20.5 12.68 19.83 12 19 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEuro(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="euro">
        <path
          id="Vector"
          d="M15.5 18.5C12.99 18.5 10.82 17.08 9.74 15H15.5L16.5 13H9.08C9.03 12.67 9 12.34 9 12C9 11.66 9.03 11.33 9.08 11H15.5L16.5 9H9.74C10.82 6.92 13 5.5 15.5 5.5C17.11 5.5 18.59 6.09 19.73 7.07L21.5 5.3C19.91 3.87 17.8 3 15.5 3C11.58 3 8.26 5.51 7.02 9H3.5L2.5 11H6.56C6.52 11.33 6.5 11.66 6.5 12C6.5 12.34 6.52 12.67 6.56 13H3.5L2.5 15H7.02C8.26 18.49 11.58 21 15.5 21C17.81 21 19.91 20.13 21.5 18.7L19.72 16.93C18.59 17.91 17.12 18.5 15.5 18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEuroSymbol(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="euro_symbol">
        <path
          id="Vector"
          d="M15 18.5C12.49 18.5 10.32 17.08 9.24 15H15V13H8.58C8.53 12.67 8.5 12.34 8.5 12C8.5 11.66 8.53 11.33 8.58 11H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.51 6.52 9H3V11H6.06C6.02 11.33 6 11.66 6 12C6 12.34 6.02 12.67 6.06 13H3V15H6.52C7.76 18.49 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEvStation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ev_station">
        <path
          id="Vector"
          d="M19.52 7.23L19.53 7.22L15.81 3.5L14.75 4.56L16.86 6.67C15.92 7.03 15.25 7.93 15.25 9C15.25 10.38 16.37 11.5 17.75 11.5C18.11 11.5 18.44 11.42 18.75 11.29V18.5C18.75 19.05 18.3 19.5 17.75 19.5C17.2 19.5 16.75 19.05 16.75 18.5V14C16.75 12.9 15.85 12 14.75 12H13.75V5C13.75 3.9 12.85 3 11.75 3H5.75C4.65 3 3.75 3.9 3.75 5V21H13.75V13.5H15.25V18.5C15.25 19.88 16.37 21 17.75 21C19.13 21 20.25 19.88 20.25 18.5V9C20.25 8.31 19.97 7.68 19.52 7.23ZM11.75 11V19H5.75V5H11.75V11ZM17.75 10C17.2 10 16.75 9.55 16.75 9C16.75 8.45 17.2 8 17.75 8C18.3 8 18.75 8.45 18.75 9C18.75 9.55 18.3 10 17.75 10ZM9.75 6L5.75 13.5H7.75V18L11.75 11H9.75V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEvent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="event">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEventAvailable(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="event_available">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM5 8V6H19V8H5ZM10.56 18.46L16.49 12.53L15.43 11.47L10.56 16.34L8.45 14.23L7.39 15.29L10.56 18.46Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEventBusy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="event_busy">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM5 8V6H19V8H5ZM8.23 17.41L9.29 18.47L11.73 16.03L14.17 18.47L15.23 17.41L12.79 14.97L15.23 12.53L14.17 11.47L11.73 13.91L9.29 11.47L8.23 12.53L10.67 14.97L8.23 17.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEventNote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="event_note">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM5 8V6H19V8H5ZM7 12H17V14H7V12ZM7 16H14V18H7V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEventRepeat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="event_repeat">
        <path
          id="Vector"
          d="M19.5 11V5C19.5 3.9 18.6 3 17.5 3H16.5V1H14.5V3H6.5V1H4.5V3H3.5C2.4 3 1.5 3.9 1.5 5V19C1.5 20.1 2.4 21 3.5 21H10.5V19H3.5V9H17.5V11H19.5ZM17.5 7H3.5V5H17.5V7ZM14.14 19C14.57 20.45 15.91 21.5 17.5 21.5C19.43 21.5 21 19.93 21 18C21 16.07 19.43 14.5 17.5 14.5C16.55 14.5 15.68 14.88 15.05 15.5H16.5V17H12.5V13H14V14.43C14.9 13.55 16.14 13 17.5 13C20.26 13 22.5 15.24 22.5 18C22.5 20.76 20.26 23 17.5 23C15.08 23 13.06 21.28 12.6 19H14.14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconEventSeat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="event_seat">
        <path
          id="Vector"
          d="M15 5V12H9V5H15ZM15 3H9C7.9 3 7 3.9 7 5V14H17V5C17 3.9 16.1 3 15 3ZM22 10H19V13H22V10ZM5 10H2V13H5V10ZM20 15H4V21H6V17H18V21H20V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExitToApp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exit_to_app">
        <path
          id="Vector"
          d="M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C3.89 3 3 3.9 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExpand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="expand">
        <g id="Vector">
          <path d="M20 20H4V22H20V20Z" fill="currentColor" />
          <path d="M20 2H4V4H20V2Z" fill="currentColor" />
          <path
            d="M9.41 13.59L8 15L12 19L16 15L14.59 13.59L13 15.17V8.83L14.59 10.41L16 9L12 5L8 9L9.41 10.41L11 8.83V15.17L9.41 13.59Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconExpandCircleDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="expand_circle_down">
        <path
          id="Vector"
          d="M15.08 9.59L12 12.67L8.92 9.59L7.5 11L12 15.5L16.5 11L15.08 9.59ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExpandContent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="expand_content">
        <path id="Vector" d="M5 19V13H7V17H11V19H5ZM17 11V7H13V5H19V11H17Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconExpandLess(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="expand_less">
        <path
          id="Vector"
          d="M12 8.29504L6 14.295L7.41 15.705L12 11.125L16.59 15.705L18 14.295L12 8.29504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExpandMore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="expand_more">
        <path
          id="Vector"
          d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExplicit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="explicit">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15H11V13H15V11H11V9H15V7H9V17H15V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExplore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="explore">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 17.5L14.01 14.01L17.5 6.5L9.99 9.99L6.5 17.5ZM12 10.9C12.61 10.9 13.1 11.39 13.1 12C13.1 12.61 12.61 13.1 12 13.1C11.39 13.1 10.9 12.61 10.9 12C10.9 11.39 11.39 10.9 12 10.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExploreOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="explore_off">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 13.48 19.59 14.86 18.88 16.06L20.34 17.52C21.39 15.93 22 14.04 22 12C22 6.48 17.52 2 12 2C9.96 2 8.07 2.61 6.49 3.66L7.95 5.12C9.14 4.41 10.52 4 12 4ZM14.91 12.08L17.5 6.5L11.92 9.09L14.91 12.08ZM2.1 4.93L3.66 6.49C2.61 8.07 2 9.96 2 12C2 17.52 6.48 22 12 22C14.04 22 15.93 21.39 17.51 20.34L19.07 21.9L20.48 20.49L3.51 3.51L2.1 4.93ZM5.12 7.94L9.1 11.92L6.5 17.5L12.08 14.91L16.06 18.89C14.86 19.59 13.48 20 12 20C7.59 20 4 16.41 4 12C4 10.52 4.41 9.14 5.12 7.94Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExposure(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exposure">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17.59 5L5 17.59V5H17.59ZM6.41 19L19 6.41V19H6.41ZM6 7H11V8.5H6V7ZM16 12.5H14.5V14.5H12.5V16H14.5V18H16V16H18V14.5H16V12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExposureNeg1(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exposure_neg_1">
        <path
          id="Vector"
          d="M4.5 11.5V13.5H12.5V11.5H4.5ZM19.5 18.5H17.5V7.88L14.5 8.9V7.2L19.2 5.5H19.5V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExposureNeg2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exposure_neg_2">
        <path
          id="Vector"
          d="M15.55 16.79L18.41 13.72C18.79 13.33 19.13 12.93 19.45 12.54C19.77 12.15 20.04 11.76 20.27 11.37C20.5 10.98 20.68 10.59 20.81 10.2C20.94 9.81 21 9.41 21 9.02C21 8.49 20.91 8 20.73 7.56C20.55 7.12 20.29 6.75 19.95 6.45C19.61 6.14 19.18 5.91 18.69 5.74C18.18 5.58 17.61 5.5 16.97 5.5C16.28 5.5 15.66 5.61 15.12 5.82C14.58 6.03 14.12 6.33 13.76 6.7C13.39 7.07 13.11 7.5 12.92 8C12.74 8.47 12.65 8.97 12.64 9.5H14.78C14.79 9.19 14.83 8.9 14.91 8.63C15 8.34 15.14 8.09 15.31 7.88C15.49 7.67 15.72 7.51 15.99 7.39C16.26 7.27 16.59 7.21 16.95 7.21C17.26 7.21 17.53 7.26 17.76 7.36C17.99 7.46 18.19 7.61 18.35 7.79C18.51 7.97 18.63 8.19 18.72 8.44C18.8 8.69 18.85 8.96 18.85 9.25C18.85 9.47 18.82 9.68 18.77 9.9C18.71 10.12 18.62 10.35 18.48 10.6C18.34 10.85 18.16 11.13 17.92 11.43C17.69 11.73 17.4 12.08 17.04 12.46L12.87 17.01V18.5H21.5V16.79H15.55ZM2.5 11.5V13.5H10.5V11.5H2.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExposurePlus1(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exposure_plus_1">
        <path
          id="Vector"
          d="M10 7.5H8V11.5H4V13.5H8V17.5H10V13.5H14V11.5H10V7.5ZM20 18.5H18V7.88L15 8.9V7.2L19.7 5.5H20V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExposurePlus2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exposure_plus_2">
        <path
          id="Vector"
          d="M16.05 16.79L18.91 13.72C19.29 13.33 19.63 12.93 19.95 12.54C20.27 12.15 20.54 11.76 20.77 11.37C21 10.98 21.18 10.59 21.31 10.2C21.44 9.81 21.5 9.41 21.5 9.02C21.5 8.49 21.41 8 21.23 7.56C21.05 7.12 20.79 6.75 20.45 6.45C20.11 6.14 19.68 5.91 19.19 5.74C18.68 5.58 18.11 5.5 17.47 5.5C16.78 5.5 16.16 5.61 15.62 5.82C15.08 6.03 14.62 6.33 14.26 6.7C13.89 7.07 13.61 7.5 13.42 8C13.24 8.47 13.15 8.97 13.14 9.5H15.28C15.29 9.19 15.33 8.9 15.41 8.63C15.5 8.34 15.64 8.09 15.81 7.88C15.99 7.67 16.22 7.51 16.49 7.39C16.76 7.27 17.09 7.21 17.45 7.21C17.76 7.21 18.03 7.26 18.26 7.36C18.49 7.46 18.69 7.61 18.85 7.79C19.01 7.97 19.13 8.19 19.22 8.44C19.3 8.69 19.35 8.96 19.35 9.25C19.35 9.47 19.32 9.68 19.27 9.9C19.21 10.12 19.12 10.35 18.98 10.6C18.84 10.85 18.66 11.13 18.42 11.43C18.19 11.73 17.9 12.08 17.54 12.46L13.37 17.01V18.5H22V16.79H16.05ZM8 7.5H6V11.5H2V13.5H6V17.5H8V13.5H12V11.5H8V7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExposureZero(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="exposure_zero">
        <path
          id="Vector"
          d="M16.135 13C16.135 14 16.035 14.85 15.835 15.55C15.635 16.25 15.355 16.82 15.005 17.25C14.645 17.69 14.215 18 13.705 18.2C13.195 18.4 12.635 18.5 12.005 18.5C11.385 18.5 10.825 18.4 10.315 18.2C9.80498 18 9.36498 17.69 9.00498 17.25C8.64498 16.81 8.35498 16.24 8.15498 15.55C7.95498 14.85 7.85498 14 7.85498 13V10.96C7.85498 9.96 7.95498 9.11 8.15498 8.41C8.35498 7.71 8.63498 7.15 8.99498 6.72C9.35498 6.29 9.79498 5.98 10.305 5.79C10.805 5.6 11.375 5.5 11.995 5.5C12.625 5.5 13.185 5.6 13.695 5.79C14.205 5.98 14.645 6.29 15.005 6.72C15.365 7.15 15.645 7.71 15.845 8.41C16.045 9.11 16.145 9.95 16.145 10.96V13H16.135ZM14.025 10.64C14.025 10 13.975 9.46 13.895 9.02C13.805 8.58 13.675 8.23 13.495 7.96C13.325 7.69 13.105 7.5 12.855 7.38C12.605 7.25 12.315 7.19 11.995 7.19C11.675 7.19 11.385 7.25 11.135 7.37C10.885 7.49 10.665 7.68 10.495 7.95C10.325 8.22 10.185 8.57 10.095 9.01C10.005 9.45 9.96498 9.99 9.96498 10.63V13.3C9.96498 13.94 10.015 14.48 10.105 14.92C10.195 15.37 10.335 15.73 10.505 16.01C10.675 16.29 10.895 16.49 11.145 16.62C11.395 16.75 11.685 16.81 12.015 16.81C12.345 16.81 12.635 16.75 12.885 16.62C13.135 16.49 13.345 16.29 13.515 16.01C13.685 15.73 13.815 15.37 13.905 14.92C13.995 14.47 14.035 13.93 14.035 13.3V10.64H14.025Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExtension(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="extension">
        <path
          id="Vector"
          d="M10.75 4.25C11.03 4.25 11.25 4.47 11.25 4.75V6.75H17.25V12.75H19.25C19.53 12.75 19.75 12.97 19.75 13.25C19.75 13.53 19.53 13.75 19.25 13.75H17.25V19.75H15.13C14.45 18 12.74 16.75 10.75 16.75C8.76 16.75 7.05 18 6.37 19.75H4.25V17.63C6 16.95 7.25 15.24 7.25 13.25C7.25 11.26 6.01 9.55 4.26 8.87L4.25 6.75H10.25V4.75C10.25 4.47 10.47 4.25 10.75 4.25ZM10.75 2.25C9.37 2.25 8.25 3.37 8.25 4.75H4.25C3.15 4.75 2.26 5.65 2.26 6.75V10.55H2.55C4.04 10.55 5.25 11.76 5.25 13.25C5.25 14.74 4.04 15.95 2.55 15.95H2.25V19.75C2.25 20.85 3.15 21.75 4.25 21.75H8.05V21.45C8.05 19.96 9.26 18.75 10.75 18.75C12.24 18.75 13.45 19.96 13.45 21.45V21.75H17.25C18.35 21.75 19.25 20.85 19.25 19.75V15.75C20.63 15.75 21.75 14.63 21.75 13.25C21.75 11.87 20.63 10.75 19.25 10.75V6.75C19.25 5.65 18.35 4.75 17.25 4.75H13.25C13.25 3.37 12.13 2.25 10.75 2.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconExtensionOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="extension_off">
        <path
          id="Vector"
          d="M1.44495 4.17001L3.06495 5.79001C3.06495 5.84001 3.05495 5.89001 3.05495 5.95001V9.75001C5.75495 9.75001 6.05495 11.91 6.05495 12.45C6.05495 12.99 5.76495 15.15 3.05495 15.15V18.95C3.05495 20.05 3.95495 20.95 5.05495 20.95H8.85495C8.85495 18.24 11.0149 17.95 11.5549 17.95C12.0949 17.95 14.2549 18.24 14.2549 20.95H18.0549C18.1149 20.95 18.1649 20.95 18.2149 20.94L19.8249 22.55L21.2349 21.14L2.86495 2.76001L1.44495 4.17001ZM11.5549 15.95C10.0549 15.95 7.98495 16.78 7.18495 18.95H5.05495V16.82C7.22495 16.02 8.05495 13.95 8.05495 12.45C8.05495 11.76 7.87495 10.95 7.47495 10.2L13.8049 16.53C13.0549 16.13 12.2449 15.95 11.5549 15.95ZM8.88495 5.95001L6.88495 3.95001H9.05495C9.05495 2.57001 10.1749 1.45001 11.5549 1.45001C12.9349 1.45001 14.0549 2.57001 14.0549 3.95001H18.0549C19.1549 3.95001 20.0549 4.85001 20.0549 5.95001V9.95001C21.4349 9.95001 22.5549 11.07 22.5549 12.45C22.5549 13.83 21.4349 14.95 20.0549 14.95V17.12L18.0549 15.12V12.95H20.0549C20.3349 12.95 20.5549 12.73 20.5549 12.45C20.5549 12.17 20.3349 11.95 20.0549 11.95H18.0549V5.95001H12.0549V3.95001C12.0549 3.67001 11.8349 3.45001 11.5549 3.45001C11.2749 3.45001 11.0549 3.67001 11.0549 3.95001V5.95001H8.88495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFace(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face">
        <path
          id="Vector"
          d="M10.25 13C10.25 13.69 9.69 14.25 9 14.25C8.31 14.25 7.75 13.69 7.75 13C7.75 12.31 8.31 11.75 9 11.75C9.69 11.75 10.25 12.31 10.25 13ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM10.66 4.12C12.06 6.44 14.6 8 17.5 8C17.96 8 18.41 7.95 18.84 7.88C17.44 5.56 14.9 4 12 4C11.54 4 11.09 4.05 10.66 4.12ZM4.42 9.47C6.13 8.5 7.45 6.92 8.08 5.03C6.37 6 5.05 7.58 4.42 9.47ZM20 12C20 11.22 19.88 10.47 19.67 9.76C18.97 9.91 18.25 10 17.5 10C14.37 10 11.58 8.56 9.74 6.31C8.69 8.87 6.6 10.88 4 11.86C4.01 11.9 4 11.95 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFace2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_2" clipPath="url(#clip0_395_344)">
        <g id="Vector">
          <path
            d="M21.97 13.52C21.97 13.51 21.97 13.5 21.97 13.48C23.21 12.38 24 10.78 24 9C24 5.69 21.31 3 18 3C17.74 3 17.48 3.02 17.22 3.06C16.19 1.23 14.24 0 12 0C9.76 0 7.81 1.23 6.78 3.06C6.52 3.02 6.26 3 6 3C2.69 3 0 5.69 0 9C0 10.78 0.79 12.38 2.02 13.48C2.02 13.49 2.02 13.5 2.02 13.52C0.79 14.62 0 16.22 0 18C0 21.31 2.69 24 6 24C7.39 24 8.67 23.52 9.69 22.72C10.43 22.9 11.2 23 12 23C12.8 23 13.57 22.9 14.31 22.72C15.33 23.52 16.61 24 18 24C21.31 24 24 21.31 24 18C24 16.22 23.21 14.62 21.97 13.52ZM22 9C22 9.55 21.88 10.07 21.68 10.54C21.11 8.29 19.78 6.35 17.98 5C17.99 5 17.99 5 18 5C20.21 5 22 6.79 22 9ZM12.03 5C14.76 5.01 17.16 6.39 18.6 8.48C17.89 9.05 17 9.37 16.07 9.37C13.82 9.38 12 7.55 12 5.31C12 5.21 12.02 5.11 12.03 5ZM12 2C13.25 2 14.36 2.59 15.1 3.5C14.12 3.18 13.08 3 12 3C10.92 3 9.88 3.18 8.9 3.5C9.64 2.59 10.75 2 12 2ZM6 5C6.01 5 6.01 5 6.02 5C4.22 6.35 2.89 8.29 2.32 10.54C2.12 10.07 2 9.55 2 9C2 6.79 3.79 5 6 5ZM6 22C3.79 22 2 20.21 2 18C2 17.31 2.19 16.68 2.5 16.12C3.3 18.56 5.02 20.59 7.24 21.8C6.85 21.93 6.44 22 6 22ZM4 13C4 9.28 6.56 6.15 10 5.26C10 5.28 10 5.29 10 5.31C10 8.65 12.72 11.37 16.06 11.37C17.32 11.37 18.51 10.98 19.51 10.28C19.82 11.14 20 12.05 20 13C20 17.41 16.41 21 12 21C7.59 21 4 17.41 4 13ZM18 22C17.56 22 17.15 21.93 16.75 21.8C18.98 20.59 20.69 18.56 21.49 16.12C21.8 16.68 21.99 17.32 21.99 18C22 20.21 20.21 22 18 22Z"
            fill="currentColor"
          />
          <path
            d="M9 15.25C9.69036 15.25 10.25 14.6904 10.25 14C10.25 13.3096 9.69036 12.75 9 12.75C8.30964 12.75 7.75 13.3096 7.75 14C7.75 14.6904 8.30964 15.25 9 15.25Z"
            fill="currentColor"
          />
          <path
            d="M15 15.25C15.6904 15.25 16.25 14.6904 16.25 14C16.25 13.3096 15.6904 12.75 15 12.75C14.3096 12.75 13.75 13.3096 13.75 14C13.75 14.6904 14.3096 15.25 15 15.25Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_344">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconFace3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_3">
        <g id="Vector">
          <path
            d="M9.00446 13.25C9.69481 13.25 10.2545 12.6904 10.2545 12C10.2545 11.3096 9.69481 10.75 9.00446 10.75C8.3141 10.75 7.75446 11.3096 7.75446 12C7.75446 12.6904 8.3141 13.25 9.00446 13.25Z"
            fill="currentColor"
          />
          <path
            d="M15.0045 13.25C15.6948 13.25 16.2545 12.6904 16.2545 12C16.2545 11.3096 15.6948 10.75 15.0045 10.75C14.3141 10.75 13.7545 11.3096 13.7545 12C13.7545 12.6904 14.3141 13.25 15.0045 13.25Z"
            fill="currentColor"
          />
          <path
            d="M22.9145 10.96C22.3945 5.32 17.6645 1 12.0045 1C6.34446 1 1.61446 5.32 1.09446 10.96L0.194457 20.82C0.0944567 21.99 1.01446 23 2.19446 23H21.8145C22.9945 23 23.9145 21.99 23.8045 20.82L22.9145 10.96ZM13.0045 3.07C15.2645 3.35 17.2245 4.58 18.4945 6.35C17.9145 6.75 17.2345 7 16.5045 7C14.5745 7 13.0045 5.43 13.0045 3.5V3.07ZM11.0045 3.07V3.5C11.0045 5.43 9.43446 7 7.50446 7C6.77446 7 6.09446 6.75 5.51446 6.35C6.78446 4.58 8.74446 3.35 11.0045 3.07ZM4.54446 8.13C5.41446 8.68 6.43446 9 7.50446 9C9.36446 9 11.0045 8.07 12.0045 6.65C13.0045 8.07 14.6445 9 16.5045 9C17.5745 9 18.5945 8.68 19.4645 8.13C19.8045 9.02 20.0045 9.99 20.0045 11C20.0045 15.41 16.4145 19 12.0045 19C7.59446 19 4.00446 15.41 4.00446 11C4.00446 9.99 4.20446 9.02 4.54446 8.13ZM12.0045 21H2.19446L2.75446 14.8C4.25446 18.44 7.82446 21 12.0045 21C16.1845 21 19.7545 18.44 21.2545 14.8L21.8145 21H12.0045Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFace4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_4">
        <g id="Vector">
          <path
            d="M13 3C12.04 3 11.12 3.14 10.25 3.39C9.37 1.96 7.8 1 6 1C3.24 1 1 3.24 1 6C1 7.8 1.96 9.37 3.39 10.25C3.14 11.12 3 12.04 3 13C3 18.52 7.48 23 13 23C18.52 23 23 18.52 23 13C23 7.48 18.52 3 13 3ZM13 5C15.9 5 18.44 6.56 19.84 8.88C19.41 8.95 18.96 9 18.5 9C15.6 9 13.06 7.44 11.66 5.12C12.09 5.05 12.54 5 13 5ZM5.42 10.47C6.05 8.58 7.37 7 9.08 6.03C8.45 7.92 7.13 9.5 5.42 10.47ZM3 6C3 4.35 4.35 3 6 3C6.95 3 7.8 3.46 8.35 4.15C6.56 5.09 5.09 6.56 4.15 8.35C3.46 7.8 3 6.95 3 6ZM13 21C8.59 21 5 17.41 5 13C5 12.95 5.01 12.9 5.01 12.85C7.61 11.87 9.69 9.86 10.75 7.3C12.58 9.56 15.37 11 18.5 11C19.25 11 19.97 10.91 20.67 10.76C20.88 11.47 21 12.22 21 13C21 17.41 17.41 21 13 21Z"
            fill="currentColor"
          />
          <path
            d="M10 15.25C10.6904 15.25 11.25 14.6904 11.25 14C11.25 13.3096 10.6904 12.75 10 12.75C9.30964 12.75 8.75 13.3096 8.75 14C8.75 14.6904 9.30964 15.25 10 15.25Z"
            fill="currentColor"
          />
          <path
            d="M16 15.25C16.6904 15.25 17.25 14.6904 17.25 14C17.25 13.3096 16.6904 12.75 16 12.75C15.3096 12.75 14.75 13.3096 14.75 14C14.75 14.6904 15.3096 15.25 16 15.25Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFace5(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_5">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 10.88 4.23 9.82 4.65 8.85C4.74 8.94 4.86 9 5 9C5.28 9 5.5 8.78 5.5 8.5C5.5 8.25 5.31 8.05 5.07 8.01C5.22 7.75 5.39 7.5 5.56 7.26C5.53 7.34 5.5 7.41 5.5 7.5C5.5 7.78 5.72 8 6 8C6.28 8 6.5 7.78 6.5 7.5C6.5 7.22 6.28 7 6 7C5.87 7 5.75 7.05 5.66 7.13C6.18 6.45 6.81 5.85 7.52 5.37C7.51 5.41 7.5 5.45 7.5 5.5C7.5 5.78 7.72 6 8 6C8.28 6 8.5 5.78 8.5 5.5C8.5 5.26 8.33 5.07 8.1 5.02C8.26 4.93 8.42 4.85 8.59 4.77C8.68 4.91 8.83 5 9 5C9.28 5 9.5 4.78 9.5 4.5C9.5 4.47 9.49 4.44 9.48 4.41C9.87 4.28 10.27 4.18 10.69 4.11C10.58 4.21 10.5 4.34 10.5 4.5C10.5 4.78 10.72 5 11 5C11.28 5 11.5 4.78 11.5 4.5C11.5 4.29 11.37 4.12 11.2 4.04C11.46 4.01 11.73 4 12 4C12.27 4 12.54 4.01 12.8 4.04C12.62 4.12 12.5 4.29 12.5 4.5C12.5 4.78 12.72 5 13 5C13.28 5 13.5 4.78 13.5 4.5C13.5 4.34 13.42 4.21 13.31 4.12C13.72 4.19 14.13 4.29 14.52 4.42C14.51 4.44 14.5 4.47 14.5 4.5C14.5 4.78 14.72 5 15 5C15.17 5 15.32 4.91 15.41 4.77C15.58 4.85 15.74 4.93 15.9 5.02C15.67 5.07 15.5 5.26 15.5 5.5C15.5 5.78 15.72 6 16 6C16.28 6 16.5 5.78 16.5 5.5C16.5 5.45 16.49 5.41 16.47 5.37C17.18 5.85 17.81 6.45 18.33 7.13C18.25 7.05 18.13 7 18 7C17.72 7 17.5 7.22 17.5 7.5C17.5 7.78 17.72 8 18 8C18.28 8 18.5 7.78 18.5 7.5C18.5 7.41 18.47 7.34 18.43 7.27C18.61 7.51 18.77 7.76 18.92 8.02C18.69 8.05 18.5 8.25 18.5 8.5C18.5 8.78 18.72 9 19 9C19.14 9 19.26 8.94 19.35 8.85C19.77 9.82 20 10.88 20 12C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M9 14.25C9.69036 14.25 10.25 13.6904 10.25 13C10.25 12.3096 9.69036 11.75 9 11.75C8.30964 11.75 7.75 12.3096 7.75 13C7.75 13.6904 8.30964 14.25 9 14.25Z"
            fill="currentColor"
          />
          <path
            d="M12 6C12.2761 6 12.5 5.77614 12.5 5.5C12.5 5.22386 12.2761 5 12 5C11.7239 5 11.5 5.22386 11.5 5.5C11.5 5.77614 11.7239 6 12 6Z"
            fill="currentColor"
          />
          <path
            d="M14 6C14.2761 6 14.5 5.77614 14.5 5.5C14.5 5.22386 14.2761 5 14 5C13.7239 5 13.5 5.22386 13.5 5.5C13.5 5.77614 13.7239 6 14 6Z"
            fill="currentColor"
          />
          <path
            d="M10 6C10.2761 6 10.5 5.77614 10.5 5.5C10.5 5.22386 10.2761 5 10 5C9.72386 5 9.5 5.22386 9.5 5.5C9.5 5.77614 9.72386 6 10 6Z"
            fill="currentColor"
          />
          <path
            d="M17 7C17.2761 7 17.5 6.77614 17.5 6.5C17.5 6.22386 17.2761 6 17 6C16.7239 6 16.5 6.22386 16.5 6.5C16.5 6.77614 16.7239 7 17 7Z"
            fill="currentColor"
          />
          <path
            d="M9 7C9.27614 7 9.5 6.77614 9.5 6.5C9.5 6.22386 9.27614 6 9 6C8.72386 6 8.5 6.22386 8.5 6.5C8.5 6.77614 8.72386 7 9 7Z"
            fill="currentColor"
          />
          <path
            d="M7 7C7.27614 7 7.5 6.77614 7.5 6.5C7.5 6.22386 7.27614 6 7 6C6.72386 6 6.5 6.22386 6.5 6.5C6.5 6.77614 6.72386 7 7 7Z"
            fill="currentColor"
          />
          <path
            d="M11 7C11.2761 7 11.5 6.77614 11.5 6.5C11.5 6.22386 11.2761 6 11 6C10.7239 6 10.5 6.22386 10.5 6.5C10.5 6.77614 10.7239 7 11 7Z"
            fill="currentColor"
          />
          <path
            d="M13 7C13.2761 7 13.5 6.77614 13.5 6.5C13.5 6.22386 13.2761 6 13 6C12.7239 6 12.5 6.22386 12.5 6.5C12.5 6.77614 12.7239 7 13 7Z"
            fill="currentColor"
          />
          <path
            d="M15 7C15.2761 7 15.5 6.77614 15.5 6.5C15.5 6.22386 15.2761 6 15 6C14.7239 6 14.5 6.22386 14.5 6.5C14.5 6.77614 14.7239 7 15 7Z"
            fill="currentColor"
          />
          <path
            d="M12 8C12.2761 8 12.5 7.77614 12.5 7.5C12.5 7.22386 12.2761 7 12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8Z"
            fill="currentColor"
          />
          <path
            d="M14 8C14.2761 8 14.5 7.77614 14.5 7.5C14.5 7.22386 14.2761 7 14 7C13.7239 7 13.5 7.22386 13.5 7.5C13.5 7.77614 13.7239 8 14 8Z"
            fill="currentColor"
          />
          <path
            d="M16 8C16.2761 8 16.5 7.77614 16.5 7.5C16.5 7.22386 16.2761 7 16 7C15.7239 7 15.5 7.22386 15.5 7.5C15.5 7.77614 15.7239 8 16 8Z"
            fill="currentColor"
          />
          <path
            d="M10 8C10.2761 8 10.5 7.77614 10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5C9.5 7.77614 9.72386 8 10 8Z"
            fill="currentColor"
          />
          <path
            d="M8 8C8.27614 8 8.5 7.77614 8.5 7.5C8.5 7.22386 8.27614 7 8 7C7.72386 7 7.5 7.22386 7.5 7.5C7.5 7.77614 7.72386 8 8 8Z"
            fill="currentColor"
          />
          <path
            d="M9 9C9.27614 9 9.5 8.77614 9.5 8.5C9.5 8.22386 9.27614 8 9 8C8.72386 8 8.5 8.22386 8.5 8.5C8.5 8.77614 8.72386 9 9 9Z"
            fill="currentColor"
          />
          <path
            d="M7 9C7.27614 9 7.5 8.77614 7.5 8.5C7.5 8.22386 7.27614 8 7 8C6.72386 8 6.5 8.22386 6.5 8.5C6.5 8.77614 6.72386 9 7 9Z"
            fill="currentColor"
          />
          <path
            d="M11 9C11.2761 9 11.5 8.77614 11.5 8.5C11.5 8.22386 11.2761 8 11 8C10.7239 8 10.5 8.22386 10.5 8.5C10.5 8.77614 10.7239 9 11 9Z"
            fill="currentColor"
          />
          <path
            d="M13 9C13.2761 9 13.5 8.77614 13.5 8.5C13.5 8.22386 13.2761 8 13 8C12.7239 8 12.5 8.22386 12.5 8.5C12.5 8.77614 12.7239 9 13 9Z"
            fill="currentColor"
          />
          <path
            d="M15 9C15.2761 9 15.5 8.77614 15.5 8.5C15.5 8.22386 15.2761 8 15 8C14.7239 8 14.5 8.22386 14.5 8.5C14.5 8.77614 14.7239 9 15 9Z"
            fill="currentColor"
          />
          <path
            d="M17 9C17.2761 9 17.5 8.77614 17.5 8.5C17.5 8.22386 17.2761 8 17 8C16.7239 8 16.5 8.22386 16.5 8.5C16.5 8.77614 16.7239 9 17 9Z"
            fill="currentColor"
          />
          <path
            d="M15 14.25C15.6904 14.25 16.25 13.6904 16.25 13C16.25 12.3096 15.6904 11.75 15 11.75C14.3096 11.75 13.75 12.3096 13.75 13C13.75 13.6904 14.3096 14.25 15 14.25Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFace6(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_6">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 4C15.68 4 18.78 6.51 19.71 9.9C19.11 9.74 18.38 9.53 17.45 7.66C16.94 6.64 15.91 6 14.76 6H9.24C8.09 6 7.06 6.64 6.55 7.66C5.62 9.52 4.97 9.72 4.29 9.9C5.22 6.51 8.32 4 12 4ZM12 20C7.59 20 4 16.41 4 12C4 11.99 4 11.98 4 11.97C6.31 11.75 7.43 10.38 8.34 8.56C8.51 8.21 8.85 8 9.24 8H14.77C15.15 8 15.49 8.21 15.66 8.55C16.56 10.35 17.65 11.74 20 11.96C20 11.97 20 11.98 20 11.99C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M9 14.25C9.69036 14.25 10.25 13.6904 10.25 13C10.25 12.3096 9.69036 11.75 9 11.75C8.30964 11.75 7.75 12.3096 7.75 13C7.75 13.6904 8.30964 14.25 9 14.25Z"
            fill="currentColor"
          />
          <path
            d="M15 14.25C15.6904 14.25 16.25 13.6904 16.25 13C16.25 12.3096 15.6904 11.75 15 11.75C14.3096 11.75 13.75 12.3096 13.75 13C13.75 13.6904 14.3096 14.25 15 14.25Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFaceRetouchingNatural(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_retouching_natural">
        <g id="Vector">
          <path
            d="M19.39 11.25C19.46 11.66 19.5 12.07 19.5 12.5C19.5 16.91 15.91 20.5 11.5 20.5C7.09 20.5 3.5 16.91 3.5 12.5C3.5 12.45 3.51 12.4 3.5 12.36C6.1 11.38 8.19 9.37 9.24 6.81C12.62 10.95 17.21 10.54 18.23 10.42L17.34 8.49C17.21 8.5 12.72 8.87 10.16 4.63C11.17 4.47 11.87 4.48 12.75 4.62C15.27 3.47 14.68 3.73 15.51 3.36C14.28 2.8 12.93 2.5 11.5 2.5C5.98 2.5 1.5 6.98 1.5 12.5C1.5 18.02 5.98 22.5 11.5 22.5C17.02 22.5 21.5 18.02 21.5 12.5C21.5 11.07 21.2 9.72 20.66 8.49L19.39 11.25ZM7.58 5.53C6.95 7.42 5.63 9 3.92 9.97C4.55 8.08 5.87 6.5 7.58 5.53Z"
            fill="currentColor"
          />
          <path
            d="M14.5 14.75C15.1904 14.75 15.75 14.1904 15.75 13.5C15.75 12.8096 15.1904 12.25 14.5 12.25C13.8096 12.25 13.25 12.8096 13.25 13.5C13.25 14.1904 13.8096 14.75 14.5 14.75Z"
            fill="currentColor"
          />
          <path
            d="M8.5 14.75C9.19036 14.75 9.75 14.1904 9.75 13.5C9.75 12.8096 9.19036 12.25 8.5 12.25C7.80964 12.25 7.25 12.8096 7.25 13.5C7.25 14.1904 7.80964 14.75 8.5 14.75Z"
            fill="currentColor"
          />
          <path
            d="M22.5 5L20.1 3.9L19 1.5L17.9 3.9L15.5 5L17.9 6.1L19 8.5L20.1 6.1L22.5 5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFaceRetouchingOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="face_retouching_off">
        <g id="Vector">
          <path
            d="M9.05507 14.1949C9.74542 14.1949 10.3051 13.6353 10.3051 12.9449C10.3051 12.2546 9.74542 11.6949 9.05507 11.6949C8.36471 11.6949 7.80507 12.2546 7.80507 12.9449C7.80507 13.6353 8.36471 14.1949 9.05507 14.1949Z"
            fill="currentColor"
          />
          <path
            d="M17.5551 9.94495C18.3051 9.94495 19.0251 9.85495 19.7251 9.70495C19.9351 10.4149 20.0551 11.1649 20.0551 11.9449C20.0551 13.1649 19.7751 14.3149 19.2851 15.3449L20.7751 16.8349C21.5851 15.3849 22.0551 13.7249 22.0551 11.9449C22.0551 6.42495 17.5751 1.94495 12.0551 1.94495C10.2751 1.94495 8.61507 2.41495 7.16507 3.22495L12.4951 8.55495C13.9851 9.43495 15.7051 9.94495 17.5551 9.94495ZM10.7151 4.06495C11.1451 3.99495 11.5951 3.94495 12.0551 3.94495C14.9551 3.94495 17.4951 5.50495 18.8951 7.82495C18.4651 7.89495 18.0151 7.94495 17.5551 7.94495C14.6551 7.94495 12.1151 6.38495 10.7151 4.06495Z"
            fill="currentColor"
          />
          <path
            d="M1.94507 3.66495L4.13507 5.85495C2.83507 7.54495 2.05507 9.65495 2.05507 11.9449C2.05507 17.4649 6.53507 21.9449 12.0551 21.9449C14.3451 21.9449 16.4551 21.1649 18.1451 19.8649L20.3351 22.0549L21.7451 20.6449L3.36507 2.25495L1.94507 3.66495ZM16.7151 18.4349C15.4051 19.3849 13.7951 19.9449 12.0551 19.9449C7.64507 19.9449 4.05507 16.3549 4.05507 11.9449C4.05507 11.8949 4.06507 11.8449 4.05507 11.8049C5.44507 11.2849 6.68507 10.4549 7.69507 9.41495L16.7151 18.4349ZM6.28507 8.00495C5.75507 8.55495 5.14507 9.03495 4.47507 9.41495C4.73507 8.64495 5.10507 7.93495 5.56507 7.28495L6.28507 8.00495Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFactCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fact_check">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 19H4V5H20V19Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.41 10.42L17.99 9L14.82 12.17L13.41 10.75L12 12.16L14.82 15L19.41 10.42Z"
            fill="currentColor"
          />
          <path d="M10 7H5V9H10V7Z" fill="currentColor" />
          <path d="M10 11H5V13H10V11Z" fill="currentColor" />
          <path d="M10 15H5V17H10V15Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconFactory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="factory">
        <path
          id="Vector"
          d="M22 22H2V10L9 7V9L14 7V10H17L18 2H21L22 10V22ZM12 9.95L7 11.95V10L4 11.32V20H20V12H12V9.95ZM11 18H13V14H11V18ZM7 18H9V14H7V18ZM17 14H15V18H17V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFamilyRestroom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="family_restroom">
        <path
          id="Vector"
          d="M15.75 4C15.75 2.89 16.64 2 17.75 2C18.86 2 19.75 2.89 19.75 4C19.75 5.11 18.86 6 17.75 6C16.64 6 15.75 5.11 15.75 4ZM19.75 22V16H22.25L19.71 8.37C19.43 7.55 18.67 7 17.81 7H17.69C16.83 7 16.06 7.55 15.79 8.37L14.93 10.95C16.01 11.55 16.75 12.68 16.75 14V22H19.75ZM12.25 11.5C13.08 11.5 13.75 10.83 13.75 10C13.75 9.17 13.08 8.5 12.25 8.5C11.42 8.5 10.75 9.17 10.75 10C10.75 10.83 11.42 11.5 12.25 11.5ZM5.25 6C6.36 6 7.25 5.11 7.25 4C7.25 2.89 6.36 2 5.25 2C4.14 2 3.25 2.89 3.25 4C3.25 5.11 4.14 6 5.25 6ZM7.25 22V15H8.75V9C8.75 7.9 7.85 7 6.75 7H3.75C2.65 7 1.75 7.9 1.75 9V15H3.25V22H7.25ZM13.75 22V18H14.75V14C14.75 13.18 14.07 12.5 13.25 12.5H11.25C10.43 12.5 9.75 13.18 9.75 14V18H10.75V22H13.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFastForward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fast_forward">
        <path
          id="Vector"
          d="M14.25 9.86L17.28 12L14.25 14.14V9.86ZM5.25 9.86L8.28 12L5.25 14.14V9.86ZM12.25 6V18L20.75 12L12.25 6ZM3.25 6V18L11.75 12L3.25 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFastRewind(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fast_rewind">
        <path
          id="Vector"
          d="M18.75 9.86V14.14L15.72 12L18.75 9.86ZM9.75 9.86V14.14L6.72 12L9.75 9.86ZM20.75 6L12.25 12L20.75 18V6ZM11.75 6L3.25 12L11.75 18V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFastfood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fastfood">
        <path
          id="Vector"
          d="M1 21.98C1 22.54 1.45 22.99 2.01 22.99H15C15.56 22.99 16.01 22.54 16.01 21.98V21H1V21.98ZM8.5 8.99C4.75 8.99 1 11 1 15H16C16 11 12.25 8.99 8.5 8.99ZM3.62 13C4.73 11.45 7.09 10.99 8.5 10.99C9.91 10.99 12.27 11.45 13.38 13H3.62ZM1 17H16V19H1V17ZM18 5V1H16V5H11L11.23 7H20.79L19.39 21H18V23H19.72C20.56 23 21.25 22.35 21.35 21.53L23 5H18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFavorite(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="favorite">
        <path
          id="Vector"
          d="M12 21.175L10.55 19.855C5.4 15.185 2 12.105 2 8.32501C2 5.24501 4.42 2.82501 7.5 2.82501C9.24 2.82501 10.91 3.63501 12 4.91501C13.09 3.63501 14.76 2.82501 16.5 2.82501C19.58 2.82501 22 5.24501 22 8.32501C22 12.105 18.6 15.185 13.45 19.865L12 21.175Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFavoriteBorder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="favorite_border">
        <path
          id="Vector"
          d="M16.5 2.82501C14.76 2.82501 13.09 3.63501 12 4.91501C10.91 3.63501 9.24 2.82501 7.5 2.82501C4.42 2.82501 2 5.24501 2 8.32501C2 12.105 5.4 15.185 10.55 19.865L12 21.175L13.45 19.855C18.6 15.185 22 12.105 22 8.32501C22 5.24501 19.58 2.82501 16.5 2.82501ZM12.1 18.375L12 18.475L11.9 18.375C7.14 14.065 4 11.215 4 8.32501C4 6.32501 5.5 4.82501 7.5 4.82501C9.04 4.82501 10.54 5.81501 11.07 7.18501H12.94C13.46 5.81501 14.96 4.82501 16.5 4.82501C18.5 4.82501 20 6.32501 20 8.32501C20 11.215 16.86 14.065 12.1 18.375Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFax(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fax">
        <g id="Vector">
          <path
            d="M19 8.5H18V3.5H8V8.5H7.22C6.67 7.89 5.89 7.5 5 7.5C3.34 7.5 2 8.84 2 10.5V17.5C2 19.16 3.34 20.5 5 20.5C5.89 20.5 6.67 20.11 7.22 19.5H22V11.5C22 9.84 20.66 8.5 19 8.5ZM6 17.5C6 18.05 5.55 18.5 5 18.5C4.45 18.5 4 18.05 4 17.5V10.5C4 9.95 4.45 9.5 5 9.5C5.55 9.5 6 9.95 6 10.5V17.5ZM10 5.5H16V8.5H10V5.5ZM20 17.5H8V10.5H19C19.55 10.5 20 10.95 20 11.5V17.5Z"
            fill="currentColor"
          />
          <path
            d="M15 13.5C15.5523 13.5 16 13.0523 16 12.5C16 11.9477 15.5523 11.5 15 11.5C14.4477 11.5 14 11.9477 14 12.5C14 13.0523 14.4477 13.5 15 13.5Z"
            fill="currentColor"
          />
          <path
            d="M18 13.5C18.5523 13.5 19 13.0523 19 12.5C19 11.9477 18.5523 11.5 18 11.5C17.4477 11.5 17 11.9477 17 12.5C17 13.0523 17.4477 13.5 18 13.5Z"
            fill="currentColor"
          />
          <path
            d="M15 16.5C15.5523 16.5 16 16.0523 16 15.5C16 14.9477 15.5523 14.5 15 14.5C14.4477 14.5 14 14.9477 14 15.5C14 16.0523 14.4477 16.5 15 16.5Z"
            fill="currentColor"
          />
          <path
            d="M18 16.5C18.5523 16.5 19 16.0523 19 15.5C19 14.9477 18.5523 14.5 18 14.5C17.4477 14.5 17 14.9477 17 15.5C17 16.0523 17.4477 16.5 18 16.5Z"
            fill="currentColor"
          />
          <path d="M13 11.5H9V16.5H13V11.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconFeaturedPlayList(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="featured_play_list">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM5 10H14V12H5V10ZM5 7H14V9H5V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFeaturedSeasonalAndGifts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="featured_seasonal_and_gifts">
        <path
          id="Vector"
          d="M4 22V11H2V5H7.2C7.11667 4.85 7.0625 4.69167 7.0375 4.525C7.0125 4.35833 7 4.18333 7 4C7 3.16667 7.29167 2.45833 7.875 1.875C8.45833 1.29167 9.16667 1 10 1C10.3833 1 10.7417 1.07083 11.075 1.2125C11.4083 1.35417 11.7167 1.55 12 1.8C12.2833 1.53333 12.5917 1.33333 12.925 1.2C13.2583 1.06667 13.6167 1 14 1C14.8333 1 15.5417 1.29167 16.125 1.875C16.7083 2.45833 17 3.16667 17 4C17 4.18333 16.9833 4.35417 16.95 4.5125C16.9167 4.67083 16.8667 4.83333 16.8 5H22V11H20V22H4ZM14 3C13.7167 3 13.4792 3.09583 13.2875 3.2875C13.0958 3.47917 13 3.71667 13 4C13 4.28333 13.0958 4.52083 13.2875 4.7125C13.4792 4.90417 13.7167 5 14 5C14.2833 5 14.5208 4.90417 14.7125 4.7125C14.9042 4.52083 15 4.28333 15 4C15 3.71667 14.9042 3.47917 14.7125 3.2875C14.5208 3.09583 14.2833 3 14 3ZM9 4C9 4.28333 9.09583 4.52083 9.2875 4.7125C9.47917 4.90417 9.71667 5 10 5C10.2833 5 10.5208 4.90417 10.7125 4.7125C10.9042 4.52083 11 4.28333 11 4C11 3.71667 10.9042 3.47917 10.7125 3.2875C10.5208 3.09583 10.2833 3 10 3C9.71667 3 9.47917 3.09583 9.2875 3.2875C9.09583 3.47917 9 3.71667 9 4ZM4 7V9H11V7H4ZM11 20V11H6V20H11ZM13 20H18V11H13V20ZM20 9V7H13V9H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFeaturedVideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="featured_video">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM4 6H13V13H4V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFeed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="feed">
        <path
          id="Vector"
          d="M16 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V8L16 3ZM19 19H5V5H15V9H19V19ZM7 17H17V15H7V17ZM12 7H7V9H12V7ZM7 13H17V11H7V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFeedback(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="feedback">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM11 12H13V14H11V12ZM11 6H13V10H11V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFemale(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="female">
        <path
          id="Vector"
          d="M17.5 9C17.5 5.96 15.04 3.5 12 3.5C8.96 3.5 6.5 5.96 6.5 9C6.5 11.7 8.44 13.93 11 14.4V16.5H9V18.5H11V20.5H13V18.5H15V16.5H13V14.4C15.56 13.93 17.5 11.7 17.5 9ZM8.5 9C8.5 7.07 10.07 5.5 12 5.5C13.93 5.5 15.5 7.07 15.5 9C15.5 10.93 13.93 12.5 12 12.5C10.07 12.5 8.5 10.93 8.5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFence(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fence">
        <path
          id="Vector"
          d="M21 12V10H19V7L16 4L14 6L12 4L10 6L8 4L5 7V10H3V12H5V14H3V16H5V20H19V16H21V14H19V12H21ZM16 6.83L17 7.83V10H15V7.83L16 6.83ZM12 6.83L13 7.83V10H11V7.83L12 6.83ZM11 14V12H13V14H11ZM13 16V18H11V16H13ZM7 7.83L8 6.83L9 7.83V10H7V7.83ZM7 12H9V14H7V12ZM7 16H9V18H7V16ZM17 18H15V16H17V18ZM17 14H15V12H17V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFestival(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="festival">
        <path
          id="Vector"
          d="M23 11V9C17 7 12 2 12 2C12 2 7 7 1 9V11C1 12.49 1.93 13.75 3.24 14.26C3.2 16.76 2.92 19.69 2 22H22C21.08 19.69 20.8 16.76 20.76 14.26C22.07 13.75 23 12.49 23 11ZM12 4.71C13.33 5.85 15.49 7.55 18.11 9H5.89C8.51 7.55 10.67 5.85 12 4.71ZM13 11H16C16 11.83 15.33 12.5 14.5 12.5C13.67 12.5 13 11.83 13 11ZM9.5 12.5C8.67 12.5 8 11.83 8 11H11C11 11.83 10.33 12.5 9.5 12.5ZM6 11C6 11.83 5.33 12.5 4.5 12.5C3.67 12.5 3 11.83 3 11H6ZM4.66 20C5.05 18.14 5.2 16.18 5.23 14.42C5.91 14.27 6.52 13.93 6.99 13.44C7.24 13.69 7.53 13.89 7.84 14.06C7.74 15.93 7.58 18.06 7.32 19.99H4.66V20ZM9.35 20C9.59 18.17 9.74 16.22 9.83 14.47C10.67 14.39 11.44 14.02 12 13.45C12.56 14.02 13.32 14.39 14.17 14.47C14.27 16.22 14.41 18.17 14.65 20H9.35ZM16.67 20C16.4 18.06 16.24 15.93 16.15 14.07C16.46 13.9 16.76 13.7 17 13.45C17.47 13.93 18.08 14.28 18.76 14.43C18.79 16.19 18.94 18.15 19.33 20.01H16.67V20ZM19.5 12.5C18.67 12.5 18 11.83 18 11H21C21 11.83 20.33 12.5 19.5 12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFiberDvr(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fiber_dvr">
        <path
          id="Vector"
          d="M11.87 12.43L10.87 9H9.37L11.12 15H12.62L14.37 9H12.87L11.87 12.43ZM21 11.5V10.5C21 9.65 20.35 9 19.5 9H16V15H17.5V13H18.65L19.5 15H21L20.1 12.9C20.6 12.65 21 12.1 21 11.5ZM19.5 11.5H17.5V10.5H19.5V11.5ZM6.5 9H3V15H6.5C7.35 15 8 14.35 8 13.5V10.5C8 9.65 7.35 9 6.5 9ZM6.5 13.5H4.5V10.5H6.5V13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFiberManualRecord(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fiber_manual_record">
        <path
          id="Vector"
          d="M12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFiberNew(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fiber_new">
        <path
          id="Vector"
          d="M7.25 12.5L4.75 9H3.5V15H4.75V11.5L7.3 15H8.5V9H7.25V12.5ZM9.5 15H13.5V13.75H11V12.64H13.5V11.38H11V10.26H13.5V9H9.5V15ZM19.25 9V13.5H18.13V9.99H16.88V13.51H15.75V9H14.5V14C14.5 14.55 14.95 15 15.5 15H19.5C20.05 15 20.5 14.55 20.5 14V9H19.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFiberPin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fiber_pin">
        <path
          id="Vector"
          d="M11 15H12.5V9H11V15ZM18.75 9V12.5L16.25 9H15V15H16.25V11.5L18.8 15H20V9H18.75ZM7.5 9H4V15H5.5V13H7.5C8.35 13 9 12.35 9 11.5V10.5C9 9.65 8.35 9 7.5 9ZM7.5 11.5H5.5V10.5H7.5V11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFiberSmartRecord(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fiber_smart_record">
        <path
          id="Vector"
          d="M9 4C4.58 4 1 7.58 1 12C1 16.42 4.58 20 9 20C13.42 20 17 16.42 17 12C17 7.58 13.42 4 9 4ZM9 18C5.69 18 3 15.31 3 12C3 8.69 5.69 6 9 6C12.31 6 15 8.69 15 12C15 15.31 12.31 18 9 18ZM17 4.26V6.35C19.33 7.17 21 9.39 21 12C21 14.61 19.33 16.83 17 17.65V19.74C20.45 18.85 23 15.73 23 12C23 8.27 20.45 5.15 17 4.26Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFileCopy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_copy">
        <path
          id="Vector"
          d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM15.5 5H8.5C7.4 5 6.51 5.9 6.51 7L6.5 21C6.5 22.1 7.39 23 8.49 23H19.5C20.6 23 21.5 22.1 21.5 21V11L15.5 5ZM8.5 21V7H14.5V12H19.5V21H8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFileDownload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_download">
        <path
          id="Vector"
          d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFileDownloadDone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_download_done">
        <g id="Vector">
          <path
            d="M20.1301 5.41L18.7201 4L9.53012 13.19L5.28012 8.95L3.87012 10.36L9.53012 16.02L20.1301 5.41Z"
            fill="currentColor"
          />
          <path d="M19.0001 18H5.00012V20H19.0001V18Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconFileDownloadOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_download_off">
        <path
          id="Vector"
          d="M18.7101 14.4601V14.2901H20.7101V16.4601L18.7101 14.4601ZM16.1201 11.8801L17.7101 10.2901L16.3001 8.8801L14.7101 10.4601L16.1201 11.8801ZM13.7101 9.4601V3.2901H11.7101V7.4601L13.7101 9.4601ZM21.9001 20.4801L3.5201 2.1001L2.1001 3.5101L8.2901 9.7001L7.7101 10.2901L12.7101 15.2901L13.3001 14.7001L15.8801 17.2901H6.7101V14.2901H4.7101V17.2901C4.7101 18.3901 5.6101 19.2901 6.7101 19.2901H17.8801L20.4901 21.9001L21.9001 20.4801Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFileOpen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_open">
        <path
          id="Vector"
          d="M13.3201 21.8149H4.32007C3.22007 21.8149 2.32007 20.9149 2.32007 19.8149V3.81494C2.32007 2.71494 3.22007 1.81494 4.32007 1.81494H12.3201L18.3201 7.81494V13.8149H16.3201V8.81494H11.3201V3.81494H4.32007V19.8149H13.3201V21.8149ZM17.3201 21.4749V19.2349L20.2701 22.1849L21.6801 20.7749L18.7301 17.8149H20.9701V15.8149H15.3201V21.4749H17.3201Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilePresent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_present">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H14V8H18V20ZM12 17C10.9 17 10 16.1 10 15V9.5C10 9.22 10.22 9 10.5 9C10.78 9 11 9.22 11 9.5V15H13V9.5C13 8.12 11.88 7 10.5 7C9.12 7 8 8.12 8 9.5V15C8 17.21 9.79 19 12 19C14.21 19 16 17.21 16 15V11H14V15C14 16.1 13.1 17 12 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFileUpload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file_upload">
        <path
          id="Vector"
          d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter">
        <path
          id="Vector"
          d="M15.96 10.29L13.21 13.83L11.25 11.47L8.5 15H19.5L15.96 10.29ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter1(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_1">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM14 15H16V5H12V7H14V15ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_2">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM17 13H13V11H15C16.1 11 17 10.11 17 9V7C17 5.89 16.1 5 15 5H11V7H15V9H13C11.9 9 11 9.89 11 11V15H17V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_3">
        <path
          id="Vector"
          d="M21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM17 13V11.5C17 10.67 16.33 10 15.5 10C16.33 10 17 9.33 17 8.5V7C17 5.89 16.1 5 15 5H11V7H15V9H13V11H15V13H11V15H15C16.1 15 17 14.11 17 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_4">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM15 15H17V5H15V9H13V5H11V11H15V15ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter5(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_5">
        <path
          id="Vector"
          d="M21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM17 13V11C17 9.89 16.1 9 15 9H13V7H17V5H11V11H15V13H11V15H15C16.1 15 17 14.11 17 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter6(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_6">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15H15C16.1 15 17 14.11 17 13V11C17 9.89 16.1 9 15 9H13V7H17V5H13C11.9 5 11 5.89 11 7V13C11 14.11 11.9 15 13 15ZM13 11H15V13H13V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter7(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_7">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15L17 7V5H11V7H15L11 15H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter8(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_8">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15H15C16.1 15 17 14.11 17 13V11.5C17 10.67 16.33 10 15.5 10C16.33 10 17 9.33 17 8.5V7C17 5.89 16.1 5 15 5H13C11.9 5 11 5.89 11 7V8.5C11 9.33 11.67 10 12.5 10C11.67 10 11 10.67 11 11.5V13C11 14.11 11.9 15 13 15ZM13 7H15V9H13V7ZM13 11H15V13H13V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter9(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_9">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM15 5H13C11.9 5 11 5.89 11 7V9C11 10.11 11.9 11 13 11H15V13H11V15H15C16.1 15 17 14.11 17 13V7C17 5.89 16.1 5 15 5ZM15 9H13V7H15V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilter9Plus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_9_plus">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM14 12V8C14 6.89 13.1 6 12 6H11C9.9 6 9 6.89 9 8V9C9 10.11 9.9 11 11 11H12V12H9V14H12C13.1 14 14 13.11 14 12ZM11 9V8H12V9H11ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 9H19V7H17V9H15V11H17V13H19V11H21V17H7V3H21V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_alt">
        <path
          id="Vector"
          d="M7.00506 6H17.0051L11.9951 12.3L7.00506 6ZM4.25506 5.61C6.27506 8.2 10.0051 13 10.0051 13V19C10.0051 19.55 10.4551 20 11.0051 20H13.0051C13.5551 20 14.0051 19.55 14.0051 19V13C14.0051 13 17.7251 8.2 19.7451 5.61C20.2551 4.95 19.7851 4 18.9551 4H5.04506C4.21506 4 3.74506 4.95 4.25506 5.61Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterAltOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_alt_off">
        <g id="Vector">
          <path
            d="M17.66 5.28998L14.09 9.83998L15.52 11.27C16.55 9.95998 20.5 4.89998 20.5 4.89998C21.01 4.23998 20.54 3.28998 19.71 3.28998H7.53998L9.53998 5.28998H17.66Z"
            fill="currentColor"
          />
          <path
            d="M3.51998 2.09998L2.09998 3.50998L10.71 12.29V18.29C10.71 18.84 11.16 19.29 11.71 19.29H13.71C14.26 19.29 14.71 18.84 14.71 18.29V16.12L20.49 21.9L21.9 20.49L3.51998 2.09998Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFilterBAndW(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_b_and_w">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19L12 11V19H5L12 11V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterCenterFocus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_center_focus">
        <path
          id="Vector"
          d="M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterDrama(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_drama">
        <path
          id="Vector"
          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.61 5.64 5.36 8.04C2.35 8.36 0 10.9 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.79 3.79 10 6 10C8.21 10 10 11.79 10 14H12C12 11.24 10.14 8.92 7.6 8.22C8.61 6.88 10.2 6 12 6C15.03 6 17.5 8.47 17.5 11.5V12H19C20.65 12 22 13.35 22 15C22 16.65 20.65 18 19 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterFrames(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_frames">
        <path
          id="Vector"
          d="M20 5H16L12 1L8 5H4C2.9 5 2 5.9 2 7V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V7C22 5.9 21.1 5 20 5ZM20 21H4V7H8.52L12.04 3.5L15.52 7H20V21ZM6 19H18V9H6V19ZM8 11H16V17H8V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterHdr(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_hdr">
        <path
          id="Vector"
          d="M14 6L9.78 11.63L11.03 13.3L14 9.33L19 16H10.54L6.53 10.63L1 18H23L14 6ZM5 16L6.52 13.97L8.04 16H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterList(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_list">
        <path
          id="Vector"
          d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterListOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_list_off">
        <path
          id="Vector"
          d="M11.545 7.29498H21.715V5.29498H9.54498L11.545 7.29498ZM16.545 12.295H18.715V10.295H14.545L16.545 12.295ZM14.715 16.125V17.295H10.715V15.295H13.885L10.885 12.295H6.71498V10.295H8.88498L5.88498 7.29498H3.71498V5.29498H3.88498L2.10498 3.51498L3.51498 2.10498L21.895 20.485L20.485 21.895L14.715 16.125Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterNone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_none">
        <path
          id="Vector"
          d="M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterTiltShift(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_tilt_shift">
        <path
          id="Vector"
          d="M11 4.07005V2.05005C8.99005 2.25005 7.16005 3.05005 5.68005 4.26005L7.10005 5.69005C8.21005 4.83005 9.54005 4.25005 11 4.07005ZM18.32 4.26005C16.84 3.05005 15.01 2.25005 13 2.05005V4.07005C14.46 4.25005 15.79 4.83005 16.9 5.69005L18.32 4.26005ZM19.93 11H21.9501C21.75 8.99005 20.9501 7.16005 19.74 5.68005L18.31 7.10005C19.17 8.21005 19.75 9.54005 19.93 11ZM5.69005 7.10005L4.26005 5.68005C3.05005 7.16005 2.25005 8.99005 2.05005 11H4.07005C4.25005 9.54005 4.83005 8.21005 5.69005 7.10005ZM4.07005 13H2.05005C2.25005 15.01 3.05005 16.84 4.26005 18.32L5.69005 16.89C4.83005 15.79 4.25005 14.46 4.07005 13ZM15 12C15 10.34 13.66 9.00005 12 9.00005C10.34 9.00005 9.00005 10.34 9.00005 12C9.00005 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12ZM18.31 16.9L19.74 18.33C20.9501 16.85 21.75 15.01 21.9501 13.01H19.93C19.75 14.46 19.17 15.79 18.31 16.9ZM13 19.93V21.9501C15.01 21.75 16.84 20.9501 18.32 19.74L16.89 18.31C15.79 19.17 14.46 19.75 13 19.93ZM5.68005 19.74C7.16005 20.9501 9.00005 21.75 11 21.9501V19.93C9.54005 19.75 8.21005 19.17 7.10005 18.31L5.68005 19.74Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFilterVintage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="filter_vintage">
        <path
          id="Vector"
          d="M18.7001 12.4001C18.42 12.2401 18.13 12.1101 17.84 12.0001C18.13 11.8901 18.42 11.7601 18.7001 11.6001C20.6201 10.4901 21.6901 8.48006 21.7001 6.41006C20.7901 5.89006 19.75 5.61006 18.6901 5.61006C17.67 5.61006 16.64 5.87006 15.7 6.41006C15.42 6.57006 15.16 6.76006 14.92 6.95006C14.97 6.64006 15 6.32006 15 6.00006C15 3.78006 13.79 1.85006 12 0.810059C10.21 1.85006 9.00005 3.78006 9.00005 6.00006C9.00005 6.32006 9.03005 6.64006 9.08005 6.95006C8.84005 6.75006 8.58005 6.56006 8.30005 6.40006C7.36005 5.86006 6.33005 5.60006 5.31005 5.60006C4.26005 5.60006 3.21005 5.88006 2.30005 6.40006C2.30005 8.47006 3.37005 10.4801 5.30005 11.5901C5.58005 11.7501 5.87005 11.8801 6.16005 11.9901C5.87005 12.1001 5.58005 12.2301 5.30005 12.3901C3.38005 13.5001 2.31005 15.5101 2.30005 17.5801C3.21005 18.1001 4.25005 18.3801 5.31005 18.3801C6.33005 18.3801 7.36005 18.1201 8.30005 17.5801C8.58005 17.4201 8.84005 17.2301 9.08005 17.0401C9.03005 17.3601 9.00005 17.6801 9.00005 18.0001C9.00005 20.2201 10.21 22.1501 12 23.1901C13.79 22.1501 15 20.2201 15 18.0001C15 17.6801 14.97 17.3601 14.92 17.0501C15.16 17.2501 15.42 17.4301 15.7 17.5901C16.64 18.1301 17.67 18.3901 18.6901 18.3901C19.74 18.3901 20.7901 18.1101 21.7001 17.5901C21.6901 15.5201 20.6201 13.5101 18.7001 12.4001ZM16.16 8.52006C16.37 8.35006 16.54 8.23006 16.7 8.15006C17.31 7.80006 18.0001 7.61006 18.7001 7.61006C18.9701 7.61006 19.23 7.64006 19.49 7.69006C19.18 8.60006 18.55 9.38006 17.71 9.87006C17.54 9.97006 17.35 10.0501 17.13 10.1401L15.75 10.6601C15.58 10.2001 15.34 9.79006 15.03 9.42006L16.16 8.52006ZM12 3.37006C12.63 4.09006 13 5.03006 13 6.00006C13 6.19006 12.98 6.41006 12.95 6.63006L12.72 8.07006C12.48 8.03006 12.24 8.00006 12 8.00006C11.76 8.00006 11.52 8.03006 11.29 8.07006L11.06 6.63006C11.02 6.41006 11 6.19006 11 6.00006C11 5.02006 11.37 4.09006 12 3.37006ZM4.51005 7.68006C4.77005 7.62006 5.04005 7.60006 5.31005 7.60006C6.00005 7.60006 6.69005 7.78006 7.30005 8.14006C7.45005 8.23006 7.62005 8.34006 7.79005 8.49006L8.94005 9.45006C8.64005 9.81006 8.41005 10.2101 8.24005 10.6501L6.86005 10.1301C6.65005 10.0401 6.46005 9.95006 6.30005 9.86006C5.43005 9.36006 4.81005 8.59006 4.51005 7.68006ZM7.84005 15.4701C7.63005 15.6401 7.46005 15.7601 7.30005 15.8401C6.69005 16.1901 6.00005 16.3801 5.30005 16.3801C5.03005 16.3801 4.77005 16.3501 4.51005 16.3001C4.82005 15.3901 5.45005 14.6101 6.29005 14.1201C6.46005 14.0201 6.65005 13.9401 6.87005 13.8501L8.25005 13.3301C8.41005 13.7901 8.66005 14.2101 8.97005 14.5701L7.84005 15.4701ZM12 20.6301C11.37 19.9101 11 18.9701 11 18.0001C11 17.8001 11.02 17.5901 11.06 17.3501L11.28 15.9301C11.51 15.9701 11.75 16.0001 12 16.0001C12.24 16.0001 12.48 15.9701 12.71 15.9301L12.94 17.3701C12.98 17.5901 13 17.8101 13 18.0001C13 18.9801 12.63 19.9101 12 20.6301ZM18.6901 16.3901C18.0001 16.3901 17.31 16.2101 16.7 15.8501C16.52 15.7501 16.36 15.6301 16.21 15.5101L15.06 14.5501C15.36 14.1901 15.6 13.7901 15.76 13.3401L17.14 13.8601C17.36 13.9401 17.55 14.0301 17.71 14.1201C18.56 14.6101 19.18 15.3901 19.49 16.3001C19.22 16.3701 18.9501 16.3901 18.6901 16.3901Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFindInPage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="find_in_page">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 4H13L18 9V17.58L16.16 15.74C17.44 13.8 17.23 11.17 15.52 9.46C14.55 8.49 13.28 8 12 8C10.72 8 9.45 8.49 8.47 9.46C6.52 11.41 6.52 14.57 8.47 16.51C9.44 17.48 10.72 17.97 12 17.97C12.96 17.97 13.92 17.69 14.75 17.14L17.6 20H6V4ZM14.11 15.1C13.55 15.66 12.8 15.98 12 15.98C11.2 15.98 10.45 15.67 9.89 15.1C9.33 14.54 9.01 13.79 9.01 12.99C9.01 12.19 9.32 11.44 9.89 10.88C10.45 10.31 11.2 10 12 10C12.8 10 13.55 10.31 14.11 10.88C14.67 11.44 14.99 12.19 14.99 12.99C14.99 13.79 14.68 14.54 14.11 15.1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFindReplace(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="find_replace">
        <path
          id="Vector"
          d="M10.255 5.255C11.635 5.255 12.885 5.815 13.795 6.715L11.255 9.255H17.255V3.255L15.205 5.30501C13.935 4.03501 12.185 3.255 10.255 3.255C6.725 3.255 3.825 5.865 3.335 9.255H5.355C5.815 6.975 7.835 5.255 10.255 5.255ZM15.895 14.395C16.555 13.495 17.015 12.425 17.175 11.255H15.155C14.695 13.535 12.675 15.255 10.255 15.255C8.875 15.255 7.625 14.695 6.715 13.795L9.255 11.255H3.255V17.255L5.30501 15.205C6.57501 16.475 8.32501 17.255 10.255 17.255C11.805 17.255 13.235 16.745 14.395 15.895L19.255 20.745L20.745 19.255L15.895 14.395Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFingerprint(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fingerprint">
        <path
          id="Vector"
          d="M17.815 4.47C17.735 4.47 17.655 4.45 17.585 4.41C15.665 3.42 14.005 3 12.015 3C10.035 3 8.15499 3.47 6.44499 4.41C6.20499 4.54 5.90499 4.45 5.76499 4.21C5.63499 3.97 5.72499 3.66 5.96499 3.53C7.82499 2.52 9.86499 2 12.015 2C14.145 2 16.005 2.47 18.045 3.52C18.295 3.65 18.385 3.95 18.255 4.19C18.165 4.37 17.995 4.47 17.815 4.47ZM3.50499 9.72C3.40499 9.72 3.30499 9.69 3.21499 9.63C2.98499 9.47 2.93499 9.16 3.09499 8.93C4.08499 7.53 5.34499 6.43 6.84499 5.66C9.98499 4.04 14.005 4.03 17.155 5.65C18.655 6.42 19.915 7.51 20.905 8.9C21.065 9.12 21.015 9.44 20.785 9.6C20.555 9.76 20.245 9.71 20.085 9.48C19.185 8.22 18.045 7.23 16.695 6.54C13.825 5.07 10.155 5.07 7.29499 6.55C5.93499 7.25 4.79499 8.25 3.89499 9.51C3.81499 9.65 3.66499 9.72 3.50499 9.72ZM9.75499 21.79C9.62499 21.79 9.49499 21.74 9.40499 21.64C8.53499 20.77 8.06499 20.21 7.39499 19C6.70499 17.77 6.34499 16.27 6.34499 14.66C6.34499 11.69 8.88499 9.27 12.005 9.27C15.125 9.27 17.665 11.69 17.665 14.66C17.665 14.94 17.445 15.16 17.165 15.16C16.885 15.16 16.665 14.94 16.665 14.66C16.665 12.24 14.575 10.27 12.005 10.27C9.43499 10.27 7.34499 12.24 7.34499 14.66C7.34499 16.1 7.66499 17.43 8.27499 18.51C8.91499 19.66 9.35499 20.15 10.125 20.93C10.315 21.13 10.315 21.44 10.125 21.64C10.015 21.74 9.88499 21.79 9.75499 21.79ZM16.925 19.94C15.735 19.94 14.685 19.64 13.825 19.05C12.335 18.04 11.445 16.4 11.445 14.66C11.445 14.38 11.665 14.16 11.945 14.16C12.225 14.16 12.445 14.38 12.445 14.66C12.445 16.07 13.165 17.4 14.385 18.22C15.095 18.7 15.925 18.93 16.925 18.93C17.165 18.93 17.565 18.9 17.965 18.83C18.235 18.78 18.495 18.96 18.545 19.24C18.595 19.51 18.415 19.77 18.135 19.82C17.565 19.93 17.065 19.94 16.925 19.94ZM14.915 22C14.875 22 14.825 21.99 14.785 21.98C13.195 21.54 12.155 20.95 11.065 19.88C9.66499 18.49 8.89499 16.64 8.89499 14.66C8.89499 13.04 10.275 11.72 11.975 11.72C13.675 11.72 15.055 13.04 15.055 14.66C15.055 15.73 15.985 16.6 17.135 16.6C18.285 16.6 19.215 15.73 19.215 14.66C19.215 10.89 15.965 7.83 11.965 7.83C9.12499 7.83 6.52499 9.41 5.35499 11.86C4.96499 12.67 4.76499 13.62 4.76499 14.66C4.76499 15.44 4.83499 16.67 5.43499 18.27C5.53499 18.53 5.40499 18.82 5.14499 18.91C4.88499 19.01 4.59499 18.87 4.50499 18.62C4.01499 17.31 3.77499 16.01 3.77499 14.66C3.77499 13.46 4.00499 12.37 4.45499 11.42C5.78499 8.63 8.73499 6.82 11.965 6.82C16.515 6.82 20.215 10.33 20.215 14.65C20.215 16.27 18.835 17.59 17.135 17.59C15.435 17.59 14.055 16.27 14.055 14.65C14.055 13.58 13.125 12.71 11.975 12.71C10.825 12.71 9.89499 13.58 9.89499 14.65C9.89499 16.36 10.555 17.96 11.765 19.16C12.715 20.1 13.625 20.62 15.035 21.01C15.305 21.08 15.455 21.36 15.385 21.62C15.335 21.85 15.125 22 14.915 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFireExtinguisher(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fire_extinguisher">
        <path
          id="Vector"
          d="M8 18.5H18V19.5C18 20.6 17.1 21.5 16 21.5H10C8.9 21.5 8 20.6 8 19.5V18.5ZM8 17.5H18V12.5H8V17.5ZM18 2.5V8.5L14.85 7.84C14.84 7.84 14.84 7.85 14.83 7.86C16.38 8.48 17.55 9.84 17.9 11.5H8.1C8.44 9.84 9.62 8.48 11.17 7.86C10.84 7.6 10.57 7.28 10.37 6.91L6 6V5L10.37 4.09C10.87 3.15 11.86 2.5 13 2.5C13.7 2.5 14.34 2.75 14.85 3.16L18 2.5ZM14 5.5C13.97 4.91 13.55 4.5 13 4.5C12.45 4.5 12 4.95 12 5.5C12 6.05 12.45 6.5 13 6.5C13.55 6.5 14 6.05 14 5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFireHydrantAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fire_hydrant_alt">
        <g id="Vector">
          <path
            d="M12 10.5C10.07 10.5 8.5 12.07 8.5 14C8.5 15.93 10.07 17.5 12 17.5C13.93 17.5 15.5 15.93 15.5 14C15.5 12.07 13.93 10.5 12 10.5ZM12 15.5C11.17 15.5 10.5 14.83 10.5 14C10.5 13.17 11.17 12.5 12 12.5C12.83 12.5 13.5 13.17 13.5 14C13.5 14.83 12.83 15.5 12 15.5Z"
            fill="currentColor"
          />
          <path
            d="M19 11H18V8H20V6H17.65C16.83 3.67 14.61 2 12 2C9.39 2 7.17 3.67 6.35 6H4V8H6V11H5C3.9 11 3 11.9 3 13V15C3 16.1 3.9 17 5 17H6V20H4V22H20V20H18V17H19C20.1 17 21 16.1 21 15V13C21 11.9 20.1 11 19 11ZM12 4C13.47 4 14.75 4.81 15.44 6H8.56C9.25 4.81 10.53 4 12 4ZM19 15H16V20H8V15H5V13H8V8H16V13H19V15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFireTruck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fire_truck">
        <g id="Vector">
          <path
            d="M22.9 10.69L21.46 6.37C21.18 5.55 20.42 5 19.56 5H19V4C19 3.45 18.55 3 18 3H17C16.45 3 16 3.45 16 4V5H14C12.9 5 12 5.9 12 7V11H1V16C1 17.1 1.9 18 3 18H4C4 19.66 5.34 21 7 21C8.66 21 10 19.66 10 18H14C14 19.66 15.34 21 17 21C18.66 21 20 19.66 20 18H23V11.32C23 11.11 22.97 10.9 22.9 10.69ZM14 7H19.56L20.89 11H14V7ZM7 19C6.45 19 6 18.55 6 18C6 17.45 6.45 17 7 17C7.55 17 8 17.45 8 18C8 18.55 7.55 19 7 19ZM12 16H9.22C8.67 15.39 7.89 15 7 15C6.11 15 5.33 15.39 4.78 16H3V13H12V16ZM17 19C16.45 19 16 18.55 16 18C16 17.45 16.45 17 17 17C17.55 17 18 17.45 18 18C18 18.55 17.55 19 17 19ZM19.22 16C18.67 15.39 17.88 15 17 15C16.12 15 15.33 15.39 14.78 16H14V13H21V16H19.22Z"
            fill="currentColor"
          />
          <path
            d="M11 8.5H10V6.5H11V5H1V6.5H2V8.5H1V10H11V8.5ZM8.5 8.5H6.75V6.5H8.5V8.5ZM3.5 6.5H5.25V8.5H3.5V6.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFireplace(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fireplace">
        <g id="Vector">
          <path
            d="M12.01 12.46C11.86 12.88 11.86 13.28 11.93 13.74C12.03 14.29 12.26 14.78 12.13 15.34C12 15.93 11.36 16.72 10.6 16.97C11.88 18.02 13.8 17.34 13.99 15.65C14.16 14.11 12.55 13.67 12.01 12.46Z"
            fill="currentColor"
          />
          <path
            d="M2 2V22H22V2H2ZM12 18C10.42 18 9.03 16.12 9 14.94C9 14.89 8.99 14.81 8.99 14.72C8.86 12.99 9.99 11.52 11.46 10.35C11.93 11.36 12.73 12.38 14.03 13.27C14.61 13.69 15 14.13 15 15C15 16.65 13.65 18 12 18ZM20 20H18V18H15.98C16.61 17.16 17 16.13 17 15C17 13.11 15.91 12.15 15.15 11.63C12.2 9.61 13 7 13 7C6.27 10.57 6.98 14.47 7 15C7.03 15.96 7.49 17.07 8.23 18H6V20H4V4H20V20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFirstPage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="first_page">
        <path
          id="Vector"
          d="M18.2049 16.59L13.6149 12L18.2049 7.41L16.7949 6L10.7949 12L16.7949 18L18.2049 16.59ZM5.79492 6H7.79492V18H5.79492V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFitScreen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fit_screen">
        <path
          id="Vector"
          d="M6 16H18V8H6V16ZM8 10H16V14H8V10ZM4 15H2V18C2 19.1 2.9 20 4 20H7V18H4V15ZM4 6H7V4H4C2.9 4 2 4.9 2 6V9H4V6ZM20 4H17V6H20V9H22V6C22 4.9 21.1 4 20 4ZM20 18H17V20H20C21.1 20 22 19.1 22 18V15H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFitbit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fitbit">
        <path
          id="Vector"
          d="M19.88 13.89C20.92 13.89 21.77 13.04 21.77 12C21.77 10.96 20.92 10.11 19.88 10.11C18.84 10.11 17.99 10.96 17.99 12C17.99 13.04 18.84 13.89 19.88 13.89ZM15.64 13.68C16.57 13.68 17.32 12.93 17.32 12C17.32 11.07 16.57 10.32 15.64 10.32C14.71 10.32 13.96 11.07 13.96 12C13.96 12.93 14.71 13.68 15.64 13.68ZM15.64 9.42C16.57 9.42 17.32 8.67 17.32 7.74C17.32 6.81 16.57 6.06 15.64 6.06C14.71 6.06 13.96 6.81 13.96 7.74C13.96 8.67 14.71 9.42 15.64 9.42ZM15.64 17.93C16.57 17.93 17.32 17.18 17.32 16.25C17.32 15.32 16.57 14.57 15.64 14.57C14.71 14.57 13.96 15.32 13.96 16.25C13.96 17.17 14.71 17.93 15.64 17.93ZM11.4 13.47C12.21 13.47 12.87 12.81 12.87 12C12.87 11.19 12.21 10.53 11.4 10.53C10.59 10.53 9.92998 11.19 9.92998 12C9.92998 12.81 10.58 13.47 11.4 13.47ZM11.4 9.21C12.21 9.21 12.87 8.55 12.87 7.74C12.87 6.93 12.21 6.27 11.4 6.27C10.59 6.27 9.92998 6.93 9.92998 7.74C9.92998 8.55 10.58 9.21 11.4 9.21ZM11.4 17.73C12.21 17.73 12.87 17.07 12.87 16.26C12.87 15.45 12.21 14.79 11.4 14.79C10.59 14.79 9.92998 15.45 9.92998 16.26C9.91998 17.07 10.58 17.73 11.4 17.73ZM11.4 22C12.21 22 12.87 21.34 12.87 20.53C12.87 19.72 12.21 19.06 11.4 19.06C10.59 19.06 9.92998 19.72 9.92998 20.53C9.91998 21.34 10.58 22 11.4 22ZM11.4 4.94C12.21 4.94 12.87 4.28 12.87 3.47C12.87 2.66 12.21 2 11.4 2C10.59 2 9.92998 2.66 9.92998 3.47C9.92998 4.28 10.58 4.94 11.4 4.94ZM7.14998 13.26C7.84998 13.26 8.40998 12.69 8.40998 12C8.40998 11.31 7.83998 10.74 7.14998 10.74C6.44998 10.74 5.88998 11.31 5.88998 12C5.88998 12.69 6.44998 13.26 7.14998 13.26ZM7.14998 17.51C7.84998 17.51 8.40998 16.94 8.40998 16.25C8.40998 15.55 7.83998 14.99 7.14998 14.99C6.44998 14.99 5.88998 15.56 5.88998 16.25C5.88998 16.94 6.44998 17.51 7.14998 17.51ZM7.14998 9.02C7.84998 9.02 8.40998 8.45 8.40998 7.76C8.40998 7.06 7.83998 6.5 7.14998 6.5C6.44998 6.5 5.88998 7.07 5.88998 7.76C5.88998 8.45 6.44998 9.02 7.14998 9.02ZM3.27998 13.05C3.85998 13.05 4.32998 12.58 4.32998 12C4.32998 11.42 3.85998 10.95 3.27998 10.95C2.69998 10.95 2.22998 11.42 2.22998 12C2.22998 12.58 2.69998 13.05 3.27998 13.05Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFitnessCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fitness_center">
        <path
          id="Vector"
          d="M20.57 14.86L22 13.43L20.57 12L17 15.57L8.43 7L12 3.43L10.57 2L9.14 3.43L7.71 2L5.57 4.14L4.14 2.71L2.71 4.14L4.14 5.57L2 7.71L3.43 9.14L2 10.57L3.43 12L7 8.43L15.57 17L12 20.57L13.43 22L14.86 20.57L16.29 22L18.43 19.86L19.86 21.29L21.29 19.86L19.86 18.43L22 16.29L20.57 14.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlag(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flag">
        <path
          id="Vector"
          d="M11.86 5.5L12.26 7.5H17.5V13.5H14.14L13.74 11.5H6.5V5.5H11.86ZM13.5 3.5H4.5V20.5H6.5V13.5H12.1L12.5 15.5H19.5V5.5H13.9L13.5 3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlagCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flag_circle">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M15 9L14 7H8V18H9.5V13H12L13 15H18V9H15ZM16.5 13.5H13.93L12.93 11.5H9.5V8.5H13.07L14.07 10.5H16.5V13.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFlaky(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flaky">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.05 17.58L14.04 17.59L11.64 15.19L12.7 14.13L14.05 15.48L16.54 13L17.6 14.06L14.06 17.6L14.05 17.58ZM12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM7.34 6.28L8.75 7.69L10.16 6.28L11.22 7.34L9.81 8.75L11.22 10.16L10.16 11.22L8.75 9.81L7.34 11.22L6.28 10.16L7.69 8.75L6.28 7.34L7.34 6.28ZM12 20C9.8 20 7.8 19.1 6.3 17.7L17.7 6.3C19.1 7.8 20 9.8 20 12C20 16.4 16.4 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flare">
        <path
          id="Vector"
          d="M7 11H1V13H7V11ZM9.17 7.76L7.05 5.64L5.64 7.05L7.76 9.17L9.17 7.76ZM13 1H11V7H13V1ZM18.36 7.05L16.95 5.64L14.83 7.76L16.24 9.17L18.36 7.05ZM17 11V13H23V11H17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9ZM14.83 16.24L16.95 18.36L18.36 16.95L16.24 14.83L14.83 16.24ZM5.64 16.95L7.05 18.36L9.17 16.24L7.76 14.83L5.64 16.95ZM11 23H13V17H11V23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlashAuto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flash_auto">
        <path
          id="Vector"
          d="M2.3999 1.5V13.5H5.3999V22.5L12.3999 10.5H8.3999L12.3999 1.5H2.3999ZM18.3999 1.5H16.3999L13.1999 10.5H15.0999L15.7999 8.5H18.9999L19.6999 10.5H21.5999L18.3999 1.5ZM16.2499 7.15L17.3999 3.5L18.5499 7.15H16.2499Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlashOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flash_off">
        <path
          id="Vector"
          d="M18.4299 10H14.8199L17.0999 12.28L18.4299 10ZM18.4299 2H8.42993V3.61L14.5599 9.74L18.4299 2ZM4.83993 2.86L3.42993 4.27L8.42993 9.27V13H11.4299V22L15.0099 15.85L19.1599 20L20.5699 18.59L4.83993 2.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlashOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flash_on">
        <path id="Vector" d="M7 2V13H10V22L17 10H13L16 2H7Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconFlashlightOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flashlight_off">
        <g id="Vector">
          <path
            d="M3.5201 2.50501L2.1001 3.91501L8.7101 10.525V21.695H16.7101V18.525L20.4901 22.305L21.9001 20.895L3.5201 2.50501ZM14.7101 19.695H10.7101V12.525L14.7101 16.525V19.695Z"
            fill="currentColor"
          />
          <path
            d="M16.7101 3.69501V4.69501H8.5401L10.5401 6.69501H16.7101V7.08501L14.7101 10.095V10.865L16.7101 12.865V10.695L18.7101 7.69501V1.69501H6.7101V2.86501L7.5401 3.69501H16.7101Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFlashlightOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flashlight_on">
        <g id="Vector">
          <path
            d="M18 2H6V8L8 11V22H16V11L18 8V2ZM16 4V5H8V4H16ZM14 10.4V20H10V10.39L8 7.39V7H16V7.39L14 10.4Z"
            fill="currentColor"
          />
          <path
            d="M12 15.5C12.8284 15.5 13.5 14.8284 13.5 14C13.5 13.1716 12.8284 12.5 12 12.5C11.1716 12.5 10.5 13.1716 10.5 14C10.5 14.8284 11.1716 15.5 12 15.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFlatware(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flatware">
        <path
          id="Vector"
          d="M16 7.08C16 8.85 15.16 10.33 14 10.9V21H12V10.9C10.84 10.33 10 8.85 10 7.08C10.01 4.83 11.35 3 13 3C14.66 3 16 4.83 16 7.08ZM17 3V21H19V13H21V7C21 5.24 19.76 3 17 3ZM8.28 3C7.88 3 7.56 3.32 7.56 3.72V7H6.72V3.72C6.72 3.32 6.4 3 6 3C5.6 3 5.28 3.32 5.28 3.72V7H4.44V3.72C4.44 3.32 4.12 3 3.72 3C3.32 3 3 3.32 3 3.72V9C3 10.1 3.9 11 5 11V21H7V11C8.1 11 9 10.1 9 9V3.72C9 3.32 8.68 3 8.28 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flight">
        <path
          id="Vector"
          d="M21.5 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2.5 14V16L10.5 13.5V19L8.5 20.5V22L12 21L15.5 22V20.5L13.5 19V13.5L21.5 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlightClass(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flight_class">
        <path
          id="Vector"
          d="M16.5 3.5H14.5C13.4 3.5 12.5 4.4 12.5 5.5V10.5C12.5 11.6 13.4 12.5 14.5 12.5H16.5C17.6 12.5 18.5 11.6 18.5 10.5V5.5C18.5 4.4 17.6 3.5 16.5 3.5ZM16.5 10.5H14.5V5.5H16.5V10.5ZM10 15.5H18.5V17.5H9.99C9.11 17.5 8.33 16.92 8.07 16.07L5.5 7.5V3.5H7.5V7.5L10 15.5ZM8.5 18.5H18.5V20.5H8.5V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlightLand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flight_land">
        <path
          id="Vector"
          d="M2.5 19.5H21.5V21.5H2.5V19.5ZM19.34 16.35C20.14 16.56 20.96 16.09 21.18 15.29C21.39 14.49 20.92 13.67 20.12 13.45L14.81 12.03L12.05 3.01L10.12 2.5V10.78L5.15 9.45L4.22 7.13L2.77 6.74V11.91L19.34 16.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlightTakeoff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flight_takeoff">
        <path
          id="Vector"
          d="M2.51999 18.715H21.52V20.715H2.51999V18.715ZM22.09 9.35497C21.88 8.55497 21.05 8.07497 20.25 8.29497L14.94 9.71497L8.03999 3.28497L6.10999 3.79497L10.25 10.965L5.27999 12.295L3.30999 10.755L1.85999 11.145L4.44999 15.635L21.02 11.205C21.83 10.975 22.3 10.155 22.09 9.35497Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlip(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flip">
        <path
          id="Vector"
          d="M15 21H17V19H15V21ZM19 9H21V7H19V9ZM3 5V19C3 20.1 3.9 21 5 21H9V19H5V5H9V3H5C3.9 3 3 3.9 3 5ZM19 3V5H21C21 3.9 20.1 3 19 3ZM11 23H13V1H11V23ZM19 17H21V15H19V17ZM15 5H17V3H15V5ZM19 13H21V11H19V13ZM19 21C20.1 21 21 20.1 21 19H19V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlipCameraAndroid(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flip_camera_android">
        <g id="Vector">
          <path
            d="M9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9C10.34 9 9 10.34 9 12ZM13 12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12Z"
            fill="currentColor"
          />
          <path
            d="M8 10V8H5.09C6.47 5.61 9.05 4 12 4C15.72 4 18.85 6.56 19.74 10H21.8C20.87 5.44 16.84 2 12 2C8.73 2 5.82 3.58 4 6.01V4H2V10H8Z"
            fill="currentColor"
          />
          <path
            d="M16 14V16H18.91C17.53 18.39 14.95 20 12 20C8.28 20 5.15 17.44 4.26 14H2.2C3.13 18.56 7.16 22 12 22C15.27 22 18.18 20.42 20 17.99V20H22V14H16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFlipCameraIos(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flip_camera_ios">
        <g id="Vector">
          <path
            d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L8.64 6.35L9.88 5H14.12L15.36 6.35L15.95 7H20V19Z"
            fill="currentColor"
          />
          <path
            d="M12 17C9.79 17 8 15.21 8 13H10L7.5 10.5L5 13H7C7 15.76 9.24 18 12 18C12.86 18 13.65 17.76 14.36 17.38L13.62 16.64C13.13 16.87 12.58 17 12 17Z"
            fill="currentColor"
          />
          <path
            d="M12 8C11.14 8 10.35 8.24 9.64 8.62L10.38 9.35C10.87 9.13 11.42 9 12 9C14.21 9 16 10.79 16 13H14L16.5 15.5L19 13H17C17 10.24 14.76 8 12 8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFlipToBack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flip_to_back">
        <path
          id="Vector"
          d="M9 7H7V9H9V7ZM9 11H7V13H9V11ZM9 3C7.89 3 7 3.9 7 5H9V3ZM13 15H11V17H13V15ZM19 3V5H21C21 3.9 20.1 3 19 3ZM13 3H11V5H13V3ZM9 17V15H7C7 16.1 7.89 17 9 17ZM19 13H21V11H19V13ZM19 9H21V7H19V9ZM19 17C20.1 17 21 16.1 21 15H19V17ZM5 7H3V19C3 20.1 3.89 21 5 21H17V19H5V7ZM15 5H17V3H15V5ZM15 17H17V15H15V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlipToFront(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flip_to_front">
        <path
          id="Vector"
          d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM5 21V19H3C3 20.1 3.89 21 5 21ZM3 9H5V7H3V9ZM15 21H17V19H15V21ZM19 3H9C7.89 3 7 3.9 7 5V15C7 16.1 7.89 17 9 17H19C20.1 17 21 16.1 21 15V5C21 3.9 20.1 3 19 3ZM19 15H9V5H19V15ZM11 21H13V19H11V21ZM7 21H9V19H7V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFlood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flood">
        <g id="Vector">
          <path
            d="M18.67 19C16.72 19 16.58 20 15.34 20C14.15 20 13.92 19 12.01 19C10.06 19 9.91 20 8.67 20C7.43 20 7.29 19 5.34 19C3.39 19 3.24 20 2 20V22C3.95 22 4.11 21 5.34 21C6.58 21 6.72 22 8.67 22C10.62 22 10.77 21 12.01 21C13.23 21 13.41 22 15.34 22C17.27 22 17.44 21 18.67 21C19.89 21 20.07 22 22 22V20C20.76 20 20.62 19 18.67 19Z"
            fill="currentColor"
          />
          <path
            d="M8.68 17.5C10.63 17.5 10.77 16.5 12.01 16.5C13.2 16.5 13.43 17.5 15.34 17.5C17.29 17.5 17.43 16.5 18.67 16.5C19.86 16.5 20.07 17.48 21.98 17.5V15.5C21.35 15.5 20.98 15.22 20.5 14.95L18.48 7.42L20.57 8.27L21.31 6.41L9.78 2L2 11.61L3.57 12.84L4.96 11.06L5.89 14.54C5.71 14.52 5.54 14.49 5.33 14.49C3.38 14.49 3.24 15.49 2 15.49V17.49C3.9 17.49 4.17 16.49 5.35 16.49C6.54 16.5 6.77 17.5 8.68 17.5ZM10.42 4.41L16.16 6.5L18.31 14.52C16.77 14.63 16.49 15.41 15.46 15.48L14.04 10.17L10.18 11.21L11.09 14.6C9.97 14.85 9.68 15.5 8.67 15.5C8.49 15.5 8.34 15.48 8.22 15.45L6.5 9.09L10.42 4.41Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFluorescent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fluorescent">
        <g id="Vector">
          <path
            d="M5.00393 15H19.0039V9H5.00393V15ZM7.00393 11H17.0039V13H7.00393V11Z"
            fill="currentColor"
          />
          <path d="M13.0039 2H11.0039V5H13.0039V2Z" fill="currentColor" />
          <path
            d="M19.08 4.59648L17.2903 6.39887L18.7095 7.80807L20.4992 6.00568L19.08 4.59648Z"
            fill="currentColor"
          />
          <path d="M13.0039 19H11.0039V22H13.0039V19Z" fill="currentColor" />
          <path
            d="M17.2939 17.71L19.0839 19.51L20.5039 18.09L18.7039 16.3L17.2939 17.71Z"
            fill="currentColor"
          />
          <path
            d="M4.90577 4.60196L3.49865 6.00909L5.28761 7.79806L6.69474 6.39093L4.90577 4.60196Z"
            fill="currentColor"
          />
          <path
            d="M5.29848 16.2865L3.49609 18.0762L4.90529 19.4954L6.70768 17.7057L5.29848 16.2865Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFlutterDash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flutter_dash">
        <path
          id="Vector"
          d="M11.07 11.4546C11.36 11.0646 11.88 10.8946 12.34 11.0846C12.51 11.1546 12.66 11.2646 12.77 11.4146C12.99 11.6946 13.02 12.0046 12.99 12.2646C12.94 12.5946 12.74 12.8946 12.45 13.0546C12.45 13.0546 7.58 16.0046 7.38 15.7446C7.18 15.4846 11.07 11.4546 11.07 11.4546ZM22 9.75458C22 12.2546 21 12.7546 20.5 12.7546C20.27 12.7546 20.06 12.6546 19.88 12.4946C19.4 15.8146 17.52 17.8046 14.55 18.4846C14.66 18.9246 15.03 19.2546 15.5 19.2546H16.08C16.3 19.2546 16.49 19.4046 16.56 19.6146C16.73 20.1346 17.22 20.6346 17.58 20.9346C17.83 21.1446 17.82 21.5246 17.55 21.7146C17.21 21.9546 16.65 22.2046 15.76 22.2446C15.58 22.2546 15.41 22.1746 15.31 22.0246C15.18 21.8246 15 21.4646 15 21.0146C15 20.7146 15.04 20.4446 15.09 20.2146C14.31 20.0546 13.7 19.4346 13.54 18.6546C13.05 18.7146 12.54 18.7546 12 18.7546C11.12 18.7546 10.3 18.6646 9.55 18.5046C9.53 18.5846 9.5 18.6646 9.5 18.7546C9.5 19.3046 9.95 19.7546 10.5 19.7546H11.08C11.3 19.7546 11.49 19.9046 11.56 20.1146C11.73 20.6346 12.22 21.1346 12.58 21.4346C12.83 21.6446 12.82 22.0246 12.55 22.2146C12.21 22.4546 11.65 22.7046 10.76 22.7446C10.58 22.7546 10.41 22.6746 10.31 22.5246C10.18 22.3246 10 21.9646 10 21.5146C10 21.2146 10.04 20.9446 10.09 20.7146C9.19 20.5246 8.5 19.7146 8.5 18.7546C8.5 18.5746 8.53 18.3946 8.58 18.2246C6.12 17.3646 4.55 15.4446 4.12 12.4846C3.94 12.6546 3.74 12.7546 3.5 12.7546C3 12.7546 2 12.2546 2 9.75458C2 7.48458 3.7 5.25458 5 5.25458C5.43 5.25458 5.49 5.74458 5.5 6.10458C6.78 4.32458 8.76 3.08458 11.05 2.81458C11.25 1.85458 12.13 1.25458 13 1.25458V2.25458C13 2.25458 13.33 1.75458 14 1.75458C14.67 1.75458 15 2.25458 15 2.25458C14.51 2.25458 14.15 2.60458 14.04 3.02458C15.86 3.50458 17.43 4.61458 18.5 6.10458C18.51 5.74458 18.57 5.25458 19 5.25458C20.3 5.25458 22 7.48458 22 9.75458ZM5 10.7546C5 11.5646 5.1 12.2846 5.25 12.9646C5.43 12.2746 5.71 11.6346 6.08 11.0446C5.87 10.5746 5.74 10.0546 5.74 9.50458C5.75 7.43458 7.43 5.75458 9.5 5.75458C10.46 5.75458 11.34 6.12458 12 6.72458C12.66 6.12458 13.54 5.75458 14.5 5.75458C16.57 5.75458 18.25 7.43458 18.25 9.50458C18.25 10.0546 18.13 10.5746 17.91 11.0446C18.28 11.6346 18.57 12.2846 18.75 12.9846C18.9 12.3046 19 11.5746 19 10.7546C19 6.89458 15.86 3.75458 12 3.75458C8.14 3.75458 5 6.89458 5 10.7546ZM17.98 15.0446C17.98 14.9446 18 14.8546 18 14.7546C18 13.7446 17.74 12.8046 17.3 11.9746C16.61 12.7546 15.62 13.2546 14.5 13.2546C14.23 13.2546 13.96 13.2246 13.71 13.1646C13.85 12.9346 13.94 12.6746 13.98 12.3946C13.99 12.3246 13.99 12.2646 14 12.2046C14.17 12.2346 14.33 12.2546 14.5 12.2546C16.02 12.2546 17.25 11.0246 17.25 9.50458C17.25 7.98458 16.02 6.75458 14.5 6.75458C13.83 6.75458 13.18 7.00458 12.67 7.47458L12 8.07458L11.33 7.47458C10.82 7.00458 10.17 6.75458 9.5 6.75458C7.98 6.75458 6.75 7.98458 6.75 9.50458C6.75 10.8446 7.71 11.9646 8.98 12.2046L8.22 13.0346C7.62 12.8146 7.1 12.4446 6.69 11.9846C6.26 12.8146 6 13.7546 6 14.7546C6 14.8346 6.01 14.9046 6.01 14.9946C7.13 16.8146 9.14 17.7546 12 17.7546C14.88 17.7546 16.88 16.8446 17.98 15.0446ZM16 9.50458C16 10.4746 15.33 11.2546 14.5 11.2546C13.67 11.2546 13 10.4746 13 9.50458C13 8.53458 13.67 7.75458 14.5 7.75458C15.33 7.75458 16 8.53458 16 9.50458ZM15.25 8.63458C15.25 8.42458 15.08 8.25458 14.87 8.25458C14.66 8.25458 14.5 8.42458 14.5 8.63458C14.5 8.84458 14.67 9.01458 14.88 9.01458C15.09 9.01458 15.25 8.83458 15.25 8.63458ZM11 9.50458C11 10.4746 10.33 11.2546 9.5 11.2546C8.67 11.2546 8 10.4746 8 9.50458C8 8.53458 8.67 7.75458 9.5 7.75458C10.33 7.75458 11 8.53458 11 9.50458ZM10.25 8.63458C10.25 8.42458 10.08 8.25458 9.87 8.25458C9.66 8.25458 9.5 8.42458 9.5 8.63458C9.5 8.84458 9.67 9.01458 9.88 9.01458C10.09 9.01458 10.25 8.83458 10.25 8.63458Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFmdBad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fmd_bad">
        <g id="Vector">
          <path
            d="M12 2C7.8 2 4 5.22 4 10.2C4 13.52 6.67 17.45 12 22C17.33 17.45 20 13.52 20 10.2C20 5.22 16.2 2 12 2ZM12 19.33C7.95 15.63 6 12.54 6 10.19C6 6.57 8.65 4 12 4C15.35 4 18 6.57 18 10.2C18 12.54 16.05 15.64 12 19.33Z"
            fill="currentColor"
          />
          <path d="M13 6H11V11H13V6Z" fill="currentColor" />
          <path d="M13 13H11V15H13V13Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconFmdGood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fmd_good">
        <path
          id="Vector"
          d="M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder">
        <path
          id="Vector"
          d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolderCopy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_copy">
        <path
          id="Vector"
          d="M3 19.5H20V21.5H3C1.9 21.5 1 20.6 1 19.5V6.5H3V19.5ZM23 6.5V15.5C23 16.6 22.1 17.5 21 17.5H7C5.9 17.5 5 16.6 5 15.5L5.01 4.5C5.01 3.4 5.9 2.5 7 2.5H12L14 4.5H21C22.1 4.5 23 5.4 23 6.5ZM7 15.5H21V6.5H13.17L11.17 4.5H7V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolderDelete(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_delete">
        <path
          id="Vector"
          d="M16.5 10V9H14.5V10H12V11.5H13V15.5C13 16.33 13.67 17 14.5 17H16.5C17.33 17 18 16.33 18 15.5V11.5H19V10H16.5ZM16.5 15.5H14.5V11.5H16.5V15.5ZM20 6H12L10 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolderOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_off">
        <g id="Vector">
          <path
            d="M20.655 5.29502H12.655L10.655 3.29502H7.82497L11.825 7.29502H20.655V16.465L22.415 18.225C22.565 17.945 22.655 17.635 22.655 17.295V7.29502C22.655 6.19502 21.755 5.29502 20.655 5.29502Z"
            fill="currentColor"
          />
          <path
            d="M2.75497 1.39502L1.34497 2.80502L2.90497 4.36502C2.75497 4.64502 2.66497 4.95502 2.66497 5.29502L2.65497 17.295C2.65497 18.395 3.55497 19.295 4.65497 19.295H17.825L21.135 22.605L22.545 21.195L2.75497 1.39502ZM4.65497 17.295V6.12502L15.825 17.295H4.65497Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconFolderOpen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_open">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolderShared(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_shared">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM15 13C16.1 13 17 12.1 17 11C17 9.9 16.1 9 15 9C13.9 9 13 9.9 13 11C13 12.1 13.9 13 15 13ZM11 17H19V16C19 14.67 16.33 14 15 14C13.67 14 11 14.67 11 16V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolderSpecial(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_special">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM13.08 14.04L12.39 17L15 15.47L17.61 17L16.92 14.04L19.22 12.05L16.19 11.79L15 9L13.81 11.79L10.78 12.05L13.08 14.04Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFolderZip(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="folder_zip">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM16 16H18V14H16V12H18V10H16V8H20V18H16V16ZM16 16H14V18H4V6H9.17L11.17 8H14V10H16V12H14V14H16V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFollowTheSigns(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="follow_the_signs">
        <path
          id="Vector"
          d="M9.5 5.25C10.6 5.25 11.5 4.35 11.5 3.25C11.5 2.15 10.6 1.25 9.5 1.25C8.4 1.25 7.5 2.15 7.5 3.25C7.5 4.35 8.4 5.25 9.5 5.25ZM5.75 8.65L3 22.75H5.1L6.85 14.75L9 16.75V22.75H11V15.2L8.95 13.15L9.55 10.15C10.85 11.75 12.8 12.75 15 12.75V10.75C13.15 10.75 11.55 9.75 10.65 8.3L9.7 6.7C9.35 6.1 8.7 5.75 8 5.75C7.75 5.75 7.5 5.8 7.25 5.9L2 8.05V12.75H4V9.4L5.75 8.65ZM13 1.75V8.75H16.75V22.75H18.25V8.75H22V1.75H13ZM18.01 7.75V6H14.5V4.5H18.01V2.75L20.5 5.25L18.01 7.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFontDownload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="font_download">
        <path
          id="Vector"
          d="M9.17 15.5H14.81L15.95 18.5H18.04L12.93 5.5H11.07L5.96 18.5H8.05L9.17 15.5ZM12 7.98L14.07 13.5H9.93L12 7.98ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 20H4V4H20V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFontDownloadOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="font_download_off">
        <path
          id="Vector"
          d="M5.48497 1.34497H20.655C21.755 1.34497 22.655 2.24497 22.655 3.34497V18.515L20.655 16.515V3.34497H7.48497L5.48497 1.34497ZM11.575 5.34497L11.005 6.86497L12.365 8.22497L12.595 7.56497H12.695L13.235 9.08497L16.275 12.125L13.725 5.34497H11.575ZM21.145 22.655L19.825 21.345H4.65497C3.55497 21.345 2.65497 20.445 2.65497 19.345V4.17497L1.34497 2.85497L2.75497 1.44497L22.555 21.245L21.145 22.655ZM17.825 19.345L12.755 14.275H10.235L9.14497 17.345H7.06497L9.45497 10.975L4.65497 6.17497V19.345H17.825Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFoodBank(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="food_bank">
        <path
          id="Vector"
          d="M12 5.5L18 10V19H6V10L12 5.5ZM12 3L4 9V21H20V9L12 3ZM11.5 9.5V12.5H11V9.5H10V12.5H9.5V9.5H8.5V12.5C8.5 13.33 9.17 14 10 14V18H11V14C11.83 14 12.5 13.33 12.5 12.5V9.5H11.5ZM13 11.5V14.5H14V18H15V9.5C13.9 9.5 13 10.4 13 11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForest(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forest">
        <path
          id="Vector"
          d="M24 18L20.14 12H22L15 2L12 6.29L9 2L2 12H3.86L0 18H7V22H11V18H13V22H17V18H24ZM15 5.49L18.16 10H16.48L20.34 16H16.72L14.15 12H16L13.22 8.03L15 5.49ZM3.66 16L7.52 10H5.84L9 5.49L12.16 10H10.48L14.34 16H3.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForkLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fork_left">
        <path
          id="Vector"
          d="M10.41 15.59L9 17L5 13L9 9L10.41 10.41L8.83 12C10.34 11.67 12.56 12.08 14 13.36V6.83L12.41 8.42L11 7L15 3L19 7L17.59 8.41L16 6.83V21H14V17C13.27 14.42 10.93 13.53 8.83 14L10.41 15.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForkRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fork_right">
        <path
          id="Vector"
          d="M13.59 15.59L15 17L19 13L15 9L13.59 10.41L15.17 12C13.66 11.67 11.44 12.08 10 13.36V6.83L11.59 8.42L13 7L9 3L5 7L6.41 8.41L8 6.83V21H10V17C10.73 14.42 13.07 13.53 15.17 14L13.59 15.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatAlignCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_align_center">
        <path
          id="Vector"
          d="M7 15V17H17V15H7ZM3 21H21V19H3V21ZM3 13H21V11H3V13ZM7 7V9H17V7H7ZM3 3V5H21V3H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatAlignJustify(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_align_justify">
        <path
          id="Vector"
          d="M3 21H21V19H3V21ZM3 17H21V15H3V17ZM3 13H21V11H3V13ZM3 9H21V7H3V9ZM3 3V5H21V3H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatAlignLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_align_left">
        <path
          id="Vector"
          d="M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatAlignRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_align_right">
        <path
          id="Vector"
          d="M3 21H21V19H3V21ZM9 17H21V15H9V17ZM3 13H21V11H3V13ZM9 9H21V7H9V9ZM3 3V5H21V3H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatBold(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_bold">
        <path
          id="Vector"
          d="M15.225 11.79C16.195 11.12 16.875 10.02 16.875 9C16.875 6.74 15.125 5 12.875 5H6.625V19H13.665C15.755 19 17.375 17.3 17.375 15.21C17.375 13.69 16.515 12.39 15.225 11.79ZM9.625 7.5H12.625C13.455 7.5 14.125 8.17 14.125 9C14.125 9.83 13.455 10.5 12.625 10.5H9.625V7.5ZM13.125 16.5H9.625V13.5H13.125C13.955 13.5 14.625 14.17 14.625 15C14.625 15.83 13.955 16.5 13.125 16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatClear(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_clear">
        <path
          id="Vector"
          d="M21 7.07005V4.07005H7.39L10.39 7.07005H12.22L11.67 8.35005L13.76 10.4501L15.21 7.07005H21ZM4.41 3.93005L3 5.34005L9.97 12.3101L7.5 18.0701H10.5L12.07 14.4101L17.73 20.0701L19.14 18.6601L4.41 3.93005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatColorFill(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_color_fill">
        <path
          id="Vector"
          d="M16.56 8.94L7.62 0L6.21 1.41L8.59 3.79L3.44 8.94C2.85 9.53 2.85 10.48 3.44 11.06L8.94 16.56C9.23 16.85 9.62 17 10 17C10.38 17 10.77 16.85 11.06 16.56L16.56 11.06C17.15 10.48 17.15 9.53 16.56 8.94ZM5.21 10L10 5.21L14.79 10H5.21ZM19 11.5C19 11.5 17 13.67 17 15C17 16.1 17.9 17 19 17C20.1 17 21 16.1 21 15C21 13.67 19 11.5 19 11.5ZM2 20H22V24H2V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatColorReset(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_color_reset">
        <path
          id="Vector"
          d="M12 6.19503C13.53 8.19503 15.08 10.625 15.71 12.435L17.94 14.665C17.97 14.395 18 14.115 18 13.835C18 9.85503 12 3.03503 12 3.03503C12 3.03503 10.82 4.38503 9.5 6.22503L10.94 7.66503C11.28 7.15503 11.64 6.66503 12 6.19503ZM5.41 4.97503L4 6.38503L7.32 9.70503C6.55 11.165 6 12.625 6 13.835C6 17.145 8.69 19.835 12 19.835C13.52 19.835 14.9 19.265 15.95 18.335L18.58 20.965L20 19.555L5.41 4.97503ZM12 17.835C9.79 17.835 8 16.045 8 13.835C8 13.145 8.32 12.215 8.81 11.195L14.53 16.915C13.83 17.475 12.96 17.835 12 17.835Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatColorText(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_color_text">
        <path
          id="Vector"
          d="M2 18.5H22V22.5H2V18.5ZM5.49 15.5H7.91L9.18 11.92H14.83L16.09 15.5H18.51L13.25 1.5H10.75L5.49 15.5ZM9.91 9.89L11.94 4.1H12.06L14.09 9.89H9.91Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatIndentDecrease(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_indent_decrease">
        <path
          id="Vector"
          d="M11 17H21V15H11V17ZM3 12L7 16V8L3 12ZM3 21H21V19H3V21ZM3 3V5H21V3H3ZM11 9H21V7H11V9ZM11 13H21V11H11V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatIndentIncrease(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_indent_increase">
        <path
          id="Vector"
          d="M3 21H21V19H3V21ZM3 8V16L7 12L3 8ZM11 17H21V15H11V17ZM3 3V5H21V3H3ZM11 9H21V7H11V9ZM11 13H21V11H11V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatItalic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_italic">
        <path
          id="Vector"
          d="M10 5V8H12.21L8.79 16H6V19H14V16H11.79L15.21 8H18V5H10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatLineSpacing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_line_spacing">
        <path
          id="Vector"
          d="M6.25 7H8.75L5.25 3.5L1.75 7H4.25V17H1.75L5.25 20.5L8.75 17H6.25V7ZM10.25 5V7H22.25V5H10.25ZM10.25 19H22.25V17H10.25V19ZM10.25 13H22.25V11H10.25V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatListBulleted(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_list_bulleted">
        <path
          id="Vector"
          d="M4.25 10.5C3.42 10.5 2.75 11.17 2.75 12C2.75 12.83 3.42 13.5 4.25 13.5C5.08 13.5 5.75 12.83 5.75 12C5.75 11.17 5.08 10.5 4.25 10.5ZM4.25 4.5C3.42 4.5 2.75 5.17 2.75 6C2.75 6.83 3.42 7.5 4.25 7.5C5.08 7.5 5.75 6.83 5.75 6C5.75 5.17 5.08 4.5 4.25 4.5ZM4.25 16.5C3.42 16.5 2.75 17.18 2.75 18C2.75 18.82 3.43 19.5 4.25 19.5C5.07 19.5 5.75 18.82 5.75 18C5.75 17.18 5.08 16.5 4.25 16.5ZM7.25 19H21.25V17H7.25V19ZM7.25 13H21.25V11H7.25V13ZM7.25 5V7H21.25V5H7.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatListNumbered(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_list_numbered">
        <path
          id="Vector"
          d="M2.5 17H4.5V17.5H3.5V18.5H4.5V19H2.5V20H5.5V16H2.5V17ZM3.5 8H4.5V4H2.5V5H3.5V8ZM2.5 11H4.3L2.5 13.1V14H5.5V13H3.7L5.5 10.9V10H2.5V11ZM7.5 5V7H21.5V5H7.5ZM7.5 19H21.5V17H7.5V19ZM7.5 13H21.5V11H7.5V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatListNumberedRtl(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_list_numbered_rtl">
        <path
          id="Vector"
          d="M18.5 17H20.5V17.5H19.5V18.5H20.5V19H18.5V20H21.5V16H18.5V17ZM19.5 8H20.5V4H18.5V5H19.5V8ZM18.5 11H20.3L18.5 13.1V14H21.5V13H19.7L21.5 10.9V10H18.5V11ZM2.5 5H16.5V7H2.5V5ZM2.5 17H16.5V19H2.5V17ZM2.5 11H16.5V13H2.5V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatOverline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_overline">
        <path
          id="Vector"
          d="M19 3V5H5V3H19ZM12 7C8.13 7 5 10.13 5 14C5 17.87 8.13 21 12 21C15.87 21 19 17.87 19 14C19 10.13 15.87 7 12 7ZM12 18.5C9.51 18.5 7.5 16.49 7.5 14C7.5 11.51 9.51 9.5 12 9.5C14.49 9.5 16.5 11.51 16.5 14C16.5 16.49 14.49 18.5 12 18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatPaint(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_paint">
        <path
          id="Vector"
          d="M17.5 4V3C17.5 2.45 17.05 2 16.5 2H4.5C3.95 2 3.5 2.45 3.5 3V7C3.5 7.55 3.95 8 4.5 8H16.5C17.05 8 17.5 7.55 17.5 7V6H18.5V10H8.5V21C8.5 21.55 8.95 22 9.5 22H11.5C12.05 22 12.5 21.55 12.5 21V12H20.5V4H17.5ZM15.5 6H5.5V4H15.5V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatQuote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_quote">
        <path
          id="Vector"
          d="M18.62 18H13.38L15.38 14H13V6H21V13.24L18.62 18ZM16.62 16H17.38L19 12.76V8H15V12H18.62L16.62 16ZM8.62 18H3.38L5.38 14H3V6H11V13.24L8.62 18ZM6.62 16H7.38L9 12.76V8H5V12H8.62L6.62 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatShapes(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_shapes">
        <path
          id="Vector"
          d="M23 7V1H17V3H7V1H1V7H3V17H1V23H7V21H17V23H23V17H21V7H23ZM3 3H5V5H3V3ZM5 21H3V19H5V21ZM17 19H7V17H5V7H7V5H17V7H19V17H17V19ZM21 21H19V19H21V21ZM19 5V3H21V5H19ZM13.73 14H10.24L9.51 16H7.89L11.29 7H12.69L16.1 16H14.47L13.73 14ZM10.69 12.74H13.3L12 8.91L10.69 12.74Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatSize(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_size">
        <path
          id="Vector"
          d="M8.5 4.5V7.5H13.5V19.5H16.5V7.5H21.5V4.5H8.5ZM2.5 12.5H5.5V19.5H8.5V12.5H11.5V9.5H2.5V12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatStrikethrough(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_strikethrough">
        <path
          id="Vector"
          d="M10 19.5H14V16.5H10V19.5ZM5 4.5V7.5H10V10.5H14V7.5H19V4.5H5ZM3 14.5H21V12.5H3V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatTextdirectionLToR(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_textdirection_l_to_r">
        <path
          id="Vector"
          d="M8 4V8C6.9 8 6 7.1 6 6C6 4.9 6.9 4 8 4ZM16 2H8C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10V15H10V4H12V15H14V4H16V2ZM16 14V17H4V19H16V22L20 18L16 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatTextdirectionRToL(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_textdirection_r_to_l">
        <path
          id="Vector"
          d="M10 4V8C8.9 8 8 7.1 8 6C8 4.9 8.9 4 10 4ZM18 2H10C7.79 2 6 3.79 6 6C6 8.21 7.79 10 10 10V15H12V4H14V15H16V4H18V2ZM8 14L4 18L8 22V19H20V17H8V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFormatUnderlined(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="format_underlined">
        <path
          id="Vector"
          d="M12 17C15.31 17 18 14.31 18 11V3H15.5V11C15.5 12.93 13.93 14.5 12 14.5C10.07 14.5 8.5 12.93 8.5 11V3H6V11C6 14.31 8.69 17 12 17ZM5 19V21H19V19H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFort(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fort">
        <path
          id="Vector"
          d="M21 3V5H19V3H17V5H15V3H13V7L15 9V10H9V9L11 7V3H9V5H7V3H5V5H3V3H1V7L3 9V15L1 17V21H10V18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18V21H23V17L21 15V9L23 7V3H21ZM21 19H16V18C16 15.79 14.21 14 12 14C9.79 14 8 15.79 8 18V19H3V17.83L5 15.83V8.17L3.83 7H8.17L7 8.17V12H17V8.17L15.83 7H20.17L19 8.17V15.83L21 17.83V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForum(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forum">
        <path
          id="Vector"
          d="M15 4V11H5.17L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForward(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forward">
        <path
          id="Vector"
          d="M14 8.83L17.17 12L14 15.17V14H6V10H14V8.83ZM12 4V8H4V16H12V20L20 12L12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForward10(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forward_10">
        <g id="Vector">
          <path
            d="M18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14C6 10.69 8.69 8 12 8V12L17 7L12 2V6C7.58 6 4 9.58 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14H18Z"
            fill="currentColor"
          />
          <path
            d="M10.9 17V12.73H10.81L9.04 13.36V14.05L10.05 13.74V17H10.9Z"
            fill="currentColor"
          />
          <path
            d="M14.32 12.78C14.14 12.71 13.95 12.68 13.73 12.68C13.51 12.68 13.32 12.71 13.14 12.78C12.96 12.85 12.81 12.96 12.69 13.11C12.57 13.26 12.46 13.45 12.4 13.68C12.34 13.91 12.3 14.18 12.3 14.5V15.24C12.3 15.56 12.34 15.84 12.41 16.06C12.48 16.28 12.58 16.48 12.71 16.63C12.84 16.78 12.99 16.89 13.17 16.96C13.35 17.03 13.54 17.06 13.76 17.06C13.98 17.06 14.17 17.03 14.35 16.96C14.53 16.89 14.68 16.78 14.8 16.63C14.92 16.48 15.02 16.29 15.09 16.06C15.16 15.83 15.19 15.56 15.19 15.24V14.5C15.19 14.18 15.15 13.9 15.08 13.68C15.01 13.46 14.91 13.26 14.78 13.11C14.65 12.96 14.49 12.85 14.32 12.78ZM14.33 15.35C14.33 15.54 14.32 15.7 14.29 15.83C14.26 15.96 14.23 16.07 14.18 16.15C14.13 16.23 14.07 16.29 13.99 16.32C13.91 16.35 13.83 16.37 13.74 16.37C13.65 16.37 13.56 16.35 13.49 16.32C13.42 16.29 13.35 16.23 13.3 16.15C13.25 16.07 13.21 15.96 13.18 15.83C13.15 15.7 13.14 15.54 13.14 15.35V14.38C13.14 14.19 13.15 14.03 13.18 13.9C13.21 13.77 13.24 13.67 13.3 13.59C13.36 13.51 13.41 13.45 13.49 13.42C13.57 13.39 13.65 13.37 13.74 13.37C13.83 13.37 13.92 13.39 13.99 13.42C14.06 13.45 14.13 13.51 14.18 13.59C14.23 13.67 14.27 13.77 14.3 13.9C14.33 14.03 14.34 14.19 14.34 14.38V15.35H14.33Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconForward30(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forward_30">
        <path
          id="Vector"
          d="M18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14C6 10.69 8.69 8 12 8V12L17 7L12 2V6C7.58 6 4 9.58 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14H18ZM10.54 16.22C10.48 16.27 10.42 16.31 10.34 16.34C10.26 16.37 10.17 16.38 10.07 16.38C9.98 16.38 9.9 16.37 9.82 16.34C9.74 16.31 9.68 16.28 9.62 16.23C9.56 16.18 9.52 16.13 9.49 16.06C9.46 15.99 9.44 15.92 9.44 15.84H8.59C8.59 16.05 8.63 16.23 8.71 16.39C8.79 16.55 8.9 16.67 9.04 16.77C9.18 16.87 9.33 16.95 9.5 17C9.67 17.05 9.85 17.07 10.03 17.07C10.24 17.07 10.44 17.04 10.63 16.99C10.82 16.94 10.97 16.85 11.11 16.75C11.25 16.65 11.35 16.51 11.43 16.36C11.51 16.21 11.55 16.03 11.55 15.83C11.55 15.6 11.49 15.39 11.37 15.22C11.25 15.05 11.07 14.92 10.83 14.83C10.93 14.78 11.03 14.73 11.11 14.66C11.19 14.59 11.26 14.52 11.31 14.44C11.36 14.36 11.41 14.28 11.44 14.19C11.47 14.1 11.48 14.01 11.48 13.92C11.48 13.72 11.44 13.55 11.37 13.39C11.3 13.23 11.2 13.11 11.07 13.01C10.94 12.91 10.79 12.83 10.61 12.78C10.43 12.73 10.24 12.7 10.02 12.7C9.83 12.7 9.64 12.73 9.48 12.78C9.32 12.83 9.16 12.91 9.04 13.01C8.92 13.11 8.81 13.23 8.74 13.38C8.67 13.53 8.63 13.68 8.63 13.86H9.48C9.48 13.79 9.5 13.72 9.53 13.66C9.56 13.6 9.6 13.55 9.65 13.51C9.7 13.47 9.76 13.44 9.83 13.41C9.9 13.38 9.97 13.38 10.05 13.38C10.15 13.38 10.23 13.39 10.3 13.42C10.37 13.45 10.43 13.48 10.48 13.53C10.53 13.58 10.56 13.64 10.59 13.7C10.62 13.76 10.63 13.84 10.63 13.92C10.63 14.1 10.58 14.24 10.47 14.35C10.36 14.46 10.21 14.51 9.99 14.51H9.56V15.17H10.01C10.12 15.17 10.21 15.18 10.3 15.21C10.39 15.24 10.46 15.27 10.52 15.32C10.58 15.37 10.63 15.44 10.66 15.52C10.69 15.6 10.71 15.7 10.71 15.81C10.71 15.9 10.7 15.98 10.67 16.05C10.64 16.12 10.59 16.16 10.54 16.22ZM14.44 12.78C14.26 12.71 14.07 12.68 13.85 12.68C13.63 12.68 13.44 12.71 13.26 12.78C13.08 12.85 12.93 12.96 12.81 13.11C12.69 13.26 12.58 13.45 12.52 13.68C12.46 13.91 12.42 14.18 12.42 14.5V15.24C12.42 15.56 12.46 15.84 12.53 16.06C12.6 16.28 12.7 16.48 12.83 16.63C12.96 16.78 13.11 16.89 13.29 16.96C13.47 17.03 13.66 17.06 13.88 17.06C14.1 17.06 14.29 17.03 14.47 16.96C14.65 16.89 14.8 16.78 14.92 16.63C15.04 16.48 15.14 16.29 15.21 16.06C15.28 15.83 15.31 15.56 15.31 15.24V14.5C15.31 14.18 15.27 13.9 15.2 13.68C15.13 13.46 15.03 13.26 14.9 13.11C14.77 12.96 14.62 12.85 14.44 12.78ZM14.45 15.35C14.45 15.54 14.44 15.7 14.41 15.83C14.38 15.96 14.35 16.07 14.3 16.15C14.25 16.23 14.19 16.29 14.11 16.32C14.03 16.35 13.95 16.37 13.86 16.37C13.77 16.37 13.68 16.35 13.61 16.32C13.54 16.29 13.47 16.23 13.42 16.15C13.37 16.07 13.33 15.96 13.3 15.83C13.27 15.7 13.26 15.54 13.26 15.35V14.38C13.26 14.19 13.27 14.03 13.3 13.9C13.33 13.77 13.36 13.67 13.42 13.59C13.48 13.51 13.53 13.45 13.61 13.42C13.69 13.39 13.77 13.37 13.86 13.37C13.95 13.37 14.04 13.39 14.11 13.42C14.18 13.45 14.25 13.51 14.3 13.59C14.35 13.67 14.39 13.77 14.42 13.9C14.45 14.03 14.46 14.19 14.46 14.38V15.35H14.45Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForward5(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forward_5">
        <path
          id="Vector"
          d="M18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14C6 10.69 8.69 8 12 8V12L17 7L12 2V6C7.58 6 4 9.58 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14H18ZM12.48 16.15C12.43 16.22 12.37 16.28 12.3 16.32C12.23 16.36 12.13 16.38 12.03 16.38C11.86 16.38 11.72 16.33 11.61 16.23C11.5 16.13 11.44 15.99 11.42 15.82H10.58C10.59 16.02 10.63 16.19 10.71 16.35C10.79 16.51 10.9 16.63 11.03 16.74C11.16 16.85 11.32 16.93 11.49 16.98C11.66 17.03 11.84 17.06 12.02 17.06C12.26 17.06 12.48 17.02 12.66 16.94C12.84 16.86 12.99 16.76 13.11 16.63C13.23 16.5 13.32 16.35 13.38 16.18C13.44 16.01 13.47 15.83 13.47 15.64C13.47 15.42 13.44 15.21 13.38 15.04C13.32 14.87 13.24 14.71 13.13 14.59C13.02 14.47 12.88 14.37 12.72 14.31C12.56 14.25 12.38 14.21 12.17 14.21C12.1 14.21 12.03 14.22 11.97 14.23C11.91 14.24 11.84 14.25 11.79 14.27C11.74 14.29 11.69 14.3 11.64 14.32C11.59 14.34 11.56 14.36 11.53 14.37L11.64 13.45H13.34V12.74H10.95L10.7 14.91L11.37 15.08C11.4 15.05 11.43 15.02 11.47 14.99C11.51 14.96 11.54 14.94 11.59 14.92C11.64 14.9 11.69 14.88 11.74 14.87C11.79 14.86 11.87 14.85 11.94 14.85C12.06 14.85 12.16 14.87 12.24 14.9C12.32 14.93 12.4 14.99 12.45 15.05C12.5 15.11 12.55 15.19 12.58 15.29C12.61 15.39 12.62 15.48 12.62 15.6C12.62 15.72 12.61 15.82 12.59 15.91C12.57 16 12.53 16.08 12.48 16.15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForwardToInbox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="forward_to_inbox">
        <path
          id="Vector"
          d="M19.5 2.5H3.5C2.4 2.5 1.5 3.4 1.5 4.5V16.5C1.5 17.6 2.4 18.5 3.5 18.5H12.5V16.5H3.5V6.5L11.5 11.5L19.5 6.5V11.5H21.5V4.5C21.5 3.4 20.6 2.5 19.5 2.5ZM11.5 9.5L3.5 4.5H19.5L11.5 9.5ZM18.5 13.5L22.5 17.5L18.5 21.5V18.5H14.5V16.5H18.5V13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFoundation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="foundation">
        <path
          id="Vector"
          d="M19 12.5H22L12 3.5L2 12.5H5V15.5H3V17.5H5V20.5H7V17.5H11V20.5H13V17.5H17V20.5H19V17.5H21V15.5H19V12.5ZM7 15.5V10.69L11 7.09V15.5H7ZM13 15.5V7.09L17 10.69V15.5H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFreeBreakfast(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="free_breakfast">
        <path
          id="Vector"
          d="M3 19H19V21H3V19ZM19 3H3V13C3 15.21 4.79 17 7 17H13C15.21 17 17 15.21 17 13V10H19C20.11 10 21 9.1 21 8V5C21 3.89 20.11 3 19 3ZM15 13C15 14.1 14.1 15 13 15H7C5.9 15 5 14.1 5 13V5H15V13ZM19 8H17V5H19V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFreeCancellation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="free_cancellation">
        <path
          id="Vector"
          d="M10.62 19.75H4.41003V9.75H18.41V14.13L20.41 12.13V5.75C20.41 4.65 19.51 3.75 18.41 3.75H17.41V1.75H15.41V3.75H7.41003V1.75H5.41003V3.75H4.41003C3.30003 3.75 2.42003 4.65 2.42003 5.75L2.41003 19.75C2.41003 20.85 3.30003 21.75 4.41003 21.75H12.62L10.62 19.75ZM4.41003 5.75H18.41V7.75H4.41003V5.75ZM15.95 22.25L12.41 18.71L13.82 17.3L15.94 19.42L20.18 15.18L21.59 16.59L15.95 22.25ZM9.82003 13.75L11.41 15.34L10 16.75L8.41003 15.16L6.82003 16.75L5.41003 15.34L7.00003 13.75L5.41003 12.16L6.82003 10.75L8.41003 12.34L10 10.75L11.41 12.16L9.82003 13.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFrontHand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="front_hand">
        <path
          id="Vector"
          d="M18 8C17.83 8 17.66 8.02 17.5 8.05V4.5C17.5 3.12 16.38 2 15 2C14.81 2 14.63 2.02 14.46 2.06C14.25 0.89 13.23 0 12 0C10.94 0 10.04 0.66 9.67 1.59C9.46 1.53 9.23 1.5 9 1.5C7.62 1.5 6.5 2.62 6.5 4V4.55C6.34 4.52 6.17 4.5 6 4.5C4.62 4.5 3.5 5.62 3.5 7V15.5C3.5 20.19 7.31 24 12 24C16.69 24 20.5 20.19 20.5 15.5V10.5C20.5 9.12 19.38 8 18 8ZM18.5 15.5C18.5 19.09 15.59 22 12 22C8.41 22 5.5 19.09 5.5 15.5V7C5.5 6.72 5.72 6.5 6 6.5C6.28 6.5 6.5 6.72 6.5 7V12H8.5V4C8.5 3.72 8.72 3.5 9 3.5C9.28 3.5 9.5 3.72 9.5 4V11H11.5V2.5C11.5 2.22 11.72 2 12 2C12.28 2 12.5 2.22 12.5 2.5V11H14.5V4.5C14.5 4.22 14.72 4 15 4C15.28 4 15.5 4.22 15.5 4.5V13.42C13.73 14.19 12.5 15.95 12.5 18H14.5C14.5 16.34 15.84 15 17.5 15V10.5C17.5 10.22 17.72 10 18 10C18.28 10 18.5 10.22 18.5 10.5V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFullscreen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fullscreen">
        <path
          id="Vector"
          d="M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFullscreenExit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fullscreen_exit">
        <path
          id="Vector"
          d="M5 16H8V19H10V14H5V16ZM8 8H5V10H10V5H8V8ZM14 19H16V16H19V14H14V19ZM16 8V5H14V10H19V8H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconFunctions(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="functions">
        <path
          id="Vector"
          d="M18 4H6V6L12.5 12L6 18V20H18V17H11L16 12L11 7H18V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="g_mobiledata">
        <path
          id="Vector"
          d="M12.5 11V13H14.5V15H9.5V9H16.5C16.5 7.9 15.6 7 14.5 7H9.5C8.4 7 7.5 7.9 7.5 9V15C7.5 16.1 8.4 17 9.5 17H14.5C15.6 17 16.5 16.1 16.5 15V11H12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGTranslate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="g_translate">
        <path
          id="Vector"
          d="M20 5H10.88L10 2H4C2.9 2 2 2.9 2 4V17C2 18.1 2.9 19 4 19H11L12 22H20C21.1 22 22 21.1 22 20V7C22 5.9 21.1 5 20 5ZM7.17 14.59C4.92 14.59 3.08 12.76 3.08 10.5C3.08 8.24 4.91 6.41 7.17 6.41C8.21 6.41 9.16 6.78 9.91 7.48L9.98 7.54L8.75 8.72L8.69 8.67C8.4 8.4 7.91 8.08 7.17 8.08C5.86 8.08 4.79 9.17 4.79 10.5C4.79 11.83 5.86 12.92 7.17 12.92C8.54 12.92 9.13 12.05 9.29 11.46H7.08V9.91H11.03L11.04 9.98C11.08 10.19 11.09 10.38 11.09 10.59C11.09 12.94 9.48 14.59 7.17 14.59ZM13.2 12.88C13.53 13.48 13.94 14.06 14.39 14.58L13.85 15.11L13.2 12.88ZM13.97 12.12H12.98L12.67 11.08H16.66C16.66 11.08 16.32 12.39 15.1 13.82C14.58 13.2 14.21 12.59 13.97 12.12ZM21 20C21 20.55 20.55 21 20 21H13L15 19L14.19 16.23L15.11 15.31L17.79 18L18.52 17.27L15.81 14.59C16.71 13.56 17.41 12.34 17.73 11.08H19V10.04H15.36V9H14.32V10.04H12.36L11.18 6H20C20.55 6 21 6.45 21 7V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGamepad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gamepad">
        <path
          id="Vector"
          d="M13 4V6.67L12 7.67L11 6.67V4H13ZM20 11V13H17.33L16.33 12L17.33 11H20ZM6.67 11L7.67 12L6.67 13H4V11H6.67ZM12 16.33L13 17.33V20H11V17.33L12 16.33ZM15 2H9V7.5L12 10.5L15 7.5V2ZM22 9H16.5L13.5 12L16.5 15H22V9ZM7.5 9H2V15H7.5L10.5 12L7.5 9ZM12 13.5L9 16.5V22H15V16.5L12 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGames(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="games">
        <path
          id="Vector"
          d="M13 4V6.67L12 7.67L11 6.67V4H13ZM20 11V13H17.33L16.33 12L17.33 11H20ZM6.67 11L7.67 12L6.67 13H4V11H6.67ZM12 16.33L13 17.33V20H11V17.33L12 16.33ZM15 2H9V7.5L12 10.5L15 7.5V2ZM22 9H16.5L13.5 12L16.5 15H22V9ZM7.5 9H2V15H7.5L10.5 12L7.5 9ZM12 13.5L9 16.5V22H15V16.5L12 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGarage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="garage">
        <g id="Vector">
          <path
            d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 20H4V4H20V20Z"
            fill="currentColor"
          />
          <path
            d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z"
            fill="currentColor"
          />
          <path
            d="M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z"
            fill="currentColor"
          />
          <path
            d="M5.78 18.5H6.22C6.65 18.5 7 18.14 7 17.69V16.5H17V17.69C17 18.14 17.34 18.5 17.78 18.5H18.22C18.65 18.5 19 18.14 19 17.69V11.19C18.18 8.73 17.66 7.16 17.44 6.5C17.39 6.34 17.32 6.21 17.25 6.1C17.23 6.08 17.22 6.06 17.2 6.03C16.82 5.51 16.28 5.5 16.28 5.5H7.72C7.72 5.5 7.18 5.51 6.8 6.04C6.78 6.06 6.77 6.08 6.75 6.1C6.68 6.21 6.61 6.34 6.56 6.5C6.34 7.16 5.82 8.72 5 11.19V17.69C5 18.14 5.35 18.5 5.78 18.5ZM8.33 7.5H15.67L15.9 8.19L16.33 9.5H7.67L8.33 7.5ZM7 11.5H17V14.5H7V11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconGasMeter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gas_meter">
        <g id="Vector">
          <path
            d="M16 4H15V2H13V4H11V2H9V4H8C5.79 4 4 5.79 4 8V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V8C20 5.79 18.21 4 16 4ZM18 18C18 19.1 17.1 20 16 20H8C6.9 20 6 19.1 6 18V8C6 6.9 6.9 6 8 6H16C17.1 6 18 6.9 18 8V18Z"
            fill="currentColor"
          />
          <path
            d="M9.5 15.54C9.5 16.9 10.62 18 12 18C13.38 18 14.5 16.9 14.5 15.54C14.5 14.45 14.05 14.13 12 11.75C9.93 14.15 9.5 14.46 9.5 15.54Z"
            fill="currentColor"
          />
          <path d="M16 8H8V10H16V8Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconGavel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gavel">
        <path
          id="Vector"
          d="M1.39502 21H13.395V23H1.39502V21ZM5.63502 8.07L8.46502 5.24L22.605 19.38L19.775 22.21L5.63502 8.07ZM12.715 1L18.375 6.66L15.545 9.49L9.88502 3.83L12.715 1ZM4.22502 9.48L9.88502 15.14L7.05502 17.97L1.39502 12.31L4.22502 9.48Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGeneratingTokens(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="generating_tokens">
        <path
          id="Vector"
          d="M9 4C4.58 4 1 7.58 1 12C1 16.42 4.58 20 9 20C13.42 20 17 16.42 17 12C17 7.58 13.42 4 9 4ZM9 18C5.69 18 3 15.31 3 12C3 8.69 5.69 6 9 6C12.31 6 15 8.69 15 12C15 15.31 12.31 18 9 18ZM12 10.5H10V15.5H8V10.5H6V9H12V10.5ZM20.25 3.75L23 5L20.25 6.25L19 9L17.75 6.25L15 5L17.75 3.75L19 1L20.25 3.75ZM20.25 17.75L23 19L20.25 20.25L19 23L17.75 20.25L15 19L17.75 17.75L19 15L20.25 17.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGesture(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gesture">
        <path
          id="Vector"
          d="M4.66992 6.90001C5.36992 6.19001 6.06992 5.55001 6.37992 5.68001C6.87992 5.88001 6.37992 6.71001 6.07992 7.20001C5.82992 7.62001 3.21992 11.09 3.21992 13.51C3.21992 14.79 3.69992 15.85 4.55992 16.49C5.30992 17.05 6.29992 17.22 7.19992 16.95C8.26992 16.64 9.14992 15.55 10.2599 14.18C11.4699 12.69 13.0899 10.74 14.3399 10.74C15.9699 10.74 15.9899 11.75 16.0999 12.53C12.3199 13.17 10.7199 16.2 10.7199 17.9C10.7199 19.6 12.1599 20.99 13.9299 20.99C15.5599 20.99 18.2199 19.66 18.6199 14.89H21.0799V12.39H18.6099C18.4599 10.74 17.5199 8.19001 14.5799 8.19001C12.3299 8.19001 10.3999 10.1 9.63992 11.03C9.05992 11.76 7.57992 13.51 7.34992 13.75C7.09992 14.05 6.66992 14.59 6.23992 14.59C5.78992 14.59 5.51992 13.76 5.87992 12.67C6.22992 11.58 7.27992 9.81001 7.72992 9.15001C8.50992 8.01001 9.02992 7.23001 9.02992 5.87001C9.02992 3.70001 7.38992 3.01001 6.51992 3.01001C5.19992 3.01001 4.04992 4.01001 3.79992 4.26001C3.43992 4.62001 3.13992 4.92001 2.91992 5.19001L4.66992 6.90001ZM13.9599 18.56C13.6499 18.56 13.2199 18.3 13.2199 17.84C13.2199 17.24 13.9499 15.64 16.0899 15.08C15.7899 17.77 14.6599 18.56 13.9599 18.56Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGetApp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="get_app">
        <path
          id="Vector"
          d="M13 5.5V11.5H14.17L12 13.67L9.83 11.5H11V5.5H13ZM15 3.5H9V9.5H5L12 16.5L19 9.5H15V3.5ZM19 18.5H5V20.5H19V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGif(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gif">
        <path
          id="Vector"
          d="M11.5 9H13V15H11.5V9ZM9 9H6C5.4 9 5 9.5 5 10V14C5 14.5 5.4 15 6 15H9C9.6 15 10 14.5 10 14V12H8.5V13.5H6.5V10.5H10V10C10 9.5 9.6 9 9 9ZM19 10.5V9H14.5V15H16V13H18V11.5H16V10.5H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGifBox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gif_box">
        <path
          id="Vector"
          d="M19 19H5V5H19V19ZM5 3C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5ZM11.5 14H12.5V10H11.5V14ZM13.5 14H14.5V12.5H16V11.5H14.5V11H16.5V10H13.5V14ZM9.5 12V13H8.5V11H10.5C10.5 10.45 10.05 10 9.5 10H8.5C7.95 10 7.5 10.45 7.5 11V13C7.5 13.55 7.95 14 8.5 14H9.5C10.05 14 10.5 13.55 10.5 13V12H9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGirl(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="girl">
        <path
          id="Vector"
          d="M12 7.5C12.97 7.5 13.75 6.72 13.75 5.75C13.75 4.78 12.97 4 12 4C11.03 4 10.25 4.78 10.25 5.75C10.25 6.72 11.03 7.5 12 7.5ZM14 16V20H10V16H8L10.38 9.62C10.63 8.95 11.28 8.5 12 8.5C12.72 8.5 13.37 8.95 13.62 9.62L16 16H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGite(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gite">
        <path
          id="Vector"
          d="M18 6.5H9V4.5H7V6.5H6L2 10.5V19.5H22V10.5L18 6.5ZM4 12.5H14V17.5H4V12.5ZM20 17.5H16V11.33L18 9.33L20 11.33V17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGolfCourse(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="golf_course">
        <g id="Vector">
          <path
            d="M19 21C19.8284 21 20.5 20.3284 20.5 19.5C20.5 18.6716 19.8284 18 19 18C18.1716 18 17.5 18.6716 17.5 19.5C17.5 20.3284 18.1716 21 19 21Z"
            fill="currentColor"
          />
          <path
            d="M16.5 5.92L8.5 2V20H6.5V18.27C4.71 18.62 3.5 19.26 3.5 20C3.5 21.1 6.19 22 9.5 22C12.81 22 15.5 21.1 15.5 20C15.5 19.01 13.34 18.19 10.5 18.03V8.98L16.5 5.92Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconGppBad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gpp_bad">
        <path
          id="Vector"
          d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09ZM9.91 8.5L8.5 9.91L10.59 12L8.5 14.09L9.91 15.5L12 13.42L14.09 15.5L15.5 14.09L13.42 12L15.5 9.91L14.09 8.5L12 10.59L9.91 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGppGood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gpp_good">
        <path
          id="Vector"
          d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.31L12 4.19L18 6.31V11.09ZM8.82 10.59L7.4 12L10.94 15.54L16.6 9.88L15.19 8.47L10.95 12.71L8.82 10.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGppMaybe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gpp_maybe">
        <g id="Vector">
          <path
            d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z"
            fill="currentColor"
          />
          <path d="M13 14H11V16H13V14Z" fill="currentColor" />
          <path d="M13 7H11V12H13V7Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconGpsFixed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gps_fixed">
        <path
          id="Vector"
          d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGpsNotFixed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gps_not_fixed">
        <path
          id="Vector"
          d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGpsOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gps_off">
        <path
          id="Vector"
          d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C10.02 3.17 9.09 3.44 8.23 3.84L9.76 5.37C10.46 5.13 11.22 5 12 5C15.87 5 19 8.13 19 12C19 12.79 18.87 13.54 18.63 14.24L20.16 15.77C20.56 14.91 20.83 13.98 20.94 13H23V11H20.94ZM3 4.27L5.04 6.31C3.97 7.62 3.26 9.23 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C14.77 20.74 16.38 20.03 17.69 18.96L19.73 21L21.14 19.59L4.41 2.86L3 4.27ZM16.27 17.54C15.09 18.45 13.61 19 12 19C8.13 19 5 15.87 5 12C5 10.39 5.55 8.91 6.46 7.73L16.27 17.54Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGradient(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="gradient">
        <path
          id="Vector"
          d="M11 9H13V11H11V9ZM9 11H11V13H9V11ZM13 11H15V13H13V11ZM15 9H17V11H15V9ZM7 9H9V11H7V9ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18ZM19 11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGrading(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grading">
        <path
          id="Vector"
          d="M4 7H20V9H4V7ZM4 13H20V11H4V13ZM4 17H11V15H4V17ZM4 21H11V19H4V21ZM15.41 18.17L14 16.75L12.59 18.16L15.41 21L20 16.42L18.58 15L15.41 18.17ZM4 3V5H20V3H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGrain(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grain">
        <path
          id="Vector"
          d="M10 12C8.9 12 8 12.9 8 14C8 15.1 8.9 16 10 16C11.1 16 12 15.1 12 14C12 12.9 11.1 12 10 12ZM6 8C4.9 8 4 8.9 4 10C4 11.1 4.9 12 6 12C7.1 12 8 11.1 8 10C8 8.9 7.1 8 6 8ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM18 8C19.1 8 20 7.1 20 6C20 4.9 19.1 4 18 4C16.9 4 16 4.9 16 6C16 7.1 16.9 8 18 8ZM14 16C12.9 16 12 16.9 12 18C12 19.1 12.9 20 14 20C15.1 20 16 19.1 16 18C16 16.9 15.1 16 14 16ZM18 12C16.9 12 16 12.9 16 14C16 15.1 16.9 16 18 16C19.1 16 20 15.1 20 14C20 12.9 19.1 12 18 12ZM14 8C12.9 8 12 8.9 12 10C12 11.1 12.9 12 14 12C15.1 12 16 11.1 16 10C16 8.9 15.1 8 14 8ZM10 4C8.9 4 8 4.9 8 6C8 7.1 8.9 8 10 8C11.1 8 12 7.1 12 6C12 4.9 11.1 4 10 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGraphicEq(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="graphic_eq">
        <path
          id="Vector"
          d="M7 18H9V6H7V18ZM11 22H13V2H11V22ZM3 14H5V10H3V14ZM15 18H17V6H15V18ZM19 10V14H21V10H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGrass(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grass">
        <path
          id="Vector"
          d="M12 20H2V18H7.75C7.02 15.19 4.81 12.99 2 12.26C2.64 12.1 3.31 12 4 12C8.42 12 12 15.58 12 20ZM22 12.26C21.36 12.1 20.69 12 20 12C17.07 12 14.52 13.58 13.12 15.93C13.41 16.59 13.65 17.28 13.79 18C13.92 18.65 13.99 19.32 13.99 20H21.99V18H16.24C16.98 15.19 19.19 12.99 22 12.26ZM15.64 11.02C16.42 8.93 17.87 7.18 19.73 6.02C15.44 6.16 12 9.67 12 14C12 14.01 12 14.02 12 14.02C12.95 12.75 14.2 11.72 15.64 11.02ZM11.42 8.85C10.58 6.66 8.88 4.89 6.7 4C8.14 5.86 9 8.18 9 10.71C9 10.92 8.97 11.12 8.96 11.32C9.39 11.56 9.79 11.84 10.18 12.14C10.39 10.96 10.83 9.85 11.42 8.85Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGrid3x3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grid_3x3">
        <path
          id="Vector"
          d="M20 10V8H16V4H14V8H10V4H8V8H4V10H8V14H4V16H8V20H10V16H14V20H16V16H20V14H16V10H20ZM14 14H10V10H14V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGrid4x4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grid_4x4">
        <path
          id="Vector"
          d="M22 7V5H19V2H17V5H13V2H11V5H7V2H5V5H2V7H5V11H2V13H5V17H2V19H5V22H7V19H11V22H13V19H17V22H19V19H22V17H19V13H22V11H19V7H22ZM7 7H11V11H7V7ZM7 17V13H11V17H7ZM17 17H13V13H17V17ZM17 11H13V7H17V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGridGoldenratio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grid_goldenratio">
        <path
          id="Vector"
          d="M22 11V9H15V2H13V9H11V2H9V9H2V11H9V13H2V15H9V22H11V15H13V22H15V15H22V13H15V11H22ZM13 13H11V11H13V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGridOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grid_off" clipPath="url(#clip0_395_1818)">
        <path
          id="Vector"
          d="M8.56494 3.42494V4.31494L10.5649 6.31494V3.42494H14.5649V7.42494H11.6749L13.6749 9.42494H14.5649V10.3149L16.5649 12.3149V9.42494H20.5649V13.4249H17.6749L19.6749 15.4249H20.5649V16.3149L22.5649 18.3149V3.42494C22.5649 2.32494 21.6649 1.42494 20.5649 1.42494H5.67494L7.67494 3.42494H8.56494ZM16.5649 3.42494H20.5649V7.42494H16.5649V3.42494ZM1.97494 0.564941L0.564941 1.97494L2.56494 3.97494V19.4249C2.56494 20.5249 3.46494 21.4249 4.56494 21.4249H20.0149L22.0249 23.4349L23.4349 22.0249L1.97494 0.564941ZM10.5649 11.9749L12.0149 13.4249H10.5649V11.9749ZM4.56494 5.97494L6.01494 7.42494H4.56494V5.97494ZM8.56494 19.4249H4.56494V15.4249H8.56494V19.4249ZM8.56494 13.4249H4.56494V9.42494H8.01494L8.56494 9.97494V13.4249ZM14.5649 19.4249H10.5649V15.4249H14.0149L14.5649 15.9749V19.4249ZM16.5649 19.4249V17.9749L18.0149 19.4249H16.5649Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_1818">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconGridOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grid_on">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM8 20H4V16H8V20ZM8 14H4V10H8V14ZM8 8H4V4H8V8ZM14 20H10V16H14V20ZM14 14H10V10H14V14ZM14 8H10V4H14V8ZM20 20H16V16H20V20ZM20 14H16V10H20V14ZM20 8H16V4H20V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGridView(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grid_view">
        <path
          id="Vector"
          d="M3 3V11H11V3H3ZM9 9H5V5H9V9ZM3 13V21H11V13H3ZM9 19H5V15H9V19ZM13 3V11H21V3H13ZM19 9H15V5H19V9ZM13 13V21H21V13H13ZM19 19H15V15H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGroup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="group">
        <path
          id="Vector"
          d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGroupAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="group_add">
        <g id="Vector">
          <path d="M22 9V7H20V9H18V11H20V13H22V11H24V9H22Z" fill="currentColor" />
          <path
            d="M8 12C10.21 12 12 10.21 12 8C12 5.79 10.21 4 8 4C5.79 4 4 5.79 4 8C4 10.21 5.79 12 8 12ZM8 6C9.1 6 10 6.9 10 8C10 9.1 9.1 10 8 10C6.9 10 6 9.1 6 8C6 6.9 6.9 6 8 6Z"
            fill="currentColor"
          />
          <path
            d="M8 13C5.33 13 0 14.34 0 17V20H16V17C16 14.34 10.67 13 8 13ZM14 18H2V17.01C2.2 16.29 5.3 15 8 15C10.7 15 13.8 16.29 14 17V18Z"
            fill="currentColor"
          />
          <path
            d="M12.51 4.05C13.43 5.11 14 6.49 14 8C14 9.51 13.43 10.89 12.51 11.95C14.47 11.7 16 10.04 16 8C16 5.96 14.47 4.3 12.51 4.05Z"
            fill="currentColor"
          />
          <path
            d="M16.53 13.83C17.42 14.66 18 15.7 18 17V20H20V17C20 15.55 18.41 14.49 16.53 13.83Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconGroupOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="group_off">
        <path
          id="Vector"
          d="M15.1552 7.29502C15.1552 5.87502 14.6552 4.56502 13.8252 3.53502C14.2452 3.39502 14.6852 3.29502 15.1552 3.29502C17.3652 3.29502 19.1552 5.08502 19.1552 7.29502C19.1552 9.50502 17.3652 11.295 15.1552 11.295C15.0952 11.295 15.0352 11.295 14.9752 11.295L14.2052 10.525C14.8052 9.58502 15.1552 8.47502 15.1552 7.29502ZM22.9852 19.295H23.1552V16.295C23.1552 14.115 19.5752 12.825 16.8152 12.425C17.9152 13.175 18.7652 14.135 19.0452 15.365L22.9852 19.295ZM9.15522 5.29502C9.09521 5.29502 9.04522 5.29502 8.99522 5.30502L7.39521 3.70502C7.92521 3.44502 8.52522 3.29502 9.15522 3.29502C11.3652 3.29502 13.1552 5.08502 13.1552 7.29502C13.1552 7.92502 13.0052 8.52502 12.7452 9.05502L11.1452 7.45502C11.1552 7.40502 11.1552 7.35502 11.1552 7.29502C11.1552 6.19502 10.2552 5.29502 9.15522 5.29502ZM9.32522 11.295C9.26521 11.295 9.21522 11.295 9.15522 11.295C6.94522 11.295 5.15521 9.50502 5.15521 7.29502C5.15521 7.23502 5.15521 7.18502 5.15521 7.12502L0.845215 2.80502L2.25521 1.39502L22.0552 21.195L20.6452 22.605L17.1552 19.125V19.295H1.15521V16.295C1.15521 13.635 6.48522 12.295 9.15522 12.295C9.52522 12.295 9.95522 12.325 10.4052 12.375L9.32522 11.295ZM9.15522 14.295C6.45522 14.295 3.35521 15.585 3.15521 16.305V17.295H15.1552V17.125L13.0452 15.015C11.9152 14.605 10.4852 14.295 9.15522 14.295Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGroupRemove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="group_remove">
        <path
          id="Vector"
          d="M24 9V11H18V9H24ZM8 4C5.79 4 4 5.79 4 8C4 10.21 5.79 12 8 12C10.21 12 12 10.21 12 8C12 5.79 10.21 4 8 4ZM8 10C6.9 10 6 9.1 6 8C6 6.9 6.9 6 8 6C9.1 6 10 6.9 10 8C10 9.1 9.1 10 8 10ZM8 13C5.33 13 0 14.34 0 17V20H16V17C16 14.34 10.67 13 8 13ZM14 18H2V17.01C2.2 16.29 5.3 15 8 15C10.7 15 13.8 16.29 14 17V18ZM12.51 4.05C13.43 5.11 14 6.49 14 8C14 9.51 13.43 10.89 12.51 11.95C14.47 11.7 16 10.04 16 8C16 5.96 14.47 4.3 12.51 4.05ZM16.53 13.83C17.42 14.66 18 15.7 18 17V20H20V17C20 15.55 18.41 14.49 16.53 13.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGroupWork(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="group_work">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M8 16C9.10457 16 10 15.1046 10 14C10 12.8954 9.10457 12 8 12C6.89543 12 6 12.8954 6 14C6 15.1046 6.89543 16 8 16Z"
            fill="currentColor"
          />
          <path
            d="M12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z"
            fill="currentColor"
          />
          <path
            d="M16 16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12C14.8954 12 14 12.8954 14 14C14 15.1046 14.8954 16 16 16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconGroups(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="groups">
        <path
          id="Vector"
          d="M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGroups2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="groups_2">
        <g id="Vector">
          <path
            d="M10.27 12H13.73C14.66 12 15.36 11.17 15.21 10.25L14.91 8.46C14.67 7.04 13.44 6 12 6C10.56 6 9.33 7.04 9.09 8.47L8.79 10.26C8.64 11.17 9.34 12 10.27 12ZM11.06 8.79C11.14 8.33 11.53 8 12 8C12.47 8 12.86 8.33 12.94 8.79L13.14 10H10.86L11.06 8.79Z"
            fill="currentColor"
          />
          <path
            d="M1.66 11.11C1.53 11.37 1.48 11.68 1.56 11.99C1.72 12.68 2.32 13.02 3.09 12.99C3.09 12.99 4.58 12.99 5.04 12.99C5.87 12.99 6.55 12.41 6.55 11.7C6.55 11.56 6.52 11.43 6.48 11.3C6.47 11.27 6.47 11.25 6.49 11.22C6.58 11.06 6.63 10.88 6.63 10.69C6.63 10.38 6.49 10.09 6.27 9.87C6.24 9.84 6.24 9.81 6.25 9.77C6.32 9.57 6.32 9.34 6.26 9.12C6.1 8.69 5.71 8.4 5.27 8.38C5.24 8.38 5.22 8.37 5.2 8.35C5.03 8.14 4.72 8 4.37 8C4.07 8 3.8 8.1 3.62 8.26C3.59 8.29 3.56 8.29 3.53 8.28C3.39 8.22 3.23 8.19 3.07 8.19C2.42 8.19 1.89 8.68 1.83 9.31C1.83 9.33 1.82 9.35 1.8 9.37C1.51 9.63 1.34 10.02 1.39 10.42C1.42 10.64 1.51 10.85 1.64 11.02C1.67 11.04 1.67 11.08 1.66 11.11Z"
            fill="currentColor"
          />
          <path
            d="M16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.34 15.58 8.56 15.48C9.66 14.99 10.82 14.75 11.99 14.75C13.17 14.75 14.32 15 15.42 15.48C15.65 15.58 15.82 15.77 15.91 16H8.07Z"
            fill="currentColor"
          />
          <path
            d="M1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58Z"
            fill="currentColor"
          />
          <path
            d="M22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43C24 15.62 23.52 14.9 22.78 14.58Z"
            fill="currentColor"
          />
          <path
            d="M22 11V10.5C22 9.4 21.1 8.5 20 8.5H18C17.58 8.5 17.35 8.98 17.61 9.31L18.31 9.94C18.12 10.25 18 10.61 18 11C18 12.1 18.9 13 20 13C21.1 13 22 12.1 22 11Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconGroups3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="groups_3">
        <g id="Vector">
          <path
            d="M16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.34 15.58 8.56 15.48C9.66 14.99 10.82 14.75 11.99 14.75C13.17 14.75 14.32 15 15.42 15.48C15.65 15.58 15.82 15.77 15.91 16H8.07Z"
            fill="currentColor"
          />
          <path
            d="M1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58Z"
            fill="currentColor"
          />
          <path
            d="M22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43C24 15.62 23.52 14.9 22.78 14.58Z"
            fill="currentColor"
          />
          <path
            d="M12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8Z"
            fill="currentColor"
          />
          <path
            d="M3.9999 8.49687L1.49677 11L3.9999 13.5031L6.50303 11L3.9999 8.49687Z"
            fill="currentColor"
          />
          <path d="M20 9L17.5 13H22.5L20 9Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconHMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="h_mobiledata">
        <path id="Vector" d="M15 11H9V7H7V17H9V13H15V17H17V7H15V11Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconHPlusMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="h_plus_mobiledata">
        <path
          id="Vector"
          d="M11 11H5V7H3V17H5V13H11V17H13V7H11V11ZM21 11H19V9H17V11H15V13H17V15H19V13H21V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHail(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hail">
        <path
          id="Vector"
          d="M12.5 6C11.4 6 10.5 5.1 10.5 4C10.5 2.9 11.4 2 12.5 2C13.6 2 14.5 2.9 14.5 4C14.5 5.1 13.6 6 12.5 6ZM17.5 2H19.5C19.5 4.7 18.57 6.41 17.2 7.5C16.7 7.9 16.1 8.2 15.5 8.4V22H13.5V16H11.5V22H9.5V10.1C9.2 10.2 9 10.3 8.9 10.4C8.37 10.81 7.5 11.43 7.5 14H5.5C5.5 11.94 5.85 10.22 7.61 8.71C8.71 7.81 10.5 7 12.5 7C14.5 7 15.18 6.54 15.98 5.94C16.46 5.55 17.5 4.76 17.5 2ZM4.5 16H7.5V22H4.5V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHandshake(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="handshake">
        <path
          id="Vector"
          d="M12.222 19.855C12.042 20.035 11.722 20.065 11.512 19.855C11.332 19.675 11.302 19.355 11.512 19.145L14.902 15.755L13.492 14.345L10.102 17.735C9.91205 17.935 9.59204 17.925 9.39205 17.735C9.18204 17.525 9.21204 17.205 9.39205 17.025L12.782 13.635L11.372 12.225L7.98205 15.615C7.80205 15.795 7.48205 15.825 7.27205 15.615C7.08205 15.425 7.08205 15.105 7.27205 14.905L10.662 11.515L9.24204 10.105L5.85205 13.495C5.67205 13.675 5.35205 13.705 5.14205 13.495C4.95204 13.295 4.95204 12.985 5.14205 12.785L9.52205 8.405L11.392 10.265C12.342 11.215 13.982 11.205 14.932 10.265C15.912 9.28501 15.912 7.705 14.932 6.725L13.072 4.86501L13.352 4.585C14.132 3.805 15.402 3.805 16.182 4.585L20.422 8.825C21.202 9.605 21.202 10.875 20.422 11.655L12.222 19.855ZM21.832 13.075C23.392 11.515 23.392 8.985 21.832 7.415L17.592 3.175C16.032 1.615 13.502 1.615 11.932 3.175L11.652 3.455L11.372 3.175C9.81204 1.615 7.28205 1.615 5.71205 3.175L2.17205 6.715C0.752045 8.135 0.622045 10.345 1.77205 11.905L3.22205 10.455C2.83205 9.705 2.96205 8.755 3.59205 8.125L7.13205 4.585C7.91205 3.805 9.18204 3.805 9.96204 4.585L13.522 8.14501C13.702 8.32501 13.732 8.64501 13.522 8.85501C13.312 9.06501 12.992 9.03501 12.812 8.85501L9.52205 5.57501L3.72205 11.365C2.74205 12.335 2.74205 13.925 3.72205 14.905C4.11205 15.295 4.61205 15.535 5.14205 15.605C5.21205 16.125 5.44205 16.625 5.84205 17.025C6.24205 17.425 6.74205 17.655 7.26205 17.725C7.33205 18.245 7.56205 18.745 7.96205 19.145C8.36205 19.545 8.86204 19.775 9.38204 19.845C9.45204 20.385 9.69204 20.875 10.082 21.265C10.552 21.735 11.182 21.995 11.852 21.995C12.522 21.995 13.152 21.735 13.622 21.265L21.832 13.075Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHandyman(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="handyman">
        <g id="Vector">
          <path
            d="M21.6886 18.6688L16.3886 13.3688H15.3986L12.8586 15.9088V16.8988L18.1586 22.1988C18.5486 22.5888 19.1786 22.5888 19.5686 22.1988L21.6886 20.0788C22.0786 19.6988 22.0786 19.0588 21.6886 18.6688ZM18.8586 20.0888L14.6186 15.8488L15.3286 15.1388L19.5686 19.3788L18.8586 20.0888Z"
            fill="currentColor"
          />
          <path
            d="M17.3586 10.6888L18.7686 9.27878L20.8886 11.3988C22.0586 10.2288 22.0586 8.32878 20.8886 7.15878L17.3486 3.61878L15.9386 5.02878V2.20878L15.2386 1.49878L11.6986 5.03878L12.4086 5.74878H15.2386L13.8286 7.15878L14.8886 8.21878L11.9986 11.1088L7.86855 6.97878V5.55878L4.84855 2.53878L2.01855 5.36878L5.04855 8.39878H6.45855L10.5886 12.5288L9.73855 13.3788H7.61855L2.31855 18.6788C1.92855 19.0688 1.92855 19.6988 2.31855 20.0888L4.43855 22.2088C4.82855 22.5988 5.45855 22.5988 5.84855 22.2088L11.1486 16.9088V14.7888L16.2986 9.63878L17.3586 10.6888ZM9.37855 15.8388L5.13855 20.0788L4.42855 19.3688L8.66855 15.1288L9.37855 15.8388Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHardware(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hardware">
        <path
          id="Vector"
          d="M18 3L15 6V3H9C6.24 3 4 5.24 4 8H9V20C9 20.55 9.45 21 10 21H14C14.55 21 15 20.55 15 20V8L18 11H20V3H18ZM13 19H11V13H13V19ZM11 11V6H6.77C7.32 5.39 8.11 5 9 5H13V11H11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hd">
        <path
          id="Vector"
          d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7.5 13H9.5V15H11V9H9.5V11.5H7.5V9H6V15H7.5V13ZM18 14V10C18 9.45 17.55 9 17 9H13V15H17C17.55 15 18 14.55 18 14ZM16.5 13.5H14.5V10.5H16.5V13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrAuto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_auto">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11.01 6L6.88 17H8.78L9.78 14.19H14.22L15.21 17H17.11L12.98 6H11.01ZM10.35 12.59L11.95 8.04H12.04L13.64 12.59H10.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrAutoSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_auto_select">
        <g id="Vector">
          <path
            d="M10 16H6.5V22H10C10.8 22 11.5 21.3 11.5 20.5V17.5C11.5 16.7 10.8 16 10 16ZM10 20.5H8V17.5H10V20.5Z"
            fill="currentColor"
          />
          <path d="M3.5 18H1.5V16H0V22H1.5V19.5H3.5V22H5V16H3.5V18Z" fill="currentColor" />
          <path d="M22 18.5V16.5H20.5V18.5H18.5V20H20.5V22H22V20H24V18.5H22Z" fill="currentColor" />
          <path
            d="M16.5 16H13V22H14.5V20H15.6L16.5 22H18L17.1 19.9C17.6 19.6 18 19.1 18 18.5V17.5C18 16.7 17.3 16 16.5 16ZM16.5 18.5H14.5V17.5H16.5V18.5Z"
            fill="currentColor"
          />
          <path d="M11.97 5.3L10.95 8.19H13.05L12.03 5.3H11.97Z" fill="currentColor" />
          <path
            d="M12 2C8.69 2 6 4.69 6 8C6 11.31 8.69 14 12 14C15.31 14 18 11.31 18 8C18 4.69 15.31 2 12 2ZM14.04 11L13.41 9.21H10.58L9.96 11H8.74L11.37 4H12.62L15.25 11H14.04Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHdrEnhancedSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_enhanced_select">
        <path
          id="Vector"
          d="M12 2C15.31 2 18 4.69 18 8C18 11.31 15.31 14 12 14C8.69 14 6 11.31 6 8C6 4.69 8.69 2 12 2ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM13 11H11V9H9V7H11V5H13V7H15V9H13V11ZM24 20H22V22H20.5V20H18.5V18.5H20.5V16.5H22V18.5H24V20ZM18 18.5C18 19.1 17.6 19.6 17.1 19.9L18 22H16.5L15.6 20H14.5V22H13V16H16.5C17.3 16 18 16.7 18 17.5V18.5ZM16.5 18.5V17.5H14.5V18.5H16.5ZM3.5 18V16H5V22H3.5V19.5H1.5V22H0V16H1.5V18H3.5ZM10 16C10.8 16 11.5 16.7 11.5 17.5V20.5C11.5 21.3 10.8 22 10 22H6.5V16H10ZM10 20.5V17.5H8V20.5H10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_off">
        <path
          id="Vector"
          d="M17.9951 14.4549V12.4549H19.0951L19.9951 14.4549H21.4951L20.5951 12.3549C21.0951 12.0549 21.4951 11.5549 21.4951 10.9549V9.95495C21.4951 9.15495 20.7951 8.45495 19.9951 8.45495H16.4951V13.3149L17.6351 14.4549H17.9951ZM17.9951 9.95495H19.9951V10.9549H17.9951V9.95495ZM13.4951 9.95495V10.3149L14.9951 11.8149V9.95495C14.9951 9.15495 14.2951 8.45495 13.4951 8.45495H11.6351L13.1351 9.95495H13.4951ZM3.00507 1.94495L1.94507 3.00495L7.39507 8.45495H6.99507V10.4549H4.99507V8.45495H3.49507V14.4549H4.99507V11.9549H6.99507V14.4549H8.49507V9.55495L9.99507 11.0549V14.4549H13.3951L20.9951 22.0549L22.0551 20.9949L3.00507 1.94495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrOffSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_off_select">
        <path
          id="Vector"
          d="M18 18.5065V17.5065C18 16.7065 17.3 16.0065 16.5 16.0065H13V22.0065H14.5V20.0065H15.6L16.5 22.0065H18L17.1 19.9065C17.6 19.6065 18 19.1065 18 18.5065ZM16.5 18.5065H14.5V17.5065H16.5V18.5065ZM3.5 18.0065H1.5V16.0065H0V22.0065H1.5V19.5065H3.5V22.0065H5V16.0065H3.5V18.0065ZM10 16.0065H6.5V22.0065H10C10.8 22.0065 11.5 21.3065 11.5 20.5065V17.5065C11.5 16.7065 10.8 16.0065 10 16.0065ZM10 20.5065H8V17.5065H10V20.5065ZM24 20.0065H22V22.0065H20.5V20.0065H18.5V18.5065H20.5V16.5065H22V18.5065H24V20.0065ZM10.98 4.15654L9.42 2.59654C14.52 0.176541 19.83 5.48654 17.41 10.5865L15.85 9.02654C16.66 6.06654 13.94 3.34654 10.98 4.15654ZM6.34 2.34654L4.93 3.76654L6.59 5.42654C4.17 10.5265 9.48 15.8365 14.58 13.4165L16.24 15.0765L17.65 13.6665L6.34 2.34654ZM8.15 6.98654L13.02 11.8565C10.06 12.6665 7.34 9.94654 8.15 6.98654Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_on">
        <path
          id="Vector"
          d="M21 11.5V10.5C21 9.7 20.3 9 19.5 9H16V15H17.5V13H18.6L19.5 15H21L20.1 12.9C20.6 12.6 21 12.1 21 11.5ZM19.5 11.5H17.5V10.5H19.5V11.5ZM6.5 11H4.5V9H3V15H4.5V12.5H6.5V15H8V9H6.5V11ZM13 9H9.5V15H13C13.8 15 14.5 14.3 14.5 13.5V10.5C14.5 9.7 13.8 9 13 9ZM13 13.5H11V10.5H13V13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrOnSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_on_select">
        <path
          id="Vector"
          d="M18 18.5V17.5C18 16.7 17.3 16 16.5 16H13V22H14.5V20H15.6L16.5 22H18L17.1 19.9C17.6 19.6 18 19.1 18 18.5ZM16.5 18.5H14.5V17.5H16.5V18.5ZM3.5 18H1.5V16H0V22H1.5V19.5H3.5V22H5V16H3.5V18ZM10 16H6.5V22H10C10.8 22 11.5 21.3 11.5 20.5V17.5C11.5 16.7 10.8 16 10 16ZM10 20.5H8V17.5H10V20.5ZM24 20H22V22H20.5V20H18.5V18.5H20.5V16.5H22V18.5H24V20ZM12 4C14.21 4 16 5.79 16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8C8 5.79 9.79 4 12 4ZM12 2C8.69 2 6 4.69 6 8C6 11.31 8.69 14 12 14C15.31 14 18 11.31 18 8C18 4.69 15.31 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrPlus(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_plus">
        <path
          id="Vector"
          d="M8.13 19C9.28 19.64 10.6 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12C4 14.52 5.17 16.77 7 18.24V13H10.5C11.3 13 12 13.7 12 14.5V15.5C12 16.1 11.6 16.6 11.1 16.9L12 19H10.5L9.6 17H8.5V19H8.13ZM12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM17.5 16H16V17.5H14.5V16H13V14.5H14.5V13H16V14.49H17.5V16ZM10.5 15.5V14.5H8.5V15.5H10.5ZM10.5 8V6H12V12H10.5V9.5H8.5V12H7V6H8.5V8H10.5ZM16 6C16.8 6 17.5 6.7 17.5 7.5V10.5C17.5 11.3 16.8 12 16 12H13V6H16ZM16 10.5V7.5H14.5V10.5H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrStrong(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_strong">
        <path
          id="Vector"
          d="M17 6C13.69 6 11 8.69 11 12C11 15.31 13.69 18 17 18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM5 8C2.79 8 1 9.79 1 12C1 14.21 2.79 16 5 16C7.21 16 9 14.21 9 12C9 9.79 7.21 8 5 8ZM5 14C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10C6.1 10 7 10.9 7 12C7 13.1 6.1 14 5 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHdrWeak(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hdr_weak">
        <path
          id="Vector"
          d="M5 8C2.79 8 1 9.79 1 12C1 14.21 2.79 16 5 16C7.21 16 9 14.21 9 12C9 9.79 7.21 8 5 8ZM17 6C13.69 6 11 8.69 11 12C11 15.31 13.69 18 17 18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16C14.79 16 13 14.21 13 12C13 9.79 14.79 8 17 8C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHeadphones(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="headphones">
        <path
          id="Vector"
          d="M12 3C7.03 3 3 7.03 3 12V19C3 20.1 3.9 21 5 21H9V13H5V12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12V13H15V21H19C20.1 21 21 20.1 21 19V12C21 7.03 16.97 3 12 3ZM7 15V19H5V15H7ZM19 19H17V15H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHeadphonesBattery(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="headphones_battery">
        <g id="Vector">
          <path
            d="M21 7H20V6H18V7H17C16.45 7 16 7.45 16 8V17C16 17.55 16.45 18 17 18H21C21.55 18 22 17.55 22 17V8C22 7.45 21.55 7 21 7ZM20 16H18V9H20V16Z"
            fill="currentColor"
          />
          <path
            d="M8 6C4.69 6 2 8.69 2 12V16C2 17.1 2.9 18 4 18H6V13H3.5V12C3.5 9.52 5.52 7.5 8 7.5C10.48 7.5 12.5 9.52 12.5 12V13H10V18H12C13.1 18 14 17.1 14 16V12C14 8.69 11.31 6 8 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHeadsetMic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="headset_mic">
        <path
          id="Vector"
          d="M19 14V18H17V14H19ZM7 14V18H6C5.45 18 5 17.55 5 17V14H7ZM12 1C7.03 1 3 5.03 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H15V20H19V21H12V23H18C19.66 23 21 21.66 21 20V10C21 5.03 16.97 1 12 1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHeadsetOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="headset_off">
        <g id="Vector">
          <path
            d="M12.7099 3.345C16.5799 3.345 19.7099 6.475 19.7099 10.345V11.345H15.7099V11.515L17.5399 13.345H19.7099V15.515L21.7099 17.515V10.345C21.7099 5.375 17.6799 1.345 12.7099 1.345C10.6899 1.345 8.8299 2.015 7.3299 3.145L8.7599 4.575C9.8799 3.795 11.2399 3.345 12.7099 3.345Z"
            fill="currentColor"
          />
          <path
            d="M2.8099 1.445L1.3999 2.855L4.7299 6.185C4.0799 7.435 3.7099 8.845 3.7099 10.345V17.345C3.7099 18.445 4.6099 19.345 5.7099 19.345H9.7099V11.345H5.7099V10.345C5.7099 9.405 5.8999 8.515 6.2299 7.695L15.7099 17.175V19.345H17.8799L18.8799 20.345H12.7099V22.345H19.7099C20.0499 22.345 20.3599 22.255 20.6399 22.105L21.1899 22.655L22.5999 21.245L2.8099 1.445ZM7.7099 13.345V17.345H5.7099V13.345H7.7099Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHealing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="healing">
        <path
          id="Vector"
          d="M17.7449 12L21.7249 8.02004C22.1149 7.63004 22.1149 7.00004 21.7249 6.61004L17.3849 2.27004C16.9949 1.88004 16.3649 1.88004 15.9749 2.27004L11.9949 6.25004L8.01491 2.27004C7.81491 2.08004 7.56491 1.98004 7.30491 1.98004C7.05491 1.98004 6.79491 2.08004 6.60491 2.27004L2.26491 6.61004C1.87491 7.00004 1.87491 7.63004 2.26491 8.02004L6.24491 12L2.26491 15.98C1.87491 16.37 1.87491 17 2.26491 17.39L6.60491 21.73C6.99491 22.12 7.62491 22.12 8.01491 21.73L11.9949 17.75L15.9749 21.73C16.1749 21.93 16.4249 22.02 16.6849 22.02C16.9449 22.02 17.1949 21.92 17.3949 21.73L21.7349 17.39C22.1249 17 22.1249 16.37 21.7349 15.98L17.7449 12ZM12.0149 8.98004C12.5649 8.98004 13.0149 9.43004 13.0149 9.98004C13.0149 10.53 12.5649 10.98 12.0149 10.98C11.4649 10.98 11.0149 10.53 11.0149 9.98004C11.0149 9.43004 11.4649 8.98004 12.0149 8.98004ZM7.30491 10.94L3.67491 7.32004L7.30491 3.69004L10.9249 7.31004L7.30491 10.94ZM10.0149 12.98C9.46491 12.98 9.01491 12.53 9.01491 11.98C9.01491 11.43 9.46491 10.98 10.0149 10.98C10.5649 10.98 11.0149 11.43 11.0149 11.98C11.0149 12.53 10.5649 12.98 10.0149 12.98ZM12.0149 14.98C11.4649 14.98 11.0149 14.53 11.0149 13.98C11.0149 13.43 11.4649 12.98 12.0149 12.98C12.5649 12.98 13.0149 13.43 13.0149 13.98C13.0149 14.53 12.5649 14.98 12.0149 14.98ZM14.0149 10.98C14.5649 10.98 15.0149 11.43 15.0149 11.98C15.0149 12.53 14.5649 12.98 14.0149 12.98C13.4649 12.98 13.0149 12.53 13.0149 11.98C13.0149 11.43 13.4649 10.98 14.0149 10.98ZM16.6749 20.32L13.0449 16.7L16.6749 13.07L20.2949 16.69L16.6749 20.32Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHealthAndSafety(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="health_and_safety">
        <path
          id="Vector"
          d="M10.5 13H8V10H10.5V7.5H13.5V10H16V13H13.5V15.5H10.5V13ZM12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHearing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hearing">
        <path
          id="Vector"
          d="M17 20.39C16.71 20.39 16.44 20.33 16.24 20.24C15.53 19.87 15.03 19.36 14.53 17.86C14.02 16.3 13.06 15.57 12.14 14.86C11.35 14.25 10.53 13.62 9.82 12.33C9.29 11.37 9 10.32 9 9.38999C9 6.58998 11.2 4.38999 14 4.38999C16.8 4.38999 19 6.58998 19 9.38999H21C21 5.45999 17.93 2.38999 14 2.38999C10.07 2.38999 7 5.45999 7 9.38999C7 10.65 7.38 12.04 8.07 13.29C8.98 14.94 10.05 15.77 10.92 16.44C11.73 17.06 12.31 17.51 12.63 18.49C13.23 20.31 14 21.33 15.36 22.04C15.87 22.27 16.43 22.39 17 22.39C19.21 22.39 21 20.6 21 18.39H19C19 19.49 18.1 20.39 17 20.39ZM7.64 3.02999L6.22 1.60999C4.23 3.59999 3 6.34999 3 9.38999C3 12.43 4.23 15.18 6.22 17.17L7.63 15.76C6.01 14.13 5 11.88 5 9.38999C5 6.89999 6.01 4.64999 7.64 3.02999ZM11.5 9.38999C11.5 10.77 12.62 11.89 14 11.89C15.38 11.89 16.5 10.77 16.5 9.38999C16.5 8.00998 15.38 6.88999 14 6.88999C12.62 6.88999 11.5 8.00998 11.5 9.38999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHearingDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hearing_disabled">
        <path
          id="Vector"
          d="M6.7401 3.28499C7.8601 2.52499 9.2201 2.08499 10.7101 2.08499C14.6401 2.08499 17.7101 5.15499 17.7101 9.08499C17.7101 10.345 17.3301 11.735 16.6401 12.985C16.6201 13.025 16.5901 13.065 16.5601 13.115L15.0801 11.635C15.4801 10.775 15.7101 9.88499 15.7101 9.08499C15.7101 6.28499 13.5101 4.08499 10.7101 4.08499C9.7901 4.08499 8.9501 4.34499 8.2101 4.75499L6.7401 3.28499ZM17.9201 14.465L19.3501 15.895C20.8201 14.015 21.7101 11.655 21.7101 9.08499C21.7101 6.04499 20.4801 3.29499 18.4901 1.30499L17.0701 2.72499C18.7001 4.34499 19.7101 6.59499 19.7101 9.08499C19.7101 11.105 19.0401 12.965 17.9201 14.465ZM10.7101 6.58499C10.5001 6.58499 10.3101 6.61499 10.1201 6.66499L13.1301 9.67499C13.1801 9.48499 13.2101 9.29499 13.2101 9.08499C13.2101 7.70499 12.0901 6.58499 10.7101 6.58499ZM21.9001 21.275L3.5201 2.89499L2.1001 4.30499L4.2301 6.43499C3.9001 7.24499 3.7101 8.13499 3.7101 9.08499H5.7101C5.7101 8.72499 5.7601 8.37499 5.8301 8.03499L12.4401 14.645C11.5601 15.325 10.6601 16.055 10.1701 17.545C9.6701 19.045 9.1701 19.555 8.4601 19.925C8.2701 20.025 8.0001 20.085 7.7101 20.085C6.6101 20.085 5.7101 19.185 5.7101 18.085H3.7101C3.7101 20.295 5.5001 22.085 7.7101 22.085C8.2801 22.085 8.8401 21.965 9.3501 21.735C10.7101 21.025 11.4801 20.005 12.0801 18.185C12.4001 17.205 12.9801 16.755 13.7901 16.135C13.8201 16.115 13.8401 16.095 13.8701 16.075L20.4901 22.695L21.9001 21.275Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHeartBroken(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="heart_broken">
        <path
          id="Vector"
          d="M16.5 3C15.54 3 14.6 3.25 13.77 3.69L12 9H15L12 19L13 10H10L11.54 4.61C10.47 3.61 9.01 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.63 6.16 15.68 12 21C17.47 16.06 22 12.74 22 8.5C22 5.42 19.58 3 16.5 3ZM10.24 16.73C6.45 13.34 4 11 4 8.5C4 6.54 5.54 5 7.5 5C8.09 5 8.69 5.15 9.23 5.42L7.35 12H10.77L10.24 16.73ZM15.13 15.53L17.69 7H14.78L15.39 5.18C15.75 5.06 16.13 5 16.5 5C18.46 5 20 6.54 20 8.5C20 10.71 17.98 12.93 15.13 15.53Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHeatPump(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="heat_pump">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18ZM11.25 15.92C10.7 15.82 10.2 15.6 9.75 15.3L11.25 13.8V15.92ZM12.75 15.92V13.81L14.25 15.31C13.8 15.61 13.3 15.82 12.75 15.92ZM15.31 14.25L13.81 12.75H15.92C15.82 13.3 15.61 13.8 15.31 14.25ZM15.92 11.25H13.81L15.31 9.75C15.61 10.2 15.82 10.7 15.92 11.25ZM12.75 8.08C13.3 8.18 13.8 8.4 14.25 8.7L12.75 10.2V8.08ZM12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11ZM11.25 8.08V10.19L9.75 8.69C10.2 8.39 10.7 8.18 11.25 8.08ZM8.69 9.75L10.19 11.25H8.08C8.18 10.7 8.39 10.2 8.69 9.75ZM10.19 12.75L8.69 14.25C8.39 13.81 8.18 13.3 8.07 12.75H10.19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHeight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="height">
        <path
          id="Vector"
          d="M13 6.99H16L12 3L8 6.99H11V17.01H8L12 21L16 17.01H13V6.99Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHelp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="help">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHelpCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="help_center">
        <path
          id="Vector"
          d="M13.25 16.74C13.25 17.43 12.72 18 12 18C11.3 18 10.74 17.44 10.74 16.74C10.74 16.03 11.3 15.49 12 15.49C12.71 15.49 13.25 16.04 13.25 16.74ZM11.99 6C10.22 6 9.01 7.15 8.56 8.49L10.2 9.18C10.42 8.51 10.94 7.7 12 7.7C13.62 7.7 13.94 9.22 13.37 10.03C12.83 10.8 11.9 11.32 11.41 12.19C11.02 12.88 11.1 13.68 11.1 14.17H12.92C12.92 13.24 12.99 13.05 13.14 12.76C13.53 12.04 14.25 11.7 15.01 10.59C15.69 9.59 15.43 8.23 14.99 7.51C14.48 6.67 13.47 6 11.99 6ZM19 5H5V19H19V5ZM19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHelpOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="help_outline">
        <path
          id="Vector"
          d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHevc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hevc">
        <g id="Vector">
          <path d="M5.5 11H4.5V9H3V15H4.5V12.5H5.5V15H7V9H5.5V11Z" fill="currentColor" />
          <path
            d="M21 11V10C21 9.45 20.55 9 20 9H18C17.45 9 17 9.45 17 10V14C17 14.55 17.45 15 18 15H20C20.55 15 21 14.55 21 14V13H19.5V13.5H18.5V10.5H19.5V11H21Z"
            fill="currentColor"
          />
          <path d="M14.25 13.5L13.5 9H12L13 15H15.5L16.5 9H15L14.25 13.5Z" fill="currentColor" />
          <path d="M8 9V15H11.5V13.5H9.5V12.5H11.5V11H9.5V10.5H11.5V9H8Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconHexagon(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hexagon">
        <path
          id="Vector"
          d="M17.2001 3H6.8001L1.6001 12L6.8001 21H17.2001L22.4001 12L17.2001 3ZM16.0501 19H7.9501L3.9101 12L7.9501 5H16.0401L20.0801 12L16.0501 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHideImage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hide_image">
        <g id="Vector">
          <path
            d="M19.7101 4.28998V15.46L21.7101 17.46V4.28998C21.7101 3.18998 20.8101 2.28998 19.7101 2.28998H6.5401L8.5401 4.28998H19.7101Z"
            fill="currentColor"
          />
          <path
            d="M3.5201 2.09998L2.1001 3.50998L3.7101 5.11998V18.29C3.7101 19.39 4.6101 20.29 5.7101 20.29H18.8801L20.4901 21.9L21.9001 20.49L3.5201 2.09998ZM5.7101 18.29V7.11998L12.7801 14.19L11.9601 15.29L9.7101 12.29L6.7101 16.29H14.8801L16.8801 18.29H5.7101Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHideSource(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hide_source">
        <path
          id="Vector"
          d="M3.11495 2.50501L1.69495 3.91501L3.96495 6.18501C2.91495 7.76501 2.30495 9.65501 2.30495 11.695C2.30495 17.215 6.78495 21.695 12.3049 21.695C14.3449 21.695 16.2349 21.085 17.8149 20.035L20.0849 22.305L21.4949 20.895L3.11495 2.50501ZM12.3049 19.695C7.89495 19.695 4.30495 16.105 4.30495 11.695C4.30495 10.215 4.71495 8.83501 5.42495 7.63501L16.3649 18.575C15.1649 19.285 13.7849 19.695 12.3049 19.695ZM8.24495 4.81501L6.79495 3.35501C8.37495 2.30501 10.2649 1.69501 12.3049 1.69501C17.8249 1.69501 22.3049 6.17501 22.3049 11.695C22.3049 13.735 21.6949 15.625 20.6449 17.205L19.1849 15.745C19.8949 14.555 20.3049 13.175 20.3049 11.695C20.3049 7.28501 16.7149 3.69501 12.3049 3.69501C10.8249 3.69501 9.44495 4.10501 8.24495 4.81501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHighQuality(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="high_quality">
        <path
          id="Vector"
          d="M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18ZM7.5 13H9.5V15H11V9H9.5V11.5H7.5V9H6V15H7.5V13ZM14 15H14.75V16.5H16.25V15H17C17.55 15 18 14.55 18 14V10C18 9.45 17.55 9 17 9H14C13.45 9 13 9.45 13 10V14C13 14.55 13.45 15 14 15ZM14.5 10.5H16.5V13.5H14.5V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHighlight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="highlight">
        <path
          id="Vector"
          d="M6.00093 14L9.00093 17V22H15.0009V17L18.0009 14V9H6.00093V14ZM8.00093 11H16.0009V13.17L13.0009 16.17V20H11.0009V16.17L8.00093 13.17V11ZM11.0009 2H13.0009V5H11.0009V2ZM3.50293 5.874L4.91693 4.46L7.03893 6.58L5.62493 7.995L3.50293 5.874ZM16.9609 6.582L19.0839 4.462L20.4969 5.878L18.3739 7.998L16.9609 6.582Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHighlightAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="highlight_alt">
        <path
          id="Vector"
          d="M17 5H15V3H17V5ZM15 15V21L17.29 18.71L19.59 21L21 19.59L18.71 17.3L21 15H15ZM19 9H21V7H19V9ZM19 13H21V11H19V13ZM11 21H13V19H11V21ZM7 5H9V3H7V5ZM3 17H5V15H3V17ZM5 21V19H3C3 20.1 3.9 21 5 21ZM19 3V5H21C21 3.9 20.1 3 19 3ZM11 5H13V3H11V5ZM3 9H5V7H3V9ZM7 21H9V19H7V21ZM3 13H5V11H3V13ZM3 5H5V3C3.9 3 3 3.9 3 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHighlightOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="highlight_off">
        <path
          id="Vector"
          d="M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHiking(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hiking">
        <path
          id="Vector"
          d="M13.7498 5.25C14.8498 5.25 15.7498 4.35 15.7498 3.25C15.7498 2.15 14.8498 1.25 13.7498 1.25C12.6498 1.25 11.7498 2.15 11.7498 3.25C11.7498 4.35 12.6498 5.25 13.7498 5.25ZM17.7498 10.53C16.5198 10.16 15.5298 9.36 14.9498 8.35L13.9498 6.75C13.5398 6.1 12.8398 5.75 12.1098 5.75C11.3298 5.75 10.5198 6.25 10.3298 7.19C10.1398 8.13 7.2498 22.75 7.2498 22.75H9.3498L11.1498 14.75L13.2498 16.75V22.75H15.2498V15.25L13.1498 13.25L13.7498 10.25C14.7498 11.4 16.1598 12.26 17.7498 12.59V22.75H19.2498V8.75H17.7498V10.53ZM7.6798 12.88L5.5598 12.47C5.0198 12.36 4.6598 11.84 4.7698 11.3L5.5298 7.37C5.7398 6.29 6.7898 5.58 7.8698 5.79L9.0298 6.02L7.6798 12.88Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHistory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="history">
        <path
          id="Vector"
          d="M13.5 3C8.53 3 4.5 7.03 4.5 12H1.5L5.39 15.89L5.46 16.03L9.5 12H6.5C6.5 8.13 9.63 5 13.5 5C17.37 5 20.5 8.13 20.5 12C20.5 15.87 17.37 19 13.5 19C11.57 19 9.82 18.21 8.56 16.94L7.14 18.36C8.77 19.99 11.01 21 13.5 21C18.47 21 22.5 16.97 22.5 12C22.5 7.03 18.47 3 13.5 3ZM12.5 8V13L16.75 15.52L17.52 14.24L14 12.15V8H12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHistoryEdu(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="history_edu">
        <path
          id="Vector"
          d="M9.78021 4V5.38C8.95021 5.05 8.06021 4.88 7.17021 4.88C5.38021 4.88 3.59021 5.56 2.22021 6.93L5.55021 10.26H6.66021V11.37C7.52022 12.23 8.64021 12.68 9.77021 12.73V15H6.78021V18C6.78021 19.1 7.68021 20 8.78021 20H18.7802C20.4402 20 21.7802 18.66 21.7802 17V4H9.78021ZM8.67021 10.41V8.26H6.39021L5.35021 7.22C5.92021 7 6.54021 6.88 7.17021 6.88C8.51021 6.88 9.76021 7.4 10.7102 8.34L12.1202 9.75L11.9202 9.95C11.4102 10.46 10.7302 10.75 10.0002 10.75C9.53022 10.75 9.07021 10.63 8.67021 10.41ZM19.7802 17C19.7802 17.55 19.3302 18 18.7802 18C18.2302 18 17.7802 17.55 17.7802 17V15H11.7802V12.41C12.3502 12.18 12.8802 11.84 13.3402 11.38L13.5402 11.18L16.3702 14H17.7802V12.59L11.7802 6.62V6H19.7802V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHistoryToggleOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="history_toggle_off">
        <path
          id="Vector"
          d="M15.1 19.37L16.1 21.11C15.14 21.55 14.09 21.84 13 21.95V19.93C13.74 19.84 14.44 19.65 15.1 19.37ZM4.07005 13H2.05005C2.16005 14.1 2.45005 15.14 2.89005 16.1L4.63005 15.1C4.35005 14.44 4.16005 13.74 4.07005 13ZM15.1 4.62999L16.1 2.88999C15.14 2.44999 14.1 2.15999 13 2.04999V4.06999C13.74 4.15999 14.44 4.34999 15.1 4.62999ZM19.93 11H21.9501C21.84 9.89999 21.5501 8.85999 21.1101 7.89999L19.3701 8.89999C19.6501 9.55999 19.84 10.26 19.93 11ZM8.90005 19.37L7.90005 21.11C8.86005 21.55 9.91005 21.84 11 21.95V19.93C10.26 19.84 9.56005 19.65 8.90005 19.37ZM11 4.06999V2.04999C9.90005 2.15999 8.86005 2.44999 7.90005 2.88999L8.90005 4.62999C9.56005 4.34999 10.26 4.15999 11 4.06999ZM18.3601 7.16999L20.1 6.15999C19.4701 5.28999 18.7 4.51999 17.83 3.88999L16.82 5.62999C17.41 6.07999 17.9201 6.58999 18.3601 7.16999ZM4.63005 8.89999L2.89005 7.89999C2.45005 8.85999 2.16005 9.89999 2.05005 11H4.07005C4.16005 10.26 4.35005 9.55999 4.63005 8.89999ZM19.93 13C19.84 13.74 19.6501 14.44 19.3701 15.1L21.1101 16.1C21.5501 15.14 21.84 14.09 21.9501 13H19.93ZM16.83 18.36L17.84 20.1C18.71 19.47 19.4801 18.7 20.1101 17.83L18.3701 16.82C17.9201 17.41 17.41 17.92 16.83 18.36ZM7.17005 5.63999L6.17005 3.88999C5.29005 4.52999 4.53005 5.28999 3.90005 6.16999L5.64005 7.17999C6.08005 6.58999 6.59005 6.07999 7.17005 5.63999ZM5.64005 16.83L3.90005 17.83C4.53005 18.7 5.30005 19.47 6.17005 20.1L7.18005 18.36C6.59005 17.92 6.08005 17.41 5.64005 16.83ZM13 6.99999H11V12.41L15.29 16.7L16.7 15.29L13 11.59V6.99999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hive">
        <path
          id="Vector"
          d="M21.5 9L19.25 5H15.94L14.25 2H9.75L8.06 5H4.75L2.5 9L4.19 12L2.5 15L4.75 19H8.06L9.75 22H14.25L15.94 19H19.25L21.5 15L19.81 12L21.5 9ZM19.21 9L18.09 11H15.95L14.83 9L15.95 7H18.09L19.21 9ZM10.94 14L9.82 12L10.94 10H13.06L14.18 12L13.06 14H10.94ZM13.08 4L14.2 5.98L13.06 8H10.94L9.8 5.98L10.92 4H13.08ZM5.92 7H8.06L9.18 9L8.06 11H5.92L4.79 9L5.92 7ZM4.79 15L5.91 13H8.05L9.17 15L8.05 17H5.92L4.79 15ZM10.92 20L9.8 18.02L10.94 16H13.06L14.19 18.02L13.08 20H10.92ZM18.08 17H15.94L14.82 15L15.94 13H18.08L19.2 15L18.08 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHls(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hls">
        <path
          id="Vector"
          d="M6.75 9H8.25V15H6.75V12.5H4.75V15H3.25V9H4.75V11H6.75V9ZM16.75 15H19.75C20.3 15 20.75 14.55 20.75 14V12.5C20.75 11.95 20.3 11.5 19.75 11.5H17.25V10.5H19.25V11H20.75V10C20.75 9.45 20.3 9 19.75 9H16.75C16.2 9 15.75 9.45 15.75 10V11.5C15.75 12.05 16.2 12.5 16.75 12.5H19.25V13.5H17.25V13H15.75V14C15.75 14.55 16.2 15 16.75 15ZM14.25 15V13.5H11.75V9H10.25V15H14.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHlsOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hls_off">
        <path
          id="Vector"
          d="M18.545 14.295H20.215C20.765 14.295 21.215 13.845 21.215 13.295V11.795C21.215 11.245 20.765 10.795 20.215 10.795H17.715V9.79498H19.715V10.295H21.215V9.29498C21.215 8.74498 20.765 8.29498 20.215 8.29498H17.215C16.665 8.29498 16.215 8.74498 16.215 9.29498V10.795C16.215 11.345 16.665 11.795 17.215 11.795H19.715V12.795H17.715V12.295H16.545L18.545 14.295ZM8.71498 10.125V14.295H7.21498V11.795H5.21498V14.295H3.71498V8.29498H5.21498V10.295H7.21498V8.62498L2.10498 3.51498L3.51498 2.10498L21.895 20.485L20.485 21.895L12.885 14.295H10.715V12.125L8.71498 10.125Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHolidayVillage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="holiday_village">
        <path
          id="Vector"
          d="M8 4L2 10V20H14V10L8 4ZM12 18H9V15H7V18H4V10.83L8 6.83L12 10.83V18ZM9 13H7V11H9V13ZM18 20V8.35L13.65 4H10.82L16 9.18V20H18ZM22 20V6.69L19.31 4H16.48L20 7.52V20H22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHome(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="home">
        <path
          id="Vector"
          d="M12 6.19L17 10.69V18.5H15V12.5H9V18.5H7V10.69L12 6.19ZM12 3.5L2 12.5H5V20.5H11V14.5H13V20.5H19V12.5H22L12 3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHomeMax(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="home_max">
        <path
          id="Vector"
          d="M19 5H5C2.79 5 1 6.79 1 9V14C1 16.21 2.79 18 5 18H7V19H17V18H19C21.21 18 23 16.21 23 14V9C23 6.79 21.21 5 19 5ZM21 14C21 15.1 20.1 16 19 16H5C3.9 16 3 15.1 3 14V9C3 7.9 3.9 7 5 7H19C20.1 7 21 7.9 21 9V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHomeMini(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="home_mini">
        <path
          id="Vector"
          d="M12 5C4.19 5 2 9.48 2 12C2 15.86 5.13 19 8.99 19H15.01C17.7 19 22 16.92 22 12C22 12 22 5 12 5ZM12 7C19.64 7 19.99 11.51 20 12H4C4 11.8 4.09 7 12 7ZM14.86 17H9.14C7.04 17 5.22 15.76 4.43 14H19.58C18.78 15.76 16.96 17 14.86 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHomeRepairService(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="home_repair_service">
        <path
          id="Vector"
          d="M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V20H22V10C22 8.9 21.1 8 20 8ZM9 6H15V8H9V6ZM20 18H4V15H6V16H8V15H16V16H18V15H20V18ZM18 13V12H16V13H8V12H6V13H4V10H20V13H18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHomeWork(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="home_work">
        <g id="Vector">
          <path
            d="M1 11V21H7V16H9V21H15V11L8 6L1 11ZM13 19H11V14H5V19H3V12.03L8 8.46L13 12.03V19Z"
            fill="currentColor"
          />
          <path d="M19 7H17V9H19V7Z" fill="currentColor" />
          <path d="M19 11H17V13H19V11Z" fill="currentColor" />
          <path d="M19 15H17V17H19V15Z" fill="currentColor" />
          <path d="M10 3V4.97L12 6.4V5H21V19H17V21H23V3H10Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconHorizontalDistribute(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="horizontal_distribute">
        <path
          id="Vector"
          d="M4 22H2V2H4V22ZM22 2H20V22H22V2ZM13.5 7H10.5V17H13.5V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHorizontalRule(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="horizontal_rule">
        <path id="Vector" d="M20 11H4V13H20V11Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconHorizontalSplit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="horizontal_split">
        <path
          id="Vector"
          d="M19 15V17H5V15H19ZM21 5H3V7H21V5ZM21 9H3V11H21V9ZM21 13H3V19H21V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHotTub(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hot_tub">
        <g id="Vector">
          <path
            d="M7 7.5C8.10457 7.5 9 6.60457 9 5.5C9 4.39543 8.10457 3.5 7 3.5C5.89543 3.5 5 4.39543 5 5.5C5 6.60457 5.89543 7.5 7 7.5Z"
            fill="currentColor"
          />
          <path
            d="M11.15 11.5C10.84 11.28 10.56 11.04 10.33 10.78L8.93 9.23C8.74 9.02 8.5 8.85 8.24 8.73C7.95 8.59 7.62 8.5 7.28 8.5H7.25C6.01 8.5 5 9.51 5 10.75V11.5H2V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5V11.5H11.15ZM7 19.5H5V13.5H7V19.5ZM11 19.5H9V13.5H11V19.5ZM15 19.5H13V13.5H15V19.5ZM19 19.5H17V13.5H19V19.5ZM17.42 6.71C17.99 7.33 18.24 8.12 18.09 8.91L17.98 9.5H19.89L19.95 9.07C20.16 7.71 19.68 6.36 18.65 5.36L18.58 5.29C18.01 4.67 17.76 3.88 17.91 3.09L18 2.5H16.11L16.05 2.93C15.85 4.29 16.32 5.64 17.35 6.65L17.42 6.71ZM13.42 6.71C13.99 7.33 14.24 8.12 14.09 8.91L13.98 9.5H15.89L15.95 9.07C16.16 7.71 15.68 6.36 14.65 5.36L14.58 5.29C14.01 4.67 13.76 3.88 13.91 3.09L14 2.5H12.11L12.05 2.93C11.85 4.29 12.32 5.64 13.35 6.65L13.42 6.71Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHotel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hotel">
        <path
          id="Vector"
          d="M7 13.5C8.66 13.5 10 12.16 10 10.5C10 8.84 8.66 7.5 7 7.5C5.34 7.5 4 8.84 4 10.5C4 12.16 5.34 13.5 7 13.5ZM7 9.5C7.55 9.5 8 9.95 8 10.5C8 11.05 7.55 11.5 7 11.5C6.45 11.5 6 11.05 6 10.5C6 9.95 6.45 9.5 7 9.5ZM19 6.5H11V14.5H3V4.5H1V19.5H3V16.5H21V19.5H23V10.5C23 8.29 21.21 6.5 19 6.5ZM21 14.5H13V8.5H19C20.1 8.5 21 9.4 21 10.5V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHotelClass(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hotel_class">
        <path
          id="Vector"
          d="M10.66 8.89L11.6 12H14.42L12.15 13.62L13.08 16.63L10.66 14.79L8.24003 16.63L9.17003 13.62L6.90003 12H9.72003L10.66 8.89ZM8.24003 10H0.660034L6.83003 14.41L4.49003 22L10.66 17.31L16.84 22L14.49 14.41L20.66 10H13.08L10.66 2L8.24003 10ZM21.02 22L19.16 15.99L23.34 13H19.9L16.82 15.2L18.28 19.92L21.02 22ZM16.66 8L14.84 2L13.8 5.45L14.57 8H16.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHourglassBottom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hourglass_bottom">
        <path
          id="Vector"
          d="M18 22L17.99 16L14 12L17.99 7.99L18 2H6V8L10 12L6 15.99V22H18ZM8 7.5V4H16V7.5L12 11.5L8 7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHourglassDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hourglass_disabled">
        <g id="Vector">
          <path
            d="M8.70502 3.34003H16.705V6.84003L13.865 9.68003L15.115 10.93L18.705 7.35003L18.695 7.34003H18.705V1.34003H6.70502V2.51003L8.70502 4.51003V3.34003Z"
            fill="currentColor"
          />
          <path
            d="M2.80502 1.44003L1.39502 2.85003L10.295 11.75L6.70502 15.34L6.71502 15.35H6.70502V21.34H18.705V20.17L21.195 22.66L22.605 21.25L2.80502 1.44003ZM16.705 19.34H8.70502V15.84L11.545 13L16.705 18.17V19.34Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHourglassEmpty(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hourglass_empty">
        <path
          id="Vector"
          d="M6 2V8H6.01L6 8.01L10 12L6 16L6.01 16.01H6V22H18V16.01H17.99L18 16L14 12L18 8.01L17.99 8H18V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5ZM12 11.5L8 7.5V4H16V7.5L12 11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHourglassFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hourglass_full">
        <path
          id="Vector"
          d="M6 2V8H6.01L6 8.01L10 12L6 16L6.01 16.01H6V22H18V16.01H17.99L18 16L14 12L18 8.01L17.99 8H18V2H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHourglassTop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hourglass_top">
        <path
          id="Vector"
          d="M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHouse(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="house">
        <g id="Vector">
          <path
            d="M19 9.8V4.5H16V7.1L12 3.5L2 12.5H5V20.5H11V14.5H13V20.5H19V12.5H22L19 9.8ZM17 18.5H15V12.5H9V18.5H7V10.69L12 6.19L17 10.69V18.5Z"
            fill="currentColor"
          />
          <path
            d="M10 10.5H14C14 9.4 13.1 8.5 12 8.5C10.9 8.5 10 9.4 10 10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconHouseSiding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="house_siding">
        <path
          id="Vector"
          d="M19 12.5H22L12 3.5L2 12.5H5V20.5H7V18.5H17V20.5H19V12.5ZM7.21 10.5H16.79L17 10.69V12.5H7V10.69L7.21 10.5ZM14.57 8.5H9.43L12 6.19L14.57 8.5ZM7 16.5V14.5H17V16.5H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHouseboat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="houseboat">
        <path
          id="Vector"
          d="M12 16.75C10.05 16.75 9.9 17.75 8.66 17.75C7.47 17.75 7.24 16.75 5.33 16.75C3.38 16.75 3.24 17.75 2 17.75V19.75C3.9 19.75 4.17 18.75 5.35 18.75C6.54 18.75 6.77 19.75 8.68 19.75C10.63 19.75 10.76 18.75 12 18.75C13.24 18.75 13.37 19.75 15.32 19.75C17.23 19.75 17.46 18.75 18.65 18.75C19.83 18.75 20.1 19.75 22 19.75V17.75C20.76 17.75 20.62 16.75 18.67 16.75C16.76 16.75 16.53 17.75 15.34 17.75C14.1 17.75 13.95 16.75 12 16.75ZM20.34 12.09L18.97 13.46C18.78 13.64 18.52 13.75 18.26 13.75H17V10.4L18.32 11.37L19.5 9.75L12 4.25L4.5 9.75L5.68 11.36L7 10.4V13.75H5.74C5.47 13.75 5.22 13.64 5.03 13.46L3.66 12.09L2.25 13.5L3.62 14.87C4.18 15.43 4.95 15.75 5.74 15.75H18.25C19.05 15.75 19.81 15.43 20.37 14.87L21.74 13.5L20.34 12.09ZM13 13.75V11.75H11V13.75H9V8.93L12 6.73L15 8.93V13.75H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHowToReg(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="how_to_reg">
        <path
          id="Vector"
          d="M10.5 11.75C12.71 11.75 14.5 9.96 14.5 7.75C14.5 5.54 12.71 3.75 10.5 3.75C8.29 3.75 6.5 5.54 6.5 7.75C6.5 9.96 8.29 11.75 10.5 11.75ZM10.5 5.75C11.6 5.75 12.5 6.65 12.5 7.75C12.5 8.85 11.6 9.75 10.5 9.75C9.4 9.75 8.5 8.85 8.5 7.75C8.5 6.65 9.4 5.75 10.5 5.75ZM4.5 17.75C4.7 17.12 7.07 16.07 9.46 15.81L11.5 13.81C11.11 13.77 10.82 13.75 10.5 13.75C7.83 13.75 2.5 15.09 2.5 17.75V19.75H11.5L9.5 17.75H4.5ZM20.1 12.25L14.97 17.42L12.9 15.34L11.5 16.75L14.97 20.25L21.5 13.66L20.1 12.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHowToVote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="how_to_vote">
        <path
          id="Vector"
          d="M18 13.0007H17.32L15.32 15.0007H17.23L19 17.0007H5L6.78 15.0007H8.83L6.83 13.0007H6L3 16.0007V20.0007C3 21.1007 3.89 22.0007 4.99 22.0007H19C20.1 22.0007 21 21.1107 21 20.0007V16.0007L18 13.0007ZM19 20.0007H5V19.0007H19V20.0007ZM11.34 15.0207C11.73 15.4107 12.36 15.4107 12.75 15.0207L19.11 8.66065C19.5 8.27065 19.5 7.64065 19.11 7.25065L14.16 2.30065C13.78 1.90065 13.15 1.90065 12.76 2.29065L6.39 8.66065C6 9.05065 6 9.68065 6.39 10.0707L11.34 15.0207ZM13.46 4.41065L17 7.95065L12.05 12.9007L8.51 9.36065L13.46 4.41065Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHtml(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="html">
        <path
          id="Vector"
          d="M3.5 9H5V15H3.5V12.5H1.5V15H0V9H1.5V11H3.5V9ZM17.5 9H13C12.45 9 12 9.45 12 10V15H13.5V10.5H14.5V14H16V10.49H17V15H18.5V10C18.5 9.45 18.05 9 17.5 9ZM11 9H6V10.5H7.75V15H9.25V10.5H11V9ZM24 15V13.5H21.5V9H20V15H24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHttp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="http">
        <path
          id="Vector"
          d="M4.5 11H2.5V9H1V15H2.5V12.5H4.5V15H6V9H4.5V11ZM7 10.5H8.5V15H10V10.5H11.5V9H7V10.5ZM12.5 10.5H14V15H15.5V10.5H17V9H12.5V10.5ZM21.5 9H18V15H19.5V13H21.5C22.3 13 23 12.3 23 11.5V10.5C23 9.7 22.3 9 21.5 9ZM21.5 11.5H19.5V10.5H21.5V11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHttps(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="https">
        <path
          id="Vector"
          d="M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM9 6.5C9 4.84 10.34 3.5 12 3.5C13.66 3.5 15 4.84 15 6.5V8.5H9V6.5ZM18 20.5H6V10.5H18V20.5ZM12 17.5C13.1 17.5 14 16.6 14 15.5C14 14.4 13.1 13.5 12 13.5C10.9 13.5 10 14.4 10 15.5C10 16.6 10.9 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconHub(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hub" clipPath="url(#clip0_395_3220)">
        <path
          id="Vector"
          d="M21 7C19.34 7 18 8.34 18 10C18 10.07 18 10.14 18.01 10.21L15.98 10.89C15.34 9.68 14.16 8.8 12.76 8.57V6.41C14.04 6.07 15 4.9 15 3.5C15 1.84 13.66 0.5 12 0.5C10.34 0.5 9 1.84 9 3.5C9 4.9 9.96 6.07 11.25 6.41V8.57C9.85 8.8 8.67 9.68 8.03 10.89L5.99 10.21C6 10.14 6 10.07 6 10C6 8.34 4.66 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C4.06 13 4.98 12.45 5.52 11.63L7.55 12.31C7.35 13.6 7.72 14.97 8.64 16L7.23 17.77C6.85 17.59 6.44 17.5 6 17.5C4.34 17.5 3 18.84 3 20.5C3 22.16 4.34 23.5 6 23.5C7.66 23.5 9 22.16 9 20.5C9 19.82 8.78 19.2 8.4 18.7L9.81 16.93C11.17 17.69 12.83 17.68 14.18 16.93L15.59 18.7C15.22 19.2 15 19.82 15 20.5C15 22.16 16.34 23.5 18 23.5C19.66 23.5 21 22.16 21 20.5C21 18.84 19.66 17.5 18 17.5C17.56 17.5 17.15 17.59 16.77 17.76L15.36 15.99C16.29 14.95 16.65 13.59 16.45 12.3L18.48 11.62C19.01 12.44 19.94 12.99 21 12.99C22.66 12.99 24 11.65 24 9.99C24 8.33 22.66 7 21 7ZM3 11C2.45 11 2 10.55 2 10C2 9.45 2.45 9 3 9C3.55 9 4 9.45 4 10C4 10.55 3.55 11 3 11ZM6 21.5C5.45 21.5 5 21.05 5 20.5C5 19.95 5.45 19.5 6 19.5C6.55 19.5 7 19.95 7 20.5C7 21.05 6.55 21.5 6 21.5ZM11 3.5C11 2.95 11.45 2.5 12 2.5C12.55 2.5 13 2.95 13 3.5C13 4.05 12.55 4.5 12 4.5C11.45 4.5 11 4.05 11 3.5ZM12 15.5C10.62 15.5 9.5 14.38 9.5 13C9.5 11.62 10.62 10.5 12 10.5C13.38 10.5 14.5 11.62 14.5 13C14.5 14.38 13.38 15.5 12 15.5ZM18 19.5C18.55 19.5 19 19.95 19 20.5C19 21.05 18.55 21.5 18 21.5C17.45 21.5 17 21.05 17 20.5C17 19.95 17.45 19.5 18 19.5ZM21 11C20.45 11 20 10.55 20 10C20 9.45 20.45 9 21 9C21.55 9 22 9.45 22 10C22 10.55 21.55 11 21 11Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_3220">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconHvac(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="hvac">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
          <path
            d="M12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18ZM15.44 10C15.7 10.45 15.88 10.96 15.95 11.5H8.05C8.12 10.96 8.29 10.45 8.56 10H15.44ZM15.95 12.5C15.88 13.04 15.71 13.55 15.44 14H8.56C8.3 13.55 8.12 13.04 8.05 12.5H15.95ZM9.38 15H14.62C13.92 15.61 13.01 16 12 16C10.99 16 10.09 15.61 9.38 15ZM14.62 9H9.38C10.08 8.39 10.99 8 12 8C13.01 8 13.91 8.39 14.62 9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconIceSkating(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ice_skating">
        <path
          id="Vector"
          d="M20.5 16.5C20.5 18.16 19.16 19.5 17.5 19.5H15.5V17.5H18.5V13.5C18.5 11.71 17.31 10.16 15.59 9.68L12.97 8.94C12.12 8.69 11.5 7.89 11.5 7V2.5H2.5V17.5H5.5V19.5H1.5V21.5H17.5C20.26 21.5 22.5 19.26 22.5 16.5H20.5ZM4.5 15.5V4.5H9.5V5.5H8C7.72 5.5 7.5 5.72 7.5 6C7.5 6.28 7.72 6.5 8 6.5H9.5L9.6 7.5H8C7.72 7.5 7.5 7.72 7.5 8C7.5 8.28 7.72 8.5 8 8.5H9.81C10.26 9.62 11.21 10.51 12.41 10.86L15.03 11.59C15.9 11.83 16.5 12.6 16.5 13.5V15.5H4.5ZM13.5 19.5H7.5V17.5H13.5V19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconIcecream(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icecream">
        <path
          id="Vector"
          d="M18.38 6.24C17.79 3.24 15.14 1 12 1C8.86 1 6.21 3.24 5.62 6.24C4.08 6.81 3 8.29 3 10C3 12.21 4.79 14 7 14C7.12 14 7.23 13.98 7.34 13.98L12.07 23L16.68 13.97C16.79 13.98 16.89 14 17 14C19.21 14 21 12.21 21 10C21 8.29 19.92 6.81 18.38 6.24ZM12.05 18.63L9.32 13.42C10.15 13.79 11.06 14 12 14C12.95 14 13.88 13.79 14.72 13.4L12.05 18.63ZM17 12C16.48 12 15.99 11.8 15.61 11.44L15.05 10.9L14.39 11.32C13.68 11.76 12.86 12 12 12C11.14 12 10.32 11.76 9.61 11.31L8.95 10.9L8.39 11.44C8.01 11.79 7.52 12 7 12C5.9 12 5 11.11 5 10C5 9.02 5.72 8.18 6.68 8.03L7.45 7.9L7.51 7.12C7.71 4.8 9.66 3 12 3C14.34 3 16.29 4.8 16.48 7.12L16.54 7.9L17.31 8.02C18.28 8.18 19 9.01 19 10C19 11.1 18.1 12 17 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="image">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImageAspectRatio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="image_aspect_ratio">
        <path
          id="Vector"
          d="M16 10H14V12H16V10ZM16 14H14V16H16V14ZM8 10H6V12H8V10ZM12 10H10V12H12V10ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImageSearch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="image_search">
        <path
          id="Vector"
          d="M17.79 13V20H3.79004V6H8.81004C8.86004 5.29 9.03004 4.62 9.29004 4H3.79004C2.69004 4 1.79004 4.9 1.79004 6V20C1.79004 21.1 2.69004 22 3.79004 22H17.79C18.89 22 19.79 21.1 19.79 20V15L17.79 13ZM16.29 18H5.29004L8.04004 14.47L10 16.83L12.75 13.29L16.29 18ZM19.09 8.89C19.53 8.19 19.79 7.38 19.79 6.5C19.79 4.01 17.78 2 15.29 2C12.8 2 10.79 4.01 10.79 6.5C10.79 8.99 12.8 11 15.28 11C16.16 11 16.98 10.74 17.67 10.3L20.79 13.42L22.21 12L19.09 8.89ZM15.29 9C13.91 9 12.79 7.88 12.79 6.5C12.79 5.12 13.91 4 15.29 4C16.67 4 17.79 5.12 17.79 6.5C17.79 7.88 16.67 9 15.29 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImagesearchRoller(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="imagesearch_roller">
        <path
          id="Vector"
          d="M21 6.5V2.5C21 1.95 20.55 1.5 20 1.5H8C7.45 1.5 7 1.95 7 2.5V3.5H5C3.9 3.5 3 4.4 3 5.5V9.5C3 10.6 3.9 11.5 5 11.5H13V14.5H12C11.45 14.5 11 14.95 11 15.5V21.5C11 22.05 11.45 22.5 12 22.5H16C16.55 22.5 17 22.05 17 21.5V15.5C17 14.95 16.55 14.5 16 14.5H15V11.5C15 10.4 14.1 9.5 13 9.5H5V5.5H7V6.5C7 7.05 7.45 7.5 8 7.5H20C20.55 7.5 21 7.05 21 6.5ZM9 3.5H19V5.5H9V3.5ZM15 20.5H13V16.5H15V20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImportContacts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="import_contacts">
        <path
          id="Vector"
          d="M21 4C19.89 3.65 18.67 3.5 17.5 3.5C15.55 3.5 13.45 3.9 12 5C10.55 3.9 8.45 3.5 6.5 3.5C4.55 3.5 2.45 3.9 1 5V19.65C1 19.9 1.25 20.15 1.5 20.15C1.6 20.15 1.65 20.1 1.75 20.1C3.1 19.45 5.05 19 6.5 19C8.45 19 10.55 19.4 12 20.5C13.35 19.65 15.8 19 17.5 19C19.15 19 20.85 19.3 22.25 20.05C22.35 20.1 22.4 20.1 22.5 20.1C22.75 20.1 23 19.85 23 19.6V5C22.4 4.55 21.75 4.25 21 4ZM21 17.5C19.9 17.15 18.7 17 17.5 17C15.8 17 13.35 17.65 12 18.5V7C13.35 6.15 15.8 5.5 17.5 5.5C18.7 5.5 19.9 5.65 21 6V17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImportExport(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="import_export">
        <path
          id="Vector"
          d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconImportantDevices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="important_devices">
        <path
          id="Vector"
          d="M23 11.01L18 11C17.45 11 17 11.45 17 12V21C17 21.55 17.45 22 18 22H23C23.55 22 24 21.55 24 21V12C24 11.45 23.55 11.01 23 11.01ZM23 20H18V13H23V20ZM20 2H2C0.89 2 0 2.89 0 4V16C0 17.1 0.89 18 2 18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22 2.89 21.1 2 20 2ZM11.97 9L11 6L10.03 9H7L9.47 10.76L8.53 13.67L11 11.87L13.47 13.67L12.53 10.76L15 9H11.97Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInbox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="inbox">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.56C9.25 17.19 10.53 18 12.01 18C13.49 18 14.76 17.19 15.46 16H19V19ZM19 14H14.01C14.01 15.1 13.11 16 12.01 16C10.91 16 10.01 15.1 10.01 14H5V5H19V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconIncompleteCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="incomplete_circle">
        <path
          id="Vector"
          d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 9.24 3.12 6.74 4.93 4.93L12 12V2C17.52 2 22 6.48 22 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconIndeterminateCheckBox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="indeterminate_check_box">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 11H17V13H7V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInfo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="info">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInfoBorder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="info_border">
        <path
          id="Vector"
          d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInput(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="input">
        <path
          id="Vector"
          d="M21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V9.00001H3V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001ZM11 16L15 12L11 8.00001V11H1V13H11V16ZM21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V9.00001H3V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001ZM11 16L15 12L11 8.00001V11H1V13H11V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsertChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_chart">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsertComment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_comment">
        <path
          id="Vector"
          d="M20 4V17.17L18.83 16H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2ZM18 12H6V14H18V12ZM18 9H6V11H18V9ZM18 6H6V8H18V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsertDriveFile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_drive_file">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsertEmoticon(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_emoticon">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsertInvitation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_invitation">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM17 13H12V18H17V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsertPageBreak(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_page_break">
        <g id="Vector">
          <path
            d="M18 20H6V17H4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V17H18V20Z"
            fill="currentColor"
          />
          <path d="M6 4H13V9H18V11H20V8L14 2H6C4.9 2 4 2.9 4 4V11H6V4Z" fill="currentColor" />
          <path d="M15 13H9V15H15V13Z" fill="currentColor" />
          <path d="M23 13H17V15H23V13Z" fill="currentColor" />
          <path d="M7 13H1V15H7V13Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconInsertPhoto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insert_photo">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInsights(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="insights">
        <g id="Vector">
          <path
            d="M21 8.5C19.55 8.5 18.74 9.94 19.07 11.01L15.52 14.57C15.22 14.48 14.78 14.48 14.48 14.57L11.93 12.02C12.27 10.95 11.46 9.5 10 9.5C8.55 9.5 7.73 10.94 8.07 12.02L3.51 16.57C2.44 16.24 1 17.05 1 18.5C1 19.6 1.9 20.5 3 20.5C4.45 20.5 5.26 19.06 4.93 17.99L9.48 13.43C9.78 13.52 10.22 13.52 10.52 13.43L13.07 15.98C12.73 17.05 13.54 18.5 15 18.5C16.45 18.5 17.27 17.06 16.93 15.98L20.49 12.43C21.56 12.76 23 11.95 23 10.5C23 9.4 22.1 8.5 21 8.5Z"
            fill="currentColor"
          />
          <path
            d="M15 9.5L15.94 7.43L18 6.5L15.94 5.57L15 3.5L14.08 5.57L12 6.5L14.08 7.43L15 9.5Z"
            fill="currentColor"
          />
          <path
            d="M3.5 11.5L4 9.5L6 9L4 8.5L3.5 6.5L3 8.5L1 9L3 9.5L3.5 11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconInstallDesktop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="install_desktop">
        <g id="Vector">
          <path
            d="M20 17H4V5H12V3H4C2.89 3 2 3.89 2 5V17C2 18.1 2.89 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V14H20V17Z"
            fill="currentColor"
          />
          <path
            d="M17 14L22 9L20.59 7.59L18 10.17V3H16V10.17L13.41 7.59L12 9L17 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconInstallMobile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="install_mobile">
        <g id="Vector">
          <path
            d="M15 18H5V6H12V4H5V3H12V1.01L5 1C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H15C16.1 23 17 22.1 17 21V16H15V18ZM15 21H5V20H15V21Z"
            fill="currentColor"
          />
          <path
            d="M16 14L21 9L19.59 7.59L17 10.17V3H15V10.17L12.41 7.59L11 9L16 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconIntegrationInstructions(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="integration_instructions">
        <g id="Vector">
          <path
            d="M11 15.17L8.83 13L11 10.83L9.59 9.41L6 13L9.59 16.59L11 15.17Z"
            fill="currentColor"
          />
          <path
            d="M14.41 16.59L18 13L14.41 9.41L13 10.83L15.17 13L13 15.17L14.41 16.59Z"
            fill="currentColor"
          />
          <path
            d="M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconInterests(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="interests">
        <path
          id="Vector"
          d="M7.02 13.5C4.81 13.5 3.02 15.29 3.02 17.5C3.02 19.71 4.81 21.5 7.02 21.5C9.23 21.5 11.02 19.71 11.02 17.5C11.02 15.29 9.23 13.5 7.02 13.5ZM7.02 19.5C5.92 19.5 5.02 18.6 5.02 17.5C5.02 16.4 5.92 15.5 7.02 15.5C8.12 15.5 9.02 16.4 9.02 17.5C9.02 18.6 8.12 19.5 7.02 19.5ZM13 13.5V21.5H21V13.5H13ZM19 19.5H15V15.5H19V19.5ZM7 2.5L2 11.5H12L7 2.5ZM7 6.62L8.6 9.5H5.4L7 6.62ZM19.25 3C18.19 3 17.44 3.56 17 4.17C16.56 3.56 15.81 3 14.75 3C13.19 3 12 4.28 12 5.75C12 7.75 14.42 9.17 17 11.5C19.58 9.17 22 7.75 22 5.75C22 4.28 20.81 3 19.25 3ZM17 8.85C15.55 7.63 14 6.45 14 5.75C14 5.32 14.35 5 14.75 5C15.06 5 15.27 5.17 15.48 5.37L17 6.8L18.52 5.37C18.73 5.17 18.94 5 19.25 5C19.65 5 20 5.32 20 5.75C20 6.45 18.45 7.63 17 8.85Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInterpreterMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="interpreter_mode">
        <path
          id="Vector"
          d="M20 16.5C19.17 16.5 18.5 15.83 18.5 15V12.5C18.5 11.67 19.17 11 20 11C20.83 11 21.5 11.67 21.5 12.5V15C21.5 15.83 20.83 16.5 20 16.5ZM19.5 20H20.5V18.46C22.19 18.22 23.5 16.76 23.5 15H22.5C22.5 16.38 21.38 17.5 20 17.5C18.62 17.5 17.5 16.38 17.5 15H16.5C16.5 16.76 17.81 18.22 19.5 18.46V20ZM8.5 12C6.29 12 4.5 10.21 4.5 8C4.5 5.79 6.29 4 8.5 4C8.97 4 9.42 4.08 9.84 4.23C9 5.26 8.5 6.57 8.5 8C8.5 9.43 9 10.74 9.84 11.77C9.42 11.92 8.97 12 8.5 12ZM6.61 13.13C5.29 14.05 4.5 15.57 4.5 17.22V20H0.5V17.22C0.5 16.1 1.11 15.07 2.11 14.56C3.35 13.92 4.87 13.37 6.61 13.13ZM10.5 8C10.5 5.79 12.29 4 14.5 4C16.71 4 18.5 5.79 18.5 8C18.5 10.21 16.71 12 14.5 12C12.29 12 10.5 10.21 10.5 8ZM12.5 8C12.5 9.1 13.4 10 14.5 10C15.6 10 16.5 9.1 16.5 8C16.5 6.9 15.6 6 14.5 6C13.4 6 12.5 6.9 12.5 8ZM14.5 15C12.13 15 10.21 15.73 9.02 16.34C8.7 16.5 8.5 16.84 8.5 17.22V18H15.67C16.17 18.86 16.92 19.56 17.82 20H6.5V17.22C6.5 16.1 7.11 15.07 8.11 14.56C9.79 13.7 11.97 13 14.5 13C14.89 13 15.27 13.02 15.64 13.05C15.31 13.64 15.09 14.31 15.02 15.01C14.85 15 14.68 15 14.5 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInventory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="inventory">
        <g id="Vector">
          <path
            d="M4.25 6H6.25V9H16.25V6H18.25V11H20.25V6C20.25 4.9 19.35 4 18.25 4H14.07C13.65 2.84 12.55 2 11.25 2C9.95 2 8.85 2.84 8.43 4H4.25C3.15 4 2.25 4.9 2.25 6V20C2.25 21.1 3.15 22 4.25 22H10.25V20H4.25V6ZM11.25 4C11.8 4 12.25 4.45 12.25 5C12.25 5.55 11.8 6 11.25 6C10.7 6 10.25 5.55 10.25 5C10.25 4.45 10.7 4 11.25 4Z"
            fill="currentColor"
          />
          <path
            d="M20.25 12.5L14.76 18L11.75 15L10.25 16.5L14.76 21L21.75 14L20.25 12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconInventory2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="inventory_2">
        <g id="Vector">
          <path
            d="M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM19 20H5V9H19V20ZM20 7H4V4H20V7Z"
            fill="currentColor"
          />
          <path d="M15 12H9V14H15V12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconInvertColors(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="invert_colors">
        <path
          id="Vector"
          d="M12 5.31V19.5C8.69 19.5 6 16.87 6 13.63C6 12.07 6.62 10.6 7.75 9.49L12 5.31ZM12 2.5L6.35 8.06C4.9 9.49 4 11.46 4 13.63C4 17.98 7.58 21.5 12 21.5C16.42 21.5 20 17.98 20 13.63C20 11.46 19.1 9.49 17.65 8.06L12 2.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInvertColorsOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="invert_colors_off">
        <path
          id="Vector"
          d="M21.9001 20.89L3.5201 2.50995L2.1001 3.91995L6.3001 8.11995C5.3001 9.42995 4.7001 11.06 4.7001 12.82C4.7101 17.18 8.2901 20.7 12.7101 20.7C14.4601 20.7 16.0701 20.14 17.3801 19.2L20.4801 22.3L21.9001 20.89ZM12.7101 18.7C9.4001 18.7 6.7101 16.07 6.7101 12.83C6.7101 11.64 7.0701 10.51 7.7301 9.54995L12.7101 14.53V18.7ZM9.0901 5.25995L12.7101 1.69995L18.3601 7.25995C19.8101 8.68995 20.7101 10.66 20.7101 12.83C20.7101 14.01 20.4401 15.12 19.9701 16.13L12.7101 8.86995V4.50995L10.5101 6.66995L9.0901 5.25995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconIosShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ios_share">
        <path
          id="Vector"
          d="M16 5L14.58 6.42L12.99 4.83V16H11.01V4.83L9.42 6.42L8 5L12 1L16 5ZM20 10V21C20 22.1 19.1 23 18 23H6C4.89 23 4 22.1 4 21V10C4 8.89 4.89 8 6 8H9V10H6V21H18V10H15V8H18C19.1 8 20 8.89 20 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconIron(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="iron">
        <path
          id="Vector"
          d="M21 6C19.34 6 18 7.34 18 9V13C18 13.55 17.55 14 17 14V10C17 8.34 15.66 7 14 7H10C8.34 7 7 8.34 7 10H9C9 9.45 9.45 9 10 9H14C14.55 9 15 9.45 15 10V11H6C3.79 11 2 12.79 2 15V18H17V16C18.66 16 20 14.66 20 13V9C20 8.45 20.45 8 21 8H22V6H21ZM15 16H4V15C4 13.9 4.9 13 6 13H15V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconIso(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="iso">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5.5 7.5H7.5V5.5H9V7.5H11V9H9V11H7.5V9H5.5V7.5ZM19 19H5L19 5V19ZM17 17V15.5H12V17H17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconJavascript(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="javascript">
        <path
          id="Vector"
          d="M12.5 14V13H14V13.5H16V12.5H13.5C12.95 12.5 12.5 12.05 12.5 11.5V10C12.5 9.45 12.95 9 13.5 9H16.5C17.05 9 17.5 9.45 17.5 10V11H16V10.5H14V11.5H16.5C17.05 11.5 17.5 11.95 17.5 12.5V14C17.5 14.55 17.05 15 16.5 15H13.5C12.95 15 12.5 14.55 12.5 14ZM9.5 9V13.5H8V12.5H6.5V13.5C6.5 14.33 7.17 15 8 15H9.5C10.33 15 11 14.33 11 13.5V9C11 9 10.33 9 9.5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconJoinFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="join_full">
        <g id="Vector">
          <path
            d="M12 17.74C13.6569 17.74 15 15.1701 15 12C15 8.82989 13.6569 6.26 12 6.26C10.3431 6.26 9 8.82989 9 12C9 15.1701 10.3431 17.74 12 17.74Z"
            fill="currentColor"
          />
          <path
            d="M7.5 12C7.5 11.03 7.73 7.84 10.53 5.5C9.75 5.19 8.9 5 8 5C4.14 5 1 8.14 1 12C1 15.86 4.14 19 8 19C8.9 19 9.75 18.81 10.53 18.5C7.73 16.16 7.5 12.97 7.5 12Z"
            fill="currentColor"
          />
          <path
            d="M16 5C15.1 5 14.25 5.19 13.47 5.5C16.27 7.84 16.5 11.03 16.5 12C16.5 12.97 16.27 16.16 13.47 18.5C14.25 18.81 15.1 19 16 19C19.86 19 23 15.86 23 12C23 8.14 19.86 5 16 5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconJoinInner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="join_inner">
        <g id="Vector">
          <path
            d="M12 17.74C13.6569 17.74 15 15.1701 15 12C15 8.82989 13.6569 6.26 12 6.26C10.3431 6.26 9 8.82989 9 12C9 15.1701 10.3431 17.74 12 17.74Z"
            fill="currentColor"
          />
          <path
            d="M9.04 16.87C8.71 16.95 8.36 17 8 17C5.24 17 3 14.76 3 12C3 9.24 5.24 7 8 7C8.36 7 8.71 7.05 9.04 7.13C9.43 6.57 9.92 6.01 10.53 5.5C9.75 5.19 8.9 5 8 5C4.14 5 1 8.14 1 12C1 15.86 4.14 19 8 19C8.9 19 9.75 18.81 10.53 18.5C9.92 17.99 9.43 17.43 9.04 16.87Z"
            fill="currentColor"
          />
          <path
            d="M16 5C15.1 5 14.25 5.19 13.47 5.5C14.08 6.01 14.57 6.57 14.96 7.13C15.29 7.05 15.64 7 16 7C18.76 7 21 9.24 21 12C21 14.76 18.76 17 16 17C15.64 17 15.29 16.95 14.96 16.87C14.57 17.43 14.08 17.99 13.47 18.5C14.25 18.81 15.1 19 16 19C19.86 19 23 15.86 23 12C23 8.14 19.86 5 16 5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconJoinLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="join_left">
        <g id="Vector">
          <path
            d="M12 17.74C13.6569 17.74 15 15.1701 15 12C15 8.82989 13.6569 6.26 12 6.26C10.3431 6.26 9 8.82989 9 12C9 15.1701 10.3431 17.74 12 17.74Z"
            fill="currentColor"
          />
          <path
            d="M7.5 12C7.5 11.03 7.73 7.84 10.53 5.5C9.75 5.19 8.9 5 8 5C4.14 5 1 8.14 1 12C1 15.86 4.14 19 8 19C8.9 19 9.75 18.81 10.53 18.5C7.73 16.16 7.5 12.97 7.5 12Z"
            fill="currentColor"
          />
          <path
            d="M16 5C15.1 5 14.25 5.19 13.47 5.5C14.08 6.01 14.57 6.57 14.96 7.13C15.29 7.05 15.64 7 16 7C18.76 7 21 9.24 21 12C21 14.76 18.76 17 16 17C15.64 17 15.29 16.95 14.96 16.87C14.57 17.43 14.08 17.99 13.47 18.5C14.25 18.81 15.1 19 16 19C19.86 19 23 15.86 23 12C23 8.14 19.86 5 16 5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconJoinRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="join_right">
        <g id="Vector">
          <path
            d="M12 17.74C13.6569 17.74 15 15.1701 15 12C15 8.82989 13.6569 6.26 12 6.26C10.3431 6.26 9 8.82989 9 12C9 15.1701 10.3431 17.74 12 17.74Z"
            fill="currentColor"
          />
          <path
            d="M16.5 12C16.5 12.97 16.27 16.16 13.47 18.5C14.25 18.81 15.1 19 16 19C19.86 19 23 15.86 23 12C23 8.14 19.86 5 16 5C15.1 5 14.25 5.19 13.47 5.5C16.27 7.84 16.5 11.03 16.5 12Z"
            fill="currentColor"
          />
          <path
            d="M8 19C8.9 19 9.75 18.81 10.53 18.5C9.92 17.99 9.43 17.43 9.04 16.87C8.71 16.95 8.36 17 8 17C5.24 17 3 14.76 3 12C3 9.24 5.24 7 8 7C8.36 7 8.71 7.05 9.04 7.13C9.43 6.57 9.92 6.01 10.53 5.5C9.75 5.19 8.9 5 8 5C4.14 5 1 8.14 1 12C1 15.86 4.14 19 8 19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconKayaking(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="kayaking">
        <path
          id="Vector"
          d="M21 22.5C19.97 22.5 18.94 22.25 18 21.75C16.11 22.75 13.89 22.75 12 21.75C10.11 22.75 7.89 22.75 6 21.75C5.05 22.25 4.03 22.5 3 22.5H2V20.5H3C4.04 20.5 5.08 20.15 6 19.5C7.83 20.8 10.17 20.8 12 19.5C13.83 20.8 16.17 20.8 18 19.5C18.91 20.15 19.96 20.5 21 20.5H22V22.5H21ZM12 5C10.9 5 10 5.9 10 7C10 8.1 10.9 9 12 9C13.1 9 14 8.1 14 7C14 5.9 13.1 5 12 5ZM24 17C24 17 22.48 17.71 20.07 18.37C19.25 18.14 18.54 17.62 18 17C17.27 17.84 16.2 18.5 15 18.5C13.8 18.5 12.73 17.84 12 17C11.27 17.84 10.2 18.5 9 18.5C7.8 18.5 6.73 17.84 6 17C5.46 17.61 4.75 18.13 3.93 18.37C1.52 17.71 0 17 0 17C0 17 2.93 15.64 7.13 14.92L8.48 10.75C8.79 9.8 9.8 9.28 10.75 9.59C10.84 9.62 10.94 9.66 11.02 9.7L13.49 11L16.33 9.5L17.98 5.79L17.47 4.47L18.8 1.5L22 2.93L20.67 5.9L19.36 6.4L15.64 14.74C20.49 15.37 24 17 24 17ZM15.02 12.46L13.5 13.26L11.75 12.34L11.04 14.51C11.36 14.51 11.68 14.5 12 14.5C12.71 14.5 13.4 14.53 14.07 14.58L15.02 12.46Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKebabDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="kebab_dining">
        <path
          id="Vector"
          d="M17.75 7H18.5C19.88 7 21 5.88 21 4.5C21 3.12 19.88 2 18.5 2H17.75V1H16.25V2H15.5C14.12 2 13 3.12 13 4.5C13 5.88 14.12 7 15.5 7H16.25V8H13V13H16.25V14H15.5C14.12 14 13 15.12 13 16.5C13 17.88 14.12 19 15.5 19H16.25V23H17.75V19H18.5C19.88 19 21 17.88 21 16.5C21 15.12 19.88 14 18.5 14H17.75V13H21V8H17.75V7ZM15.5 5C15.22 5 15 4.78 15 4.5C15 4.22 15.22 4 15.5 4H18.5C18.78 4 19 4.22 19 4.5C19 4.78 18.78 5 18.5 5H15.5ZM18.5 16C18.78 16 19 16.22 19 16.5C19 16.78 18.78 17 18.5 17H15.5C15.22 17 15 16.78 15 16.5C15 16.22 15.22 16 15.5 16H18.5ZM19 10V11H15V10H19ZM7.75 7H8.5C9.88 7 11 5.88 11 4.5C11 3.12 9.88 2 8.5 2H7.75V1H6.25V2H5.5C4.12 2 3 3.12 3 4.5C3 5.88 4.12 7 5.5 7H6.25V8H3V13H6.25V14H5.5C4.12 14 3 15.12 3 16.5C3 17.88 4.12 19 5.5 19H6.25V23H7.75V19H8.5C9.88 19 11 17.88 11 16.5C11 15.12 9.88 14 8.5 14H7.75V13H11V8H7.75V7ZM5.5 5C5.22 5 5 4.78 5 4.5C5 4.22 5.22 4 5.5 4H8.5C8.78 4 9 4.22 9 4.5C9 4.78 8.78 5 8.5 5H5.5ZM8.5 16C8.78 16 9 16.22 9 16.5C9 16.78 8.78 17 8.5 17H5.5C5.22 17 5 16.78 5 16.5C5 16.22 5.22 16 5.5 16H8.5ZM9 10V11H5V10H9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKey(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="key">
        <path
          id="Vector"
          d="M21 10H12.65C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H13L15 16L17 14L19 16L23 11.96L21 10ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="key_off">
        <path
          id="Vector"
          d="M10.2 12.825L8.49 11.115C8.5 11.175 8.5 11.235 8.5 11.295C8.5 12.395 7.6 13.295 6.5 13.295C5.4 13.295 4.5 12.395 4.5 11.295C4.5 10.195 5.4 9.29498 6.5 9.29498C6.56 9.29498 6.62 9.29498 6.68 9.30498L4.97 7.59498C3.52 8.19498 2.5 9.62498 2.5 11.295C2.5 13.505 4.29 15.295 6.5 15.295C8.17 15.295 9.6 14.275 10.2 12.825ZM11.69 14.315C10.65 16.095 8.71 17.295 6.5 17.295C3.19 17.295 0.5 14.605 0.5 11.295C0.5 9.08498 1.7 7.14498 3.48 6.10498L0.89 3.51498L2.3 2.10498L20.68 20.485L19.27 21.895L11.69 14.315ZM15.76 12.725L17 11.795L18.81 13.155L20.67 11.295L19.67 10.295H13.33L11.33 8.29498H20.5L23.5 11.295L19 15.795L18.31 15.285L15.76 12.725Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard">
        <path
          id="Vector"
          d="M20 7V17H4V7H20ZM20 5H4C2.9 5 2.01 5.9 2.01 7L2 17C2 18.1 2.9 19 4 19H20C21.1 19 22 18.1 22 17V7C22 5.9 21.1 5 20 5ZM11 8H13V10H11V8ZM11 11H13V13H11V11ZM8 8H10V10H8V8ZM8 11H10V13H8V11ZM5 11H7V13H5V11ZM5 8H7V10H5V8ZM8 14H16V16H8V14ZM14 11H16V13H14V11ZM14 8H16V10H14V8ZM17 11H19V13H17V11ZM17 8H19V10H17V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_alt">
        <path
          id="Vector"
          d="M21 3.5H3C1.9 3.5 1 4.4 1 5.5V18.5C1 19.6 1.9 20.5 3 20.5H21C22.1 20.5 23 19.6 23 18.5V5.5C23 4.4 22.1 3.5 21 3.5ZM21 18.5H3V5.5H21V18.5ZM9 7.5H11V9.5H9V7.5ZM5 7.5H7V9.5H5V7.5ZM8 15.5H16V16.5H8V15.5ZM13 7.5H15V9.5H13V7.5ZM9 11.5H11V13.5H9V11.5ZM5 11.5H7V13.5H5V11.5ZM13 11.5H15V13.5H13V11.5ZM17 7.5H19V9.5H17V7.5ZM17 11.5H19V13.5H17V11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardArrowDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_arrow_down">
        <path
          id="Vector"
          d="M7.41 8.29501L12 12.875L16.59 8.29501L18 9.70501L12 15.705L6 9.70501L7.41 8.29501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardArrowLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_arrow_left">
        <path
          id="Vector"
          d="M15.7049 16.59L11.1249 12L15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardArrowRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_arrow_right">
        <path
          id="Vector"
          d="M8.29492 16.59L12.8749 12L8.29492 7.41L9.70492 6L15.7049 12L9.70492 18L8.29492 16.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardArrowUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_arrow_up">
        <path
          id="Vector"
          d="M7.41 15.705L12 11.125L16.59 15.705L18 14.295L12 8.29501L6 14.295L7.41 15.705Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardBackspace(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_backspace">
        <path
          id="Vector"
          d="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardCapslock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_capslock">
        <path
          id="Vector"
          d="M12 8.61501L16.59 13.205L18 11.795L12 5.79501L6 11.795L7.41 13.205L12 8.61501ZM6 18.205H18V16.205H6V18.205Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardCommandKey(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_command_key">
        <path
          id="Vector"
          d="M17.5 3C15.57 3 14 4.57 14 6.5V8H10V6.5C10 4.57 8.43 3 6.5 3C4.57 3 3 4.57 3 6.5C3 8.43 4.57 10 6.5 10H8V14H6.5C4.57 14 3 15.57 3 17.5C3 19.43 4.57 21 6.5 21C8.43 21 10 19.43 10 17.5V16H14V17.5C14 19.43 15.57 21 17.5 21C19.43 21 21 19.43 21 17.5C21 15.57 19.43 14 17.5 14H16V10H17.5C19.43 10 21 8.43 21 6.5C21 4.57 19.43 3 17.5 3ZM16 8V6.5C16 5.67 16.67 5 17.5 5C18.33 5 19 5.67 19 6.5C19 7.33 18.33 8 17.5 8H16ZM6.5 8C5.67 8 5 7.33 5 6.5C5 5.67 5.67 5 6.5 5C7.33 5 8 5.67 8 6.5V8H6.5ZM10 14V10H14V14H10ZM17.5 19C16.67 19 16 18.33 16 17.5V16H17.5C18.33 16 19 16.67 19 17.5C19 18.33 18.33 19 17.5 19ZM6.5 19C5.67 19 5 18.33 5 17.5C5 16.67 5.67 16 6.5 16H8V17.5C8 18.33 7.33 19 6.5 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardControlKey(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_control_key">
        <path
          id="Vector"
          d="M5 14.795L6.41 16.205L12 10.625L17.59 16.205L19 14.795L12 7.79501L5 14.795Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardDoubleArrowDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_double_arrow_down">
        <g id="Vector">
          <path d="M18 6.41L16.59 5L12 9.58L7.41 5L6 6.41L12 12.41L18 6.41Z" fill="currentColor" />
          <path d="M18 13L16.59 11.59L12 16.17L7.41 11.59L6 13L12 19L18 13Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconKeyboardDoubleArrowLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_double_arrow_left">
        <g id="Vector">
          <path
            d="M17.59 18L19 16.59L14.42 12L19 7.41L17.59 6L11.59 12L17.59 18Z"
            fill="currentColor"
          />
          <path d="M11 18L12.41 16.59L7.83 12L12.41 7.41L11 6L5 12L11 18Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconKeyboardDoubleArrowRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_double_arrow_right">
        <g id="Vector">
          <path d="M6.41 6L5 7.41L9.58 12L5 16.59L6.41 18L12.41 12L6.41 6Z" fill="currentColor" />
          <path d="M13 6L11.59 7.41L16.17 12L11.59 16.59L13 18L19 12L13 6Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconKeyboardDoubleArrowUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_double_arrow_up">
        <g id="Vector">
          <path
            d="M6 17.59L7.41 19L12 14.42L16.59 19L18 17.59L12 11.59L6 17.59Z"
            fill="currentColor"
          />
          <path d="M6 11L7.41 12.41L12 7.83L16.59 12.41L18 11L12 5L6 11Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconKeyboardHide(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_hide">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 14C2 15.1 2.9 16 4 16H20C21.1 16 22 15.1 22 14V4C22 2.9 21.1 2 20 2ZM20 14H4V4H20V14ZM11 5H13V7H11V5ZM11 8H13V10H11V8ZM8 5H10V7H8V5ZM8 8H10V10H8V8ZM5 8H7V10H5V8ZM5 5H7V7H5V5ZM8 11H16V13H8V11ZM14 8H16V10H14V8ZM14 5H16V7H14V5ZM17 8H19V10H17V8ZM17 5H19V7H17V5ZM12 22L16 18H8L12 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardOptionKey(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_option_key">
        <g id="Vector">
          <path d="M21 5H15V7H21V5Z" fill="currentColor" />
          <path d="M9 5H3V7H7.85L14.77 19H21V17H15.93L9 5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconKeyboardReturn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_return">
        <path
          id="Vector"
          d="M19.5 7V11H6.33L9.91 7.41L8.5 6L2.5 12L8.5 18L9.91 16.59L6.33 13H21.5V7H19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardTab(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_tab">
        <path
          id="Vector"
          d="M12.09 7.41L15.67 11H1.5V13H15.67L12.08 16.59L13.5 18L19.5 12L13.5 6L12.09 7.41ZM20.5 6V18H22.5V6H20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKeyboardVoice(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="keyboard_voice">
        <path
          id="Vector"
          d="M12 14.5C13.66 14.5 14.99 13.16 14.99 11.5L15 5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5ZM10.8 5.4C10.8 4.74 11.34 4.2 12 4.2C12.66 4.2 13.2 4.74 13.2 5.4L13.19 11.6C13.19 12.26 12.66 12.8 12 12.8C11.34 12.8 10.8 12.26 10.8 11.6V5.4ZM17.3 11.5C17.3 14.5 14.76 16.6 12 16.6C9.24 16.6 6.7 14.5 6.7 11.5H5C5 14.91 7.72 17.73 11 18.22V21.5H13V18.22C16.28 17.74 19 14.92 19 11.5H17.3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKingBed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="king_bed">
        <path
          id="Vector"
          d="M22 12C22 10.9 21.1 10 20 10V7C20 5.9 19.1 5 18 5H6C4.9 5 4 5.9 4 7V10C2.9 10 2 10.9 2 12V17H3.33L4 19H5L5.67 17H18.34L19 19H20L20.67 17H22V12ZM18 10H13V7H18V10ZM6 7H11V10H6V7ZM4 12H20V15H4V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKitchen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="kitchen">
        <path
          id="Vector"
          d="M8 5H10V8H8V5ZM8 12H10V17H8V12ZM18 2.01L6 2C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.89 19.1 2.01 18 2.01ZM18 20H6V10.98H18V20ZM18 9H6V4H18V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconKitesurfing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="kitesurfing">
        <path
          id="Vector"
          d="M6 3C6 1.9 6.9 1 8 1C9.1 1 10 1.9 10 3C10 4.1 9.1 5 8 5C6.9 5 6 4.1 6 3ZM20.06 1H17.94L15.5 3.44L16.56 4.5L20.06 1ZM22 23V21H21C19.96 21 18.92 20.65 18 20C16.17 21.3 13.83 21.3 12 20C10.17 21.3 7.83 21.3 6 20C5.09 20.65 4.04 21 3 21H2V23H3C4.03 23 5.05 22.75 6 22.25C7.89 23.25 10.11 23.25 12 22.25C13.89 23.25 16.11 23.25 18 22.25C18.95 22.75 19.97 23 21 23H22ZM21 13.28C21 14.72 18.81 16.9 15.96 18.86C15.65 18.95 15.33 19 15 19C13.8 19 12.73 18.34 12 17.5C11.27 18.34 10.2 19 9 19C8.06 19 7.19 18.59 6.51 18.01C6.97 17.62 7.47 17.23 8 16.84L6.45 13.87C6.15 13.3 6 12.64 6 12V8C6 6.9 6.9 6 8 6H11C12.38 6 13.63 5.44 14.54 4.54L15.95 5.95C14.68 7.21 12.93 8 11 8H9.6V11.5H12.4L14.09 13.38C16.04 12.54 17.86 12 19.15 12C19.99 12 21 12.25 21 13.28ZM12.2 14.27L11.5 13.5L9 13.6L9.83 15.61C10.42 15.23 11.64 14.55 12.2 14.27Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLabel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="label">
        <path
          id="Vector"
          d="M17.13 5.84C16.77 5.33 16.17 5 15.5 5L4.5 5.01C3.4 5.01 2.5 5.9 2.5 7V17C2.5 18.1 3.4 18.99 4.5 18.99L15.5 19C16.17 19 16.77 18.67 17.13 18.16L21.5 12L17.13 5.84ZM15.5 17H4.5V7H15.5L19.05 12L15.5 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLabelImportant(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="label_important">
        <path
          id="Vector"
          d="M3.5 18.995H14.5C15.17 18.995 15.77 18.675 16.13 18.165L20.5 12.005L16.13 5.84501C15.77 5.33501 15.17 5.005 14.5 5.005H3.5L8.5 12.005L3.5 18.995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLabelOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="label_off">
        <path
          id="Vector"
          d="M16 7.19006L19.55 12.1901L17.92 14.4801L19.35 15.9101L22 12.1901L17.63 6.03006C17.27 5.52006 16.67 5.19006 16 5.19006L8.63 5.20006L10.63 7.19006H16ZM2 4.22006L3.58 5.80006C3.22 6.15006 3 6.65006 3 7.19006V17.1901C3 18.2901 3.9 19.1801 5 19.1801L16 19.1901C16.28 19.1901 16.55 19.1201 16.79 19.0101L18.97 21.1901L20.38 19.7801L3.41 2.81006L2 4.22006ZM14.97 17.1901H5V7.22006L14.97 17.1901Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLan(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lan">
        <path
          id="Vector"
          d="M13 22H21V15H18V11H13V9H16V2H8V9H11V11H6V15H3V22H11V15H8V13H16V15H13V22ZM10 7V4H14V7H10ZM9 17V20H5V17H9ZM19 17V20H15V17H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLandscape(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="landscape">
        <path
          id="Vector"
          d="M14 6L9.78 11.63L11.03 13.3L14 9.33L19 16H10.54L6.53 10.63L1 18H23L14 6ZM5 16L6.52 13.97L8.04 16H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLandslide(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="landslide">
        <g id="Vector">
          <path
            d="M10.5 13L7.5 9H1.5V23H21.5L15.5 15L10.5 13ZM12.03 15.77L5.5 17.95L3.5 17.28V15.39L5.5 16.06L9.45 14.74L12.03 15.77ZM6.5 11L8.07 13.09L5.5 13.95L3.5 13.28V11H6.5ZM3.5 21V19.39L5.5 20.06L14.53 17.05L17.5 21H3.5Z"
            fill="currentColor"
          />
          <path
            d="M16.5 7V2L11.5 1L8.5 3V7L11.5 9L16.5 7ZM10.5 4.07L11.92 3.12L14.5 3.64V5.65L11.73 6.76L10.5 5.93V4.07Z"
            fill="currentColor"
          />
          <path
            d="M18 8L15.5 10V13L18 15L22.5 13V9L18 8ZM20.5 11.7L18.3 12.68L17.5 12.04V10.96L18.5 10.16L20.5 10.6V11.7Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLanguage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="language">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLaptop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="laptop">
        <path
          id="Vector"
          d="M20 18C21.1 18 22 17.1 22 16V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLaptopChromebook(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="laptop_chromebook">
        <path
          id="Vector"
          d="M22 18.5V3.5H2V18.5H0V20.5H24V18.5H22ZM14 18.5H10V17.5H14V18.5ZM20 15.5H4V5.5H20V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLaptopMac(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="laptop_mac">
        <path
          id="Vector"
          d="M20 18.5C21.1 18.5 21.99 17.6 21.99 16.5L22 5.5C22 4.4 21.1 3.5 20 3.5H4C2.9 3.5 2 4.4 2 5.5V16.5C2 17.6 2.9 18.5 4 18.5H0C0 19.6 0.9 20.5 2 20.5H22C23.1 20.5 24 19.6 24 18.5H20ZM4 5.5H20V16.5H4V5.5ZM12 19.5C11.45 19.5 11 19.05 11 18.5C11 17.95 11.45 17.5 12 17.5C12.55 17.5 13 17.95 13 18.5C13 19.05 12.55 19.5 12 19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLaptopWindows(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="laptop_windows">
        <path
          id="Vector"
          d="M20 18.5V17.5C21.1 17.5 21.99 16.6 21.99 15.5L22 5.5C22 4.4 21.1 3.5 20 3.5H4C2.9 3.5 2 4.4 2 5.5V15.5C2 16.6 2.9 17.5 4 17.5V18.5H0V20.5H24V18.5H20ZM4 5.5H20V15.5H4V5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLastPage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="last_page">
        <path
          id="Vector"
          d="M5.79492 7.41L10.3849 12L5.79492 16.59L7.20492 18L13.2049 12L7.20492 6L5.79492 7.41ZM16.2049 6H18.2049V18H16.2049V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLaunch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="launch">
        <path
          id="Vector"
          d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLayers(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="layers">
        <path
          id="Vector"
          d="M11.99 19.005L4.62 13.275L3 14.535L12 21.535L21 14.535L19.37 13.265L11.99 19.005ZM12 16.465L19.36 10.735L21 9.46503L12 2.46503L3 9.46503L4.63 10.735L12 16.465ZM12 4.99503L17.74 9.46503L12 13.935L6.26 9.46503L12 4.99503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLayersClear(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="layers_clear">
        <path
          id="Vector"
          d="M11.9302 5.56502L17.6702 10.035L15.7802 11.505L17.2102 12.925L20.9302 10.035L11.9302 3.03502L9.34018 5.05502L10.7602 6.47502L11.9302 5.56502ZM20.9302 15.105L19.3002 13.835L18.6302 14.355L20.0602 15.785L20.9302 15.105ZM3.34018 1.89502L1.93018 3.30502L6.15018 7.52502L2.93018 10.035L11.9302 17.035L14.0302 15.405L15.4502 16.825L11.9202 19.575L4.55018 13.845L2.93018 15.105L11.9302 22.105L16.8802 18.255L20.6602 22.035L22.0702 20.625L3.34018 1.89502ZM11.9302 14.505L6.19018 10.035L7.58018 8.95502L12.6002 13.975L11.9302 14.505Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLeaderboard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="leaderboard">
        <path
          id="Vector"
          d="M16 11V3H8V9H2V21H22V11H16ZM10 5H14V19H10V5ZM4 11H8V19H4V11ZM20 19H16V13H20V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLeakAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="leak_add">
        <path
          id="Vector"
          d="M6 3H3V6C4.66 6 6 4.66 6 3ZM14 3H12C12 7.97 7.97 12 3 12V14C9.08 14 14 9.07 14 3ZM10 3H8C8 5.76 5.76 8 3 8V10C6.87 10 10 6.87 10 3ZM10 21H12C12 16.03 16.03 12 21 12V10C14.93 10 10 14.93 10 21ZM18 21H21V18C19.34 18 18 19.34 18 21ZM14 21H16C16 18.24 18.24 16 21 16V14C17.13 14 14 17.13 14 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLeakRemove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="leak_remove">
        <path
          id="Vector"
          d="M13.9299 3.07005H11.9299C11.9299 4.42005 11.6199 5.70005 11.0899 6.84005L12.5799 8.33005C13.4399 6.77005 13.9299 4.98005 13.9299 3.07005ZM20.9299 12.0701V10.0701C19.0199 10.0701 17.2299 10.5601 15.6599 11.4201L17.1499 12.9101C18.2999 12.3801 19.5799 12.0701 20.9299 12.0701ZM20.9299 16.0701V14.0701C20.1399 14.0701 19.3899 14.2001 18.6899 14.4401L20.3699 16.1201C20.5599 16.1101 20.7399 16.0701 20.9299 16.0701ZM9.92993 3.07005H7.92993C7.92993 3.26005 7.88993 3.44005 7.86993 3.63005L9.54993 5.31005C9.79993 4.61005 9.92993 3.85005 9.92993 3.07005ZM4.33993 2.93005L2.92993 4.34005L5.76993 7.18005C4.95993 7.74005 3.98993 8.07005 2.92993 8.07005V10.0701C4.53993 10.0701 6.01993 9.52005 7.19993 8.61005L8.62993 10.0401C7.06993 11.3101 5.08993 12.0701 2.92993 12.0701V14.0701C5.64993 14.0701 8.12993 13.0801 10.0399 11.4501L12.5499 13.9601C10.9199 15.8801 9.92993 18.3601 9.92993 21.0701H11.9299C11.9299 18.9101 12.6899 16.9301 13.9599 15.3701L15.3899 16.8001C14.4799 17.9801 13.9299 19.4601 13.9299 21.0701H15.9299C15.9299 20.0101 16.2599 19.0401 16.8199 18.2301L19.6599 21.0701L21.0699 19.6601L4.33993 2.93005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLegendToggle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="legend_toggle">
        <path
          id="Vector"
          d="M20 15H4V13H20V15ZM20 17H4V19H20V17ZM15 11L20 7.45V5L15 8.55L10 5L4 8.66V11L9.92 7.39L15 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLens(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lens">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLensBlur(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lens_blur">
        <path
          id="Vector"
          d="M6 13C5.45 13 5 13.45 5 14C5 14.55 5.45 15 6 15C6.55 15 7 14.55 7 14C7 13.45 6.55 13 6 13ZM6 17C5.45 17 5 17.45 5 18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18C7 17.45 6.55 17 6 17ZM6 9C5.45 9 5 9.45 5 10C5 10.55 5.45 11 6 11C6.55 11 7 10.55 7 10C7 9.45 6.55 9 6 9ZM3 9.5C2.72 9.5 2.5 9.72 2.5 10C2.5 10.28 2.72 10.5 3 10.5C3.28 10.5 3.5 10.28 3.5 10C3.5 9.72 3.28 9.5 3 9.5ZM6 5C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5ZM21 10.5C21.28 10.5 21.5 10.28 21.5 10C21.5 9.72 21.28 9.5 21 9.5C20.72 9.5 20.5 9.72 20.5 10C20.5 10.28 20.72 10.5 21 10.5ZM14 7C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5C13.45 5 13 5.45 13 6C13 6.55 13.45 7 14 7ZM14 3.5C14.28 3.5 14.5 3.28 14.5 3C14.5 2.72 14.28 2.5 14 2.5C13.72 2.5 13.5 2.72 13.5 3C13.5 3.28 13.72 3.5 14 3.5ZM3 13.5C2.72 13.5 2.5 13.72 2.5 14C2.5 14.28 2.72 14.5 3 14.5C3.28 14.5 3.5 14.28 3.5 14C3.5 13.72 3.28 13.5 3 13.5ZM10 20.5C9.72 20.5 9.5 20.72 9.5 21C9.5 21.28 9.72 21.5 10 21.5C10.28 21.5 10.5 21.28 10.5 21C10.5 20.72 10.28 20.5 10 20.5ZM10 3.5C10.28 3.5 10.5 3.28 10.5 3C10.5 2.72 10.28 2.5 10 2.5C9.72 2.5 9.5 2.72 9.5 3C9.5 3.28 9.72 3.5 10 3.5ZM10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6C9 6.55 9.45 7 10 7ZM10 12.5C9.17 12.5 8.5 13.17 8.5 14C8.5 14.83 9.17 15.5 10 15.5C10.83 15.5 11.5 14.83 11.5 14C11.5 13.17 10.83 12.5 10 12.5ZM18 13C17.45 13 17 13.45 17 14C17 14.55 17.45 15 18 15C18.55 15 19 14.55 19 14C19 13.45 18.55 13 18 13ZM18 17C17.45 17 17 17.45 17 18C17 18.55 17.45 19 18 19C18.55 19 19 18.55 19 18C19 17.45 18.55 17 18 17ZM18 9C17.45 9 17 9.45 17 10C17 10.55 17.45 11 18 11C18.55 11 19 10.55 19 10C19 9.45 18.55 9 18 9ZM18 5C17.45 5 17 5.45 17 6C17 6.55 17.45 7 18 7C18.55 7 19 6.55 19 6C19 5.45 18.55 5 18 5ZM21 13.5C20.72 13.5 20.5 13.72 20.5 14C20.5 14.28 20.72 14.5 21 14.5C21.28 14.5 21.5 14.28 21.5 14C21.5 13.72 21.28 13.5 21 13.5ZM14 17C13.45 17 13 17.45 13 18C13 18.55 13.45 19 14 19C14.55 19 15 18.55 15 18C15 17.45 14.55 17 14 17ZM14 20.5C13.72 20.5 13.5 20.72 13.5 21C13.5 21.28 13.72 21.5 14 21.5C14.28 21.5 14.5 21.28 14.5 21C14.5 20.72 14.28 20.5 14 20.5ZM10 8.5C9.17 8.5 8.5 9.17 8.5 10C8.5 10.83 9.17 11.5 10 11.5C10.83 11.5 11.5 10.83 11.5 10C11.5 9.17 10.83 8.5 10 8.5ZM10 17C9.45 17 9 17.45 9 18C9 18.55 9.45 19 10 19C10.55 19 11 18.55 11 18C11 17.45 10.55 17 10 17ZM14 12.5C13.17 12.5 12.5 13.17 12.5 14C12.5 14.83 13.17 15.5 14 15.5C14.83 15.5 15.5 14.83 15.5 14C15.5 13.17 14.83 12.5 14 12.5ZM14 8.5C13.17 8.5 12.5 9.17 12.5 10C12.5 10.83 13.17 11.5 14 11.5C14.83 11.5 15.5 10.83 15.5 10C15.5 9.17 14.83 8.5 14 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLibraryAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="library_add">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 14H15V11H18V9H15V6H13V9H10V11H13V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLibraryAddCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="library_add_check">
        <path
          id="Vector"
          d="M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12.47 14L9 10.5L10.4 9.09L12.47 11.17L17.6 6L19 7.41L12.47 14ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLibraryBooks(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="library_books">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLibraryMusic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="library_music">
        <path
          id="Vector"
          d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM12.5 15C13.88 15 15 13.88 15 12.5V7H18V5H14V10.51C13.58 10.19 13.07 10 12.5 10C11.12 10 10 11.12 10 12.5C10 13.88 11.12 15 12.5 15ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="light">
        <path
          id="Vector"
          d="M13 6.06V3H11V6.06C6.5 6.56 3 10.37 3 14.99C3 16.1 3.9 17 5.01 17H8C8 19.21 9.79 21 12 21C14.21 21 16 19.21 16 17H18.99C20.1 17 21 16.1 21 14.99C21 10.37 17.5 6.56 13 6.06ZM12 19C10.9 19 10 18.1 10 17H14C14 18.1 13.1 19 12 19ZM5 15C5 11.14 8.14 8 12 8C15.86 8 19 11.14 19 15H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLightMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="light_mode">
        <path
          id="Vector"
          d="M12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM2 13H4C4.55 13 5 12.55 5 12C5 11.45 4.55 11 4 11H2C1.45 11 1 11.45 1 12C1 12.55 1.45 13 2 13ZM20 13H22C22.55 13 23 12.55 23 12C23 11.45 22.55 11 22 11H20C19.45 11 19 11.45 19 12C19 12.55 19.45 13 20 13ZM11 2V4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4V2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2ZM11 20V22C11 22.55 11.45 23 12 23C12.55 23 13 22.55 13 22V20C13 19.45 12.55 19 12 19C11.45 19 11 19.45 11 20ZM5.99 4.58C5.6 4.19 4.96 4.19 4.58 4.58C4.19 4.97 4.19 5.61 4.58 5.99L5.64 7.05C6.03 7.44 6.67 7.44 7.05 7.05C7.43 6.66 7.44 6.02 7.05 5.64L5.99 4.58ZM18.36 16.95C17.97 16.56 17.33 16.56 16.95 16.95C16.56 17.34 16.56 17.98 16.95 18.36L18.01 19.42C18.4 19.81 19.04 19.81 19.42 19.42C19.81 19.03 19.81 18.39 19.42 18.01L18.36 16.95ZM19.42 5.99C19.81 5.6 19.81 4.96 19.42 4.58C19.03 4.19 18.39 4.19 18.01 4.58L16.95 5.64C16.56 6.03 16.56 6.67 16.95 7.05C17.34 7.43 17.98 7.44 18.36 7.05L19.42 5.99ZM7.05 18.36C7.44 17.97 7.44 17.33 7.05 16.95C6.66 16.56 6.02 16.56 5.64 16.95L4.58 18.01C4.19 18.4 4.19 19.04 4.58 19.42C4.97 19.8 5.61 19.81 5.99 19.42L7.05 18.36Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLightbulb(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lightbulb">
        <path
          id="Vector"
          d="M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14.85 13.1L14 13.7V16H10V13.7L9.15 13.1C7.8 12.16 7 10.63 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 10.63 16.2 12.16 14.85 13.1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLightbulbCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lightbulb_circle">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M12 19C12.83 19 13.5 18.33 13.5 17.5H10.5C10.5 18.33 11.17 19 12 19Z"
            fill="currentColor"
          />
          <path d="M15 15H9V16.5H15V15Z" fill="currentColor" />
          <path
            d="M12 5C9.24 5 7 7.24 7 10C7 11.64 7.8 13.09 9.03 14H14.98C16.2 13.09 17 11.64 17 10C17 7.24 14.76 5 12 5ZM14.43 12.5H9.57C8.89 11.84 8.5 10.95 8.5 10C8.5 8.07 10.07 6.5 12 6.5C13.93 6.5 15.5 8.07 15.5 10C15.5 10.95 15.11 11.84 14.43 12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLineAxis(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="line_axis">
        <path
          id="Vector"
          d="M22 7.93L20.59 6.52L16.56 11.05L9.5 4.5L2 12.01L3.5 13.51L9.64 7.36L15.23 12.54L13.5 14.49L9.5 10.49L2 18L3.5 19.5L9.5 13.49L13.5 17.49L16.69 13.9L20.59 17.51L22 16.1L18.02 12.4L22 7.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLineStyle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="line_style">
        <path
          id="Vector"
          d="M3 16H8V14H3V16ZM9.5 16H14.5V14H9.5V16ZM16 16H21V14H16V16ZM3 20H5V18H3V20ZM7 20H9V18H7V20ZM11 20H13V18H11V20ZM15 20H17V18H15V20ZM19 20H21V18H19V20ZM3 12H11V10H3V12ZM13 12H21V10H13V12ZM3 4V8H21V4H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLineWeight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="line_weight">
        <path
          id="Vector"
          d="M3 17H21V15H3V17ZM3 20H21V19H3V20ZM3 13H21V10H3V13ZM3 4V8H21V4H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLinearScale(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="linear_scale">
        <path
          id="Vector"
          d="M19.5 9.5C18.47 9.5 17.6 10.12 17.21 11H14.29C13.9 10.12 13.03 9.5 12 9.5C10.97 9.5 10.1 10.12 9.71 11H6.79C6.4 10.12 5.53 9.5 4.5 9.5C3.12 9.5 2 10.62 2 12C2 13.38 3.12 14.5 4.5 14.5C5.53 14.5 6.4 13.88 6.79 13H9.71C10.1 13.88 10.97 14.5 12 14.5C13.03 14.5 13.9 13.88 14.29 13H17.21C17.6 13.88 18.47 14.5 19.5 14.5C20.88 14.5 22 13.38 22 12C22 10.62 20.88 9.5 19.5 9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLink(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="link">
        <path
          id="Vector"
          d="M17 7H13V9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM11 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15ZM8 11H16V13H8V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLinkOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="link_off">
        <path
          id="Vector"
          d="M14.39 11.065L16 12.675V11.065H14.39ZM17 7.06505H13V8.96505H17C18.71 8.96505 20.1 10.355 20.1 12.065C20.1 13.335 19.33 14.435 18.23 14.905L19.63 16.305C21.05 15.425 22 13.855 22 12.065C22 9.30505 19.76 7.06505 17 7.06505ZM2 4.33505L5.11 7.44505C3.29 8.18505 2 9.97505 2 12.065C2 14.825 4.24 17.065 7 17.065H11V15.165H7C5.29 15.165 3.9 13.775 3.9 12.065C3.9 10.475 5.11 9.16505 6.66 8.99505L8.73 11.065H8V13.065H10.73L13 15.335V17.065H14.73L18.74 21.075L20.15 19.665L3.41 2.92505L2 4.33505Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLinkedCamera(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="linked_camera">
        <path
          id="Vector"
          d="M20 9V20H4V8H8.05L9.88 6H15V4H9L7.17 6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9H20ZM20.67 7.99H22C21.99 4.68 19.31 2 16 2V3.33C18.58 3.33 20.66 5.41 20.67 7.99ZM18 7.99H19.33C19.32 6.15 17.84 4.67 16 4.67V6C17.11 6 17.99 6.89 18 7.99ZM7 14C7 16.76 9.24 19 12 19C14.76 19 17 16.76 17 14C17 11.24 14.76 9 12 9C9.24 9 7 11.24 7 14ZM15 14C15 15.65 13.65 17 12 17C10.35 17 9 15.65 9 14C9 12.35 10.35 11 12 11C13.65 11 15 12.34 15 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLiquor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="liquor">
        <g id="Vector">
          <path
            d="M2.5 14C2.5 15.3 3.34 16.4 4.5 16.82V20H2.5V22H8.5V20H6.5V16.82C7.66 16.4 8.5 15.3 8.5 14V6H2.5V14ZM4.5 8H6.5V11H4.5V8ZM4.5 13H6.5V14C6.5 14.55 6.05 15 5.5 15C4.95 15 4.5 14.55 4.5 14V13Z"
            fill="currentColor"
          />
          <path
            d="M20.14 8.54L19.18 8.22C18.77 8.08 18.5 7.7 18.5 7.27V3C18.5 2.45 18.05 2 17.5 2H14.5C13.95 2 13.5 2.45 13.5 3V7.28C13.5 7.71 13.23 8.09 12.82 8.23L11.86 8.55C11.05 8.83 10.5 9.59 10.5 10.45V20C10.5 21.1 11.4 22 12.5 22H19.5C20.6 22 21.5 21.1 21.5 20V10.44C21.5 9.58 20.95 8.82 20.14 8.54ZM15.5 4H16.5V5H15.5V4ZM19.5 20H12.5V18H19.5V20ZM19.5 16H12.5V14H19.5V16ZM19.5 12H12.5V10.44L13.45 10.12C14.68 9.72 15.5 8.57 15.5 7.28V7H16.5V7.28C16.5 8.57 17.32 9.72 18.55 10.13L19.5 10.44V12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconList(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="list">
        <path
          id="Vector"
          d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconListAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="list_alt">
        <path
          id="Vector"
          d="M11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM19 19H5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLiveHelp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="live_help">
        <path
          id="Vector"
          d="M19 1.5H5C3.89 1.5 3 2.4 3 3.5V17.5C3 18.6 3.89 19.5 5 19.5H9L12 22.5L15 19.5H19C20.1 19.5 21 18.6 21 17.5V3.5C21 2.4 20.1 1.5 19 1.5ZM19 17.5H14.17L12 19.67L9.83 17.5H5V3.5H19V17.5ZM11 14.5H13V16.5H11V14.5ZM12 6.5C13.1 6.5 14 7.4 14 8.5C14 10.5 11 10.25 11 13.5H13C13 11.25 16 11 16 8.5C16 6.29 14.21 4.5 12 4.5C9.79 4.5 8 6.29 8 8.5H10C10 7.4 10.9 6.5 12 6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLiveTv(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="live_tv">
        <path
          id="Vector"
          d="M9 10V18L16 14L9 10ZM21 6H13.42L16.71 2.71L16 2L12 6H11.97L7.97 2L7.28 2.71L10.56 6H3C1.9 6 1 6.9 1 8V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V8C23 6.9 22.1 6 21 6ZM21 20H3V8H21V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLiving(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="living">
        <path
          id="Vector"
          d="M17.75 10.35V9C17.75 7.34 16.41 6 14.75 6H9.25C7.59 6 6.25 7.34 6.25 9V10.35C5.51 10.78 5 11.58 5 12.5V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V12.5C19 11.58 18.49 10.78 17.75 10.35ZM9.25 7.5H14.75C15.58 7.5 16.25 8.17 16.25 9V10.03C14.99 10.15 14 11.2 14 12.5V13H10V12.5C10 11.2 9.01 10.15 7.75 10.03V9C7.75 8.17 8.42 7.5 9.25 7.5ZM17.5 16C17.5 16.28 17.28 16.5 17 16.5H7C6.72 16.5 6.5 16.28 6.5 16V12.5C6.5 11.95 6.95 11.5 7.5 11.5C8.05 11.5 8.5 11.95 8.5 12.5V14.5H15.5V12.5C15.5 11.95 15.95 11.5 16.5 11.5C17.05 11.5 17.5 11.95 17.5 12.5V16ZM20 4V20H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalActivity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_activity">
        <path
          id="Vector"
          d="M22 10V6C22 4.9 21.1 4 20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM9.07 16L12 14.12L14.93 16L14.04 12.64L16.73 10.44L13.26 10.23L12 7L10.73 10.22L7.26 10.43L9.95 12.63L9.07 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalAirport(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_airport">
        <path
          id="Vector"
          d="M22 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2 14V16L10.5 13.5V19L8 20.5V22L12 21L16 22V20.5L13.5 19V13.5L22 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalAtm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_atm">
        <path
          id="Vector"
          d="M11 17H13V16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11H11V10H15V8H13V7H11V8H10C9.45 8 9 8.45 9 9V12C9 12.55 9.45 13 10 13H13V14H9V16H11V17ZM20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalBar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_bar">
        <path
          id="Vector"
          d="M14.77 9L12 12.11L9.23 9H14.77ZM21 3H3V5L11 14V19H6V21H18V19H13V14L21 5V3ZM7.43 7L5.66 5H18.35L16.57 7H7.43Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalCafe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_cafe">
        <path
          id="Vector"
          d="M16 5V13C16 14.1 15.1 15 14 15H8C6.9 15 6 14.1 6 13V5H16ZM20 3H4V13C4 15.21 5.79 17 8 17H14C16.21 17 18 15.21 18 13V10H20C21.11 10 22 9.11 22 8V5C22 3.89 21.11 3 20 3ZM18 8V5H20V8H18ZM20 19H2V21H20V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalCarWash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_car_wash">
        <g id="Vector">
          <path
            d="M17 5.10002C17.83 5.10002 18.5 4.43002 18.5 3.60002C18.5 2.60002 17 0.900024 17 0.900024C17 0.900024 15.5 2.60002 15.5 3.60002C15.5 4.43002 16.17 5.10002 17 5.10002ZM12 5.10002C12.83 5.10002 13.5 4.43002 13.5 3.60002C13.5 2.60002 12 0.900024 12 0.900024C12 0.900024 10.5 2.60002 10.5 3.60002C10.5 4.43002 11.17 5.10002 12 5.10002ZM7 5.10002C7.83 5.10002 8.5 4.43002 8.5 3.60002C8.5 2.60002 7 0.900024 7 0.900024C7 0.900024 5.5 2.60002 5.5 3.60002C5.5 4.43002 6.17 5.10002 7 5.10002ZM18.92 8.11002C18.72 7.52002 18.16 7.10002 17.5 7.10002H6.5C5.84 7.10002 5.29 7.52002 5.08 8.11002L3 14.1V22.1C3 22.65 3.45 23.1 4 23.1H5C5.55 23.1 6 22.65 6 22.1V21.1H18V22.1C18 22.65 18.45 23.1 19 23.1H20C20.55 23.1 21 22.65 21 22.1V14.1L18.92 8.11002ZM6.85 9.10002H17.14L18.18 12.1H5.81L6.85 9.10002ZM19 19.1H5V14.44L5.12 14.1H18.89L19 14.44V19.1Z"
            fill="currentColor"
          />
          <path
            d="M7.5 18.1C8.32843 18.1 9 17.4285 9 16.6C9 15.7716 8.32843 15.1 7.5 15.1C6.67157 15.1 6 15.7716 6 16.6C6 17.4285 6.67157 18.1 7.5 18.1Z"
            fill="currentColor"
          />
          <path
            d="M16.5 18.1C17.3284 18.1 18 17.4285 18 16.6C18 15.7716 17.3284 15.1 16.5 15.1C15.6716 15.1 15 15.7716 15 16.6C15 17.4285 15.6716 18.1 16.5 18.1Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLocalConvenienceStore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_convenience_store">
        <path
          id="Vector"
          d="M19 7V4H5V7H2V20H10V16H14V20H22V7H19ZM20 18H16V14H8V18H4V9H7V6H17V9H20V18ZM8 8H10V9H8V12H11V11H9V10H11V7H8V8ZM15 9H14V7H13V10H15V12H16V7H15V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_dining">
        <path
          id="Vector"
          d="M7.79945 13.1283L10.6295 10.2983L3.60945 3.28835C2.04945 4.84835 2.04945 7.37835 3.60945 8.94835L7.79945 13.1283ZM14.5795 11.3183C16.1095 12.0283 18.2595 11.5283 19.8495 9.93835C21.7595 8.02835 22.1295 5.28835 20.6595 3.81835C19.1995 2.35835 16.4595 2.71835 14.5395 4.62835C12.9495 6.21835 12.4495 8.36835 13.1595 9.89835L3.39945 19.6583L4.80945 21.0683L11.6995 14.1983L18.5795 21.0784L19.9895 19.6683L13.1095 12.7883L14.5795 11.3183Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalDrink(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_drink">
        <path
          id="Vector"
          d="M3 2L5.01 20.23C5.13 21.23 5.97 22 7 22H17C18.03 22 18.87 21.23 18.99 20.23L21 2H3ZM17 20L7 20.01L5.89 10H18.1L17 20ZM18.33 8H5.67L5.23 4H18.76L18.33 8ZM12 19C13.66 19 15 17.66 15 16C15 14 12 10.6 12 10.6C12 10.6 9 14 9 16C9 17.66 10.34 19 12 19ZM12 13.91C12.59 14.82 13 15.64 13 16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16C11 15.63 11.41 14.81 12 13.91Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalFireDepartment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_fire_department">
        <path
          id="Vector"
          d="M16 6.5L15.56 7.05C15.14 7.57 14.58 7.8 14.02 7.8C13 7.8 12 7.02 12 5.8V2.5C12 2.5 4 6.5 4 13.5C4 17.92 7.58 21.5 12 21.5C16.42 21.5 20 17.92 20 13.5C20 10.54 18.39 7.88 16 6.5ZM12 19.5C10.9 19.5 10 18.63 10 17.56C10 17.05 10.2 16.57 10.58 16.2L12 14.8L13.43 16.2C13.8 16.57 14 17.05 14 17.56C14 18.63 13.1 19.5 12 19.5ZM15.96 18C16 17.64 16.18 16.11 14.83 14.78L12 12L9.17 14.78C7.81 16.12 8 17.66 8.04 18C6.79 16.9 6 15.29 6 13.5C6 10.34 8.13 7.85 10.03 6.25C10.26 8.24 11.96 9.8 14.02 9.8C14.8 9.8 15.56 9.57 16.2 9.14C17.34 10.28 18 11.85 18 13.5C18 15.29 17.21 16.9 15.96 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalFlorist(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_florist">
        <path
          id="Vector"
          d="M8.66 13.57C8.81 13.57 8.95 13.56 9.09 13.54C9.56 14.69 10.69 15.5 12 15.5C13.31 15.5 14.44 14.69 14.91 13.54C15.05 13.56 15.2 13.57 15.34 13.57C17.07 13.57 18.48 12.16 18.48 10.43C18.48 9.72 18.23 9.04 17.81 8.5C18.24 7.96 18.48 7.28 18.48 6.57C18.48 4.84 17.07 3.43 15.34 3.43C15.19 3.43 15.05 3.44 14.91 3.46C14.44 2.31 13.31 1.5 12 1.5C10.69 1.5 9.56 2.31 9.09 3.46C8.95 3.44 8.8 3.43 8.66 3.43C6.93 3.43 5.52 4.84 5.52 6.57C5.52 7.28 5.77 7.96 6.19 8.5C5.76 9.04 5.51 9.72 5.51 10.43C5.51 12.16 6.92 13.57 8.66 13.57ZM12 13.5C11.38 13.5 10.88 13.01 10.86 12.4L10.98 11.31C11.3 11.43 11.64 11.5 12 11.5C12.36 11.5 12.71 11.43 13.03 11.31L13.14 12.4C13.12 13.01 12.62 13.5 12 13.5ZM15.34 11.57C15.1 11.57 14.88 11.5 14.7 11.37L13.89 10.8C14.44 10.35 14.83 9.71 14.95 8.97L15.83 9.39C16.23 9.58 16.49 9.98 16.49 10.42C16.49 11.06 15.97 11.57 15.34 11.57ZM14.69 5.63C14.89 5.5 15.11 5.43 15.34 5.43C15.97 5.43 16.48 5.94 16.48 6.57C16.48 7.01 16.23 7.4 15.82 7.6L14.94 8.02C14.82 7.28 14.43 6.64 13.87 6.19L14.69 5.63ZM12 3.5C12.62 3.5 13.12 3.99 13.14 4.6L13.03 5.69C12.71 5.57 12.36 5.5 12 5.5C11.64 5.5 11.3 5.57 10.98 5.69L10.86 4.6C10.88 3.99 11.38 3.5 12 3.5ZM8.66 5.43C8.9 5.43 9.12 5.5 9.3 5.63L10.11 6.19C9.56 6.64 9.17 7.28 9.05 8.02L8.17 7.6C7.77 7.4 7.51 7.01 7.51 6.57C7.51 5.94 8.03 5.43 8.66 5.43ZM8.17 9.4L9.05 8.98C9.17 9.72 9.56 10.36 10.12 10.81L9.31 11.36C9.11 11.49 8.89 11.56 8.66 11.56C8.03 11.56 7.52 11.05 7.52 10.42C7.51 9.99 7.77 9.6 8.17 9.4ZM12 22.5C16.97 22.5 21 18.47 21 13.5C16.03 13.5 12 17.53 12 22.5ZM14.44 20.06C15.15 18.16 16.66 16.64 18.56 15.94C17.85 17.84 16.34 19.35 14.44 20.06ZM3 13.5C3 18.47 7.03 22.5 12 22.5C12 17.53 7.97 13.5 3 13.5ZM5.44 15.94C7.34 16.65 8.86 18.16 9.56 20.06C7.66 19.35 6.15 17.84 5.44 15.94Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalGasStation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_gas_station">
        <path
          id="Vector"
          d="M19.52 7.23L19.53 7.22L15.81 3.5L14.75 4.56L16.86 6.67C15.92 7.03 15.25 7.93 15.25 9C15.25 10.38 16.37 11.5 17.75 11.5C18.11 11.5 18.44 11.42 18.75 11.29V18.5C18.75 19.05 18.3 19.5 17.75 19.5C17.2 19.5 16.75 19.05 16.75 18.5V14C16.75 12.9 15.85 12 14.75 12H13.75V5C13.75 3.9 12.85 3 11.75 3H5.75C4.65 3 3.75 3.9 3.75 5V21H13.75V13.5H15.25V18.5C15.25 19.88 16.37 21 17.75 21C19.13 21 20.25 19.88 20.25 18.5V9C20.25 8.31 19.97 7.68 19.52 7.23ZM11.75 19H5.75V12H11.75V19ZM11.75 10H5.75V5H11.75V10ZM17.75 10C17.2 10 16.75 9.55 16.75 9C16.75 8.45 17.2 8 17.75 8C18.3 8 18.75 8.45 18.75 9C18.75 9.55 18.3 10 17.75 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalGroceryStore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_grocery_store">
        <path
          id="Vector"
          d="M7.99634 18C6.89634 18 6.00634 18.9 6.00634 20C6.00634 21.1 6.89634 22 7.99634 22C9.09634 22 9.99634 21.1 9.99634 20C9.99634 18.9 9.09634 18 7.99634 18ZM17.9963 18C16.8963 18 16.0063 18.9 16.0063 20C16.0063 21.1 16.8963 22 17.9963 22C19.0963 22 19.9963 21.1 19.9963 20C19.9963 18.9 19.0963 18 17.9963 18ZM16.5463 13C17.2963 13 17.9563 12.59 18.2963 11.97L21.8763 5.48C22.2463 4.82 21.7663 4 21.0063 4H6.20634L5.26634 2H1.99634V4H3.99634L7.59634 11.59L6.24634 14.03C5.51634 15.37 6.47634 17 7.99634 17H19.9963V15H7.99634L9.09634 13H16.5463ZM7.15634 6H19.3063L16.5463 11H9.52634L7.15634 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalHospital(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_hospital">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3.01 3.9 3.01 5L3 19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM10.5 17H13.5V13.5H17V10.5H13.5V7H10.5V10.5H7V13.5H10.5V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalHotel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_hotel">
        <path
          id="Vector"
          d="M7 13.5C8.66 13.5 10 12.16 10 10.5C10 8.84 8.66 7.5 7 7.5C5.34 7.5 4 8.84 4 10.5C4 12.16 5.34 13.5 7 13.5ZM7 9.5C7.55 9.5 8 9.95 8 10.5C8 11.05 7.55 11.5 7 11.5C6.45 11.5 6 11.05 6 10.5C6 9.95 6.45 9.5 7 9.5ZM19 6.5H11V14.5H3V4.5H1V19.5H3V16.5H21V19.5H23V10.5C23 8.29 21.21 6.5 19 6.5ZM21 14.5H13V8.5H19C20.1 8.5 21 9.4 21 10.5V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalLaundryService(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_laundry_service">
        <g id="Vector">
          <path
            d="M18 2.01L6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V4C20 2.89 19.11 2.01 18 2.01ZM18 20H6L5.99 4H18V20Z"
            fill="currentColor"
          />
          <path
            d="M8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7Z"
            fill="currentColor"
          />
          <path
            d="M11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7Z"
            fill="currentColor"
          />
          <path
            d="M12 19C14.76 19 17 16.76 17 14C17 11.24 14.76 9 12 9C9.24 9 7 11.24 7 14C7 16.76 9.24 19 12 19ZM14.36 11.64C15.66 12.94 15.66 15.06 14.36 16.36C13.06 17.66 10.94 17.66 9.64 16.36L14.36 11.64Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLocalLibrary(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_library">
        <path
          id="Vector"
          d="M12 9.22498C14.21 9.22498 16 7.43498 16 5.22498C16 3.01498 14.21 1.22498 12 1.22498C9.79 1.22498 8 3.01498 8 5.22498C8 7.43498 9.79 9.22498 12 9.22498ZM12 3.22498C13.1 3.22498 14 4.12498 14 5.22498C14 6.32498 13.1 7.22498 12 7.22498C10.9 7.22498 10 6.32498 10 5.22498C10 4.12498 10.9 3.22498 12 3.22498ZM12 11.775C9.64 9.57498 6.48 8.22498 3 8.22498V19.225C6.48 19.225 9.64 20.575 12 22.775C14.36 20.585 17.52 19.225 21 19.225V8.22498C17.52 8.22498 14.36 9.57498 12 11.775ZM19 17.355C16.47 17.695 14.07 18.655 12 20.175C9.94 18.655 7.53 17.685 5 17.345V10.395C7.1 10.775 9.05 11.745 10.64 13.225L12 14.505L13.36 13.235C14.95 11.755 16.9 10.785 19 10.405V17.355Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalMall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_mall">
        <path
          id="Vector"
          d="M19 6.5H17C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5H5C3.9 6.5 3 7.4 3 8.5V20.5C3 21.6 3.9 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V8.5C21 7.4 20.1 6.5 19 6.5ZM12 3.5C13.66 3.5 15 4.84 15 6.5H9C9 4.84 10.34 3.5 12 3.5ZM19 20.5H5V8.5H19V20.5ZM12 12.5C10.34 12.5 9 11.16 9 9.5H7C7 12.26 9.24 14.5 12 14.5C14.76 14.5 17 12.26 17 9.5H15C15 11.16 13.66 12.5 12 12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalMovies(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_movies">
        <path
          id="Vector"
          d="M14 5V19H10V5H14ZM20 3H18V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3ZM16 9V7H18V9H16ZM6 9V7H8V9H6ZM16 13V11H18V13H16ZM6 13V11H8V13H6ZM16 17V15H18V17H16ZM6 17V15H8V17H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalOffer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_offer">
        <g id="Vector">
          <path
            d="M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01Z"
            fill="currentColor"
          />
          <path
            d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLocalParking(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_parking">
        <path
          id="Vector"
          d="M12.5 3H5.5V21H9.5V15H12.5C15.81 15 18.5 12.31 18.5 9C18.5 5.69 15.81 3 12.5 3ZM12.7 11H9.5V7H12.7C13.8 7 14.7 7.9 14.7 9C14.7 10.1 13.8 11 12.7 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPharmacy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_pharmacy">
        <path
          id="Vector"
          d="M21 6H18.36L19.5 2.86L17.15 2L15.69 6H3V8L5 14L3 20V22H21V20L19 14L21 8V6ZM18.89 20H5.11L7.11 14L5.11 8H18.89L16.89 14L18.89 20ZM13 10H11V13H8V15H11V18H13V15H16V13H13V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPhone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_phone">
        <path
          id="Vector"
          d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPizza(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_pizza">
        <path
          id="Vector"
          d="M12 2C8.43001 2 5.23001 3.54 3.01001 6L12 22L20.99 6C18.78 3.55 15.57 2 12 2ZM12 17.92L5.51001 6.36C7.32001 4.85 9.62001 4 12 4C14.38 4 16.68 4.85 18.49 6.36L12 17.92ZM9.00001 5.5C8.17001 5.5 7.50001 6.17 7.50001 7C7.50001 7.83 8.17001 8.5 9.00001 8.5C9.83001 8.5 10.5 7.83 10.5 7C10.5 6.17 9.82001 5.5 9.00001 5.5ZM10.5 13C10.5 13.83 11.17 14.5 12 14.5C12.82 14.5 13.5 13.83 13.5 13C13.5 12.17 12.82 11.5 12 11.5C11.18 11.5 10.5 12.17 10.5 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPlay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_play">
        <path
          id="Vector"
          d="M22 10V6C22 4.9 21.1 4 20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM9.07 16L12 14.12L14.93 16L14.04 12.64L16.73 10.44L13.26 10.23L12 7L10.73 10.22L7.26 10.43L9.95 12.63L9.07 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPolice(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_police">
        <path
          id="Vector"
          d="M14.5 12.59L15.4 16.47L12 14.42L8.6 16.47L9.5 12.6L6.5 10.01L10.46 9.67L12 6.02L13.54 9.66L17.5 10L14.5 12.59ZM12 3.19L19 6.3V11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19ZM12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPostOffice(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_post_office">
        <path
          id="Vector"
          d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalPrintshop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_printshop">
        <g id="Vector">
          <path
            d="M19 8H18V3H6V8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM8 5H16V8H8V5ZM16 19H8V15H16V19ZM18 15V13H6V15H4V11C4 10.45 4.45 10 5 10H19C19.55 10 20 10.45 20 11V15H18Z"
            fill="currentColor"
          />
          <path
            d="M18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5C17 12.0523 17.4477 12.5 18 12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLocalSee(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_see">
        <path
          id="Vector"
          d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L8.64 6.35L9.88 5H14.12L15.36 6.35L15.95 7H20V19ZM12 8C9.24 8 7 10.24 7 13C7 15.76 9.24 18 12 18C14.76 18 17 15.76 17 13C17 10.24 14.76 8 12 8ZM12 16.2C10.23 16.2 8.8 14.77 8.8 13C8.8 11.23 10.23 9.8 12 9.8C13.77 9.8 15.2 11.23 15.2 13C15.2 14.77 13.77 16.2 12 16.2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalShipping(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_shipping">
        <path
          id="Vector"
          d="M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM19.5 9.5L21.46 12H17V9.5H19.5ZM6 18C5.45 18 5 17.55 5 17C5 16.45 5.45 16 6 16C6.55 16 7 16.45 7 17C7 17.55 6.55 18 6 18ZM8.22 15C7.67 14.39 6.89 14 6 14C5.11 14 4.33 14.39 3.78 15H3V6H15V15H8.22ZM18 18C17.45 18 17 17.55 17 17C17 16.45 17.45 16 18 16C18.55 16 19 16.45 19 17C19 17.55 18.55 18 18 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocalTaxi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="local_taxi">
        <g id="Vector">
          <path
            d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9V5H6.5C5.84 5 5.29 5.42 5.08 6.01L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21H20C20.55 21 21 20.55 21 20V12L18.92 6.01ZM6.85 7H17.14L18.18 10H5.81L6.85 7ZM19 17H5V12.34L5.12 12H18.89L19 12.34V17Z"
            fill="currentColor"
          />
          <path
            d="M7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16Z"
            fill="currentColor"
          />
          <path
            d="M16.5 16C17.3284 16 18 15.3284 18 14.5C18 13.6716 17.3284 13 16.5 13C15.6716 13 15 13.6716 15 14.5C15 15.3284 15.6716 16 16.5 16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLocationCity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="location_city">
        <path
          id="Vector"
          d="M15 11.5V5.5L12 2.5L9 5.5V7.5H3V21.5H21V11.5H15ZM7 19.5H5V17.5H7V19.5ZM7 15.5H5V13.5H7V15.5ZM7 11.5H5V9.5H7V11.5ZM13 19.5H11V17.5H13V19.5ZM13 15.5H11V13.5H13V15.5ZM13 11.5H11V9.5H13V11.5ZM13 7.5H11V5.5H13V7.5ZM19 19.5H17V17.5H19V19.5ZM19 15.5H17V13.5H19V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocationDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="location_disabled">
        <path
          id="Vector"
          d="M23 13V11H20.94C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C10.02 3.17 9.09 3.44 8.23 3.84L9.76 5.37C10.46 5.13 11.22 5 12 5C15.87 5 19 8.13 19 12C19 12.79 18.87 13.54 18.63 14.24L20.16 15.77C20.56 14.91 20.83 13.98 20.94 13H23ZM4.41 2.86L3 4.27L5.04 6.31C3.97 7.62 3.26 9.23 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C14.77 20.74 16.38 20.03 17.69 18.96L19.73 21L21.14 19.59L4.41 2.86ZM12 19C8.13 19 5 15.87 5 12C5 10.39 5.55 8.91 6.46 7.73L16.27 17.54C15.09 18.45 13.61 19 12 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocationOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="location_off">
        <path
          id="Vector"
          d="M12.9299 4C15.6899 4 17.9299 6.24 17.9299 9C17.9299 10.06 17.5399 11.32 16.9299 12.62L18.4199 14.11C19.2999 12.36 19.9299 10.57 19.9299 9C19.9299 5.13 16.7999 2 12.9299 2C11.0899 2 9.42993 2.71 8.17993 3.86L9.60993 5.29C10.4899 4.5 11.6499 4 12.9299 4ZM12.9299 6.5C12.3399 6.5 11.7999 6.71 11.3699 7.06L14.8699 10.56C15.2199 10.13 15.4299 9.59 15.4299 9C15.4299 7.62 14.3099 6.5 12.9299 6.5ZM4.33993 2.86L2.92993 4.27L6.10993 7.45C5.99993 7.95 5.92993 8.47 5.92993 9C5.92993 14.25 12.9299 22 12.9299 22C12.9299 22 14.5999 20.15 16.3099 17.65L19.6599 21L21.0699 19.59L4.33993 2.86ZM12.9299 18.88C10.9199 16.3 8.12993 12.14 7.94993 9.29L14.8699 16.21C14.2199 17.19 13.5399 18.1 12.9299 18.88Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLocationOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="location_on">
        <g id="Vector">
          <path
            d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z"
            fill="currentColor"
          />
          <path
            d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLocationSearching(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="location_searching">
        <path
          id="Vector"
          d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lock">
        <path
          id="Vector"
          d="M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM9 6.5C9 4.84 10.34 3.5 12 3.5C13.66 3.5 15 4.84 15 6.5V8.5H9V6.5ZM18 20.5H6V10.5H18V20.5ZM12 17.5C13.1 17.5 14 16.6 14 15.5C14 14.4 13.1 13.5 12 13.5C10.9 13.5 10 14.4 10 15.5C10 16.6 10.9 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLockClock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lock_clock">
        <g id="Vector">
          <path
            d="M4.5 20V10H16.5V11C17.2 11 17.87 11.1 18.5 11.29V10C18.5 8.9 17.6 8 16.5 8H15.5V6C15.5 3.24 13.26 1 10.5 1C7.74 1 5.5 3.24 5.5 6V8H4.5C3.4 8 2.5 8.9 2.5 10V20C2.5 21.1 3.4 22 4.5 22H10.76C10.34 21.4 10.01 20.72 9.79 20H4.5ZM7.5 6C7.5 4.34 8.84 3 10.5 3C12.16 3 13.5 4.34 13.5 6V8H7.5V6Z"
            fill="currentColor"
          />
          <path
            d="M16.5 13C13.74 13 11.5 15.24 11.5 18C11.5 20.76 13.74 23 16.5 23C19.26 23 21.5 20.76 21.5 18C21.5 15.24 19.26 13 16.5 13ZM18.15 20.35L16 18.2V15H17V17.79L18.85 19.64L18.15 20.35Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLockOpen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lock_open">
        <path
          id="Vector"
          d="M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5H9C9 4.84 10.34 3.5 12 3.5C13.66 3.5 15 4.84 15 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM18 20.5H6V10.5H18V20.5ZM12 17.5C13.1 17.5 14 16.6 14 15.5C14 14.4 13.1 13.5 12 13.5C10.9 13.5 10 14.4 10 15.5C10 16.6 10.9 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLockPerson(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lock_person">
        <g id="Vector">
          <path
            d="M4.5 20V10H16.5V11C17.2 11 17.87 11.1 18.5 11.29V10C18.5 8.9 17.6 8 16.5 8H15.5V6C15.5 3.24 13.26 1 10.5 1C7.74 1 5.5 3.24 5.5 6V8H4.5C3.4 8 2.5 8.9 2.5 10V20C2.5 21.1 3.4 22 4.5 22H10.76C10.34 21.4 10.01 20.72 9.79 20H4.5ZM7.5 6C7.5 4.34 8.84 3 10.5 3C12.16 3 13.5 4.34 13.5 6V8H7.5V6Z"
            fill="currentColor"
          />
          <path
            d="M16.5 13C13.74 13 11.5 15.24 11.5 18C11.5 20.76 13.74 23 16.5 23C19.26 23 21.5 20.76 21.5 18C21.5 15.24 19.26 13 16.5 13ZM16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15ZM16.5 21C15.47 21 14.56 20.48 14.02 19.68C14.75 19.26 15.59 19 16.5 19C17.41 19 18.25 19.26 18.98 19.68C18.44 20.48 17.53 21 16.5 21Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLockReset(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lock_reset">
        <path
          id="Vector"
          d="M13.62 3C8.65 3 4.62 7.03 4.62 12C4.62 12.06 4.63001 12.12 4.63001 12.19L2.79 10.35L1.38 11.76L5.62 16L9.86 11.76L8.45 10.35L6.63 12.17C6.63 12.11 6.62 12.06 6.62 12C6.62 8.14 9.76 5 13.62 5C17.48 5 20.62 8.14 20.62 12C20.62 15.86 17.48 19 13.62 19C11.72 19 10 18.24 8.74 17.01L7.32 18.42C8.94 20.01 11.17 21 13.62 21C18.59 21 22.62 16.97 22.62 12C22.62 7.03 18.59 3 13.62 3ZM15.62 11V10C15.62 8.9 14.72 8 13.62 8C12.52 8 11.62 8.9 11.62 10V11C11.07 11 10.62 11.45 10.62 12V15C10.62 15.55 11.07 16 11.62 16H15.62C16.17 16 16.62 15.55 16.62 15V12C16.62 11.45 16.17 11 15.62 11ZM14.62 11H12.62V10C12.62 9.45 13.07 9 13.62 9C14.17 9 14.62 9.45 14.62 10V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLogin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="login">
        <path
          id="Vector"
          d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLogoDev(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="logo_dev">
        <g id="Vector">
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM7.68 14.98H6V9H7.71C8.99 9 9.42 10.03 9.42 10.71V13.27C9.42 13.95 9 14.98 7.68 14.98ZM12.38 11.46V12.53H11.2V13.92H13.13V14.99H10.88C10.48 15 10.14 14.68 10.13 14.28V9.75C10.12 9.35 10.44 9.01 10.84 9H13.12V10.07H11.2V11.46H12.38ZM16.88 14.23C16.4 15.34 15.55 15.12 15.17 14.23L13.77 9H14.95L16.02 13.11L17.09 9H18.27L16.88 14.23Z"
            fill="currentColor"
          />
          <path
            d="M7.77 10.12H7.14V13.89H7.77C7.91 13.89 8.05 13.84 8.19 13.73C8.33 13.63 8.4 13.47 8.4 13.26V10.74C8.4 10.53 8.33 10.37 8.19 10.27C8.05 10.17 7.91 10.12 7.77 10.12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLogout(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="logout">
        <path
          id="Vector"
          d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooks(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks">
        <path
          id="Vector"
          d="M12 10.5C8.14 10.5 5 13.64 5 17.5H7C7 14.74 9.24 12.5 12 12.5C14.76 12.5 17 14.74 17 17.5H19C19 13.64 15.86 10.5 12 10.5ZM12 6.5C5.93 6.5 1 11.43 1 17.5H3C3 12.54 7.04 8.5 12 8.5C16.96 8.5 21 12.54 21 17.5H23C23 11.43 18.07 6.5 12 6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooks3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks_3">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15V13.5C15 12.67 14.33 12 13.5 12C14.33 12 15 11.33 15 10.5V9C15 7.89 14.1 7 13 7H9V9H13V11H11V13H13V15H9V17H13C14.1 17 15 16.11 15 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooks4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks_4">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM13 17H15V7H13V11H11V7H9V13H13V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooks5(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks_5">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15V13C15 11.89 14.1 11 13 11H11V9H15V7H9V13H13V15H9V17H13C14.1 17 15 16.11 15 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooks6(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks_6">
        <path
          id="Vector"
          d="M11 17H13C14.1 17 15 16.11 15 15V13C15 11.89 14.1 11 13 11H11V9H15V7H11C9.9 7 9 7.89 9 9V15C9 16.11 9.9 17 11 17ZM11 13H13V15H11V13ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooksOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks_one">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM12 17H14V7H10V9H12V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLooksTwo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="looks_two">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15H11V13H13C14.1 13 15 12.11 15 11V9C15 7.89 14.1 7 13 7H9V9H13V11H11C9.9 11 9 11.89 9 13V17H15V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLoop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="loop">
        <path
          id="Vector"
          d="M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLoupe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="loupe">
        <path
          id="Vector"
          d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22H20C21.1 22 22 21.1 22 20V12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLowPriority(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="low_priority">
        <path
          id="Vector"
          d="M14 4.5H22V6.5H14V4.5ZM14 10H22V12H14V10ZM14 15.5H22V17.5H14V15.5ZM2 11C2 14.58 4.92 17.5 8.5 17.5H9V19.5L12 16.5L9 13.5V15.5H8.5C6.02 15.5 4 13.48 4 11C4 8.52 6.02 6.5 8.5 6.5H12V4.5H8.5C4.92 4.5 2 7.42 2 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLoyalty(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="loyalty">
        <g id="Vector">
          <path
            d="M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01Z"
            fill="currentColor"
          />
          <path
            d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z"
            fill="currentColor"
          />
          <path
            d="M8.9 12.55C8.9 13.12 9.13 13.62 9.5 14L13 17.5L16.5 14C16.87 13.63 17.1 13.11 17.1 12.55C17.1 11.42 16.18 10.5 15.05 10.5C14.48 10.5 13.97 10.73 13.6 11.1L13 11.7L12.4 11.11C12.03 10.73 11.51 10.5 10.95 10.5C9.82 10.5 8.9 11.42 8.9 12.55Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLteMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lte_mobiledata">
        <path
          id="Vector"
          d="M5.5 14H8.5V16H3.5V8H5.5V14ZM8.5 10H10.5V16H12.5V10H14.5V8H8.5V10ZM20.5 10V8H15.5V16H20.5V14H17.5V13H20.5V11H17.5V10H20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLtePlusMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lte_plus_mobiledata">
        <path
          id="Vector"
          d="M2.5 14H5.5V16H0.5V8H2.5V14ZM4.5 10H6.5V16H8.5V10H10.5V8H4.5V10ZM11.5 16H16.5V14H13.5V13H16.5V11H13.5V10H16.5V8H11.5V16ZM23.5 11H21.5V9H19.5V11H17.5V13H19.5V15H21.5V13H23.5V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLuggage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="luggage">
        <path
          id="Vector"
          d="M9.5 18H8V9H9.5V18ZM12.75 18H11.25V9H12.75V18ZM16 18H14.5V9H16V18ZM17 6H15V3C15 2.45 14.55 2 14 2H10C9.45 2 9 2.45 9 3V6H7C5.9 6 5 6.9 5 8V19C5 20.1 5.9 21 7 21C7 21.55 7.45 22 8 22C8.55 22 9 21.55 9 21H15C15 21.55 15.45 22 16 22C16.55 22 17 21.55 17 21C18.1 21 19 20.1 19 19V8C19 6.9 18.1 6 17 6ZM10.5 3.5H13.5V6H10.5V3.5ZM17 19H7V8H17V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconLunchDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lunch_dining">
        <g id="Vector">
          <path
            d="M2 19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V16H2V19ZM4 18H20V19H4V18Z"
            fill="currentColor"
          />
          <path
            d="M18.66 11.5C16.71 11.5 16.57 12.5 15.33 12.5C14.14 12.5 13.91 11.5 12 11.5C10.05 11.5 9.91 12.5 8.67 12.5C7.48 12.5 7.25 11.5 5.34 11.5C3.39 11.5 3.25 12.5 2.01 12.5V14.5C3.91 14.5 4.18 13.5 5.36 13.5C6.55 13.5 6.78 14.5 8.69 14.5C10.64 14.5 10.78 13.5 12.02 13.5C13.21 13.5 13.44 14.5 15.35 14.5C17.3 14.5 17.44 13.5 18.68 13.5C19.87 13.5 20.08 14.48 22 14.5L21.99 12.52C20.38 12.19 20.37 11.5 18.66 11.5Z"
            fill="currentColor"
          />
          <path
            d="M22 9C22.02 5 17.72 3 12 3C6.29 3 2 5 2 9V10H22V9ZM4.18 8C5.01 5.81 8.61 5 12 5C15.31 5 17.93 5.73 19.19 6.99C19.49 7.3 19.71 7.63 19.84 8H4.18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconLyrics(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lyrics">
        <g id="Vector">
          <path d="M12 6.5H5V8.5H12V6.5Z" fill="currentColor" />
          <path d="M9 12.5H5V14.5H9V12.5Z" fill="currentColor" />
          <path
            d="M14 12.47V16.5H5L3 18.5V4.5H14V6.53C14.52 5.84 15.2 5.28 16 4.93V4.5C16 3.4 15.1 2.5 14 2.5H3C1.9 2.5 1.01 3.4 1.01 4.5L1 22.5L5 18.5H14C15.1 18.5 16 17.6 16 16.5V14.08C15.2 13.72 14.52 13.16 14 12.47Z"
            fill="currentColor"
          />
          <path d="M12 9.5H5V11.5H12V9.5Z" fill="currentColor" />
          <path
            d="M19 6.68C18.69 6.57 18.35 6.5 18 6.5C16.34 6.5 15 7.84 15 9.5C15 11.16 16.34 12.5 18 12.5C19.66 12.5 21 11.16 21 9.5V3.5H23V1.5H19V6.68Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMacroOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="macro_off">
        <g id="Vector">
          <path
            d="M9.3701 5.13001C9.6101 5.13001 9.8301 5.20001 10.0101 5.33001L10.8201 5.89001C10.5301 6.13001 10.2801 6.43001 10.1001 6.76001L11.7601 8.42001C11.7401 8.34001 11.7101 8.28001 11.7101 8.20001C11.7101 7.65001 12.1601 7.20001 12.7101 7.20001C13.2601 7.20001 13.7101 7.65001 13.7101 8.20001C13.7101 8.75001 13.2601 9.20001 12.7101 9.20001C12.6301 9.20001 12.5701 9.17001 12.4901 9.16001L16.5501 13.22C18.0401 12.98 19.1801 11.69 19.1801 10.13C19.1801 9.42001 18.9301 8.74001 18.5101 8.20001C18.9401 7.66001 19.1801 6.98001 19.1801 6.27001C19.1801 4.54001 17.7701 3.13001 16.0401 3.13001C15.8901 3.13001 15.7501 3.14001 15.6101 3.16001C15.1501 2.01001 14.0201 1.20001 12.7101 1.20001C11.4001 1.20001 10.2701 2.01001 9.8001 3.16001C9.6601 3.14001 9.5101 3.13001 9.3701 3.13001C8.5701 3.13001 7.8401 3.44001 7.2801 3.94001L8.7001 5.36001C8.9001 5.23001 9.1201 5.13001 9.3701 5.13001ZM16.0501 11.27C15.8101 11.27 15.5901 11.2 15.4101 11.07L14.6001 10.5C15.1501 10.05 15.5401 9.41001 15.6601 8.67001L16.5401 9.09001C16.9401 9.28001 17.2001 9.68001 17.2001 10.12C17.2001 10.76 16.6801 11.27 16.0501 11.27ZM15.4001 5.33001C15.6001 5.20001 15.8201 5.13001 16.0501 5.13001C16.6801 5.13001 17.1901 5.64001 17.1901 6.27001C17.1901 6.71001 16.9401 7.10001 16.5301 7.30001L15.6501 7.72001C15.5301 6.98001 15.1401 6.34001 14.5801 5.89001L15.4001 5.33001ZM12.7101 3.20001C13.3301 3.20001 13.8301 3.69001 13.8501 4.30001L13.7401 5.39001C13.4201 5.27001 13.0701 5.20001 12.7101 5.20001C12.3501 5.20001 12.0101 5.27001 11.6901 5.39001L11.5701 4.30001C11.5901 3.69001 12.0901 3.20001 12.7101 3.20001Z"
            fill="currentColor"
          />
          <path
            d="M20.6901 17.35C21.3401 16.11 21.7101 14.7 21.7101 13.2C20.2101 13.2 18.8001 13.57 17.5601 14.22L20.6901 17.35Z"
            fill="currentColor"
          />
          <path
            d="M3.7101 13.2C3.7101 18.17 7.7401 22.2 12.7101 22.2C12.7101 17.23 8.6801 13.2 3.7101 13.2ZM6.1501 15.64C8.0501 16.35 9.5701 17.86 10.2701 19.76C8.3701 19.05 6.8601 17.54 6.1501 15.64Z"
            fill="currentColor"
          />
          <path
            d="M3.5201 3.01001L2.1001 4.42001L6.5201 8.84001C6.3301 9.24001 6.2201 9.68001 6.2201 10.13C6.2201 11.86 7.6301 13.27 9.3701 13.27C9.5201 13.27 9.6601 13.26 9.8001 13.24C10.2701 14.39 11.4001 15.2 12.7101 15.2C12.7601 15.2 12.8201 15.19 12.8701 15.19L14.5101 16.83C13.3801 18.32 12.7101 20.18 12.7101 22.2C14.7301 22.2 16.5901 21.53 18.0901 20.4L20.4901 22.8L21.9001 21.39L3.5201 3.01001ZM15.1501 19.76C15.3501 19.22 15.6201 18.72 15.9401 18.26L16.6601 18.98C16.1901 19.29 15.6901 19.56 15.1501 19.76Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMailLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mail_lock">
        <g id="Vector">
          <path
            d="M3 8L11 13L19 8V10H21V6C21 4.9 20.1 4 19 4H3C1.9 4 1.01 4.9 1.01 6L1 18C1 19.1 1.9 20 3 20H15V18H3V8ZM19 6L11 11L3 6H19Z"
            fill="currentColor"
          />
          <path
            d="M22 15V14C22 12.9 21.1 12 20 12C18.9 12 18 12.9 18 14V15C17.45 15 17 15.45 17 16V19C17 19.55 17.45 20 18 20H22C22.55 20 23 19.55 23 19V16C23 15.45 22.55 15 22 15ZM19 15V14C19 13.45 19.45 13 20 13C20.55 13 21 13.45 21 14V15H19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMale(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="male">
        <path
          id="Vector"
          d="M9.5 11C11.43 11 13 12.57 13 14.5C13 16.43 11.43 18 9.5 18C7.57 18 6 16.43 6 14.5C6 12.57 7.57 11 9.5 11ZM9.5 9C6.46 9 4 11.46 4 14.5C4 17.54 6.46 20 9.5 20C12.54 20 15 17.54 15 14.5C15 13.34 14.64 12.27 14.03 11.38L18 7.42V10H20V4H14V6H16.58L12.61 9.97C11.73 9.36 10.66 9 9.5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMan(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="man">
        <g id="Vector">
          <path
            d="M14 7H10C8.9 7 8 7.9 8 9V15H10V22H14V15H16V9C16 7.9 15.1 7 14 7Z"
            fill="currentColor"
          />
          <path
            d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMan2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="man_2">
        <g id="Vector">
          <path
            d="M14 7H10C8.9 7 8 7.9 8 9V15H10.5V22H13.5V15H16V9C16 7.9 15.1 7 14 7Z"
            fill="currentColor"
          />
          <path
            d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMan3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="man_3">
        <g id="Vector">
          <path
            d="M14 7.12429H10C8.9 7.12429 8 8.02429 8 9.12429V15.1243H10V22.1243H14V15.1243H16V9.12429C16 8.02429 15.1 7.12429 14 7.12429Z"
            fill="currentColor"
          />
          <path
            d="M14.2485 4.12419L11.9999 1.87561L9.75132 4.12419L11.9999 6.37277L14.2485 4.12419Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMan4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="man_4">
        <g id="Vector">
          <path
            d="M13.7499 7H10.2499C9.0399 7 8.1099 8.07 8.2699 9.26L9.9999 22H13.9999L15.7299 9.26C15.8899 8.07 14.9599 7 13.7499 7Z"
            fill="currentColor"
          />
          <path
            d="M11.9999 6C13.1045 6 13.9999 5.10457 13.9999 4C13.9999 2.89543 13.1045 2 11.9999 2C10.8953 2 9.9999 2.89543 9.9999 4C9.9999 5.10457 10.8953 6 11.9999 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconManageAccounts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="manage_accounts">
        <g id="Vector">
          <path
            d="M4.08496 17.5V16.85C4.08496 16.51 4.24496 16.19 4.49496 16.04C6.18496 15.03 8.11496 14.5 10.085 14.5C10.115 14.5 10.135 14.5 10.165 14.51C10.265 13.81 10.465 13.14 10.755 12.53C10.535 12.51 10.315 12.5 10.085 12.5C7.66496 12.5 5.40496 13.17 3.47496 14.32C2.59496 14.84 2.08496 15.82 2.08496 16.85V19.5H11.345C10.925 18.9 10.595 18.22 10.375 17.5H4.08496Z"
            fill="currentColor"
          />
          <path
            d="M10.085 11.5C12.295 11.5 14.085 9.71 14.085 7.5C14.085 5.29 12.295 3.5 10.085 3.5C7.87496 3.5 6.08496 5.29 6.08496 7.5C6.08496 9.71 7.87496 11.5 10.085 11.5ZM10.085 5.5C11.185 5.5 12.085 6.4 12.085 7.5C12.085 8.6 11.185 9.5 10.085 9.5C8.98496 9.5 8.08496 8.6 8.08496 7.5C8.08496 6.4 8.98496 5.5 10.085 5.5Z"
            fill="currentColor"
          />
          <path
            d="M20.835 15.5C20.835 15.28 20.805 15.08 20.775 14.87L21.915 13.86L20.915 12.13L19.465 12.62C19.145 12.35 18.785 12.14 18.385 11.99L18.085 10.5H16.085L15.785 11.99C15.385 12.14 15.025 12.35 14.705 12.62L13.255 12.13L12.255 13.86L13.395 14.87C13.365 15.08 13.335 15.28 13.335 15.5C13.335 15.72 13.365 15.92 13.395 16.13L12.255 17.14L13.255 18.87L14.705 18.38C15.025 18.65 15.385 18.86 15.785 19.01L16.085 20.5H18.085L18.385 19.01C18.785 18.86 19.145 18.65 19.465 18.38L20.915 18.87L21.915 17.14L20.775 16.13C20.805 15.92 20.835 15.72 20.835 15.5ZM17.085 17.5C15.985 17.5 15.085 16.6 15.085 15.5C15.085 14.4 15.985 13.5 17.085 13.5C18.185 13.5 19.085 14.4 19.085 15.5C19.085 16.6 18.185 17.5 17.085 17.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconManageHistory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="manage_history">
        <path
          id="Vector"
          d="M21.275 16.87L22.415 15.87L21.415 14.14L19.965 14.63C19.645 14.36 19.285 14.15 18.885 14L18.585 12.5H16.585L16.285 13.99C15.885 14.14 15.525 14.35 15.205 14.62L13.755 14.13L12.755 15.86L13.895 16.86C13.815 17.36 13.815 17.62 13.895 18.12L12.755 19.12L13.755 20.85L15.205 20.36C15.525 20.63 15.885 20.84 16.285 20.99L16.585 22.5H18.585L18.885 21.01C19.285 20.86 19.645 20.65 19.965 20.38L21.415 20.87L22.415 19.14L21.275 18.14C21.355 17.63 21.355 17.37 21.275 16.87ZM17.585 19.5C16.485 19.5 15.585 18.6 15.585 17.5C15.585 16.4 16.485 15.5 17.585 15.5C18.685 15.5 19.585 16.4 19.585 17.5C19.585 18.6 18.685 19.5 17.585 19.5ZM9.58496 5.5V10.91L11.945 13.27L12.985 11.48L11.585 10.09V5.5H9.58496ZM19.585 10.5C19.585 5.53 15.555 1.5 10.585 1.5C7.75496 1.5 5.23496 2.82 3.58496 4.86V2.5H1.58496V8.5H7.58496V6.5H4.84496C6.11496 4.69 8.21496 3.5 10.585 3.5C14.445 3.5 17.585 6.64 17.585 10.5H19.585ZM9.44496 17.41C6.45496 16.92 4.09496 14.51 3.66496 11.5H1.64496C2.14496 16 5.95496 19.5 10.585 19.5C10.605 19.5 10.635 19.5 10.655 19.5L9.44496 17.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconManageSearch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="manage_search">
        <path
          id="Vector"
          d="M7 8.5H2V6.5H7V8.5ZM7 11.5H2V13.5H7V11.5ZM20.59 18.5L16.76 14.67C15.96 15.19 15.02 15.5 14 15.5C11.24 15.5 9 13.26 9 10.5C9 7.74 11.24 5.5 14 5.5C16.76 5.5 19 7.74 19 10.5C19 11.52 18.69 12.46 18.17 13.25L22 17.09L20.59 18.5ZM17 10.5C17 8.85 15.65 7.5 14 7.5C12.35 7.5 11 8.85 11 10.5C11 12.15 12.35 13.5 14 13.5C15.65 13.5 17 12.15 17 10.5ZM2 18.5H12V16.5H2V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMap(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="map">
        <path
          id="Vector"
          d="M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3ZM10 5.47L14 6.87V18.53L10 17.13V5.47ZM5 6.46L8 5.45V17.15L5 18.31V6.46ZM19 17.54L16 18.55V6.86L19 5.7V17.54Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMapsHomeWork(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="maps_home_work">
        <g id="Vector">
          <path d="M19 7H17V9H19V7Z" fill="currentColor" />
          <path d="M19 11H17V13H19V11Z" fill="currentColor" />
          <path d="M19 15H17V17H19V15Z" fill="currentColor" />
          <path
            d="M1 11V21H7V16H9V21H15V11L8 6L1 11ZM13 19H11V14H5V19H3V12L8 8.5L13 12V19Z"
            fill="currentColor"
          />
          <path d="M10 3V4.97L12 6.4V5H21V19H17V21H23V3H10Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMapsUgc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="maps_ugc">
        <g id="Vector">
          <path
            d="M12.5 3.5C16.91 3.5 20.5 7.09 20.5 11.5C20.5 15.91 16.91 19.5 12.5 19.5C11.32 19.5 10.16 19.24 9.07 18.72C8.8 18.59 8.51 18.53 8.21 18.53C8.02 18.53 7.83 18.56 7.65 18.61L4.45 19.55L5.39 16.35C5.53 15.88 5.49 15.37 5.28 14.93C4.76 13.84 4.5 12.68 4.5 11.5C4.5 7.09 8.09 3.5 12.5 3.5ZM12.5 1.5C6.98 1.5 2.5 5.98 2.5 11.5C2.5 13.04 2.86 14.48 3.47 15.79L1.5 22.5L8.21 20.53C9.52 21.14 10.96 21.5 12.5 21.5C18.02 21.5 22.5 17.02 22.5 11.5C22.5 5.98 18.02 1.5 12.5 1.5Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 7.5H11.5V10.5H8.5V12.5H11.5V15.5H13.5V12.5H16.5V10.5H13.5V7.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMargin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="margin">
        <path
          id="Vector"
          d="M3 3V21H21V3H3ZM19 19H5V5H19V19ZM11 7H13V9H11V7ZM7 7H9V9H7V7ZM15 7H17V9H15V7ZM7 11H9V13H7V11ZM11 11H13V13H11V11ZM15 11H17V13H15V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMarkAsUnread(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mark_as_unread">
        <g id="Vector">
          <path
            d="M16.23 7.5H18.83C18.77 7.03 18.47 6.56 18.04 6.33L10.5 2.5L2.8 6.33C2.32 6.59 2 7.14 2 7.67V15.5C2 16.6 2.9 17.5 4 17.5V7.9L10.5 4.5L16.23 7.5Z"
            fill="currentColor"
          />
          <path
            d="M20 8.5H7C5.9 8.5 5 9.4 5 10.5V19.5C5 20.6 5.9 21.5 7 21.5H20C21.1 21.5 22 20.6 22 19.5V10.5C22 9.4 21.1 8.5 20 8.5ZM20 19.5H7V12.5L13.5 15.83L20 12.5V19.5ZM13.5 13.83L7 10.5H20L13.5 13.83Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMarkChatRead(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mark_chat_read">
        <path
          id="Vector"
          d="M11.5 18H5.5L1.5 22V4C1.5 2.9 2.4 2 3.5 2H19.5C20.6 2 21.5 2.9 21.5 4V11H19.5V4H3.5V16H11.5V18ZM22.5 14.34L21.09 12.93L16.85 17.17L14.73 15.05L13.32 16.46L16.84 20L22.5 14.34Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMarkChatUnread(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mark_chat_unread">
        <path
          id="Vector"
          d="M22 7.98V17C22 18.1 21.1 19 20 19H6L2 23V5C2 3.9 2.9 3 4 3H14.1C14.04 3.32 14 3.66 14 4C14 4.34 14.04 4.68 14.1 5H4V17H20V8.9C20.74 8.75 21.42 8.42 22 7.98ZM16 4C16 5.66 17.34 7 19 7C20.66 7 22 5.66 22 4C22 2.34 20.66 1 19 1C17.34 1 16 2.34 16 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMarkEmailRead(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mark_email_read">
        <path
          id="Vector"
          d="M19.5 3H3.5C2.4 3 1.51 3.9 1.51 5L1.5 17C1.5 18.1 2.4 19 3.5 19H11.5V17H3.5V7L11.5 12L19.5 7V12H21.5V5C21.5 3.9 20.6 3 19.5 3ZM11.5 10L3.5 5H19.5L11.5 10ZM16.84 21L13.3 17.46L14.71 16.05L16.83 18.17L21.07 13.93L22.5 15.34L16.84 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMarkEmailUnread(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mark_email_unread">
        <path
          id="Vector"
          d="M22 9.98V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19L2.01 7C2.01 5.9 2.9 5 4 5H14.1C14.04 5.32 14 5.66 14 6C14 6.34 14.04 6.68 14.1 7H4L12 12L15.67 9.71C16.14 10.14 16.69 10.47 17.3 10.69L12 14L4 9V19H20V10.9C20.74 10.75 21.42 10.42 22 9.98ZM16 6C16 7.66 17.34 9 19 9C20.66 9 22 7.66 22 6C22 4.34 20.66 3 19 3C17.34 3 16 4.34 16 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMarkUnreadChatAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mark_unread_chat_alt">
        <g id="Vector">
          <path
            d="M20 17H4V5H14.1C14.02 4.61 13.92 3.89 14.1 3H4C2.9 3 2 3.9 2 5V23L6 19H20C21.1 19 22 18.1 22 17V7.98C21.42 8.42 20.74 8.75 20 8.9V17Z"
            fill="currentColor"
          />
          <path
            d="M19 7C20.6569 7 22 5.65685 22 4C22 2.34315 20.6569 1 19 1C17.3431 1 16 2.34315 16 4C16 5.65685 17.3431 7 19 7Z"
            fill="currentColor"
          />
          <path d="M14 13H6V15H14V13Z" fill="currentColor" />
          <path d="M18 10H6V12H18V10Z" fill="currentColor" />
          <path d="M6 9H18V8.9C16.79 8.65 15.75 7.95 15.03 7H6V9Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMarkunreadMailbox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="markunread_mailbox">
        <path
          id="Vector"
          d="M20 7H10V9H20V21H4V9H6V13H8V5H14V1H6V7H4C2.9 7 2 7.9 2 9V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V9C22 7.9 21.1 7 20 7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMasks(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="masks">
        <path
          id="Vector"
          d="M19.5 6C18.19 6 17.13 7.01 17.02 8.3C15.14 7.8 14.18 6.5 12 6.5C9.81 6.5 8.86 7.8 6.98 8.3C6.87 7.02 5.81 6 4.5 6C3.12 6 2 7.12 2 8.5V9C2 15 5.6 16.81 8.52 16.98C9.53 17.62 10.72 18 12 18C13.28 18 14.47 17.62 15.48 16.98C18.4 16.81 22 15 22 9V8.5C22 7.12 20.88 6 19.5 6ZM3.5 9V8.5C3.5 7.95 3.95 7.5 4.5 7.5C5.05 7.5 5.5 7.95 5.5 8.5V11.5C5.5 12.78 5.88 13.97 6.51 14.98C4.99 14.27 3.5 12.65 3.5 9ZM7 11.5V9.85C8.12 9.62 8.95 9.16 9.66 8.77C10.48 8.33 11.07 8 12 8C12.93 8 13.52 8.33 14.34 8.78C15.05 9.17 15.88 9.62 17 9.86V11.51C17 14.27 14.76 16.51 12 16.51C9.24 16.51 7 14.26 7 11.5ZM20.5 9C20.5 12.65 19.01 14.27 17.49 14.98C18.13 13.97 18.5 12.78 18.5 11.5V8.5C18.5 7.95 18.95 7.5 19.5 7.5C20.05 7.5 20.5 7.95 20.5 8.5V9ZM10.69 10.48C10.25 10.74 9.73 11.04 9 11.24V10.2C9.48 10.03 9.84 9.82 10.18 9.62C10.72 9.3 11.23 9 12 9C12.77 9 13.27 9.3 13.8 9.62C14.14 9.82 14.51 10.04 15 10.21V11.25C14.25 11.04 13.74 10.74 13.29 10.47C12.83 10.2 12.49 10 12 10C11.51 10 11.16 10.2 10.69 10.48Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMaximize(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="maximize">
        <path id="Vector" d="M3 11H21V13H3V11Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconMediaBluetoothOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="media_bluetooth_off">
        <path
          id="Vector"
          d="M9.30507 5.46498V2.29498H15.3051V6.29498H11.3051V7.46498L9.30507 5.46498ZM19.7251 14.295L22.3051 16.865L21.5051 17.665L14.7251 10.885L15.5251 10.085L18.2751 12.835V8.29498H18.8751L22.3051 11.725L19.7251 14.295ZM19.4751 12.845L20.6051 11.715L19.4751 10.585V12.845ZM21.4951 20.485L20.0851 21.895L16.1051 17.915L15.5251 18.495L14.6751 17.645L15.2551 17.065L11.3051 13.125V16.295C11.3051 18.505 9.52507 20.295 7.31507 20.295C5.10507 20.295 3.30507 18.505 3.30507 16.295C3.30507 14.085 5.09507 12.295 7.31507 12.295C8.04507 12.295 8.72507 12.505 9.31507 12.845V11.125L1.69507 3.51498L3.10507 2.10498L21.4951 20.485Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMediaBluetoothOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="media_bluetooth_on">
        <path
          id="Vector"
          d="M9 3L9.01 13.55C8.41 13.21 7.73 13 7.01 13C4.79 13 3 14.79 3 17C3 19.21 4.79 21 7.01 21C9.23 21 11 19.21 11 17V7H15V3H9ZM21 12.43L17.57 9H16.97V13.55L14.22 10.8L13.37 11.65L16.73 15L13.38 18.35L14.23 19.2L16.98 16.45V21H17.58L21 17.57L18.42 15L21 12.43ZM18.17 11.3L19.3 12.43L18.17 13.56V11.3ZM19.3 17.57L18.17 18.7V16.44L19.3 17.57Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMediation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mediation">
        <path
          id="Vector"
          d="M18 16L22 12L18 8V11H12.94C12.6 7.9 10.68 5.28 8 3.95C7.96 2.31 6.64 1 5 1C3.34 1 2 2.34 2 4C2 5.66 3.34 7 5 7C5.95 7 6.78 6.55 7.33 5.86C9.23 6.9 10.6 8.77 10.92 11H7.82C7.4 9.84 6.3 9 5 9C3.34 9 2 10.34 2 12C2 13.66 3.34 15 5 15C6.3 15 7.4 14.16 7.82 13H10.92C10.6 15.23 9.23 17.1 7.34 18.14C6.78 17.45 5.95 17 5 17C3.34 17 2 18.34 2 20C2 21.66 3.34 23 5 23C6.64 23 7.96 21.69 7.99 20.05C10.67 18.72 12.59 16.1 12.93 13H18V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMedicalInformation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="medical_information">
        <path
          id="Vector"
          d="M20 7H15V4C15 2.9 14.1 2 13 2H11C9.9 2 9 2.9 9 4V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM11 4H13V9H11V4ZM20 20H4V9H9C9 10.1 9.9 11 11 11H13C14.1 11 15 10.1 15 9H20V20ZM11 16H9V18H7V16H5V14H7V12H9V14H11V16ZM13 14.5V13H19V14.5H13ZM13 17.5V16H17V17.5H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMedicalServices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="medical_services">
        <g id="Vector">
          <path
            d="M20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6ZM10 4H14V6H10V4ZM20 20H4V8H20V20Z"
            fill="currentColor"
          />
          <path d="M13 10H11V13H8V15H11V18H13V15H16V13H13V10Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMedication(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="medication">
        <path
          id="Vector"
          d="M10.5 15H8V12H10.5V9.5H13.5V12H16V15H13.5V17.5H10.5V15ZM19 8V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V8C5 6.9 5.9 6 7 6H17C18.1 6 19 6.9 19 8ZM17 8H7V19H17V8ZM18 3H6V5H18V3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMedicationLiquid(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="medication_liquid">
        <g id="Vector">
          <path d="M14.5 3H2.5V5H14.5V3Z" fill="currentColor" />
          <path
            d="M1.5 21H15.5V6H1.5V21ZM4.5 12H7V9.5H10V12H12.5V15H10V17.5H7V15H4.5V12Z"
            fill="currentColor"
          />
          <path
            d="M19.5 6C17.82 6 16.5 7.76 16.5 10C16.5 11.77 17.33 13.22 18.5 13.76V21H20.5V13.76C21.67 13.22 22.5 11.77 22.5 10C22.5 7.76 21.18 6 19.5 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMeetingRoom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="meeting_room">
        <path
          id="Vector"
          d="M19 19V4H15V3H5V19H3V21H15V6H17V21H21V19H19ZM13 19H7V5H13V19ZM10 11H12V13H10V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMemory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="memory">
        <path
          id="Vector"
          d="M15 9H9V15H15V9ZM13 13H11V11H13V13ZM21 11V9H19V7C19 5.9 18.1 5 17 5H15V3H13V5H11V3H9V5H7C5.9 5 5 5.9 5 7V9H3V11H5V13H3V15H5V17C5 18.1 5.9 19 7 19H9V21H11V19H13V21H15V19H17C18.1 19 19 18.1 19 17V15H21V13H19V11H21ZM17 17H7V7H17V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMenu(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="menu">
        <path
          id="Vector"
          d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMenuBook(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="menu_book">
        <g id="Vector">
          <path
            d="M21 4C19.89 3.65 18.67 3.5 17.5 3.5C15.55 3.5 13.45 3.9 12 5C10.55 3.9 8.45 3.5 6.5 3.5C4.55 3.5 2.45 3.9 1 5V19.65C1 19.9 1.25 20.15 1.5 20.15C1.6 20.15 1.65 20.1 1.75 20.1C3.1 19.45 5.05 19 6.5 19C8.45 19 10.55 19.4 12 20.5C13.35 19.65 15.8 19 17.5 19C19.15 19 20.85 19.3 22.25 20.05C22.35 20.1 22.4 20.1 22.5 20.1C22.75 20.1 23 19.85 23 19.6V5C22.4 4.55 21.75 4.25 21 4ZM21 17.5C19.9 17.15 18.7 17 17.5 17C15.8 17 13.35 17.65 12 18.5V7C13.35 6.15 15.8 5.5 17.5 5.5C18.7 5.5 19.9 5.65 21 6V17.5Z"
            fill="currentColor"
          />
          <path
            d="M17.5 9.5C18.38 9.5 19.23 9.59 20 9.76V8.24C19.21 8.09 18.36 8 17.5 8C15.8 8 14.26 8.29 13 8.83V10.49C14.13 9.85 15.7 9.5 17.5 9.5Z"
            fill="currentColor"
          />
          <path
            d="M13 11.49V13.15C14.13 12.51 15.7 12.16 17.5 12.16C18.38 12.16 19.23 12.25 20 12.42V10.9C19.21 10.75 18.36 10.66 17.5 10.66C15.8 10.66 14.26 10.96 13 11.49Z"
            fill="currentColor"
          />
          <path
            d="M17.5 13.33C15.8 13.33 14.26 13.62 13 14.16V15.82C14.13 15.18 15.7 14.83 17.5 14.83C18.38 14.83 19.23 14.92 20 15.09V13.57C19.21 13.41 18.36 13.33 17.5 13.33Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMenuOpen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="menu_open">
        <path
          id="Vector"
          d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMerge(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="merge">
        <path
          id="Vector"
          d="M6.41 21L5 19.59L9.83 14.76C10.58 14.01 11 12.99 11 11.93V6.83L9.41 8.41L8 7L12 3L16 7L14.59 8.41L13 6.83V11.93C13 12.99 13.42 14.01 14.17 14.76L19 19.59L17.59 21L12 15.41L6.41 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMergeType(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="merge_type">
        <path
          id="Vector"
          d="M17.0001 20.455L18.4101 19.045L15.0001 15.635L13.5901 17.045L17.0001 20.455ZM7.50009 8.04504H11.0001V13.635L5.59009 19.045L7.00009 20.455L13.0001 14.455V8.04504H16.5001L12.0001 3.54504L7.50009 8.04504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMessage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="message">
        <path
          id="Vector"
          d="M4 4H20V16H5.17L4 17.17V4ZM4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM6 12H18V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mic">
        <g id="Vector">
          <path
            d="M12 14.5C13.66 14.5 15 13.16 15 11.5V5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5Z"
            fill="currentColor"
          />
          <path
            d="M17 11.5C17 14.26 14.76 16.5 12 16.5C9.24 16.5 7 14.26 7 11.5H5C5 15.03 7.61 17.93 11 18.42V21.5H13V18.42C16.39 17.93 19 15.03 19 11.5H17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMicExternalOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mic_external_off">
        <g id="Vector">
          <path
            d="M10.705 4.33997C10.705 2.67997 9.36502 1.33997 7.70502 1.33997C7.08502 1.33997 6.51502 1.52997 6.03502 1.83997L10.185 5.98997C10.505 5.51997 10.705 4.94997 10.705 4.33997Z"
            fill="currentColor"
          />
          <path
            d="M14.705 5.33997C14.705 4.23997 15.605 3.33997 16.705 3.33997C17.805 3.33997 18.705 4.23997 18.705 5.33997V14.51L20.705 16.51V5.33997C20.705 3.12997 18.915 1.33997 16.705 1.33997C14.495 1.33997 12.705 3.12997 12.705 5.33997V8.50997L14.705 10.51V5.33997Z"
            fill="currentColor"
          />
          <path
            d="M2.80502 1.43997L1.39502 2.84997L5.87502 7.33997H4.70502L5.70502 17.34H6.70502C6.70502 19.55 8.49502 21.34 10.705 21.34C12.915 21.34 14.705 19.55 14.705 17.34V16.17L21.195 22.66L22.605 21.25L2.80502 1.43997ZM7.89502 15.34H7.51502L6.91502 9.33997H7.87502L8.43502 9.89997L7.89502 15.34ZM12.705 17.34C12.705 18.44 11.805 19.34 10.705 19.34C9.60502 19.34 8.70502 18.44 8.70502 17.34H9.70502L10.265 11.73L12.705 14.17V17.34Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMicExternalOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mic_external_on">
        <g id="Vector">
          <path
            d="M9.22 7C9.7 6.47 10 5.77 10 5C10 3.34 8.66 2 7 2C5.34 2 4 3.34 4 5C4 5.77 4.3 6.47 4.78 7H9.22Z"
            fill="currentColor"
          />
          <path
            d="M16 2C13.79 2 12 3.79 12 6V18C12 19.1 11.1 20 10 20C8.9 20 8 19.1 8 18H9L10 8H4L5 18H6C6 20.21 7.79 22 10 22C12.21 22 14 20.21 14 18V6C14 4.9 14.9 4 16 4C17.1 4 18 4.9 18 6V22H20V6C20 3.79 18.21 2 16 2ZM7.19 16H6.81L6.21 10H7.79L7.19 16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMicNone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mic_none">
        <path
          id="Vector"
          d="M12 14.5C13.66 14.5 15 13.16 15 11.5V5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5ZM11 5.5C11 4.95 11.45 4.5 12 4.5C12.55 4.5 13 4.95 13 5.5V11.5C13 12.05 12.55 12.5 12 12.5C11.45 12.5 11 12.05 11 11.5V5.5ZM17 11.5C17 14.26 14.76 16.5 12 16.5C9.24 16.5 7 14.26 7 11.5H5C5 15.03 7.61 17.93 11 18.42V21.5H13V18.42C16.39 17.93 19 15.03 19 11.5H17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMicOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mic_off">
        <path
          id="Vector"
          d="M10.7199 5.38999C10.7199 4.72999 11.2599 4.18999 11.9199 4.18999C12.5799 4.18999 13.1199 4.72999 13.1199 5.38999L13.1099 9.29999L14.9199 11.09V5.48999C14.9199 3.82999 13.5799 2.48999 11.9199 2.48999C10.3799 2.48999 9.12992 3.64999 8.95992 5.13999L10.7199 6.89999V5.38999ZM18.9199 11.49H17.2199C17.2199 12.07 17.1199 12.62 16.9499 13.13L18.2199 14.4C18.6599 13.52 18.9199 12.53 18.9199 11.49ZM4.32992 3.34999L2.91992 4.75999L8.91992 10.76V11.49C8.91992 13.15 10.2599 14.49 11.9199 14.49C12.1499 14.49 12.3599 14.46 12.5699 14.41L14.2299 16.07C13.5199 16.4 12.7299 16.59 11.9199 16.59C9.15992 16.59 6.61992 14.49 6.61992 11.49H4.91992C4.91992 14.9 7.63992 17.72 10.9199 18.21V21.49H12.9199V18.21C13.8299 18.08 14.6899 17.76 15.4699 17.31L19.6699 21.51L21.0799 20.1L4.32992 3.34999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMicrowave(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="microwave">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 6H14V18H4V6ZM20 18H16V6H20V18ZM19 9H17V7H19V9ZM18 13C17.45 13 17 12.55 17 12C17 11.45 17.45 11 18 11C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13ZM18 17C17.45 17 17 16.55 17 16C17 15.45 17.45 15 18 15C18.55 15 19 15.45 19 16C19 16.55 18.55 17 18 17ZM10.25 16C9.46 16 8.88 15.62 8.46 15.34C8.13 15.12 7.94 15 7.75 15C7.38 15 6.95 15.41 6.8 15.61L5.38 14.19C5.73 13.79 6.59 13 7.75 13C8.55 13 9.14 13.39 9.56 13.67C9.87 13.88 10.07 14 10.25 14C10.62 14 11.05 13.59 11.2 13.39L12.62 14.81C12.26 15.21 11.41 16 10.25 16ZM10.25 11C9.46 11 8.88 10.62 8.46 10.34C8.13 10.12 7.94 10 7.75 10C7.38 10 6.95 10.41 6.8 10.61L5.37 9.19C5.73 8.79 6.59 8 7.75 8C8.55 8 9.14 8.39 9.56 8.67C9.87 8.88 10.07 9 10.25 9C10.62 9 11.05 8.59 11.2 8.39L12.62 9.81C12.26 10.21 11.41 11 10.25 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMilitaryTech(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="military_tech">
        <path
          id="Vector"
          d="M17 10.43V2H7V10.43C7 10.78 7.18 11.11 7.49 11.29L11.67 13.8L10.68 16.14L7.27 16.43L9.86 18.67L9.07 22L12 20.23L14.93 22L14.15 18.67L16.74 16.43L13.33 16.14L12.34 13.8L16.52 11.29C16.82 11.11 17 10.79 17 10.43ZM11 11.07L9 9.87V4H11V11.07ZM15 9.87L13 11.07V4H15V9.87Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMinimize(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="minimize">
        <path id="Vector" d="M6 11H18V13H6V11Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconMinorCrash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="minor_crash">
        <path
          id="Vector"
          d="M18.92 9.01C18.72 8.42 18.16 8 17.5 8H6.5C5.84 8 5.29 8.42 5.08 9.01L3 15V23C3 23.55 3.45 24 4 24H5C5.55 24 6 23.55 6 23V22H18V23C18 23.55 18.45 24 19 24H20C20.55 24 21 23.55 21 23V15L18.92 9.01ZM6.85 10H17.14L18.18 13H5.81L6.85 10ZM19 20H5V15H19V20ZM6 17.5C6 16.67 6.67 16 7.5 16C8.33 16 9 16.67 9 17.5C9 18.33 8.33 19 7.5 19C6.67 19 6 18.33 6 17.5ZM15 17.5C15 16.67 15.67 16 16.5 16C17.33 16 18 16.67 18 17.5C18 18.33 17.33 19 16.5 19C15.67 19 15 18.33 15 17.5ZM9.41 5L8 6.41L5 3.41L6.41 2L9.41 5ZM16 6.41L14.59 5L17.59 2L19 3.41L16 6.41ZM13 5H11V0H13V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMiscellaneousServices(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="miscellaneous_services">
        <g id="Vector">
          <path
            d="M14.1685 13.73L15.5685 11.31C15.6585 11.16 15.6185 10.97 15.4885 10.86L14.0085 9.70002C14.0385 9.48002 14.0585 9.25002 14.0585 9.02002C14.0585 8.79002 14.0385 8.56002 14.0085 8.33002L15.4885 7.17002C15.6185 7.06002 15.6585 6.87002 15.5685 6.72002L14.1685 4.30002C14.0785 4.15002 13.8985 4.09002 13.7385 4.15002L11.9985 4.85002C11.6385 4.57002 11.2485 4.34002 10.8185 4.16002L10.5585 2.31002C10.5285 2.15002 10.3785 2.02002 10.2085 2.02002H7.40854C7.23854 2.02002 7.08854 2.15002 7.05854 2.32002L6.79854 4.17002C6.37854 4.35002 5.97854 4.58002 5.61854 4.86002L3.87854 4.16002C3.71854 4.10002 3.53854 4.16002 3.44854 4.31002L2.04854 6.73002C1.95854 6.88002 1.99854 7.07002 2.12854 7.18002L3.60854 8.34002C3.57854 8.56002 3.55854 8.79002 3.55854 9.02002C3.55854 9.25002 3.57854 9.48002 3.60854 9.71002L2.12854 10.87C1.99854 10.98 1.95854 11.17 2.04854 11.32L3.44854 13.74C3.53854 13.89 3.71854 13.95 3.87854 13.89L5.61854 13.19C5.97854 13.47 6.36854 13.7 6.79854 13.88L7.05854 15.73C7.08854 15.89 7.23854 16.02 7.40854 16.02H10.2085C10.3785 16.02 10.5285 15.89 10.5585 15.72L10.8185 13.87C11.2385 13.69 11.6385 13.46 11.9985 13.18L13.7385 13.88C13.8985 13.94 14.0785 13.88 14.1685 13.73ZM8.80854 11.02C7.70854 11.02 6.80854 10.12 6.80854 9.02002C6.80854 7.92002 7.70854 7.02002 8.80854 7.02002C9.90854 7.02002 10.8085 7.92002 10.8085 9.02002C10.8085 10.12 9.90854 11.02 8.80854 11.02Z"
            fill="currentColor"
          />
          <path
            d="M21.9185 18.69L20.9585 17.95C20.9785 17.81 20.9985 17.66 20.9985 17.51C20.9985 17.36 20.9885 17.21 20.9585 17.07L21.9085 16.33C21.9885 16.26 22.0185 16.14 21.9585 16.04L21.0585 14.49C21.0085 14.39 20.8885 14.36 20.7785 14.39L19.6685 14.84C19.4385 14.66 19.1885 14.51 18.9085 14.4L18.7385 13.22C18.7285 13.1 18.6285 13.02 18.5285 13.02H16.7385C16.6285 13.02 16.5285 13.1 16.5185 13.21L16.3485 14.39C16.0785 14.51 15.8185 14.65 15.5885 14.83L14.4785 14.38C14.3785 14.34 14.2585 14.38 14.1985 14.48L13.2985 16.03C13.2485 16.13 13.2585 16.25 13.3485 16.32L14.2985 17.06C14.2785 17.2 14.2685 17.35 14.2685 17.5C14.2685 17.65 14.2785 17.8 14.2985 17.94L13.3485 18.68C13.2685 18.75 13.2385 18.87 13.2985 18.97L14.1985 20.52C14.2485 20.62 14.3685 20.65 14.4785 20.62L15.5885 20.17C15.8185 20.35 16.0685 20.5 16.3485 20.61L16.5185 21.79C16.5385 21.9 16.6285 21.98 16.7385 21.98H18.5285C18.6385 21.98 18.7385 21.9 18.7485 21.79L18.9185 20.61C19.1885 20.49 19.4485 20.35 19.6685 20.17L20.7885 20.62C20.8885 20.66 21.0085 20.62 21.0685 20.52L21.9685 18.97C22.0285 18.88 21.9985 18.76 21.9185 18.69ZM17.6285 18.85C16.8885 18.85 16.2785 18.25 16.2785 17.5C16.2785 16.75 16.8785 16.15 17.6285 16.15C18.3785 16.15 18.9785 16.75 18.9785 17.5C18.9785 18.25 18.3685 18.85 17.6285 18.85Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMissedVideoCall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="missed_video_call">
        <path
          id="Vector"
          d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5ZM15 16H5V8H15V16ZM7.11 11.11L11 15L14.77 11.21L13.99 10.42L11 13.43L7.89 10.33H10.44V9.22H6V13.66H7.11V11.11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMms(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mms">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM14.5 8L11 12.51L8.5 9.5L5 14H19L14.5 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMobileFriendly(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mobile_friendly">
        <path
          id="Vector"
          d="M18.905 1H8.90497C7.80497 1 6.90497 1.9 6.90497 3V6H8.90497V4H18.905V20H8.90497V18H6.90497V21C6.90497 22.1 7.80497 23 8.90497 23H18.905C20.005 23 20.905 22.1 20.905 21V3C20.905 1.9 20.005 1 18.905 1ZM6.91497 13.47L4.36497 10.92L3.09497 12.19L6.90497 16L14.095 8.81L12.825 7.54L6.91497 13.47Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMobileOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mobile_off">
        <path
          id="Vector"
          d="M17.1999 5V13.61L19.1999 15.61V3C19.1999 1.9 18.2999 1 17.1999 1H7.19994C6.48994 1 5.86994 1.37 5.51994 1.93L8.58994 5H17.1999ZM1.68994 3.76L5.19994 7.27V21C5.19994 22.1 6.09994 23 7.19994 23H17.1999C18.2199 23 19.0499 22.23 19.1799 21.25L20.8999 22.97L22.3099 21.56L3.09994 2.35L1.68994 3.76ZM7.19994 9.27L16.9299 19H7.19994V9.27Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMobileScreenShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mobile_screen_share">
        <path
          id="Vector"
          d="M16.9949 1H6.99488C5.89488 1 5.00488 1.85 5.00488 2.95V20.95C5.00488 22.05 5.89488 23 6.99488 23H16.9949C18.0949 23 18.9949 22.05 18.9949 20.95V2.95C18.9949 1.85 18.0949 1 16.9949 1ZM16.9949 19H6.99488V5H16.9949V19ZM12.7949 13.24V14.99L15.9949 12L12.7949 9.02V10.72C9.68488 11.15 8.44488 13.28 7.99488 15.42C9.10488 13.92 10.5749 13.24 12.7949 13.24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMobiledataOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mobiledata_off">
        <g id="Vector">
          <path
            d="M16.7101 6.10998L18.3001 7.69998L19.7101 6.28998L15.7101 2.28998L11.7101 6.28998L13.1201 7.69998L14.7101 6.10998V10.46L16.7101 12.46V6.10998Z"
            fill="currentColor"
          />
          <path
            d="M2.1001 3.50998L8.7101 10.12V16.47L7.1201 14.88L5.7101 16.29L9.7101 20.29L13.7101 16.29L12.3001 14.88L10.7101 16.47V12.12L20.4901 21.9L21.9001 20.48L3.5201 2.09998L2.1001 3.50998Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mode">
        <path
          id="Vector"
          d="M14.0588 9.02L14.9788 9.94L5.91878 19H4.99878V18.08L14.0588 9.02ZM17.6588 3C17.4088 3 17.1488 3.1 16.9588 3.29L15.1288 5.12L18.8788 8.87L20.7088 7.04C21.0988 6.65 21.0988 6.02 20.7088 5.63L18.3688 3.29C18.1688 3.09 17.9188 3 17.6588 3ZM14.0588 6.19L2.99878 17.25V21H6.74878L17.8088 9.94L14.0588 6.19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconModeComment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mode_comment">
        <path
          id="Vector"
          d="M20 17.17L18.83 16H4V4H20V17.17ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconModeFanOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mode_fan_off">
        <g id="Vector">
          <path
            d="M18.3051 7.70001C17.2451 7.70001 16.6651 7.99001 14.3951 8.89001C14.2051 8.75001 13.9951 8.62001 13.7751 8.52001C14.0251 7.49001 14.3851 6.99001 15.1051 6.48001C15.9151 5.91001 16.3051 5.14001 16.3051 4.20001C16.3051 2.98001 15.3551 1.70001 13.7051 1.70001C10.6251 1.70001 8.78507 3.17001 8.38507 4.96001L10.7151 7.29001C10.3751 6.39001 10.3051 6.08001 10.3051 5.70001C10.3051 4.52001 11.7051 3.70001 13.7051 3.70001C14.2751 3.70001 14.3051 4.12001 14.3051 4.20001C14.3051 4.47001 14.2551 4.63001 13.9551 4.85001C12.6851 5.75001 12.1251 6.76001 11.7951 8.24001L11.7751 8.34001L19.0251 15.59C19.2651 15.65 19.5251 15.7 19.8051 15.7C21.0251 15.7 22.3051 14.75 22.3051 13.1C22.3051 9.61001 20.4151 7.70001 18.3051 7.70001ZM19.8051 13.7C19.5351 13.7 19.3751 13.65 19.1551 13.35C18.2551 12.08 17.2451 11.52 15.7651 11.19C15.7351 10.97 15.6851 10.77 15.6151 10.57C17.4151 9.82001 17.7951 9.70001 18.3051 9.70001C19.4851 9.70001 20.3051 11.1 20.3051 13.1C20.3051 13.67 19.8851 13.7 19.8051 13.7Z"
            fill="currentColor"
          />
          <path
            d="M1.69507 3.92001L5.58507 7.81001C5.34507 7.75001 5.08507 7.70001 4.80507 7.70001C3.58507 7.70001 2.30507 8.65001 2.30507 10.3C2.30507 13.79 4.19507 15.7 6.30507 15.7C7.36507 15.7 7.94507 15.41 10.2151 14.51C10.4051 14.65 10.6151 14.78 10.8351 14.88C10.5851 15.91 10.2251 16.41 9.50507 16.92C8.69507 17.49 8.30507 18.26 8.30507 19.2C8.30507 20.42 9.25507 21.7 10.9051 21.7C13.9851 21.7 15.8251 20.23 16.2251 18.44L20.0851 22.3L21.4951 20.89L3.11507 2.51001L1.69507 3.92001ZM12.8251 15.16C12.8551 15.16 12.8851 15.14 12.9151 15.14L13.8851 16.11C14.2351 17.01 14.3051 17.32 14.3051 17.7C14.3051 18.88 12.9051 19.7 10.9051 19.7C10.3351 19.7 10.3051 19.28 10.3051 19.2C10.3051 18.93 10.3551 18.77 10.6551 18.55C11.9351 17.66 12.4851 16.64 12.8251 15.16ZM8.84507 12.22C8.87507 12.44 8.92507 12.64 8.99507 12.84C7.19507 13.58 6.81507 13.7 6.30507 13.7C5.12507 13.7 4.30507 12.3 4.30507 10.3C4.30507 9.73001 4.72507 9.70001 4.80507 9.70001C5.07507 9.70001 5.23507 9.75001 5.45507 10.05C6.34507 11.33 7.36507 11.88 8.84507 12.22Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconModeNight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mode_night">
        <path
          id="Vector"
          d="M9.5 4C13.91 4 17.5 7.59 17.5 12C17.5 16.41 13.91 20 9.5 20C9.16 20 8.82 19.98 8.49 19.93C10.4 17.77 11.5 14.95 11.5 12C11.5 9.05 10.4 6.23 8.49 4.07C8.82 4.02 9.16 4 9.5 4ZM9.5 2C7.68 2 5.97 2.5 4.5 3.35C7.49 5.08 9.5 8.3 9.5 12C9.5 15.7 7.49 18.92 4.5 20.65C5.97 21.5 7.68 22 9.5 22C15.02 22 19.5 17.52 19.5 12C19.5 6.48 15.02 2 9.5 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconModeOfTravel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mode_of_travel">
        <path
          id="Vector"
          d="M13.56 18.9C12.6 19.9 11.5 20.93 10.25 22C4.92 17.45 2.25 13.52 2.25 10.2C2.25 5.22 6.05 2 10.25 2C14.44 2 18.24 5.21 18.25 10.17L20.34 8.08L21.75 9.5L17.25 14L12.75 9.5L14.16 8.09L16.25 10.17C16.24 6.55 13.59 4 10.25 4C6.9 4 4.25 6.57 4.25 10.2C4.25 12.54 6.2 15.64 10.25 19.34C10.89 18.75 11.48 18.18 12.02 17.63C11.85 17.29 11.75 16.91 11.75 16.51C11.75 15.13 12.87 14.01 14.25 14.01C15.63 14.01 16.75 15.13 16.75 16.51C16.75 17.89 15.63 19 14.25 19C14.01 19 13.78 18.97 13.56 18.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconModeStandby(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mode_standby">
        <path
          id="Vector"
          d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconModelTraining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="model_training">
        <path
          id="Vector"
          d="M15.5 14.5C15.5 16.5 13 18 13 19.5H11C11 18 8.5 16.5 8.5 14.5C8.5 12.57 10.07 11 12 11C13.93 11 15.5 12.57 15.5 14.5ZM13 20.5H11V22H13V20.5ZM19 14C19 15.68 18.41 17.21 17.42 18.42L18.84 19.84C20.18 18.27 21 16.23 21 14C21 11.26 19.77 8.81 17.84 7.16L16.42 8.58C17.99 9.86 19 11.82 19 14ZM16 6L12 2V5C7.03 5 3 9.03 3 14C3 16.23 3.82 18.27 5.16 19.84L6.58 18.42C5.59 17.21 5 15.68 5 14C5 10.14 8.14 7 12 7V10L16 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMonetizationOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="monetization_on">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.31 11.14C10.54 10.69 9.97 10.2 9.97 9.47C9.97 8.63 10.76 8.04 12.07 8.04C13.45 8.04 13.97 8.7 14.01 9.68H15.72C15.67 8.34 14.85 7.11 13.23 6.71V5H10.9V6.69C9.39 7.01 8.18 7.99 8.18 9.5C8.18 11.29 9.67 12.19 11.84 12.71C13.79 13.17 14.18 13.86 14.18 14.58C14.18 15.11 13.79 15.97 12.08 15.97C10.48 15.97 9.85 15.25 9.76 14.33H8.04C8.14 16.03 9.4 16.99 10.9 17.3V19H13.24V17.33C14.76 17.04 15.96 16.17 15.97 14.56C15.96 12.36 14.07 11.6 12.31 11.14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoney(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="money">
        <path
          id="Vector"
          d="M15 16H18C18.55 16 19 15.55 19 15V9C19 8.45 18.55 8 18 8H15C14.45 8 14 8.45 14 9V15C14 15.55 14.45 16 15 16ZM16 10H17V14H16V10ZM9 16H12C12.55 16 13 15.55 13 15V9C13 8.45 12.55 8 12 8H9C8.45 8 8 8.45 8 9V15C8 15.55 8.45 16 9 16ZM10 10H11V14H10V10ZM5 8H7V16H5V8ZM2 4V20H22V4H2ZM20 18H4V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoneyOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="money_off">
        <path
          id="Vector"
          d="M12.4251 6.9C14.2051 6.9 14.8651 7.75 14.9251 9H17.1351C17.0651 7.28 16.0151 5.7 13.9251 5.19V3H10.9251V5.16C10.5351 5.24 10.1751 5.37 9.82511 5.52L11.3351 7.03C11.6551 6.95 12.0251 6.9 12.4251 6.9ZM5.39511 3.92L3.98511 5.33L7.42511 8.77C7.42511 10.85 8.98511 11.99 11.3351 12.68L14.8451 16.19C14.5051 16.68 13.7951 17.1 12.4251 17.1C10.3651 17.1 9.55511 16.18 9.44511 15H7.24511C7.36511 17.19 9.00511 18.42 10.9251 18.83V21H13.9251V18.85C14.8851 18.67 15.7551 18.3 16.3851 17.73L18.6051 19.95L20.0151 18.54L5.39511 3.92Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMonitor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="monitor">
        <path
          id="Vector"
          d="M20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18H7L6 19V21H18V19L17 18H20C21.1 18 22 17.1 22 16V5C22 3.9 21.1 3 20 3ZM20 16H4V5H20V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMonitorHeart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="monitor_heart">
        <g id="Vector">
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V9H4V6H20V9H22V6C22 4.9 21.1 4 20 4Z"
            fill="currentColor"
          />
          <path
            d="M20 18H4V15H2V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V15H20V18Z"
            fill="currentColor"
          />
          <path
            d="M14.89 7.55C14.55 6.87 13.44 6.87 13.1 7.55L10 13.76L8.89 11.55C8.72 11.21 8.38 11 8 11H2V13H7.38L9.1 16.45C9.28 16.79 9.62 17 10 17C10.38 17 10.72 16.79 10.89 16.45L14 10.24L15.11 12.45C15.28 12.79 15.62 13 16 13H22V11H16.62L14.89 7.55Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMonitorWeight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="monitor_weight">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6ZM11 9.5H10V8.5H11V9.5ZM12.5 9.5H11.5V8.5H12.5V9.5ZM14 9.5H13V8.5H14V9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMonochromePhotos(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="monochrome_photos">
        <path
          id="Vector"
          d="M20 5H16.8L15 3H9L7.2 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H12V18C9.2 18 7 15.8 7 13C7 10.2 9.2 8 12 8V7H20V19ZM17 13C17 10.2 14.8 8 12 8V9.8C13.8 9.8 15.2 11.2 15.2 13C15.2 14.8 13.8 16.2 12 16.2V18C14.8 18 17 15.8 17 13ZM8.8 13C8.8 14.8 10.2 16.2 12 16.2V9.8C10.2 9.8 8.8 11.2 8.8 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mood">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoodBad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mood_bad">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 13.5C9.67 13.5 7.69 14.96 6.89 17H17.11C16.31 14.96 14.33 13.5 12 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoped(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="moped">
        <g id="Vector">
          <path
            d="M19 7C19 5.9 18.1 5 17 5H14V7H17V9.65L13.52 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19C8.66 19 10 17.66 10 16H14.48L19 10.35V7ZM4 14V13C4 11.9 4.9 11 6 11H8V14H4ZM7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z"
            fill="currentColor"
          />
          <path d="M10 6H5V8H10V6Z" fill="currentColor" />
          <path
            d="M19 13C17.34 13 16 14.34 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 14.34 20.66 13 19 13ZM19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="more">
        <g id="Vector">
          <path
            d="M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.38 21 7.07 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM22 19H7.07L2.4 12L7.06 5H22V19Z"
            fill="currentColor"
          />
          <path
            d="M9 13.5C9.82843 13.5 10.5 12.8284 10.5 12C10.5 11.1716 9.82843 10.5 9 10.5C8.17157 10.5 7.5 11.1716 7.5 12C7.5 12.8284 8.17157 13.5 9 13.5Z"
            fill="currentColor"
          />
          <path
            d="M14 13.5C14.8284 13.5 15.5 12.8284 15.5 12C15.5 11.1716 14.8284 10.5 14 10.5C13.1716 10.5 12.5 11.1716 12.5 12C12.5 12.8284 13.1716 13.5 14 13.5Z"
            fill="currentColor"
          />
          <path
            d="M19 13.5C19.8284 13.5 20.5 12.8284 20.5 12C20.5 11.1716 19.8284 10.5 19 10.5C18.1716 10.5 17.5 11.1716 17.5 12C17.5 12.8284 18.1716 13.5 19 13.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMoreHoriz(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="more_horiz">
        <path
          id="Vector"
          d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoreTime(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="more_time">
        <g id="Vector">
          <path d="M9.5 8V14L14.2 16.9L15 15.7L11 13.3V8H9.5Z" fill="currentColor" />
          <path
            d="M17.42 12C17.47 12.33 17.5 12.66 17.5 13C17.5 16.9 14.4 20 10.5 20C6.6 20 3.5 16.9 3.5 13C3.5 9.1 6.6 6 10.5 6C11.2 6 11.87 6.1 12.5 6.29V4.23C11.86 4.08 11.19 4 10.5 4C5.5 4 1.5 8 1.5 13C1.5 18 5.5 22 10.5 22C15.5 22 19.5 18 19.5 13C19.5 12.66 19.48 12.33 19.44 12H17.42Z"
            fill="currentColor"
          />
          <path d="M19.5 5V2H17.5V5H14.5V7H17.5V10H19.5V7H22.5V5H19.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMoreVert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="more_vert">
        <path
          id="Vector"
          d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMosque(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mosque">
        <path
          id="Vector"
          d="M24 8C24 6.9 22 5 22 5C22 5 20 6.9 20 8C20 8.74 20.4 9.38 21 9.72V14H19V12C19 11.05 18.34 10.26 17.45 10.06C17.79 9.48 18 8.81 18 8.09C18 6.78 17.35 5.56 16.26 4.84L12 2L7.74 4.84C6.65 5.56 6 6.78 6 8.09C6 8.81 6.21 9.48 6.55 10.05C5.66 10.26 5 11.05 5 12V14H3V9.72C3.6 9.38 4 8.74 4 8C4 6.9 2 5 2 5C2 5 0 6.9 0 8C0 8.74 0.4 9.38 1 9.72V22H11V18C11 17.45 11.45 17 12 17C12.55 17 13 17.45 13 18V22H23V9.72C23.6 9.38 24 8.74 24 8ZM8.85 6.5L12 4.4L15.15 6.5C15.68 6.86 16 7.45 16 8.09C16 9.14 15.14 10 14.09 10H9.91C8.86 10 8 9.14 8 8.09C8 7.45 8.32 6.86 8.85 6.5ZM21 20H15V18C15 16.35 13.65 15 12 15C10.35 15 9 16.35 9 18V20H3V16H7V12H17V16H21V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMotionPhotosAuto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="motion_photos_auto">
        <path
          id="Vector"
          d="M2.88 7.88L4.42 9.42C4.15 10.23 4 11.1 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.1 4 10.23 4.15 9.42 4.42L7.89 2.89C9.15 2.32 10.54 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.53 2.32 9.14 2.88 7.88ZM7 5.5C7 6.33 6.33 7 5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5ZM12.03 8.99H11.96L10.8 12.3H13.19L12.03 8.99ZM11.29 7.5H12.72L15.73 15.5H14.34L13.62 13.46H10.39L9.66 15.5H8.28L11.29 7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMotionPhotosOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="motion_photos_off">
        <g id="Vector">
          <path
            d="M3.11507 2.50495L1.69507 3.91495L3.96507 6.18495C2.91507 7.76495 2.30507 9.65495 2.30507 11.6949C2.30507 17.2149 6.78507 21.6949 12.3051 21.6949C14.3451 21.6949 16.2351 21.0849 17.8151 20.0349L20.0851 22.3049L21.4951 20.8849L3.11507 2.50495ZM12.3051 19.6949C7.89507 19.6949 4.30507 16.1049 4.30507 11.6949C4.30507 10.2149 4.71507 8.83495 5.42507 7.63495L16.3551 18.5749C15.1651 19.2849 13.7851 19.6949 12.3051 19.6949Z"
            fill="currentColor"
          />
          <path
            d="M12.3051 3.69495C16.7151 3.69495 20.3051 7.28495 20.3051 11.6949C20.3051 13.1749 19.8951 14.5549 19.1851 15.7449L20.6351 17.1949C21.6951 15.6249 22.3051 13.7349 22.3051 11.6949C22.3051 6.17495 17.8251 1.69495 12.3051 1.69495C10.2651 1.69495 8.37507 2.30495 6.79507 3.35495L8.24507 4.80495C9.44507 4.10495 10.8251 3.69495 12.3051 3.69495Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMotionPhotosOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="motion_photos_on">
        <path
          id="Vector"
          d="M2.88 7.88L4.42 9.42C4.15 10.23 4 11.1 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.1 4 10.23 4.15 9.42 4.42L7.89 2.89C9.15 2.32 10.54 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.53 2.32 9.14 2.88 7.88ZM7 5.5C7 6.33 6.33 7 5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMotionPhotosPause(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="motion_photos_pause">
        <path
          id="Vector"
          d="M2.88 7.88L4.42 9.42C4.15 10.23 4 11.1 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.1 4 10.23 4.15 9.42 4.42L7.89 2.89C9.15 2.32 10.54 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.53 2.32 9.14 2.88 7.88ZM7 5.5C7 6.33 6.33 7 5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5ZM11 15H9V9H11V15ZM15 15H13V9H15V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMotionPhotosPaused(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="motion_photos_paused">
        <path
          id="Vector"
          d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.81 2.22 9.68 2.6 8.62L4.48 9.3C4.17 10.14 4 11.05 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.05 4 10.15 4.17 9.31 4.48L8.63 2.59C9.69 2.22 10.82 2 12 2C17.52 2 22 6.48 22 12ZM5.5 4C4.67 4 4 4.67 4 5.5C4 6.33 4.67 7 5.5 7C6.33 7 7 6.33 7 5.5C7 4.67 6.33 4 5.5 4ZM11 16V8H9V16H11ZM15 16V8H13V16H15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMouse(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mouse">
        <path
          id="Vector"
          d="M20 8.965C19.96 4.575 16.4 1.035 12 1.035C7.6 1.035 4.04 4.575 4 8.965V14.965C4 19.385 7.58 22.965 12 22.965C16.42 22.965 20 19.385 20 14.965V8.965ZM18 8.965H13V3.125C15.81 3.595 17.96 6.025 18 8.965ZM11 3.125V8.965H6C6.04 6.025 8.19 3.595 11 3.125ZM18 14.965C18 18.275 15.31 20.965 12 20.965C8.69 20.965 6 18.275 6 14.965V10.965H18V14.965Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoveDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="move_down">
        <g id="Vector">
          <path
            d="M3.5 10.5C3.5 12.95 5.26 14.97 7.58 15.41L6.09 13.92L7.5 12.5L11.5 16.51L7.5 20.5L6.09 19.09L7.67 17.51V17.45C4.2 17.04 1.5 14.08 1.5 10.5C1.5 6.63 4.63 3.5 8.5 3.5H11.5V5.5H8.5C5.74 5.5 3.5 7.74 3.5 10.5Z"
            fill="currentColor"
          />
          <path
            d="M22.5 10.5V3.5H13.5V10.5H22.5ZM20.5 8.5H15.5V5.5H20.5V8.5Z"
            fill="currentColor"
          />
          <path d="M22.5 12.5H13.5V19.5H22.5V12.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMoveToInbox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="move_to_inbox">
        <path
          id="Vector"
          d="M16 9H13.45V6H10.55V9H8L12 13L16 9ZM19 3H4.99C3.88 3 3 3.9 3 5V19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.56C9.25 17.19 10.53 18 12.01 18C13.49 18 14.76 17.19 15.46 16H19V19ZM19 14H14.01C14.01 15.1 13.11 16 12.01 16C10.91 16 10.01 15.1 10.01 14H5L4.99 5H19V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoveUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="move_up">
        <g id="Vector">
          <path
            d="M3.5 13.5C3.5 11.05 5.26 9.03 7.58 8.59L6.09 10.09L7.5 11.5L11.5 7.49L7.5 3.5L6.09 4.91L7.67 6.49V6.55C4.2 6.96 1.5 9.92 1.5 13.5C1.5 17.37 4.63 20.5 8.5 20.5H11.5V18.5H8.5C5.74 18.5 3.5 16.26 3.5 13.5Z"
            fill="currentColor"
          />
          <path
            d="M13.5 13.5V20.5H22.5V13.5H13.5ZM20.5 18.5H15.5V15.5H20.5V18.5Z"
            fill="currentColor"
          />
          <path d="M22.5 4.5H13.5V11.5H22.5V4.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMovie(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="movie">
        <path
          id="Vector"
          d="M4 6.47L5.76 10H20V18H4V6.47ZM22 4H18L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMovieCreation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="movie_creation">
        <path
          id="Vector"
          d="M5.76 10H20V18H4V6.47M22 4H18L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMovieFilter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="movie_filter">
        <path
          id="Vector"
          d="M9.99488 11L9.05488 13.06L6.99488 14L9.05488 14.94L9.99488 17L10.9349 14.94L12.9949 14L10.9349 13.06L9.99488 11ZM18.0049 4L20.0049 8H17.0049L15.0049 4H13.0049L15.0049 8H12.0049L10.0049 4H8.00488L10.0049 8H7.00488L5.00488 4H4.00488C2.90488 4 2.01488 4.9 2.01488 6L2.00488 18C2.00488 19.1 2.90488 20 4.00488 20H20.0049C21.1049 20 21.9949 19.1 21.9949 18V4H18.0049ZM20.0049 18H4.00488V6.47L5.76488 10H15.9949L15.3649 11.37L13.9949 12L15.3649 12.63L15.9949 14L16.6249 12.63L17.9949 12L16.6249 11.37L15.9949 10H20.0049V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMoving(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="moving">
        <path
          id="Vector"
          d="M20 9.42V12H22V6H16V8H18.58L14.12 12.46C13.73 12.85 13.1 12.85 12.71 12.46L11.54 11.29C10.37 10.12 8.47 10.12 7.3 11.29L2 16.59L3.41 18L8.7 12.71C9.09 12.32 9.72 12.32 10.11 12.71L11.28 13.88C12.45 15.05 14.35 15.05 15.52 13.88L20 9.42Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mp">
        <g id="Vector">
          <path
            d="M17 9H13.5V15H15V13.5H17C17.55 13.5 18 13.05 18 12.5V10C18 9.45 17.55 9 17 9ZM16.5 12H15V10.5H16.5V12Z"
            fill="currentColor"
          />
          <path
            d="M11.5 9H7C6.45 9 6 9.45 6 10V15H7.5V10.5H8.5V13.5H10V10.5H11V15H12.5V10C12.5 9.45 12.05 9 11.5 9Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 19V5H19V19H5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMultilineChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="multiline_chart">
        <path
          id="Vector"
          d="M22 7.175L20.59 5.76501L17.74 8.97501C15.68 6.65501 12.83 5.255 9.61 5.255C6.72 5.255 4.07 6.415 2 8.255L3.42 9.675C5.12 8.185 7.27 7.255 9.61 7.255C12.35 7.255 14.7 8.515 16.38 10.495L13.5 13.735L9.5 9.735L2 17.245L3.5 18.745L9.5 12.735L13.5 16.735L17.55 12.185C18.3 13.535 18.8 15.085 18.99 16.735H21C20.78 14.435 20.05 12.345 18.96 10.595L22 7.175Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMultipleStop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="multiple_stop">
        <path
          id="Vector"
          d="M17 4L21 8L17 12V9H13V7H17V4ZM10 7C9.45 7 9 7.45 9 8C9 8.55 9.45 9 10 9C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7ZM6 7C5.45 7 5 7.45 5 8C5 8.55 5.45 9 6 9C6.55 9 7 8.55 7 8C7 7.45 6.55 7 6 7ZM7 17H11V15H7V12L3 16L7 20V17ZM14 17C14.55 17 15 16.55 15 16C15 15.45 14.55 15 14 15C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17ZM18 17C18.55 17 19 16.55 19 16C19 15.45 18.55 15 18 15C17.45 15 17 15.45 17 16C17 16.55 17.45 17 18 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMuseum(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="museum">
        <g id="Vector">
          <path
            d="M22 11V9L12 2L2 9V11H4V20H2V22H22V20H20V11H22ZM18 20H6V9H18V20Z"
            fill="currentColor"
          />
          <path d="M10 14L12 17L14 14V18H16V11H14L12 14L10 11H8V18H10V14Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconMusicNote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="music_note">
        <path
          id="Vector"
          d="M12 3L12.01 13.55C11.42 13.21 10.74 13 10.01 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10.01 21C12.23 21 14 19.21 14 17V7H18V3H12ZM10.01 19C8.91 19 8.01 18.1 8.01 17C8.01 15.9 8.91 15 10.01 15C11.11 15 12.01 15.9 12.01 17C12.01 18.1 11.11 19 10.01 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMusicOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="music_off">
        <path
          id="Vector"
          d="M13.9299 7.06944H17.9299V3.06944H11.9299V7.67944L13.9299 9.67944V7.06944ZM11.9299 10.5094L4.33993 2.92944L2.92993 4.33944L11.9299 13.3394V13.6194C10.9899 13.0794 9.82993 12.8694 8.59993 13.2994C7.25993 13.7794 6.22993 14.9694 5.98993 16.3694C5.52993 19.1094 7.84993 21.4494 10.5799 21.0194C12.5399 20.7094 13.9299 18.9094 13.9299 16.9194V15.3394L19.6599 21.0694L21.0699 19.6594L11.9299 10.5094ZM9.92993 19.0694C8.82993 19.0694 7.92993 18.1694 7.92993 17.0694C7.92993 15.9694 8.82993 15.0694 9.92993 15.0694C11.0299 15.0694 11.9299 15.9694 11.9299 17.0694C11.9299 18.1694 11.0299 19.0694 9.92993 19.0694Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMusicVideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="music_video">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM8 15C8 13.34 9.34 12 11 12C11.35 12 11.69 12.07 12 12.18V6H17V8H14V15.03C13.98 16.67 12.65 18 11 18C9.34 18 8 16.66 8 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMyLocation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="my_location">
        <path
          id="Vector"
          d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nat">
        <g id="Vector">
          <path
            d="M6.82 13H11V11H6.82C6.4 9.84 5.3 9 4 9C2.34 9 1 10.34 1 12C1 13.66 2.34 15 4 15C5.3 15 6.4 14.16 6.82 13ZM4 13C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11C4.55 11 5 11.45 5 12C5 12.55 4.55 13 4 13Z"
            fill="currentColor"
          />
          <path
            d="M23 12L19 9V11H14.95C14.45 5.95 10.19 2 5 2V4C9.42 4 13 7.58 13 12C13 16.42 9.42 20 5 20V22C10.19 22 14.45 18.05 14.95 13H19V15L23 12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNature(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nature">
        <path
          id="Vector"
          d="M12.915 16.035H12.885C16.375 15.635 19.085 12.675 19.085 9.08496C19.085 5.21496 15.955 2.08496 12.085 2.08496C8.21504 2.08496 5.08504 5.21496 5.08504 9.08496C5.08504 12.555 7.60504 15.425 10.915 15.975V19.915H4.91504V21.915H18.915V19.915H12.915V16.035ZM7.08504 9.08496C7.08504 6.32496 9.32504 4.08496 12.085 4.08496C14.845 4.08496 17.085 6.32496 17.085 9.08496C17.085 11.845 14.845 14.085 12.085 14.085C9.32504 14.085 7.08504 11.845 7.08504 9.08496Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNaturePeople(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nature_people">
        <g id="Vector">
          <path
            d="M4.41504 10.915C5.24347 10.915 5.91504 10.2434 5.91504 9.41496C5.91504 8.58653 5.24347 7.91496 4.41504 7.91496C3.58661 7.91496 2.91504 8.58653 2.91504 9.41496C2.91504 10.2434 3.58661 10.915 4.41504 10.915Z"
            fill="currentColor"
          />
          <path
            d="M22.085 9.08496C22.085 5.21496 18.955 2.08496 15.085 2.08496C11.215 2.08496 8.08504 5.21496 8.08504 9.08496C8.08504 12.555 10.605 15.425 13.915 15.975V19.915H5.91504V16.915H6.91504V12.915C6.91504 12.365 6.46504 11.915 5.91504 11.915H2.91504C2.36504 11.915 1.91504 12.365 1.91504 12.915V16.915H2.91504V21.915H18.915V19.915H15.915V16.035C19.385 15.625 22.085 12.675 22.085 9.08496ZM15.085 14.085C12.325 14.085 10.085 11.845 10.085 9.08496C10.085 6.32496 12.325 4.08496 15.085 4.08496C17.845 4.08496 20.085 6.32496 20.085 9.08496C20.085 11.845 17.845 14.085 15.085 14.085Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNavigateBefore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="navigate_before">
        <path
          id="Vector"
          d="M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNavigateNext(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="navigate_next">
        <path
          id="Vector"
          d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNavigation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="navigation">
        <path
          id="Vector"
          d="M12 7.77L16.28 18.2L12.81 16.67L12 16.31L11.19 16.67L7.72 18.2L12 7.77ZM12 2.5L4.5 20.79L5.21 21.5L12 18.5L18.79 21.5L19.5 20.79L12 2.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNearMe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="near_me">
        <path
          id="Vector"
          d="M17.27 6.73L13.03 16.86L11.39 12.61L10.57 12.29L7.14 10.96L17.27 6.73ZM21 3L3 10.53V11.51L9.84 14.16L12.48 21H13.46L21 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNearMeDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="near_me_disabled">
        <path
          id="Vector"
          d="M11.295 7.04498L20.295 3.70498L16.955 12.705L15.395 11.145L16.895 7.09498L12.845 8.59498L11.295 7.04498ZM20.485 21.895L15.415 16.825L13.605 21.705H12.195L9.36498 14.635L2.29498 11.805V10.395L7.17498 8.58498L2.10498 3.51498L3.51498 2.10498L21.895 20.485L20.485 21.895ZM13.865 15.275L8.72498 10.135L6.01498 11.145L10.905 13.095L12.855 17.985L13.865 15.275Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNearbyError(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nearby_error">
        <path
          id="Vector"
          d="M12.0026 7.5725L16.4226 11.9925L12.0026 16.4125L7.58256 11.9925L12.0026 7.5725ZM12.0026 19.1925L4.80256 11.9925L12.0026 4.7925L18.0026 10.7925V7.1625L13.4226 2.5825C12.6426 1.8025 11.3726 1.8025 10.5926 2.5825L2.58256 10.5825C1.80256 11.3625 1.80256 12.6325 2.58256 13.4125L10.5926 21.4125C11.3726 22.1925 12.6426 22.1925 13.4226 21.4125L18.0026 16.8225V13.1925L12.0026 19.1925ZM20.0026 20.0025H22.0026V22.0025H20.0026V20.0025ZM22.0026 10.0025H20.0026V18.0025H22.0026V10.0025Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNearbyOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nearby_off">
        <path
          id="Vector"
          d="M21.7138 13.1175L19.1338 15.6975L17.3238 13.8875L19.5038 11.6975L12.3038 4.49751L10.1138 6.68751L8.30385 4.86751L10.8838 2.28751C11.6638 1.50751 12.9338 1.50751 13.7138 2.28751L21.7138 10.2875C22.5038 11.0675 22.5038 12.3275 21.7138 13.1175ZM21.4938 20.8875L20.0838 22.2975L16.3038 18.5275L13.7238 21.1075C12.9438 21.8875 11.6738 21.8875 10.8938 21.1075L2.89385 13.1075C2.11385 12.3275 2.11385 11.0575 2.89385 10.2775L5.47385 7.69751L1.69385 3.91751L3.10385 2.50751L21.4938 20.8875ZM14.4938 16.7175L13.1038 15.3275L12.3038 16.1275L7.88385 11.6975L8.68385 10.8975L7.28385 9.50751L5.10385 11.6975L12.3038 18.8975L14.4938 16.7175ZM16.7238 11.6975L12.3038 7.27751L11.5038 8.07751L15.9238 12.4975L16.7238 11.6975Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNestCamWiredStand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nest_cam_wired_stand">
        <path
          id="Vector"
          d="M15.9951 1.00008C15.8451 1.00008 16.1051 0.980078 11.7151 1.42008C8.46512 1.75008 5.99512 4.48008 5.99512 7.75008C5.99512 11.0201 8.46512 13.7501 11.7151 14.0801L13.6151 14.2701L13.0551 15.1201C12.7051 15.0401 12.3551 15.0001 11.9951 15.0001C9.23512 15.0001 6.99512 17.2401 6.99512 20.0001V22.0001C6.99512 22.5501 7.44512 23.0001 7.99512 23.0001H15.9951C16.5451 23.0001 16.9951 22.5501 16.9951 22.0001V20.0001C16.9951 18.3301 16.1651 16.8501 14.9051 15.9401L15.8751 14.4901C15.9151 14.4901 15.9651 14.5001 16.0051 14.5001C17.0951 14.5001 18.0051 13.6101 18.0051 12.5001V3.00008C17.9951 1.89008 17.0851 1.00008 15.9951 1.00008ZM14.9951 21.0001H8.99512V20.0001C8.99512 18.3501 10.3451 17.0001 11.9951 17.0001C13.6451 17.0001 14.9951 18.3501 14.9951 20.0001V21.0001ZM7.99512 7.75008C7.99512 5.50008 9.68512 3.64008 11.9151 3.41008L15.9951 3.00008L16.0251 12.5001L11.9151 12.0801C9.68512 11.8601 7.99512 10.0001 7.99512 7.75008Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkCell(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_cell">
        <path id="Vector" d="M2 22H22V2L2 22ZM20 20H17V9.83L20 6.83V20Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconNetworkCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_check">
        <path
          id="Vector"
          d="M15.9 4.77104C15.73 4.77104 15.58 4.86104 15.49 5.00104L15.42 5.15104L10.24 16.801C10.08 17.091 9.98 17.411 9.98 17.761C9.98 18.871 10.88 19.771 11.99 19.771C12.95 19.771 13.76 19.091 13.95 18.181L13.96 18.151L16.4 5.27104C16.4 4.99104 16.18 4.77104 15.9 4.77104ZM1 8.77104L3 10.771C5.88 7.89104 9.79 6.69104 13.53 7.15104L14.72 4.47104C9.89 3.61104 4.74 5.04104 1 8.77104ZM21 10.771L23 8.77104C21.36 7.13104 19.45 5.95104 17.41 5.20104L16.88 8.02104C18.38 8.64104 19.78 9.55104 21 10.771ZM17 14.771L19 12.771C18.2 11.971 17.3 11.351 16.34 10.881L15.79 13.801C16.21 14.071 16.62 14.391 17 14.771ZM5 12.771L7 14.771C8.13 13.641 9.56 12.981 11.03 12.771L12.31 9.89104C9.68 9.81104 7.01 10.761 5 12.771Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkLocked(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_locked">
        <path
          id="Vector"
          d="M22 16.5V16C22 14.62 20.88 13.5 19.5 13.5C18.12 13.5 17 14.62 17 16V16.5C16.45 16.5 16 16.95 16 17.5V21.5C16 22.05 16.45 22.5 17 22.5H22C22.55 22.5 23 22.05 23 21.5V17.5C23 16.95 22.55 16.5 22 16.5ZM21 16.5H18V16C18 15.17 18.67 14.5 19.5 14.5C20.33 14.5 21 15.17 21 16V16.5ZM18 6.33V11.76C18.47 11.6 18.97 11.5 19.5 11.5C19.67 11.5 19.83 11.53 20 11.55V1.5L1 20.5H14V18.5H5.83L18 6.33Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkPing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_ping">
        <path
          id="Vector"
          d="M12 14.67L3.41 6.09L2 7.5L10.5 16H4V18H20V16H13.5L18.65 10.85C18.91 10.95 19.2 11 19.5 11C20.88 11 22 9.88 22 8.5C22 7.12 20.88 6 19.5 6C18.12 6 17 7.12 17 8.5C17 8.85 17.07 9.17 17.2 9.47L12 14.67Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkWifi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_wifi">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM12 7.5C9.14 7.5 6.5 8.44 4.35 10.01L2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L19.65 10C17.5 8.44 14.86 7.5 12 7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkWifi1Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_wifi_1_bar">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM15.32 14.34C14.34 13.8 13.2 13.5 12 13.5C10.8 13.5 9.66 13.8 8.68 14.34L2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L15.32 14.34Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkWifi2Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_wifi_2_bar">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM16.78 12.88C15.4 12 13.76 11.5 12 11.5C10.24 11.5 8.6 12 7.22 12.88L2.92 8.58C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L16.78 12.88Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNetworkWifi3Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="network_wifi_3_bar">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L18.23 11.43C16.46 10.21 14.31 9.5 12 9.5C9.69 9.5 7.54 10.21 5.77 11.43L2.92 8.57Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNewLabel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="new_label">
        <path
          id="Vector"
          d="M21.5 11.5L17.13 17.66C16.76 18.18 16.15 18.5 15.5 18.5H12.5V16.5H15.5L19.05 11.5L15.5 6.5H5.5V9.5H3.5V6.5C3.5 5.4 4.4 4.5 5.5 4.5H15.5C16.15 4.5 16.76 4.81 17.13 5.34L21.5 11.5ZM10.5 14.5H7.5V11.5H5.5V14.5H2.5V16.5H5.5V19.5H7.5V16.5H10.5V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNewReleases(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="new_releases">
        <path
          id="Vector"
          d="M23 11.995L20.56 9.21497L20.9 5.53497L17.29 4.71497L15.4 1.53497L12 2.99497L8.6 1.53497L6.71 4.71497L3.1 5.52497L3.44 9.20497L1 11.995L3.44 14.775L3.1 18.465L6.71 19.285L8.6 22.465L12 20.995L15.4 22.455L17.29 19.275L20.9 18.455L20.56 14.775L23 11.995ZM18.49 14.105L18.75 16.895L16.01 17.515L14.58 19.925L12 18.815L9.42 19.925L7.99 17.515L5.25 16.895L5.51 14.095L3.66 11.995L5.51 9.87497L5.25 7.09497L7.99 6.48497L9.42 4.07497L12 5.17497L14.58 4.06497L16.01 6.47497L18.75 7.09497L18.49 9.88497L20.34 11.995L18.49 14.105ZM11 14.995H13V16.995H11V14.995ZM11 6.99497H13V12.995H11V6.99497Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNewspaper(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="newspaper">
        <path
          id="Vector"
          d="M22 3L20.33 4.67L18.67 3L17 4.67L15.33 3L13.67 4.67L12 3L10.33 4.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V3ZM11 19H4V13H11V19ZM20 19H13V17H20V19ZM20 15H13V13H20V15ZM20 11H4V8H20V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNextPlan(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="next_plan">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M15.97 11.03C14.87 9.79 13.28 9 11.5 9C8.68 9 6.32 10.95 5.68 13.56L6.64 13.88C7.15 11.66 9.13 10 11.5 10C13.01 10 14.35 10.68 15.26 11.74L13 14H18V9L15.97 11.03Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNextWeek(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="next_week">
        <path
          id="Vector"
          d="M11 18L15 14L11 10L10 11L13 14L10 17L11 18ZM20 6.5H16V4.5C16 3.95 15.78 3.45 15.41 3.09C15.05 2.72 14.55 2.5 14 2.5H10C8.9 2.5 8 3.4 8 4.5V6.5H4C2.9 6.5 2 7.4 2 8.5V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5V8.5C22 7.4 21.1 6.5 20 6.5ZM10 4.5H14V6.5H10V4.5ZM20 19.5H4V8.5H20V19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNfc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nfc">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 20H4V4H20V20ZM18 6H13C11.9 6 11 6.9 11 8V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V8H16V16H8V8H10V6H6V18H18V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNightShelter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="night_shelter">
        <path
          id="Vector"
          d="M12 5.5L18 10V19H6V10L12 5.5ZM12 3L4 9V21H20V9L12 3ZM15 12H11.5V15.5H8V11H7V18H8V16.5H16V18H17V14C17 12.9 16.1 12 15 12ZM9.75 12.5C9.06 12.5 8.5 13.06 8.5 13.75C8.5 14.44 9.06 15 9.75 15C10.44 15 11 14.44 11 13.75C11 13.06 10.44 12.5 9.75 12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNightlife(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nightlife">
        <path
          id="Vector"
          d="M1.5 4.5H15.5L9.5 13.5V17.5H11.5V19.5H5.5V17.5H7.5V13.5L1.5 4.5ZM10.6 8.5L12 6.5H4.99L6.39 8.5H10.6ZM17.5 4.5H22.5V7.5H19.5V16.5C19.5 18.16 18.16 19.5 16.5 19.5C14.84 19.5 13.5 18.16 13.5 16.5C13.5 14.84 14.84 13.5 16.5 13.5C16.85 13.5 17.19 13.56 17.5 13.67V4.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNightlight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nightlight">
        <path
          id="Vector"
          d="M14.5 4C14.84 4 15.18 4.02 15.51 4.07C13.6 6.23 12.5 9.05 12.5 12C12.5 14.95 13.6 17.77 15.51 19.93C15.18 19.98 14.84 20 14.5 20C10.09 20 6.5 16.41 6.5 12C6.5 7.59 10.09 4 14.5 4ZM14.5 2C8.98 2 4.5 6.48 4.5 12C4.5 17.52 8.98 22 14.5 22C16.32 22 18.03 21.5 19.5 20.65C16.51 18.92 14.5 15.7 14.5 12C14.5 8.3 16.51 5.08 19.5 3.35C18.03 2.5 16.32 2 14.5 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNightlightRound(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nightlight_round">
        <path
          id="Vector"
          d="M15.5 22C16.55 22 17.55 21.84 18.5 21.54C14.44 20.27 11.5 16.48 11.5 12C11.5 7.52 14.44 3.73 18.5 2.46C17.55 2.16 16.55 2 15.5 2C9.98 2 5.5 6.48 5.5 12C5.5 17.52 9.98 22 15.5 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNightsStay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nights_stay">
        <g id="Vector">
          <path
            d="M21.1052 17.5C18.6352 17.5 14.5352 16.17 12.4252 12.07C10.0952 7.56 11.9252 3.59 12.9552 2C7.59519 2.19 3.3052 6.58 3.3052 11.99C3.3052 12.13 3.3252 12.27 3.3252 12.41C3.9352 12.15 4.6052 11.99 5.3052 11.99C5.3052 8.9 7.0352 6.22 9.6052 4.89C9.1052 7.08 9.0652 9.93 10.6452 12.99C12.2152 16.03 14.8252 17.94 17.4452 18.85C16.2152 19.59 14.7952 20 13.3152 20C12.8152 20 12.3152 19.95 11.8352 19.86C11.4652 20.56 10.8952 21.13 10.1952 21.5C11.1752 21.82 12.2252 22 13.3052 22C16.8052 22 19.8852 20.2 21.6752 17.48C21.5052 17.49 21.3052 17.5 21.1052 17.5Z"
            fill="currentColor"
          />
          <path
            d="M8.3252 15.99H8.1452C7.7252 14.83 6.6252 13.99 5.3252 13.99C3.6652 13.99 2.3252 15.33 2.3252 16.99C2.3252 18.65 3.6652 19.99 5.3252 19.99H8.3252C9.4252 19.99 10.3252 19.09 10.3252 17.99C10.3252 16.89 9.4252 15.99 8.3252 15.99Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNoAccounts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_accounts">
        <g id="Vector">
          <path
            d="M15.18 10.94C15.38 10.5 15.5 10.02 15.5 9.5C15.5 7.57 13.93 6 12 6C11.48 6 11 6.12 10.56 6.32L15.18 10.94Z"
            fill="currentColor"
          />
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 10.15 4.63 8.45 5.69 7.1L8.55 9.96C8.76 11.52 9.98 12.75 11.54 12.95L13.74 15.15C13.17 15.05 12.59 15 12 15C9.68 15 7.55 15.8 5.86 17.12C4.7 15.73 4 13.95 4 12ZM12 20C10.26 20 8.66 19.44 7.35 18.5C8.66 17.56 10.26 17 12 17C13.74 17 15.34 17.56 16.65 18.5C15.34 19.44 13.74 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.54 18.31 16.9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNoAdultContent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_adult_content">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 10.15 4.63 8.46 5.69 7.1L7.59 9H10.42L7.1 5.69C8.46 4.63 10.15 4 12 4C16.41 4 20 7.59 20 12C20 13.85 19.37 15.54 18.31 16.9L16.41 15H13.58L16.89 18.31C15.54 19.37 13.85 20 12 20C7.59 20 4 16.41 4 12Z"
            fill="currentColor"
          />
          <path
            d="M14.25 14L12.75 12L14.25 10H12.75L12 11L11.25 10H9.75L11.25 12L9.75 14H11.25L12 13L12.75 14H14.25Z"
            fill="currentColor"
          />
          <path
            d="M8 10L7.25 11L6.5 10H5L6.5 12L5 14H6.5L7.25 13L8 14H9.5L8 12L9.5 10H8Z"
            fill="currentColor"
          />
          <path
            d="M16 14L16.75 13L17.5 14H19L17.5 12L19 10H17.5L16.75 11L16 10H14.5L16 12L14.5 14H16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNoBackpack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_backpack">
        <path
          id="Vector"
          d="M7.69498 3.84501C7.70498 3.84501 7.70498 3.83501 7.71498 3.83501V1.69501H10.715V3.69501H14.715V1.69501H17.715V3.83501C19.435 4.28501 20.715 5.83501 20.715 7.69501V16.865L18.715 14.865V7.69501C18.715 6.59501 17.815 5.69501 16.715 5.69501H9.54498L7.69498 3.84501ZM15.545 11.695L17.215 13.365V11.695H15.545ZM20.495 22.305L19.645 21.455C19.365 21.605 19.055 21.695 18.715 21.695H6.71498C5.61498 21.695 4.71498 20.795 4.71498 19.695V7.69501C4.71498 7.33501 4.77498 7.00501 4.86498 6.67501L2.10498 3.91501L3.51498 2.50501L21.895 20.885L20.495 22.305ZM17.885 19.695L11.885 13.695H8.21498V11.695H9.88498L6.71498 8.52501V19.695H17.885Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoCell(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_cell">
        <path
          id="Vector"
          d="M17.7101 6V14.17L19.7101 16.17V3C19.7101 1.9 18.8101 1.01 17.7101 1.01L7.7101 1C6.8601 1 6.1301 1.55 5.8401 2.3L9.5401 6H17.7101ZM7.7101 3H17.7101V4H7.7101V3ZM21.9001 21.19L3.5201 2.81L2.1001 4.22L5.7101 7.83V21C5.7101 22.1 6.6101 23 7.7101 23H17.7101C18.5601 23 19.2901 22.45 19.5801 21.7L20.4901 22.61L21.9001 21.19ZM17.7101 21H7.7101V20H17.7101V21ZM7.7101 18V9.83L15.8801 18H7.7101Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoCrash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_crash">
        <path
          id="Vector"
          d="M18.92 9.01C18.72 8.42 18.16 8 17.5 8H6.5C5.84 8 5.29 8.42 5.08 9.01L3 15V23C3 23.55 3.45 24 4 24H5C5.55 24 6 23.55 6 23V22H18V23C18 23.55 18.45 24 19 24H20C20.55 24 21 23.55 21 23V15L18.92 9.01ZM6.85 10H17.14L18.18 13H5.81L6.85 10ZM19 20H5V15H19V20ZM6 17.5C6 16.67 6.67 16 7.5 16C8.33 16 9 16.67 9 17.5C9 18.33 8.33 19 7.5 19C6.67 19 6 18.33 6 17.5ZM15 17.5C15 16.67 15.67 16 16.5 16C17.33 16 18 16.67 18 17.5C18 18.33 17.33 19 16.5 19C15.67 19 15 18.33 15 17.5ZM12 6.36L9.17 3.54L10.58 2.13L12 3.54L15.54 0L16.95 1.41L12 6.36Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoDrinks(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_drinks">
        <path
          id="Vector"
          d="M21.9001 20.48L3.5201 2.10001L2.1001 3.51001L10.3301 11.74L11.7101 13.29V18.29H6.7101V20.29H18.7101V20.12L20.4901 21.9L21.9001 20.48ZM13.7101 18.29V15.12L16.8801 18.29H13.7101ZM8.5401 4.29001L6.5401 2.29001H21.7101V4.29001L15.5101 11.26L14.0901 9.84001L15.4801 8.29001H12.5401L10.5401 6.29001H17.2801L19.0601 4.29001H8.5401Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoEncryption(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_encryption">
        <path
          id="Vector"
          d="M8.80503 6C8.80503 4.29 10.195 2.9 11.905 2.9C13.615 2.9 15.005 4.29 15.005 6V8H10.345L12.345 10H17.905V15.56L19.905 17.56V10C19.905 8.9 19.005 8 17.905 8H16.905V6C16.905 3.24 14.665 1 11.905 1C9.58503 1 7.64503 2.59 7.08503 4.74L8.80503 6.46V6ZM4.31503 4.81L2.90503 6.22L4.94503 8.26C4.32503 8.6 3.90503 9.25 3.90503 10V20C3.90503 21.1 4.80503 22 5.90503 22H18.685L19.685 23L21.095 21.59L4.31503 4.81ZM5.90503 20V10H6.68503L16.685 20H5.90503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoEncryptionGmailerrorred(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_encryption_gmailerrorred">
        <path
          id="Vector"
          d="M8.80503 6C8.80503 4.29 10.195 2.9 11.905 2.9C13.615 2.9 15.005 4.29 15.005 6V8H10.345L12.345 10H17.905V15.56L19.905 17.56V10C19.905 8.9 19.005 8 17.905 8H16.905V6C16.905 3.24 14.665 1 11.905 1C9.58503 1 7.64503 2.59 7.08503 4.74L8.80503 6.46V6ZM4.31503 4.81L2.90503 6.22L4.94503 8.26C4.32503 8.6 3.90503 9.25 3.90503 10V20C3.90503 21.1 4.80503 22 5.90503 22H18.685L19.685 23L21.095 21.59L4.31503 4.81ZM5.90503 20V10H6.68503L16.685 20H5.90503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoFlash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_flash">
        <path
          id="Vector"
          d="M21.0552 4.94H22.6552L19.6552 10.34V6.34H18.6552V1.34H22.6552L21.0552 4.94ZM16.6552 10.74V12.51L18.6552 14.51V10.34C18.6552 9.46 17.9352 8.74 17.0552 8.74H14.5152L13.2352 7.34H11.4852L14.8852 10.74H16.6552ZM2.75521 1.44L1.34521 2.85L7.00521 8.51L6.79521 8.74H4.25521C3.37521 8.74 2.65521 9.46 2.65521 10.34V19.74C2.65521 20.62 3.37521 21.34 4.25521 21.34H17.0552C17.8052 21.34 18.4352 20.82 18.6052 20.12L21.1452 22.66L22.5552 21.25L2.75521 1.44ZM12.1552 14.84C12.1552 15.67 11.4852 16.34 10.6552 16.34C9.82522 16.34 9.15521 15.67 9.15521 14.84C9.15521 14.01 9.82522 13.34 10.6552 13.34C11.4852 13.34 12.1552 14.01 12.1552 14.84ZM16.6152 19.34H4.65521V10.74H7.67521L8.26521 10.09L8.41522 9.93L9.91522 11.43C8.33522 11.77 7.15521 13.16 7.15521 14.84C7.15521 16.77 8.72522 18.34 10.6552 18.34C12.3352 18.34 13.7252 17.16 14.0752 15.58L16.6252 18.13L16.6152 19.34Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoFood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_food" clipPath="url(#clip0_395_812)">
        <path
          id="Vector"
          d="M1.15984 20.845H16.1698V21.825C16.1698 22.385 15.7198 22.835 15.1598 22.835H2.16984C1.60984 22.835 1.15984 22.385 1.15984 21.825V20.845ZM20.6498 23.155L16.1598 18.675V18.845H1.15984V16.845H14.3298L12.3298 14.845H1.15984C1.15984 11.605 3.61984 9.675 6.53984 9.055L0.839844 3.355L2.25984 1.945L22.0598 21.745L20.6498 23.155ZM10.3298 12.845L8.32984 10.845C6.90984 10.905 4.80984 11.405 3.77984 12.845H10.3298ZM23.1598 4.845H18.1598V0.845001H16.1598V4.845H11.1598L11.3898 6.845H20.9498L19.9498 16.815L21.7798 18.645L23.1598 4.845Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_812">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconNoLuggage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_luggage">
        <path
          id="Vector"
          d="M16.715 12.8649L15.215 11.3649V8.69495H16.715V12.8649ZM20.495 22.3049L18.645 20.4549C18.365 20.6049 18.055 20.6949 17.715 20.6949C17.715 21.2449 17.265 21.6949 16.715 21.6949C16.165 21.6949 15.715 21.2449 15.715 20.6949H9.71498C9.71498 21.2449 9.26498 21.6949 8.71498 21.6949C8.16498 21.6949 7.71498 21.2449 7.71498 20.6949C6.61498 20.6949 5.71498 19.7949 5.71498 18.6949V7.69495C5.71498 7.64495 5.73498 7.59495 5.73498 7.54495L2.10498 3.91495L3.51498 2.50495L21.895 20.8849L20.495 22.3049ZM16.885 18.6949L13.465 15.2749V17.6949H11.965V13.7749L10.215 12.0249V17.6949H8.71498V10.5249L7.71498 9.52495V18.6949H16.885ZM13.465 8.69495H12.545L13.465 9.61495V8.69495ZM19.715 7.69495V15.8649L17.715 13.8649V7.69495H11.545L9.71498 5.86495V2.69495C9.71498 2.14495 10.165 1.69495 10.715 1.69495H14.715C15.265 1.69495 15.715 2.14495 15.715 2.69495V5.69495H17.715C18.815 5.69495 19.715 6.59495 19.715 7.69495ZM11.215 5.69495H14.215V3.19495H11.215V5.69495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoMeals(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_meals">
        <path
          id="Vector"
          d="M16.705 13.345V5.34497C16.705 3.58497 18.945 1.34497 21.705 1.34497V17.515L19.705 15.515V13.345H16.705ZM21.195 22.655L10.725 12.195C10.395 12.285 10.065 12.345 9.70502 12.345V21.345H7.70502V12.345C5.49502 12.345 3.70502 10.555 3.70502 8.34497V5.17497L1.39502 2.85497L2.80502 1.44497L22.605 21.245L21.195 22.655ZM6.87502 8.34497L5.70502 7.17497V8.34497H6.87502ZM9.70502 1.34497H7.70502V3.51497L9.70502 5.51497V1.34497ZM13.705 8.34497V1.34497H11.705V7.51497L13.555 9.36497C13.645 9.03497 13.705 8.70497 13.705 8.34497Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoMeetingRoom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_meeting_room">
        <path
          id="Vector"
          d="M12.5649 4.435V8.315L14.5649 10.315V5.435H17.5649V13.315L19.5649 15.315V3.435H14.5649V2.435H6.68494L8.68494 4.435H12.5649ZM2.97494 1.565L1.56494 2.975L5.56494 6.975V18.435H3.56494V20.435H14.5649V15.975L21.0249 22.435L22.4349 21.025L2.97494 1.565ZM12.5649 18.435H7.56494V8.975L12.5649 13.975V18.435Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoPhotography(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_photography">
        <path
          id="Vector"
          d="M9.55984 5.36499L8.13984 3.95499L9.65984 2.29499H15.6598L17.4898 4.29499H20.6598C21.7598 4.29499 22.6598 5.19499 22.6598 6.29499V18.295C22.6598 18.345 22.6498 18.395 22.6398 18.455L20.6598 16.465V6.29499H16.6098L14.7798 4.29499H10.5398L9.55984 5.36499ZM21.1498 22.605L18.8298 20.295H4.65984C3.55984 20.295 2.65984 19.395 2.65984 18.295V6.29499C2.65984 5.70499 2.92984 5.17499 3.33984 4.80499L1.33984 2.80499L2.75984 1.39499L22.5598 21.195L21.1498 22.605ZM9.84984 11.315C9.73984 11.625 9.65984 11.945 9.65984 12.295C9.65984 13.955 10.9998 15.295 12.6598 15.295C13.0098 15.295 13.3298 15.215 13.6398 15.105L9.84984 11.315ZM16.8298 18.295L15.1498 16.615C14.4198 17.045 13.5698 17.295 12.6598 17.295C9.89984 17.295 7.65984 15.055 7.65984 12.295C7.65984 11.385 7.90984 10.535 8.33984 9.80499L4.82984 6.29499H4.65984V18.295H16.8298ZM15.4698 11.275L17.5398 13.345C17.6198 13.005 17.6598 12.655 17.6598 12.295C17.6598 9.53499 15.4198 7.29499 12.6598 7.29499C12.2998 7.29499 11.9498 7.33499 11.5998 7.41499L13.6698 9.48499C14.5098 9.78499 15.1698 10.445 15.4698 11.275Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoSim(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_sim">
        <path
          id="Vector"
          d="M21.4401 20.3999L3.97006 2.92994L2.56006 4.33994L5.30006 7.07994L5.18006 7.19994V18.1899C5.18006 19.2899 6.08006 20.1899 7.18006 20.1899H17.1801C17.5301 20.1899 17.8601 20.0899 18.1501 19.9299L20.0301 21.8099L21.4401 20.3999ZM7.18006 18.1899V8.95994L16.4101 18.1899H7.18006ZM11.0201 4.18994H17.1801V13.2999L19.1801 15.2999V4.18994C19.1801 3.08994 18.2801 2.18994 17.1801 2.18994H10.1901L8.13006 4.24994L9.54006 5.65994L11.0201 4.18994Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoStroller(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_stroller">
        <path
          id="Vector"
          d="M8.30482 19.29C8.30482 20.39 7.40482 21.29 6.30482 21.29C5.20482 21.29 4.30482 20.39 4.30482 19.29C4.30482 18.19 5.20482 17.29 6.30482 17.29C7.40482 17.29 8.30482 18.19 8.30482 19.29ZM15.3048 7.95001V11.46L17.3048 13.46V5.56001C17.8848 4.88001 18.2748 4.29001 18.9548 4.29001C19.7248 4.29001 20.3048 4.95001 20.3048 5.77001V6.29001H22.3048V5.77001C22.3048 3.85001 20.8248 2.29001 18.9548 2.29001C17.2948 2.29001 16.4148 3.56001 15.7748 4.32001L12.2748 8.43001L13.6948 9.85001L15.3048 7.95001ZM20.0848 21.9L18.1748 19.99C17.8848 20.75 17.1648 21.29 16.3048 21.29C15.2048 21.29 14.3048 20.39 14.3048 19.29C14.3048 18.43 14.8448 17.71 15.6048 17.42L14.4748 16.29H7.73482C6.88482 16.29 6.42482 15.29 6.97482 14.64L9.66482 11.48L1.69482 3.51001L3.10482 2.10001L21.4948 20.49L20.0848 21.9ZM12.4748 14.29L11.0848 12.9L9.90482 14.29H12.4748ZM10.3048 4.29001C10.5948 4.29001 10.8848 4.31001 11.1648 4.34001L9.79482 5.96001L11.2148 7.38001L14.6048 3.39001C13.3348 2.69001 11.8648 2.29001 10.3048 2.29001C9.07482 2.29001 7.90482 2.54001 6.83482 2.99001L8.40482 4.56001C9.01482 4.39001 9.65482 4.29001 10.3048 4.29001Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoTransfer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="no_transfer">
        <path
          id="Vector"
          d="M9.21498 12.695C10.045 12.695 10.715 13.365 10.715 14.195C10.715 15.025 10.045 15.695 9.21498 15.695C8.38498 15.695 7.71498 15.025 7.71498 14.195C7.71498 13.365 8.38498 12.695 9.21498 12.695ZM20.495 22.305L18.855 20.665C18.805 20.675 18.765 20.695 18.715 20.695H17.715C17.165 20.695 16.715 20.245 16.715 19.695V18.695H8.71498V19.695C8.71498 20.245 8.26498 20.695 7.71498 20.695H6.71498C6.16498 20.695 5.71498 20.245 5.71498 19.695V17.915C5.10498 17.365 4.71498 16.575 4.71498 15.695V6.52501L2.10498 3.91501L3.51498 2.50501L21.895 20.885L20.495 22.305ZM6.71498 8.52501V9.69501H7.88498L6.71498 8.52501ZM14.885 16.695L9.88498 11.695H6.71498V15.695C6.71498 16.065 6.92498 16.315 7.05498 16.425L7.34498 16.695H14.885ZM12.715 3.69501C16.405 3.69501 17.825 4.15501 18.375 4.68501H8.53498L10.535 6.68501H18.715V9.69501H13.545L15.545 11.695H18.715V14.865L20.525 16.675C20.635 16.365 20.715 16.045 20.715 15.695V5.69501C20.715 2.19501 17.135 1.69501 12.715 1.69501C10.195 1.69501 7.95498 1.85501 6.49498 2.64501L8.02498 4.17501C8.88498 3.89501 10.315 3.69501 12.715 3.69501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoiseAware(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="noise_aware">
        <g id="Vector">
          <path
            d="M16 15H14C14 15.55 13.55 16 13 16C12.57 16 12.19 15.73 12.05 15.32C11.9 14.88 11.65 14.24 11.12 13.71L9.75996 12.35C9.27996 11.87 8.99996 11.19 8.99996 10.5C8.99996 9.12 10.12 8 11.5 8C12.71 8 13.72 8.86 13.95 10H15.97C15.72 7.75 13.81 6 11.5 6C9.01996 6 6.99996 8.02 6.99996 10.5C6.99996 11.72 7.48996 12.91 8.34996 13.77L9.70996 15.13C9.87996 15.3 10.02 15.57 10.15 15.95C10.56 17.17 11.71 18 13 18C14.65 18 16 16.65 16 15Z"
            fill="currentColor"
          />
          <path
            d="M13.5 14C14.3284 14 15 13.3284 15 12.5C15 11.6716 14.3284 11 13.5 11C12.6715 11 12 11.6716 12 12.5C12 13.3284 12.6715 14 13.5 14Z"
            fill="currentColor"
          />
          <path
            d="M3.59996 6.58L5.17996 7.84C5.52996 7.27 5.94996 6.74 6.41996 6.27L4.84996 5.02C4.37996 5.49 3.96996 6.02 3.59996 6.58Z"
            fill="currentColor"
          />
          <path
            d="M9.45996 4.42L8.58996 2.61C7.95996 2.84 7.34996 3.13 6.78996 3.48L7.65996 5.29C8.21996 4.93 8.81996 4.64 9.45996 4.42Z"
            fill="currentColor"
          />
          <path
            d="M4.48996 9.26L2.52996 8.81C2.31996 9.44 2.16996 10.09 2.08996 10.76L4.04996 11.21C4.10996 10.53 4.26996 9.88 4.48996 9.26Z"
            fill="currentColor"
          />
          <path
            d="M20.4 6.58C20.04 6.02 19.62 5.49 19.15 5.02L17.57 6.28C18.05 6.75 18.46 7.27 18.81 7.85L20.4 6.58Z"
            fill="currentColor"
          />
          <path
            d="M4.03996 12.79L2.07996 13.24C2.15996 13.91 2.30996 14.57 2.51996 15.19L4.48996 14.74C4.26996 14.12 4.10996 13.47 4.03996 12.79Z"
            fill="currentColor"
          />
          <path
            d="M17.21 3.48C16.64 3.13 16.04 2.84 15.41 2.61L14.54 4.42C15.18 4.64 15.78 4.93 16.34 5.29L17.21 3.48Z"
            fill="currentColor"
          />
          <path
            d="M13 4.07V2.05C12.67 2.02 12.34 2 12 2C11.66 2 11.33 2.02 11 2.05V4.07C11.33 4.03 11.66 4 12 4C12.34 4 12.67 4.03 13 4.07Z"
            fill="currentColor"
          />
          <path
            d="M11 19.93V21.95C11.33 21.98 11.66 22 12 22C12.34 22 12.67 21.98 13 21.95V19.93C12.67 19.97 12.34 20 12 20C11.66 20 11.33 19.97 11 19.93Z"
            fill="currentColor"
          />
          <path
            d="M19.51 14.74L21.48 15.19C21.69 14.56 21.84 13.91 21.92 13.24L19.96 12.79C19.89 13.47 19.73 14.12 19.51 14.74Z"
            fill="currentColor"
          />
          <path
            d="M19.96 11.21L21.92 10.76C21.84 10.09 21.69 9.43 21.48 8.81L19.51 9.26C19.73 9.88 19.89 10.53 19.96 11.21Z"
            fill="currentColor"
          />
          <path
            d="M17.58 17.73L19.16 18.99C19.63 18.51 20.04 17.99 20.41 17.43L18.83 16.17C18.47 16.73 18.05 17.26 17.58 17.73Z"
            fill="currentColor"
          />
          <path
            d="M6.78996 20.52C7.35996 20.87 7.95996 21.16 8.58996 21.39L9.45996 19.58C8.81996 19.36 8.21996 19.07 7.65996 18.71L6.78996 20.52Z"
            fill="currentColor"
          />
          <path
            d="M14.54 19.58L15.41 21.39C16.04 21.16 16.65 20.87 17.21 20.52L16.34 18.71C15.78 19.07 15.18 19.36 14.54 19.58Z"
            fill="currentColor"
          />
          <path
            d="M3.59996 17.42C3.95996 17.98 4.37996 18.51 4.84996 18.98L6.42996 17.72C5.94996 17.25 5.53996 16.73 5.18996 16.15L3.59996 17.42Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNoiseControlOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="noise_control_off">
        <g id="Vector">
          <path
            d="M12 4C13.44 4 14.79 4.38 15.95 5.05L17.4 3.6C15.85 2.59 13.99 2 12 2C10.01 2 8.15 2.59 6.59 3.59L8.04 5.04C9.21 4.38 10.56 4 12 4Z"
            fill="currentColor"
          />
          <path
            d="M20 12C20 13.44 19.62 14.79 18.95 15.95L20.4 17.4C21.41 15.85 22 13.99 22 12C22 10.01 21.41 8.15 20.41 6.59L18.96 8.04C19.62 9.21 20 10.56 20 12Z"
            fill="currentColor"
          />
          <path
            d="M12 20C10.56 20 9.21 19.62 8.05 18.95L6.6 20.4C8.15 21.41 10.01 22 12 22C13.99 22 15.85 21.41 17.41 20.41L15.96 18.96C14.79 19.62 13.44 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M4 12C4 10.56 4.38 9.21 5.05 8.05L3.59 6.59C2.59 8.15 2 10.01 2 12C2 13.99 2.59 15.85 3.59 17.41L5.04 15.96C4.38 14.79 4 13.44 4 12Z"
            fill="currentColor"
          />
          <path
            d="M11.5 6C9.02 6 7 8.02 7 10.5C7 11.72 7.49 12.91 8.35 13.77L9.71 15.13C9.88 15.3 10.02 15.57 10.15 15.95C10.56 17.17 11.71 18 13 18C14.65 18 16 16.65 16 15H14C14 15.55 13.55 16 13 16C12.57 16 12.19 15.73 12.05 15.32C11.9 14.88 11.65 14.24 11.12 13.71L9.76 12.35C9.28 11.87 9 11.19 9 10.5C9 9.12 10.12 8 11.5 8C12.71 8 13.72 8.86 13.95 10H15.97C15.72 7.75 13.81 6 11.5 6Z"
            fill="currentColor"
          />
          <path
            d="M13.5 14C14.3284 14 15 13.3284 15 12.5C15 11.6716 14.3284 11 13.5 11C12.6716 11 12 11.6716 12 12.5C12 13.3284 12.6716 14 13.5 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNordicWalking(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="nordic_walking">
        <path
          id="Vector"
          d="M19.5 22.75H18V13.75H19.5V22.75ZM8.03 13.75H6.5L4.5 22.75H6.03L8.03 13.75ZM14 5.25C15.1 5.25 16 4.35 16 3.25C16 2.15 15.1 1.25 14 1.25C12.9 1.25 12 2.15 12 3.25C12 4.35 12.9 5.25 14 5.25ZM10.3 8.65L7.5 22.75H9.6L11.4 14.75L13.5 16.75V22.75H15.5V15.25L13.4 13.25L14 10.25C15.3 11.75 17.3 12.75 19.5 12.75V10.75C17.6 10.75 16 9.75 15.2 8.35L14.2 6.75C13.64 5.86 12.52 5.5 11.55 5.91L6.5 8.05V12.75H8.5V9.35L10.3 8.65Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNorth(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="north">
        <path
          id="Vector"
          d="M5 9L6.41 10.41L11 5.83V22H13V5.83L17.59 10.42L19 9L12 2L5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNorthEast(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="north_east">
        <path
          id="Vector"
          d="M9.5 4.5V6.5H16.09L4.5 18.09L5.91 19.5L17.5 7.91V14.5H19.5V4.5H9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNorthWest(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="north_west">
        <path
          id="Vector"
          d="M4.5 14.5H6.5V7.91L18.09 19.5L19.5 18.09L7.91 6.5H14.5V4.5H4.5V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotAccessible(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="not_accessible">
        <path
          id="Vector"
          d="M10.7101 3.69495C10.7101 2.59495 11.6101 1.69495 12.7101 1.69495C13.8101 1.69495 14.7101 2.59495 14.7101 3.69495C14.7101 4.79495 13.8101 5.69495 12.7101 5.69495C11.6101 5.69495 10.7101 4.79495 10.7101 3.69495ZM19.7101 12.6949V10.6949C18.1701 10.7149 16.6201 9.94495 15.6401 8.86495L14.3501 7.43495C14.1101 7.19495 13.9101 7.07495 13.7201 6.97495C13.3601 6.78495 13.0001 6.67495 12.5201 6.71495C12.0301 6.75495 11.6101 6.98495 11.2901 7.32495L14.7101 10.7449C16.0001 11.8149 17.9601 12.6849 19.7101 12.6949ZM10.7101 19.6949C9.0501 19.6949 7.7101 18.3549 7.7101 16.6949C7.7101 15.3849 8.5501 14.2849 9.7101 13.8649V11.7949C7.4301 12.2549 5.7101 14.2749 5.7101 16.6949C5.7101 19.4549 7.9501 21.6949 10.7101 21.6949C13.1301 21.6949 15.1501 19.9749 15.6101 17.6949H13.5401C13.1301 18.8549 12.0201 19.6949 10.7101 19.6949ZM3.5201 2.50495L2.1001 3.91495L10.7101 12.5249V14.6949C10.7101 15.7949 11.6101 16.6949 12.7101 16.6949H14.8801L20.4901 22.3049L21.9001 20.8949L3.5201 2.50495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotInterested(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="not_interested">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotListedLocation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="not_listed_location">
        <path
          id="Vector"
          d="M12.01 16C11.74 16 11.49 15.9 11.3 15.71C11.1 15.51 11.01 15.28 11.01 15C11 14.45 11.44 14.01 11.99 14H12.01C12.29 14 12.52 14.1 12.72 14.29C12.9 14.48 13 14.72 13 14.99C13 15.26 12.9 15.5 12.71 15.7C12.52 15.9 12.28 16 12.01 16ZM11.13 12.34C11.13 11.89 11.23 11.5 11.42 11.18C11.61 10.85 11.95 10.48 12.42 10.06C12.7 9.81 12.9 9.59 13.03 9.4C13.16 9.21 13.22 9 13.22 8.76C13.22 8.47 13.11 8.23 12.9 8.02C12.69 7.82 12.4 7.72 12.05 7.72C11.68 7.72 11.31 7.82 11.09 8.02C10.88 8.22 10.69 8.47 10.69 9H9C9 7.99 9.46 7.27 9.97 6.79C10.53 6.28 11.25 6 12 6C12.59 6 13.11 6.12 13.57 6.35C14.03 6.58 14.36 6.9 14.62 7.31C14.88 7.72 15 8.17 15 8.66C15 9.15 14.9 9.56 14.69 9.91C14.48 10.26 14.21 10.62 13.8 11C13.48 11.3 13.27 11.56 13.15 11.77C13.03 11.98 12.97 12.26 12.97 12.58V13H11.12V12.34H11.13ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotStarted(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="not_started">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 8H9V16H11V8ZM17 12L12 8V16L17 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="note">
        <path
          id="Vector"
          d="M16 4H4C2.9 4 2 4.9 2 6V18.01C2 19.11 2.9 20 4 20H20C21.1 20 22 19.1 22 18V10L16 4ZM4 18.01V6H15V11H20V18.01H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoteAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="note_add">
        <path
          id="Vector"
          d="M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNoteAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="note_alt">
        <g id="Vector">
          <path
            d="M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
            fill="currentColor"
          />
          <path d="M15.08 12.03L12.96 9.91L7 15.86V18H9.1L15.08 12.03Z" fill="currentColor" />
          <path
            d="M16.85 10.27C17.05 10.07 17.05 9.76 16.85 9.56L15.44 8.15C15.24 7.95 14.93 7.95 14.73 8.15L13.67 9.21L15.79 11.33L16.85 10.27Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconNotes(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notes">
        <path
          id="Vector"
          d="M21 11.01L3 11V13H21V11.01ZM3 16H15V18H3V16ZM21 6H3V8.01L21 8V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotificationAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notification_add">
        <path
          id="Vector"
          d="M14 14V17H6V10C6 7.79 7.79 6 10 6C10.85 6 11.64 6.26 12.28 6.72L13.71 5.29C13.07 4.78 12.32 4.41 11.5 4.2V3.5C11.5 2.67 10.83 2 10 2C9.17 2 8.5 2.67 8.5 3.5V4.2C5.91 4.86 4 7.21 4 10V17H2V19H18V17H16V14H14ZM10 22C11.1 22 12 21.1 12 20H8C8 21.1 8.9 22 10 22ZM22 8H19V5H17V8H14V10H17V13H19V10H22V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotificationImportant(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notification_important">
        <path
          id="Vector"
          d="M10.01 20.76C10.01 21.86 10.9 22.75 12 22.75C13.1 22.75 13.99 21.86 13.99 20.76H10.01ZM12 5.75C14.76 5.75 17 7.99 17 10.75V17.75H7V10.75C7 7.99 9.24 5.75 12 5.75ZM12 1.25C11.17 1.25 10.5 1.92 10.5 2.75V3.92C7.36 4.6 5 7.4 5 10.75V16.75L3 18.75V19.75H21V18.75L19 16.75V10.75C19 7.4 16.64 4.6 13.5 3.92V2.75C13.5 1.92 12.83 1.25 12 1.25ZM11 7.75H13V11.75H11V7.75ZM11 13.75H13V15.75H11V13.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotifications(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notifications">
        <path
          id="Vector"
          d="M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.9 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.37 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.64 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM16 16.75H8V10.75C8 8.27 9.51 6.25 12 6.25C14.49 6.25 16 8.27 16 10.75V16.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotificationsActive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notifications_active">
        <path
          id="Vector"
          d="M11.9998 21.75C13.0998 21.75 13.9998 20.85 13.9998 19.75H9.99979C9.99979 20.85 10.8998 21.75 11.9998 21.75ZM17.9998 15.75V10.75C17.9998 7.68 16.3698 5.11 13.4998 4.43V3.75C13.4998 2.92 12.8298 2.25 11.9998 2.25C11.1698 2.25 10.4998 2.92 10.4998 3.75V4.43C7.63979 5.11 5.99979 7.67 5.99979 10.75V15.75L3.99979 17.75V18.75H19.9998V17.75L17.9998 15.75ZM15.9998 16.75H7.99979V10.75C7.99979 8.27 9.50979 6.25 11.9998 6.25C14.4898 6.25 15.9998 8.27 15.9998 10.75V16.75ZM7.57979 3.83L6.14979 2.4C3.74978 4.23 2.16979 7.05 2.02979 10.25H4.02979C4.17979 7.6 5.53979 5.28 7.57979 3.83ZM19.9698 10.25H21.9698C21.8198 7.05 20.2398 4.23 17.8498 2.4L16.4298 3.83C18.4498 5.28 19.8198 7.6 19.9698 10.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotificationsOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notifications_off">
        <path
          id="Vector"
          d="M11.3052 21.75C12.4052 21.75 13.3052 20.85 13.3052 19.75H9.30518C9.30518 20.85 10.2052 21.75 11.3052 21.75ZM11.3052 6.25C13.7952 6.25 15.3052 8.27 15.3052 10.75V10.85L17.3052 12.85V10.75C17.3052 7.68 15.6752 5.11 12.8052 4.43V3.75C12.8052 2.92 12.1352 2.25 11.3052 2.25C10.4752 2.25 9.80518 2.92 9.80518 3.75V4.43C9.56518 4.49 9.33518 4.58 9.11518 4.66L10.7552 6.3C10.9352 6.28 11.1152 6.25 11.3052 6.25ZM4.71518 3.1L3.30518 4.51L6.11518 7.32C5.59518 8.32 5.30518 9.49 5.30518 10.75V15.75L3.30518 17.75V18.75H17.5452L19.2852 20.49L20.6952 19.08L4.71518 3.1ZM15.3052 16.75H7.30518V10.75C7.30518 10.07 7.42518 9.43 7.64518 8.85L15.3052 16.51V16.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNotificationsPaused(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="notifications_paused">
        <path
          id="Vector"
          d="M9.5 9.55H12.3L9.5 12.95V14.75H14.5V12.95H11.7L14.5 9.55V7.75H9.5V9.55ZM18 15.75V10.75C18 7.68 16.37 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.64 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM16 16.75H8V10.75C8 8.27 9.51 6.25 12 6.25C14.49 6.25 16 8.27 16 10.75V16.75ZM12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.9 21.75 12 21.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconNumbers(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="numbers">
        <path
          id="Vector"
          d="M20.5 10L21 8H17L18 4H16L15 8H11L12 4H10L9 8H5L4.5 10H8.5L7.5 14H3.5L3 16H7L6 20H8L9 16H13L12 20H14L15 16H19L19.5 14H15.5L16.5 10H20.5ZM13.5 14H9.5L10.5 10H14.5L13.5 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOfflineBolt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="offline_bolt">
        <path
          id="Vector"
          d="M12 2.02002C6.49002 2.02002 2.02002 6.49002 2.02002 12C2.02002 17.51 6.49002 21.98 12 21.98C17.51 21.98 21.98 17.51 21.98 12C21.98 6.49002 17.51 2.02002 12 2.02002ZM12 19.98C7.60002 19.98 4.02002 16.4 4.02002 12C4.02002 7.60002 7.60002 4.02002 12 4.02002C16.4 4.02002 19.98 7.60002 19.98 12C19.98 16.4 16.4 19.98 12 19.98ZM12.75 5.00002L8.25002 13.5H11.39V19L15.75 10.5H12.75V5.00002Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOfflinePin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="offline_pin">
        <path
          id="Vector"
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM7 15H17V17H7V15ZM10.3 11.2L8.4 9.3L7 10.7L10.3 14L17 7.3L15.6 5.9L10.3 11.2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOfflineShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="offline_share">
        <g id="Vector">
          <path d="M6 5H4V21C4 22.1 4.9 23 6 23H16V21H6V5Z" fill="currentColor" />
          <path
            d="M18 1H10C8.9 1 8 1.9 8 3V17C8 18.1 8.9 19 10 19H18C19.1 19 20 18.1 20 17V3C20 1.9 19.1 1 18 1ZM18 17H10V16H18V17ZM18 14H10V6H18V14ZM18 4H10V3H18V4Z"
            fill="currentColor"
          />
          <path
            d="M12.5 10.25H14.13L13.44 10.94L14.5 12L17 9.5L14.5 7L13.44 8.06L14.13 8.75H12C11.45 8.75 11 9.2 11 9.75V12H12.5V10.25Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconOilBarrel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="oil_barrel">
        <g id="Vector">
          <path
            d="M9 13.05C9 14.68 10.34 16 12 16C13.66 16 15 14.68 15 13.05C15 11.74 14.47 11.36 12 8.5C9.52 11.38 9 11.75 9 13.05Z"
            fill="currentColor"
          />
          <path
            d="M20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H19V5H20C20.55 5 21 4.55 21 4C21 3.45 20.55 3 20 3H4C3.45 3 3 3.45 3 4C3 4.55 3.45 5 4 5H5V11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H5V19H4C3.45 19 3 19.45 3 20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20C21 19.45 20.55 19 20 19H19V13H20ZM17 19H7V13C7.55 13 8 12.55 8 12C8 11.45 7.55 11 7 11V5H17V11C16.45 11 16 11.45 16 12C16 12.55 16.45 13 17 13V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconOnDeviceTraining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="on_device_training">
        <g id="Vector">
          <path d="M13 16H11V17H13V16Z" fill="currentColor" />
          <path
            d="M12 11C10.9 11 10 11.9 10 13C10 13.74 10.4 14.38 11 14.72V15.5H13V14.72C13.6 14.37 14 13.74 14 13C14 11.9 13.1 11 12 11Z"
            fill="currentColor"
          />
          <path
            d="M18 1.01L6 1C4.9 1 4 1.9 4 3V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V3C20 1.9 19.1 1.01 18 1.01ZM18 21H6V20H18V21ZM18 18H6V6H18V18ZM18 4H6V3H18V4Z"
            fill="currentColor"
          />
          <path
            d="M16.01 15.95C16.63 15.12 17 14.11 17 13C17 11.89 16.63 10.88 16.01 10.05L14.94 11.12C15.29 11.66 15.5 12.31 15.5 13C15.5 13.69 15.29 14.34 14.94 14.88L16.01 15.95Z"
            fill="currentColor"
          />
          <path
            d="M9.06 14.88C8.71 14.34 8.5 13.69 8.5 13C8.5 11.07 10.07 9.5 12 9.5V10.75L14.25 8.75L12 6.75V8C9.24 8 7 10.24 7 13C7 14.11 7.37 15.12 7.99 15.95L9.06 14.88Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconOndemandVideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ondemand_video">
        <path
          id="Vector"
          d="M9 7V15L16 11L9 7ZM21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOnlinePrediction(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="online_prediction">
        <path
          id="Vector"
          d="M15.5 11.5001C15.5 13.5001 13 15.0001 13 16.5001H11C11 15.0001 8.5 13.5001 8.5 11.5001C8.5 9.57005 10.07 8.00005 12 8.00005C13.93 8.00005 15.5 9.57005 15.5 11.5001ZM13 17.5001H11V19.0001H13V17.5001ZM22 12.0001C22 9.24005 20.88 6.74005 19.07 4.93005L18.01 5.99005C19.55 7.53005 20.5 9.66005 20.5 12.0001C20.5 14.3401 19.55 16.4701 18.01 18.0101L19.07 19.0701C20.88 17.2601 22 14.7601 22 12.0001ZM3.5 12.0001C3.5 9.66005 4.45 7.53005 5.99 5.99005L4.93 4.93005C3.12 6.74005 2 9.24005 2 12.0001C2 14.7601 3.12 17.2601 4.93 19.0701L5.99 18.0101C4.45 16.4701 3.5 14.3401 3.5 12.0001ZM17.5 12.0001C17.5 13.5201 16.88 14.8901 15.89 15.8901L16.95 16.9501C18.22 15.6801 19 13.9301 19 12.0001C19 10.0701 18.22 8.32005 16.95 7.05005L15.89 8.11005C16.88 9.11005 17.5 10.4801 17.5 12.0001ZM7.05 16.9501L8.11 15.8901C7.11 14.8901 6.5 13.5201 6.5 12.0001C6.5 10.4801 7.12 9.11005 8.11 8.11005L7.05 7.05005C5.78 8.32005 5 10.0701 5 12.0001C5 13.9301 5.78 15.6801 7.05 16.9501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOpacity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="opacity">
        <path
          id="Vector"
          d="M17.66 7.99497L12 2.34497L6.34 7.99497C4.78 9.55497 4 11.635 4 13.635C4 15.635 4.78 17.745 6.34 19.305C7.9 20.865 9.95 21.655 12 21.655C14.05 21.655 16.1 20.865 17.66 19.305C19.22 17.745 20 15.635 20 13.635C20 11.635 19.22 9.55497 17.66 7.99497ZM6 13.995C6.01 11.995 6.62 10.725 7.76 9.59497L12 5.26497L16.24 9.64497C17.38 10.765 17.99 11.995 18 13.995H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOpenInBrowser(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="open_in_browser">
        <path
          id="Vector"
          d="M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H9V18H5V8H19V18H15V20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM12 10L8 14H11V20H13V14H16L12 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOpenInFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="open_in_full">
        <path
          id="Vector"
          d="M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOpenInNew(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="open_in_new">
        <path
          id="Vector"
          d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOpenInNewOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="open_in_new_off">
        <path
          id="Vector"
          d="M17.505 5.08998L14.715 2.28998H21.715V9.28998L18.925 6.48998L14.835 10.58L13.425 9.16998L17.505 5.08998ZM19.715 11.29V15.46L21.715 17.46V11.29H19.715ZM20.495 21.9L18.885 20.29H5.71498C4.60498 20.29 3.71498 19.39 3.71498 18.29V5.11998L2.10498 3.50998L3.51498 2.09998L21.895 20.48L20.495 21.9ZM16.885 18.29L12.005 13.41L10.415 15L9.00498 13.59L10.595 12L5.71498 7.11998V18.29H16.885ZM8.54498 4.28998H12.715V2.28998H6.54498L8.54498 4.28998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOpenWith(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="open_with">
        <path
          id="Vector"
          d="M10 9H14V6H17L12 1L7 6H10V9ZM9 10H6V7L1 12L6 17V14H9V10ZM23 12L18 7V10H15V14H18V17L23 12ZM14 15H10V18H7L12 23L17 18H14V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOtherHouses(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="other_houses">
        <path
          id="Vector"
          d="M12 3L1 11.4L2.21 12.99L4 11.62V21H20V11.62L21.79 12.98L23 11.4L12 3ZM18 19H6V10.1L12 5.52L18 10.1V19ZM9 14C9 14.55 8.55 15 8 15C7.45 15 7 14.55 7 14C7 13.45 7.45 13 8 13C8.55 13 9 13.45 9 14ZM12 13C12.55 13 13 13.45 13 14C13 14.55 12.55 15 12 15C11.45 15 11 14.55 11 14C11 13.45 11.45 13 12 13ZM15 14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14C17 14.55 16.55 15 16 15C15.45 15 15 14.55 15 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOutbound(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="outbound">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.88 11.54L8.92 16.5L7.51 15.09L12.47 10.13L10.34 8L15.99 8.01L16 13.66L13.88 11.54Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOutbox(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="outbox">
        <g id="Vector">
          <path
            d="M11 9.83V14H13V9.83L14.59 11.41L16 10L12 6L8 10L9.41 11.41L11 9.83Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.02C8.93 17.21 10.37 18 12 18C13.63 18 15.06 17.21 15.98 16H19V19ZM19 14H14.82C14.41 15.16 13.31 16 12 16C10.69 16 9.6 15.16 9.18 14H5V5H19V14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconOutdoorGrill(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="outdoor_grill">
        <g id="Vector">
          <path
            d="M16.5 22C18.16 22 19.5 20.66 19.5 19C19.5 17.34 18.16 16 16.5 16C15.2 16 14.1 16.84 13.68 18H8.64L10.63 14.94C10.92 14.98 11.21 15 11.5 15C11.79 15 12.08 14.98 12.37 14.94L13.39 16.51C13.81 15.98 14.35 15.56 14.99 15.3L14.39 14.37C16.81 13.27 18.5 10.84 18.5 8H4.5C4.5 10.84 6.19 13.27 8.62 14.37L4.67 20.45C4.37 20.91 4.5 21.53 4.96 21.83C5.42 22.13 6.04 22 6.34 21.54L7.34 19.99H13.68C14.1 21.16 15.2 22 16.5 22ZM16.5 18C17.05 18 17.5 18.45 17.5 19C17.5 19.55 17.05 20 16.5 20C15.95 20 15.5 19.55 15.5 19C15.5 18.45 15.95 18 16.5 18ZM6.92 10H16.08C15.31 11.76 13.54 13 11.5 13C9.46 13 7.69 11.76 6.92 10Z"
            fill="currentColor"
          />
          <path
            d="M8.91 7H9.91C10.06 5.85 10.14 5.36 9.02 4.04C8.6 3.54 8.34 3.27 8.56 2H7.57C7.36 3.11 7.6 4.05 8.46 4.96C8.68 5.2 9.25 5.63 8.91 7Z"
            fill="currentColor"
          />
          <path
            d="M11.39 7H12.39C12.54 5.85 12.62 5.36 11.5 4.04C11.08 3.54 10.82 3.26 11.04 2H10.05C9.84 3.11 10.08 4.05 10.94 4.96C11.17 5.2 11.74 5.63 11.39 7Z"
            fill="currentColor"
          />
          <path
            d="M13.91 7H14.91C15.06 5.85 15.14 5.36 14.02 4.04C13.6 3.54 13.34 3.27 13.56 2H12.57C12.36 3.11 12.6 4.05 13.46 4.96C13.68 5.2 14.25 5.63 13.91 7Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconOutlet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="outlet">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 11V8C10 7.45 9.55 7 9 7C8.45 7 8 7.45 8 8V11C8 11.55 8.45 12 9 12C9.55 12 10 11.55 10 11ZM16 11V8C16 7.45 15.55 7 15 7C14.45 7 14 7.45 14 8V11C14 11.55 14.45 12 15 12C15.55 12 16 11.55 16 11ZM14 16C14 14.9 13.1 14 12 14C10.9 14 10 14.9 10 16V18H14V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOutlinedFlag(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="outlined_flag">
        <path
          id="Vector"
          d="M13.5 5.5L12.5 3.5H4.5V20.5H6.5V13.5H11.5L12.5 15.5H19.5V5.5H13.5ZM17.5 13.5H13.5L12.5 11.5H6.5V5.5H11.5L12.5 7.5H17.5V13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconOutput(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="output">
        <g id="Vector">
          <path
            d="M16.5 17L21.5 12L16.5 7L15.09 8.41L17.67 11H8.5V13H17.67L15.09 15.59L16.5 17Z"
            fill="currentColor"
          />
          <path
            d="M18.5 19H4.5V5H18.5V7H20.5V5C20.5 3.9 19.61 3 18.5 3H4.5C3.4 3 2.5 3.9 2.5 5V19C2.5 20.1 3.4 21 4.5 21H18.5C19.61 21 20.5 20.1 20.5 19V17H18.5V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPadding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="padding">
        <path
          id="Vector"
          d="M3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5ZM19 19H5V5H19V19ZM11 7H13V9H11V7ZM7 7H9V9H7V7ZM15 7H17V9H15V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPages(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pages">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13 5H19V11H16L17 7L13 8V5ZM5 5H11V8L7 7L8 11H5V5ZM11 19H5V13H8L7 17L11 16V19ZM19 19H13V16L17 17L16 13H19V19ZM14.63 14.63L12 13.72L9.37 14.63L10.28 12L9.37 9.37L12 10.28L14.63 9.37L13.72 12L14.63 14.63Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPageview(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pageview">
        <path
          id="Vector"
          d="M11.49 16C12.37 16 13.19 15.74 13.88 15.3L16.32 17.74L17.74 16.32L15.3 13.89C15.74 13.19 16 12.38 16 11.5C16 9.01 13.99 7 11.5 7C9.01 7 7 9.01 7 11.5C7 13.99 9.01 16 11.49 16ZM11.5 9C12.88 9 14 10.12 14 11.5C14 12.88 12.88 14 11.5 14C10.12 14 9 12.88 9 11.5C9 10.12 10.12 9 11.5 9ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPaid(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="paid">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.89 11.1C11.11 10.51 10.25 10.14 10.25 9.2C10.25 8.18 11.36 7.81 12.06 7.81C13.37 7.81 13.85 8.8 13.96 9.15L15.54 8.48C15.39 8.04 14.72 6.57 12.88 6.25V5H11.13V6.26C8.53 6.82 8.51 9.11 8.51 9.22C8.51 11.49 10.76 12.13 11.86 12.53C13.44 13.09 14.14 13.6 14.14 14.56C14.14 15.69 13.09 16.17 12.16 16.17C10.34 16.17 9.82 14.3 9.76 14.08L8.1 14.75C8.73 16.94 10.38 17.53 11.12 17.71V19H12.87V17.76C13.39 17.67 15.89 17.17 15.89 14.54C15.9 13.15 15.29 11.93 12.89 11.1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPalette(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="palette">
        <g id="Vector">
          <path
            d="M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.04 22 11C22 14.31 19.31 17 16 17H14.23C13.95 17 13.73 17.22 13.73 17.5C13.73 17.62 13.78 17.73 13.86 17.83C14.27 18.3 14.5 18.89 14.5 19.5C14.5 20.88 13.38 22 12 22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C12.28 20 12.5 19.78 12.5 19.5C12.5 19.34 12.42 19.22 12.36 19.15C11.95 18.69 11.73 18.1 11.73 17.5C11.73 16.12 12.85 15 14.23 15H16C18.21 15 20 13.21 20 11C20 7.14 16.41 4 12 4Z"
            fill="currentColor"
          />
          <path
            d="M6.5 13C7.32843 13 8 12.3284 8 11.5C8 10.6716 7.32843 10 6.5 10C5.67157 10 5 10.6716 5 11.5C5 12.3284 5.67157 13 6.5 13Z"
            fill="currentColor"
          />
          <path
            d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z"
            fill="currentColor"
          />
          <path
            d="M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z"
            fill="currentColor"
          />
          <path
            d="M17.5 13C18.3284 13 19 12.3284 19 11.5C19 10.6716 18.3284 10 17.5 10C16.6716 10 16 10.6716 16 11.5C16 12.3284 16.6716 13 17.5 13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPanTool(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pan_tool">
        <path
          id="Vector"
          d="M18.3699 23.995H11.8199C10.7399 23.995 9.67988 23.545 8.92988 22.765L1.62988 15.155L3.69988 13.325C4.31988 12.775 5.22988 12.665 5.95988 13.055L8.36988 14.335V4.785C8.36988 3.405 9.48988 2.285 10.8699 2.285C11.0399 2.285 11.2099 2.305 11.3799 2.335C11.4699 1.035 12.5499 0.00500488 13.8699 0.00500488C14.7299 0.00500488 15.4799 0.435005 15.9299 1.095C16.2199 0.975005 16.5399 0.915005 16.8699 0.915005C18.2499 0.915005 19.3699 2.03501 19.3699 3.415V3.695C19.5299 3.665 19.6999 3.645 19.8699 3.645C21.2499 3.645 22.3699 4.765 22.3699 6.145V19.995C22.3699 22.205 20.5799 23.995 18.3699 23.995ZM4.50988 15.275L10.3699 21.375C10.7499 21.765 11.2699 21.995 11.8099 21.995H18.3699C19.4699 21.995 20.3699 21.095 20.3699 19.995V6.145C20.3699 5.865 20.1499 5.645 19.8699 5.645C19.5899 5.645 19.3699 5.865 19.3699 6.145V11.995H17.3699V3.415C17.3699 3.135 17.1499 2.915 16.8699 2.915C16.5899 2.915 16.3699 3.135 16.3699 3.415V11.995H14.3699V2.505C14.3699 2.225 14.1499 2.005 13.8699 2.005C13.5899 2.005 13.3699 2.225 13.3699 2.505V11.995H11.3699V4.785C11.3699 4.505 11.1499 4.285 10.8699 4.285C10.5899 4.285 10.3699 4.515 10.3699 4.785V17.655L5.01988 14.825L4.50988 15.275Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanToolAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pan_tool_alt">
        <path
          id="Vector"
          d="M18.8905 11.77L15.0905 10.1C14.9605 10.04 14.8105 10 14.6505 10H14.0005V5.5C14.0005 4.12 12.8805 3 11.5005 3C10.1205 3 9.00049 4.12 9.00049 5.5V13.65L7.13049 13.25C6.94049 13.22 6.11049 13.1 5.40049 13.81L4.00049 15.22L9.12049 20.41C9.49049 20.79 10.0005 21 10.5305 21H17.0805C18.0605 21 18.8905 20.3 19.0505 19.33L19.9705 13.89C20.1205 13.03 19.6805 12.17 18.8905 11.77ZM17.0805 19H10.5305L6.83049 15.22L11.0005 16.11V5.5C11.0005 5.22 11.2205 5 11.5005 5C11.7805 5 12.0005 5.22 12.0005 5.5V11.68H13.7605L18.0005 13.56L17.0805 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanorama(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama">
        <path
          id="Vector"
          d="M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V6C23 4.9 22.1 4 21 4ZM21 18H3V6H21V18ZM14.5 11L11 15.51L8.5 12.5L5 17H19L14.5 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaFishEye(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_fish_eye">
        <path
          id="Vector"
          d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaHorizontal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_horizontal">
        <path
          id="Vector"
          d="M20 6.54V17.45C17.4 16.68 14.72 16.29 12 16.29C9.28 16.29 6.6 16.68 4 17.45V6.54C6.6 7.31 9.28 7.7 12 7.7C14.72 7.71 17.4 7.32 20 6.54ZM21.43 4C21.33 4 21.23 4.02 21.12 4.06C18.18 5.16 15.09 5.7 12 5.7C8.91 5.7 5.82 5.15 2.88 4.06C2.77 4.02 2.66 4 2.57 4C2.23 4 2 4.23 2 4.63V19.38C2 19.77 2.23 20 2.57 20C2.67 20 2.77 19.98 2.88 19.94C5.82 18.84 8.91 18.3 12 18.3C15.09 18.3 18.18 18.85 21.12 19.94C21.23 19.98 21.33 20 21.43 20C21.76 20 22 19.77 22 19.37V4.63C22 4.23 21.76 4 21.43 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaHorizontalSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_horizontal_select">
        <path
          id="Vector"
          d="M12 5.49995C8.11 5.49995 5.05 4.65995 3.31 4.06995C2.67 3.84995 2 4.32995 2 5.01995V19C2 19.68 2.66 20.17 3.31 19.95C5.36 19.26 8.1 18.5 12 18.5C15.87 18.5 18.66 19.26 20.69 19.95C21.34 20.16 22 19.68 22 19V4.99995C22 4.31995 21.34 3.82995 20.69 4.04995C18.66 4.72995 15.86 5.49995 12 5.49995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaPhotosphere(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_photosphere">
        <path
          id="Vector"
          d="M21.95 8.15C21.66 7.99 21.34 7.84 21.02 7.69C19.4 4.33 15.98 2 12 2C8.02 2 4.6 4.33 2.99 7.68C2.66 7.83 2.35 7.98 2.06 8.14C1.41 8.5 1 9.17 1 9.91V14.09C1 14.83 1.41 15.5 2.05 15.86C2.34 16.02 2.66 16.17 2.98 16.32C4.6 19.67 8.02 22 12 22C15.98 22 19.4 19.67 21.01 16.32C21.34 16.17 21.65 16.02 21.94 15.86C22.59 15.5 23 14.83 23 14.09V9.91C23 9.17 22.59 8.5 21.95 8.15ZM21 9.91V14.1C18.81 15.31 15.53 16 12 16C8.47 16 5.19 15.3 3 14.09V9.91C5.2 8.69 8.47 8 12 8C15.53 8 18.81 8.7 21 9.91ZM12 4C14.37 4 16.49 5.04 17.95 6.68C16.17 6.25 14.15 6 12 6C9.85 6 7.83 6.25 6.05 6.68C7.51 5.04 9.63 4 12 4ZM12 20C9.63 20 7.51 18.96 6.05 17.32C7.83 17.75 9.85 18 12 18C14.15 18 16.17 17.75 17.95 17.32C16.49 18.96 14.37 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaPhotosphereSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_photosphere_select">
        <path
          id="Vector"
          d="M21.95 8.15C21.66 7.99 21.34 7.84 21.02 7.69C19.4 4.33 15.98 2 12 2C8.02 2 4.6 4.33 2.99 7.68C2.66 7.83 2.35 7.98 2.06 8.14C1.41 8.5 1 9.17 1 9.91V14.09C1 14.83 1.41 15.5 2.05 15.86C2.34 16.02 2.66 16.17 2.98 16.32C4.6 19.67 8.02 22 12 22C15.98 22 19.4 19.67 21.01 16.32C21.34 16.17 21.65 16.02 21.94 15.86C22.59 15.5 23 14.83 23 14.09V9.91C23 9.17 22.59 8.5 21.95 8.15ZM12 4C14.37 4 16.49 5.04 17.95 6.68C16.17 6.25 14.15 6 12 6C9.85 6 7.83 6.25 6.05 6.68C7.51 5.04 9.63 4 12 4ZM12 20C9.63 20 7.51 18.96 6.05 17.32C7.83 17.75 9.85 18 12 18C14.15 18 16.17 17.75 17.95 17.32C16.49 18.96 14.37 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaVertical(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_vertical">
        <path
          id="Vector"
          d="M19.9351 21.12C18.8351 18.18 18.2951 15.09 18.2951 12C18.2951 8.91 18.8451 5.82 19.9351 2.88C19.9751 2.77 19.9951 2.66 19.9951 2.57C19.9951 2.23 19.7651 2 19.3651 2H4.62512C4.22512 2 3.99512 2.23 3.99512 2.57C3.99512 2.67 4.01512 2.77 4.05512 2.88C5.15512 5.82 5.70512 8.91 5.70512 12C5.70512 15.09 5.15512 18.18 4.06512 21.12C4.01512 21.23 3.99512 21.34 3.99512 21.43C3.99512 21.76 4.22512 22 4.62512 22H19.3751C19.7651 22 20.0051 21.76 20.0051 21.43C19.9951 21.33 19.9751 21.23 19.9351 21.12ZM6.53512 20C7.30512 17.4 7.69512 14.72 7.69512 12C7.69512 9.28 7.30512 6.6 6.53512 4H17.4451C16.6751 6.6 16.2851 9.28 16.2851 12C16.2851 14.72 16.6751 17.4 17.4451 20H6.53512Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaVerticalSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_vertical_select">
        <path
          id="Vector"
          d="M18.4984 12C18.4984 8.11 19.3384 5.05 19.9284 3.31C20.1484 2.67 19.6684 2 18.9784 2H4.99835C4.31835 2 3.83835 2.66 4.04835 3.31C4.73835 5.36 5.49835 8.1 5.49835 12C5.49835 15.87 4.73835 18.66 4.04835 20.69C3.83835 21.34 4.31835 22 4.99835 22H18.9984C19.6784 22 20.1684 21.34 19.9484 20.69C19.2684 18.66 18.4984 15.86 18.4984 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaWideAngle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_wide_angle">
        <path
          id="Vector"
          d="M12 6C14.45 6 16.71 6.2 19.29 6.64C19.76 8.42 20 10.22 20 12C20 13.78 19.76 15.58 19.29 17.36C16.71 17.8 14.45 18 12 18C9.55 18 7.29 17.8 4.71 17.36C4.24 15.58 4 13.78 4 12C4 10.22 4.24 8.42 4.71 6.64C7.29 6.2 9.55 6 12 6ZM12 4C9.27 4 6.78 4.24 4.05 4.72L3.12 4.88L2.87 5.78C2.29 7.85 2 9.93 2 12C2 14.07 2.29 16.15 2.87 18.22L3.12 19.11L4.05 19.27C6.78 19.76 9.27 20 12 20C14.73 20 17.22 19.76 19.95 19.28L20.88 19.12L21.13 18.23C21.71 16.15 22 14.07 22 12C22 9.93 21.71 7.85 21.13 5.78L20.88 4.89L19.95 4.73C17.22 4.24 14.73 4 12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPanoramaWideAngleSelect(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="panorama_wide_angle_select">
        <path
          id="Vector"
          d="M12 4C8.03 4 5.15 4.63 3 5C2.45 6.97 2 8.92 2 12C2 15.03 2.45 17.05 3 19C5.15 19.37 7.98 20 12 20C15.97 20 18.85 19.37 21 19C21.57 16.98 22 15.01 22 12C22 8.97 21.55 6.95 21 5C18.85 4.63 16.02 4 12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconParagliding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="paragliding">
        <path
          id="Vector"
          d="M12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.48 17.94C14.68 18.54 14 19 12 19C10 19 9.32 18.54 8.52 17.94C8.04 17.55 7 16.76 7 14H5C5 16.7 5.93 18.41 7.3 19.5C7.8 19.9 8.4 20.2 9 20.4V24H15V20.4C15.6 20.2 16.2 19.9 16.7 19.5C18.07 18.41 19 16.7 19 14H17C17 16.76 15.96 17.55 15.48 17.94ZM23 4.25V7.74C23 8.54 22.12 9 21.44 8.57C21.3 8.48 21.16 8.39 21 8.31L19 13H17L15.5 6.72C14.4 6.58 13.22 6.5 12 6.5C10.78 6.5 9.6 6.58 8.5 6.72L7 13H5L3 8.31C2.84 8.39 2.7 8.48 2.56 8.57C1.88 9 1 8.55 1 7.74V4.25C1 1.9 5.92 0 12 0C18.08 0 23 1.9 23 4.25ZM6.9 6.98C5.97 7.17 5.12 7.41 4.37 7.69L5.88 11.24L6.9 6.98ZM19.63 7.69C18.88 7.41 18.03 7.17 17.1 6.98L18.12 11.23L19.63 7.69ZM21 4.31C20.65 3.63 17.57 2 12 2C6.43 2 3.35 3.63 3 4.31V6.08C5.34 5.07 8.56 4.5 12 4.5C15.44 4.5 18.66 5.07 21 6.08V4.31Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPark(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="park">
        <path
          id="Vector"
          d="M16.95 12H18.95L11.95 2L5.00005 12H6.95005L3.05005 18H9.97005V22H13.92V18H20.95L16.95 12ZM6.74005 16L10.64 10H8.83005L11.96 5.5L15.11 10H13.21L17.21 16H6.74005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPartyMode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="party_mode">
        <path
          id="Vector"
          d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L8.64 6.35L9.88 5H14.12L15.36 6.35L15.95 7H20V19ZM9 13C9 11.34 10.34 10 12 10H15.98C15.06 8.79 13.63 8 12 8C9.24 8 7 10.24 7 13C7 13.34 7.04 13.68 7.1 14H9.18C9.07 13.69 9 13.35 9 13ZM15 13C15 14.66 13.66 16 12 16H8.02C8.94 17.21 10.37 18 12 18C14.76 18 17 15.76 17 13C17 12.66 16.97 12.32 16.9 12H14.82C14.93 12.31 15 12.65 15 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPassword(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="password">
        <path
          id="Vector"
          d="M2 16H22V18H2V16ZM3.15 11.95L4 10.47L4.85 11.95L6.15 11.2L5.3 9.72H7V8.22H5.3L6.15 6.75L4.85 6L4 7.47L3.15 6L1.85 6.75L2.7 8.22H1V9.72H2.7L1.85 11.2L3.15 11.95ZM9.85 11.2L11.15 11.95L12 10.47L12.85 11.95L14.15 11.2L13.3 9.72H15V8.22H13.3L14.15 6.75L12.85 6L12 7.47L11.15 6L9.85 6.75L10.7 8.22H9V9.72H10.7L9.85 11.2ZM23 8.22H21.3L22.15 6.75L20.85 6L20 7.47L19.15 6L17.85 6.75L18.7 8.22H17V9.72H18.7L17.85 11.2L19.15 11.95L20 10.47L20.85 11.95L22.15 11.2L21.3 9.72H23V8.22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPattern(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pattern">
        <path
          id="Vector"
          d="M4 6C4 4.9 4.9 4 6 4C7.1 4 8 4.9 8 6C8 7.1 7.1 8 6 8C4.9 8 4 7.1 4 6ZM6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14ZM12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM17.98 16C17.24 16 16.61 16.4 16.26 17H13.72C13.38 16.4 12.74 16 12 16C11.26 16 10.63 16.4 10.28 17H8.41L11.48 13.93C11.65 13.97 11.82 14 12 14C13.1 14 14 13.1 14 12C14 11.82 13.97 11.65 13.93 11.49L17.49 7.93C17.65 7.97 17.82 8 18 8C19.1 8 20 7.1 20 6C20 4.9 19.1 4 18 4C16.9 4 16 4.9 16 6C16 6.18 16.03 6.35 16.07 6.51L12.51 10.07C12.35 10.03 12.18 10 12 10C10.9 10 10 10.9 10 12C10 12.18 10.03 12.35 10.07 12.51L6.51 16.07C6.35 16.03 6.18 16 6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C6.74 20 7.37 19.6 7.72 19H10.29C10.63 19.6 11.27 20 12.01 20C12.75 20 13.38 19.6 13.73 19H16.28C16.62 19.6 17.26 20 18 20C19.1 20 20 19.1 20 18C19.98 16.9 19.08 16 17.98 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPause(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pause">
        <path id="Vector" d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconPauseCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pause_circle">
        <path
          id="Vector"
          d="M9 16H11V8H9V16ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM13 16H15V8H13V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPauseCircleFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pause_circle_filled">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16H9V8H11V16ZM15 16H13V8H15V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPausePresentation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pause_presentation">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.85 1 4.95V18.95C1 20.05 1.9 21 3 21H21C22.1 21 23 20.05 23 18.95V4.95C23 3.85 22.1 3 21 3ZM21 19H3V5H21V19ZM9 8H11V16H9V8ZM13 8H15V16H13V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPayment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="payment">
        <path
          id="Vector"
          d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPayments(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="payments">
        <path
          id="Vector"
          d="M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM17 14H3V6H17V14ZM10 7C8.34 7 7 8.34 7 10C7 11.66 8.34 13 10 13C11.66 13 13 11.66 13 10C13 8.34 11.66 7 10 7ZM23 7V18C23 19.1 22.1 20 21 20H4V18H21V7H23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPedalBike(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pedal_bike">
        <path
          id="Vector"
          d="M18.18 10L16.48 5.32C16.19 4.53 15.44 4 14.6 4H12V6H14.6L16.06 10H11.25L10.89 9H12V7H7V9H8.75L10.57 14H9.9C9.46 11.77 7.59 10.12 5.25 10.01C2.45 9.87 0 12.2 0 15C0 17.8 2.2 20 5 20C7.46 20 9.45 18.31 9.9 16H14.1C14.54 18.23 16.41 19.88 18.75 19.99C21.55 20.12 24 17.8 24 14.99C24 12.19 21.8 9.99 19 9.99H18.18V10ZM7.82 16C7.42 17.17 6.33 18 5 18C3.32 18 2 16.68 2 15C2 13.32 3.32 12 5 12C6.33 12 7.42 12.83 7.82 14H5V16H7.82ZM14.1 14H12.7L11.97 12H15C14.56 12.58 14.24 13.25 14.1 14ZM19 18C17.32 18 16 16.68 16 15C16 14.07 16.41 13.27 17.05 12.72L18.01 15.36L19.89 14.68L18.92 12.01C18.95 12.01 18.98 12 19.01 12C20.69 12 22.01 13.32 22.01 15C22.01 16.68 20.68 18 19 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPending(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pending">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M7 13.5C7.82843 13.5 8.5 12.8284 8.5 12C8.5 11.1716 7.82843 10.5 7 10.5C6.17157 10.5 5.5 11.1716 5.5 12C5.5 12.8284 6.17157 13.5 7 13.5Z"
            fill="currentColor"
          />
          <path
            d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
            fill="currentColor"
          />
          <path
            d="M17 13.5C17.8284 13.5 18.5 12.8284 18.5 12C18.5 11.1716 17.8284 10.5 17 10.5C16.1716 10.5 15.5 11.1716 15.5 12C15.5 12.8284 16.1716 13.5 17 13.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPendingActions(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pending_actions">
        <path
          id="Vector"
          d="M16 12.5C13.24 12.5 11 14.74 11 17.5C11 20.26 13.24 22.5 16 22.5C18.76 22.5 21 20.26 21 17.5C21 14.74 18.76 12.5 16 12.5ZM17.65 19.85L15.5 17.7V14.5H16.5V17.29L18.35 19.14L17.65 19.85ZM17 3.5H13.82C13.4 2.34 12.3 1.5 11 1.5C9.7 1.5 8.6 2.34 8.18 3.5H5C3.9 3.5 3 4.4 3 5.5V20.5C3 21.6 3.9 22.5 5 22.5H11.11C10.52 21.93 10.04 21.25 9.69 20.5H5V5.5H7V8.5H15V5.5H17V10.58C17.71 10.68 18.38 10.89 19 11.18V5.5C19 4.4 18.1 3.5 17 3.5ZM11 5.5C10.45 5.5 10 5.05 10 4.5C10 3.95 10.45 3.5 11 3.5C11.55 3.5 12 3.95 12 4.5C12 5.05 11.55 5.5 11 5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPentagon(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pentagon">
        <path
          id="Vector"
          d="M19.63 10.28L16.56 19.5H7.44L4.37 10.28L12 4.94L19.63 10.28ZM2 9.5L6 21.5H18L22 9.5L12 2.5L2 9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPeople(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="people">
        <path
          id="Vector"
          d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPeopleAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="people_alt">
        <g id="Vector">
          <path
            d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z"
            fill="currentColor"
          />
          <path
            d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
            fill="currentColor"
          />
          <path
            d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
            fill="currentColor"
          />
          <path
            d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPeopleOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="people_outline">
        <path
          id="Vector"
          d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPercent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="percent">
        <path
          id="Vector"
          d="M7.5 4C5.57 4 4 5.57 4 7.5C4 9.43 5.57 11 7.5 11C9.43 11 11 9.43 11 7.5C11 5.57 9.43 4 7.5 4ZM7.5 9C6.67 9 6 8.33 6 7.5C6 6.67 6.67 6 7.5 6C8.33 6 9 6.67 9 7.5C9 8.33 8.33 9 7.5 9ZM16.5 13C14.57 13 13 14.57 13 16.5C13 18.43 14.57 20 16.5 20C18.43 20 20 18.43 20 16.5C20 14.57 18.43 13 16.5 13ZM16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18ZM5.41 20L4 18.59L18.59 4L20 5.41L5.41 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermCameraMic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_camera_mic">
        <path
          id="Vector"
          d="M12 6C10.9 6 10 6.9 10 8V12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12V8C14 6.9 13.1 6 12 6ZM20 5H16.83L14.97 3H8.96L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H13V17.91C15.83 17.43 18 14.97 18 12H16C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12H6C6 14.97 8.17 17.43 11 17.91V19H4V7H8.21L8.8 6.35L10.04 5H14.28L15.52 6.35L16.11 7H20V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermContactCalendar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_contact_calendar">
        <path
          id="Vector"
          d="M20.84 5.22C20.79 5.1 20.73 4.99 20.66 4.88C20.52 4.67 20.33 4.48 20.12 4.34C20.01 4.27 19.9 4.21 19.78 4.16C19.54 4.06 19.28 4 19 4H18V2H16V4H8V2H6V4H5C4.58 4 4.2 4.13 3.88 4.34C3.67 4.48 3.48 4.67 3.34 4.88C3.27 4.99 3.21 5.1 3.16 5.22C3.06 5.46 3 5.72 3 6V20C3 21.1 3.89 22 5 22H19C19.28 22 19.54 21.94 19.78 21.84C19.9 21.79 20.01 21.73 20.12 21.66C20.33 21.52 20.52 21.33 20.66 21.12C20.87 20.8 21 20.41 21 20V6C21 5.72 20.94 5.46 20.84 5.22ZM5 20V6H19V20H5ZM12 13.88C9.97 13.88 6 14.96 6 17.46V19H18V17.47C18 14.96 14.03 13.88 12 13.88ZM8.31 17C9 16.44 10.69 15.88 12 15.88C13.31 15.88 15.01 16.44 15.69 17H8.31ZM12 13C13.65 13 15 11.65 15 10C15 8.35 13.65 7 12 7C10.35 7 9 8.35 9 10C9 11.65 10.35 13 12 13ZM12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermDataSetting(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_data_setting" clipPath="url(#clip0_395_4122)">
        <path
          id="Vector"
          d="M18.0593 11.57H20.0693V0L0.0693359 20H11.6293V18H4.89934L18.0593 4.83V11.57ZM23.8393 20.32L22.7693 19.49C22.7893 19.33 22.8093 19.17 22.8093 19C22.8093 18.83 22.7993 18.67 22.7693 18.51L23.8293 17.68C23.9193 17.6 23.9493 17.47 23.8893 17.36L22.8893 15.63C22.8293 15.52 22.6993 15.48 22.5793 15.52L21.3393 16.02C21.0793 15.82 20.7993 15.65 20.4893 15.53L20.2993 14.21C20.2893 14.09 20.1793 14 20.0593 14H18.0593C17.9393 14 17.8293 14.09 17.8093 14.21L17.6193 15.53C17.3193 15.66 17.0293 15.82 16.7693 16.02L15.5293 15.52C15.4193 15.48 15.2893 15.52 15.2193 15.63L14.2193 17.36C14.1593 17.47 14.1793 17.6 14.2793 17.68L15.3393 18.51C15.3193 18.67 15.3093 18.83 15.3093 19C15.3093 19.17 15.3193 19.33 15.3393 19.49L14.2793 20.32C14.1893 20.4 14.1593 20.53 14.2193 20.64L15.2193 22.37C15.2793 22.48 15.4093 22.52 15.5293 22.48L16.7693 21.98C17.0293 22.18 17.3093 22.35 17.6193 22.47L17.8093 23.79C17.8293 23.91 17.9293 24 18.0593 24H20.0593C20.1793 24 20.2893 23.91 20.3093 23.79L20.4993 22.47C20.7993 22.34 21.0893 22.18 21.3393 21.98L22.5893 22.48C22.6993 22.52 22.8293 22.48 22.8993 22.37L23.8993 20.64C23.9593 20.53 23.9293 20.4 23.8393 20.32ZM19.0593 20.5C18.2293 20.5 17.5593 19.83 17.5593 19C17.5593 18.17 18.2293 17.5 19.0593 17.5C19.8893 17.5 20.5593 18.17 20.5593 19C20.5593 19.83 19.8893 20.5 19.0593 20.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_4122">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPermDeviceInformation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_device_information">
        <path
          id="Vector"
          d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM7 4V3H17V4H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermIdentity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_identity">
        <path
          id="Vector"
          d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 15C14.7 15 17.8 16.29 18 17V18H6V17.01C6.2 16.29 9.3 15 12 15ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermMedia(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_media">
        <path
          id="Vector"
          d="M2 6H0V11H0.01L0 20C0 21.1 0.9 22 2 22H20V20H2V6ZM7 15H21L17.5 10.5L15 13.51L11.5 9L7 15ZM22 4H14L12 2H6C4.9 2 4.01 2.9 4.01 4L4 16C4 17.1 4.9 18 6 18H22C23.1 18 24 17.1 24 16V6C24 4.9 23.1 4 22 4ZM22 16H6V4H11.17L13.17 6H22V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermPhoneMsg(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_phone_msg">
        <path
          id="Vector"
          d="M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.99 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM12 3V13L15 10H21V3H12ZM19 8H14V5H19V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPermScanWifi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="perm_scan_wifi">
        <path
          id="Vector"
          d="M12 2.5C6.95 2.5 3.15 4.35 0 6.73L12 21.5L24 6.75C20.85 4.37 17.05 2.5 12 2.5ZM2.92 7.15C5.8 5.35 8.74 4.5 12 4.5C15.25 4.5 18.18 5.35 21.08 7.17L12 18.33L2.92 7.15ZM11 9.5H13V15.5H11V9.5ZM11 5.5H13V7.5H11V5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPerson(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person">
        <path
          id="Vector"
          d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPerson2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_2">
        <g id="Vector">
          <path
            d="M18.39 14.56C16.71 13.7 14.53 13 12 13C9.47 13 7.29 13.7 5.61 14.56C4.61 15.07 4 16.1 4 17.22V20H20V17.22C20 16.1 19.39 15.07 18.39 14.56ZM18 18H6V17.22C6 16.84 6.2 16.5 6.52 16.34C7.71 15.73 9.63 15 12 15C14.37 15 16.29 15.73 17.48 16.34C17.8 16.5 18 16.84 18 17.22V18Z"
            fill="currentColor"
          />
          <path
            d="M9.78 12H14.22C15.43 12 16.36 10.94 16.2 9.74L15.88 7.29C15.57 5.39 13.92 4 12 4C10.08 4 8.43 5.39 8.12 7.29L7.8 9.74C7.64 10.94 8.57 12 9.78 12ZM10.1 7.59C10.26 6.67 11.06 6 12 6C12.94 6 13.74 6.67 13.9 7.59L14.22 10H9.78L10.1 7.59Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPerson3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_3">
        <g id="Vector">
          <path
            d="M18.39 15.56C16.71 14.7 14.53 14 12 14C9.47 14 7.29 14.7 5.61 15.56C4.61 16.07 4 17.1 4 18.22V21H20V18.22C20 17.1 19.39 16.07 18.39 15.56ZM18 19H6V18.22C6 17.84 6.2 17.5 6.52 17.34C7.71 16.73 9.63 16 12 16C14.37 16 16.29 16.73 17.48 17.34C17.8 17.5 18 17.84 18 18.22V19Z"
            fill="currentColor"
          />
          <path
            d="M10 13C10.17 13 13.83 13 14 13C15.66 13 17 11.66 17 10C17 9.27 16.73 8.6 16.29 8.08C16.42 7.75 16.5 7.38 16.5 7C16.5 5.75 15.73 4.68 14.64 4.23C14 3.48 13.06 3 12 3C10.94 3 10 3.48 9.36 4.23C8.27 4.68 7.5 5.75 7.5 7C7.5 7.38 7.58 7.75 7.71 8.08C7.27 8.6 7 9.27 7 10C7 11.66 8.34 13 10 13ZM9.24 9.37C10.11 8.33 9.5 7.37 9.5 7C9.5 6.59 9.74 6.23 10.12 6.08C10.41 5.96 10.67 5.77 10.87 5.54C11.04 5.33 11.42 5 12 5C12.58 5 12.96 5.33 13.13 5.53C13.33 5.77 13.59 5.95 13.88 6.07C14.26 6.23 14.5 6.59 14.5 7C14.5 7.37 13.89 8.33 14.76 9.37C15.34 10.06 14.8 11 14 11H10C9.2 11 8.66 10.06 9.24 9.37Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPerson4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_4">
        <g id="Vector">
          <path
            d="M18.39 15.06C16.71 14.2 14.53 13.5 12 13.5C9.47 13.5 7.29 14.2 5.61 15.06C4.61 15.57 4 16.6 4 17.72V20.5H20V17.72C20 16.6 19.39 15.57 18.39 15.06ZM18 18.5H6V17.72C6 17.34 6.2 17 6.52 16.84C7.71 16.23 9.63 15.5 12 15.5C14.37 15.5 16.29 16.23 17.48 16.84C17.8 17 18 17.34 18 17.72V18.5Z"
            fill="currentColor"
          />
          <path
            d="M12 12.5C14.21 12.5 16 10.71 16 8.5C16 7.13 16 5 16 5C16 4.17 15.33 3.5 14.5 3.5C13.98 3.5 13.52 3.77 13.25 4.17C12.98 3.77 12.52 3.5 12 3.5C11.48 3.5 11.02 3.77 10.75 4.17C10.48 3.77 10.02 3.5 9.5 3.5C8.67 3.5 8 4.17 8 5C8 5 8 7.12 8 8.5C8 10.71 9.79 12.5 12 12.5ZM10 6H14V8.5C14 9.6 13.1 10.5 12 10.5C10.9 10.5 10 9.6 10 8.5V6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPersonAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_add">
        <path
          id="Vector"
          d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM15 6C16.1 6 17 6.9 17 8C17 9.1 16.1 10 15 10C13.9 10 13 9.1 13 8C13 6.9 13.9 6 15 6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14ZM9 18C9.22 17.28 12.31 16 15 16C17.7 16 20.8 17.29 21 18H9ZM6 15V12H9V10H6V7H4V10H1V12H4V15H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonAddAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_add_alt">
        <path
          id="Vector"
          d="M20 9V6H18V9H15V11H18V14H20V11H23V9H20ZM9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6ZM15.39 14.56C13.71 13.7 11.53 13 9 13C6.47 13 4.29 13.7 2.61 14.56C1.61 15.07 1 16.1 1 17.22V20H17V17.22C17 16.1 16.39 15.07 15.39 14.56ZM15 18H3V17.22C3 16.84 3.2 16.5 3.52 16.34C4.71 15.73 6.63 15 9 15C11.37 15 13.29 15.73 14.48 16.34C14.8 16.5 15 16.84 15 17.22V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonAddDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_add_disabled" clipPath="url(#clip0_395_3266)">
        <path
          id="Vector"
          d="M15.5 5.14498C16.6 5.14498 17.5 6.04498 17.5 7.14498C17.5 8.13498 16.77 8.96498 15.83 9.11498L13.52 6.80498C13.69 5.86498 14.51 5.14498 15.5 5.14498ZM15.5 3.14498C13.29 3.14498 11.5 4.93498 11.5 7.14498C11.5 7.32498 11.53 7.49498 11.55 7.66498L14.98 11.095C15.15 11.115 15.32 11.145 15.5 11.145C17.71 11.145 19.5 9.35498 19.5 7.14498C19.5 4.93498 17.71 3.14498 15.5 3.14498ZM17.19 13.305L23.03 19.145H23.5V17.145C23.5 15.005 19.94 13.645 17.19 13.305ZM13.51 15.275L15.38 17.145H9.5C9.58 16.905 10.38 16.135 12.41 15.575L13.51 15.275ZM1.91 0.85498L0.5 2.26498L4.5 6.26498V9.14498H1.5V11.145H4.5V14.145H6.5V11.145H9.38L11.89 13.655C9.69 14.255 7.5 15.445 7.5 17.145V19.145H17.38L21.38 23.145L22.79 21.735L1.91 0.85498ZM6.5 9.14498V8.26498L7.38 9.14498H6.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_3266">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPersonOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_off">
        <path
          id="Vector"
          d="M20.7101 16.465L17.3401 13.085C17.9801 13.305 18.5701 13.565 19.1101 13.845C20.0801 14.355 20.6901 15.365 20.7101 16.465ZM21.9001 20.485L20.4901 21.895L17.8801 19.295H4.7101V16.515C4.7101 15.395 5.3201 14.365 6.3201 13.855C7.6101 13.195 9.1901 12.635 10.9901 12.405L2.1001 3.51498L3.5101 2.10498L21.9001 20.485ZM15.8801 17.295L12.8801 14.295C12.8201 14.295 12.7701 14.295 12.7101 14.295C10.3401 14.295 8.4201 15.025 7.2301 15.635C6.9101 15.795 6.7101 16.135 6.7101 16.515V17.295H15.8801ZM12.7101 5.29498C13.8101 5.29498 14.7101 6.19498 14.7101 7.29498C14.7101 8.15498 14.1701 8.88498 13.4101 9.16498L14.8901 10.645C15.9901 9.93498 16.7101 8.69498 16.7101 7.29498C16.7101 5.08498 14.9201 3.29498 12.7101 3.29498C11.3101 3.29498 10.0701 4.01498 9.3601 5.11498L10.8401 6.59498C11.1201 5.83498 11.8501 5.29498 12.7101 5.29498Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_outline">
        <path
          id="Vector"
          d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonPin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_pin">
        <path
          id="Vector"
          d="M19 1.5H5C3.89 1.5 3 2.4 3 3.5V17.5C3 18.6 3.89 19.5 5 19.5H9L12 22.5L15 19.5H19C20.1 19.5 21 18.6 21 17.5V3.5C21 2.4 20.1 1.5 19 1.5ZM19 17.5H14.17L12 19.67L9.83 17.5H5V3.5H19V17.5ZM12 10.5C13.65 10.5 15 9.15 15 7.5C15 5.85 13.65 4.5 12 4.5C10.35 4.5 9 5.85 9 7.5C9 9.15 10.35 10.5 12 10.5ZM12 6.5C12.55 6.5 13 6.95 13 7.5C13 8.05 12.55 8.5 12 8.5C11.45 8.5 11 8.05 11 7.5C11 6.95 11.45 6.5 12 6.5ZM18 15.08C18 12.58 14.03 11.5 12 11.5C9.97 11.5 6 12.58 6 15.08V16.5H18V15.08ZM8.48 14.5C9.22 13.99 10.71 13.5 12 13.5C13.29 13.5 14.78 13.99 15.52 14.5H8.48Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonPinCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_pin_circle">
        <path
          id="Vector"
          d="M12 11C13.33 11 16 11.67 16 13V13.16C15.03 14.28 13.6 15 12 15C10.4 15 8.97 14.28 8 13.16V13C8 11.67 10.67 11 12 11ZM12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonRaisedHand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_raised_hand">
        <path
          id="Vector"
          d="M3 22V20.1818H21V22H3ZM4.8 19.2727V13.8182C4.305 13 3.9225 12.1326 3.6525 11.2159C3.3825 10.2992 3.2475 9.36364 3.2475 8.40909C3.2475 7.48485 3.36375 6.57576 3.59625 5.68182C3.82875 4.78788 4.1025 3.90909 4.4175 3.04545C4.5375 2.72727 4.7325 2.47348 5.0025 2.28409C5.2725 2.0947 5.5725 2 5.9025 2C6.3675 2 6.765 2.15909 7.095 2.47727C7.425 2.79545 7.56 3.17424 7.5 3.61364L7.2525 5.68182C7.1625 6.40909 7.22625 7.09848 7.44375 7.75C7.66125 8.40152 7.9875 8.97348 8.4225 9.46591C8.8575 9.95833 9.3825 10.3523 9.9975 10.6477C10.6125 10.9432 11.28 11.0909 12 11.0909C12.9 11.0909 13.8038 11.1856 14.7113 11.375C15.6188 11.5644 16.41 11.8333 17.085 12.1818C17.76 12.5303 18.2813 12.9735 18.6488 13.5114C19.0163 14.0492 19.2 14.7121 19.2 15.5V19.2727H4.8ZM6.6 17.4545H17.4V15.5C17.4 15.1364 17.31 14.8144 17.13 14.5341C16.95 14.2538 16.695 14.0303 16.365 13.8636C15.75 13.5606 15.0375 13.3258 14.2275 13.1591C13.4175 12.9924 12.675 12.9091 12 12.9091C11.01 12.9091 10.0913 12.7045 9.24375 12.2955C8.39625 11.8864 7.67625 11.3371 7.08375 10.6477C6.49125 9.95833 6.045 9.16288 5.745 8.26136C5.445 7.35985 5.355 6.42424 5.475 5.45455C5.325 5.90909 5.21625 6.39394 5.14875 6.90909C5.08125 7.42424 5.0475 7.92424 5.0475 8.40909C5.0475 9.28788 5.20125 10.1326 5.50875 10.9432C5.81625 11.7538 6.18 12.5455 6.6 13.3182V17.4545ZM12 10.1818C11.01 10.1818 10.1625 9.82576 9.4575 9.11364C8.7525 8.40152 8.4 7.54545 8.4 6.54545C8.4 5.54545 8.7525 4.68939 9.4575 3.97727C10.1625 3.26515 11.01 2.90909 12 2.90909C12.99 2.90909 13.8375 3.26515 14.5425 3.97727C15.2475 4.68939 15.6 5.54545 15.6 6.54545C15.6 7.54545 15.2475 8.40152 14.5425 9.11364C13.8375 9.82576 12.99 10.1818 12 10.1818ZM12 8.36364C12.495 8.36364 12.9188 8.18561 13.2713 7.82955C13.6238 7.47348 13.8 7.04545 13.8 6.54545C13.8 6.04545 13.6238 5.61742 13.2713 5.26136C12.9188 4.9053 12.495 4.72727 12 4.72727C11.505 4.72727 11.0813 4.9053 10.7288 5.26136C10.3763 5.61742 10.2 6.04545 10.2 6.54545C10.2 7.04545 10.3763 7.47348 10.7288 7.82955C11.0813 8.18561 11.505 8.36364 12 8.36364ZM8.4 19.2727V18.4318C8.4 17.4167 8.74875 16.5455 9.44625 15.8182C10.1438 15.0909 10.995 14.7273 12 14.7273H15.6V16.5455H12C11.49 16.5455 11.0625 16.7311 10.7175 17.1023C10.3725 17.4735 10.2 17.9167 10.2 18.4318V19.2727H8.4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonRemove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_remove">
        <g id="Vector">
          <path
            d="M13.5 8C13.5 5.79 11.71 4 9.5 4C7.29 4 5.5 5.79 5.5 8C5.5 10.21 7.29 12 9.5 12C11.71 12 13.5 10.21 13.5 8ZM11.5 8C11.5 9.1 10.6 10 9.5 10C8.4 10 7.5 9.1 7.5 8C7.5 6.9 8.4 6 9.5 6C10.6 6 11.5 6.9 11.5 8Z"
            fill="currentColor"
          />
          <path
            d="M1.5 18V20H17.5V18C17.5 15.34 12.17 14 9.5 14C6.83 14 1.5 15.34 1.5 18ZM3.5 18C3.7 17.29 6.8 16 9.5 16C12.19 16 15.27 17.28 15.5 18H3.5Z"
            fill="currentColor"
          />
          <path d="M22.5 10H16.5V12H22.5V10Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconPersonSearch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="person_search">
        <g id="Vector">
          <path
            d="M10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11ZM10 5C11.1 5 12 5.9 12 7C12 8.1 11.1 9 10 9C8.9 9 8 8.1 8 7C8 5.9 8.9 5 10 5Z"
            fill="currentColor"
          />
          <path
            d="M4 17C4.22 16.28 7.31 15 10 15C10 14.3 10.13 13.63 10.35 13.01C7.62 12.91 2 14.27 2 17V19H11.54C11.02 18.42 10.61 17.75 10.35 17H4Z"
            fill="currentColor"
          />
          <path
            d="M19.43 17.02C19.79 16.43 20 15.74 20 15C20 12.79 18.21 11 16 11C13.79 11 12 12.79 12 15C12 17.21 13.79 19 16 19C16.74 19 17.43 18.78 18.02 18.43C18.95 19.36 19.64 20.05 20.59 21L22 19.59C20.5 18.09 21.21 18.79 19.43 17.02ZM16 17C14.9 17 14 16.1 14 15C14 13.9 14.9 13 16 13C17.1 13 18 13.9 18 15C18 16.1 17.1 17 16 17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPersonalInjury(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="personal_injury">
        <path
          id="Vector"
          d="M12 10C14.21 10 16 8.21 16 6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6C8 8.21 9.79 10 12 10ZM12 4C13.1 4 14 4.9 14 6C14 7.1 13.1 8 12 8C10.9 8 10 7.1 10 6C10 4.9 10.9 4 12 4ZM18.39 12.56C16.71 11.7 14.53 11 12 11C9.47 11 7.29 11.7 5.61 12.56C4.61 13.07 4 14.1 4 15.22V22H6V15.22C6 14.84 6.2 14.5 6.52 14.34C7.71 13.73 9.63 13 12 13C12.76 13 13.47 13.07 14.13 13.2L12.58 16.5H9.75C8.23 16.5 7 17.73 7 19.25C7 20.77 8.23 22 9.75 22H18C19.1 22 20 21.1 20 20V15.22C20 14.1 19.39 13.07 18.39 12.56ZM10.94 20H9.75C9.34 20 9 19.66 9 19.25C9 18.84 9.34 18.5 9.75 18.5H11.64L10.94 20ZM18 20H13.15L16.09 13.73C16.63 13.93 17.1 14.14 17.49 14.34C17.8 14.5 18 14.84 18 15.22V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPersonalVideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="personal_video">
        <path
          id="Vector"
          d="M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPestControl(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pest_control">
        <g id="Vector">
          <path
            d="M21 13.12H17.93C17.88 12.73 17.81 12.35 17.71 11.98L20.29 10.49L19.29 8.76L16.92 10.12C16.64 9.64 16.3 9.21 15.93 8.83C16.03 8.27 16.13 7.14001 15.35 5.94001L17 4.29L15.59 2.88L13.87 4.6C12.19 3.71 10.77 4.27 10.14 4.6L8.41 2.88L7 4.29L8.65 5.94001C7.87 7.14001 7.97 8.28 8.07 8.83C7.7 9.22 7.36 9.65 7.08 10.12L4.71 8.75L3.71 10.48L6.29 11.97C6.19 12.34 6.12 12.72 6.07 13.11H3V15.11H6.07C6.12 15.5 6.19 15.88 6.29 16.25L3.71 17.74L4.71 19.47L7.08 18.12C8.16 19.93 9.96 21.12 12 21.12C14.04 21.12 15.84 19.93 16.92 18.12L19.29 19.49L20.29 17.76L17.71 16.27C17.81 15.9 17.88 15.52 17.93 15.13H21V13.12ZM12 6.12C12.88 6.12 13.62 6.69001 13.88 7.48001C13.29 7.25001 12.66 7.12 12 7.12C11.34 7.12 10.71 7.25001 10.12 7.48001C10.38 6.69001 11.12 6.12 12 6.12ZM12 19.12C9.79 19.12 8 16.88 8 14.12C8 11.36 9.79 9.12 12 9.12C14.21 9.12 16 11.36 16 14.12C16 16.88 14.21 19.12 12 19.12Z"
            fill="currentColor"
          />
          <path d="M13 11.12H11V17.12H13V11.12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconPestControlRodent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pest_control_rodent">
        <g id="Vector">
          <path
            d="M16.9998 18C17.552 18 17.9998 17.5523 17.9998 17C17.9998 16.4477 17.552 16 16.9998 16C16.4475 16 15.9998 16.4477 15.9998 17C15.9998 17.5523 16.4475 18 16.9998 18Z"
            fill="currentColor"
          />
          <path
            d="M20.8598 14.97L19.9298 14.13C20.4098 10.68 17.0598 8.09 13.8798 9.31C13.2998 9.11 12.6598 9 11.9998 9C7.73976 9 6.34976 12.58 6.10976 13.85C4.88976 13.47 3.99976 12.35 3.99976 11C3.99976 9.34 5.33976 8 6.99976 8H9.49976C10.8798 8 11.9998 6.88 11.9998 5.5C11.9998 4.12 10.8798 3 9.49976 3H7.99976C7.44976 3 6.99976 3.45 6.99976 4C6.99976 4.55 7.44976 5 7.99976 5H9.49976C9.77976 5 9.99976 5.22 9.99976 5.5C9.99976 5.78 9.77976 6 9.49976 6H6.99976C4.23976 6 1.99976 8.24 1.99976 11C1.99976 13.44 3.75976 15.47 6.06976 15.91C6.50976 18.79 8.98976 21 11.9998 21H18.5298C21.6398 21 23.2298 17.11 20.8598 14.97ZM18.5298 19H11.9998C10.7898 19 9.65976 18.46 8.88976 17.52C8.10976 16.57 7.82976 15.36 8.08976 14.11C8.39976 12.63 9.59976 11.42 11.0798 11.1C11.2998 11.05 11.5298 11.04 11.7498 11.03C11.2798 11.74 10.9998 12.58 10.9998 13.5C10.9998 14.74 11.4998 15.87 12.3198 16.68L13.7298 15.27C13.2798 14.82 12.9998 14.19 12.9998 13.5C12.9998 12.08 14.1998 11 15.4998 11C16.8798 11 17.9998 12.12 17.9998 13.5C17.9998 13.96 17.8698 14.38 17.6498 14.75L19.5198 16.45C19.8298 16.73 19.9998 17.12 19.9998 17.54C19.9998 18.34 19.3398 19 18.5298 19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPets(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pets">
        <g id="Vector">
          <path
            d="M4.5 11.4978C5.88071 11.4978 7 10.3785 7 8.9978C7 7.61709 5.88071 6.4978 4.5 6.4978C3.11929 6.4978 2 7.61709 2 8.9978C2 10.3785 3.11929 11.4978 4.5 11.4978Z"
            fill="currentColor"
          />
          <path
            d="M9 7.4978C10.3807 7.4978 11.5 6.37851 11.5 4.9978C11.5 3.61709 10.3807 2.4978 9 2.4978C7.61929 2.4978 6.5 3.61709 6.5 4.9978C6.5 6.37851 7.61929 7.4978 9 7.4978Z"
            fill="currentColor"
          />
          <path
            d="M15 7.4978C16.3807 7.4978 17.5 6.37851 17.5 4.9978C17.5 3.61709 16.3807 2.4978 15 2.4978C13.6193 2.4978 12.5 3.61709 12.5 4.9978C12.5 6.37851 13.6193 7.4978 15 7.4978Z"
            fill="currentColor"
          />
          <path
            d="M19.5 11.4978C20.8807 11.4978 22 10.3785 22 8.9978C22 7.61709 20.8807 6.4978 19.5 6.4978C18.1193 6.4978 17 7.61709 17 8.9978C17 10.3785 18.1193 11.4978 19.5 11.4978Z"
            fill="currentColor"
          />
          <path
            d="M17.34 14.3578C16.47 13.3378 15.74 12.4678 14.86 11.4478C14.4 10.9078 13.81 10.3678 13.11 10.1278C13 10.0878 12.89 10.0578 12.78 10.0378C12.53 9.9978 12.26 9.9978 12 9.9978C11.74 9.9978 11.47 9.9978 11.21 10.0478C11.1 10.0678 10.99 10.0978 10.88 10.1378C10.18 10.3778 9.6 10.9178 9.13 11.4578C8.26 12.4778 7.53 13.3478 6.65 14.3678C5.34 15.6778 3.73 17.1278 4.03 19.1578C4.32 20.1778 5.05 21.1878 6.36 21.4778C7.09 21.6278 9.42 21.0378 11.9 21.0378H12.08C14.56 21.0378 16.89 21.6178 17.62 21.4778C18.93 21.1878 19.66 20.1678 19.95 19.1578C20.26 17.1178 18.65 15.6678 17.34 14.3578Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPhishing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phishing">
        <path
          id="Vector"
          d="M17 6.68V2.5H15V6.68C13.84 7.1 13 8.2 13 9.5C13 10.8 13.84 11.9 15 12.32V15.5C15 17.71 13.21 19.5 11 19.5C8.79 19.5 7 17.71 7 15.5V14.33L8.59 15.92L10 14.5L5 9.5V15.5C5 18.81 7.69 21.5 11 21.5C14.31 21.5 17 18.81 17 15.5V12.32C18.16 11.91 19 10.81 19 9.5C19 8.19 18.16 7.1 17 6.68ZM16 10.5C15.45 10.5 15 10.05 15 9.5C15 8.95 15.45 8.5 16 8.5C16.55 8.5 17 8.95 17 9.5C17 10.05 16.55 10.5 16 10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone">
        <path
          id="Vector"
          d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneAndroid(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_android">
        <path
          id="Vector"
          d="M16 1H8C6.34 1 5 2.34 5 4V20C5 21.66 6.34 23 8 23H16C17.66 23 19 21.66 19 20V4C19 2.34 17.66 1 16 1ZM17 18H7V4H17V18ZM14 21H10V20H14V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneBluetoothSpeaker(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_bluetooth_speaker">
        <path
          id="Vector"
          d="M20 16.5C18.75 16.5 17.55 16.3 16.43 15.93C16.33 15.9 16.22 15.88 16.12 15.88C15.86 15.88 15.61 15.98 15.41 16.17L13.21 18.37C10.38 16.93 8.06 14.62 6.62 11.78L8.82 9.57C9.1 9.31 9.18 8.92 9.07 8.57C8.7 7.45 8.5 6.25 8.5 5C8.5 4.45 8.05 4 7.5 4H4C3.45 4 3 4.45 3 5C3 14.39 10.61 22 20 22C20.55 22 21 21.55 21 21V17.5C21 16.95 20.55 16.5 20 16.5ZM5.03 6H6.53C6.6 6.88 6.75 7.75 6.98 8.58L5.78 9.79C5.38 8.58 5.12 7.32 5.03 6ZM19 19.97C17.68 19.88 16.4 19.62 15.2 19.21L16.4 18.01C17.25 18.25 18.12 18.4 19 18.46V19.97ZM14.71 10.5L17 8.21V12H17.5L20.35 9.15L18.21 7L20.36 4.85L17.5 2H17V5.79L14.71 3.5L14 4.21L16.79 7L14 9.79L14.71 10.5ZM18 3.91L18.94 4.85L18 5.79V3.91ZM18 8.21L18.94 9.15L18 10.09V8.21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneCallback(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_callback">
        <path
          id="Vector"
          d="M20 15.725C18.76 15.725 17.55 15.525 16.43 15.155C16.33 15.115 16.22 15.105 16.12 15.105C15.86 15.105 15.61 15.205 15.41 15.395L13.21 17.595C10.38 16.145 8.06 13.835 6.62 11.005L8.82 8.80503C9.1 8.52503 9.18 8.13503 9.07 7.78503C8.7 6.66503 8.5 5.46503 8.5 4.21503C8.5 3.66503 8.05 3.21503 7.5 3.21503H4C3.45 3.21503 3 3.66503 3 4.21503C3 13.605 10.61 21.215 20 21.215C20.55 21.215 21 20.765 21 20.215V16.725C21 16.175 20.55 15.725 20 15.725ZM5.03 5.21503H6.53C6.6 6.10503 6.75 6.97503 6.99 7.80503L5.79 9.00503C5.38 7.80503 5.12 6.53503 5.03 5.21503ZM19 19.185C17.68 19.095 16.41 18.835 15.2 18.435L16.39 17.245C17.24 17.485 18.11 17.635 18.99 17.695V19.185H19ZM18 9.21503H15.41L20.43 4.19503L19.02 2.78503L14 7.80503V5.21503H12V11.215H18V9.21503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_disabled">
        <path
          id="Vector"
          d="M18.0501 13.83L16.6201 12.4C17.1801 11.67 17.6701 10.9 18.0901 10.08L15.8901 7.87998C15.6101 7.59998 15.5301 7.20998 15.6401 6.85998C16.0101 5.73998 16.2101 4.53998 16.2101 3.28998C16.2101 2.73998 16.6601 2.28998 17.2101 2.28998H20.7101C21.2601 2.28998 21.7101 2.73998 21.7101 3.28998C21.7101 7.26998 20.3401 10.93 18.0501 13.83ZM15.2301 16.64C12.3401 18.93 8.6801 20.29 4.7101 20.29C4.1601 20.29 3.7101 19.84 3.7101 19.29V15.8C3.7101 15.25 4.1601 14.8 4.7101 14.8C5.9501 14.8 7.1601 14.6 8.2801 14.23C8.3801 14.19 8.4901 14.18 8.5901 14.18C8.8501 14.18 9.1001 14.28 9.3001 14.47L11.5001 16.67C12.3101 16.25 13.0801 15.77 13.8001 15.21L2.1001 3.50998L3.5201 2.09998L21.9001 20.49L20.4901 21.9L15.2301 16.64ZM8.3101 16.31C7.4601 16.55 6.5901 16.7 5.7101 16.76V18.25C7.0301 18.16 8.3001 17.9 9.5101 17.5L8.3101 16.31ZM18.1701 4.28998C18.1101 5.17998 17.9601 6.04998 17.7201 6.87998L18.9201 8.07998C19.3301 6.87998 19.5901 5.60998 19.6801 4.28998H18.1701Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneEnabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_enabled">
        <path
          id="Vector"
          d="M17.46 5C17.4 5.89 17.25 6.76 17.01 7.59L18.21 8.79C18.62 7.59 18.88 6.32 18.97 5H17.46ZM7.6 17.02C6.75 17.26 5.88 17.41 5 17.47V18.96C6.32 18.87 7.59 18.61 8.8 18.21L7.6 17.02ZM16.5 3H20C20.55 3 21 3.45 21 4C21 13.39 13.39 21 4 21C3.45 21 3 20.55 3 20V16.51C3 15.96 3.45 15.51 4 15.51C5.24 15.51 6.45 15.31 7.57 14.94C7.67 14.9 7.78 14.89 7.88 14.89C8.14 14.89 8.39 14.99 8.59 15.18L10.79 17.38C13.62 15.93 15.94 13.62 17.38 10.79L15.18 8.59C14.9 8.31 14.82 7.92 14.93 7.57C15.3 6.45 15.5 5.25 15.5 4C15.5 3.45 15.95 3 16.5 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneForwarded(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_forwarded">
        <path
          id="Vector"
          d="M19 16.5C17.75 16.5 16.55 16.3 15.43 15.93C15.33 15.9 15.22 15.88 15.12 15.88C14.86 15.88 14.61 15.98 14.41 16.17L12.21 18.37C9.38 16.93 7.06 14.62 5.62 11.78L7.82 9.57C8.1 9.31 8.18 8.92 8.07 8.57C7.7 7.45 7.5 6.25 7.5 5C7.5 4.45 7.05 4 6.5 4H3C2.45 4 2 4.45 2 5C2 14.39 9.61 22 19 22C19.55 22 20 21.55 20 21V17.5C20 16.95 19.55 16.5 19 16.5ZM4.03 6H5.53C5.6 6.88 5.75 7.75 5.98 8.58L4.78 9.79C4.38 8.58 4.12 7.32 4.03 6ZM18 19.97C16.68 19.88 15.4 19.62 14.2 19.21L15.4 18.01C16.25 18.25 17.12 18.4 18 18.46V19.97ZM17 12L22 7L17 2V5H13V9H17V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneIphone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_iphone">
        <path
          id="Vector"
          d="M16 1H8C6.62 1 5.5 2.12 5.5 3.5V20.5C5.5 21.88 6.62 23 8 23H16C17.38 23 18.5 21.88 18.5 20.5V3.5C18.5 2.12 17.38 1 16 1ZM12 22C11.17 22 10.5 21.33 10.5 20.5C10.5 19.67 11.17 19 12 19C12.83 19 13.5 19.67 13.5 20.5C13.5 21.33 12.83 22 12 22ZM16.5 18H7.5V4H16.5V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoneLocked(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_locked">
        <g id="Vector">
          <path
            d="M20.0006 5.49927V4.49927C20.0006 3.39927 19.1006 2.49927 18.0006 2.49927C16.9006 2.49927 16.0006 3.39927 16.0006 4.49927V5.49927H15.0006V10.4993H21.0006V5.49927H20.0006ZM19.0006 5.49927H17.0006V4.49927C17.0006 3.94927 17.4506 3.49927 18.0006 3.49927C18.5506 3.49927 19.0006 3.94927 19.0006 4.49927V5.49927Z"
            fill="currentColor"
          />
          <path
            d="M20.2006 15.3693L16.5306 14.6393C16.0306 14.5393 15.7006 14.8393 15.6306 14.9093L13.1106 17.4093C10.6106 15.9793 8.54063 13.9093 7.11063 11.4093L9.61063 8.88927C9.84063 8.64927 9.94063 8.31927 9.88063 7.98927L9.13063 4.29927C9.04063 3.83927 8.63063 3.49927 8.15063 3.49927H4.00063C3.44063 3.49927 2.97063 3.96927 3.00063 4.52927C3.17063 7.41927 4.05063 10.1293 5.43063 12.4993C7.01063 15.2293 9.28063 17.4893 12.0006 19.0693C14.3706 20.4393 17.0806 21.3293 19.9706 21.4993C20.5206 21.5293 21.0006 21.0693 21.0006 20.4993V16.3493C21.0006 15.8693 20.6606 15.4593 20.2006 15.3693ZM5.10063 5.49927H7.33063L7.80063 7.84927L6.17063 9.49927C5.63063 8.19927 5.27063 6.86927 5.10063 5.49927ZM19.0006 19.3993C17.6306 19.2193 16.3006 18.8693 15.0006 18.3293L16.6506 16.6993L19.0006 17.1693V19.3993Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPhoneMissed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_missed" clipPath="url(#clip0_395_954)">
        <path
          id="Vector"
          d="M23.7051 16.8C20.6551 13.91 16.5351 12.13 11.9951 12.13C7.45512 12.13 3.33512 13.91 0.285117 16.8C0.105117 16.98 -0.00488281 17.23 -0.00488281 17.51C-0.00488281 17.79 0.105117 18.04 0.285117 18.22L2.76512 20.7C2.94512 20.88 3.19512 20.99 3.47512 20.99C3.74512 20.99 3.99512 20.88 4.17512 20.71C4.96512 19.97 5.86512 19.35 6.83512 18.86C7.16512 18.7 7.39512 18.36 7.39512 17.96V14.86C8.84512 14.38 10.3951 14.13 11.9951 14.13C13.5951 14.13 15.1451 14.38 16.5951 14.85V17.95C16.5951 18.34 16.8251 18.69 17.1551 18.85C18.1351 19.34 19.0251 19.97 19.8251 20.7C20.0051 20.88 20.2551 20.98 20.5251 20.98C20.8051 20.98 21.0551 20.87 21.2351 20.69L23.7151 18.21C23.8951 18.03 24.0051 17.78 24.0051 17.5C24.0051 17.22 23.8851 16.98 23.7051 16.8ZM5.39512 17.36C4.73512 17.73 4.10512 18.16 3.52512 18.63L2.45512 17.56C3.36512 16.81 4.35512 16.17 5.40512 15.66V17.36H5.39512ZM20.4751 18.62C19.8751 18.14 19.2551 17.72 18.5951 17.35V15.65C19.6451 16.16 20.6251 16.8 21.5451 17.55L20.4751 18.62ZM6.99512 6.56001L11.9351 11.5L19.0051 4.43001L17.5951 3.01001L11.9351 8.67001L8.39512 5.13001H10.9951V3.13001H4.99512V9.13001H6.99512V6.56001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_954">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPhonePaused(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phone_paused">
        <path
          id="Vector"
          d="M6.54 5C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5H6.54ZM16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.96C17.68 18.87 16.4 18.61 15.2 18.2L16.4 17.01ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3ZM15 3H17V10H15V3ZM19 3H21V10H19V3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhonelink(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phonelink">
        <path
          id="Vector"
          d="M4 6H22V4H4C2.9 4 2 4.9 2 6V17H0V20H14V17H4V6ZM23 8H17C16.45 8 16 8.45 16 9V19C16 19.55 16.45 20 17 20H23C23.55 20 24 19.55 24 19V9C24 8.45 23.55 8 23 8ZM22 17H18V10H22V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhonelinkErase(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phonelink_erase">
        <path
          id="Vector"
          d="M13 8.2L12 7.2L8 11.2L4 7.2L3 8.2L7 12.2L3 16.2L4 17.2L8 13.2L12 17.2L13 16.2L9 12.2L13 8.2ZM19 1H9C7.9 1 7 1.9 7 3V6H9V4H19V20H9V18H7V21C7 22.1 7.9 23 9 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhonelinkLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phonelink_lock">
        <path
          id="Vector"
          d="M18.5 1H8.5C7.4 1 6.5 1.9 6.5 3V6H8.5V4H18.5V20H8.5V18H6.5V21C6.5 22.1 7.4 23 8.5 23H18.5C19.6 23 20.5 22.1 20.5 21V3C20.5 1.9 19.6 1 18.5 1ZM10.3 11V9.5C10.3 8.1 8.9 7 7.5 7C6.1 7 4.7 8.1 4.7 9.5V11C4.1 11 3.5 11.6 3.5 12.2V15.7C3.5 16.4 4.1 17 4.7 17H10.2C10.9 17 11.5 16.4 11.5 15.8V12.3C11.5 11.6 10.9 11 10.3 11ZM9 11H6V9.5C6 8.7 6.7 8.2 7.5 8.2C8.3 8.2 9 8.7 9 9.5V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhonelinkOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phonelink_off">
        <path
          id="Vector"
          d="M22 6.06999V4.06999H7.39L9.39 6.06999H22ZM24 19.07V9.06999C24 8.51999 23.55 8.06999 23 8.06999H17C16.45 8.06999 16 8.51999 16 9.06999V12.68L18 14.68V10.07H22V17.07H20.39L23.32 20C23.71 19.87 24 19.51 24 19.07ZM2.06 1.57999L0.65 2.98999L2.47 4.80999C2.18 5.14999 2 5.58999 2 6.06999V17.07H0V20.07H17.73L20.08 22.42L21.49 21.01L2.06 1.57999ZM4 17.07V6.33999L14.73 17.07H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhonelinkRing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phonelink_ring">
        <path
          id="Vector"
          d="M20.1125 7.7L19.1125 8.7C20.9125 10.5 20.9125 13.3 19.1125 15.2L20.1125 16.2C22.6125 13.9 22.6125 10.1 20.1125 7.7ZM18.0125 9.8L17.0125 10.8C17.5125 11.5 17.5125 12.4 17.0125 13.1L18.0125 14.1C19.2125 12.9 19.2125 11.1 18.0125 9.8ZM14.0125 1H4.01245C2.91245 1 2.01245 1.9 2.01245 3V21C2.01245 22.1 2.91245 23 4.01245 23H14.0125C15.1125 23 16.0125 22.1 16.0125 21V3C16.0125 1.9 15.1125 1 14.0125 1ZM14.0125 20H4.01245V4H14.0125V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhonelinkSetup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="phonelink_setup">
        <path
          id="Vector"
          d="M6.90744 3V6H8.90744V4H18.9074V20H8.90744V18H6.90744V21C6.90744 22.1 7.80744 23 8.90744 23H18.9074C20.0074 23 20.9074 22.1 20.9074 21V3C20.9074 1.9 20.0074 1 18.9074 1H8.90744C7.80744 1 6.90744 1.9 6.90744 3ZM9.40744 15.5C9.69744 15.38 9.95744 15.21 10.2074 15.02L10.1874 15.05L11.1974 15.44C11.4274 15.53 11.6874 15.44 11.8074 15.22L12.6474 13.76C12.7674 13.55 12.7174 13.27 12.5274 13.12L11.6774 12.44L11.6574 12.47C11.6774 12.31 11.7074 12.15 11.7074 11.99C11.7074 11.83 11.6774 11.67 11.6574 11.51L11.6774 11.54L12.5274 10.86C12.7174 10.71 12.7674 10.43 12.6474 10.22L11.8074 8.76C11.6874 8.55 11.4274 8.45 11.1974 8.54L10.1874 8.93L10.2074 8.96C9.95744 8.79 9.69744 8.62 9.40744 8.5L9.23744 7.42C9.20744 7.18 8.99744 7 8.74744 7H7.06744C6.81744 7 6.60744 7.18 6.57744 7.42L6.40744 8.5C6.11744 8.62 5.85744 8.79 5.60744 8.98L5.62744 8.95L4.60744 8.56C4.37744 8.47 4.11744 8.56 3.99744 8.78L3.15744 10.24C3.03744 10.45 3.08744 10.73 3.27744 10.88L4.12744 11.56L4.14744 11.53C4.12744 11.68 4.09744 11.84 4.09744 12C4.09744 12.16 4.12744 12.32 4.14744 12.48L4.12744 12.45L3.27744 13.13C3.08744 13.28 3.03744 13.56 3.15744 13.77L3.99744 15.23C4.11744 15.44 4.37744 15.54 4.60744 15.45L5.61744 15.06L5.60744 15.02C5.85744 15.21 6.11744 15.38 6.40744 15.5L6.57744 16.57C6.60744 16.82 6.81744 17 7.06744 17H8.74744C8.99744 17 9.20744 16.82 9.23744 16.58L9.40744 15.5ZM5.90744 12C5.90744 10.9 6.80744 10 7.90744 10C9.00744 10 9.90744 10.9 9.90744 12C9.90744 13.1 9.00744 14 7.90744 14C6.80744 14 5.90744 13.1 5.90744 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhoto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoAlbum(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_album">
        <path
          id="Vector"
          d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H6V4H11V11L13.5 9.5L16 11V4H18V20ZM13.62 13.5L17 18H7L9.38 14.83L11 17L13.62 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoCamera(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_camera">
        <path
          id="Vector"
          d="M14.12 5L15.95 7H20V19H4V7H8.05L9.88 5H14.12ZM15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5H16.83L15 3ZM12 10C13.65 10 15 11.35 15 13C15 14.65 13.65 16 12 16C10.35 16 9 14.65 9 13C9 11.35 10.35 10 12 10ZM12 8C9.24 8 7 10.24 7 13C7 15.76 9.24 18 12 18C14.76 18 17 15.76 17 13C17 10.24 14.76 8 12 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoCameraBack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_camera_back">
        <g id="Vector">
          <path
            d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L9.88 5H14.12L15.95 7H20V19Z"
            fill="currentColor"
          />
          <path d="M11.25 16L9 13L6 17H18L14.25 12L11.25 16Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconPhotoCameraFront(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_camera_front">
        <g id="Vector">
          <path
            d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L9.88 5H14.12L15.95 7H20V19Z"
            fill="currentColor"
          />
          <path
            d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
            fill="currentColor"
          />
          <path
            d="M14.78 14.58C13.93 14.21 12.99 14 12 14C11.01 14 10.07 14.21 9.22 14.58C8.48 14.9 8 15.62 8 16.43V17H16V16.43C16 15.62 15.52 14.9 14.78 14.58Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPhotoFilter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_filter">
        <path
          id="Vector"
          d="M19 10V19H4.98V5H13.98V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V10H19ZM16.06 7.94L17 10L17.94 7.94L20 7L17.94 6.06L17 4L16.06 6.06L14 7L16.06 7.94ZM12 8L10.75 10.75L8 12L10.75 13.25L12 16L13.25 13.25L16 12L13.25 10.75L12 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoLibrary(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_library">
        <path
          id="Vector"
          d="M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoPrints(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_prints">
        <path
          id="Vector"
          d="M12.7001 19H18.3001C18.1834 19.4333 17.9834 19.7833 17.7001 20.05C17.4167 20.3167 17.0501 20.4833 16.6001 20.55L5.70007 21.875C5.15007 21.9583 4.65423 21.8292 4.21257 21.4875C3.7709 21.1458 3.51673 20.7 3.45007 20.15L2.12507 9.225C2.0584 8.675 2.19173 8.18333 2.52507 7.75C2.8584 7.31667 3.30007 7.06667 3.85007 7L5.00007 6.85V8.85L4.10007 8.975L5.45007 19.9L12.7001 19ZM9.00007 17C8.45007 17 7.97923 16.8042 7.58757 16.4125C7.1959 16.0208 7.00007 15.55 7.00007 15V4C7.00007 3.45 7.1959 2.97917 7.58757 2.5875C7.97923 2.19583 8.45007 2 9.00007 2H20.0001C20.5501 2 21.0209 2.19583 21.4126 2.5875C21.8042 2.97917 22.0001 3.45 22.0001 4V15C22.0001 15.55 21.8042 16.0208 21.4126 16.4125C21.0209 16.8042 20.5501 17 20.0001 17H9.00007ZM9.00007 15H20.0001V4H9.00007V15ZM14.5251 14C15.6584 14 16.6209 13.6083 17.4126 12.825C18.2042 12.0417 18.6417 11.1 18.7251 10C17.5917 10 16.6209 10.3917 15.8126 11.175C15.0042 11.9583 14.5751 12.9 14.5251 14ZM14.5251 14C14.4751 12.9 14.0459 11.9583 13.2376 11.175C12.4292 10.3917 11.4584 10 10.3251 10C10.4084 11.1 10.8459 12.0417 11.6376 12.825C12.4292 13.6083 13.3917 14 14.5251 14ZM14.5251 11C14.8084 11 15.0459 10.9042 15.2376 10.7125C15.4292 10.5208 15.5251 10.2833 15.5251 10V9.75L15.7751 9.85C16.0251 9.95 16.2792 9.975 16.5376 9.925C16.7959 9.875 16.9917 9.73333 17.1251 9.5C17.2751 9.25 17.3251 8.98333 17.2751 8.7C17.2251 8.41667 17.0584 8.21667 16.7751 8.1L16.5251 8L16.7751 7.9C17.0584 7.78333 17.2209 7.57917 17.2626 7.2875C17.3042 6.99583 17.2584 6.73333 17.1251 6.5C16.9751 6.25 16.7751 6.10417 16.5251 6.0625C16.2751 6.02083 16.0251 6.05 15.7751 6.15L15.5251 6.25V6C15.5251 5.71667 15.4292 5.47917 15.2376 5.2875C15.0459 5.09583 14.8084 5 14.5251 5C14.2417 5 14.0042 5.09583 13.8126 5.2875C13.6209 5.47917 13.5251 5.71667 13.5251 6V6.25L13.2751 6.15C13.0251 6.05 12.7751 6.02083 12.5251 6.0625C12.2751 6.10417 12.0751 6.25 11.9251 6.5C11.7917 6.73333 11.7459 6.99583 11.7876 7.2875C11.8292 7.57917 11.9917 7.78333 12.2751 7.9L12.5251 8L12.2751 8.1C11.9917 8.21667 11.8251 8.41667 11.7751 8.7C11.7251 8.98333 11.7751 9.25 11.9251 9.5C12.0584 9.73333 12.2542 9.875 12.5126 9.925C12.7709 9.975 13.0251 9.95 13.2751 9.85L13.5251 9.75V10C13.5251 10.2833 13.6209 10.5208 13.8126 10.7125C14.0042 10.9042 14.2417 11 14.5251 11ZM14.5251 9C14.2417 9 14.0042 8.90417 13.8126 8.7125C13.6209 8.52083 13.5251 8.28333 13.5251 8C13.5251 7.71667 13.6209 7.47917 13.8126 7.2875C14.0042 7.09583 14.2417 7 14.5251 7C14.8084 7 15.0459 7.09583 15.2376 7.2875C15.4292 7.47917 15.5251 7.71667 15.5251 8C15.5251 8.28333 15.4292 8.52083 15.2376 8.7125C15.0459 8.90417 14.8084 9 14.5251 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoPrintsFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_prints_filled">
        <path
          id="Vector"
          d="M14.526 14C15.6594 14 16.6219 13.6083 17.4135 12.825C18.2052 12.0417 18.6427 11.1 18.726 10C17.5927 10 16.6219 10.3917 15.8135 11.175C15.0052 11.9583 14.576 12.9 14.526 14ZM14.526 14C14.476 12.9 14.0469 11.9583 13.2385 11.175C12.4302 10.3917 11.4594 10 10.326 10C10.4094 11.1 10.8469 12.0417 11.6385 12.825C12.4302 13.6083 13.3927 14 14.526 14ZM14.526 11C14.8094 11 15.0469 10.9042 15.2385 10.7125C15.4302 10.5208 15.526 10.2833 15.526 10V9.75L15.776 9.85C16.026 9.95 16.2802 9.975 16.5385 9.925C16.7969 9.875 16.9927 9.73333 17.126 9.5C17.276 9.25 17.326 8.98333 17.276 8.7C17.226 8.41667 17.0594 8.21667 16.776 8.1L16.526 8L16.776 7.9C17.0594 7.78333 17.2219 7.57917 17.2635 7.2875C17.3052 6.99583 17.2594 6.73333 17.126 6.5C16.976 6.25 16.776 6.10417 16.526 6.0625C16.276 6.02083 16.026 6.05 15.776 6.15L15.526 6.25V6C15.526 5.71667 15.4302 5.47917 15.2385 5.2875C15.0469 5.09583 14.8094 5 14.526 5C14.2427 5 14.0052 5.09583 13.8135 5.2875C13.6219 5.47917 13.526 5.71667 13.526 6V6.25L13.276 6.15C13.026 6.05 12.776 6.02083 12.526 6.0625C12.276 6.10417 12.076 6.25 11.926 6.5C11.7927 6.73333 11.7469 6.99583 11.7885 7.2875C11.8302 7.57917 11.9927 7.78333 12.276 7.9L12.526 8L12.276 8.1C11.9927 8.21667 11.826 8.41667 11.776 8.7C11.726 8.98333 11.776 9.25 11.926 9.5C12.0594 9.73333 12.2552 9.875 12.5135 9.925C12.7719 9.975 13.026 9.95 13.276 9.85L13.526 9.75V10C13.526 10.2833 13.6219 10.5208 13.8135 10.7125C14.0052 10.9042 14.2427 11 14.526 11ZM14.526 9C14.2427 9 14.0052 8.90417 13.8135 8.7125C13.6219 8.52083 13.526 8.28333 13.526 8C13.526 7.71667 13.6219 7.47917 13.8135 7.2875C14.0052 7.09583 14.2427 7 14.526 7C14.8094 7 15.0469 7.09583 15.2385 7.2875C15.4302 7.47917 15.526 7.71667 15.526 8C15.526 8.28333 15.4302 8.52083 15.2385 8.7125C15.0469 8.90417 14.8094 9 14.526 9ZM5.70104 21.875C5.15104 21.9583 4.65521 21.8292 4.21354 21.4875C3.77188 21.1458 3.51771 20.7 3.45104 20.15L2.12604 9.225C2.05937 8.675 2.19271 8.18333 2.52604 7.75C2.85938 7.31667 3.30104 7.06667 3.85104 7L5.00104 6.85V15C5.00104 16.1 5.39271 17.0417 6.17604 17.825C6.95938 18.6083 7.90104 19 9.00104 19H18.301C18.201 19.4 18.001 19.7458 17.701 20.0375C17.401 20.3292 17.0344 20.5 16.601 20.55L5.70104 21.875ZM9.00104 17C8.45104 17 7.98021 16.8042 7.58854 16.4125C7.19688 16.0208 7.00104 15.55 7.00104 15V4C7.00104 3.45 7.19688 2.97917 7.58854 2.5875C7.98021 2.19583 8.45104 2 9.00104 2H20.001C20.551 2 21.0219 2.19583 21.4135 2.5875C21.8052 2.97917 22.001 3.45 22.001 4V15C22.001 15.55 21.8052 16.0208 21.4135 16.4125C21.0219 16.8042 20.551 17 20.001 17H9.00104Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoSizeSelectActual(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_size_select_actual">
        <path
          id="Vector"
          d="M21 3H3C2 3 1 4 1 5V19C1 20.1 1.9 21 3 21H21C22 21 23 20 23 19V5C23 4 22 3 21 3ZM21 18.92C20.98 18.95 20.94 18.98 20.92 19H3V5.08L3.08 5H20.91C20.94 5.02 20.97 5.06 20.99 5.08V18.92H21ZM11 15.51L8.5 12.5L5 17H19L14.5 11L11 15.51Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoSizeSelectLarge(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_size_select_large">
        <path
          id="Vector"
          d="M21 15H23V17H21V15ZM21 11H23V13H21V11ZM23 19H21V21C22 21 23 20 23 19ZM13 3H15V5H13V3ZM21 7H23V9H21V7ZM21 3V5H23C23 4 22 3 21 3ZM1 7H3V9H1V7ZM17 3H19V5H17V3ZM17 19H19V21H17V19ZM3 3C2 3 1 4 1 5H3V3ZM9 3H11V5H9V3ZM5 3H7V5H5V3ZM1 11V19C1 20.1 1.9 21 3 21H15V11H1ZM3 19L5.5 15.79L7.29 17.94L9.79 14.72L13 19H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhotoSizeSelectSmall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="photo_size_select_small">
        <path
          id="Vector"
          d="M23 15H21V17H23V15ZM23 11H21V13H23V11ZM23 19H21V21C22 21 23 20 23 19ZM15 3H13V5H15V3ZM23 7H21V9H23V7ZM21 3V5H23C23 4 22 3 21 3ZM3 21H11V15H1V19C1 20.1 1.9 21 3 21ZM3 7H1V9H3V7ZM15 19H13V21H15V19ZM19 3H17V5H19V3ZM19 19H17V21H19V19ZM3 3C2 3 1 4 1 5H3V3ZM3 11H1V13H3V11ZM11 3H9V5H11V3ZM7 3H5V5H7V3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPhp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="php">
        <path
          id="Vector"
          d="M12.75 9H14.25V15H12.75V12.5H10.75V15H9.25V9H10.75V11H12.75V9ZM7.75 10.5V11.5C7.75 12.3 7.05 13 6.25 13H4.25V15H2.75V9H6.25C7.05 9 7.75 9.7 7.75 10.5ZM6.25 10.5H4.25V11.5H6.25V10.5ZM21.25 10.5V11.5C21.25 12.3 20.55 13 19.75 13H17.75V15H16.25V9H19.75C20.55 9 21.25 9.7 21.25 10.5ZM19.75 10.5H17.75V11.5H19.75V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPiano(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="piano">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14 14.5H14.25V19H9.75V14.5H10C10.55 14.5 11 14.05 11 13.5V5H13V13.5C13 14.05 13.45 14.5 14 14.5ZM5 5H7V13.5C7 14.05 7.45 14.5 8 14.5H8.25V19H5V5ZM19 19H15.75V14.5H16C16.55 14.5 17 14.05 17 13.5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPianoOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="piano_off">
        <path
          id="Vector"
          d="M21.9001 20.48L3.5201 2.09998L2.1001 3.50998L3.7101 5.11998V18.29C3.7101 19.39 4.6101 20.29 5.7101 20.29H18.8801L20.4901 21.9L21.9001 20.48ZM8.9601 18.29H5.7101V7.11998L7.7101 9.11998V12.79C7.7101 13.34 8.1601 13.79 8.7101 13.79H8.9601V18.29ZM10.4601 18.29V13.79H10.7101C11.1701 13.79 11.5301 13.48 11.6501 13.06L14.9601 16.37V18.29H10.4601ZM11.7101 7.45998L6.5401 2.28998H19.7101C20.8101 2.28998 21.7101 3.18998 21.7101 4.28998V17.46L19.7101 15.46V4.28998H17.7101V12.79C17.7101 12.98 17.6401 13.15 17.5501 13.3L13.7101 9.45998V4.28998H11.7101V7.45998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPictureAsPdf(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="picture_as_pdf">
        <path
          id="Vector"
          d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPictureInPicture(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="picture_in_picture">
        <path
          id="Vector"
          d="M19 7.01001H11V13.01H19V7.01001ZM17 11.01H13V9.01001H17V11.01ZM21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.91001 22.1 3.01001 21 3.01001ZM21 19.02H3V4.99001H21V19.02Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPictureInPictureAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="picture_in_picture_alt">
        <path
          id="Vector"
          d="M19 11H11V17H19V11ZM17 15H13V13H17V15ZM21 3H3C1.9 3 1 3.88 1 4.98V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V4.98C23 3.88 22.1 3 21 3ZM21 19.02H3V4.97H21V19.02Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPieChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pie_chart">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19.93 11H13V4.07C16.61 4.52 19.48 7.39 19.93 11ZM4 12C4 7.93 7.06 4.56 11 4.07V19.93C7.06 19.44 4 16.07 4 12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pin">
        <g id="Vector">
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill="currentColor"
          />
          <path
            d="M6.49 10.5V15H7.64V9H6.77L5.01 10.27L5.59 11.16L6.49 10.5Z"
            fill="currentColor"
          />
          <path
            d="M11.47 10.05C11.97 10.05 12.28 10.37 12.28 10.77C12.28 11.14 12.14 11.41 11.74 11.83C11.38 12.21 10.68 12.91 9.61 13.98V15H13.5V14.01H11.13L11.1 13.96C11.78 13.28 12.25 12.82 12.5 12.57C13.11 11.97 13.42 11.35 13.42 10.71C13.42 10.47 13.37 9.67 12.51 9.23C12.04 9 11.25 8.87 10.56 9.2C9.74 9.59 9.57 10.33 9.56 10.35L10.57 10.77C10.67 10.44 10.95 10.05 11.47 10.05Z"
            fill="currentColor"
          />
          <path
            d="M16.99 13.94C16.16 13.94 16 13.18 15.97 13.08L14.94 13.49C15.39 15.08 16.95 15 16.99 15C18.19 15 18.67 14.28 18.75 14.15C19.07 13.66 19.11 12.91 18.74 12.39C18.57 12.15 18.34 11.98 18.06 11.87V11.8C18.26 11.7 18.43 11.54 18.58 11.32C18.84 10.91 18.89 10.25 18.56 9.75C18.48 9.64 18.03 9 16.94 9C15.68 9 15.2 9.9 15.09 10.24L16.08 10.65C16.19 10.33 16.43 10.01 16.93 10.01C17.37 10.01 17.68 10.27 17.68 10.66C17.68 11.24 17.13 11.38 16.8 11.38H16.34V12.38H16.84C17.4 12.38 17.88 12.62 17.88 13.17C17.88 13.66 17.4 13.94 16.99 13.94Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPinDrop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pin_drop">
        <g id="Vector">
          <path
            d="M12 4C13.93 4 17 5.4 17 9.15C17 11.31 15.28 13.82 12 16.47C8.72 13.82 7 11.3 7 9.15C7 5.4 10.07 4 12 4ZM12 2C8.73 2 5 4.46 5 9.15C5 12.27 7.33 15.56 12 19C16.67 15.56 19 12.27 19 9.15C19 4.46 15.27 2 12 2Z"
            fill="currentColor"
          />
          <path
            d="M12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7ZM5 20H19V22H5V20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPinEnd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pin_end">
        <path
          id="Vector"
          d="M20 12V6H4V18H14V20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6V12H20ZM19 14C17.34 14 16 15.34 16 17C16 18.66 17.34 20 19 20C20.66 20 22 18.66 22 17C22 15.34 20.66 14 19 14ZM14.66 8H9V13.66H11V11.42L13.95 14.37L15.36 12.96L12.41 10H14.65V8H14.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPinInvoke(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pin_invoke">
        <path
          id="Vector"
          d="M22 12V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H14V6H4V18H20V12H22ZM22 7C22 5.34 20.66 4 19 4C17.34 4 16 5.34 16 7C16 8.66 17.34 10 19 10C20.66 10 22 8.66 22 7ZM9.34 12H11.58L8.63 14.95L10.04 16.36L13 13.42V15.66H15V10H9.34V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPinch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pinch">
        <path
          id="Vector"
          d="M6.00049 2.5V1H11.0005V6H9.50049V3.56L3.56049 9.5H6.00049V11H1.00049V6H2.50049V8.44L8.44049 2.5H6.00049ZM21.8905 13.77L18.0905 12.1C17.9605 12.04 17.8105 12 17.6505 12H17.0005V7.5C17.0005 6.12 15.8805 5 14.5005 5C13.1205 5 12.0005 6.12 12.0005 7.5V15.65L10.1305 15.25C9.94049 15.22 9.11049 15.1 8.40049 15.81L7.00049 17.22L12.1205 22.41C12.4905 22.79 13.0005 23 13.5305 23H20.0805C21.0605 23 21.8905 22.3 22.0505 21.33L22.9705 15.89C23.1205 15.03 22.6805 14.17 21.8905 13.77ZM20.0805 21H13.5305L9.83049 17.22L14.0005 18.11V7.5C14.0005 7.22 14.2205 7 14.5005 7C14.7805 7 15.0005 7.22 15.0005 7.5V13.68H16.7605L21.0005 15.56L20.0805 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPivotTableChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pivot_table_chart">
        <path
          id="Vector"
          d="M20.5 4.5C20.5 3.4 19.6 2.5 18.5 2.5H9.5V7.5H20.5V4.5ZM2.5 18.5C2.5 19.6 3.4 20.5 4.5 20.5H7.5V9.5H2.5V18.5ZM2.5 4.5V7.5H7.5V2.5H4.5C3.4 2.5 2.5 3.4 2.5 4.5ZM17.5 8.49L13.5 12.5L14.91 13.91L16.5 12.31V14.5C16.5 15.6 15.6 16.5 14.5 16.5H12.33L13.92 14.91L12.5 13.5L8.5 17.5L12.5 21.5L13.91 20.09L12.33 18.5H14.5C16.71 18.5 18.5 16.71 18.5 14.5V12.32L20.09 13.92L21.5 12.5L17.5 8.49Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPix(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pix">
        <g id="Vector">
          <path
            d="M15.446 16.5199L12.436 13.5099C12.326 13.3999 12.196 13.3799 12.126 13.3799C12.056 13.3799 11.926 13.3999 11.816 13.5099L8.79604 16.5299C8.45604 16.8699 7.92603 17.4199 6.15603 17.4199L9.86603 21.1199C11.036 22.2899 12.936 22.2899 14.106 21.1199L17.826 17.4099C16.916 17.4099 16.156 17.2299 15.446 16.5199Z"
            fill="currentColor"
          />
          <path
            d="M8.79604 7.46994L11.816 10.4899C11.896 10.5699 12.016 10.6199 12.126 10.6199C12.236 10.6199 12.356 10.5699 12.436 10.4899L15.426 7.49994C16.136 6.75994 16.946 6.58994 17.856 6.58994L14.136 2.87994C12.966 1.70994 11.066 1.70994 9.89603 2.87994L6.18604 6.57994C7.94604 6.57994 8.48604 7.15994 8.79604 7.46994Z"
            fill="currentColor"
          />
          <path
            d="M21.106 9.84994L18.856 7.58994H17.596C17.056 7.58994 16.516 7.80994 16.146 8.19994L13.146 11.1999C12.866 11.4799 12.496 11.6199 12.126 11.6199C11.766 11.6199 11.386 11.4699 11.106 11.1999L8.08604 8.16994C7.70604 7.78994 7.18604 7.56994 6.63603 7.56994H5.16604L2.87604 9.86994C1.70604 11.0399 1.70604 12.9399 2.87604 14.1099L5.16604 16.4099H6.64604C7.18604 16.4099 7.70604 16.1899 8.09604 15.8099L11.116 12.7899C11.396 12.5099 11.766 12.3699 12.136 12.3699C12.506 12.3699 12.876 12.5099 13.156 12.7899L16.166 15.7999C16.546 16.1799 17.066 16.3999 17.616 16.3999H18.876L21.126 14.1399C22.296 12.9599 22.296 11.0399 21.106 9.84994Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPlace(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="place">
        <path
          id="Vector"
          d="M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlagiarism(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="plagiarism">
        <g id="Vector">
          <path
            d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
            fill="currentColor"
          />
          <path
            d="M9.03 11.03C7.66 12.4 7.66 14.61 9.03 15.98C10.15 17.1 11.83 17.29 13.16 16.57L15.04 18.45L16.45 17.04L14.57 15.16C15.28 13.83 15.1 12.15 13.98 11.03C12.61 9.66 10.39 9.66 9.03 11.03ZM12.56 14.56C11.97 15.15 11.02 15.15 10.44 14.56C9.85 13.97 9.85 13.02 10.44 12.44C11.03 11.85 11.98 11.85 12.56 12.44C13.15 13.03 13.15 13.97 12.56 14.56Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPlayArrow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="play_arrow">
        <path
          id="Vector"
          d="M8.5 8.64L13.77 12L8.5 15.36V8.64ZM6.5 5V19L17.5 12L6.5 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlayCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="play_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM9.5 16.5L16.5 12L9.5 7.5V16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlayCircleFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="play_circle_filled">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16.5V7.5L16 12L10 16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlayDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="play_disabled">
        <g id="Vector">
          <path
            d="M17.165 12.915L19.715 11.295L8.71498 4.29498V4.46498L17.165 12.915Z"
            fill="currentColor"
          />
          <path
            d="M3.52498 2.10498L2.10498 3.51498L8.71498 10.125V18.295L13.705 15.115L20.485 21.895L21.895 20.485L3.52498 2.10498ZM10.715 14.655V12.125L12.265 13.675L10.715 14.655Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPlayForWork(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="play_for_work">
        <path
          id="Vector"
          d="M11 4.5V10.09H7.5L12 14.59L16.5 10.09H13V4.5H11ZM6 13.5C6 16.81 8.69 19.5 12 19.5C15.31 19.5 18 16.81 18 13.5H16C16 15.71 14.21 17.5 12 17.5C9.79 17.5 8 15.71 8 13.5H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlayLesson(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="play_lesson">
        <path
          id="Vector"
          d="M4 19.5V3.5H6V10.5L8.5 9L11 10.5V3.5H16V10.58C16.33 10.53 16.66 10.5 17 10.5C17.34 10.5 17.67 10.53 18 10.58V3.5C18 2.4 17.1 1.5 16 1.5H4C2.9 1.5 2 2.4 2 3.5V19.5C2 20.6 2.9 21.5 4 21.5H11.26C10.84 20.9 10.51 20.22 10.29 19.5H4ZM17 12.5C14.24 12.5 12 14.74 12 17.5C12 20.26 14.24 22.5 17 22.5C19.76 22.5 22 20.26 22 17.5C22 14.74 19.76 12.5 17 12.5ZM15.75 20V15L19.75 17.5L15.75 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlaylistAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist_add">
        <path
          id="Vector"
          d="M13.5 9H2.5V11H13.5V9ZM13.5 5H2.5V7H13.5V5ZM17.5 13V9H15.5V13H11.5V15H15.5V19H17.5V15H21.5V13H17.5ZM2.5 15H9.5V13H2.5V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlaylistAddCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist_add_check">
        <g id="Vector">
          <path d="M13.5 9.5H2.5V11.5H13.5V9.5Z" fill="currentColor" />
          <path d="M13.5 5.5H2.5V7.5H13.5V5.5Z" fill="currentColor" />
          <path d="M9.5 13.5H2.5V15.5H9.5V13.5Z" fill="currentColor" />
          <path
            d="M20.09 11.43L15.84 15.67L13.72 13.55L12.31 14.96L15.84 18.5L21.5 12.84L20.09 11.43Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPlaylistAddCheckCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist_add_check_circle">
        <path
          id="Vector"
          d="M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM14 10H7V12H14V10ZM14 7H7V9H14V7ZM7 15H10V13H7V15ZM19 13.41L17.59 12L14.05 15.54L12.64 14.13L11.23 15.54L14.06 18.37L19 13.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlaylistAddCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist_add_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM14 10H7V12H14V10ZM14 7H7V9H14V7ZM7 15H10V13H7V15ZM19 13V15H17V17H15V15H13V13H15V11H17V13H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlaylistPlay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist_play">
        <g id="Vector">
          <path d="M13.5 8.5H2.5V10.5H13.5V8.5Z" fill="currentColor" />
          <path d="M13.5 4.5H2.5V6.5H13.5V4.5Z" fill="currentColor" />
          <path d="M9.5 12.5H2.5V14.5H9.5V12.5Z" fill="currentColor" />
          <path d="M15.5 11.5V19.5L21.5 15.5L15.5 11.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconPlaylistRemove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist_remove">
        <path
          id="Vector"
          d="M14 8H3V10H14V8ZM14 4H3V6H14V4ZM3 14H10V12H3V14ZM14.41 20L17 17.41L19.59 20L21 18.59L18.41 16L21 13.41L19.59 12L17 14.59L14.41 12L13 13.41L15.59 16L13 18.59L14.41 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPlumbing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="plumbing">
        <g id="Vector">
          <path
            d="M19.2788 4.92998L17.1588 2.80998C16.3788 2.02998 15.1088 2.02998 14.3288 2.80998L11.4988 5.63998L13.6187 7.75998L15.7388 5.63998L19.2788 9.17998C20.4488 7.99998 20.4488 6.09998 19.2788 4.92998Z"
            fill="currentColor"
          />
          <path
            d="M5.48875 13.77C6.07875 14.36 7.02875 14.36 7.60875 13.77L10.0788 11.3L7.95875 9.16998L5.48875 11.64C4.89875 12.23 4.89875 13.18 5.48875 13.77Z"
            fill="currentColor"
          />
          <path
            d="M15.0387 7.75998L13.6187 9.17998L10.4387 5.99998C9.84875 5.39998 8.89875 5.39998 8.31875 5.98998C7.72875 6.57998 7.72875 7.52997 8.31875 8.10997L11.4988 11.29L4.42875 18.36C3.64875 19.14 3.64875 20.41 4.42875 21.19C5.20875 21.97 6.47875 21.97 7.25875 21.19L16.4488 12C16.8388 12.39 17.4688 12.39 17.8588 12C18.2488 11.61 18.2488 10.98 17.8588 10.59L15.0387 7.75998Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPlusOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="plus_one">
        <path
          id="Vector"
          d="M10.5 8.5H8.5V12.5H4.5V14.5H8.5V18.5H10.5V14.5H14.5V12.5H10.5V8.5ZM15 6.58V8.4L17.5 7.9V18.5H19.5V5.5L15 6.58Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPodcasts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="podcasts">
        <path
          id="Vector"
          d="M14 12C14 12.74 13.6 13.38 13 13.72V22H11V13.72C10.4 13.37 10 12.74 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12ZM12 6C8.69 6 6 8.69 6 12C6 13.74 6.75 15.31 7.94 16.4L9.36 14.98C8.53 14.25 8 13.19 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 13.19 15.47 14.25 14.64 14.98L16.06 16.4C17.25 15.31 18 13.74 18 12C18 8.69 15.31 6 12 6ZM12 2C6.48 2 2 6.48 2 12C2 14.85 3.2 17.41 5.11 19.24L6.53 17.82C4.98 16.36 4 14.29 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 14.29 19.02 16.36 17.47 17.82L18.89 19.24C20.8 17.41 22 14.85 22 12C22 6.48 17.52 2 12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPointOfSale(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="point_of_sale">
        <path
          id="Vector"
          d="M17 2H7C5.9 2 5 2.9 5 4V6C5 7.1 5.9 8 7 8H17C18.1 8 19 7.1 19 6V4C19 2.9 18.1 2 17 2ZM17 6H7V4H17V6ZM20 22H4C2.9 22 2 21.1 2 20V19H22V20C22 21.1 21.1 22 20 22ZM18.53 10.19C18.21 9.47 17.49 9 16.7 9H7.3C6.51 9 5.79 9.47 5.47 10.19L2 18H22L18.53 10.19ZM9.5 16H8.5C8.22 16 8 15.78 8 15.5C8 15.22 8.22 15 8.5 15H9.5C9.78 15 10 15.22 10 15.5C10 15.78 9.78 16 9.5 16ZM9.5 14H8.5C8.22 14 8 13.78 8 13.5C8 13.22 8.22 13 8.5 13H9.5C9.78 13 10 13.22 10 13.5C10 13.78 9.78 14 9.5 14ZM9.5 12H8.5C8.22 12 8 11.78 8 11.5C8 11.22 8.22 11 8.5 11H9.5C9.78 11 10 11.22 10 11.5C10 11.78 9.78 12 9.5 12ZM12.5 16H11.5C11.22 16 11 15.78 11 15.5C11 15.22 11.22 15 11.5 15H12.5C12.78 15 13 15.22 13 15.5C13 15.78 12.78 16 12.5 16ZM12.5 14H11.5C11.22 14 11 13.78 11 13.5C11 13.22 11.22 13 11.5 13H12.5C12.78 13 13 13.22 13 13.5C13 13.78 12.78 14 12.5 14ZM12.5 12H11.5C11.22 12 11 11.78 11 11.5C11 11.22 11.22 11 11.5 11H12.5C12.78 11 13 11.22 13 11.5C13 11.78 12.78 12 12.5 12ZM15.5 16H14.5C14.22 16 14 15.78 14 15.5C14 15.22 14.22 15 14.5 15H15.5C15.78 15 16 15.22 16 15.5C16 15.78 15.78 16 15.5 16ZM15.5 14H14.5C14.22 14 14 13.78 14 13.5C14 13.22 14.22 13 14.5 13H15.5C15.78 13 16 13.22 16 13.5C16 13.78 15.78 14 15.5 14ZM15.5 12H14.5C14.22 12 14 11.78 14 11.5C14 11.22 14.22 11 14.5 11H15.5C15.78 11 16 11.22 16 11.5C16 11.78 15.78 12 15.5 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPolicy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="policy">
        <path
          id="Vector"
          d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 12.85 18.49 14.65 17.62 16.21L16.17 14.76C17.46 12.82 17.24 10.18 15.53 8.47C13.58 6.52 10.41 6.52 8.46 8.47C6.51 10.42 6.51 13.59 8.46 15.54C10.17 17.25 12.81 17.46 14.75 16.18L16.47 17.9C15.28 19.32 13.74 20.41 12 20.94C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPoll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="poll">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPolyline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="polyline">
        <path
          id="Vector"
          d="M15 16V17.26L9 14.26V11.09L11.7 8H16V2H10V6.9L7.3 10H3V16H8L15 19.5V22H21V16H15ZM12 4H14V6H12V4ZM7 14H5V12H7V14ZM19 20H17V18H19V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPolymer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="polymer">
        <path
          id="Vector"
          d="M19 4H15L7.11 16.63L4.5 12L9 4H5L0.5 12L5 20H9L16.89 7.37L19.5 12L15 20H19L23.5 12L19 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPool(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pool">
        <g id="Vector">
          <path
            d="M10 8.00007L6.75 11.2501C7.06 11.3701 7.31 11.5201 7.52 11.6401C7.89 11.8701 8.11 12.0001 8.67 12.0001C9.23 12.0001 9.45 11.8701 9.82 11.6401C10.28 11.3701 10.9 11.0001 12.01 11.0001C13.12 11.0001 13.74 11.3701 14.19 11.6401C14.56 11.8601 14.79 12.0001 15.34 12.0001C15.89 12.0001 16.12 11.8701 16.49 11.6401C16.61 11.5701 16.75 11.4901 16.9 11.4101L10.48 5.00007C8.93 3.45007 7.5 2.99007 5 3.00007V5.50007C6.82 5.49007 7.89 5.89007 9 7.00007L10 8.00007ZM5.35 15.5001C5.9 15.5001 6.13 15.6401 6.5 15.8601C6.95 16.1301 7.57 16.5001 8.68 16.5001C9.79 16.5001 10.41 16.1301 10.86 15.8601C11.23 15.6301 11.45 15.5001 12.01 15.5001C12.56 15.5001 12.79 15.6401 13.16 15.8601C13.61 16.1301 14.23 16.5001 15.34 16.5001C16.45 16.5001 17.07 16.1301 17.52 15.8601C17.89 15.6301 18.11 15.5001 18.67 15.5001C19.22 15.5001 19.45 15.6401 19.82 15.8601C20.27 16.1301 20.88 16.4901 21.98 16.5001V14.5001C21.43 14.5001 21.2 14.3601 20.83 14.1401C20.38 13.8701 19.76 13.5001 18.65 13.5001C17.54 13.5001 16.92 13.8701 16.47 14.1401C16.1 14.3701 15.87 14.5001 15.32 14.5001C14.77 14.5001 14.54 14.3601 14.17 14.1401C13.72 13.8701 13.1 13.5001 11.99 13.5001C10.88 13.5001 10.26 13.8701 9.81 14.1401C9.44 14.3701 9.22 14.5001 8.66 14.5001C8.11 14.5001 7.88 14.3601 7.51 14.1401C7.06 13.8701 6.44 13.5001 5.33 13.5001C4.22 13.5001 3.6 13.8701 3.15 14.1401C2.78 14.3701 2.56 14.5001 2 14.5001V16.5001C3.11 16.5001 3.73 16.1301 4.2 15.8601C4.57 15.6301 4.8 15.5001 5.35 15.5001ZM18.67 18.0001C17.56 18.0001 16.94 18.3701 16.49 18.6401C16.12 18.8701 15.89 19.0001 15.34 19.0001C14.79 19.0001 14.56 18.8601 14.19 18.6401C13.74 18.3701 13.12 18.0001 12.01 18.0001C10.9 18.0001 10.28 18.3701 9.82 18.6401C9.45 18.8701 9.23 19.0001 8.67 19.0001C8.11 19.0001 7.89 18.8701 7.52 18.6401C7.07 18.3701 6.45 18.0001 5.34 18.0001C4.23 18.0001 3.61 18.3701 3.15 18.6401C2.78 18.8701 2.56 19.0001 2 19.0001V21.0001C3.11 21.0001 3.73 20.6301 4.19 20.3601C4.56 20.1301 4.79 20.0001 5.34 20.0001C5.89 20.0001 6.12 20.1301 6.49 20.3601C6.94 20.6301 7.56 21.0001 8.67 21.0001C9.78 21.0001 10.4 20.6301 10.86 20.3601C11.23 20.1301 11.45 20.0001 12.01 20.0001C12.56 20.0001 12.79 20.1401 13.16 20.3601C13.61 20.6301 14.23 21.0001 15.34 21.0001C16.45 21.0001 17.06 20.6301 17.52 20.3601C17.89 20.1301 18.11 20.0001 18.67 20.0001C19.22 20.0001 19.45 20.1401 19.82 20.3601C20.27 20.6301 20.89 21.0001 22 21.0001V19.0001C21.44 19.0001 21.22 18.8701 20.85 18.6401C20.4 18.3701 19.78 18.0001 18.67 18.0001Z"
            fill="currentColor"
          />
          <path
            d="M16.5 8.00007C17.8807 8.00007 19 6.88078 19 5.50007C19 4.11936 17.8807 3.00007 16.5 3.00007C15.1193 3.00007 14 4.11936 14 5.50007C14 6.88078 15.1193 8.00007 16.5 8.00007Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPortableWifiOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="portable_wifi_off">
        <path
          id="Vector"
          d="M3.42 2.61L2.01 4.03L4.1 6.12C2.79 7.82 2 9.94 2 12.25C2 15.95 4.01 19.17 6.99 20.9L7.99 19.17C5.61 17.78 4 15.21 4 12.25C4 10.49 4.57 8.87 5.53 7.56L6.96 9C6.36 9.93 6 11.05 6 12.25C6 14.47 7.21 16.4 9 17.44L10 15.7C8.81 15 8 13.73 8 12.25C8 11.6 8.17 11 8.44 10.46L10.02 12.04L10 12.25C10 13.35 10.9 14.25 12 14.25L12.21 14.23L19.73 21.75L21.14 20.34L3.42 2.61ZM17.71 14.07C17.89 13.5 18 12.88 18 12.25C18 8.94 15.31 6.25 12 6.25C11.37 6.25 10.75 6.36 10.18 6.54L11.9 8.26C11.93 8.26 11.96 8.25 12 8.25C14.21 8.25 16 10.04 16 12.25C16 12.29 15.99 12.32 15.99 12.36L17.71 14.07ZM12 4.25C16.42 4.25 20 7.83 20 12.25C20 13.45 19.71 14.57 19.23 15.6L20.72 17.09C21.53 15.65 22 14.01 22 12.25C22 6.73 17.52 2.25 12 2.25C10.24 2.25 8.6 2.73 7.16 3.53L8.64 5.01C9.66 4.53 10.8 4.25 12 4.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPortrait(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="portrait">
        <path
          id="Vector"
          d="M12 12C13.65 12 15 10.65 15 9C15 7.35 13.65 6 12 6C10.35 6 9 7.35 9 9C9 10.65 10.35 12 12 12ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM18 16.58C18 14.08 14.03 13 12 13C9.97 13 6 14.08 6 16.58V18H18V16.58ZM8.48 16C9.22 15.49 10.71 15 12 15C13.29 15 14.78 15.49 15.52 16H8.48ZM19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPostAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="post_add">
        <g id="Vector">
          <path
            d="M16.5 19.72H4.5V7.5H11.5V5.5H4.5C3.4 5.5 2.5 6.4 2.5 7.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H16.5C17.6 21.5 18.5 20.6 18.5 19.5V12.5H16.5V19.72Z"
            fill="currentColor"
          />
          <path
            d="M18.5 2.5H16.5V5.5H13.5C13.51 5.51 13.5 7.5 13.5 7.5H16.5V10.49C16.51 10.5 18.5 10.49 18.5 10.49V7.5H21.5V5.5H18.5V2.5Z"
            fill="currentColor"
          />
          <path d="M14.5 9.5H6.5V11.5H14.5V9.5Z" fill="currentColor" />
          <path d="M6.5 12.5V14.5H14.5V12.5H6.5Z" fill="currentColor" />
          <path d="M14.5 15.5H6.5V17.5H14.5V15.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconPower(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="power">
        <path
          id="Vector"
          d="M16 9V13.66L12.5 17.17V19H11.5V17.17L8 13.65V9H16ZM16 3H14V7H10V3H8V7H7.99C6.9 6.99 6 7.89 6 8.98V14.5L9.5 18V21H14.5V18L18 14.49V9C18 7.9 17.1 7 16 7V3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPowerInput(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="power_input">
        <path
          id="Vector"
          d="M2.5 9V11H21.5V9H2.5ZM2.5 15H7.5V13H2.5V15ZM9.5 15H14.5V13H9.5V15ZM16.5 15H21.5V13H16.5V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPowerOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="power_off">
        <path
          id="Vector"
          d="M10.215 2.505H8.21505V4.385L10.215 6.385V2.505ZM16.215 8.505V12.385L18.015 14.185L18.215 13.985V8.505C18.215 7.405 17.315 6.505 16.215 6.505V2.505H14.215V6.505H10.335L12.335 8.505H16.215ZM4.33505 3.345L2.92505 4.755L6.21505 8.045V14.005L9.71505 17.505V20.505H14.715V17.505L15.195 17.025L19.6651 21.495L21.0751 20.085L4.33505 3.345ZM12.715 16.675V18.505H11.715V16.675L8.21505 13.155V10.045L13.785 15.615L12.715 16.675Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPowerSettingsNew(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="power_settings_new">
        <path
          id="Vector"
          d="M13 3H11V13H13V3ZM17.83 5.17L16.41 6.59C17.99 7.86 19 9.81 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 9.81 6.01 7.86 7.58 6.58L6.17 5.17C4.23 6.82 3 9.26 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 9.26 19.77 6.82 17.83 5.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPrecisionManufacturing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="precision_manufacturing">
        <path
          id="Vector"
          d="M19.928 8.66756L16.328 10.3476L13.998 8.01756V6.61756L16.328 4.28756L19.928 5.96756C20.308 6.14756 20.748 5.97756 20.928 5.60756C21.108 5.22756 20.938 4.78756 20.568 4.60756L16.648 2.77756C16.268 2.59756 15.818 2.67756 15.518 2.97756L13.778 4.71756C13.598 4.47756 13.318 4.31756 12.998 4.31756C12.448 4.31756 11.998 4.76756 11.998 5.31756V6.31756H8.81805C8.39805 5.15756 7.29805 4.31756 5.99805 4.31756C4.33805 4.31756 2.99805 5.65756 2.99805 7.31756C2.99805 8.41756 3.59805 9.36756 4.47805 9.89756L7.07805 18.3176H5.99805C4.89805 18.3176 3.99805 19.2176 3.99805 20.3176V21.3176H16.998V20.3176C16.998 19.2176 16.098 18.3176 14.998 18.3176H13.378L8.40805 9.08756C8.57805 8.84756 8.71805 8.59756 8.81805 8.31756H11.998V9.31756C11.998 9.86756 12.448 10.3176 12.998 10.3176C13.318 10.3176 13.598 10.1576 13.778 9.91756L15.518 11.6576C15.818 11.9576 16.268 12.0376 16.648 11.8576L20.568 10.0276C20.948 9.84756 21.108 9.40756 20.928 9.02756C20.748 8.65756 20.308 8.48756 19.928 8.66756ZM5.99805 8.31756C5.44805 8.31756 4.99805 7.86756 4.99805 7.31756C4.99805 6.76756 5.44805 6.31756 5.99805 6.31756C6.54805 6.31756 6.99805 6.76756 6.99805 7.31756C6.99805 7.86756 6.54805 8.31756 5.99805 8.31756ZM11.108 18.3176H9.16805L6.70805 10.3176H6.80805L11.108 18.3176Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPregnantWoman(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pregnant_woman">
        <path
          id="Vector"
          d="M9 4C9 2.89 9.89 2 11 2C12.11 2 13 2.89 13 4C13 5.11 12.11 6 11 6C9.89 6 9 5.11 9 4ZM16 13C15.99 11.66 15.17 10.49 14 10C14 8.34 12.66 7 11 7C9.34 7 8 8.34 8 10V17H10V22H13V17H16V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPresentToAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="present_to_all">
        <path
          id="Vector"
          d="M21 3H3C1.89 3 1 3.89 1 5V19C1 20.11 1.89 21 3 21H21C22.11 21 23 20.11 23 19V5C23 3.89 22.11 3 21 3ZM21 19.02H3V4.98H21V19.02ZM10 12H8L12 8L16 12H14V16H10V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPreview(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="preview">
        <path
          id="Vector"
          d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19ZM12 10.5C13.84 10.5 15.48 11.46 16.34 13C15.48 14.54 13.84 15.5 12 15.5C10.16 15.5 8.52 14.54 7.66 13C8.52 11.46 10.16 10.5 12 10.5ZM12 9C9.27 9 6.94 10.66 6 13C6.94 15.34 9.27 17 12 17C14.73 17 17.06 15.34 18 13C17.06 10.66 14.73 9 12 9ZM12 14.5C11.17 14.5 10.5 13.83 10.5 13C10.5 12.17 11.17 11.5 12 11.5C12.83 11.5 13.5 12.17 13.5 13C13.5 13.83 12.83 14.5 12 14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPriceChange(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="price_change">
        <path
          id="Vector"
          d="M8 17H10V16H11C11.55 16 12 15.55 12 15V12C12 11.45 11.55 11 11 11H8V10H12V8H10V7H8V8H7C6.45 8 6 8.45 6 9V12C6 12.55 6.45 13 7 13H10V14H6V16H8V17ZM20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18ZM14 10L16 8L18 10M18 14.25L16 16.25L14 14.25"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPriceCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="price_check">
        <g id="Vector">
          <path
            d="M10.5 13V9C10.5 8.45 10.05 8 9.5 8H5.5V6H10.5V4H8V3H6V4H4.5C3.95 4 3.5 4.45 3.5 5V9C3.5 9.55 3.95 10 4.5 10H8.5V12H3.5V14H6V15H8V14H9.5C10.05 14 10.5 13.55 10.5 13Z"
            fill="currentColor"
          />
          <path
            d="M19.09 12.52L13.43 18.17L10.6 15.34L9.19 16.76L13.43 21L20.5 13.93L19.09 12.52Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPrint(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="print">
        <g id="Vector">
          <path
            d="M19 8H18V3H6V8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM8 5H16V8H8V5ZM16 19H8V15H16V19ZM18 15V13H6V15H4V11C4 10.45 4.45 10 5 10H19C19.55 10 20 10.45 20 11V15H18Z"
            fill="currentColor"
          />
          <path
            d="M18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5C17 12.0523 17.4477 12.5 18 12.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPrintDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="print_disabled" clipPath="url(#clip0_395_3288)">
        <g id="Vector">
          <path
            d="M2.23007 0.819946L0.820068 2.22995L5.82007 7.21995C4.16007 7.21995 2.82007 8.55995 2.82007 10.2199V16.2199H6.82007V20.2199H18.8201L21.7701 23.1799L23.1801 21.7699L2.23007 0.819946ZM6.82007 14.2199H4.82007V10.2199C4.82007 9.66995 5.27007 9.21995 5.82007 9.21995H7.82007L10.8201 12.2199H6.82007V14.2199ZM8.82007 18.2199V14.2199H12.8201L16.8201 18.2199H8.82007ZM8.82007 4.21995H16.8201V7.21995H11.4801L13.4801 9.21995H19.8201C20.3701 9.21995 20.8201 9.66995 20.8201 10.2199V14.2199L18.8201 14.2299V12.2199H16.4801L20.4801 16.2199H22.8201V10.2199C22.8201 8.55995 21.4801 7.21995 19.8201 7.21995H18.8201V2.21995H6.82007V2.57995L8.82007 4.57995V4.21995Z"
            fill="currentColor"
          />
          <path
            d="M18.8201 11.7299C19.3724 11.7299 19.8201 11.2822 19.8201 10.7299C19.8201 10.1777 19.3724 9.72995 18.8201 9.72995C18.2678 9.72995 17.8201 10.1777 17.8201 10.7299C17.8201 11.2822 18.2678 11.7299 18.8201 11.7299Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_3288">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPriorityHigh(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="priority_high">
        <g id="Vector">
          <path
            d="M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z"
            fill="currentColor"
          />
          <path d="M10 3H14V15H10V3Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconPrivacyTip(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="privacy_tip">
        <path
          id="Vector"
          d="M12 3.19L19 6.3V11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19ZM12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPrivateConnectivity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="private_connectivity">
        <path
          id="Vector"
          d="M12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7ZM5.07 13C5.56 16.39 8.47 19 12 19C15.53 19 18.44 16.39 18.93 13H22V11H18.93C18.44 7.61 15.53 5 12 5C8.47 5 5.56 7.61 5.07 11H2V13H5.07ZM14 10.5V9.61C14 8.61 13.32 7.69 12.34 7.53C11.08 7.32 10 8.29 10 9.5V10.5C9.45 10.5 9 10.95 9 11.5V14.5C9 15.05 9.45 15.5 10 15.5H14C14.55 15.5 15 15.05 15 14.5V11.5C15 10.95 14.55 10.5 14 10.5ZM12 13.75C11.59 13.75 11.25 13.41 11.25 13C11.25 12.59 11.59 12.25 12 12.25C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75ZM13 10.5H11V9.5C11 8.95 11.45 8.5 12 8.5C12.55 8.5 13 8.95 13 9.5V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconProductionQuantityLimits(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="production_quantity_limits">
        <path
          id="Vector"
          d="M14 10.5H12V8.5H14V10.5ZM14 6.5H12V1.5H14V6.5ZM8 18.5C6.9 18.5 6.01 19.4 6.01 20.5C6.01 21.6 6.9 22.5 8 22.5C9.1 22.5 10 21.6 10 20.5C10 19.4 9.1 18.5 8 18.5ZM18 18.5C16.9 18.5 16.01 19.4 16.01 20.5C16.01 21.6 16.9 22.5 18 22.5C19.1 22.5 20 21.6 20 20.5C20 19.4 19.1 18.5 18 18.5ZM9.1 13.5H16.55C17.3 13.5 17.96 13.09 18.3 12.47L22 5.46L20.25 4.5L16.55 11.5H9.53L5.27 2.5H2V4.5H4L7.6 12.09L6.25 14.53C5.52 15.87 6.48 17.5 8 17.5H20V15.5H8L9.1 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPropane(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="propane">
        <path
          id="Vector"
          d="M17 6H16V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V6H7C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18V21H9V18H15V21H17V18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM10 5H14V6H10V5ZM17 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H17C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPropaneTank(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="propane_tank">
        <path
          id="Vector"
          d="M17 6.14V4C17 2.9 16.1 2 15 2H9C7.9 2 7 2.9 7 4V6.14C5.28 6.59 4 8.14 4 10V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V10C20 8.14 18.72 6.59 17 6.14ZM9 4H15V6H13C13 5.45 12.55 5 12 5C11.45 5 11 5.45 11 6H9V4ZM8 8H16C17.1 8 18 8.9 18 10V13H6V10C6 8.9 6.9 8 8 8ZM16 20H8C6.9 20 6 19.1 6 18V15H18V18C18 19.1 17.1 20 16 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPsychology(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="psychology">
        <g id="Vector">
          <path
            d="M15.8198 7.22L14.8198 7.62C14.6098 7.46 14.3898 7.33 14.1498 7.23L13.9998 6.17C13.9798 6.07 13.8998 6 13.7998 6H12.1998C12.0998 6 12.0198 6.07 12.0098 6.17L11.8598 7.23C11.6198 7.33 11.3898 7.46 11.1898 7.62L10.1898 7.22C10.0998 7.19 9.98985 7.22 9.94985 7.31L9.14985 8.69C9.09985 8.78 9.11985 8.89 9.19985 8.95L10.0498 9.61C10.0198 9.73 9.99985 9.87 9.99985 10C9.99985 10.13 10.0098 10.26 10.0298 10.39L9.18985 11.05C9.10985 11.11 9.08985 11.22 9.13985 11.3L9.93985 12.69C9.98985 12.78 10.0898 12.81 10.1898 12.78L11.1798 12.38C11.3898 12.54 11.6098 12.67 11.8598 12.77L11.9998 13.83C12.0198 13.93 12.0998 14 12.1998 14H13.7998C13.8998 14 13.9798 13.93 13.9998 13.83L14.1498 12.77C14.3898 12.67 14.6198 12.54 14.8198 12.38L15.8098 12.78C15.8998 12.82 16.0098 12.78 16.0498 12.69L16.8498 11.3C16.8998 11.21 16.8798 11.11 16.7998 11.05L15.9698 10.39C15.9898 10.26 15.9998 10.13 15.9998 10C15.9998 9.86 15.9898 9.73 15.9698 9.61L16.8198 8.95C16.8998 8.89 16.9198 8.78 16.8698 8.69L16.0698 7.31C16.0198 7.22 15.9098 7.19 15.8198 7.22ZM12.9998 11.43C12.2098 11.43 11.5698 10.79 11.5698 10C11.5698 9.21 12.2098 8.57 12.9998 8.57C13.7898 8.57 14.4298 9.21 14.4298 10C14.4298 10.79 13.7898 11.43 12.9998 11.43Z"
            fill="currentColor"
          />
          <path
            d="M19.9398 9.06C19.5098 5.79 16.7098 3.2 13.4098 3.01C13.2698 3 13.1398 3 12.9998 3C9.46985 3 6.56985 5.61 6.07985 9L4.14985 12.48C3.73985 13.14 4.21985 14 4.99985 14H5.99985V16C5.99985 17.1 6.89985 18 7.99985 18H8.99985V21H15.9998V16.32C18.6198 15.07 20.3498 12.24 19.9398 9.06ZM14.8898 14.63L13.9998 15.05V19H10.9998V16H7.99985V12H6.69985L8.02985 9.67C8.20985 7.06 10.3498 5 12.9998 5C15.7598 5 17.9998 7.24 17.9998 10C17.9998 12.09 16.7098 13.88 14.8898 14.63Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPsychologyAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="psychology_alt">
        <g id="Vector">
          <path
            d="M19.9398 9.06C19.4998 5.73 16.5698 3 12.9998 3C9.46985 3 6.56985 5.61 6.07985 9L4.14985 12.48C3.73985 13.14 4.21985 14 4.99985 14H5.99985V16C5.99985 17.1 6.89985 18 7.99985 18H8.99985V21H15.9998V16.32C18.6198 15.07 20.3498 12.24 19.9398 9.06ZM14.8898 14.63L13.9998 15.05V19H10.9998V16H7.99985V12H6.69985L8.02985 9.67C8.20985 7.06 10.3498 5 12.9998 5C15.7598 5 17.9998 7.24 17.9998 10C17.9998 12.09 16.7098 13.88 14.8898 14.63Z"
            fill="currentColor"
          />
          <path
            d="M12.4998 12.54C12.0898 12.54 11.7598 12.85 11.7598 13.27C11.7598 13.68 12.0898 14.01 12.4998 14.01C12.9198 14.01 13.2298 13.68 13.2298 13.27C13.2298 12.85 12.9198 12.54 12.4998 12.54Z"
            fill="currentColor"
          />
          <path
            d="M12.4998 7C11.4698 7 10.7598 7.67 10.4998 8.45L11.4598 8.85C11.5898 8.46 11.8898 7.99 12.5098 7.99C13.4598 7.99 13.6398 8.88 13.3098 9.35C12.9898 9.8 12.4498 10.1 12.1698 10.61C11.9398 11.01 11.9898 11.48 11.9898 11.77H13.0498C13.0498 11.22 13.0898 11.12 13.1798 10.95C13.4098 10.53 13.8298 10.33 14.2698 9.68C14.6698 9.09 14.5198 8.3 14.2598 7.88C13.9498 7.39 13.3598 7 12.4998 7Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPublic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="public">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 11.39 4.08 10.79 4.21 10.22L8.99 15V16C8.99 17.1 9.89 18 10.99 18V19.93C7.06 19.43 4 16.07 4 12ZM17.89 17.4C17.63 16.59 16.89 16 15.99 16H14.99V13C14.99 12.45 14.54 12 13.99 12H7.99V10H9.99C10.54 10 10.99 9.55 10.99 9V7H12.99C14.09 7 14.99 6.1 14.99 5V4.59C17.92 5.77 20 8.65 20 12C20 14.08 19.19 15.98 17.89 17.4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPublicOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="public_off">
        <path
          id="Vector"
          d="M11.3048 7.86995L6.79482 3.35995C8.37482 2.30995 10.2648 1.69995 12.3048 1.69995C17.8248 1.69995 22.3048 6.17995 22.3048 11.7C22.3048 13.74 21.6948 15.63 20.6448 17.21L19.1848 15.75C19.8948 14.57 20.3048 13.18 20.3048 11.7C20.3048 8.34995 18.2348 5.47995 15.3048 4.28995V4.69995C15.3048 5.79995 14.4048 6.69995 13.3048 6.69995H11.3048V7.86995ZM21.4948 20.89L20.0848 22.3L17.8148 20.03C16.2348 21.09 14.3448 21.7 12.3048 21.7C6.78482 21.7 2.30482 17.22 2.30482 11.7C2.30482 9.65995 2.91482 7.76995 3.96482 6.18995L1.69482 3.91995L3.10482 2.50995L21.4948 20.89ZM11.3048 17.7C10.2048 17.7 9.30482 16.8 9.30482 15.7V14.7L4.51482 9.90995C4.38482 10.49 4.30482 11.08 4.30482 11.7C4.30482 15.78 7.35482 19.14 11.3048 19.63V17.7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPublish(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="publish">
        <path
          id="Vector"
          d="M5 4H19V6H5V4ZM5 14H9V20H15V14H19L12 7L5 14ZM13 12V18H11V12H9.83L12 9.83L14.17 12H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPublishedWithChanges(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="published_with_changes">
        <path
          id="Vector"
          d="M18.6 19.5H21V21.5H15V15.5H17V18.23C18.83 16.76 20 14.52 20 12C20 7.93005 16.94 4.56005 13 4.07005V2.05005C18.05 2.55005 22 6.81005 22 12C22 14.99 20.68 17.67 18.6 19.5ZM4 12C4 9.48005 5.17 7.23005 7 5.77005V8.50005H9V2.50005H3V4.50005H5.4C3.32 6.33005 2 9.01005 2 12C2 17.19 5.95 21.4501 11 21.9501V19.93C7.06 19.4401 4 16.07 4 12ZM16.24 8.11005L10.58 13.77L7.75 10.94L6.34 12.35L10.58 16.59L17.65 9.52005L16.24 8.11005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconPunchClock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="punch_clock">
        <g id="Vector">
          <path
            d="M19 6.5H18V1.5H6V6.5H5C3.9 6.5 3 7.4 3 8.5V20.5C3 21.6 3.9 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V8.5C21 7.4 20.1 6.5 19 6.5ZM8 3.5H16V6.5H8V3.5ZM19 20.5H5V8.5H19V20.5Z"
            fill="currentColor"
          />
          <path
            d="M12 9.5C9.24 9.5 7 11.74 7 14.5C7 17.26 9.24 19.5 12 19.5C14.76 19.5 17 17.26 17 14.5C17 11.74 14.76 9.5 12 9.5ZM12 18C10.07 18 8.5 16.43 8.5 14.5C8.5 12.57 10.07 11 12 11C13.93 11 15.5 12.57 15.5 14.5C15.5 16.43 13.93 18 12 18Z"
            fill="currentColor"
          />
          <path
            d="M12.5 12H11.5V14.71L13.14 16.35L13.85 15.64L12.5 14.29V12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPushPin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="push_pin">
        <path
          id="Vector"
          d="M14 4V9C14 10.12 14.37 11.16 15 12H9C9.65 11.14 10 10.1 10 9V4H14ZM17 2H7C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H8V9C8 10.66 6.66 12 5 12V14H10.97V21L11.97 22L12.97 21V14H19V12C17.34 12 16 10.66 16 9V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQrCode(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="qr_code">
        <g id="Vector">
          <path d="M3 11H11V3H3V11ZM5 5H9V9H5V5Z" fill="currentColor" />
          <path d="M3 21H11V13H3V21ZM5 15H9V19H5V15Z" fill="currentColor" />
          <path d="M13 3V11H21V3H13ZM19 9H15V5H19V9Z" fill="currentColor" />
          <path d="M21 19H19V21H21V19Z" fill="currentColor" />
          <path d="M15 13H13V15H15V13Z" fill="currentColor" />
          <path d="M17 15H15V17H17V15Z" fill="currentColor" />
          <path d="M15 17H13V19H15V17Z" fill="currentColor" />
          <path d="M17 19H15V21H17V19Z" fill="currentColor" />
          <path d="M19 17H17V19H19V17Z" fill="currentColor" />
          <path d="M19 13H17V15H19V13Z" fill="currentColor" />
          <path d="M21 15H19V17H21V15Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconQrCode2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="qr_code_2">
        <path
          id="Vector"
          d="M15 21H13V19H15V21ZM13 14H11V19H13V14ZM21 12H19V16H21V12ZM19 10H17V12H19V10ZM7 12H5V14H7V12ZM5 10H3V12H5V10ZM12 5H14V3H12V5ZM4.5 4.5V7.5H7.5V4.5H4.5ZM9 9H3V3H9V9ZM4.5 16.5V19.5H7.5V16.5H4.5ZM9 21H3V15H9V21ZM16.5 4.5V7.5H19.5V4.5H16.5ZM21 9H15V3H21V9ZM19 19V16H15V18H17V21H21V19H19ZM17 12H13V14H17V12ZM13 10H7V12H9V14H11V12H13V10ZM14 9V7H12V5H10V9H14ZM6.75 5.25H5.25V6.75H6.75V5.25ZM6.75 17.25H5.25V18.75H6.75V17.25ZM18.75 5.25H17.25V6.75H18.75V5.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQrCodeScanner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="qr_code_scanner">
        <path
          id="Vector"
          d="M9.5 6.5V9.5H6.5V6.5H9.5ZM11 5H5V11H11V5ZM9.5 14.5V17.5H6.5V14.5H9.5ZM11 13H5V19H11V13ZM17.5 6.5V9.5H14.5V6.5H17.5ZM19 5H13V11H19V5ZM13 13H14.5V14.5H13V13ZM14.5 14.5H16V16H14.5V14.5ZM16 13H17.5V14.5H16V13ZM13 16H14.5V17.5H13V16ZM14.5 17.5H16V19H14.5V17.5ZM16 16H17.5V17.5H16V16ZM17.5 14.5H19V16H17.5V14.5ZM17.5 17.5H19V19H17.5V17.5ZM22 7H20V4H17V2H22V7ZM22 22V17H20V20H17V22H22ZM2 22H7V20H4V17H2V22ZM2 2V7H4V4H7V2H2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQueryBuilder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="query_builder">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQueryStats(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="query_stats">
        <path
          id="Vector"
          d="M19.88 17.97C20.32 17.27 20.58 16.46 20.58 15.58C20.58 13.09 18.57 11.08 16.08 11.08C13.59 11.08 11.58 13.09 11.58 15.58C11.58 18.07 13.59 20.08 16.07 20.08C16.95 20.08 17.77 19.82 18.46 19.38L21.58 22.5L23 21.08L19.88 17.97ZM16.08 18.08C14.7 18.08 13.58 16.96 13.58 15.58C13.58 14.2 14.7 13.08 16.08 13.08C17.46 13.08 18.58 14.2 18.58 15.58C18.58 16.96 17.46 18.08 16.08 18.08ZM15.72 9.58C14.98 9.6 14.27 9.76 13.62 10.03L13.07 9.2L9.27 15.38L6.26 11.86L2.63 17.67L1 16.5L6 8.5L9 12L13 5.5L15.72 9.58ZM18.31 10.08C17.67 9.8 16.98 9.63 16.26 9.59L21.38 1.5L23 2.68L18.31 10.08Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQuestionAnswer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="question_answer">
        <path
          id="Vector"
          d="M15 4V11H5.17L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQuestionMark(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="question_mark">
        <path
          id="Vector"
          d="M11.0688 12.35C11.8388 10.96 13.3188 10.14 14.1788 8.91C15.0888 7.62 14.5788 5.21 11.9988 5.21C10.3088 5.21 9.47882 6.49 9.12882 7.55L6.53882 6.46C7.24882 4.33 9.17882 2.5 11.9888 2.5C14.3388 2.5 15.9488 3.57 16.7688 4.91C17.4688 6.06 17.8788 8.21 16.7988 9.81C15.5988 11.58 14.4488 12.12 13.8288 13.26C13.5788 13.72 13.4788 14.02 13.4788 15.5H10.5888C10.5788 14.72 10.4588 13.45 11.0688 12.35ZM13.9988 19.5C13.9988 20.6 13.0988 21.5 11.9988 21.5C10.8988 21.5 9.99882 20.6 9.99882 19.5C9.99882 18.4 10.8988 17.5 11.9988 17.5C13.0988 17.5 13.9988 18.4 13.9988 19.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQueue(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="queue">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 15H15V11H19V9H15V5H13V9H9V11H13V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQueueMusic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="queue_music">
        <path
          id="Vector"
          d="M21.5 5H16.5V13.18C16.19 13.07 15.85 13 15.5 13C13.84 13 12.5 14.34 12.5 16C12.5 17.66 13.84 19 15.5 19C17.16 19 18.5 17.66 18.5 16V7H21.5V5ZM14.5 5H2.5V7H14.5V5ZM14.5 9H2.5V11H14.5V9ZM10.5 13H2.5V15H10.5V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQueuePlayNext(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="queue_play_next">
        <path
          id="Vector"
          d="M20.5 2.25H2.5C1.39 2.25 0.5 3.14 0.5 4.25V16.25C0.5 17.35 1.39 18.25 2.5 18.25H7.5V20.25H15.5V18.25H17.5V16.25H2.5V4.25H20.5V12.25H22.5V4.25C22.5 3.14 21.6 2.25 20.5 2.25ZM12.5 9.25V6.25H10.5V9.25H7.5V11.25H10.5V14.25H12.5V11.25H15.5V9.25H12.5ZM23.5 17.25L19 21.75L17.5 20.25L20.5 17.25L17.5 14.25L19 12.75L23.5 17.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconQuickreply(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="quickreply">
        <g id="Vector">
          <path
            d="M3.75 16.67V3.5H19.75V9.5H21.75V3.5C21.75 2.4 20.85 1.5 19.75 1.5H3.75C2.65 1.5 1.76 2.4 1.76 3.5L1.75 21.5L5.75 17.5H14.75V15.5H4.92L3.75 16.67Z"
            fill="currentColor"
          />
          <path
            d="M22.25 15.5H20.05L21.75 11.5H16.75V17.5H18.75V22.5L22.25 15.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconQuiz(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="quiz">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13.51 10.16C13.92 9.43 14.69 9 15.14 8.36C15.62 7.68 15.35 6.42 14 6.42C13.12 6.42 12.68 7.09 12.5 7.65L11.13 7.08C11.51 5.96 12.52 5 13.99 5C15.22 5 16.07 5.56 16.5 6.26C16.87 6.86 17.08 7.99 16.51 8.83C15.88 9.76 15.28 10.04 14.95 10.64C14.82 10.88 14.77 11.04 14.77 11.82H13.25C13.26 11.41 13.19 10.74 13.51 10.16ZM12.95 13.95C12.95 13.36 13.42 12.91 14 12.91C14.59 12.91 15.04 13.36 15.04 13.95C15.04 14.53 14.6 15 14 15C13.42 15 12.95 14.53 12.95 13.95Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRMobiledata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="r_mobiledata">
        <path
          id="Vector"
          d="M14.3 13.2L15.5 16H13.5L12.37 13.33H10.5V16H8.5V8H13.5C14.63 8 15.5 8.87 15.5 10V11.33C15.5 12.13 14.97 12.87 14.3 13.2ZM13.5 10H10.5V11.33H13.5V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRadar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="radar">
        <path
          id="Vector"
          d="M19.74 18.33C21.15 16.6 22 14.4 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C14.4 22 16.6 21.15 18.33 19.74C18.6 19.52 18.86 19.28 19.11 19.03C19.14 19 19.16 18.97 19.18 18.95C19.38 18.75 19.57 18.54 19.74 18.33ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.85 19.37 15.54 18.31 16.9L16.88 15.47C17.57 14.49 17.98 13.3 17.98 12.01C17.98 8.7 15.29 6.01 11.98 6.01C8.67 6.01 5.98 8.7 5.98 12.01C5.98 15.32 8.67 18.01 11.98 18.01C13.28 18.01 14.49 17.59 15.47 16.88L16.89 18.3C15.54 19.37 13.85 20 12 20ZM13.92 12.51C14.09 11.85 13.94 11.13 13.43 10.61L13.41 10.59C12.64 9.82 11.41 9.81 10.63 10.55C10.62 10.56 10.6 10.57 10.58 10.59C9.8 11.37 9.8 12.64 10.58 13.42L10.6 13.44C11.12 13.95 11.85 14.11 12.51 13.93L14.02 15.44C13.42 15.8 12.73 16.02 11.98 16.02C9.77 16.02 7.98 14.23 7.98 12.02C7.98 9.81 9.77 8.02 11.98 8.02C14.19 8.02 15.98 9.81 15.98 12.02C15.98 12.75 15.77 13.43 15.42 14.02L13.92 12.51Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRadio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="radio">
        <g id="Vector">
          <path
            d="M20 6.5H8.3L16.56 3.16L15.88 1.5L3.24 6.65C2.51 6.93 2 7.67 2 8.5V20.5C2 21.6 2.89 22.5 4 22.5H20C21.11 22.5 22 21.6 22 20.5V8.5C22 7.39 21.11 6.5 20 6.5ZM20 8.5V11.5H18V9.5H16V11.5H4V8.5H20ZM4 20.5V13.5H20V20.5H4Z"
            fill="currentColor"
          />
          <path
            d="M8 19.48C9.38071 19.48 10.5 18.3607 10.5 16.98C10.5 15.5993 9.38071 14.48 8 14.48C6.61929 14.48 5.5 15.5993 5.5 16.98C5.5 18.3607 6.61929 19.48 8 19.48Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRadioButtonChecked(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="radio_button_checked">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRadioButtonUnchecked(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="radio_button_unchecked">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRailwayAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="railway_alert">
        <g id="Vector">
          <path
            d="M9.5 17.5C10.3284 17.5 11 16.8284 11 16C11 15.1716 10.3284 14.5 9.5 14.5C8.67157 14.5 8 15.1716 8 16C8 16.8284 8.67157 17.5 9.5 17.5Z"
            fill="currentColor"
          />
          <path
            d="M3.5 11.5V8.5H10.79C10.6 7.87 10.5 7.2 10.5 6.5H3.93C4.83 5.73 7.21 5.42 10.58 5.52C10.68 4.82 10.88 4.15 11.17 3.53C2.47 3.17 1.5 5.52 1.5 7.5V17C1.5 18.93 3.07 20.5 5 20.5L3.5 21.5V22.5H15.5V21.5L14 20.5C15.93 20.5 17.5 18.93 17.5 17V13.5C15.59 13.5 13.87 12.74 12.61 11.5H3.5ZM15.5 17C15.5 17.83 14.83 18.5 14 18.5H5C4.17 18.5 3.5 17.83 3.5 17V13.5H15.5V17Z"
            fill="currentColor"
          />
          <path
            d="M17.5 1.5C14.74 1.5 12.5 3.74 12.5 6.5C12.5 9.26 14.74 11.5 17.5 11.5C20.26 11.5 22.5 9.26 22.5 6.5C22.5 3.74 20.26 1.5 17.5 1.5ZM18 9.5H17V8.5H18V9.5ZM18 7.5H17V3.5H18V7.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRamenDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ramen_dining">
        <path
          id="Vector"
          d="M19.66 14C19 15.92 17.42 17.54 15.26 18.39L14 18.89V20H10V18.89L8.73 18.39C6.57 17.54 4.99 15.92 4.33 14H19.66ZM22 2L4 3.99V12H2C2 15.69 4.47 18.86 8 20.25V22H16V20.25C19.53 18.86 22 15.69 22 12H10.5V8H22V6.5H10.5V4.78L22 3.51V2ZM8 6.5V5.06L9 4.95V6.5H8ZM5.5 6.5V5.34L6.5 5.23V6.5H5.5ZM8 12V8H9V12H8ZM5.5 12V8H6.5V12H5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRampLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ramp_left">
        <path
          id="Vector"
          d="M11.5 21H9.5V6.83L7.91 8.41L6.5 7L10.5 3L14.5 7L13.09 8.41L11.5 6.83V9C11.5 13.27 15.53 16.13 17.5 17.27L16.04 18.73C14.13 17.57 12.6 16.2 11.5 14.71V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRampRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ramp_right">
        <path
          id="Vector"
          d="M12.5 21H14.5V6.83L16.09 8.42L17.5 7L13.5 3L9.5 7L10.91 8.41L12.5 6.83V9C12.5 13.27 8.47 16.13 6.5 17.27L7.96 18.73C9.87 17.56 11.4 16.19 12.5 14.7V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRateReview(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rate_review">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM10.5 14H18V12H12.5L10.5 14ZM14.36 8.13C14.56 7.93 14.56 7.62 14.36 7.42L12.59 5.65C12.39 5.45 12.08 5.45 11.88 5.65L6 11.53V14H8.47L14.36 8.13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRawOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="raw_off">
        <g id="Vector">
          <path
            d="M17.7151 13.61L18.3051 11.25L19.0651 14.29H20.5451L22.0451 8.28998H20.5451L19.8051 11.29L19.0651 8.28998H17.5451L16.8051 11.29L16.0651 8.28998H14.5651L15.2851 11.19L17.7151 13.61Z"
            fill="currentColor"
          />
          <path
            d="M1.95508 3.50998L6.73508 8.28998H3.56508V14.29H5.06508V12.29H6.16508L7.06508 14.29H8.56508L7.66508 12.19C8.16508 11.89 8.56508 11.39 8.56508 10.79V10.12L9.99508 11.55L9.31508 14.29H10.8151L11.1951 12.79H11.2351L20.3451 21.9L21.7551 20.49L3.37508 2.09998L1.95508 3.50998ZM7.06508 10.79H5.06508V9.78998H7.06508V10.79Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRawOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="raw_on">
        <g id="Vector">
          <path
            d="M6.26001 9H2.76001V15H4.26001V13H5.36001L6.26001 15H7.76001L6.86001 12.9C7.36001 12.6 7.76001 12.1 7.76001 11.5V10.5C7.76001 9.7 7.06001 9 6.26001 9ZM6.26001 11.5H4.26001V10.5H6.26001V11.5Z"
            fill="currentColor"
          />
          <path
            d="M10.01 9L8.51001 15H10.01L10.39 13.5H12.14L12.51 15H14.01L12.51 9H10.01ZM10.76 12L11.01 11H11.51L11.76 12H10.76Z"
            fill="currentColor"
          />
          <path
            d="M19.74 9L19 12L18.26 9H16.74L16 12L15.26 9H13.76L15.26 15H16.74L17.5 11.96L18.26 15H19.74L21.24 9H19.74Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconReadMore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="read_more">
        <g id="Vector">
          <path d="M22 7H13V9H22V7Z" fill="currentColor" />
          <path d="M22 15H13V17H22V15Z" fill="currentColor" />
          <path d="M22 11H16V13H22V11Z" fill="currentColor" />
          <path d="M13 12L8 7V11H2V13H8V17L13 12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconRealEstateAgent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="real_estate_agent">
        <path
          id="Vector"
          d="M21.5 6.5V14H19.5V7.5L14.5 4L9.5 7.5V9H7.5V6.5L14.5 1.5L21.5 6.5ZM16 7H15V8H16V7ZM14 7H13V8H14V7ZM16 9H15V10H16V9ZM14 9H13V10H14V9ZM19.5 16H17.5C17.5 14.8 16.75 13.72 15.63 13.3L9.47 11H1.5V22H7.5V20.56L14.5 22.5L22.5 20V19C22.5 17.34 21.16 16 19.5 16ZM3.5 20V13H5.5V20H3.5ZM14.47 20.41L7.5 18.48V13H9.11L14.93 15.17C15.27 15.3 15.5 15.63 15.5 16C15.5 16 13.51 15.95 13.2 15.85L10.82 15.06L10.19 16.96L12.57 17.75C13.08 17.92 13.61 18.01 14.15 18.01H19.5C19.89 18.01 20.24 18.24 20.4 18.57L14.47 20.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReceipt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="receipt">
        <path
          id="Vector"
          d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5ZM19 19.09H5V4.91H19V19.09ZM6 15H18V17H6V15ZM6 11H18V13H6V11ZM6 7H18V9H6V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReceiptLong(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="receipt_long">
        <g id="Vector">
          <path
            d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM15 20H6C5.45 20 5 19.55 5 19V18H15V20ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z"
            fill="currentColor"
          />
          <path d="M15 7H9V9H15V7Z" fill="currentColor" />
          <path d="M18 7H16V9H18V7Z" fill="currentColor" />
          <path d="M15 10H9V12H15V10Z" fill="currentColor" />
          <path d="M18 10H16V12H18V10Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconRecentActors(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="recent_actors">
        <g id="Vector">
          <path
            d="M21 5H23V19H21V5ZM17 5H19V19H17V5ZM14 5H2C1.45 5 1 5.45 1 6V18C1 18.55 1.45 19 2 19H14C14.55 19 15 18.55 15 18V6C15 5.45 14.55 5 14 5ZM13 17H3V7H13V17Z"
            fill="currentColor"
          />
          <path
            d="M8 11.89C9.07696 11.89 9.95 11.017 9.95 9.94C9.95 8.86304 9.07696 7.99 8 7.99C6.92304 7.99 6.05 8.86304 6.05 9.94C6.05 11.017 6.92304 11.89 8 11.89Z"
            fill="currentColor"
          />
          <path
            d="M11.89 15.35C11.89 14.05 9.3 13.4 8 13.4C6.7 13.4 4.11 14.05 4.11 15.35V16H11.89V15.35Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRecommend(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="recommend">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M17 10H12.41L12.99 6.59V6.39C12.98 6.13 12.87 5.88 12.69 5.69L12 5L7.4 10C7.13 10.26 6.98 10.62 7 11V16C7 17.1 7.9 18 9 18H14.5C15.06 18.03 15.58 17.71 15.8 17.2L17.9 12.3C17.98 12.15 18.02 11.97 18 11.8V11C18 10.45 17.55 10 17 10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRecordVoiceOver(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="record_voice_over">
        <path
          id="Vector"
          d="M9.00061 13.5C11.2106 13.5 13.0006 11.71 13.0006 9.5C13.0006 7.29 11.2106 5.5 9.00061 5.5C6.79061 5.5 5.00061 7.29 5.00061 9.5C5.00061 11.71 6.79061 13.5 9.00061 13.5ZM9.00061 7.5C10.1006 7.5 11.0006 8.4 11.0006 9.5C11.0006 10.6 10.1006 11.5 9.00061 11.5C7.90061 11.5 7.00061 10.6 7.00061 9.5C7.00061 8.4 7.90061 7.5 9.00061 7.5ZM9.00061 15.5C6.33061 15.5 1.00061 16.84 1.00061 19.5V21.5H17.0006V19.5C17.0006 16.84 11.6706 15.5 9.00061 15.5ZM3.00061 19.5C3.22061 18.78 6.31061 17.5 9.00061 17.5C11.7006 17.5 14.8006 18.79 15.0006 19.5H3.00061ZM15.0806 7.55C15.9206 8.73 15.9206 10.26 15.0806 11.44L16.7606 13.13C18.7806 11.11 18.7806 8.06 16.7606 5.86L15.0806 7.55ZM20.0706 2.5L18.4406 4.13C21.2106 7.15 21.2106 11.69 18.4406 14.87L20.0706 16.5C23.9706 12.61 23.9806 6.55 20.0706 2.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRectangle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rectangle">
        <path id="Vector" d="M2 4V20H22V4H2ZM20 18H4V6H20V18Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconRecycling(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="recycling">
        <path
          id="Vector"
          d="M6.27 6.65L8.73 2.57C9.12 1.92 10.06 1.92 10.45 2.57L11.93 5.03L10.7 7.09L9.7 8.71L6.27 6.65ZM22.22 12.47L20.62 9.81L17.16 11.81L19.37 15.5H20.5C21.26 15.5 21.95 15.07 22.29 14.39C22.43 14.11 22.5 13.81 22.5 13.5C22.5 13.14 22.4 12.79 22.22 12.47ZM16.5 20.5H18C18.76 20.5 19.45 20.07 19.79 19.39L21.24 16.5H16.5V14.5L12.5 18.5L16.5 22.5V20.5ZM10.5 16.5H6.2L5.36 17.91C5.06 18.41 5.04 19.03 5.3 19.56C5.58 20.13 6.17 20.5 6.82 20.5H10.5V16.5ZM6.62 13.85L8.35 14.89L6.98 9.4L1.5 10.77L3.2 11.79L2.79 12.48C2.44 13.07 2.41 13.79 2.72 14.4L4.35 17.66L6.62 13.85ZM17.52 4.64L16.22 2.47C15.85 1.87 15.2 1.5 14.5 1.5H10.97L14.09 6.7L12.37 7.73L17.86 9.1L19.23 3.61L17.52 4.64Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRedeem(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="redeem">
        <path
          id="Vector"
          d="M20 6.5H17.82C17.93 6.19 18 5.85 18 5.5C18 3.84 16.66 2.5 15 2.5C13.95 2.5 13.04 3.04 12.5 3.85L12 4.52L11.5 3.84C10.96 3.04 10.05 2.5 9 2.5C7.34 2.5 6 3.84 6 5.5C6 5.85 6.07 6.19 6.18 6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM15 4.5C15.55 4.5 16 4.95 16 5.5C16 6.05 15.55 6.5 15 6.5C14.45 6.5 14 6.05 14 5.5C14 4.95 14.45 4.5 15 4.5ZM9 4.5C9.55 4.5 10 4.95 10 5.5C10 6.05 9.55 6.5 9 6.5C8.45 6.5 8 6.05 8 5.5C8 4.95 8.45 4.5 9 4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H9.08L7 11.33L8.62 12.5L12 7.9L15.38 12.5L17 11.33L14.92 8.5H20V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRedo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="redo">
        <path
          id="Vector"
          d="M18.63 11.1C16.78 9.49 14.38 8.5 11.73 8.5C7.08002 8.5 3.15002 11.53 1.77002 15.72L4.13002 16.5C5.18002 13.31 8.18002 11 11.73 11C13.68 11 15.46 11.72 16.85 12.88L13.23 16.5H22.23V7.5L18.63 11.1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReduceCapacity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="reduce_capacity">
        <path
          id="Vector"
          d="M16 4C16 2.9 16.9 2 18 2C19.1 2 20 2.9 20 4C20 5.1 19.1 6 18 6C16.9 6 16 5.1 16 4ZM20.78 7.58C19.93 7.21 18.99 7 18 7C17.33 7 16.69 7.1 16.08 7.28C16.66 7.83 17 8.6 17 9.43V10H22V9.43C22 8.62 21.52 7.9 20.78 7.58ZM6 6C7.1 6 8 5.1 8 4C8 2.9 7.1 2 6 2C4.9 2 4 2.9 4 4C4 5.1 4.9 6 6 6ZM7.92 7.28C7.31 7.1 6.67 7 6 7C5.01 7 4.07 7.21 3.22 7.58C2.48 7.9 2 8.62 2 9.43V10H7V9.43C7 8.6 7.34 7.83 7.92 7.28ZM10 4C10 2.9 10.9 2 12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4ZM16 10H8V9.43C8 8.62 8.48 7.9 9.22 7.58C10.07 7.21 11.01 7 12 7C12.99 7 13.93 7.21 14.78 7.58C15.52 7.9 16 8.62 16 9.43V10ZM15 16C15 14.9 15.9 14 17 14C18.1 14 19 14.9 19 16C19 17.1 18.1 18 17 18C15.9 18 15 17.1 15 16ZM21 22H13V21.43C13 20.62 13.48 19.9 14.22 19.58C15.07 19.21 16.01 19 17 19C17.99 19 18.93 19.21 19.78 19.58C20.52 19.9 21 20.62 21 21.43V22ZM5 16C5 14.9 5.9 14 7 14C8.1 14 9 14.9 9 16C9 17.1 8.1 18 7 18C5.9 18 5 17.1 5 16ZM11 22H3V21.43C3 20.62 3.48 19.9 4.22 19.58C5.07 19.21 6.01 19 7 19C7.99 19 8.93 19.21 9.78 19.58C10.52 19.9 11 20.62 11 21.43V22ZM12.75 13V11H11.25V13H9L12 16L15 13H12.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRefresh(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="refresh">
        <path
          id="Vector"
          d="M17.6449 6.35C16.1949 4.9 14.2049 4 11.9949 4C7.57488 4 4.00488 7.58 4.00488 12C4.00488 16.42 7.57488 20 11.9949 20C15.7249 20 18.8349 17.45 19.7249 14H17.6449C16.8249 16.33 14.6049 18 11.9949 18C8.68488 18 5.99488 15.31 5.99488 12C5.99488 8.69 8.68488 6 11.9949 6C13.6549 6 15.1349 6.69 16.2149 7.78L12.9949 11H19.9949V4L17.6449 6.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRememberMe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remember_me">
        <g id="Vector">
          <path
            d="M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 21H7V20H17V21ZM17 18H7V17.52C8.47 16.53 10.22 16 12 16C13.78 16 15.53 16.53 17 17.52V18ZM17 15.21C15.5 14.44 13.8 14 12 14C10.2 14 8.5 14.44 7 15.21V6H17V15.21ZM17 4H7V3H17V4Z"
            fill="currentColor"
          />
          <path
            d="M12 13C13.66 13 15 11.66 15 10C15 8.34 13.66 7 12 7C10.34 7 9 8.34 9 10C9 11.66 10.34 13 12 13ZM12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRemove(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove">
        <path id="Vector" d="M19 13H5V11H19V13Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconRemoveCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H7V11H17V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRemoveCircleOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_circle_outline">
        <path
          id="Vector"
          d="M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRemoveDone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_done">
        <path
          id="Vector"
          d="M4.67504 2.09998L3.26504 3.50998L13.645 13.89L12.235 15.3L7.99504 11.06L6.58504 12.47L12.245 18.13L15.075 15.3L21.675 21.9L23.085 20.49L4.67504 2.09998ZM17.885 12.48L22.835 7.51998L21.405 6.11998L16.465 11.06L17.885 12.48ZM17.175 7.51998L15.765 6.10998L13.645 8.22998L15.055 9.63998L17.175 7.51998ZM0.915039 12.47L6.57504 18.13L7.98504 16.72L2.32504 11.06L0.915039 12.47Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRemoveFromQueue(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_from_queue">
        <path
          id="Vector"
          d="M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17ZM16 10V12H8V10H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRemoveModerator(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_moderator">
        <path
          id="Vector"
          d="M12.7101 3.83495L18.7101 6.08495V10.7849C18.7101 11.9749 18.4801 13.1449 18.0701 14.2249L19.5801 15.7349C20.3001 14.2049 20.7101 12.5149 20.7101 10.7849V4.69495L12.7101 1.69495L7.4901 3.65495L9.0401 5.20495L12.7101 3.83495ZM3.5201 2.50495L2.1001 3.91495L4.7101 6.52495V10.7849C4.7101 15.8349 8.1201 20.5449 12.7101 21.6949C14.4301 21.2649 15.9901 20.3349 17.2601 19.0749L20.4901 22.3049L21.9001 20.8949L3.5201 2.50495ZM12.7101 19.6149C9.2601 18.4849 6.7101 14.7949 6.7101 10.7849V8.52495L15.8501 17.6649C14.9501 18.5449 13.8801 19.2349 12.7101 19.6149Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRemoveRedEye(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_red_eye">
        <path
          id="Vector"
          d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRemoveRoad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_road">
        <g id="Vector">
          <path d="M18.75 3H16.75V12H18.75V3Z" fill="currentColor" />
          <path d="M4.75 3H2.75V19H4.75V3Z" fill="currentColor" />
          <path d="M11.75 3H9.75V7H11.75V3Z" fill="currentColor" />
          <path d="M11.75 9H9.75V13H11.75V9Z" fill="currentColor" />
          <path d="M11.75 15H9.75V19H11.75V15Z" fill="currentColor" />
          <path
            d="M21.25 15.41L19.84 14L17.75 16.09L15.66 14L14.25 15.41L16.34 17.5L14.25 19.59L15.66 21L17.75 18.91L19.84 21L21.25 19.59L19.16 17.5L21.25 15.41Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRemoveShoppingCart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="remove_shopping_cart" clipPath="url(#clip0_395_4186)">
        <path
          id="Vector"
          d="M1.97494 0.564941L0.564941 1.97494L4.95494 6.36494L7.16494 11.0249L5.81494 13.4749C5.65494 13.7549 5.56494 14.0849 5.56494 14.4349C5.56494 15.5349 6.46494 16.4349 7.56494 16.4349H15.0249L16.4049 17.8149C15.9049 18.1749 15.5749 18.7649 15.5749 19.4349C15.5749 20.5349 16.4649 21.4349 17.5649 21.4349C18.2349 21.4349 18.8249 21.1049 19.1849 20.5949L22.0249 23.4349L23.4349 22.0249L1.97494 0.564941ZM7.56494 14.4349L8.66494 12.4349H11.0249L13.0249 14.4349H7.56494ZM20.5649 3.43494H7.68494L9.68494 5.43494H18.8749L16.1149 10.4349H14.6749L16.6149 12.3749C17.1549 12.2349 17.6049 11.8849 17.8649 11.4049L21.4449 4.91494C21.8149 4.25494 21.3249 3.43494 20.5649 3.43494ZM7.56494 17.4349C6.46494 17.4349 5.57494 18.3349 5.57494 19.4349C5.57494 20.5349 6.46494 21.4349 7.56494 21.4349C8.66494 21.4349 9.56494 20.5349 9.56494 19.4349C9.56494 18.3349 8.66494 17.4349 7.56494 17.4349Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_4186">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconReorder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="reorder">
        <path
          id="Vector"
          d="M3 15H21V13H3V15ZM3 19H21V17H3V19ZM3 11H21V9H3V11ZM3 5V7H21V5H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRepartition(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="repartition">
        <g id="Vector">
          <path
            d="M3.5 21.5H21.5V15.5H3.5V21.5ZM10.83 19.5V17.5H14.16V19.5H10.83ZM19.5 19.5H16.17V17.5H19.5V19.5ZM5.5 17.5H8.83V19.5H5.5V17.5Z"
            fill="currentColor"
          />
          <path
            d="M6.5 10.5L7.92 9.08L6.33 7.5H17.5C18.6 7.5 19.5 8.4 19.5 9.5C19.5 10.6 18.6 11.5 17.5 11.5H3.5V13.5H17.5C19.71 13.5 21.5 11.71 21.5 9.5C21.5 7.29 19.71 5.5 17.5 5.5H6.33L7.92 3.91L6.5 2.5L2.5 6.5L6.5 10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRepeat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="repeat">
        <path
          id="Vector"
          d="M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRepeatOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="repeat_on">
        <path
          id="Vector"
          d="M21 1H3C1.9 1 1 1.9 1 3V21C1 22.1 1.9 23 3 23H21C22.1 23 23 22.1 23 21V3C23 1.9 22.1 1 21 1ZM19 19H6.83L8.41 20.58L7 22L3 18L7 14L8.41 15.42L6.83 17H17V13H19V19ZM17 10L15.59 8.58L17.17 7H7V11H5V5H17.17L15.59 3.42L17 2L21 6L17 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRepeatOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="repeat_one">
        <path
          id="Vector"
          d="M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17ZM13 15V9H12L10 10V11H11.5V15H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRepeatOneOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="repeat_one_on">
        <path
          id="Vector"
          d="M21 1H3C1.9 1 1 1.9 1 3V21C1 22.1 1.9 23 3 23H21C22.1 23 23 22.1 23 21V3C23 1.9 22.1 1 21 1ZM19 19H6.83L8.41 20.58L7 22L3 18L7 14L8.41 15.42L6.83 17H17V13H19V19ZM10 10.5V9H13V15H11.5V10.5H10ZM17 10L15.59 8.58L17.17 7H7V11H5V5H17.17L15.59 3.42L17 2L21 6L17 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReplay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="replay">
        <path
          id="Vector"
          d="M12 6V2L7 7L12 12V8C15.31 8 18 10.69 18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14H4C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 9.58 16.42 6 12 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReplay10(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="replay_10">
        <path
          id="Vector"
          d="M12 6V2L7 7L12 12V8C15.31 8 18 10.69 18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14H4C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 9.58 16.42 6 12 6ZM10.9 17H10.05V13.74L9.04 14.05V13.36L10.81 12.73H10.9V17ZM15.18 15.24C15.18 15.56 15.15 15.84 15.08 16.06C15.01 16.28 14.91 16.48 14.79 16.63C14.67 16.78 14.51 16.89 14.34 16.96C14.17 17.03 13.97 17.06 13.75 17.06C13.53 17.06 13.34 17.03 13.16 16.96C12.98 16.89 12.83 16.78 12.7 16.63C12.57 16.48 12.47 16.29 12.4 16.06C12.33 15.83 12.29 15.56 12.29 15.24V14.5C12.29 14.18 12.32 13.9 12.39 13.68C12.46 13.46 12.56 13.26 12.68 13.11C12.8 12.96 12.96 12.85 13.13 12.78C13.3 12.71 13.5 12.68 13.72 12.68C13.94 12.68 14.13 12.71 14.31 12.78C14.49 12.85 14.64 12.96 14.77 13.11C14.9 13.26 15 13.45 15.07 13.68C15.14 13.91 15.18 14.18 15.18 14.5V15.24ZM14.33 14.38C14.33 14.19 14.32 14.03 14.29 13.9C14.26 13.77 14.22 13.67 14.17 13.59C14.12 13.51 14.06 13.45 13.98 13.42C13.9 13.39 13.82 13.37 13.73 13.37C13.64 13.37 13.55 13.39 13.48 13.42C13.41 13.45 13.34 13.51 13.29 13.59C13.24 13.67 13.2 13.77 13.17 13.9C13.14 14.03 13.13 14.19 13.13 14.38V15.35C13.13 15.54 13.14 15.7 13.17 15.83C13.2 15.96 13.24 16.07 13.29 16.15C13.34 16.23 13.4 16.29 13.48 16.32C13.56 16.35 13.64 16.37 13.73 16.37C13.82 16.37 13.91 16.35 13.98 16.32C14.05 16.29 14.12 16.23 14.17 16.15C14.22 16.07 14.26 15.96 14.28 15.83C14.3 15.7 14.32 15.54 14.32 15.35V14.38H14.33Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReplay30(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="replay_30">
        <path
          id="Vector"
          d="M12 6V2L7 7L12 12V8C15.31 8 18 10.69 18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14H4C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 9.58 16.42 6 12 6ZM9.56 14.49H10.01C10.22 14.49 10.38 14.44 10.49 14.33C10.6 14.22 10.65 14.08 10.65 13.9C10.65 13.82 10.64 13.75 10.61 13.68C10.58 13.61 10.55 13.56 10.5 13.51C10.45 13.46 10.39 13.42 10.32 13.4C10.25 13.38 10.16 13.36 10.07 13.36C9.99 13.36 9.92 13.37 9.85 13.39C9.78 13.41 9.72 13.44 9.67 13.49C9.62 13.54 9.58 13.58 9.55 13.64C9.52 13.7 9.5 13.77 9.5 13.84H8.65C8.65 13.66 8.69 13.5 8.76 13.36C8.83 13.22 8.93 13.09 9.06 12.99C9.19 12.89 9.33 12.81 9.5 12.76C9.67 12.71 9.85 12.68 10.04 12.68C10.25 12.68 10.45 12.71 10.63 12.76C10.81 12.81 10.96 12.89 11.09 12.99C11.22 13.09 11.32 13.22 11.39 13.37C11.46 13.52 11.5 13.7 11.5 13.9C11.5 13.99 11.49 14.08 11.46 14.17C11.43 14.26 11.39 14.34 11.33 14.42C11.27 14.5 11.21 14.57 11.13 14.64C11.05 14.71 10.96 14.76 10.85 14.81C11.09 14.9 11.27 15.02 11.39 15.2C11.51 15.38 11.57 15.58 11.57 15.81C11.57 16.01 11.53 16.19 11.45 16.34C11.37 16.49 11.27 16.63 11.13 16.73C10.99 16.83 10.84 16.92 10.65 16.97C10.46 17.02 10.27 17.05 10.05 17.05C9.87 17.05 9.69 17.03 9.52 16.98C9.35 16.93 9.19 16.86 9.06 16.75C8.93 16.64 8.81 16.52 8.73 16.37C8.65 16.22 8.61 16.03 8.61 15.82H9.46C9.46 15.9 9.48 15.97 9.51 16.04C9.54 16.11 9.58 16.16 9.64 16.21C9.7 16.26 9.76 16.3 9.84 16.32C9.92 16.34 10 16.36 10.09 16.36C10.19 16.36 10.28 16.35 10.36 16.32C10.44 16.29 10.51 16.25 10.56 16.2C10.61 16.15 10.66 16.09 10.69 16.02C10.72 15.95 10.73 15.87 10.73 15.78C10.73 15.67 10.71 15.57 10.68 15.49C10.65 15.41 10.6 15.34 10.54 15.29C10.48 15.24 10.41 15.2 10.32 15.18C10.23 15.16 10.14 15.14 10.03 15.14H9.56V14.49ZM15.3 15.24C15.3 15.56 15.27 15.84 15.2 16.06C15.13 16.28 15.03 16.48 14.91 16.63C14.79 16.78 14.63 16.89 14.46 16.96C14.29 17.03 14.09 17.06 13.87 17.06C13.65 17.06 13.46 17.03 13.28 16.96C13.1 16.89 12.95 16.78 12.82 16.63C12.69 16.48 12.59 16.29 12.52 16.06C12.45 15.83 12.41 15.56 12.41 15.24V14.5C12.41 14.18 12.44 13.9 12.51 13.68C12.58 13.46 12.68 13.26 12.8 13.11C12.92 12.96 13.08 12.85 13.25 12.78C13.42 12.71 13.62 12.68 13.84 12.68C14.06 12.68 14.25 12.71 14.43 12.78C14.61 12.85 14.76 12.96 14.89 13.11C15.02 13.26 15.12 13.45 15.19 13.68C15.26 13.91 15.3 14.18 15.3 14.5V15.24ZM14.45 14.38C14.45 14.19 14.44 14.03 14.41 13.9C14.38 13.77 14.34 13.67 14.29 13.59C14.24 13.51 14.18 13.45 14.1 13.42C14.02 13.39 13.94 13.37 13.85 13.37C13.76 13.37 13.67 13.39 13.6 13.42C13.53 13.45 13.46 13.51 13.41 13.59C13.36 13.67 13.32 13.77 13.29 13.9C13.26 14.03 13.25 14.19 13.25 14.38V15.35C13.25 15.54 13.26 15.7 13.29 15.83C13.32 15.96 13.36 16.07 13.41 16.15C13.46 16.23 13.52 16.29 13.6 16.32C13.68 16.35 13.76 16.37 13.85 16.37C13.94 16.37 14.03 16.35 14.1 16.32C14.17 16.29 14.24 16.23 14.29 16.15C14.34 16.07 14.38 15.96 14.4 15.83C14.43 15.7 14.44 15.54 14.44 15.35V14.38H14.45Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReplay5(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="replay_5">
        <path
          id="Vector"
          d="M12 6V2L7 7L12 12V8C15.31 8 18 10.69 18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14H4C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 9.58 16.42 6 12 6ZM10.69 14.9L10.94 12.73H13.33V13.44H11.63L11.52 14.36C11.55 14.34 11.59 14.33 11.63 14.31C11.67 14.29 11.72 14.27 11.78 14.26C11.84 14.25 11.9 14.23 11.96 14.22C12.02 14.21 12.09 14.2 12.16 14.2C12.37 14.2 12.55 14.23 12.71 14.3C12.87 14.37 13.01 14.46 13.12 14.58C13.23 14.7 13.32 14.85 13.37 15.03C13.42 15.21 13.46 15.41 13.46 15.63C13.46 15.82 13.43 16 13.37 16.17C13.31 16.34 13.22 16.49 13.1 16.62C12.98 16.75 12.83 16.86 12.65 16.93C12.47 17 12.26 17.05 12.01 17.05C11.83 17.05 11.65 17.02 11.48 16.97C11.31 16.92 11.16 16.83 11.02 16.73C10.88 16.63 10.78 16.49 10.7 16.34C10.62 16.19 10.57 16.01 10.57 15.81H11.41C11.43 15.99 11.49 16.13 11.6 16.22C11.71 16.31 11.85 16.37 12.02 16.37C12.13 16.37 12.22 16.35 12.29 16.31C12.36 16.27 12.43 16.21 12.47 16.14C12.51 16.07 12.55 15.99 12.58 15.89C12.61 15.79 12.61 15.69 12.61 15.58C12.61 15.47 12.6 15.37 12.57 15.27C12.54 15.17 12.5 15.1 12.44 15.03C12.38 14.96 12.31 14.91 12.23 14.88C12.15 14.85 12.04 14.83 11.93 14.83C11.85 14.83 11.78 14.84 11.73 14.85C11.68 14.86 11.62 14.88 11.58 14.9C11.54 14.92 11.5 14.95 11.46 14.97C11.42 14.99 11.39 15.03 11.36 15.06L10.69 14.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReplayCircleFilled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="replay_circle_filled">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 18.5C8.69 18.5 6 15.81 6 12.5H8C8 14.71 9.79 16.5 12 16.5C14.21 16.5 16 14.71 16 12.5C16 10.26 14.15 8.41 11.84 8.51L13.41 10.08L12 11.5L8 7.5L12 3.5L13.41 4.91L11.81 6.51C15.28 6.4 18 9.18 18 12.5C18 15.81 15.31 18.5 12 18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReply(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="reply">
        <path
          id="Vector"
          d="M10 8.5V4.5L3 11.5L10 18.5V14.4C15 14.4 18.5 16 21 19.5C20 14.5 17 9.5 10 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReplyAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="reply_all">
        <path
          id="Vector"
          d="M7 7.5V4.5L0 11.5L7 18.5V15.5L3 11.5L7 7.5ZM13 8.5V4.5L6 11.5L13 18.5V14.4C18 14.4 21.5 16 24 19.5C23 14.5 20 9.5 13 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReport(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="report">
        <g id="Vector">
          <path
            d="M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9Z"
            fill="currentColor"
          />
          <path
            d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
            fill="currentColor"
          />
          <path d="M11 7H13V14H11V7Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconReportOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="report_off">
        <g id="Vector">
          <path
            d="M9.39004 4.71004H15.19L19.29 8.81004V14.61L19.07 14.83L20.49 16.24L21.29 15.44V7.98004L16.02 2.71004H8.56004L7.76004 3.51004L9.17004 4.93004L9.39004 4.71004Z"
            fill="currentColor"
          />
          <path
            d="M12.29 16.71C12.8423 16.71 13.29 16.2623 13.29 15.71C13.29 15.1578 12.8423 14.71 12.29 14.71C11.7378 14.71 11.29 15.1578 11.29 15.71C11.29 16.2623 11.7378 16.71 12.29 16.71Z"
            fill="currentColor"
          />
          <path
            d="M13.29 9.04004V6.71004H11.29V7.04004L13.29 9.04004ZM2.70004 1.29004L1.29004 2.70004L4.93004 6.34004L3.29004 7.98004V15.44L8.56004 20.71H16.02L17.66 19.07L21.3 22.71L22.71 21.3L2.70004 1.29004ZM15.19 18.71H9.39004L5.29004 14.61V8.81004L6.34004 7.76004L16.24 17.66L15.19 18.71Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconReportProblem(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="report_problem">
        <path
          id="Vector"
          d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRequestPage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="request_page">
        <path
          id="Vector"
          d="M13.17 4L18 8.83V20H6V4H13.17ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15 11H11V12H14C14.55 12 15 12.45 15 13V16C15 16.55 14.55 17 14 17H13V18H11V17H9V15H13V14H10C9.45 14 9 13.55 9 13V10C9 9.45 9.45 9 10 9H11V8H13V9H15V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRequestQuote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="request_quote">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V8H18V20H6ZM11 19H13V18H14C14.55 18 15 17.55 15 17V14C15 13.45 14.55 13 14 13H11V12H15V10H13V9H11V10H10C9.45 10 9 10.45 9 11V14C9 14.55 9.45 15 10 15H13V16H9V18H11V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconResetTv(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="reset_tv">
        <path
          id="Vector"
          d="M22 8V5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H8V21H16V19H20C21.1 19 21.99 18.1 21.99 17V12H22C22 10.9 21.1 10 20 10H12.83L14.66 8.17L13.25 6.76C9.69 10.31 10.88 9.12 9 11C11.06 13.06 9.9 11.9 13.24 15.24L14.65 13.83L12.83 12H20V17H4V5H20V8H22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRestartAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="restart_alt">
        <path
          id="Vector"
          d="M6 13.285C6 11.635 6.67 10.135 7.76 9.04497L6.34 7.62497C4.9 9.07497 4 11.075 4 13.285C4 17.365 7.05 20.725 11 21.215V19.195C8.17 18.715 6 16.255 6 13.285ZM20 13.285C20 8.86497 16.42 5.28497 12 5.28497C11.94 5.28497 11.88 5.29497 11.82 5.29497L12.91 4.20497L11.5 2.78497L8 6.28497L11.5 9.78497L12.91 8.37497L11.83 7.29497C11.89 7.29497 11.95 7.28497 12 7.28497C15.31 7.28497 18 9.97497 18 13.285C18 16.255 15.83 18.715 13 19.195V21.215C16.95 20.725 20 17.365 20 13.285Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRestaurant(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="restaurant">
        <path
          id="Vector"
          d="M16 6V14H19V22H21V2C18.24 2 16 4.24 16 6ZM11 9H9V2H7V9H5V2H3V9C3 11.21 4.79 13 7 13V22H9V13C11.21 13 13 11.21 13 9V2H11V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRestaurantMenu(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="restaurant_menu">
        <path
          id="Vector"
          d="M7.79945 13.1283L10.6295 10.2983L3.60945 3.28835C2.04945 4.84835 2.04945 7.37835 3.60945 8.94835L7.79945 13.1283ZM14.5795 11.3183C16.1095 12.0283 18.2595 11.5283 19.8495 9.93835C21.7595 8.02835 22.1295 5.28835 20.6595 3.81835C19.1995 2.35835 16.4595 2.71835 14.5395 4.62835C12.9495 6.21835 12.4495 8.36835 13.1595 9.89835L3.39945 19.6583L4.80945 21.0683L11.6995 14.1983L18.5795 21.0784L19.9895 19.6683L13.1095 12.7883L14.5795 11.3183Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRestore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="restore">
        <path
          id="Vector"
          d="M13.5 3C8.53 3 4.5 7.03 4.5 12H1.5L5.5 15.99L9.5 12H6.5C6.5 8.13 9.63 5 13.5 5C17.37 5 20.5 8.13 20.5 12C20.5 15.87 17.37 19 13.5 19C11.57 19 9.82 18.21 8.56 16.94L7.14 18.36C8.77 19.99 11.01 21 13.5 21C18.47 21 22.5 16.97 22.5 12C22.5 7.03 18.47 3 13.5 3ZM12.5 8V13L16.75 15.52L17.52 14.24L14 12.15V8H12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRestoreFromTrash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="restore_from_trash">
        <path
          id="Vector"
          d="M15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 14V9H16V19H8V14ZM10 18H14V14H16L12 10L8 14H10V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRestorePage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="restore_page">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13.17L18 8.83V20ZM8.45 10.57L7.28 9.4V13H10.88L9.44 11.56C9.96 10.55 11.02 9.85 12.23 9.85C13.97 9.85 15.38 11.26 15.38 13C15.38 14.74 13.97 16.15 12.23 16.15C11.16 16.15 10.21 15.61 9.65 14.8H8.1C8.79 16.38 10.38 17.5 12.22 17.5C14.7 17.5 16.72 15.48 16.72 13C16.72 10.52 14.7 8.5 12.22 8.5C10.63 8.5 9.25 9.33 8.45 10.57Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconReviews(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="reviews">
        <g id="Vector">
          <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
            fill="currentColor"
          />
          <path
            d="M12 15L13.57 11.57L17 10L13.57 8.43L12 5L10.43 8.43L7 10L10.43 11.57L12 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRiceBowl(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rice_bowl">
        <path
          id="Vector"
          d="M19.66 14C19 15.92 17.42 17.54 15.26 18.39L14 18.88V20H10V18.88L8.73 18.38C6.57 17.53 4.99 15.91 4.33 13.99H19.66M12 2C6.48 2 2 6.48 2 12C2 15.69 4.47 18.86 8 20.25V22H16V20.25C19.53 18.86 22 15.69 22 12C22 6.48 17.52 2 12 2ZM10 12V4.26C10.64 4.1 11.31 4 12 4C12.69 4 13.36 4.1 14 4.26V12H10ZM16 12V5.08C18.39 6.47 20 9.04 20 12H16ZM4 12C4 9.05 5.61 6.47 8 5.08V12H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRingVolume(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ring_volume">
        <path
          id="Vector"
          d="M23.71 17.2399C20.66 14.3499 16.54 12.5699 12 12.5699C7.46 12.5699 3.34 14.3499 0.29 17.2399C0.11 17.4199 0 17.6699 0 17.9499C0 18.2299 0.11 18.4799 0.29 18.6599L2.77 21.1399C2.95 21.3199 3.2 21.4299 3.48 21.4299C3.75 21.4299 4 21.3199 4.18 21.1499C4.97 20.4099 5.87 19.7899 6.84 19.2999C7.17 19.1399 7.4 18.7999 7.4 18.3999V15.2999C8.85 14.8199 10.4 14.5699 12 14.5699C13.6 14.5699 15.15 14.8199 16.6 15.2899V18.3899C16.6 18.7799 16.83 19.1299 17.16 19.2899C18.14 19.7799 19.03 20.4099 19.82 21.1399C20 21.3199 20.25 21.4199 20.52 21.4199C20.8 21.4199 21.05 21.3099 21.23 21.1299L23.71 18.6499C23.89 18.4699 24 18.2199 24 17.9399C24 17.6699 23.89 17.4199 23.71 17.2399ZM5.4 17.7999C4.74 18.1699 4.11 18.5999 3.53 19.0699L2.46 17.9999C3.37 17.2499 4.36 16.6099 5.41 16.0999V17.7999H5.4ZM20.47 19.0599C19.88 18.5799 19.26 18.1599 18.6 17.7899V16.0899C19.64 16.5999 20.63 17.2399 21.54 17.9899L20.47 19.0599ZM21.16 6.82995L19.75 5.41995L16.19 8.96995L17.6 10.3799C17.6 10.3799 21.05 6.85995 21.16 6.82995ZM11 2.56995H13V7.56995H11V2.56995ZM6.4 10.3799L7.81 8.96995L4.26 5.40995L2.84 6.82995C2.95 6.85995 6.4 10.3799 6.4 10.3799Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRocket(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rocket">
        <path
          id="Vector"
          d="M14 11C14 9.9 13.1 9 12 9C10.9 9 10 9.9 10 11C10 12.1 10.9 13 12 13C13.1 13 14 12.1 14 11ZM7.98 18.25C7.69 17.35 7.41 16.31 7.22 15.25L6 16.07V19.05L7.98 18.25ZM12 2C12 2 17 4 17 13L19.11 14.41C19.67 14.78 20 15.41 20 16.07V22L15 20H9L4 22V16.07C4 15.4 4.33 14.78 4.89 14.41L7 13C7 4 12 2 12 2ZM12 4.36C12 4.36 9 6.38 9 13C9 15.25 10 18 10 18H14C14 18 15 15.25 15 13C15 6.38 12 4.36 12 4.36ZM18 19.05V16.07L16.78 15.26C16.59 16.31 16.31 17.36 16.02 18.26L18 19.05Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRocketLaunch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rocket_launch">
        <path
          id="Vector"
          d="M6.00037 14.9996C5.17037 14.9996 4.42037 15.3396 3.88037 15.8796C2.70037 17.0596 2.00037 21.9996 2.00037 21.9996C2.00037 21.9996 6.94037 21.2996 8.12037 20.1196C8.66037 19.5796 9.00037 18.8296 9.00037 17.9996C9.00037 16.3396 7.66037 14.9996 6.00037 14.9996ZM6.71037 18.7096C6.43037 18.9896 4.54037 19.4696 4.54037 19.4696C4.54037 19.4696 5.01037 17.5896 5.30037 17.2996C5.47037 17.1096 5.72037 16.9996 6.00037 16.9996C6.55037 16.9996 7.00037 17.4496 7.00037 17.9996C7.00037 18.2796 6.89037 18.5296 6.71037 18.7096ZM17.4204 13.6496C23.7804 7.28957 21.6604 2.33957 21.6604 2.33957C21.6604 2.33957 16.7104 0.219566 10.3504 6.57957L7.86037 6.07957C7.21037 5.94957 6.53037 6.15957 6.05037 6.62957L2.00037 10.6896L7.00037 12.8296L11.1704 16.9996L13.3104 21.9996L17.3604 17.9496C17.8304 17.4796 18.0404 16.7996 17.9104 16.1396L17.4204 13.6496ZM7.41037 10.8296L5.50037 10.0096L7.47037 8.03957L8.91037 8.32957C8.34037 9.15957 7.83037 10.0296 7.41037 10.8296ZM13.9904 18.4996L13.1704 16.5896C13.9704 16.1696 14.8404 15.6596 15.6604 15.0896L15.9504 16.5296L13.9904 18.4996ZM16.0004 12.2396C14.6804 13.5596 12.6204 14.6396 11.9604 14.9696L9.03037 12.0396C9.35037 11.3896 10.4304 9.32957 11.7604 7.99957C16.4404 3.31957 19.9904 4.00957 19.9904 4.00957C19.9904 4.00957 20.6804 7.55957 16.0004 12.2396ZM15.0004 10.9996C16.1004 10.9996 17.0004 10.0996 17.0004 8.99957C17.0004 7.89957 16.1004 6.99957 15.0004 6.99957C13.9004 6.99957 13.0004 7.89957 13.0004 8.99957C13.0004 10.0996 13.9004 10.9996 15.0004 10.9996Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRollerShades(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roller_shades">
        <path
          id="Vector"
          d="M20 19V3H4V19H2V21H22V19H20ZM18 5V11H6V5H18ZM6 19V13H11V14.82C10.55 15.14 10.25 15.66 10.25 16.25C10.25 17.22 11.03 18 12 18C12.97 18 13.75 17.22 13.75 16.25C13.75 15.66 13.45 15.13 13 14.82V13H18V19H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRollerShadesClosed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roller_shades_closed">
        <path
          id="Vector"
          d="M20 18.125V2.125H4V18.125H2V20.125H10.25C10.25 21.095 11.03 21.875 12 21.875C12.97 21.875 13.75 21.095 13.75 20.125H22V18.125H20ZM18 4.125V14.125H6V4.125H18ZM6 18.125V16.125H11V18.125H6ZM13 18.125V16.125H18V18.125H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRollerSkating(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roller_skating">
        <path
          id="Vector"
          d="M20 12C20 10.21 18.81 8.66 17.09 8.18L14.47 7.44C13.62 7.19 13 6.39 13 5.5V1H4V16H20V12ZM18 14H6V3H11V4H9.5C9.22 4 9 4.22 9 4.5C9 4.78 9.22 5 9.5 5H11L11.1 6H9.5C9.22 6 9 6.22 9 6.5C9 6.78 9.22 7 9.5 7H11.31C11.76 8.12 12.71 9.01 13.91 9.36L16.53 10.09C17.4 10.33 18 11.1 18 12V14ZM5 17C3.34 17 2 18.34 2 20C2 21.66 3.34 23 5 23C6.66 23 8 21.66 8 20C8 18.34 6.66 17 5 17ZM5 21C4.45 21 4 20.55 4 20C4 19.45 4.45 19 5 19C5.55 19 6 19.45 6 20C6 20.55 5.55 21 5 21ZM19 17C17.34 17 16 18.34 16 20C16 21.66 17.34 23 19 23C20.66 23 22 21.66 22 20C22 18.34 20.66 17 19 17ZM19 21C18.45 21 18 20.55 18 20C18 19.45 18.45 19 19 19C19.55 19 20 19.45 20 20C20 20.55 19.55 21 19 21ZM12 17C10.34 17 9 18.34 9 20C9 21.66 10.34 23 12 23C13.66 23 15 21.66 15 20C15 18.34 13.66 17 12 17ZM12 21C11.45 21 11 20.55 11 20C11 19.45 11.45 19 12 19C12.55 19 13 19.45 13 20C13 20.55 12.55 21 12 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoofing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roofing">
        <path
          id="Vector"
          d="M13 18.5H11V16.5H13V18.5ZM15 14.5H9V20.5H15V14.5ZM19 9.8V4.5H16V7.1L12 3.5L2 12.5H5L12 6.19L19 12.5H22L19 9.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="room">
        <g id="Vector">
          <path
            d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z"
            fill="currentColor"
          />
          <path
            d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRoomPreferences(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="room_preferences">
        <path
          id="Vector"
          d="M20.775 15.87L21.915 14.87L20.915 13.14L19.465 13.63C19.145 13.36 18.785 13.15 18.385 13L18.085 11.5H16.085L15.785 12.99C15.385 13.14 15.025 13.35 14.705 13.62L13.255 13.13L12.255 14.86L13.395 15.86C13.315 16.36 13.315 16.62 13.395 17.12L12.255 18.12L13.255 19.85L14.705 19.36C15.025 19.63 15.385 19.84 15.785 19.99L16.085 21.5H18.085L18.385 20.01C18.785 19.86 19.145 19.65 19.465 19.38L20.915 19.87L21.915 18.14L20.775 17.14C20.855 16.63 20.855 16.37 20.775 15.87ZM17.085 18.5C15.985 18.5 15.085 17.6 15.085 16.5C15.085 15.4 15.985 14.5 17.085 14.5C18.185 14.5 19.085 15.4 19.085 16.5C19.085 17.6 18.185 18.5 17.085 18.5ZM18.085 3.5V9.5H16.085V5.5H14.085V11.5H12.085V4.5H6.08496V18.5H11.085V20.5H2.08496V18.5H4.08496V2.5H14.085V3.5H18.085ZM11.085 12.5H9.08496V10.5H11.085V12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoomService(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="room_service">
        <path
          id="Vector"
          d="M2 17V19H22V17H2ZM21 16C20.73 11.93 17.75 8.6 13.84 7.79C13.94 7.55 14 7.28 14 7C14 5.9 13.1 5 12 5C10.9 5 10 5.9 10 7C10 7.28 10.06 7.55 10.16 7.79C6.25 8.6 3.27 11.93 3 16H21ZM12 9.58C14.95 9.58 17.47 11.41 18.5 13.99H5.5C6.53 11.41 9.05 9.58 12 9.58Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRotate90DegreesCcw(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rotate_90_degrees_ccw">
        <path
          id="Vector"
          d="M7.90993 7.03L1.42993 13.52L7.91993 20L14.4099 13.52L7.90993 7.03ZM4.25993 13.52L7.91993 9.86L11.5699 13.52L7.90993 17.18L4.25993 13.52ZM19.9299 7.26C18.1799 5.5 15.8699 4.62 13.5699 4.62V1.38L9.32993 5.62L13.5699 9.86V6.62C15.3599 6.62 17.1499 7.3 18.5199 8.67C21.2499 11.4 21.2499 15.84 18.5199 18.57C17.1499 19.94 15.3599 20.62 13.5699 20.62C12.5999 20.62 11.6299 20.41 10.7299 20.01L9.23993 21.5C10.5899 22.24 12.0799 22.62 13.5699 22.62C15.8699 22.62 18.1799 21.74 19.9299 19.98C23.4499 16.47 23.4499 10.77 19.9299 7.26Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRotate90DegreesCw(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rotate_90_degrees_cw">
        <path
          id="Vector"
          d="M1.5 13.5C1.5 18.47 5.53 22.5 10.5 22.5C12.26 22.5 13.9 21.99 15.29 21.12L13.83 19.66C12.84 20.19 11.7 20.5 10.5 20.5C6.64 20.5 3.5 17.36 3.5 13.5C3.5 9.64 6.64 6.5 10.5 6.5H10.67L9.09 8.09L10.5 9.5L14.5 5.5L10.5 1.5L9.08 2.91L10.67 4.5H10.5C5.53 4.5 1.5 8.53 1.5 13.5ZM10.5 13.5L16.5 19.5L22.5 13.5L16.5 7.5L10.5 13.5ZM16.5 16.67L13.33 13.5L16.5 10.33L19.67 13.5L16.5 16.67Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRotateLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rotate_left">
        <path
          id="Vector"
          d="M7.07491 10.065L5.66491 8.64503C4.76491 9.80503 4.20491 11.145 4.03491 12.535H6.05491C6.19491 11.665 6.54491 10.815 7.07491 10.065ZM6.05491 14.535H4.03491C4.20491 15.925 4.75491 17.265 5.65491 18.425L7.06491 17.005C6.54491 16.255 6.19491 15.415 6.05491 14.535ZM7.06491 19.855C8.22491 20.755 9.57491 21.295 10.9649 21.465V19.435C10.0949 19.285 9.25491 18.945 8.50491 18.405L7.06491 19.855ZM12.9649 5.60503V2.53503L8.41491 7.08503L12.9649 11.535V7.62503C15.8049 8.10503 17.9649 10.565 17.9649 13.535C17.9649 16.505 15.8049 18.965 12.9649 19.445V21.465C16.9149 20.975 19.9649 17.615 19.9649 13.535C19.9649 9.45503 16.9149 6.09503 12.9649 5.60503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRotateRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rotate_right">
        <path
          id="Vector"
          d="M15.5849 7.08503L11.0349 2.53503V5.60503C7.09491 6.09503 4.03491 9.45503 4.03491 13.535C4.03491 17.615 7.08491 20.975 11.0349 21.465V19.445C8.19491 18.965 6.03491 16.505 6.03491 13.535C6.03491 10.565 8.19491 8.10503 11.0349 7.62503V11.535L15.5849 7.08503ZM19.9649 12.535C19.7949 11.145 19.2449 9.80503 18.3449 8.64503L16.9249 10.065C17.4649 10.815 17.8049 11.665 17.9449 12.535H19.9649ZM13.0349 19.435V21.455C14.4249 21.285 15.7749 20.745 16.9349 19.845L15.4949 18.405C14.7449 18.945 13.9049 19.295 13.0349 19.435ZM16.9249 17.015L18.3449 18.425C19.2449 17.265 19.7949 15.925 19.9649 14.535H17.9449C17.8049 15.405 17.4649 16.255 16.9249 17.015Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoundaboutLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roundabout_left">
        <path
          id="Vector"
          d="M10.08 8C10.56 5.16 13.02 3 16 3C19.31 3 22 5.69 22 9C22 11.97 19.84 14.44 17 14.92V21H15V14.91C15 13.93 15.71 13.11 16.67 12.94C18.56 12.63 20 10.98 20 9C20 6.79 18.21 5 16 5C14.02 5 12.37 6.44 12.06 8.33C11.89 9.29 11.07 10 10.09 10H5.83L7.42 11.59L6 13L2 9L6 5L7.41 6.41L5.83 8H10.08Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoundaboutRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="roundabout_right">
        <path
          id="Vector"
          d="M13.92 8C13.44 5.16 10.97 3 8 3C4.69 3 2 5.69 2 9C2 11.97 4.16 14.44 7 14.92V21H9V14.91C9 13.93 8.29 13.11 7.33 12.94C5.44 12.63 4 10.98 4 9C4 6.79 5.79 5 8 5C9.98 5 11.63 6.44 11.94 8.33C12.11 9.29 12.93 10 13.91 10H18.17L16.58 11.59L18 13L22 9L18 5L16.59 6.41L18.17 8H13.92Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoundedCorner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rounded_corner">
        <path
          id="Vector"
          d="M19 19H21V21H19V19ZM19 17H21V15H19V17ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM7 5H9V3H7V5ZM15 21H17V19H15V21ZM11 21H13V19H11V21ZM15 21H17V19H15V21ZM7 21H9V19H7V21ZM3 21H5V19H3V21ZM21 8C21 5.24 18.76 3 16 3H11V5H16C17.65 5 19 6.35 19 8V13H21V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRoute(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="route">
        <path
          id="Vector"
          d="M19 15.18V7C19 4.79 17.21 3 15 3C12.79 3 11 4.79 11 7V17C11 18.1 10.1 19 9 19C7.9 19 7 18.1 7 17V8.82C8.16 8.4 9 7.3 9 6C9 4.34 7.66 3 6 3C4.34 3 3 4.34 3 6C3 7.3 3.84 8.4 5 8.82V17C5 19.21 6.79 21 9 21C11.21 21 13 19.21 13 17V7C13 5.9 13.9 5 15 5C16.1 5 17 5.9 17 7V15.18C15.84 15.59 15 16.69 15 18C15 19.66 16.34 21 18 21C19.66 21 21 19.66 21 18C21 16.7 20.16 15.6 19 15.18ZM6 7C5.45 7 5 6.55 5 6C5 5.45 5.45 5 6 5C6.55 5 7 5.45 7 6C7 6.55 6.55 7 6 7ZM18 19C17.45 19 17 18.55 17 18C17 17.45 17.45 17 18 17C18.55 17 19 17.45 19 18C19 18.55 18.55 19 18 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRouter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="router">
        <path
          id="Vector"
          d="M16 4.2C17.5 4.2 19 4.8 20.2 5.9L21 5.1C19.6 3.7 17.8 3 16 3C14.2 3 12.4 3.7 11 5.1L11.8 5.9C13 4.8 14.5 4.2 16 4.2ZM12.7 6.7L13.5 7.5C14.2 6.8 15.1 6.5 16 6.5C16.9 6.5 17.8 6.8 18.5 7.5L19.3 6.7C18.4 5.8 17.2 5.3 16 5.3C14.8 5.3 13.6 5.8 12.7 6.7ZM19 13H17V9H15V13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13ZM19 19H5V15H19V19ZM6 16H8V18H6V16ZM9.5 16H11.5V18H9.5V16ZM13 16H15V18H13V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRowing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rowing">
        <path
          id="Vector"
          d="M8 14L3.5 18.5L5 20L8.5 16.5H10.5L8 14ZM14.5 0.5C13.4 0.5 12.5 1.4 12.5 2.5C12.5 3.6 13.4 4.5 14.5 4.5C15.6 4.5 16.5 3.6 16.5 2.5C16.5 1.4 15.6 0.5 14.5 0.5ZM20.5 20.51L17.5 23.5L14.51 20.49V19L7.41 11.91C7.1 11.96 6.8 11.98 6.5 11.98V9.82C8.16 9.85 10.11 8.95 11.17 7.78L12.57 6.23C12.76 6.02 13 5.85 13.26 5.73C13.55 5.59 13.88 5.5 14.22 5.5H14.25C15.49 5.51 16.5 6.52 16.5 7.76V13.51C16.5 14.35 16.15 15.12 15.58 15.67L12 12.09V9.82C11.37 10.34 10.57 10.84 9.71 11.21L16 17.5H17.5L20.5 20.51Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRssFeed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rss_feed">
        <g id="Vector">
          <path
            d="M6.39997 19.78C7.60395 19.78 8.57997 18.804 8.57997 17.6C8.57997 16.396 7.60395 15.42 6.39997 15.42C5.19599 15.42 4.21997 16.396 4.21997 17.6C4.21997 18.804 5.19599 19.78 6.39997 19.78Z"
            fill="currentColor"
          />
          <path
            d="M4.21997 4.21997V7.04997C11.25 7.04997 16.95 12.75 16.95 19.78H19.78C19.78 11.19 12.81 4.21997 4.21997 4.21997ZM4.21997 9.87997V12.71C8.11997 12.71 11.29 15.88 11.29 19.78H14.12C14.12 14.31 9.68997 9.87997 4.21997 9.87997Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRsvp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rsvp">
        <path
          id="Vector"
          d="M16 9H17.5L15.75 15H14.25L12.5 9H14L15 12.43L16 9ZM5.1 12.9L6 15H4.5L3.65 13H2.5V15H1V9H4.5C5.35 9 6 9.65 6 10.5V11.5C6 12.1 5.6 12.65 5.1 12.9ZM4.5 10.5H2.5V11.5H4.5V10.5ZM21.5 13H19.5V15H18V9H21.5C22.33 9 23 9.67 23 10.5V11.5C23 12.33 22.33 13 21.5 13ZM21.5 10.5H19.5V11.5H21.5V10.5ZM11.5 9V10.5H8.5V11.25H10.5C11.05 11.25 11.5 11.7 11.5 12.25V14C11.5 14.55 11.05 15 10.5 15H7V13.5H10V12.75H7.75C7.34 12.75 7 12.41 7 12V10C7 9.45 7.45 9 8 9H11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRtt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rtt">
        <path
          id="Vector"
          d="M9.03 3L7.92 10.07H10.54L11.24 5.57H13.82L11.8 18.43H9.47L9.06 21H16.33L16.73 18.43H14.38L16.38 5.57H18.96L18.25 10.07H20.9L22 3H9.03ZM8 5H4L3.69 7H7.69L8 5ZM7.39 9H3.39L3.08 11H7.08L7.39 9ZM8.31 17H2.31L2 19H8L8.31 17ZM8.93 13H2.93L2.62 15H8.63L8.93 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRule(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rule">
        <path
          id="Vector"
          d="M16.45 11.035L12.91 7.49497L14.32 6.08497L16.44 8.20497L20.68 3.96497L22.09 5.37497L16.45 11.035ZM10.91 7.03497H1.91003V9.03497H10.91V7.03497ZM20.91 13.445L19.5 12.035L16.91 14.625L14.32 12.035L12.91 13.445L15.5 16.035L12.91 18.625L14.32 20.035L16.91 17.445L19.5 20.035L20.91 18.625L18.32 16.035L20.91 13.445ZM10.91 15.035H1.91003V17.035H10.91V15.035Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRuleFolder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rule_folder">
        <path
          id="Vector"
          d="M7.83 16L5 13.17L6.41 11.76L7.82 13.17L11.36 9.63L12.77 11.04L7.83 16ZM17.41 13L19 14.59L17.59 16L16 14.41L14.41 16L13 14.59L14.59 13L13 11.41L14.41 10L16 11.59L17.59 10L19 11.41L17.41 13ZM20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRunCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="run_circle">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
          <path
            d="M13.54 8.97C13.31 8.5 12.78 8.26 12.28 8.44L9 9.65V12H10V10.35L11.54 9.78L10.58 14.67L7.8 14.1L7.6 15.08L11.36 15.85L11.88 13.21L13 14.42V18H14V14.03L12.68 12.59L13.09 10.24C13.99 11.46 15.3 12 16 12V11C15.59 11 14.37 10.67 13.54 8.97Z"
            fill="currentColor"
          />
          <path
            d="M13.5 8C14.0523 8 14.5 7.55228 14.5 7C14.5 6.44772 14.0523 6 13.5 6C12.9477 6 12.5 6.44772 12.5 7C12.5 7.55228 12.9477 8 13.5 8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconRunningWithErrors(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="running_with_errors">
        <path
          id="Vector"
          d="M22 10V18H20V10H22ZM20 20V22H22V20H20ZM18 17.29C16.53 18.95 14.39 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4V13L19.55 5.45C17.72 3.34 15.02 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C14.25 22 16.33 21.26 18 20V17.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconRvHookup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="rv_hookup">
        <path
          id="Vector"
          d="M19 17V11C19 9.9 18.1 9 17 9H6V7L3 10L6 13V11H10V14H3V17C3 18.1 3.9 19 5 19H7C7 20.66 8.34 22 10 22C11.66 22 13 20.66 13 19H21V17H19ZM10 20C9.45 20 9 19.55 9 19C9 18.45 9.45 18 10 18C10.55 18 11 18.45 11 19C11 19.55 10.55 20 10 20ZM17 14H13V11H17V14ZM16 2V4H8V6H16V8L19 5L16 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSafetyCheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="safety_check">
        <path
          id="Vector"
          d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM13.65 14.35L11.5 12.2V9H12.5V11.79L14.35 13.64L13.65 14.35Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSafetyDivider(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="safety_divider">
        <path
          id="Vector"
          d="M11 5H13V19H11V5ZM5 12C6.1 12 7 11.1 7 10C7 8.9 6.1 8 5 8C3.9 8 3 8.9 3 10C3 11.1 3.9 12 5 12ZM7.78 13.58C6.93 13.21 5.99 13 5 13C4.01 13 3.07 13.21 2.22 13.58C1.48 13.9 1 14.62 1 15.43V16H9V15.43C9 14.62 8.52 13.9 7.78 13.58ZM19 12C20.1 12 21 11.1 21 10C21 8.9 20.1 8 19 8C17.9 8 17 8.9 17 10C17 11.1 17.9 12 19 12ZM21.78 13.58C20.93 13.21 19.99 13 19 13C18.01 13 17.07 13.21 16.22 13.58C15.48 13.9 15 14.62 15 15.43V16H23V15.43C23 14.62 22.52 13.9 21.78 13.58Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSailing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sailing">
        <path
          id="Vector"
          d="M11 13.5V2L3 13.5H11ZM9 11.5H6.83L9 8.38V11.5ZM21 13.5C21 6.5 14.5 1 12.5 1C12.5 1 13.5 4 13.5 7.5C13.5 11 12.5 13.5 12.5 13.5H21ZM15.38 5.24C16.8 6.76 18.26 8.96 18.79 11.5H15.11C15.32 10.4 15.5 9.04 15.5 7.5C15.5 6.71 15.45 5.95 15.38 5.24ZM22 15H2C2.31 16.53 3.16 17.84 4.33 18.73C4.98 18.46 5.55 18.01 6 17.5C6.73 18.34 7.8 19 9 19C10.2 19 11.27 18.34 12 17.5C12.73 18.34 13.8 19 15 19C16.2 19 17.26 18.34 18 17.5C18.45 18.01 19.02 18.46 19.67 18.73C20.84 17.84 21.69 16.53 22 15ZM22 23V21H21C19.96 21 18.92 20.65 18 20C16.17 21.3 13.83 21.3 12 20C10.17 21.3 7.83 21.3 6 20C5.09 20.65 4.04 21 3 21H2V23H3C4.03 23 5.05 22.75 6 22.25C7.89 23.25 10.11 23.25 12 22.25C13.89 23.25 16.11 23.25 18 22.25C18.95 22.75 19.97 23 21 23H22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSanitizer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sanitizer">
        <path
          id="Vector"
          d="M14.5 6.5C14.5 5.66 16 4 16 4C16 4 17.5 5.66 17.5 6.5C17.5 7.33 16.83 8 16 8C15.17 8 14.5 7.33 14.5 6.5ZM18.5 15C19.88 15 21 13.88 21 12.5C21 10.83 18.5 8 18.5 8C18.5 8 16 10.83 16 12.5C16 13.88 17.12 15 18.5 15ZM12 14H10V12H8V14H6V16H8V18H10V16H12V14ZM15 12V20C15 21.1 14.1 22 13 22H5C3.9 22 3 21.1 3 20V12C3 9.03 5.16 6.57 8 6.09V4H6V2H12C13.13 2 14.15 2.39 14.99 3.01L13.56 4.44C13.1 4.17 12.57 4 12 4H10V6.09C12.84 6.57 15 9.03 15 12ZM13 12C13 9.79 11.21 8 9 8C6.79 8 5 9.79 5 12V20H13V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSatellite(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="satellite">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM8.57 6H6V8.58C7.42 8.58 8.57 7.42 8.57 6ZM12 6H10.29C10.29 8.36 8.37 10.29 6 10.29V12C9.32 12 12 9.31 12 6ZM14.14 11.86L11.14 15.73L9 13.15L6 17H18L14.14 11.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSatelliteAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="satellite_alt" clipPath="url(#clip0_395_4214)">
        <path
          id="Vector"
          d="M21.5026 14.5013H23.5026C23.5026 19.4713 19.4726 23.5013 14.5026 23.5013V21.5013C18.3726 21.5013 21.5026 18.3713 21.5026 14.5013ZM14.5026 17.5013V19.5013C17.2626 19.5013 19.5026 17.2613 19.5026 14.5013H17.5026C17.5026 16.1613 16.1626 17.5013 14.5026 17.5013ZM18.7626 1.09128L22.3026 4.63128C23.0826 5.41128 23.0826 6.68128 22.3026 7.46128L19.1226 10.6413C18.3426 11.4213 17.0726 11.4213 16.2926 10.6413L15.0526 9.40128L14.3426 10.1013L15.5826 11.3413C16.3626 12.1213 16.3626 13.3913 15.5826 14.1713L14.1726 15.5813C13.3926 16.3613 12.1226 16.3613 11.3426 15.5813L10.1026 14.3413L9.39256 15.0513L10.6326 16.2913C11.4126 17.0713 11.4126 18.3413 10.6326 19.1213L7.45256 22.3013C6.67256 23.0813 5.40256 23.0813 4.62256 22.3013L1.08256 18.7613C0.302559 17.9813 0.302559 16.7113 1.08256 15.9313L4.26256 12.7513C5.04256 11.9713 6.31256 11.9713 7.09256 12.7513L8.33256 13.9913L9.04256 13.2813L7.80256 12.0513C7.02256 11.2713 7.02256 10.0013 7.80256 9.22128L9.22256 7.80128C10.0026 7.02128 11.2726 7.02128 12.0526 7.80128L13.2926 9.04128L14.0026 8.33128L12.7526 7.10128C11.9726 6.32128 11.9726 5.05128 12.7526 4.27128L15.9326 1.09128C16.7226 0.301279 17.9826 0.301279 18.7626 1.09128ZM3.56256 16.2913L2.50256 17.3513L6.04256 20.8913L7.10256 19.8313L3.56256 16.2913ZM5.68256 14.1713L4.62256 15.2313L8.16256 18.7713L9.22256 17.7113L5.68256 14.1713ZM10.6326 9.22128L9.22256 10.6313L12.7626 14.1713L14.1726 12.7613L10.6326 9.22128ZM15.2326 4.62128L14.1726 5.68128L17.7126 9.22128L18.7726 8.16128L15.2326 4.62128ZM17.3526 2.50128L16.2926 3.56128L19.8326 7.10128L20.8926 6.04128L17.3526 2.50128Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_4214">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconSave(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="save">
        <path
          id="Vector"
          d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSaveAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="save_alt">
        <path
          id="Vector"
          d="M19 12V19H5V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H19ZM13 12.67L15.59 10.09L17 11.5L12 16.5L7 11.5L8.41 10.09L11 12.67V3H13V12.67Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSaveAs(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="save_as">
        <path
          id="Vector"
          d="M19.8 11.4V6L15.8 2H3.80005C2.69005 2 1.80005 2.9 1.80005 4V18C1.80005 19.1 2.69005 20 3.80005 20H11.2L13.2 18H3.80005V4H14.97L17.8 6.83V13.4L19.8 11.4ZM13.8 14C13.8 15.66 12.46 17 10.8 17C9.14005 17 7.80005 15.66 7.80005 14C7.80005 12.34 9.14005 11 10.8 11C12.46 11 13.8 12.34 13.8 14ZM4.80005 5H13.8V9H4.80005V5ZM18.79 15.25L20.56 17.02L15.57 22H13.8V20.23L18.79 15.25ZM22.05 15.51L21.2 16.36L19.43 14.59L20.28 13.74C20.48 13.54 20.79 13.54 20.99 13.74L22.05 14.8C22.25 15 22.25 15.32 22.05 15.51Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSavedSearch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="saved_search">
        <g id="Vector">
          <path
            d="M14.73 13.31C15.52 12.24 16 10.93 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C10.93 16 12.24 15.52 13.31 14.73L19.59 21L21 19.59L14.73 13.31ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
            fill="currentColor"
          />
          <path
            d="M10.29 8.44L9.5 6L8.71 8.44H6.25L8.26 10.03L7.49 12.5L9.5 10.97L11.51 12.5L10.74 10.03L12.75 8.44H10.29Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSavings(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="savings">
        <path
          id="Vector"
          d="M15 10.5C15 9.95 15.45 9.5 16 9.5C16.55 9.5 17 9.95 17 10.5C17 11.05 16.55 11.5 16 11.5C15.45 11.5 15 11.05 15 10.5ZM8 9.5H13V7.5H8V9.5ZM22 8V14.97L19.18 15.91L17.5 21.5H12V19.5H10V21.5H4.5C4.5 21.5 2 13.04 2 10C2 6.96 4.46 4.5 7.5 4.5H12.5C13.41 3.29 14.86 2.5 16.5 2.5C17.33 2.5 18 3.17 18 4C18 4.21 17.96 4.4 17.88 4.58C17.74 4.92 17.62 5.31 17.56 5.73L19.83 8H22ZM20 10H19L15.5 6.5C15.5 5.85 15.59 5.21 15.76 4.59C14.79 4.84 14 5.56 13.67 6.5H7.5C5.57 6.5 4 8.07 4 10C4 11.88 5.22 16.65 6.01 19.5H8V17.5H14V19.5H16.01L17.56 14.35L20 13.53V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScale(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="scale">
        <path
          id="Vector"
          d="M14 11V8C18.56 7.42 22 4.9 22 2H2C2 4.9 5.44 7.42 10 8V11C6.32 11.73 2 14.61 2 22H8V20H4.13C5.06 13.17 10.78 12.8 12 12.8C13.22 12.8 18.94 13.17 19.87 20H16V22H22C22 14.61 17.68 11.73 14 11ZM18.87 4C17.5 5.19 15 6.12 12 6.12C9 6.12 6.5 5.19 5.13 4H18.87ZM12 22C10.9 22 10 21.1 10 20C10 19.45 10.22 18.95 10.59 18.59C11.39 17.79 16 16 16 16C16 16 14.21 20.61 13.41 21.41C13.05 21.78 12.55 22 12 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScanner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="scanner">
        <path
          id="Vector"
          d="M19.8 10.2L4.2 4.5L3.5 6.4L17.6 11.5H5C3.9 11.5 3 12.4 3 13.5V17.5C3 18.6 3.9 19.5 5 19.5H19C20.1 19.5 21 18.6 21 17.5V12C21 11.2 20.5 10.4 19.8 10.2ZM19 17.5H5V13.5H19V17.5ZM6 14.5H8V16.5H6V14.5ZM10 14.5H18V16.5H10V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScatterPlot(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="scatter_plot">
        <path
          id="Vector"
          d="M7.19995 18.2C4.98995 18.2 3.19995 16.41 3.19995 14.2C3.19995 11.99 4.98995 10.2 7.19995 10.2C9.40995 10.2 11.2 11.99 11.2 14.2C11.2 16.41 9.40995 18.2 7.19995 18.2ZM7.19995 12.2C6.09995 12.2 5.19995 13.1 5.19995 14.2C5.19995 15.3 6.09995 16.2 7.19995 16.2C8.29995 16.2 9.19995 15.3 9.19995 14.2C9.19995 13.1 8.29995 12.2 7.19995 12.2ZM11.2 10.2C8.98995 10.2 7.19995 8.40995 7.19995 6.19995C7.19995 3.98995 8.98995 2.19995 11.2 2.19995C13.41 2.19995 15.2 3.98995 15.2 6.19995C15.2 8.40995 13.41 10.2 11.2 10.2ZM11.2 4.19995C10.1 4.19995 9.19995 5.09995 9.19995 6.19995C9.19995 7.29995 10.1 8.19995 11.2 8.19995C12.3 8.19995 13.2 7.29995 13.2 6.19995C13.2 5.09995 12.3 4.19995 11.2 4.19995ZM16.8 21.8C14.59 21.8 12.8 20.01 12.8 17.8C12.8 15.59 14.59 13.8 16.8 13.8C19.01 13.8 20.8 15.59 20.8 17.8C20.8 20.01 19.01 21.8 16.8 21.8ZM16.8 15.8C15.7 15.8 14.8 16.7 14.8 17.8C14.8 18.9 15.7 19.8 16.8 19.8C17.9 19.8 18.8 18.9 18.8 17.8C18.8 16.7 17.9 15.8 16.8 15.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSchedule(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="schedule">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScheduleSend(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="schedule_send">
        <g id="Vector">
          <path
            d="M16.5 11C13.74 11 11.5 13.24 11.5 16C11.5 18.76 13.74 21 16.5 21C19.26 21 21.5 18.76 21.5 16C21.5 13.24 19.26 11 16.5 11ZM18.15 18.35L16 16.2V13H17V15.79L18.85 17.64L18.15 18.35Z"
            fill="currentColor"
          />
          <path
            d="M10.5 11L4.5 9.5V6.01L13.37 9.75C14.31 9.28 15.37 9 16.5 9C16.6 9 16.69 9.01 16.78 9.01L2.5 3V19L9.5 16.05C9.5 16.03 9.5 16.02 9.5 16C9.5 15.2 9.64 14.44 9.89 13.72L4.5 15.99V12.5L10.5 11Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSchema(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="schema">
        <path
          id="Vector"
          d="M13.5 9V11H10.5V9H8V7H10.5V1H3.5V7H6V9H3.5V15H6V17H3.5V23H10.5V17H8V15H10.5V13H13.5V15H20.5V9H13.5ZM5.5 3H8.5V5H5.5V3ZM8.5 21H5.5V19H8.5V21ZM8.5 13H5.5V11H8.5V13ZM18.5 13H15.5V11H18.5V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSchool(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="school">
        <path
          id="Vector"
          d="M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM18.82 9L12 12.72L5.18 9L12 5.28L18.82 9ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScience(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="science">
        <path
          id="Vector"
          d="M13.0002 11.33L18.0002 18H6.00018L11.0002 11.33V6H13.0002M15.9602 4H8.04018C7.62018 4 7.39018 4.48 7.65018 4.81L9.00018 6.5V10.67L3.20018 18.4C2.71018 19.06 3.18018 20 4.00018 20H20.0002C20.8202 20 21.2902 19.06 20.8002 18.4L15.0002 10.67V6.5L16.3502 4.81C16.6102 4.48 16.3802 4 15.9602 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="score">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5L9 15L13 19L19 13V19ZM19 10.5L13 16.5L9 12.5L5 16.5V5H19V10.5ZM13.5 9V6H12V12H13.5V9ZM17.2 12L15.2 9L17.2 6H15.5L13.5 9L15.5 12H17.2ZM11 10.5H8.5V9.75H11V6H7V7.5H9.5V8.25H7V12H11V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScoreboard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="scoreboard">
        <path
          id="Vector"
          d="M18 10H15.5C14.95 10 14.5 10.45 14.5 11V15C14.5 15.55 14.95 16 15.5 16H18C18.55 16 19 15.55 19 15V11C19 10.45 18.55 10 18 10ZM17.5 14.5H16V11.5H17.5V14.5ZM9.5 16H5V13.5C5 12.95 5.45 12.5 6 12.5H8V11.5H5V10H8.5C9.05 10 9.5 10.45 9.5 11V12.5C9.5 13.05 9.05 13.5 8.5 13.5H6.5V14.5H9.5V16ZM12.75 12H11.25V10.5H12.75V12ZM12.75 15.5H11.25V14H12.75V15.5ZM22 7V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V7C2 5.9 2.9 5 4 5H7V3H9V5H15V3H17V5H20C21.1 5 22 5.9 22 7ZM20 19V7H12.75V8.5H11.25V7H4V19H11.25V17.5H12.75V19H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScreenLockLandscape(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_lock_landscape">
        <path
          id="Vector"
          d="M21 5H3C1.9 5 1 5.9 1 7V17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5ZM19 17H5V7H19V17ZM10 16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11V10C14 8.89 13.1 8 12 8C10.89 8 10 8.9 10 10V11C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16ZM10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10V11H10.8V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScreenLockPortrait(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_lock_portrait">
        <path
          id="Vector"
          d="M10 16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11V10C14 8.89 13.1 8 12 8C10.89 8 10 8.9 10 10V11C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16ZM10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10V11H10.8V10ZM17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScreenLockRotation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_lock_rotation" clipPath="url(#clip0_395_2848)">
        <path
          id="Vector"
          d="M22.9038 13.27L20.3338 10.7L18.9238 12.11L21.1438 14.33L15.4838 19.99L4.16381 8.67L9.82381 3.01L11.9238 5.11L13.3338 3.7L10.8838 1.25C10.2938 0.66 9.34381 0.66 8.76381 1.25L2.40381 7.61C1.81381 8.2 1.81381 9.15 2.40381 9.73L14.4238 21.75C15.0138 22.34 15.9638 22.34 16.5438 21.75L22.9038 15.39C23.4938 14.8 23.4938 13.85 22.9038 13.27ZM8.12381 20.98C4.85381 19.44 2.51381 16.26 2.15381 12.5H0.653809C1.16381 18.66 6.31381 23.5 12.6038 23.5L13.2638 23.47L9.45381 19.65L8.12381 20.98ZM15.6538 9.5H20.6538C21.2038 9.5 21.6538 9.05 21.6538 8.5V4.5C21.6538 3.95 21.2038 3.5 20.6538 3.5V3C20.6538 1.62 19.5338 0.5 18.1538 0.5C16.7738 0.5 15.6538 1.62 15.6538 3V3.5C15.1038 3.5 14.6538 3.95 14.6538 4.5V8.5C14.6538 9.05 15.1038 9.5 15.6538 9.5ZM16.4538 3C16.4538 2.06 17.2138 1.3 18.1538 1.3C19.0938 1.3 19.8538 2.06 19.8538 3V3.5H16.4538V3Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_2848">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconScreenRotation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_rotation" clipPath="url(#clip0_395_2850)">
        <path
          id="Vector"
          d="M16.48 2.52C19.75 4.07 22.09 7.24 22.4501 11H23.9501C23.4401 4.84 18.29 0 12 0L11.34 0.03L15.15 3.84L16.48 2.52ZM10.23 1.75C9.64005 1.16 8.69005 1.16 8.11005 1.75L1.75005 8.11C1.16005 8.7 1.16005 9.65 1.75005 10.23L13.77 22.25C14.36 22.84 15.31 22.84 15.89 22.25L22.25 15.89C22.84 15.3 22.84 14.35 22.25 13.77L10.23 1.75ZM14.83 21.19L2.81005 9.17L9.17005 2.81L21.1901 14.83L14.83 21.19ZM7.52005 21.48C4.25005 19.94 1.91005 16.76 1.55005 13H0.0500488C0.560049 19.16 5.71005 24 12 24L12.66 23.97L8.85005 20.16L7.52005 21.48Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_2850">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconScreenRotationAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_rotation_alt">
        <path
          id="Vector"
          d="M4 7.59L9 2.59C9.78 1.81 11.05 1.81 11.83 2.59L20.24 11H17.41L10.4 4.00001L5.41 9H8V11H2V5.00001H4V7.59ZM20 19H22V13H16V15H18.59L13.6 20L6.59 13H3.76L12.17 21.41C12.95 22.19 14.22 22.19 15 21.41L20 16.41V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScreenSearchDesktop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_search_desktop">
        <g id="Vector">
          <path
            d="M4 18H20C21.1 18 21.99 17.1 21.99 16L22 5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18ZM4 5H20V16H4V5Z"
            fill="currentColor"
          />
          <path d="M23 19H1V21H23V19Z" fill="currentColor" />
          <path
            d="M13.97 7.53C12.6 6.16 10.39 6.16 9.02 7.53C7.65 8.9 7.65 11.11 9.02 12.48C10.2 13.66 12.02 13.82 13.38 12.95L15.47 15.04L16.53 13.98L14.44 11.89C15.31 10.53 15.16 8.71 13.97 7.53ZM12.91 11.41C12.13 12.19 10.86 12.19 10.08 11.41C9.3 10.63 9.3 9.36 10.08 8.58C10.86 7.8 12.13 7.8 12.91 8.58C13.69 9.37 13.69 10.63 12.91 11.41Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconScreenShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screen_share">
        <path
          id="Vector"
          d="M20 18C21.1 18 21.99 17.1 21.99 16L22 6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V16C2 17.1 2.89 18 4 18H0V20H24V18H20ZM4 16V6H20V16.01L4 16ZM13 9.13C9.11 9.67 7.56 12.33 7 15C8.39 13.13 10.22 12.28 13 12.28V14.47L17 10.73L13 7V9.13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScreenshot(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screenshot">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM17 4H7V3H17V4ZM9.5 8.5H12V7H8V11H9.5V8.5ZM12 17H16V13H14.5V15.5H12V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconScreenshotMonitor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="screenshot_monitor">
        <g id="Vector">
          <path
            d="M20 3H4C2.89 3 2 3.89 2 5V17C2 18.1 2.89 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V5C22 3.89 21.1 3 20 3ZM20 17H4V5H20V17Z"
            fill="currentColor"
          />
          <path d="M6.5 7.5H9V6H5V10H6.5V7.5Z" fill="currentColor" />
          <path d="M19 12H17.5V14.5H15V16H19V12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconScubaDiving(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="scuba_diving">
        <path
          id="Vector"
          d="M1 12.5C1 11.4 1.9 10.5 3 10.5C4.1 10.5 5 11.4 5 12.5C5 13.6 4.1 14.5 3 14.5C1.9 14.5 1 13.6 1 12.5ZM8.89 9.61L13.42 8.4L12.64 5.5L8.11 6.71C7.31 6.92 6.83 7.75 7.05 8.55C7.27 9.35 8.09 9.83 8.89 9.61ZM20.5 5.4L23 2.5L22 1.5L19 4.5L17 8.5L7.52 11.37C6.7 11.57 6.13 12.26 6.02 13.05L5.24 17.5L2.4 21.3L4 22.5L7 18.5L8.14 15.36L14 13.5L19 10L20.5 5.4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sd">
        <g id="Vector">
          <path
            d="M7 15H10C10.55 15 11 14.55 11 14V12.5C11 11.95 10.55 11.5 10 11.5H7.5V10.5H9.5V11H11V10C11 9.45 10.55 9 10 9H7C6.45 9 6 9.45 6 10V11.5C6 12.05 6.45 12.5 7 12.5H9.5V13.5H7.5V13H6V14C6 14.55 6.45 15 7 15Z"
            fill="currentColor"
          />
          <path
            d="M18 14V10C18 9.45 17.55 9 17 9H13V15H17C17.55 15 18 14.55 18 14ZM16.5 13.5H14.5V10.5H16.5V13.5Z"
            fill="currentColor"
          />
          <path
            d="M20 4H4C2.89 4 2 4.9 2 6V18C2 19.1 2.89 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSdCard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sd_card">
        <path
          id="Vector"
          d="M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H6V8.83L10.83 4H18V20ZM9 7H11V11H9V7ZM12 7H14V11H12V7ZM15 7H17V11H15V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSdCardAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sd_card_alert">
        <path
          id="Vector"
          d="M18 2H10L4.02 8L4 20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H6V8.83L10.83 4H18V20ZM11 15H13V17H11V15ZM11 8H13V13H11V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSdStorage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sd_storage">
        <path
          id="Vector"
          d="M18 4V20H6V8.83L10.83 4H18ZM18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 7H11V11H9V7ZM12 7H14V11H12V7ZM15 7H17V11H15V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSearch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="search">
        <path
          id="Vector"
          d="M15.755 14.255H14.965L14.685 13.985C15.665 12.845 16.255 11.365 16.255 9.755C16.255 6.165 13.345 3.255 9.755 3.255C6.165 3.255 3.255 6.165 3.255 9.755C3.255 13.345 6.165 16.255 9.755 16.255C11.365 16.255 12.845 15.665 13.985 14.685L14.255 14.965V15.755L19.255 20.745L20.745 19.255L15.755 14.255ZM9.755 14.255C7.26501 14.255 5.255 12.245 5.255 9.755C5.255 7.26501 7.26501 5.255 9.755 5.255C12.245 5.255 14.255 7.26501 14.255 9.755C14.255 12.245 12.245 14.255 9.755 14.255Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSearchOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="search_off">
        <g id="Vector">
          <path
            d="M16.845 14.255H16.055L15.775 13.985C16.755 12.845 17.345 11.365 17.345 9.755C17.345 6.165 14.435 3.255 10.845 3.255C7.42504 3.255 4.62504 5.895 4.37504 9.255H6.39504C6.64504 7.005 8.52504 5.255 10.845 5.255C13.335 5.255 15.345 7.26501 15.345 9.755C15.345 12.245 13.335 14.255 10.845 14.255C10.675 14.255 10.515 14.225 10.345 14.205V16.225C10.515 16.245 10.675 16.255 10.845 16.255C12.455 16.255 13.935 15.665 15.075 14.685L15.345 14.965V15.755L20.345 20.745L21.835 19.255L16.845 14.255Z"
            fill="currentColor"
          />
          <path
            d="M7.81504 11.075L5.34504 13.545L2.87504 11.075L2.16504 11.785L4.63504 14.255L2.16504 16.725L2.87504 17.435L5.34504 14.965L7.81504 17.435L8.52504 16.725L6.05504 14.255L8.52504 11.785L7.81504 11.075Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSecurity(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="security">
        <path
          id="Vector"
          d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSecurityUpdate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="security_update">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM7 4V3H17V4H7ZM16 12L12 16L8 12L9.41 10.59L11 12.17V8H13V12.17L14.59 10.58L16 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSecurityUpdateGood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="security_update_good">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM17 4H7V3H17V4ZM16 10.05L14.59 8.64L11.05 12.18L9.64 10.77L8.23 12.18L11.05 15L16 10.05Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSecurityUpdateWarning(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="security_update_warning">
        <g id="Vector">
          <path d="M13 15H11V17H13V15Z" fill="currentColor" />
          <path d="M13 7H11V13H13V7Z" fill="currentColor" />
          <path
            d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM17 4H7V3H17V4Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSegment(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="segment">
        <path
          id="Vector"
          d="M9 18H21V16H9V18ZM3 6V8H21V6H3ZM9 13H21V11H9V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSelectAll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="select_all">
        <path
          id="Vector"
          d="M3 5H5V3C3.9 3 3 3.9 3 5ZM3 13H5V11H3V13ZM7 21H9V19H7V21ZM3 9H5V7H3V9ZM13 3H11V5H13V3ZM19 3V5H21C21 3.9 20.1 3 19 3ZM5 21V19H3C3 20.1 3.9 21 5 21ZM3 17H5V15H3V17ZM9 3H7V5H9V3ZM11 21H13V19H11V21ZM19 13H21V11H19V13ZM19 21C20.1 21 21 20.1 21 19H19V21ZM19 9H21V7H19V9ZM19 17H21V15H19V17ZM15 21H17V19H15V21ZM15 5H17V3H15V5ZM7 17H17V7H7V17ZM9 9H15V15H9V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSelfImprovement(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="self_improvement">
        <g id="Vector">
          <path
            d="M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
            fill="currentColor"
          />
          <path
            d="M21 16V14C18.76 14 16.84 13.04 15.4 11.32L14.06 9.72C13.68 9.26 13.12 9 12.53 9H11.48C10.89 9 10.33 9.26 9.95 9.72L8.61 11.32C7.16 13.04 5.24 14 3 14V16C5.77 16 8.19 14.83 10 12.75V15L6.12 16.55C5.45 16.82 5 17.48 5 18.21C5 19.2 5.8 20 6.79 20H9V19.5C9 18.12 10.12 17 11.5 17H14.5C14.78 17 15 17.22 15 17.5C15 17.78 14.78 18 14.5 18H11.5C10.67 18 10 18.67 10 19.5V20H17.21C18.2 20 19 19.2 19 18.21C19 17.48 18.55 16.82 17.88 16.55L14 15V12.75C15.81 14.83 18.23 16 21 16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSell(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sell">
        <g id="Vector">
          <path
            d="M21.408 11.4125L12.578 2.5825C12.208 2.2125 11.698 2.0025 11.168 2.0025H3.99805C2.89805 2.0025 1.99805 2.9025 1.99805 4.0025V11.1725C1.99805 11.7025 2.20805 12.2125 2.58805 12.5825L11.418 21.4125C12.198 22.1925 13.468 22.1925 14.248 21.4125L21.418 14.2425C22.198 13.4625 22.198 12.2025 21.408 11.4125ZM12.828 20.0025L3.99805 11.1725V4.0025H11.168L19.998 12.8325L12.828 20.0025Z"
            fill="currentColor"
          />
          <path
            d="M6.49805 8.0025C7.32647 8.0025 7.99805 7.33093 7.99805 6.5025C7.99805 5.67408 7.32647 5.0025 6.49805 5.0025C5.66962 5.0025 4.99805 5.67408 4.99805 6.5025C4.99805 7.33093 5.66962 8.0025 6.49805 8.0025Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSend(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="send">
        <path
          id="Vector"
          d="M3.51 6.03L11.02 9.25L3.5 8.25L3.51 6.03ZM11.01 14.75L3.5 17.97V15.75L11.01 14.75ZM1.51 3L1.5 10L16.5 12L1.5 14L1.51 21L22.5 12L1.51 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSendAndArchive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="send_and_archive">
        <g id="Vector">
          <path
            d="M10.5 11L4.5 9.5V6.01L13.37 9.74C14.31 9.27 15.37 8.99 16.5 8.99C16.6 8.99 16.69 9 16.78 9L2.5 3V19L9.5 16.05C9.5 16.03 9.5 16.02 9.5 16C9.5 15.2 9.64 14.44 9.89 13.72L4.5 15.99V12.5L10.5 11Z"
            fill="currentColor"
          />
          <path
            d="M16.5 11C13.74 11 11.5 13.24 11.5 16C11.5 18.76 13.74 21 16.5 21C19.26 21 21.5 18.76 21.5 16C21.5 13.24 19.26 11 16.5 11ZM16.5 19L13.5 16L14.21 15.29L16 17.08V13H17V17.09L18.79 15.3L19.5 16L16.5 19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSendTimeExtension(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="send_time_extension">
        <g id="Vector">
          <path
            d="M17 6.25V12.51L19 13.51V6.25C19 5.15 18.1 4.25 17 4.25H13C13 2.87 11.88 1.75 10.5 1.75C9.12 1.75 8 2.87 8 4.25H4.01C2.91 4.25 2.01 5.15 2.01 6.25V10.05C4.7 10.05 5 12.21 5 12.75C5 13.29 4.71 15.45 2 15.45V19.25C2 20.35 2.9 21.25 4 21.25H7.8C7.8 19.09 9.17 18.47 10 18.31V16.28C8.57 16.45 6.85 17.32 6.13 19.25H4V17.12C6.17 16.32 7 14.25 7 12.75C7 11.26 6.17 9.19 4.01 8.38V6.25H10V4.25C10 3.97 10.22 3.75 10.5 3.75C10.78 3.75 11 3.97 11 4.25V6.25H17Z"
            fill="currentColor"
          />
          <path
            d="M12 12.25V16.25L16 17.25L12 18.25V22.25L22 17.25L12 12.25Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSendToMobile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="send_to_mobile">
        <path
          id="Vector"
          d="M16.5 8L20.5 12L16.5 16L15.09 14.59L16.67 13H11.5V11H16.67L15.08 9.41L16.5 8ZM5.5 1.01L15.5 1C16.6 1 17.5 1.9 17.5 3V7H15.5V6H5.5V18H15.5V17H17.5V21C17.5 22.1 16.6 23 15.5 23H5.5C4.4 23 3.5 22.1 3.5 21V3C3.5 1.9 4.4 1.01 5.5 1.01ZM5.5 21H15.5V20H5.5V21ZM5.5 4H15.5V3H5.5V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSensorDoor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sensor_door">
        <path
          id="Vector"
          d="M18 4V20H6V4H18ZM18 2H6C4.9 2 4 2.9 4 4V22H20V4C20 2.9 19.1 2 18 2ZM15.5 10.5C14.67 10.5 14 11.17 14 12C14 12.83 14.67 13.5 15.5 13.5C16.33 13.5 17 12.83 17 12C17 11.17 16.33 10.5 15.5 10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSensorOccupied(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sensor_occupied" clipPath="url(#clip0_395_2080)">
        <g id="Vector">
          <path
            d="M11.9999 11C13.6599 11 14.9999 9.65998 14.9999 7.99998C14.9999 6.33998 13.6599 4.99998 11.9999 4.99998C10.3399 4.99998 8.99992 6.33998 8.99992 7.99998C8.99992 9.65998 10.3399 11 11.9999 11ZM11.9999 6.99998C12.5499 6.99998 12.9999 7.44998 12.9999 7.99998C12.9999 8.54998 12.5499 8.99998 11.9999 8.99998C11.4499 8.99998 10.9999 8.54998 10.9999 7.99998C10.9999 7.44998 11.4499 6.99998 11.9999 6.99998Z"
            fill="currentColor"
          />
          <path
            d="M11.9999 12C10.1599 12 8.43992 12.5 6.96992 13.37C6.35992 13.72 5.99992 14.39 5.99992 15.09V17H17.9999V15.09C17.9999 14.39 17.6399 13.73 17.0299 13.37C15.5599 12.5 13.8399 12 11.9999 12ZM8.13992 15C9.31992 14.35 10.6499 14 11.9999 14C13.3499 14 14.6799 14.35 15.8499 15H8.13992Z"
            fill="currentColor"
          />
          <path
            d="M21.2299 8.14998L23.0799 7.37998C21.8599 4.46998 19.5299 2.12998 16.6199 0.919983L15.8499 2.76998C18.2699 3.78998 20.2099 5.72998 21.2299 8.14998Z"
            fill="currentColor"
          />
          <path
            d="M8.14992 2.76998L7.37992 0.919983C4.46992 2.13998 2.13992 4.46998 0.919922 7.37998L2.76992 8.14998C3.78992 5.72998 5.72992 3.78998 8.14992 2.76998Z"
            fill="currentColor"
          />
          <path
            d="M2.76992 15.85L0.919922 16.62C2.13992 19.53 4.46992 21.87 7.37992 23.08L8.14992 21.23C5.72992 20.21 3.78992 18.27 2.76992 15.85Z"
            fill="currentColor"
          />
          <path
            d="M15.8499 21.23L16.6199 23.08C19.5299 21.86 21.8699 19.53 23.0799 16.62L21.2299 15.85C20.2099 18.27 18.2699 20.21 15.8499 21.23Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_2080">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconSensorWindow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sensor_window">
        <path
          id="Vector"
          d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V11H14V10H10V11H6V4H18ZM6 20V13H18V20H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSensors(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sensors">
        <path
          id="Vector"
          d="M7.76 16.2401C6.67 15.1601 6 13.6601 6 12.0001C6 10.3401 6.67 8.84005 7.76 7.76005L9.18 9.18005C8.45 9.90005 8 10.9001 8 12.0001C8 13.1001 8.45 14.1001 9.17 14.8301L7.76 16.2401ZM16.24 16.2401C17.33 15.1601 18 13.6601 18 12.0001C18 10.3401 17.33 8.84005 16.24 7.76005L14.82 9.18005C15.55 9.90005 16 10.9001 16 12.0001C16 13.1001 15.55 14.1001 14.83 14.8301L16.24 16.2401ZM12 10.0001C10.9 10.0001 10 10.9001 10 12.0001C10 13.1001 10.9 14.0001 12 14.0001C13.1 14.0001 14 13.1001 14 12.0001C14 10.9001 13.1 10.0001 12 10.0001ZM20 12.0001C20 14.2101 19.1 16.2101 17.65 17.6501L19.07 19.0701C20.88 17.2601 22 14.7601 22 12.0001C22 9.24005 20.88 6.74005 19.07 4.93005L17.65 6.35005C19.1 7.79005 20 9.79005 20 12.0001ZM6.35 6.35005L4.93 4.93005C3.12 6.74005 2 9.24005 2 12.0001C2 14.7601 3.12 17.2601 4.93 19.0701L6.35 17.6501C4.9 16.2101 4 14.2101 4 12.0001C4 9.79005 4.9 7.79005 6.35 6.35005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSensorsOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sensors_off">
        <path
          id="Vector"
          d="M8.44495 10.255C8.35495 10.585 8.30495 10.935 8.30495 11.295C8.30495 12.395 8.75495 13.395 9.47495 14.125L8.05495 15.545C6.97495 14.455 6.30495 12.955 6.30495 11.295C6.30495 10.365 6.51495 9.49498 6.88495 8.70498L5.41495 7.23498C4.70495 8.42498 4.30495 9.81498 4.30495 11.295C4.30495 13.505 5.20495 15.505 6.65495 16.945L5.23495 18.365C3.42495 16.555 2.30495 14.055 2.30495 11.295C2.30495 9.25498 2.91495 7.36498 3.96495 5.78498L1.69495 3.51498L3.10495 2.10498L21.4849 20.485L20.0749 21.895L8.44495 10.255ZM17.7249 13.885C18.0949 13.095 18.3049 12.225 18.3049 11.295C18.3049 9.63498 17.6349 8.13498 16.5449 7.05498L15.1249 8.47498C15.8549 9.19498 16.3049 10.195 16.3049 11.295C16.3049 11.655 16.2549 12.005 16.1649 12.335L17.7249 13.885ZM20.3049 11.295C20.3049 12.775 19.9049 14.165 19.1949 15.355L20.6449 16.805C21.6949 15.225 22.3049 13.335 22.3049 11.295C22.3049 8.53498 21.1849 6.03498 19.3749 4.22498L17.9549 5.64498C19.4049 7.08498 20.3049 9.08498 20.3049 11.295Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSentimentDissatisfied(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sentiment_dissatisfied">
        <g id="Vector">
          <path
            d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z"
            fill="currentColor"
          />
          <path
            d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z"
            fill="currentColor"
          />
          <path
            d="M12 14C9.67 14 7.68 15.45 6.88 17.5H8.55C9.24 16.31 10.52 15.5 12 15.5C13.48 15.5 14.75 16.31 15.45 17.5H17.12C16.32 15.45 14.33 14 12 14ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSentimentNeutral(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sentiment_neutral">
        <g id="Vector">
          <path d="M9 14H15V15.5H9V14Z" fill="currentColor" />
          <path
            d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z"
            fill="currentColor"
          />
          <path
            d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z"
            fill="currentColor"
          />
          <path
            d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSentimentSatisfied(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sentiment_satisfied">
        <g id="Vector">
          <path
            d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z"
            fill="currentColor"
          />
          <path
            d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z"
            fill="currentColor"
          />
          <path
            d="M12 16C10.52 16 9.25 15.19 8.55 14H6.88C7.68 16.05 9.67 17.5 12 17.5C14.33 17.5 16.32 16.05 17.12 14H15.45C14.75 15.19 13.48 16 12 16ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSentimentSatisfiedAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sentiment_satisfied_alt">
        <g id="Vector">
          <path
            d="M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z"
            fill="currentColor"
          />
          <path
            d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z"
            fill="currentColor"
          />
          <path
            d="M12 16C10.52 16 9.25 15.19 8.55 14H6.88C7.68 16.05 9.67 17.5 12 17.5C14.33 17.5 16.32 16.05 17.12 14H15.45C14.76 15.19 13.48 16 12 16ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSentimentVeryDissatisfied(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sentiment_very_dissatisfied">
        <path
          id="Vector"
          d="M12 13.5C9.67 13.5 7.69 14.96 6.89 17H17.11C16.31 14.96 14.33 13.5 12 13.5ZM7.82 12L8.88 10.94L9.94 12L11 10.94L9.94 9.88L11 8.82L9.94 7.76L8.88 8.82L7.82 7.76L6.76 8.82L7.82 9.88L6.76 10.94L7.82 12ZM11.99 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 11.99 22C17.51 22 22 17.53 22 12C22 6.47 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM16.18 7.76L15.12 8.82L14.06 7.76L13 8.82L14.06 9.88L13 10.94L14.06 12L15.12 10.94L16.18 12L17.24 10.94L16.18 9.88L17.24 8.82L16.18 7.76Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSentimentVerySatisfied(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sentiment_very_satisfied">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 11.99 22C17.51 22 22 17.53 22 12C22 6.47 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM13 9.94L14.06 11L15.12 9.94L16.18 11L17.24 9.94L15.12 7.82L13 9.94ZM8.88 9.94L9.94 11L11 9.94L8.88 7.82L6.76 9.94L7.82 11L8.88 9.94ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSetMeal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="set_meal">
        <path
          id="Vector"
          d="M21.05 18.07L3.08 19.01L3 17.51L20.98 16.57L21.05 18.07ZM21 19.99H3V21.49H21V19.99ZM23 13.51V4.51001C23 3.41001 22.1 2.51001 21 2.51001H3C1.9 2.51001 1 3.41001 1 4.51001V13.51C1 14.61 1.9 15.51 3 15.51H21C22.1 15.51 23 14.61 23 13.51ZM21 13.51H3V4.51001H21V13.51ZM20 6.51001C18.32 6.51001 16.96 7.49001 16.79 8.74001C16.15 8.01001 14.06 6.01001 10.25 6.01001C5.58 6.01001 3.5 9.01001 3.5 9.01001C3.5 9.01001 5.58 12.01 10.25 12.01C14.06 12.01 16.15 10.01 16.79 9.28001C16.96 10.53 18.32 11.51 20 11.51V6.51001Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettings(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings">
        <path
          id="Vector"
          d="M19.4322 12.98C19.4722 12.66 19.5022 12.34 19.5022 12C19.5022 11.66 19.4722 11.34 19.4322 11.02L21.5422 9.37C21.7322 9.22 21.7822 8.95 21.6622 8.73L19.6622 5.27C19.5722 5.11 19.4022 5.02 19.2222 5.02C19.1622 5.02 19.1022 5.03 19.0522 5.05L16.5622 6.05C16.0422 5.65 15.4822 5.32 14.8722 5.07L14.4922 2.42C14.4622 2.18 14.2522 2 14.0022 2H10.0022C9.75216 2 9.54216 2.18 9.51216 2.42L9.13216 5.07C8.52216 5.32 7.96216 5.66 7.44216 6.05L4.95216 5.05C4.89216 5.03 4.83216 5.02 4.77216 5.02C4.60216 5.02 4.43216 5.11 4.34216 5.27L2.34216 8.73C2.21216 8.95 2.27216 9.22 2.46216 9.37L4.57216 11.02C4.53216 11.34 4.50216 11.67 4.50216 12C4.50216 12.33 4.53216 12.66 4.57216 12.98L2.46216 14.63C2.27216 14.78 2.22216 15.05 2.34216 15.27L4.34216 18.73C4.43216 18.89 4.60216 18.98 4.78216 18.98C4.84216 18.98 4.90216 18.97 4.95216 18.95L7.44216 17.95C7.96216 18.35 8.52216 18.68 9.13216 18.93L9.51216 21.58C9.54216 21.82 9.75216 22 10.0022 22H14.0022C14.2522 22 14.4622 21.82 14.4922 21.58L14.8722 18.93C15.4822 18.68 16.0422 18.34 16.5622 17.95L19.0522 18.95C19.1122 18.97 19.1722 18.98 19.2322 18.98C19.4022 18.98 19.5722 18.89 19.6622 18.73L21.6622 15.27C21.7822 15.05 21.7322 14.78 21.5422 14.63L19.4322 12.98ZM17.4522 11.27C17.4922 11.58 17.5022 11.79 17.5022 12C17.5022 12.21 17.4822 12.43 17.4522 12.73L17.3122 13.86L18.2022 14.56L19.2822 15.4L18.5822 16.61L17.3122 16.1L16.2722 15.68L15.3722 16.36C14.9422 16.68 14.5322 16.92 14.1222 17.09L13.0622 17.52L12.9022 18.65L12.7022 20H11.3022L10.9522 17.52L9.89216 17.09C9.46216 16.91 9.06216 16.68 8.66216 16.38L7.75216 15.68L6.69216 16.11L5.42216 16.62L4.72216 15.41L5.80216 14.57L6.69216 13.87L6.55216 12.74C6.52216 12.43 6.50216 12.2 6.50216 12C6.50216 11.8 6.52216 11.57 6.55216 11.27L6.69216 10.14L5.80216 9.44L4.72216 8.6L5.42216 7.39L6.69216 7.9L7.73216 8.32L8.63216 7.64C9.06216 7.32 9.47216 7.08 9.88216 6.91L10.9422 6.48L11.1022 5.35L11.3022 4H12.6922L13.0422 6.48L14.1022 6.91C14.5322 7.09 14.9322 7.32 15.3322 7.62L16.2422 8.32L17.3022 7.89L18.5722 7.38L19.2722 8.59L18.2022 9.44L17.3122 10.14L17.4522 11.27ZM12.0022 8C9.79216 8 8.00216 9.79 8.00216 12C8.00216 14.21 9.79216 16 12.0022 16C14.2122 16 16.0022 14.21 16.0022 12C16.0022 9.79 14.2122 8 12.0022 8ZM12.0022 14C10.9022 14 10.0022 13.1 10.0022 12C10.0022 10.9 10.9022 10 12.0022 10C13.1022 10 14.0022 10.9 14.0022 12C14.0022 13.1 13.1022 14 12.0022 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsAccessibility(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_accessibility">
        <path
          id="Vector"
          d="M20.5 4C17.89 4.7 14.83 5 12 5C9.17 5 6.11 4.7 3.5 4L3 6C4.86 6.5 7 6.83 9 7V19H11V13H13V19H15V7C17 6.83 19.14 6.5 21 6L20.5 4ZM12 4C13.1 4 14 3.1 14 2C14 0.9 13.1 0 12 0C10.9 0 10 0.9 10 2C10 3.1 10.9 4 12 4ZM7 24H9V22H7V24ZM11 24H13V22H11V24ZM15 24H17V22H15V24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsApplications(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_applications">
        <path
          id="Vector"
          d="M6.21 13.97L7.41 16.04C7.49 16.17 7.64 16.22 7.78 16.17L9.27 15.57C9.58 15.81 9.91 16.01 10.28 16.16L10.5 17.75C10.53 17.89 10.65 18 10.8 18H13.2C13.35 18 13.47 17.89 13.5 17.74L13.72 16.15C14.08 16 14.42 15.8 14.73 15.56L16.22 16.16C16.36 16.21 16.51 16.16 16.59 16.03L17.79 13.96C17.87 13.83 17.83 13.67 17.72 13.57L16.45 12.58C16.48 12.39 16.49 12.19 16.49 12C16.49 11.8 16.47 11.61 16.45 11.41L17.72 10.42C17.83 10.33 17.87 10.16 17.79 10.03L16.59 7.96C16.51 7.83 16.36 7.78 16.22 7.83L14.73 8.43C14.42 8.19 14.09 7.99 13.72 7.84L13.5 6.25C13.47 6.11 13.35 6 13.2 6H10.8C10.65 6 10.53 6.11 10.5 6.26L10.28 7.85C9.92 8 9.57 8.19 9.27 8.43L7.78 7.83C7.64 7.78 7.49 7.83 7.41 7.96L6.21 10.03C6.13 10.16 6.17 10.32 6.28 10.42L7.55 11.41C7.52 11.61 7.5 11.8 7.5 12C7.5 12.2 7.52 12.39 7.54 12.59L6.27 13.58C6.16 13.68 6.13 13.84 6.21 13.97ZM12 10.29C12.94 10.29 13.71 11.06 13.71 12C13.71 12.94 12.94 13.71 12 13.71C11.06 13.71 10.29 12.94 10.29 12C10.29 11.06 11.06 10.29 12 10.29ZM19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsBackupRestore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_backup_restore">
        <path
          id="Vector"
          d="M15.5 12C15.5 10.9 14.6 10 13.5 10C12.4 10 11.5 10.9 11.5 12C11.5 13.1 12.4 14 13.5 14C14.6 14 15.5 13.1 15.5 12ZM13.5 3C8.53 3 4.5 7.03 4.5 12H1.5L5.5 16L9.5 12H6.5C6.5 8.13 9.63 5 13.5 5C17.37 5 20.5 8.13 20.5 12C20.5 15.87 17.37 19 13.5 19C11.99 19 10.59 18.51 9.44 17.7L8.02 19.14C9.54 20.3 11.44 21 13.5 21C18.47 21 22.5 16.97 22.5 12C22.5 7.03 18.47 3 13.5 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsBluetooth(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_bluetooth">
        <path
          id="Vector"
          d="M11.645 24H13.645V22H11.645V24ZM7.64502 24H9.64502V22H7.64502V24ZM15.645 24H17.645V22H15.645V24ZM18.355 5.71L12.645 0H11.645V7.59L7.05502 3L5.64502 4.41L11.235 10L5.64502 15.59L7.05502 17L11.645 12.41V20H12.645L18.355 14.29L14.055 10L18.355 5.71ZM13.645 3.83L15.525 5.71L13.645 7.59V3.83ZM15.525 14.29L13.645 16.17V12.41L15.525 14.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsBrightness(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_brightness">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01ZM8 16H10.5L12 17.5L13.5 16H16V13.5L17.5 12L16 10.5V8H13.5L12 6.5L10.5 8H8V10.5L6.5 12L8 13.5V16ZM12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsCell(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_cell">
        <path
          id="Vector"
          d="M7 22H9V24H7V22ZM11 22H13V24H11V22ZM15 22H17V24H15V22ZM16 0.01L8 0C6.9 0 6 0.9 6 2V18C6 19.1 6.9 20 8 20H16C17.1 20 18 19.1 18 18V2C18 0.9 17.1 0.01 16 0.01ZM16 18H8V17H16V18ZM16 15H8V5H16V15ZM16 3H8V2H16V3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsEthernet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_ethernet">
        <path
          id="Vector"
          d="M7.76995 6.75998L6.22995 5.47998L0.819946 12L6.22995 18.52L7.76995 17.24L3.41995 12L7.76995 6.75998ZM6.99995 13H8.99995V11H6.99995V13ZM16.9999 11H14.9999V13H16.9999V11ZM10.9999 13H12.9999V11H10.9999V13ZM17.7699 5.47998L16.2299 6.75998L20.5799 12L16.2299 17.24L17.7699 18.52L23.1799 12L17.7699 5.47998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsInputAntenna(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_input_antenna">
        <path
          id="Vector"
          d="M12 5.29504C8.13 5.29504 5 8.42504 5 12.295H7C7 9.53504 9.24 7.29504 12 7.29504C14.76 7.29504 17 9.53504 17 12.295H19C19 8.42504 15.87 5.29504 12 5.29504ZM13 14.585C13.88 14.195 14.5 13.325 14.5 12.295C14.5 10.915 13.38 9.79504 12 9.79504C10.62 9.79504 9.5 10.915 9.5 12.295C9.5 13.315 10.12 14.195 11 14.585V17.885L7.59 21.295L9 22.705L12 19.705L15 22.705L16.41 21.295L13 17.885V14.585ZM12 1.29504C5.93 1.29504 1 6.22504 1 12.295H3C3 7.32504 7.03 3.29504 12 3.29504C16.97 3.29504 21 7.32504 21 12.295H23C23 6.22504 18.07 1.29504 12 1.29504Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsInputComponent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_input_component">
        <path
          id="Vector"
          d="M5 2C5 1.45 4.55 1 4 1C3.45 1 3 1.45 3 2V6H1V16C1 17.3 1.84 18.4 3 18.82V23H5V18.82C6.16 18.4 7 17.3 7 16V6H5V2ZM4 17C3.45 17 3 16.55 3 16V14H5V16C5 16.55 4.55 17 4 17ZM3 12V8H5V12H3ZM13 2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V6H9V16C9 17.3 9.84 18.4 11 18.82V23H13V18.82C14.16 18.4 15 17.3 15 16V6H13V2ZM12 17C11.45 17 11 16.55 11 16V14H13V16C13 16.55 12.55 17 12 17ZM11 12V8H13V12H11ZM21 6V2C21 1.45 20.55 1 20 1C19.45 1 19 1.45 19 2V6H17V16C17 17.3 17.84 18.4 19 18.82V23H21V18.82C22.16 18.4 23 17.3 23 16V6H21ZM20 17C19.45 17 19 16.55 19 16V14H21V16C21 16.55 20.55 17 20 17ZM19 12V8H21V12H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsInputComposite(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_input_composite">
        <path
          id="Vector"
          d="M5 2C5 1.45 4.55 1 4 1C3.45 1 3 1.45 3 2V6H1V16C1 17.3 1.84 18.4 3 18.82V23H5V18.82C6.16 18.4 7 17.3 7 16V6H5V2ZM4 17C3.45 17 3 16.55 3 16V14H5V16C5 16.55 4.55 17 4 17ZM3 12V8H5V12H3ZM13 2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V6H9V16C9 17.3 9.84 18.4 11 18.82V23H13V18.82C14.16 18.4 15 17.3 15 16V6H13V2ZM12 17C11.45 17 11 16.55 11 16V14H13V16C13 16.55 12.55 17 12 17ZM11 12V8H13V12H11ZM21 6V2C21 1.45 20.55 1 20 1C19.45 1 19 1.45 19 2V6H17V16C17 17.3 17.84 18.4 19 18.82V23H21V18.82C22.16 18.4 23 17.3 23 16V6H21ZM20 17C19.45 17 19 16.55 19 16V14H21V16C21 16.55 20.55 17 20 17ZM19 12V8H21V12H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsInputHdmi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_input_hdmi">
        <path
          id="Vector"
          d="M18 7V4C18 2.9 17.1 2 16 2H8C6.9 2 6 2.9 6 4V7H5V13L8 19V22H16V19L19 13V7H18ZM8 4H16V7H13.99V5H12.99V7H11V5H10V7H8V4ZM17 12.53L14 18.53V20H10V18.53L7 12.53V9H17V12.53Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsInputSvideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_input_svideo">
        <path
          id="Vector"
          d="M8 11.5C8 10.67 7.33 10 6.5 10C5.67 10 5 10.67 5 11.5C5 12.33 5.67 13 6.5 13C7.33 13 8 12.33 8 11.5ZM15 6.5C15 5.67 14.33 5 13.5 5H10.5C9.67 5 9 5.67 9 6.5C9 7.33 9.67 8 10.5 8H13.5C14.33 8 15 7.33 15 6.5ZM8.5 15C7.67 15 7 15.67 7 16.5C7 17.33 7.67 18 8.5 18C9.33 18 10 17.33 10 16.5C10 15.67 9.33 15 8.5 15ZM12 1C5.93 1 1 5.93 1 12C1 18.07 5.93 23 12 23C18.07 23 23 18.07 23 12C23 5.93 18.07 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21ZM17.5 10C16.67 10 16 10.67 16 11.5C16 12.33 16.67 13 17.5 13C18.33 13 19 12.33 19 11.5C19 10.67 18.33 10 17.5 10ZM15.5 15C14.67 15 14 15.67 14 16.5C14 17.33 14.67 18 15.5 18C16.33 18 17 17.33 17 16.5C17 15.67 16.33 15 15.5 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsOverscan(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_overscan">
        <path
          id="Vector"
          d="M12.01 5.5L10 8H14L12.01 5.5ZM18 10V14L20.5 12.01L18 10ZM6 10L3.5 12.01L6 14V10ZM14 16H10L12.01 18.5L14 16ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsPhone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_phone">
        <path
          id="Vector"
          d="M11 9H13V11H11V9ZM15 9H17V11H15V9ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.99 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM19 9H21V11H19V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsPower(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_power">
        <path
          id="Vector"
          d="M7 23H9V21H7V23ZM11 23H13V21H11V23ZM13 1H11V11H13V1ZM16.56 3.44L15.11 4.89C16.84 5.94 18 7.83 18 10C18 13.31 15.31 16 12 16C8.69 16 6 13.31 6 10C6 7.83 7.16 5.94 8.88 4.88L7.44 3.44C5.36 4.88 4 7.28 4 10C4 14.42 7.58 18 12 18C16.42 18 20 14.42 20 10C20 7.28 18.64 4.88 16.56 3.44ZM15 23H17V21H15V23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsRemote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_remote">
        <g id="Vector">
          <path
            d="M15.0051 9.5H9.0051C8.4551 9.5 8.0051 9.95 8.0051 10.5V22.5C8.0051 23.05 8.4551 23.5 9.0051 23.5H15.0051C15.5551 23.5 16.0051 23.05 16.0051 22.5V10.5C16.0051 9.95 15.5551 9.5 15.0051 9.5ZM14.0051 21.5H10.0051V11.5H14.0051V21.5Z"
            fill="currentColor"
          />
          <path
            d="M12.0051 14.5C12.5574 14.5 13.0051 14.0523 13.0051 13.5C13.0051 12.9477 12.5574 12.5 12.0051 12.5C11.4528 12.5 11.0051 12.9477 11.0051 13.5C11.0051 14.0523 11.4528 14.5 12.0051 14.5Z"
            fill="currentColor"
          />
          <path
            d="M7.0551 6.55L8.4651 7.96C9.3751 7.06 10.6251 6.5 12.0051 6.5C13.3851 6.5 14.6351 7.06 15.5451 7.96L16.9551 6.55C15.6851 5.28 13.9351 4.5 12.0051 4.5C10.0751 4.5 8.3251 5.28 7.0551 6.55ZM12.0051 0.5C8.9651 0.5 6.2151 1.73 4.2251 3.72L5.6351 5.13C7.2651 3.51 9.5151 2.5 12.0051 2.5C14.4951 2.5 16.7451 3.51 18.3651 5.14L19.7751 3.73C17.7951 1.73 15.0451 0.5 12.0051 0.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSettingsSuggest(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_suggest">
        <path
          id="Vector"
          d="M9.58991 13C10.1399 13 10.5899 13.45 10.5899 14C10.5899 14.55 10.1399 15 9.58991 15C9.03991 15 8.58991 14.55 8.58991 14C8.58991 13.45 9.03991 13 9.58991 13ZM9.58991 11C7.92991 11 6.58991 12.34 6.58991 14C6.58991 15.66 7.92991 17 9.58991 17C11.2499 17 12.5899 15.66 12.5899 14C12.5899 12.34 11.2499 11 9.58991 11ZM18.0899 9L19.1799 6.59L21.5899 5.5L19.1799 4.41L18.0899 2L16.9999 4.41L14.5899 5.5L16.9999 6.59L18.0899 9ZM20.8699 12.72L20.0899 11L19.3099 12.72L17.5899 13.5L19.3099 14.28L20.0899 16L20.8699 14.28L22.5899 13.5L20.8699 12.72ZM15.8399 14C15.8399 13.88 15.8399 13.75 15.8299 13.63L17.7699 12.16L15.2699 7.83L13.0299 8.77C12.8299 8.64 12.6099 8.51 12.3899 8.4L12.0899 6H7.08991L6.78991 8.41C6.56991 8.52 6.35991 8.65 6.14991 8.78L3.90991 7.83L1.40991 12.16L3.34991 13.63C3.33991 13.75 3.33991 13.88 3.33991 14C3.33991 14.12 3.33991 14.25 3.34991 14.37L1.40991 15.84L3.90991 20.17L6.14991 19.23C6.34991 19.36 6.56991 19.49 6.78991 19.6L7.08991 22H12.0899L12.3899 19.59C12.6099 19.48 12.8199 19.36 13.0299 19.22L15.2699 20.16L17.7699 15.83L15.8299 14.36C15.8399 14.25 15.8399 14.12 15.8399 14ZM14.4199 17.64L12.6899 16.91C12.1299 17.51 11.3899 17.95 10.5599 18.14L10.3199 20H8.85991L8.62991 18.14C7.79991 17.95 7.05991 17.51 6.49991 16.91L4.76991 17.64L4.03991 16.37L5.52991 15.24C5.40991 14.85 5.34991 14.44 5.34991 14.01C5.34991 13.58 5.40991 13.17 5.52991 12.78L4.03991 11.65L4.76991 10.38L6.49991 11.11C7.05991 10.51 7.79991 10.07 8.62991 9.88L8.85991 8H10.3299L10.5599 9.86C11.3899 10.05 12.1299 10.49 12.6899 11.09L14.4199 10.36L15.1499 11.63L13.6599 12.76C13.7799 13.15 13.8399 13.56 13.8399 13.99C13.8399 14.42 13.7799 14.83 13.6599 15.22L15.1499 16.35L14.4199 17.64Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsSystemDaydream(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_system_daydream">
        <path
          id="Vector"
          d="M15.5 17H9C6.79 17 5 15.21 5 13C5 11.07 6.36 9.44 8.22 9.08C9.04 7.8 10.47 7 12 7C13.95 7 15.66 8.28 16.26 10.09C17.84 10.45 19 11.84 19 13.5C19 15.43 17.43 17 15.5 17ZM8.74 11.02C7.74 11.15 7 11.99 7 13C7 14.1 7.9 15 9 15H15.5C16.33 15 17 14.33 17 13.5C17 12.67 16.33 12 15.5 12H14.63L14.46 11.14C14.29 9.92 13.23 9 12 9C11.04 9 10.16 9.57 9.74 10.45L9.47 11.02H8.74ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSettingsVoice(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings_voice">
        <path
          id="Vector"
          d="M7 21.5H9V23.5H7V21.5ZM12 12.5C13.66 12.5 15 11.16 15 9.5V3.5C15 1.84 13.66 0.5 12 0.5C10.34 0.5 9 1.84 9 3.5V9.5C9 11.16 10.34 12.5 12 12.5ZM11 3.5C11 2.95 11.45 2.5 12 2.5C12.55 2.5 13 2.95 13 3.5V9.5C13 10.06 12.56 10.5 12 10.5C11.45 10.5 11 10.05 11 9.5V3.5ZM11 21.5H13V23.5H11V21.5ZM15 21.5H17V23.5H15V21.5ZM19 9.5H17.3C17.3 12.5 14.76 14.6 12 14.6C9.24 14.6 6.7 12.5 6.7 9.5H5C5 12.91 7.72 15.73 11 16.22V19.5H13V16.22C16.28 15.73 19 12.91 19 9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSevereCold(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="severe_cold">
        <g id="Vector">
          <path
            d="M12.5 10.41L16.5 6.41L15.09 5L12.5 7.59V4H10.5V7.59L7.91 5L6.5 6.41L10.5 10.41V12H8.91L4.91 8L3.5 9.41L6.09 12H2.5V14H6.09L3.5 16.59L4.91 18L8.91 14H10.5V15.59L6.5 19.59L7.91 21L10.5 18.41V22H12.5V18.41L15.09 21L16.5 19.59L12.5 15.59V14H14.09L18.09 18L19.5 16.59L16.91 14H20.5V12H12.5V10.41Z"
            fill="currentColor"
          />
          <path d="M21.5 2H19.5V7H21.5V2Z" fill="currentColor" />
          <path d="M21.5 8H19.5V10H21.5V8Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconShapeLine(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shape_line">
        <g id="Vector">
          <path
            d="M6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11ZM6 3C7.65 3 9 4.35 9 6C9 7.65 7.65 9 6 9C4.35 9 3 7.65 3 6C3 4.35 4.35 3 6 3Z"
            fill="currentColor"
          />
          <path
            d="M21 14H16C14.9 14 14 14.9 14 16V21C14 22.1 14.9 23 16 23H21C22.1 23 23 22.1 23 21V16C23 14.9 22.1 14 21 14ZM21 21H16V16H21V21Z"
            fill="currentColor"
          />
          <path
            d="M17.71 7.7C18.11 7.89 18.54 8 19 8C20.65 8 22 6.65 22 5C22 3.35 20.65 2 19 2C17.35 2 16 3.35 16 5C16 5.46 16.11 5.89 16.3 6.29L6.29 16.3C5.89 16.11 5.46 16 5 16C3.35 16 2 17.35 2 19C2 20.65 3.35 22 5 22C6.65 22 8 20.65 8 19C8 18.54 7.89 18.11 7.7 17.71L17.71 7.7Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="share">
        <path
          id="Vector"
          d="M18 16.12C17.24 16.12 16.56 16.42 16.04 16.89L8.91 12.74C8.96 12.51 9 12.28 9 12.04C9 11.8 8.96 11.57 8.91 11.34L15.96 7.23004C16.5 7.73004 17.21 8.04004 18 8.04004C19.66 8.04004 21 6.70004 21 5.04004C21 3.38004 19.66 2.04004 18 2.04004C16.34 2.04004 15 3.38004 15 5.04004C15 5.28004 15.04 5.51004 15.09 5.74004L8.04 9.85004C7.5 9.35004 6.79 9.04004 6 9.04004C4.34 9.04004 3 10.38 3 12.04C3 13.7 4.34 15.04 6 15.04C6.79 15.04 7.5 14.73 8.04 14.23L15.16 18.39C15.11 18.6 15.08 18.82 15.08 19.04C15.08 20.65 16.39 21.96 18 21.96C19.61 21.96 20.92 20.65 20.92 19.04C20.92 17.43 19.61 16.12 18 16.12ZM18 4.04004C18.55 4.04004 19 4.49004 19 5.04004C19 5.59004 18.55 6.04004 18 6.04004C17.45 6.04004 17 5.59004 17 5.04004C17 4.49004 17.45 4.04004 18 4.04004ZM6 13.04C5.45 13.04 5 12.59 5 12.04C5 11.49 5.45 11.04 6 11.04C6.55 11.04 7 11.49 7 12.04C7 12.59 6.55 13.04 6 13.04ZM18 20.06C17.45 20.06 17 19.61 17 19.06C17 18.51 17.45 18.06 18 18.06C18.55 18.06 19 18.51 19 19.06C19 19.61 18.55 20.06 18 20.06Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShareLocation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="share_location">
        <g id="Vector">
          <path
            d="M13.02 19.93V21.95C15.03 21.75 16.86 20.95 18.34 19.74L16.92 18.31C15.81 19.17 14.48 19.75 13.02 19.93Z"
            fill="currentColor"
          />
          <path
            d="M4.03003 12C4.03003 7.94999 7.06003 4.58999 10.98 4.06999V2.04999C5.95003 2.57999 2.03003 6.83999 2.03003 12C2.03003 17.16 5.95003 21.42 10.98 21.95V19.93C7.06003 19.41 4.03003 16.05 4.03003 12Z"
            fill="currentColor"
          />
          <path
            d="M19.95 11H21.97C21.77 8.98999 20.97 7.15999 19.76 5.67999L18.33 7.10999C19.19 8.20999 19.77 9.53999 19.95 11Z"
            fill="currentColor"
          />
          <path
            d="M18.34 4.25999C16.86 3.04999 15.02 2.24999 13.02 2.04999V4.06999C14.48 4.24999 15.81 4.82999 16.92 5.68999L18.34 4.25999Z"
            fill="currentColor"
          />
          <path
            d="M18.33 16.9L19.76 18.32C20.97 16.84 21.77 15.01 21.97 13H19.95C19.77 14.46 19.19 15.79 18.33 16.9Z"
            fill="currentColor"
          />
          <path
            d="M16 11.1C16 8.60999 14.1 6.99999 12 6.99999C9.90003 6.99999 8.00003 8.60999 8.00003 11.1C8.00003 12.76 9.33003 14.73 12 17C14.67 14.73 16 12.76 16 11.1ZM12 12C11.41 12 10.93 11.52 10.93 10.93C10.93 10.34 11.41 9.85999 12 9.85999C12.59 9.85999 13.07 10.34 13.07 10.93C13.07 11.52 12.59 12 12 12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconShield(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shield">
        <path
          id="Vector"
          d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShieldMoon(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shield_moon">
        <g id="Vector">
          <path
            d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z"
            fill="currentColor"
          />
          <path
            d="M9.01 14.33C10.76 16.5 14.13 16.57 15.97 14.4C16.2 14.13 16.05 13.72 15.71 13.66C14.42 13.45 13.23 12.68 12.53 11.46C11.82 10.24 11.75 8.83 12.21 7.6C12.33 7.27 12.05 6.94 11.7 7C8.36 7.62 6.81 11.61 9.01 14.33Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconShop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shop">
        <path
          id="Vector"
          d="M16 6.5V4.5C16 3.39 15.11 2.5 14 2.5H10C8.89 2.5 8 3.39 8 4.5V6.5H2V19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V6.5H16ZM10 4.5H14V6.5H10V4.5ZM20 19.5H4V8.5H20V19.5ZM9 18.5L16.5 13.5L9 9.5V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShopTwo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shop_two">
        <g id="Vector">
          <path d="M3 9.5H1V20.5C1 21.61 1.89 22.5 3 22.5H19V20.5H3V9.5Z" fill="currentColor" />
          <path
            d="M18 5.5V3.5C18 2.39 17.11 1.5 16 1.5H12C10.89 1.5 10 2.39 10 3.5V5.5H5V16.5C5 17.61 5.89 18.5 7 18.5H21C22.11 18.5 23 17.61 23 16.5V5.5H18ZM12 3.5H16V5.5H12V3.5ZM21 16.5H7V7.5H21V16.5Z"
            fill="currentColor"
          />
          <path d="M12 8.5V15.5L17.5 12L12 8.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconShoppingBag(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shopping_bag">
        <path
          id="Vector"
          d="M18 6H16C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6H6C4.9 6 4 6.9 4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6ZM12 4C13.1 4 14 4.9 14 6H10C10 4.9 10.9 4 12 4ZM18 20H6V8H8V10C8 10.55 8.45 11 9 11C9.55 11 10 10.55 10 10V8H14V10C14 10.55 14.45 11 15 11C15.55 11 16 10.55 16 10V8H18V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShoppingBasket(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shopping_basket">
        <path
          id="Vector"
          d="M22 9.49001H17.21L12.83 2.93001C12.64 2.65001 12.32 2.51001 12 2.51001C11.68 2.51001 11.36 2.65001 11.17 2.94001L6.79 9.49001H2C1.45 9.49001 1 9.94001 1 10.49C1 10.58 1.01 10.67 1.04 10.76L3.58 20.03C3.81 20.87 4.58 21.49 5.5 21.49H18.5C19.42 21.49 20.19 20.87 20.43 20.03L22.97 10.76L23 10.49C23 9.94001 22.55 9.49001 22 9.49001ZM12 5.29001L14.8 9.49001H9.2L12 5.29001ZM18.5 19.49L5.51 19.5L3.31 11.49H20.7L18.5 19.49ZM12 13.49C10.9 13.49 10 14.39 10 15.49C10 16.59 10.9 17.49 12 17.49C13.1 17.49 14 16.59 14 15.49C14 14.39 13.1 13.49 12 13.49Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShoppingCart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shopping_cart">
        <path
          id="Vector"
          d="M16.5463 13C17.2963 13 17.9563 12.59 18.2963 11.97L21.8763 5.48C22.2463 4.82 21.7663 4 21.0063 4H6.20634L5.26634 2H1.99634V4H3.99634L7.59634 11.59L6.24634 14.03C5.51634 15.37 6.47634 17 7.99634 17H19.9963V15H7.99634L9.09634 13H16.5463ZM7.15634 6H19.3063L16.5463 11H9.52634L7.15634 6ZM7.99634 18C6.89634 18 6.00634 18.9 6.00634 20C6.00634 21.1 6.89634 22 7.99634 22C9.09634 22 9.99634 21.1 9.99634 20C9.99634 18.9 9.09634 18 7.99634 18ZM17.9963 18C16.8963 18 16.0063 18.9 16.0063 20C16.0063 21.1 16.8963 22 17.9963 22C19.0963 22 19.9963 21.1 19.9963 20C19.9963 18.9 19.0963 18 17.9963 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShoppingCartCheckout(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shopping_cart_checkout">
        <path
          id="Vector"
          d="M8 18C6.9 18 6.01 18.9 6.01 20C6.01 21.1 6.9 22 8 22C9.1 22 10 21.1 10 20C10 18.9 9.1 18 8 18ZM18 18C16.9 18 16.01 18.9 16.01 20C16.01 21.1 16.9 22 18 22C19.1 22 20 21.1 20 20C20 18.9 19.1 18 18 18ZM9.1 13H16.55C17.3 13 17.96 12.59 18.3 11.97L22 4.96L20.25 4L16.55 11H9.53L5.27 2H2V4H4L7.6 11.59L6.25 14.03C5.52 15.37 6.48 17 8 17H20V15H8L9.1 13ZM13 2L17 6L13 10L11.59 8.59L13.17 7H9V5H13.17L11.58 3.41L13 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShortText(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="short_text">
        <path id="Vector" d="M4 9H20V11H4V9ZM4 13H14V15H4V13Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconShortcut(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shortcut">
        <path
          id="Vector"
          d="M15 5L13.59 6.41L15 7.83L17.17 10H8C5.24 10 3 12.24 3 15V19H5V15C5 13.35 6.35 12 8 12H17.17L13.59 15.58L15 17L21 11L15 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShowChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="show_chart">
        <path
          id="Vector"
          d="M3.5 18.49L9.5 12.48L13.5 16.48L22 6.92001L20.59 5.51001L13.5 13.48L9.5 9.48001L2 16.99L3.5 18.49Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShower(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shower">
        <path
          id="Vector"
          d="M9 17C9 17.55 8.55 18 8 18C7.45 18 7 17.55 7 17C7 16.45 7.45 16 8 16C8.55 16 9 16.45 9 17ZM12 16C11.45 16 11 16.45 11 17C11 17.55 11.45 18 12 18C12.55 18 13 17.55 13 17C13 16.45 12.55 16 12 16ZM16 16C15.45 16 15 16.45 15 17C15 17.55 15.45 18 16 18C16.55 18 17 17.55 17 17C17 16.45 16.55 16 16 16ZM19 12V14H5V12C5 8.47 7.61 5.57 11 5.08V3H13V5.08C16.39 5.57 19 8.47 19 12ZM17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12H17ZM8 19C7.45 19 7 19.45 7 20C7 20.55 7.45 21 8 21C8.55 21 9 20.55 9 20C9 19.45 8.55 19 8 19ZM12 19C11.45 19 11 19.45 11 20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20C13 19.45 12.55 19 12 19ZM16 19C15.45 19 15 19.45 15 20C15 20.55 15.45 21 16 21C16.55 21 17 20.55 17 20C17 19.45 16.55 19 16 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShuffle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shuffle">
        <path
          id="Vector"
          d="M10.59 9.17L5.41 4L4 5.41L9.17 10.58L10.59 9.17ZM14.5 4L16.54 6.04L4 18.59L5.41 20L17.96 7.46L20 9.5V4H14.5ZM14.83 13.41L13.42 14.82L16.55 17.95L14.5 20H20V14.5L17.96 16.54L14.83 13.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShuffleAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shuffle_alt">
        <g id="Vector">
          <path
            d="M23 18L18 23L16.5752 21.5996L19.1748 19H16.0273C15.2215 19.0045 14.4264 18.8143 13.71 18.4453C12.9917 18.0753 12.3738 17.536 11.9092 16.875L11.8828 16.8359L11.1836 15.7344L12.3672 13.8672L13.5508 15.7334C13.8289 16.1263 14.198 16.4465 14.626 16.667C15.057 16.889 15.5357 17.0033 16.0205 17H19.1748L16.5752 14.4004L18 13L23 18Z"
            fill="currentColor"
          />
          <path
            d="M23 6L18 11L16.5752 9.59961L19.1748 7H16.0205L15.8389 7.00391C15.4166 7.02663 15.003 7.13879 14.626 7.33301C14.198 7.55351 13.8289 7.87369 13.5508 8.2666L8.11719 16.8359C8.1088 16.8491 8.09981 16.8622 8.09082 16.875C7.62618 17.5361 7.00838 18.0753 6.29004 18.4453C5.5736 18.8143 4.77848 19.0035 3.97266 18.999L2 19V17H3.97949C4.46432 17.0033 4.94301 16.889 5.37402 16.667C5.80006 16.4475 6.16667 16.1287 6.44434 15.7383L11.8828 7.16406L11.9092 7.125C12.3738 6.46393 12.9917 5.92473 13.71 5.55469C14.4183 5.18984 15.2036 5.0009 16 5.00098L19.1748 5L16.5752 2.40039L18 1L23 6Z"
            fill="currentColor"
          />
          <path
            d="M3.97266 5C4.77847 4.99554 5.57361 5.18566 6.29004 5.55469C7.00835 5.92473 7.62619 6.46393 8.09082 7.125C8.09979 7.13776 8.10882 7.15089 8.11719 7.16406L8.81543 8.26562L7.63086 10.1328L6.44434 8.26172C6.16668 7.87133 5.80003 7.55247 5.37402 7.33301C4.94302 7.11101 4.4643 6.99669 3.97949 7H2V5H3.97266Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconShuffleOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shuffle_on">
        <path
          id="Vector"
          d="M21 1H3C1.9 1 1 1.9 1 3V21C1 22.1 1.9 23 3 23H21C22.1 23 23 22.1 23 21V3C23 1.9 22.1 1 21 1ZM5.41 4L10.59 9.17L9.18 10.59L4 5.42L5.41 4ZM20 20H14V18H16.61L13.41 14.8L14.83 13.38L18 16.55V14H20V20ZM20 10H18V7.42L5.41 20L4 18.59L16.58 6H14V4H20V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconShutterSpeed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shutter_speed">
        <path
          id="Vector"
          d="M15 1.5H9V3.5H15V1.5ZM19.03 7.89L20.45 6.47C20.02 5.96 19.55 5.48 19.04 5.06L17.62 6.48C16.07 5.24 14.12 4.5 12 4.5C7.03 4.5 3 8.53 3 13.5C3 18.47 7.02 22.5 12 22.5C16.98 22.5 21 18.47 21 13.5C21 11.38 20.26 9.43 19.03 7.89ZM12 20.5C8.13 20.5 5 17.37 5 13.5C5 9.63 8.13 6.5 12 6.5C15.87 6.5 19 9.63 19 13.5C19 17.37 15.87 20.5 12 20.5ZM11.68 15.5H6.35C6.92 17.12 8.17 18.42 9.76 19.06L9.65 19L11.68 15.5ZM17.65 11.5C17.08 9.9 15.87 8.61 14.31 7.96L12.26 11.5H17.65ZM10.61 19.33C11.06 19.44 11.52 19.5 12 19.5C13.34 19.5 14.57 19.05 15.57 18.31L13.46 14.41L10.61 19.33ZM7.55 9.49C6.59 10.55 6 11.96 6 13.5C6 13.84 6.04 14.17 6.09 14.5H10.81L7.55 9.49ZM16.34 17.63C17.37 16.56 18 15.1 18 13.5C18 13.16 17.96 12.83 17.91 12.5H13.57L16.34 17.63ZM13.33 7.65C12.9 7.56 12.46 7.5 12 7.5C10.6 7.5 9.31 7.99 8.29 8.79L10.61 12.35L13.33 7.65Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSick(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sick">
        <path
          id="Vector"
          d="M6.72984 10.56L7.78984 9.5L6.72984 8.44L7.78984 7.38L9.90984 9.5L7.78984 11.62L6.72984 10.56ZM3.90984 9C3.93984 9 3.95984 9.01 3.98984 9.01C5.17984 6.07 8.04984 4 11.4098 4C13.5998 4 15.5698 4.88 17.0198 6.3C17.1698 5.7 17.4698 5.01 17.8298 4.34C16.0898 2.88 13.8498 2 11.3998 2C6.51984 2 2.45984 5.51 1.58984 10.14C2.14984 9.44 2.99984 9 3.90984 9ZM20.4098 10.5C19.9898 10.5 19.5898 10.41 19.2198 10.28C19.3398 10.83 19.4098 11.41 19.4098 12C19.4098 16.42 15.8298 20 11.4098 20C8.04984 20 5.17984 17.93 3.98984 14.99C3.95984 14.99 3.93984 15 3.90984 15C3.38984 15 2.86984 14.86 2.40984 14.6C2.08984 14.42 1.81984 14.18 1.58984 13.9C2.47984 18.51 6.51984 22 11.3898 22C16.9298 22 21.4098 17.52 21.4098 12C21.4098 11.45 21.3498 10.91 21.2698 10.38C20.9898 10.45 20.7098 10.5 20.4098 10.5ZM20.4098 3C20.4098 3 18.4098 5.9 18.4098 7C18.4098 8.1 19.3098 9 20.4098 9C21.5098 9 22.4098 8.1 22.4098 7C22.4098 5.9 20.4098 3 20.4098 3ZM15.0298 7.38L12.9098 9.5L15.0298 11.62L16.0898 10.56L15.0298 9.5L16.0898 8.44L15.0298 7.38ZM7.96984 17C8.65984 15.81 9.93984 15 11.4098 15C12.8798 15 14.1598 15.81 14.8498 17H16.5298C15.7298 14.95 13.7398 13.5 11.4098 13.5C10.5398 13.5 9.70984 13.7 8.97984 14.07L5.39984 12C5.39984 11.48 5.13984 10.98 4.65984 10.71C3.93984 10.3 3.02984 10.54 2.60984 11.26C2.19984 11.98 2.43984 12.89 3.15984 13.31C3.63984 13.59 4.20984 13.56 4.64984 13.31L7.61984 15.03C7.04984 15.56 6.58984 16.24 6.28984 17H7.96984Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignLanguage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sign_language" clipPath="url(#clip0_395_552)">
        <path
          id="Vector"
          d="M12.49 13.0015L11.56 11.1415C11.19 10.4015 11.49 9.50147 12.23 9.13147L12.49 9.00147L18.22 14.4615C18.72 14.9315 19 15.5915 19 16.2715V21.5015C19 22.8815 17.88 24.0015 16.5 24.0015H5.5C4.95 24.0015 4.5 23.5515 4.5 23.0015C4.5 22.4515 4.95 22.0015 5.5 22.0015H10V21.0015H4C3.45 21.0015 3 20.5515 3 20.0015C3 19.4515 3.45 19.0015 4 19.0015H10V18.0015H3C2.45 18.0015 2 17.5515 2 17.0015C2 16.4515 2.45 16.0015 3 16.0015H10V15.0015H4.5C3.95 15.0015 3.5 14.5515 3.5 14.0015C3.5 13.4515 3.95 13.0015 4.5 13.0015H12.49ZM14 13.2015V15.0015H12V22.0015H16C16.55 22.0015 17 21.5515 17 21.0015V16.4715C17 16.2015 16.89 15.9315 16.69 15.7415L14 13.2015ZM11.78 7.12147C10.94 7.52147 10.61 7.74147 10.15 8.31147L7.45 5.46147C7.07 5.06147 7.09 4.43147 7.49 4.05147C7.89 3.67147 8.52 3.69147 8.9 4.09147L11.78 7.12147ZM9.64 9.21147C9.41 9.76147 9.35 10.4515 9.44 11.0015H8.58L6.31 8.61147C5.93 8.21147 5.94 7.58147 6.35 7.20147C6.75 6.82147 7.38 6.84147 7.76 7.24147L9.64 9.21147ZM20.33 13.9115L21.21 13.0815C21.71 12.6115 22 11.9515 22 11.2615V3.35147L21.73 3.25147C20.95 2.97147 20.09 3.37147 19.81 4.15147L19.1 6.11147L13.6 0.311468C13.22 -0.0885323 12.59 -0.108532 12.19 0.271468C11.79 0.651468 11.77 1.28147 12.15 1.68147L15.94 5.67147L15.21 6.36147L10.39 1.28147C10.01 0.881468 9.38 0.861468 8.98 1.24147C8.58 1.62147 8.56 2.25147 8.94 2.65147L12.72 6.63147L15.38 9.00147L17.31 7.13147L18.69 8.58147L20 7.34147V11.0415C20 11.3215 19.89 11.5815 19.69 11.7715L18.99 12.4315L19.6 13.0115C19.89 13.2815 20.13 13.5815 20.33 13.9115Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_552">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconSignalCellular0Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_0_bar">
        <path id="Vector" d="M2 22H22V2L2 22ZM20 20H6.83L20 6.83V20Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSignalCellular4Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_4_bar">
        <path id="Vector" d="M2 22H22V2L2 22Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSignalCellularAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_alt">
        <path
          id="Vector"
          d="M16.5 4H19.5V20H16.5V4ZM4.5 14H7.5V20H4.5V14ZM10.5 9H13.5V20H10.5V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalCellularAlt1Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_alt_1_bar">
        <path id="Vector" d="M10.5 9H13.5V15H10.5V9Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSignalCellularAlt2Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_alt_2_bar">
        <path
          id="Vector"
          d="M7.5 11.5H10.5V17.5H7.5V11.5ZM13.5 6.5H16.5V17.5H13.5V6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalCellularConnectedNoInternet0Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_connected_no_internet_0_bar">
        <path
          id="Vector"
          d="M20 18H22V10H20V18ZM20 22H22V20H20V22ZM18 20V22H2L22 2V8H20V6.83L6.83 20H18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalCellularConnectedNoInternet4Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_connected_no_internet_4_bar">
        <path
          id="Vector"
          d="M20 18H22V10H20V18ZM20 22H22V20H20V22ZM2 22H18V8H22V2L2 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalCellularNoSim(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_no_sim">
        <path
          id="Vector"
          d="M11.0101 4.19H17.1801V13.3L19.1801 15.3V4.19C19.1801 3.09 18.2801 2.19 17.1801 2.19H10.1801L8.12006 4.25L9.54006 5.67L11.0101 4.19ZM21.4401 20.4L3.97006 2.93L2.56006 4.34L5.18006 6.96V18.19C5.18006 19.3 6.08006 20.19 7.18006 20.19H18.4101L20.0301 21.81L21.4401 20.4ZM7.18006 18.19V8.98L16.4101 18.19H7.18006Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalCellularNodata(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_nodata">
        <path
          id="Vector"
          d="M22 13H13V22H2L22 2V13ZM21 15.41L19.59 14L17.5 16.09L15.41 14L14 15.41L16.09 17.5L14 19.59L15.41 21L17.5 18.92L19.59 21L21 19.59L18.92 17.5L21 15.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalCellularNull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_null">
        <path id="Vector" d="M20 6.83V20H6.83L20 6.83ZM22 2L2 22H22V2Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSignalCellularOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_cellular_off">
        <path
          id="Vector"
          d="M21.4299 1L13.1199 9.31L21.4299 17.61V1ZM5.33993 4.36L3.92993 5.77L10.2899 12.14L1.42993 21H19.1599L21.1599 23L22.5699 21.59L5.33993 4.36Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifi0Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_0_bar">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L12 17.67L2.92 8.57Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifi4Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_4_bar">
        <path
          id="Vector"
          d="M12.0101 21.24L23.6401 6.75C23.1901 6.41 18.7101 2.75 12.0001 2.75C5.28011 2.75 0.810107 6.41 0.360107 6.75L11.9901 21.24L12.0001 21.25L12.0101 21.24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifi4BarLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_4_bar_lock">
        <g id="Vector">
          <path
            d="M21.98 10.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L15.05 17.45V14.5C15.05 14.05 15.14 13.62 15.28 13.21C15.82 11.64 17.29 10.5 19.05 10.5H21.98Z"
            fill="currentColor"
          />
          <path
            d="M22 15.5V14.5C22 13.4 21.1 12.5 20 12.5C18.9 12.5 18 13.4 18 14.5V15.5C17.45 15.5 17 15.95 17 16.5V19.5C17 20.05 17.45 20.5 18 20.5H22C22.55 20.5 23 20.05 23 19.5V16.5C23 15.95 22.55 15.5 22 15.5ZM21 15.5H19V14.5C19 13.95 19.45 13.5 20 13.5C20.55 13.5 21 13.95 21 14.5V15.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSignalWifiBad(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_bad">
        <path
          id="Vector"
          d="M24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5V11.5H20.99L24 8.48ZM19.59 13.5L17.5 15.59L15.41 13.5L14 14.91L16.09 17L14 19.09L15.41 20.5L17.5 18.42L19.59 20.5L21 19.09L18.92 17L21 14.91L19.59 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifiConnectedNoInternet4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_connected_no_internet_4">
        <path
          id="Vector"
          d="M24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5V11.5H20.99L24 8.48ZM19.59 13.5L17.5 15.59L15.41 13.5L14 14.91L16.09 17L14 19.09L15.41 20.5L17.5 18.42L19.59 20.5L21 19.09L18.92 17L21 14.91L19.59 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifiOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_off">
        <path
          id="Vector"
          d="M23.6401 7.59503C23.1901 7.25503 18.7101 3.59503 12.0001 3.59503C10.6801 3.59503 9.45011 3.73503 8.31011 3.97503L18.4301 14.095L23.6401 7.59503ZM3.41011 1.90503L2.00011 3.31503L4.05011 5.36503C1.91011 6.35503 0.590107 7.41503 0.360107 7.59503L12.0001 22.095L15.9101 17.225L19.2301 20.545L20.6401 19.135L3.41011 1.90503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifiStatusbar4Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_statusbar_4_bar">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignalWifiStatusbarConnectedNoInternet4(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_statusbar_connected_no_internet_4">
        <g id="Vector">
          <path
            d="M12.54 3.5C7.85004 3.5 3.61004 5.4 0.540039 8.48L12.54 20.5L17.54 15.49V7.5H23.46C20.51 5.01 16.7 3.5 12.54 3.5Z"
            fill="currentColor"
          />
          <path d="M21.54 17.5H19.54V19.5H21.54V17.5Z" fill="currentColor" />
          <path d="M21.54 9.5H19.54V15.5H21.54V9.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconSignalWifiStatusbarNull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signal_wifi_statusbar_null">
        <path
          id="Vector"
          d="M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM2.92 8.57C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L12 17.67L2.92 8.57Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSignpost(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="signpost">
        <path
          id="Vector"
          d="M13 10H18L21 7L18 4H13V2H11V4H4V10H11V12H6L3 15L6 18H11V22H13V18H20V12H13V10ZM6 6H17.17L18.17 7L17.17 8H6V6ZM18 16H6.83L5.83 15L6.83 14H18V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSimCard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sim_card">
        <path
          id="Vector"
          d="M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V20H6V8.83L10.83 4H18ZM7 17H9V19H7V17ZM15 17H17V19H15V17ZM7 11H9V15H7V11ZM11 15H13V19H11V15ZM11 11H13V13H11V11ZM15 11H17V15H15V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSimCardAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sim_card_alert">
        <g id="Vector">
          <path
            d="M18 2H10L4.02 8L4 20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H6V8.83L10.83 4H18V20Z"
            fill="currentColor"
          />
          <path d="M13 15H11V17H13V15Z" fill="currentColor" />
          <path d="M13 8H11V13H13V8Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconSimCardDownload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sim_card_download">
        <g id="Vector">
          <path
            d="M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V20H6V8.83L10.83 4H18Z"
            fill="currentColor"
          />
          <path
            d="M16 13L12 17L8 13L9.41 11.59L11 13.17V9.02L13 9V13.17L14.59 11.58L16 13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSingleBed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="single_bed">
        <path
          id="Vector"
          d="M20 12C20 10.9 19.1 10 18 10V7C18 5.9 17.1 5 16 5H8C6.9 5 6 5.9 6 7V10C4.9 10 4 10.9 4 12V17H5.33L6 19H7L7.67 17H16.34L17 19H18L18.67 17H20V12ZM16 10H13V7H16V10ZM8 7H11V10H8V7ZM6 12H18V15H6V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSip(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sip">
        <path
          id="Vector"
          d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM4 6V18H20V6H4ZM11 9H13V15H11V9ZM14 9H18C18.55 9 19 9.45 19 10V12C19 12.55 18.55 13 18 13H15.5V15H14V9ZM17.5 10.5H15.5V11.5H17.5V10.5ZM6.5 11.25H9C9.55 11.25 10 11.7 10 12.25V14C10 14.55 9.55 15 9 15H5V13.5H8.5V12.75H6C5.45 12.75 5 12.3 5 11.75V10C5 9.45 5.45 9 6 9H10V10.5H6.5V11.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSkateboarding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="skateboarding">
        <path
          id="Vector"
          d="M13.5 2.5C13.5 1.4 14.4 0.5 15.5 0.5C16.6 0.5 17.5 1.4 17.5 2.5C17.5 3.6 16.6 4.5 15.5 4.5C14.4 4.5 13.5 3.6 13.5 2.5ZM7.75 22C7.34 22 7 22.34 7 22.75C7 23.16 7.34 23.5 7.75 23.5C8.16 23.5 8.5 23.16 8.5 22.75C8.5 22.34 8.16 22 7.75 22ZM16.25 22C15.84 22 15.5 22.34 15.5 22.75C15.5 23.16 15.84 23.5 16.25 23.5C16.66 23.5 17 23.16 17 22.75C17 22.34 16.66 22 16.25 22ZM19.74 18.5C19.5 18.5 19.29 18.61 19.15 18.8C18.6 19.53 17.73 20 16.75 20H16.5V14L12.18 11.33L13.98 8.44C15.13 10.28 17.18 11.5 19.5 11.5V9.5C17.65 9.5 16.06 8.38 15.37 6.78L14.85 5.57C14.66 5.14 14.11 4.5 13.2 4.5H7.5L5 8.5L6.7 9.56L8.6 6.5H10.95L8.55 10.34C8.24 10.84 8.16 11.45 8.34 12.01L9.68 16.16L6.56 19.92C5.86 19.76 5.26 19.35 4.85 18.8C4.71 18.61 4.49 18.5 4.25 18.5C3.81 18.5 3.5 18.86 3.5 19.25C3.5 19.4 3.55 19.56 3.65 19.7C4.47 20.8 5.78 21.5 7.25 21.5H16.75C18.22 21.5 19.53 20.8 20.35 19.7C20.45 19.56 20.5 19.4 20.5 19.25C20.5 18.86 20.18 18.5 19.74 18.5ZM14.5 20H9.1L12 16.5L11 13.2L14.5 15.4V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSkipNext(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="skip_next">
        <path
          id="Vector"
          d="M6 18L14.5 12L6 6V18ZM8 9.86L11.03 12L8 14.14V9.86ZM16 6H18V18H16V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSkipPrevious(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="skip_previous">
        <path
          id="Vector"
          d="M6 6H8V18H6V6ZM9.5 12L18 18V6L9.5 12ZM16 14.14L12.97 12L16 9.86V14.14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSledding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sledding">
        <path
          id="Vector"
          d="M14.0005 3.74719C14.0005 4.84719 13.1005 5.74719 12.0005 5.74719C10.9005 5.74719 10.0005 4.84719 10.0005 3.74719C10.0005 2.64719 10.9005 1.74719 12.0005 1.74719C13.1005 1.74719 14.0005 2.64719 14.0005 3.74719ZM22.8005 19.4872C22.1205 21.5872 19.8605 22.7372 17.7605 22.0572L1.00049 16.6072L1.46049 15.1772L5.39049 16.4572L5.85049 15.0272L1.93049 13.7472L2.39049 12.3172L4.00049 12.8472V8.74719L9.47049 6.39719C9.86049 6.22719 10.3105 6.18719 10.7505 6.32719C11.7005 6.63719 12.2105 7.64719 11.9105 8.59719L10.8605 11.8372L13.0005 11.4972C13.8905 11.3472 14.7605 11.8172 15.1405 12.6372L17.2205 17.1472L19.1505 17.7772L18.6905 19.2072L15.3705 18.1272L14.9005 19.5472L18.2205 20.6272C19.5305 21.0572 20.9405 20.3372 21.3705 19.0172C21.8005 17.7072 21.0805 16.2972 19.7605 15.8672L20.2205 14.4372C22.3305 15.1272 23.4905 17.3872 22.8005 19.4872ZM6.00049 13.4972L7.01049 13.8272C6.79049 13.4072 6.73049 12.9072 6.89049 12.4272L7.92049 9.24719L6.00049 10.0672V13.4972ZM13.9405 17.6572L7.28049 15.4972L6.82049 16.9272L13.4805 19.0872L13.9405 17.6572ZM14.6305 16.2972L13.4505 13.7372L9.48049 14.6272L14.6305 16.2972Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSlideshow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="slideshow">
        <path
          id="Vector"
          d="M10 8V16L15 12L10 8ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSlowMotionVideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="slow_motion_video">
        <path
          id="Vector"
          d="M13.0249 9.78999L9.9749 7.49999V16.5L13.0249 14.21L15.9749 12L13.0249 9.78999ZM13.0249 9.78999L9.9749 7.49999V16.5L13.0249 14.21L15.9749 12L13.0249 9.78999ZM13.0249 9.78999L9.9749 7.49999V16.5L13.0249 14.21L15.9749 12L13.0249 9.78999ZM10.9749 4.06999V2.04999C8.9649 2.24999 7.1349 3.04999 5.6549 4.25999L7.0749 5.68999C8.1849 4.82999 9.5149 4.24999 10.9749 4.06999ZM5.6649 7.09999L4.2349 5.67999C3.0249 7.15999 2.2249 8.98999 2.0249 11H4.0449C4.2249 9.53999 4.8049 8.20999 5.6649 7.09999ZM4.0449 13H2.0249C2.2249 15.01 3.0249 16.84 4.2349 18.32L5.6649 16.89C4.8049 15.79 4.2249 14.46 4.0449 13ZM5.6549 19.74C7.1349 20.95 8.9749 21.75 10.9749 21.95V19.93C9.5149 19.75 8.1849 19.17 7.0749 18.31L5.6549 19.74ZM21.9749 12C21.9749 17.16 18.0549 21.42 13.0249 21.95V19.93C16.9449 19.41 19.9749 16.05 19.9749 12C19.9749 7.94999 16.9449 4.58999 13.0249 4.06999V2.04999C18.0549 2.57999 21.9749 6.83999 21.9749 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSmartButton(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smart_button">
        <path
          id="Vector"
          d="M22 8V14C22 15.1 21.1 16 20 16H19V14H20V8H4V14H10V16H4C2.9 16 2 15.1 2 14V8C2 6.9 2.9 6 4 6H20C21.1 6 22 6.9 22 8ZM14.5 18L15.59 15.59L18 14.5L15.59 13.41L14.5 11L13.41 13.41L11 14.5L13.41 15.59L14.5 18ZM17 13L17.62 11.62L19 11L17.62 10.38L17 9L16.38 10.38L15 11L16.38 11.62L17 13ZM14.5 18L15.59 15.59L18 14.5L15.59 13.41L14.5 11L13.41 13.41L11 14.5L13.41 15.59L14.5 18ZM17 13L17.62 11.62L19 11L17.62 10.38L17 9L16.38 10.38L15 11L16.38 11.62L17 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSmartDisplay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smart_display">
        <g id="Vector">
          <path d="M9.5 7.5V16.5L16.5 12L9.5 7.5Z" fill="currentColor" />
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18.01H4V5.99H20V18.01Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSmartScreen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smart_screen">
        <g id="Vector">
          <path d="M14 11.25H12.5V12.75H14V11.25Z" fill="currentColor" />
          <path d="M16.5 11.25H15V12.75H16.5V11.25Z" fill="currentColor" />
          <path d="M11.5 11.25H10V12.75H11.5V11.25Z" fill="currentColor" />
          <path d="M9 11.25H7.5V12.75H9V11.25Z" fill="currentColor" />
          <path
            d="M21 5H3C1.9 5 1 5.9 1 7V17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5ZM4 17H3V7H4V17ZM18 17H6V7H18V17ZM21 17H20V7H21V17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSmartToy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smart_toy">
        <path
          id="Vector"
          d="M20 9.5V7.5C20 6.4 19.1 5.5 18 5.5H15C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5H6C4.9 5.5 4 6.4 4 7.5V9.5C2.34 9.5 1 10.84 1 12.5C1 14.16 2.34 15.5 4 15.5V19.5C4 20.6 4.9 21.5 6 21.5H18C19.1 21.5 20 20.6 20 19.5V15.5C21.66 15.5 23 14.16 23 12.5C23 10.84 21.66 9.5 20 9.5ZM18 19.5H6V7.5H18V19.5ZM9 13.5C8.17 13.5 7.5 12.83 7.5 12C7.5 11.17 8.17 10.5 9 10.5C9.83 10.5 10.5 11.17 10.5 12C10.5 12.83 9.83 13.5 9 13.5ZM16.5 12C16.5 12.83 15.83 13.5 15 13.5C14.17 13.5 13.5 12.83 13.5 12C13.5 11.17 14.17 10.5 15 10.5C15.83 10.5 16.5 11.17 16.5 12ZM8 15.5H16V17.5H8V15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSmartphone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smartphone">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSmokeFree(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smoke_free">
        <path
          id="Vector"
          d="M20.5 12.525H22V15.525H20.5V12.525ZM18 12.525H19.5V15.525H18V12.525ZM17 12.525H14.66L17 14.865V12.525ZM14.5 8.17501H16.03C17.08 8.17501 18 8.91501 18 10.225V11.525H19.5V9.88501C19.5 8.07501 17.9 6.72501 16.03 6.72501H14.5C13.48 6.72501 12.65 5.74501 12.65 4.72501C12.65 3.70501 13.48 2.97501 14.5 2.97501V1.47501C12.65 1.47501 11.15 2.97501 11.15 4.82501C11.15 6.67501 12.65 8.17501 14.5 8.17501ZM18.85 4.25501C19.47 3.64501 19.85 2.80501 19.85 1.87501H18.35C18.35 2.89501 17.52 3.72501 16.5 3.72501V5.22501C18.74 5.22501 20.5 7.05501 20.5 9.29501V11.525H22V9.28501C22 7.06501 20.72 5.14501 18.85 4.25501ZM3.41 4.11501L2 5.52501L9 12.525H2V15.525H12L19 22.525L20.41 21.115L3.41 4.11501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSmokingRooms(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="smoking_rooms">
        <path
          id="Vector"
          d="M18 17.5H19.5V20.5H18V17.5ZM2 17.5H17V20.5H2V17.5ZM16.03 11.7H14.5C13.48 11.7 12.65 10.72 12.65 9.7C12.65 8.68 13.48 7.95 14.5 7.95V6.45C12.65 6.45 11.15 7.95 11.15 9.8C11.15 11.65 12.65 13.15 14.5 13.15H16.03C17.08 13.15 18 13.89 18 15.2V16.5H19.5V14.86C19.5 13.05 17.9 11.7 16.03 11.7ZM20.5 17.5H22V20.5H20.5V17.5ZM18.85 9.23C19.47 8.62 19.85 7.78 19.85 6.85C19.85 5 18.35 3.5 16.5 3.5V5C17.52 5 18.35 5.83 18.35 6.85C18.35 7.87 17.52 8.7 16.5 8.7V10.2C18.74 10.2 20.5 12.03 20.5 14.27V16.5H22V14.26C22 12.04 20.72 10.12 18.85 9.23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSms(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sms">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM7 9H9V11H7V9ZM15 9H17V11H15V9ZM11 9H13V11H11V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSmsFailed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sms_failed">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM11 12H13V14H11V12ZM11 6H13V10H11V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSnippetFolder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="snippet_folder">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM17.5 12.12V15.5H14.5V10.5H15.88L17.5 12.12ZM13 9V17H19V11.5L16.5 9H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSnooze(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="snooze">
        <path
          id="Vector"
          d="M8.99942 11.095H12.6294L8.99942 15.295V17.095H14.9994V15.095H11.3694L14.9994 10.895V9.09503H8.99942V11.095ZM16.0554 3.44103L17.3374 1.90603L21.9444 5.75603L20.6644 7.29603L16.0554 3.44103ZM3.33542 7.28503L2.05542 5.74903L6.66142 1.90503L7.94142 3.44103L3.33542 7.28503ZM11.9994 6.09503C15.8594 6.09503 18.9994 9.23503 18.9994 13.095C18.9994 16.955 15.8594 20.095 11.9994 20.095C8.13942 20.095 4.99942 16.955 4.99942 13.095C4.99942 9.23503 8.13942 6.09503 11.9994 6.09503ZM11.9994 4.09503C7.02942 4.09503 2.99942 8.12503 2.99942 13.095C2.99942 18.065 7.02942 22.095 11.9994 22.095C16.9694 22.095 20.9994 18.065 20.9994 13.095C20.9994 8.12503 16.9694 4.09503 11.9994 4.09503Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSnowboarding(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="snowboarding">
        <path
          id="Vector"
          d="M13.9989 3.24939C13.9989 2.14939 14.8989 1.24939 15.9989 1.24939C17.0989 1.24939 17.9989 2.14939 17.9989 3.24939C17.9989 4.34939 17.0989 5.24939 15.9989 5.24939C14.8989 5.24939 13.9989 4.34939 13.9989 3.24939ZM21.3989 20.3394C21.1689 20.2894 20.9389 20.3594 20.7589 20.5094C20.0689 21.1094 19.1189 21.3894 18.1589 21.1794L16.9989 20.9394L15.9989 14.7494L12.6789 12.0794L14.4789 9.18939C15.6289 11.0294 17.6789 12.2494 19.9989 12.2494V10.2494C18.1489 10.2494 16.5589 9.12939 15.8689 7.52939L15.3489 6.31939C15.1589 5.88939 14.6089 5.24939 13.6989 5.24939H7.99892L5.49892 9.24939L7.19892 10.3094L9.09892 7.24939H11.4489L8.93892 11.2394C8.65892 11.6894 8.56892 12.2394 8.68892 12.7594L9.49892 16.2494L5.99892 18.5994L5.52892 18.4994C4.56892 18.2994 3.81892 17.6494 3.42892 16.8294C3.32892 16.6194 3.14892 16.4594 2.91892 16.4094C2.48892 16.3194 2.09892 16.6094 2.01892 16.9894C1.97892 17.1294 1.99892 17.2994 2.06892 17.4494C2.64892 18.6894 3.77892 19.6494 5.21892 19.9594L17.8489 22.6494C19.2889 22.9594 20.7089 22.5394 21.7489 21.6394C21.8789 21.5294 21.9589 21.3794 21.9889 21.2294C22.0589 20.8494 21.8289 20.4294 21.3989 20.3394ZM8.72892 19.1794L11.7489 17.1494L11.3089 13.8294L14.1489 15.8494L14.8989 20.4894L8.72892 19.1794Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSnowmobile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="snowmobile">
        <path
          id="Vector"
          d="M22 16.5C22 17.05 21.55 17.5 21 17.5H20.83L18.63 15.3C20.58 14.87 22 13.9 22 12.5C22 11.5 14 4.5 14 4.5H11V6.5H13.25L14.05 7.22L11 9.5L2 8.5L0 12.5L4.54 13.86L1.05 15.74C-0.77 16.72 -0.0699999 19.5 2 19.5H8C10.21 19.5 12 17.71 12 15.5H16L18 17.5H15V19.5H21C22.66 19.5 24 18.16 24 16.5H22ZM8 17.5H2L7.25 14.67L10 15.5C10 16.6 9.11 17.5 8 17.5ZM17 13.5H10.3L2.85 11.27L3.16 10.65L11.6 11.5L15.53 8.56C15.53 8.56 19.3 12 19.8 12.7C19.8 12.7 18.7 13.5 17 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSnowshoeing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="snowshoeing">
        <path
          id="Vector"
          d="M12.5 3.25C12.5 2.15 13.4 1.25 14.5 1.25C15.6 1.25 16.5 2.15 16.5 3.25C16.5 4.35 15.6 5.25 14.5 5.25C13.4 5.25 12.5 4.35 12.5 3.25ZM6.32 18.78L5.18 17.31L4 18.25L6.38 21.29C6.89 21.94 7.54 22.44 8.26 22.7C8.54 22.8 8.79 22.74 8.98 22.59C9.28 22.36 9.4 21.89 9.1 21.52C9.02 21.42 8.9 21.35 8.79 21.3C8.36 21.12 7.97 20.85 7.65 20.47L7.57 20.37L11 17.95L11.89 14.73L14 16.73V21.25H12V22.75H15.87C16.69 22.75 17.48 22.54 18.13 22.14C18.39 21.98 18.5 21.75 18.5 21.5C18.5 21.12 18.2 20.75 17.73 20.75C17.6 20.75 17.47 20.79 17.36 20.85C16.96 21.08 16.49 21.22 16 21.25V15.23L13.89 13.23L14.49 10.23C15.79 11.73 17.8 12.75 20 12.75V10.75C18.1 10.75 16.49 9.73 15.69 8.33L14.69 6.75C14.29 6.15 13.69 5.75 12.99 5.75C12.24 5.75 11.58 6.09 7 8.03V12.75H9V9.33L10.79 8.63L9.2 16.75L6.32 18.78Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSoap(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="soap">
        <path
          id="Vector"
          d="M14.75 6C15.16 6 15.5 6.34 15.5 6.75C15.5 7.16 15.16 7.5 14.75 7.5C14.34 7.5 14 7.16 14 6.75C14 6.34 14.34 6 14.75 6ZM14.75 4.5C13.51 4.5 12.5 5.51 12.5 6.75C12.5 7.99 13.51 9 14.75 9C15.99 9 17 7.99 17 6.75C17 5.51 15.99 4.5 14.75 4.5ZM20.5 5.5C20.78 5.5 21 5.72 21 6C21 6.28 20.78 6.5 20.5 6.5C20.22 6.5 20 6.28 20 6C20 5.72 20.22 5.5 20.5 5.5ZM20.5 4C19.4 4 18.5 4.9 18.5 6C18.5 7.1 19.4 8 20.5 8C21.6 8 22.5 7.1 22.5 6C22.5 4.9 21.6 4 20.5 4ZM17 1C16.17 1 15.5 1.67 15.5 2.5C15.5 3.33 16.17 4 17 4C17.83 4 18.5 3.33 18.5 2.5C18.5 1.67 17.83 1 17 1ZM21.25 16C21.94 16 22.5 15.44 22.5 14.75C22.5 14.06 21.94 13.5 21.25 13.5H12.5V12.5H19.25C19.94 12.5 20.5 11.94 20.5 11.25C20.5 10.58 19.97 10.05 19.32 10.01L9.37 10L10.85 7.4C10.94 7.23 10.99 7.06 10.99 6.86C10.99 6.6 10.9 6.36 10.73 6.16L9.62 5L2.44 11.8C1.84 12.36 1.5 13.15 1.5 13.97V20C1.5 21.66 2.84 23 4.5 23H18.25C18.94 23 19.5 22.44 19.5 21.75C19.5 21.06 18.94 20.5 18.25 20.5H12.5V19.5H20.25C20.94 19.5 21.5 18.94 21.5 18.25C21.5 17.56 20.94 17 20.25 17H12.5V16H21.25ZM10.5 21H4.5C3.95 21 3.5 20.55 3.5 20V14C3.5 13.61 3.73 13.36 3.86 13.25L7.5 9.87V12H10.5V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSocialDistance(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="social_distance">
        <path
          id="Vector"
          d="M4 5.005C4 3.905 4.9 3.005 6 3.005C7.1 3.005 8 3.905 8 5.005C8 6.105 7.1 7.005 6 7.005C4.9 7.005 4 6.105 4 5.005ZM8.78 8.585C7.93 8.215 6.99 8.005 6 8.005C5.01 8.005 4.07 8.215 3.22 8.585C2.48 8.905 2 9.62501 2 10.435V11.005H10V10.435C10 9.62501 9.52 8.905 8.78 8.585ZM18 7.005C19.1 7.005 20 6.105 20 5.005C20 3.905 19.1 3.005 18 3.005C16.9 3.005 16 3.905 16 5.005C16 6.105 16.9 7.005 18 7.005ZM20.78 8.585C19.93 8.215 18.99 8.005 18 8.005C17.01 8.005 16.07 8.215 15.22 8.585C14.48 8.905 14 9.62501 14 10.435V11.005H22V10.435C22 9.62501 21.52 8.905 20.78 8.585ZM18.01 13.015L16.6 14.425L18.17 16.005H5.83L7.41 14.415L6 13.005L2 17.005L5.99 20.995L7.4 19.585L5.83 18.005H18.17L16.59 19.585L18 20.995L22 17.005L18.01 13.015Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSolarPower(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="solar_power">
        <g id="Vector">
          <path
            d="M20 12H4L2 22H22L20 12ZM18.36 14L18.76 16H13V14H18.36ZM11 14V16H5.24L5.64 14H11ZM4.84 18H11V20H4.44L4.84 18ZM13 20V18H19.16L19.56 20H13Z"
            fill="currentColor"
          />
          <path d="M13 8H11V11H13V8Z" fill="currentColor" />
          <path
            d="M17.1787 5.79096L15.7645 7.20516L17.8858 9.32646L19.3 7.91226L17.1787 5.79096Z"
            fill="currentColor"
          />
          <path
            d="M6.82616 5.79149L4.70486 7.91279L6.11906 9.32699L8.24036 7.20569L6.82616 5.79149Z"
            fill="currentColor"
          />
          <path d="M6 2H3V4H6V2Z" fill="currentColor" />
          <path d="M21 2H18V4H21V2Z" fill="currentColor" />
          <path
            d="M12 7C14.76 7 17 4.76 17 2H15C15 3.65 13.65 5 12 5C10.35 5 9 3.65 9 2H7C7 4.76 9.24 7 12 7Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSort(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sort">
        <path id="Vector" d="M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSortByAlpha(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sort_by_alpha">
        <path
          id="Vector"
          d="M15.215 4.65999H10.495L12.855 2.29999L15.215 4.65999ZM10.525 19.37H15.185L12.855 21.7L10.525 19.37ZM6.375 6.26999L1.875 17.73H3.715L4.635 15.28H9.745L10.665 17.73H12.505L8.015 6.26999H6.375ZM5.245 13.64L7.185 8.45999L9.125 13.64H5.245ZM16.005 16.14H22.125V17.73H13.595V16.44L19.515 7.87999H13.635V6.27999H21.935V7.53999L16.005 16.14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSos(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sos">
        <path
          id="Vector"
          d="M13.5 7H10.5C9.4 7 8.5 7.9 8.5 9V15C8.5 16.1 9.4 17 10.5 17H13.5C14.6 17 15.5 16.1 15.5 15V9C15.5 7.9 14.6 7 13.5 7ZM13.5 15H10.5V9H13.5V15ZM1 15H5V13H3C1.9 13 1 12.1 1 11V9C1 7.9 1.9 7 3 7H7V9H3V11H5C6.1 11 7 11.9 7 13V15C7 16.1 6.1 17 5 17H1V15ZM17 15H21V13H19C17.9 13 17 12.1 17 11V9C17 7.9 17.9 7 19 7H23V9H19V11H21C22.1 11 23 11.9 23 13V15C23 16.1 22.1 17 21 17H17V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSoupKitchen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="soup_kitchen">
        <path
          id="Vector"
          d="M6.10041 7C5.76041 7.55 5.70041 7.97 5.70041 8.38C5.70041 9.15 6.70041 11 6.70041 12C6.70041 12.95 6.30041 13.5 6.30041 13.5H4.80041C4.80041 13.5 5.20041 12.95 5.20041 12C5.20041 11 4.20041 9.15 4.20041 8.38C4.20041 7.97 4.26041 7.55 4.60041 7H6.10041ZM11.1004 7C10.7604 7.55 10.7004 7.97 10.7004 8.38C10.7004 9.15 11.7004 11 11.7004 12C11.7004 12.95 11.3004 13.5 11.3004 13.5H12.8004C12.8004 13.5 13.2004 12.95 13.2004 12C13.2004 11 12.2004 9.15 12.2004 8.38C12.2004 7.97 12.2604 7.55 12.6004 7H11.1004ZM7.85041 7C7.51041 7.55 7.45041 7.97 7.45041 8.38C7.45041 9.15 8.45041 11.01 8.45041 12C8.45041 12.95 8.05041 13.5 8.05041 13.5H9.55041C9.55041 13.5 9.95041 12.95 9.95041 12C9.95041 11 8.95041 9.15 8.95041 8.38C8.95041 7.97 9.01041 7.55 9.35041 7H7.85041ZM18.3004 2C16.7604 2 15.4904 3.16 15.3204 4.65L14.2304 15H3.71041C3.11041 15 2.62041 15.53 2.71041 16.13C3.23041 19.46 6.09041 22 9.45041 22C12.9304 22 15.7904 19.27 16.1604 15.77L17.3104 4.9C17.3604 4.39 17.7804 4 18.3004 4C18.8504 4 19.3004 4.45 19.3004 5C19.3004 5.3 19.2004 6.25 19.2004 6.25L21.1704 6.5C21.1704 6.5 21.3004 5.44 21.3004 5C21.3004 3.35 19.9504 2 18.3004 2ZM9.45041 20C7.51041 20 5.78041 18.77 5.02041 17H13.8104C13.0904 18.78 11.3904 20 9.45041 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSource(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="source">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSouth(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="south">
        <path
          id="Vector"
          d="M19 15L17.59 13.59L13 18.17V2H11V18.17L6.41 13.58L5 15L12 22L19 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSouthAmerica(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="south_america">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 10.05 4.7 8.26 5.87 6.87L9 10V11C9 12.1 9.9 13 11 13V18.59C11 18.86 11.11 19.11 11.29 19.3L12 20C7.58 20 4 16.42 4 12ZM13 19.94V18L16.75 12.38C16.91 12.13 17 11.84 17 11.55V10.5C17 9.95 16.55 9.5 16 9.5H14.5L13.1 7.75C12.72 7.28 12.15 7 11.54 7H8V5.07C9.18 4.39 10.54 4 12 4C16.41 4 20 7.59 20 12C20 16.07 16.94 19.44 13 19.94Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSouthEast(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="south_east">
        <path
          id="Vector"
          d="M19.5 9.5H17.5V16.09L5.91 4.5L4.5 5.91L16.09 17.5H9.5V19.5H19.5V9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSouthWest(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="south_west">
        <path
          id="Vector"
          d="M14.5 19.5V17.5H7.91L19.5 5.91L18.09 4.5L6.5 16.09V9.5H4.5V19.5H14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpa(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="spa">
        <path
          id="Vector"
          d="M15.49 9.63C15.31 6.84 14.18 4.12 12.06 2C9.92 4.14 8.74 6.86 8.51 9.63C9.79 10.31 10.97 11.19 12 12.26C13.03 11.2 14.21 10.32 15.49 9.63ZM12.05 5.19C12.68 6.22 13.12 7.37 13.35 8.57C12.88 8.87 12.44 9.2 12.01 9.55C11.59 9.21 11.14 8.88 10.68 8.58C10.93 7.38 11.39 6.23 12.05 5.19ZM12 15.45C11.18 14.2 10.14 13.11 8.94 12.25C8.81 12.16 8.67 12.09 8.54 11.99C8.67 12.08 8.81 12.16 8.93 12.24C6.98 10.83 4.59 10 2 10C2 15.32 5.36 19.82 10.03 21.49C10.66 21.72 11.32 21.89 12 22C12.68 21.88 13.33 21.71 13.97 21.49C18.64 19.82 22 15.32 22 10C17.82 10 14.15 12.17 12 15.45ZM13.32 19.6C12.88 19.75 12.44 19.87 11.99 19.97C11.55 19.88 11.12 19.76 10.71 19.61C7.42 18.43 5.01 15.62 4.26 12.26C5.36 12.52 6.41 12.97 7.38 13.59L7.36 13.6C7.49 13.69 7.62 13.78 7.75 13.85L7.82 13.89C8.81 14.61 9.66 15.5 10.33 16.54L12 19.1L13.67 16.55C14.36 15.5 15.22 14.6 16.2 13.89L16.27 13.84C16.36 13.79 16.45 13.73 16.54 13.67L16.53 13.65C17.51 13 18.6 12.52 19.74 12.25C18.99 15.62 16.59 18.43 13.32 19.6ZM8.99 12.28C8.97 12.27 8.95 12.25 8.94 12.24C8.94 12.24 8.95 12.24 8.95 12.25C8.96 12.26 8.97 12.27 8.99 12.28Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpaceBar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="space_bar">
        <path id="Vector" d="M18 9V13H6V9H4V15H20V9H18Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSpaceDashboard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="space_dashboard">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 19V5H11V19H5ZM19 19H13V12H19V19ZM19 10H13V5H19V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpatialAudio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="spatial_audio">
        <g id="Vector">
          <path
            d="M9.5 14C11.71 14 13.5 12.21 13.5 10C13.5 7.79 11.71 6 9.5 6C7.29 6 5.5 7.79 5.5 10C5.5 12.21 7.29 14 9.5 14ZM9.5 8C10.6 8 11.5 8.9 11.5 10C11.5 11.1 10.6 12 9.5 12C8.4 12 7.5 11.1 7.5 10C7.5 8.9 8.4 8 9.5 8Z"
            fill="currentColor"
          />
          <path
            d="M15.89 16.56C14.21 15.7 12.03 15 9.5 15C6.97 15 4.79 15.7 3.11 16.56C2.11 17.07 1.5 18.1 1.5 19.22V22H17.5V19.22C17.5 18.1 16.89 17.07 15.89 16.56ZM15.5 20H3.5V19.22C3.5 18.84 3.7 18.5 4.02 18.34C5.21 17.73 7.13 17 9.5 17C11.87 17 13.79 17.73 14.98 18.34C15.3 18.5 15.5 18.84 15.5 19.22V20Z"
            fill="currentColor"
          />
          <path
            d="M15.5 2H13.5C13.5 6.97 17.53 11 22.5 11V9C18.64 9 15.5 5.86 15.5 2Z"
            fill="currentColor"
          />
          <path
            d="M19.5 2H17.5C17.5 4.76 19.74 7 22.5 7V5C20.85 5 19.5 3.65 19.5 2Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSpatialAudioOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="spatial_audio_off">
        <g id="Vector">
          <path
            d="M9.5 14C11.71 14 13.5 12.21 13.5 10C13.5 7.79 11.71 6 9.5 6C7.29 6 5.5 7.79 5.5 10C5.5 12.21 7.29 14 9.5 14ZM9.5 8C10.6 8 11.5 8.9 11.5 10C11.5 11.1 10.6 12 9.5 12C8.4 12 7.5 11.1 7.5 10C7.5 8.9 8.4 8 9.5 8Z"
            fill="currentColor"
          />
          <path
            d="M15.89 16.56C14.21 15.7 12.03 15 9.5 15C6.97 15 4.79 15.7 3.11 16.56C2.11 17.07 1.5 18.1 1.5 19.22V22H17.5V19.22C17.5 18.1 16.89 17.07 15.89 16.56ZM15.5 20H3.5V19.22C3.5 18.84 3.7 18.5 4.02 18.34C5.21 17.73 7.13 17 9.5 17C11.87 17 13.79 17.73 14.98 18.34C15.3 18.5 15.5 18.84 15.5 19.22V20Z"
            fill="currentColor"
          />
          <path
            d="M19.86 2L18.45 3.41C21.18 6.14 21.18 10.58 18.45 13.31L19.86 14.72C23.38 11.21 23.38 5.51 19.86 2Z"
            fill="currentColor"
          />
          <path
            d="M17.04 11.9C18.99 9.95 18.99 6.78 17.04 4.83L15.63 6.24C16.8 7.41 16.8 9.31 15.63 10.48L17.04 11.9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSpatialTracking(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="spatial_tracking">
        <g id="Vector">
          <path
            d="M9.56006 14C11.7701 14 13.5601 12.21 13.5601 10C13.5601 7.79 11.7701 6 9.56006 6C7.35006 6 5.56006 7.79 5.56006 10C5.56006 12.21 7.35006 14 9.56006 14ZM9.56006 8C10.6601 8 11.5601 8.9 11.5601 10C11.5601 11.1 10.6601 12 9.56006 12C8.46006 12 7.56006 11.1 7.56006 10C7.56006 8.9 8.46006 8 9.56006 8Z"
            fill="currentColor"
          />
          <path
            d="M15.9501 16.56C14.2701 15.7 12.0901 15 9.56006 15C7.03006 15 4.85006 15.7 3.17006 16.56C2.17006 17.07 1.56006 18.1 1.56006 19.22V22H17.5601V19.22C17.5601 18.1 16.9501 17.07 15.9501 16.56ZM15.5601 20H3.56006V19.22C3.56006 18.84 3.76006 18.5 4.08006 18.34C5.27006 17.73 7.19006 17 9.56006 17C11.9301 17 13.8501 17.73 15.0401 18.34C15.3601 18.5 15.5601 18.84 15.5601 19.22V20Z"
            fill="currentColor"
          />
          <path
            d="M19.6101 3.41L18.2001 2C14.6901 5.51 14.6901 11.21 18.2001 14.73L19.6101 13.32C16.8801 10.58 16.8801 6.14 19.6101 3.41Z"
            fill="currentColor"
          />
          <path
            d="M22.4401 6.24L21.0301 4.83C19.0801 6.78 19.0801 9.95 21.0301 11.9L22.4401 10.49C21.2701 9.32 21.2701 7.41 22.4401 6.24Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSpeaker(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="speaker">
        <path
          id="Vector"
          d="M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 21.99 7 21.99L17 22C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2ZM7 20V4H17V20H7ZM12 9C13.1 9 14 8.1 14 7C14 5.9 13.1 5 12 5C10.89 5 10 5.9 10 7C10 8.1 10.89 9 12 9ZM12 11C9.79 11 8 12.79 8 15C8 17.21 9.79 19 12 19C14.21 19 16 17.21 16 15C16 12.79 14.21 11 12 11ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpeakerGroup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="speaker_group">
        <path
          id="Vector"
          d="M18.2 1H9.8C8.81 1 8 1.81 8 2.8V17.2C8 18.19 8.81 18.99 9.8 18.99L18.2 19C19.19 19 20 18.19 20 17.2V2.8C20 1.81 19.19 1 18.2 1ZM18 17L10 16.99V3H18V17ZM14 8C15.1 8 16 7.11 16 6C16 4.89 15.1 4 14 4C12.9 4 12 4.89 12 6C12 7.11 12.9 8 14 8ZM14 16C15.93 16 17.5 14.43 17.5 12.5C17.5 10.57 15.93 9 14 9C12.07 9 10.5 10.57 10.5 12.5C10.5 14.43 12.07 16 14 16ZM14 11C14.83 11 15.5 11.67 15.5 12.5C15.5 13.33 14.83 14 14 14C13.17 14 12.5 13.33 12.5 12.5C12.5 11.67 13.17 11 14 11ZM6 5H4V21C4 22.1 4.89 23 6 23H16V21H6V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpeakerNotes(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="speaker_notes">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM6 12H8V14H6V12ZM6 9H8V11H6V9ZM6 6H8V8H6V6ZM10 12H15V14H10V12ZM10 9H18V11H10V9ZM10 6H18V8H10V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpeakerNotesOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="speaker_notes_off" clipPath="url(#clip0_395_4300)">
        <path
          id="Vector"
          d="M20.9301 3.34005V15.3401H19.5901L21.5001 17.2501C22.3201 17.0001 22.9301 16.2401 22.9301 15.3401V3.34005C22.9301 2.24005 22.0301 1.34005 20.9301 1.34005H5.59005L7.59005 3.34005H20.9301ZM6.93005 11.3401H8.93005V13.3401H6.93005V11.3401ZM18.9301 8.34005H12.5901L14.5901 10.3401H18.9301V8.34005ZM18.9301 5.34005H10.9301V6.68005L11.5901 7.34005H18.9301V5.34005ZM2.34005 0.930054L0.930054 2.34005L2.94005 4.35005L2.93005 21.3401L6.93005 17.3401H15.9301L21.6601 23.0701L23.0701 21.6601L2.34005 0.930054ZM6.10005 15.3401L4.93005 16.5101V6.34005L6.93005 8.34005V10.3401H8.93005L13.9301 15.3401H6.10005Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_4300">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconSpeakerPhone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="speaker_phone">
        <path
          id="Vector"
          d="M7 7.57501L8.43 9.005C9.34 8.09501 10.61 7.525 12 7.525C13.39 7.525 14.66 8.09501 15.57 9.005L17 7.57501C15.72 6.295 13.95 5.505 12 5.505C10.05 5.505 8.28 6.295 7 7.57501ZM12 1.505C8.98 1.505 6.24 2.735 4.25 4.715L5.66 6.125C7.28 4.505 9.53 3.505 12 3.505C14.47 3.505 16.72 4.505 18.34 6.125L19.75 4.715C17.76 2.735 15.02 1.505 12 1.505ZM14.86 10.515L9.14 10.505C8.51 10.505 8 11.015 8 11.645V21.355C8 21.985 8.51 22.495 9.14 22.495H14.85C15.48 22.495 15.99 21.985 15.99 21.355V11.645C16 11.015 15.49 10.515 14.86 10.515ZM15 20.505H9V12.505H15V20.505Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpeed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="speed">
        <g id="Vector">
          <path
            d="M20.3643 8.55102L19.1343 10.401C19.7275 11.5841 20.0179 12.8958 19.9795 14.2187C19.9411 15.5416 19.5751 16.8343 18.9143 17.981H5.0543C4.19547 16.4911 3.8396 14.7641 4.03944 13.0561C4.23929 11.348 4.98421 9.74984 6.16378 8.49844C7.34335 7.24705 8.89477 6.40906 10.588 6.10871C12.2813 5.80837 14.0263 6.06165 15.5643 6.83102L17.4143 5.60102C15.5308 4.39323 13.2966 3.85202 11.0692 4.06395C8.84176 4.27588 6.74975 5.22871 5.1278 6.77003C3.50584 8.31134 2.44766 10.3521 2.12252 12.5658C1.79738 14.7796 2.22405 17.0384 3.3343 18.981C3.50881 19.2833 3.75939 19.5346 4.06113 19.7101C4.36288 19.8855 4.70528 19.9789 5.0543 19.981H18.9043C19.2567 19.9824 19.6033 19.8907 19.9088 19.7151C20.2144 19.5395 20.4681 19.2862 20.6443 18.981C21.5657 17.3849 22.0281 15.5653 21.9804 13.723C21.9328 11.8807 21.3769 10.0873 20.3743 8.54102L20.3643 8.55102Z"
            fill="currentColor"
          />
          <path
            d="M10.5743 15.391C10.76 15.577 10.9806 15.7245 11.2234 15.8251C11.4662 15.9258 11.7265 15.9776 11.9893 15.9776C12.2521 15.9776 12.5124 15.9258 12.7552 15.8251C12.998 15.7245 13.2186 15.577 13.4043 15.391L19.0643 6.90102L10.5743 12.561C10.3884 12.7468 10.2408 12.9673 10.1402 13.2101C10.0395 13.4529 9.98773 13.7132 9.98773 13.976C9.98773 14.2388 10.0395 14.4991 10.1402 14.7419C10.2408 14.9847 10.3884 15.2053 10.5743 15.391Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSpellcheck(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="spellcheck">
        <path
          id="Vector"
          d="M11.72 15.25H13.81L8.69998 2.25H6.83998L1.72998 15.25H3.81998L4.93998 12.25H10.58L11.72 15.25ZM5.69998 10.25L7.76998 4.73L9.83998 10.25H5.69998ZM20.86 10.84L12.77 18.93L9.09998 15.25L7.68998 16.66L12.78 21.75L22.27 12.25L20.86 10.84Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSplitscreen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="splitscreen">
        <path
          id="Vector"
          d="M18 4V9H6V4H18ZM18 2H6C4.9 2 4 2.9 4 4V9C4 10.1 4.9 11 6 11H18C19.1 11 20 10.1 20 9V4C20 2.9 19.1 2 18 2ZM18 15V20H6V15H18ZM18 13H6C4.9 13 4 13.9 4 15V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V15C20 13.9 19.1 13 18 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSpoke(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="spoke">
        <path
          id="Vector"
          d="M16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11C14.21 11 16 9.21 16 7ZM12 9C10.9 9 10 8.1 10 7C10 5.9 10.9 5 12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9ZM7 13C4.79 13 3 14.79 3 17C3 19.21 4.79 21 7 21C9.21 21 11 19.21 11 17C11 14.79 9.21 13 7 13ZM7 19C5.9 19 5 18.1 5 17C5 15.9 5.9 15 7 15C8.1 15 9 15.9 9 17C9 18.1 8.1 19 7 19ZM17 13C14.79 13 13 14.79 13 17C13 19.21 14.79 21 17 21C19.21 21 21 19.21 21 17C21 14.79 19.21 13 17 13ZM17 19C15.9 19 15 18.1 15 17C15 15.9 15.9 15 17 15C18.1 15 19 15.9 19 17C19 18.1 18.1 19 17 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSports(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports">
        <g id="Vector">
          <path
            d="M11.23 5.99622C9.57 5.99622 8.01 6.65622 6.87 7.72622C6.54 6.72622 5.61 5.99622 4.5 5.99622C3.12 5.99622 2 7.11622 2 8.49622C2 9.87622 3.12 10.9962 4.5 10.9962C4.71 10.9962 4.91 10.9662 5.11 10.9162C5.06 11.1662 5.02 11.4262 5.01 11.6962C4.83 15.3762 7.96 18.3762 11.69 17.9662C14.24 17.6862 16.37 15.7062 16.88 13.1962C17.03 12.4862 17.03 11.7962 16.94 11.1362C16.85 10.5362 17.32 10.0062 17.93 10.0062H22V5.99622H11.23ZM4.5 8.99622C4.22 8.99622 4 8.77622 4 8.49622C4 8.21622 4.22 7.99622 4.5 7.99622C4.78 7.99622 5 8.21622 5 8.49622C5 8.77622 4.78 8.99622 4.5 8.99622ZM11 14.9962C9.34 14.9962 8 13.6562 8 11.9962C8 10.3362 9.34 8.99622 11 8.99622C12.66 8.99622 14 10.3362 14 11.9962C14 13.6562 12.66 14.9962 11 14.9962Z"
            fill="currentColor"
          />
          <path
            d="M11 13.9962C12.1046 13.9962 13 13.1008 13 11.9962C13 10.8916 12.1046 9.99622 11 9.99622C9.89543 9.99622 9 10.8916 9 11.9962C9 13.1008 9.89543 13.9962 11 13.9962Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsBar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_bar">
        <path
          id="Vector"
          d="M15 19.49H8V12.86C9.26 12.52 10.11 11.59 10.77 10.87C11.6 9.96001 12.08 9.49001 13 9.49001H15V19.49ZM10 2.51001C8.11 2.51001 6.49 3.62001 5.73 5.22001C4.15 5.75001 3 7.23001 3 8.99001C3 10.85 4.28 12.4 6 12.85V21.49H17V19.49H19C20.1 19.49 21 18.59 21 17.49V11.49C21 10.39 20.1 9.49001 19 9.49001H17.44C17.79 8.90001 18 8.22001 18 7.49001C18 5.28001 16.21 3.49001 14 3.49001C13.66 3.49001 13.34 3.54001 13.02 3.62001C12.2 2.94001 11.16 2.51001 10 2.51001ZM7 10.99C5.9 10.99 5 10.09 5 8.99001C5 8.14001 5.55 7.39001 6.37 7.11001L7.17 6.84001L7.53 6.08001C8 5.11001 8.94 4.51001 10 4.51001C10.79 4.51001 11.39 4.86001 11.74 5.16001L12.52 5.81001C12.52 5.81001 13.16 5.49001 13.99 5.49001C15.09 5.49001 15.99 6.39001 15.99 7.49001H12.99C9.67 7.49001 9.15 10.99 7 10.99ZM17 17.49V11.49H19V17.49H17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsBaseball(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_baseball">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM5.61 16.78C4.6 15.45 4 13.8 4 12C4 10.2 4.6 8.55 5.61 7.22C7.06 8.31 8 10.05 8 12C8 13.95 7.06 15.69 5.61 16.78ZM12 20C10.11 20 8.37 19.34 7 18.24C8.83 16.77 10 14.53 10 12C10 9.47 8.83 7.23 7 5.76C8.37 4.66 10.11 4 12 4C13.89 4 15.63 4.66 17 5.76C15.17 7.23 14 9.47 14 12C14 14.53 15.17 16.77 17 18.24C15.63 19.34 13.89 20 12 20ZM18.39 16.78C16.94 15.69 16 13.95 16 12C16 10.05 16.94 8.31 18.39 7.22C19.4 8.55 20 10.2 20 12C20 13.8 19.4 15.45 18.39 16.78Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsBasketball(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_basketball">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07C4.22 9.82 4.63 8.72 5.23 7.75ZM4.07 13H6.91C6.7 14.26 6.1 15.38 5.23 16.25C4.63 15.28 4.22 14.18 4.07 13ZM11 19.93C9.27 19.71 7.71 18.93 6.51 17.79C7.81 16.55 8.7 14.88 8.93 13H11V19.93ZM11 11H8.93C8.69 9.12 7.81 7.44 6.5 6.2C7.71 5.06 9.27 4.29 11 4.07V11ZM19.93 11H17.09C17.3 9.74 17.9 8.62 18.77 7.75C19.37 8.72 19.78 9.82 19.93 11ZM13 4.07C14.73 4.29 16.29 5.06 17.5 6.2C16.19 7.44 15.31 9.12 15.07 11H13V4.07ZM13 19.93V13H15.07C15.31 14.88 16.19 16.55 17.49 17.79C16.29 18.93 14.73 19.71 13 19.93ZM18.77 16.25C17.9 15.39 17.31 14.26 17.09 13H19.93C19.78 14.18 19.37 15.28 18.77 16.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsCricket(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_cricket">
        <g id="Vector">
          <path
            d="M15.041 12.7906L6.54104 4.29061C6.35104 4.10061 6.09103 4.00061 5.83104 4.00061C5.57104 4.00061 5.32104 4.10061 5.13104 4.29061L2.29104 7.13061C1.90104 7.52061 1.90104 8.16061 2.29104 8.55061L10.791 17.0506C10.991 17.2506 11.241 17.3406 11.501 17.3406C11.761 17.3406 12.011 17.2406 12.211 17.0506L15.041 14.2206C15.431 13.8206 15.431 13.1806 15.041 12.7906ZM11.501 14.9206L4.41104 7.83061L5.83104 6.41061L12.921 13.5006L11.501 14.9206Z"
            fill="currentColor"
          />
          <path
            d="M15.7564 16.3426L14.3422 17.7568L18.5848 21.9994L19.999 20.5852L15.7564 16.3426Z"
            fill="currentColor"
          />
          <path
            d="M18.501 2.00061C16.571 2.00061 15.001 3.57061 15.001 5.50061C15.001 7.43061 16.571 9.00061 18.501 9.00061C20.431 9.00061 22.001 7.43061 22.001 5.50061C22.001 3.57061 20.431 2.00061 18.501 2.00061ZM18.501 7.00061C17.671 7.00061 17.001 6.33061 17.001 5.50061C17.001 4.67061 17.671 4.00061 18.501 4.00061C19.331 4.00061 20.001 4.67061 20.001 5.50061C20.001 6.33061 19.331 7.00061 18.501 7.00061Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsEsports(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_esports">
        <g id="Vector">
          <path
            d="M21.5798 16.09L20.4898 8.43C20.2098 6.46 18.5198 5 16.5298 5H7.46982C5.47982 5 3.78982 6.46 3.50982 8.43L2.41982 16.09C2.19982 17.63 3.38982 19 4.93982 19C5.61982 19 6.25982 18.73 6.73982 18.25L8.99982 16H14.9998L17.2498 18.25C17.7298 18.73 18.3798 19 19.0498 19C20.6098 19 21.7998 17.63 21.5798 16.09ZM19.4798 16.81C19.3998 16.9 19.2698 17 19.0598 17C18.9098 17 18.7698 16.94 18.6698 16.84L15.8298 14H8.16982L5.32982 16.84C5.22982 16.94 5.08982 17 4.93982 17C4.72982 17 4.59982 16.9 4.51982 16.81C4.43982 16.72 4.35982 16.58 4.38982 16.37L5.47982 8.71C5.62982 7.74 6.47982 7 7.46982 7H16.5298C17.5198 7 18.3698 7.74 18.5098 8.72L19.5998 16.38C19.6298 16.58 19.5498 16.72 19.4798 16.81Z"
            fill="currentColor"
          />
          <path
            d="M8.99982 8H7.99982V10H5.99982V11H7.99982V13H8.99982V11H10.9998V10H8.99982V8Z"
            fill="currentColor"
          />
          <path
            d="M16.9998 13C17.5521 13 17.9998 12.5523 17.9998 12C17.9998 11.4477 17.5521 11 16.9998 11C16.4475 11 15.9998 11.4477 15.9998 12C15.9998 12.5523 16.4475 13 16.9998 13Z"
            fill="currentColor"
          />
          <path
            d="M14.9998 10C15.5521 10 15.9998 9.55228 15.9998 9C15.9998 8.44772 15.5521 8 14.9998 8C14.4475 8 13.9998 8.44772 13.9998 9C13.9998 9.55228 14.4475 10 14.9998 10Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsFootball(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_football">
        <g id="Vector">
          <path
            d="M20.3098 3.69C19.9898 3.36 18.3698 3 16.2598 3C13.2298 3 9.16983 3.75 6.45983 6.46C1.86983 11.05 2.89983 19.52 3.68983 20.31C4.00983 20.64 5.62983 21 7.73983 21C10.7698 21 14.8298 20.25 17.5398 17.54C22.1298 12.95 21.0998 4.48 20.3098 3.69ZM7.73983 19C6.59983 19 5.71983 18.88 5.20983 18.77C5.02983 17.98 4.90983 16.56 5.03983 14.94L9.04983 18.95C8.52983 18.99 8.07983 19 7.73983 19ZM16.1298 16.13C14.7998 17.46 13.0698 18.18 11.4698 18.57L5.42983 12.53C5.84983 10.85 6.58983 9.16 7.87983 7.88C9.19983 6.56 10.9298 5.84 12.5198 5.45L18.5698 11.5C18.1498 13.17 17.3998 14.85 16.1298 16.13ZM18.9598 9.09L14.9298 5.06C15.4498 5.01 15.9098 5 16.2598 5C17.3998 5 18.2798 5.12 18.7898 5.23C18.9698 6.02 19.0898 7.45 18.9598 9.09Z"
            fill="currentColor"
          />
          <path
            d="M14.0997 8.49996L8.49949 14.1002L9.89955 15.5002L15.4998 9.90001L14.0997 8.49996Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsGolf(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_golf">
        <g id="Vector">
          <path
            d="M12 16C15.87 16 19 12.87 19 9C19 5.13 15.87 2 12 2C8.13 2 5 5.13 5 9C5 12.87 8.13 16 12 16ZM12 4C14.76 4 17 6.24 17 9C17 11.76 14.76 14 12 14C9.24 14 7 11.76 7 9C7 6.24 9.24 4 12 4Z"
            fill="currentColor"
          />
          <path
            d="M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9Z"
            fill="currentColor"
          />
          <path
            d="M14 9C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9Z"
            fill="currentColor"
          />
          <path
            d="M12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z"
            fill="currentColor"
          />
          <path
            d="M7 19H9C10.1 19 11 19.9 11 21V22H13V21C13 19.9 13.9 19 15 19H17V17H7V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsGymnastics(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_gymnastics">
        <path
          id="Vector"
          d="M4 5C4 3.9 4.9 3 6 3C7.1 3 8 3.9 8 5C8 6.1 7.1 7 6 7C4.9 7 4 6.1 4 5ZM1 8H7L14 3L15.31 4.52L11.14 7.5H14L21.8 3L23 4.4L14.5 11L14 21H12L11.5 11L8 10H1V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsHandball(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_handball">
        <g id="Vector">
          <path
            d="M14.2737 5.53982C13.7237 6.48982 14.0537 7.71981 15.0037 8.26981C15.9537 8.81981 17.1837 8.48982 17.7337 7.53982C18.2837 6.58982 17.9537 5.35982 17.0037 4.80982C16.0537 4.25982 14.8237 4.58982 14.2737 5.53982Z"
            fill="currentColor"
          />
          <path
            d="M15.8437 9.94982C15.8437 9.94982 14.2137 9.00982 13.2437 8.44982C10.8637 7.06982 10.0437 4.00982 11.4237 1.62982L9.69367 0.629816C8.10367 3.36982 8.60367 6.74982 10.6637 8.93982L5.51367 17.8598L7.24367 18.8598L8.74367 16.2598L10.4737 17.2598L7.47367 22.4598L9.20367 23.4598L15.4937 12.5698C16.6337 14.1198 16.8237 16.2598 15.8037 18.0298L17.5337 19.0298C19.1337 16.2798 18.8137 12.4498 15.8437 9.94982Z"
            fill="currentColor"
          />
          <path
            d="M12.7537 3.33982C13.4737 3.74982 14.3837 3.50982 14.8037 2.78982C15.2137 2.06982 14.9737 1.15982 14.2537 0.739816C13.5337 0.329816 12.6237 0.569816 12.2037 1.28982C11.7937 2.00982 12.0337 2.92982 12.7537 3.33982Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsHockey(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_hockey">
        <g id="Vector">
          <path d="M2 17V20H4V16H3C2.45 16 2 16.45 2 17Z" fill="currentColor" />
          <path
            d="M9 16H5V20L9.69 19.99C10.07 19.99 10.41 19.78 10.58 19.44L11.45 17.54L9.86 14.06L9 16Z"
            fill="currentColor"
          />
          <path
            d="M21.71 16.29C21.53 16.11 21.28 16 21 16H20V20H22V17C22 16.72 21.89 16.47 21.71 16.29Z"
            fill="currentColor"
          />
          <path
            d="M13.6 12.84L17.65 4H14.3L12.54 7.97L12.05 9.07L12 9.21L9.7 4H6.35L11.92 16.16L12 16.34L13.42 19.44C13.59 19.78 13.93 19.99 14.31 19.99L19 20V16H15L13.6 12.84Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsKabaddi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_kabaddi">
        <g id="Vector">
          <path
            d="M16.4749 5.18994C17.5795 5.18994 18.4749 4.29451 18.4749 3.18994C18.4749 2.08537 17.5795 1.18994 16.4749 1.18994C15.3703 1.18994 14.4749 2.08537 14.4749 3.18994C14.4749 4.29451 15.3703 5.18994 16.4749 5.18994Z"
            fill="currentColor"
          />
          <path
            d="M23.9749 12.6899V7.98994L18.9249 5.84994C17.9549 5.43994 16.8349 5.78994 16.2749 6.68994L15.2749 8.28994C14.6049 9.46994 13.3649 10.3499 11.8649 10.6099L11.9249 10.6699C12.6149 11.3599 13.4449 11.7399 14.3849 11.8399C15.1849 11.4199 15.9049 10.8599 16.4749 10.1999L17.0749 13.1999L14.9749 15.1899V22.6899H16.9749V16.6899L19.0749 14.6899L20.8749 22.6899H22.9749L20.7949 11.6899L20.1749 8.58994L21.9749 9.28994V12.6899H23.9749Z"
            fill="currentColor"
          />
          <path
            d="M10.2649 8.89994C10.4849 9.04994 10.7349 9.13994 10.9849 9.18994C11.1149 9.20994 11.2349 9.22994 11.3649 9.22994C11.4949 9.22994 11.6249 9.21994 11.7449 9.18994C11.8749 9.16994 11.9949 9.12994 12.1149 9.07994C12.3549 8.97994 12.5849 8.83994 12.7749 8.63994C13.2649 8.14994 13.4449 7.46994 13.3249 6.83994C13.2549 6.46994 13.0749 6.09994 12.7749 5.80994C12.5849 5.61994 12.3549 5.46994 12.1149 5.36994C11.9949 5.31994 11.8749 5.27994 11.7449 5.25994C11.6149 5.23994 11.4949 5.21994 11.3649 5.21994C11.2449 5.21994 11.1349 5.22994 11.0149 5.24994C10.8749 5.26994 10.7349 5.30994 10.6049 5.35994C10.3749 5.46994 10.1449 5.61994 9.9549 5.80994C9.6549 6.09994 9.4749 6.46994 9.4049 6.83994C9.2849 7.46994 9.4649 8.14994 9.9549 8.63994C10.0449 8.73994 10.1549 8.81994 10.2649 8.89994Z"
            fill="currentColor"
          />
          <path
            d="M11.2149 11.3699L9.2149 9.36994C9.1149 9.26994 9.0149 9.18994 8.9049 9.10994C8.6849 8.96994 8.4349 8.86994 8.1849 8.82994C8.0549 8.79994 7.9349 8.78994 7.8049 8.78994C7.2949 8.78994 6.7849 8.98994 6.3949 9.37994L3.0549 12.7199C2.6449 13.1299 2.4349 13.6999 2.4749 14.2599C2.4749 14.4399 2.5149 14.6299 2.5849 14.8099L3.6549 17.7599L0.0249023 21.3899L1.4349 22.8099L5.6749 18.5699V16.3499L6.9749 17.5599V22.6899H8.9749V16.6899L6.8549 14.5699L9.2149 12.2099L9.9249 12.9199C11.2149 14.1799 12.8949 14.9599 14.9549 14.9599L14.8149 12.8899C13.3149 12.8699 12.1149 12.2699 11.2149 11.3699Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsMartialArts(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_martial_arts">
        <g id="Vector">
          <path
            d="M19.8 2.5L11.6 9.2L10.39 8.16L13.99 6.08L9.41 1.5L8 2.91L10.74 5.65L5 8.96L3.81 13.25L6.27 17.5L8 16.5L5.97 12.98L6.32 11.68L9.5 13.5L10 22.5H12L12.5 12.5L21 3.9L19.8 2.5Z"
            fill="currentColor"
          />
          <path
            d="M5 7.5C6.10457 7.5 7 6.60457 7 5.5C7 4.39543 6.10457 3.5 5 3.5C3.89543 3.5 3 4.39543 3 5.5C3 6.60457 3.89543 7.5 5 7.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsMma(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_mma">
        <g id="Vector">
          <path
            d="M7 20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V17H7V20Z"
            fill="currentColor"
          />
          <path
            d="M18 7C17.45 7 17 7.45 17 8V5C17 3.9 16.1 3 15 3H7C5.9 3 5 3.9 5 5V10.8C5 10.93 5.01 11.06 5.04 11.19L5.84 15.19C5.93 15.66 6.34 15.99 6.82 15.99H17C17.55 15.99 18.09 15.55 18.2 15.01L18.97 11.18C18.99 11.06 19 10.93 19 10.8V8C19 7.45 18.55 7 18 7ZM17 10.6C17 10.73 16.36 14 16.36 14H7.64C7.64 14 7 10.74 7 10.6V5H15V10H17V10.6Z"
            fill="currentColor"
          />
          <path d="M14 7H8V10H14V7Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsMotorsports(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_motorsports">
        <path
          id="Vector"
          d="M21.9615 11.22C21.5715 7.01 17.7615 4 13.5615 4C13.3715 4 13.1815 4.01 12.9915 4.02C2.00146 4.74 2.00146 17.2 2.00146 17.2V18C2.00146 19.1 2.90146 20 4.00146 20H14.0015C18.6715 20 22.4115 15.99 21.9615 11.22ZM5.26147 11.56C5.83147 10.27 6.54146 9.21 7.40146 8.37L11.0215 9.9C11.6215 10.15 12.0015 10.73 12.0015 11.38C12.0015 12.27 11.2815 12.99 10.3915 12.99H4.72146C4.87146 12.53 5.04147 12.05 5.26147 11.56ZM18.4415 16.04C17.3015 17.29 15.6815 18 14.0015 18H4.00146V17.2C4.00146 17.18 4.01146 16.28 4.24146 15H10.3915C12.3815 15 14.0015 13.38 14.0015 11.39C14.0015 9.94 13.1315 8.63 11.8015 8.07L9.30147 7.01C10.4015 6.44 11.6715 6.11 13.1215 6.02C13.2715 6 13.4215 6 13.5615 6C16.8715 6 19.6915 8.37 19.9715 11.41C20.1315 13.13 19.5915 14.77 18.4415 16.04Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsRugby(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_rugby">
        <path
          id="Vector"
          d="M20.4898 3.51004C19.9298 2.95004 18.3398 2.54004 16.3298 2.54004C13.2498 2.54004 9.17976 3.50004 6.34976 6.33004C1.65976 11.03 2.09976 19.07 3.50976 20.49C4.06976 21.05 5.65976 21.46 7.66976 21.46C10.7498 21.46 14.8198 20.5 17.6498 17.67C22.3398 12.97 21.8998 4.93004 20.4898 3.51004ZM5.70976 18.29C6.33976 16.4 7.86976 13.3 10.5798 10.59C13.2598 7.91004 16.3598 6.36004 18.2798 5.71004C17.6498 7.60004 16.1198 10.7 13.3998 13.41C10.7398 16.09 7.63976 17.64 5.70976 18.29ZM7.75976 7.76004C10.3998 5.12004 14.0998 4.64004 15.7898 4.57004C13.7398 5.51004 11.3298 7.03004 9.17976 9.18004C7.01976 11.34 5.50976 13.76 4.56976 15.81C4.65976 13.33 5.43976 10.07 7.75976 7.76004ZM16.2398 16.24C13.5998 18.88 9.89976 19.36 8.20976 19.43C10.2598 18.49 12.6698 16.97 14.8198 14.82C16.9798 12.66 18.4898 10.24 19.4398 8.19004C19.3398 10.67 18.5598 13.93 16.2398 16.24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsScore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_score">
        <path
          id="Vector"
          d="M11 6H9V4H11V6ZM15 4H13V6H15V4ZM9 14H11V12H9V14ZM19 10V8H17V10H19ZM19 14V12H17V14H19ZM13 14H15V12H13V14ZM19 4H17V6H19V4ZM13 8V6H11V8H13ZM7 10V8H9V6H7V4H5V20H7V12H9V10H7ZM15 12H17V10H15V12ZM11 10V12H13V10H11ZM9 8V10H11V8H9ZM13 10H15V8H13V10ZM15 6V8H17V6H15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsSoccer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_soccer">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 5.3L14.35 4.35C16.17 4.91 17.72 6.11 18.73 7.69L18.34 9.03L16.99 9.49L13 6.7V5.3ZM9.65 4.35L11 5.3V6.7L7.01 9.49L5.66 9.03L5.27 7.69C6.28 6.12 7.83 4.92 9.65 4.35ZM7.08 17.11L5.94 17.21C4.73 15.81 4 13.99 4 12C4 11.88 4.01 11.77 4.02 11.65L5.02 10.92L6.4 11.4L7.86 15.74L7.08 17.11ZM14.5 19.59C13.71 19.85 12.87 20 12 20C11.13 20 10.29 19.85 9.5 19.59L8.81 18.1L9.45 17H14.56L15.2 18.11L14.5 19.59ZM14.27 15H9.73L8.38 10.98L12 8.44L15.63 10.98L14.27 15ZM18.06 17.21L16.92 17.11L16.13 15.74L17.59 11.4L18.98 10.93L19.98 11.66C19.99 11.77 20 11.88 20 12C20 13.99 19.27 15.81 18.06 17.21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSportsTennis(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_tennis">
        <g id="Vector">
          <path
            d="M19.5999 2.48886C17.2599 0.148859 12.9799 0.618859 10.0499 3.54886C8.44992 5.14886 7.52992 7.41886 7.50992 9.00886C7.48992 10.5889 7.76992 12.8989 6.15992 14.5089L1.91992 18.7489L3.33992 20.1689L7.57992 15.9289C9.18992 14.3189 11.4999 14.5989 13.0799 14.5789C14.6599 14.5589 16.9399 13.6389 18.5399 12.0389C21.4599 9.10886 21.9399 4.82886 19.5999 2.48886ZM10.3999 11.6789C8.86992 10.1489 9.34992 7.06886 11.4599 4.95886C13.5699 2.84886 16.6399 2.36886 18.1799 3.89886C19.7099 5.42886 19.2299 8.50886 17.1199 10.6189C15.0099 12.7289 11.9399 13.2089 10.3999 11.6789Z"
            fill="currentColor"
          />
          <path
            d="M18.0799 16.9989C18.6099 16.9989 19.1199 17.2089 19.4899 17.5889C20.2699 18.3689 20.2699 19.6389 19.4899 20.4189C19.1199 20.7889 18.6099 20.9989 18.0799 20.9989C17.5499 20.9989 17.0399 20.7889 16.6699 20.4089C15.8899 19.6289 15.8899 18.3589 16.6699 17.5789C17.0399 17.2089 17.5499 16.9989 18.0799 16.9989ZM18.0799 14.9989C17.0599 14.9989 16.0299 15.3889 15.2499 16.1689C13.6899 17.7289 13.6899 20.2589 15.2499 21.8289C16.0299 22.6089 17.0599 22.9989 18.0799 22.9989C19.0999 22.9989 20.1299 22.6089 20.9099 21.8289C22.4699 20.2689 22.4699 17.7389 20.9099 16.1689C20.1299 15.3889 19.0999 14.9989 18.0799 14.9989Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSportsVolleyball(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sports_volleyball">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 4.07C16.07 4.45 18.57 6.59 19.54 9.43L13 5.65V4.07ZM8 5.08C9.18 4.39 11.33 4.02 11 4.06V11.41L8 13.14V5.08ZM4.63 15.1C4.23 14.14 4 13.1 4 12C4 9.98 4.76 8.14 6 6.73V14.31L4.63 15.1ZM5.64 16.83L12 13.15L15 14.88L8.02 18.91C7.09 18.38 6.28 17.68 5.64 16.83ZM12 20C11.46 20 10.93 19.94 10.42 19.84L17 16.04L18.36 16.82C16.9 18.75 14.6 20 12 20ZM13 11.42V7.96L20 12.01C20 13.11 19.77 14.15 19.37 15.1L13 11.42Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSquare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="square">
        <path id="Vector" d="M3 3V21H21V3H3ZM19 19H5V5H19V19Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconSquareFoot(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="square_foot">
        <path
          id="Vector"
          d="M17.66 17.66L16.6 18.72L15.89 18.01L16.95 16.95L15.01 15.01L13.95 16.07L13.24 15.36L14.3 14.3L12.36 12.36L11.3 13.42L10.59 12.71L11.65 11.65L9.7 9.7L8.64 10.76L7.93 10.05L8.99 8.99L7.05 7.05L5.99 8.11L5.28 7.4L6.34 6.34L4 4V18C4 19.1 4.9 20 6 20H20L17.66 17.66ZM7 17V11.24L12.76 17H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSsidChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ssid_chart">
        <path
          id="Vector"
          d="M21 5.47L12 12L7.62 7.62L3 11V8.52L7.83 5L12.21 9.38L21 3V5.47ZM21 15H16.3L12.13 18.34L6 12.41L3 14.54V17L5.8 15L12 21L17 17H21V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStackedBarChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stacked_bar_chart">
        <g id="Vector">
          <path d="M8 9H4V20H8V9Z" fill="currentColor" />
          <path d="M8 4H4V8H8V4Z" fill="currentColor" />
          <path d="M14 7H10V11H14V7Z" fill="currentColor" />
          <path d="M20 10H16V14H20V10Z" fill="currentColor" />
          <path d="M20 15H16V20H20V15Z" fill="currentColor" />
          <path d="M14 12H10V20H14V12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconStackedLineChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stacked_line_chart">
        <path
          id="Vector"
          d="M2 19.99L9.5 12.48L13.5 16.48L20.59 8.51001L22 9.92001L13.5 19.48L9.5 15.48L3.5 21.49L2 19.99ZM3.5 15.49L9.5 9.48001L13.5 13.48L22 3.92001L20.59 2.51001L13.5 10.48L9.5 6.48001L2 13.99L3.5 15.49Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStadium(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stadium">
        <path
          id="Vector"
          d="M7 5L3 7V3L7 5ZM18 3V7L22 5L18 3ZM11 2V6L15 4L11 2ZM13 18H11V22C5.95 21.85 2 20.56 2 19V10C2 8.34 6.48 7 12 7C17.52 7 22 8.34 22 10V19C22 20.56 18.05 21.85 13 22V18ZM5 10.04C6.38 10.53 8.77 11 12 11C15.23 11 17.62 10.53 19 10.04C19 9.86 16.22 9 12 9C7.78 9 5 9.86 5 10.04ZM20 11.8C18.18 12.53 15.27 13 12 13C8.73 13 5.82 12.53 4 11.8V18.58C4.61 18.99 6.36 19.59 9 19.86V16H15V19.86C17.64 19.59 19.39 18.99 20 18.58V11.8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStairs(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stairs">
        <path
          id="Vector"
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18 6H13.58V9.33H11V12.66H8.42V16H6V18H10.42V14.67H13V11.34H15.58V8H18V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="star">
        <path
          id="Vector"
          d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStarBorder(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="star_border">
        <path
          id="Vector"
          d="M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9L8.24 18.17L9.24 13.89L5.92 11.01L10.3 10.63L12 6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStarHalf(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="star_half">
        <path
          id="Vector"
          d="M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9V6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStarRate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="star_rate">
        <path
          id="Vector"
          d="M12 8.89L12.94 12H15.76L13.49 13.62L14.42 16.63L12 14.79L9.58 16.63L10.51 13.62L8.24 12H11.06L12 8.89ZM12 2L9.58 10H2L8.17 14.41L5.83 22L12 17.31L18.18 22L15.83 14.41L22 10H14.42L12 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStars(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stars">
        <path
          id="Vector"
          d="M8 18L12 14.95L16 18L14.5 13.05L18.5 10.2H13.6L12 5L10.4 10.2H5.5L9.5 13.05L8 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="start">
        <path
          id="Vector"
          d="M14.59 7.41L18.17 11H6V13H18.17L14.58 16.59L16 18L22 12L16 6L14.59 7.41ZM2 6V18H4V6H2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStayCurrentLandscape(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stay_current_landscape">
        <path
          id="Vector"
          d="M1.01 7L1 17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5H3C1.9 5 1.01 5.9 1.01 7ZM19 7V17H5V7H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStayCurrentPortrait(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stay_current_portrait">
        <path
          id="Vector"
          d="M16.9949 1.01L6.99488 1C5.89488 1 5.00488 1.9 5.00488 3V21C5.00488 22.1 5.89488 23 6.99488 23H16.9949C18.0949 23 18.9949 22.1 18.9949 21V3C18.9949 1.9 18.0949 1.01 16.9949 1.01ZM16.9949 19H6.99488V5H16.9949V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStayPrimaryLandscape(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stay_primary_landscape">
        <path
          id="Vector"
          d="M1.01 7L1 17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5H3C1.9 5 1.01 5.9 1.01 7ZM19 7V17H5V7H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStayPrimaryPortrait(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stay_primary_portrait">
        <path
          id="Vector"
          d="M16.9949 1.01L6.99488 1C5.89488 1 5.00488 1.9 5.00488 3V21C5.00488 22.1 5.89488 23 6.99488 23H16.9949C18.0949 23 18.9949 22.1 18.9949 21V3C18.9949 1.9 18.0949 1.01 16.9949 1.01ZM16.9949 19H6.99488V5H16.9949V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStickyNote2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sticky_note_2">
        <path
          id="Vector"
          d="M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stop">
        <path id="Vector" d="M16 8V16H8V8H16ZM18 6H6V18H18V6Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconStopCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stop_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM16 16H8V8H16V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStopScreenShare(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stop_screen_share">
        <path
          id="Vector"
          d="M21.79 17.8601L23.79 19.8601H24V17.8601H21.79ZM1.11 2.84005L2.66 4.40005C2.25 4.77005 2 5.29005 2 5.88005V15.8601C2 16.9601 2.9 17.8601 4.01 17.8601H0V19.8601H18.13L20.84 22.5701L22.25 21.1601L2.52 1.43005L1.11 2.84005ZM4 5.88005H4.13L9.08 10.8101C7.94 11.9301 7.31 13.3801 7 14.8601C7.96 13.5701 9.13 12.7801 10.67 12.4001L14.13 15.8801H4V5.88005ZM20 5.88005V16.0701L21.3 17.3701C21.72 17.0001 22 16.4801 22 15.8801V5.88005C22 4.77005 21.1 3.88005 20 3.88005H7.8L9.8 5.88005H20ZM12.93 9.01005L15.72 11.7901L17 10.5901L13 6.86005V8.99005L12.93 9.01005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStorage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="storage">
        <path
          id="Vector"
          d="M2 20H22V16H2V20ZM4 17H6V19H4V17ZM2 4V8H22V4H2ZM6 7H4V5H6V7ZM2 14H22V10H2V14ZM4 11H6V13H4V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="store">
        <path
          id="Vector"
          d="M18.36 9L18.96 12H5.04L5.64 9H18.36ZM20 4H4V6H20V4ZM20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7ZM6 18V14H12V18H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStoreMallDirectory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="store_mall_directory">
        <path
          id="Vector"
          d="M18.36 9L18.96 12H5.04L5.64 9H18.36ZM20 4H4V6H20V4ZM20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7ZM6 18V14H12V18H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStorefront(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="storefront">
        <path
          id="Vector"
          d="M21.8981 8.89L20.8481 4.52C20.6281 3.62 19.8481 3 18.9381 3H5.04805C4.14805 3 3.35805 3.63 3.14805 4.52L2.09805 8.89C1.85805 9.91 2.07805 10.95 2.71805 11.77C2.79805 11.88 2.90805 11.96 2.99805 12.06V19C2.99805 20.1 3.89805 21 4.99805 21H18.9981C20.0981 21 20.9981 20.1 20.9981 19V12.06C21.0881 11.97 21.1981 11.88 21.2781 11.78C21.9181 10.96 22.1481 9.91 21.8981 8.89ZM18.9081 4.99L19.9581 9.36C20.0581 9.78 19.9681 10.2 19.7081 10.53C19.5681 10.71 19.2681 11 18.7681 11C18.1581 11 17.6281 10.51 17.5581 9.86L16.9781 5L18.9081 4.99ZM12.9981 5H14.9581L15.4981 9.52C15.5481 9.91 15.4281 10.3 15.1681 10.59C14.9481 10.85 14.6281 11 14.2181 11C13.5481 11 12.9981 10.41 12.9981 9.69V5ZM8.48805 9.52L9.03805 5H10.9981V9.69C10.9981 10.41 10.4481 11 9.70805 11C9.36805 11 9.05805 10.85 8.81805 10.59C8.56805 10.3 8.44805 9.91 8.48805 9.52ZM4.03805 9.36L5.04805 5H7.01805L6.43805 9.86C6.35805 10.51 5.83805 11 5.22805 11C4.73805 11 4.42805 10.71 4.29805 10.53C4.02805 10.21 3.93805 9.78 4.03805 9.36ZM4.99805 19V12.97C5.07805 12.98 5.14805 13 5.22805 13C6.09805 13 6.88805 12.64 7.46805 12.05C8.06805 12.65 8.86805 13 9.77805 13C10.6481 13 11.4281 12.64 12.0081 12.07C12.5981 12.64 13.3981 13 14.2981 13C15.1381 13 15.9381 12.65 16.5381 12.05C17.1181 12.64 17.9081 13 18.7781 13C18.8581 13 18.9281 12.98 19.0081 12.97V19H4.99805Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStorm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="storm">
        <path
          id="Vector"
          d="M18.9321 8C16.7221 4.18 11.8221 2.87 8.00209 5.07C6.59209 5.89 5.52209 7.07 4.84209 8.44C4.71209 6.24 5.06209 4.04 5.86209 2H3.74209C2.20209 6.49 2.52209 11.58 5.07209 16C6.17209 17.91 7.95209 19.19 9.93209 19.72C11.9121 20.25 14.0921 20.03 16.0021 18.93C17.4121 18.11 18.4821 16.93 19.1621 15.56C19.2921 17.76 18.9521 19.96 18.1521 22H20.2621C21.7921 17.51 21.4821 12.42 18.9321 8ZM15.0021 17.2C12.1321 18.85 8.46209 17.87 6.80209 15C6.69209 14.8 6.59209 14.6 6.50209 14.4C5.30209 11.64 6.33209 8.34 9.00209 6.8C11.8621 5.15 15.5421 6.13 17.2021 9C17.3121 9.2 17.4121 9.4 17.5021 9.6C18.7021 12.36 17.6721 15.66 15.0021 17.2ZM12.0021 10C13.1021 10 14.0021 10.9 14.0021 12C14.0021 13.1 13.1021 14 12.0021 14C10.9021 14 10.0021 13.1 10.0021 12C10.0021 10.9 10.9021 10 12.0021 10ZM12.0021 8C9.79209 8 8.00209 9.79 8.00209 12C8.00209 14.21 9.79209 16 12.0021 16C14.2121 16 16.0021 14.21 16.0021 12C16.0021 9.79 14.2121 8 12.0021 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStraight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="straight">
        <path
          id="Vector"
          d="M11 6.83L9.41 8.41L8 7L12 3L16 7L14.59 8.41L13 6.83V21H11V6.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStraighten(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="straighten">
        <path
          id="Vector"
          d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H5V12H7V8H9V12H11V8H13V12H15V8H17V12H19V8H21V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStream(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stream">
        <g id="Vector">
          <path
            d="M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z"
            fill="currentColor"
          />
          <path
            d="M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z"
            fill="currentColor"
          />
          <path
            d="M12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22Z"
            fill="currentColor"
          />
          <path
            d="M18.3475 4.2271L13.9431 8.61904L15.3553 10.0352L19.7597 5.6433L18.3475 4.2271Z"
            fill="currentColor"
          />
          <path
            d="M8.32 9.68L8.63 10L10.05 8.59L6.03 4.55H6.02L5.71 4.23L4.29 5.64L8.31 9.69L8.32 9.68Z"
            fill="currentColor"
          />
          <path
            d="M15.41 13.94L14 15.35L17.99 19.36L18.34 19.71L19.76 18.3L15.77 14.29L15.41 13.94Z"
            fill="currentColor"
          />
          <path
            d="M8.59 13.95L4.56 17.96L4.24 18.29L5.65 19.7L9.68 15.68L10.01 15.36L8.59 13.95Z"
            fill="currentColor"
          />
          <path
            d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconStreetview(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="streetview">
        <g id="Vector">
          <path
            d="M11.56 15.33C11.22 15.6 11 16.03 11 16.5V22H18C19.1 22 20 21.1 20 20V14.02C19.06 13.69 18.05 13.5 17 13.5C14.97 13.5 13.07 14.2 11.56 15.33Z"
            fill="currentColor"
          />
          <path
            d="M17 12C19.7614 12 22 9.76142 22 7C22 4.23858 19.7614 2 17 2C14.2386 2 12 4.23858 12 7C12 9.76142 14.2386 12 17 12Z"
            fill="currentColor"
          />
          <path
            d="M10.5 7C10.5 5.92 10.77 4.9 11.24 4H4C2.9 4 2 4.9 2 6V20C2 20.55 2.23 21.05 2.59 21.41L12.41 11.59C11.23 10.42 10.5 8.8 10.5 7Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconStrikethroughS(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="strikethrough_s">
        <path
          id="Vector"
          d="M7.24 10.245C6.98 9.765 6.85 9.21499 6.85 8.575C6.85 7.96499 6.98 7.41499 7.25 6.90499C7.51 6.40499 7.88 5.975 8.36 5.615C8.84 5.26499 9.41 4.985 10.06 4.785C10.72 4.595 11.45 4.495 12.24 4.495C13.05 4.495 13.78 4.605 14.45 4.835C15.11 5.055 15.68 5.375 16.14 5.775C16.61 6.175 16.97 6.655 17.22 7.205C17.47 7.755 17.6 8.355 17.6 9.015H14.59C14.59 8.705 14.54 8.425 14.44 8.165C14.35 7.895 14.2 7.67499 14 7.48499C13.8 7.29499 13.55 7.155 13.25 7.045C12.95 6.945 12.59 6.88499 12.19 6.88499C11.8 6.88499 11.45 6.925 11.16 7.015C10.87 7.105 10.63 7.225 10.44 7.375C10.25 7.535 10.1 7.71499 10 7.92499C9.9 8.13499 9.85 8.355 9.85 8.585C9.85 9.065 10.1 9.465 10.59 9.795C10.97 10.045 11.36 10.275 12 10.495H7.39C7.34 10.415 7.28 10.325 7.24 10.245ZM21 11.495H3V13.495H12.62C12.8 13.565 13.02 13.635 13.17 13.695C13.54 13.865 13.83 14.035 14.04 14.205C14.25 14.375 14.39 14.565 14.47 14.775C14.54 14.975 14.58 15.205 14.58 15.465C14.58 15.695 14.53 15.915 14.44 16.125C14.35 16.325 14.21 16.505 14.02 16.655C13.83 16.805 13.6 16.915 13.31 17.005C13.02 17.085 12.68 17.135 12.3 17.135C11.87 17.135 11.47 17.095 11.12 17.005C10.77 16.915 10.46 16.775 10.21 16.585C9.96 16.395 9.76 16.145 9.62 15.835C9.48 15.525 9.37 15.075 9.37 14.625H6.4C6.4 15.175 6.48 15.755 6.64 16.205C6.8 16.655 7.01 17.055 7.29 17.415C7.57 17.765 7.89 18.075 8.27 18.335C8.64 18.595 9.05 18.815 9.49 18.985C9.93 19.155 10.39 19.285 10.87 19.375C11.35 19.455 11.83 19.505 12.31 19.505C13.11 19.505 13.84 19.415 14.49 19.225C15.14 19.035 15.7 18.775 16.16 18.435C16.62 18.095 16.98 17.665 17.23 17.165C17.48 16.665 17.61 16.095 17.61 15.455C17.61 14.855 17.51 14.315 17.3 13.845C17.25 13.735 17.19 13.615 17.13 13.515H21V11.495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStroller(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="stroller">
        <path
          id="Vector"
          d="M17 19.5C17 20.6 16.1 21.5 15 21.5C13.9 21.5 13 20.6 13 19.5C13 18.4 13.9 17.5 15 17.5C16.1 17.5 17 18.4 17 19.5ZM5 17.5C3.9 17.5 3 18.4 3 19.5C3 20.6 3.9 21.5 5 21.5C6.1 21.5 7 20.6 7 19.5C7 18.4 6.1 17.5 5 17.5ZM14 8.16L8.6 14.5H14V8.16ZM17.65 2.5C19.52 2.5 21 4.06 21 5.98V6.5H19V5.98C19 5.16 18.42 4.5 17.65 4.5C16.97 4.5 16.58 5.09 16 5.77V14.5C16 15.6 15.1 16.5 14 16.5H6.43C5.58 16.5 5.12 15.5 5.67 14.85L14.47 4.53C15.11 3.77 15.99 2.5 17.65 2.5ZM9 4.5C8.35 4.5 7.71 4.59 7.09 4.77L8.49 6.17L9.86 4.56C9.58 4.52 9.29 4.5 9 4.5ZM9 2.5C10.56 2.5 12.03 2.9 13.3 3.6L8.6 9.11L3.72 4.22C5.21 3.14 7.03 2.5 9 2.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStyle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="style">
        <g id="Vector">
          <path
            d="M2.79231 19.4L4.13231 19.96V10.93L1.70231 16.79C1.29231 17.81 1.78231 18.98 2.79231 19.4ZM22.2923 15.7L17.3323 3.73C17.0223 2.98 16.2923 2.52 15.5223 2.5C15.2623 2.5 14.9923 2.54 14.7323 2.65L7.36231 5.7C6.61231 6.01 6.15231 6.73 6.13231 7.5C6.12231 7.77 6.17231 8.04 6.28231 8.3L11.2423 20.27C11.5523 21.03 12.2923 21.49 13.0723 21.5C13.3323 21.5 13.5923 21.45 13.8423 21.35L21.2023 18.3C22.2223 17.88 22.7123 16.71 22.2923 15.7ZM13.0923 19.5L8.13231 7.54L15.4823 4.5H15.4923L20.4423 16.45L13.0923 19.5Z"
            fill="currentColor"
          />
          <path
            d="M11.2623 9.75C11.8146 9.75 12.2623 9.30228 12.2623 8.75C12.2623 8.19772 11.8146 7.75 11.2623 7.75C10.71 7.75 10.2623 8.19772 10.2623 8.75C10.2623 9.30228 10.71 9.75 11.2623 9.75Z"
            fill="currentColor"
          />
          <path
            d="M6.14231 19.5C6.14231 20.6 7.04231 21.5 8.14231 21.5H9.59231L6.14231 13.16V19.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSubdirectoryArrowLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subdirectory_arrow_left">
        <path
          id="Vector"
          d="M10.5 8.5L11.92 9.92L8.33 13.5H17.5V3.5H19.5V15.5H8.33L11.92 19.08L10.5 20.5L4.5 14.5L10.5 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSubdirectoryArrowRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subdirectory_arrow_right">
        <path
          id="Vector"
          d="M19.5 14.5L13.5 20.5L12.08 19.08L15.67 15.5H4.5V3.5H6.5V13.5H15.67L12.08 9.92L13.5 8.5L19.5 14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSubject(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subject">
        <path
          id="Vector"
          d="M14 17H4V19H14V17ZM20 9H4V11H20V9ZM4 15H20V13H4V15ZM4 5V7H20V5H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSubscript(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subscript">
        <path
          id="Vector"
          d="M19.5599 18H17.5599V19H20.5599V20H16.5599V18C16.5599 17.45 17.0099 17 17.5599 17H19.5599V16H16.5599V15H19.5599C20.1099 15 20.5599 15.45 20.5599 16V17C20.5599 17.55 20.1099 18 19.5599 18ZM3.43994 18H6.09994L9.49994 12.58H9.61994L13.0199 18H15.6799L11.0299 10.73L15.3699 4H12.6899L9.61994 8.99H9.49994L6.40994 4H3.74994L8.06994 10.73L3.43994 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSubscriptions(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subscriptions">
        <path
          id="Vector"
          d="M4 6H20V8H4V6ZM6 2H18V4H6V2ZM20 10H4C2.9 10 2 10.9 2 12V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V12C22 10.9 21.1 10 20 10ZM20 20H4V12H20V20ZM10 12.73V19.26L16 16L10 12.73Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSubtitles(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subtitles">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18ZM6 10H8V12H6V10ZM6 14H14V16H6V14ZM16 14H18V16H16V14ZM10 10H18V12H10V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSubtitlesOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subtitles_off">
        <g id="Vector">
          <path
            d="M20.48 3.295H7.31002L9.31002 5.295H20.48V16.465L22.24 18.225C22.39 17.945 22.48 17.635 22.48 17.295V5.295C22.48 4.19499 21.58 3.295 20.48 3.295Z"
            fill="currentColor"
          />
          <path d="M18.48 9.295H13.31L15.31 11.295H18.48V9.295Z" fill="currentColor" />
          <path
            d="M1.52002 3.16499L2.72002 4.365C2.57002 4.645 2.48002 4.955 2.48002 5.295V17.295C2.48002 18.395 3.38002 19.295 4.48002 19.295H17.65L20.61 22.255L22.02 20.845L2.93002 1.745L1.52002 3.16499ZM4.48002 6.125L7.65002 9.295H6.48002V11.295H8.48002V10.125L11.65 13.295H6.48002V15.295H13.65L15.65 17.295H4.48002V6.125Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSubway(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="subway">
        <path
          id="Vector"
          d="M17.8 2.8C16 2.09 13.86 2 12 2C10.14 2 8 2.09 6.2 2.8C3.53 3.84 2 6.05 2 8.86V22H22V8.86C22 6.05 20.47 3.84 17.8 2.8ZM9.17 20L10.67 18.5H13.33L14.83 20H9.17ZM7.01 14V9H17.01V14H7.01ZM16.5 16C16.5 16.55 16.05 17 15.5 17C14.95 17 14.5 16.55 14.5 16C14.5 15.45 14.95 15 15.5 15C16.05 15 16.5 15.45 16.5 16ZM8.5 15C9.05 15 9.5 15.45 9.5 16C9.5 16.55 9.05 17 8.5 17C7.95 17 7.5 16.55 7.5 16C7.5 15.45 7.95 15 8.5 15ZM20 20H16.5V19.62L15.35 18.46C16.84 18.29 18 17.04 18 15.5V9C18 6.37 15 6 12 6C9 6 6 6.37 6 9V15.5C6 17.04 7.16 18.29 8.65 18.46L7.5 19.62V20H4V8.86C4 6.86 5.01 5.41 6.93 4.66C8.41 4.08 10.32 4 12 4C13.68 4 15.59 4.08 17.07 4.66C18.99 5.41 20 6.86 20 8.86V20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSummarize(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="summarize">
        <path
          id="Vector"
          d="M15 3H5C3.9 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 4.99 21H19C20.1 21 21 20.1 21 19V9L15 3ZM5 19V5H14V10H19V19H5ZM9 8C9 8.55 8.55 9 8 9C7.45 9 7 8.55 7 8C7 7.45 7.45 7 8 7C8.55 7 9 7.45 9 8ZM9 12C9 12.55 8.55 13 8 13C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11C8.55 11 9 11.45 9 12ZM9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSuperscript(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="superscript">
        <path
          id="Vector"
          d="M19.5599 7H17.5599V8H20.5599V9H16.5599V7C16.5599 6.45 17.0099 6 17.5599 6H19.5599V5H16.5599V4H19.5599C20.1099 4 20.5599 4.45 20.5599 5V6C20.5599 6.55 20.1099 7 19.5599 7ZM3.43994 20H6.09994L9.49994 14.58H9.61994L13.0199 20H15.6799L11.0299 12.73L15.3699 6H12.6899L9.61994 10.99H9.49994L6.40994 6H3.74994L8.06994 12.73L3.43994 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSupervisedUserCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="supervised_user_circle">
        <path
          id="Vector"
          d="M12.51 9.99C12.51 8.34 11.16 6.99 9.51 6.99C7.86 6.99 6.51 8.34 6.51 9.99C6.51 11.64 7.86 12.99 9.51 12.99C11.16 12.99 12.51 11.64 12.51 9.99ZM9.51 10.99C8.96 10.99 8.51 10.54 8.51 9.99C8.51 9.44 8.96 8.99 9.51 8.99C10.06 8.99 10.51 9.44 10.51 9.99C10.51 10.54 10.06 10.99 9.51 10.99ZM16.01 12.99C17.12 12.99 18.01 12.1 18.01 10.99C18.01 9.88 17.12 8.99 16.01 8.99C14.9 8.99 14 9.88 14.01 10.99C14.01 12.1 14.9 12.99 16.01 12.99ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM5.85 17.11C6.53 16.57 8.12 16 9.51 16C9.58 16 9.66 16.01 9.74 16.01C9.98 15.37 10.41 14.72 11.04 14.15C10.48 14.05 9.95 13.99 9.51 13.99C8.21 13.99 6.12 14.44 4.78 15.42C4.28 14.38 4 13.22 4 11.99C4 7.58 7.59 3.99 12 3.99C16.41 3.99 20 7.58 20 11.99C20 13.19 19.73 14.33 19.25 15.36C18.25 14.77 16.89 14.49 16.01 14.49C14.49 14.49 11.51 15.3 11.51 17.19V19.97C9.24 19.84 7.22 18.76 5.85 17.11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSupervisorAccount(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="supervisor_account">
        <path
          id="Vector"
          d="M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM9.05 17H4.77C5.76 16.5 7.47 16 9 16C9.11 16 9.23 16.01 9.34 16.01C9.68 15.28 10.27 14.68 10.98 14.2C10.25 14.07 9.56 14 9 14C6.66 14 2 15.17 2 17.5V19H9V17.5C9 17.33 9.02 17.16 9.05 17ZM16.5 14.5C14.66 14.5 11 15.51 11 17.5V19H22V17.5C22 15.51 18.34 14.5 16.5 14.5ZM17.71 12.68C18.47 12.25 19 11.44 19 10.5C19 9.12 17.88 8 16.5 8C15.12 8 14 9.12 14 10.5C14 11.44 14.53 12.25 15.29 12.68C15.65 12.88 16.06 13 16.5 13C16.94 13 17.35 12.88 17.71 12.68Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSupport(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="support">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19.46 9.12L16.68 10.27C16.17 8.91 15.1 7.83 13.73 7.33L14.88 4.55C16.98 5.35 18.65 7.02 19.46 9.12ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15ZM9.13 4.54L10.3 7.32C8.92 7.82 7.83 8.91 7.32 10.29L4.54 9.13C5.35 7.02 7.02 5.35 9.13 4.54ZM4.54 14.87L7.32 13.72C7.83 15.1 8.91 16.18 10.29 16.68L9.12 19.46C7.02 18.65 5.35 16.98 4.54 14.87ZM14.88 19.46L13.73 16.68C15.1 16.17 16.18 15.09 16.68 13.71L19.46 14.88C18.65 16.98 16.98 18.65 14.88 19.46Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSupportAgent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="support_agent">
        <g id="Vector">
          <path
            d="M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18H5V11.9C5 8.03 8.13 4.9 12 4.9C15.87 4.9 19 8.03 19 11.9V19H11V21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z"
            fill="currentColor"
          />
          <path
            d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z"
            fill="currentColor"
          />
          <path
            d="M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z"
            fill="currentColor"
          />
          <path
            d="M18 11.03C17.52 8.18 15.04 6 12.05 6C9.02 6 5.76 8.51 6.02 12.45C8.49 11.44 10.35 9.24 10.88 6.56C12.19 9.19 14.88 11 18 11.03Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSurfing(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="surfing">
        <path
          id="Vector"
          d="M21 22.75C19.97 22.75 18.94 22.5 18 22C16.11 23 13.89 23 12 22C10.11 23 7.89 23 6 22C5.05 22.5 4.03 22.75 3 22.75H2V20.75H3C4.04 20.75 5.08 20.4 6 19.75C7.83 21.05 10.17 21.05 12 19.75C13.83 21.05 16.17 21.05 18 19.75C18.91 20.4 19.96 20.75 21 20.75H22V22.75H21ZM17 1.25C15.9 1.25 15 2.15 15 3.25C15 4.35 15.9 5.25 17 5.25C18.1 5.25 19 4.35 19 3.25C19 2.15 18.1 1.25 17 1.25ZM14.43 8.23L12.18 9.75L16 12.75V16.59C16.53 16.97 17.03 17.37 17.49 17.76C16.81 18.34 15.94 18.75 15 18.75C13.8 18.75 12.73 18.09 12 17.25C11.27 18.09 10.2 18.75 9 18.75C8.67 18.75 8.35 18.7 8.04 18.61C5.19 16.65 3 14.47 3 13.03C3 12 4.01 11.75 4.85 11.75C5.83 11.75 7.13 12.06 8.55 12.58L8.02 9.48C7.91 8.81 8.2 8.1 8.8 7.69L10.95 6.24L8.95 5.87L6.13 7.8L5 6.15L8.5 3.75L14.05 4.78C14.5 4.87 14.98 5.15 15.27 5.67L16.15 7.22C17.01 8.73 18.64 9.75 20.5 9.75V11.75C17.91 11.75 15.64 10.33 14.43 8.23ZM10.3 10.85L10.74 13.5C11.66 13.92 13.22 14.77 14 15.25V13.75L10.3 10.85Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSurroundSound(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="surround_sound">
        <g id="Vector">
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill="currentColor"
          />
          <path
            d="M8.29 15.71C7.27 14.69 6.75 13.35 6.75 12C6.75 10.65 7.27 9.31 8.28 8.28L7.05 7.05C5.68 8.41 5 10.21 5 12C5 13.79 5.68 15.59 7.06 16.94L8.29 15.71Z"
            fill="currentColor"
          />
          <path
            d="M12 15.5C13.93 15.5 15.5 13.93 15.5 12C15.5 10.07 13.93 8.5 12 8.5C10.07 8.5 8.5 10.07 8.5 12C8.5 13.93 10.07 15.5 12 15.5ZM12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5Z"
            fill="currentColor"
          />
          <path
            d="M15.72 15.72L16.95 16.95C18.32 15.59 19 13.79 19 12C19 10.21 18.32 8.41 16.94 7.06L15.71 8.29C16.73 9.31 17.25 10.65 17.25 12C17.25 13.35 16.73 14.69 15.72 15.72Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSwapCalls(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swap_calls">
        <path
          id="Vector"
          d="M18 4.5L14 8.5H17V15.5C17 16.6 16.1 17.5 15 17.5C13.9 17.5 13 16.6 13 15.5V8.5C13 6.29 11.21 4.5 9 4.5C6.79 4.5 5 6.29 5 8.5V15.5H2L6 19.5L10 15.5H7V8.5C7 7.4 7.9 6.5 9 6.5C10.1 6.5 11 7.4 11 8.5V15.5C11 17.71 12.79 19.5 15 19.5C17.21 19.5 19 17.71 19 15.5V8.5H22L18 4.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwapHoriz(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swap_horiz">
        <path
          id="Vector"
          d="M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwapHorizontalCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swap_horizontal_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15 6.5V9H11V11H15V13.5L18.5 10L15 6.5ZM9 10.5L5.5 14L9 17.5V15H13V13H9V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwapVert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swap_vert">
        <path
          id="Vector"
          d="M16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwapVerticalCircle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swap_vertical_circle">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 9L10 5.5L13.5 9H11V13H9V9H6.5ZM17.5 15L14 18.5L10.5 15H13V11H15V15H17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe">
        <g id="Vector">
          <path
            d="M20.5 2V4.02C18.18 2.13 15.22 1 12 1C8.78 1 5.82 2.13 3.5 4.02V2H2V7H7V5.5H4.09C6.2 3.64 8.97 2.5 12 2.5C15.03 2.5 17.79 3.64 19.91 5.5H17V7H22V2H20.5Z"
            fill="currentColor"
          />
          <path
            d="M18.89 13.77L15.09 12.1C14.96 12.04 14.81 12 14.65 12H14V7.63C14 6.31 13.04 5.13 11.73 5.01C10.25 4.88 9 6.05 9 7.5V15.65L7.13 15.25C6.94 15.22 6.11 15.1 5.4 15.81L4 17.22L9.12 22.41C9.49 22.79 10 23 10.53 23H17.08C18.06 23 18.89 22.3 19.05 21.33L19.97 15.89C20.12 15.03 19.68 14.17 18.89 13.77ZM18 15.56L17.08 21H10.53L6.83 17.22L11 18.11V7.5C11 7.22 11.22 7 11.5 7C11.78 7 12 7.22 12 7.5V13.68H13.76L18 15.56Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSwipeDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_down">
        <path
          id="Vector"
          d="M19.9743 10.0028L15.8243 10.0128C15.6643 10.0028 15.5143 10.0328 15.3743 10.0928L14.7843 10.3528L12.9543 6.25281C12.3943 4.99281 10.9143 4.42281 9.65427 4.98281C8.39427 5.54281 7.82427 7.02281 8.38427 8.28281L11.6843 15.7328L9.81427 16.1228C9.62427 16.1728 8.82427 16.3928 8.45427 17.3328L7.75427 19.1928L14.5343 21.8628C15.0243 22.0528 15.5843 22.0428 16.0643 21.8228L22.0543 19.1728C22.9443 18.7728 23.4243 17.7928 23.1843 16.8528L21.8243 11.5128C21.6043 10.6528 20.8543 10.0428 19.9743 10.0028ZM21.2443 17.3428L15.2543 20.0028L10.3343 18.0428L14.5143 17.1628L10.2143 7.46281C10.1043 7.21281 10.2143 6.91281 10.4643 6.80281C10.7143 6.69281 11.0143 6.80281 11.1243 7.05281L13.6243 12.7028L15.2343 11.9928L19.8843 12.0028L21.2443 17.3428ZM3.55427 12.1828C3.35427 11.3228 3.25427 10.4228 3.25427 9.50281C3.25427 6.66281 4.24427 4.05281 5.88427 2.00281L6.95427 3.07281C5.57427 4.85281 4.75427 7.08281 4.75427 9.50281C4.75427 10.3828 4.86427 11.2428 5.07427 12.0628L6.69427 10.4428L7.75427 11.5028L4.25427 15.0028L0.754272 11.5028L1.81427 10.4428L3.55427 12.1828Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeDownAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_down_alt">
        <path
          id="Vector"
          d="M13 12.9C15.28 12.44 17 10.42 17 8C17 5.24 14.76 3 12 3C9.24 3 7 5.24 7 8C7 10.42 8.72 12.44 11 12.9V17.17L9.41 15.58L8 17L12 21L16 17L14.59 15.59L13 17.17V12.9ZM15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5C13.66 5 15 6.34 15 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_left">
        <path
          id="Vector"
          d="M18.89 13.77L15.09 12.1C14.96 12.04 14.81 12 14.65 12H14V7.5C14 6.12 12.88 5 11.5 5C10.12 5 9 6.12 9 7.5V15.65L7.13 15.25C6.94 15.22 6.11 15.1 5.4 15.81L4 17.22L9.12 22.41C9.49 22.79 10 23 10.53 23H17.08C18.06 23 18.89 22.3 19.05 21.33L19.97 15.89C20.12 15.03 19.68 14.17 18.89 13.77ZM17.08 21H10.53L6.83 17.22L11 18.11V7.5C11 7.22 11.22 7 11.5 7C11.78 7 12 7.22 12 7.5V13.68H13.76L18 15.56L17.08 21ZM4.09 5.5H7V7H2V2H3.5V4.02C5.82 2.13 8.78 1 12 1C17.49 1 21.27 4.12 22 7H20.43C19.67 5.02 16.74 2.5 12 2.5C8.97 2.5 6.21 3.64 4.09 5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeLeftAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_left_alt">
        <path
          id="Vector"
          d="M11.1 13C11.56 15.28 13.58 17 16 17C18.76 17 21 14.76 21 12C21 9.24 18.76 7 16 7C13.58 7 11.56 8.72 11.1 11H6.83L8.42 9.41L7 8L3 12L7 16L8.41 14.59L6.83 13H11.1ZM16 15C14.34 15 13 13.66 13 12C13 10.34 14.34 9 16 9C17.66 9 19 10.34 19 12C19 13.66 17.66 15 16 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_right">
        <path
          id="Vector"
          d="M18.89 13.77L15.09 12.1C14.96 12.04 14.81 12 14.65 12H14V7.5C14 6.12 12.88 5 11.5 5C10.12 5 9 6.12 9 7.5V15.65L7.13 15.25C6.94 15.22 6.11 15.1 5.4 15.81L4 17.22L9.12 22.41C9.49 22.79 10 23 10.53 23H17.08C18.06 23 18.89 22.3 19.05 21.33L19.97 15.89C20.12 15.03 19.68 14.17 18.89 13.77ZM17.08 21H10.53L6.83 17.22L11 18.11V7.5C11 7.22 11.22 7 11.5 7C11.78 7 12 7.22 12 7.5V13.68H13.76L18 15.56L17.08 21ZM12 2.5C7.26 2.5 4.33 5.02 3.57 7H2C2.73 4.12 6.51 1 12 1C15.22 1 18.18 2.13 20.5 4.02V2H22V7H17V5.5H19.91C17.79 3.64 15.03 2.5 12 2.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeRightAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_right_alt">
        <path
          id="Vector"
          d="M12.9 11C12.44 8.72 10.42 7 8 7C5.24 7 3 9.24 3 12C3 14.76 5.24 17 8 17C10.42 17 12.44 15.28 12.9 13H17.17L15.58 14.59L17 16L21 12L17 8L15.59 9.41L17.17 11H12.9ZM8 9C9.66 9 11 10.34 11 12C11 13.66 9.66 15 8 15C6.34 15 5 13.66 5 12C5 10.34 6.34 9 8 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_up">
        <path
          id="Vector"
          d="M19.9743 10.5028L15.8243 10.5128C15.6643 10.5028 15.5143 10.5328 15.3743 10.5928L14.7843 10.8528L12.9543 6.75281C12.3943 5.49281 10.9143 4.92281 9.65427 5.48281C8.39427 6.04281 7.82427 7.52281 8.38427 8.78281L11.6843 16.2328L9.81427 16.6228C9.62427 16.6728 8.82427 16.8928 8.45427 17.8328L7.75427 19.6928L14.5343 22.3628C15.0243 22.5528 15.5843 22.5428 16.0643 22.3228L22.0543 19.6728C22.9443 19.2728 23.4243 18.2928 23.1843 17.3528L21.8243 12.0128C21.6043 11.1528 20.8543 10.5428 19.9743 10.5028ZM21.2443 17.8428L15.2543 20.5028L10.3343 18.5428L14.5143 17.6628L10.2143 7.96281C10.1043 7.71281 10.2143 7.41281 10.4643 7.30281C10.7143 7.19281 11.0143 7.30281 11.1243 7.55281L13.6243 13.2028L15.2343 12.4928L19.8843 12.5028L21.2443 17.8428ZM1.81427 6.06281L0.754272 5.00281L4.25427 1.50281L7.75427 5.00281L6.69427 6.06281L5.07427 4.44281C4.86427 5.26281 4.75427 6.12281 4.75427 7.00281C4.75427 9.42281 5.57427 11.6528 6.95427 13.4328L5.88427 14.5028C4.24427 12.4528 3.25427 9.84281 3.25427 7.00281C3.25427 6.08281 3.35427 5.18281 3.55427 4.32281L1.81427 6.06281Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeUpAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_up_alt">
        <path
          id="Vector"
          d="M13 6.83L14.59 8.42L16 7L12 3L8 7L9.41 8.41L11 6.83V11.1C8.72 11.56 7 13.58 7 16C7 18.76 9.24 21 12 21C14.76 21 17 18.76 17 16C17 13.58 15.28 11.56 13 11.1V6.83ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwipeVertical(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="swipe_vertical">
        <path
          id="Vector"
          d="M1.25415 2H6.25415V7H4.75415V4.09C2.89415 6.2 1.75415 8.97 1.75415 12C1.75415 15.03 2.89415 17.79 4.75415 19.91V17H6.25415V22H1.25415V20.5H3.27415C1.38415 18.18 0.25415 15.22 0.25415 12C0.25415 8.78 1.38415 5.82 3.27415 3.5H1.25415V2ZM20.4741 10L16.3242 10.01C16.1642 10 16.0142 10.03 15.8742 10.09L15.2842 10.35L13.4542 6.25C12.8941 4.99 11.4142 4.42 10.1542 4.98C8.89415 5.54 8.32415 7.02 8.88415 8.28L12.1842 15.73L10.3142 16.12C10.1242 16.17 9.32415 16.39 8.95415 17.33L8.25415 19.19L15.0342 21.86C15.5241 22.05 16.0842 22.04 16.5641 21.82L22.5541 19.17C23.4441 18.77 23.9242 17.79 23.6842 16.85L22.3242 11.51C22.1042 10.65 21.3541 10.04 20.4741 10ZM21.7442 17.34L15.7542 20L10.8342 18.04L15.0142 17.16L10.7142 7.46C10.6042 7.21 10.7142 6.91 10.9642 6.8C11.2142 6.69 11.5142 6.8 11.6242 7.05L14.1242 12.7L15.7341 11.99L20.3841 12L21.7442 17.34Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwitchAccessShortcut(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_access_shortcut">
        <path
          id="Vector"
          d="M8.06 8.94L6 8L8.06 7.06L9 5L9.94 7.06L12 8L9.94 8.94L9 11L8.06 8.94ZM9 21L9.94 18.94L12 18L9.94 17.06L9 15L8.06 17.06L6 18L8.06 18.94L9 21ZM5.37 12.37L4 13L5.37 13.63L6 15L6.63 13.63L8 13L6.63 12.37L6 11L5.37 12.37ZM13 12C13 8.91 14.38 6.06 16.44 4H13V2H20V9H18V5.28C16.2 7.02 15 9.48 15 12C15 15.32 17.1 18.36 20 19.82V22C15.91 20.41 13 16.35 13 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwitchAccessShortcutAdd(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_access_shortcut_add">
        <path
          id="Vector"
          d="M5.56 8.94L3.5 8L5.56 7.06L6.5 5L7.44 7.06L9.5 8L7.44 8.94L6.5 11L5.56 8.94ZM6.5 21L7.44 18.94L9.5 18L7.44 17.06L6.5 15L5.56 17.06L3.5 18L5.56 18.94L6.5 21ZM2.87 12.37L1.5 13L2.87 13.63L3.5 15L4.13 13.63L5.5 13L4.13 12.37L3.5 11L2.87 12.37ZM10.5 12C10.5 8.91 11.88 6.06 13.94 4H10.5V2H17.5V9H15.5V5.28C13.7 7.02 12.5 9.48 12.5 12C12.5 15.32 14.6 18.36 17.5 19.82V22C13.41 20.41 10.5 16.35 10.5 12ZM22.5 14H20.5V12H18.5V14H16.5V16H18.5V18H20.5V16H22.5V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwitchAccount(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_account">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM14 11C15.66 11 17 9.66 17 8C17 6.34 15.66 5 14 5C12.34 5 11 6.34 11 8C11 9.66 12.34 11 14 11ZM14 7C14.55 7 15 7.45 15 8C15 8.55 14.55 9 14 9C13.45 9 13 8.55 13 8C13 7.45 13.45 7 14 7ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM10.69 16C11.64 15.37 12.78 15 14 15C15.22 15 16.36 15.37 17.31 16H10.69ZM20 15.73C18.53 14.06 16.4 13 14 13C11.6 13 9.47 14.06 8 15.73V4H20V15.73Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwitchCamera(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_camera">
        <g id="Vector">
          <path
            d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM9.88 5H14.12L15.95 7H20V19H4V7H8.05"
            fill="currentColor"
          />
          <path d="M15 12H9V9.5L5.5 13L9 16.5V14H15V16.5L18.5 13L15 9.5V12Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconSwitchLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_left">
        <path
          id="Vector"
          d="M8.5 8.62V15.38L5.12 12L8.5 8.62ZM10 5L3 12L10 19V5ZM14 5V19L21 12L14 5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwitchRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_right">
        <path
          id="Vector"
          d="M15.5 15.38V8.62L18.88 12L15.5 15.38ZM14 19L21 12L14 5V19ZM10 19V5L3 12L10 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSwitchVideo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="switch_video">
        <path
          id="Vector"
          d="M8 13H12V15L15 12L12 9V11H8V9L5 12L8 15V13ZM18 9.5V6C18 5.45 17.55 5 17 5H3C2.45 5 2 5.45 2 6V18C2 18.55 2.45 19 3 19H17C17.55 19 18 18.55 18 18V14.5L22 18.5V5.5L18 9.5ZM16 17H4V7H16V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSynagogue(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="synagogue">
        <g id="Vector">
          <path
            d="M20 4C18.34 4 17 5.34 17 7V7.29L12 3L7 7.29V7C7 5.34 5.66 4 4 4C2.34 4 1 5.34 1 7V21H11V16C11 15.45 11.45 15 12 15C12.55 15 13 15.45 13 16V21H23V7C23 5.34 21.66 4 20 4ZM20 6C20.55 6 21 6.45 21 7V8H19V7C19 6.45 19.45 6 20 6ZM4 6C4.55 6 5 6.45 5 7V8H3V7C3 6.45 3.45 6 4 6ZM3 19V10H5V19H3ZM17 19H15V16C15 14.35 13.65 13 12 13C10.35 13 9 14.35 9 16V19H7V9.92L12 5.63L17 9.92V19ZM19 19V10H21V19H19Z"
            fill="currentColor"
          />
          <path
            d="M12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.1716 8.5 10.5 9.17157 10.5 10C10.5 10.8284 11.1716 11.5 12 11.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSync(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sync">
        <path
          id="Vector"
          d="M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSyncAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sync_alt">
        <g id="Vector">
          <path
            d="M7.41 13.41L6 12L2 16L6 20L7.41 18.59L5.83 17H21V15H5.83L7.41 13.41Z"
            fill="currentColor"
          />
          <path
            d="M16.59 10.59L18 12L22 8L18 4L16.59 5.41L18.17 7H3V9H18.17L16.59 10.59Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSyncDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sync_disabled">
        <path
          id="Vector"
          d="M10.4601 5.66995V3.57995C9.80007 3.74995 9.17007 4.00995 8.58007 4.32995L10.0801 5.82995C10.2101 5.77995 10.3301 5.71995 10.4601 5.66995ZM20.4601 11.3199C20.4601 9.10995 19.5501 7.11995 18.1001 5.67995L20.4601 3.31995H14.4601V9.31995L16.7001 7.07995C17.7801 8.16995 18.4601 9.65995 18.4601 11.3199C18.4601 12.1699 18.2701 12.9699 17.9501 13.6999L19.4501 15.1999C20.0901 14.0599 20.4601 12.7299 20.4601 11.3199ZM4.73007 3.31995L3.32007 4.72995L5.68007 7.08995C4.91007 8.30995 4.46007 9.75995 4.46007 11.3199C4.46007 13.5299 5.37007 15.5199 6.82007 16.9599L4.46007 19.3199H10.4601V13.3199L8.22007 15.5599C7.14007 14.4699 6.46007 12.9799 6.46007 11.3199C6.46007 10.3199 6.71007 9.37995 7.14007 8.54995L15.2201 16.6299C14.9701 16.7599 14.7201 16.8699 14.4601 16.9699V19.0599C15.2601 18.8499 16.0101 18.5199 16.6901 18.0999L19.2701 20.6799L20.6801 19.2699L4.73007 3.31995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSyncLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sync_lock">
        <path
          id="Vector"
          d="M9.5 3.26V5.35C7.17 6.18 5.5 8.39 5.5 11C5.5 12.77 6.28 14.34 7.5 15.44V13H9.5V19H3.5V17H6.23C4.56 15.54 3.5 13.4 3.5 11C3.5 7.27 6.05 4.15 9.5 3.26ZM19.5 3H13.5V9H15.5V6.56C16.72 7.66 17.5 9.23 17.5 11H19.5C19.5 8.6 18.44 6.46 16.77 5H19.5V3ZM19.5 16V15C19.5 13.9 18.6 13 17.5 13C16.4 13 15.5 13.9 15.5 15V16C14.95 16 14.5 16.45 14.5 17V20C14.5 20.55 14.95 21 15.5 21H19.5C20.05 21 20.5 20.55 20.5 20V17C20.5 16.45 20.05 16 19.5 16ZM18.5 16H16.5V15C16.5 14.45 16.95 14 17.5 14C18.05 14 18.5 14.45 18.5 15V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSyncProblem(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sync_problem">
        <path
          id="Vector"
          d="M3 12C3 14.21 3.91 16.2 5.36 17.64L3 20H9V14L6.76 16.24C5.68 15.15 5 13.66 5 12C5 9.39 6.67 7.17 9 6.35V4.26C5.55 5.15 3 8.27 3 12ZM11 17H13V15H11V17ZM21 4H15V10L17.24 7.76C18.32 8.85 19 10.34 19 12C19 14.61 17.33 16.83 15 17.65V19.74C18.45 18.85 21 15.73 21 12C21 9.79 20.09 7.8 18.64 6.36L21 4ZM11 13H13V7H11V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSystemSecurityUpdate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="system_security_update">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM7 4V3H17V4H7ZM16 12L12 16L8 12L9.41 10.59L11 12.17V8H13V12.17L14.59 10.58L16 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSystemSecurityUpdateGood(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="system_security_update_good">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM17 4H7V3H17V4ZM16 10.05L14.59 8.64L11.05 12.18L9.64 10.77L8.23 12.18L11.05 15L16 10.05Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSystemSecurityUpdateWarning(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="system_security_update_warning">
        <g id="Vector">
          <path d="M13 15H11V17H13V15Z" fill="currentColor" />
          <path d="M13 7H11V13H13V7Z" fill="currentColor" />
          <path
            d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM17 4H7V3H17V4Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSystemUpdate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="system_update">
        <path
          id="Vector"
          d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19ZM16 13H13V8H11V13H8L12 17L16 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSystemUpdateAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="system_update_alt">
        <path
          id="Vector"
          d="M12 16L16 12H13V3H11V12H8L12 16ZM21 3H15V4.99H21V19.02H3V4.99H9V3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM12 16L16 12H13V3H11V12H8L12 16ZM21 3H15V4.99H21V19.02H3V4.99H9V3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTab(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tab">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H13V9H21V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTabUnselected(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tab_unselected">
        <path
          id="Vector"
          d="M1 9H3V7H1V9ZM1 13H3V11H1V13ZM1 5H3V3C1.9 3 1 3.9 1 5ZM9 21H11V19H9V21ZM1 17H3V15H1V17ZM3 21V19H1C1 20.1 1.9 21 3 21ZM21 3H13V9H23V5C23 3.9 22.1 3 21 3ZM21 17H23V15H21V17ZM9 5H11V3H9V5ZM5 21H7V19H5V21ZM5 5H7V3H5V5ZM21 21C22.1 21 23 20.1 23 19H21V21ZM21 13H23V11H21V13ZM13 21H15V19H13V21ZM17 21H19V19H17V21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTableBar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="table_bar">
        <path
          id="Vector"
          d="M22 7.5C22 5.57 17.52 4 12 4C6.48 4 2 5.57 2 7.5C2 9.31 5.95 10.81 11 10.98V15H9.35C8.53 15 7.8 15.5 7.49 16.26L6 20H8L9.2 17H14.8L16 20H18L16.5 16.26C16.2 15.5 15.46 15 14.65 15H13V10.98C18.05 10.81 22 9.31 22 7.5ZM12 6C16.05 6 18.74 6.86 19.72 7.5C18.74 8.14 16.05 9 12 9C7.95 9 5.26 8.14 4.28 7.5C5.26 6.86 7.95 6 12 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTableChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="table_chart">
        <path
          id="Vector"
          d="M19.5 3H4.5C3.4 3 2.5 3.9 2.5 5V19C2.5 20.1 3.4 21 4.5 21H19.5C20.6 21 21.5 20.1 21.5 19V5C21.5 3.9 20.6 3 19.5 3ZM19.5 5V8H4.5V5H19.5ZM14.5 19H9.5V10H14.5V19ZM4.5 10H7.5V19H4.5V10ZM16.5 19V10H19.5V19H16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTableRestaurant(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="table_restaurant">
        <path
          id="Vector"
          d="M21.9601 9.73L20.5301 4.73C20.4101 4.3 20.0201 4 19.5701 4H4.43009C3.98009 4 3.59009 4.3 3.47009 4.73L2.04009 9.73C1.86009 10.36 2.34009 11 3.00009 11H5.20009L4.00009 20H6.00009L6.67009 15H17.3401L18.0001 20H20.0001L18.8001 11H21.0001C21.6601 11 22.1401 10.36 21.9601 9.73ZM6.93009 13L7.20009 11H16.8001L17.0701 13H6.93009ZM4.33009 9L5.19009 6H18.8201L19.6801 9H4.33009Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTableRows(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="table_rows">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 5V8H5V5H19ZM19 10V14H5V10H19ZM5 19V16H19V19H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTableView(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="table_view">
        <path
          id="Vector"
          d="M19 7H9C7.9 7 7 7.9 7 9V19C7 20.1 7.9 21 9 21H19C20.1 21 21 20.1 21 19V9C21 7.9 20.1 7 19 7ZM19 9V11H9V9H19ZM13 15V13H15V15H13ZM15 17V19H13V17H15ZM11 15H9V13H11V15ZM17 13H19V15H17V13ZM9 17H11V19H9V17ZM17 19V17H19V19H17ZM6 17H5C3.9 17 3 16.1 3 15V5C3 3.9 3.9 3 5 3H15C16.1 3 17 3.9 17 5V6H15V5H5V15H6V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTablet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tablet">
        <path
          id="Vector"
          d="M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 22.99 19.1 22.99 18L23 6C23 4.9 22.1 4 21 4ZM19 18H5V6H19V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTabletAndroid(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tablet_android">
        <path
          id="Vector"
          d="M18 0H6C4.34 0 3 1.34 3 3V21C3 22.66 4.34 24 6 24H18C19.66 24 21 22.66 21 21V3C21 1.34 19.66 0 18 0ZM14 22H10V21H14V22ZM19.25 19H4.75V3H19.25V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTabletMac(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tablet_mac">
        <path
          id="Vector"
          d="M19 0H5C3.62 0 2.5 1.12 2.5 2.5V21.5C2.5 22.88 3.62 24 5 24H19C20.38 24 21.5 22.88 21.5 21.5V2.5C21.5 1.12 20.38 0 19 0ZM12 23C11.17 23 10.5 22.33 10.5 21.5C10.5 20.67 11.17 20 12 20C12.83 20 13.5 20.67 13.5 21.5C13.5 22.33 12.83 23 12 23ZM19.5 19H4.5V3H19.5V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTag(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tag">
        <path
          id="Vector"
          d="M20 10V8H16V4H14V8H10V4H8V8H4V10H8V14H4V16H8V20H10V16H14V20H16V16H20V14H16V10H20ZM14 14H10V10H14V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTagFaces(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tag_faces">
        <path
          id="Vector"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTakeoutDining(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="takeout_dining">
        <path
          id="Vector"
          d="M7.79 18.5L7.28 11.5H16.74L16.23 18.5H7.79ZM9.83 5.5H14.16L16.96 8.23L16.87 9.5H7.12L7.03 8.23L9.83 5.5ZM22 7.96L20.59 6.55L19 8.13L19.03 7.57L14.98 3.5H9.02L4.97 7.57L5 8.07L3.41 6.51L2 7.94L5.23 11.05L5.93 20.5H18.07L18.77 11.06L22 7.96Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTapAndPlay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tap_and_play">
        <path
          id="Vector"
          d="M3.5 16V18C6.26 18 8.5 20.24 8.5 23H10.5C10.5 19.13 7.37 16 3.5 16ZM3.5 20V23H6.5C6.5 21.34 5.16 20 3.5 20ZM3.5 12V14C8.47 14 12.5 18.03 12.5 23H14.5C14.5 16.92 9.58 12 3.5 12ZM18.5 1.01L8.5 1C7.4 1 6.5 1.9 6.5 3V10.37C7.19 10.53 7.86 10.74 8.5 11.01V5H18.5V18H15.47C15.99 19.25 16.31 20.59 16.42 22H18.5C19.6 22 20.5 21.1 20.5 20V3C20.5 1.9 19.6 1.01 18.5 1.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTapas(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tapas">
        <path
          id="Vector"
          d="M22.25 10V1H14.25V10C14.25 11.86 15.53 13.41 17.25 13.86V21H15.25V23H21.25V21H19.25V13.86C20.97 13.41 22.25 11.86 22.25 10ZM20.25 3V6H16.25V3H20.25ZM16.25 10V8H20.25V10C20.25 11.1 19.35 12 18.25 12C17.15 12 16.25 11.1 16.25 10ZM10.25 9H8.25V8H10.25C11.63 8 12.75 6.88 12.75 5.5C12.75 4.12 11.63 3 10.25 3H8.25V1H6.25V3H4.25C2.87 3 1.75 4.12 1.75 5.5C1.75 6.88 2.87 8 4.25 8H6.25V9H4.25C2.87 9 1.75 10.12 1.75 11.5C1.75 12.88 2.87 14 4.25 14H6.25V23H8.25V14H10.25C11.63 14 12.75 12.88 12.75 11.5C12.75 10.12 11.63 9 10.25 9ZM4.25 6C3.97 6 3.75 5.78 3.75 5.5C3.75 5.22 3.97 5 4.25 5H10.25C10.53 5 10.75 5.22 10.75 5.5C10.75 5.78 10.53 6 10.25 6H4.25ZM10.25 12H4.25C3.97 12 3.75 11.78 3.75 11.5C3.75 11.22 3.97 11 4.25 11H10.25C10.53 11 10.75 11.22 10.75 11.5C10.75 11.78 10.53 12 10.25 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTask(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="task">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8.82 13.05L7.4 14.46L10.94 18L16.6 12.34L15.19 10.93L10.95 15.17L8.82 13.05Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTaskAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="task_alt">
        <path
          id="Vector"
          d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTaxiAlert(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="taxi_alert">
        <g id="Vector">
          <path
            d="M6 17.5C6.82843 17.5 7.5 16.8284 7.5 16C7.5 15.1716 6.82843 14.5 6 14.5C5.17157 14.5 4.5 15.1716 4.5 16C4.5 16.8284 5.17157 17.5 6 17.5Z"
            fill="currentColor"
          />
          <path
            d="M15 17.5C15.8284 17.5 16.5 16.8284 16.5 16C16.5 15.1716 15.8284 14.5 15 14.5C14.1716 14.5 13.5 15.1716 13.5 16C13.5 16.8284 14.1716 17.5 15 17.5Z"
            fill="currentColor"
          />
          <path
            d="M17.5 13.5V18.5H3.5V13.5H17.5C15.59 13.5 13.87 12.74 12.61 11.5H4.31L5.35 8.5H10.79C10.6 7.87 10.5 7.2 10.5 6.5C10.5 5.8 10.6 5.13 10.79 4.5H7.5V6.5H5C4.34 6.5 3.79 6.92 3.58 7.51L1.5 13.5V21.5C1.5 22.05 1.95 22.5 2.5 22.5H3.5C4.05 22.5 4.5 22.05 4.5 21.5V20.5H16.5V21.5C16.5 22.05 16.95 22.5 17.5 22.5H18.5C19.05 22.5 19.5 22.05 19.5 21.5V13.5L19.41 13.23C18.8 13.4 18.16 13.5 17.5 13.5Z"
            fill="currentColor"
          />
          <path
            d="M17.5 1.5C14.74 1.5 12.5 3.74 12.5 6.5C12.5 9.26 14.74 11.5 17.5 11.5C20.26 11.5 22.5 9.26 22.5 6.5C22.5 3.74 20.26 1.5 17.5 1.5ZM18 9.5H17V8.5H18V9.5ZM18 7.5H17V3.5H18V7.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTempleBuddhist(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="temple_buddhist">
        <path
          id="Vector"
          d="M21 9.52C21 10.61 20.11 11.5 19.02 11.5H18V9.36C19.72 8.92 21 7.37 21 5.52V5.5L19 5.52C19 6.61 18.11 7.5 17.02 7.5H16.5L12 1.5L7.5 7.5H6.98C5.89 7.5 5 6.61 5 5.52H3C3 7.38 4.28 8.92 6 9.36V11.5H4.98C3.89 11.5 3 10.61 3 9.52H1C1 11.38 2.28 12.92 4 13.36V22.5H11V18.5C11 17.95 11.45 17.5 12 17.5C12.55 17.5 13 17.95 13 18.5V22.5H20V13.36C21.72 12.92 23 11.37 23 9.52V9.5L21 9.52ZM12 4.83L14 7.5H10L12 4.83ZM8 9.5H16V11.5H8V9.5ZM18 20.5H15V18.5C15 16.85 13.65 15.5 12 15.5C10.35 15.5 9 16.85 9 18.5V20.5H6V13.5H18V20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTempleHindu(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="temple_hindu">
        <path
          id="Vector"
          d="M20 11.5V13.5H18L15 3.5V1.5H13V3.5H10.97V1.5H8.97V3.62L6 13.5H4V11.5H2V22.5H11V17.5H13V22.5H22V11.5H20ZM15.31 11.5H8.69L9.29 9.5H14.71L15.31 11.5ZM14.11 7.5H9.89L10.49 5.5H13.51L14.11 7.5ZM20 20.5H15V15.5H9V20.5H4V15.5H7.49L8.09 13.5H15.91L16.51 15.5H20V20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTerminal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="terminal">
        <path
          id="Vector"
          d="M20 4H4C2.89 4 2 4.9 2 6V18C2 19.1 2.89 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.11 4 20 4ZM20 18H4V8H20V18ZM18 17H12V15H18V17ZM7.5 17L6.09 15.59L8.67 13L6.08 10.41L7.5 9L11.5 13L7.5 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTerrain(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="terrain">
        <path
          id="Vector"
          d="M14 6L9.78 11.63L11.03 13.3L14 9.33L19 16H10.54L6.53 10.63L1 18H23L14 6ZM5 16L6.52 13.97L8.04 16H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextDecrease(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_decrease">
        <path
          id="Vector"
          d="M0.995117 19H3.41512L4.68512 15.42H10.3351L11.5951 19H14.0151L8.75512 5H6.25512L0.995117 19ZM5.41512 13.39L7.44512 7.6H7.56512L9.59512 13.39H5.41512ZM23.0051 11V13H15.0051V11H23.0051Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextFields(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_fields">
        <path
          id="Vector"
          d="M2.5 4.5V7.5H7.5V19.5H10.5V7.5H15.5V4.5H2.5ZM21.5 9.5H12.5V12.5H15.5V19.5H18.5V12.5H21.5V9.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextFormat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_format">
        <path
          id="Vector"
          d="M5 17.5V19.5H19V17.5H5ZM9.5 13.3H14.5L15.4 15.5H17.5L12.75 4.5H11.25L6.5 15.5H8.6L9.5 13.3ZM12 6.48L13.87 11.5H10.13L12 6.48Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextIncrease(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_increase">
        <path
          id="Vector"
          d="M0.995117 19H3.41512L4.68512 15.42H10.3351L11.5951 19H14.0151L8.75512 5H6.25512L0.995117 19ZM5.41512 13.39L7.44512 7.6H7.56512L9.59512 13.39H5.41512ZM20.0051 11H23.0051V13H20.0051V16H18.0051V13H15.0051V11H18.0051V8H20.0051V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextRotateUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_rotate_up">
        <path
          id="Vector"
          d="M18 4L15 7H17V20H19V7H21L18 4ZM11.8 15.5V10.5L14 9.6V7.5L3 12.25V13.75L14 18.5V16.4L11.8 15.5ZM4.98 13L10 11.13V14.87L4.98 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextRotateVertical(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_rotate_vertical">
        <path
          id="Vector"
          d="M16 5H14.5L9.75 16H11.85L12.75 13.8H17.75L18.65 16H20.75L16 5ZM13.38 12L15.25 6.98L17.12 12H13.38ZM6.25 20L9.25 17H7.25V4H5.25V17H3.25L6.25 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextRotationAngledown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_rotation_angledown">
        <path
          id="Vector"
          d="M15.625 20.75V16.51L14.215 17.92L5.01498 8.73L3.60498 10.14L12.795 19.33L11.385 20.75H15.625ZM11.875 8.23L15.415 11.77L14.495 13.96L15.975 15.44L20.395 4.3L19.335 3.25L8.19498 7.67L9.68498 9.15L11.875 8.23ZM18.465 5.18L16.235 10.05L13.595 7.41L18.465 5.18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextRotationAngleup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_rotation_angleup">
        <path
          id="Vector"
          d="M16.51 8.37999L17.92 9.78999L8.73 18.98L10.14 20.39L19.33 11.2L20.75 12.62V8.37999H16.51ZM8.23 12.13L11.77 8.58999L13.96 9.50999L15.44 8.02998L4.31 3.60999L3.25 4.66999L7.67 15.81L9.15 14.33L8.23 12.13ZM7.41 10.41L5.18 5.53999L10.05 7.76999L7.41 10.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextRotationDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_rotation_down">
        <path
          id="Vector"
          d="M6 20L9 17H7V4H5V17H3L6 20ZM12.2 8.5V13.5L10 14.4V16.5L21 11.75V10.25L10 5.5V7.6L12.2 8.5ZM19.02 11L14 12.87V9.13L19.02 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextRotationNone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_rotation_none">
        <path
          id="Vector"
          d="M20 18L17 15V17H4V19H17V21L20 18ZM8.5 11.8H13.5L14.4 14H16.5L11.75 3H10.25L5.5 14H7.6L8.5 11.8ZM11 4.98L12.87 10H9.13L11 4.98Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextSnippet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="text_snippet">
        <path
          id="Vector"
          d="M14.17 5L19 9.83V19H5V5H14.17ZM14.17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V9.83C21 9.3 20.79 8.79 20.41 8.42L15.58 3.59C15.21 3.21 14.7 3 14.17 3ZM7 15H17V17H7V15ZM7 11H17V13H7V11ZM7 7H14V9H7V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTextsms(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="textsms">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16ZM7 9H9V11H7V9ZM11 9H13V11H11V9ZM15 9H17V11H15V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTexture(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="texture">
        <path
          id="Vector"
          d="M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTheaterComedy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="theater_comedy">
        <g id="Vector">
          <path
            d="M19 7.5C19.5523 7.5 20 7.05228 20 6.5C20 5.94772 19.5523 5.5 19 5.5C18.4477 5.5 18 5.94772 18 6.5C18 7.05228 18.4477 7.5 19 7.5Z"
            fill="currentColor"
          />
          <path
            d="M15 7.5C15.5523 7.5 16 7.05228 16 6.5C16 5.94772 15.5523 5.5 15 5.5C14.4477 5.5 14 5.94772 14 6.5C14 7.05228 14.4477 7.5 15 7.5Z"
            fill="currentColor"
          />
          <path
            d="M16.99 9C15.61 9 14.49 9.84 14.49 10.88H19.49C19.49 9.84 18.37 9 16.99 9Z"
            fill="currentColor"
          />
          <path
            d="M1 16C1 19.31 3.69 22 7 22C10.31 22 13 19.31 13 16V9H1V16ZM3 11H11V16C11 18.21 9.21 20 7 20C4.79 20 3 18.21 3 16V11Z"
            fill="currentColor"
          />
          <path
            d="M11 2V7.5H13V4H21V9C21 11.21 19.21 13 17 13C16.05 13 15.19 12.65 14.5 12.1V14.45C15.26 14.8 16.11 15 17 15C20.31 15 23 12.31 23 9V2H11Z"
            fill="currentColor"
          />
          <path
            d="M5 14.5C5.55228 14.5 6 14.0523 6 13.5C6 12.9477 5.55228 12.5 5 12.5C4.44772 12.5 4 12.9477 4 13.5C4 14.0523 4.44772 14.5 5 14.5Z"
            fill="currentColor"
          />
          <path
            d="M9 14.5C9.55228 14.5 10 14.0523 10 13.5C10 12.9477 9.55228 12.5 9 12.5C8.44772 12.5 8 12.9477 8 13.5C8 14.0523 8.44772 14.5 9 14.5Z"
            fill="currentColor"
          />
          <path
            d="M7 17.88C8.38 17.88 9.5 17.04 9.5 16H4.5C4.5 17.04 5.62 17.88 7 17.88Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTheaters(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="theaters">
        <path
          id="Vector"
          d="M18 3V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3H18ZM8 17H6V15H8V17ZM8 13H6V11H8V13ZM8 9H6V7H8V9ZM14 19H10V5H14V19ZM18 17H16V15H18V17ZM18 13H16V11H18V13ZM18 9H16V7H18V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThermostat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thermostat">
        <path
          id="Vector"
          d="M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5H12V6H13V8H12V9H13V11H11V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThermostatAuto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thermostat_auto">
        <path
          id="Vector"
          d="M10.5 12V6C10.5 4.34 9.16 3 7.5 3C5.84 3 4.5 4.34 4.5 6V12C3.29 12.91 2.5 14.37 2.5 16C2.5 17.12 2.88 18.14 3.5 18.97V19H3.52C4.43 20.21 5.87 21 7.5 21C9.13 21 10.56 20.21 11.48 19H11.5V18.97C12.12 18.14 12.5 17.12 12.5 16C12.5 14.37 11.71 12.91 10.5 12ZM4.5 16C4.5 15.06 4.95 14.16 5.7 13.6L6.5 13V6C6.5 5.45 6.95 5 7.5 5C8.05 5 8.5 5.45 8.5 6V13L9.3 13.6C10.05 14.17 10.5 15.06 10.5 16H4.5ZM18.12 4H16.51L13.13 13H14.69L15.5 10.7H19.13L19.93 13H21.5L18.12 4ZM15.97 9.39L17.28 5.67H17.36L18.67 9.39H15.97Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThumbDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thumb_down">
        <path
          id="Vector"
          d="M15 2H6C5.17 2 4.46 2.5 4.16 3.22L1.14 10.27C1.05 10.5 1 10.74 1 11V13C1 14.1 1.9 15 3 15H9.31L8.36 19.57L8.33 19.89C8.33 20.3 8.5 20.68 8.77 20.95L9.83 22L16.42 15.41C16.78 15.05 17 14.55 17 14V4C17 2.9 16.1 2 15 2ZM19 2V14H23V2H19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThumbDownAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thumb_down_alt">
        <path
          id="Vector"
          d="M15 2H6C5.17 2 4.46 2.5 4.16 3.22L1.14 10.27C1.05 10.5 1 10.74 1 11V13C1 14.1 1.9 15 3 15H9.31L8.36 19.57L8.33 19.89C8.33 20.3 8.5 20.68 8.77 20.95L9.83 22L16.41 15.41C16.78 15.05 17 14.55 17 14V4C17 2.9 16.1 2 15 2ZM15 14L10.66 18.34L11.77 13H3V11L6 4H15V14ZM19 2H23V14H19V2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThumbUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thumb_up">
        <path
          id="Vector"
          d="M1 22H5V10H1V22ZM23 11C23 9.9 22.1 9 21 9H14.69L15.64 4.43L15.67 4.11C15.67 3.7 15.5 3.32 15.23 3.05L14.17 2L7.59 8.59C7.22 8.95 7 9.45 7 10V20C7 21.1 7.9 22 9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 13.73C22.95 13.5 23 13.26 23 13V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThumbUpAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thumb_up_alt">
        <path
          id="Vector"
          d="M21 9H14.69L15.64 4.43L15.67 4.11C15.67 3.7 15.5 3.32 15.23 3.05L14.17 2L7.59 8.59C7.22 8.95 7 9.45 7 10V20C7 21.1 7.9 22 9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 13.73C22.95 13.5 23 13.26 23 13V11C23 9.9 22.1 9 21 9ZM21 13L18 20H9V10L13.34 5.66L12.23 11H21V13ZM1 10H5V22H1V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconThumbsUpDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thumbs_up_down" clipPath="url(#clip0_395_4390)">
        <path
          id="Vector"
          d="M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6ZM10 7.13L7.92 12H2V6.21L3.93 4.28L3.36 7H10V7.13ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10ZM22 17.79L20.07 19.72L20.64 17H14V16.87L16.08 12H22V17.79Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_4390">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconThunderstorm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="thunderstorm">
        <g id="Vector">
          <path
            d="M17.92 6.02C17.45 3.18 14.97 1 12 1C9.82 1 7.83 2.18 6.78 4.06C4.09 4.41 2 6.74 2 9.5C2 12.53 4.47 15 7.5 15H17.5C19.98 15 22 12.98 22 10.5C22 8.16 20.21 6.23 17.92 6.02ZM17.5 13H7.5C5.57 13 4 11.43 4 9.5C4 7.76 5.31 6.27 7.04 6.04L8.03 5.91L8.52 5.04C9.23 3.78 10.56 3 12 3C13.94 3 15.63 4.44 15.95 6.35L16.2 7.87L17.74 8.01C19.01 8.13 20 9.22 20 10.5C20 11.88 18.88 13 17.5 13Z"
            fill="currentColor"
          />
          <path
            d="M14.8 16L11.9 19.32L13.9 20.32L11.55 23H14.2L17.1 19.68L15.1 18.68L17.45 16H14.8Z"
            fill="currentColor"
          />
          <path
            d="M8.8 16L5.9 19.32L7.9 20.32L5.55 23H8.2L11.1 19.68L9.1 18.68L11.45 16H8.8Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTimeToLeave(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="time_to_leave">
        <g id="Vector">
          <path
            d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.85 6H17.14L18.18 9H5.81L6.85 6ZM19 16H5V11.34L5.12 11H18.89L19 11.34V16Z"
            fill="currentColor"
          />
          <path
            d="M7.5 15C8.32843 15 9 14.3284 9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15Z"
            fill="currentColor"
          />
          <path
            d="M16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTimelapse(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timelapse">
        <path
          id="Vector"
          d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTimeline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timeline">
        <path
          id="Vector"
          d="M23 8C23 9.1 22.1 10 21 10C20.82 10 20.65 9.98 20.49 9.93L16.93 13.48C16.98 13.64 17 13.82 17 14C17 15.1 16.1 16 15 16C13.9 16 13 15.1 13 14C13 13.82 13.02 13.64 13.07 13.48L10.52 10.93C10.36 10.98 10.18 11 10 11C9.82 11 9.64 10.98 9.48 10.93L4.93 15.49C4.98 15.65 5 15.82 5 16C5 17.1 4.1 18 3 18C1.9 18 1 17.1 1 16C1 14.9 1.9 14 3 14C3.18 14 3.35 14.02 3.51 14.07L8.07 9.52C8.02 9.36 8 9.18 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 9.18 11.98 9.36 11.93 9.52L14.48 12.07C14.64 12.02 14.82 12 15 12C15.18 12 15.36 12.02 15.52 12.07L19.07 8.51C19.02 8.35 19 8.18 19 8C19 6.9 19.9 6 21 6C22.1 6 23 6.9 23 8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTimer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timer">
        <path
          id="Vector"
          d="M15 1.5H9V3.5H15V1.5ZM11 14.5H13V8.5H11V14.5ZM19.03 7.89L20.45 6.47C20.02 5.96 19.55 5.48 19.04 5.06L17.62 6.48C16.07 5.24 14.12 4.5 12 4.5C7.03 4.5 3 8.53 3 13.5C3 18.47 7.02 22.5 12 22.5C16.98 22.5 21 18.47 21 13.5C21 11.38 20.26 9.43 19.03 7.89ZM12 20.5C8.13 20.5 5 17.37 5 13.5C5 9.63 8.13 6.5 12 6.5C15.87 6.5 19 9.63 19 13.5C19 17.37 15.87 20.5 12 20.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTimer10(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timer_10" clipPath="url(#clip0_395_1998)">
        <path
          id="Vector"
          d="M-0.0100098 7.71502V9.39502L2.98999 8.39502V17.995H4.98999V5.99502H4.73999L-0.0100098 7.71502ZM23.77 14.365C23.63 14.085 23.42 13.835 23.14 13.625C22.86 13.415 22.53 13.235 22.13 13.095C21.73 12.955 21.28 12.825 20.78 12.715C20.43 12.645 20.14 12.565 19.91 12.485C19.68 12.405 19.5 12.325 19.36 12.235C19.22 12.145 19.13 12.045 19.08 11.935C19.03 11.825 19 11.695 19 11.545C19 11.405 19.03 11.265 19.09 11.135C19.15 11.005 19.24 10.885 19.36 10.795C19.48 10.695 19.63 10.615 19.81 10.555C19.99 10.495 20.21 10.465 20.45 10.465C20.7 10.465 20.92 10.505 21.11 10.575C21.3 10.645 21.46 10.745 21.59 10.865C21.72 10.985 21.81 11.125 21.88 11.285C21.94 11.445 21.98 11.605 21.98 11.775H23.93C23.93 11.385 23.85 11.025 23.69 10.685C23.53 10.345 23.3 10.055 23 9.80502C22.7 9.55502 22.34 9.36502 21.91 9.21502C21.48 9.06502 20.99 8.99502 20.45 8.99502C19.94 8.99502 19.47 9.06502 19.06 9.20502C18.65 9.34502 18.29 9.53502 18 9.77502C17.71 10.015 17.49 10.295 17.33 10.615C17.17 10.935 17.1 11.265 17.1 11.625C17.1 11.985 17.18 12.315 17.33 12.585C17.48 12.865 17.69 13.105 17.97 13.315C18.24 13.525 18.57 13.695 18.95 13.845C19.33 13.985 19.76 14.105 20.22 14.205C20.61 14.285 20.93 14.375 21.17 14.465C21.41 14.555 21.6 14.655 21.74 14.755C21.87 14.855 21.96 14.975 22.01 15.095C22.06 15.215 22.08 15.345 22.08 15.485C22.08 15.805 21.95 16.055 21.68 16.255C21.41 16.455 21.02 16.545 20.51 16.545C20.29 16.545 20.08 16.525 19.87 16.465C19.66 16.415 19.47 16.335 19.31 16.225C19.14 16.115 19.01 15.965 18.9 15.785C18.79 15.605 18.73 15.375 18.72 15.115H16.83C16.83 15.475 16.91 15.825 17.07 16.165C17.23 16.505 17.46 16.815 17.77 17.095C18.08 17.365 18.46 17.585 18.92 17.755C19.38 17.925 19.9 18.005 20.5 18.005C21.03 18.005 21.51 17.945 21.94 17.815C22.37 17.685 22.74 17.505 23.05 17.275C23.36 17.045 23.59 16.765 23.76 16.445C23.93 16.125 24.01 15.775 24.01 15.385C23.99 14.985 23.92 14.645 23.77 14.365ZM13.81 7.04502C13.47 6.64502 13.06 6.34502 12.58 6.16502C12.11 5.98502 11.57 5.89502 10.99 5.89502C10.41 5.89502 9.87999 5.98502 9.39999 6.16502C8.91999 6.34502 8.50999 6.63502 8.16999 7.04502C7.82999 7.45502 7.56999 7.97502 7.37999 8.63502C7.19999 9.28502 7.09999 10.085 7.09999 11.025V12.945C7.09999 13.885 7.18999 14.685 7.37999 15.335C7.56999 15.995 7.82999 16.525 8.17999 16.935C8.51999 17.345 8.92999 17.645 9.40999 17.825C9.88999 18.005 10.42 18.105 11 18.105C11.59 18.105 12.12 18.015 12.59 17.825C13.07 17.645 13.47 17.345 13.81 16.935C14.15 16.525 14.41 15.995 14.59 15.335C14.77 14.685 14.87 13.885 14.87 12.945V11.025C14.87 10.085 14.78 9.28502 14.59 8.63502C14.41 7.97502 14.15 7.44502 13.81 7.04502ZM12.89 13.215C12.89 13.815 12.85 14.325 12.77 14.745C12.69 15.165 12.57 15.505 12.41 15.765C12.25 16.025 12.05 16.215 11.82 16.335C11.59 16.455 11.31 16.515 11 16.515C10.7 16.515 10.42 16.455 10.18 16.335C9.93999 16.215 9.73999 16.025 9.57999 15.765C9.41999 15.505 9.28999 15.165 9.19999 14.745C9.10999 14.325 9.06999 13.815 9.06999 13.215V10.715C9.06999 10.115 9.10999 9.60502 9.19999 9.19502C9.28999 8.78502 9.40999 8.45502 9.57999 8.19502C9.73999 7.94502 9.93999 7.76502 10.18 7.64502C10.42 7.53502 10.69 7.47502 10.99 7.47502C11.3 7.47502 11.57 7.53502 11.8 7.64502C12.04 7.75502 12.24 7.93502 12.4 8.19502C12.56 8.44502 12.69 8.77502 12.77 9.18502C12.85 9.59502 12.9 10.105 12.9 10.705V13.215H12.89Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_395_1998">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconTimer10Select(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timer_10_select">
        <path
          id="Vector"
          d="M13 8V16H10V8H13ZM13 5H10C8.34 5 7 6.34 7 8V16C7 17.66 8.34 19 10 19H13C14.66 19 16 17.66 16 16V8C16 6.34 14.66 5 13 5ZM1 8H3V19H6V5H1V8ZM18.5 11C17.67 11 17 11.68 17 12.5V14.5C17 15.32 17.67 16 18.5 16H21V17H17V19H21.5C22.33 19 23 18.33 23 17.5V15.5C23 14.67 22.33 14 21.5 14H19V13H23V11H18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTimer3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timer_3">
        <path
          id="Vector"
          d="M10.96 12.98C10.8 12.74 10.6 12.52 10.34 12.33C10.09 12.14 9.78004 11.98 9.41004 11.85C9.71004 11.71 9.98004 11.55 10.21 11.35C10.44 11.15 10.63 10.94 10.78 10.71C10.93 10.48 11.05 10.25 11.12 10C11.2 9.76003 11.23 9.51003 11.23 9.27003C11.23 8.72003 11.14 8.23003 10.95 7.81003C10.77 7.39003 10.51 7.04003 10.17 6.75003C9.84004 6.47003 9.44004 6.25003 8.97004 6.11003C8.52004 5.98003 8.00004 5.91003 7.44004 5.91003C6.89004 5.91003 6.38004 5.99003 5.92004 6.15003C5.45004 6.32003 5.05004 6.55003 4.72004 6.84003C4.39004 7.13003 4.12004 7.47003 3.94004 7.87003C3.74004 8.26003 3.65004 8.70003 3.65004 9.16003H5.63004C5.63004 8.90003 5.68004 8.67003 5.77004 8.47003C5.86004 8.27003 5.99004 8.09003 6.15004 7.95003C6.32004 7.81003 6.51004 7.70003 6.73004 7.62003C6.95004 7.54003 7.19004 7.50003 7.46004 7.50003C8.07004 7.50003 8.52004 7.66003 8.82004 7.97003C9.12004 8.28003 9.26004 8.72003 9.26004 9.29003C9.26004 9.56003 9.22004 9.81003 9.14004 10.03C9.06004 10.25 8.93004 10.44 8.76004 10.6C8.59004 10.76 8.38004 10.88 8.13004 10.97C7.88004 11.06 7.58004 11.1 7.24004 11.1H6.07004V12.67H7.25004C7.59004 12.67 7.89004 12.71 8.16004 12.78C8.43004 12.86 8.66004 12.97 8.85004 13.13C9.04004 13.29 9.19004 13.49 9.29004 13.74C9.39004 13.98 9.45004 14.28 9.45004 14.61C9.45004 15.23 9.27004 15.7 8.92004 16.03C8.57004 16.36 8.08004 16.52 7.47004 16.52C7.18004 16.52 6.91004 16.48 6.67004 16.39C6.43004 16.31 6.23004 16.19 6.06004 16.03C5.89004 15.87 5.76004 15.69 5.67004 15.47C5.58004 15.25 5.53004 15.01 5.53004 14.75H3.54004C3.54004 15.3 3.65004 15.78 3.86004 16.2C4.07004 16.62 4.36004 16.97 4.72004 17.25C5.08004 17.53 5.49004 17.74 5.96004 17.88C6.43004 18.02 6.92004 18.09 7.44004 18.09C8.01004 18.09 8.53004 18.01 9.02004 17.86C9.51004 17.71 9.93004 17.48 10.28 17.18C10.64 16.88 10.92 16.52 11.12 16.08C11.32 15.65 11.42 15.15 11.42 14.6C11.42 14.31 11.38 14.02 11.31 13.74C11.23 13.49 11.12 13.23 10.96 12.98ZM20.22 14.38C20.08 14.1 19.87 13.85 19.59 13.64C19.31 13.43 18.98 13.25 18.58 13.11C18.18 12.97 17.73 12.84 17.23 12.73C16.88 12.66 16.59 12.58 16.36 12.5C16.13 12.42 15.95 12.34 15.81 12.25C15.67 12.16 15.58 12.06 15.53 11.95C15.48 11.84 15.45 11.71 15.45 11.56C15.45 11.41 15.48 11.28 15.54 11.15C15.6 11.02 15.69 10.9 15.81 10.81C15.93 10.71 16.08 10.63 16.26 10.57C16.44 10.51 16.66 10.48 16.9 10.48C17.15 10.48 17.37 10.52 17.56 10.59C17.75 10.66 17.91 10.76 18.04 10.88C18.17 11 18.26 11.14 18.33 11.3C18.39 11.46 18.43 11.62 18.43 11.79H20.38C20.38 11.4 20.3 11.04 20.14 10.7C19.98 10.36 19.75 10.07 19.45 9.82003C19.15 9.57003 18.79 9.38003 18.36 9.23003C17.93 9.08003 17.44 9.01003 16.9 9.01003C16.39 9.01003 15.92 9.08003 15.51 9.22003C15.1 9.36003 14.74 9.55003 14.45 9.79003C14.16 10.03 13.94 10.31 13.78 10.63C13.62 10.95 13.55 11.28 13.55 11.64C13.55 12 13.63 12.32 13.78 12.6C13.93 12.88 14.15 13.12 14.42 13.33C14.69 13.54 15.02 13.71 15.4 13.86C15.78 14 16.21 14.12 16.67 14.22C17.06 14.3 17.38 14.39 17.62 14.48C17.86 14.57 18.05 14.67 18.19 14.77C18.32 14.87 18.41 14.99 18.46 15.11C18.51 15.23 18.53 15.36 18.53 15.5C18.53 15.82 18.4 16.07 18.13 16.27C17.86 16.47 17.47 16.56 16.96 16.56C16.74 16.56 16.53 16.54 16.32 16.48C16.11 16.43 15.92 16.35 15.76 16.24C15.59 16.13 15.46 15.98 15.35 15.8C15.24 15.62 15.18 15.39 15.17 15.13H13.28C13.28 15.49 13.36 15.84 13.52 16.18C13.68 16.52 13.91 16.83 14.22 17.11C14.53 17.38 14.91 17.6 15.37 17.77C15.83 17.94 16.35 18.02 16.95 18.02C17.48 18.02 17.96 17.96 18.39 17.83C18.82 17.7 19.19 17.52 19.5 17.29C19.81 17.06 20.04 16.78 20.21 16.46C20.38 16.14 20.46 15.79 20.46 15.4C20.44 15 20.37 14.66 20.22 14.38Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTimer3Select(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timer_3_select">
        <path
          id="Vector"
          d="M20.5 11V13H16.5V14H19C19.83 14 20.5 14.68 20.5 15.5V17.5C20.5 18.33 19.83 19 19 19H14.5V17H18.5V16H16C15.18 16 14.5 15.32 14.5 14.5V12.5C14.5 11.68 15.18 11 16 11H20.5ZM3.5 5V8H9.5V10.5H3.5V13.5H9.5V16H3.5V19H9.5C11.16 19 12.5 17.66 12.5 16V14.1C12.5 12.94 11.56 12 10.4 12C11.56 12 12.5 11.06 12.5 9.9V8C12.5 6.34 11.16 5 9.5 5H3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTimerOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="timer_off">
        <g id="Vector">
          <path d="M15.7101 1.19495H9.7101V3.19495H15.7101V1.19495Z" fill="currentColor" />
          <path
            d="M12.7101 6.19495C16.5801 6.19495 19.7101 9.32495 19.7101 13.1949C19.7101 14.1349 19.5201 15.0249 19.1901 15.8449L20.6901 17.3449C21.3401 16.1049 21.7101 14.6949 21.7101 13.1949C21.7101 11.0749 20.9701 9.12495 19.7401 7.58495L21.1601 6.16495C20.7301 5.65495 20.2601 5.17495 19.7501 4.75495L18.3301 6.17495C16.7801 4.93495 14.8301 4.19495 12.7101 4.19495C11.2101 4.19495 9.8001 4.56495 8.5601 5.21495L10.0601 6.71495C10.8801 6.38495 11.7701 6.19495 12.7101 6.19495Z"
            fill="currentColor"
          />
          <path d="M11.7101 8.36495L13.7101 10.3649V8.19495H11.7101V8.36495Z" fill="currentColor" />
          <path
            d="M3.5201 3.00495L2.1001 4.41495L5.5001 7.81495C4.3801 9.31495 3.7101 11.1749 3.7101 13.1949C3.7101 18.1649 7.7301 22.1949 12.7101 22.1949C14.7301 22.1949 16.5901 21.5249 18.0901 20.4049L20.4901 22.8049L21.9001 21.3949L3.5201 3.00495ZM12.7101 20.1949C8.8401 20.1949 5.7101 17.0649 5.7101 13.1949C5.7101 11.7249 6.1601 10.3649 6.9301 9.24495L16.6601 18.9749C15.5401 19.7449 14.1801 20.1949 12.7101 20.1949Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTipCoins(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tip_coins">
        <path
          id="Subtract"
          d="M12 2C13.3833 2 14.6837 2.26211 15.9004 2.78711C15.9339 2.80156 15.9668 2.8173 16 2.83203V5.02832C14.8174 4.34349 13.4845 4 12 4C9.76667 4 7.8752 4.7752 6.3252 6.3252C4.7752 7.8752 4 9.76667 4 12C4 14.2333 4.7752 16.1248 6.3252 17.6748C7.8752 19.2248 9.76667 20 12 20C14.2333 20 16.1248 19.2248 17.6748 17.6748C19.2248 16.1248 20 14.2333 20 12C20 10.9198 19.8167 9.92034 19.4541 9H21.5469C21.8482 9.9523 22 10.9521 22 12C22 13.3833 21.7379 14.6837 21.2129 15.9004C20.6879 17.117 19.9751 18.1752 19.0752 19.0752C18.1752 19.9751 17.117 20.6879 15.9004 21.2129C14.6837 21.7379 13.3833 22 12 22C10.6167 22 9.31628 21.7379 8.09961 21.2129C6.88302 20.6879 5.82476 19.9751 4.9248 19.0752C4.02485 18.1752 3.3121 17.117 2.78711 15.9004C2.26211 14.6837 2 13.3833 2 12C2 10.6167 2.26211 9.31628 2.78711 8.09961C3.3121 6.88302 4.02485 5.82476 4.9248 4.9248C5.82476 4.02485 6.88302 3.3121 8.09961 2.78711C9.31628 2.26211 10.6167 2 12 2ZM13.5996 10.2002H18.5L14.5 13.0498L16 18L12 14.9502L8 18L9.5 13.0498L5.5 10.2002H10.4004L12 5L13.5996 10.2002Z"
          fill="currentColor"
        />
        <path
          id="forward_5"
          d="M18 7.00012V5.50012H21V4.50012H18V1.00012H22.5V2.50012H19.5V3.50012H21.5C21.7833 3.50012 22.0208 3.59596 22.2125 3.78762C22.4042 3.97929 22.5 4.21679 22.5 4.50012V6.00012C22.5 6.28346 22.4042 6.52096 22.2125 6.71262C22.0208 6.90429 21.7833 7.00012 21.5 7.00012H18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTipsAndUpdates(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tips_and_updates">
        <path
          id="Vector"
          d="M6.25 21H10.25C10.25 22.1 9.35 23 8.25 23C7.15 23 6.25 22.1 6.25 21ZM4.25 20H12.25V18H4.25V20ZM15.75 10.5C15.75 14.32 13.09 16.36 11.98 17H4.52C3.41 16.36 0.75 14.32 0.75 10.5C0.75 6.36 4.11 3 8.25 3C12.39 3 15.75 6.36 15.75 10.5ZM13.75 10.5C13.75 7.47 11.28 5 8.25 5C5.22 5 2.75 7.47 2.75 10.5C2.75 12.97 4.24 14.39 5.1 15H11.4C12.26 14.39 13.75 12.97 13.75 10.5ZM20.62 8.37L19.25 9L20.62 9.63L21.25 11L21.88 9.63L23.25 9L21.88 8.37L21.25 7L20.62 8.37ZM18.25 7L19.19 4.94L21.25 4L19.19 3.06L18.25 1L17.31 3.06L15.25 4L17.31 4.94L18.25 7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTireRepair(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tire_repair">
        <path
          id="Vector"
          d="M18 8.5C17.45 8.5 17 8.05 17 7.5C17 7.22 17.11 6.97 17.29 6.79C17.69 6.39 19.75 5.75 19.75 5.75C19.75 5.75 19.11 7.81 18.71 8.21C18.53 8.39 18.28 8.5 18 8.5ZM19 13.5V18.5C19 20.15 17.65 21.5 16 21.5C14.35 21.5 13 20.15 13 18.5V16.5C13 15.95 12.55 15.5 12 15.5C11.45 15.5 11 15.95 11 16.5V19.5C11 20.6 10.1 21.5 9 21.5H3C1.9 21.5 1 20.6 1 19.5V5.5C1 4.4 1.9 3.5 3 3.5H9C10.1 3.5 11 4.4 11 5.5V13.67C11.31 13.56 11.65 13.5 12 13.5C13.65 13.5 15 14.85 15 16.5V18.5C15 19.05 15.45 19.5 16 19.5C16.55 19.5 17 19.05 17 18.5V13.5H16V12.08C14.23 11.31 13 9.55 13 7.5C13 4.74 15.24 2.5 18 2.5C20.76 2.5 23 4.74 23 7.5C23 9.55 21.77 11.31 20 12.08V13.5H19ZM21 7.5C21 5.84 19.66 4.5 18 4.5C16.34 4.5 15 5.84 15 7.5C15 9.16 16.34 10.5 18 10.5C19.66 10.5 21 9.16 21 7.5ZM9 7.5L7 9.5V6.67L8.17 5.5H3.83L5 6.67V9.5L3 7.5V9.67L5 11.67V14.5L3 12.5V14.67L5 16.67V19.5L3 17.5V19.5H9V17.5L7 19.5V16.67L9 14.67V12.5L7 14.5V11.67L9 9.67V7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTitle(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="title">
        <path id="Vector" d="M5 4.5V7.5H10.5V19.5H13.5V7.5H19V4.5H5Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconToc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="toc">
        <path
          id="Vector"
          d="M3 9H17V7H3V9ZM3 13H17V11H3V13ZM3 17H17V15H3V17ZM19 17H21V15H19V17ZM19 7V9H21V7H19ZM19 13H21V11H19V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconToday(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="today">
        <path
          id="Vector"
          d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM7 12H12V17H7V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconToggleOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="toggle_off">
        <path
          id="Vector"
          d="M17 6H7C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18H17C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H17C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16ZM7 9C5.34 9 4 10.34 4 12C4 13.66 5.34 15 7 15C8.66 15 10 13.66 10 12C10 10.34 8.66 9 7 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconToggleOn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="toggle_on">
        <path
          id="Vector"
          d="M17 6H7C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18H17C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H17C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16ZM17 9C15.34 9 14 10.34 14 12C14 13.66 15.34 15 17 15C18.66 15 20 13.66 20 12C20 10.34 18.66 9 17 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconToken(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="token">
        <path
          id="Vector"
          d="M21 7L12 2L3 7V17L12 22L21 17V7ZM12 4.29L17.91 7.57L14.9 9.24C14.17 8.48 13.14 8 12 8C10.86 8 9.83 8.48 9.1 9.24L6.09 7.57L12 4.29ZM11 19.16L5 15.83V9.26L8.13 11C8.04 11.31 8 11.65 8 12C8 13.86 9.27 15.43 11 15.87V19.16ZM10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12ZM13 19.16V15.88C14.73 15.44 16 13.87 16 12.01C16 11.66 15.96 11.32 15.87 11L19 9.26V15.83L13 19.16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconToll(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="toll">
        <path
          id="Vector"
          d="M15 4C10.58 4 7 7.58 7 12C7 16.42 10.58 20 15 20C19.42 20 23 16.42 23 12C23 7.58 19.42 4 15 4ZM15 18C11.69 18 9 15.31 9 12C9 8.69 11.69 6 15 6C18.31 6 21 8.69 21 12C21 15.31 18.31 18 15 18ZM3 12C3 9.39 4.67 7.17 7 6.35V4.26C3.55 5.15 1 8.27 1 12C1 15.73 3.55 18.85 7 19.74V17.65C4.67 16.83 3 14.61 3 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTonality(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tonality">
        <path
          id="Vector"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.06 19.44 4 16.08 4 12C4 7.92 7.05 4.56 11 4.07V19.93ZM13 4.07C14.03 4.2 15 4.52 15.87 5H13V4.07ZM13 7H18.24C18.49 7.31 18.72 7.65 18.92 8H13V7ZM13 10H19.74C19.82 10.33 19.89 10.66 19.93 11H13V10ZM13 19.93V19H15.87C15 19.48 14.03 19.8 13 19.93ZM18.24 17H13V16H18.92C18.72 16.35 18.49 16.69 18.24 17ZM19.74 14H13V13H19.93C19.89 13.34 19.82 13.67 19.74 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTopic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="topic">
        <path
          id="Vector"
          d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20.77C21.45 20 22 19.44 22 18.77V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTornado(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tornado">
        <path
          id="Vector"
          d="M23 2.5H1L12 21.5L23 2.5ZM19.53 4.5L17.79 7.5H6.21L4.47 4.5H19.53ZM10.26 14.5H13.74L12 17.51L10.26 14.5ZM14.9 12.5H9.1L7.36 9.5H16.63L14.9 12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTouchApp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="touch_app">
        <path
          id="Vector"
          d="M18.2639 12.94L15.0239 11.32C16.3139 10.32 17.1439 8.76 17.1439 7C17.1439 3.97 14.6739 1.5 11.6439 1.5C8.61385 1.5 6.14385 3.97 6.14385 7C6.14385 9.13 7.36385 10.98 9.14385 11.89V15.15C6.99385 14.69 7.12385 14.71 6.88385 14.71C6.35385 14.71 5.85385 14.92 5.47385 15.3L4.07385 16.72L9.16385 21.81C9.59385 22.25 10.1939 22.5 10.8139 22.5H17.1139C18.0939 22.5 18.9239 21.8 19.0839 20.83L19.8839 16.12C20.1039 14.82 19.4539 13.54 18.2639 12.94ZM17.9139 15.79L17.1139 20.5H10.8139C10.7239 20.5 10.6439 20.46 10.5739 20.4L6.89385 16.72L11.1439 17.61V7C11.1439 6.72 11.3639 6.5 11.6439 6.5C11.9239 6.5 12.1439 6.72 12.1439 7V13H13.9039L17.3639 14.73C17.7639 14.93 17.9839 15.36 17.9139 15.79ZM8.14385 7C8.14385 5.07 9.71385 3.5 11.6439 3.5C13.5739 3.5 15.1439 5.07 15.1439 7C15.1439 7.95 14.7639 8.81 14.1439 9.44V7C14.1439 5.62 13.0239 4.5 11.6439 4.5C10.2639 4.5 9.14385 5.62 9.14385 7V9.44C8.52385 8.81 8.14385 7.95 8.14385 7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTour(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tour">
        <path
          id="Vector"
          d="M20 4H6V2H4V22H6V14H20L18 9L20 4ZM16.14 9.74L17.04 12H6V6H17.05L16.15 8.26L15.85 9L16.14 9.74ZM13 9C13 10.1 12.1 11 11 11C9.9 11 9 10.1 9 9C9 7.9 9.9 7 11 7C12.1 7 13 7.9 13 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconToys(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="toys">
        <path
          id="Vector"
          d="M19.2513 10.08L17.9013 6.05C17.5013 4.82 16.3513 4 15.0613 4H9.94128C8.65128 4 7.50128 4.82 7.10128 6.05L6.31128 8.4L4.91128 7L5.20128 6.71C5.59128 6.32 5.59128 5.69 5.20128 5.3C4.81128 4.91 4.18128 4.91 3.79128 5.3L1.79128 7.3C1.40128 7.69 1.40128 8.32 1.79128 8.71C2.18128 9.1 2.81128 9.1 3.20128 8.71L3.50128 8.41L5.29128 10.2C3.68128 10.72 2.50128 12.22 2.50128 14C2.50128 15.49 3.33128 16.78 4.55128 17.47C4.77128 18.9 6.01128 20 7.50128 20C8.80128 20 9.90128 19.16 10.3213 18H14.6913C15.1013 19.16 16.2013 20 17.5113 20C19.0013 20 20.2413 18.9 20.4613 17.47C21.6713 16.78 22.5013 15.49 22.5013 14C22.5013 12.05 21.1013 10.43 19.2513 10.08ZM13.5013 6H15.0613C15.4913 6 15.8713 6.27 16.0113 6.68L17.1113 10H13.5013V6ZM8.99128 6.68C9.13128 6.27 9.51128 6 9.94128 6H11.5013V10H7.91128L7.89128 9.98L8.99128 6.68ZM7.50128 18C6.95128 18 6.50128 17.55 6.50128 17C6.50128 16.45 6.95128 16 7.50128 16C8.05128 16 8.50128 16.45 8.50128 17C8.50128 17.55 8.05128 18 7.50128 18ZM17.5013 18C16.9513 18 16.5013 17.55 16.5013 17C16.5013 16.45 16.9513 16 17.5013 16C18.0513 16 18.5013 16.45 18.5013 17C18.5013 17.55 18.0513 18 17.5013 18ZM19.9913 15.32C19.4513 14.53 18.5313 14 17.5013 14C16.2013 14 15.1013 14.84 14.6813 16H10.3213C9.90128 14.84 8.80128 14 7.50128 14C6.47128 14 5.55128 14.53 5.01128 15.32C4.70128 14.97 4.50128 14.51 4.50128 14C4.50128 12.9 5.40128 12 6.50128 12H18.5013C19.6013 12 20.5013 12.9 20.5013 14C20.5013 14.51 20.3013 14.97 19.9913 15.32Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTrackChanges(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="track_changes">
        <path
          id="Vector"
          d="M19.07 4.93L17.66 6.34C19.1 7.79 20 9.79 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.92 7.05 4.56 11 4.07V6.09C8.16 6.57 6 9.03 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 10.34 17.33 8.84 16.24 7.76L14.83 9.17C15.55 9.9 16 10.9 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12C8 10.14 9.28 8.59 11 8.14V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V2H12C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 9.24 20.88 6.74 19.07 4.93Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTraffic(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="traffic">
        <path
          id="Vector"
          d="M20 10H17V8.86C18.72 8.41 20 6.86 20 5H17V4C17 3.45 16.55 3 16 3H8C7.45 3 7 3.45 7 4V5H4C4 6.86 5.28 8.41 7 8.86V10H4C4 11.86 5.28 13.41 7 13.86V15H4C4 16.86 5.28 18.41 7 18.86V20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V18.86C18.72 18.41 20 16.86 20 15H17V13.86C18.72 13.41 20 11.86 20 10ZM15 19H9V5H15V19ZM12 18C12.83 18 13.5 17.33 13.5 16.5C13.5 15.67 12.83 15 12 15C11.17 15 10.5 15.67 10.5 16.5C10.5 17.33 11.17 18 12 18ZM12 13.5C12.83 13.5 13.5 12.83 13.5 12C13.5 11.17 12.83 10.5 12 10.5C11.17 10.5 10.5 11.17 10.5 12C10.5 12.83 11.17 13.5 12 13.5ZM12 9C12.83 9 13.5 8.33 13.5 7.5C13.5 6.67 12.83 6 12 6C11.17 6 10.5 6.67 10.5 7.5C10.5 8.33 11.17 9 12 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTrain(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="train">
        <g id="Vector">
          <path
            d="M8.5 16.5C9.32843 16.5 10 15.8284 10 15C10 14.1716 9.32843 13.5 8.5 13.5C7.67157 13.5 7 14.1716 7 15C7 15.8284 7.67157 16.5 8.5 16.5Z"
            fill="currentColor"
          />
          <path
            d="M15.5 16.5C16.3284 16.5 17 15.8284 17 15C17 14.1716 16.3284 13.5 15.5 13.5C14.6716 13.5 14 14.1716 14 15C14 15.8284 14.6716 16.5 15.5 16.5Z"
            fill="currentColor"
          />
          <path
            d="M12 2.5C8 2.5 4 3 4 6.5V16C4 17.93 5.57 19.5 7.5 19.5L6 21V21.5H8L10 19.5H14L16 21.5H18V21L16.5 19.5C18.43 19.5 20 17.93 20 16V6.5C20 3 16 2.5 12 2.5ZM12 4.5C15.51 4.5 16.96 4.98 17.57 5.5H6.43C7.04 4.98 8.49 4.5 12 4.5ZM6 7.5H11V10.5H6V7.5ZM18 16C18 16.83 17.33 17.5 16.5 17.5H7.5C6.67 17.5 6 16.83 6 16V12.5H18V16ZM18 10.5H13V7.5H18V10.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTram(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tram">
        <path
          id="Vector"
          d="M13 5L13.75 3.5H17V2H7V3.5H11.75L11 5C7.87 5.09 5 5.73 5 8.5V17C5 18.5 6.11 19.73 7.55 19.95L6 21.5V22H8L10 20H14L16 22H18V21.5L16.45 19.95C17.89 19.73 19 18.5 19 17V8.5C19 5.73 16.13 5.09 13 5ZM11.03 7H12.97C15.72 7.08 16.59 7.58 16.87 8H7.13C7.41 7.58 8.28 7.08 11.03 7ZM10.85 17.95H7.74C7.3 17.84 7 17.45 7 17V16H10.89C10.65 16.27 10.5 16.61 10.5 17C10.5 17.36 10.63 17.69 10.85 17.95ZM17 17C17 17.45 16.7 17.84 16.26 17.95H13.15C13.37 17.69 13.5 17.36 13.5 17C13.5 16.61 13.35 16.27 13.11 16H17V17ZM17 14H7V10H17V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTransferWithinAStation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="transfer_within_a_station">
        <path
          id="Vector"
          d="M16.49 15.25V13.5L14 16L16.49 18.5V16.75H22V15.25H16.49ZM19.51 19.5H14V21H19.51V22.75L22 20.25L19.51 17.75V19.5ZM9.5 5.25C10.6 5.25 11.5 4.35 11.5 3.25C11.5 2.15 10.6 1.25 9.5 1.25C8.4 1.25 7.5 2.15 7.5 3.25C7.5 4.35 8.4 5.25 9.5 5.25ZM5.75 8.65L3 22.75H5.1L6.85 14.75L9 16.75V22.75H11V15.2L8.95 13.15L9.55 10.15C10.85 11.75 12.8 12.75 15 12.75V10.75C13.15 10.75 11.55 9.75 10.65 8.3L9.7 6.7C9.35 6.1 8.7 5.75 8 5.75C7.75 5.75 7.5 5.8 7.25 5.9L2 8.05V12.75H4V9.4L5.75 8.65Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTransform(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="transform">
        <path
          id="Vector"
          d="M22 18V16H8V4H10L7 1L4 4H6V6H2V8H6V16C6 17.1 6.9 18 8 18H16V20H14L17 23L20 20H18V18H22ZM10 8H16V14H18V8C18 6.9 17.1 6 16 6H10V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTransgender(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="transgender">
        <path
          id="Vector"
          d="M12 8C13.93 8 15.5 9.57 15.5 11.5C15.5 13.43 13.93 15 12 15C10.07 15 8.5 13.43 8.5 11.5C8.5 9.57 10.07 8 12 8ZM16.53 8.38L20.5 4.42V7H22.5V1H16.5V3H19.08L15.11 6.97C14.23 6.36 13.16 6 12 6C10.84 6 9.77 6.36 8.89 6.97L8.24 6.32L9.65 4.91L8.24 3.49L6.82 4.9L4.92 3H7.5V1H1.5V7H3.5V4.42L5.41 6.32L3.99 7.74L5.4 9.15L6.81 7.74L7.46 8.39C6.86 9.27 6.5 10.34 6.5 11.5C6.5 14.2 8.44 16.44 11 16.91V19H9V21H11V23H13V21H15V19H13V16.91C15.56 16.44 17.5 14.2 17.5 11.5C17.5 10.34 17.14 9.27 16.53 8.38Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTransitEnterexit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="transit_enterexit">
        <path
          id="Vector"
          d="M16 18H6V8H9V12.77L15.98 6L18 8.03L11.15 15H16V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTranslate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="translate">
        <path
          id="Vector"
          d="M12.87 15.07L10.33 12.56L10.36 12.53C12.1 10.59 13.34 8.36 14.07 6H17V4H10V2H8V4H1V5.99H12.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8H4.69C5.42 9.63 6.42 11.17 7.67 12.56L2.58 17.58L4 19L9 14L12.11 17.11L12.87 15.07ZM18.5 10H16.5L12 22H14L15.12 19H19.87L21 22H23L18.5 10ZM15.88 17L17.5 12.67L19.12 17H15.88Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTravelExplore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="travel_explore">
        <path
          id="Vector"
          d="M19.05 16.9C19.45 16.2 19.75 15.4 19.75 14.5C19.75 12 17.75 10 15.25 10C12.75 10 10.75 12 10.75 14.5C10.75 17 12.75 19 15.25 19C16.15 19 16.95 18.7 17.65 18.3L20.85 21.5L22.25 20.1L19.05 16.9ZM15.25 17C13.85 17 12.75 15.9 12.75 14.5C12.75 13.1 13.85 12 15.25 12C16.65 12 17.75 13.1 17.75 14.5C17.75 15.9 16.65 17 15.25 17ZM11.75 20V22C6.23 22 1.75 17.52 1.75 12C1.75 6.48 6.23 2 11.75 2C16.59 2 20.62 5.44 21.55 10H19.48C18.84 7.54 17.08 5.53 14.75 4.59V5C14.75 6.1 13.85 7 12.75 7H10.75V9C10.75 9.55 10.3 10 9.75 10H7.75V12H9.75V15H8.75L3.96 10.21C3.83 10.79 3.75 11.38 3.75 12C3.75 16.41 7.34 20 11.75 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTrendingDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trending_down">
        <path
          id="Vector"
          d="M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTrendingFlat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trending_flat">
        <path id="Vector" d="M21.5 12L17.5 8V11H2.5V13H17.5V16L21.5 12Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconTrendingUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trending_up">
        <path
          id="Vector"
          d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTripOrigin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trip_origin">
        <path
          id="Vector"
          d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTroubleshoot(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="troubleshoot">
        <g id="Vector">
          <path
            d="M22.5 20.09L17.81 15.4C18.87 14.05 19.5 12.35 19.5 10.5C19.5 6.08 15.92 2.5 11.5 2.5C7.42 2.5 4.06 5.55 3.57 9.5H5.59C6.07 6.67 8.53 4.5 11.5 4.5C14.81 4.5 17.5 7.19 17.5 10.5C17.5 13.81 14.81 16.5 11.5 16.5C9.08 16.5 7 15.06 6.05 13H3.9C4.95 16.19 7.96 18.5 11.5 18.5C13.35 18.5 15.05 17.87 16.4 16.81L21.09 21.5L22.5 20.09Z"
            fill="currentColor"
          />
          <path
            d="M8.93 9.19L10.15 14.5H11.79L13.05 10.72L14 13H16V11.5H15L13.75 8.5H12.21L11.09 11.87L9.85 6.5H8.2L6.95 10.5H1.5V12H8.05L8.93 9.19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTry(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="try">
        <g id="Vector">
          <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
            fill="currentColor"
          />
          <path
            d="M12 15L13.57 11.57L17 10L13.57 8.43L12 5L10.43 8.43L7 10L10.43 11.57L12 15Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTsunami(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tsunami">
        <g id="Vector">
          <path
            d="M18.67 17.63C14.87 20.43 12.55 18.03 12 17.63C11.34 18.12 9.08 20.39 5.33 17.63C3.43 19.03 2.65 19 2 19V21C3.16 21 4.3 20.68 5.33 20.07C7.39 21.29 9.94 21.29 12 20.07C14.06 21.29 16.61 21.29 18.67 20.07C19.7 20.68 20.84 21 22 21V19C21.34 19 20.5 18.98 18.67 17.63Z"
            fill="currentColor"
          />
          <path
            d="M19.33 12H22V10H19.33C17.5 10 16 8.5 16 6.67C16 5.65 16.38 4.93 17.09 3.33C15.72 3.12 15.09 3 14 3C7.36 3 2.15 8.03 2.01 14.5L2 16.5C3.16 16.5 4.3 16.18 5.33 15.57C7.39 16.79 9.94 16.79 12 15.57C14.06 16.79 16.61 16.79 18.67 15.57C19.7 16.18 20.84 16.5 22 16.5V14.5C21.34 14.5 20.5 14.48 18.67 13.13C14.87 15.93 12.55 13.53 12 13.13C11.1 13.8 11.46 13.54 11.09 13.76C10.39 12.82 10 11.7 10 10.5C10 7.92 11.77 5.76 14.21 5.17C14.08 5.68 14 6.19 14 6.67C14 9.61 16.39 12 19.33 12ZM5.33 13.13C4.71 13.59 4.51 13.76 4.03 14C4.3 10.47 6.41 7.52 9.46 6.04C8.54 7.29 8 8.83 8 10.5C8 11.92 8.4 13.27 9.13 14.45C8.41 14.52 7.34 14.6 5.33 13.13Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTty(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tty">
        <path
          id="Vector"
          d="M15.9855 6.01434H13.9855V4.01434H15.9855V6.01434ZM17.9855 7.01434H15.9855V9.01434H17.9855V7.01434ZM18.9855 9.01434H20.9855V7.01434H18.9855V9.01434ZM18.9855 4.01434H16.9855V6.01434H18.9855V4.01434ZM14.9855 7.01434H12.9855V9.01434H14.9855V7.01434ZM18.9855 10.0143H16.9855V12.0143H18.9855V10.0143ZM15.9855 10.0143H13.9855V12.0143H15.9855V10.0143ZM12.9855 4.01434H10.9855V6.01434H12.9855V4.01434ZM19.9855 15.8343V19.9843C19.9855 20.5443 19.5155 21.0143 18.9555 20.9843C16.0655 20.8143 13.3555 19.9543 10.9855 18.5843C8.25552 17.0043 5.99552 14.7443 4.41552 12.0143C3.03552 9.64434 2.18552 6.93434 2.01552 4.04434C1.98552 3.48434 2.45552 3.01434 3.01552 3.01434H7.16552C7.64552 3.01434 8.05552 3.35434 8.14552 3.81434L8.88552 7.49434C8.95552 7.82434 8.84552 8.16434 8.61552 8.39434L6.08552 10.9143C7.51552 13.4143 9.58552 15.4843 12.0855 16.9143L14.6055 14.3943C14.8455 14.1543 15.1855 14.0543 15.5055 14.1243L19.1755 14.8543C19.6455 14.9443 19.9855 15.3543 19.9855 15.8343ZM5.16552 9.00434L6.81552 7.35434L6.34552 5.01434H4.11552C4.28552 6.38434 4.64552 7.72434 5.16552 9.00434ZM17.9855 16.6543L15.6455 16.1843L13.9955 17.8343C15.2755 18.3543 16.6255 18.7043 17.9855 18.8843V16.6543ZM19.9855 4.01434V6.01434H21.9855V4.01434H19.9855ZM19.9855 12.0143H21.9855V10.0143H19.9855V12.0143ZM12.9855 10.0143H10.9855V12.0143H12.9855V10.0143Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTune(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tune">
        <path
          id="Vector"
          d="M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V7H21V5H17V3H15V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTungsten(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tungsten">
        <g id="Vector">
          <path d="M13 18.5H11V21.5H13V18.5Z" fill="currentColor" />
          <path d="M5 10.5H2V12.5H5V10.5Z" fill="currentColor" />
          <path d="M22 10.5H19V12.5H22V10.5Z" fill="currentColor" />
          <path
            d="M17.3012 15.8943L15.8941 17.3014L18.0154 19.4227L19.4225 18.0156L17.3012 15.8943Z"
            fill="currentColor"
          />
          <path
            d="M6.70547 15.8872L4.58417 18.0085L5.9913 19.4156L8.1126 17.2943L6.70547 15.8872Z"
            fill="currentColor"
          />
          <path
            d="M15 7.52V2.5H9V7.52C7.79 8.44 7 9.87 7 11.5C7 14.26 9.24 16.5 12 16.5C14.76 16.5 17 14.26 17 11.5C17 9.87 16.21 8.44 15 7.52ZM11 4.5H13V6.6C12.68 6.54 12.34 6.5 12 6.5C11.66 6.5 11.32 6.54 11 6.6V4.5ZM12 14.5C10.35 14.5 9 13.15 9 11.5C9 9.85 10.35 8.5 12 8.5C13.65 8.5 15 9.85 15 11.5C15 13.15 13.65 14.5 12 14.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconTurnLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="turn_left">
        <path
          id="Vector"
          d="M8.83 10L10.42 11.59L9 13L5 9L9 5L10.41 6.41L8.83 8H17C18.1 8 19 8.9 19 10V19H17V10H8.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTurnRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="turn_right">
        <path
          id="Vector"
          d="M15.17 10L13.58 11.59L15 13L19 9L15 5L13.59 6.41L15.17 8H7C5.9 8 5 8.9 5 10V19H7V10H15.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTurnSharpLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="turn_sharp_left">
        <path
          id="Vector"
          d="M7.5 6.83L5.91 8.41L4.5 7L8.5 3L12.5 7L11.09 8.41L9.5 6.83V13H17.5C18.6 13 19.5 13.9 19.5 15V21H17.5V15H9.5C8.4 15 7.5 14.1 7.5 13V6.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTurnSharpRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="turn_sharp_right">
        <path
          id="Vector"
          d="M16.5 6.83L18.09 8.42L19.5 7L15.5 3L11.5 7L12.91 8.41L14.5 6.83V13H6.5C5.4 13 4.5 13.9 4.5 15V21H6.5V15H14.5C15.6 15 16.5 14.1 16.5 13V6.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTurnSlightLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="turn_slight_left">
        <path
          id="Vector"
          d="M13.16 4H7.5V9.66H9.5V7.41L14.5 12.41V20H16.5V12.42C16.5 11.89 16.29 11.38 15.91 11.01L10.91 6.01H13.16V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTurnSlightRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="turn_slight_right">
        <path
          id="Vector"
          d="M10.84 4H16.5V9.66H14.5V7.41L9.5 12.41V20H7.5V12.42C7.5 11.89 7.71 11.38 8.09 11.01L13.09 6.01H10.84V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTv(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tv">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTvOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="tv_off">
        <path
          id="Vector"
          d="M21 7V17.88L22.85 19.73C22.94 19.5 23 19.26 23 19V7C23 5.89 22.11 5 21 5H13.42L16.71 1.7L16 1L12 5L8 1L7.3 1.7L10.58 5H8.12L10.12 7H21ZM20.46 23L21.72 21.73L20.46 22.99V23ZM2.41 2.13L1 3.54L2.53 5.07C1.65 5.28 1 6.06 1 7V19C1 20.1 1.9 21 3 21H18.46L20.45 22.99L21.86 21.58L2.41 2.13ZM3 19V7H4.46L16.46 19H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTwoWheeler(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="two_wheeler">
        <path
          id="Vector"
          d="M4.17 11C4.12 11 4.06 11 4 11H4.17ZM13.41 5H9V7H12.59L14.59 9H11L7 11L5 9H0V11H4C1.79 11 0 12.79 0 15C0 17.21 1.79 19 4 19C6.21 19 8 17.21 8 15L10 17H13L16.49 10.9L17.5 11.91C16.59 12.64 16 13.75 16 15C16 17.21 17.79 19 20 19C22.21 19 24 17.21 24 15C24 12.79 22.21 11 20 11C19.82 11 19.64 11.03 19.47 11.05L17.41 9H20V6L16.28 7.86L13.41 5ZM20 17C18.9 17 18 16.1 18 15C18 13.9 18.9 13 20 13C21.1 13 22 13.9 22 15C22 16.1 21.1 17 20 17ZM4 17C2.9 17 2 16.1 2 15C2 13.9 2.9 13 4 13C5.1 13 6 13.9 6 15C6 16.1 5.1 17 4 17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTypeSpecimen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="type_specimen">
        <g id="Vector">
          <path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z" fill="currentColor" />
          <path
            d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16Z"
            fill="currentColor"
          />
          <path
            d="M12.19 12.2H15.82L16.62 14.5H18.18L14.8 5.5H13.2L9.82 14.5H11.38L12.19 12.2ZM13.96 7.17H14.04L15.35 10.89H12.66L13.96 7.17Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconUTurnLeft(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="u_turn_left">
        <path
          id="Vector"
          d="M19.5 9V21H17.5V9C17.5 6.79 15.71 5 13.5 5C11.29 5 9.5 6.79 9.5 9V13.17L11.09 11.58L12.5 13L8.5 17L4.5 13L5.91 11.59L7.5 13.17V9C7.5 5.69 10.19 3 13.5 3C16.81 3 19.5 5.69 19.5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUTurnRight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="u_turn_right">
        <path
          id="Vector"
          d="M4.5 9V21H6.5V9C6.5 6.79 8.29 5 10.5 5C12.71 5 14.5 6.79 14.5 9V13.17L12.91 11.58L11.5 13L15.5 17L19.5 13L18.09 11.59L16.5 13.17V9C16.5 5.69 13.81 3 10.5 3C7.19 3 4.5 5.69 4.5 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUmbrella(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="umbrella">
        <path
          id="Vector"
          d="M14.5 7.42L13 6.27V3.9C13 3.64 13.22 3.42 13.5 3.42C13.78 3.42 14 3.63 14 3.9V4.5H16V3.9C16 2.57 14.88 1.5 13.5 1.5C12.12 1.5 11 2.57 11 3.9V6.27L9.5 7.42L6 6.57L11.05 21.82C11.2 22.27 11.6 22.5 12 22.5C12.4 22.5 12.8 22.27 12.95 21.81L18 6.57L14.5 7.42ZM13.28 9L14.04 9.58L14.96 9.35L13 15.3V8.79L13.28 9ZM9.96 9.59L10.72 9.01L11 8.79V15.3L9.03 9.36L9.96 9.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnarchive(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unarchive">
        <path
          id="Vector"
          d="M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.59 6H5.42L6.24 5ZM5 19V8H19V19H5ZM8 14H10.55V17H13.45V14H16L12 10L8 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUndo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="undo">
        <path
          id="Vector"
          d="M12.2649 8.5C9.61489 8.5 7.21489 9.49 5.36489 11.1L1.76489 7.5V16.5H10.7649L7.14489 12.88C8.53489 11.72 10.3049 11 12.2649 11C15.8049 11 18.8149 13.31 19.8649 16.5L22.2349 15.72C20.8449 11.53 16.9149 8.5 12.2649 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnfoldLess(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unfold_less">
        <path
          id="Vector"
          d="M7.40991 18.59L8.82991 20L11.9999 16.83L15.1699 20L16.5799 18.59L11.9999 14L7.40991 18.59ZM16.5899 5.41L15.1699 4L11.9999 7.17L8.82991 4L7.40991 5.41L11.9999 10L16.5899 5.41Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnfoldLessDouble(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unfold_less_double">
        <g id="Vector">
          <path
            d="M16.5799 1.41L15.1599 0L11.9899 3.17L8.81991 0L7.40991 1.41L11.9899 6L16.5799 1.41Z"
            fill="currentColor"
          />
          <path
            d="M16.5799 6.41L15.1599 5L11.9899 8.17L8.81991 5L7.40991 6.41L11.9899 11L16.5799 6.41Z"
            fill="currentColor"
          />
          <path
            d="M7.41991 17.59L8.83991 19L12.0099 15.83L15.1799 19L16.5899 17.59L12.0099 13L7.41991 17.59Z"
            fill="currentColor"
          />
          <path
            d="M7.41991 22.59L8.83991 24L12.0099 20.83L15.1799 24L16.5899 22.59L12.0099 18L7.41991 22.59Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconUnfoldMore(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unfold_more">
        <path
          id="Vector"
          d="M11.9999 5.83L15.1699 9L16.5799 7.59L11.9999 3L7.40991 7.59L8.82991 9L11.9999 5.83ZM11.9999 18.17L8.82991 15L7.41991 16.41L11.9999 21L16.5899 16.41L15.1699 15L11.9999 18.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnfoldMoreDouble(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unfold_more_double">
        <path
          id="Vector"
          d="M12 7.83L15.17 11L16.58 9.59L12 5L7.41003 9.59L8.83003 11L12 7.83ZM12 2.83L15.17 6L16.58 4.59L12 0L7.41003 4.59L8.83003 6L12 2.83ZM12 21.17L8.83003 18L7.42003 19.41L12 24L16.59 19.41L15.17 18L12 21.17ZM12 16.17L8.83003 13L7.42003 14.41L12 19L16.59 14.41L15.17 13L12 16.17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnpublished(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unpublished">
        <path
          id="Vector"
          d="M8.24495 4.81507L6.79495 3.35507C8.37495 2.30507 10.2649 1.69507 12.3049 1.69507C17.8249 1.69507 22.3049 6.17507 22.3049 11.6951C22.3049 13.7351 21.6949 15.6251 20.6449 17.2051L19.1849 15.7451C19.8949 14.5551 20.3049 13.1751 20.3049 11.6951C20.3049 7.28507 16.7149 3.69507 12.3049 3.69507C10.8249 3.69507 9.44495 4.10507 8.24495 4.81507ZM17.9649 9.22507L16.5549 7.81507L13.9049 10.4651L15.3149 11.8751L17.9649 9.22507ZM20.0849 22.3051L17.8149 20.0351C16.2349 21.0851 14.3449 21.6951 12.3049 21.6951C6.78495 21.6951 2.30495 17.2151 2.30495 11.6951C2.30495 9.65507 2.91495 7.76507 3.96495 6.18507L1.69495 3.91507L3.10495 2.50507L21.4849 20.8851L20.0849 22.3051ZM16.3649 18.5751L12.4849 14.6951L10.8949 16.2851L6.65495 12.0451L8.06495 10.6351L10.8949 13.4651L11.0749 13.2851L5.42495 7.63507C4.71495 8.83507 4.30495 10.2151 4.30495 11.6951C4.30495 16.1051 7.89495 19.6951 12.3049 19.6951C13.7849 19.6951 15.1649 19.2851 16.3649 18.5751Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnsubscribe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="unsubscribe">
        <path
          id="Vector"
          d="M20.4885 14.5382V5.49817C20.4885 4.39817 19.5885 3.49817 18.4885 3.49817H4.49854C3.39854 3.49817 2.49854 4.39817 2.49854 5.49817V15.4982C2.49854 16.5982 3.39854 17.4982 4.49854 17.4982H14.5485C14.8285 19.4182 16.6485 20.8482 18.7285 20.4282C20.0685 20.1582 21.1585 19.0582 21.4285 17.7182C21.6785 16.4782 21.2685 15.3282 20.4885 14.5382ZM18.4885 5.49817L11.4985 8.99817L4.49854 5.49817H18.4885ZM14.8485 15.4982H4.49854V7.49817L11.4985 10.9982L18.4985 7.49817V13.5482C18.3385 13.5282 18.1685 13.4982 17.9985 13.4982C16.6085 13.4982 15.4085 14.3182 14.8485 15.4982ZM19.9985 17.4982H15.9985V16.4982H19.9985V17.4982Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUpcoming(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="upcoming">
        <path
          id="Vector"
          d="M17.6 10.81L16.19 9.4L19.75 5.85L21.16 7.26C21.05 7.29 17.6 10.81 17.6 10.81ZM13 3H11V8H13V3ZM6.4 10.81L7.81 9.4L4.26 5.84L2.84 7.26C2.95 7.29 6.4 10.81 6.4 10.81ZM20 14H16.58C15.81 15.76 14.04 17 12 17C9.96 17 8.19 15.76 7.42 14H4V19H20V14ZM20 12C21.1 12 22 12.9 22 14V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V14C2 12.9 2.9 12 4 12H9C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUpdate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="update">
        <path
          id="Vector"
          d="M11 8V13L15.25 15.52L16.02 14.24L12.5 12.15V8H11ZM21 10V3L18.36 5.64C16.74 4.01 14.49 3 12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12H19C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C13.93 5 15.68 5.79 16.95 7.05L14 10H21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUpdateDisabled(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="update_disabled">
        <path
          id="Vector"
          d="M21.655 12.2901C21.505 13.6701 21.035 14.9601 20.325 16.0801L18.855 14.6101C19.235 13.9001 19.505 13.1201 19.625 12.2901H21.655ZM9.38498 5.1301C10.375 4.6001 11.515 4.2901 12.715 4.2901C15.085 4.2901 17.185 5.4801 18.455 7.2901H15.715V9.2901H21.715V3.2901H19.715V5.6501C18.065 3.6101 15.545 2.2901 12.715 2.2901C10.955 2.2901 9.31498 2.8001 7.93498 3.6801L9.38498 5.1301ZM11.715 6.2901V7.4601L13.715 9.4601V6.2901H11.715ZM20.495 21.9001L17.495 18.9001C16.105 19.7701 14.475 20.2901 12.715 20.2901C7.74498 20.2901 3.71498 16.2601 3.71498 11.2901C3.71498 9.5301 4.22498 7.8901 5.10498 6.5101L2.10498 3.5101L3.51498 2.1001L21.895 20.4801L20.495 21.9001ZM16.035 17.4401L6.55498 7.9601C6.02498 8.9501 5.71498 10.0901 5.71498 11.2901C5.71498 15.1501 8.85498 18.2901 12.715 18.2901C13.915 18.2901 15.055 17.9801 16.035 17.4401Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUpgrade(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="upgrade">
        <path
          id="Vector"
          d="M16 18V20H8V18H16ZM11 7.99V16H13V7.99H16L12 4L8 7.99H11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUpload(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="upload">
        <path
          id="Vector"
          d="M9 16.5H15V10.5H19L12 3.5L5 10.5H9V16.5ZM12 6.33L14.17 8.5H13V14.5H11V8.5H9.83L12 6.33ZM5 18.5H19V20.5H5V18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUploadFile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="upload_file">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUsb(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="usb">
        <path
          id="Vector"
          d="M15.0999 7.40002V11.4H16.0999V13.4H13.0999V5.40002H15.0999L12.0999 1.40002L9.0999 5.40002H11.0999V13.4H8.0999V11.33C8.7999 10.96 9.2999 10.25 9.2999 9.40002C9.2999 8.19002 8.3099 7.20002 7.0999 7.20002C5.8899 7.20002 4.8999 8.19002 4.8999 9.40002C4.8999 10.25 5.3999 10.96 6.0999 11.33V13.4C6.0999 14.51 6.9899 15.4 8.0999 15.4H11.0999V18.45C10.3899 18.82 9.8999 19.55 9.8999 20.4C9.8999 21.62 10.8899 22.6 12.0999 22.6C13.3099 22.6 14.2999 21.62 14.2999 20.4C14.2999 19.55 13.8099 18.82 13.0999 18.45V15.4H16.0999C17.2099 15.4 18.0999 14.51 18.0999 13.4V11.4H19.0999V7.40002H15.0999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUsbOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="usb_off">
        <path
          id="Vector"
          d="M15.715 7.69995H19.715V11.7H18.715V13.7C18.715 14.04 18.635 14.36 18.485 14.64L16.715 12.87V11.7H15.715V7.69995ZM11.715 7.86995L13.715 9.86995V5.69995H15.715L12.715 1.69995L9.71498 5.69995H11.715V7.86995ZM13.715 15.7V17.98C14.315 18.32 14.715 18.96 14.715 19.7C14.715 20.8 13.815 21.7 12.715 21.7C11.615 21.7 10.715 20.8 10.715 19.7C10.715 18.96 11.115 18.33 11.715 17.98V15.7H8.71498C7.60498 15.7 6.71498 14.81 6.71498 13.7V11.42C6.11498 11.08 5.71498 10.44 5.71498 9.69995C5.71498 9.10995 5.97498 8.56995 6.39498 8.20995L2.10498 3.91995L3.51498 2.50995L21.895 20.89L20.485 22.3L13.885 15.7H13.715ZM11.715 13.7V13.53L9.20498 11.02C9.06498 11.18 8.89498 11.31 8.71498 11.42V13.7H11.715Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVaccines(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vaccines">
        <path
          id="Vector"
          d="M11.5 5.25H8.5V3.75H9C9.55 3.75 10 3.3 10 2.75C10 2.2 9.55 1.75 9 1.75H6C5.45 1.75 5 2.2 5 2.75C5 3.3 5.45 3.75 6 3.75H6.5V5.25H3.5C2.95 5.25 2.5 5.7 2.5 6.25C2.5 6.8 2.95 7.25 3.5 7.25V14.75C3.5 15.85 4.4 16.75 5.5 16.75H6.5V20.75L8.5 22.25V16.75H9.5C10.6 16.75 11.5 15.85 11.5 14.75V7.25C12.05 7.25 12.5 6.8 12.5 6.25C12.5 5.7 12.05 5.25 11.5 5.25ZM9.5 8.75H7.75C7.34 8.75 7 9.09 7 9.5C7 9.91 7.34 10.25 7.75 10.25H9.5V11.75H7.75C7.34 11.75 7 12.09 7 12.5C7 12.91 7.34 13.25 7.75 13.25H9.5V14.75H5.5V7.25H9.5V8.75ZM20 10.25V9.75C20.55 9.75 21 9.3 21 8.75C21 8.2 20.55 7.75 20 7.75H15C14.45 7.75 14 8.2 14 8.75C14 9.3 14.45 9.75 15 9.75V10.25C15 10.75 13.5 11.41 13.5 13.25V19.75C13.5 20.85 14.4 21.75 15.5 21.75H19.5C20.6 21.75 21.5 20.85 21.5 19.75V13.25C21.5 11.41 20 10.75 20 10.25ZM17 10.25V9.75H18V10.25C18 11.85 19.5 12.25 19.5 13.25V13.75H15.5C15.5 13.54 15.5 13.36 15.5 13.25C15.5 12.25 17 11.85 17 10.25ZM19.5 15.25V16.75H15.5C15.5 16.24 15.5 15.73 15.5 15.25H19.5ZM15.5 19.75C15.5 19.75 15.5 19.12 15.5 18.25H19.5V19.75H15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVapeFree(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vape_free">
        <path
          id="Vector"
          d="M2.30482 16.2H3.30482C4.63482 16.2 6.01482 16.02 7.30482 15.7V18.7C6.01482 18.38 4.63482 18.2 3.30482 18.2H2.30482V16.2ZM16.4748 18.7H8.30482V15.7H13.4748L1.69482 3.92001L3.10482 2.51001L21.4848 20.89L20.0748 22.3L16.4748 18.7ZM19.1348 15.7H22.3048V18.7H22.1348L19.1348 15.7ZM11.3048 17.2C11.3048 16.92 11.0848 16.7 10.8048 16.7C10.5248 16.7 10.3048 16.92 10.3048 17.2C10.3048 17.48 10.5248 17.7 10.8048 17.7C11.0848 17.7 11.3048 17.48 11.3048 17.2ZM22.3048 12.46V14.7H20.8048V12.47C20.8048 10.23 19.0448 8.40001 16.8048 8.40001V6.90001C17.8248 6.90001 18.6548 6.07001 18.6548 5.05001C18.6548 4.03001 17.8248 3.20001 16.8048 3.20001V1.70001C18.6548 1.70001 20.1548 3.20001 20.1548 5.05001C20.1548 5.98001 19.7748 6.82001 19.1548 7.43001C21.0248 8.32001 22.3048 10.24 22.3048 12.46ZM11.4548 8.02001C11.4548 8.01001 11.4548 8.01001 11.4548 8.00001C11.4548 6.15001 12.9548 4.65001 14.8048 4.65001V6.15001C13.7848 6.15001 12.9548 6.88001 12.9548 7.90001C12.9548 8.92001 13.7848 9.90001 14.8048 9.90001H16.3348C18.2048 9.90001 19.8048 11.25 19.8048 13.06V14.7H18.3048V13.4C18.3048 12.09 17.3848 11.35 16.3348 11.35H14.8048C14.7948 11.35 14.7948 11.35 14.7848 11.35L11.4548 8.02001Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVapingRooms(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vaping_rooms">
        <path
          id="Vector"
          d="M2 18H3C4.33 18 5.71 17.82 7 17.5V20.5C5.71 20.18 4.33 20 3 20H2V18ZM22 17.5V20.5H8V17.5H22ZM11 19C11 18.72 10.78 18.5 10.5 18.5C10.22 18.5 10 18.72 10 19C10 19.28 10.22 19.5 10.5 19.5C10.78 19.5 11 19.28 11 19ZM22 14.26V16.5H20.5V14.27C20.5 12.03 18.74 10.2 16.5 10.2V8.7C17.52 8.7 18.35 7.87 18.35 6.85C18.35 5.83 17.52 5 16.5 5V3.5C18.35 3.5 19.85 5 19.85 6.85C19.85 7.78 19.47 8.62 18.85 9.23C20.72 10.12 22 12.04 22 14.26ZM19.5 14.86V16.5H18V15.2C18 13.89 17.08 13.15 16.03 13.15H14.5C12.65 13.15 11.15 11.65 11.15 9.8C11.15 7.95 12.65 6.45 14.5 6.45V7.95C13.48 7.95 12.65 8.68 12.65 9.7C12.65 10.72 13.48 11.7 14.5 11.7H16.03C17.9 11.7 19.5 13.05 19.5 14.86Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerified(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="verified">
        <g id="Vector">
          <path
            d="M23 11.99L20.56 9.2L20.9 5.51L17.29 4.69L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 11.99L3.44 14.78L3.1 18.48L6.71 19.3L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79L23 11.99ZM19.05 13.47L18.49 14.12L18.57 14.97L18.75 16.92L16.01 17.54L15.57 18.28L14.58 19.96L12.8 19.19L12 18.85L11.21 19.19L9.43 19.96L8.44 18.29L8 17.55L5.26 16.93L5.44 14.97L5.52 14.12L4.96 13.47L3.67 12L4.96 10.52L5.52 9.87L5.43 9.01L5.25 7.07L7.99 6.45L8.43 5.71L9.42 4.03L11.2 4.8L12 5.14L12.79 4.8L14.57 4.03L15.56 5.71L16 6.45L18.74 7.07L18.56 9.02L18.48 9.87L19.04 10.52L20.33 11.99L19.05 13.47Z"
            fill="currentColor"
          />
          <path
            d="M10.09 13.75L7.77 11.42L6.29 12.91L10.09 16.72L17.43 9.36L15.95 7.87L10.09 13.75Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVerifiedUser(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="verified_user">
        <path
          id="Vector"
          d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11ZM7.41 11.59L6 13L10 17L18 9L16.59 7.58L10 14.17L7.41 11.59Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerticalAlignBottom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_align_bottom">
        <path
          id="Vector"
          d="M16 13H13V3H11V13H8L12 17L16 13ZM4 19V21H20V19H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerticalAlignCenter(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_align_center">
        <path
          id="Vector"
          d="M8 19H11V23H13V19H16L12 15L8 19ZM16 5H13V1H11V5H8L12 9L16 5ZM4 11V13H20V11H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerticalAlignTop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_align_top">
        <path id="Vector" d="M8 11H11V21H13V11H16L12 7L8 11ZM4 3V5H20V3H4Z" fill="currentColor" />
      </g>
    </svg>
  )
}

export function IconVerticalDistribute(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_distribute">
        <path
          id="Vector"
          d="M22 2V4H2V2H22ZM7 10.5V13.5H17V10.5H7ZM2 20V22H22V20H2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerticalShades(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_shades">
        <path
          id="Vector"
          d="M20 19V3H4V19H2V21H22V19H20ZM14 5V19H10V5H14ZM6 5H8V19H6V5ZM16 19V5H18V19H16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerticalShadesClosed(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_shades_closed">
        <path
          id="Vector"
          d="M20 19V3H4V19H2V21H22V19H20ZM13 5H14.5V19H13V5ZM11 19H9.5V5H11V19ZM6 5H7.5V19H6V5ZM16.5 19V5H18V19H16.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVerticalSplit(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vertical_split">
        <path
          id="Vector"
          d="M3 13H11V15H3V13ZM3 17H11V19H3V17ZM3 9H11V11H3V9ZM3 5H11V7H3V5ZM19 7V17H15V7H19ZM21 5H13V19H21V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVibration(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vibration">
        <path
          id="Vector"
          d="M0 15H2V9H0V15ZM3 17H5V7H3V17ZM22 9V15H24V9H22ZM19 17H21V7H19V17ZM16.5 3H7.5C6.67 3 6 3.67 6 4.5V19.5C6 20.33 6.67 21 7.5 21H16.5C17.33 21 18 20.33 18 19.5V4.5C18 3.67 17.33 3 16.5 3ZM16 19H8V5H16V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideoCall(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_call">
        <path
          id="Vector"
          d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5ZM15 16H5V8H15V16ZM9 15H11V13H13V11H11V9H9V11H7V13H9V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideoCameraBack(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_camera_back">
        <path
          id="Vector"
          d="M18 10.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V13.52L22 17.5V6.5L18 10.48ZM16 18H4V6H16V18ZM11.62 11.5L9 15L7.38 12.83L5 16H15L11.62 11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideoCameraFront(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_camera_front">
        <g id="Vector">
          <path
            d="M18 10.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V13.52L22 17.5V6.5L18 10.48ZM16 18H4V6H16V18Z"
            fill="currentColor"
          />
          <path
            d="M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"
            fill="currentColor"
          />
          <path
            d="M14 15.43C14 14.62 13.52 13.9 12.78 13.58C11.93 13.21 10.99 13 10 13C9.01 13 8.07 13.21 7.22 13.58C6.48 13.9 6 14.62 6 15.43V16H14V15.43Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVideoChat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_chat">
        <g id="Vector">
          <path
            d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
            fill="currentColor"
          />
          <path
            d="M8 14H14C14.55 14 15 13.55 15 13V11.01L17 13V7L15 8.99V7C15 6.45 14.55 6 14 6H8C7.45 6 7 6.45 7 7V13C7 13.55 7.45 14 8 14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVideoFile(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_file">
        <path
          id="Vector"
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6ZM14 14L16 12.94V17.06L14 16V17C14 17.55 13.55 18 13 18H9C8.45 18 8 17.55 8 17V13C8 12.45 8.45 12 9 12H13C13.55 12 14 12.45 14 13V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideoLabel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_label">
        <path
          id="Vector"
          d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 16H3V5H21V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideoLibrary(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_library">
        <path
          id="Vector"
          d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM12 5.5V14.5L18 10L12 5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideoSettings(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_settings">
        <g id="Vector">
          <path
            d="M2.55811 4.505H20.5581V9.505H22.5581V4.505C22.5581 3.405 21.6581 2.505 20.5581 2.505H2.55811C1.45811 2.505 0.558105 3.405 0.558105 4.505V16.505C0.558105 17.605 1.45811 18.505 2.55811 18.505H11.5581V16.505H2.55811V4.505Z"
            fill="currentColor"
          />
          <path d="M14.5581 10.505L8.55811 6.505V14.505L14.5581 10.505Z" fill="currentColor" />
          <path
            d="M22.2681 16.935C22.2981 16.645 22.3081 16.355 22.2781 16.075L23.3481 15.225C23.4481 15.145 23.4681 15.015 23.4081 14.905L22.3781 13.115C22.3181 13.005 22.1881 12.965 22.0681 13.005L20.7881 13.505C20.5581 13.335 20.3081 13.195 20.0381 13.085L19.8381 11.725C19.8181 11.595 19.7181 11.505 19.5881 11.505H17.5181C17.3981 11.505 17.2881 11.595 17.2681 11.715L17.0681 13.075C16.8081 13.185 16.5581 13.335 16.3281 13.495L15.0481 12.995C14.9281 12.945 14.7981 12.995 14.7381 13.105L13.7081 14.895C13.6481 15.005 13.6681 15.135 13.7681 15.215L14.8381 16.075C14.8081 16.365 14.7981 16.655 14.8281 16.935L13.7581 17.785C13.6581 17.865 13.6381 17.995 13.6981 18.105L14.7281 19.895C14.7881 20.005 14.9181 20.045 15.0381 20.005L16.3081 19.505C16.5381 19.675 16.7881 19.815 17.0581 19.925L17.2581 21.285C17.2781 21.405 17.3781 21.495 17.5081 21.495H19.5781C19.6981 21.495 19.8081 21.405 19.8281 21.285L20.0281 19.925C20.2881 19.815 20.5381 19.665 20.7681 19.505L22.0481 20.005C22.1681 20.055 22.2981 20.005 22.3581 19.895L23.3881 18.105C23.4481 17.995 23.4281 17.865 23.3281 17.785L22.2681 16.935ZM18.5581 18.005C17.7281 18.005 17.0581 17.335 17.0581 16.505C17.0581 15.675 17.7281 15.005 18.5581 15.005C19.3881 15.005 20.0581 15.675 20.0581 16.505C20.0581 17.335 19.3881 18.005 18.5581 18.005Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVideoStable(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="video_stable">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 18V6H6.95L4.62 14.73L16.82 18H4ZM15.62 15.61L7.07 13.32L8.38 8.4L16.94 10.69L15.62 15.61ZM20 18H17.05L19.39 9.27L7.18 6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideocam(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="videocam">
        <path
          id="Vector"
          d="M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideocamOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="videocam_off">
        <path
          id="Vector"
          d="M9.98993 8.56999L7.98993 6.56999L3.83993 2.42999L2.42993 3.83999L5.15993 6.56999H4.42993C3.87993 6.56999 3.42993 7.01999 3.42993 7.56999V17.57C3.42993 18.12 3.87993 18.57 4.42993 18.57H16.4299C16.6399 18.57 16.8199 18.49 16.9799 18.39L20.1599 21.57L21.5699 20.16L12.7099 11.3L9.98993 8.56999ZM5.42993 16.57V8.56999H7.15993L15.1599 16.57H5.42993ZM15.4299 8.56999V11.18L21.4299 17.18V7.06999L17.4299 11.07V7.56999C17.4299 7.01999 16.9799 6.56999 16.4299 6.56999H10.8199L12.8199 8.56999H15.4299Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVideogameAsset(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="videogame_asset">
        <g id="Vector">
          <path
            d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H21V16ZM6 15H8V13H10V11H8V9H6V11H4V13H6V15Z"
            fill="currentColor"
          />
          <path
            d="M14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15Z"
            fill="currentColor"
          />
          <path
            d="M18.5 12C19.3284 12 20 11.3284 20 10.5C20 9.67157 19.3284 9 18.5 9C17.6716 9 17 9.67157 17 10.5C17 11.3284 17.6716 12 18.5 12Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVideogameAssetOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="videogame_asset_off">
        <path
          id="Vector"
          d="M17.8051 8.28998C18.6351 8.28998 19.3051 8.95998 19.3051 9.78998C19.3051 10.62 18.6351 11.29 17.8051 11.29C16.9751 11.29 16.3051 10.62 16.3051 9.78998C16.3051 8.95998 16.9751 8.28998 17.8051 8.28998ZM11.1351 7.28998H20.3051V15.29H19.1351L21.0051 17.16C21.7551 16.87 22.3051 16.14 22.3051 15.29V7.28998C22.3051 6.18998 21.4051 5.28998 20.3051 5.28998H9.13507L11.1351 7.28998ZM20.0851 21.9L15.4751 17.29H4.30507C3.20507 17.29 2.30507 16.39 2.30507 15.29V7.28998C2.30507 6.43998 2.85507 5.70998 3.60507 5.41998L1.69507 3.50998L3.10507 2.09998L21.4851 20.48L20.0851 21.9ZM13.4751 15.29L10.4751 12.29H9.30507V14.29H7.30507V12.29H5.30507V10.29H7.30507V9.11998L5.47507 7.28998H4.30507V15.29H13.4751Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewAgenda(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_agenda">
        <g id="Vector">
          <path
            d="M19 13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13ZM19 19H5V15H19V19Z"
            fill="currentColor"
          />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V9C3 10.1 3.9 11 5 11H19C20.1 11 21 10.1 21 9V5C21 3.9 20.1 3 19 3ZM19 9H5V5H19V9Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconViewArray(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_array">
        <path
          id="Vector"
          d="M15 7V17H9V7H15ZM21 5H18V19H21V5ZM17 5H7V19H17V5ZM6 5H3V19H6V5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewCarousel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_carousel">
        <path
          id="Vector"
          d="M2 7H6V17H2V7ZM7 19H17V5H7V19ZM9 7H15V17H9V7ZM18 7H22V17H18V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewColumn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_column">
        <path
          id="Vector"
          d="M3 5V19H21V5H3ZM8.33 17H5V7H8.33V17ZM13.67 17H10.34V7H13.67V17ZM19 17H15.67V7H19V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewComfy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_comfy">
        <path
          id="Vector"
          d="M2 4V20H22V4H2ZM4 6H20V11H4V6ZM4 18V13H8V18H4ZM10 18V13H20V18H10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewComfyAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_comfy_alt">
        <g id="Vector">
          <path d="M11 7H7V11H11V7Z" fill="currentColor" />
          <path d="M17 7H13V11H17V7Z" fill="currentColor" />
          <path d="M11 13H7V17H11V13Z" fill="currentColor" />
          <path d="M17 13H13V17H17V13Z" fill="currentColor" />
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconViewCompact(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_compact">
        <path
          id="Vector"
          d="M2 4V20H22V4H2ZM6.5 18H4V15.5H6.5V18ZM6.5 13.25H4V10.75H6.5V13.25ZM6.5 8.5H4V6H6.5V8.5ZM11 18H8.5V15.5H11V18ZM11 13.25H8.5V10.75H11V13.25ZM11 8.5H8.5V6H11V8.5ZM15.5 18H13V15.5H15.5V18ZM15.5 13.25H13V10.75H15.5V13.25ZM15.5 8.5H13V6H15.5V8.5ZM20 18H17.5V15.5H20V18ZM20 13.25H17.5V10.75H20V13.25ZM20 8.5H17.5V6H20V8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewCompactAlt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_compact_alt">
        <g id="Vector">
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill="currentColor"
          />
          <path d="M11.5 7.5H7.5V11.5H11.5V7.5Z" fill="currentColor" />
          <path d="M16.5 7.5H12.5V11.5H16.5V7.5Z" fill="currentColor" />
          <path d="M11.5 12.5H7.5V16.5H11.5V12.5Z" fill="currentColor" />
          <path d="M16.5 12.5H12.5V16.5H16.5V12.5Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconViewCozy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_cozy">
        <g id="Vector">
          <path d="M11.25 7.25H7.25V11.25H11.25V7.25Z" fill="currentColor" />
          <path d="M16.75 7.25H12.75V11.25H16.75V7.25Z" fill="currentColor" />
          <path d="M11.25 12.75H7.25V16.75H11.25V12.75Z" fill="currentColor" />
          <path d="M16.75 12.75H12.75V16.75H16.75V12.75Z" fill="currentColor" />
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconViewDay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_day">
        <path
          id="Vector"
          d="M21.5 18H2.5V20H21.5V18ZM19.5 10V14H4.5V10H19.5ZM20.5 8H3.5C2.95 8 2.5 8.45 2.5 9V15C2.5 15.55 2.95 16 3.5 16H20.5C21.05 16 21.5 15.55 21.5 15V9C21.5 8.45 21.05 8 20.5 8ZM21.5 4H2.5V6H21.5V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewHeadline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_headline">
        <path
          id="Vector"
          d="M4 15H20V13H4V15ZM4 19H20V17H4V19ZM4 11H20V9H4V11ZM4 5V7H20V5H4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewInAr(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_in_ar">
        <g id="Vector">
          <path d="M3 4C3 3.45 3.45 3 4 3H6V1H4C2.34 1 1 2.34 1 4V6H3V4Z" fill="currentColor" />
          <path
            d="M3 20V18H1V20C1 21.66 2.34 23 4 23H6V21H4C3.45 21 3 20.55 3 20Z"
            fill="currentColor"
          />
          <path
            d="M20 1H18V3H20C20.55 3 21 3.45 21 4V6H23V4C23 2.34 21.66 1 20 1Z"
            fill="currentColor"
          />
          <path
            d="M21 20C21 20.55 20.55 21 20 21H18V23H20C21.66 23 23 21.66 23 20V18H21V20Z"
            fill="currentColor"
          />
          <path
            d="M19 14.87V9.13C19 8.41 18.62 7.75 18 7.4L13 4.52C12.69 4.34 12.35 4.25 12 4.25C11.65 4.25 11.31 4.34 11 4.52L6 7.39C5.38 7.75 5 8.41 5 9.13V14.87C5 15.59 5.38 16.25 6 16.6L11 19.48C11.31 19.66 11.65 19.75 12 19.75C12.35 19.75 12.69 19.66 13 19.48L18 16.6C18.62 16.25 19 15.59 19 14.87ZM11 17.17L7 14.87V10.24L11 12.57V17.17ZM12 10.84L8.04 8.53L12 6.25L15.96 8.53L12 10.84ZM17 14.87L13 17.17V12.57L17 10.24V14.87Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconViewKanban(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_kanban">
        <g id="Vector">
          <path d="M9 7H7V17H9V7Z" fill="currentColor" />
          <path d="M13 7H11V12H13V7Z" fill="currentColor" />
          <path d="M17 7H15V15H17V7Z" fill="currentColor" />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconViewList(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_list">
        <path
          id="Vector"
          d="M3 5V19H21V5H3ZM7 7V9H5V7H7ZM5 13V11H7V13H5ZM5 15H7V17H5V15ZM19 17H9V15H19V17ZM19 13H9V11H19V13ZM19 9H9V7H19V9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewModule(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_module">
        <path
          id="Vector"
          d="M3 5V19H21V5H3ZM19 11H15.67V7H19V11ZM13.67 11H10.34V7H13.67V11ZM8.33 7V11H5V7H8.33ZM5 17V13H8.33V17H5ZM10.33 17V13H13.66V17H10.33ZM15.67 17V13H19V17H15.67Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewQuilt(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_quilt">
        <path
          id="Vector"
          d="M3 5V19H21V5H3ZM8.33 17H5V7H8.33V17ZM13.67 17H10.34V13H13.67V17ZM19 17H15.67V13H19V17ZM19 11H10.33V7H19V11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewSidebar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_sidebar">
        <path
          id="Vector"
          d="M2 4V20H22V4H2ZM20 8.67H17.5V6H20V8.67ZM17.5 10.67H20V13.34H17.5V10.67ZM4 6H15.5V18H4V6ZM17.5 18V15.33H20V18H17.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewStream(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_stream">
        <path
          id="Vector"
          d="M3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5H5C3.9 5 3 5.9 3 7ZM19 17H5V13H19V17ZM5 11V7H19V11H5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconViewTimeline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_timeline">
        <g id="Vector">
          <path d="M12 15H6V17H12V15Z" fill="currentColor" />
          <path d="M18 7H12V9H18V7Z" fill="currentColor" />
          <path d="M15 11H9V13H15V11Z" fill="currentColor" />
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconViewWeek(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="view_week">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM8 18H4V6H8V18ZM14 18H10V6H14V18ZM20 18H16V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVignette(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vignette">
        <path
          id="Vector"
          d="M21 5V19H3V5H21ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM12 8C15.25 8 18 9.83 18 12C18 14.17 15.25 16 12 16C8.75 16 6 14.17 6 12C6 9.83 8.75 8 12 8ZM12 6C7.58 6 4 8.69 4 12C4 15.31 7.58 18 12 18C16.42 18 20 15.31 20 12C20 8.69 16.42 6 12 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVilla(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="villa">
        <path
          id="Vector"
          d="M19 10C17.9 10 17 10.9 17 12H16V3L3 8V21H21V12C21 10.9 20.1 10 19 10ZM5 9.37L14 5.91V12H9V19H5V9.37ZM19 19H16V16H14V19H11V14H19V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVisibility(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="visibility">
        <path
          id="Vector"
          d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.79 17.5 12 17.5C8.21 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVisibilityOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="visibility_off">
        <path
          id="Vector"
          d="M12 5.97505C15.79 5.97505 19.17 8.10505 20.82 11.475C20.23 12.695 19.4 13.745 18.41 14.595L19.82 16.005C21.21 14.775 22.31 13.235 23 11.475C21.27 7.08505 17 3.97505 12 3.97505C10.73 3.97505 9.51 4.17505 8.36 4.54505L10.01 6.19505C10.66 6.06505 11.32 5.97505 12 5.97505ZM10.93 7.11505L13 9.18505C13.57 9.43505 14.03 9.89505 14.28 10.465L16.35 12.535C16.43 12.195 16.49 11.835 16.49 11.465C16.5 8.98505 14.48 6.97505 12 6.97505C11.63 6.97505 11.28 7.02505 10.93 7.11505ZM2.01 3.84505L4.69 6.52505C3.06 7.80505 1.77 9.50505 1 11.475C2.73 15.865 7 18.975 12 18.975C13.52 18.975 14.98 18.685 16.32 18.155L19.74 21.575L21.15 20.165L3.42 2.42505L2.01 3.84505ZM9.51 11.345L12.12 13.955C12.08 13.965 12.04 13.975 12 13.975C10.62 13.975 9.5 12.855 9.5 11.475C9.5 11.425 9.51 11.395 9.51 11.345ZM6.11 7.94505L7.86 9.69505C7.63 10.245 7.5 10.845 7.5 11.475C7.5 13.955 9.52 15.975 12 15.975C12.63 15.975 13.23 15.845 13.77 15.615L14.75 16.595C13.87 16.835 12.95 16.975 12 16.975C8.21 16.975 4.83 14.845 3.18 11.475C3.88 10.045 4.9 8.86505 6.11 7.94505Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVoiceChat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="voice_chat">
        <path
          id="Vector"
          d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM14 10.6L17 13V7L14 9.4V7H7V13H14V10.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVoiceOverOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="voice_over_off">
        <path
          id="Vector"
          d="M16.7622 5.86L15.0822 7.55C15.8822 8.68 15.9122 10.13 15.1722 11.29L16.8722 12.99C18.7722 10.97 18.7422 8.01 16.7622 5.86ZM20.0722 2.5L18.4422 4.13C21.1622 7.1 21.2022 11.52 18.5822 14.69L20.2222 16.33C23.9622 12.44 23.9322 6.49 20.0722 2.5ZM9.4322 5.54L12.9622 9.07C12.7622 7.21 11.2922 5.74 9.4322 5.54ZM4.4122 3.36L3.0022 4.77L5.6222 7.39C5.2322 8 5.0022 8.72 5.0022 9.5C5.0022 11.71 6.7922 13.5 9.0022 13.5C9.7822 13.5 10.5022 13.27 11.1122 12.88L15.5122 17.28C13.7422 16.1 10.7822 15.5 9.0022 15.5C6.3322 15.5 1.0022 16.84 1.0022 19.5V21.5H17.0022V19.5C17.0022 19.13 16.8922 18.8 16.7122 18.48L19.7322 21.5L21.1422 20.09L4.4122 3.36ZM3.0022 19.5C3.2222 18.78 6.3122 17.5 9.0022 17.5C11.7022 17.5 14.8022 18.79 15.0022 19.5H3.0022ZM9.0022 11.5C7.9022 11.5 7.0022 10.6 7.0022 9.5C7.0022 9.28 7.0422 9.08 7.1122 8.88L9.6222 11.39C9.4222 11.46 9.2222 11.5 9.0022 11.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVoicemail(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="voicemail">
        <path
          id="Vector"
          d="M18.5 6.5C15.46 6.5 13 8.96 13 12C13 13.33 13.47 14.55 14.26 15.5H9.74C10.53 14.55 11 13.33 11 12C11 8.96 8.54 6.5 5.5 6.5C2.46 6.5 0 8.96 0 12C0 15.04 2.46 17.5 5.5 17.5H18.5C21.54 17.5 24 15.04 24 12C24 8.96 21.54 6.5 18.5 6.5ZM5.5 15.5C3.57 15.5 2 13.93 2 12C2 10.07 3.57 8.5 5.5 8.5C7.43 8.5 9 10.07 9 12C9 13.93 7.43 15.5 5.5 15.5ZM18.5 15.5C16.57 15.5 15 13.93 15 12C15 10.07 16.57 8.5 18.5 8.5C20.43 8.5 22 10.07 22 12C22 13.93 20.43 15.5 18.5 15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVolcano(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="volcano">
        <g id="Vector">
          <path
            d="M18 8.5H11L9 13.5H6L2 22.5H22L18 8.5ZM7.3 15.5H10.35L10.85 14.24L12.35 10.5H16.49L19.35 20.5H5.08L7.3 15.5Z"
            fill="currentColor"
          />
          <path d="M15 1.5H13V5.5H15V1.5Z" fill="currentColor" />
          <path
            d="M18.9496 3.13989L16.1212 5.96829L17.5354 7.38249L20.3638 4.55409L18.9496 3.13989Z"
            fill="currentColor"
          />
          <path
            d="M9.05389 3.1361L7.63969 4.5503L10.4681 7.3787L11.8823 5.9645L9.05389 3.1361Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVolumeDown(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="volume_down">
        <path
          id="Vector"
          d="M16.25 7.97V16.02C17.73 15.29 18.75 13.77 18.75 12C18.75 10.23 17.73 8.71 16.25 7.97ZM5.25 9V15H9.25L14.25 20V4L9.25 9H5.25ZM12.25 8.83V15.17L10.08 13H7.25V11H10.08L12.25 8.83Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVolumeMute(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="volume_mute">
        <path
          id="Vector"
          d="M14.5 8.83V15.17L12.33 13H9.5V11H12.33L14.5 8.83ZM16.5 4L11.5 9H7.5V15H11.5L16.5 20V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVolumeOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="volume_off">
        <path
          id="Vector"
          d="M4.33993 2.935L2.92993 4.345L7.28993 8.705L6.99993 9.005H2.99993V15.005H6.99993L11.9999 20.005V13.415L16.1799 17.595C15.5299 18.085 14.7999 18.475 13.9999 18.705V20.765C15.3399 20.465 16.5699 19.845 17.6099 19.015L19.6599 21.065L21.0699 19.655L4.33993 2.935ZM9.99993 15.175L7.82993 13.005H4.99993V11.005H7.82993L8.70993 10.125L9.99993 11.415V15.175ZM18.9999 12.005C18.9999 12.825 18.8499 13.615 18.5899 14.345L20.1199 15.875C20.6799 14.705 20.9999 13.395 20.9999 12.005C20.9999 7.725 18.0099 4.145 13.9999 3.235V5.295C16.8899 6.155 18.9999 8.835 18.9999 12.005ZM11.9999 4.005L10.1199 5.885L11.9999 7.765V4.005ZM16.4999 12.005C16.4999 10.235 15.4799 8.715 13.9999 7.975V9.765L16.4799 12.245C16.4899 12.165 16.4999 12.085 16.4999 12.005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVolumeUp(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="volume_up">
        <path
          id="Vector"
          d="M3 8.99998V15H7L12 20V3.99998L7 8.99998H3ZM10 8.82998V15.17L7.83 13H5V11H7.83L10 8.82998ZM16.5 12C16.5 10.23 15.48 8.70998 14 7.96998V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 3.22998V5.28998C16.89 6.14998 19 8.82998 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.71998 18.01 4.13998 14 3.22998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVolunteerActivism(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="volunteer_activism">
        <g id="Vector">
          <path
            d="M16.5 12.75C19.59 9.94 22.5 7.31 22.5 5.05C22.5 3.2 21.05 1.75 19.2 1.75C18.16 1.75 17.15 2.24 16.5 3C15.84 2.24 14.84 1.75 13.8 1.75C11.95 1.75 10.5 3.2 10.5 5.05C10.5 7.31 13.41 9.94 16.5 12.75ZM13.8 3.75C14.24 3.75 14.69 3.96 14.98 4.3L16.5 6.09L18.02 4.3C18.31 3.96 18.76 3.75 19.2 3.75C19.94 3.75 20.5 4.31 20.5 5.05C20.5 6.17 18.46 8.22 16.5 10.04C14.54 8.22 12.5 6.16 12.5 5.05C12.5 4.31 13.06 3.75 13.8 3.75Z"
            fill="currentColor"
          />
          <path
            d="M19.5 15.75H17.5C17.5 14.55 16.75 13.47 15.63 13.05L9.47 10.75H1.5V21.75H7.5V20.31L14.5 22.25L22.5 19.75V18.75C22.5 17.09 21.16 15.75 19.5 15.75ZM3.5 19.75V12.75H5.5V19.75H3.5ZM14.47 20.16L7.5 18.23V12.75H9.11L14.93 14.92C15.27 15.05 15.5 15.38 15.5 15.75C15.5 15.75 13.51 15.7 13.2 15.6L10.82 14.81L10.19 16.71L12.57 17.5C13.08 17.67 13.61 17.76 14.15 17.76H19.5C19.89 17.76 20.24 17.99 20.4 18.32L14.47 20.16Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVpnKey(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vpn_key">
        <path
          id="Vector"
          d="M22 19H16V15H13.32C12.18 17.42 9.72 19 7 19C3.14 19 0 15.86 0 12C0 8.14 3.14 5 7 5C9.72 5 12.17 6.58 13.32 9H24V15H22V19ZM18 17H20V13H22V11H11.94L11.71 10.33C11.01 8.34 9.11 7 7 7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17C9.11 17 11.01 15.66 11.71 13.67L11.94 13H18V17ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15ZM7 11C6.45 11 6 11.45 6 12C6 12.55 6.45 13 7 13C7.55 13 8 12.55 8 12C8 11.45 7.55 11 7 11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVpnKeyOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vpn_key_off">
        <path
          id="Vector"
          d="M2.81 2.09998L1.39 3.50998L3.98 6.09998C2.2 7.13998 1 9.07998 1 11.29C1 14.6 3.69 17.29 7 17.29C9.22 17.29 11.15 16.08 12.19 14.29L19.78 21.9L21.19 20.49L2.81 2.09998ZM7 15.29C4.79 15.29 3 13.5 3 11.29C3 9.61998 4.02 8.18998 5.47 7.58998L7.18 9.29998C7.12 9.28998 7.06 9.28998 7 9.28998C5.9 9.28998 5 10.19 5 11.29C5 12.39 5.9 13.29 7 13.29C8.1 13.29 9 12.39 9 11.29C9 11.23 9 11.17 8.99 11.11L10.73 12.85C10.22 13.77 9.14 15.29 7 15.29ZM17 13.46V12.29H15.83L17 13.46ZM13.83 10.29H21V12.29H19V15.29L21 17.29V14.29H23V8.28998H11.83L13.83 10.29Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVpnLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vpn_lock">
        <path
          id="Vector"
          d="M18.92 12C18.96 12.33 19 12.66 19 13C19 15.08 18.2 16.97 16.9 18.39C16.64 17.58 15.9 17 15 17H14V14C14 13.45 13.55 13 13 13H7V11H9C9.55 11 10 10.55 10 10V8H12C13.1 8 14 7.1 14 6V3.46C13.05 3.16 12.05 3 11 3C5.48 3 1 7.48 1 13C1 18.52 5.48 23 11 23C16.52 23 21 18.52 21 13C21 12.66 20.98 12.33 20.95 12H18.92ZM10 20.93C6.05 20.44 3 17.08 3 13C3 12.38 3.08 11.79 3.21 11.21L8 16V17C8 18.1 8.9 19 10 19V20.93ZM22 4V3.5C22 2.12 20.88 1 19.5 1C18.12 1 17 2.12 17 3.5V4C16.45 4 16 4.45 16 5V9C16 9.55 16.45 10 17 10H22C22.55 10 23 9.55 23 9V5C23 4.45 22.55 4 22 4ZM21 4H18V3.5C18 2.67 18.67 2 19.5 2C20.33 2 21 2.67 21 3.5V4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconVrpano(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vrpano">
        <g id="Vector">
          <path
            d="M21.01 4C20.45 4 17.4 5.5 12 5.5C6.69 5.5 3.51 4.01 2.99 4.01C2.46 4.01 2 4.45 2 5.02V19C2 19.57 2.46 20 2.99 20C3.56 20 6.54 18.5 12 18.5C17.42 18.5 20.44 20 21.01 20C21.54 20 22 19.57 22 19V5C22 4.43 21.54 4 21.01 4ZM20 17.63C17.99 17.04 15.38 16.5 12 16.5C8.61 16.5 6.01 17.04 4 17.63V6.38C6.58 7.11 9.32 7.5 12 7.5C15.38 7.5 17.99 6.96 20 6.37V17.63Z"
            fill="currentColor"
          />
          <path
            d="M9.17 10.99L5.48 15.41C7.48 15.15 9.66 15 12 15C14.3 15 16.52 15.15 18.51 15.4L14 10L11.17 13.39L9.17 10.99Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWallet(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wallet">
        <path
          id="Vector"
          d="M18 4H6C3.79 4 2 5.79 2 8V16C2 18.21 3.79 20 6 20H18C20.21 20 22 18.21 22 16V8C22 5.79 20.21 4 18 4ZM16.14 13.77C15.9 13.97 15.57 14.05 15.26 13.97L4.15 11.25C4.45 10.52 5.16 10 6 10H18C18.67 10 19.26 10.34 19.63 10.84L16.14 13.77ZM6 6H18C19.1 6 20 6.9 20 8V8.55C19.41 8.21 18.73 8 18 8H6C5.27 8 4.59 8.21 4 8.55V8C4 6.9 4.9 6 6 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWallpaper(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wallpaper">
        <path
          id="Vector"
          d="M4 4H11V2H4C2.9 2 2 2.9 2 4V11H4V4ZM10 13L6 18H18L15 14L12.97 16.71L10 13ZM17 8.5C17 7.67 16.33 7 15.5 7C14.67 7 14 7.67 14 8.5C14 9.33 14.67 10 15.5 10C16.33 10 17 9.33 17 8.5ZM20 2H13V4H20V11H22V4C22 2.9 21.1 2 20 2ZM20 20H13V22H20C21.1 22 22 21.1 22 20V13H20V20ZM4 13H2V20C2 21.1 2.9 22 4 22H11V20H4V13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWarehouse(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="warehouse">
        <path
          id="Vector"
          d="M20 8.35V19H18V11H6V19H4V8.35L12 5.15L20 8.35ZM22 21V7L12 3L2 7V21H8V13H16V21H22ZM11 19H9V21H11V19ZM13 16H11V18H13V16ZM15 19H13V21H15V19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWarning(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="warning">
        <path
          id="Vector"
          d="M1 21.5H23L12 2.5L1 21.5ZM13 18.5H11V16.5H13V18.5ZM13 14.5H11V10.5H13V14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWarningAmber(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="warning_amber">
        <path
          id="Vector"
          d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wash">
        <path
          id="Vector"
          d="M21.25 16C21.94 16 22.5 15.44 22.5 14.75C22.5 14.06 21.94 13.5 21.25 13.5H12.5V12.5H19.25C19.94 12.5 20.5 11.94 20.5 11.25C20.5 10.58 19.97 10.05 19.32 10.01L9.37 10L10.85 7.4C10.94 7.23 10.99 7.06 10.99 6.86C10.99 6.6 10.9 6.36 10.73 6.16L9.62 5L2.44 11.8C1.84 12.36 1.5 13.15 1.5 13.97V20C1.5 21.66 2.84 23 4.5 23H18.25C18.94 23 19.5 22.44 19.5 21.75C19.5 21.06 18.94 20.5 18.25 20.5H12.5V19.5H20.25C20.94 19.5 21.5 18.94 21.5 18.25C21.5 17.56 20.94 17 20.25 17H12.5V16H21.25ZM10.5 21H4.5C3.95 21 3.5 20.55 3.5 20V14C3.5 13.61 3.73 13.36 3.86 13.25L7.5 9.87V12H10.5V21ZM14 9C14.83 9 15.5 8.33 15.5 7.5C15.5 6.66 14 5 14 5C14 5 12.5 6.66 12.5 7.5C12.5 8.33 13.17 9 14 9ZM19 1C19 1 16.5 3.83 16.5 5.5C16.5 6.88 17.62 8 19 8C20.38 8 21.5 6.88 21.5 5.5C21.5 3.83 19 1 19 1ZM19 6.5C18.45 6.5 18 6.05 18 5.5C18 5.1 18.43 4.28 19 3.45C19.57 4.28 20 5.1 20 5.5C20 6.05 19.55 6.5 19 6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWatch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="watch">
        <path
          id="Vector"
          d="M14.31 2L14.72 4.48C13.87 4.17 12.96 4 12 4C11.05 4 10.13 4.17 9.29 4.47L9.7 2H14.31ZM14.72 19.52L14.31 22H9.7L9.29 19.53C10.13 19.83 11.05 20 12 20C12.96 20 13.87 19.83 14.72 19.52ZM16 0H8L7.05 5.73C5.19 7.19 4 9.45 4 12C4 14.55 5.19 16.81 7.05 18.27L8 24H16L16.96 18.27C18.81 16.81 20 14.54 20 12C20 9.46 18.81 7.19 16.96 5.73L16 0ZM12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWatchLater(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="watch_later">
        <path
          id="Vector"
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWatchOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="watch_off">
        <g id="Vector">
          <path
            d="M12.7101 6.69501C15.4701 6.69501 17.7101 8.93501 17.7101 11.695C17.7101 12.335 17.5801 12.945 17.3601 13.515L18.8601 15.015C19.4001 14.025 19.7101 12.895 19.7101 11.695C19.7101 9.47501 18.6801 7.50501 17.0701 6.22501L15.7101 1.69501H9.7101L8.7501 4.90501L10.8901 7.04501C11.4601 6.82501 12.0701 6.69501 12.7101 6.69501ZM11.2001 3.69501H14.2201L14.6001 4.96501C14.0501 4.80501 12.6301 4.45501 10.8201 4.96501L11.2001 3.69501Z"
            fill="currentColor"
          />
          <path
            d="M3.5201 2.50501L2.1001 3.91501L6.5601 8.37501C6.0201 9.36501 5.7101 10.495 5.7101 11.695C5.7101 13.915 6.7401 15.885 8.3501 17.165L9.7101 21.695H15.7101L16.6701 18.485L20.4901 22.305L21.9001 20.895L3.5201 2.50501ZM14.2201 19.695H11.2001L10.8201 18.425C11.3701 18.575 12.7901 18.935 14.6001 18.425L14.2201 19.695ZM12.7101 16.695C9.9501 16.695 7.7101 14.455 7.7101 11.695C7.7101 11.055 7.8401 10.445 8.0601 9.87501L14.5301 16.345C13.9601 16.565 13.3501 16.695 12.7101 16.695Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWater(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="water">
        <path
          id="Vector"
          d="M5.35 12.5C6.54 12.5 6.77 13.5 8.68 13.5C10.63 13.5 10.77 12.5 12.01 12.5C13.2 12.5 13.43 13.5 15.34 13.5C17.29 13.5 17.43 12.5 18.67 12.5C19.86 12.5 20.07 13.48 21.98 13.5V11.5C20.79 11.5 20.56 10.5 18.65 10.5C16.7 10.5 16.56 11.5 15.32 11.5C14.13 11.5 13.9 10.5 11.99 10.5C10.04 10.5 9.9 11.5 8.66 11.5C7.47 11.5 7.24 10.5 5.33 10.5C3.38 10.5 3.24 11.5 2 11.5V13.5C3.9 13.5 4.17 12.5 5.35 12.5ZM18.67 14.5C16.72 14.5 16.58 15.5 15.34 15.5C14.15 15.5 13.92 14.5 12.01 14.5C10.06 14.5 9.91 15.5 8.67 15.5C7.43 15.5 7.29 14.5 5.34 14.5C3.39 14.5 3.24 15.5 2 15.5V17.5C3.95 17.5 4.11 16.5 5.34 16.5C6.58 16.5 6.72 17.5 8.67 17.5C10.62 17.5 10.77 16.5 12.01 16.5C13.2 16.5 13.43 17.5 15.34 17.5C17.28 17.5 17.43 16.5 18.67 16.5C19.86 16.5 20.09 17.5 22 17.5V15.5C20.76 15.5 20.62 14.5 18.67 14.5ZM5.35 8.5C6.54 8.5 6.77 9.5 8.68 9.5C10.63 9.5 10.77 8.5 12.01 8.5C13.2 8.5 13.43 9.5 15.34 9.5C17.29 9.5 17.43 8.5 18.67 8.5C19.86 8.5 20.07 9.48 21.98 9.5V7.5C20.79 7.5 20.56 6.5 18.65 6.5C16.7 6.5 16.56 7.5 15.32 7.5C14.13 7.5 13.9 6.5 11.99 6.5C10.04 6.5 9.9 7.5 8.66 7.5C7.47 7.5 7.24 6.5 5.33 6.5C3.38 6.5 3.24 7.5 2 7.5V9.5C3.9 9.5 4.17 8.5 5.35 8.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWaterDamage(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="water_damage">
        <path
          id="Vector"
          d="M12 3.5L2 12.5H5V20.5H19V12.5H22L12 3.5ZM7 18.5V10.69L12 6.19L17 10.69V18.5H7ZM14 14.5C14 15.6 13.1 16.5 12 16.5C10.9 16.5 10 15.6 10 14.5C10 13.4 12 10.5 12 10.5C12 10.5 14 13.4 14 14.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWaterDrop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="water_drop">
        <path
          id="Vector"
          d="M12 2C6.67 6.55 4 10.48 4 13.8C4 18.78 7.8 22 12 22C16.2 22 20 18.78 20 13.8C20 10.48 17.33 6.55 12 2ZM12 20C8.65 20 6 17.43 6 13.8C6 11.46 7.95 8.36 12 4.66C16.05 8.36 18 11.45 18 13.8C18 17.43 15.35 20 12 20ZM7.83 14C8.2 14 8.5 14.26 8.57 14.62C8.98 16.84 10.85 17.6 12.21 17.49C12.64 17.47 13 17.81 13 18.24C13 18.64 12.68 18.97 12.28 18.99C10.15 19.12 7.66 17.9 7.09 14.87C7.01 14.42 7.37 14 7.83 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWaterfallChart(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="waterfall_chart">
        <path
          id="Vector"
          d="M18 4H21V20H18V4ZM3 13H6V20H3V13ZM14 4H17V7H14V4ZM10 5H13V9H10V5ZM7 10H10V14H7V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWaves(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="waves">
        <path
          id="Vector"
          d="M17 16.99C15.65 16.99 14.8 17.41 14.05 17.79C13.4 18.12 12.87 18.39 12 18.39C11.1 18.39 10.6 18.14 9.95 17.79C9.2 17.41 8.38 16.99 7 16.99C5.62 16.99 4.8 17.41 4.05 17.79C3.4 18.12 2.88 18.39 2 18.39V20.34C3.35 20.34 4.2 19.92 4.95 19.54C5.6 19.21 6.12 18.94 7 18.94C7.88 18.94 8.4 19.19 9.05 19.54C9.8 19.92 10.62 20.34 12 20.34C13.38 20.34 14.2 19.92 14.95 19.54C15.6 19.21 16.13 18.94 17 18.94C17.9 18.94 18.4 19.19 19.05 19.54C19.8 19.92 20.63 20.34 22 20.34V18.39C21.1 18.39 20.6 18.14 19.95 17.79C19.2 17.41 18.35 16.99 17 16.99ZM17 12.54C15.65 12.54 14.8 12.97 14.05 13.34C13.4 13.66 12.87 13.94 12 13.94C11.1 13.94 10.6 13.69 9.95 13.34C9.2 12.96 8.38 12.54 7 12.54C5.62 12.54 4.8 12.97 4.05 13.34C3.4 13.66 2.88 13.94 2 13.94V15.89C3.35 15.89 4.2 15.46 4.95 15.09C5.6 14.74 6.1 14.49 7 14.49C7.9 14.49 8.4 14.74 9.05 15.09C9.8 15.47 10.62 15.89 12 15.89C13.38 15.89 14.2 15.46 14.95 15.09C15.6 14.74 16.1 14.49 17 14.49C17.9 14.49 18.4 14.74 19.05 15.09C19.8 15.47 20.63 15.89 22 15.89V13.94C21.1 13.94 20.6 13.69 19.95 13.34C19.2 12.96 18.35 12.54 17 12.54ZM19.95 4.46003C19.2 4.08003 18.37 3.66003 17 3.66003C15.63 3.66003 14.8 4.08003 14.05 4.46003C13.4 4.78003 12.87 5.06003 12 5.06003C11.1 5.06003 10.6 4.81003 9.95 4.46003C9.2 4.09003 8.38 3.66003 7 3.66003C5.62 3.66003 4.8 4.08003 4.05 4.46003C3.4 4.79003 2.88 5.06003 2 5.06003V6.99003C3.35 6.99003 4.2 6.56003 4.95 6.19003C5.6 5.86003 6.12 5.59003 7 5.59003C7.88 5.59003 8.4 5.84003 9.05 6.19003C9.8 6.57003 10.62 6.99003 12 6.99003C13.38 6.99003 14.2 6.56003 14.95 6.19003C15.6 5.87003 16.13 5.59003 17 5.59003C17.9 5.59003 18.4 5.84003 19.05 6.19003C19.8 6.57003 20.63 6.99003 22 6.99003V5.04003C21.1 5.04003 20.6 4.79003 19.95 4.46003ZM17 8.09003C15.65 8.09003 14.8 8.52003 14.05 8.89003C13.4 9.24003 12.9 9.49003 12 9.49003C11.1 9.49003 10.6 9.24003 9.95 8.89003C9.2 8.51003 8.38 8.09003 7 8.09003C5.62 8.09003 4.8 8.52003 4.05 8.89003C3.4 9.24003 2.9 9.49003 2 9.49003V11.44C3.35 11.44 4.2 11.01 4.95 10.64C5.6 10.32 6.13 10.04 7 10.04C7.87 10.04 8.4 10.29 9.05 10.64C9.8 11.02 10.62 11.44 12 11.44C13.38 11.44 14.2 11.01 14.95 10.64C15.6 10.32 16.13 10.04 17 10.04C17.9 10.04 18.4 10.29 19.05 10.64C19.8 11.02 20.63 11.44 22 11.44V9.49003C21.1 9.49003 20.6 9.24003 19.95 8.89003C19.2 8.51003 18.35 8.09003 17 8.09003Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWavingHand(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="waving_hand">
        <path
          id="Vector"
          d="M7.03 4.95L3.49 8.49C0.17 11.81 0.17 17.19 3.49 20.51C6.81 23.83 12.19 23.83 15.51 20.51L21.52 14.5C22.49 13.53 22.49 11.94 21.52 10.96C21.4 10.84 21.27 10.73 21.13 10.64L21.52 10.25C22.49 9.28 22.49 7.69 21.52 6.71C21.36 6.55 21.17 6.41 20.98 6.3C21.38 5.38 21.21 4.28 20.46 3.53C19.59 2.66 18.24 2.57 17.26 3.25C17.16 3.1 17.05 2.96 16.92 2.83C15.95 1.86 14.36 1.86 13.38 2.83L10.87 5.34C10.78 5.2 10.67 5.07 10.55 4.95C9.58 3.98 8 3.98 7.03 4.95ZM8.44 6.37C8.64 6.17 8.95 6.17 9.15 6.37C9.35 6.57 9.35 6.88 9.15 7.08L5.97 10.26C7.14 11.43 7.14 13.33 5.97 14.5L7.38 15.91C8.83 14.46 9.2 12.34 8.5 10.55L14.8 4.25C15 4.05 15.31 4.05 15.51 4.25C15.71 4.45 15.71 4.76 15.51 4.96L10.91 9.56L12.32 10.97L18.33 4.96C18.53 4.76 18.84 4.76 19.04 4.96C19.24 5.16 19.24 5.47 19.04 5.67L13.03 11.68L14.44 13.09L19.39 8.14C19.59 7.94 19.9 7.94 20.1 8.14C20.3 8.34 20.3 8.65 20.1 8.85L14.44 14.51L15.85 15.92L19.39 12.38C19.59 12.18 19.9 12.18 20.1 12.38C20.3 12.58 20.3 12.89 20.1 13.09L14.1 19.1C11.56 21.64 7.45 21.64 4.91 19.1C2.37 16.56 2.37 12.45 4.91 9.91L8.44 6.37ZM23 17C23 20.31 20.31 23 17 23V21.5C19.48 21.5 21.5 19.48 21.5 17H23ZM1 7C1 3.69 3.69 1 7 1V2.5C4.52 2.5 2.5 4.52 2.5 7H1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbAuto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_auto">
        <path
          id="Vector"
          d="M7.1001 7L3.9001 16H5.8001L6.5001 14H9.7001L10.4001 16H12.3001L9.1001 7H7.1001ZM6.9501 12.65L8.1001 9L9.2501 12.65H6.9501ZM22.1001 7L20.9001 13.29L19.4001 7H17.8001L16.3101 13.29L15.1001 7H14.3401L14.3301 7.01C12.8601 5.18 10.6301 4 8.1001 4C3.6801 4 0.100098 7.58 0.100098 12C0.100098 16.42 3.6801 20 8.1001 20C11.0601 20 13.6501 18.39 15.0301 16C15.0601 15.94 15.0801 15.88 15.1101 15.82C15.1601 15.74 15.2001 15.65 15.2501 15.57L15.3501 16H17.1001L18.6001 9.9L20.1001 16H21.8501L23.9001 7H22.1001ZM13.4701 14.67C12.4801 16.64 10.4501 18 8.1001 18C4.7901 18 2.1001 15.31 2.1001 12C2.1001 8.69 4.7901 6 8.1001 6C11.4101 6 14.1001 8.69 14.1001 12C14.1001 12.96 13.8701 13.86 13.4701 14.67Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbCloudy(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_cloudy">
        <path
          id="Vector"
          d="M12 6C14.61 6 16.89 7.86 17.4 10.43L17.7 11.93L19.22 12.04C20.78 12.15 22 13.45 22 15C22 16.65 20.65 18 19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.07 7.14 9.94 6 12 6ZM12 4C9.11 4 6.59 5.64 5.34 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.36 10.04C18.67 6.59 15.64 4 12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbIncandescent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_incandescent">
        <path
          id="Vector"
          d="M3.55 18.5649L4.96 19.9749L6.75 18.1749L5.34 16.7649L3.55 18.5649ZM11 19.4749H13V22.4749H11V19.4749ZM1 10.4749H4V12.4749H1V10.4749ZM13 3.5249V7.4849L14 8.0649C15.24 8.7849 16 10.1049 16 11.5249C16 13.7349 14.21 15.5249 12 15.5249C9.79 15.5249 8 13.7349 8 11.5249C8 10.1049 8.77 8.7849 10 8.0649L11 7.4849V3.5249H13ZM15 1.5249H9V6.3349C7.21 7.3749 6 9.3049 6 11.5249C6 14.8349 8.69 17.5249 12 17.5249C15.31 17.5249 18 14.8349 18 11.5249C18 9.3049 16.79 7.3749 15 6.3349V1.5249ZM20 10.4749H23V12.4749H20V10.4749ZM17.24 18.1849L19.03 19.9849L20.44 18.5749L18.64 16.7849L17.24 18.1849Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbIridescent(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_iridescent">
        <path
          id="Vector"
          d="M4.99492 15H18.9949V9H4.99492V15ZM6.99492 11H16.9949V13H6.99492V11ZM10.9949 1H12.9949V4H10.9949V1ZM20.4549 5.01L19.0349 3.6L17.2449 5.39L18.6549 6.8L20.4549 5.01ZM10.9949 20H12.9949V23H10.9949V20ZM17.2349 18.71L19.0249 20.51L20.4449 19.09L18.6449 17.3L17.2349 18.71ZM4.95492 3.595L6.74292 5.385L5.33492 6.79L3.54792 5.003L4.95492 3.595ZM3.54492 19.08L4.95492 20.5L6.74492 18.7L5.33492 17.29L3.54492 19.08Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbShade(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_shade">
        <path
          id="Vector"
          d="M14 12V14.5L19.5 20H22L14 12ZM14 20H17L14 17V20ZM8 4L2 10H4V20H12V10H14L8 4ZM9 14H7V10H9V14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbSunny(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_sunny">
        <path
          id="Vector"
          d="M6.76 5.34005L4.96 3.55005L3.55 4.96005L5.34 6.75005L6.76 5.34005ZM1 11H4V13H1V11ZM11 1.05005H13V4.00005H11V1.05005ZM19.04 3.54505L20.448 4.95205L18.658 6.74205L17.251 5.33405L19.04 3.54505ZM17.24 18.66L19.03 20.46L20.44 19.05L18.64 17.26L17.24 18.66ZM20 11H23V13H20V11ZM12 6.00005C8.69 6.00005 6 8.69005 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69005 15.31 6.00005 12 6.00005ZM12 16C9.79 16 8 14.21 8 12C8 9.79005 9.79 8.00005 12 8.00005C14.21 8.00005 16 9.79005 16 12C16 14.21 14.21 16 12 16ZM11 20H13V22.9501H11V20ZM3.55 19.0401L4.96 20.4501L6.75 18.65L5.34 17.24L3.55 19.0401Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWbTwilight(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wb_twilight">
        <g id="Vector">
          <path
            d="M19.0759 6.53981L16.9552 8.66201L18.37 10.0758L20.4907 7.95361L19.0759 6.53981Z"
            fill="currentColor"
          />
          <path d="M22 18H2V20H22V18Z" fill="currentColor" />
          <path d="M13 4H11V7H13V4Z" fill="currentColor" />
          <path
            d="M4.95674 6.51064L3.54254 7.92484L5.66384 10.0461L7.07804 8.63194L4.95674 6.51064Z"
            fill="currentColor"
          />
          <path d="M5 16H19C19 12.13 15.87 9 12 9C8.13 9 5 12.13 5 16Z" fill="currentColor" />
        </g>
      </g>
    </svg>
  )
}

export function IconWc(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wc">
        <path
          id="Vector"
          d="M5 22V14.5H3.5V9C3.5 7.9 4.4 7 5.5 7H8.5C9.6 7 10.5 7.9 10.5 9V14.5H9V22H5ZM17.5 22V16H20.5L17.96 8.37C17.68 7.55 16.92 7 16.06 7H15.94C15.08 7 14.31 7.55 14.04 8.37L11.5 16H14.5V22H17.5ZM7 6C8.11 6 9 5.11 9 4C9 2.89 8.11 2 7 2C5.89 2 5 2.89 5 4C5 5.11 5.89 6 7 6ZM16 6C17.11 6 18 5.11 18 4C18 2.89 17.11 2 16 2C14.89 2 14 2.89 14 4C14 5.11 14.89 6 16 6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWeb(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="web">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 9H14.5V12.5H4V9ZM4 14.5H14.5V18H4V14.5ZM20 18H16.5V9H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWebAsset(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="web_asset">
        <path
          id="Vector"
          d="M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWebAssetOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="web_asset_off">
        <path
          id="Vector"
          d="M7.48497 3.29502H20.655C21.765 3.29502 22.655 4.19502 22.655 5.29502V17.295C22.655 17.635 22.565 17.955 22.425 18.235L20.655 16.465V7.29502H11.485L7.48497 3.29502ZM21.145 22.605L17.825 19.295H4.65497C3.54497 19.295 2.65497 18.395 2.65497 17.295V5.29502C2.65497 4.95502 2.73497 4.63502 2.88497 4.35502L1.34497 2.80502L2.75497 1.39502L22.555 21.195L21.145 22.605ZM15.825 17.295L5.82497 7.29502H4.65497V17.295H15.825Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWebStories(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="web_stories">
        <g id="Vector">
          <path
            d="M16.75 4V20C17.85 20 18.75 19.1 18.75 18V6C18.75 4.9 17.85 4 16.75 4Z"
            fill="currentColor"
          />
          <path
            d="M12.75 2H3.75C2.65 2 1.75 2.9 1.75 4V20C1.75 21.1 2.65 22 3.75 22H12.75C13.85 22 14.75 21.1 14.75 20V4C14.75 2.9 13.85 2 12.75 2ZM12.75 20H3.75V4H12.75V20Z"
            fill="currentColor"
          />
          <path
            d="M20.75 6V18C21.58 18 22.25 17.33 22.25 16.5V7.5C22.25 6.67 21.58 6 20.75 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWebhook(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="webhook">
        <path
          id="Vector"
          d="M10 15.5H15.88C16.15 15.19 16.55 15 17 15C17.83 15 18.5 15.67 18.5 16.5C18.5 17.33 17.83 18 17 18C16.56 18 16.16 17.81 15.88 17.5H11.9C11.44 19.78 9.42 21.5 7 21.5C4.24 21.5 2 19.26 2 16.5C2 14.08 3.72 12.06 6 11.6V13.67C4.84 14.08 4 15.2 4 16.5C4 18.15 5.35 19.5 7 19.5C8.65 19.5 10 18.15 10 16.5V15.5ZM12.5 4.5C14.15 4.5 15.5 5.85 15.5 7.5H17.5C17.5 4.74 15.26 2.5 12.5 2.5C9.74 2.5 7.5 4.74 7.5 7.5C7.5 8.93 8.1 10.21 9.05 11.12L6.7 15.02C6.02 15.16 5.5 15.77 5.5 16.5C5.5 17.33 6.17 18 7 18C7.83 18 8.5 17.33 8.5 16.5C8.5 16.34 8.48 16.19 8.43 16.05L11.81 10.42C10.49 10.11 9.5 8.92 9.5 7.5C9.5 5.85 10.85 4.5 12.5 4.5ZM17 13.5C16.36 13.5 15.77 13.7 15.28 14.04L12.23 8.97C11.53 8.85 11 8.24 11 7.5C11 6.67 11.67 6 12.5 6C13.33 6 14 6.67 14 7.5C14 7.65 13.98 7.79 13.94 7.93L16.13 11.58C16.41 11.53 16.7 11.5 17 11.5C19.76 11.5 22 13.74 22 16.5C22 19.26 19.76 21.5 17 21.5C15.15 21.5 13.53 20.49 12.67 19H15.34C15.82 19.32 16.39 19.5 17 19.5C18.65 19.5 20 18.15 20 16.5C20 14.85 18.65 13.5 17 13.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWeekend(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="weekend">
        <path
          id="Vector"
          d="M21 9V7C21 5.35 19.65 4 18 4H6C4.35 4 3 5.35 3 7V9C1.35 9 0 10.35 0 12V17C0 18.65 1.35 20 3 20H21C22.65 20 24 18.65 24 17V12C24 10.35 22.65 9 21 9ZM5 7C5 6.45 5.45 6 6 6H18C18.55 6 19 6.45 19 7V9.78C18.39 10.33 18 11.12 18 12V14H6V12C6 11.12 5.61 10.33 5 9.78V7ZM22 17C22 17.55 21.55 18 21 18H3C2.45 18 2 17.55 2 17V12C2 11.45 2.45 11 3 11C3.55 11 4 11.45 4 12V16H20V12C20 11.45 20.45 11 21 11C21.55 11 22 11.45 22 12V17Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWest(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="west">
        <path
          id="Vector"
          d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWhatshot(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="whatshot">
        <path
          id="Vector"
          d="M11.57 13.825C10.21 14.105 9.4 14.985 9.4 16.235C9.4 17.575 10.51 18.655 11.89 18.655C13.94 18.655 15.6 16.995 15.6 14.945C15.6 13.875 15.45 12.825 15.14 11.825C14.35 12.895 12.94 13.545 11.57 13.825ZM13.5 1.33496C13.5 1.33496 14.24 3.98496 14.24 6.13496C14.24 8.19496 12.89 9.86496 10.83 9.86496C8.76 9.86496 7.2 8.19496 7.2 6.13496L7.23 5.77496C5.21 8.17496 4 11.285 4 14.665C4 19.085 7.58 22.665 12 22.665C16.42 22.665 20 19.085 20 14.665C20 9.27496 17.41 4.46496 13.5 1.33496ZM12 20.665C8.69 20.665 6 17.975 6 14.665C6 13.135 6.3 11.625 6.86 10.235C7.87 11.245 9.27 11.865 10.83 11.865C13.49 11.865 15.58 10.035 16.11 7.43496C17.34 9.63496 18 12.105 18 14.665C18 17.975 15.31 20.665 12 20.665Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWheelchairPickup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wheelchair_pickup">
        <path
          id="Vector"
          d="M3.70508 4C3.70508 2.89 4.59508 2 5.70508 2C6.81508 2 7.70508 2.89 7.70508 4C7.70508 5.11 6.81508 6 5.70508 6C4.59508 6 3.70508 5.11 3.70508 4ZM9.20508 10.95V9C9.20508 7.9 8.30508 7 7.20508 7H4.20508C3.10508 7 2.20508 7.9 2.20508 9V15H4.20508V22H7.70508V21.89C6.46508 20.63 5.70508 18.9 5.70508 17C5.70508 14.42 7.11508 12.16 9.20508 10.95ZM15.7051 17C15.7051 18.65 14.3551 20 12.7051 20C11.0551 20 9.70508 18.65 9.70508 17C9.70508 15.89 10.3151 14.94 11.2051 14.42V12.26C9.18508 12.9 7.70508 14.77 7.70508 17C7.70508 19.76 9.94508 22 12.7051 22C15.4651 22 17.7051 19.76 17.7051 17H15.7051ZM18.7451 14H14.2051V8H12.2051V16H17.6651L20.1351 19.71L21.7951 18.6L18.7451 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWhereToVote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="where_to_vote">
        <path
          id="Vector"
          d="M12 0.755005C7.59 0.755005 4 4.34501 4 8.755C4 14.325 10.96 22.095 11.26 22.425L12 23.245L12.74 22.425C13.04 22.095 20 14.325 20 8.755C20 4.34501 16.41 0.755005 12 0.755005ZM12 20.225C9.82 17.615 6 12.295 6 8.755C6 5.445 8.69 2.755 12 2.755C15.31 2.755 18 5.445 18 8.755C18 12.585 13.75 18.115 12 20.225ZM10.47 10.925L8.71 9.155L7.29 10.575L10.47 13.755L16.48 7.745L15.07 6.32501L10.47 10.925Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWidgets(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="widgets">
        <path
          id="Vector"
          d="M16.0001 5.17497L18.8301 8.00497L16.0001 10.835L13.1701 8.00497L16.0001 5.17497ZM8.34009 5.65497V9.65497H4.34009V5.65497H8.34009ZM18.3401 15.655V19.655H14.3401V15.655H18.3401ZM8.34009 15.655V19.655H4.34009V15.655H8.34009ZM16.0001 2.34497L10.3401 7.99497L16.0001 13.655L21.6601 7.99497L16.0001 2.34497ZM10.3401 3.65497H2.34009V11.655H10.3401V3.65497ZM20.3401 13.655H12.3401V21.655H20.3401V13.655ZM10.3401 13.655H2.34009V21.655H10.3401V13.655Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWidthFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="width_full">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 18V6H5V18H4ZM7 18V6H17V18H7ZM20 18H19V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWidthNormal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="width_normal">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 18V6H8V18H4ZM10 18V6H14V18H10ZM20 18H16V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWidthWide(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="width_wide">
        <path
          id="Vector"
          d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 18V6H6V18H4ZM8 18V6H16V18H8ZM20 18H18V6H20V18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi">
        <path
          id="Vector"
          d="M1 8.77626L3 10.7763C7.97 5.80626 16.03 5.80626 21 10.7763L23 8.77626C16.93 2.70625 7.08 2.70625 1 8.77626ZM9 16.7763L12 19.7763L15 16.7763C13.35 15.1163 10.66 15.1163 9 16.7763ZM5 12.7763L7 14.7763C9.76 12.0163 14.24 12.0163 17 14.7763L19 12.7763C15.14 8.91625 8.87 8.91625 5 12.7763Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifi1Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_1_bar">
        <path
          id="Vector"
          d="M15.53 10.96L12 14.5L8.46997 10.96C9.36997 10.06 10.62 9.5 12 9.5C13.38 9.5 14.63 10.06 15.53 10.96Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifi2Bar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_2_bar">
        <path
          id="Vector"
          d="M12 6.5C15.03 6.5 17.78 7.73 19.76 9.72L17.64 11.84C16.2 10.4 14.2 9.5 12 9.5C9.79999 9.5 7.79999 10.4 6.35999 11.85L4.23999 9.73C6.21999 7.73 8.96999 6.5 12 6.5ZM12 12.5C10.62 12.5 9.36999 13.06 8.46999 13.96L12 17.5L15.53 13.96C14.63 13.06 13.38 12.5 12 12.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifiCalling(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_calling">
        <g id="Vector">
          <path
            d="M19.5 15.51C18.26 15.51 17.05 15.31 15.93 14.94C15.83 14.9 15.72 14.89 15.62 14.89C15.36 14.89 15.11 14.99 14.91 15.18L12.71 17.38C9.88 15.93 7.56 13.62 6.12 10.79L8.32 8.59C8.6 8.31 8.68 7.92 8.57 7.57C8.2 6.45 8 5.25 8 4C8 3.45 7.55 3 7 3H3.5C2.95 3 2.5 3.45 2.5 4C2.5 13.39 10.11 21 19.5 21C20.05 21 20.5 20.55 20.5 20V16.51C20.5 15.96 20.05 15.51 19.5 15.51ZM4.53 5H6.03C6.1 5.89 6.25 6.76 6.49 7.59L5.29 8.79C4.88 7.59 4.62 6.32 4.53 5ZM18.5 18.97C17.18 18.88 15.91 18.62 14.7 18.22L15.89 17.03C16.74 17.27 17.61 17.42 18.49 17.48V18.97H18.5Z"
            fill="currentColor"
          />
          <path
            d="M21.5 4.95C21.29 4.78 19.17 3 16 3C12.82 3 10.71 4.78 10.5 4.95L16 12L21.5 4.95Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWifiCalling3(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_calling_3">
        <g id="Vector">
          <path
            d="M15.9206 4.49927C17.7106 4.49927 19.3406 5.22927 20.5106 6.40927L21.5706 5.34927C20.1306 3.89927 18.1306 2.99927 15.9206 2.99927C13.7106 2.99927 11.7106 3.89927 10.2606 5.33927L11.3206 6.39927C12.5106 5.22927 14.1306 4.49927 15.9206 4.49927Z"
            fill="currentColor"
          />
          <path
            d="M15.9206 5.99927C14.5406 5.99927 13.2906 6.55927 12.3806 7.45927L13.4406 8.51927C14.0706 7.88927 14.9506 7.48927 15.9106 7.48927C16.8706 7.48927 17.7506 7.87927 18.3806 8.51927L19.4406 7.45927C18.5506 6.55927 17.3006 5.99927 15.9206 5.99927Z"
            fill="currentColor"
          />
          <path
            d="M15.9206 8.99927C15.3706 8.99927 14.8706 9.21927 14.5106 9.58927L15.9206 10.9993L17.3306 9.58927C16.9706 9.21927 16.4706 8.99927 15.9206 8.99927Z"
            fill="currentColor"
          />
          <path
            d="M19.6306 14.8693L15.9606 14.1393C15.4606 14.0393 15.1306 14.3393 15.0606 14.4093L12.5406 16.9093C10.0406 15.4793 7.97056 13.4093 6.54056 10.9093L9.04056 8.38927C9.27056 8.14927 9.37056 7.81927 9.31056 7.48927L8.56056 3.79927C8.47056 3.33927 8.06056 2.99927 7.58056 2.99927H3.43056C2.87056 2.99927 2.40056 3.46927 2.43056 4.02927C2.60056 6.91927 3.48056 9.62927 4.86056 11.9993C6.44056 14.7293 8.71056 16.9893 11.4306 18.5693C13.8006 19.9393 16.5106 20.8293 19.4006 20.9993C19.9506 21.0293 20.4306 20.5693 20.4306 19.9993V15.8493C20.4306 15.3693 20.0906 14.9593 19.6306 14.8693ZM4.53056 4.99927H6.76056L7.23056 7.34927L5.60056 8.99927C5.06056 7.69927 4.70056 6.36927 4.53056 4.99927ZM18.4306 18.8993C17.0606 18.7193 15.7306 18.3693 14.4306 17.8293L16.0806 16.1993L18.4306 16.6693V18.8993Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWifiChannel(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_channel">
        <path
          id="Vector"
          d="M16 3C13.49 3 12.23 8.61 11.6 13.57C10.79 10.66 9.61 8 8 8C4.43 8 3 21 3 21H5.01C5.62 15.73 7.01 11.18 8 10.13C8.98 11.18 10.38 15.74 10.99 21H13C13.5 18.47 15 15 16 15C17 15 18.5 18.53 19 21H21C21 21 20.5 3 16 3ZM16 13C15.01 13 14.18 13.62 13.5 14.5C14.07 9.73 15.04 5.88 16 5.06C16.97 5.87 17.91 9.73 18.49 14.49C17.81 13.62 16.98 13 16 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifiFind(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_find">
        <g id="Vector">
          <path
            d="M12 5.5C16.14 5.5 19.88 7.18 22.59 9.89L24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L13.41 19.08L2.93 8.58C5.45 6.66 8.59 5.5 12 5.5Z"
            fill="currentColor"
          />
          <path
            d="M21 13.5C21 11.26 19.24 9.5 17 9.5C14.76 9.5 13 11.26 13 13.5C13 15.74 14.76 17.5 17 17.5C17.75 17.5 18.44 17.29 19.03 16.94L21.59 19.5L23 18.09L20.44 15.53C20.79 14.94 21 14.25 21 13.5ZM17 15.5C15.88 15.5 15 14.62 15 13.5C15 12.38 15.88 11.5 17 11.5C18.12 11.5 19 12.38 19 13.5C19 14.62 18.12 15.5 17 15.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWifiLock(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_lock">
        <g id="Vector">
          <path
            d="M21.98 10.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L15.05 17.45V14.5C15.05 14.05 15.14 13.62 15.28 13.21C15.82 11.64 17.29 10.5 19.05 10.5H21.98Z"
            fill="currentColor"
          />
          <path
            d="M22 15.5V14.5C22 13.4 21.1 12.5 20 12.5C18.9 12.5 18 13.4 18 14.5V15.5C17.45 15.5 17 15.95 17 16.5V19.5C17 20.05 17.45 20.5 18 20.5H22C22.55 20.5 23 20.05 23 19.5V16.5C23 15.95 22.55 15.5 22 15.5ZM21 15.5H19V14.5C19 13.95 19.45 13.5 20 13.5C20.55 13.5 21 13.95 21 14.5V15.5Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWifiOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_off">
        <path
          id="Vector"
          d="M21 12.1701L23 10.1701C19.27 6.44006 14.13 5.02006 9.3 5.86006L11.88 8.44006C15.18 8.42006 18.49 9.66006 21 12.1701ZM19 14.1701C17.92 13.0901 16.64 12.3201 15.28 11.8401L18.3 14.8601L19 14.1701ZM9 18.1701L12 21.1701L15 18.1701C13.35 16.5101 10.66 16.5101 9 18.1701ZM3.41 2.81006L2 4.22006L5.05 7.27006C3.59 8.00006 2.22 8.96006 1 10.1701L3 12.1701C4.23 10.9401 5.65 10.0101 7.17 9.39006L9.41 11.6301C7.79 12.0601 6.27 12.9101 5 14.1701L7 16.1701C8.35 14.8201 10.11 14.1301 11.89 14.1101L18.97 21.1901L20.38 19.7801L3.41 2.81006Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifiPassword(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_password">
        <path
          id="Vector"
          d="M24 6.98L21.88 9.11C19.35 6.57 15.85 5 12 5C8.15 5 4.65 6.57 2.12 9.11L0 6.98C3.07 3.9 7.31 2 12 2C16.69 2 20.93 3.9 24 6.98ZM4.24 11.22L6.36 13.34C7.8 11.9 9.8 11 12 11C14.2 11 16.2 11.9 17.64 13.35L19.76 11.23C17.78 9.23 15.03 8 12 8C8.97 8 6.22 9.23 4.24 11.22ZM24 18V21C24 21.55 23.55 22 23 22H19C18.45 22 18 21.55 18 21V18C18 17.45 18.45 17 19 17V16C19 14.9 19.9 14 21 14C22.1 14 23 14.9 23 16V17C23.55 17 24 17.45 24 18ZM22 16C22 15.45 21.55 15 21 15C20.45 15 20 15.45 20 16V17H22V16ZM12 14C10.62 14 9.37 14.56 8.47 15.46L12 19L15.53 15.46C14.63 14.56 13.38 14 12 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifiProtectedSetup(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_protected_setup">
        <g id="Vector">
          <path
            d="M16.705 5.29L18.995 3H10.995V11L13.295 8.7C15.265 10.16 16.545 12.48 16.545 15.12C16.545 16.43 16.225 17.66 15.665 18.75C17.995 17.23 19.545 14.61 19.545 11.62C19.545 9.1 18.435 6.85 16.705 5.29Z"
            fill="currentColor"
          />
          <path
            d="M7.45496 8.88C7.45496 7.57 7.77496 6.34 8.33496 5.25C5.99496 6.77 4.45496 9.39 4.45496 12.38C4.45496 14.9 5.55496 17.15 7.29496 18.71L4.99496 21H12.995V13L10.695 15.3C8.73496 13.84 7.45496 11.52 7.45496 8.88Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWifiTethering(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_tethering">
        <path
          id="Vector"
          d="M12 10.675C10.9 10.675 10 11.575 10 12.675C10 13.775 10.9 14.675 12 14.675C13.1 14.675 14 13.775 14 12.675C14 11.575 13.1 10.675 12 10.675ZM18 12.675C18 9.36505 15.31 6.67505 12 6.67505C8.69 6.67505 6 9.36505 6 12.675C6 14.895 7.21 16.825 9 17.865L10 16.125C8.81 15.425 8 14.155 8 12.675C8 10.465 9.79 8.67505 12 8.67505C14.21 8.67505 16 10.465 16 12.675C16 14.155 15.19 15.425 14 16.125L15 17.865C16.79 16.825 18 14.895 18 12.675ZM12 2.67505C6.48 2.67505 2 7.15505 2 12.675C2 16.375 4.01 19.595 6.99 21.325L7.99 19.595C5.61 18.205 4 15.635 4 12.675C4 8.25505 7.58 4.67505 12 4.67505C16.42 4.67505 20 8.25505 20 12.675C20 15.635 18.39 18.205 16 19.595L17 21.325C19.99 19.595 22 16.375 22 12.675C22 7.15505 17.52 2.67505 12 2.67505Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifiTetheringError(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_tethering_error">
        <path
          id="Vector"
          d="M12 7.46497C8.69 7.46497 6 10.155 6 13.465C6 15.125 6.68 16.615 7.76 17.705L9.18 16.285C8.45 15.565 8 14.575 8 13.465C8 11.255 9.79 9.46497 12 9.46497C14.21 9.46497 16 11.255 16 13.465C16 14.575 15.55 15.565 14.82 16.285L16.24 17.705C17.32 16.615 18 15.125 18 13.465C18 10.155 15.31 7.46497 12 7.46497ZM12 3.46497C6.48 3.46497 2 7.94497 2 13.465C2 16.225 3.12 18.725 4.93 20.535L6.35 19.115C4.9 17.675 4 15.675 4 13.465C4 9.04497 7.58 5.46497 12 5.46497C14.53 5.46497 16.78 6.63497 18.24 8.46497H20.66C18.93 5.47497 15.7 3.46497 12 3.46497ZM12 11.465C10.9 11.465 10 12.365 10 13.465C10 14.015 10.23 14.515 10.59 14.875C10.95 15.235 11.45 15.465 12 15.465C12.55 15.465 13.05 15.235 13.41 14.875C13.77 14.515 14 14.015 14 13.465C14 12.365 13.1 11.465 12 11.465ZM20 10.465H22V16.465H20V10.465ZM20 18.465H22V20.465H20V18.465Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWifiTetheringOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wifi_tethering_off">
        <path
          id="Vector"
          d="M3.11507 2.10498L1.69507 3.51498L4.38507 6.20498C3.08507 7.89498 2.30507 10.005 2.30507 12.295C2.30507 15.055 3.42507 17.555 5.23507 19.365L6.65507 17.945C5.20507 16.505 4.30507 14.505 4.30507 12.295C4.30507 10.545 4.87507 8.94498 5.81507 7.63498L7.24507 9.06498C6.65507 9.99498 6.30507 11.105 6.30507 12.295C6.30507 13.955 6.98507 15.445 8.06507 16.535L9.48507 15.115C8.75507 14.395 8.30507 13.405 8.30507 12.295C8.30507 11.665 8.45507 11.065 8.71507 10.535L10.3251 12.145C10.3251 12.195 10.3051 12.245 10.3051 12.295C10.3051 12.845 10.5351 13.345 10.8951 13.705C11.2551 14.065 11.7551 14.295 12.3051 14.295C12.3551 14.295 12.4051 14.285 12.4651 14.275L20.0851 21.895L21.4951 20.485L3.11507 2.10498ZM18.0051 14.165C18.1951 13.575 18.3051 12.945 18.3051 12.295C18.3051 8.98498 15.6151 6.29498 12.3051 6.29498C11.6551 6.29498 11.0251 6.39498 10.4351 6.59498L12.1451 8.30498C12.1951 8.29498 12.2551 8.29498 12.3051 8.29498C14.5151 8.29498 16.3051 10.085 16.3051 12.295C16.3051 12.345 16.3051 12.405 16.2951 12.455L18.0051 14.165ZM12.3051 4.29498C16.7251 4.29498 20.3051 7.87498 20.3051 12.295C20.3051 13.515 20.0351 14.665 19.5351 15.695L21.0251 17.185C21.8351 15.745 22.3051 14.075 22.3051 12.295C22.3051 6.77498 17.8251 2.29498 12.3051 2.29498C10.5251 2.29498 8.86507 2.75498 7.41507 3.57498L8.89507 5.05498C9.93507 4.56498 11.0851 4.29498 12.3051 4.29498Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWindPower(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wind_power">
        <g id="Vector">
          <path d="M10.25 2.75H4.25V4.75H10.25V2.75Z" fill="currentColor" />
          <path d="M6.25 6.75H1.25V8.75H6.25V6.75Z" fill="currentColor" />
          <path d="M8.25 18.75H3.25V20.75H8.25V18.75Z" fill="currentColor" />
          <path
            d="M22.46 18.36L20.18 14.26C19.91 13.78 19.45 13.43 18.92 13.29L16.23 12.62C16.21 12.15 16.09 11.7 15.86 11.29L19.82 4.7C20.47 3.62 20.12 2.22 19.04 1.57C18.68 1.35 18.27 1.25 17.87 1.25C17.31 1.25 16.75 1.46 16.31 1.87L12.88 5.08C12.48 5.45 12.25 5.98 12.25 6.53V9.93C11.78 10.1 11.36 10.38 11.02 10.75H3.53C2.27 10.75 1.25 11.77 1.25 13.03C1.25 14.05 1.92 14.94 2.9 15.22L7.41 16.51C7.59 16.56 7.78 16.59 7.96 16.59C8.32 16.59 8.68 16.49 8.99 16.3L11.23 14.96C11.52 15.22 11.86 15.43 12.25 15.57V20.75C11.15 20.75 10.25 21.65 10.25 22.75H16.25C16.25 21.65 15.35 20.75 14.25 20.75V16.47L18.86 21.08C19.31 21.53 19.89 21.75 20.47 21.75C21.05 21.75 21.64 21.53 22.08 21.08C22.8 20.36 22.96 19.25 22.46 18.36ZM7.97 14.59L3.45 13.3C3.33 13.27 3.25 13.15 3.25 13.03C3.25 12.88 3.38 12.75 3.53 12.75H10.26C10.26 12.9 10.27 13.05 10.29 13.19L7.97 14.59ZM13.25 13.75C12.7 13.75 12.25 13.3 12.25 12.75C12.25 12.2 12.7 11.75 13.25 11.75C13.8 11.75 14.25 12.2 14.25 12.75C14.25 13.3 13.8 13.75 13.25 13.75ZM14.25 9.89V6.53L17.68 3.32C17.73 3.27 17.87 3.2 18.02 3.28C18.15 3.36 18.2 3.53 18.12 3.66L14.38 9.9L14.25 9.89ZM20.67 19.67C20.62 19.72 20.43 19.83 20.27 19.67L15.42 14.82C15.5 14.73 15.58 14.64 15.66 14.54L18.44 15.23L20.72 19.33C20.78 19.44 20.76 19.58 20.67 19.67Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWindow(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="window">
        <path
          id="Vector"
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 11H13V5H19V11ZM11 5V11H5V5H11ZM5 13H11V19H5V13ZM13 19V13H19V19H13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWineBar(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wine_bar">
        <path
          id="Vector"
          d="M6 3V9C6 11.97 8.16 14.43 11 14.91V19H8V21H16V19H13V14.91C15.84 14.43 18 11.97 18 9V3H6ZM12 13C10.14 13 8.59 11.72 8.14 10H15.86C15.41 11.72 13.86 13 12 13ZM16 8H8V5H16V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWoman(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="woman">
        <g id="Vector">
          <path
            d="M13.94 8.31C13.62 7.52 12.85 7 12 7C11.15 7 10.38 7.52 10.06 8.31L7 16H10V22H14V16H17L13.94 8.31Z"
            fill="currentColor"
          />
          <path
            d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWoman2(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="woman_2">
        <g id="Vector">
          <path
            d="M13.94 8.31C13.62 7.52 12.85 7 12 7C11.15 7 10.38 7.52 10.06 8.31L7 16H10.5V22H13.5V16H17L13.94 8.31Z"
            fill="currentColor"
          />
          <path
            d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWork(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="work">
        <path
          id="Vector"
          d="M20 6.5H16V4.5C16 3.39 15.11 2.5 14 2.5H10C8.89 2.5 8 3.39 8 4.5V6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM14 6.5H10V4.5H14V6.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWorkHistory(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="work_history">
        <g id="Vector">
          <path
            d="M3.5 18.5V7.5H19.5V10.79C20.22 11.01 20.9 11.33 21.5 11.76V7.5C21.5 6.39 20.61 5.5 19.5 5.5H15.5V3.5C15.5 2.39 14.61 1.5 13.5 1.5H9.5C8.39 1.5 7.5 2.39 7.5 3.5V5.5H3.5C2.39 5.5 1.51 6.39 1.51 7.5L1.5 18.5C1.5 19.61 2.39 20.5 3.5 20.5H11.18C10.88 19.88 10.68 19.21 10.58 18.5H3.5ZM9.5 3.5H13.5V5.5H9.5V3.5Z"
            fill="currentColor"
          />
          <path
            d="M17.5 12.5C14.74 12.5 12.5 14.74 12.5 17.5C12.5 20.26 14.74 22.5 17.5 22.5C20.26 22.5 22.5 20.26 22.5 17.5C22.5 14.74 20.26 12.5 17.5 12.5ZM19.15 19.85L17 17.7V14.5H18V17.29L19.85 19.14L19.15 19.85Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWorkOff(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="work_off">
        <path
          id="Vector"
          d="M9.43004 3.57992H13.43V5.57992H9.83004L11.83 7.57992H19.43V15.1799L21.43 17.1799V7.57992C21.43 6.46992 20.54 5.57992 19.43 5.57992H15.43V3.57992C15.43 2.46992 14.54 1.57992 13.43 1.57992H9.43004C8.44004 1.57992 7.63004 2.27992 7.47004 3.21992L9.43004 5.17992V3.57992ZM2.83004 1.41992L1.42004 2.82992L4.17004 5.57992H3.43004C2.32004 5.57992 1.44004 6.46992 1.44004 7.57992L1.43004 18.5799C1.43004 19.6899 2.32004 20.5799 3.43004 20.5799H19.17L21.17 22.5799L22.58 21.1699L2.83004 1.41992ZM3.43004 18.5799V7.57992H6.17004L17.17 18.5799H3.43004Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWorkOutline(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="work_outline">
        <path
          id="Vector"
          d="M14 6.5V4.5H10V6.5H14ZM4 8.5V19.5H20V8.5H4ZM20 6.5C21.11 6.5 22 7.39 22 8.5V19.5C22 20.61 21.11 21.5 20 21.5H4C2.89 21.5 2 20.61 2 19.5L2.01 8.5C2.01 7.39 2.89 6.5 4 6.5H8V4.5C8 3.39 8.89 2.5 10 2.5H14C15.11 2.5 16 3.39 16 4.5V6.5H20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWorkspacePremium(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="workspace_premium">
        <path
          id="Vector"
          d="M9.68 13.19L12 11.43L14.31 13.19L13.43 10.34L15.75 8.5H12.91L12 5.69L11.09 8.5H8.25L10.56 10.34L9.68 13.19ZM20 9.5C20 5.08 16.42 1.5 12 1.5C7.58 1.5 4 5.08 4 9.5C4 11.53 4.76 13.37 6 14.78V22.5L12 20.5L18 22.5V14.78C19.24 13.37 20 11.53 20 9.5ZM12 3.5C15.31 3.5 18 6.19 18 9.5C18 12.81 15.31 15.5 12 15.5C8.69 15.5 6 12.81 6 9.5C6 6.19 8.69 3.5 12 3.5ZM12 18.5L8 19.52V16.42C9.18 17.1 10.54 17.5 12 17.5C13.46 17.5 14.82 17.1 16 16.42V19.52L12 18.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWorkspaces(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="workspaces">
        <path
          id="Vector"
          d="M6 15C7.1 15 8 15.9 8 17C8 18.1 7.1 19 6 19C4.9 19 4 18.1 4 17C4 15.9 4.9 15 6 15ZM6 13C3.8 13 2 14.8 2 17C2 19.2 3.8 21 6 21C8.2 21 10 19.2 10 17C10 14.8 8.2 13 6 13ZM12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7C10 5.9 10.9 5 12 5ZM12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3ZM18 15C19.1 15 20 15.9 20 17C20 18.1 19.1 19 18 19C16.9 19 16 18.1 16 17C16 15.9 16.9 15 18 15ZM18 13C15.8 13 14 14.8 14 17C14 19.2 15.8 21 18 21C20.2 21 22 19.2 22 17C22 14.8 20.2 13 18 13Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWrapText(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wrap_text">
        <path
          id="Vector"
          d="M3.5 18H9.5V16H3.5V18ZM19.5 4H3.5V6H19.5V4ZM16.5 10H3.5V12H16.75C17.85 12 18.75 12.9 18.75 14C18.75 15.1 17.85 16 16.75 16H14.5V14L11.5 17L14.5 20V18H16.5C18.71 18 20.5 16.21 20.5 14C20.5 11.79 18.71 10 16.5 10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconWrongLocation(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wrong_location">
        <g id="Vector">
          <path
            d="M16.73 10.77C16.73 10.84 16.73 10.9 16.73 10.97C16.73 13.31 14.78 16.41 10.73 20.11C6.67998 16.41 4.72998 13.32 4.72998 10.97C4.72998 7.34001 7.37998 4.77001 10.73 4.77001C11.07 4.77001 11.41 4.80001 11.73 4.85001V2.83001C11.4 2.79001 11.07 2.77001 10.73 2.77001C6.52998 2.77001 2.72998 5.99001 2.72998 10.97C2.72998 14.29 5.39998 18.22 10.73 22.77C16.06 18.22 18.73 14.29 18.73 10.97C18.73 10.9 18.73 10.84 18.73 10.77H16.73Z"
            fill="currentColor"
          />
          <path
            d="M10.73 12.77C11.8345 12.77 12.73 11.8746 12.73 10.77C12.73 9.66544 11.8345 8.77001 10.73 8.77001C9.62541 8.77001 8.72998 9.66544 8.72998 10.77C8.72998 11.8746 9.62541 12.77 10.73 12.77Z"
            fill="currentColor"
          />
          <path
            d="M21.27 2.65001L19.85 1.23001L17.73 3.36001L15.61 1.23001L14.19 2.65001L16.32 4.77001L14.19 6.89001L15.61 8.31001L17.73 6.18001L19.85 8.31001L21.27 6.89001L19.14 4.77001L21.27 2.65001Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWysiwyg(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wysiwyg">
        <path
          id="Vector"
          d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19ZM17 12H7V10H17V12ZM13 16H7V14H13V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconYard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="yard">
        <path
          id="Vector"
          d="M18 13C14.69 13 12 15.69 12 19C15.31 19 18 16.31 18 13ZM6 13C6 16.31 8.69 19 12 19C12 15.69 9.31 13 6 13ZM8 11.03C8 11.89 8.7 12.59 9.56 12.59C9.89 12.59 10.19 12.49 10.45 12.31L10.44 12.43C10.44 13.29 11.14 13.99 12 13.99C12.86 13.99 13.56 13.29 13.56 12.43L13.55 12.31C13.8 12.48 14.11 12.59 14.44 12.59C15.3 12.59 16 11.89 16 11.03C16 10.41 15.63 9.87 15.11 9.62C15.63 9.38 16 8.84 16 8.22C16 7.36 15.3 6.66 14.44 6.66C14.11 6.66 13.81 6.76 13.55 6.94L13.56 6.82C13.56 5.96 12.86 5.26 12 5.26C11.14 5.26 10.44 5.96 10.44 6.82L10.45 6.94C10.2 6.76 9.89 6.66 9.56 6.66C8.7 6.66 8 7.36 8 8.22C8 8.84 8.37 9.38 8.89 9.63C8.37 9.87 8 10.41 8 11.03ZM12 8.06C12.86 8.06 13.56 8.76 13.56 9.62C13.56 10.48 12.86 11.18 12 11.18C11.14 11.18 10.44 10.48 10.44 9.62C10.44 8.76 11.14 8.06 12 8.06ZM20 4V20H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconYoutubeSearchedFor(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="youtube_searched_for">
        <path
          id="Vector"
          d="M17.01 14.26H16.21L15.94 13.99C16.92 12.85 17.51 11.38 17.51 9.76001C17.51 6.17001 14.6 3.26001 11.01 3.26001C7.42 3.26001 4.51 6.26001 4.51 9.76001H2L5.84 13.76L10 9.76001H6.51C6.51 7.26001 8.53 5.26001 11.01 5.26001C13.49 5.26001 15.51 7.27001 15.51 9.76001C15.51 12.24 13.49 14.26 11.01 14.26C10.36 14.26 9.75 14.12 9.19 13.88L7.71 15.36C8.68 15.93 9.8 16.26 11.01 16.26C12.62 16.26 14.09 15.67 15.23 14.69L15.5 14.96V15.75L20.51 20.74L22 19.26L17.01 14.26Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconZoomIn(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="zoom_in">
        <path
          id="Vector"
          d="M15.755 14.2549H14.965L14.685 13.9849C15.665 12.8449 16.255 11.3649 16.255 9.75488C16.255 6.16488 13.345 3.25488 9.755 3.25488C6.165 3.25488 3.255 6.16488 3.255 9.75488C3.255 13.3449 6.165 16.2549 9.755 16.2549C11.365 16.2549 12.845 15.6649 13.985 14.6849L14.255 14.9649V15.7549L19.255 20.7449L20.745 19.2549L15.755 14.2549ZM9.755 14.2549C7.26501 14.2549 5.255 12.2449 5.255 9.75488C5.255 7.26488 7.26501 5.25488 9.755 5.25488C12.245 5.25488 14.255 7.26488 14.255 9.75488C14.255 12.2449 12.245 14.2549 9.755 14.2549ZM10.255 7.25488H9.255V9.25488H7.255V10.2549H9.255V12.2549H10.255V10.2549H12.255V9.25488H10.255V7.25488Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconZoomInMap(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="zoom_in_map">
        <path
          id="Vector"
          d="M9 9V3H7V5.59L3.91 2.5L2.5 3.91L5.59 7H3V9H9ZM21 9V7H18.41L21.5 3.91L20.09 2.5L17 5.59V3H15V9H21ZM3 15V17H5.59L2.5 20.09L3.91 21.5L7 18.41V21H9V15H3ZM15 15V21H17V18.41L20.09 21.5L21.5 20.09L18.41 17H21V15H15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconZoomOut(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="zoom_out">
        <path
          id="Vector"
          d="M15.7549 14.2549H14.9649L14.6849 13.9849C15.6649 12.8449 16.2549 11.3649 16.2549 9.75488C16.2549 6.16488 13.3449 3.25488 9.75488 3.25488C6.16488 3.25488 3.25488 6.16488 3.25488 9.75488C3.25488 13.3449 6.16488 16.2549 9.75488 16.2549C11.3649 16.2549 12.8449 15.6649 13.9849 14.6849L14.2549 14.9649V15.7549L19.2549 20.7449L20.7449 19.2549L15.7549 14.2549ZM9.75488 14.2549C7.26488 14.2549 5.25488 12.2449 5.25488 9.75488C5.25488 7.26488 7.26488 5.25488 9.75488 5.25488C12.2449 5.25488 14.2549 7.26488 14.2549 9.75488C14.2549 12.2449 12.2449 14.2549 9.75488 14.2549ZM7.25488 9.25488H12.2549V10.2549H7.25488V9.25488Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconZoomOutMap(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="zoom_out_map">
        <path
          id="Vector"
          d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAdobeLightroom(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Adobe_Lightroom">
        <g id="Group 64">
          <path
            id="bg"
            d="M2 9.23809C2 6.70452 2 5.43774 2.49307 4.47004C2.92678 3.61883 3.61883 2.92678 4.47004 2.49307C5.43774 2 6.70452 2 9.2381 2H14.7619C17.2955 2 18.5623 2 19.53 2.49307C20.3812 2.92678 21.0732 3.61883 21.5069 4.47004C22 5.43774 22 6.70452 22 9.2381V14.7619C22 17.2955 22 18.5623 21.5069 19.53C21.0732 20.3812 20.3812 21.0732 19.53 21.5069C18.5623 22 17.2955 22 14.7619 22H9.23809C6.70452 22 5.43774 22 4.47004 21.5069C3.61883 21.0732 2.92678 20.3812 2.49307 19.53C2 18.5623 2 17.2955 2 14.7619V9.23809Z"
            fill="#001E36"
          />
          <g id="Vector">
            <path
              d="M12.5034 16.7286H7.21724C7.12776 16.7286 7.08304 16.6782 7.08308 16.5773V7.83922C7.07319 7.76813 7.13454 7.70521 7.20385 7.71537H8.84069C8.8946 7.70758 8.94209 7.75729 8.93461 7.81171V14.9948H12.7852C12.8657 14.9948 12.897 15.0361 12.8791 15.1186L12.6376 16.6048C12.6355 16.6796 12.5741 16.7279 12.5034 16.7286Z"
              fill="#31A8FF"
            />
            <path
              d="M13.8464 9.87995H15.3088C15.3895 9.88066 15.4619 9.93779 15.4832 10.0176C15.5904 10.2616 15.6036 10.5559 15.604 10.8194C15.8548 10.5199 16.1572 10.2704 16.4962 10.0833C16.8597 9.87228 17.2718 9.76535 17.6895 9.77365C17.7588 9.76348 17.8202 9.82641 17.8103 9.8975V11.5625C17.8103 11.6268 17.7654 11.6589 17.6761 11.6589C17.0571 11.6151 16.0934 11.7651 15.6436 12.2643V16.5937C15.6436 16.6763 15.6078 16.7176 15.5362 16.7175H13.9671C13.8901 16.7289 13.8221 16.6577 13.8329 16.5799V11.879C13.8329 11.2491 13.8463 10.6003 13.7525 9.97629C13.738 9.91887 13.7916 9.86547 13.8464 9.87995Z"
              fill="#31A8FF"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconAdobeXD(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Adobe_XD">
        <g id="Group 66">
          <path
            id="bg"
            d="M2 9.23809C2 6.70452 2 5.43774 2.49307 4.47004C2.92678 3.61883 3.61883 2.92678 4.47004 2.49307C5.43774 2 6.70452 2 9.2381 2H14.7619C17.2955 2 18.5623 2 19.53 2.49307C20.3812 2.92678 21.0732 3.61883 21.5069 4.47004C22 5.43774 22 6.70452 22 9.2381V14.7619C22 17.2955 22 18.5623 21.5069 19.53C21.0732 20.3812 20.3812 21.0732 19.53 21.5069C18.5623 22 17.2955 22 14.7619 22H9.23809C6.70452 22 5.43774 22 4.47004 21.5069C3.61883 21.0732 2.92678 20.3812 2.49307 19.53C2 18.5623 2 17.2955 2 14.7619V9.23809Z"
            fill="#470137"
          />
          <g id="Vector">
            <path
              d="M12.4616 7.88129L9.96604 12.1058L12.636 16.5918C12.6915 16.6935 12.636 16.716 12.5555 16.716H10.6503C10.5161 16.716 10.4222 16.7111 10.3685 16.6193C10.1895 16.2616 10.0106 15.9061 9.83189 15.5529C9.65285 15.1998 9.46279 14.8397 9.2617 14.4727C9.06044 14.1059 8.86143 13.7343 8.66465 13.358C8.48561 13.7251 8.28658 14.092 8.09442 14.4589C7.90199 14.8259 7.71193 15.1906 7.52423 15.5529C7.3364 15.9154 7.1441 16.2755 6.94732 16.6331C6.91148 16.7157 6.84877 16.7242 6.75946 16.7242H4.92141C4.84919 16.7242 4.84047 16.6699 4.88116 16.6056L7.47056 12.2434L4.94822 7.86752C4.9024 7.80509 4.94184 7.73855 5.01532 7.74367H6.90704C6.98895 7.73904 7.06135 7.76996 7.10829 7.84002C7.2693 8.20702 7.44819 8.57397 7.64496 8.94086C7.84161 9.30789 8.04063 9.67025 8.242 10.028C8.44326 10.3857 8.64228 10.7481 8.81223 11.1151C8.99102 10.739 9.17215 10.372 9.35561 10.0142C9.53883 9.65643 9.72666 9.29635 9.91908 8.93398C10.1113 8.57169 10.2969 8.21162 10.4759 7.85377C10.4997 7.77527 10.5565 7.7355 10.6369 7.74368H12.3945C12.4616 7.74368 12.4893 7.83527 12.4616 7.88129Z"
              fill="#FF61F6"
            />
            <path
              d="M16.312 16.8947C15.1288 16.9131 13.8894 16.426 13.2665 15.3466C12.9623 14.8284 12.8102 14.1793 12.8103 13.3994C12.8052 12.7679 12.9626 12.1461 13.2665 11.5968C14.0505 10.1952 15.6301 9.67011 17.1304 9.8079V7.09705C17.1304 7.03296 17.1573 7.00072 17.211 7.00072H18.9014C18.9476 6.99395 18.9885 7.03588 18.982 7.08327V15.2158C18.982 15.5514 19.0152 15.8857 19.0356 16.2204C19.0389 16.2775 19.0058 16.3341 18.9551 16.358C18.1198 16.7153 17.2161 16.8905 16.312 16.8947ZM17.1304 15.1883V11.4317C15.905 11.0912 14.7153 12.0246 14.7154 13.3169C14.6863 14.6529 15.838 15.576 17.1304 15.1883Z"
              fill="#FF61F6"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconAffinityDesigner(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Affinity_Designer">
        <g id="Group">
          <g id="Group_2">
            <g id="designer_icon_marketing">
              <g id="Group_3">
                <path
                  id="Vector"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 3.95312C22 2.87515 21.1248 2 20.0469 2H3.95312C2.87516 2 2 2.87515 2 3.95312V20.0468C2 21.1248 2.87516 22 3.95312 22H20.0469C21.1248 22 22 21.1248 22 20.0468V3.95312Z"
                  fill="#134881"
                />
              </g>
              <g id="Group_4">
                <path
                  id="Vector_2"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.5352 19.7599C20.5318 20.1883 20.183 20.5351 19.7539 20.5351H11.8693L8.49922 14.6977H20.5352V19.7599ZM3.46484 19.7539V16.3264L10.8904 3.46484H13.7924L7.51914 14.3306L11.1012 20.5351H4.24609C3.81484 20.5351 3.46484 20.1851 3.46484 19.7539ZM12.9799 14.0321H10.0459C9.71836 14.0321 9.41563 13.8602 9.25195 13.5765C9.08809 13.2929 9.08809 12.9433 9.25195 12.6598C9.90371 11.5309 10.7197 10.1174 10.7197 10.1174L12.9799 14.0321ZM19.7539 3.46484C20.183 3.46484 20.5318 3.81162 20.5352 4.24002V14.0321H13.7484L11.1037 9.45211L14.5605 3.46484H19.7539Z"
                  fill="url(#paint0_radial_914_315)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_914_315"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.5123 0.256667) scale(20.2785 20.2785)"
        >
          <stop stopColor="#6BE1FB" />
          <stop offset="1" stopColor="#38BDFA" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function IconAffinityPhoto(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Affinity_Photo">
        <g id="Group">
          <g id="Group_2">
            <g id="photo_icon_marketing">
              <g id="Group_3">
                <path
                  id="Vector"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 3.95312C22 2.87515 21.1248 2 20.0469 2H3.95312C2.87516 2 2 2.87515 2 3.95312V20.0468C2 21.1248 2.87516 22 3.95312 22H20.0469C21.1248 22 22 21.1248 22 20.0468V3.95312Z"
                  fill="#4E3188"
                />
              </g>
              <g id="Group_4">
                <path
                  id="Vector_2"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.5352 14.697V19.7539C20.5352 20.1798 20.1936 20.5266 19.7695 20.535L14.6051 20.5349L11.2332 14.697H20.5352ZM13.8367 20.5349H4.70039L9.27109 12.6304L13.8367 20.5349ZM3.9668 20.4836C3.69043 20.3776 3.48946 20.1193 3.46699 19.8118L3.46484 16.3262L7.1791 9.89551H10.0822L3.9668 20.4836ZM12.7373 9.8835C12.9902 9.88455 13.2322 10.0331 13.3629 10.2533C13.3643 10.2555 13.3668 10.26 13.3668 10.26L14.1344 11.5892C14.1344 11.5892 14.1389 11.5966 14.141 11.6002C14.2664 11.8196 14.2713 12.0961 14.1459 12.3195C13.8887 12.7695 13.6273 13.2174 13.368 13.6663C13.2406 13.8847 12.9996 14.0271 12.7434 14.0303C12.2545 14.0324 11.2729 14.0312 11.2729 14.0312C11.0199 14.0302 10.774 13.8953 10.6432 13.6751C10.6402 13.6704 10.6348 13.6606 10.6348 13.6606C10.6348 13.6606 9.8668 12.3313 9.86523 12.3283C9.73965 12.1088 9.73984 11.8254 9.86523 11.602C9.86699 11.5987 9.8709 11.5921 9.8709 11.5921C9.8709 11.5921 10.3848 10.7008 10.642 10.2551C10.7693 10.0368 11.0109 9.88655 11.267 9.88334C11.2713 9.88332 11.2799 9.88313 11.2799 9.88313L12.7285 9.8835H12.7373ZM20.0057 3.50637L13.9266 14.0312H20.5352V4.24609C20.5352 3.90301 20.3135 3.61127 20.0057 3.50637ZM10.8934 3.46484H19.2611L14.7357 11.2999L10.552 4.05617L10.8934 3.46484ZM12.7719 9.23028H7.56328L10.1676 4.7214L12.7719 9.23028Z"
                  fill="url(#paint0_radial_914_323)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_914_323"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.5123 0.256671) scale(20.2783 20.2783)"
        >
          <stop stopColor="#F9A6FF" />
          <stop offset="1" stopColor="#EA73FF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function IconAffirm(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Affirm">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Affirm_2">
          <path
            id="Affirm_3"
            d="M6.62988 12.3434C7.673 12.3434 8.47346 12.8108 8.47363 13.9615V16.7486H7.33008V16.0836C7.07013 16.5337 6.52341 16.8746 5.91016 16.8746C5.0505 16.8745 4.5002 16.407 4.5 15.6344C4.5 14.6592 5.49238 14.31 6.75684 14.1451C7.09569 14.1013 7.27534 13.9896 7.27539 13.7672C7.27539 13.4381 7.00493 13.274 6.51562 13.274C6.00047 13.274 5.42951 13.5504 5.07617 13.8736L4.67383 13.027C5.11415 12.6761 5.9252 12.3435 6.62988 12.3434ZM14.4746 10.3297C15.1618 10.3297 15.5437 10.5738 15.5527 10.5797L15.1758 11.443C15.1758 11.443 14.9356 11.3063 14.6279 11.3063C14.349 11.3063 14.0255 11.468 14.0254 12.0338V12.4693H15.1348V13.4137H14.0254V16.7486H12.8027V13.4137H10.9463V16.7486H9.72266V13.4137H9.0127V12.4693H9.72266V12.1549C9.72266 10.7713 10.6125 10.3298 11.3945 10.3297C11.8856 10.3297 12.2483 10.4471 12.4736 10.5797L12.0957 11.443C11.9194 11.3433 11.7063 11.3063 11.5479 11.3063C11.2695 11.3063 10.9464 11.468 10.9463 12.0338V12.4693H12.8027V12.1549C12.8027 10.771 13.6925 10.3297 14.4746 10.3297ZM17.0869 12.4693V16.7486H15.8643V12.4693H17.0869ZM20.543 12.3434C20.7049 12.3434 20.9028 12.3613 21.0918 12.442L20.8682 13.5738C20.7241 13.4661 20.5061 13.4186 20.3447 13.4186C19.9309 13.4187 19.3379 13.707 19.3379 14.6871V16.7486H18.1143V12.4693H19.2568V13.1881C19.5179 12.6223 19.9137 12.3434 20.543 12.3434ZM26.7656 12.3434C27.5477 12.3434 28.1952 12.8289 28.1953 13.7906V16.7486H26.9727V14.1774C26.9725 13.611 26.6309 13.3756 26.3076 13.3756C25.9031 13.3756 25.4982 13.7459 25.498 14.5455V16.7486H24.2754V14.1861C24.2753 13.6024 23.9533 13.3756 23.6035 13.3756C23.217 13.3759 22.8039 13.7548 22.8037 14.5455V16.7486H21.5781V12.4693H22.7588V13.1168C22.9657 12.7035 23.4133 12.3434 24.0605 12.3434C24.6535 12.3434 25.1488 12.6188 25.3828 13.0953C25.6346 12.7265 26.1185 12.3435 26.7656 12.3434ZM7.25 14.8092C6.26353 14.9135 5.72266 15.0792 5.72266 15.5621C5.72274 15.8231 5.88355 15.9811 6.20508 15.9811C6.81363 15.981 7.24999 15.4552 7.25 14.8092Z"
            fill="#060809"
          />
          <path
            id="Affirm-Arc"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.9933 6.5C19.6896 6.5 16.7449 8.79338 15.9092 11.7421H17.1069C17.8049 9.54612 20.1743 7.61873 22.9933 7.61873C26.4199 7.61873 29.3813 10.2274 29.3813 14.2885C29.3813 15.2003 29.2631 16.0222 29.0395 16.7484H30.2014L30.213 16.7087C30.4032 15.9594 30.5 15.1456 30.5 14.2885C30.5 9.75937 27.1997 6.5 22.9933 6.5Z"
            fill="#0FA0EA"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAlipay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Alipay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Alipay_2">
          <path
            id="Vector"
            d="M31.4934 10.5729L31.5 10.5656H30.4538L29.7932 12.8557H29.7582L28.9996 10.5656H27.7564L29.2523 14.345L28.6273 15.4969V15.5247H29.6034L31.4934 10.5729Z"
            fill="black"
          />
          <path id="Vector_2" d="M19.8955 10.5656H18.7859V14.3311H19.8955V10.5656Z" fill="black" />
          <path
            id="Vector_3"
            d="M27.5381 13.3894V11.8162C27.5381 10.9591 27.0323 10.4883 26.1402 10.4883C25.5708 10.4883 25.178 10.5868 24.4611 10.8044L24.6575 11.6687C25.3109 11.3738 25.5986 11.2475 25.9008 11.2475C26.2658 11.2475 26.4278 11.5073 26.4278 11.9081V11.9359C25.1562 12.1746 24.7627 12.3082 24.5173 12.5542C24.3348 12.7367 24.2574 12.9966 24.2574 13.2988C24.2574 14.0223 24.8196 14.4085 25.3459 14.4085C25.7394 14.4085 26.0555 14.261 26.484 13.9376L26.5614 14.3311H27.6711L27.5381 13.3894ZM26.4285 13.4178C26.1335 13.5792 25.9649 13.6427 25.7685 13.6427C25.5014 13.6427 25.3327 13.4668 25.3327 13.1864C25.3327 13.0812 25.3539 12.9754 25.4379 12.8914C25.5714 12.7579 25.8313 12.6593 26.4285 12.5191V13.4178Z"
            fill="black"
          />
          <path
            id="Vector_4"
            d="M22.6564 10.4883C22.2491 10.4883 21.933 10.643 21.5746 10.938V10.5657H20.4649V15.5247H21.5746V14.2954C21.7855 14.3516 21.9819 14.38 22.2207 14.38C23.2113 14.38 24.1034 13.6493 24.1034 12.3498C24.1034 11.184 23.4573 10.4883 22.6564 10.4883ZM21.9535 13.6843C21.8272 13.6843 21.7075 13.6704 21.5739 13.6281V11.5913C21.806 11.43 21.9951 11.3526 22.2339 11.3526C22.6485 11.3526 22.9785 11.6826 22.9785 12.3855C22.9792 13.2842 22.4944 13.6843 21.9535 13.6843Z"
            fill="black"
          />
          <path
            id="Vector_5"
            d="M9.3796 8.62604H4.62156C4.00193 8.62604 3.5 9.13259 3.5 9.75686V14.5552C3.5 15.1795 4.00193 15.6861 4.62156 15.6861H9.3796C9.99923 15.6861 10.5005 15.1795 10.5005 14.5552V9.75686C10.5012 9.13193 9.99923 8.62604 9.3796 8.62604Z"
            fill="#1677FF"
          />
          <path
            id="Vector_6"
            d="M9.26385 13.0593C8.98413 12.9648 8.60785 12.8199 8.18925 12.6672C8.44054 12.2261 8.64157 11.7242 8.77383 11.1786H7.3937V10.6773H9.08398V10.3976H7.3937V9.56172H6.70397C6.58295 9.56172 6.58295 9.68208 6.58295 9.68208V10.3969H4.8735V10.6767H6.58295V11.1779H5.17108V11.4577H7.90885C7.809 11.8055 7.67409 12.1328 7.51472 12.4298C6.6266 12.1342 5.6783 11.8948 5.08313 12.0422C4.70222 12.1368 4.45688 12.3054 4.31272 12.4827C3.65142 13.2941 4.12557 14.5267 5.52223 14.5267C6.34819 14.5267 7.14373 14.0625 7.76006 13.2974C8.67993 13.7431 10.5005 14.5089 10.5005 14.5089V13.4177C10.5011 13.4177 10.2723 13.3992 9.26385 13.0593ZM5.39196 14.0552C4.3028 14.0552 3.98075 13.1903 4.51904 12.7168C4.69892 12.5567 5.02692 12.4787 5.2015 12.4615C5.84825 12.3974 6.44739 12.646 7.15431 12.9939C6.65768 13.6472 6.02482 14.0552 5.39196 14.0552Z"
            fill="white"
          />
          <path
            id="Vector_7"
            d="M14.9715 9.37859H13.4823L11.8178 14.331H12.8435L13.1245 13.3616H14.8876L15.1547 14.331H16.4681L14.9715 9.37859ZM13.356 12.5535L14.016 10.2707H14.0437L14.6687 12.5535H13.356Z"
            fill="black"
          />
          <path id="Vector_8" d="M18.0267 9.20268H16.9171V14.3304H18.0267V9.20268Z" fill="black" />
          <path
            id="Vector_9"
            d="M18.7012 9.65961C18.7012 10.0246 18.9684 10.2706 19.3407 10.2706C19.713 10.2706 19.9802 10.0246 19.9802 9.65961C19.9802 9.30118 19.713 9.04857 19.3407 9.04857C18.9684 9.04857 18.7012 9.30118 18.7012 9.65961Z"
            fill="#1677FF"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAmazonPay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="AmazonPay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Amazon">
          <path
            id="Smile"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1041 16.8449C21.3012 16.3446 21.7397 15.2235 21.5312 14.9518H21.5327C21.3251 14.6795 20.1597 14.8224 19.6356 14.8867L19.6344 14.8868C19.475 14.9064 19.4504 14.7647 19.5938 14.6621C20.5245 13.9943 22.0494 14.1853 22.2265 14.4108C22.4036 14.6363 22.1782 16.1974 21.3065 16.9428C21.1724 17.0571 21.0443 16.996 21.1041 16.8449ZM14.8412 17.6169C16.8683 17.6169 19.2289 16.9631 20.8549 15.7378V15.7402C21.124 15.5335 20.8933 15.2297 20.6188 15.3487C18.8439 16.1133 16.9386 16.5124 15.0122 16.5231C12.3396 16.5231 9.75444 15.7746 7.66299 14.5321C7.47975 14.4233 7.34329 14.6151 7.49662 14.7553C9.5101 16.6105 12.1294 17.631 14.8412 17.6169Z"
            fill="#FF9900"
          />
          <path
            id="Amazon_2"
            d="M5.58203 9.01172C6.0037 9.01172 6.55454 9.12645 6.88574 9.45215C7.27423 9.82381 7.27216 10.3102 7.26953 10.8418C7.26931 10.8857 7.26855 10.9301 7.26855 10.9746V12.3516C7.26855 12.7225 7.40396 12.9072 7.5459 13.1016C7.56271 13.1246 7.57988 13.1482 7.59668 13.1719C7.65153 13.25 7.6637 13.3476 7.59668 13.4062C7.4197 13.5573 7.10519 13.8357 6.93262 13.9932L6.92578 13.9922C6.86877 14.0427 6.78646 14.0505 6.7207 14.0127C6.47559 13.8044 6.40162 13.6915 6.28809 13.5186C6.26862 13.4889 6.24747 13.4578 6.22461 13.4238C5.74872 13.9184 5.41214 14.0663 4.79688 14.0664C4.06778 14.0664 3.5 13.6067 3.5 12.6875C3.50005 11.9696 3.88329 11.4817 4.41992 11.2422C4.8161 11.0646 5.34472 11.0096 5.80176 10.9619C5.88675 10.9531 5.9701 10.9446 6.04883 10.9355V10.7549C6.05034 10.56 6.05194 10.3422 5.94336 10.1787C5.83751 10.0161 5.63632 9.9502 5.45703 9.9502C5.12675 9.95029 4.83284 10.1229 4.76074 10.4805C4.75162 10.5638 4.68857 10.6308 4.60742 10.6436L3.77441 10.5498C3.73292 10.5437 3.69522 10.5212 3.6709 10.4863C3.64656 10.4514 3.63753 10.4073 3.64551 10.3652C3.838 9.32576 4.75798 9.01178 5.58203 9.01172ZM16.9336 9.00879C17.3543 9.00881 17.9044 9.12288 18.2363 9.44824C18.6259 9.81799 18.6241 10.3011 18.6211 10.8301C18.6208 10.8767 18.6201 10.9243 18.6201 10.9717V12.3496C18.6202 12.7195 18.7546 12.9044 18.8965 13.0986C18.9133 13.1216 18.9305 13.1444 18.9473 13.168C19.0055 13.2494 19.0177 13.3454 18.9434 13.3994C18.7662 13.5506 18.4517 13.8298 18.2793 13.9863C18.222 14.0359 18.1408 14.0443 18.0752 14.0068C17.8288 13.7975 17.7558 13.686 17.6406 13.5107C17.6214 13.4815 17.6007 13.4505 17.5781 13.417C17.1028 13.9118 16.7637 14.0596 16.1504 14.0596C15.4214 14.0594 14.8545 13.5999 14.8545 12.6816C14.8546 11.9631 15.2356 11.4759 15.7783 11.2363C16.1754 11.0581 16.7067 11.0024 17.165 10.9551C17.2481 10.9465 17.3292 10.9385 17.4062 10.9297V10.8184C17.4062 10.7967 17.4071 10.7743 17.4072 10.752C17.4087 10.557 17.4101 10.3397 17.3008 10.1768C17.198 10.0139 16.9931 9.94629 16.8145 9.94629C16.4841 9.94635 16.191 10.1198 16.1182 10.4775C16.1087 10.5608 16.0459 10.6278 15.9648 10.6406L15.126 10.5479C15.0841 10.542 15.046 10.5185 15.0215 10.4834C14.9971 10.4483 14.9879 10.4045 14.9961 10.3623C15.1893 9.3218 16.1094 9.00879 16.9336 9.00879ZM25.3027 9.00586C26.5881 9.0061 27.2832 10.1338 27.2832 11.5664C27.2832 12.9512 26.5169 14.0496 25.3027 14.0498C24.0416 14.0498 23.3545 12.9223 23.3545 11.5186C23.3545 10.1148 24.0501 9.00586 25.3027 9.00586ZM12.6865 9.02246C13.143 8.95028 13.6022 9.13505 13.8877 9.50586C14.1627 9.88782 14.1065 10.445 14.1064 10.9287V13.7939C14.1056 13.8383 14.087 13.8804 14.0557 13.9111C14.0243 13.9418 13.9819 13.958 13.9385 13.957H13.0732C12.9882 13.9524 12.9212 13.8818 12.9199 13.7949V11.3877C12.9199 11.1967 12.936 10.72 12.8955 10.5381C12.8311 10.2329 12.6373 10.1466 12.3867 10.1465C12.1571 10.1536 11.9534 10.2994 11.8691 10.5176C11.7802 10.7477 11.7881 11.1293 11.7881 11.3877V13.7939C11.7873 13.8381 11.7685 13.8805 11.7373 13.9111C11.7061 13.9416 11.6643 13.9578 11.6211 13.957H10.7529C10.6683 13.9518 10.6012 13.8815 10.5996 13.7949V11.3877C10.5996 10.8812 10.6766 10.1348 10.0635 10.1348C9.45022 10.1348 9.46582 10.8608 9.46582 11.3877V13.7939C9.46499 13.8383 9.44638 13.8804 9.41504 13.9111C9.38368 13.9418 9.34127 13.958 9.29785 13.957H8.43164C8.35149 13.9526 8.28617 13.8892 8.27832 13.8076V9.2666C8.2814 9.17576 8.35529 9.10359 8.44434 9.10449H9.25195C9.33447 9.10936 9.40072 9.17739 9.40527 9.26172V9.85449H9.4209C9.63091 9.28076 10.0272 9.01381 10.5605 9.01367C11.0941 9.01367 11.4415 9.28061 11.6846 9.85449C11.8468 9.41285 12.2301 9.09466 12.6865 9.02246ZM30.2627 9C30.6506 9.00002 31.0289 9.14372 31.2734 9.53516C31.4994 9.89832 31.5 10.5091 31.5 10.9482V13.8057C31.4873 13.8889 31.4164 13.9498 31.334 13.9482H30.4629C30.3848 13.9448 30.3203 13.8847 30.3096 13.8057V11.3398C30.3096 10.8435 30.366 10.1174 29.7676 10.1172C29.5452 10.1277 29.3488 10.2696 29.2656 10.4805C29.1445 10.7576 29.1289 11.0349 29.1289 11.3418V13.7852C29.1256 13.8773 29.0503 13.95 28.96 13.9482H28.0957C28.0107 13.9435 27.9435 13.8721 27.9424 13.7852V9.24414C27.9516 9.15797 28.0245 9.09357 28.1094 9.0957H28.9121C28.9853 9.0981 29.0479 9.15006 29.0654 9.22266V9.91699H29.083C29.3253 9.29613 29.6647 9 30.2627 9ZM22.6885 9.08789C22.7317 9.0864 22.7737 9.10298 22.8047 9.13379C22.8356 9.1646 22.8529 9.20688 22.8525 9.25098V9.80762C22.8525 9.90079 22.7759 10.0232 22.6387 10.2158L21.1641 12.3662C21.7114 12.3529 22.2906 12.4359 22.7881 12.7217C22.8798 12.7717 22.9384 12.8685 22.9414 12.9746V13.6699C22.9414 13.7654 22.8386 13.8765 22.7305 13.8193C21.7864 13.3239 20.666 13.3254 19.7236 13.8242C19.6247 13.8782 19.5205 13.7693 19.5205 13.6738V13.0127C19.5115 12.8568 19.549 12.7017 19.627 12.5674L21.3359 10.0615H19.8457C19.8023 10.0632 19.7597 10.0465 19.7285 10.0156C19.6975 9.98481 19.6803 9.9426 19.6807 9.89844V9.25098C19.6787 9.20684 19.6949 9.16392 19.7256 9.13281C19.7563 9.1017 19.7986 9.08551 19.8418 9.08789H22.6885ZM6.05176 11.6455C5.42552 11.6456 4.76465 11.7831 4.76465 12.5361C4.76479 12.9195 4.95825 13.1777 5.29004 13.1777C5.53384 13.1777 5.75263 13.0244 5.89062 12.7754C6.05294 12.4806 6.05206 12.2044 6.05176 11.8789V11.6455ZM17.4082 11.6416C16.7818 11.6416 16.1201 11.7783 16.1201 12.5322C16.1203 12.9146 16.314 13.1726 16.6455 13.1729C16.8884 13.1729 17.1079 13.0195 17.2451 12.7715C17.408 12.4752 17.4084 12.1977 17.4082 11.8682V11.6416ZM25.3105 9.93359C24.6723 9.93378 24.6319 10.8207 24.6318 11.375C24.6318 11.381 24.6318 11.3874 24.6318 11.3936C24.6318 11.9552 24.6316 13.1133 25.3027 13.1133C25.9807 13.1129 26.0058 12.1586 26.0059 11.5762C26.0059 11.1941 25.9904 10.7346 25.877 10.3721C25.7796 10.0591 25.5849 9.93359 25.3105 9.93359Z"
            fill="black"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconAmex(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Amex">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="#1F72CD" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="AMEX"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.68111 8.5L3.5 15.7467H7.30824L7.78035 14.5913H8.85949L9.3316 15.7467H13.5234V14.8649L13.8969 15.7467H16.0652L16.4387 14.8462V15.7467H25.1566L26.2166 14.6213L27.2092 15.7467L31.6868 15.7561L28.4957 12.1436L31.6868 8.5H27.2786L26.2467 9.60463L25.2854 8.5H15.8016L14.9872 10.3704L14.1537 8.5H10.3534V9.35186L9.93068 8.5H6.68111ZM19.6994 9.52905H24.7055L26.2367 11.2316L27.8172 9.52905H29.3484L27.0219 12.1426L29.3484 14.726H27.7477L26.2166 13.0036L24.628 14.726H19.6994V9.52905ZM20.9356 11.555V10.6057V10.6048H24.0593L25.4223 12.1229L23.9989 13.6493H20.9356V12.613H23.6667V11.555H20.9356ZM7.41799 9.52905H9.2743L11.3843 14.4431V9.52905H13.4178L15.0476 13.0524L16.5496 9.52905H18.573V14.7291H17.3418L17.3317 10.6544L15.5368 14.7291H14.4355L12.6305 10.6544V14.7291H10.0977L9.61756 13.5633H7.02338L6.54421 14.728H5.18717L7.41799 9.52905ZM7.46634 12.4856L8.32101 10.4089L9.1747 12.4856H7.46634Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export function IconApple(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Apple">
        <path
          id="Apple_2"
          d="M17.178 11.9129C17.178 12.0022 17.044 14.6359 19.9456 16.0198C19.4099 17.6714 17.5351 21.3319 15.3477 21.3319C14.0978 21.3319 13.3836 20.5284 11.9551 20.5284C10.482 20.5284 9.67851 21.3319 8.56252 21.3319C6.41982 21.4212 4.3664 17.4036 3.78609 15.7519C3.33969 14.502 3.16113 13.2967 3.16113 12.1361C3.16113 8.16319 5.79487 6.24369 8.29469 6.19905C9.49995 6.19905 11.0177 7.0472 11.6873 7.0472C12.3122 7.0472 14.0532 6.02049 15.6602 6.15441C17.3119 6.28833 18.5618 6.91328 19.4099 8.11855C17.9368 9.05598 17.178 10.2613 17.178 11.9129ZM14.6781 4.59203C13.7854 5.61874 12.714 6.19905 11.5534 6.10977C11.4641 4.9045 11.9105 3.78851 12.714 2.89572C13.4282 2.09221 14.6781 1.42262 15.7495 1.33334C15.7495 1.82437 15.8834 3.16356 14.6781 4.59203Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconAppleColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5022)">
        <path
          id="Vector"
          d="M21.792 18.7036C21.429 19.542 20.9994 20.3139 20.5016 21.0235C19.8231 21.9909 19.2676 22.6605 18.8395 23.0323C18.1758 23.6427 17.4647 23.9552 16.7032 23.973C16.1566 23.973 15.4973 23.8175 14.73 23.5019C13.9601 23.1879 13.2525 23.0323 12.6056 23.0323C11.9271 23.0323 11.1994 23.1879 10.4211 23.5019C9.64153 23.8175 9.01355 23.9819 8.53342 23.9982C7.80322 24.0293 7.07539 23.7078 6.3489 23.0323C5.88521 22.6279 5.30523 21.9346 4.61043 20.9524C3.86498 19.9035 3.25211 18.6873 2.77198 17.3006C2.25777 15.8029 2 14.3526 2 12.9485C2 11.3401 2.34754 9.95285 3.04367 8.79037C3.59076 7.85662 4.31859 7.12005 5.22953 6.57932C6.14046 6.0386 7.12473 5.76305 8.18469 5.74542C8.76467 5.74542 9.52524 5.92483 10.4704 6.27741C11.4129 6.63117 12.0181 6.81058 12.2834 6.81058C12.4817 6.81058 13.154 6.6008 14.2937 6.18259C15.3714 5.79475 16.281 5.63417 17.0262 5.69742C19.0454 5.86038 20.5624 6.65636 21.5712 8.09039C19.7654 9.18458 18.8721 10.7171 18.8898 12.6831C18.9061 14.2145 19.4617 15.4888 20.5535 16.5007C21.0483 16.9703 21.6009 17.3332 22.2156 17.591C22.0823 17.9776 21.9416 18.348 21.792 18.7036ZM17.161 0.480396C17.161 1.68067 16.7225 2.80136 15.8484 3.83866C14.7937 5.07181 13.5179 5.78438 12.1343 5.67194C12.1167 5.52795 12.1065 5.3764 12.1065 5.21714C12.1065 4.06488 12.6081 2.83173 13.4989 1.82347C13.9436 1.31296 14.5092 0.888487 15.1951 0.549875C15.8796 0.216314 16.5269 0.0318484 17.1358 0.000259399C17.1536 0.160717 17.161 0.321185 17.161 0.480381V0.480396Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5022">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconAppleColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_265)">
        <path
          id="Vector"
          d="M21.792 18.7036C21.429 19.5421 20.9994 20.3139 20.5016 21.0235C19.8231 21.9909 19.2676 22.6605 18.8395 23.0323C18.1758 23.6427 17.4647 23.9553 16.7032 23.973C16.1566 23.973 15.4973 23.8175 14.73 23.5019C13.9601 23.1879 13.2525 23.0323 12.6056 23.0323C11.9271 23.0323 11.1994 23.1879 10.4211 23.5019C9.64153 23.8175 9.01355 23.9819 8.53342 23.9982C7.80322 24.0293 7.07539 23.7079 6.3489 23.0323C5.88521 22.6279 5.30523 21.9346 4.61043 20.9524C3.86498 19.9035 3.25211 18.6873 2.77198 17.3006C2.25777 15.8029 2 14.3526 2 12.9485C2 11.3401 2.34754 9.95287 3.04367 8.79038C3.59076 7.85663 4.31859 7.12006 5.22953 6.57934C6.14046 6.03861 7.12473 5.76307 8.18469 5.74544C8.76467 5.74544 9.52524 5.92484 10.4704 6.27742C11.4129 6.63119 12.0181 6.81059 12.2834 6.81059C12.4817 6.81059 13.154 6.60082 14.2937 6.18261C15.3714 5.79477 16.281 5.63418 17.0262 5.69744C19.0454 5.8604 20.5624 6.65637 21.5712 8.0904C19.7654 9.18459 18.8721 10.7171 18.8898 12.6832C18.9061 14.2145 19.4617 15.4888 20.5535 16.5007C21.0483 16.9703 21.6009 17.3332 22.2156 17.591C22.0823 17.9777 21.9416 18.348 21.792 18.7036ZM17.161 0.480411C17.161 1.68069 16.7225 2.80138 15.8484 3.83868C14.7937 5.07183 13.5179 5.7844 12.1343 5.67196C12.1167 5.52796 12.1065 5.37641 12.1065 5.21716C12.1065 4.0649 12.6081 2.83175 13.4989 1.82348C13.9436 1.31298 14.5092 0.888503 15.1951 0.54989C15.8796 0.21633 16.5269 0.0318637 17.1358 0.000274658C17.1536 0.160733 17.161 0.321201 17.161 0.480396V0.480411Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_265">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconApplePay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ApplePay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="ApplePay_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.3462 8.93296C8.81624 8.97261 9.28628 8.69506 9.58006 8.34316C9.86894 7.98135 10.0599 7.49563 10.0109 7C9.59475 7.01983 9.08064 7.27755 8.78686 7.63936C8.51757 7.95161 8.28745 8.45715 8.3462 8.93296ZM13.9377 15.3167V7.58981H16.8021C18.2807 7.58981 19.3138 8.62072 19.3138 10.1274C19.3138 11.6342 18.2611 12.675 16.7629 12.675H15.1226V15.3167H13.9377ZM10.006 9.02714C9.5919 9.00301 9.21406 9.1532 8.90886 9.27451C8.71246 9.35257 8.54614 9.41868 8.41961 9.41868C8.27762 9.41868 8.10444 9.34904 7.90999 9.27085C7.65521 9.16839 7.36392 9.05125 7.05845 9.05687C6.35829 9.06679 5.70709 9.46825 5.34966 10.1076C4.61522 11.3863 5.1587 13.2796 5.86866 14.3205C6.2163 14.8359 6.63248 15.4009 7.18086 15.3811C7.42211 15.3719 7.59566 15.2974 7.77526 15.2202C7.98203 15.1314 8.19683 15.0391 8.53223 15.0391C8.85599 15.0391 9.0614 15.129 9.25858 15.2152C9.44606 15.2973 9.62611 15.376 9.89339 15.3712C10.4614 15.3613 10.8188 14.8557 11.1664 14.3403C11.5416 13.7871 11.7064 13.2471 11.7314 13.1652L11.7344 13.1557C11.7338 13.1551 11.7291 13.153 11.721 13.1492C11.5956 13.0911 10.637 12.6469 10.6278 11.4557C10.6186 10.4559 11.3881 9.94937 11.5093 9.86963L11.5093 9.86962C11.5166 9.86477 11.5216 9.8615 11.5238 9.85979C11.0342 9.12626 10.2704 9.04696 10.006 9.02714ZM21.478 15.3761C22.2223 15.3761 22.9126 14.9945 23.226 14.3898H23.2505V15.3166H24.3472V11.4706C24.3472 10.3554 23.4659 9.63672 22.1096 9.63672C20.8513 9.63672 19.921 10.3653 19.8867 11.3665H20.9541C21.0423 10.8907 21.478 10.5784 22.0754 10.5784C22.8 10.5784 23.2064 10.9204 23.2064 11.5499V11.9761L21.7277 12.0653C20.3519 12.1496 19.6077 12.7195 19.6077 13.7108C19.6077 14.712 20.3764 15.3761 21.478 15.3761ZM21.7962 14.4592C21.1646 14.4592 20.7631 14.1519 20.7631 13.6811C20.7631 13.1954 21.1499 12.9129 21.8893 12.8683L23.2063 12.784V13.2202C23.2063 13.9438 22.5992 14.4592 21.7962 14.4592ZM27.9851 15.619C27.5102 16.9721 26.9667 17.4181 25.8112 17.4181C25.7231 17.4181 25.4293 17.4082 25.3607 17.3884V16.4616C25.4342 16.4715 25.6153 16.4814 25.7084 16.4814C26.2323 16.4814 26.526 16.2584 26.7072 15.6785L26.8149 15.3365L24.8075 9.71108H26.0462L27.4416 14.2758H27.4661L28.8616 9.71108H30.066L27.9851 15.619ZM15.1225 8.60087H16.4886C17.5168 8.60087 18.1044 9.15598 18.1044 10.1324C18.1044 11.1088 17.5168 11.6688 16.4837 11.6688H15.1225V8.60087Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export function IconBancontact(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Bancontact">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Bancontact_2">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.11213 17.5857C9.11213 17.441 9.07801 17.3157 9.00994 17.2099C8.94178 17.1041 8.85214 17.0234 8.74093 16.9677C8.85214 16.9121 8.93831 16.8298 8.99954 16.7213C9.06069 16.6127 9.09126 16.4903 9.09126 16.3539V16.2787C9.09126 16.1116 9.0593 15.9725 8.99539 15.8611C8.93138 15.7498 8.84166 15.6606 8.72629 15.5939C8.61093 15.527 8.47253 15.4791 8.31135 15.4497C8.15 15.4205 7.97072 15.406 7.77325 15.406C7.70657 15.406 7.63702 15.4073 7.56479 15.4101C7.49238 15.4129 7.42223 15.4164 7.35416 15.4205C7.28599 15.4247 7.22338 15.4296 7.16647 15.4352C7.1094 15.4408 7.0628 15.4464 7.02669 15.4518C6.94606 15.4659 6.88907 15.4909 6.85572 15.527C6.82238 15.5633 6.80566 15.6287 6.80566 15.7233V18.2622C6.80566 18.3569 6.82299 18.4223 6.8578 18.4585C6.89253 18.4947 6.9516 18.5197 7.03509 18.5336C7.07675 18.542 7.12681 18.5489 7.18518 18.5545C7.24356 18.5601 7.30678 18.5649 7.37494 18.5691C7.4431 18.5733 7.51326 18.5767 7.58557 18.5796C7.65789 18.5823 7.72874 18.5838 7.79828 18.5838C7.97904 18.5838 8.14931 18.5698 8.30927 18.542C8.46907 18.5142 8.60807 18.4647 8.72629 18.3937C8.84451 18.3228 8.93831 18.2267 9.00786 18.1056C9.07732 17.9845 9.11213 17.8321 9.11213 17.6483V17.5857ZM8.40314 16.3871C8.40314 16.4317 8.39621 16.4742 8.38226 16.5145C8.36832 16.5548 8.34546 16.5896 8.3135 16.619C8.28145 16.6481 8.23841 16.6718 8.18419 16.6898C8.12997 16.708 8.06112 16.717 7.97772 16.717H7.51064V15.9946C7.5245 15.9946 7.54606 15.994 7.57525 15.9925C7.60444 15.9911 7.63501 15.9904 7.66697 15.9904H7.82754C8.04163 15.9904 8.19112 16.0176 8.27591 16.0719C8.3607 16.1261 8.40314 16.2103 8.40314 16.3244V16.3871ZM8.29678 17.9031C8.3788 17.8391 8.41985 17.7485 8.41985 17.6316V17.5857C8.41985 17.4854 8.38781 17.3985 8.32389 17.3247C8.25989 17.251 8.14453 17.214 7.97772 17.214H7.51064V17.9949H7.58356C7.61552 17.9949 7.64887 17.9957 7.68368 17.997C7.71841 17.9984 7.75176 17.9992 7.7838 17.9992H7.85257C8.06666 17.9992 8.21477 17.9671 8.29678 17.9031ZM11.3978 16.9718C11.3978 16.8188 11.3748 16.6885 11.3289 16.5814C11.2831 16.4743 11.2184 16.3865 11.135 16.3183C11.0516 16.2501 10.9494 16.2001 10.8284 16.168C10.7075 16.136 10.5719 16.12 10.4218 16.12C10.2827 16.12 10.1471 16.1298 10.0151 16.1493C9.88298 16.1687 9.77801 16.1882 9.70024 16.2076C9.6474 16.2217 9.62099 16.2522 9.62099 16.2995V16.6377C9.62099 16.6656 9.62792 16.6852 9.64186 16.6962C9.65572 16.7073 9.67373 16.713 9.69608 16.713H9.71686L9.84201 16.7025C9.89207 16.6983 9.94837 16.6949 10.011 16.692C10.0735 16.6893 10.1388 16.6872 10.207 16.6858C10.2751 16.6844 10.3425 16.6837 10.4093 16.6837C10.5066 16.6837 10.583 16.7018 10.6386 16.738C10.6942 16.7742 10.722 16.8522 10.722 16.9718V17.1222H10.4969C10.1381 17.1222 9.87744 17.1785 9.71479 17.2913C9.55214 17.404 9.47081 17.5829 9.47081 17.8278V17.8656C9.47081 18.0019 9.49099 18.116 9.53126 18.2078C9.57154 18.2997 9.62515 18.3735 9.69183 18.4293C9.75861 18.4848 9.83431 18.5246 9.91918 18.5481C10.004 18.5718 10.0923 18.5837 10.184 18.5837C10.3092 18.5837 10.4169 18.567 10.5073 18.5336C10.5976 18.5002 10.6831 18.4542 10.7638 18.3958V18.4626C10.7638 18.4848 10.7721 18.5044 10.7888 18.521C10.8055 18.5377 10.8249 18.5461 10.8472 18.5461H11.3144C11.3365 18.5461 11.356 18.5377 11.3727 18.521C11.3894 18.5044 11.3978 18.4848 11.3978 18.4626V16.9718ZM10.574 18.047C10.6309 18.029 10.6846 18.0074 10.7346 17.9823V17.523H10.4969C10.4246 17.523 10.3648 17.5293 10.3175 17.5418C10.2702 17.5543 10.2326 17.5732 10.2049 17.5982C10.1771 17.6232 10.1576 17.6553 10.1465 17.6942C10.1354 17.7332 10.1298 17.7777 10.1298 17.8278V17.8655C10.1298 17.9545 10.1513 18.0116 10.1944 18.0366C10.2376 18.0617 10.3036 18.0742 10.3926 18.0742C10.4565 18.0742 10.517 18.0652 10.574 18.047ZM13.9503 18.4584V17.0678C13.9503 16.9371 13.9399 16.8138 13.9191 16.6983C13.8982 16.5829 13.8607 16.4826 13.8065 16.3976C13.7523 16.3127 13.6772 16.2452 13.5812 16.1951C13.4853 16.145 13.3623 16.12 13.2121 16.12C13.0786 16.12 12.9604 16.1361 12.8576 16.1683C12.7547 16.2006 12.6463 16.2574 12.5323 16.3387V16.2375C12.5323 16.2152 12.5239 16.1955 12.5073 16.1787C12.4905 16.1618 12.4711 16.1533 12.4488 16.1533H11.9817C11.9594 16.1533 11.94 16.1617 11.9233 16.1784C11.9066 16.1951 11.8983 16.2147 11.8983 16.2369V18.4584C11.8983 18.4807 11.9072 18.5009 11.9254 18.5189C11.9434 18.5371 11.9636 18.5461 11.9859 18.5461H12.4905C12.5128 18.5461 12.5323 18.5371 12.5489 18.519C12.5656 18.501 12.5739 18.4809 12.5739 18.4586V16.817C12.6463 16.7781 12.7143 16.7462 12.7783 16.7212C12.8423 16.6962 12.9048 16.6837 12.966 16.6837C13.0299 16.6837 13.0821 16.6899 13.1224 16.7025C13.1627 16.715 13.194 16.7365 13.2162 16.7672C13.2385 16.7976 13.2538 16.8378 13.2621 16.8878C13.2704 16.9378 13.2747 16.999 13.2747 17.0712V18.4586C13.2747 18.4809 13.283 18.501 13.2997 18.519C13.3164 18.5371 13.3358 18.5461 13.3581 18.5461H13.8628C13.8849 18.5461 13.9051 18.5371 13.9232 18.5189C13.9413 18.5009 13.9503 18.4807 13.9503 18.4584ZM16.0023 18.0535V18.425C16.0023 18.4556 15.9953 18.4772 15.9815 18.4897C15.9675 18.5023 15.9453 18.5127 15.9147 18.521C15.8563 18.535 15.7805 18.5488 15.6874 18.5629C15.5942 18.5767 15.4851 18.5837 15.36 18.5837C15.0652 18.5837 14.8296 18.4933 14.6531 18.3122C14.4765 18.1313 14.3882 17.8696 14.3882 17.5272V17.1765C14.3882 16.834 14.4765 16.5723 14.6531 16.3915C14.8296 16.2104 15.0652 16.12 15.36 16.12C15.4851 16.12 15.5942 16.1269 15.6874 16.1408C15.7805 16.1548 15.8563 16.1687 15.9147 16.1826C15.9453 16.1909 15.9675 16.2014 15.9815 16.2139C15.9953 16.2264 16.0023 16.248 16.0023 16.2786V16.6503C16.0023 16.6726 15.9946 16.6899 15.9794 16.7025C15.9641 16.715 15.9453 16.7212 15.9231 16.7212H15.9147C15.8368 16.713 15.7625 16.706 15.6916 16.7004C15.6207 16.6949 15.5254 16.692 15.4059 16.692C15.3586 16.692 15.3141 16.6997 15.2724 16.715C15.2307 16.7303 15.1945 16.7568 15.164 16.7943C15.1333 16.832 15.1091 16.882 15.091 16.9447C15.0729 17.0073 15.0638 17.0845 15.0638 17.1765V17.5272C15.0638 17.619 15.0729 17.6963 15.091 17.759C15.1091 17.8216 15.1333 17.8717 15.164 17.9093C15.1945 17.9469 15.2307 17.9733 15.2724 17.9886C15.3141 18.0039 15.3586 18.0116 15.4059 18.0116C15.5254 18.0116 15.6207 18.0088 15.6916 18.0033C15.7625 17.9977 15.8368 17.9907 15.9147 17.9824H15.9231C15.9453 17.9824 15.9641 17.9886 15.9794 18.0012C15.9946 18.0137 16.0023 18.0311 16.0023 18.0535ZM18.3173 17.2057C18.3173 17.0386 18.2943 16.8883 18.2483 16.7547C18.2023 16.6211 18.1354 16.5077 18.0477 16.4144C17.96 16.3211 17.8513 16.2487 17.7218 16.1972C17.5922 16.1458 17.4424 16.12 17.2725 16.12C17.1026 16.12 16.9528 16.1458 16.8232 16.1972C16.6937 16.2487 16.5843 16.3211 16.4952 16.4144C16.406 16.5077 16.3384 16.6211 16.2925 16.7547C16.2464 16.8883 16.2235 17.0386 16.2235 17.2057V17.498C16.2235 17.665 16.2464 17.8153 16.2925 17.949C16.3384 18.0826 16.406 18.196 16.4952 18.2893C16.5843 18.3826 16.6937 18.4549 16.8232 18.5064C16.9528 18.5579 17.1026 18.5837 17.2725 18.5837C17.4424 18.5837 17.5922 18.5579 17.7218 18.5064C17.8513 18.4549 17.96 18.3826 18.0477 18.2893C18.1354 18.196 18.2023 18.0826 18.2483 17.949C18.2943 17.8153 18.3173 17.665 18.3173 17.498V17.2057ZM17.2725 18.0116C17.5185 18.0116 17.6416 17.8404 17.6416 17.498V17.2057C17.6416 16.866 17.5185 16.6962 17.2725 16.6962C17.1508 16.6962 17.0582 16.7387 16.9946 16.8236C16.931 16.9085 16.8992 17.0359 16.8992 17.2057V17.498C16.8992 17.6678 16.931 17.7958 16.9946 17.8821C17.0582 17.9685 17.1508 18.0116 17.2725 18.0116ZM20.7988 18.4584V17.0678C20.7988 16.9371 20.7882 16.8138 20.7675 16.6983C20.7466 16.5829 20.7091 16.4826 20.6548 16.3976C20.6005 16.3127 20.5255 16.2452 20.4297 16.1951C20.3337 16.145 20.2106 16.12 20.0605 16.12C19.9271 16.12 19.8089 16.1361 19.706 16.1683C19.6031 16.2006 19.4946 16.2574 19.3807 16.3387V16.2375C19.3807 16.2152 19.3723 16.1955 19.3555 16.1787C19.339 16.1618 19.3194 16.1533 19.2973 16.1533H18.8301C18.8078 16.1533 18.7884 16.1617 18.7717 16.1784C18.7551 16.1951 18.7467 16.2147 18.7467 16.2369V18.4584C18.7467 18.4807 18.7557 18.5009 18.7738 18.5189C18.7919 18.5371 18.812 18.5461 18.8343 18.5461H19.339C19.3612 18.5461 19.3807 18.5371 19.3974 18.519C19.414 18.501 19.4224 18.4809 19.4224 18.4586V16.817C19.4946 16.7781 19.5628 16.7462 19.6267 16.7212C19.6907 16.6962 19.7532 16.6837 19.8145 16.6837C19.8784 16.6837 19.9305 16.6899 19.9708 16.7025C20.0111 16.715 20.0424 16.7365 20.0647 16.7672C20.087 16.7976 20.1022 16.8378 20.1106 16.8878C20.1189 16.9378 20.1231 16.999 20.1231 17.0712V18.4586C20.1231 18.4809 20.1314 18.501 20.1481 18.519C20.1648 18.5371 20.1842 18.5461 20.2065 18.5461H20.7111C20.7334 18.5461 20.7536 18.5371 20.7717 18.5189C20.7897 18.5009 20.7988 18.4807 20.7988 18.4584ZM22.6174 18.1447V18.4679C22.6174 18.5148 22.591 18.5424 22.5382 18.5506C22.4742 18.5617 22.4186 18.5699 22.3714 18.5755C22.3241 18.581 22.2698 18.5838 22.2087 18.5838C22.0952 18.5838 21.995 18.5747 21.908 18.5567C21.821 18.5385 21.7483 18.5031 21.6903 18.4502C21.6323 18.3973 21.5881 18.3242 21.5577 18.2309C21.5274 18.1377 21.5121 18.0174 21.5121 17.8697V16.6588L21.1785 16.6044C21.1561 16.5989 21.1361 16.5885 21.118 16.5731C21.0999 16.5579 21.0908 16.539 21.0908 16.5168V16.2411C21.0908 16.2189 21.0999 16.1987 21.118 16.1806C21.1361 16.1625 21.1561 16.1534 21.1785 16.1534H21.5121V15.811C21.5121 15.7887 21.5204 15.7707 21.537 15.7567C21.5534 15.7429 21.5729 15.7332 21.5951 15.7275L22.1008 15.6399H22.1132C22.1353 15.6399 22.1533 15.6461 22.1671 15.6586C22.1809 15.6712 22.1878 15.6886 22.1878 15.7108V16.1534H22.5298C22.552 16.1534 22.5715 16.1619 22.5882 16.1787C22.6049 16.1955 22.6132 16.2153 22.6132 16.2376V16.5787C22.6132 16.6012 22.6049 16.6208 22.5882 16.6376C22.5715 16.6545 22.552 16.6629 22.5298 16.6629H22.1878V17.878C22.1878 17.9616 22.1948 18.0152 22.2087 18.0388C22.2226 18.0625 22.2614 18.0743 22.3254 18.0743H22.5298C22.5882 18.0743 22.6174 18.0978 22.6174 18.1447ZM24.8445 16.9718C24.8445 16.8188 24.8217 16.6885 24.7757 16.5814C24.7299 16.4743 24.6653 16.3865 24.5819 16.3183C24.4984 16.2501 24.3962 16.2001 24.2753 16.168C24.1544 16.136 24.0188 16.12 23.8686 16.12C23.7295 16.12 23.594 16.1298 23.462 16.1493C23.3298 16.1687 23.2249 16.1882 23.1471 16.2076C23.0941 16.2217 23.0679 16.2522 23.0679 16.2995V16.6377C23.0679 16.6656 23.0747 16.6852 23.0886 16.6962C23.1026 16.7073 23.1206 16.713 23.1429 16.713H23.1637L23.2889 16.7025C23.3389 16.6983 23.3952 16.6949 23.4578 16.692C23.5204 16.6893 23.5857 16.6872 23.6538 16.6858C23.7219 16.6844 23.7894 16.6837 23.8561 16.6837C23.9534 16.6837 24.0299 16.7018 24.0855 16.738C24.1411 16.7742 24.1689 16.8522 24.1689 16.9718V17.1222H23.9437C23.5849 17.1222 23.3243 17.1785 23.1616 17.2913C22.999 17.404 22.9177 17.5829 22.9177 17.8278V17.8656C22.9177 18.0019 22.9378 18.116 22.9781 18.2078C23.0183 18.2997 23.072 18.3735 23.1387 18.4293C23.2055 18.4848 23.2812 18.5246 23.366 18.5481C23.4508 18.5718 23.5391 18.5837 23.6309 18.5837C23.756 18.5837 23.8637 18.567 23.9541 18.5336C24.0444 18.5002 24.1298 18.4542 24.2106 18.3958V18.4626C24.2106 18.4848 24.219 18.5044 24.2357 18.521C24.2523 18.5377 24.2718 18.5461 24.2941 18.5461H24.7612C24.7834 18.5461 24.8029 18.5377 24.8196 18.521C24.8362 18.5044 24.8445 18.4848 24.8445 18.4626V16.9718ZM24.0209 18.047C24.0778 18.029 24.1314 18.0074 24.1815 17.9823V17.523H23.9437C23.8714 17.523 23.8117 17.5293 23.7644 17.5418C23.7171 17.5543 23.6795 17.5732 23.6518 17.5982C23.6239 17.6232 23.6044 17.6553 23.5934 17.6942C23.5822 17.7332 23.5767 17.7777 23.5767 17.8278V17.8655C23.5767 17.9545 23.5982 18.0116 23.6413 18.0366C23.6844 18.0617 23.7504 18.0742 23.8395 18.0742C23.9034 18.0742 23.9637 18.0652 24.0209 18.047ZM26.8966 18.425V18.0535C26.8966 18.0311 26.8889 18.0137 26.8737 18.0012C26.8584 17.9886 26.8397 17.9824 26.8174 17.9824H26.8091C26.7312 17.9907 26.6568 17.9977 26.5859 18.0033C26.5151 18.0088 26.4198 18.0116 26.3003 18.0116C26.2529 18.0116 26.2084 18.0039 26.1668 17.9886C26.1251 17.9733 26.0889 17.9469 26.0583 17.9093C26.0277 17.8717 26.0034 17.8216 25.9854 17.759C25.9672 17.6963 25.9582 17.619 25.9582 17.5272V17.1765C25.9582 17.0845 25.9672 17.0073 25.9854 16.9447C26.0034 16.882 26.0277 16.832 26.0583 16.7943C26.0889 16.7568 26.1251 16.7303 26.1668 16.715C26.2084 16.6997 26.2529 16.692 26.3003 16.692C26.4198 16.692 26.5151 16.6949 26.5859 16.7004C26.6568 16.706 26.7312 16.713 26.8091 16.7212H26.8174C26.8397 16.7212 26.8584 16.715 26.8737 16.7025C26.8889 16.6899 26.8966 16.6726 26.8966 16.6503V16.2786C26.8966 16.248 26.8897 16.2264 26.8758 16.2139C26.8617 16.2014 26.8397 16.1909 26.8091 16.1826C26.7507 16.1687 26.6748 16.1548 26.5817 16.1408C26.4886 16.1269 26.3795 16.12 26.2544 16.12C25.9595 16.12 25.724 16.2104 25.5474 16.3915C25.3708 16.5723 25.2825 16.834 25.2825 17.1765V17.5272C25.2825 17.8696 25.3708 18.1313 25.5474 18.3122C25.724 18.4933 25.9595 18.5837 26.2544 18.5837C26.3795 18.5837 26.4886 18.5767 26.5817 18.5629C26.6748 18.5488 26.7507 18.535 26.8091 18.521C26.8397 18.5127 26.8617 18.5023 26.8758 18.4897C26.8897 18.4772 26.8966 18.4556 26.8966 18.425ZM28.6942 18.1447V18.4679C28.6942 18.5148 28.6677 18.5424 28.615 18.5506C28.551 18.5617 28.4954 18.5699 28.4482 18.5755C28.4008 18.581 28.3466 18.5838 28.2855 18.5838C28.1721 18.5838 28.0718 18.5747 27.9848 18.5567C27.8977 18.5385 27.8251 18.5031 27.7672 18.4502C27.7091 18.3973 27.6649 18.3242 27.6345 18.2309C27.6042 18.1377 27.5889 18.0174 27.5889 17.8697V16.6588L27.2553 16.6044C27.233 16.5989 27.2129 16.5885 27.1948 16.5731C27.1767 16.5579 27.1677 16.539 27.1677 16.5168V16.2411C27.1677 16.2189 27.1767 16.1987 27.1948 16.1806C27.2129 16.1625 27.233 16.1534 27.2553 16.1534H27.5889V15.811C27.5889 15.7887 27.5972 15.7707 27.6138 15.7567C27.6302 15.7429 27.6496 15.7332 27.6718 15.7275L28.1775 15.6399H28.19C28.2121 15.6399 28.2301 15.6461 28.2438 15.6586C28.2577 15.6712 28.2646 15.6886 28.2646 15.7108V16.1534H28.6067C28.6288 16.1534 28.6483 16.1619 28.665 16.1787C28.6817 16.1955 28.6901 16.2153 28.6901 16.2376V16.5787C28.6901 16.6012 28.6817 16.6208 28.665 16.6376C28.6483 16.6545 28.6288 16.6629 28.6067 16.6629H28.2646V17.878C28.2646 17.9616 28.2716 18.0152 28.2855 18.0388C28.2994 18.0625 28.3383 18.0743 28.4023 18.0743H28.6067C28.665 18.0743 28.6942 18.0978 28.6942 18.1447Z"
            fill="#005697"
          />
          <path
            id="Path"
            d="M26.3094 7.36993H19.5332L18.8441 8.14678L16.6077 10.6675V10.6676L15.9186 11.4443H9.232L9.91049 10.6577L10.2316 10.2853L10.9101 9.4987H7.82912C7.26625 9.4987 6.80566 9.97154 6.80566 10.5494V12.7663C6.80566 13.3443 7.26625 13.8171 7.82912 13.8171H19.6246C20.1874 13.8171 20.9564 13.4659 21.3333 13.0367L23.1175 11.0049L26.3094 7.36993Z"
            fill="#005697"
          />
          <path
            id="Path_2"
            d="M27.6709 5C28.2337 5 28.6943 5.47284 28.6943 6.05077V8.26764C28.6943 8.84548 28.2337 9.31841 27.6709 9.31841H24.5999L25.2848 8.53766H25.2849L25.6245 8.15058L26.3094 7.36991H19.5333L15.9187 11.4473H9.19061L14.0157 5.98504L14.1982 5.77832C14.5764 5.35023 15.3464 5 15.9093 5H27.6709V5Z"
            fill="#FBD500"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconBehanceColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5192)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.92188 0H19.0781C20.3824 0.00360791 21.6322 0.52332 22.5544 1.44557C23.4767 2.36782 23.9964 3.61762 24 4.92188V19.0781C23.9964 20.3824 23.4767 21.6322 22.5544 22.5544C21.6322 23.4767 20.3824 23.9964 19.0781 24H4.92188C3.61762 23.9964 2.36782 23.4767 1.44557 22.5544C0.52332 21.6322 0.00360791 20.3824 0 19.0781L0 4.92188C0.00360791 3.61762 0.52332 2.36782 1.44557 1.44557C2.36782 0.52332 3.61762 0.00360791 4.92188 0Z"
          fill="#1769FF"
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6973 14.5273C14.9574 14.7345 15.2753 14.8558 15.6073 14.8747C15.9392 14.8936 16.2689 14.8091 16.5508 14.6328C16.7448 14.5139 16.8939 14.3339 16.9746 14.1211H18.3711C18.1465 14.8164 17.8066 15.3105 17.3418 15.6094C16.8407 15.9202 16.2594 16.0771 15.6699 16.0606C15.249 16.066 14.8308 15.9918 14.4375 15.8418C14.0857 15.7046 13.7678 15.4927 13.5059 15.2207C13.2488 14.9424 13.0496 14.6157 12.9199 14.2598C12.7788 13.8644 12.7087 13.4471 12.7129 13.0273C12.7099 12.6154 12.782 12.2064 12.9258 11.8203C13.0584 11.4567 13.2645 11.1242 13.5312 10.8438C13.798 10.5695 14.1167 10.351 14.4688 10.2012C14.8499 10.0402 15.2601 9.95974 15.6738 9.96485C16.1186 9.95395 16.5593 10.0525 16.957 10.252C17.3125 10.4338 17.6213 10.6951 17.8594 11.0156C18.0973 11.3482 18.2673 11.7246 18.3594 12.123C18.4639 12.5436 18.5014 12.9779 18.4707 13.4102H14.3047C14.2884 13.818 14.4281 14.2168 14.6953 14.5254L14.6973 14.5273ZM9.27539 7.9375C9.62503 7.93399 9.97404 7.96804 10.3164 8.03907C10.6037 8.09537 10.8771 8.20751 11.1211 8.36914C11.3465 8.5248 11.527 8.73696 11.6445 8.98438C11.7744 9.2787 11.8364 9.59841 11.8262 9.91992C11.8388 10.2751 11.7435 10.6259 11.5527 10.9258C11.3445 11.2106 11.0649 11.4356 10.7422 11.5781C11.1849 11.6866 11.5742 11.9499 11.8398 12.3203C12.0509 12.6681 12.1726 13.0627 12.194 13.4689C12.2155 13.8751 12.1361 14.2804 11.9629 14.6484C11.8118 14.9358 11.5941 15.1829 11.3281 15.3691C11.0532 15.5598 10.7462 15.6994 10.4219 15.7813C10.0814 15.8706 9.73089 15.9159 9.37891 15.916H5.51562V7.93946H9.27539V7.9375ZM9.14453 14.5547C9.30933 14.5561 9.47376 14.5391 9.63477 14.5039C9.78203 14.4751 9.92211 14.4174 10.0469 14.334C10.1685 14.2545 10.2674 14.1448 10.334 14.0156C10.4092 13.8545 10.4447 13.6777 10.4375 13.5C10.4375 13.0898 10.3203 12.7949 10.0898 12.6172C9.82343 12.4325 9.50343 12.3412 9.17969 12.3574H7.26953V14.5527H9.14453V14.5547ZM9.04688 11.1582C9.3247 11.172 9.59931 11.0937 9.82812 10.9356C9.93336 10.8484 10.0156 10.7368 10.0677 10.6104C10.1198 10.4841 10.1402 10.3469 10.127 10.2109C10.1326 10.052 10.0984 9.89422 10.0273 9.75196C9.96367 9.6366 9.86983 9.54073 9.75586 9.47461C9.63621 9.40241 9.50345 9.35462 9.36523 9.33399C9.21638 9.30701 9.06534 9.29393 8.91406 9.29492H7.27344V11.1582H9.05078H9.04688ZM13.9785 8.58203H17.2129V9.36328H13.9785V8.58203ZM16.5176 11.4941C16.3987 11.3822 16.2582 11.2959 16.1047 11.2405C15.9512 11.185 15.7879 11.1617 15.625 11.1719C15.4075 11.164 15.1912 11.2082 14.9941 11.3008C14.8392 11.3785 14.7022 11.4876 14.5918 11.6211C14.494 11.7404 14.4222 11.8787 14.3809 12.0273C14.3418 12.1544 14.3169 12.2854 14.3066 12.418H16.8867C16.8673 12.0814 16.7384 11.7604 16.5195 11.5039L16.5176 11.4941Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5192">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBehanceColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_263)">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M22 7H15V5H22V7ZM23.726 17C23.284 18.297 21.697 20 18.625 20C15.551 20 13.061 18.271 13.061 14.325C13.061 10.415 15.386 8.405 18.527 8.405C21.609 8.405 23.491 10.187 23.902 12.831C23.98 13.337 24.011 14.019 23.997 14.971H15.97C16.1 18.182 19.453 18.283 20.558 17H23.726ZM16.04 13H21.005C20.9 11.453 19.869 10.781 18.528 10.781C17.062 10.781 16.251 11.549 16.04 13ZM6.466 19.988H0V5.021H6.953C12.429 5.102 12.533 10.465 9.673 11.927C13.134 13.187 13.25 19.988 6.466 19.988ZM3 11H6.584C9.092 11 9.49 8 6.272 8H3V11ZM6.391 14H3V17.016H6.341C9.396 17.016 9.209 14 6.391 14Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_633_263">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBitcoin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Bitcoin">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Bitcoin_2"
          d="M17.563 4C22.0166 4.00014 25.6265 7.61065 25.6265 12.0645C25.6265 16.5183 22.0167 20.1288 17.563 20.1289C13.1093 20.1289 9.4986 16.5184 9.4986 12.0645C9.49867 7.61057 13.1094 4 17.563 4ZM17.0132 8.4502L15.2213 8.00781L14.9849 8.95312C14.9849 8.95312 15.6401 9.1029 15.6304 9.11328C15.9901 9.20302 16.0556 9.43991 16.0445 9.62793L15.0474 13.6123C15.0033 13.7207 14.8905 13.8842 14.6392 13.8223C14.6121 13.8244 13.9937 13.6611 13.9937 13.6611L13.5523 14.6748L15.3414 15.125L14.9742 16.5957L15.8619 16.8164L16.2261 15.3613C16.4684 15.4263 16.704 15.487 16.9341 15.5439L16.5709 16.9922L17.4595 17.2129L17.8277 15.7451C19.3431 16.0305 20.483 15.9157 20.9625 14.5508C21.2149 13.6021 20.9431 12.8168 20.1461 12.4033C20.7268 12.2702 21.1637 11.8899 21.2808 11.1045C21.4418 10.031 20.6213 9.45359 19.4996 9.06836L19.8638 7.61426L18.9752 7.39258L18.6207 8.80957C18.3875 8.75164 18.1475 8.69648 17.9088 8.64258L18.2652 7.2168L17.3775 6.99609L17.0132 8.4502ZM17.0035 12.3477C17.6062 12.4974 19.5372 12.7942 19.2505 13.9404C18.9751 15.0388 17.1175 14.4451 16.5152 14.2959L17.0035 12.3477ZM17.6685 9.68848C18.1702 9.81352 19.7857 10.0461 19.525 11.0889C19.2737 12.0871 17.7277 11.5801 17.2261 11.4561L17.6685 9.68848Z"
          fill="#F7931A"
        />
      </g>
    </svg>
  )
}

export function IconBitcoinCash(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="BitcoinCash">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="BitcoinCash_2"
          d="M13.5986 5.04159C17.477 2.85242 22.3954 4.22204 24.5849 8.10052C26.7743 11.9791 25.4055 16.8977 21.5273 19.0872C17.6488 21.2765 12.7296 19.9073 10.5401 16.0287C8.35075 12.1501 9.72018 7.23094 13.5986 5.04159ZM15.3074 9.18723L13.5294 9.6829L13.7883 10.6223C13.7883 10.6223 14.4325 10.4306 14.4292 10.4444C14.7865 10.3458 14.96 10.5199 15.0428 10.6891L16.1331 14.6489C16.148 14.765 16.1302 14.9628 15.8809 15.0324C15.8578 15.0478 15.2395 15.2094 15.2395 15.2094L15.3534 16.3092L17.1327 15.8217L17.5359 17.283L18.4175 17.0388L18.0194 15.5926C18.2623 15.5301 18.4973 15.4671 18.7257 15.4036L19.1213 16.8433L20.0036 16.5987L19.6027 15.1395C21.0627 14.6431 21.9989 13.9829 21.7455 12.5585C21.4989 11.6082 20.8763 11.058 19.9789 11.0897C20.4192 10.6882 20.6128 10.1424 20.3286 9.40082C19.941 8.38685 18.9427 8.28735 17.7765 8.50332L17.3789 7.05798L16.496 7.30179L16.8839 8.71001C16.6524 8.77418 16.4162 8.84415 16.1818 8.91455L15.7914 7.49771L14.9098 7.74189L15.3074 9.18723ZM17.2148 12.5861C17.8133 12.4202 19.6408 11.7294 19.9546 12.8685C20.2547 13.9604 18.3452 14.3566 17.7474 14.5227L17.2148 12.5861ZM16.4868 9.94345C16.9851 9.80574 18.5063 9.21416 18.7918 10.2504C19.0639 11.2432 17.4681 11.5616 16.9704 11.7002L16.4868 9.94345Z"
          fill="#8FC258"
        />
      </g>
    </svg>
  )
}

export function IconBitpay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Bitpay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Bitpay_2"
          d="M27.8564 11.0842L27.4385 12.8508C27.4005 12.9981 27.3767 13.1359 27.3672 13.2639C27.3577 13.3919 27.3739 13.5023 27.415 13.5949C27.4562 13.6876 27.5268 13.7596 27.6279 13.8107C27.7291 13.862 27.8686 13.8879 28.0459 13.8879C28.1978 13.8879 28.345 13.8737 28.4873 13.8449C28.5631 13.8296 28.6392 13.8091 28.7158 13.7873L28.8262 13.3195H28.8252L29.625 9.9162H31L30.8193 10.6867C30.8203 10.6871 30.8212 10.6882 30.8223 10.6887L29.8711 14.7346C29.7787 15.1394 29.6566 15.4895 29.5059 15.7853C29.3549 16.081 29.1671 16.3274 28.9424 16.5236C28.7175 16.7199 28.4479 16.8665 28.1338 16.9631C27.8197 17.0596 27.453 17.1076 27.0342 17.1076C26.81 17.1076 26.6069 17.0955 26.4238 17.0715L26.6943 15.9191C26.8329 15.9385 26.986 15.9494 27.1543 15.9494C27.5483 15.9494 27.8456 15.8603 28.0459 15.6828C28.246 15.5053 28.371 15.2776 28.4326 14.9973V14.9953C28.424 14.9975 28.4151 14.9991 28.4062 15.0012C28.1849 15.0523 27.9226 15.0783 27.6191 15.0783C27.1825 15.0783 26.8429 15.0121 26.6025 14.881C26.3623 14.75 26.1919 14.5709 26.0908 14.3439C25.9896 14.117 25.9443 13.856 25.957 13.5617C25.9696 13.2674 26.0149 12.9565 26.0908 12.6301L26.7266 9.91327H28.1309L27.8564 11.0842ZM18.5713 9.9162C18.9189 9.9162 19.2193 9.96965 19.4707 10.0764C19.722 10.1832 19.9284 10.3288 20.0898 10.5139C20.2512 10.6992 20.3705 10.9163 20.4482 11.1642C20.5257 11.4124 20.5645 11.6777 20.5645 11.9601C20.5644 12.4186 20.4898 12.8382 20.3408 13.218C20.1919 13.5977 19.9853 13.9253 19.7217 14.2014C19.4576 14.4778 19.1408 14.693 18.7715 14.8469C18.4021 15.0006 18 15.0773 17.5654 15.0773C17.3545 15.0773 17.1434 15.0593 16.9326 15.0217L16.5127 16.7258H15.1348L16.7344 9.9162C16.9671 9.91606 18.1984 9.9162 18.5713 9.9162ZM10.9424 15.0793H9.56641L10.7812 9.91327H12.1562L10.9424 15.0793ZM14.374 9.91425H15.9502L15.665 11.0851H14.0986L13.6816 12.8517C13.6437 12.9991 13.6199 13.1369 13.6104 13.2648C13.6009 13.3928 13.616 13.5032 13.6572 13.5959C13.6983 13.6887 13.7698 13.7606 13.8711 13.8117C13.9722 13.863 14.1118 13.8889 14.2891 13.8889C14.4409 13.8888 14.5882 13.8747 14.7305 13.8459C14.8235 13.8271 14.9205 13.8048 15.0166 13.7717L14.7295 14.9826C14.707 14.9881 14.6723 14.9968 14.6494 15.0021C14.4278 15.0533 14.165 15.0793 13.8613 15.0793C13.4248 15.0793 13.086 15.0131 12.8457 14.882C12.6053 14.7509 12.4341 14.5721 12.333 14.3449C12.2317 14.1179 12.1874 13.857 12.2002 13.5627C12.2128 13.2684 12.2571 12.9574 12.333 12.631L13.2637 8.65643L14.7354 8.42596L14.374 9.91425ZM6.9707 10.092C7.09398 10.0359 7.21051 9.99538 7.33398 9.96405C7.45737 9.93286 7.59037 9.91718 7.73242 9.91718C8.02878 9.91718 8.28476 9.97028 8.50098 10.0764C8.71698 10.1825 8.896 10.326 9.03809 10.507C9.18002 10.6882 9.28551 10.9002 9.35352 11.1437C9.42138 11.3873 9.45508 11.6499 9.45508 11.9308C9.45506 12.3617 9.37622 12.7695 9.21875 13.1535C9.06128 13.5374 8.84675 13.8714 8.5752 14.1555C8.30341 14.4396 7.98278 14.6649 7.6123 14.8303C7.24189 14.9957 6.84031 15.0783 6.4082 15.0783C6.35265 15.0783 6.25516 15.0765 6.11621 15.0734C5.9774 15.0702 5.81847 15.0563 5.63965 15.0314C5.46054 15.0064 5.26992 14.9691 5.06934 14.9191C4.86866 14.8693 4.67894 14.8005 4.5 14.7131L6.10254 7.90253L7.53809 7.67792L6.9707 10.092ZM25.2305 12.8234C25.1441 13.179 25.1192 13.5361 25.1562 13.8947C25.1934 14.2535 25.3296 14.8032 25.4619 15.0783H24.1309C23.9683 14.8002 23.9751 14.6697 23.9443 14.5822C23.7717 14.7257 23.5806 14.8442 23.3711 14.9377C23.1614 15.0312 22.927 15.0783 22.668 15.0783C22.3596 15.0783 22.0958 15.0233 21.877 14.9142C21.6581 14.8052 21.4795 14.6587 21.3408 14.4748C21.2021 14.291 21.1015 14.0756 21.04 13.8293C20.9783 13.5829 20.9473 13.319 20.9473 13.0383C20.9473 12.608 21.0227 12.2028 21.1738 11.8224C21.3249 11.442 21.5344 11.1092 21.8027 10.8254C22.071 10.5416 22.7187 9.91621 23.7812 9.9162H25.915L25.2305 12.8234ZM17.1836 13.8908C17.2892 13.916 17.4199 13.9289 17.5752 13.9289C17.8173 13.9289 18.0375 13.8832 18.2363 13.7922C18.435 13.7012 18.6044 13.5737 18.7441 13.4103C18.8838 13.2472 18.9926 13.0507 19.0703 12.8215C19.1477 12.5924 19.1865 12.3398 19.1865 12.0637C19.1865 11.7939 19.1275 11.5645 19.0098 11.3762C18.8917 11.1877 18.6844 11.0873 18.3926 11.0861C18.1886 11.0853 17.8496 11.0851 17.8496 11.0851L17.1836 13.8908ZM7.36719 11.0851C7.28064 11.0851 7.19071 11.094 7.05176 11.1252C6.91283 11.1565 6.79273 11.2216 6.68164 11.3215L6.07812 13.8908C6.25605 13.9223 6.31805 13.9259 6.36133 13.926H6.52832C6.74434 13.926 6.94825 13.873 7.13965 13.7668C7.331 13.6606 7.49679 13.518 7.63574 13.34C7.77439 13.1622 7.88363 12.961 7.96387 12.7365C8.04405 12.5117 8.08496 12.277 8.08496 12.0334C8.08493 11.7339 8.03518 11.4997 7.93652 11.3312C7.83772 11.1626 7.63236 11.0852 7.36719 11.0851ZM24.2539 11.0851C23.6129 11.0851 23.4902 11.0851 23.2275 11.2228C23.041 11.3206 22.8866 11.4683 22.751 11.6398C22.6153 11.8114 22.5086 12.0092 22.4316 12.2336C22.3544 12.4582 22.3164 12.6925 22.3164 12.9357C22.3164 13.235 22.3661 13.4722 22.4648 13.6467C22.5634 13.8212 22.7456 13.9084 23.0107 13.9084C23.1524 13.9083 23.2805 13.8805 23.3945 13.8244C23.5085 13.7683 23.6303 13.674 23.7598 13.5432C23.7721 13.3875 23.7926 13.2234 23.8203 13.0519C23.848 12.8807 23.8832 12.7218 23.9141 12.5783L24.2539 11.0851ZM12.2988 9.31561H10.9229L11.1338 8.41815H12.5098L12.2988 9.31561Z"
          fill="#002855"
        />
      </g>
    </svg>
  )
}

export function IconCanva(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Canva">
        <g id="Group 68">
          <path
            id="Vector"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="#7D2AE7"
          />
          <path
            id="Vector_2"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="url(#paint0_radial_914_1197)"
          />
          <path
            id="Vector_3"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="url(#paint1_radial_914_1197)"
          />
          <path
            id="Vector_4"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="url(#paint2_radial_914_1197)"
          />
          <path
            id="Vector_5"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="url(#paint3_radial_914_1197)"
          />
          <path
            id="Vector_6"
            d="M16.3174 14.0514C16.2349 14.0514 16.1622 14.1211 16.0867 14.2733C15.2332 16.0039 13.7591 17.2284 12.0533 17.2284C10.0808 17.2284 8.85937 15.4479 8.85937 12.9881C8.85937 8.82143 11.1809 6.41235 13.22 6.41235C14.1729 6.41235 14.7548 7.01114 14.7548 7.96403C14.7548 9.09497 14.1122 9.69376 14.1122 10.0926C14.1122 10.2717 14.2236 10.3801 14.4445 10.3801C15.3317 10.3801 16.3731 9.36055 16.3731 7.92026C16.3731 6.52375 15.1576 5.49725 13.1186 5.49725C9.74861 5.49725 6.75366 8.62151 6.75366 12.9443C6.75366 16.2904 8.66442 18.5016 11.6126 18.5016C14.7418 18.5016 16.5512 15.3882 16.5512 14.3777C16.5512 14.1539 16.4368 14.0514 16.3174 14.0514Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_914_1197"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.86325 19.7264) rotate(-49.416) scale(15.4683)"
        >
          <stop stopColor="#6420FF" />
          <stop offset="1" stopColor="#6420FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_914_1197"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.2947 4.27364) rotate(54.703) scale(17.4434)"
        >
          <stop stopColor="#00C4CC" />
          <stop offset="1" stopColor="#00C4CC" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_914_1197"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.86316 19.7263) rotate(-45.1954) scale(15.2811 7.02796)"
        >
          <stop stopColor="#6420FF" />
          <stop offset="1" stopColor="#6420FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_914_1197"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.1789 4.69474) rotate(66.5198) scale(15.7459 26.3779)"
        >
          <stop stopColor="#00C4CC" stopOpacity="0.725916" />
          <stop offset="0.0001" stopColor="#00C4CC" />
          <stop offset="1" stopColor="#00C4CC" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function IconCitadele(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Citadele">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Citadele_2"
          d="M5.37174 10.3079C5.14145 10.3079 5.11873 10.2317 5.11873 9.67591V9.58108C5.11873 9.02343 5.14145 8.94794 5.37174 8.94794H10.6379C10.869 8.94794 10.8917 9.02343 10.8917 9.58032V9.67516C10.8917 10.2317 10.8686 10.3075 10.6379 10.3075H5.37174V10.3079ZM5.37174 7.86073C5.14145 7.86073 5.11873 7.78486 5.11873 7.22835V7.13351C5.11873 6.57511 5.14145 6.5 5.37174 6.5H10.6379C10.869 6.5 10.8917 6.57587 10.8917 7.13351V7.22835C10.8917 7.78486 10.8686 7.86073 10.6379 7.86073H5.37174ZM6.16065 15.1283C6.16065 14.2072 6.632 13.7008 7.34122 13.7008C7.60897 13.7008 7.82333 13.7752 8.09148 13.9022C8.1887 13.9493 8.26918 13.9303 8.39668 13.6424L8.48952 13.4467C8.58116 13.2107 8.58793 13.1132 8.47677 13.0609C8.14805 12.8776 7.63925 12.7619 7.19977 12.7619C5.94748 12.7619 5 13.7065 5 15.1283C5 16.5497 5.94748 17.4943 7.19938 17.4943C7.63925 17.4943 8.15961 17.379 8.48952 17.1946C8.59948 17.1434 8.59231 17.0448 8.50147 16.8088L8.40983 16.6021C8.28233 16.3138 8.20145 16.2975 8.10343 16.3422C7.83528 16.4701 7.60937 16.5444 7.34122 16.5444C6.632 16.5444 6.16184 16.049 6.16184 15.1283H6.16105H6.16065ZM21.0821 17.2766C21.0821 17.4017 21.0327 17.4359 20.661 17.4359H20.6239C20.2323 17.4359 20.1777 17.4188 20.147 17.3274C20.1265 17.2653 20.1101 17.2021 20.098 17.1381C19.8908 17.3741 19.641 17.5 19.2605 17.5C18.3377 17.5 17.7831 16.8551 17.7831 15.818C17.7831 14.697 18.4003 14.0331 19.3155 14.0331C19.5733 14.0331 19.8107 14.109 19.994 14.2471V12.7904C19.994 12.6929 20.006 12.6523 20.5199 12.6523H20.557C21.0327 12.6523 21.0817 12.6929 21.0817 12.7904V17.2766H21.0821ZM19.9944 15.065C19.9316 14.9996 19.8551 14.9474 19.7699 14.9117C19.6847 14.8761 19.5926 14.8577 19.4995 14.8578C19.0899 14.8578 18.8955 15.1966 18.8955 15.8187C18.8955 16.1753 18.9748 16.4018 19.0899 16.5205C19.1935 16.643 19.3529 16.6825 19.5063 16.6825C19.6956 16.6825 19.8418 16.6381 19.9095 16.5558C19.9697 16.4928 19.994 16.3953 19.994 16.1708V15.0646L19.9948 15.065H19.9944ZM26.6268 17.2993C26.6268 17.3961 26.5778 17.4359 26.1009 17.4359H26.0642C25.551 17.4359 25.5403 17.3961 25.5403 17.2993V12.7904C25.5403 12.6929 25.551 12.6523 26.0638 12.6523H26.1005C26.577 12.6523 26.6264 12.6929 26.6264 12.7904V17.2993H26.6268ZM22.8002 16.1006C22.8608 16.5091 23.1293 16.7056 23.5512 16.7056C23.876 16.7056 24.18 16.6374 24.5354 16.4928C24.6095 16.4644 24.676 16.4928 24.7545 16.7216L24.8103 16.8498C24.8888 17.0857 24.882 17.1381 24.7976 17.1832C24.3752 17.4074 23.9357 17.4992 23.4469 17.4992C22.3663 17.4992 21.6886 16.8733 21.6886 15.8017C21.6886 14.7596 22.3113 14.0331 23.3803 14.0331C24.4378 14.0331 24.9804 14.7478 24.9804 15.7379C24.9804 16.0664 24.9506 16.1006 24.8282 16.1006H22.8002ZM23.8927 15.4621C23.876 15.1177 23.7294 14.8172 23.3688 14.8172C23.056 14.8172 22.8297 15.0411 22.787 15.4621H23.8927ZM28.3194 16.1006C28.3791 16.5091 28.6485 16.7056 29.0708 16.7056C29.3927 16.7056 29.6995 16.6374 30.0537 16.4928C30.1263 16.4644 30.1948 16.4928 30.2737 16.7216L30.3291 16.8498C30.4076 17.0857 30.4012 17.1381 30.3171 17.1832C29.8948 17.4074 29.4545 17.4992 28.9652 17.4992C27.8843 17.4992 27.2073 16.8733 27.2073 15.8017C27.2073 14.7596 27.8289 14.0331 28.8983 14.0331C29.9565 14.0331 30.5 14.7478 30.5 15.7379C30.5 16.0664 30.4693 16.1006 30.347 16.1006H28.319H28.3194ZM29.4131 15.4621C29.3931 15.1177 29.2477 14.8172 28.8871 14.8172C28.5755 14.8172 28.3484 15.0411 28.3062 15.4621H29.4131ZM16.0443 15.0877C15.9892 15.0185 15.9182 14.9624 15.8366 14.9236C15.7551 14.8848 15.6653 14.8643 15.5741 14.8639C15.1645 14.8639 14.9697 15.2034 14.9697 15.8073C14.9697 16.3195 15.1147 16.7 15.561 16.7C15.7267 16.7 15.8479 16.6597 15.9343 16.5782C16.0132 16.4985 16.0443 16.3885 16.0443 16.148V15.0877ZM17.144 17.2766C17.144 17.4017 17.0958 17.4359 16.7232 17.4359H16.673C16.2826 17.4359 16.2276 17.4188 16.1973 17.3274C16.1763 17.2655 16.1599 17.2022 16.1483 17.1381C15.9411 17.3741 15.6901 17.5 15.3108 17.5C14.425 17.5 13.8565 16.8657 13.8565 15.8309C13.8565 14.6795 14.5593 14.0331 15.3905 14.0331C15.7267 14.0331 16.0192 14.1667 16.1786 14.3563L16.1973 14.2122C16.2025 14.1439 16.222 14.0984 16.6236 14.0984H16.667C17.083 14.0984 17.1432 14.1261 17.1432 14.2311V17.2766H17.144ZM12.0444 13.1253C12.4532 13.1253 12.4779 13.1303 12.4779 13.257V14.0976H13.1811C13.2783 14.0976 13.3086 14.1147 13.3086 14.4311V14.4777C13.3086 14.7933 13.2783 14.8116 13.1811 14.8116H12.4779V16.3202C12.4779 16.5729 12.5261 16.7056 12.7703 16.7056C12.8978 16.7056 13.0094 16.6825 13.1194 16.6487C13.2349 16.6066 13.2787 16.6597 13.3576 16.9238L13.376 16.9871C13.4612 17.2766 13.4361 17.2993 13.3273 17.3502C13.1074 17.448 12.8134 17.5 12.5388 17.5C11.6714 17.5 11.4272 17.0857 11.4272 16.365V14.8116H11.0176C10.914 14.8116 10.8881 14.7926 10.8881 14.4777V14.4311C10.8881 14.1147 10.9136 14.0984 11.0176 14.0984H11.4758C11.5256 13.8279 11.6101 13.447 11.6655 13.257C11.6961 13.1473 11.7145 13.1253 12.0444 13.1253ZM9.77169 14.0984C10.2486 14.0984 10.2909 14.1374 10.2909 14.2361V17.2993C10.2909 17.4017 10.2486 17.4359 9.77169 17.4359H9.74061C9.21587 17.4359 9.20391 17.4017 9.20391 17.2993V14.2361C9.20391 14.1374 9.21587 14.0984 9.74061 14.0984H9.77169ZM9.74061 12.6011C10.0849 12.6011 10.3343 12.8541 10.3343 13.1417C10.3327 13.2137 10.3162 13.2848 10.2855 13.3507C10.2549 13.4166 10.2108 13.476 10.1558 13.5256C10.0442 13.6261 9.8948 13.6807 9.74061 13.6773C9.40034 13.6773 9.14813 13.4243 9.14813 13.1417C9.14813 12.8533 9.40034 12.6011 9.74061 12.6011Z"
          fill="#EE293D"
        />
      </g>
    </svg>
  )
}

export function IconClubhouseColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <g id="Vector">
          <path
            id="Vector_2"
            d="M5.9054 10.2909C6.22287 11.3435 6.60717 12.3309 7.02489 13.2833C7.74337 14.9891 8.22793 15.8914 8.8978 17.0109C9.71654 18.3476 10.6203 19.8696 12.1074 20.8554C13.1935 21.5739 14.515 21.9415 15.7849 21.9415C17.5743 21.9415 19.1115 21.1562 20.0988 20.2357C21.0679 19.3334 22.3226 17.5942 22.3226 14.2008C22.3226 13.0311 22.8406 12.0271 23.2249 11.2251C23.2249 11.2084 23.2416 11.1749 23.275 11.1081C23.4254 10.7739 23.6092 10.3395 23.6092 9.90506C23.6092 9.5876 23.5257 9.22 23.3084 8.90253C22.9743 8.33443 22.3727 8.13392 21.8198 8.13392C20.5332 8.13392 19.6462 9.0362 19.195 9.95671L19.0446 10.2575C18.8608 9.99013 18.677 9.70608 18.5267 9.45544C18.0588 8.63671 17.7915 8.08532 17.5575 7.38203C17.3738 6.83063 17.2234 6.1957 17.1231 5.6762C16.8391 4.03722 16.3712 3.50253 15.6011 3.30203C15.033 3.15165 14.3646 3.26861 13.8786 3.58608C13.5459 2.83418 12.9778 2.5 12.2244 2.5C11.155 2.5 10.1844 3.20177 10.1844 4.38962C10.1844 4.54 10.2011 4.69038 10.2178 4.87418C10.0841 4.84076 9.93375 4.82405 9.78337 4.82405C8.63046 4.82405 7.77679 5.62608 7.77679 6.71367C7.77679 6.9643 7.81021 7.24835 7.89375 7.58253C7.7935 7.56582 7.69325 7.56582 7.59299 7.56582C7.02489 7.59924 6.50692 7.81646 6.1378 8.2676C5.77173 8.70203 5.62135 9.37038 5.9054 10.2909Z"
            fill="#1F1F1F"
          />
          <path
            id="Vector_3"
            d="M6.85785 9.99013C6.70747 9.50557 6.72418 9.13798 6.90798 8.90405C7.09178 8.68684 7.34241 8.58658 7.64317 8.56988C8.16115 8.55317 8.36165 8.92076 8.66241 9.87317C8.84621 10.4747 9.2138 11.3451 9.43102 11.8296C9.71507 12.4144 10.1161 13.1997 10.2999 13.4686C10.4503 13.7025 10.5839 13.7694 10.7343 13.7694C11.0017 13.7694 11.2022 13.619 11.2022 13.3516C11.2022 13.2013 11.0518 12.9506 10.9682 12.8003C10.8179 12.5162 10.5004 11.9481 10.2832 11.4635C10.0492 10.9289 9.7819 10.2605 9.56469 9.65747C9.43102 9.30658 9.28064 8.80532 9.13026 8.30405C8.89634 7.53544 8.77937 7.0676 8.77937 6.71519C8.77937 6.18051 9.18039 5.82962 9.7819 5.82962C10.2163 5.82962 10.5004 6.04684 10.6842 6.83215C10.8346 7.55064 11.1019 8.72177 11.4862 9.64076C11.7368 10.2423 12.1044 11.0458 12.3217 11.4468C12.4553 11.6808 12.6057 11.8813 12.6057 11.9648C12.6057 12.0818 12.3885 12.2656 12.2047 12.5162C12.0877 12.6666 12.0376 12.7668 12.0376 12.8838C12.0376 12.9841 12.1044 13.0843 12.2047 13.218C12.3049 13.3516 12.4052 13.4853 12.5222 13.4853C12.6057 13.4853 12.6558 13.4519 12.706 13.3851C13.2239 12.7334 13.792 12.2823 14.4452 11.9132C15.2138 11.4787 16.0006 11.2615 16.6189 11.1279C16.9196 11.061 17.0032 10.9942 17.0032 10.8271C17.0032 10.6266 16.8528 10.5096 16.6523 10.4929C16.5019 10.4762 16.3682 10.4929 16.1343 10.5096C15.9672 10.5263 15.8837 10.4428 15.7834 10.2256C15.4827 9.59064 14.8979 8.51975 14.547 7.14962C14.3966 6.56481 14.2629 5.94658 14.1794 5.14304C14.1292 4.77545 14.1961 4.64177 14.3799 4.47469C14.6138 4.27418 15.0315 4.19064 15.349 4.27418C15.7333 4.37443 15.9338 4.67519 16.1343 5.84633C16.2346 6.39772 16.4017 7.0995 16.6022 7.70253C16.8528 8.47114 17.1703 9.1076 17.6548 9.95975C17.9222 10.4276 18.2563 10.9122 18.6072 11.3815C18.5404 11.582 18.4234 11.7157 18.0391 12.0332C17.6548 12.3506 17.2705 12.6848 16.9196 13.303C16.669 13.7542 16.552 14.2554 16.552 14.5896C16.552 14.9071 16.6189 14.9739 16.8194 14.9739C17.1703 14.9739 17.4543 14.9071 17.471 14.7567C17.5546 14.1552 17.6548 13.7709 17.989 13.3182C18.1895 13.0676 18.5404 12.7501 18.8244 12.4995C19.3591 12.0651 19.5429 11.8144 19.7267 11.1962C19.8103 10.9122 19.9105 10.6448 20.0442 10.3942C20.3617 9.80937 20.9298 9.14102 21.8168 9.14102C22.1009 9.14102 22.3348 9.22456 22.4852 9.45848C22.5687 9.59215 22.6022 9.77595 22.6022 9.90962C22.6022 10.2104 22.3849 10.6281 22.2847 10.8286C21.9171 11.6139 21.3156 12.8185 21.3156 14.2053C21.3156 17.2311 20.2462 18.7365 19.4092 19.5051C18.5905 20.2737 17.3024 20.9435 15.7819 20.9435C14.6958 20.9435 13.5748 20.6261 12.6558 20.0246C11.3692 19.1724 10.5657 17.8342 9.74697 16.4975C9.09532 15.4114 8.64418 14.5577 7.94089 12.9035C7.54444 11.9451 7.17532 11.0094 6.85785 9.99013Z"
            fill="#FFE450"
          />
          <path
            id="Vector_4"
            d="M11.155 4.38961C11.155 3.75468 11.7398 3.50404 12.2244 3.50404C12.7424 3.50404 12.9262 3.75468 13.0598 4.28936C13.1768 4.72379 13.2269 5.1248 13.2771 5.59265C13.3439 6.0605 13.5778 7.13139 13.6446 7.39873C13.8953 8.31771 14.3965 9.40531 14.9981 10.7086C14.6472 10.8256 14.1793 11.0261 13.8619 11.1932C13.4609 11.4104 13.3773 11.4104 13.2102 11.0929C12.8593 10.4413 12.6087 9.9567 12.3915 9.38708C12.2077 8.91923 12.0239 8.38455 11.8735 7.7648C11.6229 6.71214 11.5895 6.41139 11.389 5.92531C11.272 5.42556 11.155 4.80733 11.155 4.38961Z"
            fill="#FFE450"
          />
          <path
            id="Vector_5"
            d="M5.17028 15.5815C4.81635 15.8003 2.94041 16.783 2.51661 16.9395C2.21433 17.0519 1.88623 17.0246 1.69332 16.4534C1.45635 15.7471 1.78901 15.58 2.26294 15.3962C2.68218 15.2337 4.42142 14.6048 4.82547 14.4954C5.10952 14.4195 5.30699 14.5152 5.4437 14.857C5.59408 15.2322 5.49078 15.3825 5.17028 15.5815Z"
            fill="#1F1F1F"
          />
          <path
            id="Vector_6"
            d="M3.62394 11.6002C3.11964 11.6139 1.02495 11.5243 0.546473 11.4772C0.13027 11.4362 -0.0383376 11.2524 0.00723201 10.6494C0.0558396 10.0023 0.307992 9.96278 0.716599 10.0023C1.19052 10.0478 3.38546 10.4048 3.73483 10.5127C4.09635 10.6251 4.14647 10.7891 4.10242 11.1051C4.04622 11.5152 3.8609 11.5927 3.62394 11.6002Z"
            fill="#1F1F1F"
          />
          <path
            id="Vector_7"
            d="M3.88364 7.35925C3.30643 7.17697 1.59301 6.1395 1.14643 5.87216C0.742377 5.62912 0.690732 5.41038 0.971744 4.87722C1.22086 4.40633 1.49731 4.32431 1.90744 4.53697C2.38288 4.78456 4.06136 6.09089 4.38187 6.34912C4.69174 6.59823 4.64921 6.72735 4.48668 7.04785C4.32415 7.36836 4.17225 7.45039 3.88364 7.35925Z"
            fill="#1F1F1F"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconClubhouseColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <g id="Vector">
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.9054 10.2909C6.22287 11.3435 6.60717 12.3309 7.02489 13.2833C7.74337 14.9891 8.22793 15.8914 8.8978 17.0109L8.97209 17.1322C9.77155 18.4389 10.6652 19.8993 12.1074 20.8554C13.1935 21.5739 14.515 21.9415 15.7849 21.9415C17.5743 21.9415 19.1115 21.1562 20.0988 20.2357C21.0679 19.3334 22.3226 17.5942 22.3226 14.2008C22.3226 13.0982 22.7829 12.1427 23.1576 11.365L23.1576 11.3649C23.1804 11.3177 23.2029 11.271 23.2249 11.2251C23.2249 11.2084 23.2416 11.1749 23.275 11.1081C23.4254 10.7739 23.6092 10.3395 23.6092 9.90506C23.6092 9.5876 23.5257 9.22 23.3084 8.90253C22.9743 8.33443 22.3727 8.13392 21.8198 8.13392C20.5332 8.13392 19.6462 9.0362 19.195 9.95671L19.0446 10.2575C18.8608 9.99013 18.677 9.70608 18.5267 9.45544C18.0588 8.63671 17.7915 8.08532 17.5576 7.38203C17.3738 6.83063 17.2234 6.1957 17.1231 5.6762C16.8391 4.03722 16.3712 3.50253 15.6011 3.30203C15.033 3.15165 14.3646 3.26861 13.8786 3.58608C13.5459 2.83418 12.9778 2.5 12.2244 2.5C11.155 2.5 10.1844 3.20177 10.1844 4.38962C10.1844 4.51628 10.1962 4.64293 10.21 4.78955L10.21 4.78958C10.2125 4.81704 10.2152 4.84519 10.2178 4.87418C10.0841 4.84076 9.93375 4.82405 9.78337 4.82405C8.63046 4.82405 7.77679 5.62608 7.77679 6.71367C7.77679 6.9643 7.81021 7.24835 7.89375 7.58253C7.7935 7.56582 7.69325 7.56582 7.59299 7.56582C7.02489 7.59924 6.50692 7.81646 6.1378 8.2676C5.77173 8.70203 5.62135 9.37038 5.9054 10.2909ZM6.85779 9.99011C6.70741 9.50556 6.72412 9.13796 6.90792 8.90404C7.09172 8.68682 7.34235 8.58657 7.64311 8.56986C8.16108 8.55315 8.36159 8.92075 8.66235 9.87315C8.84615 10.4747 9.21374 11.345 9.43096 11.8296C9.71501 12.4144 10.116 13.1997 10.2998 13.4686C10.4502 13.7025 10.5839 13.7694 10.7342 13.7694C11.0016 13.7694 11.2021 13.619 11.2021 13.3516C11.2021 13.2163 11.0803 12.9997 10.995 12.8482L10.995 12.8481C10.9855 12.8313 10.9765 12.8153 10.9682 12.8002C10.9379 12.7431 10.9009 12.6745 10.8593 12.5974L10.8593 12.5972L10.8592 12.5972C10.694 12.2909 10.4566 11.8506 10.2831 11.4635C10.0492 10.9288 9.78184 10.2605 9.56463 9.65745C9.43096 9.30657 9.28058 8.8053 9.1302 8.30404C8.89627 7.53543 8.77931 7.06758 8.77931 6.71518C8.77931 6.18049 9.18032 5.82961 9.78184 5.82961C10.2163 5.82961 10.5003 6.04682 10.6841 6.83214C10.8345 7.55062 11.1018 8.72176 11.4861 9.64075C11.7368 10.2423 12.1044 11.0458 12.3216 11.4468C12.3653 11.5232 12.4107 11.5961 12.4521 11.6625C12.5375 11.7993 12.6056 11.9085 12.6056 11.9648C12.6056 12.0392 12.5179 12.1405 12.4067 12.2689C12.343 12.3425 12.2716 12.4249 12.2046 12.5162C12.0877 12.6666 12.0375 12.7668 12.0375 12.8838C12.0375 12.984 12.1044 13.0843 12.2046 13.218C12.3049 13.3516 12.4051 13.4853 12.5221 13.4853C12.6056 13.4853 12.6558 13.4519 12.7059 13.3851C13.2239 12.7334 13.792 12.2823 14.4451 11.9132C15.2137 11.4787 16.0006 11.2615 16.6188 11.1278C16.9196 11.061 17.0031 10.9942 17.0031 10.8271C17.0031 10.6266 16.8527 10.5096 16.6522 10.4929C16.5293 10.4792 16.4176 10.4879 16.2533 10.5006C16.2165 10.5035 16.177 10.5066 16.1342 10.5096C15.9672 10.5263 15.8836 10.4428 15.7834 10.2256C15.7366 10.1269 15.683 10.0177 15.6245 9.89845C15.3065 9.25053 14.8433 8.3068 14.5469 7.14961C14.3965 6.5648 14.2629 5.94657 14.1793 5.14302C14.1292 4.77543 14.196 4.64176 14.3798 4.47467C14.6137 4.27416 15.0315 4.19062 15.3489 4.27416C15.7332 4.37442 15.9337 4.67518 16.1342 5.84632C16.2345 6.39771 16.4016 7.09948 16.6021 7.70252C16.8527 8.47113 17.1702 9.10758 17.6548 9.95973C17.9221 10.4276 18.2563 10.9121 18.6072 11.3815C18.5403 11.582 18.4234 11.7157 18.0391 12.0332C17.6548 12.3506 17.2705 12.6848 16.9196 13.303C16.6689 13.7542 16.552 14.2554 16.552 14.5896C16.552 14.9071 16.6188 14.9739 16.8193 14.9739C17.1702 14.9739 17.4543 14.9071 17.471 14.7567C17.5545 14.1552 17.6548 13.7709 17.9889 13.3182C18.1894 13.0676 18.5403 12.7501 18.8244 12.4995C19.3591 12.0651 19.5429 11.8144 19.7267 11.1962C19.8102 10.9121 19.9105 10.6448 20.0441 10.3942C20.3616 9.80935 20.9297 9.141 21.8168 9.141C22.1008 9.141 22.3348 9.22454 22.4851 9.45847C22.5687 9.59214 22.6021 9.77594 22.6021 9.90961C22.6021 10.196 22.4051 10.5885 22.2997 10.7984L22.2846 10.8286C22.266 10.8684 22.2468 10.9092 22.2271 10.9511L22.227 10.9512C21.8576 11.7365 21.3155 12.8888 21.3155 14.2053C21.3155 17.2311 20.2461 18.7364 19.4092 19.5051C18.5905 20.2737 17.3024 20.9435 15.7818 20.9435C14.6958 20.9435 13.5748 20.6261 12.6558 20.0245C11.3952 19.1896 10.5984 17.8881 9.79659 16.5786L9.79658 16.5786L9.74691 16.4975C9.09526 15.4114 8.64412 14.5577 7.94083 12.9035C7.54438 11.945 7.17526 11.0094 6.85779 9.99011ZM12.2243 3.50403C11.7398 3.50403 11.155 3.75466 11.155 4.3896C11.155 4.80732 11.2719 5.42555 11.3889 5.92529C11.5342 6.27767 11.5918 6.53265 11.7079 7.04731C11.752 7.24258 11.8045 7.47524 11.8734 7.76479C12.0238 8.38453 12.2076 8.91922 12.3914 9.38707C12.6086 9.95669 12.8593 10.4412 13.2102 11.0929C13.3772 11.4104 13.4608 11.4104 13.8618 11.1931C14.1793 11.0261 14.6471 10.8255 14.998 10.7086C14.3965 9.40529 13.8952 8.3177 13.6446 7.39871C13.5778 7.13137 13.3438 6.06048 13.277 5.59264C13.2269 5.12479 13.1767 4.72378 13.0598 4.28934C12.9261 3.75466 12.7423 3.50403 12.2243 3.50403Z"
            fill="currentColor"
          />
          <path
            id="Vector_3"
            d="M5.17028 15.5815C4.81635 15.8003 2.94041 16.783 2.51661 16.9395C2.21433 17.0519 1.88623 17.0246 1.69332 16.4534C1.45635 15.7471 1.78901 15.58 2.26294 15.3962C2.68218 15.2337 4.42142 14.6048 4.82547 14.4954C5.10952 14.4195 5.30699 14.5152 5.4437 14.857C5.59408 15.2322 5.49078 15.3825 5.17028 15.5815Z"
            fill="currentColor"
          />
          <path
            id="Vector_4"
            d="M3.62394 11.6002C3.11964 11.6139 1.02495 11.5243 0.546473 11.4772C0.13027 11.4362 -0.0383376 11.2524 0.00723201 10.6494C0.0558396 10.0023 0.307992 9.96278 0.716599 10.0023C1.19052 10.0478 3.38546 10.4048 3.73483 10.5127C4.09635 10.6251 4.14647 10.7891 4.10242 11.1051C4.04622 11.5152 3.8609 11.5927 3.62394 11.6002Z"
            fill="currentColor"
          />
          <path
            id="Vector_5"
            d="M3.88364 7.35925C3.30643 7.17697 1.59301 6.1395 1.14643 5.87216C0.742377 5.62912 0.690732 5.41038 0.971744 4.87722C1.22086 4.40633 1.49731 4.32431 1.90744 4.53697C2.38288 4.78456 4.06136 6.09089 4.38187 6.34912C4.69174 6.59823 4.64921 6.72735 4.48668 7.04785C4.32415 7.36836 4.17225 7.45039 3.88364 7.35925Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconCoreldraw(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Coreldraw">
        <g id="Group 63">
          <g id="Group">
            <path
              id="Vector"
              d="M4.69577 8.74907C4.45781 8.63786 4.25166 8.55204 4.0832 8.48737C4.04786 8.21601 4.02195 7.94404 4.00604 7.67086C3.99309 7.44603 4.00133 7.22423 4.02725 7.00665C4.17038 7.03083 4.37299 7.06709 4.62508 7.11725C4.60035 7.42609 4.59799 7.75124 4.62508 8.09453C4.64217 8.31392 4.66573 8.5321 4.69577 8.74907ZM7.04942 10.1748C6.44746 9.72151 5.88201 9.37037 5.39079 9.10081C5.29125 8.47287 5.24884 7.85036 5.28594 7.25807C5.74006 7.36082 6.27723 7.49378 6.868 7.6624C6.82913 8.45474 6.90158 9.30691 7.04942 10.1748ZM13.2316 10.5054C13.2257 10.5737 13.218 10.6432 13.211 10.7127C12.3887 11.1533 11.57 11.7474 10.8343 12.5482C10.5964 12.8068 10.3796 13.0667 10.1811 13.3254C9.9585 13.0365 9.72113 12.744 9.46903 12.4503C9.35595 12.3191 9.24286 12.1916 9.12859 12.0671C8.93952 10.7677 8.81937 9.4858 8.79698 8.2843C10.2607 8.81736 11.8409 9.5408 13.2316 10.5054Z"
              fill="#2AC64B"
            />
            <path
              id="Vector_2"
              d="M4.87526 5.85471C4.75216 6.23789 4.66263 6.65853 4.62494 7.11725C4.37284 7.06709 4.17023 7.03083 4.0271 7.00665C4.043 6.86946 4.06715 6.73408 4.09719 6.60051C4.27684 6.40228 4.53659 6.14058 4.87526 5.85471Z"
              fill="#008A5A"
            />
            <path
              id="Vector_3"
              d="M7.73969 4.19872C7.30677 5.01342 6.95985 6.11157 6.87209 7.57658C6.87091 7.60498 6.86915 7.63399 6.86797 7.6624C6.2772 7.49378 5.74062 7.36142 5.2865 7.25807C5.28709 7.23813 5.28885 7.21939 5.29003 7.19945C5.34658 6.43129 5.56745 5.72658 5.90142 5.10106C6.41797 4.77409 7.02994 4.45619 7.73969 4.19872Z"
              fill="#009550"
            />
            <path
              id="Vector_4"
              d="M13.2315 10.5054C11.8409 9.5408 10.2606 8.81737 8.79694 8.28431C8.76867 6.85315 8.87705 5.53742 9.16566 4.44713C9.17331 4.41691 9.18156 4.38729 9.18981 4.35828C10.3507 5.06238 11.8633 5.84747 13.2993 6.19196C13.4247 7.49137 13.387 8.96786 13.2315 10.5054Z"
              fill="#00983E"
            />
            <path
              id="Vector_5"
              d="M18.1608 7.67086C18.1255 8.27524 18.0412 8.87357 17.9105 9.4719C17.745 9.47855 17.5541 9.48943 17.3427 9.50816C17.4357 9.04702 17.5041 8.57501 17.5418 8.09453C17.6678 6.47722 17.1583 5.2455 16.5693 4.38547C16.7419 4.43564 16.9056 4.4852 17.0582 4.53355C17.7196 5.39418 18.2303 6.50019 18.1608 7.67086ZM16.6889 9.58613C16.2277 9.65382 15.707 9.75958 15.1575 9.92095C15.2835 9.10927 15.3383 8.31633 15.2941 7.57658C15.194 5.88977 14.7487 4.69008 14.2251 3.84758C14.7175 3.93098 15.1846 4.0295 15.6157 4.13285C16.3031 4.96568 16.7896 6.0052 16.8768 7.20005C16.9321 7.96157 16.8526 8.77385 16.6889 9.58613Z"
              fill="#009A37"
            />
            <path
              id="Vector_6"
              d="M13.2993 6.19196C11.8633 5.84686 10.3507 5.06178 9.18982 4.35828C9.25108 4.1401 9.3194 3.94187 9.39479 3.76177C9.60742 3.72429 9.82653 3.69407 10.0521 3.6705C10.9592 3.57562 11.8651 3.58468 12.7274 3.65721C12.8293 3.88808 12.9223 4.14977 13.0012 4.44713C13.1414 4.97898 13.2398 5.56462 13.2993 6.19196Z"
              fill="#00863F"
            />
            <path
              id="Vector_7"
              d="M7.10004 2.87151C7.05233 2.90173 5.50974 3.87599 4.87538 5.85411C4.53671 6.13998 4.27696 6.40228 4.0979 6.59991C4.51727 4.73359 6.19121 3.20936 7.10004 2.87151ZM8.07602 3.64149C7.95998 3.81071 7.8469 3.99626 7.7397 4.19872C7.03054 4.45619 6.41798 4.77409 5.90142 5.10166C6.29664 4.35767 6.85207 3.72368 7.47818 3.22084C7.62661 3.32963 7.82981 3.47408 8.07602 3.64149Z"
              fill="#06CBF6"
            />
            <path
              id="Vector_8"
              d="M17.0583 4.53354C16.9057 4.48519 16.742 4.43563 16.5694 4.38547C15.8732 3.36891 15.0657 2.87091 15.0657 2.87091C15.6011 3.06974 16.4039 3.68198 17.0583 4.53354ZM15.6158 4.13284C15.1852 4.02949 14.7182 3.93098 14.2258 3.84758C13.3422 2.42367 12.2326 2.01934 12.1784 2.0006C13.3676 2.24538 14.6787 2.99782 15.6158 4.13284ZM12.7273 3.6572C11.865 3.58407 10.9591 3.57561 10.0521 3.67049C9.8265 3.69407 9.60798 3.72428 9.39476 3.76176C10.0321 2.2206 11.0687 2 11.0687 2H11.0982C11.0982 2 12.0877 2.21032 12.7273 3.6572ZM9.98906 2.0006C9.93782 2.01874 8.93416 2.38438 8.07599 3.64148C7.83037 3.47468 7.62658 3.33023 7.47815 3.22144C8.26034 2.5941 9.15445 2.17225 9.98906 2.0006Z"
              fill="url(#paint0_linear_914_1172)"
            />
            <path
              id="Vector_9"
              d="M11.0833 22H12.1488L12.5429 20.2352H9.62378L10.0178 22H11.0833Z"
              fill="#666565"
            />
          </g>
          <path
            id="Vector_10"
            d="M7.06012 13.9911C7.26509 14.4143 7.46064 14.7922 7.6291 15.1077C7.91771 15.6475 8.19218 16.1066 8.47549 16.5246C8.55736 16.2385 8.65926 15.9365 8.78649 15.6234C8.56679 15.1201 8.3465 14.5791 8.13682 14.0158C7.68093 12.792 7.27628 11.4605 7.05011 10.1673C6.44815 9.72639 5.88271 9.38381 5.39148 9.12186C5.67243 10.8625 6.41281 12.6549 7.06012 13.9911Z"
            fill="url(#paint1_linear_914_1172)"
          />
          <path
            id="Vector_11"
            d="M6.09764 13.9738C6.21367 14.1763 6.33442 14.3799 6.45928 14.5854C7.04416 15.5437 7.71975 16.429 8.32112 17.1483C8.33879 17.0612 8.3594 16.9711 8.38237 16.8799C8.13912 16.5455 7.90175 16.2065 7.69737 15.8915C7.40463 15.4412 6.98114 14.7884 6.53939 13.985C5.78311 12.607 4.97559 10.7851 4.69522 8.78376C4.45727 8.67545 4.25112 8.59186 4.08325 8.52888C4.32533 10.3225 5.01211 12.0837 6.09764 13.9738Z"
            fill="url(#paint2_linear_914_1172)"
          />
          <path
            id="Vector_12"
            d="M9.23407 12.7899C9.31005 13.2432 9.39899 13.7035 9.495 14.1585C9.50442 14.202 9.51326 14.245 9.52268 14.2886C9.7147 13.9784 9.93322 13.6634 10.1806 13.3479C9.95089 13.0577 9.71352 12.7734 9.46849 12.495C9.35541 12.3673 9.24232 12.2431 9.12805 12.1224C9.16162 12.3443 9.19638 12.5668 9.23407 12.7899Z"
            fill="url(#paint3_linear_914_1172)"
          />
          <path
            id="Vector_13"
            d="M17.3422 8.94904C17.0712 10.2641 16.5941 11.4819 16.0864 12.5238C16.1889 12.6268 16.289 12.7299 16.3862 12.8311C17.1095 11.4872 17.6237 10.2017 17.9105 8.91372C17.7445 8.92019 17.5542 8.9302 17.3422 8.94904ZM15.1581 9.35108C15.0586 9.97915 14.9155 10.6184 14.7423 11.2524C15.0415 11.522 15.3684 11.8239 15.69 12.1336C16.0923 11.1741 16.4681 10.0986 16.6895 9.02497C16.2278 9.09149 15.7077 9.1945 15.1581 9.35108Z"
            fill="#97CC1A"
          />
          <path
            id="Vector_14"
            d="M10.8344 13.1238C10.5964 13.3758 10.3796 13.6289 10.1812 13.8814C11.0464 14.9739 11.6896 16.0129 12.1555 16.8817C12.3245 16.2283 12.5001 15.5049 12.6573 14.7638C12.7592 14.2858 12.8529 13.8014 12.933 13.324C13.0455 12.6576 13.1391 11.9919 13.211 11.3367C12.3881 11.7659 11.57 12.3439 10.8344 13.1238ZM16.0865 13.7384C16.067 13.7784 16.0476 13.8178 16.0282 13.8573C15.4539 15.0151 14.8502 15.9452 14.4691 16.5321C14.0291 17.2096 13.436 18.0031 12.966 18.6099C12.983 18.6547 12.9995 18.6965 13.0148 18.7365C13.7428 17.9442 14.8278 16.6674 15.7072 15.2265C15.928 14.8644 16.1342 14.5083 16.3268 14.1557C16.3468 14.1192 16.3668 14.0827 16.3863 14.0457C16.2891 13.9438 16.189 13.8414 16.0865 13.7384ZM14.7424 12.4669L14.7194 12.5493C14.1616 14.5619 13.3123 16.5115 12.6402 17.8547C12.7133 18.0142 12.7798 18.1632 12.8381 18.2997C13.4589 17.5616 13.9702 16.814 14.538 15.7533C14.8496 15.1694 15.2536 14.3735 15.6394 13.4682L15.6901 13.3481C15.3685 13.0385 15.0416 12.7365 14.7424 12.4669Z"
            fill="url(#paint4_linear_914_1172)"
          />
          <path
            id="Vector_15"
            d="M11.6436 21.1276C12.0971 20.6578 12.4852 20.2411 12.8381 19.8208C12.7797 19.6842 12.7138 19.5359 12.6401 19.3758C12.1642 20.3282 11.7761 20.9757 11.6436 21.1276Z"
            fill="url(#paint5_linear_914_1172)"
          />
          <path
            id="Vector_16"
            d="M12.2007 21.249C12.2248 21.2254 12.5464 20.9164 13.0153 20.4072C12.9994 20.3672 12.9835 20.3254 12.9664 20.2807C12.5458 20.8246 12.2254 21.2195 12.2007 21.249Z"
            fill="url(#paint6_linear_914_1172)"
          />
          <path
            id="Vector_17"
            d="M9.52258 15.529C10.0586 18.0348 10.7936 20.3328 10.7936 20.3328H11.3732C11.3732 20.3328 11.7461 19.1656 12.1554 17.588C11.6895 16.7192 11.0463 15.6808 10.1811 14.5877C9.93312 14.9038 9.7146 15.2188 9.52258 15.529Z"
            fill="url(#paint7_linear_914_1172)"
          />
          <path
            id="Vector_18"
            d="M8.47485 18.3648C9.06091 19.2342 9.67818 19.9259 10.5228 20.8012C10.3261 20.5763 9.56392 19.2525 8.78585 17.4642C8.65862 17.7768 8.55672 18.0788 8.47485 18.3648Z"
            fill="url(#paint8_linear_914_1172)"
          />
          <path
            id="Vector_19"
            d="M8.32104 19.2352C9.20514 20.293 9.92961 20.9893 9.96672 21.0246C9.92784 20.9764 9.12974 19.9957 8.3823 18.9668C8.35992 19.058 8.3393 19.1481 8.32104 19.2352Z"
            fill="url(#paint9_linear_914_1172)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_1172"
          x1="7.90654"
          y1="3.05837"
          x2="16.4945"
          y2="3.31202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0288F7" />
          <stop offset="1" stopColor="#2EE2BD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_914_1172"
          x1="8.56389"
          y1="15.8865"
          x2="6.45376"
          y2="10.6651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB1918" />
          <stop offset="0.388" stopColor="#A2183D" />
          <stop offset="0.749" stopColor="#902869" />
          <stop offset="1" stopColor="#73358A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_914_1172"
          x1="7.49638"
          y1="16.3223"
          x2="5.38619"
          y2="11.1008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB1918" />
          <stop offset="0.388" stopColor="#A2183D" />
          <stop offset="0.749" stopColor="#902869" />
          <stop offset="1" stopColor="#73358A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_914_1172"
          x1="10.4291"
          y1="15.244"
          x2="8.31893"
          y2="10.0225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB1918" />
          <stop offset="0.388" stopColor="#A2183D" />
          <stop offset="0.749" stopColor="#902869" />
          <stop offset="1" stopColor="#73358A" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_914_1172"
          x1="14.7704"
          y1="12.8232"
          x2="11.7071"
          y2="16.1715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADD816" />
          <stop offset="1" stopColor="#DBD704" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_914_1172"
          x1="12.4522"
          y1="20.7739"
          x2="9.84509"
          y2="16.3746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1282B" />
          <stop offset="0.388" stopColor="#E3402A" />
          <stop offset="0.702" stopColor="#E76226" />
          <stop offset="1" stopColor="#F19A0A" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_914_1172"
          x1="12.6188"
          y1="20.8248"
          x2="10.0117"
          y2="16.4255"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1282B" />
          <stop offset="0.388" stopColor="#E3402A" />
          <stop offset="0.702" stopColor="#E76226" />
          <stop offset="1" stopColor="#F19A0A" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_914_1172"
          x1="12.1752"
          y1="20.1237"
          x2="9.56816"
          y2="15.7245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1282B" />
          <stop offset="0.388" stopColor="#E3402A" />
          <stop offset="0.702" stopColor="#E76226" />
          <stop offset="1" stopColor="#F19A0A" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_914_1172"
          x1="10.7369"
          y1="21.464"
          x2="8.12983"
          y2="17.0646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1282B" />
          <stop offset="0.388" stopColor="#E3402A" />
          <stop offset="0.702" stopColor="#E76226" />
          <stop offset="1" stopColor="#F19A0A" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_914_1172"
          x1="10.2545"
          y1="22.0015"
          x2="7.64743"
          y2="17.6022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1282B" />
          <stop offset="0.388" stopColor="#E3402A" />
          <stop offset="0.702" stopColor="#E76226" />
          <stop offset="1" stopColor="#F19A0A" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconDinersClub(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="DinersClub">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="DinersClub_2">
          <path
            id="Vector"
            d="M19.045 19.4999C22.9425 19.5187 26.5 16.2921 26.5 12.367C26.5 8.07494 22.9425 5.10785 19.045 5.10945H15.6906C11.7467 5.10785 8.5 8.07574 8.5 12.367C8.5 16.2929 11.7467 19.5187 15.6906 19.4999H19.045Z"
            fill="#0079BE"
          />
          <path
            id="Vector_2"
            d="M15.7067 5.70423C12.1023 5.70543 9.18211 8.6533 9.18091 12.2917C9.18211 15.9296 12.1023 18.8775 15.7067 18.8787C19.3114 18.8775 22.2328 15.9296 22.2332 12.2917C22.2328 8.6533 19.3118 5.70543 15.7067 5.70423ZM11.5704 12.2917C11.5697 11.4504 11.8227 10.6286 12.2965 9.93343C12.7702 9.2383 13.4427 8.70225 14.2259 8.39536V16.1876C13.4426 15.8809 12.7701 15.345 12.2963 14.6499C11.8225 13.9548 11.5695 13.1329 11.5704 12.2917ZM17.187 16.1892V8.39496C17.9708 8.70142 18.6439 9.23741 19.118 9.93278C19.5921 10.6281 19.8452 11.4505 19.8441 12.2921C19.845 13.1336 19.5918 13.9559 19.1178 14.6512C18.6437 15.3465 17.9707 15.8826 17.187 16.1892Z"
            fill="white"
          />
          <path
            id="Vector_3"
            d="M19.045 19.4999C22.9425 19.5187 26.5 16.2921 26.5 12.367C26.5 8.07494 22.9425 5.10785 19.045 5.10945H15.6906C11.7467 5.10785 8.5 8.07574 8.5 12.367C8.5 16.2929 11.7467 19.5187 15.6906 19.4999H19.045Z"
            fill="#0079BE"
          />
          <path
            id="Vector_4"
            d="M15.7067 5.70423C12.1023 5.70543 9.18211 8.6533 9.18091 12.2917C9.18211 15.9296 12.1023 18.8775 15.7067 18.8787C19.3114 18.8775 22.2328 15.9296 22.2332 12.2917C22.2328 8.6533 19.3118 5.70543 15.7067 5.70423ZM11.5704 12.2917C11.5697 11.4504 11.8227 10.6286 12.2965 9.93343C12.7702 9.2383 13.4427 8.70225 14.2259 8.39536V16.1876C13.4426 15.8809 12.7701 15.345 12.2963 14.6499C11.8225 13.9548 11.5695 13.1329 11.5704 12.2917ZM17.187 16.1892V8.39496C17.9708 8.70142 18.6439 9.23741 19.118 9.93278C19.5921 10.6281 19.8452 11.4505 19.8441 12.2921C19.845 13.1336 19.5918 13.9559 19.1178 14.6512C18.6437 15.3465 17.9707 15.8826 17.187 16.1892Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDiscordColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M20.317 4.15559C18.7873 3.45371 17.147 2.93659 15.4319 2.64042C15.4007 2.6347 15.3695 2.64899 15.3534 2.67756C15.1424 3.05277 14.9087 3.54227 14.7451 3.92701C12.9004 3.65084 11.0652 3.65084 9.25832 3.92701C9.09465 3.53372 8.85248 3.05277 8.64057 2.67756C8.62448 2.64994 8.59328 2.63566 8.56205 2.64042C6.84791 2.93564 5.20756 3.45276 3.67693 4.15559C3.66368 4.1613 3.65233 4.17083 3.64479 4.18321C0.533392 8.83157 -0.31895 13.3657 0.0991801 17.8436C0.101072 17.8655 0.11337 17.8864 0.130398 17.8997C2.18321 19.4073 4.17171 20.3225 6.12328 20.9291C6.15451 20.9387 6.18761 20.9272 6.20748 20.9015C6.66913 20.2711 7.08064 19.6063 7.43348 18.9073C7.4543 18.8664 7.43442 18.8178 7.39186 18.8016C6.73913 18.554 6.1176 18.2521 5.51973 17.9093C5.47244 17.8817 5.46865 17.814 5.51216 17.7816C5.63797 17.6874 5.76382 17.5893 5.88396 17.4902C5.90569 17.4721 5.93598 17.4683 5.96153 17.4797C9.88928 19.273 14.1415 19.273 18.023 17.4797C18.0485 17.4674 18.0788 17.4712 18.1015 17.4893C18.2216 17.5883 18.3475 17.6874 18.4742 17.7816C18.5177 17.814 18.5149 17.8817 18.4676 17.9093C17.8697 18.2588 17.2482 18.554 16.5945 18.8007C16.552 18.8169 16.533 18.8664 16.5538 18.9073C16.9143 19.6054 17.3258 20.2701 17.7789 20.9006C17.7978 20.9272 17.8319 20.9387 17.8631 20.9291C19.8241 20.3225 21.8126 19.4073 23.8654 17.8997C23.8834 17.8864 23.8948 17.8664 23.8967 17.8445C24.3971 12.6676 23.0585 8.17065 20.3482 4.18415C20.3416 4.17083 20.3303 4.1613 20.317 4.15559ZM8.02002 15.117C6.8375 15.117 5.86313 14.0314 5.86313 12.6981C5.86313 11.3648 6.8186 10.2791 8.02002 10.2791C9.23087 10.2791 10.1958 11.3743 10.1769 12.6981C10.1769 14.0314 9.22141 15.117 8.02002 15.117ZM15.9947 15.117C14.8123 15.117 13.8379 14.0314 13.8379 12.6981C13.8379 11.3648 14.7933 10.2791 15.9947 10.2791C17.2056 10.2791 18.1705 11.3743 18.1516 12.6981C18.1516 14.0314 17.2056 15.117 15.9947 15.117Z"
          fill="#5865F2"
        />
      </g>
    </svg>
  )
}

export function IconDiscordColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M20.317 4.15559C18.7873 3.45371 17.147 2.93659 15.4319 2.64042C15.4007 2.6347 15.3695 2.64899 15.3534 2.67756C15.1424 3.05277 14.9087 3.54227 14.7451 3.92701C12.9004 3.65084 11.0652 3.65084 9.25832 3.92701C9.09465 3.53372 8.85248 3.05277 8.64057 2.67756C8.62449 2.64994 8.59328 2.63566 8.56205 2.64042C6.84791 2.93564 5.20756 3.45276 3.67693 4.15559C3.66368 4.1613 3.65233 4.17083 3.64479 4.18321C0.533392 8.83157 -0.31895 13.3657 0.0991801 17.8436C0.101072 17.8655 0.11337 17.8864 0.130398 17.8997C2.18321 19.4073 4.17171 20.3225 6.12328 20.9291C6.15451 20.9387 6.18761 20.9272 6.20748 20.9015C6.66913 20.2711 7.08064 19.6063 7.43348 18.9073C7.4543 18.8664 7.43442 18.8178 7.39186 18.8016C6.73913 18.554 6.1176 18.2521 5.51973 17.9093C5.47244 17.8817 5.46865 17.814 5.51216 17.7816C5.63797 17.6874 5.76382 17.5893 5.88396 17.4902C5.90569 17.4721 5.93598 17.4683 5.96153 17.4797C9.88928 19.273 14.1415 19.273 18.023 17.4797C18.0485 17.4674 18.0788 17.4712 18.1015 17.4893C18.2216 17.5883 18.3475 17.6874 18.4742 17.7816C18.5177 17.814 18.5149 17.8817 18.4676 17.9093C17.8697 18.2588 17.2482 18.554 16.5945 18.8007C16.552 18.8169 16.533 18.8664 16.5538 18.9073C16.9143 19.6054 17.3258 20.2701 17.7789 20.9006C17.7978 20.9272 17.8319 20.9387 17.8631 20.9291C19.8241 20.3225 21.8126 19.4073 23.8654 17.8997C23.8834 17.8864 23.8948 17.8664 23.8967 17.8445C24.3971 12.6676 23.0585 8.17065 20.3482 4.18415C20.3416 4.17083 20.3303 4.1613 20.317 4.15559ZM8.02002 15.117C6.8375 15.117 5.86313 14.0314 5.86313 12.6981C5.86313 11.3648 6.8186 10.2791 8.02002 10.2791C9.23087 10.2791 10.1958 11.3743 10.1769 12.6981C10.1769 14.0314 9.22141 15.117 8.02002 15.117ZM15.9947 15.117C14.8123 15.117 13.8379 14.0314 13.8379 12.6981C13.8379 11.3648 14.7933 10.2791 15.9947 10.2791C17.2056 10.2791 18.1705 11.3743 18.1516 12.6981C18.1516 14.0314 17.2056 15.117 15.9947 15.117Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconDiscover(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Discover">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Discover_2">
          <path id="Stripe" d="M15 23L34 17.25V20C34 21.6569 32.6569 23 31 23H15Z" fill="#FD6020" />
          <path
            id="DISC-VER"
            d="M15.1846 9.11092C15.5504 9.11092 15.9686 9.16456 16.2822 9.37947V10.4537C16.0209 10.1314 15.6026 9.91658 15.1846 9.91658C14.3484 9.97034 13.6694 10.723 13.7217 11.5826V11.69C13.7218 12.5495 14.4012 13.1939 15.2373 13.1939C15.6553 13.1938 16.021 12.9791 16.2822 12.6568V13.731C15.9165 13.8922 15.5508 13.9995 15.1328 13.9996C13.8263 13.9996 12.7804 12.8719 12.7803 11.5289C12.7803 10.132 13.8257 9.00351 15.1846 9.11092ZM23.3906 12.3345L24.6445 9.11092H25.585L23.6514 13.9996H23.1807L21.2471 9.11092H22.1885L23.3906 12.3345ZM11.0039 9.00349C11.4741 9.00363 11.9448 9.21834 12.3105 9.5406L11.8398 10.1851C11.6309 9.97037 11.3696 9.80932 11.1084 9.80916C10.7949 9.75544 10.5328 10.024 10.4805 10.3463C10.4805 10.6149 10.6377 10.7223 11.1602 10.9371C12.2055 11.3669 12.4673 11.6898 12.5195 12.3345V12.4957C12.4673 13.3553 11.7874 13.9996 10.9512 13.9459C10.324 13.9459 9.6964 13.6238 9.38281 13.0328L9.95801 12.442C10.1148 12.8181 10.4813 13.0865 10.8994 13.0865H10.9512C11.2647 13.0865 11.5781 12.7643 11.5781 12.3883C11.5781 12.1735 11.474 12.0123 11.3174 11.9049C11.1083 11.7974 10.8985 11.69 10.6895 11.6363C9.85346 11.3677 9.59277 10.9909 9.59277 10.3463V10.2926C9.64519 9.54053 10.2723 8.94977 11.0039 9.00349ZM5.56836 9.11092C6.82251 9.16486 7.81495 10.2396 7.7627 11.5289C7.7626 12.2272 7.44926 12.8716 6.92676 13.3551C6.45638 13.7311 5.88154 13.9459 5.30664 13.8922H4V9.11092H5.56836ZM9.01758 13.8922H8.12891V9.11092H9.01758V13.8922ZM28.5117 9.91658H26.8916V10.9908H28.46V11.7974H26.8916V13.0865H28.5117V13.8922H26.0039V9.11092H28.5117V9.91658ZM30.3936 9.11092C31.4387 9.11092 32.0135 9.59432 32.0137 10.5074C32.0659 11.2057 31.5958 11.7973 30.9688 11.9049L32.3799 13.8922H31.2822L30.0801 11.9586H29.9756V13.8922H29.0869V9.11092H30.3936ZM5.14941 9.91658H4.88867V13.0865H5.14941C5.56744 13.1402 6.03798 12.9791 6.35156 12.7105C6.66507 12.3882 6.82219 11.9586 6.82227 11.4752C6.82227 11.0454 6.66513 10.6149 6.35156 10.2926C6.03797 10.0241 5.56737 9.86287 5.14941 9.91658ZM29.9756 11.314H30.2363C30.8112 11.314 31.0732 11.0446 31.0732 10.5611C31.0731 10.1316 30.811 9.86287 30.2363 9.86287H29.9756V11.314Z"
            fill="black"
          />
          <path
            id="O"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9477 9C17.6411 9 16.5435 10.0745 16.5435 11.4714C16.5435 12.8146 17.5888 13.9429 18.9477 13.9966C20.3066 14.0503 21.3519 12.9221 21.4041 11.5252C21.3519 10.1283 20.3066 9 18.9477 9V9Z"
            fill="#FD6020"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDocs(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Docs">
        <g id="Layer_5">
          <path
            id="Vector"
            d="M18.1818 22H6.36364C5.61364 22 5 21.3864 5 20.6364V3.36364C5 2.61364 5.61364 2 6.36364 2H14.5455L19.5455 7V20.6364C19.5455 21.3864 18.9318 22 18.1818 22Z"
            fill="#3086F6"
          />
          <path id="Vector_2" d="M14.5454 2L19.5454 7H14.5454V2Z" fill="#0C67D6" />
          <path
            id="Vector_3"
            d="M16.3635 10.8637H8.18164V9.72729H16.3635V10.8637ZM16.3635 12.4546H8.18164V13.5909H16.3635V12.4546ZM14.0907 15.1818H8.18164V16.3182H14.0907V15.1818Z"
            fill="#FDFFFF"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconDribbbleColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57969 18.4203 0.375 12 0.375C5.57969 0.375 0.375 5.57969 0.375 12C0.375 18.4203 5.57969 23.625 12 23.625Z"
          fill="#EA4C89"
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C5.37527 0 0 5.37527 0 12C0 18.6248 5.37527 24 12 24C18.6117 24 24 18.6248 24 12C24 5.37527 18.6117 0 12 0ZM19.9262 5.53145C21.3579 7.27549 22.2169 9.50107 22.243 11.9089C21.9046 11.8438 18.5206 11.154 15.1106 11.5835C15.0325 11.4143 14.9675 11.2321 14.8894 11.0499C14.6811 10.5554 14.4469 10.0478 14.2126 9.56618C17.9869 8.0304 19.705 5.81779 19.9262 5.53145ZM12 1.77007C14.603 1.77007 16.9848 2.74621 18.7939 4.34707C18.6117 4.60738 17.0629 6.67679 13.4186 8.04338C11.7397 4.95878 9.87855 2.43384 9.5922 2.04338C10.3601 1.86117 11.1671 1.77007 12 1.77007ZM7.63995 2.73319C7.91325 3.09761 9.73538 5.63558 11.4404 8.65508C6.65076 9.9306 2.42083 9.90458 1.96529 9.90458C2.62907 6.72885 4.77657 4.08676 7.63995 2.73319ZM1.74404 12.0131C1.74404 11.9089 1.74404 11.8048 1.74404 11.7007C2.18655 11.7136 7.15835 11.7788 12.2733 10.243C12.5727 10.8156 12.846 11.4013 13.1063 11.9869C12.9761 12.026 12.8329 12.0651 12.7028 12.1041C7.41865 13.8091 4.60738 18.4685 4.3731 18.859C2.7462 17.0499 1.74404 14.6421 1.74404 12.0131ZM12 22.256C9.6312 22.256 7.44469 21.449 5.71367 20.0954C5.89588 19.718 7.97827 15.7094 13.757 13.692C13.783 13.679 13.7961 13.679 13.8221 13.666C15.2668 17.4013 15.8525 20.5379 16.0087 21.436C14.7722 21.9696 13.4186 22.256 12 22.256ZM17.7136 20.4989C17.6096 19.8742 17.0629 16.8807 15.7223 13.1974C18.9371 12.6898 21.7484 13.5228 22.0998 13.6399C21.6573 16.4902 20.0173 18.9501 17.7136 20.4989Z"
          fill="#C32361"
        />
      </g>
    </svg>
  )
}

export function IconDribbbleColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C5.37527 0 0 5.37527 0 12C0 18.6248 5.37527 24 12 24C18.6117 24 24 18.6248 24 12C24 5.37527 18.6117 0 12 0ZM19.9262 5.53145C21.3579 7.27549 22.217 9.50107 22.243 11.9089C21.9046 11.8439 18.5206 11.154 15.1106 11.5835C15.0325 11.4143 14.9675 11.2321 14.8894 11.0499C14.6811 10.5554 14.4469 10.0477 14.2126 9.56618C17.9869 8.0304 19.705 5.81779 19.9262 5.53145ZM12 1.77007C14.603 1.77007 16.9848 2.74621 18.7939 4.34707C18.6117 4.60738 17.0629 6.67679 13.4186 8.04338C11.7397 4.95878 9.87855 2.43384 9.5922 2.04338C10.3601 1.86117 11.1671 1.77007 12 1.77007ZM7.63995 2.73319C7.91325 3.09761 9.73538 5.63558 11.4404 8.65508C6.65076 9.9306 2.42083 9.90458 1.96529 9.90458C2.62907 6.72885 4.77657 4.08676 7.63995 2.73319ZM1.74404 12.0131C1.74404 11.9089 1.74404 11.8048 1.74404 11.7007C2.18655 11.7136 7.15835 11.7787 12.2733 10.243C12.5727 10.8156 12.846 11.4013 13.1063 11.9869C12.9761 12.026 12.8329 12.0651 12.7028 12.1041C7.41865 13.8091 4.60738 18.4685 4.3731 18.859C2.7462 17.0499 1.74404 14.6421 1.74404 12.0131ZM12 22.256C9.6312 22.256 7.44469 21.449 5.71367 20.0954C5.89588 19.718 7.97827 15.7094 13.757 13.692C13.783 13.679 13.7961 13.679 13.8221 13.666C15.2668 17.4013 15.8525 20.5379 16.0087 21.436C14.7722 21.9696 13.4186 22.256 12 22.256ZM17.7136 20.4989C17.6096 19.8742 17.0629 16.8807 15.7223 13.1974C18.9371 12.6898 21.7484 13.5228 22.0998 13.6399C21.6573 16.4902 20.0173 18.9501 17.7136 20.4989Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconElo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Elo">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Elo_2">
          <path
            id="Elo_3"
            d="M11.9176 12.5556C11.637 13.9082 10.4187 14.9254 8.95846 14.9254C8.62344 14.9254 8.30095 14.8717 8.00007 14.7727L7.32935 16.7407C7.84122 16.909 8.38889 17 8.95846 17C11.4405 17 13.511 15.2704 13.9881 12.9719L11.9176 12.5556Z"
            fill="#EC412A"
          />
          <path
            id="Elo_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.9526 8.11116V13.8014L24.9737 14.2107L24.4906 15.3331L23.4808 14.9272C23.2538 14.8319 23.1001 14.6869 22.9833 14.523C22.8712 14.3554 22.7881 14.1263 22.7881 13.8171V8.11116H23.9526ZM16.208 12.3404C16.2334 10.7131 17.6192 9.41419 19.3007 9.43911C20.7279 9.46076 21.9105 10.4274 22.2211 11.7131L16.7011 13.9945C16.3804 13.5205 16.1982 12.9502 16.208 12.3404ZM17.471 12.5685C17.4635 12.5002 17.4581 12.4302 17.4601 12.3596C17.476 11.4009 18.2918 10.6359 19.2826 10.6518C19.8218 10.6587 20.3006 10.8975 20.6243 11.2671L17.471 12.5685ZM20.5081 13.6249C20.1754 13.9378 19.7243 14.1285 19.2262 14.1216C18.8847 14.1161 18.5684 14.0173 18.2994 13.8526L17.6325 14.88C18.0892 15.1592 18.6277 15.3243 19.2082 15.333C20.0533 15.3452 20.8235 15.0242 21.3835 14.4941L20.5081 13.6249ZM28.2025 10.6517C28.0036 10.6517 27.8124 10.6828 27.6338 10.7407L27.2365 9.58939C27.5397 9.49147 27.8645 9.43828 28.2025 9.43828C29.6773 9.43828 30.9077 10.4513 31.1898 11.7971L29.9598 12.0396C29.7941 11.2476 29.0703 10.6517 28.2025 10.6517ZM26.183 14.5936L27.0141 13.6848C26.6429 13.367 26.4092 12.9029 26.4092 12.3856C26.4092 11.8688 26.6429 11.4049 27.0138 11.0874L26.1821 10.1786C25.5515 10.7186 25.1543 11.5076 25.1543 12.3856C25.1543 13.2647 25.5518 14.0534 26.183 14.5936ZM28.2024 14.1201C29.0694 14.1201 29.7931 13.5248 29.9598 12.7339L31.1894 12.9774C30.9059 14.3217 29.6759 15.3334 28.2024 15.3334C27.8642 15.3334 27.539 15.28 27.2349 15.1817L27.6332 14.0307C27.8121 14.0885 28.0034 14.1201 28.2024 14.1201Z"
            fill="black"
          />
          <path
            id="Elo_5"
            d="M5.53441 15.8889L6.77447 14.2878C6.22095 13.7279 5.87158 12.9105 5.87158 11.9994C5.87158 11.089 6.22062 10.2716 6.77399 9.71214L5.53327 8.11116C4.59271 9.06238 4 10.4518 4 11.9994C4 13.5478 4.59358 14.9377 5.53441 15.8889Z"
            fill="#1BA7DE"
          />
          <path
            id="Elo_6"
            d="M7.99912 9.22531C8.29998 9.12667 8.62183 9.07312 8.95671 9.07312C10.4182 9.07312 11.6373 10.0915 11.917 11.4444L13.9881 11.0302C13.5129 8.73084 11.4411 7 8.95671 7C8.38792 7 7.84043 7.0909 7.32935 7.25834L7.99912 9.22531Z"
            fill="#FECA2F"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEtherium(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Etherium">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Etherium_2">
          <circle id="Ellipse 1" cx="17.435" cy="11.935" r="7.93499" fill="#6481E7" />
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5281 6.35181V14.362L21.0874 12.2578L17.5281 6.35181Z"
            fill="#C1CCF5"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9684 12.2578L17.5278 14.362V6.35181L13.9684 12.2578Z"
            fill="white"
          />
          <path
            id="Vector_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.528 10.6401L13.9684 12.2577L17.5278 14.3619L21.0874 12.258L17.528 10.6401Z"
            fill="#8299EC"
          />
          <path
            id="Vector_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.528 10.6401L13.9684 12.2577L17.5278 14.3619L17.528 10.6401Z"
            fill="#C1CCF5"
          />
          <path
            id="Vector_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5281 15.0359V17.9491L21.0898 12.9329L17.5281 15.0359Z"
            fill="#C1CCF5"
          />
          <path
            id="Vector_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9684 12.9329L17.5278 17.9488V15.0359L13.9684 12.9329Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconEtsyColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5081)">
        <g id="Group">
          <path
            id="path2"
            d="M9.16615 1.87285C8.6092 1.87285 8.57644 2.06949 8.57644 2.39723V11.2134C8.57644 11.2134 11.7543 11.2462 13.4251 11.0823C14.7028 10.9512 14.8994 10.7218 15.1942 9.4764L15.6529 7.57551H17.0616L16.8651 11.9017L16.9633 16.1951H15.5546L15.1615 14.4908C14.8666 13.2126 14.3097 12.9504 13.3924 12.8849C12.2129 12.7866 8.57644 12.7866 8.57644 12.7866V20.259C8.57644 21.6683 9.36271 22.3238 11.0008 22.3238H15.8822C17.5203 22.3238 18.9945 22.1599 20.0101 19.8657L21.2878 16.9489H22.5C22.4017 17.5388 21.7465 22.8809 21.6482 24.0608C21.6482 24.0608 17.1599 23.8969 15.227 23.8969H6.64353L1.5 24.0608V22.6843L3.23635 22.3566C4.44852 22.1271 4.84165 21.7666 4.84165 20.7834C4.84165 20.7834 4.93994 17.5388 4.93994 12.1311C4.93994 6.72339 4.84165 3.446 4.84165 3.446C4.74337 2.33168 4.44852 2.06949 3.23635 1.84007L1.5 1.51233V0.13583L6.64353 0.299698H16.2426C18.1427 0.299698 21.3534 -0.0608139 21.3534 -0.0608139C21.3534 -0.0608139 21.1568 2.00394 20.9275 6.75616H19.6498L19.2239 5.0847C18.6997 2.98716 17.9789 1.87285 16.6685 1.87285H9.16615Z"
            fill="#F56400"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_634_5081">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconEtsyColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_4933)">
        <g id="Group">
          <path
            id="path2"
            d="M9.16615 1.87285C8.6092 1.87285 8.57644 2.0695 8.57644 2.39724V11.2134C8.57644 11.2134 11.7543 11.2462 13.4251 11.0823C14.7028 10.9512 14.8994 10.7218 15.1942 9.47641L15.6529 7.57552H17.0616L16.8651 11.9017L16.9633 16.1951H15.5546L15.1615 14.4908C14.8666 13.2126 14.3097 12.9504 13.3924 12.8849C12.2129 12.7866 8.57644 12.7866 8.57644 12.7866V20.259C8.57644 21.6683 9.36271 22.3238 11.0008 22.3238H15.8822C17.5203 22.3238 18.9945 22.1599 20.0101 19.8657L21.2878 16.9489H22.5C22.4017 17.5388 21.7465 22.881 21.6482 24.0608C21.6482 24.0608 17.1599 23.8969 15.227 23.8969H6.64353L1.5 24.0608V22.6843L3.23635 22.3566C4.44852 22.1272 4.84165 21.7666 4.84165 20.7834C4.84165 20.7834 4.93994 17.5388 4.93994 12.1311C4.93994 6.7234 4.84165 3.446 4.84165 3.446C4.74337 2.33169 4.44852 2.0695 3.23635 1.84008L1.5 1.51234V0.135838L6.64353 0.299706H16.2426C18.1427 0.299706 21.3534 -0.0608063 21.3534 -0.0608063C21.3534 -0.0608063 21.1568 2.00395 20.9275 6.75617H19.6498L19.2239 5.0847C18.6997 2.98717 17.9789 1.87285 16.6685 1.87285H9.16615Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_633_4933">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconFacebookColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_633_4949)">
        <path
          id="c"
          d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24 18.1354 24 12Z"
          fill="#0866FF"
        />
        <path
          id="d"
          d="M16.7001 15.6672L17.3735 12H13.4539V10.703C13.4539 8.76528 14.2142 8.01984 16.1817 8.01984C16.7927 8.01984 17.2847 8.03472 17.5679 8.06448V4.74048C17.0313 4.5912 15.7195 4.4424 14.9591 4.4424C10.9492 4.4424 9.10074 6.33552 9.10074 10.4198V12H6.62634V15.6672H9.10074V23.6467C10.0291 23.8771 11.0001 24 11.9995 24C12.4915 24 12.9767 23.9698 13.4534 23.9122V15.6672H16.6996H16.7001Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_4949">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconFacebookColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_268)">
        <path
          id="Vector"
          d="M12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12C24 5.37264 18.6274 0 12 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_268">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconFacebookPay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="FacebookPay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="FacebookPay_2">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.79201 7H8.82038V7.72089H8.79201C6.96333 7.72089 5.41592 8.92513 4.9012 10.5847L4.21301 10.3661C4.82095 8.41539 6.64072 7 8.79201 7Z"
            fill="url(#paint0_linear_647_2948)"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.82085 7.72089V7H8.79248C10.9503 7 12.7757 8.42529 13.3772 10.3859L12.6898 10.6053C12.184 8.9441 10.6447 7.73327 8.82085 7.72089Z"
            fill="url(#paint1_linear_647_2948)"
          />
          <path
            id="Vector_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1857 15.0882L11.6096 15.6722C10.7874 16.269 9.80202 16.5886 8.79203 16.5861C7.79767 16.5887 6.82673 16.2791 6.01172 15.6994L6.43647 15.1154C7.10115 15.588 7.91416 15.866 8.79203 15.866C9.68692 15.866 10.5137 15.5773 11.1857 15.0882Z"
            fill="url(#paint2_linear_647_2948)"
          />
          <path
            id="Vector_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.21399 10.3661L4.90137 10.5847C4.78017 10.9756 4.71866 11.3831 4.71899 11.793C4.71899 13.1647 5.39664 14.378 6.43662 15.1154L6.01269 15.6994C4.8349 14.8605 4.0535 13.5029 4 11.9613V11.6256C4.0154 11.1884 4.08916 10.7661 4.21399 10.3661Z"
            fill="url(#paint3_linear_647_2948)"
          />
          <path
            id="Vector_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5868 11.793C13.5868 13.3882 12.8087 14.8003 11.609 15.6722L11.1851 15.089C11.7034 14.7161 12.1265 14.2222 12.4189 13.6488C12.7112 13.0754 12.8643 12.439 12.8654 11.793C12.8654 11.379 12.8038 10.9789 12.6887 10.6028L13.3761 10.3834C13.5139 10.8288 13.5868 11.3023 13.5868 11.7939V11.793Z"
            fill="url(#paint4_linear_647_2948)"
          />
          <path
            id="Vector_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0375 12.5049C11.0375 12.2553 10.8633 12.1434 10.4766 12.1434H9.52417V12.8648H10.4766C10.8697 12.8648 11.0375 12.757 11.0375 12.5049ZM10.3429 10.9924H9.52417V11.7138H10.3429C10.7133 11.7138 10.8811 11.6019 10.8811 11.3547C10.8811 11.1067 10.7109 10.9924 10.3429 10.9924ZM11.5377 12.5503C11.5377 13.0318 11.1534 13.3058 10.4758 13.3058H9.07592C9.0516 13.3058 9.03539 13.2896 9.03539 13.2661V10.5911C9.03539 10.5676 9.0516 10.5522 9.07592 10.5522H10.3526C11.0116 10.5522 11.3739 10.8059 11.3739 11.2639C11.3739 11.5355 11.2523 11.7535 10.9014 11.8581C11.3456 11.9505 11.5255 12.2123 11.5377 12.5503ZM8.45339 10.5911V10.9648C8.45339 10.9891 8.43717 11.0045 8.41286 11.0045H6.79168V11.7025H8.13726C8.16157 11.7025 8.17698 11.7187 8.17698 11.7422V12.115C8.17698 12.1394 8.16076 12.1556 8.13645 12.1556H6.79249V13.2661C6.79249 13.2904 6.77628 13.3058 6.75197 13.3058H6.34424C6.31992 13.3058 6.30371 13.2896 6.30371 13.2661V10.5911C6.30371 10.5676 6.31992 10.5522 6.34424 10.5522H8.41367C8.43798 10.5522 8.4542 10.5684 8.4542 10.5911H8.45339Z"
            fill="#64717D"
          />
          <path
            id="Vector_7"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.2918 10.1804C27.6894 11.4052 28.146 12.6101 28.6601 13.7908L29.9165 10.1804H30.9208L29.1205 14.8446C28.8903 15.442 28.6171 15.9024 28.301 16.2266C27.9848 16.5508 27.5609 16.713 27.03 16.713C26.8979 16.713 26.773 16.7024 26.6571 16.6813V15.8667C26.7544 15.8821 26.8411 15.8894 26.9141 15.8894C27.2367 15.8894 27.4993 15.8002 27.702 15.6203C27.9046 15.4411 28.0829 15.1777 28.2361 14.8308C27.8558 14.08 27.5011 13.3165 27.1726 12.5417C26.8412 11.7608 26.525 10.9736 26.2243 10.1804H27.2918ZM23.5631 10.0718C24.1273 10.0718 24.5812 10.2315 24.9249 10.5509C25.2694 10.8711 25.4412 11.3493 25.4412 11.9856V14.7035H24.5577V13.9659C24.3794 14.2318 24.15 14.436 23.8711 14.5795C23.5752 14.7265 23.2482 14.8002 22.9179 14.7943C22.4323 14.7943 22.0554 14.6711 21.7871 14.4255C21.5188 14.1799 21.3842 13.8556 21.3842 13.4552C21.3842 13.0572 21.5358 12.7233 21.8382 12.4549C22.1405 12.1875 22.6228 12.0521 23.2859 12.0521H24.5382V12.0391C24.5382 11.2788 24.1824 10.8986 23.4707 10.8986C23.1724 10.8986 22.9219 10.9513 22.7168 11.0575C22.5134 11.1629 22.348 11.3104 22.2224 11.5009L21.5918 10.9983C21.7879 10.7 22.0465 10.4706 22.3675 10.3109C22.7085 10.1465 23.0833 10.0643 23.4618 10.071H23.5623L23.5631 10.0718ZM18.3316 8.37122C19.1389 8.37122 19.742 8.56008 20.1408 8.93863C20.5396 9.31717 20.7398 9.83027 20.7398 10.4787C20.7398 11.1248 20.5396 11.6379 20.1408 12.0172C19.742 12.3974 19.1389 12.5871 18.3316 12.5871H16.6002V14.7043H15.6323V8.37122H18.3308H18.3316ZM24.5382 12.7638H23.3224C22.9608 12.7638 22.7023 12.8205 22.5466 12.934C22.4728 12.9851 22.413 13.0539 22.3725 13.134C22.332 13.2141 22.3122 13.3031 22.3148 13.3928C22.3148 13.79 22.5823 13.9894 23.1205 13.9894C23.4764 13.9894 23.7722 13.9108 24.0089 13.7519C24.2456 13.5938 24.4223 13.379 24.5382 13.1075V12.7638ZM18.24 9.25719H16.6002V11.7003H18.2392C18.7644 11.7003 19.147 11.599 19.3886 11.3947C19.6293 11.1921 19.7493 10.8865 19.7493 10.4787C19.7493 10.0718 19.6293 9.76623 19.3886 9.56278C19.147 9.35932 18.7644 9.25719 18.2392 9.25719H18.24Z"
            fill="#1B2529"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_647_2948"
          x1="8.82038"
          y1="7.93287"
          x2="5.13067"
          y2="10.6083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#24D365" />
          <stop offset="1" stopColor="#139DBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_647_2948"
          x1="8.79248"
          y1="7.90895"
          x2="12.493"
          y2="10.5998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23D068" />
          <stop offset="0.52" stopColor="#EACD36" />
          <stop offset="1" stopColor="#FF6C5C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_647_2948"
          x1="6.22328"
          y1="15.4165"
          x2="11.3908"
          y2="15.4165"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#266FF3" />
          <stop offset="1" stopColor="#C439D6" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_647_2948"
          x1="5.4242"
          y1="15.4313"
          x2="3.87373"
          y2="10.9078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#266FF3" />
          <stop offset="1" stopColor="#149FBA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_647_2948"
          x1="12.5282"
          y1="10.4981"
          x2="10.9744"
          y2="15.0025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C5C" />
          <stop offset="1" stopColor="#C439D6" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconFigma(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Figma">
        <g id="Group 65">
          <g id="Layer 2">
            <g id="Layer 1">
              <g id="Layer 2_2">
                <g id="Surfaces">
                  <g id="Utility Surface">
                    <g id="Outline no shadow">
                      <path
                        id="Vector"
                        d="M5.54167 1.99998H18.4583C18.9236 1.99953 19.3843 2.09318 19.8142 2.27557C20.2441 2.45796 20.6347 2.72551 20.9636 3.06291C21.2926 3.4003 21.5535 3.80092 21.7313 4.24184C21.9091 4.68275 22.0004 5.15531 22 5.63246V18.3675C22.0004 18.8447 21.9091 19.3172 21.7313 19.7581C21.5535 20.199 21.2926 20.5997 20.9636 20.9371C20.6347 21.2745 20.2441 21.542 19.8142 21.7244C19.3843 21.9068 18.9236 22.0004 18.4583 22H5.54167C5.07645 22.0004 4.6157 21.9068 4.18581 21.7244C3.75592 21.542 3.36532 21.2745 3.03635 20.9371C2.70739 20.5997 2.44653 20.199 2.2687 19.7581C2.09087 19.3172 1.99956 18.8447 2 18.3675V5.63246C1.99956 5.15531 2.09087 4.68275 2.2687 4.24184C2.44653 3.80092 2.70739 3.4003 3.03635 3.06291C3.36532 2.72551 3.75592 2.45796 4.18581 2.27557C4.6157 2.09318 5.07645 1.99953 5.54167 1.99998Z"
                        fill="#000B1D"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Group">
            <g id="5">
              <g id="path1_fill-link">
                <path
                  id="path1_fill"
                  d="M9.91658 18.4103C11.0672 18.4103 11.9999 17.4536 11.9999 16.2735V14.1367H9.91658C8.76599 14.1367 7.83325 15.0934 7.83325 16.2735C7.83325 17.4536 8.76599 18.4103 9.91658 18.4103Z"
                  fill="#0ACF83"
                />
              </g>
            </g>
            <g id="4">
              <g id="path2_fill-link">
                <path
                  id="path2_fill"
                  d="M7.83325 12C7.83325 10.8199 8.76599 9.86325 9.91658 9.86325H11.9999V14.1368H9.91658C8.76599 14.1368 7.83325 13.1801 7.83325 12Z"
                  fill="#A259FF"
                />
              </g>
            </g>
            <g id="3">
              <g id="path2_fill-link_2">
                <path
                  id="path2_fill_2"
                  d="M7.83325 7.7265C7.83325 6.5464 8.76599 5.58974 9.91658 5.58974H11.9999V9.86325H9.91658C8.76599 9.86325 7.83325 8.90659 7.83325 7.7265Z"
                  fill="#F24E1E"
                />
              </g>
            </g>
            <g id="2">
              <g id="path3_fill-link">
                <path
                  id="path3_fill"
                  d="M12 5.58974H14.0833C15.2339 5.58974 16.1667 6.5464 16.1667 7.7265C16.1667 8.90659 15.2339 9.86325 14.0833 9.86325H12V5.58974Z"
                  fill="#FF7262"
                />
              </g>
            </g>
            <g id="1">
              <g id="path4_fill-link">
                <path
                  id="path4_fill"
                  d="M16.1667 12C16.1667 13.1801 15.2339 14.1368 14.0833 14.1368C12.9327 14.1368 12 13.1801 12 12C12 10.8199 12.9327 9.86325 14.0833 9.86325C15.2339 9.86325 16.1667 10.8199 16.1667 12Z"
                  fill="#1ABCFE"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconFigmaColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M8.00006 24C10.2081 24 12.0001 22.208 12.0001 20V15.9999H8.00006C5.79205 15.9999 4 17.792 4 20C4 22.208 5.79205 24 8.00006 24Z"
          fill="#0ACF83"
        />
        <path
          id="Vector_2"
          d="M4 12C4 9.79199 5.79205 7.99995 8.00006 7.99995H12.0001V15.9999H8.00006C5.79205 16 4 14.208 4 12Z"
          fill="#A259FF"
        />
        <path
          id="Vector_3"
          d="M4 4.00003C4 1.79203 5.79205 0 8.00006 0H12.0001V7.99997H8.00006C5.79205 7.99997 4 6.20803 4 4.00003Z"
          fill="#F24E1E"
        />
        <path
          id="Vector_4"
          d="M12 0H16.0001C18.2081 0 20.0001 1.79203 20.0001 4.00003C20.0001 6.20803 18.2081 7.99997 16.0001 7.99997H12V0Z"
          fill="#FF7262"
        />
        <path
          id="Vector_5"
          d="M20.0001 12C20.0001 14.208 18.2081 16 16.0001 16C13.792 16 12 14.208 12 12C12 9.79197 13.792 7.99994 16.0001 7.99994C18.2081 7.99994 20.0001 9.79197 20.0001 12Z"
          fill="#1ABCFE"
        />
      </g>
    </svg>
  )
}

export function IconFigmaColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.16003 0H15.8399C18.2247 0 20.16 1.93525 20.16 4.32003C20.16 5.99123 19.2096 7.44161 17.8201 8.15996C19.2096 8.87835 20.16 10.3288 20.16 12C20.16 14.3848 18.2247 16.32 15.8399 16.32C14.4834 16.32 13.2723 15.6938 12.4801 14.7149V19.68C12.4801 22.0648 10.5448 24 8.16003 24C5.77524 24 3.83997 22.0648 3.83997 19.68C3.83997 18.0088 4.79035 16.5583 6.17982 15.84C4.79035 15.1216 3.83997 13.6712 3.83997 12C3.83997 10.3288 4.79034 8.87835 6.1798 8.15996C4.79035 7.44161 3.83997 5.99123 3.83997 4.32003C3.83997 1.93525 5.77524 0 8.16003 0ZM4.79997 4.32003C4.79997 2.46545 6.30542 0.96 8.16003 0.96H11.5198V7.67994H8.16003L8.14961 7.67995C6.29977 7.67433 4.79997 6.17112 4.79997 4.32003ZM11.5201 11.9543C11.5199 11.9695 11.5198 11.9847 11.5198 12C11.5198 12.0152 11.5199 12.0304 11.5201 12.0457V15.3599H8.16C6.30542 15.36 4.79997 13.8546 4.79997 12C4.79997 10.1488 6.29984 8.64553 8.1497 8.63996L8.16003 8.63997H11.5198L11.5201 11.9543ZM12.4801 12.0402V11.9597C12.5016 10.1282 13.9913 8.64734 15.8261 8.63997H15.8399C15.8434 8.63997 15.8468 8.63996 15.8502 8.63996C17.7001 8.64553 19.2 10.1488 19.2 12C19.2 13.8546 17.6945 15.36 15.8399 15.36C13.9987 15.36 12.5017 13.8763 12.4801 12.0402ZM13.1252 8.63997C12.8882 8.83174 12.6719 9.04806 12.4801 9.28506V8.63997H13.1252ZM15.8503 7.67995C15.8469 7.67994 15.8434 7.67994 15.8399 7.67994C15.8347 7.67994 15.8294 7.67995 15.8242 7.67997H12.4801V0.96H15.8399C17.6945 0.96 19.2 2.46545 19.2 4.32003C19.2 6.17112 17.7002 7.67433 15.8503 7.67995ZM8.16003 16.3199C6.30542 16.3199 4.79997 17.8254 4.79997 19.68C4.79997 21.5345 6.30542 23.04 8.16003 23.04C10.0146 23.04 11.5201 21.5345 11.5201 19.68V16.3199H8.16003Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconForbrugsforeningen(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Forbrugsforeningen">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Forbrugsforeningen_2"
          d="M20.9395 4.84666C23.2996 5.47521 24.3223 7.04636 24.5664 10.2734C24.6415 11.2644 24.633 11.9285 24.6328 11.9433C24.6328 11.9433 24.6424 12.612 24.5664 13.6142C24.2341 18.0068 22.4627 19.3334 17.832 19.3867C17.7607 19.3872 17.3572 19.3872 17.2861 19.3867C16.483 19.3773 15.7684 19.3293 15.1299 19.2344C15.1523 19.2341 15.1746 19.234 15.1973 19.2324C16.0351 19.1841 17.2014 18.5372 17.8955 17.0342C18.1956 16.3832 18.2787 15.227 18.2803 15.2041V12.707H20.9395V10.2383H18.2803C18.2803 10.2383 18.2792 10.2351 18.2783 10.2305L18.2773 10.2275C18.2759 10.2231 18.2757 10.2181 18.2734 10.2109C18.2732 10.2089 18.2717 10.2057 18.2715 10.2031C18.2696 10.196 18.2679 10.1891 18.2666 10.1797C18.2655 10.1758 18.2655 10.1705 18.2646 10.166C18.2629 10.1567 18.2612 10.1468 18.2598 10.1357C18.2585 10.1305 18.2582 10.1239 18.2578 10.1181C18.256 10.1064 18.2554 10.0944 18.2539 10.081C18.2535 10.0745 18.2526 10.0671 18.252 10.0605C18.2511 10.0464 18.2502 10.0324 18.25 10.0166V9.94041C18.25 9.93285 18.2507 9.92413 18.251 9.916C18.2514 9.89622 18.2518 9.87638 18.2539 9.85448C18.2544 9.8479 18.2554 9.84001 18.2559 9.83299C18.258 9.80924 18.261 9.78527 18.2646 9.75975C18.2651 9.75495 18.2671 9.74979 18.2676 9.7451C18.272 9.71605 18.2768 9.68632 18.2832 9.65526V9.65233C18.3282 9.43662 18.4243 9.17086 18.6172 8.8701C19.136 8.0629 20.6094 8.10121 20.8926 8.1162C20.9215 8.11794 20.9383 8.11907 20.9395 8.11913V4.84666ZM15.1787 14.4404C15.1822 14.5783 15.1469 15.0465 14.7441 15.5498C14.2194 16.2061 13.4619 16.1572 13.4619 16.1572H13.4629V18.8056C11.6071 18.0564 10.7699 16.4947 10.5518 13.6142C10.5254 13.2672 10.5098 12.9617 10.5 12.709L15.1973 12.707C15.1968 12.7649 15.1771 14.399 15.1787 14.4404ZM17.832 4.49998C18.4168 4.50669 18.9556 4.53413 19.4521 4.58495C19.416 4.58617 19.3806 4.58748 19.3408 4.59178C18.9342 4.63212 17.4035 4.56264 16.0156 6.23924C15.2702 7.14071 15.1963 10.2392 15.1963 10.2392H10.5547C10.8941 5.87431 12.6674 4.55306 17.2861 4.49998H17.832Z"
          fill="#659AD2"
        />
      </g>
    </svg>
  )
}

export function IconGiropay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Giropay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="giropay">
          <path
            id="Subtract"
            d="M28.7418 7C29.8258 7.00016 30.7041 7.7774 30.7047 8.7373V15.3428C30.7043 16.3025 29.8259 17.0797 28.7418 17.0801H6.36292C5.27873 17.0797 4.40044 16.3025 4.40002 15.3428V8.7373C4.40061 7.7774 5.27884 7.00016 6.36292 7H28.7418ZM6.36292 7.74316C5.74248 7.74415 5.24031 8.18812 5.23889 8.7373V15.3428C5.23967 15.686 5.43628 15.9882 5.73499 16.167C5.88425 16.2563 6.05899 16.3148 6.24768 16.332L6.36292 16.3379H18.0563V7.74316H6.36292Z"
            fill="#0F3365"
          />
          <path
            id="Union"
            d="M27.408 12.3743H27.4188L28.0027 10.7318H28.9852L27.9432 13.0745C27.6652 13.7067 27.4518 14.3206 26.5516 14.3206C26.3444 14.3206 26.143 14.3007 25.9412 14.262L26.0067 13.6009C26.1373 13.6399 26.2576 13.6536 26.3943 13.6536C26.6339 13.6536 26.819 13.5281 26.8895 13.306L25.7391 10.7318H26.7977L27.408 12.3743ZM20.9627 10.6741C21.7481 10.6741 22.1783 11.3355 22.1785 11.9437C22.1785 12.6874 21.7261 13.306 20.8807 13.306C20.5371 13.306 20.1658 13.1952 19.9803 12.8958H19.9695V14.262H18.9881V10.7318H19.8934V11.1859H19.9041C20.1004 10.8333 20.5155 10.6742 20.9627 10.6741ZM24.1678 10.7562C24.8932 10.7562 25.5203 11.0313 25.5203 11.7991V12.7357C25.5203 12.9338 25.5315 13.1324 25.575 13.3304H24.6746C24.6693 13.1955 24.6531 13.0643 24.6531 12.9339H24.6424C24.4189 13.2477 24.1457 13.388 23.742 13.388C23.1802 13.3879 22.6785 13.1418 22.6785 12.596C22.6786 11.8283 23.6226 11.7366 24.1463 11.7366C24.3044 11.7367 24.479 11.7513 24.6043 11.7708C24.5989 11.4279 24.3095 11.3353 23.9549 11.3353C23.6389 11.3353 23.3225 11.3888 23.0496 11.5238L23.033 10.9349C23.3821 10.8091 23.7476 10.7562 24.1678 10.7562ZM24.1893 12.2005C23.8565 12.2005 23.5945 12.2921 23.5945 12.5335C23.5946 12.707 23.7691 12.8088 23.9979 12.8089C24.3691 12.8089 24.6043 12.5087 24.6043 12.2142C24.4789 12.2094 24.3366 12.2005 24.1893 12.2005ZM20.5701 11.3402C20.21 11.3402 19.9695 11.6208 19.9695 11.9974C19.9696 12.3645 20.2427 12.64 20.5701 12.64C20.9408 12.64 21.1649 12.3641 21.1649 11.9632C21.1647 11.63 20.9516 11.3402 20.5701 11.3402Z"
            fill="#FFFFFE"
          />
          <path
            id="Union_2"
            d="M7.91266 10.6743C8.33235 10.6744 8.67021 10.8772 8.8775 11.186H8.88824V10.7319H9.77789V12.9536C9.77789 13.9869 9.2105 14.3208 8.065 14.3208C7.59598 14.3208 7.20824 14.2328 6.97906 14.1606L7.02887 13.4751C7.32877 13.6055 7.57973 13.6831 7.98883 13.6831C8.55609 13.683 8.8609 13.4461 8.8609 12.9536V12.8178H8.85016C8.6158 13.1128 8.28873 13.2475 7.89606 13.2475C7.11598 13.2475 6.63046 12.7269 6.63043 11.9829C6.63043 11.2343 7.02912 10.6743 7.91266 10.6743ZM15.8619 10.6743C16.7996 10.6744 17.5142 11.1571 17.5142 11.9926C17.5142 12.8231 16.7996 13.306 15.8619 13.3061C14.9237 13.3061 14.2086 12.8233 14.2086 11.9926C14.2086 11.157 14.9237 10.6743 15.8619 10.6743ZM11.4371 13.2475H10.4556V10.7319H11.4371V13.2475ZM13.8384 10.6743C13.9526 10.6743 14.0724 10.6884 14.1705 10.7026L14.1216 11.4272C14.0129 11.3984 13.9038 11.3989 13.7896 11.3989C13.3315 11.3989 13.0748 11.6933 13.0748 12.186V13.2475H12.0923V10.7319H12.9869V11.1958H12.9976C13.1668 10.8772 13.413 10.6743 13.8384 10.6743ZM15.8619 11.2827C15.4091 11.2827 15.2232 11.6159 15.2232 11.9926C15.2232 12.3645 15.4091 12.6977 15.8619 12.6977C16.3142 12.6975 16.4996 12.3644 16.4996 11.9926C16.4996 11.616 16.3142 11.2829 15.8619 11.2827ZM8.20172 11.3403C7.83626 11.3403 7.64511 11.6255 7.64508 11.9682C7.64508 12.3593 7.90718 12.5815 8.20172 12.5815C8.55056 12.5814 8.82867 12.3205 8.82867 11.9341C8.82848 11.654 8.64302 11.3404 8.20172 11.3403ZM11.4371 10.3217H10.4556V9.68405H11.4371V10.3217Z"
            fill="#D8232A"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconGithubColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5064)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0099 0C5.36875 0 0 5.40833 0 12.0992C0 17.4475 3.43994 21.9748 8.21205 23.5771C8.80869 23.6976 9.02724 23.3168 9.02724 22.9965C9.02724 22.716 9.00757 21.7545 9.00757 20.7527C5.6667 21.474 4.97099 19.3104 4.97099 19.3104C4.43409 17.9082 3.63858 17.5478 3.63858 17.5478C2.54511 16.8066 3.71823 16.8066 3.71823 16.8066C4.93117 16.8868 5.56763 18.0486 5.56763 18.0486C6.64118 19.8913 8.37111 19.3707 9.06706 19.0501C9.16638 18.2688 9.48473 17.728 9.82275 17.4276C7.15817 17.1471 4.35469 16.1055 4.35469 11.458C4.35469 10.1359 4.8316 9.05428 5.58729 8.21304C5.46807 7.91263 5.0504 6.67043 5.70677 5.00787C5.70677 5.00787 6.72083 4.6873 9.00732 6.24981C9.98625 5.98497 10.9958 5.85024 12.0099 5.84911C13.024 5.84911 14.0577 5.98948 15.0123 6.24981C17.299 4.6873 18.3131 5.00787 18.3131 5.00787C18.9695 6.67043 18.5515 7.91263 18.4323 8.21304C19.2079 9.05428 19.6652 10.1359 19.6652 11.458C19.6652 16.1055 16.8617 17.1269 14.1772 17.4276C14.6148 17.8081 14.9924 18.5292 14.9924 19.6711C14.9924 21.2936 14.9727 22.5957 14.9727 22.9962C14.9727 23.3168 15.1915 23.6976 15.7879 23.5774C20.56 21.9745 23.9999 17.4475 23.9999 12.0992C24.0196 5.40833 18.6312 0 12.0099 0Z"
          fill="#24292F"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5064">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconGithubColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_279)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0099 0C5.36875 0 0 5.40833 0 12.0992C0 17.4475 3.43994 21.9748 8.21205 23.5771C8.80869 23.6976 9.02724 23.3168 9.02724 22.9965C9.02724 22.716 9.00757 21.7545 9.00757 20.7527C5.6667 21.474 4.97099 19.3104 4.97099 19.3104C4.43409 17.9082 3.63858 17.5478 3.63858 17.5478C2.54511 16.8066 3.71823 16.8066 3.71823 16.8066C4.93117 16.8868 5.56763 18.0486 5.56763 18.0486C6.64118 19.8913 8.37111 19.3707 9.06706 19.0501C9.16638 18.2688 9.48473 17.728 9.82275 17.4276C7.15817 17.1471 4.35469 16.1055 4.35469 11.458C4.35469 10.1359 4.8316 9.05428 5.58729 8.21304C5.46807 7.91263 5.0504 6.67043 5.70677 5.00787C5.70677 5.00787 6.72083 4.6873 9.00732 6.24981C9.98625 5.98497 10.9958 5.85024 12.0099 5.84911C13.024 5.84911 14.0577 5.98948 15.0123 6.24981C17.299 4.6873 18.3131 5.00787 18.3131 5.00787C18.9695 6.67043 18.5515 7.91263 18.4323 8.21304C19.2079 9.05428 19.6652 10.1359 19.6652 11.458C19.6652 16.1055 16.8617 17.1269 14.1772 17.4276C14.6148 17.8081 14.9924 18.5292 14.9924 19.6711C14.9924 21.2936 14.9727 22.5957 14.9727 22.9962C14.9727 23.3168 15.1915 23.6976 15.7879 23.5774C20.56 21.9745 23.9999 17.4475 23.9999 12.0992C24.0196 5.40833 18.6312 0 12.0099 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_279">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconGooglePay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="GooglePay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="GooglePay_2">
          <g id="Pay">
            <path
              id="Union"
              d="M27.4976 14.3186H27.5151L28.9741 10.6556H30.0005L26.8462 18.0003H25.8735L27.0454 15.4309L24.9771 10.6556H26.0024L27.4976 14.3186ZM22.562 10.4895C23.2592 10.4896 23.81 10.6796 24.2144 11.054C24.6188 11.4286 24.8188 11.9525 24.8188 12.6126V15.7581H23.9155V15.0501H23.8745C23.4819 15.6328 22.9664 15.925 22.3159 15.9251C21.7649 15.9251 21.2955 15.7581 20.9263 15.4251C20.5629 15.1159 20.3579 14.6577 20.3696 14.1761C20.3697 13.6469 20.5688 13.2305 20.9614 12.9153C21.3541 12.6002 21.8821 12.4456 22.5386 12.4456C23.1011 12.4456 23.558 12.553 23.9214 12.7552V12.5354C23.9214 12.2084 23.7808 11.8989 23.5347 11.6849C23.2827 11.4589 22.9605 11.3334 22.6265 11.3333C22.0989 11.3333 21.6822 11.56 21.3774 12.012L20.5454 11.4827C20.9909 10.8226 21.6652 10.4895 22.562 10.4895ZM18.0894 8.30106C18.6931 8.28918 19.2796 8.52134 19.7075 8.9495C20.5628 9.7582 20.6155 11.1194 19.813 11.9934L19.7075 12.1009C19.2679 12.5231 18.7282 12.7376 18.0894 12.7376H16.5298V15.7581H15.5864V8.30106H18.0894ZM22.6851 13.219C22.3042 13.219 21.982 13.3141 21.7241 13.4983C21.4722 13.6826 21.3424 13.9143 21.3423 14.1936C21.3423 14.4434 21.4603 14.6759 21.6538 14.8186C21.8648 14.985 22.1226 15.0746 22.3862 15.0686C22.7849 15.0686 23.1664 14.9078 23.4478 14.6224C23.7583 14.3251 23.9165 13.9739 23.9165 13.5696C23.6234 13.3317 23.2127 13.2131 22.6851 13.219ZM16.5298 11.8216H18.1128C18.4645 11.8335 18.805 11.6906 19.0454 11.4349C19.5378 10.9175 19.5261 10.0848 19.0161 9.58524C18.7758 9.34737 18.4528 9.21708 18.1128 9.21708H16.5298V11.8216Z"
              fill="#3C4043"
            />
          </g>
          <g id="G">
            <path
              id="Blue"
              d="M13.2721 12.083C13.2721 11.7916 13.2486 11.5002 13.2017 11.2147H9.22174V12.862H11.5019C11.4081 13.3913 11.1033 13.867 10.6578 14.1643V15.2347H12.0177C12.8149 14.4914 13.2721 13.3913 13.2721 12.083Z"
              fill="#4285F4"
            />
            <path
              id="Green"
              d="M9.22192 16.2695C10.3591 16.2695 11.3204 15.8889 12.0179 15.2347L10.658 14.1643C10.277 14.426 9.79049 14.5746 9.22192 14.5746C8.11995 14.5746 7.18796 13.8194 6.85385 12.8085H5.45294V13.9146C6.16805 15.3596 7.62758 16.2695 9.22192 16.2695Z"
              fill="#34A853"
            />
            <path
              id="Yellow"
              d="M6.85401 12.8085C6.67814 12.2792 6.67814 11.7024 6.85401 11.1672V10.067H5.45288C4.84904 11.2742 4.84904 12.7014 5.45288 13.9086L6.85401 12.8085Z"
              fill="#FBBC04"
            />
            <path
              id="Red"
              d="M9.22192 9.40099C9.82566 9.38909 10.406 9.62102 10.8397 10.0432L12.0472 8.81821C11.2793 8.0927 10.2711 7.69427 9.22192 7.70616C7.62758 7.70616 6.16805 8.62196 5.45294 10.067L6.85385 11.1731C7.18796 10.1562 8.11995 9.40099 9.22192 9.40099Z"
              fill="#EA4335"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconGoolgeColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_4998)">
        <g id="Vector">
          <path
            id="Vector_2"
            d="M11.9998 9.81815V14.4654H18.4579C18.1743 15.96 17.3233 17.2255 16.047 18.0764L19.9415 21.0982C22.2106 19.0037 23.5197 15.9273 23.5197 12.2728C23.5197 11.4219 23.4433 10.6037 23.3015 9.81828L11.9998 9.81815Z"
            fill="#4285F4"
          />
          <path
            id="Vector_3"
            d="M5.27461 14.284L4.39625 14.9564L1.28711 17.3782C3.26165 21.2945 7.30862 24 11.9995 24C15.2394 24 17.9557 22.9309 19.9412 21.0982L16.0467 18.0764C14.9776 18.7964 13.614 19.2328 11.9995 19.2328C8.87951 19.2328 6.22868 17.1273 5.27952 14.2909L5.27461 14.284Z"
            fill="#34A853"
          />
          <path
            id="Vector_4"
            d="M1.28718 6.62182C0.469042 8.2363 0 10.0581 0 11.9999C0 13.9417 0.469042 15.7636 1.28718 17.378C1.28718 17.3889 5.27997 14.2799 5.27997 14.2799C5.03998 13.5599 4.89812 12.7963 4.89812 11.9998C4.89812 11.2033 5.03998 10.4397 5.27997 9.71975L1.28718 6.62182Z"
            fill="#FBBC05"
          />
          <path
            id="Vector_5"
            d="M11.9997 4.77818C13.767 4.77818 15.3379 5.38907 16.5925 6.56727L20.0288 3.13095C17.9452 1.18917 15.2398 0 11.9997 0C7.30887 0 3.26165 2.69454 1.28711 6.62183L5.27978 9.72001C6.22882 6.88362 8.87976 4.77818 11.9997 4.77818Z"
            fill="#EA4335"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_634_4998">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconGoolgeColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_266)">
        <g id="Vector">
          <path
            id="Vector_2"
            d="M11.9998 9.81815V14.4654H18.4579C18.1743 15.96 17.3233 17.2255 16.047 18.0764L19.9415 21.0982C22.2106 19.0037 23.5197 15.9273 23.5197 12.2728C23.5197 11.4219 23.4433 10.6037 23.3015 9.81828L11.9998 9.81815Z"
            fill="currentColor"
          />
          <path
            id="Vector_3"
            d="M5.27461 14.284L4.39625 14.9564L1.28711 17.3782C3.26165 21.2945 7.30862 24 11.9995 24C15.2394 24 17.9557 22.9309 19.9412 21.0982L16.0467 18.0764C14.9776 18.7964 13.614 19.2328 11.9995 19.2328C8.87951 19.2328 6.22868 17.1273 5.27952 14.2909L5.27461 14.284Z"
            fill="currentColor"
          />
          <path
            id="Vector_4"
            d="M1.28718 6.62182C0.469042 8.2363 0 10.0581 0 11.9999C0 13.9417 0.469042 15.7636 1.28718 17.378C1.28718 17.3889 5.27997 14.2799 5.27997 14.2799C5.03998 13.5599 4.89812 12.7963 4.89812 11.9998C4.89812 11.2033 5.03998 10.4397 5.27997 9.71975L1.28718 6.62182Z"
            fill="currentColor"
          />
          <path
            id="Vector_5"
            d="M11.9997 4.77818C13.767 4.77818 15.3379 5.38907 16.5925 6.56727L20.0288 3.13095C17.9452 1.18917 15.2398 0 11.9997 0C7.30887 0 3.26165 2.69454 1.28711 6.62183L5.27978 9.72001C6.22882 6.88362 8.87976 4.77818 11.9997 4.77818Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_633_266">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconIdeal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Ideal">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Ideal_2">
          <path
            id="Union"
            d="M17.8423 4.95592C23.5013 4.95607 25.6762 8.04871 25.6763 11.9579C25.6763 16.6343 22.6366 18.9851 17.8423 18.9852H9.51324V4.95592H17.8423ZM10.3043 18.1942H17.8414C22.3887 18.1942 24.8609 16.0659 24.8609 11.9833C24.8609 7.77685 22.1911 5.79771 17.8414 5.79771H10.3043V18.1942ZM13.7398 17.1551H11.3179V12.8495H13.7398V17.1551ZM12.5289 9.18736C13.3612 9.18764 14.0357 9.8637 14.0357 10.6971C14.0353 11.5302 13.361 12.2056 12.5289 12.2059C11.6965 12.2059 11.0214 11.5304 11.0211 10.6971C11.0211 9.86353 11.6963 9.18736 12.5289 9.18736Z"
            fill="black"
          />
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.1175 9.31078H22.8095V11.3892H23.8228C23.5509 7.60347 20.5605 6.76219 17.8419 6.76219H14.9504V9.31078H15.3705C16.1614 9.31078 16.6309 9.83039 16.6309 10.6964C16.6309 11.5624 16.1614 12.0821 15.3952 12.0821H14.9504V17.1545H17.8419C22.2658 17.1545 23.7733 15.1008 23.8475 12.0821H22.1175V9.31078ZM18.7811 11.3892V12.0821H17.0511V9.31078H18.7316V10.0036H17.7431V10.3253H18.6822V11.0181H17.7678V11.3892H18.7811ZM19.0776 12.0821L19.9179 9.31078H20.9064L21.7467 12.0821H21.03L20.8817 11.5625H19.9673L19.819 12.0821H19.0776ZM20.1728 10.8448H20.165V10.8696L20.1728 10.8448ZM20.1728 10.8448H20.6593L20.4369 10.0778H20.4122L20.1728 10.8448ZM14.9504 11.3892V10.0036H15.3705C15.6424 10.0036 15.9389 10.0778 15.9389 10.6964C15.9389 11.315 15.6671 11.3892 15.3705 11.3892H14.9504Z"
            fill="#D50072"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconIllustrator(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Illustrator">
        <g id="Layer 2">
          <g id="Layer 1">
            <g id="Layer 2_2">
              <g id="Surfaces">
                <g id="Drawing Surface">
                  <g id="Outline no shadow">
                    <path
                      id="Vector"
                      d="M5.54167 1.99998H18.4583C18.9236 1.99953 19.3843 2.09318 19.8142 2.27557C20.2441 2.45796 20.6347 2.72551 20.9636 3.06291C21.2926 3.4003 21.5535 3.80092 21.7313 4.24184C21.9091 4.68275 22.0004 5.15531 22 5.63246V18.3675C22.0004 18.8447 21.9091 19.3172 21.7313 19.7581C21.5535 20.199 21.2926 20.5997 20.9636 20.9371C20.6347 21.2745 20.2441 21.542 19.8142 21.7244C19.3843 21.9068 18.9236 22.0004 18.4583 22H5.54167C5.07645 22.0004 4.6157 21.9068 4.18581 21.7244C3.75592 21.542 3.36532 21.2745 3.03635 20.9371C2.70739 20.5997 2.44653 20.199 2.2687 19.7581C2.09087 19.3172 1.99956 18.8447 2 18.3675V5.63246C1.99956 5.15531 2.09087 4.68275 2.2687 4.24184C2.44653 3.80092 2.70739 3.4003 3.03635 3.06291C3.36532 2.72551 3.75592 2.45796 4.18581 2.27557C4.6157 2.09318 5.07645 1.99953 5.54167 1.99998Z"
                      fill="#330000"
                    />
                  </g>
                </g>
              </g>
              <g id="Outlined Mnemonics Logos">
                <g id="Ai">
                  <path
                    id="Vector_2"
                    d="M11.6917 14H8.5917L7.95836 16.0085C7.95129 16.0452 7.93112 16.0777 7.90182 16.0999C7.87253 16.122 7.83622 16.1321 7.80003 16.1282H6.23336C6.1417 16.1282 6.1167 16.0769 6.1417 15.9744L8.82503 8.05128C8.85003 7.96581 8.87503 7.8718 8.90836 7.76923C8.9419 7.58605 8.95864 7.40006 8.95836 7.21368C8.95587 7.19227 8.96135 7.17069 8.97371 7.15325C8.98608 7.13582 9.00441 7.12382 9.02503 7.11966H11.1834C11.25 7.11966 11.2834 7.1453 11.2917 7.18804L14.3334 15.9915C14.3584 16.0855 14.3334 16.1282 14.25 16.1282H12.5084C12.4789 16.1311 12.4494 16.1233 12.425 16.1061C12.4006 16.0889 12.3829 16.0634 12.375 16.0342L11.6917 14ZM9.07503 12.265H11.1917C11.1417 12.0855 11.075 11.8718 11 11.6496C10.925 11.4274 10.85 11.1709 10.775 10.9145C10.7 10.6581 10.6167 10.3932 10.5334 10.1282C10.45 9.86325 10.375 9.61539 10.3084 9.36752C10.2417 9.11966 10.1834 8.90598 10.125 8.70086H10.1084C10.0335 9.07337 9.93889 9.44144 9.82503 9.80342C9.70003 10.2137 9.57503 10.641 9.4417 11.0684C9.32503 11.5043 9.20003 11.906 9.07503 12.265Z"
                    fill="#FF9A00"
                  />
                  <path
                    id="Vector_3"
                    d="M16.1499 8.58119C16.0131 8.58426 15.8771 8.55939 15.7498 8.50804C15.6224 8.45668 15.5063 8.37986 15.4082 8.28205C15.2173 8.06794 15.1156 7.78572 15.1249 7.49572C15.12 7.35443 15.1441 7.21365 15.1958 7.08258C15.2475 6.95151 15.3256 6.83309 15.4249 6.73504C15.6252 6.54086 15.891 6.43367 16.1666 6.43589C16.4916 6.43589 16.7416 6.53846 16.9249 6.73504C17.1095 6.94228 17.2081 7.21513 17.1999 7.49572C17.205 7.64013 17.1818 7.78412 17.1317 7.91917C17.0816 8.05423 17.0056 8.17762 16.9082 8.28205C16.81 8.38463 16.6915 8.46442 16.5607 8.51602C16.4299 8.56763 16.2898 8.58985 16.1499 8.58119ZM15.2166 16V9.4188C15.2166 9.33333 15.2499 9.29914 15.3249 9.29914H16.9749C17.0499 9.29914 17.0832 9.34188 17.0832 9.4188V16C17.0832 16.094 17.0499 16.1367 16.9749 16.1367H15.3416C15.324 16.1382 15.3064 16.1356 15.29 16.1292C15.2736 16.1227 15.2589 16.1125 15.2469 16.0993C15.2348 16.0862 15.2259 16.0704 15.2206 16.0532C15.2154 16.036 15.214 16.0178 15.2166 16Z"
                    fill="#FF9A00"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconInDesign(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="InDesign">
        <g id="Layer 2">
          <g id="Layer 1">
            <g id="Surfaces">
              <g id="Publishing Surface">
                <g id="Outline no shadow">
                  <path
                    id="Vector"
                    d="M5.54167 1.99998H18.4583C18.9236 1.99953 19.3843 2.09318 19.8142 2.27557C20.2441 2.45796 20.6347 2.72551 20.9636 3.06291C21.2926 3.4003 21.5535 3.80092 21.7313 4.24184C21.9091 4.68275 22.0004 5.15531 22 5.63246V18.3675C22.0004 18.8447 21.9091 19.3172 21.7313 19.7581C21.5535 20.199 21.2926 20.5997 20.9636 20.9371C20.6347 21.2745 20.2441 21.542 19.8142 21.7244C19.3843 21.9068 18.9236 22.0004 18.4583 22H5.54167C5.07645 22.0004 4.6157 21.9068 4.18581 21.7244C3.75592 21.542 3.36532 21.2745 3.03635 20.9371C2.70739 20.5997 2.44653 20.199 2.2687 19.7581C2.09087 19.3172 1.99956 18.8447 2 18.3675V5.63246C1.99956 5.15531 2.09087 4.68275 2.2687 4.24184C2.44653 3.80092 2.70739 3.4003 3.03635 3.06291C3.36532 2.72551 3.75592 2.45796 4.18581 2.27557C4.6157 2.09318 5.07645 1.99953 5.54167 1.99998Z"
                    fill="#49021F"
                  />
                </g>
              </g>
            </g>
            <g id="Outlined Mnemonics Logos">
              <g id="Id">
                <path
                  id="Vector_2"
                  d="M9.26666 7.23077V16C9.26666 16.094 9.22499 16.1367 9.14999 16.1367H7.51666C7.44166 16.1367 7.40833 16.094 7.40833 16V7.23077C7.40833 7.15384 7.44999 7.11966 7.52499 7.11966H9.14999C9.16262 7.11761 9.17553 7.11823 9.18792 7.12147C9.20032 7.12471 9.21193 7.13051 9.22207 7.13851C9.23221 7.1465 9.24065 7.15653 9.24688 7.16799C9.25312 7.17944 9.25701 7.19208 9.25832 7.20513C9.26147 7.2085 9.26386 7.21255 9.2653 7.21699C9.26674 7.22142 9.2672 7.22613 9.26666 7.23077Z"
                  fill="#FF3366"
                />
                <path
                  id="Vector_3"
                  d="M14.0666 16.2735C13.4489 16.2839 12.8368 16.1525 12.275 15.8889C11.7523 15.6382 11.3142 15.2335 11.0166 14.7265C10.7083 14.2051 10.5583 13.5556 10.5583 12.7778C10.5499 12.1453 10.7082 11.5222 11.0166 10.9744C11.3329 10.4176 11.7909 9.95964 12.3416 9.64957C12.925 9.31624 13.625 9.15384 14.45 9.15384C14.5084 9.15317 14.5669 9.15602 14.625 9.16239C14.7 9.17094 14.7833 9.17094 14.8833 9.17949V6.47863C14.8833 6.4188 14.9083 6.38461 14.9666 6.38461H16.6583C16.677 6.38202 16.6959 6.38674 16.7114 6.39782C16.7268 6.40891 16.7376 6.42555 16.7416 6.44444V14.5983C16.7416 14.7521 16.75 14.9231 16.7583 15.1111C16.7666 15.2991 16.7833 15.4615 16.7916 15.6068C16.7934 15.6357 16.7863 15.6644 16.7714 15.6889C16.7564 15.7135 16.7344 15.7326 16.7083 15.7436C16.2718 15.9317 15.8162 16.0693 15.35 16.1538C14.9265 16.2326 14.497 16.2726 14.0666 16.2735ZM14.8833 14.5641V10.8034C14.8091 10.7851 14.734 10.7708 14.6583 10.7607C14.5666 10.7521 14.475 10.7436 14.3833 10.7436C14.0567 10.7398 13.7338 10.816 13.4416 10.9658C13.1569 11.1113 12.9131 11.329 12.7333 11.5983C12.55 11.8718 12.4583 12.2393 12.4583 12.6838C12.451 12.9837 12.4991 13.2824 12.6 13.5641C12.6806 13.7919 12.8085 13.999 12.975 14.1709C13.1356 14.3282 13.3296 14.4452 13.5416 14.5128C13.7649 14.5878 13.9984 14.6253 14.2333 14.6239C14.3583 14.6239 14.475 14.6154 14.5833 14.6068C14.6851 14.6149 14.7875 14.6003 14.8833 14.5641Z"
                  fill="#FF3366"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconInkscape(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Inkscape">
        <path
          id="Vector"
          d="M18.2959 18.4183C17.4598 19.1441 18.3943 19.8856 19.214 19.4123C19.3943 19.2229 19.214 18.5918 18.2959 18.4183ZM6.1968 19.5858C6.85257 20.1222 7.86903 19.4438 8.16413 18.6865C7.52475 17.8819 5.16395 18.7181 6.1968 19.5858ZM18.6402 17.6768C18.6402 18.0396 21.3944 18.2763 21.3944 17.5979C21.001 16.4935 18.9681 16.5566 18.6402 17.6768ZM21.1977 11.1923L13.5415 3.65081C12.607 2.78306 11.0495 2.78306 10.1643 3.65081L2.77036 10.9241C0.278407 13.906 4.47538 13.5589 6.26237 14.4109C6.90176 15.042 3.78682 15.5153 4.44259 16.1464C5.08198 16.7775 8.34447 17.3612 8.98385 18.0081L8.31168 19.9487C8.95106 20.5798 10.443 19.9802 10.7217 21.4475C10.9184 22.4888 13.4103 21.8893 14.6235 21.0373C15.2629 20.4062 13.394 20.4693 14.0333 19.8225C15.64 18.2447 17.1319 19.2545 17.6729 17.661C17.9516 16.8721 15.3121 16.4619 15.9515 15.8151C17.8204 14.7895 24.2307 14.1111 21.1977 11.1923ZM12.0168 16.099C11.2299 16.3041 7.42638 14.8053 8.37726 14.8053C8.57399 14.9158 11.5578 15.4995 12.2955 15.6257C12.5578 15.6731 12.3775 15.9255 12.0168 16.099ZM16.1318 7.97377L14.6891 6.85359L14.4104 8.5102L13.1972 7.89489L11.2627 9.07818L10.6233 6.63271L9.55766 8.39976H7.9674C7.31162 8.39976 7.24604 7.56356 7.83624 6.99558C8.86909 5.92273 10.0495 4.81833 10.6889 4.18724C11.3283 3.55615 12.4595 3.55615 13.0989 4.17146L16.0171 7.02714C16.2958 7.29535 16.2958 7.816 16.1318 7.97377Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconInstagramColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_4957)">
        <g id="Social Icons" clipPath="url(#clip1_634_4957)">
          <g id="Layer_1-2">
            <g id="Clip path group">
              <mask
                id="mask0_634_4957"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <g id="clippath">
                  <path
                    id="Vector"
                    d="M12 2.16186C15.2041 2.16186 15.5837 2.17386 16.8491 2.23165C18.0192 2.28503 18.6546 2.48031 19.0774 2.64477C19.6378 2.8626 20.0374 3.1223 20.4573 3.54223C20.8771 3.96216 21.1374 4.36183 21.3548 4.92212C21.5192 5.34493 21.7145 5.98029 21.7679 7.15041C21.8256 8.41586 21.8377 8.79528 21.8377 11.9996C21.8377 15.2039 21.8257 15.5832 21.7679 16.8486C21.7145 18.0187 21.5192 18.6541 21.3548 19.0769C21.1369 19.6373 20.8772 20.0369 20.4573 20.4568C20.0374 20.8766 19.6377 21.1369 19.0774 21.3543C18.6546 21.5187 18.0192 21.714 16.8491 21.7674C15.5838 21.8251 15.2042 21.8372 12 21.8372C8.79566 21.8372 8.41635 21.8252 7.15089 21.7674C5.98077 21.714 5.34541 21.5187 4.9226 21.3543C4.36221 21.1363 3.96264 20.8766 3.54271 20.4568C3.12288 20.0369 2.8626 19.6372 2.64525 19.0769C2.48069 18.6541 2.28551 18.0187 2.23213 16.8486C2.17443 15.5833 2.16234 15.2038 2.16234 11.9996C2.16234 8.79538 2.17434 8.41596 2.23213 7.15041C2.28551 5.98029 2.48079 5.34493 2.64525 4.92212C2.86308 4.36173 3.12278 3.96216 3.54271 3.54223C3.96264 3.1224 4.36231 2.86212 4.9226 2.64477C5.34541 2.48031 5.98077 2.28503 7.15089 2.23165C8.41625 2.17443 8.79576 2.16186 12 2.16186ZM12 0C8.74094 0 8.33215 0.0139208 7.0523 0.0721003C5.77484 0.13028 4.90282 0.333332 4.13958 0.62999C3.35031 0.936824 2.68134 1.34715 2.0142 2.0142C1.34715 2.68134 0.93644 3.35031 0.62999 4.13958C0.333236 4.90292 0.13028 5.77532 0.0721003 7.0523C0.0139208 8.33224 0 8.74104 0 12C0 15.2589 0.0139208 15.6678 0.0721003 16.9476C0.13028 18.2251 0.333332 19.0971 0.62999 19.8603C0.936824 20.6496 1.34715 21.3186 2.0142 21.9857C2.68134 22.6528 3.35079 23.0631 4.13958 23.3699C4.90292 23.6667 5.77532 23.8696 7.0523 23.9278C8.33215 23.986 8.74094 23.9999 12 23.9999C15.259 23.9999 15.6678 23.986 16.9476 23.9278C18.2251 23.8696 19.0971 23.6666 19.8603 23.3699C20.6496 23.063 21.3186 22.6528 21.9857 21.9857C22.6528 21.3186 23.0631 20.6491 23.3699 19.8603C23.6667 19.0971 23.8696 18.2246 23.9278 16.9476C23.986 15.6678 23.9999 15.259 23.9999 12C23.9999 8.74094 23.986 8.33215 23.9278 7.0523C23.8696 5.77484 23.6666 4.90282 23.3699 4.13958C23.063 3.35031 22.6528 2.68134 21.9857 2.0142C21.3186 1.34715 20.6491 0.936824 19.8603 0.62999C19.0971 0.333236 18.2246 0.13028 16.9476 0.0721003C15.6679 0.0139208 15.259 0 12 0ZM12 5.83792C8.59664 5.83792 5.83792 8.59664 5.83792 12C5.83792 15.4033 8.59664 18.1621 12 18.1621C15.4033 18.1621 18.1621 15.4033 18.1621 12C18.1621 8.59664 15.4033 5.83792 12 5.83792ZM12 16.0002C9.79096 16.0002 7.99978 14.2096 7.99978 12C7.99978 9.79048 9.79096 7.99987 12 7.99987C14.2089 7.99987 16.0001 9.79048 16.0001 12C16.0001 14.2096 14.2089 16.0002 12 16.0002ZM18.4055 4.15455C17.61 4.15455 16.9655 4.79904 16.9655 5.59454C16.9655 6.39005 17.61 7.03463 18.4055 7.03463C19.201 7.03463 19.8455 6.39005 19.8455 5.59454C19.8455 4.79904 19.2011 4.15455 18.4055 4.15455Z"
                    fill="white"
                  />
                </g>
              </mask>
              <g mask="url(#mask0_634_4957)">
                <g id="Group">
                  <g id="Instagram_GLYPH_2500px.tif">
                    <rect
                      id="Instagram_GLYPH_2500px"
                      x="-6.75171"
                      y="-6.7517"
                      width="37.4422"
                      height="37.4422"
                      fill="url(#pattern0_634_4957)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <pattern
          id="pattern0_634_4957"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_634_4957" transform="scale(0.0133333)" />
        </pattern>
        <clipPath id="clip0_634_4957">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_634_4957">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <image
          id="image0_634_4957"
          data-name="Instagram_GLYPH_2500px-min.png"
          width="75"
          height="75"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  )
}

export function IconInstagramColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_276)">
        <path
          id="Union"
          d="M12 0C15.2578 0 15.6658 0.0142578 16.9502 0.0751953C18.2251 0.131458 19.0973 0.337516 19.8613 0.632812C20.6487 0.937487 21.3188 1.3501 21.9844 2.01562C22.6547 2.68121 23.0621 3.35162 23.3574 4.14844C23.6527 4.90781 23.8598 5.78457 23.916 7.05957C23.9723 8.33909 23.9863 8.74725 23.9863 12.0049C23.9863 15.2625 23.9723 15.6705 23.916 16.9502C23.8598 18.2251 23.6527 19.0973 23.3574 19.8613C23.0528 20.6486 22.6401 21.3189 21.9746 21.9844C21.309 22.6499 20.639 23.0625 19.8516 23.3672C19.0922 23.6625 18.2154 23.8686 16.9404 23.9248C15.6609 23.981 15.2528 23.9951 11.9951 23.9951C8.73748 23.9951 8.32947 23.9811 7.0498 23.9248C5.77492 23.8685 4.90269 23.6625 4.13867 23.3672C3.35132 23.0625 2.68115 22.6499 2.01562 21.9844C1.34534 21.3188 0.9373 20.6486 0.62793 19.8564C0.332617 19.0971 0.126563 18.2203 0.0703125 16.9453C0.0140625 15.6656 0 15.2578 0 12C0 8.74219 0.0140625 8.33418 0.0703125 7.0498C0.126575 5.77491 0.332632 4.9027 0.62793 4.13867C0.937292 3.35129 1.34539 2.68117 2.01562 2.01562C2.68122 1.34534 3.35141 0.9373 4.14355 0.62793C4.90293 0.332617 5.77969 0.126563 7.05469 0.0703125C8.33437 0.0140625 8.74219 2.7444e-09 12 0ZM12 2.16113C8.79391 2.16113 8.41411 2.1752 7.15332 2.23145C5.98635 2.283 5.34863 2.47951 4.92676 2.64355C4.36903 2.85915 3.97063 3.1173 3.54883 3.53906C3.1317 3.95619 2.86893 4.3593 2.65332 4.91699C2.48927 5.33885 2.29181 5.97179 2.24023 7.14355C2.18399 8.40444 2.16992 8.78434 2.16992 11.9902C2.16992 15.1918 2.18398 15.5723 2.24023 16.8379C2.29182 18.0048 2.48928 18.6426 2.65332 19.0645C2.86891 19.6221 3.12705 20.0206 3.54883 20.4424C3.96591 20.8594 4.36908 21.1223 4.92676 21.3379C5.34863 21.5019 5.98172 21.6985 7.15332 21.75C8.4141 21.8062 8.79391 21.8203 12 21.8203C15.2014 21.8203 15.5812 21.8062 16.8467 21.75C18.0136 21.6985 18.6514 21.5019 19.0732 21.3379C19.6309 21.1223 20.0294 20.8641 20.4512 20.4424C20.8683 20.0253 21.1311 19.6221 21.3467 19.0645C21.5107 18.6426 21.7082 18.0095 21.7598 16.8379C21.816 15.577 21.8301 15.1965 21.8301 11.9902C21.8301 8.78903 21.816 8.40913 21.7598 7.14355C21.7082 5.97648 21.5107 5.33885 21.3467 4.91699C21.1311 4.3593 20.873 3.96088 20.4512 3.53906C20.0341 3.12199 19.631 2.85915 19.0732 2.64355C18.6514 2.47951 18.0183 2.283 16.8467 2.23145C15.5859 2.1752 15.2061 2.16113 12 2.16113ZM12 5.83594C15.4031 5.83594 18.1641 8.59688 18.1641 12C18.1641 15.4031 15.4031 18.1641 12 18.1641C8.59688 18.1641 5.83594 15.4031 5.83594 12C5.83594 8.59688 8.59688 5.83594 12 5.83594ZM12 8.00195C9.79219 8.00195 8.00195 9.79219 8.00195 12C8.00195 14.2078 9.79219 15.998 12 15.998C14.2078 15.998 15.998 14.2078 15.998 12C15.998 9.79219 14.2078 8.00195 12 8.00195ZM18.4082 4.15332C19.2001 4.15353 19.8465 4.7999 19.8467 5.5918C19.8467 6.38854 19.2002 7.03104 18.4082 7.03125C17.6113 7.03125 16.9688 6.38399 16.9688 5.5918C16.9689 4.79508 17.6161 4.15332 18.4082 4.15332Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_276">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconInterac(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Interac">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Interac_2">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.7108 18.8423C25.7108 19.2049 25.5668 19.5526 25.3104 19.809C25.0541 20.0653 24.7064 20.2094 24.3438 20.2094H10.6593C10.4797 20.2096 10.3017 20.1743 10.1357 20.1057C9.96965 20.0371 9.81877 19.9365 9.69166 19.8095C9.56455 19.6825 9.46372 19.5318 9.39492 19.3658C9.32612 19.1999 9.29071 19.022 9.29071 18.8423V5.15845C9.29071 4.97879 9.32612 4.8009 9.39492 4.63494C9.46372 4.46898 9.56455 4.31821 9.69166 4.19125C9.81877 4.06429 9.96965 3.96362 10.1357 3.89501C10.3017 3.8264 10.4797 3.79119 10.6593 3.7914H24.3429C24.7054 3.7914 25.0531 3.93543 25.3095 4.1918C25.5659 4.44817 25.7099 4.79588 25.7099 5.15845L25.7108 18.8423Z"
            fill="#EDAA00"
          />
          <path
            id="Vector_2"
            d="M18.459 12.1776V9.23753L19.2267 9.05577V9.44072C19.2267 9.44072 19.4252 8.93398 19.8863 8.81623C20.0283 8.7805 20.0997 8.80194 20.0997 8.80194V9.55195C19.9616 9.55384 19.8251 9.58232 19.6977 9.63584C19.4131 9.748 19.2702 9.99345 19.2702 10.3663V11.9896L18.459 12.1776ZM14.4134 13.1336C14.4134 13.1336 14.2891 12.9472 14.2891 12.2848V10.8211L13.8939 10.9143V10.3119L14.2895 10.2187V9.56127L15.1056 9.36864V10.0245L15.6823 9.88781V10.4906L15.1056 10.6276V12.1189C15.1056 12.7965 15.2855 12.9267 15.2855 12.9267L14.4134 13.1336ZM15.7674 11.3847C15.7674 10.8618 15.842 10.4806 16.0017 10.1879C16.1915 9.84059 16.5038 9.6144 16.958 9.51094C17.8531 9.30744 18.1759 9.83748 18.1632 10.5477C18.1591 10.8016 18.1601 10.9255 18.1601 10.9255L16.583 11.2962V11.3217C16.583 11.8188 16.6874 12.054 17.0018 11.9869C17.2733 11.9297 17.3488 11.7594 17.3703 11.5494C17.374 11.5149 17.3753 11.4288 17.3753 11.4288L18.1144 11.2518C18.1144 11.2518 18.1163 11.3123 18.1144 11.3798C18.1076 11.6622 18.0255 12.3625 16.9987 12.6048C16.0262 12.8357 15.7665 12.2416 15.7665 11.3847H15.7674ZM16.9897 10.0584C16.7284 10.1177 16.5914 10.374 16.5858 10.7988L17.3793 10.6099C17.3808 10.5906 17.3808 10.5477 17.3808 10.4819C17.3793 10.1615 17.2802 9.99251 16.99 10.0584H16.9897ZM22.8605 9.66535C22.8295 8.76994 23.0619 8.05907 24.0608 7.83227C24.6983 7.68748 24.9397 7.85277 25.0621 8.01278C25.1799 8.16564 25.2252 8.37163 25.2252 8.66026V8.7137L24.4429 8.90012V8.79106C24.4429 8.4493 24.3497 8.31881 24.1011 8.38095C23.8057 8.4552 23.6864 8.73545 23.6864 9.29345V9.5535C23.6864 10.1205 23.764 10.3803 24.1042 10.3088C24.4 10.2467 24.4404 9.98816 24.446 9.76074C24.446 9.72501 24.4482 9.61067 24.4482 9.61067L25.2293 9.42674V9.54822C25.2271 10.2914 24.8353 10.7599 24.1008 10.9308C23.0901 11.1682 22.8919 10.5831 22.8609 9.66535H22.8605ZM20.1584 10.9187C20.1584 10.2377 20.558 10.0223 21.1586 9.7741C21.6982 9.55071 21.7097 9.43979 21.7122 9.24592C21.715 9.0828 21.6395 8.94268 21.3705 9.01135C21.1235 9.07348 21.0579 9.25306 21.0449 9.39598C21.0403 9.44618 21.0387 9.49659 21.0399 9.54698L20.2827 9.72563C20.2776 9.57472 20.2952 9.42391 20.3349 9.27823C20.4561 8.87091 20.8156 8.59688 21.4351 8.45365C22.2404 8.26724 22.5091 8.62143 22.5104 9.17135V10.4735C22.5104 11.1032 22.6272 11.1952 22.6272 11.1952L21.8837 11.3714C21.8426 11.2854 21.8092 11.196 21.7837 11.1042C21.7837 11.1042 21.6212 11.514 21.0601 11.6463C20.4698 11.7849 20.1591 11.4201 20.1591 10.919L20.1584 10.9187ZM21.7079 9.9891C21.5825 10.077 21.4501 10.1544 21.312 10.2206C21.0635 10.342 20.952 10.4912 20.952 10.7211C20.952 10.9202 21.0762 11.0514 21.2999 10.9954C21.5407 10.9352 21.7079 10.7105 21.7079 10.3989V9.9891ZM10.147 15.1944C10.0621 15.1943 9.9789 15.1712 9.90605 15.1277C9.8332 15.0842 9.77342 15.0219 9.733 14.9473C9.69258 14.8727 9.67302 14.7886 9.67638 14.7038C9.67974 14.619 9.7059 14.5367 9.75209 14.4656L9.75706 14.459L9.76607 14.4569L10.8752 14.1949V15.0379L10.8578 15.0419C10.6062 15.1025 10.3054 15.1711 10.2433 15.1839C10.2115 15.191 10.179 15.1946 10.1464 15.1944H10.147ZM10.147 16.2729C10.0223 16.2729 9.90276 16.2235 9.81448 16.1355C9.72619 16.0475 9.67638 15.9281 9.67597 15.8034C9.67547 15.7124 9.70196 15.6233 9.75209 15.5474L9.75706 15.539L9.76607 15.5371L10.8752 15.2752V16.1181L10.8578 16.1228C10.6062 16.1831 10.3054 16.253 10.2433 16.2651C10.2114 16.2713 10.1789 16.2745 10.1464 16.2744L10.147 16.2729ZM10.147 17.3531C10.022 17.3531 9.90223 17.3034 9.81391 17.215C9.72559 17.1266 9.67597 17.0068 9.67597 16.8818C9.67547 16.7908 9.70196 16.7017 9.75209 16.6258L9.75706 16.6171L10.8756 16.3536V17.1966L10.8582 17.2009C10.5925 17.2649 10.297 17.3317 10.2436 17.3438C10.2117 17.3499 10.1792 17.353 10.1467 17.3531"
            fill="#231F20"
          />
          <path
            id="Vector_3"
            d="M10.0165 14.1614L10.0162 9.4454L10.8759 9.2422V13.9579L10.0165 14.1614Z"
            fill="#231F20"
          />
          <path
            id="Vector_4"
            d="M12.1581 13.7603C12.1548 13.6218 12.0974 13.4901 11.9983 13.3934C11.8992 13.2966 11.7661 13.2425 11.6276 13.2425C11.4891 13.2425 11.3561 13.2966 11.2569 13.3934C11.1578 13.4901 11.1005 13.6218 11.0971 13.7603V18.1684C11.0978 18.5491 11.2493 18.914 11.5184 19.1832C11.7876 19.4524 12.1524 19.604 12.5331 19.6047C12.9345 19.6047 14.0344 19.6029 14.0344 19.6029V15.7133C14.0346 15.599 14.0065 15.4864 13.9527 15.3855C13.8989 15.2846 13.821 15.1986 13.7259 15.1351L12.3874 14.226V16.2903C12.3882 16.3057 12.3859 16.3212 12.3805 16.3357C12.3752 16.3502 12.3669 16.3635 12.3563 16.3747C12.3456 16.3859 12.3328 16.3949 12.3186 16.401C12.3043 16.4071 12.289 16.4102 12.2735 16.4102C12.2581 16.4102 12.2428 16.4071 12.2285 16.401C12.2143 16.3949 12.2015 16.3859 12.1908 16.3747C12.1802 16.3635 12.1719 16.3502 12.1666 16.3357C12.1612 16.3212 12.1589 16.3057 12.1597 16.2903C12.1597 16.2682 12.1569 14.0328 12.1569 13.7603H12.1581ZM12.8746 10.4716C12.712 10.5092 12.5595 10.5814 12.4274 10.6832C12.2953 10.7851 12.1867 10.9143 12.109 11.0619V10.7317L11.3351 10.915V13.0317C11.4708 12.9782 11.6188 12.9631 11.7625 12.9883C11.9062 13.0135 12.0403 13.0778 12.1497 13.1743V11.8073C12.1497 11.4801 12.3132 11.2185 12.5456 11.1673C12.7211 11.1287 12.8671 11.1915 12.8671 11.5031V13.4975L13.6821 13.3061V11.1968C13.6821 10.6851 13.4857 10.3268 12.8743 10.4716H12.8746ZM24.7229 7.45323C24.6231 7.45329 24.5256 7.42377 24.4427 7.36842C24.3597 7.31306 24.295 7.23435 24.2568 7.14223C24.2186 7.05011 24.2085 6.94873 24.2279 6.8509C24.2473 6.75307 24.2953 6.6632 24.3658 6.59263C24.4363 6.52207 24.5261 6.47398 24.6239 6.45447C24.7217 6.43495 24.8231 6.44487 24.9152 6.48298C25.0074 6.52109 25.0862 6.58568 25.1417 6.66857C25.1971 6.75146 25.2267 6.84893 25.2268 6.94866C25.2266 7.08221 25.1734 7.21022 25.0789 7.30462C24.9845 7.39903 24.8564 7.45213 24.7229 7.4523V7.45323ZM24.7229 6.50748C24.6357 6.50748 24.5505 6.53333 24.478 6.58176C24.4055 6.63019 24.349 6.69902 24.3156 6.77956C24.2822 6.86011 24.2735 6.94873 24.2904 7.03425C24.3074 7.11976 24.3494 7.19832 24.411 7.25999C24.4726 7.32166 24.5512 7.36367 24.6367 7.38072C24.7222 7.39776 24.8108 7.38908 24.8914 7.35575C24.9719 7.32243 25.0408 7.26597 25.0893 7.19351C25.1378 7.12105 25.1637 7.03585 25.1637 6.94866C25.1636 6.83176 25.1171 6.71968 25.0344 6.63699C24.9518 6.55429 24.8398 6.50772 24.7229 6.50748Z"
            fill="#231F20"
          />
          <path
            id="Vector_5"
            d="M24.5392 6.64888H24.7567C24.8434 6.64888 24.9121 6.69207 24.9121 6.80671C24.9121 6.88656 24.8767 6.94808 24.8095 6.95864C24.8717 6.96486 24.9028 6.99841 24.9056 7.08509C24.9056 7.12393 24.9074 7.1724 24.9093 7.20937C24.9093 7.21993 24.9119 7.23032 24.917 7.23956C24.9222 7.2488 24.9295 7.25659 24.9385 7.26219H24.8279C24.8168 7.24626 24.8109 7.22725 24.8111 7.20782C24.8074 7.17084 24.808 7.13636 24.8068 7.09162C24.8068 7.02451 24.7847 6.99499 24.717 6.99499H24.639V7.26219H24.5405L24.5392 6.64888ZM24.716 6.92291C24.7294 6.92415 24.7429 6.92239 24.7555 6.91777C24.7681 6.91315 24.7795 6.90579 24.7889 6.89621C24.7983 6.88663 24.8054 6.87508 24.8098 6.86239C24.8142 6.84971 24.8157 6.83621 24.8142 6.82287C24.8142 6.75731 24.7862 6.72314 24.721 6.72314H24.639V6.92291H24.716Z"
            fill="#231F20"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconJCB(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="JCB">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="JCB_2">
          <path
            id="Vector"
            d="M22.3181 12.2873C22.8318 12.2985 23.3484 12.2646 23.86 12.3049C24.3782 12.4016 24.5031 13.1859 24.0427 13.4428C23.7287 13.6121 23.3555 13.5059 23.015 13.5357H22.3181V12.2873ZM24.1571 10.8743C24.2712 11.2771 23.8829 11.6388 23.4949 11.5833H22.3181C22.3264 11.2035 22.302 10.7911 22.3301 10.4313C22.8015 10.4445 23.2773 10.4042 23.7459 10.4524C23.9473 10.5029 24.1158 10.6685 24.1571 10.8743ZM26.989 4.90046C27.0109 5.66977 26.9922 6.47973 26.9985 7.26464C26.997 10.4558 27.0015 13.6468 26.996 16.8382C26.9753 18.0341 25.9154 19.0733 24.7277 19.0972C23.5389 19.102 22.3499 19.0979 21.1609 19.0992V14.2749C22.4563 14.2682 23.7525 14.2885 25.0474 14.2648C25.6481 14.2271 26.3061 13.8307 26.3341 13.1696C26.4048 12.5057 25.7789 12.0465 25.1846 11.9739C24.9561 11.968 24.9628 11.9073 25.1846 11.8809C25.7514 11.7584 26.1965 11.1717 26.0297 10.5842C25.8876 9.96622 25.2046 9.72705 24.6365 9.72824C23.4781 9.72037 22.3196 9.72714 21.1611 9.72485C21.1686 8.82421 21.1455 7.92259 21.1736 7.0226C21.2654 5.84823 22.352 4.87976 23.5229 4.90077C24.6784 4.9006 25.8338 4.9006 26.989 4.90055V4.90046Z"
            fill="url(#paint0_linear_647_2935)"
          />
          <path
            id="Vector_2"
            d="M8.07061 7.14442C8.10019 5.95036 9.16462 4.91969 10.3508 4.90224C11.5352 4.89859 12.7198 4.90171 13.9043 4.90065C13.901 8.89574 13.9107 12.8913 13.8994 16.8861C13.8538 18.0657 12.8009 19.0767 11.6277 19.0976C10.441 19.1019 9.25421 19.0982 8.06749 19.0994V14.1124C9.22019 14.3847 10.429 14.5006 11.6049 14.32C12.3079 14.2069 13.0769 13.8617 13.3149 13.1325C13.49 12.5087 13.3915 11.8521 13.4175 11.2119V9.72504H11.3824C11.3733 10.7084 11.4011 11.6935 11.3677 12.6757C11.3128 13.2794 10.715 13.663 10.1456 13.6425C9.43945 13.65 8.04014 13.1307 8.04014 13.1307C8.03663 11.2883 8.06063 8.98093 8.07061 7.1446V7.14442Z"
            fill="url(#paint1_linear_647_2935)"
          />
          <path
            id="Vector_3"
            d="M14.6632 10.3246C14.5561 10.3473 14.6417 9.95969 14.6143 9.81265C14.6216 8.88295 14.599 7.95224 14.6267 7.02319C14.7182 5.84385 15.8132 4.87296 16.9889 4.90057H20.4513C20.4481 8.89565 20.4577 12.8912 20.4464 16.886C20.4008 18.0656 19.3479 19.0766 18.1746 19.0975C16.9879 19.102 15.801 19.0982 14.6142 19.0994V13.6354C15.4248 14.3005 16.5264 14.404 17.5362 14.4058C18.2974 14.4055 19.0542 14.2881 19.7935 14.1126V13.1116C18.9604 13.5268 17.981 13.7906 17.0575 13.552C16.4132 13.3916 15.9456 12.769 15.956 12.1042C15.8813 11.4128 16.2866 10.6828 16.9661 10.4772C17.8097 10.2132 18.7291 10.4151 19.5198 10.7585C19.6892 10.8472 19.8612 10.9572 19.7934 10.674V9.88725C18.4709 9.5726 17.0635 9.45682 15.7349 9.79911C15.3503 9.9076 14.9756 10.0721 14.6632 10.3247V10.3246Z"
            fill="url(#paint2_linear_647_2935)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_647_2935"
          x1="21.121"
          y1="11.6963"
          x2="26.9616"
          y2="11.6963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B03A" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_647_2935"
          x1="7.9433"
          y1="12.136"
          x2="13.8086"
          y2="12.136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6EB6" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_647_2935"
          x1="14.6057"
          y1="11.8339"
          x2="20.4502"
          y2="11.8339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DE0D3D" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconKlarna(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Klarna">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="#FEB4C7" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Klarna_2"
          d="M14.041 10.8447C14.5133 10.8447 14.9516 10.9946 15.3145 11.249V10.9668H16.5996V15.3779H15.3145V15.0957C14.9516 15.3501 14.5134 15.5 14.041 15.5C12.791 15.4998 11.7775 14.458 11.7773 13.1729C11.7773 11.8875 12.7909 10.845 14.041 10.8447ZM27.5938 10.8447C28.0662 10.8447 28.5043 10.9945 28.8672 11.249V10.9668H30.1514V15.3779H28.8672V15.0957C28.5043 15.3501 28.0662 15.5 27.5938 15.5C26.3435 15.5 25.3303 14.4581 25.3301 13.1729C25.3301 11.8874 26.3434 10.8447 27.5938 10.8447ZM31.5156 13.8135C31.9605 13.8137 32.3211 14.1842 32.3213 14.6416C32.3213 15.0991 31.9607 15.4705 31.5156 15.4707C31.0704 15.4707 30.709 15.0992 30.709 14.6416C30.7092 14.184 31.0706 13.8135 31.5156 13.8135ZM5.42383 9V15.3799H4V9H5.42383ZM8.97949 9C8.97949 10.3811 8.45629 11.6661 7.52344 12.6211L9.49121 15.3799H7.73242L5.59375 12.3818L6.14648 11.957C7.06185 11.2521 7.58691 10.174 7.58691 9H8.97949ZM11.251 15.3779H9.90625V9.00098H11.251V15.3779ZM18.5869 11.541C18.8445 11.1966 19.3242 10.9668 19.8457 10.9668V12.251C19.8405 12.2509 19.8353 12.25 19.8301 12.25C19.3218 12.2501 18.5899 12.6237 18.5898 13.3184V15.3779H17.2715V10.9668H18.5869V11.541ZM23.0469 10.8486C24.0817 10.8486 24.876 11.5467 24.876 12.5732V15.3779H23.5928V13.0508C23.5927 12.4075 23.2677 12.0605 22.7031 12.0605C22.1766 12.0607 21.7394 12.3893 21.7393 13.0596V15.3779H20.4443V10.9668H21.7236V11.4639C22.0483 11.0121 22.5338 10.8487 23.0469 10.8486ZM14.1465 12.0381C13.5039 12.0383 12.9834 12.5462 12.9834 13.1729C12.9835 13.7994 13.5039 14.3074 14.1465 14.3076C14.7893 14.3076 15.3104 13.7995 15.3105 13.1729C15.3105 12.5461 14.7894 12.0381 14.1465 12.0381ZM27.6992 12.0381C27.0563 12.0381 26.5352 12.5461 26.5352 13.1729C26.5353 13.7995 27.0564 14.3076 27.6992 14.3076C28.342 14.3076 28.8631 13.7995 28.8633 13.1729C28.8633 12.5461 28.3421 12.0381 27.6992 12.0381Z"
          fill="#17120F"
        />
      </g>
    </svg>
  )
}

export function IconLightcoin(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Lightcoin">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Lightcoin_2"
          d="M17.4346 4C21.8168 4 25.3699 7.55239 25.3701 11.9346C25.3701 16.3169 21.8169 19.8701 17.4346 19.8701C13.0524 19.8699 9.5 16.3168 9.5 11.9346C9.50023 7.55253 13.0525 4.00023 17.4346 4ZM15.5 11.9346L14.5322 12.3223L14.2422 13.3867L15.209 12.999L14.5322 15.6123H21.209L21.5967 14.0645H17.4346L18.0156 11.9346L19.1768 11.5479L19.4678 10.4834L18.3057 10.9678L19.1768 7.58008H16.6611L15.5 11.9346Z"
          fill="#A5A8A9"
        />
      </g>
    </svg>
  )
}

export function IconLinkedInColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_4981)">
        <path
          id="Vector"
          d="M22.2283 0H1.77167C1.30179 0 0.851161 0.186657 0.518909 0.518909C0.186657 0.851161 0 1.30179 0 1.77167V22.2283C0 22.6982 0.186657 23.1488 0.518909 23.4811C0.851161 23.8133 1.30179 24 1.77167 24H22.2283C22.6982 24 23.1488 23.8133 23.4811 23.4811C23.8133 23.1488 24 22.6982 24 22.2283V1.77167C24 1.30179 23.8133 0.851161 23.4811 0.518909C23.1488 0.186657 22.6982 0 22.2283 0ZM7.15333 20.445H3.545V8.98333H7.15333V20.445ZM5.34667 7.395C4.93736 7.3927 4.53792 7.2692 4.19873 7.04009C3.85955 6.81098 3.59584 6.48653 3.44088 6.10769C3.28591 5.72885 3.24665 5.31259 3.32803 4.91145C3.40941 4.51032 3.6078 4.14228 3.89816 3.85378C4.18851 3.56529 4.55782 3.36927 4.95947 3.29046C5.36112 3.21165 5.77711 3.25359 6.15495 3.41099C6.53279 3.56838 6.85554 3.83417 7.08247 4.17481C7.30939 4.51546 7.43032 4.91569 7.43 5.325C7.43386 5.59903 7.38251 5.87104 7.27901 6.1248C7.17551 6.37857 7.02198 6.6089 6.82757 6.80207C6.63316 6.99523 6.40185 7.14728 6.14742 7.24915C5.893 7.35102 5.62067 7.40062 5.34667 7.395ZM20.4533 20.455H16.8467V14.1933C16.8467 12.3467 16.0617 11.7767 15.0483 11.7767C13.9783 11.7767 12.9283 12.5833 12.9283 14.24V20.455H9.32V8.99167H12.79V10.58H12.8367C13.185 9.875 14.405 8.67 16.2667 8.67C18.28 8.67 20.455 9.865 20.455 13.365L20.4533 20.455Z"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_4981">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconLinkedInColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_264)">
        <path
          id="Vector"
          d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5562 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_264">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconLinux(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Linux">
        <g id="Vector">
          <path
            d="M10.1276 7.66531L10.1822 8.93223L9.30806 10.5847L7.55129 13.2921V14.6691L7.669 15.5422L8.65243 18.737L10.8925 20.004H14.2799L17.4487 17.5803L18.8692 13.7796L15.5911 9.75848L14.6623 7.50006L10.1276 7.66531Z"
            fill="#ECEFF1"
          />
          <path
            d="M17.8858 10.8051C17.0117 9.53815 16.3014 8.76698 15.919 7.16957C15.5365 5.57215 16.0282 6.01282 15.7004 4.63574C15.5365 3.91966 15.2633 3.42391 14.9902 3.03833C14.6623 2.65274 14.2799 2.43241 14.0614 2.37733C13.5696 2.10191 12.4223 1.66124 11.0018 2.43241C9.52663 3.20358 9.69054 4.85607 9.96372 8.21615C9.96372 8.43648 9.90908 8.7119 9.79981 8.93223C9.58127 9.42798 9.19882 9.86865 8.87101 10.2542C8.48857 10.8051 8.10612 11.3559 7.83294 11.9618C7.17732 13.2287 6.57633 14.8261 6.74024 15.4321C7.01342 15.377 10.4554 20.665 10.4554 20.7751C10.674 20.72 11.6028 20.72 12.4223 20.72C13.5696 20.665 14.2253 20.6099 15.1541 20.8302C15.1541 20.665 15.0994 20.4997 15.0994 20.3345C15.0994 20.004 15.1541 19.7285 15.2087 19.343C15.2633 19.0676 15.318 18.7921 15.3726 18.4616C14.8262 18.9574 13.8428 19.5082 12.914 19.6735C12.0945 19.8387 10.7286 19.5633 10.073 18.7371C10.1276 18.7371 10.2369 18.7371 10.2915 18.682C10.4554 18.6269 10.6193 18.5718 10.674 18.4616C10.8379 18.1862 10.7286 17.9108 10.6193 17.7456C10.5101 17.5803 9.69054 16.9744 9.30809 16.6439C8.92565 16.3134 8.70711 16.1481 8.48857 15.9278C8.48857 15.9278 8.16075 15.5973 8.05148 15.4871C7.94221 15.377 7.88758 15.2668 7.83294 15.2117C7.72367 14.9363 7.66904 14.6058 7.72367 14.1651C7.77831 13.5592 7.99685 13.0635 8.27003 12.5126C8.3793 12.2923 8.65247 11.8516 8.65247 11.8516C8.65247 11.8516 7.72367 14.1651 8.21539 14.8812C8.21539 14.8812 8.27003 14.1651 8.48857 13.4491C8.65247 12.9533 8.92565 12.2372 9.25346 11.8516C9.58127 11.4661 10.4008 10.0339 10.4554 9.15257C10.4554 8.76698 10.5101 8.3814 10.5101 8.10598C10.2915 7.88565 14.116 7.33482 14.3345 7.94073C14.3892 8.16107 15.1541 10.1441 15.5911 11.1906C15.8097 11.6864 16.0829 12.1271 16.2468 12.6779C16.4107 13.2838 16.5199 14.1101 16.5199 14.9363C16.5199 15.1016 16.5199 15.377 16.4653 15.6524C16.5746 15.6524 18.7053 13.3389 16.1921 11.411C16.1921 11.411 17.7219 12.1271 17.7765 13.5592C17.8312 14.716 17.3395 15.6524 17.2302 15.8176C17.2848 15.8176 18.3775 16.3134 18.4322 16.3134C18.6507 16.3134 19.0878 16.1481 19.0878 16.1481C19.1424 15.9829 19.3063 15.5422 19.3063 15.377C19.6888 14.1101 18.76 12.072 17.8858 10.8051Z"
            fill="#263238"
          />
          <path
            d="M10.9472 7.16957C11.3394 7.16957 11.6574 6.67634 11.6574 6.0679C11.6574 5.45947 11.3394 4.96624 10.9472 4.96624C10.5549 4.96624 10.2369 5.45947 10.2369 6.0679C10.2369 6.67634 10.5549 7.16957 10.9472 7.16957Z"
            fill="#ECEFF1"
          />
          <path
            d="M13.4057 7.27973C13.9187 7.27973 14.3345 6.71251 14.3345 6.01281C14.3345 5.31312 13.9187 4.7459 13.4057 4.7459C12.8928 4.7459 12.4769 5.31312 12.4769 6.01281C12.4769 6.71251 12.8928 7.27973 13.4057 7.27973Z"
            fill="#ECEFF1"
          />
          <path
            d="M11.3439 6.14328C11.2985 5.78111 11.0918 5.50916 10.8823 5.53586C10.6727 5.56256 10.5396 5.87781 10.5851 6.23999C10.6305 6.60216 10.8371 6.87412 11.0467 6.84741C11.2562 6.82071 11.3893 6.50546 11.3439 6.14328Z"
            fill="#212121"
          />
          <path
            d="M13.3511 6.94923C13.6528 6.94923 13.8974 6.62863 13.8974 6.23315C13.8974 5.83767 13.6528 5.51707 13.3511 5.51707C13.0493 5.51707 12.8047 5.83767 12.8047 6.23315C12.8047 6.62863 13.0493 6.94923 13.3511 6.94923Z"
            fill="#212121"
          />
          <path
            d="M20.6176 18.3515C20.399 18.2413 20.0166 18.076 19.6888 17.5803C19.5248 17.3049 19.5795 16.5337 19.3063 16.2032C19.1424 15.9829 18.9239 16.0931 18.8692 16.0931C18.3775 16.2032 17.2302 16.9744 16.4653 16.0931C16.356 15.9829 16.1921 15.8176 15.9189 15.8176C15.6458 15.8176 15.5365 15.9278 15.4272 16.1481C15.3179 16.3685 15.3179 16.5337 15.3179 17.0845C15.3179 17.5252 15.3179 18.021 15.2633 18.4065C15.154 19.343 14.9901 19.8938 14.9901 20.4446C14.9901 21.0505 15.154 21.4361 15.3726 21.6014C15.5365 21.7666 15.8097 21.8768 16.4106 21.8768C17.0116 21.8768 17.3941 21.6565 17.7765 21.2709C18.0497 20.9955 18.2682 20.8853 19.0331 20.3345C19.6341 19.9489 20.5629 19.4531 20.7268 19.2879C20.8361 19.1777 21 19.1226 21 18.7921C21 18.5167 20.7815 18.4065 20.6176 18.3515Z"
            fill="#FFC107"
          />
          <path
            d="M9.63588 18.5167C9.08952 17.6354 9.03489 17.4701 8.65244 16.9193C8.32463 16.3685 7.61437 15.3219 7.17729 15.3219C6.84948 15.3219 6.68558 15.4871 6.46704 15.7075C6.24849 15.9278 6.02995 16.4236 5.64751 16.699C5.3197 16.9744 4.3909 16.9193 4.17236 17.2498C3.95382 17.5803 4.3909 18.0761 4.3909 18.9023C4.3909 19.2328 4.11772 19.4531 4.06309 19.6735C4.00845 19.9489 3.95382 20.1141 4.06309 20.3345C4.28163 20.665 4.5548 20.7751 6.4124 21.1607C7.39583 21.381 8.32463 21.9319 8.92562 21.987C9.52661 22.042 10.5647 21.987 10.5647 20.4997C10.6193 19.6184 10.1276 19.3981 9.63588 18.5167Z"
            fill="#FFC107"
          />
          <path
            d="M10.6739 8.54665C10.3461 8.32631 10.073 8.10598 10.073 7.77548C10.073 7.44498 10.2915 7.33482 10.6193 7.0594C10.6739 7.00432 11.2749 6.45348 11.8759 6.45348C12.4769 6.45348 13.1872 6.83907 13.4603 6.94923C13.9521 7.0594 14.4438 7.16957 14.3891 7.55515C14.3345 8.10598 14.2799 8.21615 13.7335 8.49156C13.3511 8.60173 12.6408 9.20765 12.1491 9.20765C11.9306 9.20765 11.6027 9.20765 11.3842 9.15256C11.2203 9.09748 10.9471 8.82206 10.6739 8.54665Z"
            fill="#FFC107"
          />
          <path
            d="M10.5647 8.10599C10.6739 8.21615 10.8378 8.32632 11.0017 8.3814C11.111 8.43649 11.2749 8.49157 11.2749 8.49157C11.4935 8.49157 11.6574 8.49157 11.7666 8.49157C12.0398 8.49157 12.4223 8.3814 12.8047 8.16107C13.1872 7.99582 13.2418 7.88565 13.515 7.77549C13.7881 7.61024 14.0613 7.44499 13.952 7.3899C13.8428 7.33482 13.7335 7.3899 13.3511 7.61024C13.0232 7.83057 12.7501 7.94074 12.4223 8.10599C12.2584 8.16107 12.0398 8.27123 11.8759 8.27123C11.712 8.27123 11.5481 8.27123 11.3842 8.27123C11.2203 8.27123 11.111 8.21615 10.9471 8.16107C10.8378 8.10599 10.7832 8.0509 10.7286 8.0509C10.6193 7.99582 10.4008 7.77549 10.2915 7.7204C10.2915 7.7204 10.1822 7.7204 10.2369 7.77549C10.4008 7.94074 10.4554 7.99582 10.5647 8.10599Z"
            fill="#634703"
          />
          <path
            d="M12.2037 6.89415C12.2584 7.00432 12.3677 7.00432 12.4223 7.0594C12.4769 7.11448 12.5316 7.11448 12.5316 7.11448C12.5862 7.0594 12.5316 6.94923 12.4769 6.94923C12.4769 6.83907 12.2037 6.83907 12.2037 6.89415Z"
            fill="#634703"
          />
          <path
            d="M11.3296 7.00431C11.3296 7.0594 11.4389 7.11448 11.4389 7.0594C11.4935 7.00431 11.5481 6.94923 11.6028 6.94923C11.712 6.89415 11.6574 6.83907 11.4935 6.83907C11.3842 6.89415 11.3842 6.94923 11.3296 7.00431Z"
            fill="#634703"
          />
          <path
            d="M16.6292 16.7541C16.6292 16.8091 16.6292 16.8642 16.6292 16.9193C16.7384 17.1396 17.0116 17.1947 17.2302 17.1947C17.558 17.1947 17.8858 16.9744 18.0497 16.7541C18.0497 16.699 18.1043 16.6439 18.159 16.5888C18.2682 16.4236 18.3229 16.3134 18.3775 16.2583C18.3775 16.2583 18.3229 16.2032 18.3229 16.1481C18.2682 16.038 18.1043 15.9278 17.8858 15.8727C17.7219 15.8176 17.4487 15.7626 17.3394 15.7626C16.8477 15.7075 16.5745 15.8727 16.4106 16.038C16.4106 16.038 16.4653 16.038 16.4653 16.0931C16.5745 16.2032 16.6292 16.3134 16.6292 16.4786C16.6838 16.5888 16.6292 16.6439 16.6292 16.7541Z"
            fill="#455A64"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMaestro(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Maestro">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Maestro_2">
          <path
            id="Left"
            d="M13.2716 5.22397C17.0401 5.22421 20.0948 8.31503 20.0948 12.1273C20.0947 15.9394 17.04 19.0294 13.2716 19.0296C9.50305 19.0296 6.44757 15.9395 6.44739 12.1273C6.44739 8.31488 9.50294 5.22397 13.2716 5.22397Z"
            fill="#ED0006"
          />
          <path
            id="Right"
            d="M22.1241 5.22397C25.8925 5.22421 28.9473 8.31503 28.9473 12.1273C28.9471 15.9394 25.8924 19.0294 22.1241 19.0296C18.3555 19.0296 15.3 15.9395 15.2999 12.1273C15.2999 8.31488 18.3554 5.22397 22.1241 5.22397Z"
            fill="#0099DF"
          />
          <path
            id="Middle"
            d="M17.6974 6.87497C19.164 8.14109 20.0948 10.0236 20.0948 12.1269C20.0948 14.23 19.1637 16.1118 17.6974 17.3779C16.2311 16.1118 15.2999 14.23 15.2999 12.1269C15.2999 10.0236 16.2308 8.14109 17.6974 6.87497Z"
            fill="#6C6BBD"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMastercard(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Mastercard">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Mastercard_2">
          <path
            id="Left"
            d="M22.1758 5C25.9444 5 29 8.09091 29 11.9033C28.9998 15.7156 25.9443 18.8057 22.1758 18.8057C20.4864 18.8056 18.9416 18.1832 17.75 17.1543C16.5584 18.1832 15.0137 18.8056 13.3242 18.8057C9.55566 18.8057 6.50018 15.7156 6.5 11.9033C6.5 8.09091 9.55555 5 13.3242 5C15.0134 5.00011 16.5584 5.62186 17.75 6.65039C18.9416 5.62185 20.4866 5.00011 22.1758 5Z"
            fill="#ED0006"
          />
          <path
            id="Right"
            d="M22.1758 5C25.9444 5 29 8.09091 29 11.9033C28.9998 15.7156 25.9443 18.8057 22.1758 18.8057C20.4863 18.8056 18.9416 18.1832 17.75 17.1543C19.2164 15.8882 20.1474 14.0064 20.1475 11.9033C20.1475 9.79982 19.2168 7.91652 17.75 6.65039C18.9416 5.62185 20.4866 5.00011 22.1758 5Z"
            fill="#F9A000"
          />
          <path
            id="Middle"
            d="M17.75 6.65102C19.2166 7.91714 20.1475 9.79963 20.1475 11.903C20.1475 14.0061 19.2163 15.8878 17.75 17.1539C16.2837 15.8878 15.3525 14.0061 15.3525 11.903C15.3525 9.79965 16.2834 7.91714 17.75 6.65102Z"
            fill="#FF5E00"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconMediumColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5043)">
        <path
          id="Vector"
          d="M24 11.8277C24 15.007 23.4672 17.5859 22.8097 17.5859C22.1522 17.5859 21.6196 15.0077 21.6196 11.8277C21.6196 8.64769 22.1525 6.06944 22.8097 6.06944C23.467 6.06944 24 8.64746 24 11.8277Z"
          fill="black"
        />
        <path
          id="Vector_2"
          d="M20.9627 11.8277C20.9627 15.377 19.4474 18.2555 17.5783 18.2555C15.7091 18.2555 14.1938 15.377 14.1938 11.8277C14.1938 8.27838 15.7089 5.39995 17.578 5.39995C19.4472 5.39995 20.9625 8.27746 20.9625 11.8277"
          fill="black"
        />
        <path
          id="Vector_3"
          d="M13.5374 11.8277C13.5374 15.5984 10.5069 18.6552 6.76884 18.6552C3.03073 18.6552 0 15.5977 0 11.8277C0 8.05767 3.0305 5 6.76884 5C10.5072 5 13.5374 8.05698 13.5374 11.8277Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5043">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconMediumColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_270)">
        <path
          id="Vector"
          d="M24 11.8277C24 15.007 23.4672 17.5859 22.8097 17.5859C22.1522 17.5859 21.6196 15.0077 21.6196 11.8277C21.6196 8.64769 22.1525 6.06944 22.8097 6.06944C23.467 6.06944 24 8.64746 24 11.8277Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M20.9628 11.8277C20.9628 15.377 19.4476 18.2555 17.5784 18.2555C15.7092 18.2555 14.194 15.377 14.194 11.8277C14.194 8.27838 15.709 5.39995 17.5782 5.39995C19.4473 5.39995 20.9626 8.27746 20.9626 11.8277"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M13.5374 11.8277C13.5374 15.5984 10.5069 18.6552 6.76884 18.6552C3.03073 18.6552 0 15.5977 0 11.8277C0 8.05767 3.0305 5 6.76884 5C10.5072 5 13.5374 8.05698 13.5374 11.8277Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_270">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconMessengerColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M11.9997 0C5.24086 0 0 4.95273 0 11.6394C0 15.1372 1.43396 18.161 3.7679 20.2489C3.96289 20.4229 4.08289 20.6689 4.08889 20.9329L4.15489 23.0687C4.15969 23.2259 4.20303 23.3795 4.28108 23.5159C4.35914 23.6524 4.46953 23.7677 4.60254 23.8515C4.73556 23.9353 4.88713 23.9852 5.04394 23.9968C5.20075 24.0083 5.35799 23.9811 5.50185 23.9177L7.88378 22.8677C8.08478 22.7778 8.31277 22.7628 8.52577 22.8197C9.62074 23.1197 10.7847 23.2817 11.9997 23.2817C18.7585 23.2817 23.9993 18.329 23.9993 11.6424C23.9993 4.95573 18.7585 0 11.9997 0Z"
          fill="url(#paint0_radial_634_5189)"
        />
        <path
          id="Vector_2"
          d="M4.794 15.0442L8.31891 9.45248C8.45151 9.24195 8.62632 9.06121 8.8323 8.92165C9.03828 8.78209 9.27096 8.68675 9.51564 8.64165C9.76033 8.59654 10.0117 8.60266 10.2539 8.65961C10.4961 8.71655 10.7239 8.82309 10.9228 8.9725L13.7278 11.0754C13.853 11.1691 14.0053 11.2196 14.1617 11.219C14.3182 11.2185 14.4702 11.167 14.5947 11.0724L18.3806 8.19855C18.8846 7.81457 19.5446 8.42053 19.2086 8.9575L15.6807 14.5462C15.5481 14.7567 15.3733 14.9375 15.1673 15.077C14.9613 15.2166 14.7287 15.3119 14.484 15.357C14.2393 15.4021 13.9879 15.396 13.7457 15.3391C13.5035 15.2821 13.2757 15.1756 13.0768 15.0262L10.2719 12.9233C10.1466 12.8295 9.99429 12.7791 9.83786 12.7797C9.68144 12.7802 9.52944 12.8317 9.40488 12.9263L5.61898 15.8001C5.11499 16.1841 4.45501 15.5811 4.794 15.0442Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_634_5189"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.01989 23.9987) scale(26.3993 26.3986)"
        >
          <stop stopColor="#0099FF" />
          <stop offset="0.6" stopColor="#A033FF" />
          <stop offset="0.9" stopColor="#FF5280" />
          <stop offset="1" stopColor="#FF7061" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function IconMessengerColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.6397C0 4.95286 5.241 0 12 0C18.759 0 24 4.95586 24 11.6427C24 18.3295 18.759 23.2824 12 23.2824C10.785 23.2824 9.621 23.1204 8.526 22.8204C8.313 22.7634 8.085 22.7784 7.884 22.8684L5.502 23.9183C5.35814 23.9818 5.20089 24.009 5.04408 23.9974C4.88726 23.9859 4.73569 23.936 4.60267 23.8521C4.46965 23.7683 4.35926 23.6531 4.2812 23.5166C4.20314 23.3801 4.15981 23.2265 4.155 23.0694L4.089 20.9334C4.083 20.6694 3.963 20.4234 3.768 20.2494C1.434 18.1615 0 15.1376 0 11.6397ZM8.31901 9.45274L4.79401 15.0446C4.45501 15.5816 5.11501 16.1846 5.61901 15.8006L9.40501 12.9266C9.52958 12.832 9.68158 12.7806 9.83801 12.78C9.99444 12.7795 10.1468 12.8299 10.272 12.9236L13.077 15.0266C13.276 15.176 13.5037 15.2825 13.746 15.3395C13.9882 15.3964 14.2395 15.4026 14.4842 15.3575C14.7289 15.3124 14.9616 15.217 15.1676 15.0774C15.3736 14.9379 15.5484 14.7571 15.681 14.5466L19.209 8.95776C19.545 8.42077 18.885 7.81479 18.381 8.19878L14.595 11.0727C14.4704 11.1673 14.3184 11.2188 14.162 11.2193C14.0056 11.2199 13.8532 11.1694 13.728 11.0757L10.923 8.97276C10.7241 8.82334 10.4963 8.7168 10.2541 8.65985C10.0119 8.6029 9.76047 8.59678 9.51578 8.64189C9.27109 8.68699 9.0384 8.78234 8.83242 8.9219C8.62643 9.06146 8.45162 9.24221 8.31901 9.45274Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconMicrosoftOfficeWord(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Microsoft_Office_Word">
        <g id="Group 67">
          <path
            id="Vector"
            d="M21.1475 2H7.50369C7.03283 2 6.65112 2.37614 6.65112 2.84013V6.58335L14.5581 8.87502L22 6.58335V2.84013C22 2.37614 21.6183 2 21.1475 2Z"
            fill="#41A5EE"
          />
          <path
            id="Vector_2"
            d="M22 6.58335H6.65112V11.1667L14.5581 12.5417L22 11.1667V6.58335Z"
            fill="#2B7CD3"
          />
          <path
            id="Vector_3"
            d="M6.65112 11.1667V15.7501L14.093 16.6667L22 15.7501V11.1667H6.65112Z"
            fill="#185ABD"
          />
          <path
            id="Vector_4"
            d="M7.50369 20.3334H21.1475C21.6183 20.3334 22 19.9573 22 19.4933V15.75H6.65112V19.4933C6.65112 19.9573 7.03283 20.3334 7.50369 20.3334Z"
            fill="#103F91"
          />
          <path
            id="Vector_5"
            opacity="0.1"
            d="M12.3102 5.66668H6.65112V17.1251H12.3102C12.7804 17.1235 13.1612 16.7483 13.1628 16.2849V6.50681C13.1612 6.04345 12.7804 5.66819 12.3102 5.66668Z"
            fill="black"
          />
          <path
            id="Vector_6"
            opacity="0.2"
            d="M11.8451 6.12502H6.65112V17.5834H11.8451C12.3153 17.5819 12.6961 17.2066 12.6977 16.7433V6.96515C12.6961 6.50178 12.3153 6.12652 11.8451 6.12502Z"
            fill="black"
          />
          <path
            id="Vector_7"
            opacity="0.2"
            d="M11.8451 6.12502H6.65112V16.6667H11.8451C12.3153 16.6652 12.6961 16.29 12.6977 15.8266V6.96515C12.6961 6.50178 12.3153 6.12652 11.8451 6.12502Z"
            fill="black"
          />
          <path
            id="Vector_8"
            opacity="0.2"
            d="M11.38 6.12502H6.65112V16.6667H11.38C11.8502 16.6652 12.231 16.29 12.2325 15.8266V6.96515C12.231 6.50178 11.8502 6.12652 11.38 6.12502Z"
            fill="black"
          />
          <path
            id="Vector_9"
            d="M2.85256 6.12502H11.38C11.8509 6.12502 12.2326 6.50115 12.2326 6.96515V15.3683C12.2326 15.8323 11.8509 16.2084 11.38 16.2084H2.85256C2.38171 16.2084 2 15.8323 2 15.3683V6.96515C2 6.50115 2.38171 6.12502 2.85256 6.12502Z"
            fill="url(#paint0_linear_914_1245)"
          />
          <path
            id="Vector_10"
            d="M5.49864 12.5683C5.51539 12.698 5.52655 12.8107 5.53166 12.9075H5.55119C5.55863 12.8158 5.57414 12.7053 5.5977 12.5761C5.62127 12.4468 5.64252 12.3376 5.66143 12.2484L6.55818 8.43594H7.71772L8.64795 12.1911C8.702 12.4246 8.74069 12.6613 8.76377 12.8997H8.77912C8.79646 12.6687 8.82878 12.4391 8.87587 12.2122L9.61773 8.4341H10.6731L9.36982 13.8975H8.13679L7.25307 10.2794C7.22749 10.1753 7.19819 10.0392 7.16609 9.87189C7.134 9.7046 7.114 9.58223 7.10609 9.50523H7.09074C7.08051 9.59414 7.0605 9.72615 7.03074 9.90123C7.00097 10.0763 6.97709 10.2059 6.9591 10.2899L6.1284 13.8965H4.87444L3.56421 8.43593H4.63863L5.44654 12.2561C5.46469 12.3345 5.4819 12.439 5.49864 12.5683Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_1245"
          x1="3.77761"
          y1="5.46856"
          x2="10.3089"
          y2="16.9479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2368C4" />
          <stop offset="0.5" stopColor="#1A5DBE" />
          <stop offset="1" stopColor="#1146AC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconMicrosoftWindows(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Microsoft_Windows">
        <g id="Shape">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4.83167L10.1734 3.72197L10.1769 11.5816L2.00747 11.6279L2 4.83167ZM10.1695 12.4871L10.1758 20.3536L2.00634 19.2338L2.00589 12.4344L10.1695 12.4871ZM11.1603 3.5768L21.9975 2V11.4816L11.1603 11.5674V3.5768ZM22 12.5611L21.9975 22L11.1603 20.4752L11.1451 12.5434L22 12.5611Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconOneNote(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="OneNote">
        <g id="OneNote)" clipPath="url(#clip0_914_1312)">
          <path
            id="Vector"
            d="M17.3488 22H7.50275C7.03241 22 6.65112 21.6106 6.65112 21.1303V3.86973C6.65112 3.38939 7.03241 3 7.50275 3H21.1483C21.6187 3 22 3.38939 22 3.86973V7.75L17.3488 22Z"
            fill="#CA64EA"
          />
          <path
            id="Vector_2"
            d="M22 12.5L19.6745 13.925L17.3489 12.5V7.75H22L22 12.5Z"
            fill="#AE4BD5"
          />
          <path
            id="Vector_3"
            d="M22 17.25L19.6745 18.675L17.3489 17.25V12.5H22V17.25Z"
            fill="#9332BF"
          />
          <path
            id="Vector_4"
            d="M17.3489 17.25H22V21.1094C22 21.6013 21.6096 22 21.1279 22H17.3489V17.25Z"
            fill="#7719AA"
          />
          <path
            id="Vector_5"
            opacity="0.2"
            d="M12.3102 6.8H6.65112V18.675H12.3102C12.7804 18.6734 13.1612 18.2845 13.1627 17.8043V7.67067C13.1612 7.19047 12.7804 6.80157 12.3102 6.8Z"
            fill="black"
          />
          <path
            id="Vector_6"
            opacity="0.2"
            d="M11.8451 7.27499H6.65112V19.15H11.8451C12.3153 19.1484 12.6961 18.7595 12.6976 18.2793V8.14567C12.6961 7.66546 12.3153 7.27656 11.8451 7.27499Z"
            fill="black"
          />
          <path
            id="Vector_7"
            opacity="0.5"
            d="M11.8451 7.27499H6.65112V18.2H11.8451C12.3153 18.1984 12.6961 17.8095 12.6976 17.3293V8.14567C12.6961 7.66546 12.3153 7.27656 11.8451 7.27499Z"
            fill="black"
          />
          <path
            id="Vector_8"
            opacity="0.5"
            d="M11.38 7.27499H6.65112V18.2H11.38C11.8502 18.1984 12.231 17.8095 12.2325 17.3293V8.14567C12.231 7.66546 11.8502 7.27656 11.38 7.27499Z"
            fill="black"
          />
          <path
            id="Vector_9"
            d="M2.85256 7.27499H11.38C11.8509 7.27499 12.2326 7.66481 12.2326 8.14567V16.8543C12.2326 17.3352 11.8509 17.725 11.38 17.725H2.85256C2.38171 17.725 2 17.3352 2 16.8543V8.14567C2 7.66481 2.38171 7.27499 2.85256 7.27499Z"
            fill="url(#paint0_linear_914_1312)"
          />
          <path
            id="Vector_10"
            d="M4.80273 9.66995H5.95855L8.22971 13.4224C8.33297 13.5906 8.41049 13.726 8.46227 13.8286H8.47716C8.44906 13.5731 8.43788 13.316 8.44367 13.0591V9.66995H9.42972V15.3301H8.34785L5.99156 11.4735C5.91176 11.3463 5.84148 11.2131 5.78133 11.075H5.76273C5.78648 11.3558 5.79626 11.6377 5.79203 11.9196V15.3301H4.80273V9.66995Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_1312"
          x1="3.7776"
          y1="6.59467"
          x2="10.6678"
          y2="18.2798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8324B3" />
          <stop offset="0.5" stopColor="#7A1BAC" />
          <stop offset="1" stopColor="#621197" />
        </linearGradient>
        <clipPath id="clip0_914_1312">
          <rect width="20" height="19" fill="white" transform="translate(2 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPSP(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="PSP">
        <g id="Group 1">
          <path
            id="Vector"
            d="M12.3824 2C8.33214 2 5.05027 5.26032 5 9.29623C5 9.32495 5 9.35368 5 9.38959V20.5566V22L6.27828 21.325C6.27828 21.325 7.11849 20.8725 7.93716 20.1688C9.12926 19.1347 9.74686 18.0575 9.7684 16.9515V16.9372V16.298C10.5799 16.6068 11.4632 16.7792 12.3824 16.7792C16.4614 16.7792 19.7648 13.4758 19.7648 9.39677C19.7648 5.31777 16.4614 2 12.3824 2Z"
            fill="#0B1E39"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.81871 12.14C9.81871 12.0323 9.94079 11.9748 10.0341 12.0251L15.2765 15.0413C15.3842 15.1059 15.3771 15.2639 15.255 15.3142C14.9031 15.4506 14.5009 15.6158 14.1778 15.7091C12.8708 16.0969 11.571 16.0251 10.2711 15.6301C10.0054 15.5511 9.8977 15.3357 9.85461 15.228C9.84025 15.1921 9.83307 15.149 9.83307 15.1131L9.81153 12.1472L9.81871 12.14ZM13.5027 12.7361C13.4022 12.7935 13.4022 12.9443 13.5027 13.0018L16.009 14.5027C16.2316 14.6391 16.3896 14.6032 16.562 14.4524C17.9121 13.289 18.702 11.8312 18.8815 10.0502C18.8815 9.99279 18.8815 9.94252 18.8815 9.87789C18.8815 9.76299 18.7595 9.69118 18.6589 9.74863C16.9067 10.7612 15.2191 11.7379 13.4955 12.7289L13.5027 12.7361ZM15.851 10.1221V4.16155C15.851 4.03947 15.9875 3.96766 16.088 4.03947C16.7702 4.49189 17.3017 5.04486 17.7541 5.68399C18.3286 6.50267 18.702 7.40033 18.8385 8.39136C18.8528 8.50626 18.7882 8.70733 18.6948 8.7576L16.0665 10.2513C15.9731 10.3088 15.851 10.237 15.851 10.1292V10.1221ZM14.7379 6.81146C12.9785 5.7989 11.2909 4.82223 9.553 3.82403C9.4381 3.7594 9.44528 3.60141 9.553 3.53678C9.57454 3.5296 9.5889 3.51523 9.60327 3.50805C10.6446 3.04127 11.7218 2.81146 12.878 2.91918C13.5027 2.97663 14.106 3.09872 14.6876 3.30697C14.7954 3.35006 14.939 3.48651 14.939 3.58705C14.9534 4.59243 14.9534 5.59064 14.9534 6.68938C14.9534 6.80428 14.8313 6.86891 14.7307 6.81864L14.7379 6.81146ZM6.07724 9.10231L11.3268 6.07179C11.4201 6.01434 11.4201 5.87789 11.3268 5.82044C10.3789 5.27466 9.50991 4.77915 8.63379 4.29082C8.54761 4.24055 8.35372 4.29082 8.26754 4.35545C7.06826 5.31775 6.3214 6.57448 5.99106 8.06819C5.93361 8.31954 5.90488 8.66425 5.87616 8.96586C5.8618 9.08076 5.98388 9.15258 6.08442 9.09513L6.07724 9.10231Z"
            fill="url(#paint0_linear_914_1256)"
          />
          <path
            id="Vector_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4111 6.55296C12.368 6.55296 12.3321 6.56014 12.2962 6.58168L9.9838 7.91741C9.91198 7.9605 9.8689 8.03949 9.8689 8.12567V10.7971C9.8689 10.8833 9.91198 10.9623 9.9838 11.0054L12.2962 12.3411C12.3321 12.3627 12.3752 12.3698 12.4111 12.3698C12.447 12.3698 12.4901 12.3627 12.526 12.3411L14.8384 11.0054C14.9102 10.9623 14.9533 10.8833 14.9533 10.7971V8.12567C14.9533 8.03949 14.9102 7.9605 14.8384 7.91741L12.526 6.58168C12.4901 6.56014 12.447 6.55296 12.4111 6.55296ZM12.4111 7.73069L13.912 8.59963V10.3303L12.4111 11.1993L10.9102 10.3303V8.59963L12.4111 7.73069Z"
            fill="url(#paint1_linear_914_1256)"
          />
          <path
            id="Vector_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.89942 16.93C8.85633 18.9766 5.8689 20.5565 5.8689 20.5565V10.4811C5.8689 10.1651 5.96944 10.1149 6.23514 9.96407L8.69834 8.55653C8.79888 8.49908 8.92814 8.57089 8.92814 8.68579L8.89942 16.93Z"
            fill="url(#paint2_linear_914_1256)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_1256"
          x1="10.6374"
          y1="14.2226"
          x2="14.1347"
          y2="4.63552"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.17" stopColor="#4396FF" />
          <stop offset="1" stopColor="#3EDCFA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_914_1256"
          x1="13.1939"
          y1="7.06283"
          x2="11.6427"
          y2="11.7881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE100" />
          <stop offset="1" stopColor="#FF5A00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_914_1256"
          x1="7.39852"
          y1="20.5493"
          x2="7.39852"
          y2="8.53498"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE100" />
          <stop offset="0.64" stopColor="#FF5A00" />
          <stop offset="1" stopColor="#FF5A00" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconPayPal(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="PayPal">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="PayPal_2">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.90001 15.2409H8.34439C8.23794 15.2409 8.1474 15.3183 8.1308 15.4234L7.50163 19.4124C7.48913 19.4912 7.55009 19.5621 7.62993 19.5621H8.37259C8.47905 19.5621 8.56958 19.4847 8.58618 19.3795L8.75588 18.3036C8.77225 18.1982 8.863 18.121 8.96924 18.121H9.46169C10.4864 18.121 11.0778 17.6251 11.2323 16.6424C11.3019 16.2125 11.2353 15.8747 11.0339 15.6381C10.8129 15.3784 10.4206 15.2409 9.90001 15.2409ZM10.0795 16.6979C9.99443 17.2561 9.56792 17.2561 9.15553 17.2561H8.92078L9.08547 16.2136C9.09525 16.1506 9.14984 16.1042 9.21353 16.1042H9.32112C9.60204 16.1042 9.86706 16.1042 10.004 16.2643C10.0856 16.3599 10.1106 16.5018 10.0795 16.6979ZM14.5501 16.68H13.8052C13.7417 16.68 13.6869 16.7264 13.6771 16.7895L13.6441 16.9978L13.592 16.9223C13.4308 16.6882 13.0712 16.61 12.7122 16.61C11.889 16.61 11.1859 17.2335 11.049 18.1081C10.9778 18.5443 11.079 18.9615 11.3264 19.2524C11.5535 19.5199 11.8783 19.6314 12.2647 19.6314C12.928 19.6314 13.2959 19.2048 13.2959 19.2048L13.2626 19.4119C13.2501 19.4911 13.3111 19.562 13.3904 19.562H14.0615C14.1682 19.562 14.2582 19.4846 14.2751 19.3794L14.6777 16.8297C14.6904 16.7513 14.6297 16.68 14.5501 16.68ZM13.5117 18.1299C13.4398 18.5555 13.102 18.8412 12.6713 18.8412C12.455 18.8412 12.282 18.7718 12.1711 18.6403C12.061 18.5098 12.0191 18.3239 12.0541 18.117C12.1213 17.695 12.4647 17.4 12.889 17.4C13.1004 17.4 13.2724 17.4702 13.3857 17.6028C13.4992 17.7368 13.5442 17.9238 13.5117 18.1299ZM17.769 16.6799H18.5176C18.6224 16.6799 18.6836 16.7975 18.624 16.8835L16.1342 20.4774C16.0939 20.5356 16.0275 20.5702 15.9565 20.5702H15.2089C15.1036 20.5702 15.0421 20.4517 15.1031 20.3655L15.8783 19.2712L15.0538 16.8514C15.0253 16.7673 15.0874 16.6799 15.1769 16.6799H15.9124C16.008 16.6799 16.0923 16.7426 16.1199 16.8341L16.5575 18.2956L17.59 16.7747C17.6304 16.7154 17.6976 16.6799 17.769 16.6799Z"
            fill="#253B80"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.8855 19.4124L26.5239 15.3504C26.5337 15.2873 26.5883 15.2409 26.6518 15.2407H27.3705C27.4499 15.2407 27.5108 15.3119 27.4983 15.3906L26.8687 19.3795C26.8523 19.4847 26.7618 19.5621 26.6551 19.5621H26.0132C25.9339 19.5621 25.8729 19.4911 25.8855 19.4124ZM20.9961 15.2409H19.4402C19.334 15.2409 19.2434 15.3183 19.2268 15.4233L18.5976 19.4124C18.5851 19.4911 18.6461 19.5621 18.7255 19.5621H19.5239C19.5981 19.5621 19.6615 19.508 19.6731 19.4343L19.8516 18.3036C19.8681 18.1982 19.9588 18.1209 20.065 18.1209H20.5572C21.5822 18.1209 22.1734 17.625 22.3281 16.6424C22.3979 16.2125 22.3308 15.8747 22.1295 15.6381C21.9086 15.3784 21.5167 15.2409 20.9961 15.2409ZM21.1755 16.6979C21.0907 17.2561 20.6642 17.2561 20.2515 17.2561H20.017L20.182 16.2136C20.1918 16.1506 20.2459 16.1042 20.3098 16.1042H20.4173C20.6981 16.1042 20.9633 16.1042 21.1002 16.2643C21.1819 16.3599 21.2067 16.5018 21.1755 16.6979ZM25.6458 16.68H24.9013C24.8373 16.68 24.783 16.7264 24.7734 16.7895L24.7405 16.9978L24.6882 16.9223C24.5269 16.6882 24.1676 16.61 23.8086 16.61C22.9853 16.61 22.2825 17.2335 22.1455 18.1081C22.0746 18.5443 22.1753 18.9615 22.4228 19.2524C22.6503 19.5199 22.9747 19.6314 23.3611 19.6314C24.0244 19.6314 24.3922 19.2048 24.3922 19.2048L24.359 19.4119C24.3465 19.491 24.4075 19.562 24.4873 19.562H25.1581C25.2643 19.562 25.3548 19.4846 25.3715 19.3794L25.7743 16.8297C25.7866 16.7512 25.7257 16.68 25.6458 16.68ZM24.6075 18.1299C24.536 18.5555 24.1978 18.8411 23.7669 18.8411C23.551 18.8411 23.3778 18.7718 23.2667 18.6403C23.1566 18.5098 23.1152 18.3239 23.1499 18.1169C23.2173 17.6949 23.5604 17.4 23.9846 17.4C24.1962 17.4 24.3681 17.4702 24.4815 17.6028C24.5953 17.7368 24.6404 17.9238 24.6075 18.1299Z"
            fill="#179BD7"
          />
          <path
            id="Vector_3"
            d="M15.657 13.8139L15.8483 12.5991L15.4223 12.5892H13.3881L14.8017 3.6254C14.8061 3.59833 14.8204 3.5731 14.8412 3.55519C14.8621 3.53727 14.8888 3.5274 14.9166 3.5274H18.3466C19.4853 3.5274 20.2711 3.76436 20.6814 4.23205C20.8738 4.45146 20.9963 4.68074 21.0556 4.93305C21.1177 5.19781 21.1188 5.51412 21.0581 5.89991L21.0537 5.92807V6.17526L21.2461 6.28424C21.4081 6.37016 21.5367 6.46853 21.6354 6.58116C21.8001 6.76875 21.9065 7.00717 21.9515 7.28984C21.9979 7.58055 21.9825 7.92648 21.9065 8.31812C21.8187 8.76864 21.6768 9.16101 21.4852 9.48207C21.3089 9.77791 21.0844 10.0232 20.8179 10.2134C20.5633 10.3941 20.2609 10.5312 19.919 10.619C19.5877 10.7052 19.21 10.7488 18.7957 10.7488H18.5287C18.3379 10.7488 18.1524 10.8175 18.0069 10.9408C17.861 11.0666 17.7644 11.2384 17.7348 11.4264L17.7147 11.5358L17.3768 13.6767L17.3614 13.7553C17.3574 13.7803 17.3505 13.7927 17.3403 13.8011C17.3311 13.8087 17.318 13.8139 17.3051 13.8139H15.657Z"
            fill="#253B80"
          />
          <path
            id="Vector_4"
            d="M21.4282 5.95672C21.418 6.02217 21.4063 6.08909 21.3931 6.15783C20.9407 8.48025 19.3932 9.28255 17.4167 9.28255H16.4104C16.1687 9.28255 15.965 9.45806 15.9273 9.69648L15.4121 12.9642L15.2662 13.8904C15.2416 14.0469 15.3624 14.1881 15.5203 14.1881H17.3052C17.5166 14.1881 17.6961 14.0345 17.7293 13.8261L17.7469 13.7354L18.083 11.6027L18.1046 11.4858C18.1374 11.2766 18.3173 11.123 18.5287 11.123H18.7957C20.5249 11.123 21.8787 10.4209 22.2744 8.3892C22.4397 7.54046 22.3541 6.83178 21.9167 6.33336C21.7844 6.18307 21.6202 6.05837 21.4282 5.95672Z"
            fill="#179BD7"
          />
          <path
            id="Vector_5"
            d="M20.9548 5.76819C20.8858 5.74807 20.8144 5.72979 20.7412 5.71333C20.6678 5.69725 20.5924 5.68299 20.5149 5.67055C20.2436 5.62667 19.9463 5.60583 19.6278 5.60583H16.9393C16.8731 5.60583 16.8103 5.62082 16.754 5.64788C16.63 5.70748 16.5379 5.82487 16.5155 5.96858L15.9435 9.59097L15.9271 9.69665C15.9648 9.45823 16.1685 9.2827 16.4102 9.2827H17.4165C19.393 9.2827 20.9406 8.48004 21.3929 6.158C21.4064 6.08925 21.4178 6.02233 21.428 5.95688C21.3136 5.89618 21.1896 5.84425 21.0561 5.8C21.0232 5.78903 20.9892 5.77843 20.9548 5.76819Z"
            fill="#222D65"
          />
          <path
            id="Vector_6"
            d="M16.5156 5.96849C16.5379 5.82477 16.6301 5.70739 16.754 5.64815C16.8107 5.62109 16.8733 5.6061 16.9394 5.6061H19.6279C19.9464 5.6061 20.2437 5.62694 20.5149 5.67082C20.5925 5.68326 20.6679 5.69752 20.7414 5.7136C20.8145 5.73007 20.8858 5.74835 20.9549 5.76846C20.9893 5.7787 21.0233 5.7893 21.0565 5.79991C21.19 5.84415 21.314 5.89645 21.4284 5.95678C21.5631 5.09854 21.4274 4.51419 20.9634 3.98505C20.4518 3.40253 19.5284 3.15314 18.3469 3.15314H14.9168C14.6755 3.15314 14.4697 3.32866 14.4323 3.56745L13.0037 12.6234C12.9755 12.8026 13.1137 12.9643 13.2943 12.9643H15.412L15.9437 9.59088L16.5156 5.96849Z"
            fill="#253B80"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPayoneer(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Payoneer">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Payoneer_2">
          <path
            id="Payoneer_3"
            d="M26.2227 11.585C26.7353 11.0407 27.3651 10.8466 28.0908 11.0469C28.5336 11.1704 28.7702 11.4916 28.7969 11.9424C28.8235 12.3831 28.6232 12.7136 28.207 12.9072C27.7876 13.1008 27.3414 13.1316 26.8887 13.1416C26.799 13.1383 26.706 13.1377 26.6064 13.1377C26.5765 13.4649 26.8089 13.7159 27.165 13.7627C27.498 13.8028 27.8179 13.7522 28.1309 13.6387C28.184 13.6187 28.234 13.5989 28.3037 13.5723C28.3237 13.7892 28.3504 13.9927 28.3604 14.1963C28.3637 14.2364 28.3169 14.2997 28.2803 14.3164C27.7144 14.5501 27.132 14.6304 26.5361 14.4668C26.0001 14.3199 25.7199 13.9288 25.6533 13.3945C25.5702 12.7102 25.7468 12.0924 26.2227 11.585ZM10.2754 10.9707C10.5583 10.9874 10.8382 11.0537 11.1211 11.0937C11.2342 11.1104 11.2513 11.1739 11.2314 11.2705C11.1049 11.9317 10.9718 12.5898 10.8652 13.251C10.8086 13.6016 10.7919 13.9624 10.7686 14.3164C10.7619 14.4232 10.7349 14.4662 10.625 14.4629C10.4187 14.4562 10.2122 14.4562 10.0059 14.4629C9.89953 14.4662 9.86312 14.4266 9.87305 14.3232C9.88636 14.1629 9.89333 13.9953 9.90332 13.8184C9.73687 13.992 9.60337 14.1696 9.43359 14.2998C9.08402 14.5703 8.6841 14.6304 8.28125 14.4434C7.88185 14.2597 7.71879 13.9021 7.70215 13.4814C7.66555 12.5965 7.97536 11.865 8.71777 11.3574C9.18374 11.037 9.7196 10.9407 10.2754 10.9707ZM23.0771 11.415C23.5732 10.991 24.1556 10.8566 24.7881 11.0469C25.2109 11.1738 25.4475 11.4913 25.4775 11.9287C25.5075 12.3595 25.3204 12.6903 24.9209 12.8906C24.608 13.0474 24.2715 13.104 23.9287 13.124C23.7159 13.134 23.4997 13.124 23.2803 13.124C23.257 13.4712 23.493 13.7182 23.8457 13.7617C24.1886 13.8018 24.5183 13.7485 24.8379 13.625C24.8711 13.6117 24.9078 13.5983 24.9443 13.585C24.951 13.5816 24.9616 13.585 24.9883 13.585C25.0083 13.7886 25.031 13.9926 25.041 14.1963C25.0443 14.2363 24.9979 14.2996 24.958 14.3164C24.4021 14.5434 23.8261 14.6238 23.2402 14.4736C22.6944 14.3334 22.394 13.9394 22.334 13.3887C22.2474 12.6106 22.4746 11.9293 23.0771 11.415ZM16.5586 10.9834C16.9845 10.9367 17.384 10.9906 17.7334 11.251C18.0662 11.498 18.2296 11.8452 18.2529 12.2559C18.2796 12.6832 18.2065 13.091 18.0068 13.4717C17.6307 14.1795 17.0277 14.5232 16.4219 14.54C15.5396 14.54 15.0366 14.2127 14.8535 13.625C14.5507 12.6566 15.1338 11.1437 16.5586 10.9834ZM21.2627 10.9873C21.6221 11.0475 21.8722 11.3111 21.9121 11.6816C21.9587 12.0957 21.8715 12.4968 21.7949 12.8975C21.7017 13.3816 21.6122 13.8659 21.5156 14.3467C21.5055 14.3901 21.4551 14.4537 21.4219 14.457C21.1357 14.4637 20.8496 14.4604 20.5635 14.457C20.5502 14.457 20.5364 14.4469 20.5098 14.4336C20.563 14.1564 20.6161 13.8752 20.666 13.5947C20.7426 13.164 20.8162 12.7364 20.8828 12.3057C20.896 12.2323 20.8899 12.1554 20.8799 12.082C20.8532 11.8251 20.6632 11.7085 20.417 11.7852C20.1773 11.862 20.0335 12.0488 19.917 12.2559C19.7439 12.5597 19.6839 12.8971 19.624 13.2344C19.5575 13.605 19.4941 13.9722 19.4209 14.3428C19.4109 14.3862 19.3614 14.4537 19.3281 14.457C19.0352 14.467 18.7384 14.4629 18.4121 14.4629C18.6318 13.3142 18.8385 12.189 19.0449 11.0537H19.8906C19.8773 11.234 19.8643 11.408 19.8477 11.585C19.9441 11.4949 20.0303 11.4078 20.1201 11.331C20.4497 11.0439 20.8266 10.9172 21.2627 10.9873ZM31.5 10.9736C31.4368 11.2907 31.3835 11.5846 31.3203 11.875C31.3137 11.8984 31.2698 11.9293 31.2432 11.9326C30.5877 12.0195 30.3115 12.2533 30.1484 12.9277C30.0353 13.395 29.9588 13.8756 29.8623 14.3496C29.8556 14.3897 29.8182 14.4531 29.7949 14.4531C29.4889 14.4631 29.1828 14.46 28.8535 14.46C28.8968 14.2129 28.9362 13.9887 28.9795 13.7617C29.1526 12.897 29.3291 12.0322 29.4023 11.1475C29.4057 11.1107 29.4558 11.0502 29.4824 11.0469C29.7354 11.0402 29.9887 11.0439 30.2617 11.0439C30.2417 11.281 30.2247 11.5052 30.208 11.7256C30.5143 11.2748 30.8674 10.9068 31.5 10.9736ZM4.97168 9.80859C5.5941 9.71511 6.22036 9.64789 6.84277 9.80468C7.38545 9.93826 7.76584 10.3226 7.8291 10.7734C7.95888 11.6716 7.43578 12.3893 6.66016 12.6465C6.2508 12.78 5.83477 12.8134 5.41211 12.7734C5.31223 12.7634 5.28129 12.7908 5.26465 12.8877C5.17479 13.3784 5.08187 13.8661 4.98535 14.3535C4.97856 14.3936 4.94219 14.4569 4.91895 14.457C4.61598 14.4637 4.31961 14.46 4 14.46C4.04659 14.2096 4.0833 13.9793 4.12988 13.749C4.36959 12.4834 4.61283 11.2207 4.85254 9.95507C4.86915 9.87521 4.89225 9.82208 4.97168 9.80859ZM16.541 11.7383C16.3682 11.7784 16.2388 11.8854 16.1357 12.0254C15.9061 12.3426 15.8128 12.7001 15.8027 13.084C15.8027 13.1341 15.7994 13.1882 15.8027 13.2383C15.8295 13.5886 16.0788 13.8122 16.4082 13.7822C16.5913 13.7655 16.7345 13.6686 16.8477 13.5283C17.1439 13.151 17.2577 12.7169 17.2178 12.2461C17.1845 11.8621 16.8939 11.6581 16.541 11.7383ZM10.1357 11.7549C9.81297 11.6648 9.54369 11.7287 9.31738 11.9189C8.89123 12.2796 8.69775 12.747 8.73438 13.3047C8.74438 13.4748 8.81077 13.6384 8.99023 13.7119C9.17002 13.7854 9.3338 13.7315 9.47363 13.6113C9.55671 13.538 9.63646 13.4547 9.69629 13.3613C10.0126 12.8771 10.0192 12.3092 10.1357 11.7549ZM27.6279 11.7051C27.2351 11.5984 26.7454 11.9593 26.7021 12.4268C26.9151 12.4134 27.1152 12.4095 27.3115 12.3828C27.4447 12.3661 27.5784 12.3263 27.6982 12.2695C27.8279 12.2127 27.8911 12.0922 27.8711 11.9453C27.851 11.8053 27.7577 11.7384 27.6279 11.7051ZM24.2949 11.7051C23.8989 11.6086 23.4304 11.9556 23.377 12.3994C23.6335 12.4527 24.1593 12.39 24.3623 12.2832C24.5021 12.2097 24.5721 12.0924 24.5488 11.9521C24.5255 11.8086 24.4281 11.7385 24.2949 11.7051ZM6.49023 10.5635C6.25385 10.48 6.01062 10.4959 5.76758 10.5293C5.73779 10.5328 5.69834 10.5794 5.69141 10.6094C5.6082 11.0467 5.52483 11.4878 5.43164 11.9785C5.63467 11.9785 5.81773 11.9956 5.99414 11.9756C6.34039 11.9388 6.61696 11.7818 6.77344 11.4512C6.94975 11.0772 6.82307 10.6803 6.49023 10.5635Z"
            fill="black"
          />
          <path
            id="Payoneer_4"
            d="M20.3334 7.06349C20.7062 7.1236 21.0058 7.32413 21.2621 7.58791C21.3253 7.65127 21.3891 7.77789 21.3627 7.84474C21.3327 7.91821 21.2123 7.98861 21.1224 8.00197C20.2836 8.12552 19.4682 8.34609 18.6859 8.66994C18.2331 8.85694 17.7896 9.08405 17.3568 9.31447C16.4148 9.82203 15.6644 10.4939 14.9154 11.2451C14.1231 12.0399 13.3689 12.9411 12.723 13.8594C12.3202 14.4304 12.0357 14.8951 11.6762 15.4961C11.4964 15.7967 11.2875 16.2605 11.141 16.5811C11.1176 16.6279 11.0678 16.7108 11.0512 16.7041C10.988 16.6841 10.8951 16.6476 10.8783 16.5977C10.8384 16.4742 10.7985 16.3305 10.8217 16.207C10.9482 15.5359 11.2279 14.9179 11.5375 14.3135C12.1401 13.1447 12.8955 12.0788 13.7777 11.1104C14.2804 10.5594 14.8003 10.0221 15.3363 9.50783C16.142 8.72978 17.0412 8.07204 18.0433 7.56447C18.506 7.33078 18.9852 7.15348 19.4945 7.05666C19.5811 7.03996 19.6642 7.01964 19.7474 7.00295C19.8573 6.99961 19.9606 7.00002 20.0639 7.00002C20.1537 7.02004 20.2435 7.05012 20.3334 7.06349ZM11.5639 7.63771C11.6503 7.66771 11.737 7.71797 11.8002 7.78127C12.3295 8.34558 12.6624 9.00368 12.7523 9.77834C12.7723 9.92861 12.779 10.0792 12.7924 10.2295C12.7824 10.6969 12.7031 11.148 12.5433 11.582C12.5267 11.6287 12.4926 11.669 12.4594 11.709C12.3863 11.8053 12.3069 11.8153 12.2504 11.709C12.1771 11.5687 12.1171 11.4179 12.0805 11.2676C11.974 10.7969 11.8734 10.3231 11.7836 9.84572C11.6671 9.23795 11.5639 8.62634 11.4574 8.01857C11.4408 7.93182 11.4348 7.84165 11.4281 7.7549C11.4215 7.65486 11.4775 7.6046 11.5639 7.63771Z"
            fill="#FC461E"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPaysafe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Paysafe">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Paysafe_2">
          <g id="Group">
            <path
              id="Vector"
              d="M29.7555 9.98418C30.1667 9.98418 30.5001 9.65084 30.5001 9.23965C30.5001 8.82846 30.1667 8.49512 29.7555 8.49512C29.3443 8.49512 29.011 8.82846 29.011 9.23965C29.011 9.65084 29.3443 9.98418 29.7555 9.98418Z"
              fill="#7887E6"
            />
            <path
              id="Vector_2"
              d="M29.7555 12.3151C30.1667 12.3151 30.5001 11.9817 30.5001 11.5705C30.5001 11.1593 30.1667 10.826 29.7555 10.826C29.3443 10.826 29.011 11.1593 29.011 11.5705C29.011 11.9817 29.3443 12.3151 29.7555 12.3151Z"
              fill="#FF5073"
            />
          </g>
          <path
            id="Union"
            d="M9.49121 16.459L9.9209 14.9551H10.5537C10.2193 15.9217 9.89275 16.8888 9.5625 17.8477H8.96582L9.30078 16.9844H9.10938C8.89436 16.3079 8.68346 15.6315 8.46484 14.9551H9.10938L9.49121 16.459ZM7.58887 14.9072C8.05852 14.9072 8.34849 15.1146 8.34863 15.5723V16.9844H7.76855L7.73242 16.7812C7.62077 16.9047 7.46954 17.0322 7.21484 17.0322C6.90069 17.0321 6.58227 16.8293 6.58203 16.4238C6.58215 15.9862 6.86491 15.6951 7.71191 15.7109V15.5762C7.71175 15.421 7.58066 15.3691 7.43359 15.3691C7.22704 15.3692 6.9845 15.4607 6.86914 15.5127L6.69336 15.1504C6.88419 15.0311 7.19492 14.9073 7.58887 14.9072ZM14.5889 14.9072C15.0584 14.9073 15.3485 15.1146 15.3486 15.5723V16.9844H14.7676L14.7314 16.7812C14.6198 16.9047 14.4694 17.0322 14.2148 17.0322C13.9007 17.0321 13.5823 16.8294 13.582 16.4238C13.5822 15.9862 13.8649 15.6951 14.7119 15.7109V15.5762C14.7118 15.4211 14.5806 15.3692 14.4336 15.3691C14.2268 15.3692 13.9834 15.4607 13.8682 15.5127L13.6934 15.1504C13.8842 15.031 14.1949 14.9073 14.5889 14.9072ZM18.0625 14.9072C18.4961 14.9073 18.9255 15.1418 18.9258 15.8574V16.0967H17.7246C17.7565 16.4309 17.9591 16.5663 18.2295 16.5664C18.4327 16.5664 18.6636 16.4834 18.7393 16.4355L18.918 16.833C18.7908 16.9287 18.4599 17.0322 18.1338 17.0322C17.4734 17.0321 17.0596 16.6219 17.0596 15.9814C17.0597 15.357 17.4977 14.9074 18.0625 14.9072ZM16.5068 14.9551H16.8965V15.3896H16.5068V16.2891C16.5069 16.4953 16.5827 16.5594 16.7217 16.5596H16.8965V16.9854H16.4434V16.9844C16.2524 16.9844 15.8742 16.9604 15.874 16.4316V15.3887H15.5635V14.9551H15.874V14.5693L16.5068 14.3506V14.9551ZM5.55957 14.2383C6.18776 14.2384 6.48604 14.6046 6.48633 15.0898C6.48633 15.6505 6.08883 15.9813 5.55957 15.9814H5.15723V16.9844H4.50488V14.2383H5.55957ZM12.3564 16.5107H13.4023V16.9844H11.7041V14.2383H12.3564V16.5107ZM20.4385 15.5C20.4024 15.4924 20.3189 15.4922 20.2793 15.4922C20.1123 15.4923 19.9329 15.5594 19.8213 15.6709V16.9844H19.1846V14.9551H19.79V15.3252C19.9212 15.0748 20.1644 14.9073 20.4385 14.9072V15.5ZM7.56934 16.1006C7.31515 16.1007 7.19555 16.2126 7.19531 16.3789C7.19531 16.526 7.30306 16.6181 7.46191 16.6182C7.5612 16.6182 7.6532 16.5818 7.71289 16.5381V16.1123C7.66105 16.1082 7.6207 16.1006 7.56934 16.1006ZM14.5693 16.1006C14.3151 16.1007 14.1955 16.2125 14.1953 16.3789C14.1953 16.526 14.3031 16.6181 14.4619 16.6182C14.561 16.6181 14.6523 16.5817 14.7119 16.5381V16.1123C14.6603 16.1082 14.6205 16.1006 14.5693 16.1006ZM18.0547 15.3525C17.8799 15.3527 17.7488 15.4924 17.7246 15.7627H18.3408C18.3407 15.4881 18.2218 15.3525 18.0547 15.3525ZM5.1582 15.5039H5.48828C5.70679 15.5039 5.85338 15.3646 5.85352 15.1143C5.85341 14.8798 5.72274 14.7159 5.48828 14.7158H5.1582V15.5039ZM21.0742 14.1924H20.8799V14.6729H20.6895V14.1924H20.4824V14.0576H21.0537L21.0742 14.1924ZM21.5059 14.4941C21.5408 14.3483 21.5753 14.2044 21.6123 14.0586H21.8516L21.9004 14.6729H21.7314L21.708 14.2275C21.6684 14.3761 21.6295 14.5243 21.5879 14.6729H21.4199L21.2998 14.2275L21.2764 14.6729H21.1064C21.1249 14.4689 21.1413 14.2626 21.1572 14.0586H21.3965L21.5059 14.4941ZM12.541 8.58105L13.4443 10.7617L14.2314 8.58105H15.3691L13.5205 13.2529H12.4307L12.9131 12.0576L11.3691 8.58105H12.541ZM20.3838 8.49512C21.2281 8.49512 21.7505 8.86724 21.75 9.68945V12.2295H20.6055V12.0674C20.377 12.2109 20.078 12.3154 19.8027 12.3154C19.1051 12.3154 18.5742 11.7893 18.5742 11.1631C18.5742 10.522 19.0289 9.82826 20.6064 9.94043V9.69629C20.6062 9.41776 20.3698 9.32425 20.1055 9.32422C19.7336 9.32422 19.2973 9.48888 19.0898 9.58203L18.7744 8.93164C19.1175 8.71712 19.676 8.49521 20.3838 8.49512ZM26.5029 8.49512C27.5185 8.49512 28.2664 9.27916 28.2666 10.3486V10.6348H25.8945C25.9125 10.8221 25.9612 10.9752 26.0332 11.0967L26.0342 11.0986C26.0459 11.1175 26.0585 11.136 26.0713 11.1533C26.079 11.1641 26.0865 11.1743 26.0947 11.1846C26.0998 11.1906 26.1048 11.1971 26.1104 11.2031C26.1242 11.2196 26.1389 11.2361 26.1543 11.251L26.1562 11.252C26.1943 11.2885 26.2369 11.3218 26.2842 11.3506C26.2851 11.3511 26.2857 11.3512 26.2861 11.3516C26.3072 11.3644 26.3304 11.3764 26.3535 11.3877C26.358 11.3897 26.3622 11.3915 26.3662 11.3936C26.3801 11.4002 26.3952 11.4064 26.4102 11.4121C26.4235 11.4172 26.4369 11.4221 26.4502 11.4268C26.4599 11.4298 26.4703 11.4325 26.4805 11.4355C26.4995 11.4407 26.5185 11.4465 26.5381 11.4512C26.5447 11.4527 26.5519 11.4535 26.5586 11.4551C26.5775 11.4591 26.5968 11.4618 26.6162 11.4648C26.6216 11.4658 26.6265 11.4673 26.6318 11.4678C26.656 11.4709 26.6814 11.4731 26.7061 11.4746C26.7121 11.4751 26.7176 11.4751 26.7236 11.4756C26.7499 11.4771 26.7764 11.4785 26.8037 11.4785C27.1145 11.4785 27.4616 11.3912 27.8037 11.1973L28.1221 11.9062C27.6174 12.2559 26.9627 12.3154 26.6318 12.3154C25.4443 12.3154 24.7002 11.5783 24.7002 10.4268C24.7002 9.30361 25.4873 8.4952 26.5029 8.49512ZM9.93262 8.49512C10.7769 8.49516 11.2988 8.86678 11.2988 9.68945V12.2295H10.1533V12.0674C9.92492 12.2108 9.62571 12.3145 9.35059 12.3145C8.6531 12.3142 8.12305 11.7882 8.12305 11.1621C8.12328 10.5211 8.57713 9.82731 10.1543 9.93945V9.69629C10.1543 9.41741 9.91779 9.32422 9.65332 9.32422C9.28137 9.3243 8.845 9.48892 8.6377 9.58203L8.32324 8.93066C8.66647 8.71617 9.22486 8.49512 9.93262 8.49512ZM16.9473 8.49414C17.4122 8.49414 17.8704 8.63694 18.1709 8.78711L17.8486 9.53906C17.6197 9.43929 17.3052 9.33108 17.0049 9.33105C16.7188 9.33105 16.5469 9.4385 16.5469 9.61035C16.5471 10.0964 18.2354 9.89677 18.2354 11.0986C18.2351 11.8856 17.5193 12.3145 16.6895 12.3145C16.2244 12.3144 15.7239 12.2074 15.2949 11.9785L15.6602 11.2422C15.9174 11.3712 16.2469 11.4854 16.5898 11.4854C16.9262 11.4853 17.126 11.3847 17.126 11.1846C17.1257 10.6487 15.41 10.8702 15.4102 9.65332C15.4102 8.88112 16.0959 8.49426 16.9473 8.49414ZM6.39551 7.29297C7.52594 7.29297 8.0625 7.95157 8.0625 8.82422C8.06241 9.83259 7.34682 10.4268 6.39551 10.4268H5.67285V12.2295H4.5V7.29297H6.39551ZM24.0957 7C24.3034 7 24.4823 7.02863 24.6396 7.07129V7.88672C24.547 7.85845 24.4112 7.83691 24.3037 7.83691C23.953 7.83702 23.8242 8.06568 23.8242 8.3877V8.58105H24.6113V9.36035H23.8242V12.2295H22.6865V9.36035H22.0781V8.58105H22.6865V8.43066C22.6865 7.56534 23.1729 7.00016 24.0957 7ZM10.1963 10.6621C9.50367 10.5475 9.26682 10.8413 9.2666 11.1416C9.2666 11.406 9.46007 11.5712 9.74609 11.5713C9.92515 11.5713 10.0898 11.5065 10.1963 11.4277V10.6621ZM20.6055 10.6621C19.9128 10.5475 19.676 10.8413 19.6758 11.1416C19.6758 11.4061 19.8692 11.5713 20.1553 11.5713C20.3343 11.5713 20.4989 11.5065 20.6064 11.4277H20.6055V10.6621ZM26.5029 9.2959C26.1881 9.29598 25.9377 9.54653 25.8945 10.0332H27.1113C27.0681 9.54697 26.8178 9.2959 26.5029 9.2959ZM5.67285 8.15137V9.56738H6.2666C6.6772 9.56738 6.94801 9.29545 6.92383 8.80664C6.90511 8.43693 6.59 8.15144 6.21973 8.15137H5.67285Z"
            fill="#2D2341"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPhotoshop(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Photoshop">
        <g id="Layer 2">
          <g id="Layer 1">
            <g id="Layer 2_2">
              <g id="Surfaces">
                <g id="Photo Surface">
                  <g id="Outline no shadow">
                    <path
                      id="Vector"
                      d="M5.54167 1.99998H18.4583C18.9236 1.99953 19.3843 2.09318 19.8142 2.27557C20.2441 2.45796 20.6347 2.72551 20.9636 3.06291C21.2926 3.4003 21.5535 3.80092 21.7313 4.24184C21.9091 4.68275 22.0004 5.15531 22 5.63246V18.3675C22.0004 18.8447 21.9091 19.3172 21.7313 19.7581C21.5535 20.199 21.2926 20.5997 20.9636 20.9371C20.6347 21.2745 20.2441 21.542 19.8142 21.7244C19.3843 21.9068 18.9236 22.0004 18.4583 22H5.54167C5.07645 22.0004 4.6157 21.9068 4.18581 21.7244C3.75592 21.542 3.36532 21.2745 3.03635 20.9371C2.70739 20.5997 2.44653 20.199 2.2687 19.7581C2.09087 19.3172 1.99956 18.8447 2 18.3675V5.63246C1.99956 5.15531 2.09087 4.68275 2.2687 4.24184C2.44653 3.80092 2.70739 3.4003 3.03635 3.06291C3.36532 2.72551 3.75592 2.45796 4.18581 2.27557C4.6157 2.09318 5.07645 1.99953 5.54167 1.99998Z"
                      fill="#001E36"
                    />
                  </g>
                </g>
              </g>
              <g id="Outlined Mnemonics Logos">
                <g id="Ps">
                  <path
                    id="Vector_2"
                    d="M6.5 16.0256V7.23076C6.5 7.17093 6.525 7.13675 6.58333 7.13675C6.725 7.13675 6.85833 7.13675 7.05 7.1282C7.24167 7.11965 7.45833 7.11965 7.68333 7.11111C7.90833 7.10256 8.15 7.10256 8.40833 7.09401C8.66667 7.08546 8.91667 7.08546 9.16667 7.08546C9.85 7.08546 10.4167 7.17093 10.8833 7.35042C11.3017 7.49613 11.6831 7.73554 12 8.05128C12.2685 8.32759 12.476 8.65988 12.6083 9.02563C12.7345 9.38183 12.7993 9.75779 12.8 10.1367C12.8 10.8718 12.6333 11.4786 12.3 11.9573C11.9651 12.4352 11.4976 12.7986 10.9583 13C10.3917 13.2137 9.76667 13.2906 9.08333 13.2906C8.88333 13.2906 8.75 13.2906 8.66667 13.282C8.58333 13.2735 8.46667 13.2735 8.30833 13.2735V16.0171C8.31019 16.0312 8.30928 16.0455 8.30565 16.0592C8.30202 16.0728 8.29574 16.0857 8.28719 16.0968C8.27864 16.108 8.26799 16.1173 8.25588 16.1241C8.24376 16.131 8.23043 16.1353 8.21667 16.1367H6.6C6.53333 16.1367 6.5 16.1026 6.5 16.0256ZM8.31667 8.78632V11.6581C8.43333 11.6667 8.54167 11.6752 8.64167 11.6752H9.08333C9.40865 11.6756 9.73202 11.6237 10.0417 11.5214C10.3073 11.4412 10.5447 11.2839 10.725 11.0684C10.9 10.8547 10.9833 10.5641 10.9833 10.188C10.9912 9.92094 10.9247 9.65709 10.7917 9.42734C10.6527 9.20543 10.4484 9.03476 10.2083 8.94016C9.89549 8.81449 9.56075 8.7563 9.225 8.76922C9.00833 8.76922 8.81667 8.76923 8.65833 8.77777C8.54442 8.77013 8.43008 8.77299 8.31667 8.78632Z"
                    fill="#31A8FF"
                  />
                  <path
                    id="Vector_3"
                    d="M17.9998 11.1367C17.7481 11.0008 17.4787 10.9029 17.1998 10.8461C16.8934 10.775 16.5805 10.7377 16.2664 10.735C16.0978 10.7291 15.9292 10.7492 15.7664 10.7949C15.6626 10.817 15.5706 10.8779 15.5081 10.9658C15.466 11.0352 15.443 11.1149 15.4414 11.1966C15.4453 11.2779 15.4745 11.3558 15.5248 11.4188C15.6037 11.5138 15.7 11.5922 15.8081 11.6496C15.9998 11.7521 16.1998 11.8461 16.3998 11.9316C16.85 12.0871 17.2807 12.2965 17.6831 12.5556C17.9568 12.732 18.1831 12.9759 18.3414 13.265C18.4753 13.5376 18.5412 13.8401 18.5331 14.1453C18.5398 14.5493 18.4265 14.9458 18.2081 15.282C17.9757 15.6232 17.6513 15.8876 17.2748 16.0427C16.8664 16.2222 16.3664 16.3162 15.7664 16.3162C15.386 16.3178 15.0063 16.2806 14.6331 16.2051C14.3392 16.153 14.0533 16.0611 13.7831 15.9316C13.754 15.9167 13.7299 15.8933 13.7136 15.8645C13.6973 15.8356 13.6896 15.8025 13.6914 15.7692V14.282C13.6907 14.2674 13.6933 14.2529 13.6991 14.2395C13.7049 14.2261 13.7137 14.2144 13.7248 14.2051C13.7365 14.1981 13.7501 14.1951 13.7636 14.1967C13.7771 14.1982 13.7898 14.2042 13.7998 14.2137C14.1208 14.4078 14.4694 14.5491 14.8331 14.6325C15.1542 14.7182 15.4847 14.7612 15.8164 14.7607C16.1331 14.7607 16.3581 14.7179 16.5081 14.641C16.575 14.6093 16.6317 14.5587 16.6716 14.4951C16.7114 14.4316 16.7328 14.3576 16.7331 14.282C16.7331 14.1624 16.6664 14.0513 16.5331 13.9402C16.3998 13.8291 16.1248 13.7008 15.7164 13.5385C15.2975 13.3871 14.8997 13.1802 14.5331 12.9231C14.272 12.7322 14.0556 12.484 13.8998 12.1966C13.7668 11.9266 13.7009 11.6271 13.7081 11.3248C13.7093 10.9601 13.8073 10.6026 13.9914 10.2906C14.2031 9.94748 14.507 9.67442 14.8664 9.50427C15.2581 9.29914 15.7498 9.20512 16.3414 9.20512C16.6872 9.20522 17.0326 9.23093 17.3748 9.28205C17.6208 9.31619 17.8616 9.38225 18.0914 9.47863C18.128 9.49194 18.158 9.5196 18.1748 9.55555C18.1844 9.58892 18.19 9.62336 18.1914 9.65811V11.0513C18.1916 11.0679 18.1878 11.0843 18.1806 11.0991C18.1734 11.114 18.1628 11.1269 18.1498 11.1367C18.1013 11.1546 18.0482 11.1546 17.9998 11.1367Z"
                    fill="#31A8FF"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconPinterestColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5037)">
        <path
          id="Vector"
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M12 0C5.37284 0 0 5.37284 0 12C0 17.0864 3.16049 21.4321 7.62469 23.1802C7.51605 22.2321 7.42716 20.7704 7.6642 19.7333C7.88148 18.7951 9.06667 13.7679 9.06667 13.7679C9.06667 13.7679 8.71111 13.0469 8.71111 11.9901C8.71111 10.321 9.67901 9.07654 10.884 9.07654C11.9111 9.07654 12.4049 9.84691 12.4049 10.7654C12.4049 11.7926 11.7531 13.3333 11.4074 14.7654C11.121 15.9605 12.0099 16.9383 13.1852 16.9383C15.3185 16.9383 16.958 14.6864 16.958 11.4469C16.958 8.57284 14.8938 6.5679 11.9407 6.5679C8.52346 6.5679 6.51852 9.12593 6.51852 11.7728C6.51852 12.8 6.91358 13.9062 7.40741 14.5086C7.50617 14.6272 7.51605 14.7358 7.48642 14.8543C7.39753 15.2296 7.19012 16.0494 7.15062 16.2173C7.10123 16.4346 6.97284 16.484 6.74568 16.3753C5.24444 15.6741 4.30617 13.4914 4.30617 11.7235C4.30617 7.94074 7.05185 4.4642 12.237 4.4642C16.3951 4.4642 19.6346 7.42716 19.6346 11.3975C19.6346 15.5358 17.0272 18.8642 13.4123 18.8642C12.1975 18.8642 11.0519 18.2321 10.6667 17.4815C10.6667 17.4815 10.0642 19.7728 9.91605 20.3358C9.64938 21.3827 8.91852 22.6864 8.42469 23.4864C9.55062 23.8321 10.7358 24.0198 11.9802 24.0198C18.6074 24.0198 23.9802 18.6469 23.9802 12.0198C24 5.37284 18.6272 0 12 0Z"
          fill="#E60019"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5037">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPinterestColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_269)">
        <path
          id="Vector"
          d="M12 0C5.37188 0 0 5.37188 0 12C0 17.0859 3.16406 21.4266 7.62656 23.175C7.52344 22.2234 7.425 20.7703 7.66875 19.7344C7.88906 18.7969 9.075 13.7719 9.075 13.7719C9.075 13.7719 8.71406 13.0547 8.71406 11.9906C8.71406 10.3219 9.67969 9.075 10.8844 9.075C11.9062 9.075 12.4031 9.84375 12.4031 10.7672C12.4031 11.7984 11.7469 13.3359 11.4094 14.7609C11.1281 15.9562 12.0094 16.9313 13.1859 16.9313C15.3187 16.9313 16.9594 14.6812 16.9594 11.4375C16.9594 8.56406 14.8969 6.55313 11.9484 6.55313C8.53594 6.55313 6.52969 9.1125 6.52969 11.7609C6.52969 12.7922 6.92812 13.8984 7.425 14.4984C7.52344 14.6156 7.5375 14.7234 7.50937 14.8406C7.42031 15.2203 7.21406 16.0359 7.17656 16.2C7.125 16.4203 7.00313 16.4672 6.77344 16.3594C5.27344 15.6609 4.33594 13.4719 4.33594 11.7094C4.33594 7.92188 7.0875 4.44844 12.2625 4.44844C16.425 4.44844 19.6594 7.41563 19.6594 11.3813C19.6594 15.5156 17.0531 18.8438 13.4344 18.8438C12.2203 18.8438 11.0766 18.2109 10.6828 17.4656C10.6828 17.4656 10.0828 19.7578 9.9375 20.3203C9.66562 21.3609 8.93437 22.6688 8.44687 23.4656C9.57187 23.8125 10.7625 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_269">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconPoli(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Poli">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Poli_2">
          <path
            id="Union"
            d="M8.0415 8.6577C8.75702 8.6577 9.42535 8.64328 9.76709 8.7036C10.1251 8.77063 10.4695 8.89459 10.7876 9.06883C11.1073 9.26533 11.3559 9.55539 11.4976 9.89793C11.6706 10.3142 11.7542 10.7611 11.7437 11.2104C11.7436 12.0474 11.5576 12.7026 11.106 13.1401C10.6541 13.5776 9.65699 13.7602 8.78369 13.7602H8.2915V16.0005L6.1001 15.9975V8.6577H8.0415ZM28.8364 15.9751H26.5132V11.1499H28.8364V15.9751ZM23.6011 13.7622H26.0923V15.9653H21.1763V8.61473H23.6011V13.7622ZM8.271 10.1509L8.27393 12.4097C8.30755 12.4145 8.34151 12.4169 8.37549 12.4175C9.05243 12.4424 9.23194 12.2783 9.33545 12.1528C9.4948 11.959 9.49951 11.526 9.49951 11.1255C9.49952 10.7926 9.51154 10.5196 9.26514 10.2583C9.10061 10.0865 8.70609 10.0278 8.271 10.0278V10.1509ZM28.853 8.64696V10.6421H26.48V8.64696H28.853Z"
            fill="black"
          />
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9155 15.4591C18.2285 15.3489 18.5374 15.1165 18.8036 14.8801C19.5536 14.2109 20.3439 13.0753 20.2823 11.6927C20.2182 10.237 19.4205 9.304 18.3583 8.72251C18.6647 8.78846 18.9177 8.98792 19.1535 9.17532C19.8354 9.71579 20.353 10.553 20.3752 11.7297C20.4047 13.2948 19.5536 14.3621 18.7099 15.098C18.9744 14.9693 19.1782 14.7313 19.3753 14.5004C19.934 13.8458 20.4483 12.9136 20.4483 11.7474C20.4483 10.1059 19.5002 9.16084 18.3944 8.54235C18.7507 8.65506 19.0786 8.84036 19.3564 9.08604C19.7649 9.43398 20.0846 9.8706 20.29 10.361C20.4954 10.8515 20.5808 11.3821 20.5395 11.9107C20.4724 13.0625 19.956 14.1451 19.0968 14.9347C18.2508 15.7261 17.1547 16.2118 15.989 16.3117C15.835 16.3225 15.6804 16.3225 15.5264 16.3117C13.5958 16.1548 12.1951 14.9444 12.0489 13.0881C12.0337 12.8951 12.0337 12.7012 12.0489 12.5082C12.131 11.3372 12.6716 10.4043 13.3806 9.68362C14.152 8.89945 15.1272 8.30831 16.4876 8.21662C16.5213 8.07104 16.5608 7.90456 16.5813 7.8C17.029 8.26568 17.5729 8.77318 18.1348 9.32089C17.4579 9.6603 16.799 10.0174 16.1368 10.3713C16.1516 10.2386 16.1828 10.0874 16.1919 9.99085C15.0557 10.1879 14.0978 10.9954 13.899 12.1278C13.6525 13.5096 14.5989 14.5656 15.9528 14.5728C17.3207 14.5801 18.4815 13.5458 18.6902 12.3635C18.8545 11.408 18.4273 10.7404 17.876 10.2989C18.3903 10.6319 18.944 11.2335 18.875 12.1278C18.7633 13.5289 17.4176 14.6894 16.0095 14.6999C15.6392 14.7013 15.2732 14.6228 14.9375 14.4699C14.6018 14.317 14.3047 14.0934 14.0674 13.8152C14.5283 14.4715 15.3342 14.8173 16.2502 14.757C16.9699 14.7095 17.5786 14.3637 18.0264 13.9423C18.4741 13.5208 18.8397 12.9128 18.9301 12.2943C18.9666 12.0481 18.9666 11.7981 18.9301 11.552C18.8175 10.8281 18.369 10.4911 17.9582 10.0238C18.5431 10.4807 19.156 11.0895 19.1157 12.0747C19.0549 13.5144 17.6468 14.7835 16.1738 14.8817C15.2077 14.946 14.6129 14.6227 14.1019 14.1578C14.5858 14.7578 15.4985 15.0658 16.4515 14.9187C17.8111 14.7087 19.0229 13.598 19.1708 12.2203C19.3039 10.9761 18.6606 10.3986 18.0461 9.78898C18.7033 10.2715 19.2595 10.8112 19.2998 11.8037C19.3351 12.6659 18.9062 13.5096 18.3566 14.0492C17.4776 14.9122 15.7655 15.4784 14.4346 14.683C15.5683 15.5299 17.3289 15.0449 18.2638 14.2125C18.9424 13.6093 19.4378 12.805 19.3556 11.6042C19.2891 10.6391 18.7304 10.1453 18.0979 9.63054C18.7485 9.95707 19.3762 10.6101 19.4665 11.5503C19.5873 12.7809 19.0081 13.6897 18.3032 14.301C17.4513 15.0369 16.2494 15.4752 14.8996 15.1342C17.1358 15.8162 19.2266 14.1908 19.524 12.3096C19.7376 10.9576 19.0311 10.1606 18.3591 9.59274C18.2901 9.53483 18.2507 9.49301 18.1562 9.41177C19.1166 9.90077 19.9143 10.9817 19.5988 12.5082C19.2316 14.2857 17.4127 15.7253 15.0664 15.3514C15.4073 15.4849 15.8058 15.4559 16.1492 15.4382C17.2172 15.3795 18.1833 14.8575 18.7009 14.2953C19.3285 13.6117 19.8255 12.7503 19.7294 11.5093C19.6423 10.3833 19.0015 9.8485 18.2178 9.25735C18.5462 9.38637 18.8383 9.59044 19.0697 9.85252C19.5167 10.3168 19.788 10.9167 19.8387 11.5528C19.934 12.8324 19.3334 13.783 18.6737 14.4482C17.9705 15.1583 17.0175 15.6144 15.8066 15.6248C17.706 15.6811 18.9679 14.5398 19.5799 13.2707C19.9307 12.5468 20.0326 11.519 19.7442 10.7171C19.4805 9.97879 18.8758 9.4721 18.2819 9.06111C19.3195 9.604 20.1928 10.623 20.003 12.2018C19.939 12.747 19.7546 13.272 19.4624 13.7404C18.8964 14.6701 17.9705 15.324 16.9321 15.6795C17.701 15.5187 18.4306 15.0658 18.967 14.4835C19.6243 13.7734 20.1287 12.875 20.0958 11.6227C20.0589 10.2748 19.2077 9.49783 18.3386 8.88819C18.3499 8.88972 18.3609 8.8927 18.3714 8.89704C19.3203 9.35226 20.0383 10.1421 20.1878 11.3694C20.4261 13.3069 19.1231 14.7216 17.9155 15.4591Z"
            fill="#30469D"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconPowerPoint(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="PowerPoint">
        <g id="Group 2">
          <path
            id="Vector"
            d="M14.0931 13.2325L12.6978 3H12.5936C7.51978 3.01481 3.41032 7.12427 3.39551 12.1981V12.3023L14.0931 13.2325Z"
            fill="#ED6C47"
          />
          <path
            id="Vector_2"
            d="M12.8016 3H12.6974V12.3023L17.3485 14.1627L21.9997 12.3023V12.1981C21.9848 7.12427 17.8754 3.01481 12.8016 3Z"
            fill="#FF8F6B"
          />
          <path
            id="Vector_3"
            d="M22.0001 12.3024V12.4047C21.9855 17.4796 17.8751 21.5901 12.8001 21.6046H12.5955C7.52051 21.5901 3.41007 17.4796 3.39551 12.4047V12.3024H22.0001Z"
            fill="#D35230"
          />
          <path
            id="Vector_4"
            opacity="0.1"
            d="M13.1627 7.57217V17.4977C13.1603 17.8426 12.9513 18.1524 12.6324 18.2837C12.5309 18.3267 12.4218 18.3488 12.3115 18.3489H5.59061C5.46038 18.2 5.3348 18.0419 5.21852 17.8837C4.03355 16.303 3.39373 14.3803 3.39527 12.4047V12.2C3.39256 10.4181 3.91334 8.67463 4.89294 7.18612C4.99527 7.02798 5.10224 6.86984 5.21852 6.72101H12.3115C12.7801 6.72456 13.1591 7.10357 13.1627 7.57217Z"
            fill="black"
          />
          <path
            id="Vector_5"
            opacity="0.2"
            d="M12.6976 8.03734V17.9629C12.6975 18.0731 12.6754 18.1823 12.6324 18.2838C12.5011 18.6027 12.1913 18.8117 11.8464 18.814H6.01387C5.86671 18.6646 5.72551 18.5095 5.59061 18.3489C5.46038 18.2001 5.3348 18.0419 5.21852 17.8838C4.03355 16.303 3.39373 14.3803 3.39527 12.4047V12.2001C3.39256 10.4182 3.91334 8.67468 4.89294 7.18617H11.8464C12.315 7.18971 12.694 7.56872 12.6976 8.03734Z"
            fill="black"
          />
          <path
            id="Vector_6"
            opacity="0.2"
            d="M12.6975 8.03733V17.0326C12.694 17.5012 12.315 17.8802 11.8464 17.8838H5.21852C4.03355 16.303 3.39373 14.3803 3.39527 12.4047V12.2001C3.39256 10.4182 3.91334 8.67468 4.89294 7.18617H11.8464C12.315 7.1897 12.694 7.56871 12.6975 8.03733Z"
            fill="black"
          />
          <path
            id="Vector_7"
            opacity="0.2"
            d="M12.2324 8.03733V17.0326C12.2289 17.5012 11.8499 17.8802 11.3813 17.8838H5.21852C4.03355 16.303 3.39373 14.3803 3.39527 12.4047V12.2001C3.39256 10.4182 3.91334 8.67468 4.89294 7.18617H11.3813C11.8499 7.1897 12.2289 7.56871 12.2324 8.03733Z"
            fill="black"
          />
          <path
            id="Vector_8"
            d="M2.85255 7.18617H11.3799C11.8508 7.18617 12.2325 7.56788 12.2325 8.03872V16.5661C12.2325 17.037 11.8508 17.4187 11.3799 17.4187H2.85255C2.38171 17.4187 2 17.037 2 16.5661V8.03872C2 7.56788 2.38171 7.18617 2.85255 7.18617Z"
            fill="url(#paint0_linear_914_1324)"
          />
          <path
            id="Vector_9"
            d="M7.20938 9.46003C7.76449 9.42257 8.31481 9.58382 8.76194 9.91492C9.13486 10.2479 9.33412 10.7337 9.30239 11.2326C9.30849 11.5794 9.21607 11.9208 9.03589 12.2172C8.85347 12.5085 8.59065 12.7408 8.27914 12.8861C7.92302 13.0517 7.53367 13.1335 7.14101 13.1251H6.06241V15.1298H4.95776V9.46003H7.20938ZM6.06148 12.2591H7.01218C7.31357 12.2812 7.61262 12.192 7.85265 12.0084C8.05117 11.818 8.15523 11.5494 8.13683 11.2749C8.13683 10.6501 7.77373 10.3377 7.04754 10.3377H6.06149V12.2591H6.06148Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_1324"
          x1="3.77759"
          y1="6.52"
          x2="10.4549"
          y2="18.0848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CA4C28" />
          <stop offset="0.5" stopColor="#C5401E" />
          <stop offset="1" stopColor="#B62F14" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconProcreate(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Procreate">
        <g id="procreate">
          <path
            id="bg"
            d="M2 9.23809C2 6.70452 2 5.43774 2.49307 4.47004C2.92678 3.61883 3.61883 2.92678 4.47004 2.49307C5.43774 2 6.70452 2 9.2381 2H14.7619C17.2955 2 18.5623 2 19.53 2.49307C20.3812 2.92678 21.0732 3.61883 21.5069 4.47004C22 5.43774 22 6.70452 22 9.2381V14.7619C22 17.2955 22 18.5623 21.5069 19.53C21.0732 20.3812 20.3812 21.0732 19.53 21.5069C18.5623 22 17.2955 22 14.7619 22H9.23809C6.70452 22 5.43774 22 4.47004 21.5069C3.61883 21.0732 2.92678 20.3812 2.49307 19.53C2 18.5623 2 17.2955 2 14.7619V9.23809Z"
            fill="#242424"
          />
          <path
            id="bg_2"
            d="M7.61899 12.2857C4.83329 14.336 4.28564 17.3333 4.28564 19.8333C4.41263 19.0873 4.99517 17.3381 6.30945 16.3095C8.26184 14.7816 11.8333 15.2849 15.738 12.6905C19.6428 10.096 20.0237 6.71429 19.5237 4.11905C19.1763 6.62326 17.9908 7.71463 16.3571 8.69048C12.8095 10.8095 10.5952 10.0952 7.61899 12.2857Z"
            fill="url(#paint0_linear_914_369)"
          />
          <path
            id="bg_top"
            d="M7.61899 12.2857C4.83329 14.336 4.28564 17.3333 4.28564 19.8333C4.41263 19.0873 4.99517 17.3381 6.30945 16.3095C8.26184 14.7816 11.8333 15.2849 15.738 12.6905C19.6428 10.096 20.0237 6.71429 19.5237 4.11905C19.1763 6.62326 17.9908 7.71463 16.3571 8.69048C12.8095 10.8095 10.5952 10.0952 7.61899 12.2857Z"
            fill="url(#paint1_linear_914_369)"
          />
          <path
            id="one"
            d="M4.31885 18.8085C4.47171 16.5496 5.20519 14.0622 7.61886 12.2857C9.17041 11.1438 10.5149 10.7913 11.9492 10.4152C12.7862 10.1958 13.6538 9.9683 14.611 9.57124C14.2617 9.90476 12.6024 10.6833 11.3507 11.2035C10.1023 11.7224 8.78618 12.2694 7.6903 13C5.4916 14.4658 4.59758 17.0161 4.31885 18.8085Z"
            fill="url(#paint2_linear_914_369)"
          />
          <path
            id="one_top"
            d="M4.31885 18.8085C4.47171 16.5496 5.20519 14.0622 7.61886 12.2857C9.17041 11.1438 10.5149 10.7913 11.9492 10.4152C12.7862 10.1958 13.6538 9.9683 14.611 9.57124C14.2617 9.90476 12.6024 10.6833 11.3507 11.2035C10.1023 11.7224 8.78618 12.2694 7.6903 13C5.4916 14.4658 4.59758 17.0161 4.31885 18.8085Z"
            fill="url(#paint3_linear_914_369)"
          />
          <path
            id="three"
            d="M17.8697 10.8363C17.5959 11.1045 17.2907 11.3446 16.9523 11.5476C15.4285 12.4619 13.8088 12.7568 12.2328 13.0437C10.977 13.2723 9.74881 13.4959 8.61901 14.0238C6.07156 15.2142 4.50017 17.6902 4.28572 19.8329C4.2857 19.833 4.28569 19.8331 4.28567 19.8332C4.28566 19.8328 4.28565 19.8324 4.28564 19.832C4.28566 19.6685 4.28801 19.5028 4.29319 19.3354C4.30617 19.0698 4.33363 18.7755 4.37907 18.4616C4.71538 16.6994 5.63007 14.3736 7.69043 13C8.56263 12.4185 9.57437 11.9533 10.5804 11.5261C11.4652 11.2356 12.2626 11.0548 13.0223 10.8826C14.2182 10.6114 15.3207 10.3615 16.5238 9.7381C19.0481 8.43003 19.7095 5.742 19.5317 4.16082C19.9091 6.1643 19.7566 8.62851 17.8697 10.8363Z"
            fill="url(#paint4_linear_914_369)"
          />
          <path
            id="four"
            d="M17.8698 10.8364C17.596 11.1046 17.2908 11.3446 16.9524 11.5476C15.4286 12.4619 13.8089 12.7568 12.2329 13.0437C10.9771 13.2723 9.74891 13.4959 8.6191 14.0238C7.15406 14.7084 6.01184 15.8182 5.26489 17.0453C5.92395 16.1192 6.92799 15.0846 8.16671 14.6905C9.37546 14.3059 10.5284 14.2662 11.7262 14.2249C12.0695 14.213 12.4165 14.2011 12.7696 14.1808C13.7211 13.8345 14.7182 13.3681 15.7381 12.6905C16.6172 12.1064 17.3177 11.4824 17.8698 10.8364Z"
            fill="url(#paint5_linear_914_369)"
          />
          <path
            id="four_top"
            d="M17.8698 10.8364C17.596 11.1046 17.2908 11.3446 16.9524 11.5476C15.4286 12.4619 13.8089 12.7568 12.2329 13.0437C10.9771 13.2723 9.74891 13.4959 8.6191 14.0238C7.15406 14.7084 6.01184 15.8182 5.26489 17.0453C5.92395 16.1192 6.92799 15.0846 8.16671 14.6905C9.37546 14.3059 10.5284 14.2662 11.7262 14.2249C12.0695 14.213 12.4165 14.2011 12.7696 14.1808C13.7211 13.8345 14.7182 13.3681 15.7381 12.6905C16.6172 12.1064 17.3177 11.4824 17.8698 10.8364Z"
            fill="url(#paint6_linear_914_369)"
          />
          <path
            id="two"
            d="M19.5318 4.16082C19.5292 4.14687 19.5265 4.13295 19.5239 4.11905C19.1765 6.62326 17.9909 7.71463 16.3572 8.69048C15.7383 9.06015 15.16 9.34359 14.6112 9.57127C14.2619 9.90481 12.6026 10.6833 11.351 11.2035L11.3508 11.2036C11.096 11.3095 10.8385 11.4165 10.5806 11.5261C11.4653 11.2356 12.2627 11.0548 13.0224 10.8826C14.2183 10.6115 15.3209 10.3615 16.5239 9.7381C19.0482 8.43003 19.7096 5.742 19.5318 4.16082Z"
            fill="url(#paint7_linear_914_369)"
          />
          <path
            id="two_top"
            d="M19.5318 4.16082C19.5292 4.14687 19.5265 4.13295 19.5239 4.11905C19.1765 6.62326 17.9909 7.71463 16.3572 8.69048C15.7383 9.06015 15.16 9.34359 14.6112 9.57127C14.2619 9.90481 12.6026 10.6833 11.351 11.2035L11.3508 11.2036C11.096 11.3095 10.8385 11.4165 10.5806 11.5261C11.4653 11.2356 12.2627 11.0548 13.0224 10.8826C14.2183 10.6115 15.3209 10.3615 16.5239 9.7381C19.0482 8.43003 19.7096 5.742 19.5318 4.16082Z"
            fill="url(#paint8_linear_914_369)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_369"
          x1="12.9999"
          y1="13.5714"
          x2="4.76183"
          y2="19.4762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE5004" />
          <stop offset="0.602538" stopColor="#FFB915" />
          <stop offset="1" stopColor="#FFFC41" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_914_369"
          x1="9.73803"
          y1="14.0714"
          x2="9.78564"
          y2="14.9286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD3E00" />
          <stop offset="1" stopColor="#FD4400" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_914_369"
          x1="14.6189"
          y1="9.14286"
          x2="2.99981"
          y2="19.4762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005FC6" />
          <stop offset="0.279756" stopColor="#23A4DF" />
          <stop offset="0.465158" stopColor="#3AC2B7" />
          <stop offset="0.640642" stopColor="#60EC7A" />
          <stop offset="0.818668" stopColor="#CFFDBD" />
          <stop offset="1" stopColor="#D0FCB6" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_914_369"
          x1="12.2617"
          y1="11.119"
          x2="11.2617"
          y2="10.2143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0061CB" />
          <stop offset="1" stopColor="#067EEA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_914_369"
          x1="19.5714"
          y1="4.14286"
          x2="4.28565"
          y2="19.8095"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E55F1" />
          <stop offset="0.140795" stopColor="#8B48DF" />
          <stop offset="0.274905" stopColor="#E04DD9" />
          <stop offset="0.492309" stopColor="#F496C8" />
          <stop offset="0.633104" stopColor="#FAD2BA" />
          <stop offset="0.856964" stopColor="#FEF7E5" />
          <stop offset="1" stopColor="#FFF5BF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_914_369"
          x1="18.0714"
          y1="10.6905"
          x2="5.59525"
          y2="16.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F41A73" />
          <stop offset="0.399909" stopColor="#FC50A3" />
          <stop offset="0.584511" stopColor="#FE9485" />
          <stop offset="0.703104" stopColor="#FFAF88" />
          <stop offset="1" stopColor="#FFC385" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_914_369"
          x1="13.5714"
          y1="12.4286"
          x2="13.5952"
          y2="13.5714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9B0008" />
          <stop offset="1" stopColor="#EA115A" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_914_369"
          x1="19.5715"
          y1="5.42858"
          x2="8.30958"
          y2="12.7857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#231283" />
          <stop offset="0.362865" stopColor="#7053C6" />
          <stop offset="0.466353" stopColor="#7272DB" />
          <stop offset="0.634311" stopColor="#399EE9" />
          <stop offset="1" stopColor="#00CFFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_914_369"
          x1="16.762"
          y1="9.14286"
          x2="17.262"
          y2="9.78572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F259D" stopOpacity="0" />
          <stop offset="1" stopColor="#412DAA" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconQiwi(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Qiwi">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Qiwi_2"
          d="M17.0674 4.5C20.977 4.50002 24.1348 7.6578 24.1348 11.5674C24.1348 12.883 23.7586 14.1233 23.1572 15.1758C23.1196 15.2134 23.0821 15.2138 23.082 15.1387C22.8189 13.4094 21.7664 12.4697 20.2627 12.1689C20.1125 12.1314 20.1123 12.0558 20.2998 12.0557C20.7884 12.0181 21.4278 12.0186 21.8037 12.0938C21.8413 11.9058 21.8418 11.7177 21.8418 11.5674C21.8418 9.01111 19.736 6.90625 17.1797 6.90625C14.6236 6.90649 12.5186 9.01125 12.5186 11.5674C12.5186 14.1235 14.6236 16.2283 17.1797 16.2285H17.4053C17.3301 15.8151 17.2925 15.4012 17.3301 14.9502C17.3302 14.6499 17.4058 14.6124 17.5186 14.8379C18.1576 15.9656 19.0972 16.9429 20.9014 17.3564C22.3675 17.6948 23.8337 18.0711 25.4502 20.0635C25.6004 20.2514 25.375 20.4394 25.2246 20.2891C23.6082 18.8606 22.1424 18.3711 20.7891 18.3711C19.0974 18.4087 18.0824 18.5967 17.0674 18.5967C13.1578 18.5967 10 15.4394 10 11.5674C10 7.69538 13.1578 4.5 17.0674 4.5ZM20.6387 15.627C20.789 15.627 20.9771 15.7022 21.165 15.8525C21.4658 16.1157 21.5781 16.417 21.4277 16.6426C21.3524 16.7551 21.1649 16.83 21.0146 16.8301C20.8267 16.8301 20.6382 16.7554 20.5254 16.6426C20.2247 16.3794 20.1499 16.0029 20.3379 15.7773C20.3756 15.7023 20.4885 15.627 20.6387 15.627ZM22.1797 14.4619C22.4428 14.5747 22.5557 14.9507 22.5557 15.1387C22.5932 15.4393 22.518 15.5898 22.4053 15.5898C22.2925 15.5898 22.1425 15.4768 21.9922 15.2139C21.8418 14.9507 21.7666 14.6875 21.8418 14.5371C21.9545 14.462 22.067 14.4244 22.1797 14.4619Z"
          fill="#F28A1A"
        />
      </g>
    </svg>
  )
}

export function IconRedditColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <g id="Group 1">
          <path
            id="Vector"
            d="M12 0C5.37281 0 0 5.37281 0 12C0 15.3141 1.34344 18.3141 3.51469 20.4853L1.22906 22.7709C0.775312 23.2247 1.09688 24 1.73813 24H12C18.6272 24 24 18.6272 24 12C24 5.37281 18.6272 0 12 0Z"
            fill="#FF4500"
          />
          <path
            id="Vector_2"
            d="M18.8024 14.3944C20.35 14.3944 21.6046 13.1398 21.6046 11.5922C21.6046 10.0446 20.35 8.78999 18.8024 8.78999C17.2548 8.78999 16.0002 10.0446 16.0002 11.5922C16.0002 13.1398 17.2548 14.3944 18.8024 14.3944Z"
            fill="url(#paint0_radial_634_5103)"
          />
          <path
            id="Vector_3"
            d="M5.19745 14.3944C6.74506 14.3944 7.99964 13.1398 7.99964 11.5922C7.99964 10.0446 6.74506 8.78999 5.19745 8.78999C3.64985 8.78999 2.39526 10.0446 2.39526 11.5922C2.39526 13.1398 3.64985 14.3944 5.19745 14.3944Z"
            fill="url(#paint1_radial_634_5103)"
          />
          <path
            id="Vector_4"
            d="M12.0065 19.9997C16.4246 19.9997 20.0062 17.3134 20.0062 13.9997C20.0062 10.686 16.4246 7.99969 12.0065 7.99969C7.58842 7.99969 4.00684 10.686 4.00684 13.9997C4.00684 17.3134 7.58842 19.9997 12.0065 19.9997Z"
            fill="url(#paint2_radial_634_5103)"
          />
          <path
            id="Vector_5"
            d="M9.64138 13.4165C9.5945 14.4328 8.9195 14.8022 8.13482 14.8022C7.35013 14.8022 6.75013 14.2819 6.797 13.2656C6.84388 12.2494 7.51888 11.5762 8.30357 11.5762C9.08825 11.5762 9.68825 12.4003 9.64138 13.4165Z"
            fill="#842123"
          />
          <path
            id="Vector_6"
            d="M17.2162 13.2647C17.2631 14.2809 16.664 14.8013 15.8784 14.8013C15.0928 14.8013 14.4178 14.4328 14.3718 13.4156C14.325 12.3994 14.924 11.5753 15.7096 11.5753C16.4953 11.5753 17.1703 12.2475 17.2162 13.2647Z"
            fill="#842123"
          />
          <path
            id="Vector_7"
            d="M14.3718 13.5047C14.4159 14.4563 15.0468 14.8013 15.7818 14.8013C16.5168 14.8013 17.0774 14.2847 17.0334 13.3331C16.9893 12.3816 16.3584 11.7591 15.6234 11.7591C14.8884 11.7591 14.3278 12.5531 14.3718 13.5047Z"
            fill="url(#paint3_radial_634_5103)"
          />
          <path
            id="Vector_8"
            d="M9.64214 13.5047C9.59808 14.4563 8.96714 14.8013 8.23214 14.8013C7.49714 14.8013 6.93652 14.2847 6.98058 13.3331C7.02464 12.3816 7.65558 11.7591 8.39058 11.7591C9.12558 11.7591 9.6862 12.5531 9.64214 13.5047Z"
            fill="url(#paint4_radial_634_5103)"
          />
          <path
            id="Vector_9"
            d="M12.0066 15.48C11.0147 15.48 10.0641 15.5278 9.1847 15.615C9.0347 15.63 8.93908 15.7828 8.9972 15.9197C9.48939 17.0737 10.651 17.8847 12.0066 17.8847C13.3622 17.8847 14.5228 17.0737 15.016 15.9197C15.0741 15.7828 14.9794 15.63 14.8285 15.615C13.9491 15.5278 12.9985 15.48 12.0066 15.48Z"
            fill="#BBCFDA"
          />
          <path
            id="Vector_10"
            d="M12.0066 15.7003C11.0175 15.7003 10.0697 15.7491 9.19314 15.8381C9.04314 15.8531 8.94845 16.0088 9.00658 16.1475C9.49783 17.3203 10.6556 18.1434 12.0056 18.1434C13.3556 18.1434 14.5144 17.3194 15.0056 16.1475C15.0638 16.0088 14.9691 15.8531 14.8191 15.8381C13.9425 15.7491 12.9947 15.7003 12.0056 15.7003H12.0066Z"
            fill="white"
          />
          <path
            id="Vector_11"
            d="M12.0066 15.5859C11.0335 15.5859 10.1007 15.6338 9.23723 15.7209C9.09004 15.7359 8.99629 15.8888 9.05348 16.0256C9.53629 17.1797 10.6763 17.9906 12.0066 17.9906C13.3369 17.9906 14.476 17.1797 14.9597 16.0256C15.0169 15.8888 14.9232 15.7359 14.776 15.7209C13.9135 15.6338 12.9807 15.5859 12.0066 15.5859Z"
            fill="url(#paint5_radial_634_5103)"
          />
          <path
            id="Vector_12"
            d="M16.3885 7.18406C17.4851 7.18406 18.3741 6.29507 18.3741 5.19844C18.3741 4.10181 17.4851 3.21281 16.3885 3.21281C15.2918 3.21281 14.4028 4.10181 14.4028 5.19844C14.4028 6.29507 15.2918 7.18406 16.3885 7.18406Z"
            fill="url(#paint6_radial_634_5103)"
          />
          <path
            id="Vector_13"
            d="M11.9784 8.25281C11.7403 8.25281 11.5481 8.15343 11.5481 7.99968C11.5481 6.22031 12.9956 4.77374 14.774 4.77374C15.0122 4.77374 15.2043 4.96687 15.2043 5.20406C15.2043 5.44124 15.0112 5.63437 14.774 5.63437C13.47 5.63437 12.4087 6.69562 12.4087 7.99968C12.4087 8.15343 12.2156 8.25281 11.9784 8.25281Z"
            fill="url(#paint7_radial_634_5103)"
          />
          <path
            id="Vector_14"
            d="M9.119 13.9753C9.119 14.3437 8.72713 14.5087 8.24432 14.5087C7.7615 14.5087 7.36963 14.3437 7.36963 13.9753C7.36963 13.6069 7.7615 13.3087 8.24432 13.3087C8.72713 13.3087 9.119 13.6069 9.119 13.9753Z"
            fill="#FF6101"
          />
          <path
            id="Vector_15"
            d="M16.6444 13.9753C16.6444 14.3437 16.2525 14.5087 15.7697 14.5087C15.2869 14.5087 14.895 14.3437 14.895 13.9753C14.895 13.6069 15.2869 13.3087 15.7697 13.3087C16.2525 13.3087 16.6444 13.6069 16.6444 13.9753Z"
            fill="#FF6101"
          />
          <path
            id="Vector_16"
            d="M8.84812 12.9759C9.02001 12.9759 9.15937 12.824 9.15937 12.6366C9.15937 12.4491 9.02001 12.2972 8.84812 12.2972C8.67622 12.2972 8.53687 12.4491 8.53687 12.6366C8.53687 12.824 8.67622 12.9759 8.84812 12.9759Z"
            fill="#FFC49C"
          />
          <path
            id="Vector_17"
            d="M16.2458 12.9759C16.4177 12.9759 16.5571 12.824 16.5571 12.6366C16.5571 12.4491 16.4177 12.2972 16.2458 12.2972C16.0739 12.2972 15.9346 12.4491 15.9346 12.6366C15.9346 12.824 16.0739 12.9759 16.2458 12.9759Z"
            fill="#FFC49C"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.8448 10.0835) scale(5.61577 4.89886)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.23981 10.0835) scale(5.61577 4.89886)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.22 9.29775) scale(16.9394 11.8936)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.4949 14.1536) rotate(180) scale(1.41529 2.07776)"
        >
          <stop stopColor="#FF6600" />
          <stop offset="0.5" stopColor="#FF4500" />
          <stop offset="0.7" stopColor="#FC4301" />
          <stop offset="0.82" stopColor="#F43F07" />
          <stop offset="0.92" stopColor="#E53812" />
          <stop offset="1" stopColor="#D4301F" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.45531 14.1536) scale(1.41529 2.07776)"
        >
          <stop stopColor="#FF6600" />
          <stop offset="0.5" stopColor="#FF4500" />
          <stop offset="0.7" stopColor="#FC4301" />
          <stop offset="0.82" stopColor="#F43F07" />
          <stop offset="0.92" stopColor="#E53812" />
          <stop offset="1" stopColor="#D4301F" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0346 18.2726) scale(4.99052 3.29162)"
        >
          <stop stopColor="#172E35" />
          <stop offset="0.29" stopColor="#0E1C21" />
          <stop offset="0.73" stopColor="#030708" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.4355 3.19745) scale(4.38069)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_634_5103"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.61 7.97305) scale(3.59065)"
        >
          <stop offset="0.48" stopColor="#7A9299" />
          <stop offset="0.67" stopColor="#172E35" />
          <stop offset="0.75" />
          <stop offset="0.82" stopColor="#172E35" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function IconRedditColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M14.4413 5.65873C14.6494 6.54092 15.4416 7.19811 16.3875 7.19811C17.4919 7.19811 18.3872 6.30279 18.3872 5.19842C18.3872 4.09404 17.4919 3.19873 16.3875 3.19873C15.4219 3.19873 14.6166 3.88311 14.4291 4.79342C12.8119 4.96686 11.5491 6.33842 11.5491 8.00061C11.5491 8.00436 11.5491 8.00717 11.5491 8.01092C9.79035 8.08498 8.18441 8.58561 6.90941 9.37592C6.43597 9.00936 5.8416 8.79092 5.1966 8.79092C3.64878 8.79092 2.39441 10.0453 2.39441 11.5931C2.39441 12.7162 3.05441 13.6837 4.00785 14.1309C4.10066 17.384 7.64535 20.0006 12.0057 20.0006C16.366 20.0006 19.9153 17.3812 20.0035 14.1253C20.9494 13.6753 21.6038 12.7106 21.6038 11.594C21.6038 10.0462 20.3494 8.79186 18.8016 8.79186C18.1594 8.79186 17.5678 9.00842 17.0953 9.37217C15.8091 8.57623 14.1853 8.07561 12.4088 8.00904C12.4088 8.00623 12.4088 8.00436 12.4088 8.00154C12.4088 6.81092 13.2938 5.82279 14.4413 5.66061V5.65873ZM6.79691 13.3715C6.84378 12.3553 7.51878 11.5753 8.30347 11.5753C9.08816 11.5753 9.68816 12.3994 9.64128 13.4156C9.59441 14.4319 9.00847 14.8012 8.22285 14.8012C7.43722 14.8012 6.75003 14.3878 6.79691 13.3715ZM15.7088 11.5753C16.4944 11.5753 17.1694 12.3553 17.2153 13.3715C17.2622 14.3878 16.5741 14.8012 15.7894 14.8012C15.0047 14.8012 14.4178 14.4328 14.371 13.4156C14.3241 12.3994 14.9232 11.5753 15.7088 11.5753ZM14.775 15.7228C14.9222 15.7378 15.016 15.8906 14.9588 16.0275C14.476 17.1815 13.336 17.9925 12.0057 17.9925C10.6753 17.9925 9.53628 17.1815 9.05253 16.0275C8.99535 15.8906 9.0891 15.7378 9.23628 15.7228C10.0988 15.6356 11.0316 15.5878 12.0057 15.5878C12.9797 15.5878 13.9116 15.6356 14.775 15.7228Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSEPA(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SEPA">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="SEPA_2">
          <path
            id="S-PA"
            d="M8.41602 15.6562C8.53285 15.6563 8.62907 15.7079 8.70508 15.8105V15.6797H8.93848V16.5303C8.93848 16.6421 8.92956 16.726 8.91113 16.7812C8.89274 16.8367 8.86632 16.8806 8.83301 16.9121C8.79974 16.9435 8.7556 16.9685 8.7002 16.9863C8.6446 17.0042 8.57418 17.0127 8.48926 17.0127C8.32876 17.0127 8.21466 16.985 8.14746 16.9297C8.08036 16.8743 8.04688 16.8038 8.04688 16.7188C8.04688 16.7104 8.04728 16.7004 8.04785 16.6885L8.33301 16.7197C8.33778 16.7546 8.34831 16.7787 8.36523 16.792C8.3891 16.8109 8.42731 16.8203 8.47852 16.8203C8.54395 16.8203 8.5932 16.8106 8.62598 16.791C8.64768 16.7779 8.66449 16.7573 8.67578 16.7285C8.68347 16.7076 8.68748 16.669 8.6875 16.6133L8.68848 16.4746C8.61443 16.5756 8.52021 16.6259 8.40625 16.626C8.27919 16.626 8.17871 16.5725 8.10449 16.4648C8.04624 16.3797 8.0166 16.2733 8.0166 16.1465C8.01662 15.9877 8.0547 15.8662 8.13086 15.7822C8.20717 15.6983 8.30258 15.6562 8.41602 15.6562ZM19.0752 16.3516L19.2969 15.6797H19.5557L19.1621 16.7568C19.1401 16.8123 19.1185 16.8546 19.0986 16.8838C19.0788 16.9129 19.0561 16.937 19.0303 16.9551C19.0043 16.9732 18.9723 16.987 18.9346 16.9971C18.8968 17.0073 18.8541 17.0127 18.8066 17.0127C18.7586 17.0127 18.7113 17.0072 18.665 16.9971L18.6416 16.8008C18.6809 16.8087 18.7165 16.8125 18.748 16.8125C18.8066 16.8125 18.8498 16.7953 18.8779 16.7607C18.9059 16.7261 18.9275 16.6822 18.9424 16.6289L18.582 15.6797H18.8486L19.0752 16.3516ZM5.53223 15.2959C5.69559 15.296 5.81866 15.3315 5.90137 15.4033C5.98414 15.4754 6.02808 15.572 6.03223 15.6924L5.76758 15.7031C5.75632 15.6359 5.73239 15.5872 5.69531 15.5576C5.65828 15.5282 5.60248 15.5137 5.52832 15.5137C5.45181 15.5137 5.39195 15.529 5.34863 15.5605C5.32075 15.5807 5.30668 15.6078 5.30664 15.6416C5.30664 15.6724 5.3199 15.6987 5.3457 15.7207C5.37885 15.7486 5.45979 15.7785 5.58789 15.8086C5.71589 15.8388 5.81068 15.8698 5.87207 15.9023C5.93336 15.9348 5.98189 15.9789 6.0166 16.0352C6.05121 16.0916 6.06833 16.1614 6.06836 16.2441C6.06836 16.3192 6.04734 16.3896 6.00586 16.4551C5.96426 16.5206 5.90508 16.5697 5.8291 16.6016C5.75317 16.6334 5.65821 16.6494 5.54492 16.6494C5.38008 16.6494 5.25346 16.611 5.16504 16.5342C5.07667 16.4574 5.02409 16.3454 5.00684 16.1982L5.2627 16.1719C5.27811 16.2584 5.3093 16.3226 5.35645 16.3633C5.40367 16.4039 5.46773 16.4238 5.54785 16.4238C5.6324 16.4238 5.6962 16.4059 5.73926 16.3701C5.78226 16.334 5.80371 16.2915 5.80371 16.2432C5.80371 16.2123 5.79523 16.1859 5.77734 16.1641C5.75931 16.1423 5.72751 16.1236 5.68262 16.1074C5.65179 16.0969 5.58113 16.078 5.47168 16.0508C5.3311 16.016 5.23261 15.9728 5.17578 15.9219C5.09591 15.8502 5.05566 15.7624 5.05566 15.6592C5.05568 15.5929 5.07462 15.5304 5.1123 15.4727C5.14991 15.4149 5.20467 15.371 5.27539 15.3408C5.34625 15.3107 5.43212 15.2959 5.53223 15.2959ZM10.1631 15.6562C10.3039 15.6563 10.4147 15.7035 10.4961 15.7969C10.5776 15.8905 10.6168 16.0335 10.6133 16.2266H9.98438C9.98611 16.3008 10.0063 16.3589 10.0449 16.4004C10.0839 16.4417 10.1332 16.4629 10.1914 16.4629C10.2308 16.4628 10.2642 16.4519 10.291 16.4307C10.3178 16.4094 10.3379 16.3752 10.3516 16.3281L10.6006 16.3691C10.5684 16.4604 10.5176 16.5304 10.4482 16.5781C10.3789 16.6259 10.2916 16.6494 10.1875 16.6494C10.0227 16.6493 9.90035 16.5952 9.82129 16.4873C9.75896 16.4009 9.72756 16.2918 9.72754 16.1602C9.72754 16.0028 9.76937 15.8793 9.85156 15.79C9.93365 15.7009 10.0376 15.6562 10.1631 15.6562ZM12.9463 16.1152C12.9463 16.2476 12.9508 16.3291 12.96 16.3594C12.9692 16.3896 12.9864 16.414 13.0107 16.4316C13.0351 16.4491 13.0662 16.458 13.1035 16.458C13.1461 16.458 13.184 16.4454 13.2178 16.4219C13.2517 16.3984 13.2756 16.3698 13.2881 16.335C13.3005 16.3002 13.3066 16.2147 13.3066 16.0791V15.6797H13.5576V16.626H13.3242V16.4844C13.2897 16.5348 13.2446 16.5747 13.1885 16.6045C13.1323 16.6342 13.0731 16.6494 13.0107 16.6494C12.947 16.6494 12.8895 16.6354 12.8389 16.6074C12.7884 16.5795 12.7521 16.5397 12.7295 16.4893C12.7069 16.4386 12.6953 16.3685 12.6953 16.2793V15.6797H12.9463V16.1152ZM15.0605 15.6562C15.2035 15.6563 15.3207 15.7027 15.4121 15.7959C15.5035 15.8893 15.5498 16.0078 15.5498 16.1504C15.5498 16.294 15.5033 16.4133 15.4111 16.5078C15.3189 16.6023 15.2025 16.6494 15.0625 16.6494C14.9759 16.6494 14.893 16.63 14.8145 16.5908C14.7357 16.5514 14.6757 16.4931 14.6348 16.417C14.5939 16.341 14.5733 16.2487 14.5732 16.1396C14.5732 16.0562 14.5938 15.9747 14.6348 15.8965C14.6757 15.8186 14.7336 15.7589 14.8086 15.7178C14.8837 15.6766 14.9679 15.6562 15.0605 15.6562ZM18.0039 15.6562C18.1153 15.6563 18.1984 15.6699 18.2529 15.6963C18.3074 15.7229 18.346 15.7562 18.3682 15.7969C18.3904 15.8376 18.4014 15.9126 18.4014 16.0215L18.3994 16.3145C18.3994 16.3978 18.4032 16.4595 18.4111 16.499C18.4192 16.5385 18.4342 16.5808 18.4561 16.626H18.208C18.2014 16.6097 18.1931 16.5857 18.1836 16.5537C18.1795 16.5392 18.1765 16.5292 18.1748 16.5244C18.1322 16.566 18.0866 16.5972 18.0381 16.6182C17.9894 16.639 17.937 16.6494 17.8818 16.6494C17.7848 16.6494 17.7083 16.6231 17.6523 16.5703C17.5964 16.5173 17.5684 16.4501 17.5684 16.3691C17.5684 16.3156 17.581 16.2676 17.6064 16.2256C17.632 16.1837 17.668 16.1512 17.7139 16.1289C17.7599 16.1067 17.8266 16.087 17.9131 16.0703C18.0298 16.0483 18.1111 16.0279 18.1562 16.0088V15.9834C18.1562 15.9347 18.1439 15.8997 18.1201 15.8789C18.0961 15.8582 18.0506 15.8477 17.9844 15.8477C17.9398 15.8477 17.9049 15.8575 17.8799 15.875C17.8549 15.8927 17.8347 15.9237 17.8193 15.9678L17.5938 15.9258C17.6193 15.8342 17.6634 15.7667 17.7256 15.7227C17.788 15.6786 17.881 15.6562 18.0039 15.6562ZM21.8076 15.6562C21.9486 15.6563 22.0601 15.7034 22.1416 15.7969C22.2229 15.8905 22.2613 16.0337 22.2578 16.2266H21.6289C21.6307 16.3011 21.6515 16.3589 21.6904 16.4004C21.7293 16.4417 21.7777 16.4629 21.8359 16.4629C21.8754 16.4629 21.9087 16.452 21.9355 16.4307C21.9625 16.4094 21.9833 16.3753 21.9971 16.3281L22.2451 16.3691C22.2129 16.4604 22.1621 16.5304 22.0928 16.5781C22.0235 16.6258 21.9369 16.6493 21.833 16.6494C21.6681 16.6494 21.546 16.5953 21.4668 16.4873C21.4043 16.4009 21.3731 16.2921 21.373 16.1602C21.373 16.0028 21.4141 15.8793 21.4961 15.79C21.5783 15.7009 21.6821 15.6562 21.8076 15.6562ZM23.9463 15.6797H24.1172V15.8789H23.9463V16.2617C23.9463 16.3389 23.948 16.3845 23.9512 16.3975C23.9543 16.4103 23.9613 16.4213 23.9727 16.4297C23.984 16.4378 23.9976 16.4423 24.0137 16.4424C24.0365 16.4424 24.07 16.434 24.1133 16.418L24.1348 16.6123C24.077 16.6372 24.0115 16.6494 23.9385 16.6494C23.8937 16.6494 23.8533 16.642 23.8174 16.627C23.7814 16.6118 23.7542 16.5915 23.7373 16.5674C23.7206 16.5434 23.7096 16.5106 23.7031 16.4697C23.6978 16.4405 23.6943 16.3816 23.6943 16.293V15.8789H23.5811V15.6797H23.6943V15.4902L23.9463 15.3428V15.6797ZM24.6895 15.6562C24.8194 15.6563 24.9162 15.6769 24.9795 15.7188C25.0427 15.7607 25.0864 15.8232 25.1104 15.9053L24.874 15.9492C24.8638 15.9125 24.8449 15.8838 24.8164 15.8643C24.7879 15.8446 24.747 15.835 24.6943 15.835C24.6277 15.835 24.5795 15.8446 24.5508 15.8633C24.5317 15.8764 24.5225 15.8933 24.5225 15.9141C24.5225 15.932 24.5303 15.9474 24.5469 15.96C24.5695 15.9766 24.6484 16.0007 24.7822 16.0312C24.9158 16.0618 25.0094 16.0984 25.0625 16.1426C25.1148 16.1873 25.1405 16.2502 25.1406 16.3301C25.1406 16.4173 25.1046 16.4929 25.0322 16.5557C24.9597 16.6184 24.8527 16.6494 24.7109 16.6494C24.5823 16.6494 24.4803 16.6233 24.4053 16.5713C24.3303 16.5191 24.2809 16.4487 24.2578 16.3594L24.5088 16.3203C24.5195 16.3687 24.5417 16.4055 24.5742 16.4307C24.6068 16.4557 24.6524 16.4678 24.7109 16.4678C24.7753 16.4678 24.8239 16.4563 24.8564 16.4326C24.8783 16.4159 24.8895 16.3932 24.8896 16.3652C24.8896 16.3462 24.8839 16.3298 24.8721 16.3174C24.8595 16.3054 24.8315 16.2944 24.7881 16.2842C24.5854 16.2393 24.4567 16.198 24.4023 16.1611C24.3271 16.1099 24.2891 16.0383 24.2891 15.9473C24.2892 15.8651 24.3218 15.7961 24.3867 15.7402C24.4518 15.6843 24.5529 15.6562 24.6895 15.6562ZM28.4707 15.6562C28.6116 15.6563 28.7231 15.7034 28.8047 15.7969C28.8859 15.8905 28.9244 16.0337 28.9209 16.2266H28.292C28.2938 16.3011 28.3147 16.3589 28.3535 16.4004C28.3925 16.4417 28.4409 16.4629 28.499 16.4629C28.5385 16.4628 28.5717 16.452 28.5986 16.4307C28.6255 16.4094 28.6463 16.3754 28.6602 16.3281L28.9082 16.3691C28.8761 16.4604 28.8252 16.5304 28.7559 16.5781C28.6866 16.6258 28.6 16.6494 28.4961 16.6494C28.3311 16.6494 28.209 16.5953 28.1299 16.4873C28.0674 16.4009 28.0362 16.2921 28.0361 16.1602C28.0361 16.0028 28.077 15.8793 28.1592 15.79C28.2412 15.7009 28.3452 15.6562 28.4707 15.6562ZM29.5479 15.6562C29.6593 15.6563 29.7423 15.6699 29.7969 15.6963C29.8514 15.7229 29.8899 15.7562 29.9121 15.7969C29.9344 15.8376 29.9453 15.9126 29.9453 16.0215L29.9434 16.3145C29.9434 16.3978 29.9471 16.4595 29.9551 16.499C29.9631 16.5385 29.9782 16.5808 30 16.626H29.752C29.7454 16.6097 29.7371 16.5857 29.7275 16.5537C29.7235 16.5392 29.7204 16.5292 29.7188 16.5244C29.6761 16.5661 29.6305 16.5972 29.582 16.6182C29.5334 16.639 29.481 16.6494 29.4258 16.6494C29.3288 16.6494 29.2522 16.6231 29.1963 16.5703C29.1404 16.5173 29.1123 16.4501 29.1123 16.3691C29.1123 16.3156 29.1249 16.2676 29.1504 16.2256C29.1759 16.1837 29.2119 16.1512 29.2578 16.1289C29.3039 16.1067 29.3706 16.087 29.457 16.0703C29.5737 16.0483 29.6551 16.0279 29.7002 16.0088V15.9834C29.7002 15.9347 29.6879 15.8997 29.6641 15.8789C29.6402 15.8582 29.5945 15.8477 29.5283 15.8477C29.4838 15.8477 29.4489 15.8575 29.4238 15.875C29.3989 15.8927 29.3786 15.9237 29.3633 15.9678L29.1377 15.9258C29.1632 15.8342 29.2074 15.7667 29.2695 15.7227C29.3319 15.6786 29.425 15.6562 29.5479 15.6562ZM6.59277 16.626H6.3418V15.6797H6.59277V16.626ZM7.44727 15.6562C7.50245 15.6562 7.55298 15.6666 7.59863 15.6865C7.64426 15.7064 7.6787 15.7318 7.70215 15.7627C7.7256 15.7937 7.74178 15.8288 7.75098 15.8682C7.76016 15.9074 7.76562 15.964 7.76562 16.0371V16.626H7.51367V16.1416C7.51366 16.0394 7.50863 15.9734 7.49805 15.9434C7.48736 15.9133 7.47022 15.8897 7.44629 15.873C7.42234 15.8564 7.39302 15.8477 7.35938 15.8477C7.31637 15.8477 7.27736 15.86 7.24316 15.8838C7.209 15.9076 7.1855 15.9393 7.17285 15.9785C7.16011 16.0177 7.15431 16.0904 7.1543 16.1963V16.626H6.90332V15.6797H7.13574V15.8184C7.21813 15.7101 7.32226 15.6563 7.44727 15.6562ZM9.49023 16.626H9.23926V15.3193H9.49023V16.626ZM12.4014 15.5391H11.6992V15.8301H12.3516V16.0508H11.6992V16.4053H12.4268V16.626H11.4355V15.3193H12.4014V15.5391ZM14.3076 15.6562C14.3644 15.6563 14.419 15.6726 14.4717 15.7041L14.3955 15.9229C14.3533 15.8956 14.3136 15.8818 14.2773 15.8818C14.2423 15.8819 14.2128 15.8919 14.1885 15.9111C14.1641 15.9305 14.1449 15.9652 14.1309 16.0156C14.1169 16.0662 14.1094 16.1728 14.1094 16.334V16.626H13.8584V15.6797H14.0918V15.8145C14.1317 15.7509 14.1674 15.7084 14.1992 15.6875C14.231 15.6668 14.2673 15.6562 14.3076 15.6562ZM16.79 15.3193C16.9502 15.3193 17.0549 15.3258 17.1035 15.3389C17.1781 15.3585 17.2406 15.4011 17.291 15.4668C17.3414 15.5324 17.3662 15.6176 17.3662 15.7217C17.3662 15.8018 17.3523 15.8691 17.3232 15.9238C17.2943 15.9783 17.2575 16.0215 17.2129 16.0527C17.1682 16.084 17.1223 16.1041 17.0762 16.1143C17.0133 16.1268 16.9218 16.1338 16.8027 16.1338H16.6309V16.626H16.3672V15.3193H16.79ZM20.834 15.6562C20.9035 15.6562 20.9626 15.6699 21.0107 15.6982C21.0589 15.7264 21.0954 15.7684 21.1191 15.8232C21.1362 15.8636 21.1445 15.9292 21.1445 16.0195V16.626H20.8936V16.084C20.8936 15.9899 20.8843 15.9288 20.8672 15.9014C20.844 15.8658 20.8085 15.8477 20.7607 15.8477C20.7258 15.8477 20.6928 15.8585 20.6621 15.8799C20.6313 15.9014 20.6093 15.9332 20.5957 15.9746C20.582 16.0159 20.5752 16.0816 20.5752 16.1709V16.626H20.3232V16.1064C20.3232 16.0142 20.3195 15.9547 20.3105 15.9277C20.3017 15.9009 20.2873 15.8813 20.2686 15.8682C20.2499 15.8552 20.2252 15.8477 20.1934 15.8477C20.1548 15.8477 20.1197 15.8591 20.0889 15.8799C20.0582 15.9007 20.0359 15.9306 20.0225 15.9697C20.0092 16.009 20.0029 16.0741 20.0029 16.165V16.626H19.751V15.6797H19.9814V15.8086C20.0642 15.7069 20.1631 15.6563 20.2773 15.6562C20.3379 15.6562 20.3909 15.6684 20.4355 15.6934C20.4801 15.7183 20.5165 15.7564 20.5449 15.8066C20.5865 15.7562 20.6317 15.7184 20.6797 15.6934C20.7279 15.6684 20.7794 15.6563 20.834 15.6562ZM23.0576 15.6562C23.1127 15.6562 23.1635 15.6667 23.209 15.6865C23.2546 15.7064 23.29 15.7317 23.3135 15.7627C23.3368 15.7936 23.3531 15.8289 23.3623 15.8682C23.3715 15.9074 23.376 15.9641 23.376 16.0371V16.626H23.125V16.1416C23.125 16.0394 23.1189 15.9734 23.1084 15.9434C23.0977 15.9134 23.0806 15.8897 23.0566 15.873C23.0328 15.8566 23.0041 15.8477 22.9707 15.8477C22.9277 15.8477 22.8887 15.86 22.8545 15.8838C22.8202 15.9076 22.797 15.9393 22.7842 15.9785C22.7715 16.0177 22.7647 16.0904 22.7646 16.1963V16.626H22.5137V15.6797H22.7471V15.8184C22.8294 15.7105 22.9329 15.6564 23.0576 15.6562ZM27.1543 16.626H26.8691L26.7568 16.3301H26.2305L26.123 16.626H25.8438L26.3496 15.3193H26.627L27.1543 16.626ZM27.7822 15.6562C27.8392 15.6562 27.8943 15.6725 27.9473 15.7041L27.8711 15.9229C27.8288 15.8955 27.7892 15.8818 27.7529 15.8818C27.7177 15.8819 27.6875 15.8919 27.6631 15.9111C27.6389 15.9306 27.6203 15.9655 27.6064 16.0156C27.5924 16.0662 27.585 16.1728 27.585 16.334V16.626H27.334V15.6797H27.5664V15.8145C27.6061 15.7511 27.642 15.7085 27.6738 15.6875C27.7055 15.6667 27.7418 15.6563 27.7822 15.6562ZM18.0039 16.2109C17.9347 16.2258 17.8894 16.2406 17.8682 16.2549C17.8355 16.2782 17.8193 16.308 17.8193 16.3438C17.8194 16.3789 17.8325 16.4089 17.8584 16.4346C17.8845 16.4602 17.9177 16.4736 17.958 16.4736C18.0029 16.4736 18.0461 16.4584 18.0869 16.4287C18.1168 16.4061 18.136 16.3783 18.1455 16.3457C18.152 16.3242 18.1553 16.2829 18.1553 16.2227V16.1729C18.1232 16.1836 18.0727 16.1961 18.0039 16.2109ZM29.5479 16.2109C29.4786 16.2258 29.4334 16.2406 29.4121 16.2549C29.3795 16.2782 29.3633 16.308 29.3633 16.3438C29.3634 16.3789 29.3764 16.4089 29.4023 16.4346C29.4284 16.4602 29.4616 16.4736 29.502 16.4736C29.5469 16.4736 29.59 16.4585 29.6309 16.4287C29.6608 16.4061 29.681 16.3784 29.6904 16.3457C29.6969 16.3242 29.7002 16.2829 29.7002 16.2227V16.1729C29.6682 16.1836 29.6171 16.196 29.5479 16.2109ZM15.0615 15.8613C14.9961 15.8614 14.9411 15.8865 14.8965 15.9365C14.8519 15.9866 14.8301 16.0592 14.8301 16.1533C14.8301 16.2475 14.8519 16.32 14.8965 16.3701C14.941 16.42 14.9962 16.4452 15.0615 16.4453C15.1269 16.4453 15.1823 16.4201 15.2266 16.3701C15.2709 16.32 15.293 16.2468 15.293 16.1514C15.293 16.0583 15.2709 15.9866 15.2266 15.9365C15.1822 15.8864 15.127 15.8613 15.0615 15.8613ZM8.47754 15.8477C8.41838 15.8478 8.36945 15.8716 8.33105 15.918C8.29244 15.9649 8.27344 16.0369 8.27344 16.1328C8.27348 16.2333 8.29253 16.3068 8.33105 16.3535C8.36958 16.4004 8.41704 16.4238 8.47363 16.4238C8.5342 16.4238 8.58511 16.3995 8.62695 16.3516C8.66864 16.3036 8.69043 16.2328 8.69043 16.1387C8.69042 16.0405 8.66982 15.9676 8.62988 15.9199C8.58978 15.8723 8.53877 15.8477 8.47754 15.8477ZM26.3105 16.1104H26.6699L26.4873 15.625L26.3105 16.1104ZM10.1777 15.8477C10.1228 15.8477 10.0778 15.8688 10.042 15.9092C10.0061 15.9496 9.9877 16.0047 9.98828 16.0742H10.3652C10.3635 16.0005 10.3445 15.9437 10.3086 15.9053C10.2728 15.8671 10.229 15.8477 10.1777 15.8477ZM21.8223 15.8477C21.7675 15.8477 21.7222 15.8688 21.6865 15.9092C21.6507 15.9496 21.6332 16.0048 21.6338 16.0742H22.0098C22.0079 16.0005 21.9891 15.9437 21.9531 15.9053C21.9175 15.8671 21.8735 15.8477 21.8223 15.8477ZM28.4854 15.8477C28.4304 15.8477 28.3854 15.8688 28.3496 15.9092C28.3138 15.9496 28.2962 16.0048 28.2969 16.0742H28.6729C28.671 16.0005 28.652 15.9437 28.6162 15.9053C28.5804 15.8671 28.5365 15.8477 28.4854 15.8477ZM16.6309 15.9131H16.7754C16.8788 15.9131 16.9485 15.9063 16.9834 15.8926C17.0181 15.8788 17.0457 15.8574 17.0654 15.8281C17.0852 15.7989 17.0947 15.7644 17.0947 15.7256C17.0947 15.6777 17.0806 15.6376 17.0527 15.6064C17.025 15.5756 16.9897 15.5566 16.9473 15.5488C16.9158 15.5429 16.8525 15.54 16.7578 15.54H16.6309V15.9131ZM6.59277 15.5498H6.3418V15.3193H6.59277V15.5498ZM7.91895 8.03613C8.63664 8.03613 9.14821 8.07726 9.45312 8.15918C10.1973 8.35946 10.5693 8.92092 10.5693 9.84277C10.5693 9.91838 10.5637 10.0316 10.5527 10.1826H8.84277C8.84277 9.9015 8.80976 9.71224 8.74414 9.61621C8.64227 9.47425 8.36084 9.40332 7.90137 9.40332C7.4551 9.40334 7.15904 9.44447 7.01465 9.52637C6.87045 9.60859 6.79785 9.78749 6.79785 10.0625C6.7979 10.3113 6.8622 10.4751 6.99023 10.5537C7.08212 10.6095 7.20409 10.6425 7.35547 10.6523L7.7002 10.6768C8.43917 10.7259 8.90087 10.7606 9.08496 10.7803C9.66915 10.8393 10.0926 10.9949 10.3555 11.2471C10.5623 11.4439 10.6862 11.701 10.7256 12.0186C10.7486 12.2086 10.7598 12.4241 10.7598 12.6631C10.7598 13.2139 10.7076 13.6174 10.6025 13.873C10.4121 14.3419 9.98454 14.6382 9.31934 14.7627C9.04056 14.8153 8.61362 14.8418 8.04004 14.8418C7.08262 14.8418 6.41498 14.7846 6.03809 14.6699C5.57567 14.5294 5.27065 14.2442 5.12305 13.8154C5.04085 13.5766 5 13.1787 5 12.6221H6.70996V12.7646C6.71002 13.0615 6.79577 13.2528 6.96582 13.3379C7.08366 13.3965 7.22635 13.427 7.39355 13.4307H8.02148C8.34231 13.4307 8.54742 13.4139 8.63574 13.3809C8.79271 13.319 8.89598 13.2197 8.94531 13.082C8.9715 12.9971 8.98438 12.8864 8.98438 12.752C8.98427 12.451 8.87433 12.2679 8.65527 12.2021C8.57269 12.1762 8.19148 12.1396 7.51172 12.0938C6.96536 12.0547 6.58568 12.0179 6.37305 11.9814C5.81327 11.8766 5.44012 11.6604 5.25391 11.333C5.09027 11.0547 5.00782 10.6335 5.00781 10.0703C5.00781 9.64161 5.05231 9.29772 5.14062 9.03906C5.22906 8.78044 5.37177 8.58359 5.56836 8.44922C5.85658 8.243 6.22589 8.12214 6.6748 8.08594C7.04841 8.05332 7.46306 8.03613 7.91895 8.03613ZM21.4971 8C21.9667 8 22.325 8.03849 22.5713 8.11523C23.1346 8.29202 23.5125 8.65413 23.7061 9.20117C23.8059 9.48819 23.8564 9.9202 23.8564 10.4971C23.8564 11.191 23.801 11.6905 23.6914 11.9941C23.4718 12.5943 23.0193 12.9396 22.3369 13.0293C22.2566 13.0427 21.9145 13.0548 21.3115 13.0645L21.0068 13.0752H19.9102V14.8418H18.0723V8H21.4971ZM29.9922 14.8418H28.1299L27.7793 13.6592H25.3223L24.9922 14.8418H23.0898L25.1426 8H27.915L29.9922 14.8418ZM25.7178 12.3262H27.415L26.5537 9.36035L25.7178 12.3262ZM19.9102 11.4883H21.0566C21.4199 11.4752 21.6412 11.4471 21.7207 11.4033C21.8292 11.3435 21.9022 11.2235 21.9385 11.0439C21.9617 10.9243 21.9727 10.746 21.9727 10.5098C21.9726 10.2207 21.9496 10.0062 21.9033 9.86621C21.8372 9.67019 21.6793 9.55026 21.4287 9.50684C21.3792 9.50028 21.2602 9.49707 21.0723 9.49707H19.9102V11.4883Z"
            fill="#10298E"
          />
          <path
            id="Fill 26"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5354 8.96263C16.2936 8.96263 16.9702 9.31247 17.415 9.86043L17.8112 9.00944C17.1915 8.42273 16.3481 8.06102 15.4178 8.06102C13.9695 8.06102 12.7305 8.93724 12.222 10.1776H11.4494L10.9932 11.1573H11.9871C11.9797 11.2482 11.9749 11.3391 11.9749 11.4319C11.9749 11.5442 11.9807 11.6552 11.9918 11.7648H11.4922L11.0361 12.7449H12.2457C12.7687 13.9538 13.9922 14.8026 15.4178 14.8026C16.1363 14.8026 16.803 14.5869 17.355 14.2186V13.0175C16.9104 13.5245 16.2603 13.8449 15.5354 13.8449C14.6881 13.8449 13.9428 13.4072 13.5088 12.7449H16.0418L16.498 11.7648H13.1361C13.1188 11.6469 13.1095 11.5264 13.1095 11.4036C13.1095 11.3206 13.1138 11.2385 13.1218 11.1573H16.7807L17.2368 10.1776H13.4382C13.8583 9.45133 14.6401 8.96263 15.5354 8.96263Z"
            fill="#FFBE00"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconShopPay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ShopPay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="#5A31F4" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Shop Pay"
          d="M19.7044 11.0612C19.7044 12.6013 18.6247 13.7008 17.1158 13.7008H15.6943C15.6786 13.7008 15.663 13.7039 15.6485 13.7099C15.6341 13.7159 15.6209 13.7247 15.6098 13.7358C15.5988 13.747 15.59 13.7602 15.584 13.7747C15.5781 13.7892 15.5751 13.8048 15.5751 13.8205V15.8446C15.5751 15.8763 15.5626 15.9066 15.5403 15.9291C15.5179 15.9515 15.4876 15.9642 15.456 15.9643H14.4613C14.4376 15.9642 14.4145 15.9571 14.3949 15.944C14.3752 15.9308 14.3599 15.9122 14.3508 15.8903C14.3448 15.876 14.3417 15.8607 14.3415 15.8452V8.54087C14.3415 8.52517 14.3445 8.50962 14.3505 8.4951C14.3564 8.48058 14.3652 8.46737 14.3762 8.45625C14.3873 8.44512 14.4005 8.4363 14.415 8.43027C14.4295 8.42425 14.445 8.42115 14.4607 8.42115H17.1222C18.6247 8.41942 19.7044 9.51883 19.7044 11.0612ZM18.4639 11.0612C18.4639 10.1758 17.8601 9.52866 17.0412 9.52866H15.6943C15.6786 9.52866 15.663 9.53176 15.6485 9.53778C15.6341 9.5438 15.6209 9.55263 15.6098 9.56376C15.5988 9.57488 15.59 9.58808 15.584 9.6026C15.5781 9.61712 15.5751 9.63268 15.5751 9.64837V12.4672C15.5751 12.4988 15.5877 12.5291 15.61 12.5514C15.6324 12.5738 15.6627 12.5863 15.6943 12.5863H17.0412C17.8601 12.5921 18.4639 11.9444 18.4639 11.0612ZM19.9994 14.563C19.9891 14.3268 20.0379 14.0918 20.1416 13.8793C20.2452 13.6668 20.4003 13.4835 20.5927 13.3462C20.9808 13.0542 21.5875 12.9032 22.4781 12.872L23.4266 12.8385V12.5585C23.4266 11.9976 23.0507 11.7604 22.4469 11.7604C21.8431 11.7604 21.4602 11.9744 21.3723 12.3243C21.3652 12.3489 21.35 12.3705 21.3293 12.3855C21.3086 12.4006 21.2834 12.4084 21.2578 12.4076H20.3209C20.3037 12.4081 20.2865 12.4047 20.2707 12.3978C20.2549 12.3909 20.2408 12.3806 20.2294 12.3676C20.2181 12.3547 20.2097 12.3393 20.2049 12.3227C20.2001 12.3062 20.1991 12.2887 20.2018 12.2717C20.3406 11.4424 21.0305 10.812 22.4897 10.812C24.0419 10.812 24.6023 11.5349 24.6023 12.9148V15.8446C24.602 15.8766 24.5891 15.9071 24.5663 15.9296C24.5436 15.952 24.5128 15.9645 24.4809 15.9643H23.5365C23.5049 15.9643 23.4746 15.9518 23.452 15.9296C23.441 15.9185 23.4322 15.9054 23.4263 15.8909C23.4203 15.8764 23.4173 15.8609 23.4173 15.8452V15.626C23.4177 15.6079 23.4125 15.5901 23.4025 15.575C23.3926 15.5599 23.3783 15.5481 23.3615 15.5413C23.3447 15.5345 23.3262 15.5329 23.3085 15.5368C23.2908 15.5406 23.2747 15.5498 23.2623 15.563C22.979 15.8712 22.5215 16.0939 21.7887 16.0939C20.7107 16.0939 19.9994 15.5329 19.9994 14.563ZM23.4266 13.928V13.7008L22.1982 13.7655C21.551 13.7985 21.1746 14.0674 21.1746 14.5202C21.1746 14.9297 21.5198 15.1564 22.123 15.1564C22.9425 15.1564 23.4266 14.714 23.4266 13.928ZM25.5508 18.1782V17.3292C25.551 17.3114 25.5551 17.2939 25.5628 17.2778C25.5705 17.2618 25.5817 17.2476 25.5955 17.2364C25.6093 17.2251 25.6254 17.217 25.6426 17.2127C25.6599 17.2083 25.6779 17.2078 25.6954 17.2112C25.84 17.2384 25.9874 17.2523 26.1349 17.2529C26.3884 17.2652 26.6388 17.1921 26.8459 17.0453C27.0529 16.8985 27.2048 16.6865 27.2771 16.4432L27.3384 16.2477C27.3473 16.2215 27.3473 16.193 27.3384 16.1668L25.3704 11.1121C25.3632 11.0938 25.3607 11.074 25.3629 11.0545C25.3651 11.035 25.372 11.0163 25.3831 11C25.3941 10.9837 25.4089 10.9704 25.4262 10.9611C25.4436 10.9518 25.4629 10.9469 25.4825 10.9467H26.4368C26.4612 10.947 26.4849 10.9546 26.5049 10.9685C26.5249 10.9824 26.5403 11.002 26.549 11.0248L27.8855 14.5896C27.8939 14.6133 27.9094 14.6338 27.9299 14.6483C27.9504 14.6628 27.9749 14.6706 28 14.6706C28.0252 14.6706 28.0497 14.6628 28.0702 14.6483C28.0907 14.6338 28.1062 14.6133 28.1145 14.5896L29.2753 11.0346C29.2833 11.0103 29.2988 10.9892 29.3196 10.9742C29.3404 10.9593 29.3653 10.9513 29.3909 10.9514H30.3781C30.3979 10.9515 30.4174 10.9564 30.4348 10.9656C30.4523 10.9749 30.4673 10.9883 30.4785 11.0046C30.4897 11.0209 30.4968 11.0397 30.4991 11.0593C30.5015 11.0789 30.4991 11.0988 30.4921 11.1173L28.3869 16.7306C27.9023 18.0354 27.0712 18.3691 26.1563 18.3691C25.9828 18.3737 25.8093 18.3529 25.6416 18.3072C25.6137 18.2998 25.5893 18.2828 25.5727 18.2592C25.5561 18.2356 25.5483 18.2069 25.5508 18.1782ZM7.94924 8.00012C6.69546 7.99119 5.48593 8.46308 4.56946 9.31872C4.53027 9.35462 4.50584 9.40381 4.50092 9.45673C4.496 9.50964 4.51095 9.5625 4.54286 9.605L5.1102 10.38C5.12859 10.4058 5.15242 10.4272 5.17999 10.4428C5.20757 10.4584 5.23823 10.4678 5.26982 10.4703C5.30141 10.4728 5.33316 10.4683 5.36284 10.4572C5.39251 10.4461 5.41939 10.4286 5.44159 10.406C5.77113 10.0765 6.16303 9.81607 6.59438 9.63981C7.02574 9.46355 7.48791 9.37504 7.95386 9.37945C9.89938 9.37945 10.9155 10.8438 10.9155 12.2896C10.9155 13.8615 9.8479 14.9673 8.31359 14.9893C7.12801 14.9893 6.23448 14.2033 6.23448 13.1652C6.23572 12.903 6.29513 12.6442 6.40844 12.4077C6.52175 12.1712 6.68613 11.9628 6.88973 11.7975C6.93277 11.7615 6.95998 11.7101 6.9655 11.6543C6.97101 11.5985 6.9544 11.5427 6.91923 11.499L6.32297 10.746C6.30493 10.7233 6.28252 10.7043 6.25706 10.6904C6.23159 10.6764 6.20358 10.6677 6.17469 10.6647C6.14579 10.6618 6.1166 10.6646 6.08882 10.6731C6.06105 10.6816 6.03526 10.6956 6.01298 10.7142C5.64679 11.0093 5.35128 11.3825 5.14813 11.8066C4.94498 12.2308 4.83934 12.695 4.83896 13.1652C4.83896 14.9523 6.35767 16.3541 8.30318 16.3657H8.3292C10.6391 16.3356 12.3093 14.6249 12.3093 12.2867C12.3093 10.2105 10.7802 8.00012 7.94982 8.00012H7.94924Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export function IconSignalColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M9.1191 0.350321L9.38844 1.44131C8.3269 1.70366 7.3109 2.12431 6.37459 2.68912L5.79841 1.72428C6.82903 1.10015 7.9488 0.636839 9.1191 0.350321ZM14.8809 0.350321L14.6115 1.44131C15.6731 1.70366 16.6891 2.12431 17.6254 2.68912L18.2084 1.72428C17.175 1.1007 16.0531 0.637445 14.8809 0.350321ZM1.72427 5.79502C1.10072 6.82715 0.637456 7.94794 0.350307 9.11912L1.44129 9.38845C1.70365 8.32692 2.1243 7.31092 2.68911 6.37461L1.72427 5.79502ZM1.12422 12C1.12414 11.4545 1.16517 10.9097 1.24696 10.3703L0.135519 10.1999C-0.045173 11.392 -0.045173 12.6046 0.135519 13.7967L1.24696 13.6297C1.1653 13.0903 1.12427 12.5455 1.12422 12ZM18.2016 22.2723L17.6254 21.3109C16.6905 21.8762 15.6756 22.2969 14.6149 22.5587L14.8843 23.6497C16.0531 23.3604 17.1716 22.896 18.2016 22.2723ZM22.8757 12C22.8757 12.5455 22.8347 13.0903 22.753 13.6297L23.8645 13.7967C24.0451 12.6046 24.0451 11.392 23.8645 10.1999L22.753 10.3703C22.8348 10.9097 22.8758 11.4545 22.8757 12ZM23.6497 14.8775L22.5587 14.6081C22.2969 15.6709 21.8763 16.6882 21.3109 17.6254L22.2757 18.205C22.8999 17.1719 23.3631 16.0499 23.6497 14.8775ZM13.6296 22.753C12.5494 22.9167 11.4506 22.9167 10.3703 22.753L10.2033 23.8645C11.3943 24.0452 12.6057 24.0452 13.7967 23.8645L13.6296 22.753ZM20.7551 18.4504C20.1071 19.3292 19.3301 20.105 18.4504 20.7517L19.1187 21.6586C20.0876 20.9453 20.9448 20.0916 21.662 19.1255L20.7551 18.4504ZM18.4504 3.24484C19.3302 3.89279 20.1072 4.66977 20.7551 5.54955L21.662 4.8745C20.9474 3.90755 20.0924 3.05263 19.1255 2.33796L18.4504 3.24484ZM3.24483 5.54955C3.89277 4.66977 4.66975 3.89279 5.54953 3.24484L4.87449 2.33796C3.90754 3.05263 3.05262 3.90755 2.33795 4.8745L3.24483 5.54955ZM22.2757 5.79502L21.3109 6.37461C21.8762 7.30944 22.2969 8.32439 22.5587 9.38504L23.6497 9.11571C23.3625 7.94562 22.8992 6.82595 22.2757 5.79502ZM10.3703 1.24697C11.4506 1.08331 12.5494 1.08331 13.6296 1.24697L13.7967 0.135533C12.6057 -0.0451778 11.3943 -0.0451778 10.2033 0.135533L10.3703 1.24697ZM3.821 21.9586L1.49925 22.4973L2.04133 20.1756L0.946939 19.9199L0.404856 22.2416C0.370938 22.3856 0.365733 22.5348 0.389538 22.6808C0.413343 22.8267 0.465691 22.9665 0.543588 23.0923C0.621484 23.218 0.723401 23.3271 0.843507 23.4134C0.963614 23.4997 1.09955 23.5614 1.24355 23.5951C1.41195 23.6326 1.58655 23.6326 1.75495 23.5951L4.0767 23.0599L3.821 21.9586ZM1.17877 18.9175L2.27658 19.1698L2.6516 17.5606C2.10394 16.6419 1.69604 15.6469 1.44129 14.6081L0.350307 14.8775C0.595704 15.8718 0.966906 16.8307 1.45493 17.7311L1.17877 18.9175ZM6.42914 21.3518L4.81994 21.7268L5.07564 22.8246L6.25867 22.5485C7.15837 23.038 8.1175 23.4092 9.11228 23.6531L9.38162 22.5621C8.34611 22.304 7.35458 21.8939 6.43937 21.345L6.42914 21.3518ZM12 2.24932C6.61324 2.25273 2.25271 6.62008 2.25271 12.0034C2.25568 13.837 2.77433 15.6328 3.74941 17.1856L2.81184 21.1881L6.81099 20.2506C11.3693 23.1178 17.3901 21.7507 20.2574 17.1958C23.1246 12.641 21.7609 6.62008 17.206 3.74942C15.6467 2.76883 13.842 2.24882 12 2.24932Z"
          fill="#3A76F0"
        />
      </g>
    </svg>
  )
}

export function IconSignalColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M9.1191 0.350321L9.38844 1.44131C8.3269 1.70366 7.3109 2.12431 6.37459 2.68912L5.79841 1.72428C6.82903 1.10015 7.9488 0.636839 9.1191 0.350321ZM14.8809 0.350321L14.6115 1.44131C15.6731 1.70366 16.6891 2.12431 17.6254 2.68912L18.2084 1.72428C17.175 1.1007 16.0531 0.637445 14.8809 0.350321ZM1.72427 5.79502C1.10072 6.82715 0.637456 7.94794 0.350307 9.11912L1.44129 9.38845C1.70365 8.32692 2.1243 7.31092 2.68911 6.37461L1.72427 5.79502ZM1.12422 12C1.12414 11.4545 1.16517 10.9097 1.24696 10.3703L0.135519 10.1999C-0.045173 11.392 -0.045173 12.6046 0.135519 13.7967L1.24696 13.6297C1.1653 13.0903 1.12427 12.5455 1.12422 12ZM18.2016 22.2723L17.6254 21.3109C16.6905 21.8762 15.6756 22.2969 14.6149 22.5587L14.8843 23.6497C16.0531 23.3604 17.1716 22.896 18.2016 22.2723ZM22.8757 12C22.8757 12.5455 22.8347 13.0903 22.753 13.6297L23.8645 13.7967C24.0451 12.6046 24.0451 11.392 23.8645 10.1999L22.753 10.3703C22.8348 10.9097 22.8758 11.4545 22.8757 12ZM23.6497 14.8775L22.5587 14.6081C22.2969 15.6709 21.8763 16.6882 21.3109 17.6254L22.2757 18.205C22.8999 17.1719 23.3631 16.0499 23.6497 14.8775ZM13.6296 22.753C12.5494 22.9167 11.4506 22.9167 10.3703 22.753L10.2033 23.8645C11.3943 24.0452 12.6057 24.0452 13.7967 23.8645L13.6296 22.753ZM20.7551 18.4504C20.1071 19.3292 19.3301 20.105 18.4504 20.7517L19.1187 21.6586C20.0876 20.9453 20.9448 20.0916 21.662 19.1255L20.7551 18.4504ZM18.4504 3.24484C19.3302 3.89279 20.1072 4.66977 20.7551 5.54955L21.662 4.8745C20.9474 3.90755 20.0924 3.05263 19.1255 2.33796L18.4504 3.24484ZM3.24483 5.54955C3.89277 4.66977 4.66975 3.89279 5.54953 3.24484L4.87449 2.33796C3.90754 3.05263 3.05262 3.90755 2.33795 4.8745L3.24483 5.54955ZM22.2757 5.79502L21.3109 6.37461C21.8762 7.30944 22.2969 8.32439 22.5587 9.38504L23.6497 9.11571C23.3625 7.94562 22.8992 6.82595 22.2757 5.79502ZM10.3703 1.24697C11.4506 1.08331 12.5494 1.08331 13.6296 1.24697L13.7967 0.135533C12.6057 -0.0451778 11.3943 -0.0451778 10.2033 0.135533L10.3703 1.24697ZM3.821 21.9586L1.49925 22.4973L2.04133 20.1756L0.946939 19.9199L0.404856 22.2416C0.370938 22.3856 0.365733 22.5348 0.389538 22.6808C0.413343 22.8267 0.465691 22.9665 0.543588 23.0923C0.621484 23.218 0.723401 23.3271 0.843507 23.4134C0.963614 23.4997 1.09955 23.5614 1.24355 23.5951C1.41195 23.6326 1.58655 23.6326 1.75495 23.5951L4.0767 23.0599L3.821 21.9586ZM1.17877 18.9175L2.27658 19.1698L2.6516 17.5606C2.10394 16.6419 1.69604 15.6469 1.44129 14.6081L0.350307 14.8775C0.595704 15.8718 0.966906 16.8307 1.45493 17.7311L1.17877 18.9175ZM6.42914 21.3518L4.81994 21.7268L5.07564 22.8246L6.25867 22.5485C7.15837 23.038 8.1175 23.4092 9.11228 23.6531L9.38162 22.5621C8.34611 22.304 7.35458 21.8939 6.43937 21.345L6.42914 21.3518ZM12 2.24932C6.61324 2.25273 2.25271 6.62008 2.25271 12.0034C2.25568 13.837 2.77433 15.6328 3.74941 17.1856L2.81184 21.1881L6.81099 20.2506C11.3693 23.1178 17.3901 21.7507 20.2574 17.1958C23.1246 12.641 21.7609 6.62008 17.206 3.74942C15.6467 2.76883 13.842 2.24882 12 2.24932Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSketch(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Sketch">
        <g id="sketch">
          <path
            id="vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.08181 3.59263L12 3L17.9181 3.59263L22.4999 9.4185L12 20.9999L1.5 9.4185L6.08181 3.59263Z"
            fill="#FDB300"
          />
          <path
            id="vector_2"
            d="M5.75297 9.41851L11.9999 21L1.5 9.41851H5.75297ZM18.247 9.41851L12.0001 21L22.5 9.41851"
            fill="#EA6C00"
          />
          <path
            id="vector_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.75317 9.41851H18.2471L12.0001 21"
            fill="#FDAD00"
          />
          <path
            id="vector_4"
            d="M12.0001 3L6.08196 3.59253L5.75317 9.41844L12.0001 3ZM12.0002 3L17.9184 3.59253L18.2472 9.41844"
            fill="#FDD231"
          />
          <path
            id="vector_5"
            d="M22.5 9.41841L17.9182 3.59251L18.247 9.41841H22.5ZM1.5 9.41841L6.08176 3.59251L5.75297 9.41841"
            fill="#FDAD00"
          />
          <path
            id="vector_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0001 3L5.75317 9.41844H18.2471"
            fill="#FEEEB7"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconSkrill(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Skrill">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Skrill_2"
          d="M8.17676 8.29498C9.53753 8.29498 10.2714 8.50583 10.9033 8.72565L10.9346 8.73541V10.5381L10.9111 10.5313C10.6575 10.4246 10.3594 10.3194 10.3594 10.3194C9.82416 10.16 9.07549 9.9903 8.49707 9.9903C8.16787 9.9903 7.29202 9.99063 7.29199 10.6485C7.29199 11.1938 7.90106 11.2331 8.16406 11.2501C10.0927 11.3787 11.2422 12.3185 11.2422 13.7637C11.242 15.0387 10.2144 16.3241 7.92188 16.3243C6.85872 16.3243 5.95101 16.2204 5.14648 16.0098V14.1544C5.68364 14.3741 6.56878 14.6045 7.48047 14.6046C8.3126 14.6046 8.80754 14.3307 8.80762 13.8653C8.80762 13.302 8.20421 13.2669 7.97559 13.253C5.29031 13.071 5.00013 11.4907 5 10.8194C5 9.65407 5.8311 8.29513 8.17676 8.29498ZM13.9131 12.4444C14.7194 11.4741 15.0526 10.538 15.0986 10.4219H17.5547C17.4846 10.6447 17.0459 11.9868 16.0469 13.2471C16.0469 13.2471 17.1597 15.187 17.4141 16.2393H14.8418C14.8379 16.2218 14.531 14.8366 13.9131 13.9141V16.2393H11.7656V8.71686L13.9131 8.29498V12.4444ZM20.7441 10.3428C20.7552 10.3424 21.0942 10.3305 21.2959 10.3731V12.0723C20.0773 12.1141 19.9424 12.5519 19.9424 13.5733V16.2393H17.8447V12.9708C17.8447 11.264 18.8215 10.4045 20.7441 10.3428ZM23.999 16.2393H21.918V10.4288H23.999V16.2393ZM26.9609 16.2393H24.8809V8.6651L26.9609 8.29498V16.2393ZM30 16.2393H27.9189V8.6651L30 8.29498V16.2393ZM22.958 7.83014C23.5246 7.83038 23.9832 8.28731 23.9834 8.85065C23.9834 9.41446 23.5247 9.87092 22.958 9.87115C22.3921 9.87115 21.9316 9.41461 21.9316 8.85065C21.9318 8.28717 22.3922 7.83014 22.958 7.83014Z"
          fill="#862165"
        />
      </g>
    </svg>
  )
}

export function IconSlides(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Slides">
        <g id="Page-1">
          <g id="Consumer-Apps-Slides-Large-VD-R8">
            <g id="Hero">
              <g id="Personal">
                <g id="Slides-icon">
                  <g id="Group">
                    <g id="Clipped">
                      <g id="Mask group">
                        <mask
                          id="mask0_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_2">
                            <path
                              id="Vector"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask0_914_1262)">
                          <path
                            id="Path"
                            d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L16.1607 4.68182L13.9286 1.5Z"
                            fill="#F4B400"
                          />
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_2">
                      <g id="Mask group_2">
                        <mask
                          id="mask1_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_3">
                            <path
                              id="Vector_2"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask1_914_1262)">
                          <path
                            id="Shape"
                            d="M15.0447 10.5911H9.24118C8.87287 10.5911 8.57153 10.8979 8.57153 11.2729V17.182C8.57153 17.557 8.87287 17.8638 9.24118 17.8638H15.0447C15.4131 17.8638 15.7144 17.557 15.7144 17.182V11.2729C15.7144 10.8979 15.4131 10.5911 15.0447 10.5911ZM14.8215 15.8184H9.46439V12.6366H14.8215V15.8184Z"
                            fill="#F1F1F1"
                          />
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_3">
                      <g id="Mask group_3">
                        <mask
                          id="mask2_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_4">
                            <path
                              id="Vector_3"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask2_914_1262)">
                          <path
                            id="Path_2"
                            d="M14.3202 6.55557L19.2856 11.6101V6.95444L14.3202 6.55557Z"
                            fill="url(#paint0_linear_914_1262)"
                          />
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_4">
                      <g id="Mask group_4">
                        <mask
                          id="mask3_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_5">
                            <path
                              id="Vector_4"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask3_914_1262)">
                          <g id="Group_6">
                            <g id="Group_7">
                              <path
                                id="Path_3"
                                d="M13.9286 1.5V5.59091C13.9286 6.34432 14.5279 6.95455 15.2679 6.95455H19.2857L13.9286 1.5Z"
                                fill="#FADA80"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_5">
                      <g id="Mask group_5">
                        <mask
                          id="mask4_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_8">
                            <path
                              id="Vector_5"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask4_914_1262)">
                          <path
                            id="Path_4"
                            d="M13.9286 1.5V1.61364L19.1741 6.95455H19.2857L13.9286 1.5Z"
                            fill="white"
                            fillOpacity="0.1"
                          />
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_6">
                      <g id="Mask group_6">
                        <mask
                          id="mask5_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_9">
                            <path
                              id="Vector_6"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask5_914_1262)">
                          <path
                            id="Path_5"
                            d="M6.33929 1.5C5.60268 1.5 5 2.11364 5 2.86364V2.97727C5 2.22727 5.60268 1.61364 6.33929 1.61364H13.9286V1.5H6.33929Z"
                            fill="white"
                            fillOpacity="0.2"
                          />
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_7">
                      <g id="Mask group_7">
                        <mask
                          id="mask6_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_10">
                            <path
                              id="Vector_7"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask6_914_1262)">
                          <path
                            id="Path_6"
                            d="M17.9464 21.3861H6.33929C5.60268 21.3861 5 20.7725 5 20.0225V20.1361C5 20.8861 5.60268 21.4997 6.33929 21.4997H17.9464C18.683 21.4997 19.2857 20.8861 19.2857 20.1361V20.0225C19.2857 20.7725 18.683 21.3861 17.9464 21.3861Z"
                            fill="#BF360C"
                            fillOpacity="0.2"
                          />
                        </g>
                      </g>
                    </g>
                    <g id="Clipped_8">
                      <g id="Mask group_8">
                        <mask
                          id="mask7_914_1262"
                          style={{ maskType: 'luminance' }}
                          maskUnits="userSpaceOnUse"
                          x="5"
                          y="1"
                          width="15"
                          height="21"
                        >
                          <g id="Group_11">
                            <path
                              id="Vector_8"
                              d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                              fill="white"
                            />
                          </g>
                        </mask>
                        <g mask="url(#mask7_914_1262)">
                          <path
                            id="Path_7"
                            d="M15.2679 6.95437C14.5279 6.95437 13.9286 6.34414 13.9286 5.59073V5.70437C13.9286 6.45777 14.5279 7.068 15.2679 7.068H19.2857V6.95437H15.2679Z"
                            fill="#BF360C"
                            fillOpacity="0.1"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <path
                    id="Path_8"
                    d="M13.9286 1.5H6.33929C5.60268 1.5 5 2.11364 5 2.86364V20.1364C5 20.8864 5.60268 21.5 6.33929 21.5H17.9464C18.683 21.5 19.2857 20.8864 19.2857 20.1364V6.95455L13.9286 1.5Z"
                    fill="url(#paint1_radial_914_1262)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_914_1262"
          x1="262.617"
          y1="49.9544"
          x2="262.617"
          y2="512.081"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BF360C" stopOpacity="0.2" />
          <stop offset="1" stopColor="#BF360C" stopOpacity="0.02" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_914_1262"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(50.2579 41.0288) scale(2303.55 2345.43)"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function IconSnapchatColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M22.2972 17.6797C18.5806 15.8801 17.9883 13.1015 17.9619 12.8954C17.93 12.6457 17.8939 12.4495 18.1692 12.1955C18.4347 11.9502 19.6126 11.2209 19.9395 10.9927C20.4797 10.6149 20.7176 10.2376 20.5422 9.77392C20.4196 9.45312 20.121 9.33229 19.8064 9.33229C19.7072 9.33259 19.6083 9.3437 19.5115 9.36541C18.9179 9.49422 18.3415 9.79171 18.0079 9.87206C17.9678 9.8824 17.9267 9.88796 17.8853 9.88862C17.7075 9.88862 17.64 9.80949 17.6572 9.59543C17.6989 8.94648 17.7872 7.67986 17.6848 6.49666C17.5443 4.86876 17.0195 4.06217 16.3971 3.34881C16.096 3.00287 14.6979 1.51666 11.9999 1.51666C9.30182 1.51666 7.90558 3.00287 7.60635 3.34452C6.98212 4.05788 6.45784 4.86446 6.31864 6.49236C6.21624 7.67556 6.30822 8.94157 6.34624 9.59113C6.3585 9.79477 6.29596 9.88433 6.11813 9.88433C6.07674 9.88362 6.03558 9.87806 5.99549 9.86777C5.66253 9.78741 5.08613 9.48993 4.49256 9.36112C4.39574 9.33941 4.29684 9.3283 4.19761 9.328C3.88182 9.328 3.58442 9.45067 3.46178 9.76962C3.28641 10.2333 3.5231 10.6106 4.06516 10.9884C4.39199 11.2166 5.56994 11.9453 5.83545 12.1912C6.11016 12.4452 6.07459 12.6414 6.04271 12.8911C6.01634 13.1003 5.42338 15.8788 1.70744 17.6754C1.48976 17.7809 1.11939 18.0042 1.77244 18.3649C2.7977 18.9316 3.48018 18.8709 4.01059 19.2125C4.46067 19.5027 4.19455 20.1283 4.52199 20.354C4.92425 20.6319 6.11322 20.3344 7.64927 20.8417C8.93697 21.2661 9.71941 22.4653 12.0029 22.4653C14.2865 22.4653 15.0916 21.2606 16.3566 20.8417C17.8896 20.3344 19.081 20.6319 19.4839 20.354C19.8107 20.1283 19.5452 19.5027 19.9953 19.2125C20.5257 18.8709 21.2076 18.9316 22.2334 18.3649C22.8853 18.0085 22.5149 17.7852 22.2972 17.6797Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M23.9142 17.4685C23.7474 17.0146 23.4298 16.7717 23.068 16.5705C22.9999 16.5307 22.9374 16.4988 22.884 16.4742C22.7761 16.4184 22.6657 16.3644 22.556 16.3074C21.4283 15.7093 20.5478 14.9549 19.937 14.0606C19.7636 13.8088 19.6132 13.542 19.4876 13.2632C19.4354 13.1142 19.4379 13.0295 19.4753 12.9522C19.5124 12.8927 19.5615 12.8415 19.6194 12.8019C19.8132 12.6737 20.0131 12.5437 20.1486 12.456C20.3902 12.2996 20.5815 12.1757 20.7048 12.088C21.1677 11.7641 21.4915 11.42 21.6938 11.0354C21.835 10.7697 21.9173 10.4767 21.9352 10.1763C21.9531 9.87596 21.9061 9.57526 21.7975 9.29467C21.4909 8.48746 20.7287 7.98634 19.8052 7.98634C19.6104 7.98615 19.4162 8.00671 19.2257 8.04767C19.1748 8.05872 19.1239 8.07037 19.0743 8.08325C19.0829 7.53121 19.0706 6.94851 19.0215 6.375C18.8474 4.35884 18.1416 3.30199 17.4058 2.45921C16.9346 1.93109 16.3796 1.48429 15.763 1.13678C14.6464 0.498865 13.3802 0.175003 11.9999 0.175003C10.6196 0.175003 9.35948 0.498865 8.24163 1.13678C7.6236 1.48439 7.06746 1.93209 6.59582 2.46167C5.85999 3.30444 5.15421 4.36313 4.98006 6.37745C4.931 6.95096 4.91874 7.53673 4.92671 8.0857C4.87704 8.07282 4.82676 8.06117 4.77587 8.05013C4.58543 8.00917 4.39118 7.98861 4.1964 7.98879C3.27232 7.98879 2.50889 8.48992 2.20353 9.29712C2.09437 9.57783 2.04691 9.87875 2.06437 10.1794C2.08183 10.4801 2.1638 10.7735 2.3047 11.0397C2.50767 11.4243 2.83143 11.7684 3.29439 12.0923C3.41703 12.1781 3.60896 12.302 3.85056 12.4603C3.98117 12.5449 4.17187 12.6688 4.3589 12.7927C4.42433 12.8351 4.47995 12.8909 4.522 12.9565C4.56125 13.0369 4.56248 13.1234 4.50422 13.2828C4.38032 13.5557 4.23236 13.817 4.06211 14.0637C3.46486 14.9377 2.61007 15.6787 1.51859 16.2718C0.94035 16.5785 0.339422 16.7834 0.0855607 17.4734C-0.105755 17.9942 0.0193358 18.5867 0.505597 19.086C0.684059 19.2723 0.891048 19.4291 1.11879 19.5503C1.59266 19.8108 2.09654 20.0125 2.61927 20.1508C2.72714 20.1786 2.82955 20.2245 2.92219 20.2864C3.0994 20.4415 3.07426 20.6752 3.31034 21.0175C3.42884 21.1944 3.57942 21.3475 3.75429 21.4689C4.24975 21.8112 4.80653 21.8327 5.39642 21.8554C5.92928 21.8756 6.53327 21.8989 7.22311 22.1265C7.50886 22.2209 7.80565 22.4037 8.14965 22.6172C8.97562 23.1251 10.1063 23.82 11.9987 23.82C13.891 23.82 15.0297 23.1214 15.8618 22.6117C16.2033 22.4019 16.4983 22.2209 16.776 22.1289C17.4659 21.9008 18.0699 21.8781 18.6027 21.8578C19.1926 21.8351 19.7494 21.8137 20.2449 21.4714C20.452 21.3269 20.6245 21.1384 20.7501 20.9194C20.92 20.6305 20.9157 20.4287 21.0751 20.2876C21.162 20.2286 21.2582 20.1847 21.3596 20.1575C21.8895 20.0188 22.4003 19.8152 22.8804 19.5515C23.1223 19.4217 23.3401 19.2511 23.5242 19.0473L23.5303 19.04C23.9866 18.5517 24.1012 17.9764 23.9142 17.4685ZM22.2322 18.3726C21.2063 18.9394 20.5245 18.8787 19.9941 19.2203C19.5434 19.5104 19.8101 20.1361 19.4827 20.3618C19.0804 20.6397 17.8914 20.3422 16.3554 20.8494C15.0885 21.2684 14.2803 22.473 12.0017 22.473C9.7231 22.473 8.93392 21.2708 7.64622 20.8464C6.11324 20.3391 4.92181 20.6366 4.51894 20.3587C4.19211 20.133 4.45762 19.5074 4.00754 19.2172C3.47651 18.8756 2.79464 18.9363 1.76939 18.3726C1.11634 18.012 1.4867 17.7887 1.70439 17.6832C5.42033 15.8835 6.01329 13.105 6.03965 12.8989C6.07154 12.6492 6.10711 12.4529 5.8324 12.199C5.56688 11.9536 4.38894 11.2243 4.06211 10.9962C3.52128 10.6183 3.28336 10.2411 3.45873 9.77739C3.58137 9.4566 3.88061 9.33576 4.19456 9.33576C4.29379 9.33607 4.39268 9.34717 4.4895 9.36889C5.08307 9.49769 5.65948 9.79518 5.99244 9.87553C6.03253 9.88583 6.07369 9.89139 6.11508 9.89209C6.2929 9.89209 6.35545 9.80254 6.34318 9.5989C6.30517 8.94934 6.21319 7.68333 6.31559 6.50013C6.45601 4.87223 6.98029 4.06564 7.60329 3.35229C7.90253 3.00941 9.30858 1.5232 11.9974 1.5232C14.6863 1.5232 16.096 3.00328 16.3952 3.34493C17.0189 4.05828 17.5437 4.86487 17.6829 6.49277C17.7853 7.67597 17.697 8.94259 17.6553 9.59154C17.6412 9.80561 17.7056 9.88473 17.8835 9.88473C17.9248 9.88407 17.966 9.87851 18.0061 9.86817C18.3397 9.78782 18.9161 9.49033 19.5096 9.36152C19.6065 9.33981 19.7054 9.32871 19.8046 9.3284C20.1204 9.3284 20.4178 9.45108 20.5404 9.77003C20.7158 10.2337 20.4791 10.611 19.9377 10.9888C19.6108 11.217 18.4329 11.9457 18.1674 12.1916C17.892 12.4456 17.9282 12.6419 17.9601 12.8915C17.9865 13.1007 18.5788 15.8792 22.2954 17.6758C22.5149 17.7856 22.8853 18.0089 22.2322 18.3726Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export function IconSnapchatColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M23.9132 17.4576C23.7478 17.0041 23.4291 16.759 23.0675 16.5628C23.0001 16.5261 22.9388 16.4893 22.8836 16.4648C22.7733 16.4096 22.663 16.3545 22.5527 16.2993C21.425 15.6987 20.5425 14.951 19.9358 14.0563C19.7642 13.805 19.611 13.5353 19.4884 13.2595C19.4332 13.1125 19.4394 13.0267 19.4761 12.947C19.5129 12.8857 19.5619 12.8367 19.6232 12.7938C19.8193 12.6651 20.0155 12.5364 20.1503 12.4506C20.3893 12.2912 20.5854 12.1687 20.708 12.0829C21.1676 11.758 21.4924 11.4148 21.6947 11.0287C21.9827 10.4894 22.0195 9.85817 21.7989 9.28821C21.4924 8.47924 20.7325 7.98282 19.8071 7.98282C19.611 7.98282 19.421 8.00121 19.2249 8.04411C19.1758 8.05637 19.1207 8.06862 19.0716 8.08088C19.0778 7.52931 19.0655 6.94709 19.0165 6.37101C18.8449 4.3547 18.134 3.30058 17.3985 2.46097C16.9266 1.93391 16.3751 1.48652 15.7561 1.13719C14.6407 0.499818 13.3721 0.175003 11.9931 0.175003C10.6142 0.175003 9.35171 0.499818 8.2363 1.13719C7.61732 1.48652 7.06574 1.93391 6.59384 2.46097C5.85841 3.30058 5.15363 4.36083 4.9759 6.37101C4.92687 6.94709 4.91461 7.52931 4.92074 8.08088C4.87171 8.06862 4.82268 8.05637 4.76752 8.04411C4.57754 8.00121 4.38142 7.98282 4.19144 7.98282C3.26602 7.98282 2.50607 8.48537 2.19965 9.28821C1.97902 9.85817 2.01579 10.4894 2.30383 11.0287C2.50607 11.4148 2.83089 11.758 3.29053 12.0829C3.41311 12.1687 3.60309 12.2912 3.84824 12.4506C3.97694 12.5364 4.16692 12.6589 4.35691 12.7815C4.42432 12.8244 4.47948 12.8796 4.52238 12.947C4.55915 13.0267 4.56528 13.1125 4.50399 13.2718C4.38142 13.5415 4.23434 13.805 4.06274 14.0501C3.46826 14.9204 2.61026 15.6619 1.51937 16.2564C0.943285 16.5628 0.342683 16.7651 0.085282 17.4576C-0.104704 17.9786 0.0178675 18.5669 0.502026 19.0694C0.679755 19.2533 0.888127 19.4126 1.11489 19.5352C1.58679 19.7926 2.08933 19.9949 2.61639 20.1358C2.7267 20.1665 2.82476 20.2094 2.91669 20.2706C3.09442 20.4239 3.0699 20.6567 3.30279 20.9999C3.41923 21.1777 3.57245 21.3309 3.74405 21.4535C4.24047 21.7967 4.79817 21.815 5.38651 21.8396C5.9197 21.8579 6.5203 21.8825 7.21283 22.1092C7.50087 22.2012 7.79505 22.385 8.13825 22.5995C8.96561 23.1082 10.0933 23.8007 11.987 23.8007C13.8807 23.8007 15.0145 23.1021 15.848 22.5934C16.1912 22.385 16.4854 22.2012 16.7612 22.1092C17.4476 21.8825 18.0543 21.8579 18.5875 21.8396C19.1758 21.815 19.7335 21.7967 20.23 21.4535C20.4383 21.3064 20.6099 21.1225 20.7325 20.9019C20.9041 20.6138 20.898 20.4116 21.0573 20.2706C21.1431 20.2094 21.2412 20.1665 21.3392 20.1419C21.8663 20.001 22.3811 19.7987 22.8591 19.5352C23.0981 19.4065 23.3188 19.2349 23.5026 19.0327L23.5087 19.0265C23.9868 18.5363 24.1032 17.9602 23.9132 17.4576ZM22.234 18.3585C21.2105 18.9224 20.5241 18.8611 19.9971 19.2043C19.5436 19.4923 19.8132 20.1174 19.4884 20.3442C19.0839 20.62 17.895 20.3258 16.3628 20.8345C15.0942 21.2512 14.2914 22.4586 12.0115 22.4586C9.73168 22.4586 8.94722 21.2573 7.66022 20.8345C6.12807 20.3258 4.93912 20.6261 4.53464 20.3442C4.20982 20.1174 4.47335 19.4923 4.02596 19.2043C3.49278 18.8611 2.8125 18.9224 1.78903 18.3585C1.13327 17.9969 1.50711 17.7763 1.72162 17.6721C5.43554 15.8764 6.03001 13.1002 6.05453 12.8918C6.08517 12.6406 6.12194 12.4444 5.84616 12.1932C5.58263 11.948 4.40594 11.2187 4.07499 10.992C3.53568 10.612 3.29666 10.2381 3.47439 9.77237C3.59696 9.45369 3.89726 9.33111 4.20982 9.33111C4.30788 9.33111 4.40594 9.34337 4.50399 9.36176C5.09847 9.49046 5.67456 9.78463 6.0055 9.87043C6.0484 9.88269 6.08517 9.88882 6.12807 9.88882C6.3058 9.88882 6.36709 9.79689 6.35483 9.59464C6.31806 8.94501 6.22613 7.68252 6.33031 6.49971C6.47127 4.87563 6.9922 4.06666 7.61732 3.35574C7.91762 3.01254 9.32106 1.52942 12.0115 1.52942C14.702 1.52942 16.1054 3.00641 16.4057 3.34961C17.0308 4.06053 17.5518 4.8695 17.6927 6.49358C17.7969 7.67639 17.705 8.93888 17.6621 9.58851C17.6498 9.80301 17.7111 9.88269 17.8888 9.88269C17.9317 9.88269 17.9685 9.87656 18.0114 9.8643C18.3423 9.78463 18.9184 9.48433 19.5129 9.35563C19.611 9.33111 19.709 9.32499 19.8071 9.32499C20.1196 9.32499 20.4199 9.44756 20.5425 9.76624C20.7202 10.232 20.4812 10.6059 19.9419 10.9858C19.6171 11.2126 18.4404 11.9419 18.1707 12.187C17.895 12.4383 17.9317 12.6344 17.9624 12.8857C17.9869 13.0941 18.5814 15.8703 22.2953 17.666C22.5159 17.7702 22.8836 17.9969 22.234 18.3585Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconSofort(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Sofort">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="#F884A1" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Sofort_2"
          d="M11.3348 16.5833C11.7795 16.5833 12.1909 16.7907 12.3739 17.1937L11.788 17.5638C11.6758 17.381 11.522 17.2601 11.3143 17.2601C11.069 17.2601 10.9149 17.427 10.9149 17.639C10.915 17.8924 11.1396 17.9716 11.4969 18.0755C12.0581 18.2418 12.5154 18.5201 12.5155 19.1644C12.5155 19.8587 11.9752 20.3323 11.2684 20.3323C10.7737 20.3323 10.3497 20.1078 10.0878 19.7503L10.5741 19.264C10.7196 19.4511 10.9613 19.6556 11.2772 19.6556C11.5721 19.6554 11.7753 19.4801 11.7753 19.1976C11.7752 18.8984 11.5344 18.8232 11.1561 18.7152C10.462 18.5114 10.1796 18.1497 10.1796 17.68C10.1798 17.0899 10.6283 16.5834 11.3348 16.5833ZM14.1249 17.68C14.8729 17.6802 15.4792 18.2789 15.4794 19.0062C15.4794 19.7336 14.873 20.3321 14.1249 20.3323C13.3766 20.3323 12.7694 19.7337 12.7694 19.0062C12.7696 18.2788 13.3767 17.68 14.1249 17.68ZM18.7723 17.68C19.5205 17.68 20.1276 18.2788 20.1278 19.0062C20.1278 19.7337 19.5206 20.3323 18.7723 20.3323C18.024 20.3323 17.4169 19.7337 17.4169 19.0062C17.417 18.2788 18.0241 17.68 18.7723 17.68ZM24.5262 19.3597C24.7881 19.3598 24.9999 19.5766 24.9999 19.8343C24.9997 20.096 24.7838 20.3078 24.5262 20.3079C24.2645 20.3079 24.0528 20.096 24.0526 19.8343C24.0526 19.5724 24.2643 19.3597 24.5262 19.3597ZM22.9999 17.3392C22.9999 17.68 23.2787 17.9382 23.661 17.9466V18.6156C23.3785 18.6155 23.1578 18.5328 22.9999 18.3665V18.9818C23 19.4223 23.2876 19.6173 23.6825 19.6048V20.2698H23.578C22.7134 20.2698 22.2938 19.6962 22.2938 19.0228V16.9447H22.9999V17.3392ZM17.2303 17.2943C16.8354 17.2776 16.5478 17.4767 16.5477 17.9173V18.1878C16.7057 18.0216 16.9304 17.9379 17.2089 17.9378V18.6116C16.8182 18.6201 16.5477 18.8699 16.5477 19.2191V20.2659H15.8417V17.8763C15.8417 17.2028 16.2654 16.6283 17.1259 16.6282H17.2303V17.2943ZM21.8856 18.47C21.462 18.4702 21.2168 18.7031 21.2167 19.1185V20.2659H20.5096V17.7513H21.1962V18.0374C21.3375 17.8092 21.5659 17.7009 21.8856 17.7132V18.47ZM14.1239 18.346C13.7584 18.3462 13.4757 18.6323 13.4755 19.0062C13.4755 19.3844 13.7624 19.6671 14.1239 19.6673C14.4856 19.6673 14.7723 19.3803 14.7723 19.0062C14.7721 18.6322 14.4855 18.346 14.1239 18.346ZM18.7723 18.346C18.4108 18.346 18.1241 18.6322 18.1239 19.0062C18.1239 19.3845 18.4107 19.6673 18.7723 19.6673C19.1381 19.6673 19.4208 19.3803 19.4208 19.0062C19.4206 18.6323 19.1338 18.3461 18.7723 18.346ZM19.2382 4.16536C19.392 3.57502 19.995 3.22565 20.5936 3.37532C21.1298 3.5334 21.4502 4.07812 21.3339 4.61848L20.3651 9.43489L20.7802 9.53157C20.9007 9.5482 21.0592 9.62359 21.2089 9.78157C21.479 10.0684 21.6078 10.5463 21.5497 11.2445C21.3654 13.4555 20.2899 14.9112 17.8427 14.9349C17.8236 14.9401 17.8039 14.9447 17.7831 14.9447C15.9778 14.9446 14.4467 13.6266 14.4003 11.7445L13.9911 11.3363C13.4884 10.8333 13.4095 10.1309 13.8124 9.71516L13.8544 9.66926C14.0275 9.49195 14.2552 9.39486 14.4882 9.38215C14.2072 8.82836 14.2945 8.22079 14.7313 7.92317L14.7938 7.88118C15.2731 7.6036 15.6868 7.71282 16.0409 8.06575L15.6337 4.71809C15.4965 4.13617 15.8536 3.49579 16.4022 3.37922C16.6807 3.32103 16.9758 3.3756 17.2128 3.53352C17.4496 3.69143 17.6167 3.93605 17.6708 4.21028L18.3612 7.16633L19.2382 4.16536ZM17.995 9.34895C17.8537 9.32403 17.7081 9.31986 17.5751 9.34895C17.3715 9.39468 17.2422 9.50691 17.1757 9.72297C17.0866 10.0197 17.0961 10.2452 17.287 10.4261C17.3307 10.4433 17.3657 10.4727 17.3905 10.5091C17.5217 10.5967 17.7068 10.6729 17.9579 10.7415L19.6825 11.1282C19.9693 11.1948 19.8785 11.6226 19.5917 11.5687L19.537 11.5609C19.3209 11.5401 19.0758 11.5569 18.8514 11.64C18.4316 11.798 18.1699 12.1599 18.1366 12.8333C18.1281 12.9579 18.0239 13.0494 17.8993 13.0452C17.7746 13.0368 17.6791 12.9326 17.6874 12.8079C17.7206 12.0638 18.0118 11.5777 18.4774 11.3157L17.8495 11.1702C17.6312 11.1111 17.4483 11.0392 17.2958 10.9593C17.2229 11.0739 17.1317 11.1761 17.0184 11.2532L16.9686 11.2865C16.9398 11.3059 16.9097 11.3231 16.8798 11.3392C17.0817 11.7164 17.0289 12.1931 16.7186 12.5169L16.6727 12.5628C16.2819 12.9618 15.6463 12.9699 15.243 12.5833L14.9061 12.2474C15.1757 13.5745 16.3449 14.4669 17.7225 14.4925C17.7261 14.4923 17.7297 14.4915 17.7333 14.4915C19.9865 14.5123 20.9339 13.2483 21.1044 11.2113C21.1542 10.6297 21.0552 10.2763 20.8807 10.0892C20.835 10.0435 20.7885 10.0101 20.7469 9.99348L20.6971 9.97688L18.078 9.36555C18.0654 9.36142 18.0363 9.35721 17.995 9.34895ZM14.8368 9.92708C14.634 9.78396 14.352 9.80419 14.1786 9.98567L14.1366 10.0306C13.9204 10.2551 13.9664 10.6797 14.3114 11.0247L15.5585 12.2591C15.7787 12.4752 16.1323 12.4714 16.3485 12.2513L16.3905 12.2054C16.5936 11.9984 16.5993 11.6761 16.4169 11.4583C16.0898 11.4623 15.7671 11.3078 15.5673 11.0159L14.8368 9.92708ZM15.9286 8.63411C15.6418 8.21438 15.3636 8.06897 15.0311 8.26008L14.9852 8.29329C14.7276 8.47199 14.6941 8.89577 14.9598 9.30305L15.9413 10.763C16.1159 11.0205 16.4649 11.0867 16.7225 10.9124L16.7723 10.8831C16.8421 10.8375 16.8973 10.773 16.9384 10.7005C16.6947 10.4491 16.6334 10.1402 16.7001 9.78645L16.201 9.04133C16.1873 9.02624 16.1761 9.009 16.1669 8.99055L15.9286 8.63411ZM20.4725 3.80696C20.1235 3.71992 19.7664 3.93226 19.6708 4.28547L18.5526 8.11848C18.5194 8.23905 18.3939 8.30604 18.2733 8.27278C18.1786 8.24657 18.1179 8.16336 18.1122 8.07063L17.2294 4.30208C17.1961 4.14007 17.1008 3.99897 16.9637 3.90754C16.8266 3.8161 16.6561 3.78642 16.494 3.81965C16.203 3.88201 15.9868 4.27317 16.0741 4.62239L16.078 4.6468L16.5819 8.80208L16.9003 9.27571C17.0387 9.08329 17.237 8.96247 17.4755 8.90852C17.675 8.86695 17.8787 8.87136 18.0741 8.90462C18.132 8.9129 18.1735 8.92482 18.1903 8.92903L19.9276 9.33333L20.8925 4.52669C20.959 4.21073 20.7719 3.89842 20.4725 3.80696Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export function IconSpotifyColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M11.9633 0C5.35629 0 0 5.35614 0 11.9631C0 18.5704 5.35629 23.9261 11.9633 23.9261C18.571 23.9261 23.9267 18.5704 23.9267 11.9631C23.9267 5.35657 18.571 0.000571425 11.9631 0.000571425L11.9633 0ZM17.4496 17.2543C17.2353 17.6057 16.7753 17.7171 16.4239 17.5014C13.615 15.7857 10.079 15.3971 5.91471 16.3486C5.51343 16.44 5.11343 16.1886 5.022 15.7871C4.93014 15.3857 5.18057 14.9857 5.58286 14.8943C10.14 13.8527 14.049 14.3014 17.2024 16.2286C17.5539 16.4443 17.6653 16.9029 17.4496 17.2543ZM18.9139 13.9964C18.6439 14.4357 18.0696 14.5743 17.631 14.3043C14.4153 12.3273 9.51343 11.7549 5.70986 12.9094C5.21657 13.0584 4.69557 12.7804 4.54586 12.288C4.39729 11.7947 4.67543 11.2747 5.16786 11.1247C9.51257 9.80643 14.9139 10.445 18.6067 12.7143C19.0453 12.9843 19.1839 13.5584 18.9139 13.9964ZM19.0396 10.6044C15.1839 8.31429 8.82243 8.10371 5.14114 9.221C4.55 9.40029 3.92486 9.06657 3.74571 8.47543C3.56657 7.884 3.9 7.25929 4.49157 7.07957C8.71743 5.79671 15.7424 6.04457 20.1816 8.67986C20.7144 8.99543 20.8887 9.68214 20.573 10.2131C20.2587 10.7449 19.5701 10.9201 19.0401 10.6044H19.0396Z"
          fill="#1ED760"
        />
      </g>
    </svg>
  )
}

export function IconSpotifyColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M11.9633 0C5.35629 0 0 5.35614 0 11.9631C0 18.5704 5.35629 23.9261 11.9633 23.9261C18.571 23.9261 23.9267 18.5704 23.9267 11.9631C23.9267 5.35657 18.571 0.000571425 11.9631 0.000571425L11.9633 0ZM17.4496 17.2543C17.2353 17.6057 16.7753 17.7171 16.4239 17.5014C13.615 15.7857 10.079 15.3971 5.91471 16.3486C5.51343 16.44 5.11343 16.1886 5.022 15.7871C4.93014 15.3857 5.18057 14.9857 5.58286 14.8943C10.14 13.8527 14.049 14.3014 17.2024 16.2286C17.5539 16.4443 17.6653 16.9029 17.4496 17.2543ZM18.9139 13.9964C18.6439 14.4357 18.0696 14.5743 17.631 14.3043C14.4153 12.3273 9.51343 11.7549 5.70986 12.9094C5.21657 13.0584 4.69557 12.7804 4.54586 12.288C4.39729 11.7947 4.67543 11.2747 5.16786 11.1247C9.51257 9.80643 14.9139 10.445 18.6067 12.7143C19.0453 12.9843 19.1839 13.5584 18.9139 13.9964ZM19.0396 10.6044C15.1839 8.31429 8.82243 8.10371 5.14114 9.221C4.55 9.40029 3.92486 9.06657 3.74571 8.47543C3.56657 7.884 3.9 7.25929 4.49157 7.07957C8.71743 5.79671 15.7424 6.04457 20.1816 8.67986C20.7144 8.99543 20.8887 9.68214 20.573 10.2131C20.2587 10.7449 19.5701 10.9201 19.0401 10.6044H19.0396Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconStripe(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stripe">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Stripe_2"
          d="M22.5029 8.93997C23.7425 8.94006 24.9109 10.0569 24.918 12.106C24.918 14.3457 23.7639 15.3636 22.4961 15.3638C21.873 15.3638 21.4972 15.1022 21.2422 14.9185L21.2344 16.9175L19.4639 17.2925V9.05325H21.0225L21.1143 9.49173C21.3622 9.26562 21.8088 8.93997 22.5029 8.93997ZM7.39453 8.93997C7.98216 8.94001 8.56276 9.03218 9.15039 9.26517V10.9263C8.61221 10.6367 7.93274 10.4742 7.39453 10.4742C7.01925 10.4742 6.79216 10.5797 6.79199 10.855C6.79199 11.6464 9.4906 11.2723 9.49805 13.3775C9.49805 14.6423 8.48502 15.3706 7.01172 15.3706C6.40256 15.3706 5.73686 15.2499 5.07812 14.9673V13.2857C5.67312 13.6107 6.42381 13.8511 7.01172 13.8511C7.40829 13.8511 7.69132 13.7453 7.69141 13.4204C7.69141 12.5796 5 12.8902 5 10.94C5.00007 9.68937 5.95666 8.93997 7.39453 8.93997ZM11.5732 9.06009H12.9189V10.5659H11.5732V13.0738C11.5732 14.1195 12.6922 13.7945 12.9189 13.7027V15.1372C12.6852 15.2644 12.2604 15.3706 11.6797 15.3706C10.6313 15.3706 9.84473 14.6 9.84473 13.5542L9.85156 7.89505L11.5801 7.52689L11.5732 9.06009ZM27.9424 8.93997C29.621 8.93997 30.4999 10.3676 30.5 12.1763C30.5 12.3457 30.4854 12.7128 30.4854 12.8052H27.0225C27.1004 13.639 27.7094 13.8794 28.3965 13.8794C29.0976 13.8794 29.6502 13.731 30.1318 13.4908V14.9038C29.6502 15.1723 29.0126 15.3637 28.1699 15.3638C26.4416 15.3638 25.2373 14.2894 25.2373 12.1626C25.2373 10.368 26.2568 8.94025 27.9424 8.93997ZM15.1221 9.58353C15.54 8.82039 16.369 8.9753 16.5957 9.06009V10.6861C16.3761 10.6083 15.6679 10.5093 15.25 11.0533V15.2437H13.4785V9.06009H15.0088L15.1221 9.58353ZM18.8057 15.2437H17.0273V9.06009H18.8057V15.2437ZM22.0781 10.5093C21.6744 10.5093 21.4185 10.6501 21.2344 10.855L21.2422 13.4771C21.4122 13.6607 21.6604 13.8091 22.0781 13.8091C22.7295 13.8089 23.1688 13.1023 23.1689 12.1558C23.1689 11.2303 22.7225 10.5096 22.0781 10.5093ZM27.9355 10.3745C27.4894 10.3746 27.001 10.7071 27.001 11.5054H28.8281C28.8281 10.7069 28.3676 10.3745 27.9355 10.3745ZM18.8057 8.14212L17.0273 8.52396V7.08157L18.8057 6.70755V8.14212Z"
          fill="#6461FC"
        />
      </g>
    </svg>
  )
}

export function IconStudio(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Studio">
        <path
          id="Vector"
          d="M11.9989 22C11.6422 22 11.3294 21.7847 11.2015 21.4516L9.4386 16.8705C9.12795 16.0608 9.0315 15.8298 8.88684 15.6279C8.74666 15.4305 8.57396 15.2567 8.37209 15.112C8.17135 14.9707 7.94034 14.8732 7.12841 14.5603L2.54952 12.7985C2.22093 12.6729 2 12.351 2 12C2 11.649 2.21981 11.3294 2.54952 11.2026L7.12841 9.43972C7.92352 9.13469 8.16911 9.03263 8.37097 8.88797C8.57395 8.74554 8.74666 8.5706 8.88684 8.3721C9.02926 8.17024 9.13356 7.92688 9.4386 7.13065L11.2015 2.54839C11.3271 2.22092 11.6467 2 11.9989 2C12.351 2 12.6717 2.2198 12.7973 2.54839L14.5592 7.13065C14.872 7.94146 14.9696 8.17248 15.1109 8.3721C15.2533 8.57396 15.4283 8.74778 15.629 8.88797C15.8298 9.03039 16.0731 9.13469 16.8705 9.43972L21.4516 11.2026C21.7791 11.3282 22 11.6479 22 12C22 12.3521 21.7802 12.6729 21.4516 12.7985L16.8705 14.5603C16.0574 14.8732 15.8275 14.9707 15.629 15.112C15.4283 15.2533 15.2545 15.4283 15.1109 15.6268C14.9707 15.8264 14.872 16.0563 14.5592 16.8705L12.7973 21.4516C12.6717 21.7791 12.3521 22 11.9989 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTelegramColourColour(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Colour" clipPath="url(#clip0_634_5142)">
        <path
          id="Vector"
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.43189 11.8733C8.93014 10.3492 11.2628 9.3444 12.43 8.85893C15.7626 7.47282 16.455 7.23203 16.9064 7.22408C17.0056 7.22234 17.2276 7.24694 17.3714 7.3636C17.4928 7.46211 17.5262 7.59518 17.5422 7.68857C17.5581 7.78197 17.578 7.99473 17.5622 8.16097C17.3816 10.0585 16.6002 14.6631 16.2027 16.7884C16.0345 17.6876 15.7032 17.9891 15.3826 18.0186C14.6857 18.0828 14.1566 17.5581 13.4816 17.1157C12.4255 16.4233 11.8288 15.9924 10.8036 15.3168C9.61884 14.536 10.3869 14.1069 11.0621 13.4056C11.2388 13.2221 14.3092 10.4294 14.3686 10.176C14.376 10.1443 14.3829 10.0262 14.3128 9.96385C14.2426 9.90148 14.139 9.92281 14.0643 9.93977C13.9584 9.96381 12.2712 11.079 9.00264 13.2853C8.52373 13.6142 8.08994 13.7744 7.70129 13.766C7.27283 13.7568 6.44864 13.5238 5.83594 13.3246C5.08444 13.0803 4.48716 12.9512 4.53917 12.5363C4.56626 12.3202 4.86383 12.0992 5.43189 11.8733Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_634_5142"
          x1="12"
          y1="0"
          x2="12"
          y2="23.822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset="1" stopColor="#229ED9" />
        </linearGradient>
        <clipPath id="clip0_634_5142">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconTelegramColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_278)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.43 8.85893C11.2628 9.3444 8.93014 10.3492 5.43189 11.8733C4.86383 12.0992 4.56626 12.3202 4.53917 12.5363C4.49339 12.9015 4.95071 13.0453 5.57347 13.2411C5.65818 13.2678 5.74595 13.2954 5.83594 13.3246C6.44864 13.5238 7.27283 13.7568 7.70129 13.766C8.08994 13.7744 8.52373 13.6142 9.00264 13.2853C12.2712 11.079 13.9584 9.96381 14.0643 9.93977C14.139 9.92281 14.2426 9.90148 14.3128 9.96385C14.3829 10.0262 14.376 10.1443 14.3686 10.176C14.3233 10.3691 12.5281 12.0381 11.5991 12.9018C11.3095 13.171 11.1041 13.362 11.0621 13.4056C10.968 13.5033 10.8721 13.5958 10.78 13.6846C10.2108 14.2333 9.78391 14.6448 10.8036 15.3168C11.2936 15.6397 11.6858 15.9067 12.077 16.1731C12.5042 16.4641 12.9303 16.7543 13.4816 17.1157C13.6221 17.2077 13.7562 17.3034 13.8869 17.3965C14.3841 17.751 14.8307 18.0694 15.3826 18.0186C15.7032 17.9891 16.0345 17.6876 16.2027 16.7884C16.6002 14.6631 17.3816 10.0585 17.5622 8.16097C17.578 7.99473 17.5581 7.78197 17.5422 7.68857C17.5262 7.59518 17.4928 7.46211 17.3714 7.3636C17.2276 7.24694 17.0056 7.22234 16.9064 7.22408C16.455 7.23203 15.7626 7.47282 12.43 8.85893Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_278">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconTheGIMP(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="The_GIMP">
        <g id="layer1">
          <g id="Group">
            <path
              id="path4323"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.18738 6.23545C5.18738 6.23545 6.62282 9.19747 9.98738 9.11393C17.0355 8.93925 18.2659 5.2633 18.4481 4.73165C18.6304 4.2 18.8962 4.28355 18.957 4.76963C21.2583 25.6329 3.00763 16.6785 2.36206 13.1241C5.98485 12.0608 5.10383 10.0329 5.10383 10.0329L5.19497 6.23545H5.18738Z"
              fill="url(#paint0_radial_914_1204)"
            />
            <path
              id="Vector"
              d="M11.9317 18.357C10.0786 18.357 7.98235 17.8101 6.00766 16.7924C3.87349 15.6911 2.30893 14.2405 2.11146 13.1772L2.07349 12.957L2.28614 12.8962C3.59247 12.5165 4.4583 11.9468 4.79247 11.2557C5.08108 10.6557 4.87602 10.162 4.86842 10.1468L4.84564 10.1013V10.0481L4.95956 5.21772L5.40766 6.14431C5.46842 6.26583 6.82792 8.96203 9.97982 8.88608C12.8811 8.81013 15.1216 8.14177 16.633 6.88861C17.1646 6.4481 17.8634 5.71139 18.2051 4.67848C18.3722 4.18481 18.6229 4.13165 18.7596 4.14684C18.8735 4.15443 19.1317 4.23798 19.2001 4.76962C19.6786 9.14431 19.2988 12.5241 18.0608 14.8329C16.9975 16.8076 15.3494 17.9772 13.1545 18.2962C12.7596 18.357 12.357 18.3797 11.9317 18.3797V18.357ZM2.66589 13.2987C2.96209 14.0658 4.13931 15.2658 6.23551 16.3443C8.56716 17.5443 11.0659 18.0684 13.0785 17.7722C15.1064 17.476 16.633 16.3975 17.6127 14.5671C18.8051 12.3494 19.1697 9.06076 18.6988 4.79241C18.6988 4.77722 18.6988 4.76203 18.6988 4.75443C18.6988 4.76962 18.6836 4.78481 18.6836 4.8076C18.3039 5.94684 17.5292 6.7595 16.952 7.24557C15.357 8.57469 13.0102 9.28861 9.99501 9.36456C9.94944 9.36456 9.89627 9.36456 9.8507 9.36456C8.10387 9.36456 6.88108 8.56709 6.15956 7.88355C5.85576 7.59494 5.60513 7.30633 5.42285 7.0557L5.3545 9.98734C5.41526 10.1696 5.57475 10.762 5.25576 11.438C4.88361 12.2354 4.01779 12.8582 2.67349 13.2911L2.66589 13.2987Z"
              fill="#2E3436"
            />
          </g>
          <path
            id="path6480"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.86843 15.0304C11.2406 15.7063 12.957 15.076 13.9596 14.3013C13.6938 13.9595 13.2381 13.5798 13.2381 13.5798C13.2381 13.5798 14.4153 13.9063 14.8254 14.438C15.2355 14.9696 14.9773 15.2962 14.871 15.9797C14.6279 15.3797 14.1798 15.1595 14.1191 14.9165C13.2153 16.162 10.9672 16.1165 7.86084 15.0152L7.86843 15.0304Z"
            fill="url(#paint1_linear_914_1204)"
          />
          <path
            id="Vector_2"
            opacity="0.2"
            d="M11.9165 17.8101C11.8634 17.8101 11.8102 17.8101 11.7571 17.8101C9.85072 17.7798 7.6406 17.119 5.6811 15.9949C4.85326 15.5165 4.11655 14.9772 3.55452 14.4228C3.15199 14.0279 3.00769 13.7316 2.88617 13.4734L2.76465 13.2228L3.01528 13.1241C4.25326 12.638 5.11148 11.962 5.35452 11.2709C5.55199 10.7241 5.46845 10.3291 5.3849 10.0709L5.36971 10.0329L5.45326 7.13925L5.87098 7.59494C7.00262 8.82532 8.3925 9.42532 9.99503 9.38735C12.9874 9.3114 15.4026 8.58228 16.9824 7.27595C17.4988 6.84304 17.9317 6.34937 18.2735 5.79494L18.676 5.12659L18.7368 5.90127C19.0558 10.1089 18.5393 13.238 17.195 15.2051C16.0102 16.9367 14.233 17.8177 11.9241 17.8177L11.9165 17.8101ZM3.45579 13.4886C3.54693 13.6633 3.67604 13.838 3.91148 14.0734C4.43553 14.5899 5.15705 15.1215 5.93933 15.5696C7.82288 16.6481 9.94946 17.2861 11.7722 17.3165C13.9824 17.3544 15.6684 16.5494 16.7773 14.9241C17.9621 13.1924 18.4786 10.3443 18.2811 6.66076C17.9925 7.02532 17.6659 7.3595 17.3014 7.67089C15.6077 9.06836 13.1545 9.82026 10.0102 9.9038C8.45326 9.94178 7.07857 9.42532 5.92414 8.36962L5.87857 9.97975C5.94693 10.2 6.09123 10.7392 5.833 11.4608C5.55199 12.243 4.70895 12.9646 3.45579 13.5038V13.4886Z"
            fill="url(#paint2_linear_914_1204)"
          />
          <g id="Group_2">
            <path
              id="path4357"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.8558 10.7013C8.8558 11.8253 7.94441 12.7367 6.82036 12.7367C5.6963 12.7367 4.78491 11.8253 4.78491 10.7013C4.78491 9.57722 5.6963 8.66582 6.82036 8.66582C7.94441 8.66582 8.8558 9.57722 8.8558 10.7013Z"
              fill="url(#paint3_radial_914_1204)"
            />
            <path
              id="Vector_3"
              d="M6.82026 12.9798C5.5595 12.9798 4.53418 11.9544 4.53418 10.6937C4.53418 9.43292 5.5595 8.4076 6.82026 8.4076C8.08102 8.4076 9.10633 9.43292 9.10633 10.6937C9.10633 11.9544 8.08102 12.9798 6.82026 12.9798ZM6.82026 8.91646C5.84051 8.91646 5.03545 9.71393 5.03545 10.7013C5.03545 11.6886 5.83291 12.4861 6.82026 12.4861C7.8076 12.4861 8.60507 11.6886 8.60507 10.7013C8.60507 9.71393 7.8076 8.91646 6.82026 8.91646Z"
              fill="#888A85"
            />
          </g>
          <g id="Group_3">
            <path
              id="path5198"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.8076 11.4608C5.79494 12.8278 5.80253 14.4987 4.83798 15.1975C3.86582 15.8962 2.28608 15.357 1.29873 13.9899C0.311393 12.6228 0.303798 10.9519 1.26836 10.2532C2.24051 9.55443 3.82025 10.0937 4.8076 11.4608Z"
              fill="url(#paint4_radial_914_1204)"
            />
            <path
              id="Vector_4"
              d="M3.84304 15.7595C3.56963 15.7595 3.28102 15.7063 2.99241 15.6076C2.27849 15.3646 1.61013 14.8481 1.10127 14.1494L1.08608 14.1342C0.0303848 12.6608 0.0455746 10.8304 1.11646 10.0557C1.6557 9.66836 2.36203 9.59241 3.10633 9.85063C3.82026 10.0937 4.49621 10.6177 5.00507 11.3165C6.06836 12.7975 6.06076 14.6278 4.97469 15.4101C4.64811 15.6456 4.26076 15.7671 3.83545 15.7671L3.84304 15.7595ZM1.5038 13.8608C1.9519 14.476 2.53671 14.9316 3.1519 15.1443C3.74431 15.3418 4.29114 15.2962 4.68608 15.0076C5.54431 14.3924 5.50633 12.8734 4.60254 11.6203C4.15444 10.9975 3.56963 10.5418 2.95444 10.3291C2.36203 10.1316 1.81519 10.1772 1.42026 10.4658C0.56203 11.081 0.600005 12.6076 1.5038 13.8608Z"
              fill="black"
            />
          </g>
          <g id="Group_4">
            <path
              id="path4359"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.27859 10.9975C8.27859 11.5367 7.83808 11.9772 7.29884 11.9772C6.7596 11.9772 6.31909 11.5367 6.31909 10.9975C6.31909 10.4582 6.7596 10.0177 7.29884 10.0177C7.83808 10.0177 8.27859 10.4582 8.27859 10.9975Z"
              fill="#2E3436"
            />
            <path
              id="Vector_5"
              d="M7.29874 12.2278C6.62279 12.2278 6.06836 11.6734 6.06836 10.9975C6.06836 10.3215 6.62279 9.76709 7.29874 9.76709C7.97469 9.76709 8.52912 10.3215 8.52912 10.9975C8.52912 11.6734 7.97469 12.2278 7.29874 12.2278ZM7.29874 10.2684C6.89621 10.2684 6.56963 10.5949 6.56963 10.9975C6.56963 11.4 6.89621 11.7266 7.29874 11.7266C7.70127 11.7266 8.02785 11.4 8.02785 10.9975C8.02785 10.5949 7.70127 10.2684 7.29874 10.2684Z"
              fill="black"
            />
          </g>
          <path
            id="Vector_6"
            opacity="0.3"
            d="M3.7824 15.2279C3.59253 15.2279 3.37227 15.1975 3.12164 15.1139C2.49885 14.9165 1.89126 14.4608 1.44316 13.8684C1.00265 13.276 0.736829 12.562 0.714045 11.9089C0.69126 11.119 1.01025 10.7165 1.28366 10.5114C1.67101 10.2228 2.21025 10.1696 2.81025 10.3595C3.42544 10.557 4.03303 11.0051 4.48113 11.5975C4.92164 12.1899 5.18746 12.8962 5.19506 13.5418C5.21025 14.1722 5.00518 14.6734 4.61784 14.962C4.43556 15.0987 4.16215 15.2279 3.7748 15.2279H3.7824ZM1.59506 10.9063C1.33683 11.1038 1.20772 11.4304 1.22291 11.8937C1.2381 12.4481 1.46594 13.0557 1.85329 13.5646C2.23303 14.0734 2.75708 14.4684 3.28113 14.6354C3.72164 14.7798 4.07101 14.7494 4.32923 14.5519C4.57987 14.362 4.71658 14.0051 4.70139 13.5418C4.6862 12.9949 4.46594 12.3873 4.0862 11.8861C3.70645 11.3772 3.18999 10.9899 2.66594 10.8228C2.22544 10.6861 1.84569 10.7089 1.59506 10.8987V10.9063Z"
            fill="url(#paint5_linear_914_1204)"
          />
          <path
            id="path6446"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.91657 11.6279C2.91657 12.2127 2.52163 12.6911 2.03555 12.6911C1.54948 12.6911 1.15454 12.2127 1.15454 11.6279C1.15454 11.043 1.54948 10.5646 2.03555 10.5646C2.52163 10.5646 2.91657 11.043 2.91657 11.6279Z"
            fill="white"
          />
          <path
            id="path4361"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.60263 10.5494C7.60263 10.9215 7.29883 11.2253 6.92668 11.2253C6.55453 11.2253 6.25073 10.9215 6.25073 10.5494C6.25073 10.1772 6.55453 9.87342 6.92668 9.87342C7.29883 9.87342 7.60263 10.1772 7.60263 10.5494Z"
            fill="white"
          />
          <g id="Group_5">
            <path
              id="path6462"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.4051 10.9215C13.4051 12.243 12.3342 13.3063 11.0203 13.3063C9.70638 13.3063 8.6355 12.2354 8.6355 10.9215C8.6355 9.6076 9.70638 8.53671 11.0203 8.53671C12.3342 8.53671 13.4051 9.6076 13.4051 10.9215Z"
              fill="url(#paint6_radial_914_1204)"
            />
            <path
              id="Vector_7"
              d="M11.0202 13.557C9.56958 13.557 8.38477 12.3722 8.38477 10.9215C8.38477 9.47089 9.56958 8.28608 11.0202 8.28608C12.4708 8.28608 13.6557 9.47089 13.6557 10.9215C13.6557 12.3722 12.4708 13.557 11.0202 13.557ZM11.0202 8.77975C9.84299 8.77975 8.88603 9.73671 8.88603 10.9139C8.88603 12.0911 9.84299 13.0481 11.0202 13.0481C12.1974 13.0481 13.1544 12.0911 13.1544 10.9139C13.1544 9.73671 12.1974 8.77975 11.0202 8.77975Z"
              fill="#888A85"
            />
          </g>
          <g id="Group_6">
            <path
              id="path6464"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.7292 11.2709C12.7292 11.9089 12.2128 12.4177 11.5824 12.4177C10.952 12.4177 10.4355 11.9013 10.4355 11.2709C10.4355 10.6405 10.952 10.1241 11.5824 10.1241C12.2128 10.1241 12.7292 10.6405 12.7292 11.2709Z"
              fill="#2E3436"
            />
            <path
              id="Vector_8"
              d="M11.5823 12.6684C10.8076 12.6684 10.1848 12.038 10.1848 11.2709C10.1848 10.5038 10.8152 9.87342 11.5823 9.87342C12.3494 9.87342 12.9798 10.5038 12.9798 11.2709C12.9798 12.038 12.3494 12.6684 11.5823 12.6684ZM11.5823 10.3747C11.0886 10.3747 10.6861 10.7772 10.6861 11.2709C10.6861 11.7646 11.0886 12.1671 11.5823 12.1671C12.076 12.1671 12.4785 11.7646 12.4785 11.2709C12.4785 10.7772 12.076 10.3747 11.5823 10.3747Z"
              fill="black"
            />
          </g>
          <path
            id="path6466"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9316 10.7392C11.9316 11.1797 11.5746 11.5367 11.1341 11.5367C10.6936 11.5367 10.3367 11.1797 10.3367 10.7392C10.3367 10.2987 10.6936 9.94177 11.1341 9.94177C11.5746 9.94177 11.9316 10.2987 11.9316 10.7392Z"
            fill="white"
          />
          <g id="g8463">
            <g id="Group_7">
              <path
                id="path6937"
                d="M18.2962 18.0456L18.7595 17.1266C17.0355 15.8658 13.8608 14.9468 13.8608 14.9468C13.3139 14.6886 13.1393 15.1823 13.519 15.5089C13.519 15.5089 16.238 17.4532 18.2962 18.0532V18.0456Z"
                fill="url(#paint7_linear_914_1204)"
              />
              <path
                id="Vector_9"
                d="M18.4253 18.3418L18.2278 18.281C16.1468 17.681 13.481 15.7823 13.3747 15.7063L13.3595 15.6911C13.0785 15.4481 12.9873 15.0987 13.1468 14.8481C13.2683 14.6582 13.5417 14.5215 13.9519 14.7038C14.2405 14.7873 17.2253 15.676 18.9114 16.9139L19.0785 17.0354L18.4253 18.3342V18.3418ZM13.6709 15.3114C13.8303 15.4253 16.2531 17.1342 18.1671 17.7494L18.4405 17.2101C16.7392 16.0557 13.8228 15.1975 13.7924 15.1899L13.7544 15.1747C13.6481 15.1291 13.5873 15.1215 13.5645 15.1291C13.5645 15.1595 13.5797 15.2354 13.6709 15.3114Z"
                fill="#673907"
              />
            </g>
            <g id="Group_8">
              <path
                id="path6935"
                d="M20.5063 18.8962L20.757 18.3494L18.8354 17.119L18.6835 17.1038L18.6152 16.8911C18.3342 17.0658 17.9316 17.719 18.038 18.0835L18.243 18.0076L18.357 18.1139L20.5063 18.8962Z"
                fill="url(#paint8_linear_914_1204)"
              />
              <path
                id="Vector_10"
                d="M20.6353 19.2076L18.2125 18.3266L18.1746 18.2886L17.8632 18.4101L17.7872 18.1519C17.6353 17.6354 18.1366 16.8835 18.4708 16.6785L18.7442 16.5038L18.8581 16.8684H18.9037L21.0606 18.2582L20.6277 19.2152L20.6353 19.2076ZM18.486 17.8937L20.3695 18.5848L20.4303 18.4405L18.7442 17.3544L18.5087 17.3316C18.4252 17.4456 18.3493 17.5899 18.3037 17.7114L18.4784 17.8861L18.486 17.8937Z"
                fill="#888A85"
              />
            </g>
            <path
              id="Vector_11"
              d="M20.5367 18.6532C20.5063 18.6532 20.4683 18.6532 20.438 18.6304L19.162 18.0835C19.0329 18.0304 18.9797 17.8785 19.0329 17.757C19.0861 17.6279 19.2304 17.5747 19.3595 17.6279L20.6354 18.1747C20.7645 18.2279 20.8177 18.3798 20.7645 18.5013C20.7266 18.5924 20.6278 18.6532 20.5367 18.6532Z"
              fill="white"
            />
            <path
              id="path6933"
              d="M23.3013 21.2278C22.7013 19.1924 22.4887 17.5747 20.9241 17.719C19.6634 17.8329 19.5722 19.6481 20.8785 20.1418C22.1393 20.6203 23.3013 21.2278 23.3013 21.2278Z"
              fill="url(#paint9_radial_914_1204)"
            />
            <path
              id="path6971"
              opacity="0.5"
              d="M21.0151 17.8861C21.2962 17.8025 21.5848 17.962 21.6683 18.243C21.7519 18.5241 21.5924 18.8127 21.3114 18.8962C21.0303 18.9797 20.7417 18.8203 20.6582 18.5392C20.5746 18.2582 20.7341 17.9696 21.0151 17.8861Z"
              fill="white"
            />
            <path
              id="path6983"
              d="M18.7215 17.1342C18.9114 17.081 19.1089 17.1873 19.1621 17.3772C19.2152 17.5671 19.1089 17.7646 18.919 17.8177C18.7291 17.8709 18.5317 17.7646 18.4785 17.5747C18.4253 17.3848 18.5317 17.1873 18.7215 17.1342Z"
              fill="white"
            />
            <path
              id="path1571"
              opacity="0.4"
              d="M22.5418 20.0127C22.5418 20.0127 22.3443 19.2835 21.919 18.9038C21.7671 18.7671 21.957 18.5696 22.1013 18.7443C22.4127 19.1241 22.5418 20.0127 22.5418 20.0127Z"
              fill="url(#paint10_linear_914_1204)"
            />
          </g>
          <path
            id="path8532"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4988 15.8658C12.2507 15.9342 12.9266 15.7291 13.2076 15.6304C13.2532 15.3494 13.4735 14.8177 14.233 14.7873L13.9671 14.3241C13.9671 14.3241 12.9874 15 11.9317 15.1975L11.4988 15.8734V15.8658Z"
            fill="url(#paint11_linear_914_1204)"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_914_1204"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.28738 12.5506) scale(17.0613 12.3949)"
        >
          <stop stopColor="#857C63" />
          <stop offset="1" stopColor="#221F19" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_914_1204"
          x1="13.8624"
          y1="14.1251"
          x2="8.24818"
          y2="15.2279"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_914_1204"
          x1="10.0695"
          y1="8.54431"
          x2="19.1925"
          y2="18.9205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_914_1204"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.53706 8.94608) scale(2.95063)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#B9B9B0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_914_1204"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.66775 11.5943) rotate(-30) scale(2.2238 2.58835)"
        >
          <stop stopColor="#5B676B" />
          <stop offset="1" stopColor="#141718" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_914_1204"
          x1="1.42112"
          y1="11.3919"
          x2="2.99233"
          y2="13.6596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_914_1204"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.6355 10.0329) scale(3.4557)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#B9B9B0" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_914_1204"
          x1="15.9077"
          y1="16.8792"
          x2="14.8527"
          y2="19.1776"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E3D09" />
          <stop offset="0.2" stopColor="#EA8113" />
          <stop offset="0.6" stopColor="#5C3307" />
          <stop offset="1" stopColor="#E07C12" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_914_1204"
          x1="18.8837"
          y1="19.7103"
          x2="19.358"
          y2="18.7798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDBDBD" />
          <stop offset="0.3" stopColor="#E2E2E2" />
          <stop offset="0.7" stopColor="#A3A3A3" />
          <stop offset="1" stopColor="#DDDDDD" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_914_1204"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.4042 18.6656) rotate(-106.4) scale(2.4243 2.36658)"
        >
          <stop stopColor="#696969" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_914_1204"
          x1="21.3615"
          y1="19.3498"
          x2="21.9494"
          y2="20.4278"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_914_1204"
          x1="12.5256"
          y1="14.5094"
          x2="11.6233"
          y2="14.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function IconThreadsColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M17.6921 11.1235C17.5887 11.074 17.4837 11.0263 17.3774 10.9806C17.1921 7.56728 15.327 5.61312 12.1952 5.59312C12.181 5.59304 12.1669 5.59304 12.1528 5.59304C10.2795 5.59304 8.72164 6.39261 7.76275 7.84759L9.48512 9.0291C10.2014 7.94229 11.3257 7.7106 12.1536 7.7106C12.1631 7.7106 12.1727 7.7106 12.1822 7.71069C13.2134 7.71726 13.9915 8.01708 14.4951 8.60175C14.8616 9.02741 15.1067 9.61563 15.2281 10.358C14.3139 10.2026 13.3251 10.1548 12.2681 10.2154C9.29059 10.3869 7.37639 12.1235 7.50495 14.5365C7.57019 15.7605 8.17996 16.8135 9.22188 17.5014C10.1028 18.0829 11.2374 18.3673 12.4165 18.3029C13.9738 18.2175 15.1954 17.6234 16.0476 16.537C16.6949 15.712 17.1042 14.6429 17.285 13.2957C18.0271 13.7436 18.5771 14.333 18.8809 15.0415C19.3974 16.2459 19.4275 18.225 17.8126 19.8385C16.3978 21.252 14.697 21.8635 12.1267 21.8824C9.27552 21.8612 7.11922 20.9469 5.71726 19.1646C4.40444 17.4958 3.72596 15.0852 3.70065 12C3.72596 8.91473 4.40444 6.5042 5.71726 4.83534C7.11922 3.05311 9.27549 2.13875 12.1266 2.11756C14.9985 2.13891 17.1924 3.05767 18.648 4.8485C19.3618 5.7267 19.8999 6.8311 20.2546 8.11879L22.273 7.58028C21.843 5.99528 21.1664 4.62946 20.2456 3.49675C18.3795 1.20084 15.6503 0.0243935 12.1337 0H12.1196C8.6102 0.0243088 5.91151 1.20522 4.09854 3.50991C2.48524 5.5608 1.65305 8.41446 1.62509 11.9916L1.625 12L1.62509 12.0084C1.65305 15.5855 2.48524 18.4393 4.09854 20.4901C5.91151 22.7948 8.6102 23.9757 12.1196 24H12.1337C15.2538 23.9784 17.453 23.1615 19.2647 21.3514C21.6351 18.9832 21.5637 16.0149 20.7825 14.1926C20.222 12.8859 19.1534 11.8245 17.6921 11.1235ZM12.3051 16.1884C11.0001 16.2619 9.6443 15.6761 9.57745 14.4215C9.5279 13.4913 10.2395 12.4532 12.3851 12.3296C12.6309 12.3154 12.872 12.3085 13.1089 12.3085C13.8883 12.3085 14.6174 12.3842 15.2802 12.5291C15.033 15.6169 13.5828 16.1182 12.3051 16.1884Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export function IconThreadsColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M17.6921 11.1235C17.5887 11.074 17.4837 11.0263 17.3774 10.9806C17.1921 7.56728 15.327 5.61312 12.1952 5.59312C12.181 5.59304 12.1669 5.59304 12.1528 5.59304C10.2795 5.59304 8.72164 6.39261 7.76275 7.84759L9.48512 9.0291C10.2014 7.94229 11.3257 7.7106 12.1536 7.7106C12.1631 7.7106 12.1727 7.7106 12.1822 7.71069C13.2134 7.71726 13.9915 8.01708 14.4951 8.60175C14.8616 9.02741 15.1067 9.61563 15.2281 10.358C14.3139 10.2026 13.3251 10.1548 12.2681 10.2154C9.29059 10.3869 7.37639 12.1235 7.50495 14.5365C7.57019 15.7605 8.17996 16.8135 9.22188 17.5014C10.1028 18.0829 11.2374 18.3673 12.4165 18.3029C13.9738 18.2175 15.1954 17.6234 16.0476 16.537C16.6949 15.712 17.1042 14.6429 17.285 13.2957C18.0271 13.7436 18.5771 14.333 18.8809 15.0415C19.3974 16.2459 19.4275 18.225 17.8126 19.8385C16.3978 21.252 14.697 21.8635 12.1267 21.8824C9.27552 21.8612 7.11922 20.9469 5.71726 19.1646C4.40444 17.4958 3.72596 15.0852 3.70065 12C3.72596 8.91473 4.40444 6.5042 5.71726 4.83534C7.11922 3.05311 9.27549 2.13875 12.1266 2.11756C14.9985 2.13891 17.1924 3.05767 18.648 4.8485C19.3618 5.7267 19.8999 6.8311 20.2546 8.11879L22.273 7.58028C21.843 5.99528 21.1664 4.62946 20.2456 3.49675C18.3795 1.20084 15.6503 0.0243935 12.1337 0H12.1196C8.6102 0.0243088 5.91151 1.20522 4.09854 3.50991C2.48524 5.5608 1.65305 8.41446 1.62509 11.9916L1.625 12L1.62509 12.0084C1.65305 15.5855 2.48524 18.4393 4.09854 20.4901C5.91151 22.7948 8.6102 23.9757 12.1196 24H12.1337C15.2538 23.9784 17.453 23.1615 19.2647 21.3514C21.6351 18.9832 21.5637 16.0149 20.7825 14.1926C20.222 12.8859 19.1534 11.8245 17.6921 11.1235ZM12.3051 16.1884C11.0001 16.2619 9.6443 15.6761 9.57745 14.4215C9.5279 13.4913 10.2395 12.4532 12.3851 12.3296C12.6309 12.3154 12.872 12.3085 13.1089 12.3085C13.8883 12.3085 14.6174 12.3842 15.2802 12.5291C15.033 15.6169 13.5828 16.1182 12.3051 16.1884Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTikTokColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M17.1765 8.66348C18.7198 9.77066 20.6105 10.4221 22.6525 10.4221V6.47863C22.2661 6.47871 21.8806 6.43827 21.5025 6.35788V9.46195C19.4606 9.46195 17.5702 8.81051 16.0265 7.70342V15.7509C16.0265 19.7766 12.7745 23.0399 8.76333 23.0399C7.26666 23.0399 5.87556 22.5858 4.71997 21.8071C6.03888 23.1604 7.87821 24 9.91309 24C13.9245 24 17.1766 20.7367 17.1766 16.7108V8.66348H17.1765ZM18.5951 4.68501C17.8064 3.82024 17.2885 2.70269 17.1765 1.46719V0.959976H16.0867C16.361 2.5303 17.2966 3.87189 18.5951 4.68501ZM7.25706 18.7178C6.81638 18.138 6.57824 17.4286 6.57931 16.6993C6.57931 14.858 8.06672 13.3651 9.90177 13.3651C10.2438 13.3651 10.5837 13.4176 10.9096 13.5214V9.48979C10.5287 9.4374 10.1443 9.41516 9.7601 9.42332V12.5613C9.43394 12.4575 9.09384 12.4048 8.75177 12.4052C6.91671 12.4052 5.42938 13.8979 5.42938 15.7394C5.42938 17.0414 6.17284 18.1687 7.25706 18.7178Z"
          fill="#FF004F"
        />
        <path
          id="Vector_2"
          d="M16.0265 7.70334C17.5702 8.81043 19.4607 9.46186 21.5025 9.46186V6.35779C20.3628 6.11415 19.3538 5.51642 18.5951 4.68501C17.2966 3.8718 16.361 2.53021 16.0867 0.959976H13.2241V16.7106C13.2176 18.5468 11.7327 20.0336 9.90162 20.0336C8.82257 20.0336 7.86394 19.5174 7.25682 18.7178C6.17269 18.1687 5.42923 17.0413 5.42923 15.7394C5.42923 13.8981 6.91655 12.4052 8.75161 12.4052C9.1032 12.4052 9.44208 12.4602 9.75995 12.5614V9.4234C5.81921 9.50511 2.6499 12.7365 2.6499 16.7107C2.6499 18.6946 3.43913 20.4931 4.72006 21.8071C5.87565 22.5858 7.26675 23.04 8.76342 23.04C12.7747 23.04 16.0265 19.7766 16.0265 15.7509V7.70334H16.0265Z"
          fill="black"
        />
        <path
          id="Vector_3"
          d="M21.5025 6.3578V5.51848C20.4748 5.52005 19.4672 5.23119 18.5952 4.68493C19.3671 5.53306 20.3835 6.11787 21.5025 6.3578ZM16.0867 0.959983C16.0605 0.809911 16.0404 0.658851 16.0265 0.507214V0H12.074V15.7508C12.0677 17.5868 10.5829 19.0736 8.75164 19.0736C8.214 19.0736 7.70638 18.9455 7.25685 18.7179C7.86397 19.5174 8.82259 20.0336 9.90164 20.0336C11.7326 20.0336 13.2177 18.5469 13.2241 16.7107V0.959983H16.0867ZM9.76014 9.42341V8.52989C9.42988 8.48459 9.09691 8.46186 8.76353 8.46202C4.75192 8.46194 1.5 11.7254 1.5 15.7508C1.5 18.2745 2.77806 20.4987 4.72017 21.807C3.43924 20.493 2.65001 18.6944 2.65001 16.7106C2.65001 12.7365 5.81924 9.50511 9.76014 9.42341Z"
          fill="#00F2EA"
        />
      </g>
    </svg>
  )
}

export function IconTikTokColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTumblrColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M14.6 24C11 24 8.3 22.15 8.3 17.7V10.6H5V6.75C8.6 5.8 10.1 2.7 10.3 0H14.05V6.1H18.4V10.6H14.05V16.8C14.05 18.65 15 19.3 16.5 19.3H18.6V24H14.6Z"
          fill="#001935"
        />
      </g>
    </svg>
  )
}

export function IconTumblrColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M14.6 24C11 24 8.3 22.15 8.3 17.7V10.6H5V6.75C8.6 5.8 10.1 2.7 10.3 0H14.05V6.1H18.4V10.6H14.05V16.8C14.05 18.65 15 19.3 16.5 19.3H18.6V24H14.6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconTwitchColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M20.5722 11.1429L17.1436 14.5714H13.7151L10.7151 17.5714V14.5714H6.85791V1.71428H20.5722V11.1429Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M6.0008 0L1.71509 4.28571V19.7143H6.85794V24L11.1437 19.7143H14.5722L22.2865 12V0H6.0008ZM20.5722 11.1429L17.1437 14.5714H13.7151L10.7151 17.5714V14.5714H6.85794V1.71429H20.5722V11.1429Z"
          fill="#9146FF"
        />
        <path id="Vector_3" d="M18.0007 4.71428H16.2864V9.85714H18.0007V4.71428Z" fill="#9146FF" />
        <path id="Vector_4" d="M13.2863 4.71429H11.572V9.85715H13.2863V4.71429Z" fill="#9146FF" />
      </g>
    </svg>
  )
}

export function IconTwitchColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M6.00068 0L1.71497 4.28571V19.7143H6.85782V24L11.1435 19.7143H14.5721L22.2864 12V0H6.00068ZM20.5721 11.1429L17.1435 14.5714H13.715L10.715 17.5714V14.5714H6.85782V1.71429H20.5721V11.1429Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M18.0007 4.71428H16.2864V9.85714H18.0007V4.71428Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M13.2864 4.71429H11.5721V9.85715H13.2864V4.71429Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconUnionPay(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="UnionPay">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="UnionPay_2">
          <path
            id="Vector"
            d="M10.8277 5.00154H16.3435C17.1135 5.00154 17.5924 5.62912 17.4127 6.40163L14.8448 17.427C14.6635 18.1968 13.8926 18.8249 13.1221 18.8249H7.6069C6.83802 18.8249 6.35806 18.1968 6.53768 17.427L9.10674 6.40163C9.28636 5.62912 10.0568 5.00154 10.8277 5.00154Z"
            fill="#E21836"
          />
          <path
            id="Vector_2"
            d="M15.8842 5H22.2272C22.997 5 22.6499 5.62758 22.4688 6.40009L19.9012 17.4255C19.7211 18.1953 19.7773 18.8234 19.0058 18.8234H12.6628C11.8914 18.8234 11.414 18.1953 11.5952 17.4255L14.1627 6.40009C14.345 5.62758 15.1139 5 15.8842 5Z"
            fill="#00447C"
          />
          <path
            id="Vector_3"
            d="M21.9758 5H27.4915C28.2626 5 28.7415 5.62758 28.5604 6.40009L25.9928 17.4255C25.8115 18.1953 25.0401 18.8234 24.2692 18.8234H18.756C17.9846 18.8234 17.5061 18.1953 17.6868 17.4255L20.2548 6.40009C20.4344 5.62758 21.2043 5 21.9758 5Z"
            fill="#007B84"
          />
          <path
            id="Vector_4"
            d="M12.268 8.53332C11.7008 8.5391 11.5332 8.53332 11.4797 8.52068C11.4592 8.61842 11.0764 10.3841 11.0753 10.3855C10.9929 10.7428 10.933 10.9974 10.7293 11.1618C10.6137 11.2574 10.4787 11.3035 10.3222 11.3035C10.0706 11.3035 9.92411 11.1786 9.8995 10.9417L9.8948 10.8604C9.8948 10.8604 9.97143 10.3819 9.97143 10.3792C9.97143 10.3792 10.3731 8.77021 10.4451 8.55752C10.4488 8.54542 10.4499 8.5391 10.4509 8.53332C9.66893 8.54018 9.53032 8.53332 9.52078 8.52068C9.51554 8.53803 9.49618 8.63778 9.49618 8.63778L9.08599 10.4513L9.05077 10.6051L8.9826 11.1082C8.9826 11.2574 9.01191 11.3792 9.07026 11.4822C9.25714 11.8087 9.7902 11.8577 10.0918 11.8577C10.4803 11.8577 10.8448 11.7751 11.0911 11.6244C11.5186 11.3718 11.6305 10.977 11.7302 10.6261L11.7765 10.446C11.7765 10.446 12.1903 8.77492 12.2606 8.55752C12.2633 8.54542 12.2643 8.5391 12.268 8.53332ZM13.676 9.88143C13.5762 9.88143 13.3939 9.90563 13.2301 9.98589C13.1707 10.0164 13.1145 10.0516 13.0552 10.0867L13.1087 9.89353L13.0794 9.861C12.7322 9.93131 12.6545 9.94072 12.3337 9.98589L12.3068 10.0038C12.2696 10.3126 12.2365 10.5448 12.0984 11.1518C12.0458 11.3755 11.9913 11.6014 11.9365 11.8245L11.9513 11.8529C12.28 11.8356 12.3798 11.8356 12.6655 11.8403L12.6886 11.8151C12.7249 11.6292 12.7296 11.5856 12.81 11.2091C12.8478 11.0305 12.9266 10.6382 12.9654 10.4985C13.0368 10.4654 13.1073 10.4329 13.1745 10.4329C13.3346 10.4329 13.3151 10.5726 13.3089 10.6283C13.3021 10.7217 13.2437 11.0269 13.1839 11.2889L13.144 11.458C13.1161 11.5829 13.0856 11.7043 13.0578 11.8282L13.0699 11.8529C13.3939 11.8356 13.4927 11.8356 13.7694 11.8403L13.8019 11.8151C13.8519 11.5247 13.8666 11.447 13.9553 11.0242L14 10.8299C14.0867 10.4497 14.1302 10.2569 14.0646 10.0999C13.9953 9.92392 13.8288 9.88143 13.676 9.88143ZM15.2488 10.2795C15.0766 10.3126 14.9668 10.3346 14.8576 10.3489C14.7494 10.3662 14.6438 10.3819 14.4774 10.4051L14.4642 10.417L14.4521 10.4266C14.4348 10.5505 14.4227 10.6577 14.3997 10.7837C14.3802 10.9139 14.3502 11.062 14.3014 11.2746C14.2636 11.4375 14.2441 11.4942 14.2226 11.5515C14.2017 11.6087 14.1785 11.6644 14.136 11.8245L14.146 11.8393L14.1543 11.8529C14.3099 11.8455 14.4117 11.8402 14.5162 11.8393C14.6207 11.8355 14.7289 11.8393 14.8965 11.8402L14.9111 11.8283L14.9268 11.8151C14.951 11.6707 14.9547 11.6319 14.9695 11.5614C14.9841 11.4859 15.0094 11.3813 15.0714 11.1019C15.1007 10.9707 15.1333 10.8399 15.1637 10.706C15.1953 10.5726 15.2284 10.4412 15.2599 10.31L15.2551 10.2942L15.2488 10.2795ZM15.2525 9.74278C15.096 9.65042 14.8213 9.67973 14.6365 9.80731C14.4522 9.93234 14.4312 10.1098 14.5871 10.2034C14.7409 10.2932 15.0167 10.2664 15.1999 10.1378C15.3838 10.0101 15.4068 9.8342 15.2525 9.74278ZM16.1989 11.8818C16.5155 11.8818 16.8401 11.7946 17.0843 11.5356C17.2723 11.3256 17.3585 11.0132 17.3883 10.8845C17.4855 10.4581 17.4098 10.259 17.3148 10.1377C17.1704 9.95285 16.9152 9.89356 16.6505 9.89356C16.4913 9.89356 16.1122 9.90929 15.816 10.1823C15.6033 10.3793 15.505 10.6466 15.4458 10.9028C15.3859 11.1639 15.3171 11.6339 15.7493 11.8088C15.8827 11.8661 16.0749 11.8818 16.1989 11.8818ZM16.1742 10.9223C16.2472 10.5994 16.3333 10.3283 16.5533 10.3283C16.7257 10.3283 16.7382 10.53 16.6615 10.854C16.6478 10.9259 16.5849 11.1933 16.4998 11.3072C16.4404 11.3912 16.3701 11.4422 16.2923 11.4422C16.2692 11.4422 16.1317 11.4422 16.1295 11.238C16.1285 11.1372 16.149 11.0342 16.1742 10.9223ZM18.1798 11.8403L18.2045 11.8152C18.2396 11.6292 18.2454 11.5855 18.3231 11.2091C18.362 11.0306 18.4423 10.6382 18.4801 10.4986C18.5517 10.4654 18.6209 10.4328 18.6903 10.4328C18.8493 10.4328 18.8299 10.5725 18.8236 10.6282C18.8178 10.7217 18.7595 11.0268 18.6986 11.2888L18.6608 11.4579C18.6319 11.583 18.6005 11.7042 18.5726 11.8282L18.5847 11.8529C18.9098 11.8356 19.0049 11.8356 19.2832 11.8403L19.3168 11.8152C19.3656 11.5246 19.3787 11.4469 19.4702 11.0242L19.5137 10.8298C19.6008 10.4496 19.6449 10.257 19.5804 10.0999C19.509 9.92396 19.3415 9.88147 19.1908 9.88147C19.0909 9.88147 18.9077 9.90554 18.7448 9.98593C18.6866 10.0165 18.6283 10.0515 18.571 10.0868L18.6209 9.89357L18.5941 9.8609C18.247 9.93135 18.1677 9.94076 17.8473 9.98593L17.8227 10.0038C17.7838 10.3126 17.7523 10.5447 17.6142 11.1518C17.5616 11.3755 17.507 11.6014 17.4524 11.8246L17.4671 11.8529C17.7964 11.8356 17.8946 11.8356 18.1798 11.8403ZM20.5682 11.8529C20.5887 11.7531 20.7101 11.1618 20.7111 11.1618C20.7111 11.1618 20.8145 10.728 20.8208 10.7123C20.8208 10.7123 20.8534 10.6671 20.8859 10.6492H20.9338C21.3854 10.6492 21.8953 10.6492 22.295 10.3552C22.567 10.1535 22.7529 9.85573 22.8359 9.49381C22.8574 9.40507 22.8732 9.29954 22.8732 9.194C22.8732 9.05539 22.8454 8.91826 22.765 8.81111C22.5612 8.52595 22.1553 8.52071 21.6868 8.51856C21.6853 8.51856 21.4558 8.52071 21.4558 8.52071C20.8561 8.52811 20.6155 8.52595 20.5167 8.51385C20.5084 8.55755 20.4927 8.63526 20.4927 8.63526C20.4927 8.63526 20.2778 9.63094 20.2778 9.63255C20.2778 9.63255 19.7637 11.7495 19.7395 11.8492C20.2632 11.8429 20.4779 11.8429 20.5682 11.8529ZM20.9663 10.0841C20.9663 10.0841 21.1947 9.09048 21.1937 9.09424L21.201 9.04329L21.2043 9.00444L21.2956 9.01385C21.2956 9.01385 21.7666 9.05431 21.7777 9.05539C21.9636 9.12732 22.0402 9.31271 21.9867 9.55471C21.9379 9.77587 21.7945 9.9618 21.6102 10.0516C21.4584 10.1277 21.2724 10.134 21.0809 10.134H20.9569L20.9663 10.0841ZM22.3885 10.9407C22.3281 11.198 22.2588 11.6681 22.6888 11.8356C22.826 11.8939 22.9489 11.9113 23.0737 11.9049C23.2056 11.8978 23.3278 11.8317 23.441 11.7365C23.4308 11.7756 23.4206 11.8147 23.4104 11.854L23.4299 11.8791C23.7392 11.8661 23.8352 11.8661 24.1704 11.8686L24.2008 11.8455C24.2497 11.5578 24.2958 11.2784 24.423 10.728C24.485 10.4644 24.5468 10.2033 24.6104 9.94073L24.6005 9.91183C24.2544 9.97596 24.1619 9.98967 23.829 10.0369L23.8038 10.0574C23.8004 10.0842 23.7969 10.1099 23.7937 10.1355C23.7419 10.0519 23.6669 9.98053 23.5512 9.93603C23.4031 9.87781 23.0555 9.95283 22.7566 10.2249C22.5466 10.4192 22.4458 10.6854 22.3885 10.9407ZM23.1153 10.9564C23.1894 10.6393 23.2745 10.371 23.495 10.371C23.6344 10.371 23.7078 10.4996 23.6929 10.719C23.681 10.7737 23.6683 10.8314 23.6531 10.8966C23.631 10.9909 23.6071 11.0843 23.5838 11.1779C23.5602 11.2419 23.5326 11.3022 23.5024 11.3424C23.4456 11.4228 23.3106 11.4727 23.2329 11.4727C23.2109 11.4727 23.0748 11.4727 23.0701 11.2721C23.069 11.1722 23.0896 11.0694 23.1153 10.9564ZM26.9107 9.90926L26.8839 9.87874C26.5415 9.94811 26.4795 9.95914 26.1649 10.0016L26.1418 10.0247C26.1407 10.0285 26.1398 10.0343 26.1382 10.0395L26.1371 10.0343C25.9029 10.5746 25.9097 10.4581 25.7191 10.8834C25.718 10.8641 25.718 10.852 25.717 10.8314L25.6692 9.90926L25.6392 9.87874C25.2806 9.94811 25.2721 9.95914 24.9408 10.0016L24.915 10.0247C24.9114 10.0358 24.9114 10.0479 24.9092 10.061L24.9114 10.0658C24.9528 10.2774 24.9428 10.2302 24.9844 10.5641C25.0037 10.728 25.0296 10.8928 25.0489 11.0547C25.0816 11.3256 25.0999 11.459 25.1398 11.8724C24.9161 12.2416 24.8631 12.3813 24.6477 12.7053L24.6492 12.7085L24.4976 12.9483C24.4802 12.9736 24.4645 12.991 24.4424 12.9983C24.4182 13.0103 24.3868 13.0125 24.3431 13.0125H24.2591L24.1342 13.4279L24.5626 13.4353C24.8142 13.4342 24.9723 13.3166 25.0574 13.1585L25.3268 12.6968H25.3225L25.3509 12.6643C25.5321 12.2741 26.9107 9.90926 26.9107 9.90926ZM22.3885 15.3653H22.2067L22.8795 13.1401H23.1026L23.1735 12.9109L23.1803 13.1658C23.172 13.3234 23.296 13.463 23.6216 13.4399H23.9982L24.1278 13.0115H23.9861C23.9046 13.0115 23.8668 12.9909 23.8715 12.9468L23.8647 12.6874H23.1673V12.6888C22.9418 12.6935 22.2686 12.7104 22.1322 12.7467C21.9673 12.7892 21.7934 12.9143 21.7934 12.9143L21.8617 12.6848H21.2094L21.0735 13.1401L20.3917 15.3993H20.2594L20.1297 15.8247H21.429L21.3854 15.9665H22.0256L22.0681 15.8247H22.2477L22.3885 15.3653ZM21.8554 13.5922C21.751 13.6212 21.5566 13.7088 21.5566 13.7088L21.7294 13.1401H22.2477L22.1227 13.5545C22.1227 13.5545 21.9626 13.5639 21.8554 13.5922ZM21.8654 14.4047C21.8654 14.4047 21.7026 14.4251 21.5954 14.4493C21.4899 14.4813 21.292 14.5821 21.292 14.5821L21.4705 13.9903H21.9915L21.8654 14.4047ZM21.575 15.3705H21.0551L21.2058 14.8711H21.7241L21.575 15.3705ZM22.827 13.9903H23.5764L23.4687 14.3391H22.7093L22.5953 14.7204H23.2597L22.7567 15.4287C22.7214 15.4808 22.6898 15.4992 22.6548 15.5138C22.6195 15.5317 22.5733 15.5527 22.5198 15.5527H22.3355L22.2088 15.9703H22.6909C22.9415 15.9703 23.0895 15.8563 23.1988 15.7066L23.5438 15.2345L23.6179 15.7139C23.6336 15.8037 23.6982 15.8563 23.7419 15.8767C23.7901 15.9009 23.84 15.9424 23.9105 15.9486C23.986 15.9518 24.0406 15.9544 24.0769 15.9544H24.3138L24.456 15.4871H24.3626C24.3089 15.4871 24.2166 15.4781 24.2008 15.4613C24.1851 15.4408 24.1851 15.4094 24.1766 15.3615L24.1015 14.881H23.7938L23.9287 14.7204H24.6866L24.8032 14.3391H24.1015L24.2108 13.9903H24.9103L25.04 13.5603H22.9546L22.827 13.9903ZM16.4977 15.4676L16.6726 14.8858H17.3914L17.5228 14.453H16.8033L16.9131 14.0948H17.6162L17.7465 13.6758H15.9872L15.8596 14.0948H16.2593L16.1527 14.453H15.7519L15.6191 14.8932H16.0186L15.7855 15.663C15.7541 15.7649 15.8003 15.8037 15.8296 15.8511C15.8596 15.8972 15.89 15.9277 15.9583 15.945C16.0287 15.9608 16.077 15.9702 16.1426 15.9702H16.953L17.0974 15.4908L16.7382 15.5401C16.6688 15.5401 16.4767 15.5318 16.4977 15.4676ZM16.5801 12.6821L16.3979 13.0114C16.359 13.0833 16.3239 13.128 16.2923 13.1485C16.2644 13.1659 16.2093 13.1731 16.1295 13.1731H16.0344L15.9074 13.5943H16.223C16.3748 13.5943 16.4914 13.5387 16.547 13.5108C16.6069 13.4788 16.6226 13.4971 16.6688 13.4525L16.7755 13.3601H17.7612L17.892 12.9216H17.1705L17.2964 12.6821H16.5801ZM18.0354 15.4761C18.0186 15.4519 18.0307 15.4093 18.0564 15.3205L18.3258 14.4288H19.2842C19.4239 14.4268 19.5247 14.4251 19.5903 14.4204C19.6608 14.413 19.7374 14.3879 19.8209 14.3427C19.9071 14.2954 19.9512 14.2455 19.9884 14.1883C20.03 14.1311 20.0967 14.0061 20.1539 13.8133L20.4926 12.6848L19.498 12.6906C19.498 12.6906 19.1917 12.7357 19.0569 12.7856C18.9208 12.8413 18.7264 12.9967 18.7264 12.9967L18.8162 12.6873H18.2018L17.3417 15.5401C17.3111 15.6509 17.2907 15.7313 17.286 15.7795C17.2844 15.8316 17.3516 15.883 17.3952 15.9219C17.4467 15.9607 17.5227 15.9544 17.5958 15.9607C17.6725 15.9665 17.7817 15.9702 17.9324 15.9702H18.4046L18.5495 15.4808L18.1268 15.5207C18.0816 15.5207 18.049 15.4965 18.0354 15.4761ZM18.4996 13.8265H19.5063L19.4423 14.0271C19.4333 14.0318 19.4118 14.0171 19.3094 14.0292H18.4376L18.4996 13.8265ZM18.7013 13.1537H19.7164L19.6434 13.3953C19.6434 13.3953 19.165 13.3906 19.0883 13.4047C18.7512 13.4631 18.5542 13.6432 18.5542 13.6432L18.7013 13.1537ZM19.4649 14.6988C19.4565 14.7288 19.4433 14.747 19.4249 14.7608C19.4045 14.7739 19.3714 14.7786 19.3221 14.7786H19.1786L19.1871 14.5344H18.5904L18.5662 15.7286C18.5653 15.8148 18.5736 15.8647 18.6367 15.9046C18.6997 15.9545 18.894 15.9608 19.1555 15.9608H19.5294L19.6644 15.5138L19.3389 15.5316L19.2307 15.538C19.2159 15.5316 19.2017 15.5259 19.186 15.5101C19.1723 15.4966 19.1492 15.5049 19.1529 15.4187L19.1555 15.1126L19.4969 15.0985C19.6812 15.0985 19.76 15.0385 19.8272 14.9814C19.8913 14.9267 19.9123 14.8637 19.9365 14.7786L19.9937 14.5076H19.5247L19.4649 14.6988Z"
            fill="#FEFEFE"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVKColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5171)">
        <path
          id="Vector"
          d="M0 11.52C0 6.0894 0 3.37413 1.68707 1.68707C3.37413 0 6.0894 0 11.52 0H12.48C17.9106 0 20.6259 0 22.313 1.68707C24 3.37413 24 6.0894 24 11.52V12.48C24 17.9106 24 20.6259 22.313 22.313C20.6259 24 17.9106 24 12.48 24H11.52C6.0894 24 3.37413 24 1.68707 22.313C0 20.6259 0 17.9106 0 12.48V11.52Z"
          fill="#0077FF"
        />
        <path
          id="Vector_2"
          d="M12.77 17.29C7.3 17.29 4.18005 13.54 4.05005 7.30005H6.79005C6.88005 11.88 8.9 13.82 10.5 14.22V7.30005H13.0801V11.25C14.6601 11.08 16.3199 9.28005 16.8799 7.30005H19.4599C19.0299 9.74005 17.2299 11.54 15.9499 12.28C17.2299 12.88 19.28 14.45 20.06 17.29H17.2199C16.6099 15.39 15.0901 13.92 13.0801 13.72V17.29H12.77Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5171">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconVKColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One" clipPath="url(#clip0_633_287)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.68707 1.68707C0 3.37413 0 6.0894 0 11.52V12.48C0 17.9106 0 20.6259 1.68707 22.313C3.37413 24 6.0894 24 11.52 24H12.48C17.9106 24 20.6259 24 22.313 22.313C24 20.6259 24 17.9106 24 12.48V11.52C24 6.0894 24 3.37413 22.313 1.68707C20.6259 0 17.9106 0 12.48 0H11.52C6.0894 0 3.37413 0 1.68707 1.68707ZM4.05006 7.30005C4.18006 13.54 7.30005 17.2901 12.7701 17.2901H13.0801V13.72C15.0901 13.92 16.61 15.3901 17.22 17.2901H20.06C19.28 14.4501 17.2299 12.8801 15.95 12.2801C17.2299 11.5401 19.0299 9.74005 19.4599 7.30005H16.8799C16.3199 9.28005 14.6601 11.08 13.0801 11.25V7.30005H10.5V14.22C8.9 13.8201 6.88005 11.88 6.79005 7.30005H4.05006Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_287">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconVenmo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Venmo">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="#3D95CE" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Venmo_2"
          d="M23.275 8.46C23.275 11.524 20.718 15.505 18.642 18.3H13.902L12 6.67L16.151 6.268L17.156 14.543C18.096 12.977 19.255 10.518 19.255 8.841C19.255 7.923 19.101 7.298 18.861 6.783L22.641 6C23.078 6.738 23.275 7.499 23.275 8.46Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export function IconVerifone(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Verifone">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Verifone_2">
          <path
            id="Verifone_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9894 10.6083H16.1286L16.3117 9.67052H15.1723L14.9894 10.6083ZM14.8712 11.2115H16.0107L15.2868 14.9142C15.234 14.933 15.0709 14.9988 14.8457 14.9988C14.5417 14.9988 14.2629 14.8784 14.2629 14.4516C14.2629 14.3714 14.272 14.2799 14.2923 14.1761C14.5187 13.0206 14.8712 11.2115 14.8712 11.2115ZM26.1847 11.1269C25.4264 11.1269 25.1249 11.5782 24.9834 11.8529H24.97L25.0137 11.2123H23.8878C23.8804 11.3532 23.8317 11.7972 23.7595 12.1802C23.7595 12.1802 23.4994 13.5242 23.4503 13.7816C23.4128 13.9781 23.3442 14.2687 23.3442 14.4374C23.3442 14.7965 23.5235 14.9989 23.9235 14.9989C24.1479 14.9989 24.3096 14.9366 24.3685 14.9143L24.745 12.9859C24.8495 12.4535 25.2285 12.105 25.6791 12.105C26.0427 12.105 26.2166 12.3744 26.2166 12.5947C26.2166 12.7864 26.1692 12.9989 26.1326 13.1868L25.9706 14.0126C25.9513 14.1117 25.9101 14.3021 25.9101 14.4515C25.9101 14.8165 26.1127 14.9989 26.4975 14.9989C26.7076 14.9989 26.8407 14.9456 26.9351 14.9143L27.273 13.1856C27.3462 12.7949 27.3733 12.5892 27.3733 12.3405C27.3733 11.6246 26.9613 11.1269 26.1847 11.1269ZM21.1237 12.0222C20.4868 12.0222 20.1341 12.6838 20.1341 13.2735C20.1341 13.7708 20.3552 14.1039 20.8577 14.1039C21.4258 14.1039 21.8704 13.6127 21.8704 12.7743C21.8704 12.3907 21.6695 12.0222 21.1237 12.0222ZM20.7878 14.999C19.5679 14.999 18.9842 14.2557 18.9842 13.3081C18.9842 12.008 19.8627 11.1269 21.2204 11.1269C22.3984 11.1269 23.024 11.8517 23.024 12.7824C23.024 14.1771 22.0856 14.999 20.7878 14.999ZM16.5213 14.1075C16.4954 14.2407 16.479 14.3341 16.479 14.4488C16.479 14.8733 16.7582 14.9989 17.0541 14.9989C17.2907 14.9989 17.4371 14.9332 17.4907 14.9142L18.0385 12.1075L18.9244 12.1074L19.0992 11.2115L18.2135 11.2116L18.2565 10.9909C18.3367 10.5771 18.5284 10.3952 18.8599 10.3952C19.0813 10.3952 19.2604 10.4352 19.3226 10.4516L19.4894 9.5997C19.4183 9.58146 19.091 9.5 18.6065 9.5C17.8345 9.5 17.3287 9.97645 17.1791 10.7438L17.0875 11.2115H16.5108L16.3358 12.1074H16.9129C16.9129 12.1074 16.6853 13.2679 16.5213 14.1075ZM13.8985 11.127C13.3266 11.127 13.0121 11.5305 12.8891 11.8523H12.876L12.92 11.2115H11.7935C11.7836 11.4336 11.7378 11.8092 11.6231 12.3997C11.5068 12.9981 11.3934 13.595 11.2765 14.176C11.2564 14.2753 11.2475 14.3724 11.2475 14.4547C11.2475 14.7589 11.3954 14.9986 11.8327 14.9986C12.0493 14.9986 12.1997 14.9415 12.2719 14.9142L12.607 13.1977C12.7277 12.5409 12.947 12.1067 13.5832 12.1067C13.8726 12.1067 14.1475 12.1695 14.2051 12.1866L14.3979 11.199C14.3563 11.1844 14.1893 11.127 13.8985 11.127ZM30.4242 12.7122C30.4852 12.3728 30.2908 12.0222 29.8516 12.0222C29.3152 12.0222 29.0796 12.3946 28.9745 12.7122H30.4242ZM30.9326 14.0901C30.9326 14.6051 30.4418 15 29.5728 15C28.3718 15 27.7845 14.2398 27.7845 13.3091C27.7845 12.3853 28.388 11.1279 29.8611 11.1279C30.8323 11.1279 31.5585 11.6182 31.5585 12.7407C31.5585 13.0167 31.498 13.3168 31.472 13.437H28.8904C28.886 13.7064 29.1094 14.1731 30.0068 14.1731C30.4067 14.1731 30.8596 14.0295 30.9326 13.993C30.9326 14.021 30.9326 14.0716 30.9326 14.0901ZM9.83787 12.7122C9.89875 12.3728 9.7044 12.0222 9.26516 12.0222C8.7288 12.0222 8.49331 12.3946 8.38803 12.7122H9.83787ZM10.3463 14.0901C10.3463 14.6051 9.85555 15 8.98667 15C7.78555 15 7.19836 14.2398 7.19836 13.3091C7.19836 12.3853 7.80175 11.1279 9.27489 11.1279C10.2461 11.1279 10.9723 11.6182 10.9723 12.7407C10.9723 13.0167 10.9118 13.3168 10.8857 13.437H8.30418C8.29986 13.7064 8.52317 14.1731 9.42053 14.1731C9.82046 14.1731 10.2733 14.0295 10.3463 13.993C10.3463 14.021 10.3463 14.0716 10.3463 14.0901ZM3.5 9.95157H4.64618V13.6332C4.64618 14.1868 4.91733 14.4694 5.35264 14.4694C5.39703 14.4694 5.42321 14.4636 5.43184 14.4615C5.24103 14.7549 4.99366 14.9956 4.42565 14.9956C3.82466 14.9956 3.5 14.5716 3.5 13.9354V9.95157Z"
            fill="#1A1919"
          />
          <path
            id="V"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.11946 13.0085C5.01884 13.1682 4.96545 13.353 4.96545 13.5417V13.6393C4.96545 14.0125 5.16383 14.1463 5.38043 14.1463C5.60183 14.1463 5.72034 13.9937 5.82907 13.8203C6.01124 13.5299 8.23744 9.95157 8.23744 9.95157H7.0461L5.11946 13.0085Z"
            fill="#00A3DA"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconVisa(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Visa">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="visa-logo"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6253 16.2582H8.50494L6.91495 10.1924C6.83949 9.91334 6.67925 9.66667 6.44354 9.5504C5.85531 9.25823 5.20712 9.0257 4.5 8.90843V8.6749H7.91567C8.38708 8.6749 8.74064 9.0257 8.79957 9.43313L9.62454 13.8086L11.7438 8.6749H13.8052L10.6253 16.2582ZM14.9838 16.2582H12.9813L14.6302 8.6749H16.6327L14.9838 16.2582ZM19.2234 10.7757C19.2823 10.3673 19.6359 10.1337 20.0483 10.1337C20.6965 10.0751 21.4026 10.1924 21.9919 10.4835L22.3454 8.85081C21.7562 8.61727 21.108 8.5 20.5198 8.5C18.5762 8.5 17.162 9.55041 17.162 11.0082C17.162 12.1173 18.1637 12.6996 18.8708 13.0504C19.6359 13.4002 19.9305 13.6338 19.8716 13.9835C19.8716 14.5082 19.2823 14.7418 18.6941 14.7418C17.9869 14.7418 17.2798 14.5669 16.6327 14.2747L16.2791 15.9085C16.9862 16.1996 17.7512 16.3169 18.4584 16.3169C20.6376 16.3745 21.9919 15.3251 21.9919 13.75C21.9919 11.7665 19.2234 11.6502 19.2234 10.7757ZM29 16.2582L27.41 8.6749H25.7022C25.3486 8.6749 24.9951 8.90843 24.8772 9.25823L21.9329 16.2582H23.9943L24.4058 15.1502H26.9386L27.1743 16.2582H29ZM25.9968 10.7171L26.585 13.5751H24.9361L25.9968 10.7171Z"
          fill="#172B85"
        />
      </g>
    </svg>
  )
}

export function IconWeChat(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="WeChat">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="WeChat_2"
          d="M15.637 13.8559C15.567 13.892 15.4883 13.9129 15.4045 13.9129C15.2107 13.9129 15.0423 13.8038 14.9539 13.6423L14.92 13.5664L13.5091 10.3968C13.4938 10.3623 13.4844 10.3233 13.4844 10.2854C13.4844 10.1393 13.6001 10.021 13.7428 10.021C13.8007 10.021 13.8543 10.0406 13.8974 10.0734L15.5624 11.287C15.684 11.3684 15.8293 11.4162 15.9855 11.4162C16.0788 11.4162 16.1677 11.3984 16.2506 11.3675L24.0804 7.80001C22.6769 6.10671 20.3655 5 17.7499 5C13.4696 5 10 7.96007 10 11.6118C10 13.6038 11.0439 15.3971 12.6778 16.6093C12.8088 16.7051 12.8947 16.8625 12.8947 17.0401C12.8947 17.0989 12.8824 17.1525 12.8674 17.2085C12.7369 17.7068 12.528 18.5049 12.5183 18.5423C12.502 18.6048 12.4766 18.6702 12.4766 18.7356C12.4766 18.8817 12.5922 19 12.7351 19C12.7911 19 12.8369 18.9786 12.8842 18.9508L14.5809 17.9479C14.7085 17.8727 14.8436 17.8258 14.9925 17.8258C15.0717 17.8258 15.1482 17.8384 15.2202 17.8609C16.0117 18.094 16.8656 18.2235 17.7499 18.2235C22.0299 18.2235 25.5 15.2633 25.5 11.6118C25.5 10.5057 25.1798 9.46407 24.6171 8.54777L15.6938 13.8223L15.637 13.8559Z"
          fill="#1AAD19"
        />
      </g>
    </svg>
  )
}

export function IconWebmoney(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Webmoney">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <g id="Webmoney_2">
          <path
            id="Webmoney-watermark"
            d="M28.8145 17.9275H28.8457L29.4414 16.0564H30L29.0547 18.5984C28.7935 19.3001 28.4743 19.6658 27.874 19.6658V19.2498C28.2292 19.2498 28.4487 18.9745 28.5742 18.5984L27.5713 16.0564H28.1455L28.8145 17.9275ZM11.0938 15.9705C11.7464 15.9705 12.1494 16.3823 12.1494 17.2107V17.3992H10.4463C10.4464 18.0088 10.7025 18.2781 11.2402 18.2781C11.5221 18.2781 11.7832 18.182 12.0703 18.0145V18.4002C11.8354 18.5324 11.5224 18.6345 11.1465 18.6346C10.2693 18.6346 9.90828 18.1057 9.9082 17.3025C9.9082 16.5301 10.3107 15.9707 11.0938 15.9705ZM13.167 16.159C13.3236 16.0776 13.5901 15.9706 13.8721 15.9705C14.5196 15.9705 14.8701 16.4079 14.8701 17.2215C14.8701 18.1718 14.3999 18.6346 13.6426 18.6346C13.3657 18.6346 12.9374 18.5484 12.624 18.3855V14.8367L13.167 14.7098V16.159ZM20.8027 15.9705C21.4922 15.9705 21.9941 16.4129 21.9941 17.3025C21.994 18.1718 21.5182 18.6346 20.8027 18.6346C20.0873 18.6345 19.6124 18.1717 19.6123 17.3025C19.6123 16.4129 20.1135 15.9706 20.8027 15.9705ZM26.3545 15.9705C27.0074 15.9705 27.4091 16.3823 27.4092 17.2107V17.3992H25.707C25.7071 18.0089 25.9632 18.2781 26.501 18.2781C26.7829 18.2781 27.0442 18.1822 27.3311 18.0145V18.4002C27.0962 18.5325 26.7825 18.6346 26.4062 18.6346C25.5293 18.6345 25.169 18.1056 25.1689 17.3025C25.1689 16.5299 25.5712 15.9705 26.3545 15.9705ZM6.66992 17.658H6.70605L7.38574 14.9686H7.85059L8.57617 17.658H8.6123L9.14551 14.9686H9.75684L8.91016 18.573H8.34668L7.63574 16.0369H7.59961L6.91016 18.573H6.3457L5.5 14.9686H6.08496L6.66992 17.658ZM17.2461 17.8103H17.2725L18.3896 14.9686H19.0371V18.573H18.4736V15.9607H18.4268L17.3613 18.573H17.0273L15.9609 16.0213H15.9141V18.573H15.4443V14.9686H16.0762L17.2461 17.8103ZM23.8213 15.9705C24.4483 15.9705 24.6826 16.2097 24.6826 16.7332V18.573H24.1396V16.8504C24.1396 16.4488 23.9362 16.3768 23.6699 16.3768C23.461 16.3768 23.195 16.4691 23.0332 16.5603V18.573H22.4893V16.3465C22.7242 16.2092 23.221 15.9705 23.8213 15.9705ZM13.7314 16.367C13.5224 16.367 13.371 16.4231 13.1621 16.535V18.1971C13.3291 18.2683 13.512 18.2781 13.6426 18.2781C14.029 18.2781 14.3212 18.0446 14.3213 17.2215C14.3213 16.5757 14.0813 16.367 13.7314 16.367ZM20.8027 16.326C20.4581 16.326 20.1602 16.6164 20.1602 17.3025C20.1602 17.999 20.4322 18.2781 20.8027 18.2781C21.1735 18.2781 21.4452 17.9991 21.4453 17.3025C21.4453 16.6163 21.1578 16.326 20.8027 16.326ZM11.0781 16.3113C10.7596 16.3115 10.5143 16.5504 10.457 17.0584H11.6533C11.6275 16.5245 11.3601 16.3113 11.0781 16.3113ZM26.3389 16.3113C26.0202 16.3113 25.7753 16.5501 25.7178 17.0584H26.9131C26.8871 16.5246 26.6208 16.3114 26.3389 16.3113Z"
            fill="#0068A3"
          />
          <path
            id="Webmoney-logo"
            d="M17.3997 4.31329C18.1184 4.31329 18.7993 4.4762 19.4055 4.76544C19.5006 4.80936 19.5955 4.85761 19.6907 4.91095L19.2698 5.27814L18.636 4.64142L17.5676 5.56915L16.9329 4.89435L14.9426 6.64142L16.219 8.00958L15.717 8.43927L16.9739 9.81036L16.4758 10.2381L18.2717 12.1844L19.3381 11.2293L20.26 12.2527C20.0767 12.3915 19.8765 12.5218 19.6565 12.6424C18.99 13.0124 18.2194 13.2244 17.3997 13.2244C14.8787 13.2243 12.8227 11.2229 12.8225 8.76935C12.8225 6.31514 14.8786 4.31339 17.3997 4.31329ZM21.5042 11.1258L20.6877 11.8406L19.9524 11.0467L20.7688 10.3309L21.5042 11.1258ZM19.4084 10.4236L18.3196 11.3777L17.3401 10.3182L18.428 9.36407L19.4084 10.4236ZM20.7864 9.5213L19.97 10.2361L19.2346 9.44122L20.051 8.72638L20.7864 9.5213ZM18.634 8.59259L17.5461 9.54669L16.5657 8.48712L17.6545 7.53302L18.634 8.59259ZM22.012 8.99493L21.467 9.4715L20.9778 8.9422L21.5217 8.46466L22.012 8.99493ZM20.0881 7.84161L19.2717 8.55646L18.5364 7.76251L19.3528 7.04669L20.0881 7.84161ZM21.3157 7.42072L20.7717 7.89728L20.2815 7.36798L20.8254 6.89142L21.3157 7.42072ZM17.8547 6.784L16.7668 7.73712L15.7864 6.67755L16.8752 5.72443L17.8547 6.784ZM19.3352 6.24396L18.5188 6.95978L17.7844 6.16486L18.6008 5.44904L19.3352 6.24396ZM20.6204 5.8465L20.0764 6.32404L19.5862 5.79376L20.1301 5.3172L20.6204 5.8465Z"
            fill="#0068A3"
          />
        </g>
      </g>
    </svg>
  )
}

export function IconWhatsAppColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M0 24L1.687 17.837C0.645998 16.033 0.0989998 13.988 0.0999998 11.891C0.103 5.335 5.43799 0 11.993 0C15.174 0.001 18.16 1.24 20.406 3.488C22.6509 5.736 23.8869 8.724 23.8859 11.902C23.8829 18.459 18.548 23.794 11.993 23.794C10.003 23.793 8.04198 23.294 6.30499 22.346L0 24ZM6.59698 20.193C8.27298 21.188 9.87298 21.784 11.989 21.785C17.437 21.785 21.875 17.351 21.878 11.9C21.88 6.438 17.463 2.01 11.997 2.008C6.54498 2.008 2.11 6.442 2.108 11.892C2.107 14.117 2.75899 15.783 3.85399 17.526L2.85499 21.174L6.59698 20.193ZM17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382C17.117 14.233 15.656 13.514 15.383 13.415C15.111 13.316 14.913 13.266 14.714 13.564C14.516 13.861 13.946 14.531 13.773 14.729C13.6 14.927 13.426 14.952 13.129 14.803C12.832 14.654 11.874 14.341 10.739 13.328C9.85598 12.54 9.25898 11.567 9.08598 11.269C8.91298 10.972 9.06798 10.811 9.21598 10.663C9.34998 10.53 9.51298 10.316 9.66198 10.142C9.81298 9.97 9.86198 9.846 9.96198 9.647C10.061 9.449 10.012 9.275 9.93698 9.126C9.86198 8.978 9.26798 7.515 9.02098 6.92C8.77898 6.341 8.53398 6.419 8.35198 6.41L7.78198 6.4C7.58398 6.4 7.26198 6.474 6.98998 6.772C6.71798 7.07 5.94999 7.788 5.94999 9.251C5.94999 10.714 7.01498 12.127 7.16298 12.325C7.31198 12.523 9.25798 15.525 12.239 16.812C12.948 17.118 13.502 17.301 13.933 17.438C14.645 17.664 15.293 17.632 15.805 17.556C16.376 17.471 17.563 16.837 17.811 16.143C18.059 15.448 18.059 14.853 17.984 14.729Z"
          fill="#25D366"
        />
      </g>
    </svg>
  )
}

export function IconWhatsAppColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M0 24L1.687 17.837C0.645998 16.033 0.0989998 13.988 0.0999998 11.891C0.103 5.335 5.43799 0 11.993 0C15.174 0.001 18.16 1.24 20.406 3.488C22.6509 5.736 23.8869 8.724 23.8859 11.902C23.8829 18.459 18.548 23.794 11.993 23.794C10.003 23.793 8.04198 23.294 6.30499 22.346L0 24ZM6.59698 20.193C8.27298 21.188 9.87298 21.784 11.989 21.785C17.437 21.785 21.875 17.351 21.878 11.9C21.88 6.438 17.463 2.01 11.997 2.008C6.54498 2.008 2.11 6.442 2.108 11.892C2.107 14.117 2.75899 15.783 3.85399 17.526L2.85499 21.174L6.59698 20.193ZM17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382C17.117 14.233 15.656 13.514 15.383 13.415C15.111 13.316 14.913 13.266 14.714 13.564C14.516 13.861 13.946 14.531 13.773 14.729C13.6 14.927 13.426 14.952 13.129 14.803C12.832 14.654 11.874 14.341 10.739 13.328C9.85598 12.54 9.25898 11.567 9.08598 11.269C8.91298 10.972 9.06798 10.811 9.21598 10.663C9.34998 10.53 9.51298 10.316 9.66198 10.142C9.81298 9.97 9.86198 9.846 9.96198 9.647C10.061 9.449 10.012 9.275 9.93698 9.126C9.86198 8.978 9.26798 7.515 9.02098 6.92C8.77898 6.341 8.53398 6.419 8.35198 6.41L7.78198 6.4C7.58398 6.4 7.26198 6.474 6.98998 6.772C6.71798 7.07 5.94999 7.788 5.94999 9.251C5.94999 10.714 7.01498 12.127 7.16298 12.325C7.31198 12.523 9.25798 15.525 12.239 16.812C12.948 17.118 13.502 17.301 13.933 17.438C14.645 17.664 15.293 17.632 15.805 17.556C16.376 17.471 17.563 16.837 17.811 16.143C18.059 15.448 18.059 14.853 17.984 14.729Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconXColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full">
        <path
          id="Vector"
          d="M18.3263 1.90391H21.6998L14.3297 10.3274L23 21.7899H16.2112L10.894 14.8379L4.80995 21.7899H1.43443L9.31743 12.78L1 1.90391H7.96111L12.7674 8.25824L18.3263 1.90391ZM17.1423 19.7707H19.0116L6.94539 3.81704H4.93946L17.1423 19.7707Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export function IconXColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M18.3263 1.90391H21.6998L14.3297 10.3274L23 21.7899H16.2112L10.894 14.8379L4.80995 21.7899H1.43443L9.31743 12.78L1 1.90391H7.96111L12.7674 8.25824L18.3263 1.90391ZM17.1423 19.7707H19.0116L6.94539 3.81704H4.93946L17.1423 19.7707Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconYandex(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Yandex">
        <g id="BASE">
          <rect width="35" height="24" rx="4" fill="white" />
          <rect
            x="0.5"
            y="0.5"
            width="34"
            height="23"
            rx="3.5"
            stroke="#131315"
            strokeOpacity="0.12"
          />
        </g>
        <path
          id="Yandex_2"
          d="M24.5001 10.7791C24.4279 10.3461 24.031 10.0574 23.4897 10.0574C23.3093 10.0574 23.1649 10.0574 22.9845 10.0574C22.6597 10.0213 22.5876 10.1296 22.5876 10.3822C22.5876 11.6451 22.5876 12.872 22.5876 14.135C22.5876 14.7845 21.938 15.4701 21.1803 15.6145C18.7987 16.1557 16.4171 16.6609 14.0355 17.2022C13.7829 17.2744 13.4942 17.2744 13.2055 17.2744C13.0973 17.2744 12.9169 17.2022 12.8808 17.0939C12.8447 17.0218 12.9529 16.8774 13.0251 16.8053C13.1334 16.7331 13.2777 16.6609 13.4221 16.5888C13.8551 16.4444 14.3242 16.3001 14.7572 16.1557C16.5253 15.5784 18.2935 15.001 20.0616 14.3876C20.8555 14.135 21.2885 13.5937 21.2885 12.9081C21.3246 10.743 21.2885 8.54186 21.2885 6.37678C21.2885 6.01593 21.1081 5.72725 20.7112 5.58291C20.2421 5.40249 19.809 5.54683 19.4121 5.72725C16.8862 6.91805 14.3963 8.10885 11.8704 9.29964C11.1487 9.66049 10.7157 10.1657 10.7157 10.8874C10.7157 12.9442 10.7157 15.001 10.7157 17.0579C10.7157 17.1661 10.7157 17.2744 10.7518 17.3465C11.0044 18.0321 11.6539 18.4652 12.5199 18.4652C14.2881 18.4652 16.0562 18.4652 17.8244 18.4652C19.5925 18.4652 21.3246 18.4652 23.0928 18.4652C23.4897 18.4652 23.8144 18.393 24.1031 18.1404C24.464 17.8517 24.464 17.4548 24.464 17.0939C24.464 15.3187 24.5001 10.7791 24.5001 10.7791ZM17.1388 10.1296C17.3192 9.66049 17.7161 9.37181 18.2935 9.29964C18.6904 9.26356 19.0152 9.48006 19.0873 9.84091C19.1595 10.3822 18.51 11.0317 17.8244 11.0317C17.2831 11.0317 16.9583 10.6348 17.1388 10.1296Z"
          fill="#FD6727"
        />
      </g>
    </svg>
  )
}

export function IconYoutubeColourFull(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=Full" clipPath="url(#clip0_634_5016)">
        <path
          id="Vector"
          d="M23.5221 6.18546C23.3864 5.67487 23.119 5.20888 22.7466 4.83411C22.3743 4.45935 21.91 4.18896 21.4003 4.05C19.5239 3.54546 12.0239 3.54546 12.0239 3.54546C12.0239 3.54546 4.52393 3.54546 2.64756 4.05C2.13786 4.18896 1.67358 4.45935 1.30121 4.83411C0.928842 5.20888 0.661431 5.67487 0.525744 6.18546C0.0239258 8.07 0.0239258 12 0.0239258 12C0.0239258 12 0.0239258 15.93 0.525744 17.8145C0.661431 18.3251 0.928842 18.7911 1.30121 19.1659C1.67358 19.5407 2.13786 19.811 2.64756 19.95C4.52393 20.4545 12.0239 20.4545 12.0239 20.4545C12.0239 20.4545 19.5239 20.4545 21.4003 19.95C21.91 19.811 22.3743 19.5407 22.7466 19.1659C23.119 18.7911 23.3864 18.3251 23.5221 17.8145C24.0239 15.93 24.0239 12 24.0239 12C24.0239 12 24.0239 8.07 23.5221 6.18546Z"
          fill="#FF0302"
        />
        <path
          id="Vector_2"
          d="M9.56934 15.5687V8.4314L15.8421 12L9.56934 15.5687Z"
          fill="#FEFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_634_5016">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconYoutubeColourOne(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Colour=One">
        <path
          id="Vector"
          d="M23.7609 7.20005C23.7609 7.20005 23.5266 5.54536 22.8047 4.8188C21.8906 3.86255 20.8688 3.85786 20.4 3.80161C17.0438 3.55786 12.0047 3.55786 12.0047 3.55786H11.9953C11.9953 3.55786 6.95625 3.55786 3.6 3.80161C3.13125 3.85786 2.10938 3.86255 1.19531 4.8188C0.473438 5.54536 0.24375 7.20005 0.24375 7.20005C0.24375 7.20005 0 9.14536 0 11.086V12.9047C0 14.8454 0.239062 16.7907 0.239062 16.7907C0.239062 16.7907 0.473437 18.4454 1.19062 19.1719C2.10469 20.1282 3.30469 20.0954 3.83906 20.1985C5.76094 20.3813 12 20.4375 12 20.4375C12 20.4375 17.0438 20.4282 20.4 20.1891C20.8688 20.1329 21.8906 20.1282 22.8047 19.1719C23.5266 18.4454 23.7609 16.7907 23.7609 16.7907C23.7609 16.7907 24 14.85 24 12.9047V11.086C24 9.14536 23.7609 7.20005 23.7609 7.20005ZM9.52031 15.1125V8.36724L16.0031 11.7516L9.52031 15.1125Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function IconGrokLogo(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 106 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#grok-logo-clip)">
        <path
          d="M92.2363 29.9489V10.2012H95.3507V23.234L101.937 15.6497H105.713L99.7877 22.1494L105.768 29.9489H102.048L97.2036 23.2472L95.3507 23.234V29.9489H92.2363Z"
          fill="currentColor"
        />
        <path
          d="M82.7922 30.2806C78.1622 30.2806 75.6543 26.9893 75.6543 22.7853C75.6543 18.5537 78.1622 15.29 82.7922 15.29C87.4499 15.29 89.9302 18.5537 89.9302 22.7853C89.9302 26.9893 87.4499 30.2806 82.7922 30.2806ZM78.9064 22.7853C78.9064 26.0489 80.6701 27.6807 82.7922 27.6807C84.942 27.6807 86.6782 26.0489 86.6782 22.7853C86.6782 19.5217 84.942 17.8622 82.7922 17.8622C80.6701 17.8622 78.9064 19.5217 78.9064 22.7853Z"
          fill="currentColor"
        />
        <path
          d="M66.9863 29.9486V17.9174L69.6045 15.6494H75.1716V18.3046H70.1007V29.9486H66.9863Z"
          fill="currentColor"
        />
        <path
          d="M55.0785 30.3141C49.1427 30.3141 45.6035 25.9938 45.6035 20.1027C45.6035 14.1562 49.2691 9.73096 55.1944 9.73096C59.8244 9.73096 63.2143 12.1095 64.0135 16.5348H60.4583C59.9347 14.0179 57.8401 12.6074 55.1944 12.6074C50.9226 12.6074 49.0485 16.3136 49.0485 20.1027C49.0485 23.8917 50.9226 27.5703 55.1944 27.5703C59.2732 27.5703 61.0646 24.6109 61.2024 22.1493H55.0566V19.2856H64.3443L64.3291 20.7828C64.3291 26.3467 62.067 30.3141 55.0785 30.3141Z"
          fill="currentColor"
        />
        <path
          d="M15.799 25.5038L29.1996 15.5764C29.8566 15.0897 30.7955 15.2795 31.1086 16.0355C32.7561 20.0223 32.0201 24.8135 28.7421 28.103C25.4642 31.3925 20.9034 32.114 16.7347 30.4709L12.1807 32.5869C18.7124 37.0673 26.644 35.9593 31.6004 30.9818C35.5319 27.0364 36.7495 21.6584 35.611 16.8087L35.6213 16.819C33.9702 9.69455 36.0272 6.84682 40.2407 1.02362C40.3403 0.885553 40.4401 0.747481 40.5398 0.605957L34.9952 6.17026V6.153L15.7957 25.5073"
          fill="currentColor"
        />
        <path
          d="M13.0336 27.9169C8.34539 23.4226 9.15369 16.4672 13.1539 12.4563C16.1119 9.48772 20.9583 8.27615 25.1889 10.0573L29.7326 7.95168C28.9141 7.35797 27.8649 6.71939 26.6611 6.27065C21.2197 4.02353 14.7051 5.14191 10.2819 9.57747C6.02712 13.8473 4.68913 20.4127 6.98676 26.015C8.7031 30.202 5.88953 33.1636 3.05533 36.1529C2.05097 37.2125 1.04318 38.2723 0.231445 39.3941L13.0301 27.9203"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="grok-logo-clip">
          <rect width="106" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconGrokBackground(props: IconProps) {
  return (
    <svg {...props} viewBox="314 59 374 360" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="grok-icon-mask"
        style={{ maskType: 'alpha' } as React.CSSProperties}
        maskUnits="userSpaceOnUse"
        x="314"
        y="59"
        width="374"
        height="360"
      >
        <path
          d="M458.441 289.433L582.778 197.554C588.874 193.05 597.587 194.806 600.492 201.803C615.778 238.702 608.949 283.045 578.534 313.49C548.12 343.935 505.802 350.612 467.122 335.405L424.867 354.989C485.473 396.456 559.066 386.201 605.055 340.134C641.533 303.618 652.831 253.844 642.267 208.96L642.363 209.055C627.043 143.116 646.129 116.76 685.224 62.8656C686.149 61.5877 687.074 60.3098 688 59L636.554 110.499V110.339L458.409 289.466"
          fill="white"
        />
        <path
          d="M432.785 311.777C389.286 270.182 396.786 205.808 433.902 168.687C461.348 141.212 506.315 129.999 545.57 146.483L587.729 126.995C580.134 121.501 570.399 115.59 559.229 111.437C508.741 90.6399 448.295 100.991 407.254 142.042C367.776 181.561 355.361 242.324 376.68 294.174C392.605 332.926 366.499 360.336 340.202 388.003C330.883 397.81 321.532 407.618 314 418.001L432.753 311.808"
          fill="white"
        />
      </mask>
      <g mask="url(#grok-icon-mask)">
        <g opacity={0.9} filter="url(#grok-blur-1)">
          <ellipse
            cx={262.5}
            cy={134}
            rx={181}
            ry={262.5}
            transform="rotate(90 262.5 134)"
            fill="#FFBCCB"
          />
        </g>
        <g filter="url(#grok-blur-2)">
          <ellipse
            cx={638.5}
            cy={248.5}
            rx={113.5}
            ry={177.5}
            transform="rotate(90 638.5 248.5)"
            fill="#C23259"
          />
        </g>
      </g>
      <defs>
        <filter
          id="grok-blur-1"
          x={-218.66}
          y={-265.66}
          width={962.32}
          height={799.32}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={109.33} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="grok-blur-2"
          x={215}
          y={-111}
          width={847}
          height={719}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={123} result="effect1_foregroundBlur" />
        </filter>
      </defs>
    </svg>
  )
}

export function IconGeminiBackground(props: IconProps) {
  return (
    <svg {...props} viewBox="0 0 387 386" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="gemini-icon-mask"
        style={{ maskType: 'alpha' } as React.CSSProperties}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="387"
        height="386"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M345.094 172.522C315.869 160.113 289.295 142.238 266.808 119.864C235.492 88.5661 213.15 49.4748 202.104 6.65188C201.619 4.74994 200.513 3.06334 198.96 1.85868C197.406 0.654019 195.495 0 193.527 0C191.56 0 189.649 0.654019 188.095 1.85868C186.542 3.06334 185.436 4.74994 184.951 6.65188C173.882 49.4693 151.536 88.5562 120.229 119.864C97.74 142.236 71.1672 160.11 41.9438 172.522C30.5088 177.435 18.7572 181.383 6.72408 184.419C4.8055 184.889 3.10041 185.987 1.88143 187.538C0.662452 189.088 0 191.002 0 192.973C0 194.943 0.662452 196.857 1.88143 198.407C3.10041 199.958 4.8055 201.056 6.72408 201.527C18.7572 204.545 30.4736 208.493 41.9438 213.406C71.1688 225.815 97.7422 243.689 120.229 266.064C151.554 297.365 173.902 336.462 184.951 379.293C185.423 381.207 186.524 382.908 188.079 384.123C189.633 385.339 191.552 386 193.527 386C195.503 386 197.422 385.339 198.976 384.123C200.531 382.908 201.632 381.207 202.104 379.293C205.13 367.274 209.088 355.588 214.014 344.147C226.454 314.997 244.375 288.492 266.808 266.064C298.193 234.827 337.391 212.543 380.331 201.527C382.238 201.043 383.929 199.94 385.136 198.391C386.344 196.841 387 194.935 387 192.973C387 191.01 386.344 189.104 385.136 187.555C383.929 186.005 382.238 184.902 380.331 184.419C368.286 181.396 356.503 177.418 345.094 172.522Z"
          fill="white"
        />
      </mask>
      <g mask="url(#gemini-icon-mask)">
        <g opacity={0.9} filter="url(#gemini-blur-1)">
          <ellipse cx={-50} cy={90} rx={262.5} ry={181} fill="#b37d00" />
        </g>
        <g filter="url(#gemini-blur-2)">
          <ellipse cx={325} cy={189.5} rx={177.5} ry={113.5} fill="#ffe099" />
        </g>
      </g>
      <defs>
        <filter
          id="gemini-blur-1"
          x={-500}
          y={-500}
          width={1500}
          height={1500}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={109.33} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="gemini-blur-2"
          x={-500}
          y={-500}
          width={1500}
          height={1500}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={123} result="effect1_foregroundBlur" />
        </filter>
      </defs>
    </svg>
  )
}
